
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
// Import JS libraries
/* Tabulator v6.2.5 (c) Oliver Folkerd 2024 */ class $c2a9788f40f9c90a$var$CoreFeature {
    constructor(table){
        this.table = table;
    }
    //////////////////////////////////////////
    /////////////// DataLoad /////////////////
    //////////////////////////////////////////
    reloadData(data, silent, columnsChanged) {
        return this.table.dataLoader.load(data, undefined, undefined, undefined, silent, columnsChanged);
    }
    //////////////////////////////////////////
    ///////////// Localization ///////////////
    //////////////////////////////////////////
    langText() {
        return this.table.modules.localize.getText(...arguments);
    }
    langBind() {
        return this.table.modules.localize.bind(...arguments);
    }
    langLocale() {
        return this.table.modules.localize.getLocale(...arguments);
    }
    //////////////////////////////////////////
    ////////// Inter Table Comms /////////////
    //////////////////////////////////////////
    commsConnections() {
        return this.table.modules.comms.getConnections(...arguments);
    }
    commsSend() {
        return this.table.modules.comms.send(...arguments);
    }
    //////////////////////////////////////////
    //////////////// Layout  /////////////////
    //////////////////////////////////////////
    layoutMode() {
        return this.table.modules.layout.getMode();
    }
    layoutRefresh(force) {
        return this.table.modules.layout.layout(force);
    }
    //////////////////////////////////////////
    /////////////// Event Bus ////////////////
    //////////////////////////////////////////
    subscribe() {
        return this.table.eventBus.subscribe(...arguments);
    }
    unsubscribe() {
        return this.table.eventBus.unsubscribe(...arguments);
    }
    subscribed(key) {
        return this.table.eventBus.subscribed(key);
    }
    subscriptionChange() {
        return this.table.eventBus.subscriptionChange(...arguments);
    }
    dispatch() {
        return this.table.eventBus.dispatch(...arguments);
    }
    chain() {
        return this.table.eventBus.chain(...arguments);
    }
    confirm() {
        return this.table.eventBus.confirm(...arguments);
    }
    dispatchExternal() {
        return this.table.externalEvents.dispatch(...arguments);
    }
    subscribedExternal(key) {
        return this.table.externalEvents.subscribed(key);
    }
    subscriptionChangeExternal() {
        return this.table.externalEvents.subscriptionChange(...arguments);
    }
    //////////////////////////////////////////
    //////////////// Options /////////////////
    //////////////////////////////////////////
    options(key) {
        return this.table.options[key];
    }
    setOption(key, value) {
        if (typeof value !== "undefined") this.table.options[key] = value;
        return this.table.options[key];
    }
    //////////////////////////////////////////
    /////////// Deprecation Checks ///////////
    //////////////////////////////////////////
    deprecationCheck(oldOption, newOption, convert) {
        return this.table.deprecationAdvisor.check(oldOption, newOption, convert);
    }
    deprecationCheckMsg(oldOption, msg) {
        return this.table.deprecationAdvisor.checkMsg(oldOption, msg);
    }
    deprecationMsg(msg) {
        return this.table.deprecationAdvisor.msg(msg);
    }
    //////////////////////////////////////////
    //////////////// Modules /////////////////
    //////////////////////////////////////////
    module(key) {
        return this.table.module(key);
    }
}
class $c2a9788f40f9c90a$var$Helpers {
    static elVisible(el) {
        return !(el.offsetWidth <= 0 && el.offsetHeight <= 0);
    }
    static elOffset(el) {
        var box = el.getBoundingClientRect();
        return {
            top: box.top + window.pageYOffset - document.documentElement.clientTop,
            left: box.left + window.pageXOffset - document.documentElement.clientLeft
        };
    }
    static retrieveNestedData(separator, field, data) {
        var structure = separator ? field.split(separator) : [
            field
        ], length = structure.length, output;
        for(let i = 0; i < length; i++){
            data = data[structure[i]];
            output = data;
            if (!data) break;
        }
        return output;
    }
    static deepClone(obj, clone, list = []) {
        var objectProto = {}.__proto__, arrayProto = [].__proto__;
        if (!clone) clone = Object.assign(Array.isArray(obj) ? [] : {}, obj);
        for(var i in obj){
            let subject = obj[i], match, copy;
            if (subject != null && typeof subject === "object" && (subject.__proto__ === objectProto || subject.__proto__ === arrayProto)) {
                match = list.findIndex((item)=>{
                    return item.subject === subject;
                });
                if (match > -1) clone[i] = list[match].copy;
                else {
                    copy = Object.assign(Array.isArray(subject) ? [] : {}, subject);
                    list.unshift({
                        subject: subject,
                        copy: copy
                    });
                    clone[i] = this.deepClone(subject, copy, list);
                }
            }
        }
        return clone;
    }
}
let $c2a9788f40f9c90a$var$Popup$1 = class Popup extends $c2a9788f40f9c90a$var$CoreFeature {
    constructor(table, element, parent){
        super(table);
        this.element = element;
        this.container = this._lookupContainer();
        this.parent = parent;
        this.reversedX = false;
        this.childPopup = null;
        this.blurable = false;
        this.blurCallback = null;
        this.blurEventsBound = false;
        this.renderedCallback = null;
        this.visible = false;
        this.hideable = true;
        this.element.classList.add("tabulator-popup-container");
        this.blurEvent = this.hide.bind(this, false);
        this.escEvent = this._escapeCheck.bind(this);
        this.destroyBinding = this.tableDestroyed.bind(this);
        this.destroyed = false;
    }
    tableDestroyed() {
        this.destroyed = true;
        this.hide(true);
    }
    _lookupContainer() {
        var container = this.table.options.popupContainer;
        if (typeof container === "string") {
            container = document.querySelector(container);
            if (!container) console.warn("Menu Error - no container element found matching selector:", this.table.options.popupContainer, "(defaulting to document body)");
        } else if (container === true) container = this.table.element;
        if (container && !this._checkContainerIsParent(container)) {
            container = false;
            console.warn("Menu Error - container element does not contain this table:", this.table.options.popupContainer, "(defaulting to document body)");
        }
        if (!container) container = document.body;
        return container;
    }
    _checkContainerIsParent(container, element = this.table.element) {
        if (container === element) return true;
        else return element.parentNode ? this._checkContainerIsParent(container, element.parentNode) : false;
    }
    renderCallback(callback) {
        this.renderedCallback = callback;
    }
    containerEventCoords(e) {
        var touch = !(e instanceof MouseEvent);
        var x = touch ? e.touches[0].pageX : e.pageX;
        var y = touch ? e.touches[0].pageY : e.pageY;
        if (this.container !== document.body) {
            let parentOffset = $c2a9788f40f9c90a$var$Helpers.elOffset(this.container);
            x -= parentOffset.left;
            y -= parentOffset.top;
        }
        return {
            x: x,
            y: y
        };
    }
    elementPositionCoords(element, position = "right") {
        var offset = $c2a9788f40f9c90a$var$Helpers.elOffset(element), containerOffset, x, y;
        if (this.container !== document.body) {
            containerOffset = $c2a9788f40f9c90a$var$Helpers.elOffset(this.container);
            offset.left -= containerOffset.left;
            offset.top -= containerOffset.top;
        }
        switch(position){
            case "right":
                x = offset.left + element.offsetWidth;
                y = offset.top - 1;
                break;
            case "bottom":
                x = offset.left;
                y = offset.top + element.offsetHeight;
                break;
            case "left":
                x = offset.left;
                y = offset.top - 1;
                break;
            case "top":
                x = offset.left;
                y = offset.top;
                break;
            case "center":
                x = offset.left + element.offsetWidth / 2;
                y = offset.top + element.offsetHeight / 2;
                break;
        }
        return {
            x: x,
            y: y,
            offset: offset
        };
    }
    show(origin, position) {
        var x, y, parentEl, parentOffset, coords;
        if (this.destroyed || this.table.destroyed) return this;
        if (origin instanceof HTMLElement) {
            parentEl = origin;
            coords = this.elementPositionCoords(origin, position);
            parentOffset = coords.offset;
            x = coords.x;
            y = coords.y;
        } else if (typeof origin === "number") {
            parentOffset = {
                top: 0,
                left: 0
            };
            x = origin;
            y = position;
        } else {
            coords = this.containerEventCoords(origin);
            x = coords.x;
            y = coords.y;
            this.reversedX = false;
        }
        this.element.style.top = y + "px";
        this.element.style.left = x + "px";
        this.container.appendChild(this.element);
        if (typeof this.renderedCallback === "function") this.renderedCallback();
        this._fitToScreen(x, y, parentEl, parentOffset, position);
        this.visible = true;
        this.subscribe("table-destroy", this.destroyBinding);
        this.element.addEventListener("mousedown", (e)=>{
            e.stopPropagation();
        });
        return this;
    }
    _fitToScreen(x, y, parentEl, parentOffset, position) {
        var scrollTop = this.container === document.body ? document.documentElement.scrollTop : this.container.scrollTop;
        //move menu to start on right edge if it is too close to the edge of the screen
        if (x + this.element.offsetWidth >= this.container.offsetWidth || this.reversedX) {
            this.element.style.left = "";
            if (parentEl) this.element.style.right = this.container.offsetWidth - parentOffset.left + "px";
            else this.element.style.right = this.container.offsetWidth - x + "px";
            this.reversedX = true;
        }
        //move menu to start on bottom edge if it is too close to the edge of the screen
        let offsetHeight = Math.max(this.container.offsetHeight, scrollTop ? this.container.scrollHeight : 0);
        if (y + this.element.offsetHeight > offsetHeight) {
            if (parentEl) switch(position){
                case "bottom":
                    this.element.style.top = parseInt(this.element.style.top) - this.element.offsetHeight - parentEl.offsetHeight - 1 + "px";
                    break;
                default:
                    this.element.style.top = parseInt(this.element.style.top) - this.element.offsetHeight + parentEl.offsetHeight + 1 + "px";
            }
            else this.element.style.height = offsetHeight + "px";
        }
    }
    isVisible() {
        return this.visible;
    }
    hideOnBlur(callback) {
        this.blurable = true;
        if (this.visible) {
            setTimeout(()=>{
                if (this.visible) {
                    this.table.rowManager.element.addEventListener("scroll", this.blurEvent);
                    this.subscribe("cell-editing", this.blurEvent);
                    document.body.addEventListener("click", this.blurEvent);
                    document.body.addEventListener("contextmenu", this.blurEvent);
                    document.body.addEventListener("mousedown", this.blurEvent);
                    window.addEventListener("resize", this.blurEvent);
                    document.body.addEventListener("keydown", this.escEvent);
                    this.blurEventsBound = true;
                }
            }, 100);
            this.blurCallback = callback;
        }
        return this;
    }
    _escapeCheck(e) {
        if (e.keyCode == 27) this.hide();
    }
    blockHide() {
        this.hideable = false;
    }
    restoreHide() {
        this.hideable = true;
    }
    hide(silent = false) {
        if (this.visible && this.hideable) {
            if (this.blurable && this.blurEventsBound) {
                document.body.removeEventListener("keydown", this.escEvent);
                document.body.removeEventListener("click", this.blurEvent);
                document.body.removeEventListener("contextmenu", this.blurEvent);
                document.body.removeEventListener("mousedown", this.blurEvent);
                window.removeEventListener("resize", this.blurEvent);
                this.table.rowManager.element.removeEventListener("scroll", this.blurEvent);
                this.unsubscribe("cell-editing", this.blurEvent);
                this.blurEventsBound = false;
            }
            if (this.childPopup) this.childPopup.hide();
            if (this.parent) this.parent.childPopup = null;
            if (this.element.parentNode) this.element.parentNode.removeChild(this.element);
            this.visible = false;
            if (this.blurCallback && !silent) this.blurCallback();
            this.unsubscribe("table-destroy", this.destroyBinding);
        }
        return this;
    }
    child(element) {
        if (this.childPopup) this.childPopup.hide();
        this.childPopup = new Popup(this.table, element, this);
        return this.childPopup;
    }
};
class $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed extends $c2a9788f40f9c90a$var$CoreFeature {
    constructor(table, name){
        super(table);
        this._handler = null;
    }
    initialize() {
    // setup module when table is initialized, to be overridden in module
    }
    ///////////////////////////////////
    ////// Options Registration ///////
    ///////////////////////////////////
    registerTableOption(key, value) {
        this.table.optionsList.register(key, value);
    }
    registerColumnOption(key, value) {
        this.table.columnManager.optionsList.register(key, value);
    }
    ///////////////////////////////////
    /// Public Function Registration ///
    ///////////////////////////////////
    registerTableFunction(name, func) {
        if (typeof this.table[name] === "undefined") this.table[name] = (...args)=>{
            this.table.initGuard(name);
            return func(...args);
        };
        else console.warn("Unable to bind table function, name already in use", name);
    }
    registerComponentFunction(component, func, handler) {
        return this.table.componentFunctionBinder.bind(component, func, handler);
    }
    ///////////////////////////////////
    ////////// Data Pipeline //////////
    ///////////////////////////////////
    registerDataHandler(handler, priority) {
        this.table.rowManager.registerDataPipelineHandler(handler, priority);
        this._handler = handler;
    }
    registerDisplayHandler(handler, priority) {
        this.table.rowManager.registerDisplayPipelineHandler(handler, priority);
        this._handler = handler;
    }
    displayRows(adjust) {
        var index = this.table.rowManager.displayRows.length - 1, lookupIndex;
        if (this._handler) {
            lookupIndex = this.table.rowManager.displayPipeline.findIndex((item)=>{
                return item.handler === this._handler;
            });
            if (lookupIndex > -1) index = lookupIndex;
        }
        if (adjust) index = index + adjust;
        if (this._handler) {
            if (index > -1) return this.table.rowManager.getDisplayRows(index);
            else return this.activeRows();
        }
    }
    activeRows() {
        return this.table.rowManager.activeRows;
    }
    refreshData(renderInPosition, handler) {
        if (!handler) handler = this._handler;
        if (handler) this.table.rowManager.refreshActiveData(handler, false, renderInPosition);
    }
    ///////////////////////////////////
    //////// Footer Management ////////
    ///////////////////////////////////
    footerAppend(element) {
        return this.table.footerManager.append(element);
    }
    footerPrepend(element) {
        return this.table.footerManager.prepend(element);
    }
    footerRemove(element) {
        return this.table.footerManager.remove(element);
    }
    ///////////////////////////////////
    //////// Popups Management ////////
    ///////////////////////////////////
    popup(menuEl, menuContainer) {
        return new $c2a9788f40f9c90a$var$Popup$1(this.table, menuEl, menuContainer);
    }
    ///////////////////////////////////
    //////// Alert Management ////////
    ///////////////////////////////////
    alert(content, type) {
        return this.table.alertManager.alert(content, type);
    }
    clearAlert() {
        return this.table.alertManager.clear();
    }
}
var $c2a9788f40f9c90a$var$defaultAccessors = {
    rownum: function(value, data, type, params, column, row) {
        return row.getPosition();
    }
};
class $c2a9788f40f9c90a$export$bf9f5472bce61c69 extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "accessor";
    //load defaults
    static accessors = $c2a9788f40f9c90a$var$defaultAccessors;
    constructor(table){
        super(table);
        this.allowedTypes = [
            "",
            "data",
            "download",
            "clipboard",
            "print",
            "htmlOutput"
        ]; //list of accessor types
        this.registerColumnOption("accessor");
        this.registerColumnOption("accessorParams");
        this.registerColumnOption("accessorData");
        this.registerColumnOption("accessorDataParams");
        this.registerColumnOption("accessorDownload");
        this.registerColumnOption("accessorDownloadParams");
        this.registerColumnOption("accessorClipboard");
        this.registerColumnOption("accessorClipboardParams");
        this.registerColumnOption("accessorPrint");
        this.registerColumnOption("accessorPrintParams");
        this.registerColumnOption("accessorHtmlOutput");
        this.registerColumnOption("accessorHtmlOutputParams");
    }
    initialize() {
        this.subscribe("column-layout", this.initializeColumn.bind(this));
        this.subscribe("row-data-retrieve", this.transformRow.bind(this));
    }
    //initialize column accessor
    initializeColumn(column) {
        var match = false, config = {};
        this.allowedTypes.forEach((type)=>{
            var key = "accessor" + (type.charAt(0).toUpperCase() + type.slice(1)), accessor;
            if (column.definition[key]) {
                accessor = this.lookupAccessor(column.definition[key]);
                if (accessor) {
                    match = true;
                    config[key] = {
                        accessor: accessor,
                        params: column.definition[key + "Params"] || {}
                    };
                }
            }
        });
        if (match) column.modules.accessor = config;
    }
    lookupAccessor(value) {
        var accessor = false;
        //set column accessor
        switch(typeof value){
            case "string":
                if ($c2a9788f40f9c90a$export$bf9f5472bce61c69.accessors[value]) accessor = $c2a9788f40f9c90a$export$bf9f5472bce61c69.accessors[value];
                else console.warn("Accessor Error - No such accessor found, ignoring: ", value);
                break;
            case "function":
                accessor = value;
                break;
        }
        return accessor;
    }
    //apply accessor to row
    transformRow(row, type) {
        var key = "accessor" + (type.charAt(0).toUpperCase() + type.slice(1)), rowComponent = row.getComponent();
        //clone data object with deep copy to isolate internal data from returned result
        var data = $c2a9788f40f9c90a$var$Helpers.deepClone(row.data || {});
        this.table.columnManager.traverse(function(column) {
            var value, accessor, params, colComponent;
            if (column.modules.accessor) {
                accessor = column.modules.accessor[key] || column.modules.accessor.accessor || false;
                if (accessor) {
                    value = column.getFieldValue(data);
                    if (value != "undefined") {
                        colComponent = column.getComponent();
                        params = typeof accessor.params === "function" ? accessor.params(value, data, type, colComponent, rowComponent) : accessor.params;
                        column.setFieldValue(data, accessor.accessor(value, data, type, params, colComponent, rowComponent));
                    }
                }
            }
        });
        return data;
    }
}
var $c2a9788f40f9c90a$var$defaultConfig = {
    method: "GET"
};
function $c2a9788f40f9c90a$var$generateParamsList$1(data, prefix) {
    var output = [];
    prefix = prefix || "";
    if (Array.isArray(data)) data.forEach((item, i)=>{
        output = output.concat($c2a9788f40f9c90a$var$generateParamsList$1(item, prefix ? prefix + "[" + i + "]" : i));
    });
    else if (typeof data === "object") for(var key in data)output = output.concat($c2a9788f40f9c90a$var$generateParamsList$1(data[key], prefix ? prefix + "[" + key + "]" : key));
    else output.push({
        key: prefix,
        value: data
    });
    return output;
}
function $c2a9788f40f9c90a$var$serializeParams(params) {
    var output = $c2a9788f40f9c90a$var$generateParamsList$1(params), encoded = [];
    output.forEach(function(item) {
        encoded.push(encodeURIComponent(item.key) + "=" + encodeURIComponent(item.value));
    });
    return encoded.join("&");
}
function $c2a9788f40f9c90a$var$urlBuilder(url, config, params) {
    if (url) {
        if (params && Object.keys(params).length) {
            if (!config.method || config.method.toLowerCase() == "get") {
                config.method = "get";
                url += (url.includes("?") ? "&" : "?") + $c2a9788f40f9c90a$var$serializeParams(params);
            }
        }
    }
    return url;
}
function $c2a9788f40f9c90a$var$defaultLoaderPromise(url, config, params) {
    var contentType;
    return new Promise((resolve, reject)=>{
        //set url
        url = this.urlGenerator.call(this.table, url, config, params);
        //set body content if not GET request
        if (config.method.toUpperCase() != "GET") {
            contentType = typeof this.table.options.ajaxContentType === "object" ? this.table.options.ajaxContentType : this.contentTypeFormatters[this.table.options.ajaxContentType];
            if (contentType) {
                for(var key in contentType.headers){
                    if (!config.headers) config.headers = {};
                    if (typeof config.headers[key] === "undefined") config.headers[key] = contentType.headers[key];
                }
                config.body = contentType.body.call(this, url, config, params);
            } else console.warn("Ajax Error - Invalid ajaxContentType value:", this.table.options.ajaxContentType);
        }
        if (url) {
            //configure headers
            if (typeof config.headers === "undefined") config.headers = {};
            if (typeof config.headers.Accept === "undefined") config.headers.Accept = "application/json";
            if (typeof config.headers["X-Requested-With"] === "undefined") config.headers["X-Requested-With"] = "XMLHttpRequest";
            if (typeof config.mode === "undefined") config.mode = "cors";
            if (config.mode == "cors") {
                if (typeof config.headers["Origin"] === "undefined") config.headers["Origin"] = window.location.origin;
                if (typeof config.credentials === "undefined") config.credentials = "same-origin";
            } else if (typeof config.credentials === "undefined") config.credentials = "include";
            //send request
            fetch(url, config).then((response)=>{
                if (response.ok) response.json().then((data)=>{
                    resolve(data);
                }).catch((error)=>{
                    reject(error);
                    console.warn("Ajax Load Error - Invalid JSON returned", error);
                });
                else {
                    console.error("Ajax Load Error - Connection Error: " + response.status, response.statusText);
                    reject(response);
                }
            }).catch((error)=>{
                console.error("Ajax Load Error - Connection Error: ", error);
                reject(error);
            });
        } else {
            console.warn("Ajax Load Error - No URL Set");
            resolve([]);
        }
    });
}
function $c2a9788f40f9c90a$var$generateParamsList(data, prefix) {
    var output = [];
    prefix = prefix || "";
    if (Array.isArray(data)) data.forEach((item, i)=>{
        output = output.concat($c2a9788f40f9c90a$var$generateParamsList(item, prefix ? prefix + "[" + i + "]" : i));
    });
    else if (typeof data === "object") for(var key in data)output = output.concat($c2a9788f40f9c90a$var$generateParamsList(data[key], prefix ? prefix + "[" + key + "]" : key));
    else output.push({
        key: prefix,
        value: data
    });
    return output;
}
var $c2a9788f40f9c90a$var$defaultContentTypeFormatters = {
    "json": {
        headers: {
            "Content-Type": "application/json"
        },
        body: function(url, config, params) {
            return JSON.stringify(params);
        }
    },
    "form": {
        headers: {},
        body: function(url, config, params) {
            var output = $c2a9788f40f9c90a$var$generateParamsList(params), form = new FormData();
            output.forEach(function(item) {
                form.append(item.key, item.value);
            });
            return form;
        }
    }
};
class $c2a9788f40f9c90a$export$b25c9f93be571d3a extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "ajax";
    //load defaults
    static defaultConfig = $c2a9788f40f9c90a$var$defaultConfig;
    static defaultURLGenerator = $c2a9788f40f9c90a$var$urlBuilder;
    static defaultLoaderPromise = $c2a9788f40f9c90a$var$defaultLoaderPromise;
    static contentTypeFormatters = $c2a9788f40f9c90a$var$defaultContentTypeFormatters;
    constructor(table){
        super(table);
        this.config = {}; //hold config object for ajax request
        this.url = ""; //request URL
        this.urlGenerator = false;
        this.params = false; //request parameters
        this.loaderPromise = false;
        this.registerTableOption("ajaxURL", false); //url for ajax loading
        this.registerTableOption("ajaxURLGenerator", false);
        this.registerTableOption("ajaxParams", {}); //params for ajax loading
        this.registerTableOption("ajaxConfig", "get"); //ajax request type
        this.registerTableOption("ajaxContentType", "form"); //ajax request type
        this.registerTableOption("ajaxRequestFunc", false); //promise function
        this.registerTableOption("ajaxRequesting", function() {});
        this.registerTableOption("ajaxResponse", false);
        this.contentTypeFormatters = $c2a9788f40f9c90a$export$b25c9f93be571d3a.contentTypeFormatters;
    }
    //initialize setup options
    initialize() {
        this.loaderPromise = this.table.options.ajaxRequestFunc || $c2a9788f40f9c90a$export$b25c9f93be571d3a.defaultLoaderPromise;
        this.urlGenerator = this.table.options.ajaxURLGenerator || $c2a9788f40f9c90a$export$b25c9f93be571d3a.defaultURLGenerator;
        if (this.table.options.ajaxURL) this.setUrl(this.table.options.ajaxURL);
        this.setDefaultConfig(this.table.options.ajaxConfig);
        this.registerTableFunction("getAjaxUrl", this.getUrl.bind(this));
        this.subscribe("data-loading", this.requestDataCheck.bind(this));
        this.subscribe("data-params", this.requestParams.bind(this));
        this.subscribe("data-load", this.requestData.bind(this));
    }
    requestParams(data, config, silent, params) {
        var ajaxParams = this.table.options.ajaxParams;
        if (ajaxParams) {
            if (typeof ajaxParams === "function") ajaxParams = ajaxParams.call(this.table);
            params = Object.assign(Object.assign({}, ajaxParams), params);
        }
        return params;
    }
    requestDataCheck(data, params, config, silent) {
        return !!(!data && this.url || typeof data === "string");
    }
    requestData(url, params, config, silent, previousData) {
        var ajaxConfig;
        if (!previousData && this.requestDataCheck(url)) {
            if (url) this.setUrl(url);
            ajaxConfig = this.generateConfig(config);
            return this.sendRequest(this.url, params, ajaxConfig);
        } else return previousData;
    }
    setDefaultConfig(config = {}) {
        this.config = Object.assign({}, $c2a9788f40f9c90a$export$b25c9f93be571d3a.defaultConfig);
        if (typeof config == "string") this.config.method = config;
        else Object.assign(this.config, config);
    }
    //load config object
    generateConfig(config = {}) {
        var ajaxConfig = Object.assign({}, this.config);
        if (typeof config == "string") ajaxConfig.method = config;
        else Object.assign(ajaxConfig, config);
        return ajaxConfig;
    }
    //set request url
    setUrl(url) {
        this.url = url;
    }
    //get request url
    getUrl() {
        return this.url;
    }
    //send ajax request
    sendRequest(url, params, config) {
        if (this.table.options.ajaxRequesting.call(this.table, url, params) !== false) return this.loaderPromise(url, config, params).then((data)=>{
            if (this.table.options.ajaxResponse) data = this.table.options.ajaxResponse.call(this.table, url, params, data);
            return data;
        });
        else return Promise.reject();
    }
}
var $c2a9788f40f9c90a$var$defaultPasteActions = {
    replace: function(data) {
        return this.table.setData(data);
    },
    update: function(data) {
        return this.table.updateOrAddData(data);
    },
    insert: function(data) {
        return this.table.addData(data);
    }
};
var $c2a9788f40f9c90a$var$defaultPasteParsers = {
    table: function(clipboard) {
        var data = [], headerFindSuccess = true, columns = this.table.columnManager.columns, columnMap = [], rows = [];
        //get data from clipboard into array of columns and rows.
        clipboard = clipboard.split("\n");
        clipboard.forEach(function(row) {
            data.push(row.split("	"));
        });
        if (data.length && !(data.length === 1 && data[0].length < 2)) {
            //check if headers are present by title
            data[0].forEach(function(value) {
                var column = columns.find(function(column) {
                    return value && column.definition.title && value.trim() && column.definition.title.trim() === value.trim();
                });
                if (column) columnMap.push(column);
                else headerFindSuccess = false;
            });
            //check if column headers are present by field
            if (!headerFindSuccess) {
                headerFindSuccess = true;
                columnMap = [];
                data[0].forEach(function(value) {
                    var column = columns.find(function(column) {
                        return value && column.field && value.trim() && column.field.trim() === value.trim();
                    });
                    if (column) columnMap.push(column);
                    else headerFindSuccess = false;
                });
                if (!headerFindSuccess) columnMap = this.table.columnManager.columnsByIndex;
            }
            //remove header row if found
            if (headerFindSuccess) data.shift();
            data.forEach(function(item) {
                var row = {};
                item.forEach(function(value, i) {
                    if (columnMap[i]) row[columnMap[i].field] = value;
                });
                rows.push(row);
            });
            return rows;
        } else return false;
    }
};
var $c2a9788f40f9c90a$var$bindings$2 = {
    copyToClipboard: [
        "ctrl + 67",
        "meta + 67"
    ]
};
var $c2a9788f40f9c90a$var$actions$2 = {
    copyToClipboard: function(e) {
        if (!this.table.modules.edit.currentCell) {
            if (this.table.modExists("clipboard", true)) this.table.modules.clipboard.copy(false, true);
        }
    }
};
var $c2a9788f40f9c90a$var$extensions$4 = {
    keybindings: {
        bindings: $c2a9788f40f9c90a$var$bindings$2,
        actions: $c2a9788f40f9c90a$var$actions$2
    }
};
class $c2a9788f40f9c90a$export$3a36bd45ca02edda extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "clipboard";
    static moduleExtensions = $c2a9788f40f9c90a$var$extensions$4;
    //load defaults
    static pasteActions = $c2a9788f40f9c90a$var$defaultPasteActions;
    static pasteParsers = $c2a9788f40f9c90a$var$defaultPasteParsers;
    constructor(table){
        super(table);
        this.mode = true;
        this.pasteParser = function() {};
        this.pasteAction = function() {};
        this.customSelection = false;
        this.rowRange = false;
        this.blocked = true; //block copy actions not originating from this command
        this.registerTableOption("clipboard", false); //enable clipboard
        this.registerTableOption("clipboardCopyStyled", true); //formatted table data
        this.registerTableOption("clipboardCopyConfig", false); //clipboard config
        this.registerTableOption("clipboardCopyFormatter", false); //DEPRECATED - REMOVE in 5.0
        this.registerTableOption("clipboardCopyRowRange", "active"); //restrict clipboard to visible rows only
        this.registerTableOption("clipboardPasteParser", "table"); //convert pasted clipboard data to rows
        this.registerTableOption("clipboardPasteAction", "insert"); //how to insert pasted data into the table
        this.registerColumnOption("clipboard");
        this.registerColumnOption("titleClipboard");
    }
    initialize() {
        this.mode = this.table.options.clipboard;
        this.rowRange = this.table.options.clipboardCopyRowRange;
        if (this.mode === true || this.mode === "copy") this.table.element.addEventListener("copy", (e)=>{
            var plain, html, list;
            if (!this.blocked) {
                e.preventDefault();
                if (this.customSelection) {
                    plain = this.customSelection;
                    if (this.table.options.clipboardCopyFormatter) plain = this.table.options.clipboardCopyFormatter("plain", plain);
                } else {
                    list = this.table.modules.export.generateExportList(this.table.options.clipboardCopyConfig, this.table.options.clipboardCopyStyled, this.rowRange, "clipboard");
                    html = this.table.modules.export.generateHTMLTable(list);
                    plain = html ? this.generatePlainContent(list) : "";
                    if (this.table.options.clipboardCopyFormatter) {
                        plain = this.table.options.clipboardCopyFormatter("plain", plain);
                        html = this.table.options.clipboardCopyFormatter("html", html);
                    }
                }
                if (window.clipboardData && window.clipboardData.setData) window.clipboardData.setData("Text", plain);
                else if (e.clipboardData && e.clipboardData.setData) {
                    e.clipboardData.setData("text/plain", plain);
                    if (html) e.clipboardData.setData("text/html", html);
                } else if (e.originalEvent && e.originalEvent.clipboardData.setData) {
                    e.originalEvent.clipboardData.setData("text/plain", plain);
                    if (html) e.originalEvent.clipboardData.setData("text/html", html);
                }
                this.dispatchExternal("clipboardCopied", plain, html);
                this.reset();
            }
        });
        if (this.mode === true || this.mode === "paste") this.table.element.addEventListener("paste", (e)=>{
            this.paste(e);
        });
        this.setPasteParser(this.table.options.clipboardPasteParser);
        this.setPasteAction(this.table.options.clipboardPasteAction);
        this.registerTableFunction("copyToClipboard", this.copy.bind(this));
    }
    reset() {
        this.blocked = true;
        this.customSelection = false;
    }
    generatePlainContent(list) {
        var output = [];
        list.forEach((row)=>{
            var rowData = [];
            row.columns.forEach((col)=>{
                var value = "";
                if (col) {
                    if (row.type === "group") col.value = col.component.getKey();
                    if (col.value === null) value = "";
                    else switch(typeof col.value){
                        case "object":
                            value = JSON.stringify(col.value);
                            break;
                        case "undefined":
                            value = "";
                            break;
                        default:
                            value = col.value;
                    }
                }
                rowData.push(value);
            });
            output.push(rowData.join("	"));
        });
        return output.join("\n");
    }
    copy(range, internal) {
        var sel, textRange;
        this.blocked = false;
        this.customSelection = false;
        if (this.mode === true || this.mode === "copy") {
            this.rowRange = range || this.table.options.clipboardCopyRowRange;
            if (typeof window.getSelection != "undefined" && typeof document.createRange != "undefined") {
                range = document.createRange();
                range.selectNodeContents(this.table.element);
                sel = window.getSelection();
                if (sel.toString() && internal) this.customSelection = sel.toString();
                sel.removeAllRanges();
                sel.addRange(range);
            } else if (typeof document.selection != "undefined" && typeof document.body.createTextRange != "undefined") {
                textRange = document.body.createTextRange();
                textRange.moveToElementText(this.table.element);
                textRange.select();
            }
            document.execCommand("copy");
            if (sel) sel.removeAllRanges();
        }
    }
    //PASTE EVENT HANDLING
    setPasteAction(action) {
        switch(typeof action){
            case "string":
                this.pasteAction = $c2a9788f40f9c90a$export$3a36bd45ca02edda.pasteActions[action];
                if (!this.pasteAction) console.warn("Clipboard Error - No such paste action found:", action);
                break;
            case "function":
                this.pasteAction = action;
                break;
        }
    }
    setPasteParser(parser) {
        switch(typeof parser){
            case "string":
                this.pasteParser = $c2a9788f40f9c90a$export$3a36bd45ca02edda.pasteParsers[parser];
                if (!this.pasteParser) console.warn("Clipboard Error - No such paste parser found:", parser);
                break;
            case "function":
                this.pasteParser = parser;
                break;
        }
    }
    paste(e) {
        var data, rowData, rows;
        if (this.checkPasteOrigin(e)) {
            data = this.getPasteData(e);
            rowData = this.pasteParser.call(this, data);
            if (rowData) {
                e.preventDefault();
                if (this.table.modExists("mutator")) rowData = this.mutateData(rowData);
                rows = this.pasteAction.call(this, rowData);
                this.dispatchExternal("clipboardPasted", data, rowData, rows);
            } else this.dispatchExternal("clipboardPasteError", data);
        }
    }
    mutateData(data) {
        var output = [];
        if (Array.isArray(data)) data.forEach((row)=>{
            output.push(this.table.modules.mutator.transformRow(row, "clipboard"));
        });
        else output = data;
        return output;
    }
    checkPasteOrigin(e) {
        var valid = true;
        var blocked = this.confirm("clipboard-paste", [
            e
        ]);
        if (blocked || ![
            "DIV",
            "SPAN"
        ].includes(e.target.tagName)) valid = false;
        return valid;
    }
    getPasteData(e) {
        var data;
        if (window.clipboardData && window.clipboardData.getData) data = window.clipboardData.getData("Text");
        else if (e.clipboardData && e.clipboardData.getData) data = e.clipboardData.getData("text/plain");
        else if (e.originalEvent && e.originalEvent.clipboardData.getData) data = e.originalEvent.clipboardData.getData("text/plain");
        return data;
    }
}
class $c2a9788f40f9c90a$export$3ef2519bf7055551 {
    constructor(row){
        this._row = row;
        return new Proxy(this, {
            get: function(target, name, receiver) {
                if (typeof target[name] !== "undefined") return target[name];
                else return target._row.table.componentFunctionBinder.handle("row", target._row, name);
            }
        });
    }
    getData(transform) {
        return this._row.getData(transform);
    }
    getElement() {
        return this._row.getElement();
    }
    getTable() {
        return this._row.table;
    }
    getCells() {
        var cells = [];
        this._row.getCells().forEach(function(cell) {
            cells.push(cell.getComponent());
        });
        return cells;
    }
    getCell(column) {
        var cell = this._row.getCell(column);
        return cell ? cell.getComponent() : false;
    }
    _getSelf() {
        return this._row;
    }
}
//public cell object
class $c2a9788f40f9c90a$export$1919f52c249c72c9 {
    constructor(cell){
        this._cell = cell;
        return new Proxy(this, {
            get: function(target, name, receiver) {
                if (typeof target[name] !== "undefined") return target[name];
                else return target._cell.table.componentFunctionBinder.handle("cell", target._cell, name);
            }
        });
    }
    getValue() {
        return this._cell.getValue();
    }
    getOldValue() {
        return this._cell.getOldValue();
    }
    getInitialValue() {
        return this._cell.initialValue;
    }
    getElement() {
        return this._cell.getElement();
    }
    getRow() {
        return this._cell.row.getComponent();
    }
    getData(transform) {
        return this._cell.row.getData(transform);
    }
    getType() {
        return "cell";
    }
    getField() {
        return this._cell.column.getField();
    }
    getColumn() {
        return this._cell.column.getComponent();
    }
    setValue(value, mutate) {
        if (typeof mutate == "undefined") mutate = true;
        this._cell.setValue(value, mutate);
    }
    restoreOldValue() {
        this._cell.setValueActual(this._cell.getOldValue());
    }
    restoreInitialValue() {
        this._cell.setValueActual(this._cell.initialValue);
    }
    checkHeight() {
        this._cell.checkHeight();
    }
    getTable() {
        return this._cell.table;
    }
    _getSelf() {
        return this._cell;
    }
}
class $c2a9788f40f9c90a$var$Cell extends $c2a9788f40f9c90a$var$CoreFeature {
    constructor(column, row){
        super(column.table);
        this.table = column.table;
        this.column = column;
        this.row = row;
        this.element = null;
        this.value = null;
        this.initialValue;
        this.oldValue = null;
        this.modules = {};
        this.height = null;
        this.width = null;
        this.minWidth = null;
        this.component = null;
        this.loaded = false; //track if the cell has been added to the DOM yet
        this.build();
    }
    //////////////// Setup Functions /////////////////
    //generate element
    build() {
        this.generateElement();
        this.setWidth();
        this._configureCell();
        this.setValueActual(this.column.getFieldValue(this.row.data));
        this.initialValue = this.value;
    }
    generateElement() {
        this.element = document.createElement("div");
        this.element.className = "tabulator-cell";
        this.element.setAttribute("role", "gridcell");
        if (this.column.isRowHeader) this.element.classList.add("tabulator-row-header");
    }
    _configureCell() {
        var element = this.element, field = this.column.getField(), vertAligns = {
            top: "flex-start",
            bottom: "flex-end",
            middle: "center"
        }, hozAligns = {
            left: "flex-start",
            right: "flex-end",
            center: "center"
        };
        //set text alignment
        element.style.textAlign = this.column.hozAlign;
        if (this.column.vertAlign) {
            element.style.display = "inline-flex";
            element.style.alignItems = vertAligns[this.column.vertAlign] || "";
            if (this.column.hozAlign) element.style.justifyContent = hozAligns[this.column.hozAlign] || "";
        }
        if (field) element.setAttribute("tabulator-field", field);
        //add class to cell if needed
        if (this.column.definition.cssClass) {
            var classNames = this.column.definition.cssClass.split(" ");
            classNames.forEach((className)=>{
                element.classList.add(className);
            });
        }
        this.dispatch("cell-init", this);
        //hide cell if not visible
        if (!this.column.visible) this.hide();
    }
    //generate cell contents
    _generateContents() {
        var val;
        val = this.chain("cell-format", this, null, ()=>{
            return this.element.innerHTML = this.value;
        });
        switch(typeof val){
            case "object":
                if (val instanceof Node) {
                    //clear previous cell contents
                    while(this.element.firstChild)this.element.removeChild(this.element.firstChild);
                    this.element.appendChild(val);
                } else {
                    this.element.innerHTML = "";
                    if (val != null) console.warn("Format Error - Formatter has returned a type of object, the only valid formatter object return is an instance of Node, the formatter returned:", val);
                }
                break;
            case "undefined":
                this.element.innerHTML = "";
                break;
            default:
                this.element.innerHTML = val;
        }
    }
    cellRendered() {
        this.dispatch("cell-rendered", this);
    }
    //////////////////// Getters ////////////////////
    getElement(containerOnly) {
        if (!this.loaded) {
            this.loaded = true;
            if (!containerOnly) this.layoutElement();
        }
        return this.element;
    }
    getValue() {
        return this.value;
    }
    getOldValue() {
        return this.oldValue;
    }
    //////////////////// Actions ////////////////////
    setValue(value, mutate, force) {
        var changed = this.setValueProcessData(value, mutate, force);
        if (changed) {
            this.dispatch("cell-value-updated", this);
            this.cellRendered();
            if (this.column.definition.cellEdited) this.column.definition.cellEdited.call(this.table, this.getComponent());
            this.dispatchExternal("cellEdited", this.getComponent());
            if (this.subscribedExternal("dataChanged")) this.dispatchExternal("dataChanged", this.table.rowManager.getData());
        }
    }
    setValueProcessData(value, mutate, force) {
        var changed = false;
        if (this.value !== value || force) {
            changed = true;
            if (mutate) value = this.chain("cell-value-changing", [
                this,
                value
            ], null, value);
        }
        this.setValueActual(value);
        if (changed) this.dispatch("cell-value-changed", this);
        return changed;
    }
    setValueActual(value) {
        this.oldValue = this.value;
        this.value = value;
        this.dispatch("cell-value-save-before", this);
        this.column.setFieldValue(this.row.data, value);
        this.dispatch("cell-value-save-after", this);
        if (this.loaded) this.layoutElement();
    }
    layoutElement() {
        this._generateContents();
        this.dispatch("cell-layout", this);
    }
    setWidth() {
        this.width = this.column.width;
        this.element.style.width = this.column.widthStyled;
    }
    clearWidth() {
        this.width = "";
        this.element.style.width = "";
    }
    getWidth() {
        return this.width || this.element.offsetWidth;
    }
    setMinWidth() {
        this.minWidth = this.column.minWidth;
        this.element.style.minWidth = this.column.minWidthStyled;
    }
    setMaxWidth() {
        this.maxWidth = this.column.maxWidth;
        this.element.style.maxWidth = this.column.maxWidthStyled;
    }
    checkHeight() {
        // var height = this.element.css("height");
        this.row.reinitializeHeight();
    }
    clearHeight() {
        this.element.style.height = "";
        this.height = null;
        this.dispatch("cell-height", this, "");
    }
    setHeight() {
        this.height = this.row.height;
        this.element.style.height = this.row.heightStyled;
        this.dispatch("cell-height", this, this.row.heightStyled);
    }
    getHeight() {
        return this.height || this.element.offsetHeight;
    }
    show() {
        this.element.style.display = this.column.vertAlign ? "inline-flex" : "";
    }
    hide() {
        this.element.style.display = "none";
    }
    delete() {
        this.dispatch("cell-delete", this);
        if (!this.table.rowManager.redrawBlock && this.element.parentNode) this.element.parentNode.removeChild(this.element);
        this.element = false;
        this.column.deleteCell(this);
        this.row.deleteCell(this);
        this.calcs = {};
    }
    getIndex() {
        return this.row.getCellIndex(this);
    }
    //////////////// Object Generation /////////////////
    getComponent() {
        if (!this.component) this.component = new $c2a9788f40f9c90a$export$1919f52c249c72c9(this);
        return this.component;
    }
}
//public column object
class $c2a9788f40f9c90a$export$11bb209ad3a8e411 {
    constructor(column){
        this._column = column;
        this.type = "ColumnComponent";
        return new Proxy(this, {
            get: function(target, name, receiver) {
                if (typeof target[name] !== "undefined") return target[name];
                else return target._column.table.componentFunctionBinder.handle("column", target._column, name);
            }
        });
    }
    getElement() {
        return this._column.getElement();
    }
    getDefinition() {
        return this._column.getDefinition();
    }
    getField() {
        return this._column.getField();
    }
    getTitleDownload() {
        return this._column.getTitleDownload();
    }
    getCells() {
        var cells = [];
        this._column.cells.forEach(function(cell) {
            cells.push(cell.getComponent());
        });
        return cells;
    }
    isVisible() {
        return this._column.visible;
    }
    show() {
        if (this._column.isGroup) this._column.columns.forEach(function(column) {
            column.show();
        });
        else this._column.show();
    }
    hide() {
        if (this._column.isGroup) this._column.columns.forEach(function(column) {
            column.hide();
        });
        else this._column.hide();
    }
    toggle() {
        if (this._column.visible) this.hide();
        else this.show();
    }
    delete() {
        return this._column.delete();
    }
    getSubColumns() {
        var output = [];
        if (this._column.columns.length) this._column.columns.forEach(function(column) {
            output.push(column.getComponent());
        });
        return output;
    }
    getParentColumn() {
        return this._column.getParentComponent();
    }
    _getSelf() {
        return this._column;
    }
    scrollTo(position, ifVisible) {
        return this._column.table.columnManager.scrollToColumn(this._column, position, ifVisible);
    }
    getTable() {
        return this._column.table;
    }
    move(to, after) {
        var toColumn = this._column.table.columnManager.findColumn(to);
        if (toColumn) this._column.table.columnManager.moveColumn(this._column, toColumn, after);
        else console.warn("Move Error - No matching column found:", toColumn);
    }
    getNextColumn() {
        var nextCol = this._column.nextColumn();
        return nextCol ? nextCol.getComponent() : false;
    }
    getPrevColumn() {
        var prevCol = this._column.prevColumn();
        return prevCol ? prevCol.getComponent() : false;
    }
    updateDefinition(updates) {
        return this._column.updateDefinition(updates);
    }
    getWidth() {
        return this._column.getWidth();
    }
    setWidth(width) {
        var result;
        if (width === true) result = this._column.reinitializeWidth(true);
        else result = this._column.setWidth(width);
        this._column.table.columnManager.rerenderColumns(true);
        return result;
    }
}
var $c2a9788f40f9c90a$var$defaultColumnOptions = {
    "title": undefined,
    "field": undefined,
    "columns": undefined,
    "visible": undefined,
    "hozAlign": undefined,
    "vertAlign": undefined,
    "width": undefined,
    "minWidth": 40,
    "maxWidth": undefined,
    "maxInitialWidth": undefined,
    "cssClass": undefined,
    "variableHeight": undefined,
    "headerVertical": undefined,
    "headerHozAlign": undefined,
    "headerWordWrap": false,
    "editableTitle": undefined
};
class $c2a9788f40f9c90a$var$Column extends $c2a9788f40f9c90a$var$CoreFeature {
    static defaultOptionList = $c2a9788f40f9c90a$var$defaultColumnOptions;
    constructor(def, parent, rowHeader){
        super(parent.table);
        this.definition = def; //column definition
        this.parent = parent; //hold parent object
        this.type = "column"; //type of element
        this.columns = []; //child columns
        this.cells = []; //cells bound to this column
        this.isGroup = false;
        this.isRowHeader = rowHeader;
        this.element = this.createElement(); //column header element
        this.contentElement = false;
        this.titleHolderElement = false;
        this.titleElement = false;
        this.groupElement = this.createGroupElement(); //column group holder element
        this.hozAlign = ""; //horizontal text alignment
        this.vertAlign = ""; //vert text alignment
        //multi dimensional filed handling
        this.field = "";
        this.fieldStructure = "";
        this.getFieldValue = "";
        this.setFieldValue = "";
        this.titleDownload = null;
        this.titleFormatterRendered = false;
        this.mapDefinitions();
        this.setField(this.definition.field);
        this.modules = {}; //hold module variables;
        this.width = null; //column width
        this.widthStyled = ""; //column width pre-styled to improve render efficiency
        this.maxWidth = null; //column maximum width
        this.maxWidthStyled = ""; //column maximum pre-styled to improve render efficiency
        this.maxInitialWidth = null;
        this.minWidth = null; //column minimum width
        this.minWidthStyled = ""; //column minimum pre-styled to improve render efficiency
        this.widthFixed = false; //user has specified a width for this column
        this.visible = true; //default visible state
        this.component = null;
        //initialize column
        if (this.definition.columns) {
            this.isGroup = true;
            this.definition.columns.forEach((def, i)=>{
                var newCol = new $c2a9788f40f9c90a$var$Column(def, this);
                this.attachColumn(newCol);
            });
            this.checkColumnVisibility();
        } else parent.registerColumnField(this);
        this._initialize();
    }
    createElement() {
        var el = document.createElement("div");
        el.classList.add("tabulator-col");
        el.setAttribute("role", "columnheader");
        el.setAttribute("aria-sort", "none");
        if (this.isRowHeader) el.classList.add("tabulator-row-header");
        switch(this.table.options.columnHeaderVertAlign){
            case "middle":
                el.style.justifyContent = "center";
                break;
            case "bottom":
                el.style.justifyContent = "flex-end";
                break;
        }
        return el;
    }
    createGroupElement() {
        var el = document.createElement("div");
        el.classList.add("tabulator-col-group-cols");
        return el;
    }
    mapDefinitions() {
        var defaults = this.table.options.columnDefaults;
        //map columnDefaults onto column definitions
        if (defaults) {
            for(let key in defaults)if (typeof this.definition[key] === "undefined") this.definition[key] = defaults[key];
        }
        this.definition = this.table.columnManager.optionsList.generate($c2a9788f40f9c90a$var$Column.defaultOptionList, this.definition);
    }
    checkDefinition() {
        Object.keys(this.definition).forEach((key)=>{
            if ($c2a9788f40f9c90a$var$Column.defaultOptionList.indexOf(key) === -1) console.warn("Invalid column definition option in '" + (this.field || this.definition.title) + "' column:", key);
        });
    }
    setField(field) {
        this.field = field;
        this.fieldStructure = field ? this.table.options.nestedFieldSeparator ? field.split(this.table.options.nestedFieldSeparator) : [
            field
        ] : [];
        this.getFieldValue = this.fieldStructure.length > 1 ? this._getNestedData : this._getFlatData;
        this.setFieldValue = this.fieldStructure.length > 1 ? this._setNestedData : this._setFlatData;
    }
    //register column position with column manager
    registerColumnPosition(column) {
        this.parent.registerColumnPosition(column);
    }
    //register column position with column manager
    registerColumnField(column) {
        this.parent.registerColumnField(column);
    }
    //trigger position registration
    reRegisterPosition() {
        if (this.isGroup) this.columns.forEach(function(column) {
            column.reRegisterPosition();
        });
        else this.registerColumnPosition(this);
    }
    //build header element
    _initialize() {
        var def = this.definition;
        while(this.element.firstChild)this.element.removeChild(this.element.firstChild);
        if (def.headerVertical) {
            this.element.classList.add("tabulator-col-vertical");
            if (def.headerVertical === "flip") this.element.classList.add("tabulator-col-vertical-flip");
        }
        this.contentElement = this._buildColumnHeaderContent();
        this.element.appendChild(this.contentElement);
        if (this.isGroup) this._buildGroupHeader();
        else this._buildColumnHeader();
        this.dispatch("column-init", this);
    }
    //build header element for header
    _buildColumnHeader() {
        var def = this.definition;
        this.dispatch("column-layout", this);
        //set column visibility
        if (typeof def.visible != "undefined") {
            if (def.visible) this.show(true);
            else this.hide(true);
        }
        //assign additional css classes to column header
        if (def.cssClass) {
            var classNames = def.cssClass.split(" ");
            classNames.forEach((className)=>{
                this.element.classList.add(className);
            });
        }
        if (def.field) this.element.setAttribute("tabulator-field", def.field);
        //set min width if present
        this.setMinWidth(parseInt(def.minWidth));
        if (def.maxInitialWidth) this.maxInitialWidth = parseInt(def.maxInitialWidth);
        if (def.maxWidth) this.setMaxWidth(parseInt(def.maxWidth));
        this.reinitializeWidth();
        //set horizontal text alignment
        this.hozAlign = this.definition.hozAlign;
        this.vertAlign = this.definition.vertAlign;
        this.titleElement.style.textAlign = this.definition.headerHozAlign;
    }
    _buildColumnHeaderContent() {
        var contentElement = document.createElement("div");
        contentElement.classList.add("tabulator-col-content");
        this.titleHolderElement = document.createElement("div");
        this.titleHolderElement.classList.add("tabulator-col-title-holder");
        contentElement.appendChild(this.titleHolderElement);
        this.titleElement = this._buildColumnHeaderTitle();
        this.titleHolderElement.appendChild(this.titleElement);
        return contentElement;
    }
    //build title element of column
    _buildColumnHeaderTitle() {
        var def = this.definition;
        var titleHolderElement = document.createElement("div");
        titleHolderElement.classList.add("tabulator-col-title");
        if (def.headerWordWrap) titleHolderElement.classList.add("tabulator-col-title-wrap");
        if (def.editableTitle) {
            var titleElement = document.createElement("input");
            titleElement.classList.add("tabulator-title-editor");
            titleElement.addEventListener("click", (e)=>{
                e.stopPropagation();
                titleElement.focus();
            });
            titleElement.addEventListener("mousedown", (e)=>{
                e.stopPropagation();
            });
            titleElement.addEventListener("change", ()=>{
                def.title = titleElement.value;
                this.dispatchExternal("columnTitleChanged", this.getComponent());
            });
            titleHolderElement.appendChild(titleElement);
            if (def.field) this.langBind("columns|" + def.field, (text)=>{
                titleElement.value = text || def.title || "&nbsp;";
            });
            else titleElement.value = def.title || "&nbsp;";
        } else if (def.field) this.langBind("columns|" + def.field, (text)=>{
            this._formatColumnHeaderTitle(titleHolderElement, text || def.title || "&nbsp;");
        });
        else this._formatColumnHeaderTitle(titleHolderElement, def.title || "&nbsp;");
        return titleHolderElement;
    }
    _formatColumnHeaderTitle(el, title) {
        var contents = this.chain("column-format", [
            this,
            title,
            el
        ], null, ()=>{
            return title;
        });
        switch(typeof contents){
            case "object":
                if (contents instanceof Node) el.appendChild(contents);
                else {
                    el.innerHTML = "";
                    console.warn("Format Error - Title formatter has returned a type of object, the only valid formatter object return is an instance of Node, the formatter returned:", contents);
                }
                break;
            case "undefined":
                el.innerHTML = "";
                break;
            default:
                el.innerHTML = contents;
        }
    }
    //build header element for column group
    _buildGroupHeader() {
        this.element.classList.add("tabulator-col-group");
        this.element.setAttribute("role", "columngroup");
        this.element.setAttribute("aria-title", this.definition.title);
        //asign additional css classes to column header
        if (this.definition.cssClass) {
            var classNames = this.definition.cssClass.split(" ");
            classNames.forEach((className)=>{
                this.element.classList.add(className);
            });
        }
        this.titleElement.style.textAlign = this.definition.headerHozAlign;
        this.element.appendChild(this.groupElement);
    }
    //flat field lookup
    _getFlatData(data) {
        return data[this.field];
    }
    //nested field lookup
    _getNestedData(data) {
        var dataObj = data, structure = this.fieldStructure, length = structure.length, output;
        for(let i = 0; i < length; i++){
            dataObj = dataObj[structure[i]];
            output = dataObj;
            if (!dataObj) break;
        }
        return output;
    }
    //flat field set
    _setFlatData(data, value) {
        if (this.field) data[this.field] = value;
    }
    //nested field set
    _setNestedData(data, value) {
        var dataObj = data, structure = this.fieldStructure, length = structure.length;
        for(let i = 0; i < length; i++)if (i == length - 1) dataObj[structure[i]] = value;
        else {
            if (!dataObj[structure[i]]) {
                if (typeof value !== "undefined") dataObj[structure[i]] = {};
                else break;
            }
            dataObj = dataObj[structure[i]];
        }
    }
    //attach column to this group
    attachColumn(column) {
        if (this.groupElement) {
            this.columns.push(column);
            this.groupElement.appendChild(column.getElement());
            column.columnRendered();
        } else console.warn("Column Warning - Column being attached to another column instead of column group");
    }
    //vertically align header in column
    verticalAlign(alignment, height) {
        //calculate height of column header and group holder element
        var parentHeight = this.parent.isGroup ? this.parent.getGroupElement().clientHeight : height || this.parent.getHeadersElement().clientHeight;
        // var parentHeight = this.parent.isGroup ? this.parent.getGroupElement().clientHeight : this.parent.getHeadersElement().clientHeight;
        this.element.style.height = parentHeight + "px";
        this.dispatch("column-height", this, this.element.style.height);
        if (this.isGroup) this.groupElement.style.minHeight = parentHeight - this.contentElement.offsetHeight + "px";
        //vertically align cell contents
        // if(!this.isGroup && alignment !== "top"){
        // 	if(alignment === "bottom"){
        // 		this.element.style.paddingTop = (this.element.clientHeight - this.contentElement.offsetHeight) + "px";
        // 	}else{
        // 		this.element.style.paddingTop = ((this.element.clientHeight - this.contentElement.offsetHeight) / 2) + "px";
        // 	}
        // }
        this.columns.forEach(function(column) {
            column.verticalAlign(alignment);
        });
    }
    //clear vertical alignment
    clearVerticalAlign() {
        this.element.style.paddingTop = "";
        this.element.style.height = "";
        this.element.style.minHeight = "";
        this.groupElement.style.minHeight = "";
        this.columns.forEach(function(column) {
            column.clearVerticalAlign();
        });
        this.dispatch("column-height", this, "");
    }
    //// Retrieve Column Information ////
    //return column header element
    getElement() {
        return this.element;
    }
    //return column group element
    getGroupElement() {
        return this.groupElement;
    }
    //return field name
    getField() {
        return this.field;
    }
    getTitleDownload() {
        return this.titleDownload;
    }
    //return the first column in a group
    getFirstColumn() {
        if (!this.isGroup) return this;
        else {
            if (this.columns.length) return this.columns[0].getFirstColumn();
            else return false;
        }
    }
    //return the last column in a group
    getLastColumn() {
        if (!this.isGroup) return this;
        else {
            if (this.columns.length) return this.columns[this.columns.length - 1].getLastColumn();
            else return false;
        }
    }
    //return all columns in a group
    getColumns(traverse) {
        var columns = [];
        if (traverse) this.columns.forEach((column)=>{
            columns.push(column);
            columns = columns.concat(column.getColumns(true));
        });
        else columns = this.columns;
        return columns;
    }
    //return all columns in a group
    getCells() {
        return this.cells;
    }
    //retrieve the top column in a group of columns
    getTopColumn() {
        if (this.parent.isGroup) return this.parent.getTopColumn();
        else return this;
    }
    //return column definition object
    getDefinition(updateBranches) {
        var colDefs = [];
        if (this.isGroup && updateBranches) {
            this.columns.forEach(function(column) {
                colDefs.push(column.getDefinition(true));
            });
            this.definition.columns = colDefs;
        }
        return this.definition;
    }
    //////////////////// Actions ////////////////////
    checkColumnVisibility() {
        var visible = false;
        this.columns.forEach(function(column) {
            if (column.visible) visible = true;
        });
        if (visible) {
            this.show();
            this.dispatchExternal("columnVisibilityChanged", this.getComponent(), false);
        } else this.hide();
    }
    //show column
    show(silent, responsiveToggle) {
        if (!this.visible) {
            this.visible = true;
            this.element.style.display = "";
            if (this.parent.isGroup) this.parent.checkColumnVisibility();
            this.cells.forEach(function(cell) {
                cell.show();
            });
            if (!this.isGroup && this.width === null) this.reinitializeWidth();
            this.table.columnManager.verticalAlignHeaders();
            this.dispatch("column-show", this, responsiveToggle);
            if (!silent) this.dispatchExternal("columnVisibilityChanged", this.getComponent(), true);
            if (this.parent.isGroup) this.parent.matchChildWidths();
            if (!this.silent) this.table.columnManager.rerenderColumns();
        }
    }
    //hide column
    hide(silent, responsiveToggle) {
        if (this.visible) {
            this.visible = false;
            this.element.style.display = "none";
            this.table.columnManager.verticalAlignHeaders();
            if (this.parent.isGroup) this.parent.checkColumnVisibility();
            this.cells.forEach(function(cell) {
                cell.hide();
            });
            this.dispatch("column-hide", this, responsiveToggle);
            if (!silent) this.dispatchExternal("columnVisibilityChanged", this.getComponent(), false);
            if (this.parent.isGroup) this.parent.matchChildWidths();
            if (!this.silent) this.table.columnManager.rerenderColumns();
        }
    }
    matchChildWidths() {
        var childWidth = 0;
        if (this.contentElement && this.columns.length) {
            this.columns.forEach(function(column) {
                if (column.visible) childWidth += column.getWidth();
            });
            this.contentElement.style.maxWidth = childWidth - 1 + "px";
            if (this.table.initialized) this.element.style.width = childWidth + "px";
            if (this.parent.isGroup) this.parent.matchChildWidths();
        }
    }
    removeChild(child) {
        var index = this.columns.indexOf(child);
        if (index > -1) this.columns.splice(index, 1);
        if (!this.columns.length) this.delete();
    }
    setWidth(width) {
        this.widthFixed = true;
        this.setWidthActual(width);
    }
    setWidthActual(width) {
        if (isNaN(width)) width = Math.floor(this.table.element.clientWidth / 100 * parseInt(width));
        width = Math.max(this.minWidth, width);
        if (this.maxWidth) width = Math.min(this.maxWidth, width);
        this.width = width;
        this.widthStyled = width ? width + "px" : "";
        this.element.style.width = this.widthStyled;
        if (!this.isGroup) this.cells.forEach(function(cell) {
            cell.setWidth();
        });
        if (this.parent.isGroup) this.parent.matchChildWidths();
        this.dispatch("column-width", this);
        if (this.subscribedExternal("columnWidth")) this.dispatchExternal("columnWidth", this.getComponent());
    }
    checkCellHeights() {
        var rows = [];
        this.cells.forEach(function(cell) {
            if (cell.row.heightInitialized) {
                if (cell.row.getElement().offsetParent !== null) {
                    rows.push(cell.row);
                    cell.row.clearCellHeight();
                } else cell.row.heightInitialized = false;
            }
        });
        rows.forEach(function(row) {
            row.calcHeight();
        });
        rows.forEach(function(row) {
            row.setCellHeight();
        });
    }
    getWidth() {
        var width = 0;
        if (this.isGroup) this.columns.forEach(function(column) {
            if (column.visible) width += column.getWidth();
        });
        else width = this.width;
        return width;
    }
    getLeftOffset() {
        var offset = this.element.offsetLeft;
        if (this.parent.isGroup) offset += this.parent.getLeftOffset();
        return offset;
    }
    getHeight() {
        return Math.ceil(this.element.getBoundingClientRect().height);
    }
    setMinWidth(minWidth) {
        if (this.maxWidth && minWidth > this.maxWidth) {
            minWidth = this.maxWidth;
            console.warn("the minWidth (" + minWidth + "px) for column '" + this.field + "' cannot be bigger that its maxWidth (" + this.maxWidthStyled + ")");
        }
        this.minWidth = minWidth;
        this.minWidthStyled = minWidth ? minWidth + "px" : "";
        this.element.style.minWidth = this.minWidthStyled;
        this.cells.forEach(function(cell) {
            cell.setMinWidth();
        });
    }
    setMaxWidth(maxWidth) {
        if (this.minWidth && maxWidth < this.minWidth) {
            maxWidth = this.minWidth;
            console.warn("the maxWidth (" + maxWidth + "px) for column '" + this.field + "' cannot be smaller that its minWidth (" + this.minWidthStyled + ")");
        }
        this.maxWidth = maxWidth;
        this.maxWidthStyled = maxWidth ? maxWidth + "px" : "";
        this.element.style.maxWidth = this.maxWidthStyled;
        this.cells.forEach(function(cell) {
            cell.setMaxWidth();
        });
    }
    delete() {
        return new Promise((resolve, reject)=>{
            if (this.isGroup) this.columns.forEach(function(column) {
                column.delete();
            });
            this.dispatch("column-delete", this);
            var cellCount = this.cells.length;
            for(let i = 0; i < cellCount; i++)this.cells[0].delete();
            if (this.element.parentNode) this.element.parentNode.removeChild(this.element);
            this.element = false;
            this.contentElement = false;
            this.titleElement = false;
            this.groupElement = false;
            if (this.parent.isGroup) this.parent.removeChild(this);
            this.table.columnManager.deregisterColumn(this);
            this.table.columnManager.rerenderColumns(true);
            this.dispatch("column-deleted", this);
            resolve();
        });
    }
    columnRendered() {
        if (this.titleFormatterRendered) this.titleFormatterRendered();
        this.dispatch("column-rendered", this);
    }
    //////////////// Cell Management /////////////////
    //generate cell for this column
    generateCell(row) {
        var cell = new $c2a9788f40f9c90a$var$Cell(this, row);
        this.cells.push(cell);
        return cell;
    }
    nextColumn() {
        var index = this.table.columnManager.findColumnIndex(this);
        return index > -1 ? this._nextVisibleColumn(index + 1) : false;
    }
    _nextVisibleColumn(index) {
        var column = this.table.columnManager.getColumnByIndex(index);
        return !column || column.visible ? column : this._nextVisibleColumn(index + 1);
    }
    prevColumn() {
        var index = this.table.columnManager.findColumnIndex(this);
        return index > -1 ? this._prevVisibleColumn(index - 1) : false;
    }
    _prevVisibleColumn(index) {
        var column = this.table.columnManager.getColumnByIndex(index);
        return !column || column.visible ? column : this._prevVisibleColumn(index - 1);
    }
    reinitializeWidth(force) {
        this.widthFixed = false;
        //set width if present
        if (typeof this.definition.width !== "undefined" && !force) // maxInitialWidth ignored here as width specified
        this.setWidth(this.definition.width);
        this.dispatch("column-width-fit-before", this);
        this.fitToData(force);
        this.dispatch("column-width-fit-after", this);
    }
    //set column width to maximum cell width for non group columns
    fitToData(force) {
        if (this.isGroup) return;
        if (!this.widthFixed) {
            this.element.style.width = "";
            this.cells.forEach((cell)=>{
                cell.clearWidth();
            });
        }
        var maxWidth = this.element.offsetWidth;
        if (!this.width || !this.widthFixed) {
            this.cells.forEach((cell)=>{
                var width = cell.getWidth();
                if (width > maxWidth) maxWidth = width;
            });
            if (maxWidth) {
                var setTo = maxWidth + 1;
                if (this.maxInitialWidth && !force) setTo = Math.min(setTo, this.maxInitialWidth);
                this.setWidthActual(setTo);
            }
        }
    }
    updateDefinition(updates) {
        var definition;
        if (!this.isGroup) {
            if (!this.parent.isGroup) {
                definition = Object.assign({}, this.getDefinition());
                definition = Object.assign(definition, updates);
                return this.table.columnManager.addColumn(definition, false, this).then((column)=>{
                    if (definition.field == this.field) this.field = false; //clear field name to prevent deletion of duplicate column from arrays
                    return this.delete().then(()=>{
                        return column.getComponent();
                    });
                });
            } else {
                console.error("Column Update Error - The updateDefinition function is only available on ungrouped columns");
                return Promise.reject("Column Update Error - The updateDefinition function is only available on columns, not column groups");
            }
        } else {
            console.error("Column Update Error - The updateDefinition function is only available on ungrouped columns");
            return Promise.reject("Column Update Error - The updateDefinition function is only available on columns, not column groups");
        }
    }
    deleteCell(cell) {
        var index = this.cells.indexOf(cell);
        if (index > -1) this.cells.splice(index, 1);
    }
    //////////////// Object Generation /////////////////
    getComponent() {
        if (!this.component) this.component = new $c2a9788f40f9c90a$export$11bb209ad3a8e411(this);
        return this.component;
    }
    getPosition() {
        return this.table.columnManager.getVisibleColumnsByIndex().indexOf(this) + 1;
    }
    getParentComponent() {
        return this.parent instanceof $c2a9788f40f9c90a$var$Column ? this.parent.getComponent() : false;
    }
}
//public row object
class $c2a9788f40f9c90a$export$5df91075f5ba4651 {
    constructor(row){
        this._row = row;
        return new Proxy(this, {
            get: function(target, name, receiver) {
                if (typeof target[name] !== "undefined") return target[name];
                else return target._row.table.componentFunctionBinder.handle("row", target._row, name);
            }
        });
    }
    getData(transform) {
        return this._row.getData(transform);
    }
    getElement() {
        return this._row.getElement();
    }
    getCells() {
        var cells = [];
        this._row.getCells().forEach(function(cell) {
            cells.push(cell.getComponent());
        });
        return cells;
    }
    getCell(column) {
        var cell = this._row.getCell(column);
        return cell ? cell.getComponent() : false;
    }
    getIndex() {
        return this._row.getData("data")[this._row.table.options.index];
    }
    getPosition() {
        return this._row.getPosition();
    }
    watchPosition(callback) {
        return this._row.watchPosition(callback);
    }
    delete() {
        return this._row.delete();
    }
    scrollTo(position, ifVisible) {
        return this._row.table.rowManager.scrollToRow(this._row, position, ifVisible);
    }
    move(to, after) {
        this._row.moveToRow(to, after);
    }
    update(data) {
        return this._row.updateData(data);
    }
    normalizeHeight() {
        this._row.normalizeHeight(true);
    }
    _getSelf() {
        return this._row;
    }
    reformat() {
        return this._row.reinitialize();
    }
    getTable() {
        return this._row.table;
    }
    getNextRow() {
        var row = this._row.nextRow();
        return row ? row.getComponent() : row;
    }
    getPrevRow() {
        var row = this._row.prevRow();
        return row ? row.getComponent() : row;
    }
}
class $c2a9788f40f9c90a$var$Row extends $c2a9788f40f9c90a$var$CoreFeature {
    constructor(data, parent, type = "row"){
        super(parent.table);
        this.parent = parent;
        this.data = {};
        this.type = type; //type of element
        this.element = false;
        this.modules = {}; //hold module variables;
        this.cells = [];
        this.height = 0; //hold element height
        this.heightStyled = ""; //hold element height pre-styled to improve render efficiency
        this.manualHeight = false; //user has manually set row height
        this.outerHeight = 0; //hold elements outer height
        this.initialized = false; //element has been rendered
        this.heightInitialized = false; //element has resized cells to fit
        this.position = 0; //store position of element in row list
        this.positionWatchers = [];
        this.component = null;
        this.created = false;
        this.setData(data);
    }
    create() {
        if (!this.created) {
            this.created = true;
            this.generateElement();
        }
    }
    createElement() {
        var el = document.createElement("div");
        el.classList.add("tabulator-row");
        el.setAttribute("role", "row");
        this.element = el;
    }
    getElement() {
        this.create();
        return this.element;
    }
    detachElement() {
        if (this.element && this.element.parentNode) this.element.parentNode.removeChild(this.element);
    }
    generateElement() {
        this.createElement();
        this.dispatch("row-init", this);
    }
    generateCells() {
        this.cells = this.table.columnManager.generateCells(this);
    }
    //functions to setup on first render
    initialize(force, inFragment) {
        this.create();
        if (!this.initialized || force) {
            this.deleteCells();
            while(this.element.firstChild)this.element.removeChild(this.element.firstChild);
            this.dispatch("row-layout-before", this);
            this.generateCells();
            this.initialized = true;
            this.table.columnManager.renderer.renderRowCells(this, inFragment);
            if (force) this.normalizeHeight();
            this.dispatch("row-layout", this);
            if (this.table.options.rowFormatter) this.table.options.rowFormatter(this.getComponent());
            this.dispatch("row-layout-after", this);
        } else this.table.columnManager.renderer.rerenderRowCells(this, inFragment);
    }
    rendered() {
        this.cells.forEach((cell)=>{
            cell.cellRendered();
        });
    }
    reinitializeHeight() {
        this.heightInitialized = false;
        if (this.element && this.element.offsetParent !== null) this.normalizeHeight(true);
    }
    deinitialize() {
        this.initialized = false;
    }
    deinitializeHeight() {
        this.heightInitialized = false;
    }
    reinitialize(children) {
        this.initialized = false;
        this.heightInitialized = false;
        if (!this.manualHeight) {
            this.height = 0;
            this.heightStyled = "";
        }
        if (this.element && this.element.offsetParent !== null) this.initialize(true);
        this.dispatch("row-relayout", this);
    }
    //get heights when doing bulk row style calcs in virtual DOM
    calcHeight(force) {
        var maxHeight = 0, minHeight = 0;
        if (this.table.options.rowHeight) this.height = this.table.options.rowHeight;
        else {
            minHeight = this.calcMinHeight();
            maxHeight = this.calcMaxHeight();
            if (force) this.height = Math.max(maxHeight, minHeight);
            else this.height = this.manualHeight ? this.height : Math.max(maxHeight, minHeight);
        }
        this.heightStyled = this.height ? this.height + "px" : "";
        this.outerHeight = this.element.offsetHeight;
    }
    calcMinHeight() {
        return this.table.options.resizableRows ? this.element.clientHeight : 0;
    }
    calcMaxHeight() {
        var maxHeight = 0;
        this.cells.forEach(function(cell) {
            var height = cell.getHeight();
            if (height > maxHeight) maxHeight = height;
        });
        return maxHeight;
    }
    //set of cells
    setCellHeight() {
        this.cells.forEach(function(cell) {
            cell.setHeight();
        });
        this.heightInitialized = true;
    }
    clearCellHeight() {
        this.cells.forEach(function(cell) {
            cell.clearHeight();
        });
    }
    //normalize the height of elements in the row
    normalizeHeight(force) {
        if (force && !this.table.options.rowHeight) this.clearCellHeight();
        this.calcHeight(force);
        this.setCellHeight();
    }
    //set height of rows
    setHeight(height, force) {
        if (this.height != height || force) {
            this.manualHeight = true;
            this.height = height;
            this.heightStyled = height ? height + "px" : "";
            this.setCellHeight();
            // this.outerHeight = this.element.outerHeight();
            this.outerHeight = this.element.offsetHeight;
            if (this.subscribedExternal("rowHeight")) this.dispatchExternal("rowHeight", this.getComponent());
        }
    }
    //return rows outer height
    getHeight() {
        return this.outerHeight;
    }
    //return rows outer Width
    getWidth() {
        return this.element.offsetWidth;
    }
    //////////////// Cell Management /////////////////
    deleteCell(cell) {
        var index = this.cells.indexOf(cell);
        if (index > -1) this.cells.splice(index, 1);
    }
    //////////////// Data Management /////////////////
    setData(data) {
        this.data = this.chain("row-data-init-before", [
            this,
            data
        ], undefined, data);
        this.dispatch("row-data-init-after", this);
    }
    //update the rows data
    updateData(updatedData) {
        var visible = this.element && $c2a9788f40f9c90a$var$Helpers.elVisible(this.element), tempData = {}, newRowData;
        return new Promise((resolve, reject)=>{
            if (typeof updatedData === "string") updatedData = JSON.parse(updatedData);
            this.dispatch("row-data-save-before", this);
            if (this.subscribed("row-data-changing")) {
                tempData = Object.assign(tempData, this.data);
                tempData = Object.assign(tempData, updatedData);
            }
            newRowData = this.chain("row-data-changing", [
                this,
                tempData,
                updatedData
            ], null, updatedData);
            //set data
            for(let attrname in newRowData)this.data[attrname] = newRowData[attrname];
            this.dispatch("row-data-save-after", this);
            //update affected cells only
            for(let attrname in updatedData){
                let columns = this.table.columnManager.getColumnsByFieldRoot(attrname);
                columns.forEach((column)=>{
                    let cell = this.getCell(column.getField());
                    if (cell) {
                        let value = column.getFieldValue(newRowData);
                        if (cell.getValue() !== value) {
                            cell.setValueProcessData(value);
                            if (visible) cell.cellRendered();
                        }
                    }
                });
            }
            //Partial reinitialization if visible
            if (visible) {
                this.normalizeHeight(true);
                if (this.table.options.rowFormatter) this.table.options.rowFormatter(this.getComponent());
            } else {
                this.initialized = false;
                this.height = 0;
                this.heightStyled = "";
            }
            this.dispatch("row-data-changed", this, visible, updatedData);
            //this.reinitialize();
            this.dispatchExternal("rowUpdated", this.getComponent());
            if (this.subscribedExternal("dataChanged")) this.dispatchExternal("dataChanged", this.table.rowManager.getData());
            resolve();
        });
    }
    getData(transform) {
        if (transform) return this.chain("row-data-retrieve", [
            this,
            transform
        ], null, this.data);
        return this.data;
    }
    getCell(column) {
        var match = false;
        column = this.table.columnManager.findColumn(column);
        if (!this.initialized && this.cells.length === 0) this.generateCells();
        match = this.cells.find(function(cell) {
            return cell.column === column;
        });
        return match;
    }
    getCellIndex(findCell) {
        return this.cells.findIndex(function(cell) {
            return cell === findCell;
        });
    }
    findCell(subject) {
        return this.cells.find((cell)=>{
            return cell.element === subject;
        });
    }
    getCells() {
        if (!this.initialized && this.cells.length === 0) this.generateCells();
        return this.cells;
    }
    nextRow() {
        var row = this.table.rowManager.nextDisplayRow(this, true);
        return row || false;
    }
    prevRow() {
        var row = this.table.rowManager.prevDisplayRow(this, true);
        return row || false;
    }
    moveToRow(to, before) {
        var toRow = this.table.rowManager.findRow(to);
        if (toRow) {
            this.table.rowManager.moveRowActual(this, toRow, !before);
            this.table.rowManager.refreshActiveData("display", false, true);
        } else console.warn("Move Error - No matching row found:", to);
    }
    ///////////////////// Actions  /////////////////////
    delete() {
        this.dispatch("row-delete", this);
        this.deleteActual();
        return Promise.resolve();
    }
    deleteActual(blockRedraw) {
        this.detachModules();
        this.table.rowManager.deleteRow(this, blockRedraw);
        this.deleteCells();
        this.initialized = false;
        this.heightInitialized = false;
        this.element = false;
        this.dispatch("row-deleted", this);
    }
    detachModules() {
        this.dispatch("row-deleting", this);
    }
    deleteCells() {
        var cellCount = this.cells.length;
        for(let i = 0; i < cellCount; i++)this.cells[0].delete();
    }
    wipe() {
        this.detachModules();
        this.deleteCells();
        if (this.element) {
            while(this.element.firstChild)this.element.removeChild(this.element.firstChild);
            if (this.element.parentNode) this.element.parentNode.removeChild(this.element);
        }
        this.element = false;
        this.modules = {};
    }
    isDisplayed() {
        return this.table.rowManager.getDisplayRows().includes(this);
    }
    getPosition() {
        return this.isDisplayed() ? this.position : false;
    }
    setPosition(position) {
        if (position != this.position) {
            this.position = position;
            this.positionWatchers.forEach((callback)=>{
                callback(this.position);
            });
        }
    }
    watchPosition(callback) {
        this.positionWatchers.push(callback);
        callback(this.position);
    }
    getGroup() {
        return this.modules.group || false;
    }
    //////////////// Object Generation /////////////////
    getComponent() {
        if (!this.component) this.component = new $c2a9788f40f9c90a$export$5df91075f5ba4651(this);
        return this.component;
    }
}
var $c2a9788f40f9c90a$var$defaultCalculations = {
    "avg": function(values, data, calcParams) {
        var output = 0, precision = typeof calcParams.precision !== "undefined" ? calcParams.precision : 2;
        if (values.length) {
            output = values.reduce(function(sum, value) {
                return Number(sum) + Number(value);
            });
            output = output / values.length;
            output = precision !== false ? output.toFixed(precision) : output;
        }
        return parseFloat(output).toString();
    },
    "max": function(values, data, calcParams) {
        var output = null, precision = typeof calcParams.precision !== "undefined" ? calcParams.precision : false;
        values.forEach(function(value) {
            value = Number(value);
            if (value > output || output === null) output = value;
        });
        return output !== null ? precision !== false ? output.toFixed(precision) : output : "";
    },
    "min": function(values, data, calcParams) {
        var output = null, precision = typeof calcParams.precision !== "undefined" ? calcParams.precision : false;
        values.forEach(function(value) {
            value = Number(value);
            if (value < output || output === null) output = value;
        });
        return output !== null ? precision !== false ? output.toFixed(precision) : output : "";
    },
    "sum": function(values, data, calcParams) {
        var output = 0, precision = typeof calcParams.precision !== "undefined" ? calcParams.precision : false;
        if (values.length) values.forEach(function(value) {
            value = Number(value);
            output += !isNaN(value) ? Number(value) : 0;
        });
        return precision !== false ? output.toFixed(precision) : output;
    },
    "concat": function(values, data, calcParams) {
        var output = 0;
        if (values.length) output = values.reduce(function(sum, value) {
            return String(sum) + String(value);
        });
        return output;
    },
    "count": function(values, data, calcParams) {
        var output = 0;
        if (values.length) values.forEach(function(value) {
            if (value) output++;
        });
        return output;
    },
    "unique": function(values, data, calcParams) {
        var unique = values.filter((value, index)=>{
            return (values || value === 0) && values.indexOf(value) === index;
        });
        return unique.length;
    }
};
class $c2a9788f40f9c90a$export$840b3bc55b30dec6 extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "columnCalcs";
    //load defaults
    static calculations = $c2a9788f40f9c90a$var$defaultCalculations;
    constructor(table){
        super(table);
        this.topCalcs = [];
        this.botCalcs = [];
        this.genColumn = false;
        this.topElement = this.createElement();
        this.botElement = this.createElement();
        this.topRow = false;
        this.botRow = false;
        this.topInitialized = false;
        this.botInitialized = false;
        this.blocked = false;
        this.recalcAfterBlock = false;
        this.registerTableOption("columnCalcs", true);
        this.registerColumnOption("topCalc");
        this.registerColumnOption("topCalcParams");
        this.registerColumnOption("topCalcFormatter");
        this.registerColumnOption("topCalcFormatterParams");
        this.registerColumnOption("bottomCalc");
        this.registerColumnOption("bottomCalcParams");
        this.registerColumnOption("bottomCalcFormatter");
        this.registerColumnOption("bottomCalcFormatterParams");
    }
    createElement() {
        var el = document.createElement("div");
        el.classList.add("tabulator-calcs-holder");
        return el;
    }
    initialize() {
        this.genColumn = new $c2a9788f40f9c90a$var$Column({
            field: "value"
        }, this);
        this.subscribe("cell-value-changed", this.cellValueChanged.bind(this));
        this.subscribe("column-init", this.initializeColumnCheck.bind(this));
        this.subscribe("row-deleted", this.rowsUpdated.bind(this));
        this.subscribe("scroll-horizontal", this.scrollHorizontal.bind(this));
        this.subscribe("row-added", this.rowsUpdated.bind(this));
        this.subscribe("column-moved", this.recalcActiveRows.bind(this));
        this.subscribe("column-add", this.recalcActiveRows.bind(this));
        this.subscribe("data-refreshed", this.recalcActiveRowsRefresh.bind(this));
        this.subscribe("table-redraw", this.tableRedraw.bind(this));
        this.subscribe("rows-visible", this.visibleRows.bind(this));
        this.subscribe("scrollbar-vertical", this.adjustForScrollbar.bind(this));
        this.subscribe("redraw-blocked", this.blockRedraw.bind(this));
        this.subscribe("redraw-restored", this.restoreRedraw.bind(this));
        this.subscribe("table-redrawing", this.resizeHolderWidth.bind(this));
        this.subscribe("column-resized", this.resizeHolderWidth.bind(this));
        this.subscribe("column-show", this.resizeHolderWidth.bind(this));
        this.subscribe("column-hide", this.resizeHolderWidth.bind(this));
        this.registerTableFunction("getCalcResults", this.getResults.bind(this));
        this.registerTableFunction("recalc", this.userRecalc.bind(this));
        this.resizeHolderWidth();
    }
    resizeHolderWidth() {
        this.topElement.style.minWidth = this.table.columnManager.headersElement.offsetWidth + "px";
    }
    tableRedraw(force) {
        this.recalc(this.table.rowManager.activeRows);
        if (force) this.redraw();
    }
    blockRedraw() {
        this.blocked = true;
        this.recalcAfterBlock = false;
    }
    restoreRedraw() {
        this.blocked = false;
        if (this.recalcAfterBlock) {
            this.recalcAfterBlock = false;
            this.recalcActiveRowsRefresh();
        }
    }
    ///////////////////////////////////
    ///////// Table Functions /////////
    ///////////////////////////////////
    userRecalc() {
        this.recalc(this.table.rowManager.activeRows);
    }
    ///////////////////////////////////
    ///////// Internal Logic //////////
    ///////////////////////////////////
    blockCheck() {
        if (this.blocked) this.recalcAfterBlock = true;
        return this.blocked;
    }
    visibleRows(viewable, rows) {
        if (this.topRow) rows.unshift(this.topRow);
        if (this.botRow) rows.push(this.botRow);
        return rows;
    }
    rowsUpdated(row) {
        if (this.table.options.groupBy) this.recalcRowGroup(row);
        else this.recalcActiveRows();
    }
    recalcActiveRowsRefresh() {
        if (this.table.options.groupBy && this.table.options.dataTreeStartExpanded && this.table.options.dataTree) this.recalcAll();
        else this.recalcActiveRows();
    }
    recalcActiveRows() {
        this.recalc(this.table.rowManager.activeRows);
    }
    cellValueChanged(cell) {
        if (cell.column.definition.topCalc || cell.column.definition.bottomCalc) {
            if (this.table.options.groupBy) {
                if (this.table.options.columnCalcs == "table" || this.table.options.columnCalcs == "both") this.recalcActiveRows();
                if (this.table.options.columnCalcs != "table") this.recalcRowGroup(cell.row);
            } else this.recalcActiveRows();
        }
    }
    initializeColumnCheck(column) {
        if (column.definition.topCalc || column.definition.bottomCalc) this.initializeColumn(column);
    }
    //initialize column calcs
    initializeColumn(column) {
        var def = column.definition;
        var config = {
            topCalcParams: def.topCalcParams || {},
            botCalcParams: def.bottomCalcParams || {}
        };
        if (def.topCalc) {
            switch(typeof def.topCalc){
                case "string":
                    if ($c2a9788f40f9c90a$export$840b3bc55b30dec6.calculations[def.topCalc]) config.topCalc = $c2a9788f40f9c90a$export$840b3bc55b30dec6.calculations[def.topCalc];
                    else console.warn("Column Calc Error - No such calculation found, ignoring: ", def.topCalc);
                    break;
                case "function":
                    config.topCalc = def.topCalc;
                    break;
            }
            if (config.topCalc) {
                column.modules.columnCalcs = config;
                this.topCalcs.push(column);
                if (this.table.options.columnCalcs != "group") this.initializeTopRow();
            }
        }
        if (def.bottomCalc) {
            switch(typeof def.bottomCalc){
                case "string":
                    if ($c2a9788f40f9c90a$export$840b3bc55b30dec6.calculations[def.bottomCalc]) config.botCalc = $c2a9788f40f9c90a$export$840b3bc55b30dec6.calculations[def.bottomCalc];
                    else console.warn("Column Calc Error - No such calculation found, ignoring: ", def.bottomCalc);
                    break;
                case "function":
                    config.botCalc = def.bottomCalc;
                    break;
            }
            if (config.botCalc) {
                column.modules.columnCalcs = config;
                this.botCalcs.push(column);
                if (this.table.options.columnCalcs != "group") this.initializeBottomRow();
            }
        }
    }
    //dummy functions to handle being mock column manager
    registerColumnField() {}
    removeCalcs() {
        var changed = false;
        if (this.topInitialized) {
            this.topInitialized = false;
            this.topElement.parentNode.removeChild(this.topElement);
            changed = true;
        }
        if (this.botInitialized) {
            this.botInitialized = false;
            this.footerRemove(this.botElement);
            changed = true;
        }
        if (changed) this.table.rowManager.adjustTableSize();
    }
    reinitializeCalcs() {
        if (this.topCalcs.length) this.initializeTopRow();
        if (this.botCalcs.length) this.initializeBottomRow();
    }
    initializeTopRow() {
        var fragment = document.createDocumentFragment();
        if (!this.topInitialized) {
            fragment.appendChild(document.createElement("br"));
            fragment.appendChild(this.topElement);
            this.table.columnManager.getContentsElement().insertBefore(fragment, this.table.columnManager.headersElement.nextSibling);
            this.topInitialized = true;
        }
    }
    initializeBottomRow() {
        if (!this.botInitialized) {
            this.footerPrepend(this.botElement);
            this.botInitialized = true;
        }
    }
    scrollHorizontal(left) {
        if (this.botInitialized && this.botRow) this.botElement.scrollLeft = left;
    }
    recalc(rows) {
        var data, row;
        if (!this.blockCheck()) {
            if (this.topInitialized || this.botInitialized) {
                data = this.rowsToData(rows);
                if (this.topInitialized) {
                    if (this.topRow) this.topRow.deleteCells();
                    row = this.generateRow("top", data);
                    this.topRow = row;
                    while(this.topElement.firstChild)this.topElement.removeChild(this.topElement.firstChild);
                    this.topElement.appendChild(row.getElement());
                    row.initialize(true);
                }
                if (this.botInitialized) {
                    if (this.botRow) this.botRow.deleteCells();
                    row = this.generateRow("bottom", data);
                    this.botRow = row;
                    while(this.botElement.firstChild)this.botElement.removeChild(this.botElement.firstChild);
                    this.botElement.appendChild(row.getElement());
                    row.initialize(true);
                }
                this.table.rowManager.adjustTableSize();
                //set resizable handles
                if (this.table.modExists("frozenColumns")) this.table.modules.frozenColumns.layout();
            }
        }
    }
    recalcRowGroup(row) {
        this.recalcGroup(this.table.modules.groupRows.getRowGroup(row));
    }
    recalcAll() {
        if (this.topCalcs.length || this.botCalcs.length) {
            if (this.table.options.columnCalcs !== "group") this.recalcActiveRows();
            if (this.table.options.groupBy && this.table.options.columnCalcs !== "table") {
                var groups = this.table.modules.groupRows.getChildGroups();
                groups.forEach((group)=>{
                    this.recalcGroup(group);
                });
            }
        }
    }
    recalcGroup(group) {
        var data, rowData;
        if (!this.blockCheck()) {
            if (group) {
                if (group.calcs) {
                    if (group.calcs.bottom) {
                        data = this.rowsToData(group.rows);
                        rowData = this.generateRowData("bottom", data);
                        group.calcs.bottom.updateData(rowData);
                        group.calcs.bottom.reinitialize();
                    }
                    if (group.calcs.top) {
                        data = this.rowsToData(group.rows);
                        rowData = this.generateRowData("top", data);
                        group.calcs.top.updateData(rowData);
                        group.calcs.top.reinitialize();
                    }
                }
            }
        }
    }
    //generate top stats row
    generateTopRow(rows) {
        return this.generateRow("top", this.rowsToData(rows));
    }
    //generate bottom stats row
    generateBottomRow(rows) {
        return this.generateRow("bottom", this.rowsToData(rows));
    }
    rowsToData(rows) {
        var data = [], hasDataTreeColumnCalcs = this.table.options.dataTree && this.table.options.dataTreeChildColumnCalcs, dataTree = this.table.modules.dataTree;
        rows.forEach((row)=>{
            data.push(row.getData());
            if (hasDataTreeColumnCalcs && row.modules.dataTree?.open) this.rowsToData(dataTree.getFilteredTreeChildren(row)).forEach((dataRow)=>{
                data.push(row);
            });
        });
        return data;
    }
    //generate stats row
    generateRow(pos, data) {
        var rowData = this.generateRowData(pos, data), row;
        if (this.table.modExists("mutator")) this.table.modules.mutator.disable();
        row = new $c2a9788f40f9c90a$var$Row(rowData, this, "calc");
        if (this.table.modExists("mutator")) this.table.modules.mutator.enable();
        row.getElement().classList.add("tabulator-calcs", "tabulator-calcs-" + pos);
        row.component = false;
        row.getComponent = ()=>{
            if (!row.component) row.component = new $c2a9788f40f9c90a$export$3ef2519bf7055551(row);
            return row.component;
        };
        row.generateCells = ()=>{
            var cells = [];
            this.table.columnManager.columnsByIndex.forEach((column)=>{
                //set field name of mock column
                this.genColumn.setField(column.getField());
                this.genColumn.hozAlign = column.hozAlign;
                if (column.definition[pos + "CalcFormatter"] && this.table.modExists("format")) this.genColumn.modules.format = {
                    formatter: this.table.modules.format.getFormatter(column.definition[pos + "CalcFormatter"]),
                    params: column.definition[pos + "CalcFormatterParams"] || {}
                };
                else this.genColumn.modules.format = {
                    formatter: this.table.modules.format.getFormatter("plaintext"),
                    params: {}
                };
                //ensure css class definition is replicated to calculation cell
                this.genColumn.definition.cssClass = column.definition.cssClass;
                //generate cell and assign to correct column
                var cell = new $c2a9788f40f9c90a$var$Cell(this.genColumn, row);
                cell.getElement();
                cell.column = column;
                cell.setWidth();
                column.cells.push(cell);
                cells.push(cell);
                if (!column.visible) cell.hide();
            });
            row.cells = cells;
        };
        return row;
    }
    //generate stats row
    generateRowData(pos, data) {
        var rowData = {}, calcs = pos == "top" ? this.topCalcs : this.botCalcs, type = pos == "top" ? "topCalc" : "botCalc", params, paramKey;
        calcs.forEach(function(column) {
            var values = [];
            if (column.modules.columnCalcs && column.modules.columnCalcs[type]) {
                data.forEach(function(item) {
                    values.push(column.getFieldValue(item));
                });
                paramKey = type + "Params";
                params = typeof column.modules.columnCalcs[paramKey] === "function" ? column.modules.columnCalcs[paramKey](values, data) : column.modules.columnCalcs[paramKey];
                column.setFieldValue(rowData, column.modules.columnCalcs[type](values, data, params));
            }
        });
        return rowData;
    }
    hasTopCalcs() {
        return !!this.topCalcs.length;
    }
    hasBottomCalcs() {
        return !!this.botCalcs.length;
    }
    //handle table redraw
    redraw() {
        if (this.topRow) this.topRow.normalizeHeight(true);
        if (this.botRow) this.botRow.normalizeHeight(true);
    }
    //return the calculated
    getResults() {
        var results = {}, groups;
        if (this.table.options.groupBy && this.table.modExists("groupRows")) {
            groups = this.table.modules.groupRows.getGroups(true);
            groups.forEach((group)=>{
                results[group.getKey()] = this.getGroupResults(group);
            });
        } else results = {
            top: this.topRow ? this.topRow.getData() : {},
            bottom: this.botRow ? this.botRow.getData() : {}
        };
        return results;
    }
    //get results from a group
    getGroupResults(group) {
        var groupObj = group._getSelf(), subGroups = group.getSubGroups(), subGroupResults = {}, results = {};
        subGroups.forEach((subgroup)=>{
            subGroupResults[subgroup.getKey()] = this.getGroupResults(subgroup);
        });
        results = {
            top: groupObj.calcs.top ? groupObj.calcs.top.getData() : {},
            bottom: groupObj.calcs.bottom ? groupObj.calcs.bottom.getData() : {},
            groups: subGroupResults
        };
        return results;
    }
    adjustForScrollbar(width) {
        if (this.botRow) {
            if (this.table.rtl) this.botElement.style.paddingLeft = width + "px";
            else this.botElement.style.paddingRight = width + "px";
        }
    }
}
class $c2a9788f40f9c90a$export$a5a9878f12569c04 extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "dataTree";
    constructor(table){
        super(table);
        this.indent = 10;
        this.field = "";
        this.collapseEl = null;
        this.expandEl = null;
        this.branchEl = null;
        this.elementField = false;
        this.startOpen = function() {};
        this.registerTableOption("dataTree", false); //enable data tree
        this.registerTableOption("dataTreeFilter", true); //filter child rows
        this.registerTableOption("dataTreeSort", true); //sort child rows
        this.registerTableOption("dataTreeElementColumn", false);
        this.registerTableOption("dataTreeBranchElement", true); //show data tree branch element
        this.registerTableOption("dataTreeChildIndent", 9); //data tree child indent in px
        this.registerTableOption("dataTreeChildField", "_children"); //data tre column field to look for child rows
        this.registerTableOption("dataTreeCollapseElement", false); //data tree row collapse element
        this.registerTableOption("dataTreeExpandElement", false); //data tree row expand element
        this.registerTableOption("dataTreeStartExpanded", false);
        this.registerTableOption("dataTreeChildColumnCalcs", false); //include visible data tree rows in column calculations
        this.registerTableOption("dataTreeSelectPropagate", false); //selecting a parent row selects its children
        //register component functions
        this.registerComponentFunction("row", "treeCollapse", this.collapseRow.bind(this));
        this.registerComponentFunction("row", "treeExpand", this.expandRow.bind(this));
        this.registerComponentFunction("row", "treeToggle", this.toggleRow.bind(this));
        this.registerComponentFunction("row", "getTreeParent", this.getTreeParent.bind(this));
        this.registerComponentFunction("row", "getTreeChildren", this.getRowChildren.bind(this));
        this.registerComponentFunction("row", "addTreeChild", this.addTreeChildRow.bind(this));
        this.registerComponentFunction("row", "isTreeExpanded", this.isRowExpanded.bind(this));
    }
    initialize() {
        if (this.table.options.dataTree) {
            var dummyEl = null, options = this.table.options;
            this.field = options.dataTreeChildField;
            this.indent = options.dataTreeChildIndent;
            if (this.options("movableRows")) console.warn("The movableRows option is not available with dataTree enabled, moving of child rows could result in unpredictable behavior");
            if (options.dataTreeBranchElement) {
                if (options.dataTreeBranchElement === true) {
                    this.branchEl = document.createElement("div");
                    this.branchEl.classList.add("tabulator-data-tree-branch");
                } else if (typeof options.dataTreeBranchElement === "string") {
                    dummyEl = document.createElement("div");
                    dummyEl.innerHTML = options.dataTreeBranchElement;
                    this.branchEl = dummyEl.firstChild;
                } else this.branchEl = options.dataTreeBranchElement;
            } else {
                this.branchEl = document.createElement("div");
                this.branchEl.classList.add("tabulator-data-tree-branch-empty");
            }
            if (options.dataTreeCollapseElement) {
                if (typeof options.dataTreeCollapseElement === "string") {
                    dummyEl = document.createElement("div");
                    dummyEl.innerHTML = options.dataTreeCollapseElement;
                    this.collapseEl = dummyEl.firstChild;
                } else this.collapseEl = options.dataTreeCollapseElement;
            } else {
                this.collapseEl = document.createElement("div");
                this.collapseEl.classList.add("tabulator-data-tree-control");
                this.collapseEl.tabIndex = 0;
                this.collapseEl.innerHTML = "<div class='tabulator-data-tree-control-collapse'></div>";
            }
            if (options.dataTreeExpandElement) {
                if (typeof options.dataTreeExpandElement === "string") {
                    dummyEl = document.createElement("div");
                    dummyEl.innerHTML = options.dataTreeExpandElement;
                    this.expandEl = dummyEl.firstChild;
                } else this.expandEl = options.dataTreeExpandElement;
            } else {
                this.expandEl = document.createElement("div");
                this.expandEl.classList.add("tabulator-data-tree-control");
                this.expandEl.tabIndex = 0;
                this.expandEl.innerHTML = "<div class='tabulator-data-tree-control-expand'></div>";
            }
            switch(typeof options.dataTreeStartExpanded){
                case "boolean":
                    this.startOpen = function(row, index) {
                        return options.dataTreeStartExpanded;
                    };
                    break;
                case "function":
                    this.startOpen = options.dataTreeStartExpanded;
                    break;
                default:
                    this.startOpen = function(row, index) {
                        return options.dataTreeStartExpanded[index];
                    };
                    break;
            }
            this.subscribe("row-init", this.initializeRow.bind(this));
            this.subscribe("row-layout-after", this.layoutRow.bind(this));
            this.subscribe("row-deleted", this.rowDelete.bind(this), 0);
            this.subscribe("row-data-changed", this.rowDataChanged.bind(this), 10);
            this.subscribe("cell-value-updated", this.cellValueChanged.bind(this));
            this.subscribe("edit-cancelled", this.cellValueChanged.bind(this));
            this.subscribe("column-moving-rows", this.columnMoving.bind(this));
            this.subscribe("table-built", this.initializeElementField.bind(this));
            this.subscribe("table-redrawing", this.tableRedrawing.bind(this));
            this.registerDisplayHandler(this.getRows.bind(this), 30);
        }
    }
    tableRedrawing(force) {
        var rows;
        if (force) {
            rows = this.table.rowManager.getRows();
            rows.forEach((row)=>{
                this.reinitializeRowChildren(row);
            });
        }
    }
    initializeElementField() {
        var firstCol = this.table.columnManager.getFirstVisibleColumn();
        this.elementField = this.table.options.dataTreeElementColumn || (firstCol ? firstCol.field : false);
    }
    getRowChildren(row) {
        return this.getTreeChildren(row, true);
    }
    columnMoving() {
        var rows = [];
        this.table.rowManager.rows.forEach((row)=>{
            rows = rows.concat(this.getTreeChildren(row, false, true));
        });
        return rows;
    }
    rowDataChanged(row, visible, updatedData) {
        if (this.redrawNeeded(updatedData)) {
            this.initializeRow(row);
            if (visible) {
                this.layoutRow(row);
                this.refreshData(true);
            }
        }
    }
    cellValueChanged(cell) {
        var field = cell.column.getField();
        if (field === this.elementField) this.layoutRow(cell.row);
    }
    initializeRow(row) {
        var childArray = row.getData()[this.field];
        var isArray = Array.isArray(childArray);
        var children = isArray || !isArray && typeof childArray === "object" && childArray !== null;
        if (!children && row.modules.dataTree && row.modules.dataTree.branchEl) row.modules.dataTree.branchEl.parentNode.removeChild(row.modules.dataTree.branchEl);
        if (!children && row.modules.dataTree && row.modules.dataTree.controlEl) row.modules.dataTree.controlEl.parentNode.removeChild(row.modules.dataTree.controlEl);
        row.modules.dataTree = {
            index: row.modules.dataTree ? row.modules.dataTree.index : 0,
            open: children ? row.modules.dataTree ? row.modules.dataTree.open : this.startOpen(row.getComponent(), 0) : false,
            controlEl: row.modules.dataTree && children ? row.modules.dataTree.controlEl : false,
            branchEl: row.modules.dataTree && children ? row.modules.dataTree.branchEl : false,
            parent: row.modules.dataTree ? row.modules.dataTree.parent : false,
            children: children
        };
    }
    reinitializeRowChildren(row) {
        var children = this.getTreeChildren(row, false, true);
        children.forEach(function(child) {
            child.reinitialize(true);
        });
    }
    layoutRow(row) {
        var cell = this.elementField ? row.getCell(this.elementField) : row.getCells()[0], el = cell.getElement(), config = row.modules.dataTree;
        if (config.branchEl) {
            if (config.branchEl.parentNode) config.branchEl.parentNode.removeChild(config.branchEl);
            config.branchEl = false;
        }
        if (config.controlEl) {
            if (config.controlEl.parentNode) config.controlEl.parentNode.removeChild(config.controlEl);
            config.controlEl = false;
        }
        this.generateControlElement(row, el);
        row.getElement().classList.add("tabulator-tree-level-" + config.index);
        if (config.index) {
            if (this.branchEl) {
                config.branchEl = this.branchEl.cloneNode(true);
                el.insertBefore(config.branchEl, el.firstChild);
                if (this.table.rtl) config.branchEl.style.marginRight = (config.branchEl.offsetWidth + config.branchEl.style.marginLeft) * (config.index - 1) + config.index * this.indent + "px";
                else config.branchEl.style.marginLeft = (config.branchEl.offsetWidth + config.branchEl.style.marginRight) * (config.index - 1) + config.index * this.indent + "px";
            } else if (this.table.rtl) el.style.paddingRight = parseInt(window.getComputedStyle(el, null).getPropertyValue("padding-right")) + config.index * this.indent + "px";
            else el.style.paddingLeft = parseInt(window.getComputedStyle(el, null).getPropertyValue("padding-left")) + config.index * this.indent + "px";
        }
    }
    generateControlElement(row, el) {
        var config = row.modules.dataTree, oldControl = config.controlEl;
        el = el || row.getCells()[0].getElement();
        if (config.children !== false) {
            if (config.open) {
                config.controlEl = this.collapseEl.cloneNode(true);
                config.controlEl.addEventListener("click", (e)=>{
                    e.stopPropagation();
                    this.collapseRow(row);
                });
            } else {
                config.controlEl = this.expandEl.cloneNode(true);
                config.controlEl.addEventListener("click", (e)=>{
                    e.stopPropagation();
                    this.expandRow(row);
                });
            }
            config.controlEl.addEventListener("mousedown", (e)=>{
                e.stopPropagation();
            });
            if (oldControl && oldControl.parentNode === el) oldControl.parentNode.replaceChild(config.controlEl, oldControl);
            else el.insertBefore(config.controlEl, el.firstChild);
        }
    }
    getRows(rows) {
        var output = [];
        rows.forEach((row, i)=>{
            var config, children;
            output.push(row);
            if (row instanceof $c2a9788f40f9c90a$var$Row) {
                row.create();
                config = row.modules.dataTree;
                if (!config.index && config.children !== false) {
                    children = this.getChildren(row, false, true);
                    children.forEach((child)=>{
                        child.create();
                        output.push(child);
                    });
                }
            }
        });
        return output;
    }
    getChildren(row, allChildren, sortOnly) {
        var config = row.modules.dataTree, children = [], output = [];
        if (config.children !== false && (config.open || allChildren)) {
            if (!Array.isArray(config.children)) config.children = this.generateChildren(row);
            if (this.table.modExists("filter") && this.table.options.dataTreeFilter) children = this.table.modules.filter.filter(config.children);
            else children = config.children;
            if (this.table.modExists("sort") && this.table.options.dataTreeSort) this.table.modules.sort.sort(children, sortOnly);
            children.forEach((child)=>{
                output.push(child);
                var subChildren = this.getChildren(child, false, true);
                subChildren.forEach((sub)=>{
                    output.push(sub);
                });
            });
        }
        return output;
    }
    generateChildren(row) {
        var children = [];
        var childArray = row.getData()[this.field];
        if (!Array.isArray(childArray)) childArray = [
            childArray
        ];
        childArray.forEach((childData)=>{
            var childRow = new $c2a9788f40f9c90a$var$Row(childData || {}, this.table.rowManager);
            childRow.create();
            childRow.modules.dataTree.index = row.modules.dataTree.index + 1;
            childRow.modules.dataTree.parent = row;
            if (childRow.modules.dataTree.children) childRow.modules.dataTree.open = this.startOpen(childRow.getComponent(), childRow.modules.dataTree.index);
            children.push(childRow);
        });
        return children;
    }
    expandRow(row, silent) {
        var config = row.modules.dataTree;
        if (config.children !== false) {
            config.open = true;
            row.reinitialize();
            this.refreshData(true);
            this.dispatchExternal("dataTreeRowExpanded", row.getComponent(), row.modules.dataTree.index);
        }
    }
    collapseRow(row) {
        var config = row.modules.dataTree;
        if (config.children !== false) {
            config.open = false;
            row.reinitialize();
            this.refreshData(true);
            this.dispatchExternal("dataTreeRowCollapsed", row.getComponent(), row.modules.dataTree.index);
        }
    }
    toggleRow(row) {
        var config = row.modules.dataTree;
        if (config.children !== false) {
            if (config.open) this.collapseRow(row);
            else this.expandRow(row);
        }
    }
    isRowExpanded(row) {
        return row.modules.dataTree.open;
    }
    getTreeParent(row) {
        return row.modules.dataTree.parent ? row.modules.dataTree.parent.getComponent() : false;
    }
    getTreeParentRoot(row) {
        return row.modules.dataTree && row.modules.dataTree.parent ? this.getTreeParentRoot(row.modules.dataTree.parent) : row;
    }
    getFilteredTreeChildren(row) {
        var config = row.modules.dataTree, output = [], children;
        if (config.children) {
            if (!Array.isArray(config.children)) config.children = this.generateChildren(row);
            if (this.table.modExists("filter") && this.table.options.dataTreeFilter) children = this.table.modules.filter.filter(config.children);
            else children = config.children;
            children.forEach((childRow)=>{
                if (childRow instanceof $c2a9788f40f9c90a$var$Row) output.push(childRow);
            });
        }
        return output;
    }
    rowDelete(row) {
        var parent = row.modules.dataTree.parent, childIndex;
        if (parent) {
            childIndex = this.findChildIndex(row, parent);
            if (childIndex !== false) parent.data[this.field].splice(childIndex, 1);
            if (!parent.data[this.field].length) delete parent.data[this.field];
            this.initializeRow(parent);
            this.layoutRow(parent);
        }
        this.refreshData(true);
    }
    addTreeChildRow(row, data, top, index) {
        var childIndex = false;
        if (typeof data === "string") data = JSON.parse(data);
        if (!Array.isArray(row.data[this.field])) {
            row.data[this.field] = [];
            row.modules.dataTree.open = this.startOpen(row.getComponent(), row.modules.dataTree.index);
        }
        if (typeof index !== "undefined") {
            childIndex = this.findChildIndex(index, row);
            if (childIndex !== false) row.data[this.field].splice(top ? childIndex : childIndex + 1, 0, data);
        }
        if (childIndex === false) {
            if (top) row.data[this.field].unshift(data);
            else row.data[this.field].push(data);
        }
        this.initializeRow(row);
        this.layoutRow(row);
        this.refreshData(true);
    }
    findChildIndex(subject, parent) {
        var match = false;
        if (typeof subject == "object") {
            if (subject instanceof $c2a9788f40f9c90a$var$Row) //subject is row element
            match = subject.data;
            else if (subject instanceof $c2a9788f40f9c90a$export$5df91075f5ba4651) //subject is public row component
            match = subject._getSelf().data;
            else if (typeof HTMLElement !== "undefined" && subject instanceof HTMLElement) {
                if (parent.modules.dataTree) {
                    match = parent.modules.dataTree.children.find((childRow)=>{
                        return childRow instanceof $c2a9788f40f9c90a$var$Row ? childRow.element === subject : false;
                    });
                    if (match) match = match.data;
                }
            } else if (subject === null) match = false;
        } else if (typeof subject == "undefined") match = false;
        else //subject should be treated as the index of the row
        match = parent.data[this.field].find((row)=>{
            return row.data[this.table.options.index] == subject;
        });
        if (match) {
            if (Array.isArray(parent.data[this.field])) match = parent.data[this.field].indexOf(match);
            if (match == -1) match = false;
        }
        //catch all for any other type of input
        return match;
    }
    getTreeChildren(row, component, recurse) {
        var config = row.modules.dataTree, output = [];
        if (config && config.children) {
            if (!Array.isArray(config.children)) config.children = this.generateChildren(row);
            config.children.forEach((childRow)=>{
                if (childRow instanceof $c2a9788f40f9c90a$var$Row) {
                    output.push(component ? childRow.getComponent() : childRow);
                    if (recurse) this.getTreeChildren(childRow, component, recurse).forEach((child)=>{
                        output.push(child);
                    });
                }
            });
        }
        return output;
    }
    getChildField() {
        return this.field;
    }
    redrawNeeded(data) {
        return (this.field ? typeof data[this.field] !== "undefined" : false) || (this.elementField ? typeof data[this.elementField] !== "undefined" : false);
    }
}
function $c2a9788f40f9c90a$var$csv$1(list, options = {}, setFileContents) {
    var delimiter = options.delimiter ? options.delimiter : ",", fileContents = [], headers = [];
    list.forEach((row)=>{
        var item = [];
        switch(row.type){
            case "group":
                console.warn("Download Warning - CSV downloader cannot process row groups");
                break;
            case "calc":
                console.warn("Download Warning - CSV downloader cannot process column calculations");
                break;
            case "header":
                row.columns.forEach((col, i)=>{
                    if (col && col.depth === 1) headers[i] = typeof col.value == "undefined" || col.value === null ? "" : '"' + String(col.value).split('"').join('""') + '"';
                });
                break;
            case "row":
                row.columns.forEach((col)=>{
                    if (col) {
                        switch(typeof col.value){
                            case "object":
                                col.value = col.value !== null ? JSON.stringify(col.value) : "";
                                break;
                            case "undefined":
                                col.value = "";
                                break;
                        }
                        item.push('"' + String(col.value).split('"').join('""') + '"');
                    }
                });
                fileContents.push(item.join(delimiter));
                break;
        }
    });
    if (headers.length) fileContents.unshift(headers.join(delimiter));
    fileContents = fileContents.join("\n");
    if (options.bom) fileContents = "\uFEFF" + fileContents;
    setFileContents(fileContents, "text/csv");
}
function $c2a9788f40f9c90a$var$json$1(list, options, setFileContents) {
    var fileContents = [];
    list.forEach((row)=>{
        var item = {};
        switch(row.type){
            case "header":
                break;
            case "group":
                console.warn("Download Warning - JSON downloader cannot process row groups");
                break;
            case "calc":
                console.warn("Download Warning - JSON downloader cannot process column calculations");
                break;
            case "row":
                row.columns.forEach((col)=>{
                    if (col) item[col.component.getTitleDownload() || col.component.getField()] = col.value;
                });
                fileContents.push(item);
                break;
        }
    });
    fileContents = JSON.stringify(fileContents, null, "	");
    setFileContents(fileContents, "application/json");
}
function $c2a9788f40f9c90a$var$pdf(list, options = {}, setFileContents) {
    var header = [], body = [], autoTableParams = {}, rowGroupStyles = options.rowGroupStyles || {
        fontStyle: "bold",
        fontSize: 12,
        cellPadding: 6,
        fillColor: 220
    }, rowCalcStyles = options.rowCalcStyles || {
        fontStyle: "bold",
        fontSize: 10,
        cellPadding: 4,
        fillColor: 232
    }, jsPDFParams = options.jsPDF || {}, title = options.title ? options.title : "";
    if (!jsPDFParams.orientation) jsPDFParams.orientation = options.orientation || "landscape";
    if (!jsPDFParams.unit) jsPDFParams.unit = "pt";
    //parse row list
    list.forEach((row)=>{
        switch(row.type){
            case "header":
                header.push(parseRow(row));
                break;
            case "group":
                body.push(parseRow(row, rowGroupStyles));
                break;
            case "calc":
                body.push(parseRow(row, rowCalcStyles));
                break;
            case "row":
                body.push(parseRow(row));
                break;
        }
    });
    function parseRow(row, styles) {
        var rowData = [];
        row.columns.forEach((col)=>{
            var cell;
            if (col) {
                switch(typeof col.value){
                    case "object":
                        col.value = col.value !== null ? JSON.stringify(col.value) : "";
                        break;
                    case "undefined":
                        col.value = "";
                        break;
                }
                cell = {
                    content: col.value,
                    colSpan: col.width,
                    rowSpan: col.height
                };
                if (styles) cell.styles = styles;
                rowData.push(cell);
            }
        });
        return rowData;
    }
    //configure PDF
    var doc = new jspdf.jsPDF(jsPDFParams); //set document to landscape, better for most tables
    if (options.autoTable) {
        if (typeof options.autoTable === "function") autoTableParams = options.autoTable(doc) || {};
        else autoTableParams = options.autoTable;
    }
    if (title) autoTableParams.didDrawPage = function(data) {
        doc.text(title, 40, 30);
    };
    autoTableParams.head = header;
    autoTableParams.body = body;
    doc.autoTable(autoTableParams);
    if (options.documentProcessing) options.documentProcessing(doc);
    setFileContents(doc.output("arraybuffer"), "application/pdf");
}
function $c2a9788f40f9c90a$var$xlsx$1(list, options, setFileContents) {
    var self = this, sheetName = options.sheetName || "Sheet1", workbook = XLSX.utils.book_new(), tableFeatures = new $c2a9788f40f9c90a$var$CoreFeature(this), compression = "compress" in options ? options.compress : true, writeOptions = options.writeOptions || {
        bookType: "xlsx",
        bookSST: true,
        compression: compression
    }, output;
    writeOptions.type = "binary";
    workbook.SheetNames = [];
    workbook.Sheets = {};
    function generateSheet() {
        var rows = [], merges = [], worksheet = {}, range = {
            s: {
                c: 0,
                r: 0
            },
            e: {
                c: list[0] ? list[0].columns.reduce((a, b)=>a + (b && b.width ? b.width : 1), 0) : 0,
                r: list.length
            }
        };
        //parse row list
        list.forEach((row, i)=>{
            var rowData = [];
            row.columns.forEach(function(col, j) {
                if (col) {
                    rowData.push(!(col.value instanceof Date) && typeof col.value === "object" ? JSON.stringify(col.value) : col.value);
                    if (col.width > 1 || col.height > -1) {
                        if (col.height > 1 || col.width > 1) merges.push({
                            s: {
                                r: i,
                                c: j
                            },
                            e: {
                                r: i + col.height - 1,
                                c: j + col.width - 1
                            }
                        });
                    }
                } else rowData.push("");
            });
            rows.push(rowData);
        });
        //convert rows to worksheet
        XLSX.utils.sheet_add_aoa(worksheet, rows);
        worksheet["!ref"] = XLSX.utils.encode_range(range);
        if (merges.length) worksheet["!merges"] = merges;
        return worksheet;
    }
    if (options.sheetOnly) {
        setFileContents(generateSheet());
        return;
    }
    if (options.sheets) {
        for(var sheet in options.sheets)if (options.sheets[sheet] === true) {
            workbook.SheetNames.push(sheet);
            workbook.Sheets[sheet] = generateSheet();
        } else {
            workbook.SheetNames.push(sheet);
            tableFeatures.commsSend(options.sheets[sheet], "download", "intercept", {
                type: "xlsx",
                options: {
                    sheetOnly: true
                },
                active: self.active,
                intercept: function(data) {
                    workbook.Sheets[sheet] = data;
                }
            });
        }
    } else {
        workbook.SheetNames.push(sheetName);
        workbook.Sheets[sheetName] = generateSheet();
    }
    if (options.documentProcessing) workbook = options.documentProcessing(workbook);
    //convert workbook to binary array
    function s2ab(s) {
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for(var i = 0; i != s.length; ++i)view[i] = s.charCodeAt(i) & 0xFF;
        return buf;
    }
    output = XLSX.write(workbook, writeOptions);
    setFileContents(s2ab(output), "application/octet-stream");
}
function $c2a9788f40f9c90a$var$html$1(list, options, setFileContents) {
    if (this.modExists("export", true)) setFileContents(this.modules.export.generateHTMLTable(list), "text/html");
}
function $c2a9788f40f9c90a$var$jsonLines(list, options, setFileContents) {
    const fileContents = [];
    list.forEach((row)=>{
        const item = {};
        switch(row.type){
            case "header":
                break;
            case "group":
                console.warn("Download Warning - JSON downloader cannot process row groups");
                break;
            case "calc":
                console.warn("Download Warning - JSON downloader cannot process column calculations");
                break;
            case "row":
                row.columns.forEach((col)=>{
                    if (col) item[col.component.getTitleDownload() || col.component.getField()] = col.value;
                });
                fileContents.push(JSON.stringify(item));
                break;
        }
    });
    setFileContents(fileContents.join("\n"), "application/x-ndjson");
}
var $c2a9788f40f9c90a$var$defaultDownloaders = {
    csv: $c2a9788f40f9c90a$var$csv$1,
    json: $c2a9788f40f9c90a$var$json$1,
    jsonLines: $c2a9788f40f9c90a$var$jsonLines,
    pdf: $c2a9788f40f9c90a$var$pdf,
    xlsx: $c2a9788f40f9c90a$var$xlsx$1,
    html: $c2a9788f40f9c90a$var$html$1
};
class $c2a9788f40f9c90a$export$6dd96c6d41f32a97 extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "download";
    //load defaults
    static downloaders = $c2a9788f40f9c90a$var$defaultDownloaders;
    constructor(table){
        super(table);
        this.registerTableOption("downloadEncoder", function(data, mimeType) {
            return new Blob([
                data
            ], {
                type: mimeType
            });
        }); //function to manipulate download data
        // this.registerTableOption("downloadReady", undefined); //warn of function deprecation
        this.registerTableOption("downloadConfig", {}); //download config
        this.registerTableOption("downloadRowRange", "active"); //restrict download to active rows only
        this.registerColumnOption("download");
        this.registerColumnOption("titleDownload");
    }
    initialize() {
        this.deprecatedOptionsCheck();
        this.registerTableFunction("download", this.download.bind(this));
        this.registerTableFunction("downloadToTab", this.downloadToTab.bind(this));
    }
    deprecatedOptionsCheck() {
    // this.deprecationCheck("downloadReady", "downloadEncoder");
    }
    ///////////////////////////////////
    ///////// Table Functions /////////
    ///////////////////////////////////
    downloadToTab(type, filename, options, active) {
        this.download(type, filename, options, active, true);
    }
    ///////////////////////////////////
    ///////// Internal Logic //////////
    ///////////////////////////////////
    //trigger file download
    download(type, filename, options, range, interceptCallback) {
        var downloadFunc = false;
        function buildLink(data, mime) {
            if (interceptCallback) {
                if (interceptCallback === true) this.triggerDownload(data, mime, type, filename, true);
                else interceptCallback(data);
            } else this.triggerDownload(data, mime, type, filename);
        }
        if (typeof type == "function") downloadFunc = type;
        else if ($c2a9788f40f9c90a$export$6dd96c6d41f32a97.downloaders[type]) downloadFunc = $c2a9788f40f9c90a$export$6dd96c6d41f32a97.downloaders[type];
        else console.warn("Download Error - No such download type found: ", type);
        if (downloadFunc) {
            var list = this.generateExportList(range);
            downloadFunc.call(this.table, list, options || {}, buildLink.bind(this));
        }
    }
    generateExportList(range) {
        var list = this.table.modules.export.generateExportList(this.table.options.downloadConfig, false, range || this.table.options.downloadRowRange, "download");
        //assign group header formatter
        var groupHeader = this.table.options.groupHeaderDownload;
        if (groupHeader && !Array.isArray(groupHeader)) groupHeader = [
            groupHeader
        ];
        list.forEach((row)=>{
            var group;
            if (row.type === "group") {
                group = row.columns[0];
                if (groupHeader && groupHeader[row.indent]) group.value = groupHeader[row.indent](group.value, row.component._group.getRowCount(), row.component._group.getData(), row.component);
            }
        });
        return list;
    }
    triggerDownload(data, mime, type, filename, newTab) {
        var element = document.createElement("a"), blob = this.table.options.downloadEncoder(data, mime);
        if (blob) {
            if (newTab) window.open(window.URL.createObjectURL(blob));
            else {
                filename = filename || "Tabulator." + (typeof type === "function" ? "txt" : type);
                if (navigator.msSaveOrOpenBlob) navigator.msSaveOrOpenBlob(blob, filename);
                else {
                    element.setAttribute("href", window.URL.createObjectURL(blob));
                    //set file title
                    element.setAttribute("download", filename);
                    //trigger download
                    element.style.display = "none";
                    document.body.appendChild(element);
                    element.click();
                    //remove temporary link element
                    document.body.removeChild(element);
                }
            }
            this.dispatchExternal("downloadComplete");
        }
    }
    commsReceived(table, action, data) {
        switch(action){
            case "intercept":
                this.download(data.type, "", data.options, data.active, data.intercept);
                break;
        }
    }
}
function $c2a9788f40f9c90a$var$maskInput(el, options) {
    var mask = options.mask, maskLetter = typeof options.maskLetterChar !== "undefined" ? options.maskLetterChar : "A", maskNumber = typeof options.maskNumberChar !== "undefined" ? options.maskNumberChar : "9", maskWildcard = typeof options.maskWildcardChar !== "undefined" ? options.maskWildcardChar : "*";
    function fillSymbols(index) {
        var symbol = mask[index];
        if (typeof symbol !== "undefined" && symbol !== maskWildcard && symbol !== maskLetter && symbol !== maskNumber) {
            el.value = el.value + "" + symbol;
            fillSymbols(index + 1);
        }
    }
    el.addEventListener("keydown", (e)=>{
        var index = el.value.length, char = e.key;
        if (e.keyCode > 46 && !e.ctrlKey && !e.metaKey) {
            if (index >= mask.length) {
                e.preventDefault();
                e.stopPropagation();
                return false;
            } else switch(mask[index]){
                case maskLetter:
                    if (char.toUpperCase() == char.toLowerCase()) {
                        e.preventDefault();
                        e.stopPropagation();
                        return false;
                    }
                    break;
                case maskNumber:
                    if (isNaN(char)) {
                        e.preventDefault();
                        e.stopPropagation();
                        return false;
                    }
                    break;
                case maskWildcard:
                    break;
                default:
                    if (char !== mask[index]) {
                        e.preventDefault();
                        e.stopPropagation();
                        return false;
                    }
            }
        }
        return;
    });
    el.addEventListener("keyup", (e)=>{
        if (e.keyCode > 46) {
            if (options.maskAutoFill) fillSymbols(el.value.length);
        }
    });
    if (!el.placeholder) el.placeholder = mask;
    if (options.maskAutoFill) fillSymbols(el.value.length);
}
//input element
function $c2a9788f40f9c90a$var$input(cell, onRendered, success, cancel, editorParams) {
    //create and style input
    var cellValue = cell.getValue(), input = document.createElement("input");
    input.setAttribute("type", editorParams.search ? "search" : "text");
    input.style.padding = "4px";
    input.style.width = "100%";
    input.style.boxSizing = "border-box";
    if (editorParams.elementAttributes && typeof editorParams.elementAttributes == "object") {
        for(let key in editorParams.elementAttributes)if (key.charAt(0) == "+") {
            key = key.slice(1);
            input.setAttribute(key, input.getAttribute(key) + editorParams.elementAttributes["+" + key]);
        } else input.setAttribute(key, editorParams.elementAttributes[key]);
    }
    input.value = typeof cellValue !== "undefined" ? cellValue : "";
    onRendered(function() {
        if (cell.getType() === "cell") {
            input.focus({
                preventScroll: true
            });
            input.style.height = "100%";
            if (editorParams.selectContents) input.select();
        }
    });
    function onChange(e) {
        if ((cellValue === null || typeof cellValue === "undefined") && input.value !== "" || input.value !== cellValue) {
            if (success(input.value)) cellValue = input.value; //persist value if successfully validated incase editor is used as header filter
        } else cancel();
    }
    //submit new value on blur or change
    input.addEventListener("change", onChange);
    input.addEventListener("blur", onChange);
    //submit new value on enter
    input.addEventListener("keydown", function(e) {
        switch(e.keyCode){
            // case 9:
            case 13:
                onChange();
                break;
            case 27:
                cancel();
                break;
            case 35:
            case 36:
                e.stopPropagation();
                break;
        }
    });
    if (editorParams.mask) $c2a9788f40f9c90a$var$maskInput(input, editorParams);
    return input;
}
//resizable text area element
function $c2a9788f40f9c90a$var$textarea$1(cell, onRendered, success, cancel, editorParams) {
    var cellValue = cell.getValue(), vertNav = editorParams.verticalNavigation || "hybrid", value = String(cellValue !== null && typeof cellValue !== "undefined" ? cellValue : ""), input = document.createElement("textarea"), scrollHeight = 0;
    //create and style input
    input.style.display = "block";
    input.style.padding = "2px";
    input.style.height = "100%";
    input.style.width = "100%";
    input.style.boxSizing = "border-box";
    input.style.whiteSpace = "pre-wrap";
    input.style.resize = "none";
    if (editorParams.elementAttributes && typeof editorParams.elementAttributes == "object") {
        for(let key in editorParams.elementAttributes)if (key.charAt(0) == "+") {
            key = key.slice(1);
            input.setAttribute(key, input.getAttribute(key) + editorParams.elementAttributes["+" + key]);
        } else input.setAttribute(key, editorParams.elementAttributes[key]);
    }
    input.value = value;
    onRendered(function() {
        if (cell.getType() === "cell") {
            input.focus({
                preventScroll: true
            });
            input.style.height = "100%";
            input.scrollHeight;
            input.style.height = input.scrollHeight + "px";
            cell.getRow().normalizeHeight();
            if (editorParams.selectContents) input.select();
        }
    });
    function onChange(e) {
        if ((cellValue === null || typeof cellValue === "undefined") && input.value !== "" || input.value !== cellValue) {
            if (success(input.value)) cellValue = input.value; //persist value if successfully validated incase editor is used as header filter
            setTimeout(function() {
                cell.getRow().normalizeHeight();
            }, 300);
        } else cancel();
    }
    //submit new value on blur or change
    input.addEventListener("change", onChange);
    input.addEventListener("blur", onChange);
    input.addEventListener("keyup", function() {
        input.style.height = "";
        var heightNow = input.scrollHeight;
        input.style.height = heightNow + "px";
        if (heightNow != scrollHeight) {
            scrollHeight = heightNow;
            cell.getRow().normalizeHeight();
        }
    });
    input.addEventListener("keydown", function(e) {
        switch(e.keyCode){
            case 13:
                if (e.shiftKey && editorParams.shiftEnterSubmit) onChange();
                break;
            case 27:
                cancel();
                break;
            case 38:
                if (vertNav == "editor" || vertNav == "hybrid" && input.selectionStart) {
                    e.stopImmediatePropagation();
                    e.stopPropagation();
                }
                break;
            case 40:
                if (vertNav == "editor" || vertNav == "hybrid" && input.selectionStart !== input.value.length) {
                    e.stopImmediatePropagation();
                    e.stopPropagation();
                }
                break;
            case 35:
            case 36:
                e.stopPropagation();
                break;
        }
    });
    if (editorParams.mask) $c2a9788f40f9c90a$var$maskInput(input, editorParams);
    return input;
}
//input element with type of number
function $c2a9788f40f9c90a$var$number$1(cell, onRendered, success, cancel, editorParams) {
    var cellValue = cell.getValue(), vertNav = editorParams.verticalNavigation || "editor", input = document.createElement("input");
    input.setAttribute("type", "number");
    if (typeof editorParams.max != "undefined") input.setAttribute("max", editorParams.max);
    if (typeof editorParams.min != "undefined") input.setAttribute("min", editorParams.min);
    if (typeof editorParams.step != "undefined") input.setAttribute("step", editorParams.step);
    //create and style input
    input.style.padding = "4px";
    input.style.width = "100%";
    input.style.boxSizing = "border-box";
    if (editorParams.elementAttributes && typeof editorParams.elementAttributes == "object") {
        for(let key in editorParams.elementAttributes)if (key.charAt(0) == "+") {
            key = key.slice(1);
            input.setAttribute(key, input.getAttribute(key) + editorParams.elementAttributes["+" + key]);
        } else input.setAttribute(key, editorParams.elementAttributes[key]);
    }
    input.value = cellValue;
    var blurFunc = function(e) {
        onChange();
    };
    onRendered(function() {
        if (cell.getType() === "cell") {
            //submit new value on blur
            input.removeEventListener("blur", blurFunc);
            input.focus({
                preventScroll: true
            });
            input.style.height = "100%";
            //submit new value on blur
            input.addEventListener("blur", blurFunc);
            if (editorParams.selectContents) input.select();
        }
    });
    function onChange() {
        var value = input.value;
        if (!isNaN(value) && value !== "") value = Number(value);
        if (value !== cellValue) {
            if (success(value)) cellValue = value; //persist value if successfully validated incase editor is used as header filter
        } else cancel();
    }
    //submit new value on enter
    input.addEventListener("keydown", function(e) {
        switch(e.keyCode){
            case 13:
                // case 9:
                onChange();
                break;
            case 27:
                cancel();
                break;
            case 38:
            case 40:
                if (vertNav == "editor") {
                    e.stopImmediatePropagation();
                    e.stopPropagation();
                }
                break;
            case 35:
            case 36:
                e.stopPropagation();
                break;
        }
    });
    if (editorParams.mask) $c2a9788f40f9c90a$var$maskInput(input, editorParams);
    return input;
}
//input element with type of number
function $c2a9788f40f9c90a$var$range(cell, onRendered, success, cancel, editorParams) {
    var cellValue = cell.getValue(), input = document.createElement("input");
    input.setAttribute("type", "range");
    if (typeof editorParams.max != "undefined") input.setAttribute("max", editorParams.max);
    if (typeof editorParams.min != "undefined") input.setAttribute("min", editorParams.min);
    if (typeof editorParams.step != "undefined") input.setAttribute("step", editorParams.step);
    //create and style input
    input.style.padding = "4px";
    input.style.width = "100%";
    input.style.boxSizing = "border-box";
    if (editorParams.elementAttributes && typeof editorParams.elementAttributes == "object") {
        for(let key in editorParams.elementAttributes)if (key.charAt(0) == "+") {
            key = key.slice(1);
            input.setAttribute(key, input.getAttribute(key) + editorParams.elementAttributes["+" + key]);
        } else input.setAttribute(key, editorParams.elementAttributes[key]);
    }
    input.value = cellValue;
    onRendered(function() {
        if (cell.getType() === "cell") {
            input.focus({
                preventScroll: true
            });
            input.style.height = "100%";
        }
    });
    function onChange() {
        var value = input.value;
        if (!isNaN(value) && value !== "") value = Number(value);
        if (value != cellValue) {
            if (success(value)) cellValue = value; //persist value if successfully validated incase editor is used as header filter
        } else cancel();
    }
    //submit new value on blur
    input.addEventListener("blur", function(e) {
        onChange();
    });
    //submit new value on enter
    input.addEventListener("keydown", function(e) {
        switch(e.keyCode){
            case 13:
                // case 9:
                onChange();
                break;
            case 27:
                cancel();
                break;
        }
    });
    return input;
}
//input element
function $c2a9788f40f9c90a$var$date$1(cell, onRendered, success, cancel, editorParams) {
    var inputFormat = editorParams.format, vertNav = editorParams.verticalNavigation || "editor", DT = inputFormat ? window.DateTime || luxon.DateTime : null;
    //create and style input
    var cellValue = cell.getValue(), input = document.createElement("input");
    function convertDate(value) {
        var newDatetime;
        if (DT.isDateTime(value)) newDatetime = value;
        else if (inputFormat === "iso") newDatetime = DT.fromISO(String(value));
        else newDatetime = DT.fromFormat(String(value), inputFormat);
        return newDatetime.toFormat("yyyy-MM-dd");
    }
    input.type = "date";
    input.style.padding = "4px";
    input.style.width = "100%";
    input.style.boxSizing = "border-box";
    if (editorParams.max) input.setAttribute("max", inputFormat ? convertDate(editorParams.max) : editorParams.max);
    if (editorParams.min) input.setAttribute("min", inputFormat ? convertDate(editorParams.min) : editorParams.min);
    if (editorParams.elementAttributes && typeof editorParams.elementAttributes == "object") {
        for(let key in editorParams.elementAttributes)if (key.charAt(0) == "+") {
            key = key.slice(1);
            input.setAttribute(key, input.getAttribute(key) + editorParams.elementAttributes["+" + key]);
        } else input.setAttribute(key, editorParams.elementAttributes[key]);
    }
    cellValue = typeof cellValue !== "undefined" ? cellValue : "";
    if (inputFormat) {
        if (DT) cellValue = convertDate(cellValue);
        else console.error("Editor Error - 'date' editor 'format' param is dependant on luxon.js");
    }
    input.value = cellValue;
    onRendered(function() {
        if (cell.getType() === "cell") {
            input.focus({
                preventScroll: true
            });
            input.style.height = "100%";
            if (editorParams.selectContents) input.select();
        }
    });
    function onChange() {
        var value = input.value, luxDate;
        if ((cellValue === null || typeof cellValue === "undefined") && value !== "" || value !== cellValue) {
            if (value && inputFormat) {
                luxDate = DT.fromFormat(String(value), "yyyy-MM-dd");
                switch(inputFormat){
                    case true:
                        value = luxDate;
                        break;
                    case "iso":
                        value = luxDate.toISO();
                        break;
                    default:
                        value = luxDate.toFormat(inputFormat);
                }
            }
            if (success(value)) cellValue = input.value; //persist value if successfully validated incase editor is used as header filter
        } else cancel();
    }
    //submit new value on blur
    input.addEventListener("blur", function(e) {
        if (e.relatedTarget || e.rangeParent || e.explicitOriginalTarget !== input) onChange(); // only on a "true" blur; not when focusing browser's date/time picker
    });
    //submit new value on enter
    input.addEventListener("keydown", function(e) {
        switch(e.keyCode){
            // case 9:
            case 13:
                onChange();
                break;
            case 27:
                cancel();
                break;
            case 35:
            case 36:
                e.stopPropagation();
                break;
            case 38:
            case 40:
                if (vertNav == "editor") {
                    e.stopImmediatePropagation();
                    e.stopPropagation();
                }
                break;
        }
    });
    return input;
}
//input element
function $c2a9788f40f9c90a$var$time$1(cell, onRendered, success, cancel, editorParams) {
    var inputFormat = editorParams.format, vertNav = editorParams.verticalNavigation || "editor", DT = inputFormat ? window.DateTime || luxon.DateTime : null, newDatetime;
    //create and style input
    var cellValue = cell.getValue(), input = document.createElement("input");
    input.type = "time";
    input.style.padding = "4px";
    input.style.width = "100%";
    input.style.boxSizing = "border-box";
    if (editorParams.elementAttributes && typeof editorParams.elementAttributes == "object") {
        for(let key in editorParams.elementAttributes)if (key.charAt(0) == "+") {
            key = key.slice(1);
            input.setAttribute(key, input.getAttribute(key) + editorParams.elementAttributes["+" + key]);
        } else input.setAttribute(key, editorParams.elementAttributes[key]);
    }
    cellValue = typeof cellValue !== "undefined" ? cellValue : "";
    if (inputFormat) {
        if (DT) {
            if (DT.isDateTime(cellValue)) newDatetime = cellValue;
            else if (inputFormat === "iso") newDatetime = DT.fromISO(String(cellValue));
            else newDatetime = DT.fromFormat(String(cellValue), inputFormat);
            cellValue = newDatetime.toFormat("HH:mm");
        } else console.error("Editor Error - 'date' editor 'format' param is dependant on luxon.js");
    }
    input.value = cellValue;
    onRendered(function() {
        if (cell.getType() == "cell") {
            input.focus({
                preventScroll: true
            });
            input.style.height = "100%";
            if (editorParams.selectContents) input.select();
        }
    });
    function onChange() {
        var value = input.value, luxTime;
        if ((cellValue === null || typeof cellValue === "undefined") && value !== "" || value !== cellValue) {
            if (value && inputFormat) {
                luxTime = DT.fromFormat(String(value), "hh:mm");
                switch(inputFormat){
                    case true:
                        value = luxTime;
                        break;
                    case "iso":
                        value = luxTime.toISO();
                        break;
                    default:
                        value = luxTime.toFormat(inputFormat);
                }
            }
            if (success(value)) cellValue = input.value; //persist value if successfully validated incase editor is used as header filter
        } else cancel();
    }
    //submit new value on blur
    input.addEventListener("blur", function(e) {
        if (e.relatedTarget || e.rangeParent || e.explicitOriginalTarget !== input) onChange(); // only on a "true" blur; not when focusing browser's date/time picker
    });
    //submit new value on enter
    input.addEventListener("keydown", function(e) {
        switch(e.keyCode){
            // case 9:
            case 13:
                onChange();
                break;
            case 27:
                cancel();
                break;
            case 35:
            case 36:
                e.stopPropagation();
                break;
            case 38:
            case 40:
                if (vertNav == "editor") {
                    e.stopImmediatePropagation();
                    e.stopPropagation();
                }
                break;
        }
    });
    return input;
}
//input element
function $c2a9788f40f9c90a$var$datetime$2(cell, onRendered, success, cancel, editorParams) {
    var inputFormat = editorParams.format, vertNav = editorParams.verticalNavigation || "editor", DT = inputFormat ? window.DateTime || luxon.DateTime : null, newDatetime;
    //create and style input
    var cellValue = cell.getValue(), input = document.createElement("input");
    input.type = "datetime-local";
    input.style.padding = "4px";
    input.style.width = "100%";
    input.style.boxSizing = "border-box";
    if (editorParams.elementAttributes && typeof editorParams.elementAttributes == "object") {
        for(let key in editorParams.elementAttributes)if (key.charAt(0) == "+") {
            key = key.slice(1);
            input.setAttribute(key, input.getAttribute(key) + editorParams.elementAttributes["+" + key]);
        } else input.setAttribute(key, editorParams.elementAttributes[key]);
    }
    cellValue = typeof cellValue !== "undefined" ? cellValue : "";
    if (inputFormat) {
        if (DT) {
            if (DT.isDateTime(cellValue)) newDatetime = cellValue;
            else if (inputFormat === "iso") newDatetime = DT.fromISO(String(cellValue));
            else newDatetime = DT.fromFormat(String(cellValue), inputFormat);
            cellValue = newDatetime.toFormat("yyyy-MM-dd") + "T" + newDatetime.toFormat("HH:mm");
        } else console.error("Editor Error - 'date' editor 'format' param is dependant on luxon.js");
    }
    input.value = cellValue;
    onRendered(function() {
        if (cell.getType() === "cell") {
            input.focus({
                preventScroll: true
            });
            input.style.height = "100%";
            if (editorParams.selectContents) input.select();
        }
    });
    function onChange() {
        var value = input.value, luxDateTime;
        if ((cellValue === null || typeof cellValue === "undefined") && value !== "" || value !== cellValue) {
            if (value && inputFormat) {
                luxDateTime = DT.fromISO(String(value));
                switch(inputFormat){
                    case true:
                        value = luxDateTime;
                        break;
                    case "iso":
                        value = luxDateTime.toISO();
                        break;
                    default:
                        value = luxDateTime.toFormat(inputFormat);
                }
            }
            if (success(value)) cellValue = input.value; //persist value if successfully validated incase editor is used as header filter
        } else cancel();
    }
    //submit new value on blur
    input.addEventListener("blur", function(e) {
        if (e.relatedTarget || e.rangeParent || e.explicitOriginalTarget !== input) onChange(); // only on a "true" blur; not when focusing browser's date/time picker
    });
    //submit new value on enter
    input.addEventListener("keydown", function(e) {
        switch(e.keyCode){
            // case 9:
            case 13:
                onChange();
                break;
            case 27:
                cancel();
                break;
            case 35:
            case 36:
                e.stopPropagation();
                break;
            case 38:
            case 40:
                if (vertNav == "editor") {
                    e.stopImmediatePropagation();
                    e.stopPropagation();
                }
                break;
        }
    });
    return input;
}
let $c2a9788f40f9c90a$var$Edit$1 = class Edit {
    constructor(editor, cell, onRendered, success, cancel, editorParams){
        this.edit = editor;
        this.table = editor.table;
        this.cell = cell;
        this.params = this._initializeParams(editorParams);
        this.data = [];
        this.displayItems = [];
        this.currentItems = [];
        this.focusedItem = null;
        this.input = this._createInputElement();
        this.listEl = this._createListElement();
        this.initialValues = null;
        this.isFilter = cell.getType() === "header";
        this.filterTimeout = null;
        this.filtered = false;
        this.typing = false;
        this.values = [];
        this.popup = null;
        this.listIteration = 0;
        this.lastAction = "";
        this.filterTerm = "";
        this.blurable = true;
        this.actions = {
            success: success,
            cancel: cancel
        };
        this._deprecatedOptionsCheck();
        this._initializeValue();
        onRendered(this._onRendered.bind(this));
    }
    _deprecatedOptionsCheck() {
    // if(this.params.listItemFormatter){
    // 	this.cell.getTable().deprecationAdvisor.msg("The listItemFormatter editor param has been deprecated, please see the latest editor documentation for updated options");
    // }
    // if(this.params.sortValuesList){
    // 	this.cell.getTable().deprecationAdvisor.msg("The sortValuesList editor param has been deprecated, please see the latest editor documentation for updated options");
    // }
    // if(this.params.searchFunc){
    // 	this.cell.getTable().deprecationAdvisor.msg("The searchFunc editor param has been deprecated, please see the latest editor documentation for updated options");
    // }
    // if(this.params.searchingPlaceholder){
    // 	this.cell.getTable().deprecationAdvisor.msg("The searchingPlaceholder editor param has been deprecated, please see the latest editor documentation for updated options");
    // }
    }
    _initializeValue() {
        var initialValue = this.cell.getValue();
        if (typeof initialValue === "undefined" && typeof this.params.defaultValue !== "undefined") initialValue = this.params.defaultValue;
        this.initialValues = this.params.multiselect ? initialValue : [
            initialValue
        ];
        if (this.isFilter) {
            this.input.value = this.initialValues ? this.initialValues.join(",") : "";
            this.headerFilterInitialListGen();
        }
    }
    _onRendered() {
        var cellEl = this.cell.getElement();
        function clickStop(e) {
            e.stopPropagation();
        }
        if (!this.isFilter) {
            this.input.style.height = "100%";
            this.input.focus({
                preventScroll: true
            });
        }
        cellEl.addEventListener("click", clickStop);
        setTimeout(()=>{
            cellEl.removeEventListener("click", clickStop);
        }, 1000);
        this.input.addEventListener("mousedown", this._preventPopupBlur.bind(this));
    }
    _createListElement() {
        var listEl = document.createElement("div");
        listEl.classList.add("tabulator-edit-list");
        listEl.addEventListener("mousedown", this._preventBlur.bind(this));
        listEl.addEventListener("keydown", this._inputKeyDown.bind(this));
        return listEl;
    }
    _setListWidth() {
        var element = this.isFilter ? this.input : this.cell.getElement();
        this.listEl.style.minWidth = element.offsetWidth + "px";
        if (this.params.maxWidth) {
            if (this.params.maxWidth === true) this.listEl.style.maxWidth = element.offsetWidth + "px";
            else if (typeof this.params.maxWidth === "number") this.listEl.style.maxWidth = this.params.maxWidth + "px";
            else this.listEl.style.maxWidth = this.params.maxWidth;
        }
    }
    _createInputElement() {
        var attribs = this.params.elementAttributes;
        var input = document.createElement("input");
        input.setAttribute("type", this.params.clearable ? "search" : "text");
        input.style.padding = "4px";
        input.style.width = "100%";
        input.style.boxSizing = "border-box";
        if (!this.params.autocomplete) {
            input.style.cursor = "default";
            input.style.caretColor = "transparent";
        // input.readOnly = (this.edit.currentCell != false);
        }
        if (attribs && typeof attribs == "object") {
            for(let key in attribs)if (key.charAt(0) == "+") {
                key = key.slice(1);
                input.setAttribute(key, input.getAttribute(key) + attribs["+" + key]);
            } else input.setAttribute(key, attribs[key]);
        }
        if (this.params.mask) $c2a9788f40f9c90a$var$maskInput(input, this.params);
        this._bindInputEvents(input);
        return input;
    }
    _initializeParams(params) {
        var valueKeys = [
            "values",
            "valuesURL",
            "valuesLookup"
        ], valueCheck;
        params = Object.assign({}, params);
        params.verticalNavigation = params.verticalNavigation || "editor";
        params.placeholderLoading = typeof params.placeholderLoading === "undefined" ? "Searching ..." : params.placeholderLoading;
        params.placeholderEmpty = typeof params.placeholderEmpty === "undefined" ? "No Results Found" : params.placeholderEmpty;
        params.filterDelay = typeof params.filterDelay === "undefined" ? 300 : params.filterDelay;
        params.emptyValue = Object.keys(params).includes("emptyValue") ? params.emptyValue : "";
        valueCheck = Object.keys(params).filter((key)=>valueKeys.includes(key)).length;
        if (!valueCheck) console.warn("list editor config error - either the values, valuesURL, or valuesLookup option must be set");
        else if (valueCheck > 1) console.warn("list editor config error - only one of the values, valuesURL, or valuesLookup options can be set on the same editor");
        if (params.autocomplete) {
            if (params.multiselect) {
                params.multiselect = false;
                console.warn("list editor config error - multiselect option is not available when autocomplete is enabled");
            }
        } else {
            if (params.freetext) {
                params.freetext = false;
                console.warn("list editor config error - freetext option is only available when autocomplete is enabled");
            }
            if (params.filterFunc) {
                params.filterFunc = false;
                console.warn("list editor config error - filterFunc option is only available when autocomplete is enabled");
            }
            if (params.filterRemote) {
                params.filterRemote = false;
                console.warn("list editor config error - filterRemote option is only available when autocomplete is enabled");
            }
            if (params.mask) {
                params.mask = false;
                console.warn("list editor config error - mask option is only available when autocomplete is enabled");
            }
            if (params.allowEmpty) {
                params.allowEmpty = false;
                console.warn("list editor config error - allowEmpty option is only available when autocomplete is enabled");
            }
            if (params.listOnEmpty) {
                params.listOnEmpty = false;
                console.warn("list editor config error - listOnEmpty option is only available when autocomplete is enabled");
            }
        }
        if (params.filterRemote && !(typeof params.valuesLookup === "function" || params.valuesURL)) {
            params.filterRemote = false;
            console.warn("list editor config error - filterRemote option should only be used when values list is populated from a remote source");
        }
        return params;
    }
    //////////////////////////////////////
    ////////// Event Handling ////////////
    //////////////////////////////////////
    _bindInputEvents(input) {
        input.addEventListener("focus", this._inputFocus.bind(this));
        input.addEventListener("click", this._inputClick.bind(this));
        input.addEventListener("blur", this._inputBlur.bind(this));
        input.addEventListener("keydown", this._inputKeyDown.bind(this));
        input.addEventListener("search", this._inputSearch.bind(this));
        if (this.params.autocomplete) input.addEventListener("keyup", this._inputKeyUp.bind(this));
    }
    _inputFocus(e) {
        this.rebuildOptionsList();
    }
    _filter() {
        if (this.params.filterRemote) {
            clearTimeout(this.filterTimeout);
            this.filterTimeout = setTimeout(()=>{
                this.rebuildOptionsList();
            }, this.params.filterDelay);
        } else this._filterList();
    }
    _inputClick(e) {
        e.stopPropagation();
    }
    _inputBlur(e) {
        if (this.blurable) {
            if (this.popup) this.popup.hide();
            else this._resolveValue(true);
        }
    }
    _inputSearch() {
        this._clearChoices();
    }
    _inputKeyDown(e) {
        switch(e.keyCode){
            case 38:
                this._keyUp(e);
                break;
            case 40:
                this._keyDown(e);
                break;
            case 37:
            case 39:
                this._keySide(e);
                break;
            case 13:
                this._keyEnter();
                break;
            case 27:
                this._keyEsc();
                break;
            case 36:
            case 35:
                this._keyHomeEnd(e);
                break;
            case 9:
                this._keyTab(e);
                break;
            default:
                this._keySelectLetter(e);
        }
    }
    _inputKeyUp(e) {
        switch(e.keyCode){
            case 38:
            case 37:
            case 39:
            case 40:
            case 13:
            case 27:
                break;
            default:
                this._keyAutoCompLetter(e);
        }
    }
    _preventPopupBlur() {
        if (this.popup) this.popup.blockHide();
        setTimeout(()=>{
            if (this.popup) this.popup.restoreHide();
        }, 10);
    }
    _preventBlur() {
        this.blurable = false;
        setTimeout(()=>{
            this.blurable = true;
        }, 10);
    }
    //////////////////////////////////////
    //////// Keyboard Navigation /////////
    //////////////////////////////////////
    _keyTab(e) {
        if (this.params.autocomplete && this.lastAction === "typing") this._resolveValue(true);
        else if (this.focusedItem) this._chooseItem(this.focusedItem, true);
    }
    _keyUp(e) {
        var index = this.displayItems.indexOf(this.focusedItem);
        if (this.params.verticalNavigation == "editor" || this.params.verticalNavigation == "hybrid" && index) {
            e.stopImmediatePropagation();
            e.stopPropagation();
            e.preventDefault();
            if (index > 0) this._focusItem(this.displayItems[index - 1]);
        }
    }
    _keyDown(e) {
        var index = this.displayItems.indexOf(this.focusedItem);
        if (this.params.verticalNavigation == "editor" || this.params.verticalNavigation == "hybrid" && index < this.displayItems.length - 1) {
            e.stopImmediatePropagation();
            e.stopPropagation();
            e.preventDefault();
            if (index < this.displayItems.length - 1) {
                if (index == -1) this._focusItem(this.displayItems[0]);
                else this._focusItem(this.displayItems[index + 1]);
            }
        }
    }
    _keySide(e) {
        if (!this.params.autocomplete) {
            e.stopImmediatePropagation();
            e.stopPropagation();
            e.preventDefault();
        }
    }
    _keyEnter(e) {
        if (this.params.autocomplete && this.lastAction === "typing") this._resolveValue(true);
        else if (this.focusedItem) this._chooseItem(this.focusedItem);
    }
    _keyEsc(e) {
        this._cancel();
    }
    _keyHomeEnd(e) {
        if (this.params.autocomplete) //prevent table navigation while using input element
        e.stopImmediatePropagation();
    }
    _keySelectLetter(e) {
        if (!this.params.autocomplete) {
            // if(this.edit.currentCell === false){
            e.preventDefault();
            // }
            if (e.keyCode >= 38 && e.keyCode <= 90) this._scrollToValue(e.keyCode);
        }
    }
    _keyAutoCompLetter(e) {
        this._filter();
        this.lastAction = "typing";
        this.typing = true;
    }
    _scrollToValue(char) {
        clearTimeout(this.filterTimeout);
        var character = String.fromCharCode(char).toLowerCase();
        this.filterTerm += character.toLowerCase();
        var match = this.displayItems.find((item)=>{
            return typeof item.label !== "undefined" && item.label.toLowerCase().startsWith(this.filterTerm);
        });
        if (match) this._focusItem(match);
        this.filterTimeout = setTimeout(()=>{
            this.filterTerm = "";
        }, 800);
    }
    _focusItem(item) {
        this.lastAction = "focus";
        if (this.focusedItem && this.focusedItem.element) this.focusedItem.element.classList.remove("focused");
        this.focusedItem = item;
        if (item && item.element) {
            item.element.classList.add("focused");
            item.element.scrollIntoView({
                behavior: "smooth",
                block: "nearest",
                inline: "start"
            });
        }
    }
    //////////////////////////////////////
    /////// Data List Generation /////////
    //////////////////////////////////////
    headerFilterInitialListGen() {
        this._generateOptions(true);
    }
    rebuildOptionsList() {
        this._generateOptions().then(this._sortOptions.bind(this)).then(this._buildList.bind(this)).then(this._showList.bind(this)).catch((e)=>{
            if (!Number.isInteger(e)) console.error("List generation error", e);
        });
    }
    _filterList() {
        this._buildList(this._filterOptions());
        this._showList();
    }
    _generateOptions(silent) {
        var values = [];
        var iteration = ++this.listIteration;
        this.filtered = false;
        if (this.params.values) values = this.params.values;
        else if (this.params.valuesURL) values = this._ajaxRequest(this.params.valuesURL, this.input.value);
        else {
            if (typeof this.params.valuesLookup === "function") values = this.params.valuesLookup(this.cell, this.input.value);
            else if (this.params.valuesLookup) values = this._uniqueColumnValues(this.params.valuesLookupField);
        }
        if (values instanceof Promise) {
            if (!silent) this._addPlaceholder(this.params.placeholderLoading);
            return values.then().then((responseValues)=>{
                if (this.listIteration === iteration) return this._parseList(responseValues);
                else return Promise.reject(iteration);
            });
        } else return Promise.resolve(this._parseList(values));
    }
    _addPlaceholder(contents) {
        var placeholder = document.createElement("div");
        if (typeof contents === "function") contents = contents(this.cell.getComponent(), this.listEl);
        if (contents) {
            this._clearList();
            if (contents instanceof HTMLElement) placeholder = contents;
            else {
                placeholder.classList.add("tabulator-edit-list-placeholder");
                placeholder.innerHTML = contents;
            }
            this.listEl.appendChild(placeholder);
            this._showList();
        }
    }
    _ajaxRequest(url, term) {
        var params = this.params.filterRemote ? {
            term: term
        } : {};
        url = $c2a9788f40f9c90a$var$urlBuilder(url, {}, params);
        return fetch(url).then((response)=>{
            if (response.ok) return response.json().catch((error)=>{
                console.warn("List Ajax Load Error - Invalid JSON returned", error);
                return Promise.reject(error);
            });
            else {
                console.error("List Ajax Load Error - Connection Error: " + response.status, response.statusText);
                return Promise.reject(response);
            }
        }).catch((error)=>{
            console.error("List Ajax Load Error - Connection Error: ", error);
            return Promise.reject(error);
        });
    }
    _uniqueColumnValues(field) {
        var output = {}, data = this.table.getData(this.params.valuesLookup), column;
        if (field) column = this.table.columnManager.getColumnByField(field);
        else column = this.cell.getColumn()._getSelf();
        if (column) data.forEach((row)=>{
            var val = column.getFieldValue(row);
            if (val !== null && typeof val !== "undefined" && val !== "") output[val] = true;
        });
        else {
            console.warn("unable to find matching column to create select lookup list:", field);
            output = [];
        }
        return Object.keys(output);
    }
    _parseList(inputValues) {
        var data = [];
        if (!Array.isArray(inputValues)) inputValues = Object.entries(inputValues).map(([key, value])=>{
            return {
                label: value,
                value: key
            };
        });
        inputValues.forEach((value)=>{
            if (typeof value !== "object") value = {
                label: value,
                value: value
            };
            this._parseListItem(value, data, 0);
        });
        if (!this.currentItems.length && this.params.freetext) {
            this.input.value = this.initialValues;
            this.typing = true;
            this.lastAction = "typing";
        }
        this.data = data;
        return data;
    }
    _parseListItem(option, data, level) {
        var item = {};
        if (option.options) item = this._parseListGroup(option, level + 1);
        else {
            item = {
                label: option.label,
                value: option.value,
                itemParams: option.itemParams,
                elementAttributes: option.elementAttributes,
                element: false,
                selected: false,
                visible: true,
                level: level,
                original: option
            };
            if (this.initialValues && this.initialValues.indexOf(option.value) > -1) this._chooseItem(item, true);
        }
        data.push(item);
    }
    _parseListGroup(option, level) {
        var item = {
            label: option.label,
            group: true,
            itemParams: option.itemParams,
            elementAttributes: option.elementAttributes,
            element: false,
            visible: true,
            level: level,
            options: [],
            original: option
        };
        option.options.forEach((child)=>{
            this._parseListItem(child, item.options, level);
        });
        return item;
    }
    _sortOptions(options) {
        var sorter;
        if (this.params.sort) {
            sorter = typeof this.params.sort === "function" ? this.params.sort : this._defaultSortFunction.bind(this);
            this._sortGroup(sorter, options);
        }
        return options;
    }
    _sortGroup(sorter, options) {
        options.sort((a, b)=>{
            return sorter(a.label, b.label, a.value, b.value, a.original, b.original);
        });
        options.forEach((option)=>{
            if (option.group) this._sortGroup(sorter, option.options);
        });
    }
    _defaultSortFunction(as, bs) {
        var a, b, a1, b1, i = 0, L, rx = /(\d+)|(\D+)/g, rd = /\d/;
        var emptyAlign = 0;
        if (this.params.sort === "desc") [as, bs] = [
            bs,
            as
        ];
        //handle empty values
        if (!as && as !== 0) emptyAlign = !bs && bs !== 0 ? 0 : -1;
        else if (!bs && bs !== 0) emptyAlign = 1;
        else {
            if (isFinite(as) && isFinite(bs)) return as - bs;
            a = String(as).toLowerCase();
            b = String(bs).toLowerCase();
            if (a === b) return 0;
            if (!(rd.test(a) && rd.test(b))) return a > b ? 1 : -1;
            a = a.match(rx);
            b = b.match(rx);
            L = a.length > b.length ? b.length : a.length;
            while(i < L){
                a1 = a[i];
                b1 = b[i++];
                if (a1 !== b1) {
                    if (isFinite(a1) && isFinite(b1)) {
                        if (a1.charAt(0) === "0") a1 = "." + a1;
                        if (b1.charAt(0) === "0") b1 = "." + b1;
                        return a1 - b1;
                    } else return a1 > b1 ? 1 : -1;
                }
            }
            return a.length > b.length;
        }
        return emptyAlign;
    }
    _filterOptions() {
        var filterFunc = this.params.filterFunc || this._defaultFilterFunc, term = this.input.value;
        if (term) {
            this.filtered = true;
            this.data.forEach((item)=>{
                this._filterItem(filterFunc, term, item);
            });
        } else this.filtered = false;
        return this.data;
    }
    _filterItem(func, term, item) {
        var matches = false;
        if (!item.group) item.visible = func(term, item.label, item.value, item.original);
        else {
            item.options.forEach((option)=>{
                if (this._filterItem(func, term, option)) matches = true;
            });
            item.visible = matches;
        }
        return item.visible;
    }
    _defaultFilterFunc(term, label, value, item) {
        term = String(term).toLowerCase();
        if (label !== null && typeof label !== "undefined") {
            if (String(label).toLowerCase().indexOf(term) > -1 || String(value).toLowerCase().indexOf(term) > -1) return true;
        }
        return false;
    }
    //////////////////////////////////////
    /////////// Display List /////////////
    //////////////////////////////////////
    _clearList() {
        while(this.listEl.firstChild)this.listEl.removeChild(this.listEl.firstChild);
        this.displayItems = [];
    }
    _buildList(data) {
        this._clearList();
        data.forEach((option)=>{
            this._buildItem(option);
        });
        if (!this.displayItems.length) this._addPlaceholder(this.params.placeholderEmpty);
    }
    _buildItem(item) {
        var el = item.element, contents;
        if (!this.filtered || item.visible) {
            if (!el) {
                el = document.createElement("div");
                el.tabIndex = 0;
                contents = this.params.itemFormatter ? this.params.itemFormatter(item.label, item.value, item.original, el) : item.label;
                if (contents instanceof HTMLElement) el.appendChild(contents);
                else el.innerHTML = contents;
                if (item.group) el.classList.add("tabulator-edit-list-group");
                else el.classList.add("tabulator-edit-list-item");
                el.classList.add("tabulator-edit-list-group-level-" + item.level);
                if (item.elementAttributes && typeof item.elementAttributes == "object") {
                    for(let key in item.elementAttributes)if (key.charAt(0) == "+") {
                        key = key.slice(1);
                        el.setAttribute(key, this.input.getAttribute(key) + item.elementAttributes["+" + key]);
                    } else el.setAttribute(key, item.elementAttributes[key]);
                }
                if (item.group) el.addEventListener("click", this._groupClick.bind(this, item));
                else el.addEventListener("click", this._itemClick.bind(this, item));
                el.addEventListener("mousedown", this._preventBlur.bind(this));
                item.element = el;
            }
            this._styleItem(item);
            this.listEl.appendChild(el);
            if (item.group) item.options.forEach((option)=>{
                this._buildItem(option);
            });
            else this.displayItems.push(item);
        }
    }
    _showList() {
        var startVis = this.popup && this.popup.isVisible();
        if (this.input.parentNode) {
            if (this.params.autocomplete && this.input.value === "" && !this.params.listOnEmpty) {
                if (this.popup) this.popup.hide(true);
                return;
            }
            this._setListWidth();
            if (!this.popup) this.popup = this.edit.popup(this.listEl);
            this.popup.show(this.cell.getElement(), "bottom");
            if (!startVis) setTimeout(()=>{
                this.popup.hideOnBlur(this._resolveValue.bind(this, true));
            }, 10);
        }
    }
    _styleItem(item) {
        if (item && item.element) {
            if (item.selected) item.element.classList.add("active");
            else item.element.classList.remove("active");
        }
    }
    //////////////////////////////////////
    ///////// User Interaction ///////////
    //////////////////////////////////////
    _itemClick(item, e) {
        e.stopPropagation();
        this._chooseItem(item);
    }
    _groupClick(item, e) {
        e.stopPropagation();
    }
    //////////////////////////////////////
    ////// Current Item Management ///////
    //////////////////////////////////////
    _cancel() {
        this.popup.hide(true);
        this.actions.cancel();
    }
    _clearChoices() {
        this.typing = true;
        this.currentItems.forEach((item)=>{
            item.selected = false;
            this._styleItem(item);
        });
        this.currentItems = [];
        this.focusedItem = null;
    }
    _chooseItem(item, silent) {
        var index;
        this.typing = false;
        if (this.params.multiselect) {
            index = this.currentItems.indexOf(item);
            if (index > -1) {
                this.currentItems.splice(index, 1);
                item.selected = false;
            } else {
                this.currentItems.push(item);
                item.selected = true;
            }
            this.input.value = this.currentItems.map((item)=>item.label).join(",");
            this._styleItem(item);
        } else {
            this.currentItems = [
                item
            ];
            item.selected = true;
            this.input.value = item.label;
            this._styleItem(item);
            if (!silent) this._resolveValue();
        }
        this._focusItem(item);
    }
    _resolveValue(blur) {
        var output, initialValue;
        if (this.popup) this.popup.hide(true);
        if (this.params.multiselect) output = this.currentItems.map((item)=>item.value);
        else {
            if (blur && this.params.autocomplete && this.typing) {
                if (this.params.freetext || this.params.allowEmpty && this.input.value === "") output = this.input.value;
                else {
                    this.actions.cancel();
                    return;
                }
            } else if (this.currentItems[0]) output = this.currentItems[0].value;
            else {
                initialValue = Array.isArray(this.initialValues) ? this.initialValues[0] : this.initialValues;
                if (initialValue === null || typeof initialValue === "undefined" || initialValue === "") output = initialValue;
                else output = this.params.emptyValue;
            }
        }
        if (output === "") output = this.params.emptyValue;
        this.actions.success(output);
        if (this.isFilter) {
            this.initialValues = output && !Array.isArray(output) ? [
                output
            ] : output;
            this.currentItems = [];
        }
    }
};
function $c2a9788f40f9c90a$var$list(cell, onRendered, success, cancel, editorParams) {
    var list = new $c2a9788f40f9c90a$var$Edit$1(this, cell, onRendered, success, cancel, editorParams);
    return list.input;
}
//star rating
function $c2a9788f40f9c90a$var$star$1(cell, onRendered, success, cancel, editorParams) {
    var self = this, element = cell.getElement(), value = cell.getValue(), maxStars = element.getElementsByTagName("svg").length || 5, size = element.getElementsByTagName("svg")[0] ? element.getElementsByTagName("svg")[0].getAttribute("width") : 14, stars = [], starsHolder = document.createElement("div"), star = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    //change star type
    function starChange(val) {
        stars.forEach(function(star, i) {
            if (i < val) {
                if (self.table.browser == "ie") star.setAttribute("class", "tabulator-star-active");
                else star.classList.replace("tabulator-star-inactive", "tabulator-star-active");
                star.innerHTML = '<polygon fill="#488CE9" stroke="#014AAE" stroke-width="37.6152" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" points="259.216,29.942 330.27,173.919 489.16,197.007 374.185,309.08 401.33,467.31 259.216,392.612 117.104,467.31 144.25,309.08 29.274,197.007 188.165,173.919 "/>';
            } else {
                if (self.table.browser == "ie") star.setAttribute("class", "tabulator-star-inactive");
                else star.classList.replace("tabulator-star-active", "tabulator-star-inactive");
                star.innerHTML = '<polygon fill="#010155" stroke="#686868" stroke-width="37.6152" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" points="259.216,29.942 330.27,173.919 489.16,197.007 374.185,309.08 401.33,467.31 259.216,392.612 117.104,467.31 144.25,309.08 29.274,197.007 188.165,173.919 "/>';
            }
        });
    }
    //build stars
    function buildStar(i) {
        var starHolder = document.createElement("span");
        var nextStar = star.cloneNode(true);
        stars.push(nextStar);
        starHolder.addEventListener("mouseenter", function(e) {
            e.stopPropagation();
            e.stopImmediatePropagation();
            starChange(i);
        });
        starHolder.addEventListener("mousemove", function(e) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        });
        starHolder.addEventListener("click", function(e) {
            e.stopPropagation();
            e.stopImmediatePropagation();
            success(i);
            element.blur();
        });
        starHolder.appendChild(nextStar);
        starsHolder.appendChild(starHolder);
    }
    //handle keyboard navigation value change
    function changeValue(val) {
        value = val;
        starChange(val);
    }
    //style cell
    element.style.whiteSpace = "nowrap";
    element.style.overflow = "hidden";
    element.style.textOverflow = "ellipsis";
    //style holding element
    starsHolder.style.verticalAlign = "middle";
    starsHolder.style.display = "inline-block";
    starsHolder.style.padding = "4px";
    //style star
    star.setAttribute("width", size);
    star.setAttribute("height", size);
    star.setAttribute("viewBox", "0 0 512 512");
    star.setAttribute("xml:space", "preserve");
    star.style.padding = "0 1px";
    if (editorParams.elementAttributes && typeof editorParams.elementAttributes == "object") {
        for(let key in editorParams.elementAttributes)if (key.charAt(0) == "+") {
            key = key.slice(1);
            starsHolder.setAttribute(key, starsHolder.getAttribute(key) + editorParams.elementAttributes["+" + key]);
        } else starsHolder.setAttribute(key, editorParams.elementAttributes[key]);
    }
    //create correct number of stars
    for(var i = 1; i <= maxStars; i++)buildStar(i);
    //ensure value does not exceed number of stars
    value = Math.min(parseInt(value), maxStars);
    // set initial styling of stars
    starChange(value);
    starsHolder.addEventListener("mousemove", function(e) {
        starChange(0);
    });
    starsHolder.addEventListener("click", function(e) {
        success(0);
    });
    element.addEventListener("blur", function(e) {
        cancel();
    });
    //allow key based navigation
    element.addEventListener("keydown", function(e) {
        switch(e.keyCode){
            case 39:
                changeValue(value + 1);
                break;
            case 37:
                changeValue(value - 1);
                break;
            case 13:
                success(value);
                break;
            case 27:
                cancel();
                break;
        }
    });
    return starsHolder;
}
//draggable progress bar
function $c2a9788f40f9c90a$var$progress$1(cell, onRendered, success, cancel, editorParams) {
    var element = cell.getElement(), max = typeof editorParams.max === "undefined" ? element.getElementsByTagName("div")[0] && element.getElementsByTagName("div")[0].getAttribute("max") || 100 : editorParams.max, min = typeof editorParams.min === "undefined" ? element.getElementsByTagName("div")[0] && element.getElementsByTagName("div")[0].getAttribute("min") || 0 : editorParams.min, percent = (max - min) / 100, value = cell.getValue() || 0, handle = document.createElement("div"), bar = document.createElement("div"), mouseDrag, mouseDragWidth;
    //set new value
    function updateValue() {
        var style = window.getComputedStyle(element, null);
        var calcVal = percent * Math.round(bar.offsetWidth / ((element.clientWidth - parseInt(style.getPropertyValue("padding-left")) - parseInt(style.getPropertyValue("padding-right"))) / 100)) + min;
        success(calcVal);
        element.setAttribute("aria-valuenow", calcVal);
        element.setAttribute("aria-label", value);
    }
    //style handle
    handle.style.position = "absolute";
    handle.style.right = "0";
    handle.style.top = "0";
    handle.style.bottom = "0";
    handle.style.width = "5px";
    handle.classList.add("tabulator-progress-handle");
    //style bar
    bar.style.display = "inline-block";
    bar.style.position = "relative";
    // bar.style.top = "8px";
    // bar.style.bottom = "8px";
    // bar.style.left = "4px";
    // bar.style.marginRight = "4px";
    bar.style.height = "100%";
    bar.style.backgroundColor = "#488CE9";
    bar.style.maxWidth = "100%";
    bar.style.minWidth = "0%";
    if (editorParams.elementAttributes && typeof editorParams.elementAttributes == "object") {
        for(let key in editorParams.elementAttributes)if (key.charAt(0) == "+") {
            key = key.slice(1);
            bar.setAttribute(key, bar.getAttribute(key) + editorParams.elementAttributes["+" + key]);
        } else bar.setAttribute(key, editorParams.elementAttributes[key]);
    }
    //style cell
    element.style.padding = "4px 4px";
    //make sure value is in range
    value = Math.min(parseFloat(value), max);
    value = Math.max(parseFloat(value), min);
    //workout percentage
    value = Math.round((value - min) / percent);
    // bar.style.right = value + "%";
    bar.style.width = value + "%";
    element.setAttribute("aria-valuemin", min);
    element.setAttribute("aria-valuemax", max);
    bar.appendChild(handle);
    handle.addEventListener("mousedown", function(e) {
        mouseDrag = e.screenX;
        mouseDragWidth = bar.offsetWidth;
    });
    handle.addEventListener("mouseover", function() {
        handle.style.cursor = "ew-resize";
    });
    element.addEventListener("mousemove", function(e) {
        if (mouseDrag) bar.style.width = mouseDragWidth + e.screenX - mouseDrag + "px";
    });
    element.addEventListener("mouseup", function(e) {
        if (mouseDrag) {
            e.stopPropagation();
            e.stopImmediatePropagation();
            mouseDrag = false;
            mouseDragWidth = false;
            updateValue();
        }
    });
    //allow key based navigation
    element.addEventListener("keydown", function(e) {
        switch(e.keyCode){
            case 39:
                e.preventDefault();
                bar.style.width = bar.clientWidth + element.clientWidth / 100 + "px";
                break;
            case 37:
                e.preventDefault();
                bar.style.width = bar.clientWidth - element.clientWidth / 100 + "px";
                break;
            case 9:
            case 13:
                updateValue();
                break;
            case 27:
                cancel();
                break;
        }
    });
    element.addEventListener("blur", function() {
        cancel();
    });
    return bar;
}
//checkbox
function $c2a9788f40f9c90a$var$tickCross$1(cell, onRendered, success, cancel, editorParams) {
    var value = cell.getValue(), input = document.createElement("input"), tristate = editorParams.tristate, indetermValue = typeof editorParams.indeterminateValue === "undefined" ? null : editorParams.indeterminateValue, indetermState = false, trueValueSet = Object.keys(editorParams).includes("trueValue"), falseValueSet = Object.keys(editorParams).includes("falseValue");
    input.setAttribute("type", "checkbox");
    input.style.marginTop = "5px";
    input.style.boxSizing = "border-box";
    if (editorParams.elementAttributes && typeof editorParams.elementAttributes == "object") {
        for(let key in editorParams.elementAttributes)if (key.charAt(0) == "+") {
            key = key.slice(1);
            input.setAttribute(key, input.getAttribute(key) + editorParams.elementAttributes["+" + key]);
        } else input.setAttribute(key, editorParams.elementAttributes[key]);
    }
    input.value = value;
    if (tristate && (typeof value === "undefined" || value === indetermValue || value === "")) {
        indetermState = true;
        input.indeterminate = true;
    }
    if (this.table.browser != "firefox" && this.table.browser != "safari") onRendered(function() {
        if (cell.getType() === "cell") input.focus({
            preventScroll: true
        });
    });
    input.checked = trueValueSet ? value === editorParams.trueValue : value === true || value === "true" || value === "True" || value === 1;
    function setValue(blur) {
        var checkedValue = input.checked;
        if (trueValueSet && checkedValue) checkedValue = editorParams.trueValue;
        else if (falseValueSet && !checkedValue) checkedValue = editorParams.falseValue;
        if (tristate) {
            if (!blur) {
                if (input.checked && !indetermState) {
                    input.checked = false;
                    input.indeterminate = true;
                    indetermState = true;
                    return indetermValue;
                } else {
                    indetermState = false;
                    return checkedValue;
                }
            } else {
                if (indetermState) return indetermValue;
                else return checkedValue;
            }
        } else return checkedValue;
    }
    //submit new value on blur
    input.addEventListener("change", function(e) {
        success(setValue());
    });
    input.addEventListener("blur", function(e) {
        success(setValue(true));
    });
    //submit new value on enter
    input.addEventListener("keydown", function(e) {
        if (e.keyCode == 13) success(setValue());
        if (e.keyCode == 27) cancel();
    });
    return input;
}
var $c2a9788f40f9c90a$var$defaultEditors = {
    input: $c2a9788f40f9c90a$var$input,
    textarea: $c2a9788f40f9c90a$var$textarea$1,
    number: $c2a9788f40f9c90a$var$number$1,
    range: $c2a9788f40f9c90a$var$range,
    date: $c2a9788f40f9c90a$var$date$1,
    time: $c2a9788f40f9c90a$var$time$1,
    datetime: $c2a9788f40f9c90a$var$datetime$2,
    list: $c2a9788f40f9c90a$var$list,
    star: $c2a9788f40f9c90a$var$star$1,
    progress: $c2a9788f40f9c90a$var$progress$1,
    tickCross: $c2a9788f40f9c90a$var$tickCross$1
};
class $c2a9788f40f9c90a$export$2394e2d3d2175314 extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "edit";
    //load defaults
    static editors = $c2a9788f40f9c90a$var$defaultEditors;
    constructor(table){
        super(table);
        this.currentCell = false; //hold currently editing cell
        this.mouseClick = false; //hold mousedown state to prevent click binding being overridden by editor opening
        this.recursionBlock = false; //prevent focus recursion
        this.invalidEdit = false;
        this.editedCells = [];
        this.convertEmptyValues = false;
        this.editors = $c2a9788f40f9c90a$export$2394e2d3d2175314.editors;
        this.registerTableOption("editTriggerEvent", "focus");
        this.registerTableOption("editorEmptyValue");
        this.registerTableOption("editorEmptyValueFunc", this.emptyValueCheck.bind(this));
        this.registerColumnOption("editable");
        this.registerColumnOption("editor");
        this.registerColumnOption("editorParams");
        this.registerColumnOption("editorEmptyValue");
        this.registerColumnOption("editorEmptyValueFunc");
        this.registerColumnOption("cellEditing");
        this.registerColumnOption("cellEdited");
        this.registerColumnOption("cellEditCancelled");
        this.registerTableFunction("getEditedCells", this.getEditedCells.bind(this));
        this.registerTableFunction("clearCellEdited", this.clearCellEdited.bind(this));
        this.registerTableFunction("navigatePrev", this.navigatePrev.bind(this));
        this.registerTableFunction("navigateNext", this.navigateNext.bind(this));
        this.registerTableFunction("navigateLeft", this.navigateLeft.bind(this));
        this.registerTableFunction("navigateRight", this.navigateRight.bind(this));
        this.registerTableFunction("navigateUp", this.navigateUp.bind(this));
        this.registerTableFunction("navigateDown", this.navigateDown.bind(this));
        this.registerComponentFunction("cell", "isEdited", this.cellIsEdited.bind(this));
        this.registerComponentFunction("cell", "clearEdited", this.clearEdited.bind(this));
        this.registerComponentFunction("cell", "edit", this.editCell.bind(this));
        this.registerComponentFunction("cell", "cancelEdit", this.cellCancelEdit.bind(this));
        this.registerComponentFunction("cell", "navigatePrev", this.navigatePrev.bind(this));
        this.registerComponentFunction("cell", "navigateNext", this.navigateNext.bind(this));
        this.registerComponentFunction("cell", "navigateLeft", this.navigateLeft.bind(this));
        this.registerComponentFunction("cell", "navigateRight", this.navigateRight.bind(this));
        this.registerComponentFunction("cell", "navigateUp", this.navigateUp.bind(this));
        this.registerComponentFunction("cell", "navigateDown", this.navigateDown.bind(this));
    }
    initialize() {
        this.subscribe("cell-init", this.bindEditor.bind(this));
        this.subscribe("cell-delete", this.clearEdited.bind(this));
        this.subscribe("cell-value-changed", this.updateCellClass.bind(this));
        this.subscribe("column-layout", this.initializeColumnCheck.bind(this));
        this.subscribe("column-delete", this.columnDeleteCheck.bind(this));
        this.subscribe("row-deleting", this.rowDeleteCheck.bind(this));
        this.subscribe("row-layout", this.rowEditableCheck.bind(this));
        this.subscribe("data-refreshing", this.cancelEdit.bind(this));
        this.subscribe("clipboard-paste", this.pasteBlocker.bind(this));
        this.subscribe("keybinding-nav-prev", this.navigatePrev.bind(this, undefined));
        this.subscribe("keybinding-nav-next", this.keybindingNavigateNext.bind(this));
        // this.subscribe("keybinding-nav-left", this.navigateLeft.bind(this, undefined));
        // this.subscribe("keybinding-nav-right", this.navigateRight.bind(this, undefined));
        this.subscribe("keybinding-nav-up", this.navigateUp.bind(this, undefined));
        this.subscribe("keybinding-nav-down", this.navigateDown.bind(this, undefined));
        if (Object.keys(this.table.options).includes("editorEmptyValue")) this.convertEmptyValues = true;
    }
    ///////////////////////////////////
    ///////// Paste Negation //////////
    ///////////////////////////////////
    pasteBlocker(e) {
        if (this.currentCell) return true;
    }
    ///////////////////////////////////
    ////// Keybinding Functions ///////
    ///////////////////////////////////
    keybindingNavigateNext(e) {
        var cell = this.currentCell, newRow = this.options("tabEndNewRow");
        if (cell) {
            if (!this.navigateNext(cell, e)) {
                if (newRow) {
                    cell.getElement().firstChild.blur();
                    if (!this.invalidEdit) {
                        if (newRow === true) newRow = this.table.addRow({});
                        else if (typeof newRow == "function") newRow = this.table.addRow(newRow(cell.row.getComponent()));
                        else newRow = this.table.addRow(Object.assign({}, newRow));
                        newRow.then(()=>{
                            setTimeout(()=>{
                                cell.getComponent().navigateNext();
                            });
                        });
                    }
                }
            }
        }
    }
    ///////////////////////////////////
    ///////// Cell Functions //////////
    ///////////////////////////////////
    cellIsEdited(cell) {
        return !!cell.modules.edit && cell.modules.edit.edited;
    }
    cellCancelEdit(cell) {
        if (cell === this.currentCell) this.table.modules.edit.cancelEdit();
        else console.warn("Cancel Editor Error - This cell is not currently being edited ");
    }
    ///////////////////////////////////
    ///////// Table Functions /////////
    ///////////////////////////////////
    updateCellClass(cell) {
        if (this.allowEdit(cell)) cell.getElement().classList.add("tabulator-editable");
        else cell.getElement().classList.remove("tabulator-editable");
    }
    clearCellEdited(cells) {
        if (!cells) cells = this.table.modules.edit.getEditedCells();
        if (!Array.isArray(cells)) cells = [
            cells
        ];
        cells.forEach((cell)=>{
            this.table.modules.edit.clearEdited(cell._getSelf());
        });
    }
    navigatePrev(cell = this.currentCell, e) {
        var nextCell, prevRow;
        if (cell) {
            if (e) e.preventDefault();
            nextCell = this.navigateLeft();
            if (nextCell) return true;
            else {
                prevRow = this.table.rowManager.prevDisplayRow(cell.row, true);
                if (prevRow) {
                    nextCell = this.findPrevEditableCell(prevRow, prevRow.cells.length);
                    if (nextCell) {
                        nextCell.getComponent().edit();
                        return true;
                    }
                }
            }
        }
        return false;
    }
    navigateNext(cell = this.currentCell, e) {
        var nextCell, nextRow;
        if (cell) {
            if (e) e.preventDefault();
            nextCell = this.navigateRight();
            if (nextCell) return true;
            else {
                nextRow = this.table.rowManager.nextDisplayRow(cell.row, true);
                if (nextRow) {
                    nextCell = this.findNextEditableCell(nextRow, -1);
                    if (nextCell) {
                        nextCell.getComponent().edit();
                        return true;
                    }
                }
            }
        }
        return false;
    }
    navigateLeft(cell = this.currentCell, e) {
        var index, nextCell;
        if (cell) {
            if (e) e.preventDefault();
            index = cell.getIndex();
            nextCell = this.findPrevEditableCell(cell.row, index);
            if (nextCell) {
                nextCell.getComponent().edit();
                return true;
            }
        }
        return false;
    }
    navigateRight(cell = this.currentCell, e) {
        var index, nextCell;
        if (cell) {
            if (e) e.preventDefault();
            index = cell.getIndex();
            nextCell = this.findNextEditableCell(cell.row, index);
            if (nextCell) {
                nextCell.getComponent().edit();
                return true;
            }
        }
        return false;
    }
    navigateUp(cell = this.currentCell, e) {
        var index, nextRow;
        if (cell) {
            if (e) e.preventDefault();
            index = cell.getIndex();
            nextRow = this.table.rowManager.prevDisplayRow(cell.row, true);
            if (nextRow) {
                nextRow.cells[index].getComponent().edit();
                return true;
            }
        }
        return false;
    }
    navigateDown(cell = this.currentCell, e) {
        var index, nextRow;
        if (cell) {
            if (e) e.preventDefault();
            index = cell.getIndex();
            nextRow = this.table.rowManager.nextDisplayRow(cell.row, true);
            if (nextRow) {
                nextRow.cells[index].getComponent().edit();
                return true;
            }
        }
        return false;
    }
    findNextEditableCell(row, index) {
        var nextCell = false;
        if (index < row.cells.length - 1) for(var i = index + 1; i < row.cells.length; i++){
            let cell = row.cells[i];
            if (cell.column.modules.edit && $c2a9788f40f9c90a$var$Helpers.elVisible(cell.getElement())) {
                let allowEdit = this.allowEdit(cell);
                if (allowEdit) {
                    nextCell = cell;
                    break;
                }
            }
        }
        return nextCell;
    }
    findPrevEditableCell(row, index) {
        var prevCell = false;
        if (index > 0) for(var i = index - 1; i >= 0; i--){
            let cell = row.cells[i];
            if (cell.column.modules.edit && $c2a9788f40f9c90a$var$Helpers.elVisible(cell.getElement())) {
                let allowEdit = this.allowEdit(cell);
                if (allowEdit) {
                    prevCell = cell;
                    break;
                }
            }
        }
        return prevCell;
    }
    ///////////////////////////////////
    ///////// Internal Logic //////////
    ///////////////////////////////////
    initializeColumnCheck(column) {
        if (typeof column.definition.editor !== "undefined") this.initializeColumn(column);
    }
    columnDeleteCheck(column) {
        if (this.currentCell && this.currentCell.column === column) this.cancelEdit();
    }
    rowDeleteCheck(row) {
        if (this.currentCell && this.currentCell.row === row) this.cancelEdit();
    }
    rowEditableCheck(row) {
        row.getCells().forEach((cell)=>{
            if (cell.column.modules.edit && typeof cell.column.modules.edit.check === "function") this.updateCellClass(cell);
        });
    }
    //initialize column editor
    initializeColumn(column) {
        var convertEmpty = Object.keys(column.definition).includes("editorEmptyValue");
        var config = {
            editor: false,
            blocked: false,
            check: column.definition.editable,
            params: column.definition.editorParams || {},
            convertEmptyValues: convertEmpty,
            editorEmptyValue: column.definition.editorEmptyValue,
            editorEmptyValueFunc: column.definition.editorEmptyValueFunc
        };
        //set column editor
        switch(typeof column.definition.editor){
            case "string":
                if (this.editors[column.definition.editor]) config.editor = this.editors[column.definition.editor];
                else console.warn("Editor Error - No such editor found: ", column.definition.editor);
                break;
            case "function":
                config.editor = column.definition.editor;
                break;
            case "boolean":
                if (column.definition.editor === true) {
                    if (typeof column.definition.formatter !== "function") {
                        if (this.editors[column.definition.formatter]) config.editor = this.editors[column.definition.formatter];
                        else config.editor = this.editors["input"];
                    } else console.warn("Editor Error - Cannot auto lookup editor for a custom formatter: ", column.definition.formatter);
                }
                break;
        }
        if (config.editor) column.modules.edit = config;
    }
    getCurrentCell() {
        return this.currentCell ? this.currentCell.getComponent() : false;
    }
    clearEditor(cancel) {
        var cell = this.currentCell, cellEl;
        this.invalidEdit = false;
        if (cell) {
            this.currentCell = false;
            cellEl = cell.getElement();
            this.dispatch("edit-editor-clear", cell, cancel);
            cellEl.classList.remove("tabulator-editing");
            while(cellEl.firstChild)cellEl.removeChild(cellEl.firstChild);
            cell.row.getElement().classList.remove("tabulator-editing");
            cell.table.element.classList.remove("tabulator-editing");
        }
    }
    cancelEdit() {
        if (this.currentCell) {
            var cell = this.currentCell;
            var component = this.currentCell.getComponent();
            this.clearEditor(true);
            cell.setValueActual(cell.getValue());
            cell.cellRendered();
            if (cell.column.definition.editor == "textarea" || cell.column.definition.variableHeight) cell.row.normalizeHeight(true);
            if (cell.column.definition.cellEditCancelled) cell.column.definition.cellEditCancelled.call(this.table, component);
            this.dispatch("edit-cancelled", cell);
            this.dispatchExternal("cellEditCancelled", component);
        }
    }
    //return a formatted value for a cell
    bindEditor(cell) {
        if (cell.column.modules.edit) {
            var self = this, element = cell.getElement(true);
            this.updateCellClass(cell);
            element.setAttribute("tabindex", 0);
            element.addEventListener("mousedown", function(e) {
                if (e.button === 2) e.preventDefault();
                else self.mouseClick = true;
            });
            if (this.options("editTriggerEvent") === "dblclick") element.addEventListener("dblclick", function(e) {
                if (!element.classList.contains("tabulator-editing")) {
                    element.focus({
                        preventScroll: true
                    });
                    self.edit(cell, e, false);
                }
            });
            if (this.options("editTriggerEvent") === "focus" || this.options("editTriggerEvent") === "click") element.addEventListener("click", function(e) {
                if (!element.classList.contains("tabulator-editing")) {
                    element.focus({
                        preventScroll: true
                    });
                    self.edit(cell, e, false);
                }
            });
            if (this.options("editTriggerEvent") === "focus") element.addEventListener("focus", function(e) {
                if (!self.recursionBlock) self.edit(cell, e, false);
            });
        }
    }
    focusCellNoEvent(cell, block) {
        this.recursionBlock = true;
        if (!(block && this.table.browser === "ie")) cell.getElement().focus({
            preventScroll: true
        });
        this.recursionBlock = false;
    }
    editCell(cell, forceEdit) {
        this.focusCellNoEvent(cell);
        this.edit(cell, false, forceEdit);
    }
    focusScrollAdjust(cell) {
        if (this.table.rowManager.getRenderMode() == "virtual") {
            var topEdge = this.table.rowManager.element.scrollTop, bottomEdge = this.table.rowManager.element.clientHeight + this.table.rowManager.element.scrollTop, rowEl = cell.row.getElement();
            if (rowEl.offsetTop < topEdge) this.table.rowManager.element.scrollTop -= topEdge - rowEl.offsetTop;
            else if (rowEl.offsetTop + rowEl.offsetHeight > bottomEdge) this.table.rowManager.element.scrollTop += rowEl.offsetTop + rowEl.offsetHeight - bottomEdge;
            var leftEdge = this.table.rowManager.element.scrollLeft, rightEdge = this.table.rowManager.element.clientWidth + this.table.rowManager.element.scrollLeft, cellEl = cell.getElement();
            if (this.table.modExists("frozenColumns")) {
                leftEdge += parseInt(this.table.modules.frozenColumns.leftMargin || 0);
                rightEdge -= parseInt(this.table.modules.frozenColumns.rightMargin || 0);
            }
            if (this.table.options.renderHorizontal === "virtual") {
                leftEdge -= parseInt(this.table.columnManager.renderer.vDomPadLeft);
                rightEdge -= parseInt(this.table.columnManager.renderer.vDomPadLeft);
            }
            if (cellEl.offsetLeft < leftEdge) this.table.rowManager.element.scrollLeft -= leftEdge - cellEl.offsetLeft;
            else if (cellEl.offsetLeft + cellEl.offsetWidth > rightEdge) this.table.rowManager.element.scrollLeft += cellEl.offsetLeft + cellEl.offsetWidth - rightEdge;
        }
    }
    allowEdit(cell) {
        var check = cell.column.modules.edit ? true : false;
        if (cell.column.modules.edit) switch(typeof cell.column.modules.edit.check){
            case "function":
                if (cell.row.initialized) check = cell.column.modules.edit.check(cell.getComponent());
                break;
            case "string":
                check = !!cell.row.data[cell.column.modules.edit.check];
                break;
            case "boolean":
                check = cell.column.modules.edit.check;
                break;
        }
        return check;
    }
    edit(cell, e, forceEdit) {
        var self = this, allowEdit = true, rendered = function() {}, element = cell.getElement(), editFinished = false, cellEditor, component, params;
        //prevent editing if another cell is refusing to leave focus (eg. validation fail)
        if (this.currentCell) {
            if (!this.invalidEdit && this.currentCell !== cell) this.cancelEdit();
            return;
        }
        //handle successful value change
        function success(value) {
            if (self.currentCell === cell && !editFinished) {
                var valid = self.chain("edit-success", [
                    cell,
                    value
                ], true, true);
                if (valid === true || self.table.options.validationMode === "highlight") {
                    editFinished = true;
                    self.clearEditor();
                    if (!cell.modules.edit) cell.modules.edit = {};
                    cell.modules.edit.edited = true;
                    if (self.editedCells.indexOf(cell) == -1) self.editedCells.push(cell);
                    value = self.transformEmptyValues(value, cell);
                    cell.setValue(value, true);
                    return valid === true;
                } else {
                    editFinished = true;
                    self.invalidEdit = true;
                    self.focusCellNoEvent(cell, true);
                    rendered();
                    setTimeout(()=>{
                        editFinished = false;
                    }, 10);
                    return false;
                }
            }
        }
        //handle aborted edit
        function cancel() {
            // editFinished = true;
            if (self.currentCell === cell && !editFinished) self.cancelEdit();
        }
        function onRendered(callback) {
            rendered = callback;
        }
        if (!cell.column.modules.edit.blocked) {
            if (e) e.stopPropagation();
            allowEdit = this.allowEdit(cell);
            if (allowEdit || forceEdit) {
                self.cancelEdit();
                self.currentCell = cell;
                this.focusScrollAdjust(cell);
                component = cell.getComponent();
                if (this.mouseClick) {
                    this.mouseClick = false;
                    if (cell.column.definition.cellClick) cell.column.definition.cellClick.call(this.table, e, component);
                }
                if (cell.column.definition.cellEditing) cell.column.definition.cellEditing.call(this.table, component);
                this.dispatch("cell-editing", cell);
                this.dispatchExternal("cellEditing", component);
                params = typeof cell.column.modules.edit.params === "function" ? cell.column.modules.edit.params(component) : cell.column.modules.edit.params;
                cellEditor = cell.column.modules.edit.editor.call(self, component, onRendered, success, cancel, params);
                //if editor returned, add to DOM, if false, abort edit
                if (this.currentCell && cellEditor !== false) {
                    if (cellEditor instanceof Node) {
                        element.classList.add("tabulator-editing");
                        cell.row.getElement().classList.add("tabulator-editing");
                        cell.table.element.classList.add("tabulator-editing");
                        while(element.firstChild)element.removeChild(element.firstChild);
                        element.appendChild(cellEditor);
                        //trigger onRendered Callback
                        rendered();
                        //prevent editing from triggering rowClick event
                        var children = element.children;
                        for(var i = 0; i < children.length; i++)children[i].addEventListener("click", function(e) {
                            e.stopPropagation();
                        });
                    } else {
                        console.warn("Edit Error - Editor should return an instance of Node, the editor returned:", cellEditor);
                        this.blur(element);
                        return false;
                    }
                } else {
                    this.blur(element);
                    return false;
                }
                return true;
            } else {
                this.mouseClick = false;
                this.blur(element);
                return false;
            }
        } else {
            this.mouseClick = false;
            this.blur(element);
            return false;
        }
    }
    emptyValueCheck(value) {
        return value === "" || value === null || typeof value === "undefined";
    }
    transformEmptyValues(value, cell) {
        var mod = cell.column.modules.edit, convert = mod.convertEmptyValues || this.convertEmptyValues, checkFunc;
        if (convert) {
            checkFunc = mod.editorEmptyValueFunc || this.options("editorEmptyValueFunc");
            if (checkFunc && checkFunc(value)) value = mod.convertEmptyValues ? mod.editorEmptyValue : this.options("editorEmptyValue");
        }
        return value;
    }
    blur(element) {
        if (!this.confirm("edit-blur", [
            element
        ])) element.blur();
    }
    getEditedCells() {
        var output = [];
        this.editedCells.forEach((cell)=>{
            output.push(cell.getComponent());
        });
        return output;
    }
    clearEdited(cell) {
        var editIndex;
        if (cell.modules.edit && cell.modules.edit.edited) {
            cell.modules.edit.edited = false;
            this.dispatch("edit-edited-clear", cell);
        }
        editIndex = this.editedCells.indexOf(cell);
        if (editIndex > -1) this.editedCells.splice(editIndex, 1);
    }
}
class $c2a9788f40f9c90a$var$ExportRow {
    constructor(type, columns, component, indent){
        this.type = type;
        this.columns = columns;
        this.component = component || false;
        this.indent = indent || 0;
    }
}
class $c2a9788f40f9c90a$var$ExportColumn {
    constructor(value, component, width, height, depth){
        this.value = value;
        this.component = component || false;
        this.width = width;
        this.height = height;
        this.depth = depth;
    }
}
var $c2a9788f40f9c90a$var$columnLookups$1 = {};
var $c2a9788f40f9c90a$var$rowLookups$1 = {
    visible: function() {
        return this.rowManager.getVisibleRows(false, true);
    },
    all: function() {
        return this.rowManager.rows;
    },
    selected: function() {
        return this.modules.selectRow.selectedRows;
    },
    active: function() {
        if (this.options.pagination) return this.rowManager.getDisplayRows(this.rowManager.displayRows.length - 2);
        else return this.rowManager.getDisplayRows();
    }
};
class $c2a9788f40f9c90a$export$4e0f34fd9829977c extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "export";
    static columnLookups = $c2a9788f40f9c90a$var$columnLookups$1;
    static rowLookups = $c2a9788f40f9c90a$var$rowLookups$1;
    constructor(table){
        super(table);
        this.config = {};
        this.cloneTableStyle = true;
        this.colVisProp = "";
        this.colVisPropAttach = "";
        this.registerTableOption("htmlOutputConfig", false); //html output config
        this.registerColumnOption("htmlOutput");
        this.registerColumnOption("titleHtmlOutput");
    }
    initialize() {
        this.registerTableFunction("getHtml", this.getHtml.bind(this));
    }
    ///////////////////////////////////
    ///////// Internal Logic //////////
    ///////////////////////////////////
    generateExportList(config, style, range, colVisProp) {
        var headers, body, columns, colLookup;
        this.cloneTableStyle = style;
        this.config = config || {};
        this.colVisProp = colVisProp;
        this.colVisPropAttach = this.colVisProp.charAt(0).toUpperCase() + this.colVisProp.slice(1);
        colLookup = $c2a9788f40f9c90a$export$4e0f34fd9829977c.columnLookups[range];
        if (colLookup) {
            columns = colLookup.call(this.table);
            columns = columns.filter((col)=>this.columnVisCheck(col));
        }
        headers = this.config.columnHeaders !== false ? this.headersToExportRows(this.generateColumnGroupHeaders(columns)) : [];
        if (columns) columns = columns.map((col)=>col.getComponent());
        body = this.bodyToExportRows(this.rowLookup(range), columns);
        return headers.concat(body);
    }
    generateTable(config, style, range, colVisProp) {
        var list = this.generateExportList(config, style, range, colVisProp);
        return this.generateTableElement(list);
    }
    rowLookup(range) {
        var rows = [], rowLookup;
        if (typeof range == "function") range.call(this.table).forEach((row)=>{
            row = this.table.rowManager.findRow(row);
            if (row) rows.push(row);
        });
        else {
            rowLookup = $c2a9788f40f9c90a$export$4e0f34fd9829977c.rowLookups[range] || $c2a9788f40f9c90a$export$4e0f34fd9829977c.rowLookups["active"];
            rows = rowLookup.call(this.table);
        }
        return Object.assign([], rows);
    }
    generateColumnGroupHeaders(columns) {
        var output = [];
        if (!columns) columns = this.config.columnGroups !== false ? this.table.columnManager.columns : this.table.columnManager.columnsByIndex;
        columns.forEach((column)=>{
            var colData = this.processColumnGroup(column);
            if (colData) output.push(colData);
        });
        return output;
    }
    processColumnGroup(column) {
        var subGroups = column.columns, maxDepth = 0, title = column.definition["title" + this.colVisPropAttach] || column.definition.title;
        var groupData = {
            title: title,
            column: column,
            depth: 1
        };
        if (subGroups.length) {
            groupData.subGroups = [];
            groupData.width = 0;
            subGroups.forEach((subGroup)=>{
                var subGroupData = this.processColumnGroup(subGroup);
                if (subGroupData) {
                    groupData.width += subGroupData.width;
                    groupData.subGroups.push(subGroupData);
                    if (subGroupData.depth > maxDepth) maxDepth = subGroupData.depth;
                }
            });
            groupData.depth += maxDepth;
            if (!groupData.width) return false;
        } else {
            if (this.columnVisCheck(column)) groupData.width = 1;
            else return false;
        }
        return groupData;
    }
    columnVisCheck(column) {
        var visProp = column.definition[this.colVisProp];
        if (this.config.rowHeaders === false && column.isRowHeader) return false;
        if (typeof visProp === "function") visProp = visProp.call(this.table, column.getComponent());
        if (visProp === false || visProp === true) return visProp;
        return column.visible && column.field;
    }
    headersToExportRows(columns) {
        var headers = [], headerDepth = 0, exportRows = [];
        function parseColumnGroup(column, level) {
            var depth = headerDepth - level;
            if (typeof headers[level] === "undefined") headers[level] = [];
            column.height = column.subGroups ? 1 : depth - column.depth + 1;
            headers[level].push(column);
            if (column.height > 1) for(let i = 1; i < column.height; i++){
                if (typeof headers[level + i] === "undefined") headers[level + i] = [];
                headers[level + i].push(false);
            }
            if (column.width > 1) for(let i = 1; i < column.width; i++)headers[level].push(false);
            if (column.subGroups) column.subGroups.forEach(function(subGroup) {
                parseColumnGroup(subGroup, level + 1);
            });
        }
        //calculate maximum header depth
        columns.forEach(function(column) {
            if (column.depth > headerDepth) headerDepth = column.depth;
        });
        columns.forEach(function(column) {
            parseColumnGroup(column, 0);
        });
        headers.forEach((header)=>{
            var columns = [];
            header.forEach((col)=>{
                if (col) {
                    let title = typeof col.title === "undefined" ? "" : col.title;
                    columns.push(new $c2a9788f40f9c90a$var$ExportColumn(title, col.column.getComponent(), col.width, col.height, col.depth));
                } else columns.push(null);
            });
            exportRows.push(new $c2a9788f40f9c90a$var$ExportRow("header", columns));
        });
        return exportRows;
    }
    bodyToExportRows(rows, columns = []) {
        var exportRows = [];
        if (columns.length === 0) this.table.columnManager.columnsByIndex.forEach((column)=>{
            if (this.columnVisCheck(column)) columns.push(column.getComponent());
        });
        if (this.config.columnCalcs !== false && this.table.modExists("columnCalcs")) {
            if (this.table.modules.columnCalcs.topInitialized) rows.unshift(this.table.modules.columnCalcs.topRow);
            if (this.table.modules.columnCalcs.botInitialized) rows.push(this.table.modules.columnCalcs.botRow);
        }
        rows = rows.filter((row)=>{
            switch(row.type){
                case "group":
                    return this.config.rowGroups !== false;
                case "calc":
                    return this.config.columnCalcs !== false;
                case "row":
                    return !(this.table.options.dataTree && this.config.dataTree === false && row.modules.dataTree.parent);
            }
            return true;
        });
        rows.forEach((row, i)=>{
            var rowData = row.getData(this.colVisProp);
            var exportCols = [];
            var indent = 0;
            switch(row.type){
                case "group":
                    indent = row.level;
                    exportCols.push(new $c2a9788f40f9c90a$var$ExportColumn(row.key, row.getComponent(), columns.length, 1));
                    break;
                case "calc":
                case "row":
                    columns.forEach((col)=>{
                        exportCols.push(new $c2a9788f40f9c90a$var$ExportColumn(col._column.getFieldValue(rowData), col, 1, 1));
                    });
                    if (this.table.options.dataTree && this.config.dataTree !== false) indent = row.modules.dataTree.index;
                    break;
            }
            exportRows.push(new $c2a9788f40f9c90a$var$ExportRow(row.type, exportCols, row.getComponent(), indent));
        });
        return exportRows;
    }
    generateTableElement(list) {
        var table = document.createElement("table"), headerEl = document.createElement("thead"), bodyEl = document.createElement("tbody"), styles = this.lookupTableStyles(), rowFormatter = this.table.options["rowFormatter" + this.colVisPropAttach], setup = {};
        setup.rowFormatter = rowFormatter !== null ? rowFormatter : this.table.options.rowFormatter;
        if (this.table.options.dataTree && this.config.dataTree !== false && this.table.modExists("columnCalcs")) setup.treeElementField = this.table.modules.dataTree.elementField;
        //assign group header formatter
        setup.groupHeader = this.table.options["groupHeader" + this.colVisPropAttach];
        if (setup.groupHeader && !Array.isArray(setup.groupHeader)) setup.groupHeader = [
            setup.groupHeader
        ];
        table.classList.add("tabulator-print-table");
        this.mapElementStyles(this.table.columnManager.getHeadersElement(), headerEl, [
            "border-top",
            "border-left",
            "border-right",
            "border-bottom",
            "background-color",
            "color",
            "font-weight",
            "font-family",
            "font-size"
        ]);
        if (list.length > 1000) console.warn("It may take a long time to render an HTML table with more than 1000 rows");
        list.forEach((row, i)=>{
            let rowEl;
            switch(row.type){
                case "header":
                    headerEl.appendChild(this.generateHeaderElement(row, setup, styles));
                    break;
                case "group":
                    bodyEl.appendChild(this.generateGroupElement(row, setup, styles));
                    break;
                case "calc":
                    bodyEl.appendChild(this.generateCalcElement(row, setup, styles));
                    break;
                case "row":
                    rowEl = this.generateRowElement(row, setup, styles);
                    this.mapElementStyles(i % 2 && styles.evenRow ? styles.evenRow : styles.oddRow, rowEl, [
                        "border-top",
                        "border-left",
                        "border-right",
                        "border-bottom",
                        "color",
                        "font-weight",
                        "font-family",
                        "font-size",
                        "background-color"
                    ]);
                    bodyEl.appendChild(rowEl);
                    break;
            }
        });
        if (headerEl.innerHTML) table.appendChild(headerEl);
        table.appendChild(bodyEl);
        this.mapElementStyles(this.table.element, table, [
            "border-top",
            "border-left",
            "border-right",
            "border-bottom"
        ]);
        return table;
    }
    lookupTableStyles() {
        var styles = {};
        //lookup row styles
        if (this.cloneTableStyle && window.getComputedStyle) {
            styles.oddRow = this.table.element.querySelector(".tabulator-row-odd:not(.tabulator-group):not(.tabulator-calcs)");
            styles.evenRow = this.table.element.querySelector(".tabulator-row-even:not(.tabulator-group):not(.tabulator-calcs)");
            styles.calcRow = this.table.element.querySelector(".tabulator-row.tabulator-calcs");
            styles.firstRow = this.table.element.querySelector(".tabulator-row:not(.tabulator-group):not(.tabulator-calcs)");
            styles.firstGroup = this.table.element.getElementsByClassName("tabulator-group")[0];
            if (styles.firstRow) {
                styles.styleCells = styles.firstRow.getElementsByClassName("tabulator-cell");
                styles.styleRowHeader = styles.firstRow.getElementsByClassName("tabulator-row-header")[0];
                styles.firstCell = styles.styleCells[0];
                styles.lastCell = styles.styleCells[styles.styleCells.length - 1];
            }
        }
        return styles;
    }
    generateHeaderElement(row, setup, styles) {
        var rowEl = document.createElement("tr");
        row.columns.forEach((column)=>{
            if (column) {
                var cellEl = document.createElement("th");
                var classNames = column.component._column.definition.cssClass ? column.component._column.definition.cssClass.split(" ") : [];
                cellEl.colSpan = column.width;
                cellEl.rowSpan = column.height;
                cellEl.innerHTML = column.value;
                if (this.cloneTableStyle) cellEl.style.boxSizing = "border-box";
                classNames.forEach(function(className) {
                    cellEl.classList.add(className);
                });
                this.mapElementStyles(column.component.getElement(), cellEl, [
                    "text-align",
                    "border-left",
                    "border-right",
                    "background-color",
                    "color",
                    "font-weight",
                    "font-family",
                    "font-size"
                ]);
                this.mapElementStyles(column.component._column.contentElement, cellEl, [
                    "padding-top",
                    "padding-left",
                    "padding-right",
                    "padding-bottom"
                ]);
                if (column.component._column.visible) this.mapElementStyles(column.component.getElement(), cellEl, [
                    "width"
                ]);
                else if (column.component._column.definition.width) cellEl.style.width = column.component._column.definition.width + "px";
                if (column.component._column.parent && column.component._column.parent.isGroup) this.mapElementStyles(column.component._column.parent.groupElement, cellEl, [
                    "border-top"
                ]);
                else this.mapElementStyles(column.component.getElement(), cellEl, [
                    "border-top"
                ]);
                if (column.component._column.isGroup) this.mapElementStyles(column.component.getElement(), cellEl, [
                    "border-bottom"
                ]);
                else this.mapElementStyles(this.table.columnManager.getElement(), cellEl, [
                    "border-bottom"
                ]);
                rowEl.appendChild(cellEl);
            }
        });
        return rowEl;
    }
    generateGroupElement(row, setup, styles) {
        var rowEl = document.createElement("tr"), cellEl = document.createElement("td"), group = row.columns[0];
        rowEl.classList.add("tabulator-print-table-row");
        if (setup.groupHeader && setup.groupHeader[row.indent]) group.value = setup.groupHeader[row.indent](group.value, row.component._group.getRowCount(), row.component._group.getData(), row.component);
        else if (setup.groupHeader !== false) group.value = row.component._group.generator(group.value, row.component._group.getRowCount(), row.component._group.getData(), row.component);
        cellEl.colSpan = group.width;
        cellEl.innerHTML = group.value;
        rowEl.classList.add("tabulator-print-table-group");
        rowEl.classList.add("tabulator-group-level-" + row.indent);
        if (group.component.isVisible()) rowEl.classList.add("tabulator-group-visible");
        this.mapElementStyles(styles.firstGroup, rowEl, [
            "border-top",
            "border-left",
            "border-right",
            "border-bottom",
            "color",
            "font-weight",
            "font-family",
            "font-size",
            "background-color"
        ]);
        this.mapElementStyles(styles.firstGroup, cellEl, [
            "padding-top",
            "padding-left",
            "padding-right",
            "padding-bottom"
        ]);
        rowEl.appendChild(cellEl);
        return rowEl;
    }
    generateCalcElement(row, setup, styles) {
        var rowEl = this.generateRowElement(row, setup, styles);
        rowEl.classList.add("tabulator-print-table-calcs");
        this.mapElementStyles(styles.calcRow, rowEl, [
            "border-top",
            "border-left",
            "border-right",
            "border-bottom",
            "color",
            "font-weight",
            "font-family",
            "font-size",
            "background-color"
        ]);
        return rowEl;
    }
    generateRowElement(row, setup, styles) {
        var rowEl = document.createElement("tr");
        rowEl.classList.add("tabulator-print-table-row");
        row.columns.forEach((col, i)=>{
            if (col) {
                var cellEl = document.createElement("td"), column = col.component._column, table = this.table, index = table.columnManager.findColumnIndex(column), value = col.value, cellStyle, styleProps;
                var cellWrapper = {
                    modules: {},
                    getValue: function() {
                        return value;
                    },
                    getField: function() {
                        return column.definition.field;
                    },
                    getElement: function() {
                        return cellEl;
                    },
                    getType: function() {
                        return "cell";
                    },
                    getColumn: function() {
                        return column.getComponent();
                    },
                    getData: function() {
                        return row.component.getData();
                    },
                    getRow: function() {
                        return row.component;
                    },
                    getTable: function() {
                        return table;
                    },
                    getComponent: function() {
                        return cellWrapper;
                    },
                    column: column
                };
                var classNames = column.definition.cssClass ? column.definition.cssClass.split(" ") : [];
                classNames.forEach(function(className) {
                    cellEl.classList.add(className);
                });
                if (this.table.modExists("format") && this.config.formatCells !== false) value = this.table.modules.format.formatExportValue(cellWrapper, this.colVisProp);
                else switch(typeof value){
                    case "object":
                        value = value !== null ? JSON.stringify(value) : "";
                        break;
                    case "undefined":
                        value = "";
                        break;
                }
                if (value instanceof Node) cellEl.appendChild(value);
                else cellEl.innerHTML = value;
                styleProps = [
                    "padding-top",
                    "padding-left",
                    "padding-right",
                    "padding-bottom",
                    "border-top",
                    "border-left",
                    "border-right",
                    "border-bottom",
                    "color",
                    "font-weight",
                    "font-family",
                    "font-size",
                    "text-align"
                ];
                if (column.isRowHeader) {
                    cellStyle = styles.styleRowHeader;
                    styleProps.push("background-color");
                } else cellStyle = styles.styleCells && styles.styleCells[index] ? styles.styleCells[index] : styles.firstCell;
                if (cellStyle) {
                    this.mapElementStyles(cellStyle, cellEl, styleProps);
                    if (column.definition.align) cellEl.style.textAlign = column.definition.align;
                }
                if (this.table.options.dataTree && this.config.dataTree !== false) {
                    if (setup.treeElementField && setup.treeElementField == column.field || !setup.treeElementField && i == 0) {
                        if (row.component._row.modules.dataTree.controlEl) cellEl.insertBefore(row.component._row.modules.dataTree.controlEl.cloneNode(true), cellEl.firstChild);
                        if (row.component._row.modules.dataTree.branchEl) cellEl.insertBefore(row.component._row.modules.dataTree.branchEl.cloneNode(true), cellEl.firstChild);
                    }
                }
                rowEl.appendChild(cellEl);
                if (cellWrapper.modules.format && cellWrapper.modules.format.renderedCallback) cellWrapper.modules.format.renderedCallback();
            }
        });
        if (setup.rowFormatter && row.type === "row" && this.config.formatCells !== false) {
            let formatComponent = Object.assign(row.component);
            formatComponent.getElement = function() {
                return rowEl;
            };
            setup.rowFormatter(row.component);
        }
        return rowEl;
    }
    generateHTMLTable(list) {
        var holder = document.createElement("div");
        holder.appendChild(this.generateTableElement(list));
        return holder.innerHTML;
    }
    getHtml(visible, style, config, colVisProp) {
        var list = this.generateExportList(config || this.table.options.htmlOutputConfig, style, visible, colVisProp || "htmlOutput");
        return this.generateHTMLTable(list);
    }
    mapElementStyles(from, to, props) {
        if (this.cloneTableStyle && from && to) {
            var lookup = {
                "background-color": "backgroundColor",
                "color": "fontColor",
                "width": "width",
                "font-weight": "fontWeight",
                "font-family": "fontFamily",
                "font-size": "fontSize",
                "text-align": "textAlign",
                "border-top": "borderTop",
                "border-left": "borderLeft",
                "border-right": "borderRight",
                "border-bottom": "borderBottom",
                "padding-top": "paddingTop",
                "padding-left": "paddingLeft",
                "padding-right": "paddingRight",
                "padding-bottom": "paddingBottom"
            };
            if (window.getComputedStyle) {
                var fromStyle = window.getComputedStyle(from);
                props.forEach(function(prop) {
                    if (!to.style[lookup[prop]]) to.style[lookup[prop]] = fromStyle.getPropertyValue(prop);
                });
            }
        }
    }
}
var $c2a9788f40f9c90a$var$defaultFilters = {
    //equal to
    "=": function(filterVal, rowVal, rowData, filterParams) {
        return rowVal == filterVal ? true : false;
    },
    //less than
    "<": function(filterVal, rowVal, rowData, filterParams) {
        return rowVal < filterVal ? true : false;
    },
    //less than or equal to
    "<=": function(filterVal, rowVal, rowData, filterParams) {
        return rowVal <= filterVal ? true : false;
    },
    //greater than
    ">": function(filterVal, rowVal, rowData, filterParams) {
        return rowVal > filterVal ? true : false;
    },
    //greater than or equal to
    ">=": function(filterVal, rowVal, rowData, filterParams) {
        return rowVal >= filterVal ? true : false;
    },
    //not equal to
    "!=": function(filterVal, rowVal, rowData, filterParams) {
        return rowVal != filterVal ? true : false;
    },
    "regex": function(filterVal, rowVal, rowData, filterParams) {
        if (typeof filterVal == "string") filterVal = new RegExp(filterVal);
        return filterVal.test(rowVal);
    },
    //contains the string
    "like": function(filterVal, rowVal, rowData, filterParams) {
        if (filterVal === null || typeof filterVal === "undefined") return rowVal === filterVal ? true : false;
        else {
            if (typeof rowVal !== "undefined" && rowVal !== null) return String(rowVal).toLowerCase().indexOf(filterVal.toLowerCase()) > -1;
            else return false;
        }
    },
    //contains the keywords
    "keywords": function(filterVal, rowVal, rowData, filterParams) {
        var keywords = filterVal.toLowerCase().split(typeof filterParams.separator === "undefined" ? " " : filterParams.separator), value = String(rowVal === null || typeof rowVal === "undefined" ? "" : rowVal).toLowerCase(), matches = [];
        keywords.forEach((keyword)=>{
            if (value.includes(keyword)) matches.push(true);
        });
        return filterParams.matchAll ? matches.length === keywords.length : !!matches.length;
    },
    //starts with the string
    "starts": function(filterVal, rowVal, rowData, filterParams) {
        if (filterVal === null || typeof filterVal === "undefined") return rowVal === filterVal ? true : false;
        else {
            if (typeof rowVal !== "undefined" && rowVal !== null) return String(rowVal).toLowerCase().startsWith(filterVal.toLowerCase());
            else return false;
        }
    },
    //ends with the string
    "ends": function(filterVal, rowVal, rowData, filterParams) {
        if (filterVal === null || typeof filterVal === "undefined") return rowVal === filterVal ? true : false;
        else {
            if (typeof rowVal !== "undefined" && rowVal !== null) return String(rowVal).toLowerCase().endsWith(filterVal.toLowerCase());
            else return false;
        }
    },
    //in array
    "in": function(filterVal, rowVal, rowData, filterParams) {
        if (Array.isArray(filterVal)) return filterVal.length ? filterVal.indexOf(rowVal) > -1 : true;
        else {
            console.warn("Filter Error - filter value is not an array:", filterVal);
            return false;
        }
    }
};
class $c2a9788f40f9c90a$export$2e3bebbdf3339a4e extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "filter";
    //load defaults
    static filters = $c2a9788f40f9c90a$var$defaultFilters;
    constructor(table){
        super(table);
        this.filterList = []; //hold filter list
        this.headerFilters = {}; //hold column filters
        this.headerFilterColumns = []; //hold columns that use header filters
        this.prevHeaderFilterChangeCheck = "";
        this.prevHeaderFilterChangeCheck = "{}";
        this.changed = false; //has filtering changed since last render
        this.tableInitialized = false;
        this.registerTableOption("filterMode", "local"); //local or remote filtering
        this.registerTableOption("initialFilter", false); //initial filtering criteria
        this.registerTableOption("initialHeaderFilter", false); //initial header filtering criteria
        this.registerTableOption("headerFilterLiveFilterDelay", 300); //delay before updating column after user types in header filter
        this.registerTableOption("placeholderHeaderFilter", false); //placeholder when header filter is empty
        this.registerColumnOption("headerFilter");
        this.registerColumnOption("headerFilterPlaceholder");
        this.registerColumnOption("headerFilterParams");
        this.registerColumnOption("headerFilterEmptyCheck");
        this.registerColumnOption("headerFilterFunc");
        this.registerColumnOption("headerFilterFuncParams");
        this.registerColumnOption("headerFilterLiveFilter");
        this.registerTableFunction("searchRows", this.searchRows.bind(this));
        this.registerTableFunction("searchData", this.searchData.bind(this));
        this.registerTableFunction("setFilter", this.userSetFilter.bind(this));
        this.registerTableFunction("refreshFilter", this.userRefreshFilter.bind(this));
        this.registerTableFunction("addFilter", this.userAddFilter.bind(this));
        this.registerTableFunction("getFilters", this.getFilters.bind(this));
        this.registerTableFunction("setHeaderFilterFocus", this.userSetHeaderFilterFocus.bind(this));
        this.registerTableFunction("getHeaderFilterValue", this.userGetHeaderFilterValue.bind(this));
        this.registerTableFunction("setHeaderFilterValue", this.userSetHeaderFilterValue.bind(this));
        this.registerTableFunction("getHeaderFilters", this.getHeaderFilters.bind(this));
        this.registerTableFunction("removeFilter", this.userRemoveFilter.bind(this));
        this.registerTableFunction("clearFilter", this.userClearFilter.bind(this));
        this.registerTableFunction("clearHeaderFilter", this.userClearHeaderFilter.bind(this));
        this.registerComponentFunction("column", "headerFilterFocus", this.setHeaderFilterFocus.bind(this));
        this.registerComponentFunction("column", "reloadHeaderFilter", this.reloadHeaderFilter.bind(this));
        this.registerComponentFunction("column", "getHeaderFilterValue", this.getHeaderFilterValue.bind(this));
        this.registerComponentFunction("column", "setHeaderFilterValue", this.setHeaderFilterValue.bind(this));
    }
    initialize() {
        this.subscribe("column-init", this.initializeColumnHeaderFilter.bind(this));
        this.subscribe("column-width-fit-before", this.hideHeaderFilterElements.bind(this));
        this.subscribe("column-width-fit-after", this.showHeaderFilterElements.bind(this));
        this.subscribe("table-built", this.tableBuilt.bind(this));
        this.subscribe("placeholder", this.generatePlaceholder.bind(this));
        if (this.table.options.filterMode === "remote") this.subscribe("data-params", this.remoteFilterParams.bind(this));
        this.registerDataHandler(this.filter.bind(this), 10);
    }
    tableBuilt() {
        if (this.table.options.initialFilter) this.setFilter(this.table.options.initialFilter);
        if (this.table.options.initialHeaderFilter) this.table.options.initialHeaderFilter.forEach((item)=>{
            var column = this.table.columnManager.findColumn(item.field);
            if (column) this.setHeaderFilterValue(column, item.value);
            else {
                console.warn("Column Filter Error - No matching column found:", item.field);
                return false;
            }
        });
        this.tableInitialized = true;
    }
    remoteFilterParams(data, config, silent, params) {
        params.filter = this.getFilters(true, true);
        return params;
    }
    generatePlaceholder(text) {
        if (this.table.options.placeholderHeaderFilter && Object.keys(this.headerFilters).length) return this.table.options.placeholderHeaderFilter;
    }
    ///////////////////////////////////
    ///////// Table Functions /////////
    ///////////////////////////////////
    //set standard filters
    userSetFilter(field, type, value, params) {
        this.setFilter(field, type, value, params);
        this.refreshFilter();
    }
    //set standard filters
    userRefreshFilter() {
        this.refreshFilter();
    }
    //add filter to array
    userAddFilter(field, type, value, params) {
        this.addFilter(field, type, value, params);
        this.refreshFilter();
    }
    userSetHeaderFilterFocus(field) {
        var column = this.table.columnManager.findColumn(field);
        if (column) this.setHeaderFilterFocus(column);
        else {
            console.warn("Column Filter Focus Error - No matching column found:", field);
            return false;
        }
    }
    userGetHeaderFilterValue(field) {
        var column = this.table.columnManager.findColumn(field);
        if (column) return this.getHeaderFilterValue(column);
        else console.warn("Column Filter Error - No matching column found:", field);
    }
    userSetHeaderFilterValue(field, value) {
        var column = this.table.columnManager.findColumn(field);
        if (column) this.setHeaderFilterValue(column, value);
        else {
            console.warn("Column Filter Error - No matching column found:", field);
            return false;
        }
    }
    //remove filter from array
    userRemoveFilter(field, type, value) {
        this.removeFilter(field, type, value);
        this.refreshFilter();
    }
    //clear filters
    userClearFilter(all) {
        this.clearFilter(all);
        this.refreshFilter();
    }
    //clear header filters
    userClearHeaderFilter() {
        this.clearHeaderFilter();
        this.refreshFilter();
    }
    //search for specific row components
    searchRows(field, type, value) {
        return this.search("rows", field, type, value);
    }
    //search for specific data
    searchData(field, type, value) {
        return this.search("data", field, type, value);
    }
    ///////////////////////////////////
    ///////// Internal Logic //////////
    ///////////////////////////////////
    initializeColumnHeaderFilter(column) {
        var def = column.definition;
        if (def.headerFilter) this.initializeColumn(column);
    }
    //initialize column header filter
    initializeColumn(column, value) {
        var self = this, field = column.getField();
        //handle successfully value change
        function success(value) {
            var filterType = column.modules.filter.tagType == "input" && column.modules.filter.attrType == "text" || column.modules.filter.tagType == "textarea" ? "partial" : "match", type = "", filterChangeCheck = "", filterFunc;
            if (typeof column.modules.filter.prevSuccess === "undefined" || column.modules.filter.prevSuccess !== value) {
                column.modules.filter.prevSuccess = value;
                if (!column.modules.filter.emptyFunc(value)) {
                    column.modules.filter.value = value;
                    switch(typeof column.definition.headerFilterFunc){
                        case "string":
                            if ($c2a9788f40f9c90a$export$2e3bebbdf3339a4e.filters[column.definition.headerFilterFunc]) {
                                type = column.definition.headerFilterFunc;
                                filterFunc = function(data) {
                                    var params = column.definition.headerFilterFuncParams || {};
                                    var fieldVal = column.getFieldValue(data);
                                    params = typeof params === "function" ? params(value, fieldVal, data) : params;
                                    return $c2a9788f40f9c90a$export$2e3bebbdf3339a4e.filters[column.definition.headerFilterFunc](value, fieldVal, data, params);
                                };
                            } else console.warn("Header Filter Error - Matching filter function not found: ", column.definition.headerFilterFunc);
                            break;
                        case "function":
                            filterFunc = function(data) {
                                var params = column.definition.headerFilterFuncParams || {};
                                var fieldVal = column.getFieldValue(data);
                                params = typeof params === "function" ? params(value, fieldVal, data) : params;
                                return column.definition.headerFilterFunc(value, fieldVal, data, params);
                            };
                            type = filterFunc;
                            break;
                    }
                    if (!filterFunc) switch(filterType){
                        case "partial":
                            filterFunc = function(data) {
                                var colVal = column.getFieldValue(data);
                                if (typeof colVal !== "undefined" && colVal !== null) return String(colVal).toLowerCase().indexOf(String(value).toLowerCase()) > -1;
                                else return false;
                            };
                            type = "like";
                            break;
                        default:
                            filterFunc = function(data) {
                                return column.getFieldValue(data) == value;
                            };
                            type = "=";
                    }
                    self.headerFilters[field] = {
                        value: value,
                        func: filterFunc,
                        type: type
                    };
                } else delete self.headerFilters[field];
                column.modules.filter.value = value;
                filterChangeCheck = JSON.stringify(self.headerFilters);
                if (self.prevHeaderFilterChangeCheck !== filterChangeCheck) {
                    self.prevHeaderFilterChangeCheck = filterChangeCheck;
                    self.trackChanges();
                    self.refreshFilter();
                }
            }
            return true;
        }
        column.modules.filter = {
            success: success,
            attrType: false,
            tagType: false,
            emptyFunc: false
        };
        this.generateHeaderFilterElement(column);
    }
    generateHeaderFilterElement(column, initialValue, reinitialize) {
        var self = this, success = column.modules.filter.success, field = column.getField(), filterElement, editor, editorElement, cellWrapper, typingTimer, searchTrigger, params, onRenderedCallback;
        column.modules.filter.value = initialValue;
        //handle aborted edit
        function cancel() {}
        function onRendered(callback) {
            onRenderedCallback = callback;
        }
        if (column.modules.filter.headerElement && column.modules.filter.headerElement.parentNode) column.contentElement.removeChild(column.modules.filter.headerElement.parentNode);
        if (field) {
            //set empty value function
            column.modules.filter.emptyFunc = column.definition.headerFilterEmptyCheck || function(value) {
                return !value && value !== 0;
            };
            filterElement = document.createElement("div");
            filterElement.classList.add("tabulator-header-filter");
            //set column editor
            switch(typeof column.definition.headerFilter){
                case "string":
                    if (self.table.modules.edit.editors[column.definition.headerFilter]) {
                        editor = self.table.modules.edit.editors[column.definition.headerFilter];
                        if ((column.definition.headerFilter === "tick" || column.definition.headerFilter === "tickCross") && !column.definition.headerFilterEmptyCheck) column.modules.filter.emptyFunc = function(value) {
                            return value !== true && value !== false;
                        };
                    } else console.warn("Filter Error - Cannot build header filter, No such editor found: ", column.definition.editor);
                    break;
                case "function":
                    editor = column.definition.headerFilter;
                    break;
                case "boolean":
                    if (column.modules.edit && column.modules.edit.editor) editor = column.modules.edit.editor;
                    else if (column.definition.formatter && self.table.modules.edit.editors[column.definition.formatter]) {
                        editor = self.table.modules.edit.editors[column.definition.formatter];
                        if ((column.definition.formatter === "tick" || column.definition.formatter === "tickCross") && !column.definition.headerFilterEmptyCheck) column.modules.filter.emptyFunc = function(value) {
                            return value !== true && value !== false;
                        };
                    } else editor = self.table.modules.edit.editors["input"];
                    break;
            }
            if (editor) {
                cellWrapper = {
                    getValue: function() {
                        return typeof initialValue !== "undefined" ? initialValue : "";
                    },
                    getField: function() {
                        return column.definition.field;
                    },
                    getElement: function() {
                        return filterElement;
                    },
                    getColumn: function() {
                        return column.getComponent();
                    },
                    getTable: ()=>{
                        return this.table;
                    },
                    getType: ()=>{
                        return "header";
                    },
                    getRow: function() {
                        return {
                            normalizeHeight: function() {}
                        };
                    }
                };
                params = column.definition.headerFilterParams || {};
                params = typeof params === "function" ? params.call(self.table, cellWrapper) : params;
                editorElement = editor.call(this.table.modules.edit, cellWrapper, onRendered, success, cancel, params);
                if (!editorElement) {
                    console.warn("Filter Error - Cannot add filter to " + field + " column, editor returned a value of false");
                    return;
                }
                if (!(editorElement instanceof Node)) {
                    console.warn("Filter Error - Cannot add filter to " + field + " column, editor should return an instance of Node, the editor returned:", editorElement);
                    return;
                }
                //set Placeholder Text
                self.langBind("headerFilters|columns|" + column.definition.field, function(value) {
                    editorElement.setAttribute("placeholder", typeof value !== "undefined" && value ? value : column.definition.headerFilterPlaceholder || self.langText("headerFilters|default"));
                });
                //focus on element on click
                editorElement.addEventListener("click", function(e) {
                    e.stopPropagation();
                    editorElement.focus();
                });
                editorElement.addEventListener("focus", (e)=>{
                    var left = this.table.columnManager.contentsElement.scrollLeft;
                    var headerPos = this.table.rowManager.element.scrollLeft;
                    if (left !== headerPos) {
                        this.table.rowManager.scrollHorizontal(left);
                        this.table.columnManager.scrollHorizontal(left);
                    }
                });
                //live update filters as user types
                typingTimer = false;
                searchTrigger = function(e) {
                    if (typingTimer) clearTimeout(typingTimer);
                    typingTimer = setTimeout(function() {
                        success(editorElement.value);
                    }, self.table.options.headerFilterLiveFilterDelay);
                };
                column.modules.filter.headerElement = editorElement;
                column.modules.filter.attrType = editorElement.hasAttribute("type") ? editorElement.getAttribute("type").toLowerCase() : "";
                column.modules.filter.tagType = editorElement.tagName.toLowerCase();
                if (column.definition.headerFilterLiveFilter !== false) {
                    if (!(column.definition.headerFilter === "autocomplete" || column.definition.headerFilter === "tickCross" || (column.definition.editor === "autocomplete" || column.definition.editor === "tickCross") && column.definition.headerFilter === true)) {
                        editorElement.addEventListener("keyup", searchTrigger);
                        editorElement.addEventListener("search", searchTrigger);
                        //update number filtered columns on change
                        if (column.modules.filter.attrType == "number") editorElement.addEventListener("change", function(e) {
                            success(editorElement.value);
                        });
                        //change text inputs to search inputs to allow for clearing of field
                        if (column.modules.filter.attrType == "text" && this.table.browser !== "ie") editorElement.setAttribute("type", "search");
                    }
                    //prevent input and select elements from propagating click to column sorters etc
                    if (column.modules.filter.tagType == "input" || column.modules.filter.tagType == "select" || column.modules.filter.tagType == "textarea") editorElement.addEventListener("mousedown", function(e) {
                        e.stopPropagation();
                    });
                }
                filterElement.appendChild(editorElement);
                column.contentElement.appendChild(filterElement);
                if (!reinitialize) self.headerFilterColumns.push(column);
                if (onRenderedCallback) onRenderedCallback();
            }
        } else console.warn("Filter Error - Cannot add header filter, column has no field set:", column.definition.title);
    }
    //hide all header filter elements (used to ensure correct column widths in "fitData" layout mode)
    hideHeaderFilterElements() {
        this.headerFilterColumns.forEach(function(column) {
            if (column.modules.filter && column.modules.filter.headerElement) column.modules.filter.headerElement.style.display = "none";
        });
    }
    //show all header filter elements (used to ensure correct column widths in "fitData" layout mode)
    showHeaderFilterElements() {
        this.headerFilterColumns.forEach(function(column) {
            if (column.modules.filter && column.modules.filter.headerElement) column.modules.filter.headerElement.style.display = "";
        });
    }
    //programmatically set focus of header filter
    setHeaderFilterFocus(column) {
        if (column.modules.filter && column.modules.filter.headerElement) column.modules.filter.headerElement.focus();
        else console.warn("Column Filter Focus Error - No header filter set on column:", column.getField());
    }
    //programmatically get value of header filter
    getHeaderFilterValue(column) {
        if (column.modules.filter && column.modules.filter.headerElement) return column.modules.filter.value;
        else console.warn("Column Filter Error - No header filter set on column:", column.getField());
    }
    //programmatically set value of header filter
    setHeaderFilterValue(column, value) {
        if (column) {
            if (column.modules.filter && column.modules.filter.headerElement) {
                this.generateHeaderFilterElement(column, value, true);
                column.modules.filter.success(value);
            } else console.warn("Column Filter Error - No header filter set on column:", column.getField());
        }
    }
    reloadHeaderFilter(column) {
        if (column) {
            if (column.modules.filter && column.modules.filter.headerElement) this.generateHeaderFilterElement(column, column.modules.filter.value, true);
            else console.warn("Column Filter Error - No header filter set on column:", column.getField());
        }
    }
    refreshFilter() {
        if (this.tableInitialized) {
            if (this.table.options.filterMode === "remote") this.reloadData(null, false, false);
            else this.refreshData(true);
        }
    //TODO - Persist left position of row manager
    // left = this.scrollLeft;
    // this.scrollHorizontal(left);
    }
    //check if the filters has changed since last use
    trackChanges() {
        this.changed = true;
        this.dispatch("filter-changed");
    }
    //check if the filters has changed since last use
    hasChanged() {
        var changed = this.changed;
        this.changed = false;
        return changed;
    }
    //set standard filters
    setFilter(field, type, value, params) {
        this.filterList = [];
        if (!Array.isArray(field)) field = [
            {
                field: field,
                type: type,
                value: value,
                params: params
            }
        ];
        this.addFilter(field);
    }
    //add filter to array
    addFilter(field, type, value, params) {
        var changed = false;
        if (!Array.isArray(field)) field = [
            {
                field: field,
                type: type,
                value: value,
                params: params
            }
        ];
        field.forEach((filter)=>{
            filter = this.findFilter(filter);
            if (filter) {
                this.filterList.push(filter);
                changed = true;
            }
        });
        if (changed) this.trackChanges();
    }
    findFilter(filter) {
        var column;
        if (Array.isArray(filter)) return this.findSubFilters(filter);
        var filterFunc = false;
        if (typeof filter.field == "function") filterFunc = function(data) {
            return filter.field(data, filter.type || {}); // pass params to custom filter function
        };
        else if ($c2a9788f40f9c90a$export$2e3bebbdf3339a4e.filters[filter.type]) {
            column = this.table.columnManager.getColumnByField(filter.field);
            if (column) filterFunc = function(data) {
                return $c2a9788f40f9c90a$export$2e3bebbdf3339a4e.filters[filter.type](filter.value, column.getFieldValue(data), data, filter.params || {});
            };
            else filterFunc = function(data) {
                return $c2a9788f40f9c90a$export$2e3bebbdf3339a4e.filters[filter.type](filter.value, data[filter.field], data, filter.params || {});
            };
        } else console.warn("Filter Error - No such filter type found, ignoring: ", filter.type);
        filter.func = filterFunc;
        return filter.func ? filter : false;
    }
    findSubFilters(filters) {
        var output = [];
        filters.forEach((filter)=>{
            filter = this.findFilter(filter);
            if (filter) output.push(filter);
        });
        return output.length ? output : false;
    }
    //get all filters
    getFilters(all, ajax) {
        var output = [];
        if (all) output = this.getHeaderFilters();
        if (ajax) output.forEach(function(item) {
            if (typeof item.type == "function") item.type = "function";
        });
        output = output.concat(this.filtersToArray(this.filterList, ajax));
        return output;
    }
    //filter to Object
    filtersToArray(filterList, ajax) {
        var output = [];
        filterList.forEach((filter)=>{
            var item;
            if (Array.isArray(filter)) output.push(this.filtersToArray(filter, ajax));
            else {
                item = {
                    field: filter.field,
                    type: filter.type,
                    value: filter.value
                };
                if (ajax) {
                    if (typeof item.type == "function") item.type = "function";
                }
                output.push(item);
            }
        });
        return output;
    }
    //get all filters
    getHeaderFilters() {
        var output = [];
        for(var key in this.headerFilters)output.push({
            field: key,
            type: this.headerFilters[key].type,
            value: this.headerFilters[key].value
        });
        return output;
    }
    //remove filter from array
    removeFilter(field, type, value) {
        if (!Array.isArray(field)) field = [
            {
                field: field,
                type: type,
                value: value
            }
        ];
        field.forEach((filter)=>{
            var index = -1;
            if (typeof filter.field == "object") index = this.filterList.findIndex((element)=>{
                return filter === element;
            });
            else index = this.filterList.findIndex((element)=>{
                return filter.field === element.field && filter.type === element.type && filter.value === element.value;
            });
            if (index > -1) this.filterList.splice(index, 1);
            else console.warn("Filter Error - No matching filter type found, ignoring: ", filter.type);
        });
        this.trackChanges();
    }
    //clear filters
    clearFilter(all) {
        this.filterList = [];
        if (all) this.clearHeaderFilter();
        this.trackChanges();
    }
    //clear header filters
    clearHeaderFilter() {
        this.headerFilters = {};
        this.prevHeaderFilterChangeCheck = "{}";
        this.headerFilterColumns.forEach((column)=>{
            if (typeof column.modules.filter.value !== "undefined") delete column.modules.filter.value;
            column.modules.filter.prevSuccess = undefined;
            this.reloadHeaderFilter(column);
        });
        this.trackChanges();
    }
    //search data and return matching rows
    search(searchType, field, type, value) {
        var activeRows = [], filterList = [];
        if (!Array.isArray(field)) field = [
            {
                field: field,
                type: type,
                value: value
            }
        ];
        field.forEach((filter)=>{
            filter = this.findFilter(filter);
            if (filter) filterList.push(filter);
        });
        this.table.rowManager.rows.forEach((row)=>{
            var match = true;
            filterList.forEach((filter)=>{
                if (!this.filterRecurse(filter, row.getData())) match = false;
            });
            if (match) activeRows.push(searchType === "data" ? row.getData("data") : row.getComponent());
        });
        return activeRows;
    }
    //filter row array
    filter(rowList, filters) {
        var activeRows = [], activeRowComponents = [];
        if (this.subscribedExternal("dataFiltering")) this.dispatchExternal("dataFiltering", this.getFilters(true));
        if (this.table.options.filterMode !== "remote" && (this.filterList.length || Object.keys(this.headerFilters).length)) rowList.forEach((row)=>{
            if (this.filterRow(row)) activeRows.push(row);
        });
        else activeRows = rowList.slice(0);
        if (this.subscribedExternal("dataFiltered")) {
            activeRows.forEach((row)=>{
                activeRowComponents.push(row.getComponent());
            });
            this.dispatchExternal("dataFiltered", this.getFilters(true), activeRowComponents);
        }
        return activeRows;
    }
    //filter individual row
    filterRow(row, filters) {
        var match = true, data = row.getData();
        this.filterList.forEach((filter)=>{
            if (!this.filterRecurse(filter, data)) match = false;
        });
        for(var field in this.headerFilters)if (!this.headerFilters[field].func(data)) match = false;
        return match;
    }
    filterRecurse(filter, data) {
        var match = false;
        if (Array.isArray(filter)) filter.forEach((subFilter)=>{
            if (this.filterRecurse(subFilter, data)) match = true;
        });
        else match = filter.func(data);
        return match;
    }
}
function $c2a9788f40f9c90a$var$plaintext(cell, formatterParams, onRendered) {
    return this.emptyToSpace(this.sanitizeHTML(cell.getValue()));
}
function $c2a9788f40f9c90a$var$html(cell, formatterParams, onRendered) {
    return cell.getValue();
}
function $c2a9788f40f9c90a$var$textarea(cell, formatterParams, onRendered) {
    cell.getElement().style.whiteSpace = "pre-wrap";
    return this.emptyToSpace(this.sanitizeHTML(cell.getValue()));
}
function $c2a9788f40f9c90a$var$money(cell, formatterParams, onRendered) {
    var floatVal = parseFloat(cell.getValue()), sign = "", number, integer, decimal, rgx, value;
    var decimalSym = formatterParams.decimal || ".";
    var thousandSym = formatterParams.thousand || ",";
    var negativeSign = formatterParams.negativeSign || "-";
    var symbol = formatterParams.symbol || "";
    var after = !!formatterParams.symbolAfter;
    var precision = typeof formatterParams.precision !== "undefined" ? formatterParams.precision : 2;
    if (isNaN(floatVal)) return this.emptyToSpace(this.sanitizeHTML(cell.getValue()));
    if (floatVal < 0) {
        floatVal = Math.abs(floatVal);
        sign = negativeSign;
    }
    number = precision !== false ? floatVal.toFixed(precision) : floatVal;
    number = String(number).split(".");
    integer = number[0];
    decimal = number.length > 1 ? decimalSym + number[1] : "";
    if (formatterParams.thousand !== false) {
        rgx = /(\d+)(\d{3})/;
        while(rgx.test(integer))integer = integer.replace(rgx, "$1" + thousandSym + "$2");
    }
    value = integer + decimal;
    if (sign === true) {
        value = "(" + value + ")";
        return after ? value + symbol : symbol + value;
    } else return after ? sign + value + symbol : sign + symbol + value;
}
function $c2a9788f40f9c90a$var$link(cell, formatterParams, onRendered) {
    var value = cell.getValue(), urlPrefix = formatterParams.urlPrefix || "", download = formatterParams.download, label = value, el = document.createElement("a"), data;
    function labelTraverse(path, data) {
        var item = path.shift(), value = data[item];
        if (path.length && typeof value === "object") return labelTraverse(path, value);
        return value;
    }
    if (formatterParams.labelField) {
        data = cell.getData();
        label = labelTraverse(formatterParams.labelField.split(this.table.options.nestedFieldSeparator), data);
    }
    if (formatterParams.label) switch(typeof formatterParams.label){
        case "string":
            label = formatterParams.label;
            break;
        case "function":
            label = formatterParams.label(cell);
            break;
    }
    if (label) {
        if (formatterParams.urlField) {
            data = cell.getData();
            value = $c2a9788f40f9c90a$var$Helpers.retrieveNestedData(this.table.options.nestedFieldSeparator, formatterParams.urlField, data);
        }
        if (formatterParams.url) switch(typeof formatterParams.url){
            case "string":
                value = formatterParams.url;
                break;
            case "function":
                value = formatterParams.url(cell);
                break;
        }
        el.setAttribute("href", urlPrefix + value);
        if (formatterParams.target) el.setAttribute("target", formatterParams.target);
        if (formatterParams.download) {
            if (typeof download == "function") download = download(cell);
            else download = download === true ? "" : download;
            el.setAttribute("download", download);
        }
        el.innerHTML = this.emptyToSpace(this.sanitizeHTML(label));
        return el;
    } else return "&nbsp;";
}
function $c2a9788f40f9c90a$var$image(cell, formatterParams, onRendered) {
    var el = document.createElement("img"), src = cell.getValue();
    if (formatterParams.urlPrefix) src = formatterParams.urlPrefix + cell.getValue();
    if (formatterParams.urlSuffix) src = src + formatterParams.urlSuffix;
    el.setAttribute("src", src);
    switch(typeof formatterParams.height){
        case "number":
            el.style.height = formatterParams.height + "px";
            break;
        case "string":
            el.style.height = formatterParams.height;
            break;
    }
    switch(typeof formatterParams.width){
        case "number":
            el.style.width = formatterParams.width + "px";
            break;
        case "string":
            el.style.width = formatterParams.width;
            break;
    }
    el.addEventListener("load", function() {
        cell.getRow().normalizeHeight();
    });
    return el;
}
function $c2a9788f40f9c90a$var$tickCross(cell, formatterParams, onRendered) {
    var value = cell.getValue(), element = cell.getElement(), empty = formatterParams.allowEmpty, truthy = formatterParams.allowTruthy, trueValueSet = Object.keys(formatterParams).includes("trueValue"), tick = typeof formatterParams.tickElement !== "undefined" ? formatterParams.tickElement : '<svg enable-background="new 0 0 24 24" height="14" width="14" viewBox="0 0 24 24" xml:space="preserve" ><path fill="#2DC214" clip-rule="evenodd" d="M21.652,3.211c-0.293-0.295-0.77-0.295-1.061,0L9.41,14.34  c-0.293,0.297-0.771,0.297-1.062,0L3.449,9.351C3.304,9.203,3.114,9.13,2.923,9.129C2.73,9.128,2.534,9.201,2.387,9.351  l-2.165,1.946C0.078,11.445,0,11.63,0,11.823c0,0.194,0.078,0.397,0.223,0.544l4.94,5.184c0.292,0.296,0.771,0.776,1.062,1.07  l2.124,2.141c0.292,0.293,0.769,0.293,1.062,0l14.366-14.34c0.293-0.294,0.293-0.777,0-1.071L21.652,3.211z" fill-rule="evenodd"/></svg>', cross = typeof formatterParams.crossElement !== "undefined" ? formatterParams.crossElement : '<svg enable-background="new 0 0 24 24" height="14" width="14"  viewBox="0 0 24 24" xml:space="preserve" ><path fill="#CE1515" d="M22.245,4.015c0.313,0.313,0.313,0.826,0,1.139l-6.276,6.27c-0.313,0.312-0.313,0.826,0,1.14l6.273,6.272  c0.313,0.313,0.313,0.826,0,1.14l-2.285,2.277c-0.314,0.312-0.828,0.312-1.142,0l-6.271-6.271c-0.313-0.313-0.828-0.313-1.141,0  l-6.276,6.267c-0.313,0.313-0.828,0.313-1.141,0l-2.282-2.28c-0.313-0.313-0.313-0.826,0-1.14l6.278-6.269  c0.313-0.312,0.313-0.826,0-1.14L1.709,5.147c-0.314-0.313-0.314-0.827,0-1.14l2.284-2.278C4.308,1.417,4.821,1.417,5.135,1.73  L11.405,8c0.314,0.314,0.828,0.314,1.141,0.001l6.276-6.267c0.312-0.312,0.826-0.312,1.141,0L22.245,4.015z"/></svg>';
    if (trueValueSet && value === formatterParams.trueValue || !trueValueSet && (truthy && value || value === true || value === "true" || value === "True" || value === 1 || value === "1")) {
        element.setAttribute("aria-checked", true);
        return tick || "";
    } else if (empty && (value === "null" || value === "" || value === null || typeof value === "undefined")) {
        element.setAttribute("aria-checked", "mixed");
        return "";
    } else {
        element.setAttribute("aria-checked", false);
        return cross || "";
    }
}
function $c2a9788f40f9c90a$var$datetime$1(cell, formatterParams, onRendered) {
    var DT = window.DateTime || luxon.DateTime;
    var inputFormat = formatterParams.inputFormat || "yyyy-MM-dd HH:mm:ss";
    var outputFormat = formatterParams.outputFormat || "dd/MM/yyyy HH:mm:ss";
    var invalid = typeof formatterParams.invalidPlaceholder !== "undefined" ? formatterParams.invalidPlaceholder : "";
    var value = cell.getValue();
    if (typeof DT != "undefined") {
        var newDatetime;
        if (DT.isDateTime(value)) newDatetime = value;
        else if (inputFormat === "iso") newDatetime = DT.fromISO(String(value));
        else newDatetime = DT.fromFormat(String(value), inputFormat);
        if (newDatetime.isValid) {
            if (formatterParams.timezone) newDatetime = newDatetime.setZone(formatterParams.timezone);
            return newDatetime.toFormat(outputFormat);
        } else {
            if (invalid === true || !value) return value;
            else if (typeof invalid === "function") return invalid(value);
            else return invalid;
        }
    } else console.error("Format Error - 'datetime' formatter is dependant on luxon.js");
}
function $c2a9788f40f9c90a$var$datetimediff(cell, formatterParams, onRendered) {
    var DT = window.DateTime || luxon.DateTime;
    var inputFormat = formatterParams.inputFormat || "yyyy-MM-dd HH:mm:ss";
    var invalid = typeof formatterParams.invalidPlaceholder !== "undefined" ? formatterParams.invalidPlaceholder : "";
    var suffix = typeof formatterParams.suffix !== "undefined" ? formatterParams.suffix : false;
    var unit = typeof formatterParams.unit !== "undefined" ? formatterParams.unit : "days";
    var humanize = typeof formatterParams.humanize !== "undefined" ? formatterParams.humanize : false;
    var date = typeof formatterParams.date !== "undefined" ? formatterParams.date : DT.now();
    var value = cell.getValue();
    if (typeof DT != "undefined") {
        var newDatetime;
        if (DT.isDateTime(value)) newDatetime = value;
        else if (inputFormat === "iso") newDatetime = DT.fromISO(String(value));
        else newDatetime = DT.fromFormat(String(value), inputFormat);
        if (newDatetime.isValid) {
            if (humanize) return newDatetime.diff(date, unit).toHuman() + (suffix ? " " + suffix : "");
            else return parseInt(newDatetime.diff(date, unit)[unit]) + (suffix ? " " + suffix : "");
        } else {
            if (invalid === true) return value;
            else if (typeof invalid === "function") return invalid(value);
            else return invalid;
        }
    } else console.error("Format Error - 'datetimediff' formatter is dependant on luxon.js");
}
function $c2a9788f40f9c90a$var$lookup(cell, formatterParams, onRendered) {
    var value = cell.getValue();
    if (typeof formatterParams[value] === "undefined") {
        console.warn("Missing display value for " + value);
        return value;
    }
    return formatterParams[value];
}
function $c2a9788f40f9c90a$var$star(cell, formatterParams, onRendered) {
    var value = cell.getValue(), element = cell.getElement(), maxStars = formatterParams && formatterParams.stars ? formatterParams.stars : 5, stars = document.createElement("span"), star = document.createElementNS("http://www.w3.org/2000/svg", "svg"), starActive = '<polygon fill="#FFEA00" stroke="#C1AB60" stroke-width="37.6152" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" points="259.216,29.942 330.27,173.919 489.16,197.007 374.185,309.08 401.33,467.31 259.216,392.612 117.104,467.31 144.25,309.08 29.274,197.007 188.165,173.919 "/>', starInactive = '<polygon fill="#D2D2D2" stroke="#686868" stroke-width="37.6152" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" points="259.216,29.942 330.27,173.919 489.16,197.007 374.185,309.08 401.33,467.31 259.216,392.612 117.104,467.31 144.25,309.08 29.274,197.007 188.165,173.919 "/>';
    //style stars holder
    stars.style.verticalAlign = "middle";
    //style star
    star.setAttribute("width", "14");
    star.setAttribute("height", "14");
    star.setAttribute("viewBox", "0 0 512 512");
    star.setAttribute("xml:space", "preserve");
    star.style.padding = "0 1px";
    value = value && !isNaN(value) ? parseInt(value) : 0;
    value = Math.max(0, Math.min(value, maxStars));
    for(var i = 1; i <= maxStars; i++){
        var nextStar = star.cloneNode(true);
        nextStar.innerHTML = i <= value ? starActive : starInactive;
        stars.appendChild(nextStar);
    }
    element.style.whiteSpace = "nowrap";
    element.style.overflow = "hidden";
    element.style.textOverflow = "ellipsis";
    element.setAttribute("aria-label", value);
    return stars;
}
function $c2a9788f40f9c90a$var$traffic(cell, formatterParams, onRendered) {
    var value = this.sanitizeHTML(cell.getValue()) || 0, el = document.createElement("span"), max = formatterParams && formatterParams.max ? formatterParams.max : 100, min = formatterParams && formatterParams.min ? formatterParams.min : 0, colors = formatterParams && typeof formatterParams.color !== "undefined" ? formatterParams.color : [
        "red",
        "orange",
        "green"
    ], color = "#666666", percent, percentValue;
    if (isNaN(value) || typeof cell.getValue() === "undefined") return;
    el.classList.add("tabulator-traffic-light");
    //make sure value is in range
    percentValue = parseFloat(value) <= max ? parseFloat(value) : max;
    percentValue = parseFloat(percentValue) >= min ? parseFloat(percentValue) : min;
    //workout percentage
    percent = (max - min) / 100;
    percentValue = Math.round((percentValue - min) / percent);
    //set color
    switch(typeof colors){
        case "string":
            color = colors;
            break;
        case "function":
            color = colors(value);
            break;
        case "object":
            if (Array.isArray(colors)) {
                var unit = 100 / colors.length;
                var index = Math.floor(percentValue / unit);
                index = Math.min(index, colors.length - 1);
                index = Math.max(index, 0);
                color = colors[index];
                break;
            }
    }
    el.style.backgroundColor = color;
    return el;
}
function $c2a9788f40f9c90a$var$progress(cell, formatterParams = {}, onRendered) {
    var value = this.sanitizeHTML(cell.getValue()) || 0, element = cell.getElement(), max = formatterParams.max ? formatterParams.max : 100, min = formatterParams.min ? formatterParams.min : 0, legendAlign = formatterParams.legendAlign ? formatterParams.legendAlign : "center", percent, percentValue, color, legend, legendColor;
    //make sure value is in range
    percentValue = parseFloat(value) <= max ? parseFloat(value) : max;
    percentValue = parseFloat(percentValue) >= min ? parseFloat(percentValue) : min;
    //workout percentage
    percent = (max - min) / 100;
    percentValue = Math.round((percentValue - min) / percent);
    //set bar color
    switch(typeof formatterParams.color){
        case "string":
            color = formatterParams.color;
            break;
        case "function":
            color = formatterParams.color(value);
            break;
        case "object":
            if (Array.isArray(formatterParams.color)) {
                let unit = 100 / formatterParams.color.length;
                let index = Math.floor(percentValue / unit);
                index = Math.min(index, formatterParams.color.length - 1);
                index = Math.max(index, 0);
                color = formatterParams.color[index];
                break;
            }
        default:
            color = "#2DC214";
    }
    //generate legend
    switch(typeof formatterParams.legend){
        case "string":
            legend = formatterParams.legend;
            break;
        case "function":
            legend = formatterParams.legend(value);
            break;
        case "boolean":
            legend = value;
            break;
        default:
            legend = false;
    }
    //set legend color
    switch(typeof formatterParams.legendColor){
        case "string":
            legendColor = formatterParams.legendColor;
            break;
        case "function":
            legendColor = formatterParams.legendColor(value);
            break;
        case "object":
            if (Array.isArray(formatterParams.legendColor)) {
                let unit = 100 / formatterParams.legendColor.length;
                let index = Math.floor(percentValue / unit);
                index = Math.min(index, formatterParams.legendColor.length - 1);
                index = Math.max(index, 0);
                legendColor = formatterParams.legendColor[index];
            }
            break;
        default:
            legendColor = "#000";
    }
    element.style.minWidth = "30px";
    element.style.position = "relative";
    element.setAttribute("aria-label", percentValue);
    var barEl = document.createElement("div");
    barEl.style.display = "inline-block";
    barEl.style.width = percentValue + "%";
    barEl.style.backgroundColor = color;
    barEl.style.height = "100%";
    barEl.setAttribute("data-max", max);
    barEl.setAttribute("data-min", min);
    var barContainer = document.createElement("div");
    barContainer.style.position = "relative";
    barContainer.style.width = "100%";
    barContainer.style.height = "100%";
    if (legend) {
        var legendEl = document.createElement("div");
        legendEl.style.position = "absolute";
        legendEl.style.top = 0;
        legendEl.style.left = 0;
        legendEl.style.textAlign = legendAlign;
        legendEl.style.width = "100%";
        legendEl.style.color = legendColor;
        legendEl.innerHTML = legend;
    }
    onRendered(function() {
        //handle custom element needed if formatter is to be included in printed/downloaded output
        if (!(cell instanceof $c2a9788f40f9c90a$export$1919f52c249c72c9)) {
            var holderEl = document.createElement("div");
            holderEl.style.position = "absolute";
            holderEl.style.top = "4px";
            holderEl.style.bottom = "4px";
            holderEl.style.left = "4px";
            holderEl.style.right = "4px";
            element.appendChild(holderEl);
            element = holderEl;
        }
        element.appendChild(barContainer);
        barContainer.appendChild(barEl);
        if (legend) barContainer.appendChild(legendEl);
    });
    return "";
}
function $c2a9788f40f9c90a$var$color(cell, formatterParams, onRendered) {
    cell.getElement().style.backgroundColor = this.sanitizeHTML(cell.getValue());
    return "";
}
function $c2a9788f40f9c90a$var$buttonTick(cell, formatterParams, onRendered) {
    return '<svg enable-background="new 0 0 24 24" height="14" width="14" viewBox="0 0 24 24" xml:space="preserve" ><path fill="#2DC214" clip-rule="evenodd" d="M21.652,3.211c-0.293-0.295-0.77-0.295-1.061,0L9.41,14.34  c-0.293,0.297-0.771,0.297-1.062,0L3.449,9.351C3.304,9.203,3.114,9.13,2.923,9.129C2.73,9.128,2.534,9.201,2.387,9.351  l-2.165,1.946C0.078,11.445,0,11.63,0,11.823c0,0.194,0.078,0.397,0.223,0.544l4.94,5.184c0.292,0.296,0.771,0.776,1.062,1.07  l2.124,2.141c0.292,0.293,0.769,0.293,1.062,0l14.366-14.34c0.293-0.294,0.293-0.777,0-1.071L21.652,3.211z" fill-rule="evenodd"/></svg>';
}
function $c2a9788f40f9c90a$var$buttonCross(cell, formatterParams, onRendered) {
    return '<svg enable-background="new 0 0 24 24" height="14" width="14" viewBox="0 0 24 24" xml:space="preserve" ><path fill="#CE1515" d="M22.245,4.015c0.313,0.313,0.313,0.826,0,1.139l-6.276,6.27c-0.313,0.312-0.313,0.826,0,1.14l6.273,6.272  c0.313,0.313,0.313,0.826,0,1.14l-2.285,2.277c-0.314,0.312-0.828,0.312-1.142,0l-6.271-6.271c-0.313-0.313-0.828-0.313-1.141,0  l-6.276,6.267c-0.313,0.313-0.828,0.313-1.141,0l-2.282-2.28c-0.313-0.313-0.313-0.826,0-1.14l6.278-6.269  c0.313-0.312,0.313-0.826,0-1.14L1.709,5.147c-0.314-0.313-0.314-0.827,0-1.14l2.284-2.278C4.308,1.417,4.821,1.417,5.135,1.73  L11.405,8c0.314,0.314,0.828,0.314,1.141,0.001l6.276-6.267c0.312-0.312,0.826-0.312,1.141,0L22.245,4.015z"/></svg>';
}
function $c2a9788f40f9c90a$var$toggle(cell, formatterParams, onRendered) {
    var value = cell.getValue(), size = formatterParams.size || 15, sizePx = size + "px", containEl, switchEl, onValue = formatterParams.hasOwnProperty("onValue") ? formatterParams.onValue : true, offValue = formatterParams.hasOwnProperty("offValue") ? formatterParams.offValue : false, state = formatterParams.onTruthy ? value : value === onValue;
    containEl = document.createElement("div");
    containEl.classList.add("tabulator-toggle");
    if (state) {
        containEl.classList.add("tabulator-toggle-on");
        containEl.style.flexDirection = "row-reverse";
        if (formatterParams.onColor) containEl.style.background = formatterParams.onColor;
    } else if (formatterParams.offColor) containEl.style.background = formatterParams.offColor;
    containEl.style.width = 2.5 * size + "px";
    containEl.style.borderRadius = sizePx;
    if (formatterParams.clickable) containEl.addEventListener("click", (e)=>{
        cell.setValue(state ? offValue : onValue);
    });
    switchEl = document.createElement("div");
    switchEl.classList.add("tabulator-toggle-switch");
    switchEl.style.height = sizePx;
    switchEl.style.width = sizePx;
    switchEl.style.borderRadius = sizePx;
    containEl.appendChild(switchEl);
    return containEl;
}
function $c2a9788f40f9c90a$var$rownum(cell, formatterParams, onRendered) {
    var content = document.createElement("span");
    var row = cell.getRow();
    var table = cell.getTable();
    row.watchPosition((position)=>{
        if (formatterParams.relativeToPage) position += table.modules.page.getPageSize() * (table.modules.page.getPage() - 1);
        content.innerText = position;
    });
    return content;
}
function $c2a9788f40f9c90a$var$handle(cell, formatterParams, onRendered) {
    cell.getElement().classList.add("tabulator-row-handle");
    return "<div class='tabulator-row-handle-box'><div class='tabulator-row-handle-bar'></div><div class='tabulator-row-handle-bar'></div><div class='tabulator-row-handle-bar'></div></div>";
}
var $c2a9788f40f9c90a$var$defaultFormatters = {
    plaintext: $c2a9788f40f9c90a$var$plaintext,
    html: $c2a9788f40f9c90a$var$html,
    textarea: $c2a9788f40f9c90a$var$textarea,
    money: $c2a9788f40f9c90a$var$money,
    link: $c2a9788f40f9c90a$var$link,
    image: $c2a9788f40f9c90a$var$image,
    tickCross: $c2a9788f40f9c90a$var$tickCross,
    datetime: $c2a9788f40f9c90a$var$datetime$1,
    datetimediff: $c2a9788f40f9c90a$var$datetimediff,
    lookup: $c2a9788f40f9c90a$var$lookup,
    star: $c2a9788f40f9c90a$var$star,
    traffic: $c2a9788f40f9c90a$var$traffic,
    progress: $c2a9788f40f9c90a$var$progress,
    color: $c2a9788f40f9c90a$var$color,
    buttonTick: $c2a9788f40f9c90a$var$buttonTick,
    buttonCross: $c2a9788f40f9c90a$var$buttonCross,
    toggle: $c2a9788f40f9c90a$var$toggle,
    rownum: $c2a9788f40f9c90a$var$rownum,
    handle: $c2a9788f40f9c90a$var$handle
};
class $c2a9788f40f9c90a$export$5634f967e02d772d extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "format";
    //load defaults
    static formatters = $c2a9788f40f9c90a$var$defaultFormatters;
    constructor(table){
        super(table);
        this.registerColumnOption("formatter");
        this.registerColumnOption("formatterParams");
        this.registerColumnOption("formatterPrint");
        this.registerColumnOption("formatterPrintParams");
        this.registerColumnOption("formatterClipboard");
        this.registerColumnOption("formatterClipboardParams");
        this.registerColumnOption("formatterHtmlOutput");
        this.registerColumnOption("formatterHtmlOutputParams");
        this.registerColumnOption("titleFormatter");
        this.registerColumnOption("titleFormatterParams");
    }
    initialize() {
        this.subscribe("cell-format", this.formatValue.bind(this));
        this.subscribe("cell-rendered", this.cellRendered.bind(this));
        this.subscribe("column-layout", this.initializeColumn.bind(this));
        this.subscribe("column-format", this.formatHeader.bind(this));
    }
    //initialize column formatter
    initializeColumn(column) {
        column.modules.format = this.lookupFormatter(column, "");
        if (typeof column.definition.formatterPrint !== "undefined") column.modules.format.print = this.lookupFormatter(column, "Print");
        if (typeof column.definition.formatterClipboard !== "undefined") column.modules.format.clipboard = this.lookupFormatter(column, "Clipboard");
        if (typeof column.definition.formatterHtmlOutput !== "undefined") column.modules.format.htmlOutput = this.lookupFormatter(column, "HtmlOutput");
    }
    lookupFormatter(column, type) {
        var config = {
            params: column.definition["formatter" + type + "Params"] || {}
        }, formatter = column.definition["formatter" + type];
        //set column formatter
        switch(typeof formatter){
            case "string":
                if ($c2a9788f40f9c90a$export$5634f967e02d772d.formatters[formatter]) config.formatter = $c2a9788f40f9c90a$export$5634f967e02d772d.formatters[formatter];
                else {
                    console.warn("Formatter Error - No such formatter found: ", formatter);
                    config.formatter = $c2a9788f40f9c90a$export$5634f967e02d772d.formatters.plaintext;
                }
                break;
            case "function":
                config.formatter = formatter;
                break;
            default:
                config.formatter = $c2a9788f40f9c90a$export$5634f967e02d772d.formatters.plaintext;
                break;
        }
        return config;
    }
    cellRendered(cell) {
        if (cell.modules.format && cell.modules.format.renderedCallback && !cell.modules.format.rendered) {
            cell.modules.format.renderedCallback();
            cell.modules.format.rendered = true;
        }
    }
    //return a formatted value for a column header
    formatHeader(column, title, el) {
        var formatter, params, onRendered, mockCell;
        if (column.definition.titleFormatter) {
            formatter = this.getFormatter(column.definition.titleFormatter);
            onRendered = (callback)=>{
                column.titleFormatterRendered = callback;
            };
            mockCell = {
                getValue: function() {
                    return title;
                },
                getElement: function() {
                    return el;
                },
                getType: function() {
                    return "header";
                },
                getColumn: function() {
                    return column.getComponent();
                },
                getTable: ()=>{
                    return this.table;
                }
            };
            params = column.definition.titleFormatterParams || {};
            params = typeof params === "function" ? params() : params;
            return formatter.call(this, mockCell, params, onRendered);
        } else return title;
    }
    //return a formatted value for a cell
    formatValue(cell) {
        var component = cell.getComponent(), params = typeof cell.column.modules.format.params === "function" ? cell.column.modules.format.params(component) : cell.column.modules.format.params;
        function onRendered(callback) {
            if (!cell.modules.format) cell.modules.format = {};
            cell.modules.format.renderedCallback = callback;
            cell.modules.format.rendered = false;
        }
        return cell.column.modules.format.formatter.call(this, component, params, onRendered);
    }
    formatExportValue(cell, type) {
        var formatter = cell.column.modules.format[type], params;
        if (formatter) {
            params = typeof formatter.params === "function" ? formatter.params(cell.getComponent()) : formatter.params;
            function onRendered(callback) {
                if (!cell.modules.format) cell.modules.format = {};
                cell.modules.format.renderedCallback = callback;
                cell.modules.format.rendered = false;
            }
            return formatter.formatter.call(this, cell.getComponent(), params, onRendered);
        } else return this.formatValue(cell);
    }
    sanitizeHTML(value) {
        if (value) {
            var entityMap = {
                "&": "&amp;",
                "<": "&lt;",
                ">": "&gt;",
                '"': "&quot;",
                "'": "&#39;",
                "/": "&#x2F;",
                "`": "&#x60;",
                "=": "&#x3D;"
            };
            return String(value).replace(/[&<>"'`=/]/g, function(s) {
                return entityMap[s];
            });
        } else return value;
    }
    emptyToSpace(value) {
        return value === null || typeof value === "undefined" || value === "" ? "&nbsp;" : value;
    }
    //get formatter for cell
    getFormatter(formatter) {
        switch(typeof formatter){
            case "string":
                if ($c2a9788f40f9c90a$export$5634f967e02d772d.formatters[formatter]) formatter = $c2a9788f40f9c90a$export$5634f967e02d772d.formatters[formatter];
                else {
                    console.warn("Formatter Error - No such formatter found: ", formatter);
                    formatter = $c2a9788f40f9c90a$export$5634f967e02d772d.formatters.plaintext;
                }
                break;
            case "function":
                break;
            default:
                formatter = $c2a9788f40f9c90a$export$5634f967e02d772d.formatters.plaintext;
                break;
        }
        return formatter;
    }
}
class $c2a9788f40f9c90a$export$c00c4e95a253fbf9 extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "frozenColumns";
    constructor(table){
        super(table);
        this.leftColumns = [];
        this.rightColumns = [];
        this.initializationMode = "left";
        this.active = false;
        this.blocked = true;
        this.registerColumnOption("frozen");
    }
    //reset initial state
    reset() {
        this.initializationMode = "left";
        this.leftColumns = [];
        this.rightColumns = [];
        this.active = false;
    }
    initialize() {
        this.subscribe("cell-layout", this.layoutCell.bind(this));
        this.subscribe("column-init", this.initializeColumn.bind(this));
        this.subscribe("column-width", this.layout.bind(this));
        this.subscribe("row-layout-after", this.layoutRow.bind(this));
        this.subscribe("table-layout", this.layout.bind(this));
        this.subscribe("columns-loading", this.reset.bind(this));
        this.subscribe("column-add", this.reinitializeColumns.bind(this));
        this.subscribe("column-deleted", this.reinitializeColumns.bind(this));
        this.subscribe("column-hide", this.reinitializeColumns.bind(this));
        this.subscribe("column-show", this.reinitializeColumns.bind(this));
        this.subscribe("columns-loaded", this.reinitializeColumns.bind(this));
        this.subscribe("table-redraw", this.layout.bind(this));
        this.subscribe("layout-refreshing", this.blockLayout.bind(this));
        this.subscribe("layout-refreshed", this.unblockLayout.bind(this));
        this.subscribe("scrollbar-vertical", this.adjustForScrollbar.bind(this));
    }
    blockLayout() {
        this.blocked = true;
    }
    unblockLayout() {
        this.blocked = false;
    }
    layoutCell(cell) {
        this.layoutElement(cell.element, cell.column);
    }
    reinitializeColumns() {
        this.reset();
        this.table.columnManager.columnsByIndex.forEach((column)=>{
            this.initializeColumn(column);
        });
        this.layout();
    }
    //initialize specific column
    initializeColumn(column) {
        var config = {
            margin: 0,
            edge: false
        };
        if (!column.isGroup) {
            if (this.frozenCheck(column)) {
                config.position = this.initializationMode;
                if (this.initializationMode == "left") this.leftColumns.push(column);
                else this.rightColumns.unshift(column);
                this.active = true;
                column.modules.frozen = config;
            } else this.initializationMode = "right";
        }
    }
    frozenCheck(column) {
        if (column.parent.isGroup && column.definition.frozen) console.warn("Frozen Column Error - Parent column group must be frozen, not individual columns or sub column groups");
        if (column.parent.isGroup) return this.frozenCheck(column.parent);
        else return column.definition.frozen;
    }
    //layout calculation rows
    layoutCalcRows() {
        if (this.table.modExists("columnCalcs")) {
            if (this.table.modules.columnCalcs.topInitialized && this.table.modules.columnCalcs.topRow) this.layoutRow(this.table.modules.columnCalcs.topRow);
            if (this.table.modules.columnCalcs.botInitialized && this.table.modules.columnCalcs.botRow) this.layoutRow(this.table.modules.columnCalcs.botRow);
            if (this.table.modExists("groupRows")) this.layoutGroupCalcs(this.table.modules.groupRows.getGroups());
        }
    }
    layoutGroupCalcs(groups) {
        groups.forEach((group)=>{
            if (group.calcs.top) this.layoutRow(group.calcs.top);
            if (group.calcs.bottom) this.layoutRow(group.calcs.bottom);
            if (group.groupList && group.groupList.length) this.layoutGroupCalcs(group.groupList);
        });
    }
    //calculate column positions and layout headers
    layoutColumnPosition(allCells) {
        var leftParents = [];
        var leftMargin = 0;
        var rightMargin = 0;
        this.leftColumns.forEach((column, i)=>{
            column.modules.frozen.marginValue = leftMargin;
            column.modules.frozen.margin = column.modules.frozen.marginValue + "px";
            if (column.visible) leftMargin += column.getWidth();
            if (i == this.leftColumns.length - 1) column.modules.frozen.edge = true;
            else column.modules.frozen.edge = false;
            if (column.parent.isGroup) {
                var parentEl = this.getColGroupParentElement(column);
                if (!leftParents.includes(parentEl)) {
                    this.layoutElement(parentEl, column);
                    leftParents.push(parentEl);
                }
                parentEl.classList.toggle("tabulator-frozen-left", column.modules.frozen.edge && column.modules.frozen.position === "left");
                parentEl.classList.toggle("tabulator-frozen-right", column.modules.frozen.edge && column.modules.frozen.position === "right");
            } else this.layoutElement(column.getElement(), column);
            if (allCells) column.cells.forEach((cell)=>{
                this.layoutElement(cell.getElement(true), column);
            });
        });
        this.rightColumns.forEach((column, i)=>{
            column.modules.frozen.marginValue = rightMargin;
            column.modules.frozen.margin = column.modules.frozen.marginValue + "px";
            if (column.visible) rightMargin += column.getWidth();
            if (i == this.rightColumns.length - 1) column.modules.frozen.edge = true;
            else column.modules.frozen.edge = false;
            if (column.parent.isGroup) this.layoutElement(this.getColGroupParentElement(column), column);
            else this.layoutElement(column.getElement(), column);
            if (allCells) column.cells.forEach((cell)=>{
                this.layoutElement(cell.getElement(true), column);
            });
        });
    }
    getColGroupParentElement(column) {
        return column.parent.isGroup ? this.getColGroupParentElement(column.parent) : column.getElement();
    }
    //layout columns appropriately
    layout() {
        if (this.active && !this.blocked) {
            //calculate left columns
            this.layoutColumnPosition();
            this.reinitializeRows();
            this.layoutCalcRows();
        }
    }
    reinitializeRows() {
        var visibleRows = this.table.rowManager.getVisibleRows(true);
        var otherRows = this.table.rowManager.getRows().filter((row)=>!visibleRows.includes(row));
        otherRows.forEach((row)=>{
            row.deinitialize();
        });
        visibleRows.forEach((row)=>{
            if (row.type === "row") this.layoutRow(row);
        });
    }
    layoutRow(row) {
        if (this.table.options.layout === "fitDataFill" && this.rightColumns.length) this.table.rowManager.getTableElement().style.minWidth = "calc(100% - " + this.rightMargin + ")";
        this.leftColumns.forEach((column)=>{
            var cell = row.getCell(column);
            if (cell) this.layoutElement(cell.getElement(true), column);
        });
        this.rightColumns.forEach((column)=>{
            var cell = row.getCell(column);
            if (cell) this.layoutElement(cell.getElement(true), column);
        });
    }
    layoutElement(element, column) {
        var position;
        if (column.modules.frozen && element) {
            element.style.position = "sticky";
            if (this.table.rtl) position = column.modules.frozen.position === "left" ? "right" : "left";
            else position = column.modules.frozen.position;
            element.style[position] = column.modules.frozen.margin;
            element.classList.add("tabulator-frozen");
            element.classList.toggle("tabulator-frozen-left", column.modules.frozen.edge && column.modules.frozen.position === "left");
            element.classList.toggle("tabulator-frozen-right", column.modules.frozen.edge && column.modules.frozen.position === "right");
        }
    }
    adjustForScrollbar(width) {
        if (this.rightColumns.length) this.table.columnManager.getContentsElement().style.width = "calc(100% - " + width + "px)";
    }
    getFrozenColumns() {
        return this.leftColumns.concat(this.rightColumns);
    }
    _calcSpace(columns, index) {
        var width = 0;
        for(let i = 0; i < index; i++)if (columns[i].visible) width += columns[i].getWidth();
        return width;
    }
}
class $c2a9788f40f9c90a$export$6e51ce5331c5fffa extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "frozenRows";
    constructor(table){
        super(table);
        this.topElement = document.createElement("div");
        this.rows = [];
        //register component functions
        this.registerComponentFunction("row", "freeze", this.freezeRow.bind(this));
        this.registerComponentFunction("row", "unfreeze", this.unfreezeRow.bind(this));
        this.registerComponentFunction("row", "isFrozen", this.isRowFrozen.bind(this));
        //register table options
        this.registerTableOption("frozenRowsField", "id"); //field to choose frozen rows by
        this.registerTableOption("frozenRows", false); //holder for frozen row identifiers
    }
    initialize() {
        var fragment = document.createDocumentFragment();
        this.rows = [];
        this.topElement.classList.add("tabulator-frozen-rows-holder");
        fragment.appendChild(document.createElement("br"));
        fragment.appendChild(this.topElement);
        // this.table.columnManager.element.append(this.topElement);
        this.table.columnManager.getContentsElement().insertBefore(fragment, this.table.columnManager.headersElement.nextSibling);
        this.subscribe("row-deleting", this.detachRow.bind(this));
        this.subscribe("rows-visible", this.visibleRows.bind(this));
        this.registerDisplayHandler(this.getRows.bind(this), 10);
        if (this.table.options.frozenRows) {
            this.subscribe("data-processed", this.initializeRows.bind(this));
            this.subscribe("row-added", this.initializeRow.bind(this));
            this.subscribe("table-redrawing", this.resizeHolderWidth.bind(this));
            this.subscribe("column-resized", this.resizeHolderWidth.bind(this));
            this.subscribe("column-show", this.resizeHolderWidth.bind(this));
            this.subscribe("column-hide", this.resizeHolderWidth.bind(this));
        }
        this.resizeHolderWidth();
    }
    resizeHolderWidth() {
        this.topElement.style.minWidth = this.table.columnManager.headersElement.offsetWidth + "px";
    }
    initializeRows() {
        this.table.rowManager.getRows().forEach((row)=>{
            this.initializeRow(row);
        });
    }
    initializeRow(row) {
        var frozenRows = this.table.options.frozenRows, rowType = typeof frozenRows;
        if (rowType === "number") {
            if (row.getPosition() && row.getPosition() + this.rows.length <= frozenRows) this.freezeRow(row);
        } else if (rowType === "function") {
            if (frozenRows.call(this.table, row.getComponent())) this.freezeRow(row);
        } else if (Array.isArray(frozenRows)) {
            if (frozenRows.includes(row.data[this.options("frozenRowsField")])) this.freezeRow(row);
        }
    }
    isRowFrozen(row) {
        var index = this.rows.indexOf(row);
        return index > -1;
    }
    isFrozen() {
        return !!this.rows.length;
    }
    visibleRows(viewable, rows) {
        this.rows.forEach((row)=>{
            rows.push(row);
        });
        return rows;
    }
    //filter frozen rows out of display data
    getRows(rows) {
        var output = rows.slice(0);
        this.rows.forEach(function(row) {
            var index = output.indexOf(row);
            if (index > -1) output.splice(index, 1);
        });
        return output;
    }
    freezeRow(row) {
        if (!row.modules.frozen) {
            row.modules.frozen = true;
            this.topElement.appendChild(row.getElement());
            row.initialize();
            row.normalizeHeight();
            this.rows.push(row);
            this.refreshData(false, "display");
            this.table.rowManager.adjustTableSize();
            this.styleRows();
        } else console.warn("Freeze Error - Row is already frozen");
    }
    unfreezeRow(row) {
        if (row.modules.frozen) {
            row.modules.frozen = false;
            this.detachRow(row);
            this.table.rowManager.adjustTableSize();
            this.refreshData(false, "display");
            if (this.rows.length) this.styleRows();
        } else console.warn("Freeze Error - Row is already unfrozen");
    }
    detachRow(row) {
        var index = this.rows.indexOf(row);
        if (index > -1) {
            var rowEl = row.getElement();
            if (rowEl.parentNode) rowEl.parentNode.removeChild(rowEl);
            this.rows.splice(index, 1);
        }
    }
    styleRows(row) {
        this.rows.forEach((row, i)=>{
            this.table.rowManager.styleRow(row, i);
        });
    }
}
//public group object
class $c2a9788f40f9c90a$export$450247cd99a94b80 {
    constructor(group){
        this._group = group;
        this.type = "GroupComponent";
        return new Proxy(this, {
            get: function(target, name, receiver) {
                if (typeof target[name] !== "undefined") return target[name];
                else return target._group.groupManager.table.componentFunctionBinder.handle("group", target._group, name);
            }
        });
    }
    getKey() {
        return this._group.key;
    }
    getField() {
        return this._group.field;
    }
    getElement() {
        return this._group.element;
    }
    getRows() {
        return this._group.getRows(true);
    }
    getSubGroups() {
        return this._group.getSubGroups(true);
    }
    getParentGroup() {
        return this._group.parent ? this._group.parent.getComponent() : false;
    }
    isVisible() {
        return this._group.visible;
    }
    show() {
        this._group.show();
    }
    hide() {
        this._group.hide();
    }
    toggle() {
        this._group.toggleVisibility();
    }
    scrollTo(position, ifVisible) {
        return this._group.groupManager.table.rowManager.scrollToRow(this._group, position, ifVisible);
    }
    _getSelf() {
        return this._group;
    }
    getTable() {
        return this._group.groupManager.table;
    }
}
//Group functions
class $c2a9788f40f9c90a$var$Group {
    constructor(groupManager, parent, level, key, field, generator, oldGroup){
        this.groupManager = groupManager;
        this.parent = parent;
        this.key = key;
        this.level = level;
        this.field = field;
        this.hasSubGroups = level < groupManager.groupIDLookups.length - 1;
        this.addRow = this.hasSubGroups ? this._addRowToGroup : this._addRow;
        this.type = "group"; //type of element
        this.old = oldGroup;
        this.rows = [];
        this.groups = [];
        this.groupList = [];
        this.generator = generator;
        this.element = false;
        this.elementContents = false;
        this.height = 0;
        this.outerHeight = 0;
        this.initialized = false;
        this.calcs = {};
        this.initialized = false;
        this.modules = {};
        this.arrowElement = false;
        this.visible = oldGroup ? oldGroup.visible : typeof groupManager.startOpen[level] !== "undefined" ? groupManager.startOpen[level] : groupManager.startOpen[0];
        this.component = null;
        this.createElements();
        this.addBindings();
        this.createValueGroups();
    }
    wipe(elementsOnly) {
        if (!elementsOnly) {
            if (this.groupList.length) this.groupList.forEach(function(group) {
                group.wipe();
            });
            else this.rows.forEach((row)=>{
                if (row.modules) delete row.modules.group;
            });
        }
        this.element = false;
        this.arrowElement = false;
        this.elementContents = false;
    }
    createElements() {
        var arrow = document.createElement("div");
        arrow.classList.add("tabulator-arrow");
        this.element = document.createElement("div");
        this.element.classList.add("tabulator-row");
        this.element.classList.add("tabulator-group");
        this.element.classList.add("tabulator-group-level-" + this.level);
        this.element.setAttribute("role", "rowgroup");
        this.arrowElement = document.createElement("div");
        this.arrowElement.classList.add("tabulator-group-toggle");
        this.arrowElement.appendChild(arrow);
        //setup movable rows
        if (this.groupManager.table.options.movableRows !== false && this.groupManager.table.modExists("moveRow")) this.groupManager.table.modules.moveRow.initializeGroupHeader(this);
    }
    createValueGroups() {
        var level = this.level + 1;
        if (this.groupManager.allowedValues && this.groupManager.allowedValues[level]) this.groupManager.allowedValues[level].forEach((value)=>{
            this._createGroup(value, level);
        });
    }
    addBindings() {
        var toggleElement;
        if (this.groupManager.table.options.groupToggleElement) {
            toggleElement = this.groupManager.table.options.groupToggleElement == "arrow" ? this.arrowElement : this.element;
            toggleElement.addEventListener("click", (e)=>{
                if (this.groupManager.table.options.groupToggleElement === "arrow") {
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                }
                //allow click event to propagate before toggling visibility
                setTimeout(()=>{
                    this.toggleVisibility();
                });
            });
        }
    }
    _createGroup(groupID, level) {
        var groupKey = level + "_" + groupID;
        var group = new $c2a9788f40f9c90a$var$Group(this.groupManager, this, level, groupID, this.groupManager.groupIDLookups[level].field, this.groupManager.headerGenerator[level] || this.groupManager.headerGenerator[0], this.old ? this.old.groups[groupKey] : false);
        this.groups[groupKey] = group;
        this.groupList.push(group);
    }
    _addRowToGroup(row) {
        var level = this.level + 1;
        if (this.hasSubGroups) {
            var groupID = this.groupManager.groupIDLookups[level].func(row.getData()), groupKey = level + "_" + groupID;
            if (this.groupManager.allowedValues && this.groupManager.allowedValues[level]) {
                if (this.groups[groupKey]) this.groups[groupKey].addRow(row);
            } else {
                if (!this.groups[groupKey]) this._createGroup(groupID, level);
                this.groups[groupKey].addRow(row);
            }
        }
    }
    _addRow(row) {
        this.rows.push(row);
        row.modules.group = this;
    }
    insertRow(row, to, after) {
        var data = this.conformRowData({});
        row.updateData(data);
        var toIndex = this.rows.indexOf(to);
        if (toIndex > -1) {
            if (after) this.rows.splice(toIndex + 1, 0, row);
            else this.rows.splice(toIndex, 0, row);
        } else if (after) this.rows.push(row);
        else this.rows.unshift(row);
        row.modules.group = this;
        // this.generateGroupHeaderContents();
        if (this.groupManager.table.modExists("columnCalcs") && this.groupManager.table.options.columnCalcs != "table") this.groupManager.table.modules.columnCalcs.recalcGroup(this);
        this.groupManager.updateGroupRows(true);
    }
    scrollHeader(left) {
        if (this.arrowElement) {
            this.arrowElement.style.marginLeft = left;
            this.groupList.forEach(function(child) {
                child.scrollHeader(left);
            });
        }
    }
    getRowIndex(row) {}
    //update row data to match grouping constraints
    conformRowData(data) {
        if (this.field) data[this.field] = this.key;
        else console.warn("Data Conforming Error - Cannot conform row data to match new group as groupBy is a function");
        if (this.parent) data = this.parent.conformRowData(data);
        return data;
    }
    removeRow(row) {
        var index = this.rows.indexOf(row);
        var el = row.getElement();
        if (index > -1) this.rows.splice(index, 1);
        if (!this.groupManager.table.options.groupValues && !this.rows.length) {
            if (this.parent) this.parent.removeGroup(this);
            else this.groupManager.removeGroup(this);
            this.groupManager.updateGroupRows(true);
        } else {
            if (el.parentNode) el.parentNode.removeChild(el);
            if (!this.groupManager.blockRedraw) {
                this.generateGroupHeaderContents();
                if (this.groupManager.table.modExists("columnCalcs") && this.groupManager.table.options.columnCalcs != "table") this.groupManager.table.modules.columnCalcs.recalcGroup(this);
            }
        }
    }
    removeGroup(group) {
        var groupKey = group.level + "_" + group.key, index;
        if (this.groups[groupKey]) {
            delete this.groups[groupKey];
            index = this.groupList.indexOf(group);
            if (index > -1) this.groupList.splice(index, 1);
            if (!this.groupList.length) {
                if (this.parent) this.parent.removeGroup(this);
                else this.groupManager.removeGroup(this);
            }
        }
    }
    getHeadersAndRows() {
        var output = [];
        output.push(this);
        this._visSet();
        if (this.calcs.top) {
            this.calcs.top.detachElement();
            this.calcs.top.deleteCells();
        }
        if (this.calcs.bottom) {
            this.calcs.bottom.detachElement();
            this.calcs.bottom.deleteCells();
        }
        if (this.visible) {
            if (this.groupList.length) this.groupList.forEach(function(group) {
                output = output.concat(group.getHeadersAndRows());
            });
            else {
                if (this.groupManager.table.options.columnCalcs != "table" && this.groupManager.table.modExists("columnCalcs") && this.groupManager.table.modules.columnCalcs.hasTopCalcs()) {
                    this.calcs.top = this.groupManager.table.modules.columnCalcs.generateTopRow(this.rows);
                    output.push(this.calcs.top);
                }
                output = output.concat(this.rows);
                if (this.groupManager.table.options.columnCalcs != "table" && this.groupManager.table.modExists("columnCalcs") && this.groupManager.table.modules.columnCalcs.hasBottomCalcs()) {
                    this.calcs.bottom = this.groupManager.table.modules.columnCalcs.generateBottomRow(this.rows);
                    output.push(this.calcs.bottom);
                }
            }
        } else {
            if (!this.groupList.length && this.groupManager.table.options.columnCalcs != "table") {
                if (this.groupManager.table.modExists("columnCalcs")) {
                    if (this.groupManager.table.modules.columnCalcs.hasTopCalcs()) {
                        if (this.groupManager.table.options.groupClosedShowCalcs) {
                            this.calcs.top = this.groupManager.table.modules.columnCalcs.generateTopRow(this.rows);
                            output.push(this.calcs.top);
                        }
                    }
                    if (this.groupManager.table.modules.columnCalcs.hasBottomCalcs()) {
                        if (this.groupManager.table.options.groupClosedShowCalcs) {
                            this.calcs.bottom = this.groupManager.table.modules.columnCalcs.generateBottomRow(this.rows);
                            output.push(this.calcs.bottom);
                        }
                    }
                }
            }
        }
        return output;
    }
    getData(visible, transform) {
        var output = [];
        this._visSet();
        if (!visible || visible && this.visible) this.rows.forEach((row)=>{
            output.push(row.getData(transform || "data"));
        });
        return output;
    }
    getRowCount() {
        var count = 0;
        if (this.groupList.length) this.groupList.forEach((group)=>{
            count += group.getRowCount();
        });
        else count = this.rows.length;
        return count;
    }
    toggleVisibility() {
        if (this.visible) this.hide();
        else this.show();
    }
    hide() {
        this.visible = false;
        if (this.groupManager.table.rowManager.getRenderMode() == "basic" && !this.groupManager.table.options.pagination) {
            this.element.classList.remove("tabulator-group-visible");
            if (this.groupList.length) this.groupList.forEach((group)=>{
                var rows = group.getHeadersAndRows();
                rows.forEach((row)=>{
                    row.detachElement();
                });
            });
            else this.rows.forEach((row)=>{
                var rowEl = row.getElement();
                rowEl.parentNode.removeChild(rowEl);
            });
            this.groupManager.updateGroupRows(true);
        } else this.groupManager.updateGroupRows(true);
        this.groupManager.table.externalEvents.dispatch("groupVisibilityChanged", this.getComponent(), false);
    }
    show() {
        this.visible = true;
        if (this.groupManager.table.rowManager.getRenderMode() == "basic" && !this.groupManager.table.options.pagination) {
            this.element.classList.add("tabulator-group-visible");
            var prev = this.generateElement();
            if (this.groupList.length) this.groupList.forEach((group)=>{
                var rows = group.getHeadersAndRows();
                rows.forEach((row)=>{
                    var rowEl = row.getElement();
                    prev.parentNode.insertBefore(rowEl, prev.nextSibling);
                    row.initialize();
                    prev = rowEl;
                });
            });
            else this.rows.forEach((row)=>{
                var rowEl = row.getElement();
                prev.parentNode.insertBefore(rowEl, prev.nextSibling);
                row.initialize();
                prev = rowEl;
            });
            this.groupManager.updateGroupRows(true);
        } else this.groupManager.updateGroupRows(true);
        this.groupManager.table.externalEvents.dispatch("groupVisibilityChanged", this.getComponent(), true);
    }
    _visSet() {
        var data = [];
        if (typeof this.visible == "function") {
            this.rows.forEach(function(row) {
                data.push(row.getData());
            });
            this.visible = this.visible(this.key, this.getRowCount(), data, this.getComponent());
        }
    }
    getRowGroup(row) {
        var match = false;
        if (this.groupList.length) this.groupList.forEach(function(group) {
            var result = group.getRowGroup(row);
            if (result) match = result;
        });
        else if (this.rows.find(function(item) {
            return item === row;
        })) match = this;
        return match;
    }
    getSubGroups(component) {
        var output = [];
        this.groupList.forEach(function(child) {
            output.push(component ? child.getComponent() : child);
        });
        return output;
    }
    getRows(component, includeChildren) {
        var output = [];
        if (includeChildren && this.groupList.length) this.groupList.forEach((group)=>{
            output = output.concat(group.getRows(component, includeChildren));
        });
        else this.rows.forEach(function(row) {
            output.push(component ? row.getComponent() : row);
        });
        return output;
    }
    generateGroupHeaderContents() {
        var data = [];
        var rows = this.getRows(false, true);
        rows.forEach(function(row) {
            data.push(row.getData());
        });
        this.elementContents = this.generator(this.key, this.getRowCount(), data, this.getComponent());
        while(this.element.firstChild)this.element.removeChild(this.element.firstChild);
        if (typeof this.elementContents === "string") this.element.innerHTML = this.elementContents;
        else this.element.appendChild(this.elementContents);
        this.element.insertBefore(this.arrowElement, this.element.firstChild);
    }
    getPath(path = []) {
        path.unshift(this.key);
        if (this.parent) this.parent.getPath(path);
        return path;
    }
    ////////////// Standard Row Functions //////////////
    getElement() {
        return this.elementContents ? this.element : this.generateElement();
    }
    generateElement() {
        this.addBindings = false;
        this._visSet();
        if (this.visible) this.element.classList.add("tabulator-group-visible");
        else this.element.classList.remove("tabulator-group-visible");
        for(var i = 0; i < this.element.childNodes.length; ++i)this.element.childNodes[i].parentNode.removeChild(this.element.childNodes[i]);
        this.generateGroupHeaderContents();
        // this.addBindings();
        return this.element;
    }
    detachElement() {
        if (this.element && this.element.parentNode) this.element.parentNode.removeChild(this.element);
    }
    //normalize the height of elements in the row
    normalizeHeight() {
        this.setHeight(this.element.clientHeight);
    }
    initialize(force) {
        if (!this.initialized || force) {
            this.normalizeHeight();
            this.initialized = true;
        }
    }
    reinitialize() {
        this.initialized = false;
        this.height = 0;
        if ($c2a9788f40f9c90a$var$Helpers.elVisible(this.element)) this.initialize(true);
    }
    setHeight(height) {
        if (this.height != height) {
            this.height = height;
            this.outerHeight = this.element.offsetHeight;
        }
    }
    //return rows outer height
    getHeight() {
        return this.outerHeight;
    }
    getGroup() {
        return this;
    }
    reinitializeHeight() {}
    calcHeight() {}
    setCellHeight() {}
    clearCellHeight() {}
    deinitializeHeight() {}
    rendered() {}
    //////////////// Object Generation /////////////////
    getComponent() {
        if (!this.component) this.component = new $c2a9788f40f9c90a$export$450247cd99a94b80(this);
        return this.component;
    }
}
class $c2a9788f40f9c90a$export$41e6b6ec902cbe0a extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "groupRows";
    constructor(table){
        super(table);
        this.groupIDLookups = false; //enable table grouping and set field to group by
        this.startOpen = [
            function() {
                return false;
            }
        ]; //starting state of group
        this.headerGenerator = [
            function() {
                return "";
            }
        ];
        this.groupList = []; //ordered list of groups
        this.allowedValues = false;
        this.groups = {}; //hold row groups
        this.displayHandler = this.getRows.bind(this);
        this.blockRedraw = false;
        //register table options
        this.registerTableOption("groupBy", false); //enable table grouping and set field to group by
        this.registerTableOption("groupStartOpen", true); //starting state of group
        this.registerTableOption("groupValues", false);
        this.registerTableOption("groupUpdateOnCellEdit", false);
        this.registerTableOption("groupHeader", false); //header generation function
        this.registerTableOption("groupHeaderPrint", null);
        this.registerTableOption("groupHeaderClipboard", null);
        this.registerTableOption("groupHeaderHtmlOutput", null);
        this.registerTableOption("groupHeaderDownload", null);
        this.registerTableOption("groupToggleElement", "arrow");
        this.registerTableOption("groupClosedShowCalcs", false);
        //register table functions
        this.registerTableFunction("setGroupBy", this.setGroupBy.bind(this));
        this.registerTableFunction("setGroupValues", this.setGroupValues.bind(this));
        this.registerTableFunction("setGroupStartOpen", this.setGroupStartOpen.bind(this));
        this.registerTableFunction("setGroupHeader", this.setGroupHeader.bind(this));
        this.registerTableFunction("getGroups", this.userGetGroups.bind(this));
        this.registerTableFunction("getGroupedData", this.userGetGroupedData.bind(this));
        //register component functions
        this.registerComponentFunction("row", "getGroup", this.rowGetGroup.bind(this));
    }
    //initialize group configuration
    initialize() {
        this.subscribe("table-destroy", this._blockRedrawing.bind(this));
        this.subscribe("rows-wipe", this._blockRedrawing.bind(this));
        this.subscribe("rows-wiped", this._restore_redrawing.bind(this));
        if (this.table.options.groupBy) {
            if (this.table.options.groupUpdateOnCellEdit) {
                this.subscribe("cell-value-updated", this.cellUpdated.bind(this));
                this.subscribe("row-data-changed", this.reassignRowToGroup.bind(this), 0);
            }
            this.subscribe("table-built", this.configureGroupSetup.bind(this));
            this.subscribe("row-deleting", this.rowDeleting.bind(this));
            this.subscribe("row-deleted", this.rowsUpdated.bind(this));
            this.subscribe("scroll-horizontal", this.scrollHeaders.bind(this));
            this.subscribe("rows-wipe", this.wipe.bind(this));
            this.subscribe("rows-added", this.rowsUpdated.bind(this));
            this.subscribe("row-moving", this.rowMoving.bind(this));
            this.subscribe("row-adding-index", this.rowAddingIndex.bind(this));
            this.subscribe("rows-sample", this.rowSample.bind(this));
            this.subscribe("render-virtual-fill", this.virtualRenderFill.bind(this));
            this.registerDisplayHandler(this.displayHandler, 20);
            this.initialized = true;
        }
    }
    _blockRedrawing() {
        this.blockRedraw = true;
    }
    _restore_redrawing() {
        this.blockRedraw = false;
    }
    configureGroupSetup() {
        if (this.table.options.groupBy) {
            var groupBy = this.table.options.groupBy, startOpen = this.table.options.groupStartOpen, groupHeader = this.table.options.groupHeader;
            this.allowedValues = this.table.options.groupValues;
            if (Array.isArray(groupBy) && Array.isArray(groupHeader) && groupBy.length > groupHeader.length) console.warn("Error creating group headers, groupHeader array is shorter than groupBy array");
            this.headerGenerator = [
                function() {
                    return "";
                }
            ];
            this.startOpen = [
                function() {
                    return false;
                }
            ]; //starting state of group
            this.langBind("groups|item", (langValue, lang)=>{
                this.headerGenerator[0] = (value, count, data)=>{
                    return (typeof value === "undefined" ? "" : value) + "<span>(" + count + " " + (count === 1 ? langValue : lang.groups.items) + ")</span>";
                };
            });
            this.groupIDLookups = [];
            if (groupBy) {
                if (this.table.modExists("columnCalcs") && this.table.options.columnCalcs != "table" && this.table.options.columnCalcs != "both") this.table.modules.columnCalcs.removeCalcs();
            } else if (this.table.modExists("columnCalcs") && this.table.options.columnCalcs != "group") {
                var cols = this.table.columnManager.getRealColumns();
                cols.forEach((col)=>{
                    if (col.definition.topCalc) this.table.modules.columnCalcs.initializeTopRow();
                    if (col.definition.bottomCalc) this.table.modules.columnCalcs.initializeBottomRow();
                });
            }
            if (!Array.isArray(groupBy)) groupBy = [
                groupBy
            ];
            groupBy.forEach((group, i)=>{
                var lookupFunc, column;
                if (typeof group == "function") lookupFunc = group;
                else {
                    column = this.table.columnManager.getColumnByField(group);
                    if (column) lookupFunc = function(data) {
                        return column.getFieldValue(data);
                    };
                    else lookupFunc = function(data) {
                        return data[group];
                    };
                }
                this.groupIDLookups.push({
                    field: typeof group === "function" ? false : group,
                    func: lookupFunc,
                    values: this.allowedValues ? this.allowedValues[i] : false
                });
            });
            if (startOpen) {
                if (!Array.isArray(startOpen)) startOpen = [
                    startOpen
                ];
                startOpen.forEach((level)=>{});
                this.startOpen = startOpen;
            }
            if (groupHeader) this.headerGenerator = Array.isArray(groupHeader) ? groupHeader : [
                groupHeader
            ];
        } else {
            this.groupList = [];
            this.groups = {};
        }
    }
    rowSample(rows, prevValue) {
        if (this.table.options.groupBy) {
            var group = this.getGroups(false)[0];
            prevValue.push(group.getRows(false)[0]);
        }
        return prevValue;
    }
    virtualRenderFill() {
        var el = this.table.rowManager.tableElement;
        var rows = this.table.rowManager.getVisibleRows();
        if (this.table.options.groupBy) {
            rows = rows.filter((row)=>{
                return row.type !== "group";
            });
            el.style.minWidth = !rows.length ? this.table.columnManager.getWidth() + "px" : "";
        } else return rows;
    }
    rowAddingIndex(row, index, top) {
        if (this.table.options.groupBy) {
            this.assignRowToGroup(row);
            var groupRows = row.modules.group.rows;
            if (groupRows.length > 1) {
                if (!index || index && groupRows.indexOf(index) == -1) {
                    if (top) {
                        if (groupRows[0] !== row) {
                            index = groupRows[0];
                            this.table.rowManager.moveRowInArray(row.modules.group.rows, row, index, !top);
                        }
                    } else if (groupRows[groupRows.length - 1] !== row) {
                        index = groupRows[groupRows.length - 1];
                        this.table.rowManager.moveRowInArray(row.modules.group.rows, row, index, !top);
                    }
                } else this.table.rowManager.moveRowInArray(row.modules.group.rows, row, index, !top);
            }
            return index;
        }
    }
    trackChanges() {
        this.dispatch("group-changed");
    }
    ///////////////////////////////////
    ///////// Table Functions /////////
    ///////////////////////////////////
    setGroupBy(groups) {
        this.table.options.groupBy = groups;
        if (!this.initialized) this.initialize();
        this.configureGroupSetup();
        if (!groups && this.table.modExists("columnCalcs") && this.table.options.columnCalcs === true) this.table.modules.columnCalcs.reinitializeCalcs();
        this.refreshData();
        this.trackChanges();
    }
    setGroupValues(groupValues) {
        this.table.options.groupValues = groupValues;
        this.configureGroupSetup();
        this.refreshData();
        this.trackChanges();
    }
    setGroupStartOpen(values) {
        this.table.options.groupStartOpen = values;
        this.configureGroupSetup();
        if (this.table.options.groupBy) {
            this.refreshData();
            this.trackChanges();
        } else console.warn("Grouping Update - cant refresh view, no groups have been set");
    }
    setGroupHeader(values) {
        this.table.options.groupHeader = values;
        this.configureGroupSetup();
        if (this.table.options.groupBy) {
            this.refreshData();
            this.trackChanges();
        } else console.warn("Grouping Update - cant refresh view, no groups have been set");
    }
    userGetGroups(values) {
        return this.getGroups(true);
    }
    // get grouped table data in the same format as getData()
    userGetGroupedData() {
        return this.table.options.groupBy ? this.getGroupedData() : this.getData();
    }
    ///////////////////////////////////////
    ///////// Component Functions /////////
    ///////////////////////////////////////
    rowGetGroup(row) {
        return row.modules.group ? row.modules.group.getComponent() : false;
    }
    ///////////////////////////////////
    ///////// Internal Logic //////////
    ///////////////////////////////////
    rowMoving(from, to, after) {
        if (this.table.options.groupBy) {
            if (!after && to instanceof $c2a9788f40f9c90a$var$Group) to = this.table.rowManager.prevDisplayRow(from) || to;
            var toGroup = to instanceof $c2a9788f40f9c90a$var$Group ? to : to.modules.group;
            var fromGroup = from instanceof $c2a9788f40f9c90a$var$Group ? from : from.modules.group;
            if (toGroup === fromGroup) this.table.rowManager.moveRowInArray(toGroup.rows, from, to, after);
            else {
                if (fromGroup) fromGroup.removeRow(from);
                toGroup.insertRow(from, to, after);
            }
        }
    }
    rowDeleting(row) {
        //remove from group
        if (this.table.options.groupBy && row.modules.group) row.modules.group.removeRow(row);
    }
    rowsUpdated(row) {
        if (this.table.options.groupBy) this.updateGroupRows(true);
    }
    cellUpdated(cell) {
        if (this.table.options.groupBy) this.reassignRowToGroup(cell.row);
    }
    //return appropriate rows with group headers
    getRows(rows) {
        if (this.table.options.groupBy && this.groupIDLookups.length) {
            this.dispatchExternal("dataGrouping");
            this.generateGroups(rows);
            if (this.subscribedExternal("dataGrouped")) this.dispatchExternal("dataGrouped", this.getGroups(true));
            return this.updateGroupRows();
        } else return rows.slice(0);
    }
    getGroups(component) {
        var groupComponents = [];
        this.groupList.forEach(function(group) {
            groupComponents.push(component ? group.getComponent() : group);
        });
        return groupComponents;
    }
    getChildGroups(group) {
        var groupComponents = [];
        if (!group) group = this;
        group.groupList.forEach((child)=>{
            if (child.groupList.length) groupComponents = groupComponents.concat(this.getChildGroups(child));
            else groupComponents.push(child);
        });
        return groupComponents;
    }
    wipe() {
        if (this.table.options.groupBy) {
            this.groupList.forEach(function(group) {
                group.wipe();
            });
            this.groupList = [];
            this.groups = {};
        }
    }
    pullGroupListData(groupList) {
        var groupListData = [];
        groupList.forEach((group)=>{
            var groupHeader = {};
            groupHeader.level = 0;
            groupHeader.rowCount = 0;
            groupHeader.headerContent = "";
            var childData = [];
            if (group.hasSubGroups) {
                childData = this.pullGroupListData(group.groupList);
                groupHeader.level = group.level;
                groupHeader.rowCount = childData.length - group.groupList.length; // data length minus number of sub-headers
                groupHeader.headerContent = group.generator(group.key, groupHeader.rowCount, group.rows, group);
                groupListData.push(groupHeader);
                groupListData = groupListData.concat(childData);
            } else {
                groupHeader.level = group.level;
                groupHeader.headerContent = group.generator(group.key, group.rows.length, group.rows, group);
                groupHeader.rowCount = group.getRows().length;
                groupListData.push(groupHeader);
                group.getRows().forEach((row)=>{
                    groupListData.push(row.getData("data"));
                });
            }
        });
        return groupListData;
    }
    getGroupedData() {
        return this.pullGroupListData(this.groupList);
    }
    getRowGroup(row) {
        var match = false;
        if (this.options("dataTree")) row = this.table.modules.dataTree.getTreeParentRoot(row);
        this.groupList.forEach((group)=>{
            var result = group.getRowGroup(row);
            if (result) match = result;
        });
        return match;
    }
    countGroups() {
        return this.groupList.length;
    }
    generateGroups(rows) {
        var oldGroups = this.groups;
        this.groups = {};
        this.groupList = [];
        if (this.allowedValues && this.allowedValues[0]) {
            this.allowedValues[0].forEach((value)=>{
                this.createGroup(value, 0, oldGroups);
            });
            rows.forEach((row)=>{
                this.assignRowToExistingGroup(row, oldGroups);
            });
        } else rows.forEach((row)=>{
            this.assignRowToGroup(row, oldGroups);
        });
        Object.values(oldGroups).forEach((group)=>{
            group.wipe(true);
        });
    }
    createGroup(groupID, level, oldGroups) {
        var groupKey = level + "_" + groupID, group;
        oldGroups = oldGroups || [];
        group = new $c2a9788f40f9c90a$var$Group(this, false, level, groupID, this.groupIDLookups[0].field, this.headerGenerator[0], oldGroups[groupKey]);
        this.groups[groupKey] = group;
        this.groupList.push(group);
    }
    assignRowToExistingGroup(row, oldGroups) {
        var groupID = this.groupIDLookups[0].func(row.getData()), groupKey = "0_" + groupID;
        if (this.groups[groupKey]) this.groups[groupKey].addRow(row);
    }
    assignRowToGroup(row, oldGroups) {
        var groupID = this.groupIDLookups[0].func(row.getData()), newGroupNeeded = !this.groups["0_" + groupID];
        if (newGroupNeeded) this.createGroup(groupID, 0, oldGroups);
        this.groups["0_" + groupID].addRow(row);
        return !newGroupNeeded;
    }
    reassignRowToGroup(row) {
        if (row.type === "row") {
            var oldRowGroup = row.modules.group, oldGroupPath = oldRowGroup.getPath(), newGroupPath = this.getExpectedPath(row), samePath;
            // figure out if new group path is the same as old group path
            samePath = oldGroupPath.length == newGroupPath.length && oldGroupPath.every((element, index)=>{
                return element === newGroupPath[index];
            });
            // refresh if they new path and old path aren't the same (aka the row's groupings have changed)
            if (!samePath) {
                oldRowGroup.removeRow(row);
                this.assignRowToGroup(row, this.groups);
                this.refreshData(true);
            }
        }
    }
    getExpectedPath(row) {
        var groupPath = [], rowData = row.getData();
        this.groupIDLookups.forEach((groupId)=>{
            groupPath.push(groupId.func(rowData));
        });
        return groupPath;
    }
    updateGroupRows(force) {
        var output = [];
        if (!this.blockRedraw) {
            this.groupList.forEach((group)=>{
                output = output.concat(group.getHeadersAndRows());
            });
            if (force) this.refreshData(true);
        }
        return output;
    }
    scrollHeaders(left) {
        if (this.table.options.groupBy) {
            if (this.table.options.renderHorizontal === "virtual") left -= this.table.columnManager.renderer.vDomPadLeft;
            left = left + "px";
            this.groupList.forEach((group)=>{
                group.scrollHeader(left);
            });
        }
    }
    removeGroup(group) {
        var groupKey = group.level + "_" + group.key, index;
        if (this.groups[groupKey]) {
            delete this.groups[groupKey];
            index = this.groupList.indexOf(group);
            if (index > -1) this.groupList.splice(index, 1);
        }
    }
    checkBasicModeGroupHeaderWidth() {
        var element = this.table.rowManager.tableElement, onlyGroupHeaders = true;
        this.table.rowManager.getDisplayRows().forEach((row, index)=>{
            this.table.rowManager.styleRow(row, index);
            element.appendChild(row.getElement());
            row.initialize(true);
            if (row.type !== "group") onlyGroupHeaders = false;
        });
        if (onlyGroupHeaders) element.style.minWidth = this.table.columnManager.getWidth() + "px";
        else element.style.minWidth = "";
    }
}
var $c2a9788f40f9c90a$var$defaultUndoers = {
    cellEdit: function(action) {
        action.component.setValueProcessData(action.data.oldValue);
        action.component.cellRendered();
    },
    rowAdd: function(action) {
        action.component.deleteActual();
        this.table.rowManager.checkPlaceholder();
    },
    rowDelete: function(action) {
        var newRow = this.table.rowManager.addRowActual(action.data.data, action.data.pos, action.data.index);
        if (this.table.options.groupBy && this.table.modExists("groupRows")) this.table.modules.groupRows.updateGroupRows(true);
        this._rebindRow(action.component, newRow);
        this.table.rowManager.checkPlaceholder();
    },
    rowMove: function(action) {
        var after = action.data.posFrom - action.data.posTo > 0;
        this.table.rowManager.moveRowActual(action.component, this.table.rowManager.getRowFromPosition(action.data.posFrom), after);
        this.table.rowManager.regenerateRowPositions();
        this.table.rowManager.reRenderInPosition();
    }
};
var $c2a9788f40f9c90a$var$defaultRedoers = {
    cellEdit: function(action) {
        action.component.setValueProcessData(action.data.newValue);
        action.component.cellRendered();
    },
    rowAdd: function(action) {
        var newRow = this.table.rowManager.addRowActual(action.data.data, action.data.pos, action.data.index);
        if (this.table.options.groupBy && this.table.modExists("groupRows")) this.table.modules.groupRows.updateGroupRows(true);
        this._rebindRow(action.component, newRow);
        this.table.rowManager.checkPlaceholder();
    },
    rowDelete: function(action) {
        action.component.deleteActual();
        this.table.rowManager.checkPlaceholder();
    },
    rowMove: function(action) {
        this.table.rowManager.moveRowActual(action.component, this.table.rowManager.getRowFromPosition(action.data.posTo), action.data.after);
        this.table.rowManager.regenerateRowPositions();
        this.table.rowManager.reRenderInPosition();
    }
};
var $c2a9788f40f9c90a$var$bindings$1 = {
    undo: [
        "ctrl + 90",
        "meta + 90"
    ],
    redo: [
        "ctrl + 89",
        "meta + 89"
    ]
};
var $c2a9788f40f9c90a$var$actions$1 = {
    undo: function(e) {
        var cell = false;
        if (this.table.options.history && this.table.modExists("history") && this.table.modExists("edit")) {
            cell = this.table.modules.edit.currentCell;
            if (!cell) {
                e.preventDefault();
                this.table.modules.history.undo();
            }
        }
    },
    redo: function(e) {
        var cell = false;
        if (this.table.options.history && this.table.modExists("history") && this.table.modExists("edit")) {
            cell = this.table.modules.edit.currentCell;
            if (!cell) {
                e.preventDefault();
                this.table.modules.history.redo();
            }
        }
    }
};
var $c2a9788f40f9c90a$var$extensions$3 = {
    keybindings: {
        bindings: $c2a9788f40f9c90a$var$bindings$1,
        actions: $c2a9788f40f9c90a$var$actions$1
    }
};
class $c2a9788f40f9c90a$export$173658fc60691186 extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "history";
    static moduleExtensions = $c2a9788f40f9c90a$var$extensions$3;
    //load defaults
    static undoers = $c2a9788f40f9c90a$var$defaultUndoers;
    static redoers = $c2a9788f40f9c90a$var$defaultRedoers;
    constructor(table){
        super(table);
        this.history = [];
        this.index = -1;
        this.registerTableOption("history", false); //enable edit history
    }
    initialize() {
        if (this.table.options.history) {
            this.subscribe("cell-value-updated", this.cellUpdated.bind(this));
            this.subscribe("cell-delete", this.clearComponentHistory.bind(this));
            this.subscribe("row-delete", this.rowDeleted.bind(this));
            this.subscribe("rows-wipe", this.clear.bind(this));
            this.subscribe("row-added", this.rowAdded.bind(this));
            this.subscribe("row-move", this.rowMoved.bind(this));
        }
        this.registerTableFunction("undo", this.undo.bind(this));
        this.registerTableFunction("redo", this.redo.bind(this));
        this.registerTableFunction("getHistoryUndoSize", this.getHistoryUndoSize.bind(this));
        this.registerTableFunction("getHistoryRedoSize", this.getHistoryRedoSize.bind(this));
        this.registerTableFunction("clearHistory", this.clear.bind(this));
    }
    rowMoved(from, to, after) {
        this.action("rowMove", from, {
            posFrom: from.getPosition(),
            posTo: to.getPosition(),
            to: to,
            after: after
        });
    }
    rowAdded(row, data, pos, index) {
        this.action("rowAdd", row, {
            data: data,
            pos: pos,
            index: index
        });
    }
    rowDeleted(row) {
        var index, rows;
        if (this.table.options.groupBy) {
            rows = row.getComponent().getGroup()._getSelf().rows;
            index = rows.indexOf(row);
            if (index) index = rows[index - 1];
        } else {
            index = row.table.rowManager.getRowIndex(row);
            if (index) index = row.table.rowManager.rows[index - 1];
        }
        this.action("rowDelete", row, {
            data: row.getData(),
            pos: !index,
            index: index
        });
    }
    cellUpdated(cell) {
        this.action("cellEdit", cell, {
            oldValue: cell.oldValue,
            newValue: cell.value
        });
    }
    clear() {
        this.history = [];
        this.index = -1;
    }
    action(type, component, data) {
        this.history = this.history.slice(0, this.index + 1);
        this.history.push({
            type: type,
            component: component,
            data: data
        });
        this.index++;
    }
    getHistoryUndoSize() {
        return this.index + 1;
    }
    getHistoryRedoSize() {
        return this.history.length - (this.index + 1);
    }
    clearComponentHistory(component) {
        var index = this.history.findIndex(function(item) {
            return item.component === component;
        });
        if (index > -1) {
            this.history.splice(index, 1);
            if (index <= this.index) this.index--;
            this.clearComponentHistory(component);
        }
    }
    undo() {
        if (this.index > -1) {
            let action = this.history[this.index];
            $c2a9788f40f9c90a$export$173658fc60691186.undoers[action.type].call(this, action);
            this.index--;
            this.dispatchExternal("historyUndo", action.type, action.component.getComponent(), action.data);
            return true;
        } else {
            console.warn(this.options("history") ? "History Undo Error - No more history to undo" : "History module not enabled");
            return false;
        }
    }
    redo() {
        if (this.history.length - 1 > this.index) {
            this.index++;
            let action = this.history[this.index];
            $c2a9788f40f9c90a$export$173658fc60691186.redoers[action.type].call(this, action);
            this.dispatchExternal("historyRedo", action.type, action.component.getComponent(), action.data);
            return true;
        } else {
            console.warn(this.options("history") ? "History Redo Error - No more history to redo" : "History module not enabled");
            return false;
        }
    }
    //rebind rows to new element after deletion
    _rebindRow(oldRow, newRow) {
        this.history.forEach(function(action) {
            if (action.component instanceof $c2a9788f40f9c90a$var$Row) {
                if (action.component === oldRow) action.component = newRow;
            } else if (action.component instanceof $c2a9788f40f9c90a$var$Cell) {
                if (action.component.row === oldRow) {
                    var field = action.component.column.getField();
                    if (field) action.component = newRow.getCell(field);
                }
            }
        });
    }
}
class $c2a9788f40f9c90a$export$b0b448c470bac827 extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "htmlTableImport";
    constructor(table){
        super(table);
        this.fieldIndex = [];
        this.hasIndex = false;
    }
    initialize() {
        this.tableElementCheck();
    }
    tableElementCheck() {
        if (this.table.originalElement && this.table.originalElement.tagName === "TABLE") {
            if (this.table.originalElement.childNodes.length) this.parseTable();
            else console.warn("Unable to parse data from empty table tag, Tabulator should be initialized on a div tag unless importing data from a table element.");
        }
    }
    parseTable() {
        var element = this.table.originalElement, options = this.table.options, headers = element.getElementsByTagName("th"), rows = element.getElementsByTagName("tbody")[0], data = [];
        this.hasIndex = false;
        this.dispatchExternal("htmlImporting");
        rows = rows ? rows.getElementsByTagName("tr") : [];
        //check for Tabulator inline options
        this._extractOptions(element, options);
        if (headers.length) this._extractHeaders(headers, rows);
        else this._generateBlankHeaders(headers, rows);
        //iterate through table rows and build data set
        for(var index = 0; index < rows.length; index++){
            var row = rows[index], cells = row.getElementsByTagName("td"), item = {};
            //create index if the don't exist in table
            if (!this.hasIndex) item[options.index] = index;
            for(var i = 0; i < cells.length; i++){
                var cell = cells[i];
                if (typeof this.fieldIndex[i] !== "undefined") item[this.fieldIndex[i]] = cell.innerHTML;
            }
            //add row data to item
            data.push(item);
        }
        options.data = data;
        this.dispatchExternal("htmlImported");
    }
    //extract tabulator attribute options
    _extractOptions(element, options, defaultOptions) {
        var attributes = element.attributes;
        var optionsArr = defaultOptions ? Object.keys(defaultOptions) : Object.keys(options);
        var optionsList = {};
        optionsArr.forEach((item)=>{
            optionsList[item.toLowerCase()] = item;
        });
        for(var index in attributes){
            var attrib = attributes[index];
            var name;
            if (attrib && typeof attrib == "object" && attrib.name && attrib.name.indexOf("tabulator-") === 0) {
                name = attrib.name.replace("tabulator-", "");
                if (typeof optionsList[name] !== "undefined") options[optionsList[name]] = this._attribValue(attrib.value);
            }
        }
    }
    //get value of attribute
    _attribValue(value) {
        if (value === "true") return true;
        if (value === "false") return false;
        return value;
    }
    //find column if it has already been defined
    _findCol(title) {
        var match = this.table.options.columns.find((column)=>{
            return column.title === title;
        });
        return match || false;
    }
    //extract column from headers
    _extractHeaders(headers, rows) {
        for(var index = 0; index < headers.length; index++){
            var header = headers[index], exists = false, col = this._findCol(header.textContent), width;
            if (col) exists = true;
            else col = {
                title: header.textContent.trim()
            };
            if (!col.field) col.field = header.textContent.trim().toLowerCase().replaceAll(" ", "_");
            width = header.getAttribute("width");
            if (width && !col.width) col.width = width;
            //check for Tabulator inline options
            this._extractOptions(header, col, this.table.columnManager.optionsList.registeredDefaults);
            this.fieldIndex[index] = col.field;
            if (col.field == this.table.options.index) this.hasIndex = true;
            if (!exists) this.table.options.columns.push(col);
        }
    }
    //generate blank headers
    _generateBlankHeaders(headers, rows) {
        for(var index = 0; index < headers.length; index++){
            var header = headers[index], col = {
                title: "",
                field: "col" + index
            };
            this.fieldIndex[index] = col.field;
            var width = header.getAttribute("width");
            if (width) col.width = width;
            this.table.options.columns.push(col);
        }
    }
}
function $c2a9788f40f9c90a$var$csv(input) {
    var data = [], row = 0, col = 0, inQuote = false;
    //Iterate over each character
    for(let index = 0; index < input.length; index++){
        let char = input[index], nextChar = input[index + 1];
        //Initialize empty row
        if (!data[row]) data[row] = [];
        //Initialize empty column
        if (!data[row][col]) data[row][col] = "";
        //Handle quotation mark inside string
        if (char == '"' && inQuote && nextChar == '"') {
            data[row][col] += char;
            index++;
            continue;
        }
        //Begin / End Quote
        if (char == '"') {
            inQuote = !inQuote;
            continue;
        }
        //Next column (if not in quote)
        if (char == "," && !inQuote) {
            col++;
            continue;
        }
        //New row if new line and not in quote (CRLF) 
        if (char == "\r" && nextChar == "\n" && !inQuote) {
            col = 0;
            row++;
            index++;
            continue;
        }
        //New row if new line and not in quote (CR or LF) 
        if ((char == "\r" || char == "\n") && !inQuote) {
            col = 0;
            row++;
            continue;
        }
        //Normal Character, append to column
        data[row][col] += char;
    }
    return data;
}
function $c2a9788f40f9c90a$var$json(input) {
    try {
        return JSON.parse(input);
    } catch (e) {
        console.warn("JSON Import Error - File contents is invalid JSON", e);
        return Promise.reject();
    }
}
function $c2a9788f40f9c90a$var$array$1(input) {
    return input;
}
function $c2a9788f40f9c90a$var$xlsx(input, floop) {
    var workbook2 = XLSX.read(input);
    var sheet = workbook2.Sheets[workbook2.SheetNames[0]];
    return XLSX.utils.sheet_to_json(sheet, {});
}
var $c2a9788f40f9c90a$var$defaultImporters = {
    csv: $c2a9788f40f9c90a$var$csv,
    json: $c2a9788f40f9c90a$var$json,
    array: $c2a9788f40f9c90a$var$array$1,
    xlsx: $c2a9788f40f9c90a$var$xlsx
};
class $c2a9788f40f9c90a$export$bceca318c211ca25 extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "import";
    //load defaults
    static importers = $c2a9788f40f9c90a$var$defaultImporters;
    constructor(table){
        super(table);
        this.registerTableOption("importFormat");
        this.registerTableOption("importReader", "text");
    }
    initialize() {
        this.registerTableFunction("import", this.importFromFile.bind(this));
        if (this.table.options.importFormat) {
            this.subscribe("data-loading", this.loadDataCheck.bind(this), 10);
            this.subscribe("data-load", this.loadData.bind(this), 10);
        }
    }
    loadDataCheck(data) {
        return this.table.options.importFormat && (typeof data === "string" || Array.isArray(data) && data.length && Array.isArray(data));
    }
    loadData(data, params, config, silent, previousData) {
        return this.importData(this.lookupImporter(), data).then(this.structureData.bind(this)).catch((err)=>{
            console.error("Import Error:", err || "Unable to import data");
            return Promise.reject(err);
        });
    }
    lookupImporter(importFormat) {
        var importer;
        if (!importFormat) importFormat = this.table.options.importFormat;
        if (typeof importFormat === "string") importer = $c2a9788f40f9c90a$export$bceca318c211ca25.importers[importFormat];
        else importer = importFormat;
        if (!importer) console.error("Import Error - Importer not found:", importFormat);
        return importer;
    }
    importFromFile(importFormat, extension, importReader) {
        var importer = this.lookupImporter(importFormat);
        if (importer) return this.pickFile(extension, importReader).then(this.importData.bind(this, importer)).then(this.structureData.bind(this)).then(this.setData.bind(this)).catch((err)=>{
            this.dispatch("import-error", err);
            this.dispatchExternal("importError", err);
            console.error("Import Error:", err || "Unable to import file");
            return Promise.reject(err);
        });
    }
    pickFile(extensions, importReader) {
        return new Promise((resolve, reject)=>{
            var input = document.createElement("input");
            input.type = "file";
            input.accept = extensions;
            input.addEventListener("change", (e)=>{
                var file = input.files[0], reader = new FileReader();
                this.dispatch("import-importing", input.files);
                this.dispatchExternal("importImporting", input.files);
                switch(importReader || this.table.options.importReader){
                    case "buffer":
                        reader.readAsArrayBuffer(file);
                        break;
                    case "binary":
                        reader.readAsBinaryString(file);
                        break;
                    case "url":
                        reader.readAsDataURL(file);
                        break;
                    case "text":
                    default:
                        reader.readAsText(file);
                }
                reader.onload = (e)=>{
                    resolve(reader.result);
                };
                reader.onerror = (e)=>{
                    console.warn("File Load Error - Unable to read file");
                    reject();
                };
            });
            this.dispatch("import-choose");
            this.dispatchExternal("importChoose");
            input.click();
        });
    }
    importData(importer, fileContents) {
        var data = importer.call(this.table, fileContents);
        if (data instanceof Promise) return data;
        else return data ? Promise.resolve(data) : Promise.reject();
    }
    structureData(parsedData) {
        var data = [];
        if (Array.isArray(parsedData) && parsedData.length && Array.isArray(parsedData[0])) {
            if (this.table.options.autoColumns) data = this.structureArrayToObject(parsedData);
            else data = this.structureArrayToColumns(parsedData);
            return data;
        } else return parsedData;
    }
    structureArrayToObject(parsedData) {
        var columns = parsedData.shift();
        var data = parsedData.map((values)=>{
            var row = {};
            columns.forEach((key, i)=>{
                row[key] = values[i];
            });
            return row;
        });
        return data;
    }
    structureArrayToColumns(parsedData) {
        var data = [], columns = this.table.getColumns();
        //remove first row if it is the column names
        if (columns[0] && parsedData[0][0]) {
            if (columns[0].getDefinition().title === parsedData[0][0]) parsedData.shift();
        }
        //convert row arrays to objects
        parsedData.forEach((rowData)=>{
            var row = {};
            rowData.forEach((value, index)=>{
                var column = columns[index];
                if (column) row[column.getField()] = value;
            });
            data.push(row);
        });
        return data;
    }
    setData(data) {
        this.dispatch("import-imported", data);
        this.dispatchExternal("importImported", data);
        return this.table.setData(data);
    }
}
class $c2a9788f40f9c90a$export$69fa60f71dd0541a extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "interaction";
    constructor(table){
        super(table);
        this.eventMap = {
            //row events
            rowClick: "row-click",
            rowDblClick: "row-dblclick",
            rowContext: "row-contextmenu",
            rowMouseEnter: "row-mouseenter",
            rowMouseLeave: "row-mouseleave",
            rowMouseOver: "row-mouseover",
            rowMouseOut: "row-mouseout",
            rowMouseMove: "row-mousemove",
            rowMouseDown: "row-mousedown",
            rowMouseUp: "row-mouseup",
            rowTap: "row",
            rowDblTap: "row",
            rowTapHold: "row",
            //cell events
            cellClick: "cell-click",
            cellDblClick: "cell-dblclick",
            cellContext: "cell-contextmenu",
            cellMouseEnter: "cell-mouseenter",
            cellMouseLeave: "cell-mouseleave",
            cellMouseOver: "cell-mouseover",
            cellMouseOut: "cell-mouseout",
            cellMouseMove: "cell-mousemove",
            cellMouseDown: "cell-mousedown",
            cellMouseUp: "cell-mouseup",
            cellTap: "cell",
            cellDblTap: "cell",
            cellTapHold: "cell",
            //column header events
            headerClick: "column-click",
            headerDblClick: "column-dblclick",
            headerContext: "column-contextmenu",
            headerMouseEnter: "column-mouseenter",
            headerMouseLeave: "column-mouseleave",
            headerMouseOver: "column-mouseover",
            headerMouseOut: "column-mouseout",
            headerMouseMove: "column-mousemove",
            headerMouseDown: "column-mousedown",
            headerMouseUp: "column-mouseup",
            headerTap: "column",
            headerDblTap: "column",
            headerTapHold: "column",
            //group header
            groupClick: "group-click",
            groupDblClick: "group-dblclick",
            groupContext: "group-contextmenu",
            groupMouseEnter: "group-mouseenter",
            groupMouseLeave: "group-mouseleave",
            groupMouseOver: "group-mouseover",
            groupMouseOut: "group-mouseout",
            groupMouseMove: "group-mousemove",
            groupMouseDown: "group-mousedown",
            groupMouseUp: "group-mouseup",
            groupTap: "group",
            groupDblTap: "group",
            groupTapHold: "group"
        };
        this.subscribers = {};
        this.touchSubscribers = {};
        this.columnSubscribers = {};
        this.touchWatchers = {
            row: {
                tap: null,
                tapDbl: null,
                tapHold: null
            },
            cell: {
                tap: null,
                tapDbl: null,
                tapHold: null
            },
            column: {
                tap: null,
                tapDbl: null,
                tapHold: null
            },
            group: {
                tap: null,
                tapDbl: null,
                tapHold: null
            }
        };
        this.registerColumnOption("headerClick");
        this.registerColumnOption("headerDblClick");
        this.registerColumnOption("headerContext");
        this.registerColumnOption("headerMouseEnter");
        this.registerColumnOption("headerMouseLeave");
        this.registerColumnOption("headerMouseOver");
        this.registerColumnOption("headerMouseOut");
        this.registerColumnOption("headerMouseMove");
        this.registerColumnOption("headerMouseDown");
        this.registerColumnOption("headerMouseUp");
        this.registerColumnOption("headerTap");
        this.registerColumnOption("headerDblTap");
        this.registerColumnOption("headerTapHold");
        this.registerColumnOption("cellClick");
        this.registerColumnOption("cellDblClick");
        this.registerColumnOption("cellContext");
        this.registerColumnOption("cellMouseEnter");
        this.registerColumnOption("cellMouseLeave");
        this.registerColumnOption("cellMouseOver");
        this.registerColumnOption("cellMouseOut");
        this.registerColumnOption("cellMouseMove");
        this.registerColumnOption("cellMouseDown");
        this.registerColumnOption("cellMouseUp");
        this.registerColumnOption("cellTap");
        this.registerColumnOption("cellDblTap");
        this.registerColumnOption("cellTapHold");
    }
    initialize() {
        this.initializeExternalEvents();
        this.subscribe("column-init", this.initializeColumn.bind(this));
        this.subscribe("cell-dblclick", this.cellContentsSelectionFixer.bind(this));
        this.subscribe("scroll-horizontal", this.clearTouchWatchers.bind(this));
        this.subscribe("scroll-vertical", this.clearTouchWatchers.bind(this));
    }
    clearTouchWatchers() {
        var types = Object.values(this.touchWatchers);
        types.forEach((type)=>{
            for(let key in type)type[key] = null;
        });
    }
    cellContentsSelectionFixer(e, cell) {
        var range;
        if (this.table.modExists("edit")) {
            if (this.table.modules.edit.currentCell === cell) return; //prevent instant selection of editor content
        }
        e.preventDefault();
        try {
            if (document.selection) {
                range = document.body.createTextRange();
                range.moveToElementText(cell.getElement());
                range.select();
            } else if (window.getSelection) {
                range = document.createRange();
                range.selectNode(cell.getElement());
                window.getSelection().removeAllRanges();
                window.getSelection().addRange(range);
            }
        } catch (e) {}
    }
    initializeExternalEvents() {
        for(let key in this.eventMap)this.subscriptionChangeExternal(key, this.subscriptionChanged.bind(this, key));
    }
    subscriptionChanged(key, added) {
        if (added) {
            if (!this.subscribers[key]) {
                if (this.eventMap[key].includes("-")) {
                    this.subscribers[key] = this.handle.bind(this, key);
                    this.subscribe(this.eventMap[key], this.subscribers[key]);
                } else this.subscribeTouchEvents(key);
            }
        } else {
            if (this.eventMap[key].includes("-")) {
                if (this.subscribers[key] && !this.columnSubscribers[key] && !this.subscribedExternal(key)) {
                    this.unsubscribe(this.eventMap[key], this.subscribers[key]);
                    delete this.subscribers[key];
                }
            } else this.unsubscribeTouchEvents(key);
        }
    }
    subscribeTouchEvents(key) {
        var type = this.eventMap[key];
        if (!this.touchSubscribers[type + "-touchstart"]) {
            this.touchSubscribers[type + "-touchstart"] = this.handleTouch.bind(this, type, "start");
            this.touchSubscribers[type + "-touchend"] = this.handleTouch.bind(this, type, "end");
            this.subscribe(type + "-touchstart", this.touchSubscribers[type + "-touchstart"]);
            this.subscribe(type + "-touchend", this.touchSubscribers[type + "-touchend"]);
        }
        this.subscribers[key] = true;
    }
    unsubscribeTouchEvents(key) {
        var noTouch = true, type = this.eventMap[key];
        if (this.subscribers[key] && !this.subscribedExternal(key)) {
            delete this.subscribers[key];
            for(let i in this.eventMap){
                if (this.eventMap[i] === type) {
                    if (this.subscribers[i]) noTouch = false;
                }
            }
            if (noTouch) {
                this.unsubscribe(type + "-touchstart", this.touchSubscribers[type + "-touchstart"]);
                this.unsubscribe(type + "-touchend", this.touchSubscribers[type + "-touchend"]);
                delete this.touchSubscribers[type + "-touchstart"];
                delete this.touchSubscribers[type + "-touchend"];
            }
        }
    }
    initializeColumn(column) {
        var def = column.definition;
        for(let key in this.eventMap)if (def[key]) {
            this.subscriptionChanged(key, true);
            if (!this.columnSubscribers[key]) this.columnSubscribers[key] = [];
            this.columnSubscribers[key].push(column);
        }
    }
    handle(action, e, component) {
        this.dispatchEvent(action, e, component);
    }
    handleTouch(type, action, e, component) {
        var watchers = this.touchWatchers[type];
        if (type === "column") type = "header";
        switch(action){
            case "start":
                watchers.tap = true;
                clearTimeout(watchers.tapHold);
                watchers.tapHold = setTimeout(()=>{
                    clearTimeout(watchers.tapHold);
                    watchers.tapHold = null;
                    watchers.tap = null;
                    clearTimeout(watchers.tapDbl);
                    watchers.tapDbl = null;
                    this.dispatchEvent(type + "TapHold", e, component);
                }, 1000);
                break;
            case "end":
                if (watchers.tap) {
                    watchers.tap = null;
                    this.dispatchEvent(type + "Tap", e, component);
                }
                if (watchers.tapDbl) {
                    clearTimeout(watchers.tapDbl);
                    watchers.tapDbl = null;
                    this.dispatchEvent(type + "DblTap", e, component);
                } else watchers.tapDbl = setTimeout(()=>{
                    clearTimeout(watchers.tapDbl);
                    watchers.tapDbl = null;
                }, 300);
                clearTimeout(watchers.tapHold);
                watchers.tapHold = null;
                break;
        }
    }
    dispatchEvent(action, e, component) {
        var componentObj = component.getComponent(), callback;
        if (this.columnSubscribers[action]) {
            if (component instanceof $c2a9788f40f9c90a$var$Cell) callback = component.column.definition[action];
            else if (component instanceof $c2a9788f40f9c90a$var$Column) callback = component.definition[action];
            if (callback) callback(e, componentObj);
        }
        this.dispatchExternal(action, e, componentObj);
    }
}
var $c2a9788f40f9c90a$var$defaultBindings = {
    navPrev: "shift + 9",
    navNext: 9,
    navUp: 38,
    navDown: 40,
    navLeft: 37,
    navRight: 39,
    scrollPageUp: 33,
    scrollPageDown: 34,
    scrollToStart: 36,
    scrollToEnd: 35
};
var $c2a9788f40f9c90a$var$defaultActions = {
    keyBlock: function(e) {
        e.stopPropagation();
        e.preventDefault();
    },
    scrollPageUp: function(e) {
        var rowManager = this.table.rowManager, newPos = rowManager.scrollTop - rowManager.element.clientHeight;
        e.preventDefault();
        if (rowManager.displayRowsCount) {
            if (newPos >= 0) rowManager.element.scrollTop = newPos;
            else rowManager.scrollToRow(rowManager.getDisplayRows()[0]);
        }
        this.table.element.focus();
    },
    scrollPageDown: function(e) {
        var rowManager = this.table.rowManager, newPos = rowManager.scrollTop + rowManager.element.clientHeight, scrollMax = rowManager.element.scrollHeight;
        e.preventDefault();
        if (rowManager.displayRowsCount) {
            if (newPos <= scrollMax) rowManager.element.scrollTop = newPos;
            else rowManager.scrollToRow(rowManager.getDisplayRows()[rowManager.displayRowsCount - 1]);
        }
        this.table.element.focus();
    },
    scrollToStart: function(e) {
        var rowManager = this.table.rowManager;
        e.preventDefault();
        if (rowManager.displayRowsCount) rowManager.scrollToRow(rowManager.getDisplayRows()[0]);
        this.table.element.focus();
    },
    scrollToEnd: function(e) {
        var rowManager = this.table.rowManager;
        e.preventDefault();
        if (rowManager.displayRowsCount) rowManager.scrollToRow(rowManager.getDisplayRows()[rowManager.displayRowsCount - 1]);
        this.table.element.focus();
    },
    navPrev: function(e) {
        this.dispatch("keybinding-nav-prev", e);
    },
    navNext: function(e) {
        this.dispatch("keybinding-nav-next", e);
    },
    navLeft: function(e) {
        this.dispatch("keybinding-nav-left", e);
    },
    navRight: function(e) {
        this.dispatch("keybinding-nav-right", e);
    },
    navUp: function(e) {
        this.dispatch("keybinding-nav-up", e);
    },
    navDown: function(e) {
        this.dispatch("keybinding-nav-down", e);
    }
};
class $c2a9788f40f9c90a$export$a0ff4f1c226a7cef extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "keybindings";
    //load defaults
    static bindings = $c2a9788f40f9c90a$var$defaultBindings;
    static actions = $c2a9788f40f9c90a$var$defaultActions;
    constructor(table){
        super(table);
        this.watchKeys = null;
        this.pressedKeys = null;
        this.keyupBinding = false;
        this.keydownBinding = false;
        this.registerTableOption("keybindings", {}); //array for keybindings
        this.registerTableOption("tabEndNewRow", false); //create new row when tab to end of table
    }
    initialize() {
        var bindings = this.table.options.keybindings, mergedBindings = {};
        this.watchKeys = {};
        this.pressedKeys = [];
        if (bindings !== false) {
            Object.assign(mergedBindings, $c2a9788f40f9c90a$export$a0ff4f1c226a7cef.bindings);
            Object.assign(mergedBindings, bindings);
            this.mapBindings(mergedBindings);
            this.bindEvents();
        }
        this.subscribe("table-destroy", this.clearBindings.bind(this));
    }
    mapBindings(bindings) {
        for(let key in bindings){
            if ($c2a9788f40f9c90a$export$a0ff4f1c226a7cef.actions[key]) {
                if (bindings[key]) {
                    if (typeof bindings[key] !== "object") bindings[key] = [
                        bindings[key]
                    ];
                    bindings[key].forEach((binding)=>{
                        var bindingList = Array.isArray(binding) ? binding : [
                            binding
                        ];
                        bindingList.forEach((item)=>{
                            this.mapBinding(key, item);
                        });
                    });
                }
            } else console.warn("Key Binding Error - no such action:", key);
        }
    }
    mapBinding(action, symbolsList) {
        var binding = {
            action: $c2a9788f40f9c90a$export$a0ff4f1c226a7cef.actions[action],
            keys: [],
            ctrl: false,
            shift: false,
            meta: false
        };
        var symbols = symbolsList.toString().toLowerCase().split(" ").join("").split("+");
        symbols.forEach((symbol)=>{
            switch(symbol){
                case "ctrl":
                    binding.ctrl = true;
                    break;
                case "shift":
                    binding.shift = true;
                    break;
                case "meta":
                    binding.meta = true;
                    break;
                default:
                    symbol = isNaN(symbol) ? symbol.toUpperCase().charCodeAt(0) : parseInt(symbol);
                    binding.keys.push(symbol);
                    if (!this.watchKeys[symbol]) this.watchKeys[symbol] = [];
                    this.watchKeys[symbol].push(binding);
            }
        });
    }
    bindEvents() {
        var self = this;
        this.keyupBinding = function(e) {
            var code = e.keyCode;
            var bindings = self.watchKeys[code];
            if (bindings) {
                self.pressedKeys.push(code);
                bindings.forEach(function(binding) {
                    self.checkBinding(e, binding);
                });
            }
        };
        this.keydownBinding = function(e) {
            var code = e.keyCode;
            var bindings = self.watchKeys[code];
            if (bindings) {
                var index = self.pressedKeys.indexOf(code);
                if (index > -1) self.pressedKeys.splice(index, 1);
            }
        };
        this.table.element.addEventListener("keydown", this.keyupBinding);
        this.table.element.addEventListener("keyup", this.keydownBinding);
    }
    clearBindings() {
        if (this.keyupBinding) this.table.element.removeEventListener("keydown", this.keyupBinding);
        if (this.keydownBinding) this.table.element.removeEventListener("keyup", this.keydownBinding);
    }
    checkBinding(e, binding) {
        var match = true;
        if (e.ctrlKey == binding.ctrl && e.shiftKey == binding.shift && e.metaKey == binding.meta) {
            binding.keys.forEach((key)=>{
                var index = this.pressedKeys.indexOf(key);
                if (index == -1) match = false;
            });
            if (match) binding.action.call(this, e);
            return true;
        }
        return false;
    }
}
class $c2a9788f40f9c90a$export$f1ab43fc4c3c5ce0 extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "menu";
    constructor(table){
        super(table);
        this.menuContainer = null;
        this.nestedMenuBlock = false;
        this.currentComponent = null;
        this.rootPopup = null;
        this.columnSubscribers = {};
        // this.registerTableOption("menuContainer", undefined); //deprecated
        this.registerTableOption("rowContextMenu", false);
        this.registerTableOption("rowClickMenu", false);
        this.registerTableOption("rowDblClickMenu", false);
        this.registerTableOption("groupContextMenu", false);
        this.registerTableOption("groupClickMenu", false);
        this.registerTableOption("groupDblClickMenu", false);
        this.registerColumnOption("headerContextMenu");
        this.registerColumnOption("headerClickMenu");
        this.registerColumnOption("headerDblClickMenu");
        this.registerColumnOption("headerMenu");
        this.registerColumnOption("headerMenuIcon");
        this.registerColumnOption("contextMenu");
        this.registerColumnOption("clickMenu");
        this.registerColumnOption("dblClickMenu");
    }
    initialize() {
        this.deprecatedOptionsCheck();
        this.initializeRowWatchers();
        this.initializeGroupWatchers();
        this.subscribe("column-init", this.initializeColumn.bind(this));
    }
    deprecatedOptionsCheck() {
    // if(!this.deprecationCheck("menuContainer", "popupContainer")){
    // 	this.table.options.popupContainer = this.table.options.menuContainer;
    // }
    }
    initializeRowWatchers() {
        if (this.table.options.rowContextMenu) {
            this.subscribe("row-contextmenu", this.loadMenuEvent.bind(this, this.table.options.rowContextMenu));
            this.table.on("rowTapHold", this.loadMenuEvent.bind(this, this.table.options.rowContextMenu));
        }
        if (this.table.options.rowClickMenu) this.subscribe("row-click", this.loadMenuEvent.bind(this, this.table.options.rowClickMenu));
        if (this.table.options.rowDblClickMenu) this.subscribe("row-dblclick", this.loadMenuEvent.bind(this, this.table.options.rowDblClickMenu));
    }
    initializeGroupWatchers() {
        if (this.table.options.groupContextMenu) {
            this.subscribe("group-contextmenu", this.loadMenuEvent.bind(this, this.table.options.groupContextMenu));
            this.table.on("groupTapHold", this.loadMenuEvent.bind(this, this.table.options.groupContextMenu));
        }
        if (this.table.options.groupClickMenu) this.subscribe("group-click", this.loadMenuEvent.bind(this, this.table.options.groupClickMenu));
        if (this.table.options.groupDblClickMenu) this.subscribe("group-dblclick", this.loadMenuEvent.bind(this, this.table.options.groupDblClickMenu));
    }
    initializeColumn(column) {
        var def = column.definition;
        //handle column events
        if (def.headerContextMenu && !this.columnSubscribers.headerContextMenu) {
            this.columnSubscribers.headerContextMenu = this.loadMenuTableColumnEvent.bind(this, "headerContextMenu");
            this.subscribe("column-contextmenu", this.columnSubscribers.headerContextMenu);
            this.table.on("headerTapHold", this.loadMenuTableColumnEvent.bind(this, "headerContextMenu"));
        }
        if (def.headerClickMenu && !this.columnSubscribers.headerClickMenu) {
            this.columnSubscribers.headerClickMenu = this.loadMenuTableColumnEvent.bind(this, "headerClickMenu");
            this.subscribe("column-click", this.columnSubscribers.headerClickMenu);
        }
        if (def.headerDblClickMenu && !this.columnSubscribers.headerDblClickMenu) {
            this.columnSubscribers.headerDblClickMenu = this.loadMenuTableColumnEvent.bind(this, "headerDblClickMenu");
            this.subscribe("column-dblclick", this.columnSubscribers.headerDblClickMenu);
        }
        if (def.headerMenu) this.initializeColumnHeaderMenu(column);
        //handle cell events
        if (def.contextMenu && !this.columnSubscribers.contextMenu) {
            this.columnSubscribers.contextMenu = this.loadMenuTableCellEvent.bind(this, "contextMenu");
            this.subscribe("cell-contextmenu", this.columnSubscribers.contextMenu);
            this.table.on("cellTapHold", this.loadMenuTableCellEvent.bind(this, "contextMenu"));
        }
        if (def.clickMenu && !this.columnSubscribers.clickMenu) {
            this.columnSubscribers.clickMenu = this.loadMenuTableCellEvent.bind(this, "clickMenu");
            this.subscribe("cell-click", this.columnSubscribers.clickMenu);
        }
        if (def.dblClickMenu && !this.columnSubscribers.dblClickMenu) {
            this.columnSubscribers.dblClickMenu = this.loadMenuTableCellEvent.bind(this, "dblClickMenu");
            this.subscribe("cell-dblclick", this.columnSubscribers.dblClickMenu);
        }
    }
    initializeColumnHeaderMenu(column) {
        var icon = column.definition.headerMenuIcon, headerMenuEl;
        headerMenuEl = document.createElement("span");
        headerMenuEl.classList.add("tabulator-header-popup-button");
        if (icon) {
            if (typeof icon === "function") icon = icon(column.getComponent());
            if (icon instanceof HTMLElement) headerMenuEl.appendChild(icon);
            else headerMenuEl.innerHTML = icon;
        } else headerMenuEl.innerHTML = "&vellip;";
        headerMenuEl.addEventListener("click", (e)=>{
            e.stopPropagation();
            e.preventDefault();
            this.loadMenuEvent(column.definition.headerMenu, e, column);
        });
        column.titleElement.insertBefore(headerMenuEl, column.titleElement.firstChild);
    }
    loadMenuTableCellEvent(option, e, cell) {
        if (cell._cell) cell = cell._cell;
        if (cell.column.definition[option]) this.loadMenuEvent(cell.column.definition[option], e, cell);
    }
    loadMenuTableColumnEvent(option, e, column) {
        if (column._column) column = column._column;
        if (column.definition[option]) this.loadMenuEvent(column.definition[option], e, column);
    }
    loadMenuEvent(menu, e, component) {
        if (component._group) component = component._group;
        else if (component._row) component = component._row;
        menu = typeof menu == "function" ? menu.call(this.table, e, component.getComponent()) : menu;
        this.loadMenu(e, component, menu);
    }
    loadMenu(e, component, menu, parentEl, parentPopup) {
        var touch = !(e instanceof MouseEvent), menuEl = document.createElement("div"), popup;
        menuEl.classList.add("tabulator-menu");
        if (!touch) e.preventDefault();
        //abort if no menu set
        if (!menu || !menu.length) return;
        if (!parentEl) {
            if (this.nestedMenuBlock) {
                //abort if child menu already open
                if (this.rootPopup) return;
            } else this.nestedMenuBlock = setTimeout(()=>{
                this.nestedMenuBlock = false;
            }, 100);
            if (this.rootPopup) this.rootPopup.hide();
            this.rootPopup = popup = this.popup(menuEl);
        } else popup = parentPopup.child(menuEl);
        menu.forEach((item)=>{
            var itemEl = document.createElement("div"), label = item.label, disabled = item.disabled;
            if (item.separator) itemEl.classList.add("tabulator-menu-separator");
            else {
                itemEl.classList.add("tabulator-menu-item");
                if (typeof label == "function") label = label.call(this.table, component.getComponent());
                if (label instanceof Node) itemEl.appendChild(label);
                else itemEl.innerHTML = label;
                if (typeof disabled == "function") disabled = disabled.call(this.table, component.getComponent());
                if (disabled) {
                    itemEl.classList.add("tabulator-menu-item-disabled");
                    itemEl.addEventListener("click", (e)=>{
                        e.stopPropagation();
                    });
                } else {
                    if (item.menu && item.menu.length) itemEl.addEventListener("click", (e)=>{
                        e.stopPropagation();
                        this.loadMenu(e, component, item.menu, itemEl, popup);
                    });
                    else if (item.action) itemEl.addEventListener("click", (e)=>{
                        item.action(e, component.getComponent());
                    });
                }
                if (item.menu && item.menu.length) itemEl.classList.add("tabulator-menu-item-submenu");
            }
            menuEl.appendChild(itemEl);
        });
        menuEl.addEventListener("click", (e)=>{
            if (this.rootPopup) this.rootPopup.hide();
        });
        popup.show(parentEl || e);
        if (popup === this.rootPopup) {
            this.rootPopup.hideOnBlur(()=>{
                this.rootPopup = null;
                if (this.currentComponent) {
                    this.dispatch("menu-closed", menu, popup);
                    this.dispatchExternal("menuClosed", this.currentComponent.getComponent());
                    this.currentComponent = null;
                }
            });
            this.currentComponent = component;
            this.dispatch("menu-opened", menu, popup);
            this.dispatchExternal("menuOpened", component.getComponent());
        }
    }
}
class $c2a9788f40f9c90a$export$9ab7496e9b38c128 extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "moveColumn";
    constructor(table){
        super(table);
        this.placeholderElement = this.createPlaceholderElement();
        this.hoverElement = false; //floating column header element
        this.checkTimeout = false; //click check timeout holder
        this.checkPeriod = 250; //period to wait on mousedown to consider this a move and not a click
        this.moving = false; //currently moving column
        this.toCol = false; //destination column
        this.toColAfter = false; //position of moving column relative to the destination column
        this.startX = 0; //starting position within header element
        this.autoScrollMargin = 40; //auto scroll on edge when within margin
        this.autoScrollStep = 5; //auto scroll distance in pixels
        this.autoScrollTimeout = false; //auto scroll timeout
        this.touchMove = false;
        this.moveHover = this.moveHover.bind(this);
        this.endMove = this.endMove.bind(this);
        this.registerTableOption("movableColumns", false); //enable movable columns
    }
    createPlaceholderElement() {
        var el = document.createElement("div");
        el.classList.add("tabulator-col");
        el.classList.add("tabulator-col-placeholder");
        return el;
    }
    initialize() {
        if (this.table.options.movableColumns) {
            this.subscribe("column-init", this.initializeColumn.bind(this));
            this.subscribe("alert-show", this.abortMove.bind(this));
        }
    }
    abortMove() {
        clearTimeout(this.checkTimeout);
    }
    initializeColumn(column) {
        var self = this, config = {}, colEl;
        if (!column.modules.frozen && !column.isGroup && !column.isRowHeader) {
            colEl = column.getElement();
            config.mousemove = (function(e) {
                if (column.parent === self.moving.parent) {
                    if ((self.touchMove ? e.touches[0].pageX : e.pageX) - $c2a9788f40f9c90a$var$Helpers.elOffset(colEl).left + self.table.columnManager.contentsElement.scrollLeft > column.getWidth() / 2) {
                        if (self.toCol !== column || !self.toColAfter) {
                            colEl.parentNode.insertBefore(self.placeholderElement, colEl.nextSibling);
                            self.moveColumn(column, true);
                        }
                    } else if (self.toCol !== column || self.toColAfter) {
                        colEl.parentNode.insertBefore(self.placeholderElement, colEl);
                        self.moveColumn(column, false);
                    }
                }
            }).bind(self);
            colEl.addEventListener("mousedown", function(e) {
                self.touchMove = false;
                if (e.which === 1) self.checkTimeout = setTimeout(function() {
                    self.startMove(e, column);
                }, self.checkPeriod);
            });
            colEl.addEventListener("mouseup", function(e) {
                if (e.which === 1) {
                    if (self.checkTimeout) clearTimeout(self.checkTimeout);
                }
            });
            self.bindTouchEvents(column);
        }
        column.modules.moveColumn = config;
    }
    bindTouchEvents(column) {
        var colEl = column.getElement(), startXMove = false, nextCol, prevCol, nextColWidth, prevColWidth, nextColWidthLast, prevColWidthLast;
        colEl.addEventListener("touchstart", (e)=>{
            this.checkTimeout = setTimeout(()=>{
                this.touchMove = true;
                nextCol = column.nextColumn();
                nextColWidth = nextCol ? nextCol.getWidth() / 2 : 0;
                prevCol = column.prevColumn();
                prevColWidth = prevCol ? prevCol.getWidth() / 2 : 0;
                nextColWidthLast = 0;
                prevColWidthLast = 0;
                startXMove = false;
                this.startMove(e, column);
            }, this.checkPeriod);
        }, {
            passive: true
        });
        colEl.addEventListener("touchmove", (e)=>{
            var diff, moveToCol;
            if (this.moving) {
                this.moveHover(e);
                if (!startXMove) startXMove = e.touches[0].pageX;
                diff = e.touches[0].pageX - startXMove;
                if (diff > 0) {
                    if (nextCol && diff - nextColWidthLast > nextColWidth) {
                        moveToCol = nextCol;
                        if (moveToCol !== column) {
                            startXMove = e.touches[0].pageX;
                            moveToCol.getElement().parentNode.insertBefore(this.placeholderElement, moveToCol.getElement().nextSibling);
                            this.moveColumn(moveToCol, true);
                        }
                    }
                } else if (prevCol && -diff - prevColWidthLast > prevColWidth) {
                    moveToCol = prevCol;
                    if (moveToCol !== column) {
                        startXMove = e.touches[0].pageX;
                        moveToCol.getElement().parentNode.insertBefore(this.placeholderElement, moveToCol.getElement());
                        this.moveColumn(moveToCol, false);
                    }
                }
                if (moveToCol) {
                    nextCol = moveToCol.nextColumn();
                    nextColWidthLast = nextColWidth;
                    nextColWidth = nextCol ? nextCol.getWidth() / 2 : 0;
                    prevCol = moveToCol.prevColumn();
                    prevColWidthLast = prevColWidth;
                    prevColWidth = prevCol ? prevCol.getWidth() / 2 : 0;
                }
            }
        }, {
            passive: true
        });
        colEl.addEventListener("touchend", (e)=>{
            if (this.checkTimeout) clearTimeout(this.checkTimeout);
            if (this.moving) this.endMove(e);
        });
    }
    startMove(e, column) {
        var element = column.getElement(), headerElement = this.table.columnManager.getContentsElement(), headersElement = this.table.columnManager.getHeadersElement();
        //Prevent moving columns when range selection is active
        if (this.table.modules.selectRange && this.table.modules.selectRange.columnSelection) {
            if (this.table.modules.selectRange.mousedown && this.table.modules.selectRange.selecting === "column") return;
        }
        this.moving = column;
        this.startX = (this.touchMove ? e.touches[0].pageX : e.pageX) - $c2a9788f40f9c90a$var$Helpers.elOffset(element).left;
        this.table.element.classList.add("tabulator-block-select");
        //create placeholder
        this.placeholderElement.style.width = column.getWidth() + "px";
        this.placeholderElement.style.height = column.getHeight() + "px";
        element.parentNode.insertBefore(this.placeholderElement, element);
        element.parentNode.removeChild(element);
        //create hover element
        this.hoverElement = element.cloneNode(true);
        this.hoverElement.classList.add("tabulator-moving");
        headerElement.appendChild(this.hoverElement);
        this.hoverElement.style.left = "0";
        this.hoverElement.style.bottom = headerElement.clientHeight - headersElement.offsetHeight + "px";
        if (!this.touchMove) {
            this._bindMouseMove();
            document.body.addEventListener("mousemove", this.moveHover);
            document.body.addEventListener("mouseup", this.endMove);
        }
        this.moveHover(e);
        this.dispatch("column-moving", e, this.moving);
    }
    _bindMouseMove() {
        this.table.columnManager.columnsByIndex.forEach(function(column) {
            if (column.modules.moveColumn.mousemove) column.getElement().addEventListener("mousemove", column.modules.moveColumn.mousemove);
        });
    }
    _unbindMouseMove() {
        this.table.columnManager.columnsByIndex.forEach(function(column) {
            if (column.modules.moveColumn.mousemove) column.getElement().removeEventListener("mousemove", column.modules.moveColumn.mousemove);
        });
    }
    moveColumn(column, after) {
        var movingCells = this.moving.getCells();
        this.toCol = column;
        this.toColAfter = after;
        if (after) column.getCells().forEach(function(cell, i) {
            var cellEl = cell.getElement(true);
            if (cellEl.parentNode && movingCells[i]) cellEl.parentNode.insertBefore(movingCells[i].getElement(), cellEl.nextSibling);
        });
        else column.getCells().forEach(function(cell, i) {
            var cellEl = cell.getElement(true);
            if (cellEl.parentNode && movingCells[i]) cellEl.parentNode.insertBefore(movingCells[i].getElement(), cellEl);
        });
    }
    endMove(e) {
        if (e.which === 1 || this.touchMove) {
            this._unbindMouseMove();
            this.placeholderElement.parentNode.insertBefore(this.moving.getElement(), this.placeholderElement.nextSibling);
            this.placeholderElement.parentNode.removeChild(this.placeholderElement);
            this.hoverElement.parentNode.removeChild(this.hoverElement);
            this.table.element.classList.remove("tabulator-block-select");
            if (this.toCol) this.table.columnManager.moveColumnActual(this.moving, this.toCol, this.toColAfter);
            this.moving = false;
            this.toCol = false;
            this.toColAfter = false;
            if (!this.touchMove) {
                document.body.removeEventListener("mousemove", this.moveHover);
                document.body.removeEventListener("mouseup", this.endMove);
            }
        }
    }
    moveHover(e) {
        var columnHolder = this.table.columnManager.getContentsElement(), scrollLeft = columnHolder.scrollLeft, xPos = (this.touchMove ? e.touches[0].pageX : e.pageX) - $c2a9788f40f9c90a$var$Helpers.elOffset(columnHolder).left + scrollLeft, scrollPos;
        this.hoverElement.style.left = xPos - this.startX + "px";
        if (xPos - scrollLeft < this.autoScrollMargin) {
            if (!this.autoScrollTimeout) this.autoScrollTimeout = setTimeout(()=>{
                scrollPos = Math.max(0, scrollLeft - 5);
                this.table.rowManager.getElement().scrollLeft = scrollPos;
                this.autoScrollTimeout = false;
            }, 1);
        }
        if (scrollLeft + columnHolder.clientWidth - xPos < this.autoScrollMargin) {
            if (!this.autoScrollTimeout) this.autoScrollTimeout = setTimeout(()=>{
                scrollPos = Math.min(columnHolder.clientWidth, scrollLeft + 5);
                this.table.rowManager.getElement().scrollLeft = scrollPos;
                this.autoScrollTimeout = false;
            }, 1);
        }
    }
}
var $c2a9788f40f9c90a$var$defaultSenders = {
    delete: function(fromRow, toRow, toTable) {
        fromRow.delete();
    }
};
var $c2a9788f40f9c90a$var$defaultReceivers = {
    insert: function(fromRow, toRow, fromTable) {
        this.table.addRow(fromRow.getData(), undefined, toRow);
        return true;
    },
    add: function(fromRow, toRow, fromTable) {
        this.table.addRow(fromRow.getData());
        return true;
    },
    update: function(fromRow, toRow, fromTable) {
        if (toRow) {
            toRow.update(fromRow.getData());
            return true;
        }
        return false;
    },
    replace: function(fromRow, toRow, fromTable) {
        if (toRow) {
            this.table.addRow(fromRow.getData(), undefined, toRow);
            toRow.delete();
            return true;
        }
        return false;
    }
};
class $c2a9788f40f9c90a$export$7815d73158f0bb2d extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "moveRow";
    //load defaults
    static senders = $c2a9788f40f9c90a$var$defaultSenders;
    static receivers = $c2a9788f40f9c90a$var$defaultReceivers;
    constructor(table){
        super(table);
        this.placeholderElement = this.createPlaceholderElement();
        this.hoverElement = false; //floating row header element
        this.checkTimeout = false; //click check timeout holder
        this.checkPeriod = 150; //period to wait on mousedown to consider this a move and not a click
        this.moving = false; //currently moving row
        this.toRow = false; //destination row
        this.toRowAfter = false; //position of moving row relative to the destination row
        this.hasHandle = false; //row has handle instead of fully movable row
        this.startY = 0; //starting Y position within header element
        this.startX = 0; //starting X position within header element
        this.moveHover = this.moveHover.bind(this);
        this.endMove = this.endMove.bind(this);
        this.tableRowDropEvent = false;
        this.touchMove = false;
        this.connection = false;
        this.connectionSelectorsTables = false;
        this.connectionSelectorsElements = false;
        this.connectionElements = [];
        this.connections = [];
        this.connectedTable = false;
        this.connectedRow = false;
        this.registerTableOption("movableRows", false); //enable movable rows
        this.registerTableOption("movableRowsConnectedTables", false); //tables for movable rows to be connected to
        this.registerTableOption("movableRowsConnectedElements", false); //other elements for movable rows to be connected to
        this.registerTableOption("movableRowsSender", false);
        this.registerTableOption("movableRowsReceiver", "insert");
        this.registerColumnOption("rowHandle");
    }
    createPlaceholderElement() {
        var el = document.createElement("div");
        el.classList.add("tabulator-row");
        el.classList.add("tabulator-row-placeholder");
        return el;
    }
    initialize() {
        if (this.table.options.movableRows) {
            this.connectionSelectorsTables = this.table.options.movableRowsConnectedTables;
            this.connectionSelectorsElements = this.table.options.movableRowsConnectedElements;
            this.connection = this.connectionSelectorsTables || this.connectionSelectorsElements;
            this.subscribe("cell-init", this.initializeCell.bind(this));
            this.subscribe("column-init", this.initializeColumn.bind(this));
            this.subscribe("row-init", this.initializeRow.bind(this));
        }
    }
    initializeGroupHeader(group) {
        var self = this, config = {};
        //inter table drag drop
        config.mouseup = (function(e) {
            self.tableRowDrop(e, group);
        }).bind(self);
        //same table drag drop
        config.mousemove = (function(e) {
            var rowEl;
            if (e.pageY - $c2a9788f40f9c90a$var$Helpers.elOffset(group.element).top + self.table.rowManager.element.scrollTop > group.getHeight() / 2) {
                if (self.toRow !== group || !self.toRowAfter) {
                    rowEl = group.getElement();
                    rowEl.parentNode.insertBefore(self.placeholderElement, rowEl.nextSibling);
                    self.moveRow(group, true);
                }
            } else if (self.toRow !== group || self.toRowAfter) {
                rowEl = group.getElement();
                if (rowEl.previousSibling) {
                    rowEl.parentNode.insertBefore(self.placeholderElement, rowEl);
                    self.moveRow(group, false);
                }
            }
        }).bind(self);
        group.modules.moveRow = config;
    }
    initializeRow(row) {
        var self = this, config = {}, rowEl;
        //inter table drag drop
        config.mouseup = (function(e) {
            self.tableRowDrop(e, row);
        }).bind(self);
        //same table drag drop
        config.mousemove = (function(e) {
            var rowEl = row.getElement();
            if (e.pageY - $c2a9788f40f9c90a$var$Helpers.elOffset(rowEl).top + self.table.rowManager.element.scrollTop > row.getHeight() / 2) {
                if (self.toRow !== row || !self.toRowAfter) {
                    rowEl.parentNode.insertBefore(self.placeholderElement, rowEl.nextSibling);
                    self.moveRow(row, true);
                }
            } else if (self.toRow !== row || self.toRowAfter) {
                rowEl.parentNode.insertBefore(self.placeholderElement, rowEl);
                self.moveRow(row, false);
            }
        }).bind(self);
        if (!this.hasHandle) {
            rowEl = row.getElement();
            rowEl.addEventListener("mousedown", function(e) {
                if (e.which === 1) self.checkTimeout = setTimeout(function() {
                    self.startMove(e, row);
                }, self.checkPeriod);
            });
            rowEl.addEventListener("mouseup", function(e) {
                if (e.which === 1) {
                    if (self.checkTimeout) clearTimeout(self.checkTimeout);
                }
            });
            this.bindTouchEvents(row, row.getElement());
        }
        row.modules.moveRow = config;
    }
    initializeColumn(column) {
        if (column.definition.rowHandle && this.table.options.movableRows !== false) this.hasHandle = true;
    }
    initializeCell(cell) {
        if (cell.column.definition.rowHandle && this.table.options.movableRows !== false) {
            var self = this, cellEl = cell.getElement(true);
            cellEl.addEventListener("mousedown", function(e) {
                if (e.which === 1) self.checkTimeout = setTimeout(function() {
                    self.startMove(e, cell.row);
                }, self.checkPeriod);
            });
            cellEl.addEventListener("mouseup", function(e) {
                if (e.which === 1) {
                    if (self.checkTimeout) clearTimeout(self.checkTimeout);
                }
            });
            this.bindTouchEvents(cell.row, cellEl);
        }
    }
    bindTouchEvents(row, element) {
        var startYMove = false, nextRow, prevRow, nextRowHeight, prevRowHeight, nextRowHeightLast, prevRowHeightLast;
        element.addEventListener("touchstart", (e)=>{
            this.checkTimeout = setTimeout(()=>{
                this.touchMove = true;
                nextRow = row.nextRow();
                nextRowHeight = nextRow ? nextRow.getHeight() / 2 : 0;
                prevRow = row.prevRow();
                prevRowHeight = prevRow ? prevRow.getHeight() / 2 : 0;
                nextRowHeightLast = 0;
                prevRowHeightLast = 0;
                startYMove = false;
                this.startMove(e, row);
            }, this.checkPeriod);
        }, {
            passive: true
        });
        this.moving, this.toRow, this.toRowAfter;
        element.addEventListener("touchmove", (e)=>{
            var diff, moveToRow;
            if (this.moving) {
                e.preventDefault();
                this.moveHover(e);
                if (!startYMove) startYMove = e.touches[0].pageY;
                diff = e.touches[0].pageY - startYMove;
                if (diff > 0) {
                    if (nextRow && diff - nextRowHeightLast > nextRowHeight) {
                        moveToRow = nextRow;
                        if (moveToRow !== row) {
                            startYMove = e.touches[0].pageY;
                            moveToRow.getElement().parentNode.insertBefore(this.placeholderElement, moveToRow.getElement().nextSibling);
                            this.moveRow(moveToRow, true);
                        }
                    }
                } else if (prevRow && -diff - prevRowHeightLast > prevRowHeight) {
                    moveToRow = prevRow;
                    if (moveToRow !== row) {
                        startYMove = e.touches[0].pageY;
                        moveToRow.getElement().parentNode.insertBefore(this.placeholderElement, moveToRow.getElement());
                        this.moveRow(moveToRow, false);
                    }
                }
                if (moveToRow) {
                    nextRow = moveToRow.nextRow();
                    nextRowHeightLast = nextRowHeight;
                    nextRowHeight = nextRow ? nextRow.getHeight() / 2 : 0;
                    prevRow = moveToRow.prevRow();
                    prevRowHeightLast = prevRowHeight;
                    prevRowHeight = prevRow ? prevRow.getHeight() / 2 : 0;
                }
            }
        });
        element.addEventListener("touchend", (e)=>{
            if (this.checkTimeout) clearTimeout(this.checkTimeout);
            if (this.moving) {
                this.endMove(e);
                this.touchMove = false;
            }
        });
    }
    _bindMouseMove() {
        this.table.rowManager.getDisplayRows().forEach((row)=>{
            if ((row.type === "row" || row.type === "group") && row.modules.moveRow && row.modules.moveRow.mousemove) row.getElement().addEventListener("mousemove", row.modules.moveRow.mousemove);
        });
    }
    _unbindMouseMove() {
        this.table.rowManager.getDisplayRows().forEach((row)=>{
            if ((row.type === "row" || row.type === "group") && row.modules.moveRow && row.modules.moveRow.mousemove) row.getElement().removeEventListener("mousemove", row.modules.moveRow.mousemove);
        });
    }
    startMove(e, row) {
        var element = row.getElement();
        this.setStartPosition(e, row);
        this.moving = row;
        this.table.element.classList.add("tabulator-block-select");
        //create placeholder
        this.placeholderElement.style.width = row.getWidth() + "px";
        this.placeholderElement.style.height = row.getHeight() + "px";
        if (!this.connection) {
            element.parentNode.insertBefore(this.placeholderElement, element);
            element.parentNode.removeChild(element);
        } else {
            this.table.element.classList.add("tabulator-movingrow-sending");
            this.connectToTables(row);
        }
        //create hover element
        this.hoverElement = element.cloneNode(true);
        this.hoverElement.classList.add("tabulator-moving");
        if (this.connection) {
            document.body.appendChild(this.hoverElement);
            this.hoverElement.style.left = "0";
            this.hoverElement.style.top = "0";
            this.hoverElement.style.width = this.table.element.clientWidth + "px";
            this.hoverElement.style.whiteSpace = "nowrap";
            this.hoverElement.style.overflow = "hidden";
            this.hoverElement.style.pointerEvents = "none";
        } else {
            this.table.rowManager.getTableElement().appendChild(this.hoverElement);
            this.hoverElement.style.left = "0";
            this.hoverElement.style.top = "0";
            this._bindMouseMove();
        }
        document.body.addEventListener("mousemove", this.moveHover);
        document.body.addEventListener("mouseup", this.endMove);
        this.dispatchExternal("rowMoving", row.getComponent());
        this.moveHover(e);
    }
    setStartPosition(e, row) {
        var pageX = this.touchMove ? e.touches[0].pageX : e.pageX, pageY = this.touchMove ? e.touches[0].pageY : e.pageY, element, position;
        element = row.getElement();
        if (this.connection) {
            position = element.getBoundingClientRect();
            this.startX = position.left - pageX + window.pageXOffset;
            this.startY = position.top - pageY + window.pageYOffset;
        } else this.startY = pageY - element.getBoundingClientRect().top;
    }
    endMove(e) {
        if (!e || e.which === 1 || this.touchMove) {
            this._unbindMouseMove();
            if (!this.connection) {
                this.placeholderElement.parentNode.insertBefore(this.moving.getElement(), this.placeholderElement.nextSibling);
                this.placeholderElement.parentNode.removeChild(this.placeholderElement);
            }
            this.hoverElement.parentNode.removeChild(this.hoverElement);
            this.table.element.classList.remove("tabulator-block-select");
            if (this.toRow) this.table.rowManager.moveRow(this.moving, this.toRow, this.toRowAfter);
            else this.dispatchExternal("rowMoveCancelled", this.moving.getComponent());
            this.moving = false;
            this.toRow = false;
            this.toRowAfter = false;
            document.body.removeEventListener("mousemove", this.moveHover);
            document.body.removeEventListener("mouseup", this.endMove);
            if (this.connection) {
                this.table.element.classList.remove("tabulator-movingrow-sending");
                this.disconnectFromTables();
            }
        }
    }
    moveRow(row, after) {
        this.toRow = row;
        this.toRowAfter = after;
    }
    moveHover(e) {
        if (this.connection) this.moveHoverConnections.call(this, e);
        else this.moveHoverTable.call(this, e);
    }
    moveHoverTable(e) {
        var rowHolder = this.table.rowManager.getElement(), scrollTop = rowHolder.scrollTop, yPos = (this.touchMove ? e.touches[0].pageY : e.pageY) - rowHolder.getBoundingClientRect().top + scrollTop;
        this.hoverElement.style.top = Math.min(yPos - this.startY, this.table.rowManager.element.scrollHeight - this.hoverElement.offsetHeight) + "px";
    }
    moveHoverConnections(e) {
        this.hoverElement.style.left = this.startX + (this.touchMove ? e.touches[0].pageX : e.pageX) + "px";
        this.hoverElement.style.top = this.startY + (this.touchMove ? e.touches[0].pageY : e.pageY) + "px";
    }
    elementRowDrop(e, element, row) {
        this.dispatchExternal("movableRowsElementDrop", e, element, row ? row.getComponent() : false);
    }
    //establish connection with other tables
    connectToTables(row) {
        var connectionTables;
        if (this.connectionSelectorsTables) {
            connectionTables = this.commsConnections(this.connectionSelectorsTables);
            this.dispatchExternal("movableRowsSendingStart", connectionTables);
            this.commsSend(this.connectionSelectorsTables, "moveRow", "connect", {
                row: row
            });
        }
        if (this.connectionSelectorsElements) {
            this.connectionElements = [];
            if (!Array.isArray(this.connectionSelectorsElements)) this.connectionSelectorsElements = [
                this.connectionSelectorsElements
            ];
            this.connectionSelectorsElements.forEach((query)=>{
                if (typeof query === "string") this.connectionElements = this.connectionElements.concat(Array.prototype.slice.call(document.querySelectorAll(query)));
                else this.connectionElements.push(query);
            });
            this.connectionElements.forEach((element)=>{
                var dropEvent = (e)=>{
                    this.elementRowDrop(e, element, this.moving);
                };
                element.addEventListener("mouseup", dropEvent);
                element.tabulatorElementDropEvent = dropEvent;
                element.classList.add("tabulator-movingrow-receiving");
            });
        }
    }
    //disconnect from other tables
    disconnectFromTables() {
        var connectionTables;
        if (this.connectionSelectorsTables) {
            connectionTables = this.commsConnections(this.connectionSelectorsTables);
            this.dispatchExternal("movableRowsSendingStop", connectionTables);
            this.commsSend(this.connectionSelectorsTables, "moveRow", "disconnect");
        }
        this.connectionElements.forEach((element)=>{
            element.classList.remove("tabulator-movingrow-receiving");
            element.removeEventListener("mouseup", element.tabulatorElementDropEvent);
            delete element.tabulatorElementDropEvent;
        });
    }
    //accept incomming connection
    connect(table, row) {
        if (!this.connectedTable) {
            this.connectedTable = table;
            this.connectedRow = row;
            this.table.element.classList.add("tabulator-movingrow-receiving");
            this.table.rowManager.getDisplayRows().forEach((row)=>{
                if (row.type === "row" && row.modules.moveRow && row.modules.moveRow.mouseup) row.getElement().addEventListener("mouseup", row.modules.moveRow.mouseup);
            });
            this.tableRowDropEvent = this.tableRowDrop.bind(this);
            this.table.element.addEventListener("mouseup", this.tableRowDropEvent);
            this.dispatchExternal("movableRowsReceivingStart", row, table);
            return true;
        } else {
            console.warn("Move Row Error - Table cannot accept connection, already connected to table:", this.connectedTable);
            return false;
        }
    }
    //close incoming connection
    disconnect(table) {
        if (table === this.connectedTable) {
            this.connectedTable = false;
            this.connectedRow = false;
            this.table.element.classList.remove("tabulator-movingrow-receiving");
            this.table.rowManager.getDisplayRows().forEach((row)=>{
                if (row.type === "row" && row.modules.moveRow && row.modules.moveRow.mouseup) row.getElement().removeEventListener("mouseup", row.modules.moveRow.mouseup);
            });
            this.table.element.removeEventListener("mouseup", this.tableRowDropEvent);
            this.dispatchExternal("movableRowsReceivingStop", table);
        } else console.warn("Move Row Error - trying to disconnect from non connected table");
    }
    dropComplete(table, row, success) {
        var sender = false;
        if (success) {
            switch(typeof this.table.options.movableRowsSender){
                case "string":
                    sender = $c2a9788f40f9c90a$export$7815d73158f0bb2d.senders[this.table.options.movableRowsSender];
                    break;
                case "function":
                    sender = this.table.options.movableRowsSender;
                    break;
            }
            if (sender) sender.call(this, this.moving ? this.moving.getComponent() : undefined, row ? row.getComponent() : undefined, table);
            else if (this.table.options.movableRowsSender) console.warn("Mover Row Error - no matching sender found:", this.table.options.movableRowsSender);
            this.dispatchExternal("movableRowsSent", this.moving.getComponent(), row ? row.getComponent() : undefined, table);
        } else this.dispatchExternal("movableRowsSentFailed", this.moving.getComponent(), row ? row.getComponent() : undefined, table);
        this.endMove();
    }
    tableRowDrop(e, row) {
        var receiver = false, success = false;
        e.stopImmediatePropagation();
        switch(typeof this.table.options.movableRowsReceiver){
            case "string":
                receiver = $c2a9788f40f9c90a$export$7815d73158f0bb2d.receivers[this.table.options.movableRowsReceiver];
                break;
            case "function":
                receiver = this.table.options.movableRowsReceiver;
                break;
        }
        if (receiver) success = receiver.call(this, this.connectedRow.getComponent(), row ? row.getComponent() : undefined, this.connectedTable);
        else console.warn("Mover Row Error - no matching receiver found:", this.table.options.movableRowsReceiver);
        if (success) this.dispatchExternal("movableRowsReceived", this.connectedRow.getComponent(), row ? row.getComponent() : undefined, this.connectedTable);
        else this.dispatchExternal("movableRowsReceivedFailed", this.connectedRow.getComponent(), row ? row.getComponent() : undefined, this.connectedTable);
        this.commsSend(this.connectedTable, "moveRow", "dropcomplete", {
            row: row,
            success: success
        });
    }
    commsReceived(table, action, data) {
        switch(action){
            case "connect":
                return this.connect(table, data.row);
            case "disconnect":
                return this.disconnect(table);
            case "dropcomplete":
                return this.dropComplete(table, data.row, data.success);
        }
    }
}
var $c2a9788f40f9c90a$var$defaultMutators = {};
class $c2a9788f40f9c90a$export$d0f669567356cabd extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "mutator";
    //load defaults
    static mutators = $c2a9788f40f9c90a$var$defaultMutators;
    constructor(table){
        super(table);
        this.allowedTypes = [
            "",
            "data",
            "edit",
            "clipboard"
        ]; //list of mutation types
        this.enabled = true;
        this.registerColumnOption("mutator");
        this.registerColumnOption("mutatorParams");
        this.registerColumnOption("mutatorData");
        this.registerColumnOption("mutatorDataParams");
        this.registerColumnOption("mutatorEdit");
        this.registerColumnOption("mutatorEditParams");
        this.registerColumnOption("mutatorClipboard");
        this.registerColumnOption("mutatorClipboardParams");
        this.registerColumnOption("mutateLink");
    }
    initialize() {
        this.subscribe("cell-value-changing", this.transformCell.bind(this));
        this.subscribe("cell-value-changed", this.mutateLink.bind(this));
        this.subscribe("column-layout", this.initializeColumn.bind(this));
        this.subscribe("row-data-init-before", this.rowDataChanged.bind(this));
        this.subscribe("row-data-changing", this.rowDataChanged.bind(this));
    }
    rowDataChanged(row, tempData, updatedData) {
        return this.transformRow(tempData, "data", updatedData);
    }
    //initialize column mutator
    initializeColumn(column) {
        var match = false, config = {};
        this.allowedTypes.forEach((type)=>{
            var key = "mutator" + (type.charAt(0).toUpperCase() + type.slice(1)), mutator;
            if (column.definition[key]) {
                mutator = this.lookupMutator(column.definition[key]);
                if (mutator) {
                    match = true;
                    config[key] = {
                        mutator: mutator,
                        params: column.definition[key + "Params"] || {}
                    };
                }
            }
        });
        if (match) column.modules.mutate = config;
    }
    lookupMutator(value) {
        var mutator = false;
        //set column mutator
        switch(typeof value){
            case "string":
                if ($c2a9788f40f9c90a$export$d0f669567356cabd.mutators[value]) mutator = $c2a9788f40f9c90a$export$d0f669567356cabd.mutators[value];
                else console.warn("Mutator Error - No such mutator found, ignoring: ", value);
                break;
            case "function":
                mutator = value;
                break;
        }
        return mutator;
    }
    //apply mutator to row
    transformRow(data, type, updatedData) {
        var key = "mutator" + (type.charAt(0).toUpperCase() + type.slice(1)), value;
        if (this.enabled) this.table.columnManager.traverse((column)=>{
            var mutator, params, component;
            if (column.modules.mutate) {
                mutator = column.modules.mutate[key] || column.modules.mutate.mutator || false;
                if (mutator) {
                    value = column.getFieldValue(typeof updatedData !== "undefined" ? updatedData : data);
                    if (type == "data" && !updatedData || typeof value !== "undefined") {
                        component = column.getComponent();
                        params = typeof mutator.params === "function" ? mutator.params(value, data, type, component) : mutator.params;
                        column.setFieldValue(data, mutator.mutator(value, data, type, params, component));
                    }
                }
            }
        });
        return data;
    }
    //apply mutator to new cell value
    transformCell(cell, value) {
        if (cell.column.modules.mutate) {
            var mutator = cell.column.modules.mutate.mutatorEdit || cell.column.modules.mutate.mutator || false, tempData = {};
            if (mutator) {
                tempData = Object.assign(tempData, cell.row.getData());
                cell.column.setFieldValue(tempData, value);
                return mutator.mutator(value, tempData, "edit", mutator.params, cell.getComponent());
            }
        }
        return value;
    }
    mutateLink(cell) {
        var links = cell.column.definition.mutateLink;
        if (links) {
            if (!Array.isArray(links)) links = [
                links
            ];
            links.forEach((link)=>{
                var linkCell = cell.row.getCell(link);
                if (linkCell) linkCell.setValue(linkCell.getValue(), true, true);
            });
        }
    }
    enable() {
        this.enabled = true;
    }
    disable() {
        this.enabled = false;
    }
}
function $c2a9788f40f9c90a$var$rows(pageSize, currentRow, currentPage, totalRows, totalPages) {
    var el = document.createElement("span"), showingEl = document.createElement("span"), valueEl = document.createElement("span"), ofEl = document.createElement("span"), totalEl = document.createElement("span"), rowsEl = document.createElement("span");
    this.table.modules.localize.langBind("pagination|counter|showing", (value)=>{
        showingEl.innerHTML = value;
    });
    this.table.modules.localize.langBind("pagination|counter|of", (value)=>{
        ofEl.innerHTML = value;
    });
    this.table.modules.localize.langBind("pagination|counter|rows", (value)=>{
        rowsEl.innerHTML = value;
    });
    if (totalRows) {
        valueEl.innerHTML = " " + currentRow + "-" + Math.min(currentRow + pageSize - 1, totalRows) + " ";
        totalEl.innerHTML = " " + totalRows + " ";
        el.appendChild(showingEl);
        el.appendChild(valueEl);
        el.appendChild(ofEl);
        el.appendChild(totalEl);
        el.appendChild(rowsEl);
    } else {
        valueEl.innerHTML = " 0 ";
        el.appendChild(showingEl);
        el.appendChild(valueEl);
        el.appendChild(rowsEl);
    }
    return el;
}
function $c2a9788f40f9c90a$var$pages(pageSize, currentRow, currentPage, totalRows, totalPages) {
    var el = document.createElement("span"), showingEl = document.createElement("span"), valueEl = document.createElement("span"), ofEl = document.createElement("span"), totalEl = document.createElement("span"), rowsEl = document.createElement("span");
    this.table.modules.localize.langBind("pagination|counter|showing", (value)=>{
        showingEl.innerHTML = value;
    });
    valueEl.innerHTML = " " + currentPage + " ";
    this.table.modules.localize.langBind("pagination|counter|of", (value)=>{
        ofEl.innerHTML = value;
    });
    totalEl.innerHTML = " " + totalPages + " ";
    this.table.modules.localize.langBind("pagination|counter|pages", (value)=>{
        rowsEl.innerHTML = value;
    });
    el.appendChild(showingEl);
    el.appendChild(valueEl);
    el.appendChild(ofEl);
    el.appendChild(totalEl);
    el.appendChild(rowsEl);
    return el;
}
var $c2a9788f40f9c90a$var$defaultPageCounters = {
    rows: $c2a9788f40f9c90a$var$rows,
    pages: $c2a9788f40f9c90a$var$pages
};
class $c2a9788f40f9c90a$export$7eba6c45a494ceac extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "page";
    //load defaults
    static pageCounters = $c2a9788f40f9c90a$var$defaultPageCounters;
    constructor(table){
        super(table);
        this.mode = "local";
        this.progressiveLoad = false;
        this.element = null;
        this.pageCounterElement = null;
        this.pageCounter = null;
        this.size = 0;
        this.page = 1;
        this.count = 5;
        this.max = 1;
        this.remoteRowCountEstimate = null;
        this.initialLoad = true;
        this.dataChanging = false; //flag to check if data is being changed by this module
        this.pageSizes = [];
        this.registerTableOption("pagination", false); //set pagination type
        this.registerTableOption("paginationMode", "local"); //local or remote pagination
        this.registerTableOption("paginationSize", false); //set number of rows to a page
        this.registerTableOption("paginationInitialPage", 1); //initial page to show on load
        this.registerTableOption("paginationCounter", false); // set pagination counter
        this.registerTableOption("paginationCounterElement", false); // set pagination counter
        this.registerTableOption("paginationButtonCount", 5); // set count of page button
        this.registerTableOption("paginationSizeSelector", false); //add pagination size selector element
        this.registerTableOption("paginationElement", false); //element to hold pagination numbers
        // this.registerTableOption("paginationDataSent", {}); //pagination data sent to the server
        // this.registerTableOption("paginationDataReceived", {}); //pagination data received from the server
        this.registerTableOption("paginationAddRow", "page"); //add rows on table or page
        this.registerTableOption("progressiveLoad", false); //progressive loading
        this.registerTableOption("progressiveLoadDelay", 0); //delay between requests
        this.registerTableOption("progressiveLoadScrollMargin", 0); //margin before scroll begins
        this.registerTableFunction("setMaxPage", this.setMaxPage.bind(this));
        this.registerTableFunction("setPage", this.setPage.bind(this));
        this.registerTableFunction("setPageToRow", this.userSetPageToRow.bind(this));
        this.registerTableFunction("setPageSize", this.userSetPageSize.bind(this));
        this.registerTableFunction("getPageSize", this.getPageSize.bind(this));
        this.registerTableFunction("previousPage", this.previousPage.bind(this));
        this.registerTableFunction("nextPage", this.nextPage.bind(this));
        this.registerTableFunction("getPage", this.getPage.bind(this));
        this.registerTableFunction("getPageMax", this.getPageMax.bind(this));
        //register component functions
        this.registerComponentFunction("row", "pageTo", this.setPageToRow.bind(this));
    }
    initialize() {
        if (this.table.options.pagination) {
            this.subscribe("row-deleted", this.rowsUpdated.bind(this));
            this.subscribe("row-added", this.rowsUpdated.bind(this));
            this.subscribe("data-processed", this.initialLoadComplete.bind(this));
            this.subscribe("table-built", this.calculatePageSizes.bind(this));
            this.subscribe("footer-redraw", this.footerRedraw.bind(this));
            if (this.table.options.paginationAddRow == "page") this.subscribe("row-adding-position", this.rowAddingPosition.bind(this));
            if (this.table.options.paginationMode === "remote") {
                this.subscribe("data-params", this.remotePageParams.bind(this));
                this.subscribe("data-loaded", this._parseRemoteData.bind(this));
            }
            if (this.table.options.progressiveLoad) console.error("Progressive Load Error - Pagination and progressive load cannot be used at the same time");
            this.registerDisplayHandler(this.restOnRenderBefore.bind(this), 40);
            this.registerDisplayHandler(this.getRows.bind(this), 50);
            this.createElements();
            this.initializePageCounter();
            this.initializePaginator();
        } else if (this.table.options.progressiveLoad) {
            this.subscribe("data-params", this.remotePageParams.bind(this));
            this.subscribe("data-loaded", this._parseRemoteData.bind(this));
            this.subscribe("table-built", this.calculatePageSizes.bind(this));
            this.subscribe("data-processed", this.initialLoadComplete.bind(this));
            this.initializeProgressive(this.table.options.progressiveLoad);
            if (this.table.options.progressiveLoad === "scroll") this.subscribe("scroll-vertical", this.scrollVertical.bind(this));
        }
    }
    rowAddingPosition(row, top) {
        var rowManager = this.table.rowManager, displayRows = rowManager.getDisplayRows(), index;
        if (top) {
            if (displayRows.length) index = displayRows[0];
            else if (rowManager.activeRows.length) {
                index = rowManager.activeRows[rowManager.activeRows.length - 1];
                top = false;
            }
        } else if (displayRows.length) {
            index = displayRows[displayRows.length - 1];
            top = displayRows.length < this.size ? false : true;
        }
        return {
            index: index,
            top: top
        };
    }
    calculatePageSizes() {
        var testElRow, testElCell;
        if (this.table.options.paginationSize) this.size = this.table.options.paginationSize;
        else {
            testElRow = document.createElement("div");
            testElRow.classList.add("tabulator-row");
            testElRow.style.visibility = "hidden";
            testElCell = document.createElement("div");
            testElCell.classList.add("tabulator-cell");
            testElCell.innerHTML = "Page Row Test";
            testElRow.appendChild(testElCell);
            this.table.rowManager.getTableElement().appendChild(testElRow);
            this.size = Math.floor(this.table.rowManager.getElement().clientHeight / testElRow.offsetHeight);
            this.table.rowManager.getTableElement().removeChild(testElRow);
        }
        this.dispatchExternal("pageSizeChanged", this.size);
        this.generatePageSizeSelectList();
    }
    initialLoadComplete() {
        this.initialLoad = false;
    }
    remotePageParams(data, config, silent, params) {
        if (!this.initialLoad) {
            if (this.progressiveLoad && !silent || !this.progressiveLoad && !this.dataChanging) this.reset(true);
        }
        //configure request params
        params.page = this.page;
        //set page size if defined
        if (this.size) params.size = this.size;
        return params;
    }
    ///////////////////////////////////
    ///////// Table Functions /////////
    ///////////////////////////////////
    userSetPageToRow(row) {
        if (this.table.options.pagination) {
            row = this.table.rowManager.findRow(row);
            if (row) return this.setPageToRow(row);
        }
        return Promise.reject();
    }
    userSetPageSize(size) {
        if (this.table.options.pagination) {
            this.setPageSize(size);
            return this.setPage(1);
        } else return false;
    }
    ///////////////////////////////////
    ///////// Internal Logic //////////
    ///////////////////////////////////
    scrollVertical(top, dir) {
        var element, diff, margin;
        if (!dir && !this.table.dataLoader.loading) {
            element = this.table.rowManager.getElement();
            diff = element.scrollHeight - element.clientHeight - top;
            margin = this.table.options.progressiveLoadScrollMargin || element.clientHeight * 2;
            if (diff < margin) this.nextPage().catch(()=>{}); //consume the exception thrown when on the last page
        }
    }
    restOnRenderBefore(rows, renderInPosition) {
        if (!renderInPosition) {
            if (this.mode === "local") this.reset();
        }
        return rows;
    }
    rowsUpdated() {
        this.refreshData(true, "all");
    }
    createElements() {
        var button;
        this.element = document.createElement("span");
        this.element.classList.add("tabulator-paginator");
        this.pagesElement = document.createElement("span");
        this.pagesElement.classList.add("tabulator-pages");
        button = document.createElement("button");
        button.classList.add("tabulator-page");
        button.setAttribute("type", "button");
        button.setAttribute("role", "button");
        button.setAttribute("aria-label", "");
        button.setAttribute("title", "");
        this.firstBut = button.cloneNode(true);
        this.firstBut.setAttribute("data-page", "first");
        this.prevBut = button.cloneNode(true);
        this.prevBut.setAttribute("data-page", "prev");
        this.nextBut = button.cloneNode(true);
        this.nextBut.setAttribute("data-page", "next");
        this.lastBut = button.cloneNode(true);
        this.lastBut.setAttribute("data-page", "last");
        if (this.table.options.paginationSizeSelector) {
            this.pageSizeSelect = document.createElement("select");
            this.pageSizeSelect.classList.add("tabulator-page-size");
        }
    }
    generatePageSizeSelectList() {
        var pageSizes = [];
        if (this.pageSizeSelect) {
            if (Array.isArray(this.table.options.paginationSizeSelector)) {
                pageSizes = this.table.options.paginationSizeSelector;
                this.pageSizes = pageSizes;
                if (this.pageSizes.indexOf(this.size) == -1) pageSizes.unshift(this.size);
            } else if (this.pageSizes.indexOf(this.size) == -1) {
                pageSizes = [];
                for(let i = 1; i < 5; i++)pageSizes.push(this.size * i);
                this.pageSizes = pageSizes;
            } else pageSizes = this.pageSizes;
            while(this.pageSizeSelect.firstChild)this.pageSizeSelect.removeChild(this.pageSizeSelect.firstChild);
            pageSizes.forEach((item)=>{
                var itemEl = document.createElement("option");
                itemEl.value = item;
                if (item === true) this.langBind("pagination|all", function(value) {
                    itemEl.innerHTML = value;
                });
                else itemEl.innerHTML = item;
                this.pageSizeSelect.appendChild(itemEl);
            });
            this.pageSizeSelect.value = this.size;
        }
    }
    initializePageCounter() {
        var counter = this.table.options.paginationCounter, pageCounter = null;
        if (counter) {
            if (typeof counter === "function") pageCounter = counter;
            else pageCounter = $c2a9788f40f9c90a$export$7eba6c45a494ceac.pageCounters[counter];
            if (pageCounter) {
                this.pageCounter = pageCounter;
                this.pageCounterElement = document.createElement("span");
                this.pageCounterElement.classList.add("tabulator-page-counter");
            } else console.warn("Pagination Error - No such page counter found: ", counter);
        }
    }
    //setup pagination
    initializePaginator(hidden) {
        var pageSelectLabel, paginationCounterHolder;
        if (!hidden) {
            //build pagination element
            //bind localizations
            this.langBind("pagination|first", (value)=>{
                this.firstBut.innerHTML = value;
            });
            this.langBind("pagination|first_title", (value)=>{
                this.firstBut.setAttribute("aria-label", value);
                this.firstBut.setAttribute("title", value);
            });
            this.langBind("pagination|prev", (value)=>{
                this.prevBut.innerHTML = value;
            });
            this.langBind("pagination|prev_title", (value)=>{
                this.prevBut.setAttribute("aria-label", value);
                this.prevBut.setAttribute("title", value);
            });
            this.langBind("pagination|next", (value)=>{
                this.nextBut.innerHTML = value;
            });
            this.langBind("pagination|next_title", (value)=>{
                this.nextBut.setAttribute("aria-label", value);
                this.nextBut.setAttribute("title", value);
            });
            this.langBind("pagination|last", (value)=>{
                this.lastBut.innerHTML = value;
            });
            this.langBind("pagination|last_title", (value)=>{
                this.lastBut.setAttribute("aria-label", value);
                this.lastBut.setAttribute("title", value);
            });
            //click bindings
            this.firstBut.addEventListener("click", ()=>{
                this.setPage(1);
            });
            this.prevBut.addEventListener("click", ()=>{
                this.previousPage();
            });
            this.nextBut.addEventListener("click", ()=>{
                this.nextPage();
            });
            this.lastBut.addEventListener("click", ()=>{
                this.setPage(this.max);
            });
            if (this.table.options.paginationElement) this.element = this.table.options.paginationElement;
            if (this.pageSizeSelect) {
                pageSelectLabel = document.createElement("label");
                this.langBind("pagination|page_size", (value)=>{
                    this.pageSizeSelect.setAttribute("aria-label", value);
                    this.pageSizeSelect.setAttribute("title", value);
                    pageSelectLabel.innerHTML = value;
                });
                this.element.appendChild(pageSelectLabel);
                this.element.appendChild(this.pageSizeSelect);
                this.pageSizeSelect.addEventListener("change", (e)=>{
                    this.setPageSize(this.pageSizeSelect.value == "true" ? true : this.pageSizeSelect.value);
                    this.setPage(1);
                });
            }
            //append to DOM
            this.element.appendChild(this.firstBut);
            this.element.appendChild(this.prevBut);
            this.element.appendChild(this.pagesElement);
            this.element.appendChild(this.nextBut);
            this.element.appendChild(this.lastBut);
            if (!this.table.options.paginationElement) {
                if (this.table.options.paginationCounter) {
                    if (this.table.options.paginationCounterElement) {
                        if (this.table.options.paginationCounterElement instanceof HTMLElement) this.table.options.paginationCounterElement.appendChild(this.pageCounterElement);
                        else if (typeof this.table.options.paginationCounterElement === "string") {
                            paginationCounterHolder = document.querySelector(this.table.options.paginationCounterElement);
                            if (paginationCounterHolder) paginationCounterHolder.appendChild(this.pageCounterElement);
                            else console.warn("Pagination Error - Unable to find element matching paginationCounterElement selector:", this.table.options.paginationCounterElement);
                        }
                    } else this.footerAppend(this.pageCounterElement);
                }
                this.footerAppend(this.element);
            }
            this.page = this.table.options.paginationInitialPage;
            this.count = this.table.options.paginationButtonCount;
        }
        //set default values
        this.mode = this.table.options.paginationMode;
    }
    initializeProgressive(mode) {
        this.initializePaginator(true);
        this.mode = "progressive_" + mode;
        this.progressiveLoad = true;
    }
    trackChanges() {
        this.dispatch("page-changed");
    }
    //calculate maximum page from number of rows
    setMaxRows(rowCount) {
        if (!rowCount) this.max = 1;
        else this.max = this.size === true ? 1 : Math.ceil(rowCount / this.size);
        if (this.page > this.max) this.page = this.max;
    }
    //reset to first page without triggering action
    reset(force) {
        if (!this.initialLoad) {
            if (this.mode == "local" || force) {
                this.page = 1;
                this.trackChanges();
            }
        }
    }
    //set the maximum page
    setMaxPage(max) {
        max = parseInt(max);
        this.max = max || 1;
        if (this.page > this.max) {
            this.page = this.max;
            this.trigger();
        }
    }
    //set current page number
    setPage(page) {
        switch(page){
            case "first":
                return this.setPage(1);
            case "prev":
                return this.previousPage();
            case "next":
                return this.nextPage();
            case "last":
                return this.setPage(this.max);
        }
        page = parseInt(page);
        if (page > 0 && page <= this.max || this.mode !== "local") {
            this.page = page;
            this.trackChanges();
            return this.trigger();
        } else {
            console.warn("Pagination Error - Requested page is out of range of 1 - " + this.max + ":", page);
            return Promise.reject();
        }
    }
    setPageToRow(row) {
        var rows = this.displayRows(-1);
        var index = rows.indexOf(row);
        if (index > -1) {
            var page = this.size === true ? 1 : Math.ceil((index + 1) / this.size);
            return this.setPage(page);
        } else {
            console.warn("Pagination Error - Requested row is not visible");
            return Promise.reject();
        }
    }
    setPageSize(size) {
        if (size !== true) size = parseInt(size);
        if (size > 0) {
            this.size = size;
            this.dispatchExternal("pageSizeChanged", size);
        }
        if (this.pageSizeSelect) // this.pageSizeSelect.value = size;
        this.generatePageSizeSelectList();
        this.trackChanges();
    }
    _setPageCounter(totalRows, size, currentRow) {
        var content;
        if (this.pageCounter) {
            if (this.mode === "remote") {
                size = this.size;
                currentRow = (this.page - 1) * this.size + 1;
                totalRows = this.remoteRowCountEstimate;
            }
            content = this.pageCounter.call(this, size, currentRow, this.page, totalRows, this.max);
            switch(typeof content){
                case "object":
                    if (content instanceof Node) {
                        //clear previous cell contents
                        while(this.pageCounterElement.firstChild)this.pageCounterElement.removeChild(this.pageCounterElement.firstChild);
                        this.pageCounterElement.appendChild(content);
                    } else {
                        this.pageCounterElement.innerHTML = "";
                        if (content != null) console.warn("Page Counter Error - Page Counter has returned a type of object, the only valid page counter object return is an instance of Node, the page counter returned:", content);
                    }
                    break;
                case "undefined":
                    this.pageCounterElement.innerHTML = "";
                    break;
                default:
                    this.pageCounterElement.innerHTML = content;
            }
        }
    }
    //setup the pagination buttons
    _setPageButtons() {
        let leftSize = Math.floor((this.count - 1) / 2);
        let rightSize = Math.ceil((this.count - 1) / 2);
        let min = this.max - this.page + leftSize + 1 < this.count ? this.max - this.count + 1 : Math.max(this.page - leftSize, 1);
        let max = this.page <= rightSize ? Math.min(this.count, this.max) : Math.min(this.page + rightSize, this.max);
        while(this.pagesElement.firstChild)this.pagesElement.removeChild(this.pagesElement.firstChild);
        if (this.page == 1) {
            this.firstBut.disabled = true;
            this.prevBut.disabled = true;
        } else {
            this.firstBut.disabled = false;
            this.prevBut.disabled = false;
        }
        if (this.page == this.max) {
            this.lastBut.disabled = true;
            this.nextBut.disabled = true;
        } else {
            this.lastBut.disabled = false;
            this.nextBut.disabled = false;
        }
        for(let i = min; i <= max; i++)if (i > 0 && i <= this.max) this.pagesElement.appendChild(this._generatePageButton(i));
        this.footerRedraw();
    }
    _generatePageButton(page) {
        var button = document.createElement("button");
        button.classList.add("tabulator-page");
        if (page == this.page) button.classList.add("active");
        button.setAttribute("type", "button");
        button.setAttribute("role", "button");
        this.langBind("pagination|page_title", (value)=>{
            button.setAttribute("aria-label", value + " " + page);
            button.setAttribute("title", value + " " + page);
        });
        button.setAttribute("data-page", page);
        button.textContent = page;
        button.addEventListener("click", (e)=>{
            this.setPage(page);
        });
        return button;
    }
    //previous page
    previousPage() {
        if (this.page > 1) {
            this.page--;
            this.trackChanges();
            return this.trigger();
        } else {
            console.warn("Pagination Error - Previous page would be less than page 1:", 0);
            return Promise.reject();
        }
    }
    //next page
    nextPage() {
        if (this.page < this.max) {
            this.page++;
            this.trackChanges();
            return this.trigger();
        } else {
            if (!this.progressiveLoad) console.warn("Pagination Error - Next page would be greater than maximum page of " + this.max + ":", this.max + 1);
            return Promise.reject();
        }
    }
    //return current page number
    getPage() {
        return this.page;
    }
    //return max page number
    getPageMax() {
        return this.max;
    }
    getPageSize(size) {
        return this.size;
    }
    getMode() {
        return this.mode;
    }
    //return appropriate rows for current page
    getRows(data) {
        var actualRowPageSize = 0, output, start, end, actualStartRow;
        var actualRows = data.filter((row)=>{
            return row.type === "row";
        });
        if (this.mode == "local") {
            output = [];
            this.setMaxRows(data.length);
            if (this.size === true) {
                start = 0;
                end = data.length;
            } else {
                start = this.size * (this.page - 1);
                end = start + parseInt(this.size);
            }
            this._setPageButtons();
            for(let i = start; i < end; i++){
                let row = data[i];
                if (row) {
                    output.push(row);
                    if (row.type === "row") {
                        if (!actualStartRow) actualStartRow = row;
                        actualRowPageSize++;
                    }
                }
            }
            this._setPageCounter(actualRows.length, actualRowPageSize, actualStartRow ? actualRows.indexOf(actualStartRow) + 1 : 0);
            return output;
        } else {
            this._setPageButtons();
            this._setPageCounter(actualRows.length);
            return data.slice(0);
        }
    }
    trigger() {
        var left;
        switch(this.mode){
            case "local":
                left = this.table.rowManager.scrollLeft;
                this.refreshData();
                this.table.rowManager.scrollHorizontal(left);
                this.dispatchExternal("pageLoaded", this.getPage());
                return Promise.resolve();
            case "remote":
                this.dataChanging = true;
                return this.reloadData(null).finally(()=>{
                    this.dataChanging = false;
                });
            case "progressive_load":
            case "progressive_scroll":
                return this.reloadData(null, true);
            default:
                console.warn("Pagination Error - no such pagination mode:", this.mode);
                return Promise.reject();
        }
    }
    _parseRemoteData(data) {
        var margin;
        if (typeof data.last_page === "undefined") console.warn("Remote Pagination Error - Server response missing '" + (this.options("dataReceiveParams").last_page || "last_page") + "' property");
        if (data.data) {
            this.max = parseInt(data.last_page) || 1;
            this.remoteRowCountEstimate = typeof data.last_row !== "undefined" ? data.last_row : data.last_page * this.size - (this.page == data.last_page ? this.size - data.data.length : 0);
            if (this.progressiveLoad) {
                switch(this.mode){
                    case "progressive_load":
                        if (this.page == 1) this.table.rowManager.setData(data.data, false, this.page == 1);
                        else this.table.rowManager.addRows(data.data);
                        if (this.page < this.max) setTimeout(()=>{
                            this.nextPage();
                        }, this.table.options.progressiveLoadDelay);
                        break;
                    case "progressive_scroll":
                        data = this.page === 1 ? data.data : this.table.rowManager.getData().concat(data.data);
                        this.table.rowManager.setData(data, this.page !== 1, this.page == 1);
                        margin = this.table.options.progressiveLoadScrollMargin || this.table.rowManager.element.clientHeight * 2;
                        if (this.table.rowManager.element.scrollHeight <= this.table.rowManager.element.clientHeight + margin) {
                            if (this.page < this.max) setTimeout(()=>{
                                this.nextPage();
                            });
                        }
                        break;
                }
                return false;
            } else // left = this.table.rowManager.scrollLeft;
            this.dispatchExternal("pageLoaded", this.getPage());
        } else console.warn("Remote Pagination Error - Server response missing '" + (this.options("dataReceiveParams").data || "data") + "' property");
        return data.data;
    }
    //handle the footer element being redrawn
    footerRedraw() {
        var footer = this.table.footerManager.containerElement;
        if (Math.ceil(footer.clientWidth) - footer.scrollWidth < 0) this.pagesElement.style.display = "none";
        else {
            this.pagesElement.style.display = "";
            if (Math.ceil(footer.clientWidth) - footer.scrollWidth < 0) this.pagesElement.style.display = "none";
        }
    }
}
// read persistance information from storage
var $c2a9788f40f9c90a$var$defaultReaders = {
    local: function(id, type) {
        var data = localStorage.getItem(id + "-" + type);
        return data ? JSON.parse(data) : false;
    },
    cookie: function(id, type) {
        var cookie = document.cookie, key = id + "-" + type, cookiePos = cookie.indexOf(key + "="), end, data;
        //if cookie exists, decode and load column data into tabulator
        if (cookiePos > -1) {
            cookie = cookie.slice(cookiePos);
            end = cookie.indexOf(";");
            if (end > -1) cookie = cookie.slice(0, end);
            data = cookie.replace(key + "=", "");
        }
        return data ? JSON.parse(data) : false;
    }
};
//write persistence information to storage
var $c2a9788f40f9c90a$var$defaultWriters = {
    local: function(id, type, data) {
        localStorage.setItem(id + "-" + type, JSON.stringify(data));
    },
    cookie: function(id, type, data) {
        var expireDate = new Date();
        expireDate.setDate(expireDate.getDate() + 10000);
        document.cookie = id + "-" + type + "=" + JSON.stringify(data) + "; expires=" + expireDate.toUTCString();
    }
};
class $c2a9788f40f9c90a$export$6ce0215a06bec981 extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "persistence";
    static moduleInitOrder = -10;
    //load defaults
    static readers = $c2a9788f40f9c90a$var$defaultReaders;
    static writers = $c2a9788f40f9c90a$var$defaultWriters;
    constructor(table){
        super(table);
        this.mode = "";
        this.id = "";
        // this.persistProps = ["field", "width", "visible"];
        this.defWatcherBlock = false;
        this.config = {};
        this.readFunc = false;
        this.writeFunc = false;
        this.registerTableOption("persistence", false);
        this.registerTableOption("persistenceID", ""); //key for persistent storage
        this.registerTableOption("persistenceMode", true); //mode for storing persistence information
        this.registerTableOption("persistenceReaderFunc", false); //function for handling persistence data reading
        this.registerTableOption("persistenceWriterFunc", false); //function for handling persistence data writing
    }
    // Test for whether localStorage is available for use.
    localStorageTest() {
        var testKey = "_tabulator_test";
        try {
            window.localStorage.setItem(testKey, testKey);
            window.localStorage.removeItem(testKey);
            return true;
        } catch (e) {
            return false;
        }
    }
    //setup parameters
    initialize() {
        if (this.table.options.persistence) {
            //determine persistent layout storage type
            var mode = this.table.options.persistenceMode, id = this.table.options.persistenceID, retrievedData;
            this.mode = mode !== true ? mode : this.localStorageTest() ? "local" : "cookie";
            if (this.table.options.persistenceReaderFunc) {
                if (typeof this.table.options.persistenceReaderFunc === "function") this.readFunc = this.table.options.persistenceReaderFunc;
                else if ($c2a9788f40f9c90a$export$6ce0215a06bec981.readers[this.table.options.persistenceReaderFunc]) this.readFunc = $c2a9788f40f9c90a$export$6ce0215a06bec981.readers[this.table.options.persistenceReaderFunc];
                else console.warn("Persistence Read Error - invalid reader set", this.table.options.persistenceReaderFunc);
            } else if ($c2a9788f40f9c90a$export$6ce0215a06bec981.readers[this.mode]) this.readFunc = $c2a9788f40f9c90a$export$6ce0215a06bec981.readers[this.mode];
            else console.warn("Persistence Read Error - invalid reader set", this.mode);
            if (this.table.options.persistenceWriterFunc) {
                if (typeof this.table.options.persistenceWriterFunc === "function") this.writeFunc = this.table.options.persistenceWriterFunc;
                else if ($c2a9788f40f9c90a$export$6ce0215a06bec981.writers[this.table.options.persistenceWriterFunc]) this.writeFunc = $c2a9788f40f9c90a$export$6ce0215a06bec981.writers[this.table.options.persistenceWriterFunc];
                else console.warn("Persistence Write Error - invalid reader set", this.table.options.persistenceWriterFunc);
            } else if ($c2a9788f40f9c90a$export$6ce0215a06bec981.writers[this.mode]) this.writeFunc = $c2a9788f40f9c90a$export$6ce0215a06bec981.writers[this.mode];
            else console.warn("Persistence Write Error - invalid writer set", this.mode);
            //set storage tag
            this.id = "tabulator-" + (id || this.table.element.getAttribute("id") || "");
            this.config = {
                sort: this.table.options.persistence === true || this.table.options.persistence.sort,
                filter: this.table.options.persistence === true || this.table.options.persistence.filter,
                headerFilter: this.table.options.persistence === true || this.table.options.persistence.headerFilter,
                group: this.table.options.persistence === true || this.table.options.persistence.group,
                page: this.table.options.persistence === true || this.table.options.persistence.page,
                columns: this.table.options.persistence === true ? [
                    "title",
                    "width",
                    "visible"
                ] : this.table.options.persistence.columns
            };
            //load pagination data if needed
            if (this.config.page) {
                retrievedData = this.retrieveData("page");
                if (retrievedData) {
                    if (typeof retrievedData.paginationSize !== "undefined" && (this.config.page === true || this.config.page.size)) this.table.options.paginationSize = retrievedData.paginationSize;
                    if (typeof retrievedData.paginationInitialPage !== "undefined" && (this.config.page === true || this.config.page.page)) this.table.options.paginationInitialPage = retrievedData.paginationInitialPage;
                }
            }
            //load group data if needed
            if (this.config.group) {
                retrievedData = this.retrieveData("group");
                if (retrievedData) {
                    if (typeof retrievedData.groupBy !== "undefined" && (this.config.group === true || this.config.group.groupBy)) this.table.options.groupBy = retrievedData.groupBy;
                    if (typeof retrievedData.groupStartOpen !== "undefined" && (this.config.group === true || this.config.group.groupStartOpen)) this.table.options.groupStartOpen = retrievedData.groupStartOpen;
                    if (typeof retrievedData.groupHeader !== "undefined" && (this.config.group === true || this.config.group.groupHeader)) this.table.options.groupHeader = retrievedData.groupHeader;
                }
            }
            if (this.config.columns) {
                this.table.options.columns = this.load("columns", this.table.options.columns);
                this.subscribe("column-init", this.initializeColumn.bind(this));
                this.subscribe("column-show", this.save.bind(this, "columns"));
                this.subscribe("column-hide", this.save.bind(this, "columns"));
                this.subscribe("column-moved", this.save.bind(this, "columns"));
            }
            this.subscribe("table-built", this.tableBuilt.bind(this), 0);
            this.subscribe("table-redraw", this.tableRedraw.bind(this));
            this.subscribe("filter-changed", this.eventSave.bind(this, "filter"));
            this.subscribe("filter-changed", this.eventSave.bind(this, "headerFilter"));
            this.subscribe("sort-changed", this.eventSave.bind(this, "sort"));
            this.subscribe("group-changed", this.eventSave.bind(this, "group"));
            this.subscribe("page-changed", this.eventSave.bind(this, "page"));
            this.subscribe("column-resized", this.eventSave.bind(this, "columns"));
            this.subscribe("column-width", this.eventSave.bind(this, "columns"));
            this.subscribe("layout-refreshed", this.eventSave.bind(this, "columns"));
        }
        this.registerTableFunction("getColumnLayout", this.getColumnLayout.bind(this));
        this.registerTableFunction("setColumnLayout", this.setColumnLayout.bind(this));
    }
    eventSave(type) {
        if (this.config[type]) this.save(type);
    }
    tableBuilt() {
        var sorters, filters, headerFilters;
        if (this.config.sort) {
            sorters = this.load("sort");
            if (!sorters === false) this.table.options.initialSort = sorters;
        }
        if (this.config.filter) {
            filters = this.load("filter");
            if (!filters === false) this.table.options.initialFilter = filters;
        }
        if (this.config.headerFilter) {
            headerFilters = this.load("headerFilter");
            if (!headerFilters === false) this.table.options.initialHeaderFilter = headerFilters;
        }
    }
    tableRedraw(force) {
        if (force && this.config.columns) this.save("columns");
    }
    ///////////////////////////////////
    ///////// Table Functions /////////
    ///////////////////////////////////
    getColumnLayout() {
        return this.parseColumns(this.table.columnManager.getColumns());
    }
    setColumnLayout(layout) {
        this.table.columnManager.setColumns(this.mergeDefinition(this.table.options.columns, layout, true));
        return true;
    }
    ///////////////////////////////////
    ///////// Internal Logic //////////
    ///////////////////////////////////
    initializeColumn(column) {
        var def, keys;
        if (this.config.columns) {
            this.defWatcherBlock = true;
            def = column.getDefinition();
            keys = this.config.columns === true ? Object.keys(def) : this.config.columns;
            keys.forEach((key)=>{
                var props = Object.getOwnPropertyDescriptor(def, key);
                var value = def[key];
                if (props) Object.defineProperty(def, key, {
                    set: (newValue)=>{
                        value = newValue;
                        if (!this.defWatcherBlock) this.save("columns");
                        if (props.set) props.set(newValue);
                    },
                    get: ()=>{
                        if (props.get) props.get();
                        return value;
                    }
                });
            });
            this.defWatcherBlock = false;
        }
    }
    //load saved definitions
    load(type, current) {
        var data = this.retrieveData(type);
        if (current) data = data ? this.mergeDefinition(current, data) : current;
        return data;
    }
    //retrieve data from memory
    retrieveData(type) {
        return this.readFunc ? this.readFunc(this.id, type) : false;
    }
    //merge old and new column definitions
    mergeDefinition(oldCols, newCols, mergeAllNew) {
        var output = [];
        newCols = newCols || [];
        newCols.forEach((column, to)=>{
            var from = this._findColumn(oldCols, column), keys;
            if (from) {
                if (mergeAllNew) keys = Object.keys(column);
                else if (this.config.columns === true || this.config.columns == undefined) {
                    keys = Object.keys(from);
                    keys.push("width");
                } else keys = this.config.columns;
                keys.forEach((key)=>{
                    if (key !== "columns" && typeof column[key] !== "undefined") from[key] = column[key];
                });
                if (from.columns) from.columns = this.mergeDefinition(from.columns, column.columns);
                output.push(from);
            }
        });
        oldCols.forEach((column, i)=>{
            var from = this._findColumn(newCols, column);
            if (!from) {
                if (output.length > i) output.splice(i, 0, column);
                else output.push(column);
            }
        });
        return output;
    }
    //find matching columns
    _findColumn(columns, subject) {
        var type = subject.columns ? "group" : subject.field ? "field" : "object";
        return columns.find(function(col) {
            switch(type){
                case "group":
                    return col.title === subject.title && col.columns.length === subject.columns.length;
                case "field":
                    return col.field === subject.field;
                case "object":
                    return col === subject;
            }
        });
    }
    //save data
    save(type) {
        var data = {};
        switch(type){
            case "columns":
                data = this.parseColumns(this.table.columnManager.getColumns());
                break;
            case "filter":
                data = this.table.modules.filter.getFilters();
                break;
            case "headerFilter":
                data = this.table.modules.filter.getHeaderFilters();
                break;
            case "sort":
                data = this.validateSorters(this.table.modules.sort.getSort());
                break;
            case "group":
                data = this.getGroupConfig();
                break;
            case "page":
                data = this.getPageConfig();
                break;
        }
        if (this.writeFunc) this.writeFunc(this.id, type, data);
    }
    //ensure sorters contain no function data
    validateSorters(data) {
        data.forEach(function(item) {
            item.column = item.field;
            delete item.field;
        });
        return data;
    }
    getGroupConfig() {
        var data = {};
        if (this.config.group) {
            if (this.config.group === true || this.config.group.groupBy) data.groupBy = this.table.options.groupBy;
            if (this.config.group === true || this.config.group.groupStartOpen) data.groupStartOpen = this.table.options.groupStartOpen;
            if (this.config.group === true || this.config.group.groupHeader) data.groupHeader = this.table.options.groupHeader;
        }
        return data;
    }
    getPageConfig() {
        var data = {};
        if (this.config.page) {
            if (this.config.page === true || this.config.page.size) data.paginationSize = this.table.modules.page.getPageSize();
            if (this.config.page === true || this.config.page.page) data.paginationInitialPage = this.table.modules.page.getPage();
        }
        return data;
    }
    //parse columns for data to store
    parseColumns(columns) {
        var definitions = [], excludedKeys = [
            "headerContextMenu",
            "headerMenu",
            "contextMenu",
            "clickMenu"
        ];
        columns.forEach((column)=>{
            var defStore = {}, colDef = column.getDefinition(), keys;
            if (column.isGroup) {
                defStore.title = colDef.title;
                defStore.columns = this.parseColumns(column.getColumns());
            } else {
                defStore.field = column.getField();
                if (this.config.columns === true || this.config.columns == undefined) {
                    keys = Object.keys(colDef);
                    keys.push("width");
                    keys.push("visible");
                } else keys = this.config.columns;
                keys.forEach((key)=>{
                    switch(key){
                        case "width":
                            defStore.width = column.getWidth();
                            break;
                        case "visible":
                            defStore.visible = column.visible;
                            break;
                        default:
                            if (typeof colDef[key] !== "function" && excludedKeys.indexOf(key) === -1) defStore[key] = colDef[key];
                    }
                });
            }
            definitions.push(defStore);
        });
        return definitions;
    }
}
class $c2a9788f40f9c90a$export$5a0eb14a9c37d425 extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "popup";
    constructor(table){
        super(table);
        this.columnSubscribers = {};
        this.registerTableOption("rowContextPopup", false);
        this.registerTableOption("rowClickPopup", false);
        this.registerTableOption("rowDblClickPopup", false);
        this.registerTableOption("groupContextPopup", false);
        this.registerTableOption("groupClickPopup", false);
        this.registerTableOption("groupDblClickPopup", false);
        this.registerColumnOption("headerContextPopup");
        this.registerColumnOption("headerClickPopup");
        this.registerColumnOption("headerDblClickPopup");
        this.registerColumnOption("headerPopup");
        this.registerColumnOption("headerPopupIcon");
        this.registerColumnOption("contextPopup");
        this.registerColumnOption("clickPopup");
        this.registerColumnOption("dblClickPopup");
        this.registerComponentFunction("cell", "popup", this._componentPopupCall.bind(this));
        this.registerComponentFunction("column", "popup", this._componentPopupCall.bind(this));
        this.registerComponentFunction("row", "popup", this._componentPopupCall.bind(this));
        this.registerComponentFunction("group", "popup", this._componentPopupCall.bind(this));
    }
    initialize() {
        this.initializeRowWatchers();
        this.initializeGroupWatchers();
        this.subscribe("column-init", this.initializeColumn.bind(this));
    }
    _componentPopupCall(component, contents, position) {
        this.loadPopupEvent(contents, null, component, position);
    }
    initializeRowWatchers() {
        if (this.table.options.rowContextPopup) {
            this.subscribe("row-contextmenu", this.loadPopupEvent.bind(this, this.table.options.rowContextPopup));
            this.table.on("rowTapHold", this.loadPopupEvent.bind(this, this.table.options.rowContextPopup));
        }
        if (this.table.options.rowClickPopup) this.subscribe("row-click", this.loadPopupEvent.bind(this, this.table.options.rowClickPopup));
        if (this.table.options.rowDblClickPopup) this.subscribe("row-dblclick", this.loadPopupEvent.bind(this, this.table.options.rowDblClickPopup));
    }
    initializeGroupWatchers() {
        if (this.table.options.groupContextPopup) {
            this.subscribe("group-contextmenu", this.loadPopupEvent.bind(this, this.table.options.groupContextPopup));
            this.table.on("groupTapHold", this.loadPopupEvent.bind(this, this.table.options.groupContextPopup));
        }
        if (this.table.options.groupClickPopup) this.subscribe("group-click", this.loadPopupEvent.bind(this, this.table.options.groupClickPopup));
        if (this.table.options.groupDblClickPopup) this.subscribe("group-dblclick", this.loadPopupEvent.bind(this, this.table.options.groupDblClickPopup));
    }
    initializeColumn(column) {
        var def = column.definition;
        //handle column events
        if (def.headerContextPopup && !this.columnSubscribers.headerContextPopup) {
            this.columnSubscribers.headerContextPopup = this.loadPopupTableColumnEvent.bind(this, "headerContextPopup");
            this.subscribe("column-contextmenu", this.columnSubscribers.headerContextPopup);
            this.table.on("headerTapHold", this.loadPopupTableColumnEvent.bind(this, "headerContextPopup"));
        }
        if (def.headerClickPopup && !this.columnSubscribers.headerClickPopup) {
            this.columnSubscribers.headerClickPopup = this.loadPopupTableColumnEvent.bind(this, "headerClickPopup");
            this.subscribe("column-click", this.columnSubscribers.headerClickPopup);
        }
        if (def.headerDblClickPopup && !this.columnSubscribers.headerDblClickPopup) {
            this.columnSubscribers.headerDblClickPopup = this.loadPopupTableColumnEvent.bind(this, "headerDblClickPopup");
            this.subscribe("column-dblclick", this.columnSubscribers.headerDblClickPopup);
        }
        if (def.headerPopup) this.initializeColumnHeaderPopup(column);
        //handle cell events
        if (def.contextPopup && !this.columnSubscribers.contextPopup) {
            this.columnSubscribers.contextPopup = this.loadPopupTableCellEvent.bind(this, "contextPopup");
            this.subscribe("cell-contextmenu", this.columnSubscribers.contextPopup);
            this.table.on("cellTapHold", this.loadPopupTableCellEvent.bind(this, "contextPopup"));
        }
        if (def.clickPopup && !this.columnSubscribers.clickPopup) {
            this.columnSubscribers.clickPopup = this.loadPopupTableCellEvent.bind(this, "clickPopup");
            this.subscribe("cell-click", this.columnSubscribers.clickPopup);
        }
        if (def.dblClickPopup && !this.columnSubscribers.dblClickPopup) {
            this.columnSubscribers.dblClickPopup = this.loadPopupTableCellEvent.bind(this, "dblClickPopup");
            this.subscribe("cell-click", this.columnSubscribers.dblClickPopup);
        }
    }
    initializeColumnHeaderPopup(column) {
        var icon = column.definition.headerPopupIcon, headerPopupEl;
        headerPopupEl = document.createElement("span");
        headerPopupEl.classList.add("tabulator-header-popup-button");
        if (icon) {
            if (typeof icon === "function") icon = icon(column.getComponent());
            if (icon instanceof HTMLElement) headerPopupEl.appendChild(icon);
            else headerPopupEl.innerHTML = icon;
        } else headerPopupEl.innerHTML = "&vellip;";
        headerPopupEl.addEventListener("click", (e)=>{
            e.stopPropagation();
            e.preventDefault();
            this.loadPopupEvent(column.definition.headerPopup, e, column);
        });
        column.titleElement.insertBefore(headerPopupEl, column.titleElement.firstChild);
    }
    loadPopupTableCellEvent(option, e, cell) {
        if (cell._cell) cell = cell._cell;
        if (cell.column.definition[option]) this.loadPopupEvent(cell.column.definition[option], e, cell);
    }
    loadPopupTableColumnEvent(option, e, column) {
        if (column._column) column = column._column;
        if (column.definition[option]) this.loadPopupEvent(column.definition[option], e, column);
    }
    loadPopupEvent(contents, e, component, position) {
        var renderedCallback;
        function onRendered(callback) {
            renderedCallback = callback;
        }
        if (component._group) component = component._group;
        else if (component._row) component = component._row;
        contents = typeof contents == "function" ? contents.call(this.table, e, component.getComponent(), onRendered) : contents;
        this.loadPopup(e, component, contents, renderedCallback, position);
    }
    loadPopup(e, component, contents, renderedCallback, position) {
        var touch = !(e instanceof MouseEvent), contentsEl, popup;
        if (contents instanceof HTMLElement) contentsEl = contents;
        else {
            contentsEl = document.createElement("div");
            contentsEl.innerHTML = contents;
        }
        contentsEl.classList.add("tabulator-popup");
        contentsEl.addEventListener("click", (e)=>{
            e.stopPropagation();
        });
        if (!touch) e.preventDefault();
        popup = this.popup(contentsEl);
        if (typeof renderedCallback === "function") popup.renderCallback(renderedCallback);
        if (e) popup.show(e);
        else popup.show(component.getElement(), position || "center");
        popup.hideOnBlur(()=>{
            this.dispatchExternal("popupClosed", component.getComponent());
        });
        this.dispatchExternal("popupOpened", component.getComponent());
    }
}
class $c2a9788f40f9c90a$export$94fbe99c03f5a051 extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "print";
    constructor(table){
        super(table);
        this.element = false;
        this.manualBlock = false;
        this.beforeprintEventHandler = null;
        this.afterprintEventHandler = null;
        this.registerTableOption("printAsHtml", false); //enable print as html
        this.registerTableOption("printFormatter", false); //printing page formatter
        this.registerTableOption("printHeader", false); //page header contents
        this.registerTableOption("printFooter", false); //page footer contents
        this.registerTableOption("printStyled", true); //enable print as html styling
        this.registerTableOption("printRowRange", "visible"); //restrict print to visible rows only
        this.registerTableOption("printConfig", {}); //print config options
        this.registerColumnOption("print");
        this.registerColumnOption("titlePrint");
    }
    initialize() {
        if (this.table.options.printAsHtml) {
            this.beforeprintEventHandler = this.replaceTable.bind(this);
            this.afterprintEventHandler = this.cleanup.bind(this);
            window.addEventListener("beforeprint", this.beforeprintEventHandler);
            window.addEventListener("afterprint", this.afterprintEventHandler);
            this.subscribe("table-destroy", this.destroy.bind(this));
        }
        this.registerTableFunction("print", this.printFullscreen.bind(this));
    }
    destroy() {
        if (this.table.options.printAsHtml) {
            window.removeEventListener("beforeprint", this.beforeprintEventHandler);
            window.removeEventListener("afterprint", this.afterprintEventHandler);
        }
    }
    ///////////////////////////////////
    ///////// Table Functions /////////
    ///////////////////////////////////
    ///////////////////////////////////
    ///////// Internal Logic //////////
    ///////////////////////////////////
    replaceTable() {
        if (!this.manualBlock) {
            this.element = document.createElement("div");
            this.element.classList.add("tabulator-print-table");
            this.element.appendChild(this.table.modules.export.generateTable(this.table.options.printConfig, this.table.options.printStyled, this.table.options.printRowRange, "print"));
            this.table.element.style.display = "none";
            this.table.element.parentNode.insertBefore(this.element, this.table.element);
        }
    }
    cleanup() {
        document.body.classList.remove("tabulator-print-fullscreen-hide");
        if (this.element && this.element.parentNode) {
            this.element.parentNode.removeChild(this.element);
            this.table.element.style.display = "";
        }
    }
    printFullscreen(visible, style, config) {
        var scrollX = window.scrollX, scrollY = window.scrollY, headerEl = document.createElement("div"), footerEl = document.createElement("div"), tableEl = this.table.modules.export.generateTable(typeof config != "undefined" ? config : this.table.options.printConfig, typeof style != "undefined" ? style : this.table.options.printStyled, visible || this.table.options.printRowRange, "print"), headerContent, footerContent;
        this.manualBlock = true;
        this.element = document.createElement("div");
        this.element.classList.add("tabulator-print-fullscreen");
        if (this.table.options.printHeader) {
            headerEl.classList.add("tabulator-print-header");
            headerContent = typeof this.table.options.printHeader == "function" ? this.table.options.printHeader.call(this.table) : this.table.options.printHeader;
            if (typeof headerContent == "string") headerEl.innerHTML = headerContent;
            else headerEl.appendChild(headerContent);
            this.element.appendChild(headerEl);
        }
        this.element.appendChild(tableEl);
        if (this.table.options.printFooter) {
            footerEl.classList.add("tabulator-print-footer");
            footerContent = typeof this.table.options.printFooter == "function" ? this.table.options.printFooter.call(this.table) : this.table.options.printFooter;
            if (typeof footerContent == "string") footerEl.innerHTML = footerContent;
            else footerEl.appendChild(footerContent);
            this.element.appendChild(footerEl);
        }
        document.body.classList.add("tabulator-print-fullscreen-hide");
        document.body.appendChild(this.element);
        if (this.table.options.printFormatter) this.table.options.printFormatter(this.element, tableEl);
        window.print();
        this.cleanup();
        window.scrollTo(scrollX, scrollY);
        this.manualBlock = false;
    }
}
class $c2a9788f40f9c90a$export$1806fba60a0e8399 extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "reactiveData";
    constructor(table){
        super(table);
        this.data = false;
        this.blocked = false; //block reactivity while performing update
        this.origFuncs = {}; // hold original data array functions to allow replacement after data is done with
        this.currentVersion = 0;
        this.registerTableOption("reactiveData", false); //enable data reactivity
    }
    initialize() {
        if (this.table.options.reactiveData) {
            this.subscribe("cell-value-save-before", this.block.bind(this, "cellsave"));
            this.subscribe("cell-value-save-after", this.unblock.bind(this, "cellsave"));
            this.subscribe("row-data-save-before", this.block.bind(this, "rowsave"));
            this.subscribe("row-data-save-after", this.unblock.bind(this, "rowsave"));
            this.subscribe("row-data-init-after", this.watchRow.bind(this));
            this.subscribe("data-processing", this.watchData.bind(this));
            this.subscribe("table-destroy", this.unwatchData.bind(this));
        }
    }
    watchData(data) {
        var self = this, version;
        this.currentVersion++;
        version = this.currentVersion;
        this.unwatchData();
        this.data = data;
        //override array push function
        this.origFuncs.push = data.push;
        Object.defineProperty(this.data, "push", {
            enumerable: false,
            configurable: true,
            value: function() {
                var args = Array.from(arguments), result;
                if (!self.blocked && version === self.currentVersion) {
                    self.block("data-push");
                    args.forEach((arg)=>{
                        self.table.rowManager.addRowActual(arg, false);
                    });
                    result = self.origFuncs.push.apply(data, arguments);
                    self.unblock("data-push");
                }
                return result;
            }
        });
        //override array unshift function
        this.origFuncs.unshift = data.unshift;
        Object.defineProperty(this.data, "unshift", {
            enumerable: false,
            configurable: true,
            value: function() {
                var args = Array.from(arguments), result;
                if (!self.blocked && version === self.currentVersion) {
                    self.block("data-unshift");
                    args.forEach((arg)=>{
                        self.table.rowManager.addRowActual(arg, true);
                    });
                    result = self.origFuncs.unshift.apply(data, arguments);
                    self.unblock("data-unshift");
                }
                return result;
            }
        });
        //override array shift function
        this.origFuncs.shift = data.shift;
        Object.defineProperty(this.data, "shift", {
            enumerable: false,
            configurable: true,
            value: function() {
                var row, result;
                if (!self.blocked && version === self.currentVersion) {
                    self.block("data-shift");
                    if (self.data.length) {
                        row = self.table.rowManager.getRowFromDataObject(self.data[0]);
                        if (row) row.deleteActual();
                    }
                    result = self.origFuncs.shift.call(data);
                    self.unblock("data-shift");
                }
                return result;
            }
        });
        //override array pop function
        this.origFuncs.pop = data.pop;
        Object.defineProperty(this.data, "pop", {
            enumerable: false,
            configurable: true,
            value: function() {
                var row, result;
                if (!self.blocked && version === self.currentVersion) {
                    self.block("data-pop");
                    if (self.data.length) {
                        row = self.table.rowManager.getRowFromDataObject(self.data[self.data.length - 1]);
                        if (row) row.deleteActual();
                    }
                    result = self.origFuncs.pop.call(data);
                    self.unblock("data-pop");
                }
                return result;
            }
        });
        //override array splice function
        this.origFuncs.splice = data.splice;
        Object.defineProperty(this.data, "splice", {
            enumerable: false,
            configurable: true,
            value: function() {
                var args = Array.from(arguments), start = args[0] < 0 ? data.length + args[0] : args[0], end = args[1], newRows = args[2] ? args.slice(2) : false, startRow, result;
                if (!self.blocked && version === self.currentVersion) {
                    self.block("data-splice");
                    //add new rows
                    if (newRows) {
                        startRow = data[start] ? self.table.rowManager.getRowFromDataObject(data[start]) : false;
                        if (startRow) newRows.forEach((rowData)=>{
                            self.table.rowManager.addRowActual(rowData, true, startRow, true);
                        });
                        else {
                            newRows = newRows.slice().reverse();
                            newRows.forEach((rowData)=>{
                                self.table.rowManager.addRowActual(rowData, true, false, true);
                            });
                        }
                    }
                    //delete removed rows
                    if (end !== 0) {
                        var oldRows = data.slice(start, typeof args[1] === "undefined" ? args[1] : start + end);
                        oldRows.forEach((rowData, i)=>{
                            var row = self.table.rowManager.getRowFromDataObject(rowData);
                            if (row) row.deleteActual(i !== oldRows.length - 1);
                        });
                    }
                    if (newRows || end !== 0) self.table.rowManager.reRenderInPosition();
                    result = self.origFuncs.splice.apply(data, arguments);
                    self.unblock("data-splice");
                }
                return result;
            }
        });
    }
    unwatchData() {
        if (this.data !== false) for(var key in this.origFuncs)Object.defineProperty(this.data, key, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: this.origFuncs.key
        });
    }
    watchRow(row) {
        var data = row.getData();
        for(var key in data)this.watchKey(row, data, key);
        if (this.table.options.dataTree) this.watchTreeChildren(row);
    }
    watchTreeChildren(row) {
        var self = this, childField = row.getData()[this.table.options.dataTreeChildField], origFuncs = {};
        if (childField) {
            origFuncs.push = childField.push;
            Object.defineProperty(childField, "push", {
                enumerable: false,
                configurable: true,
                value: ()=>{
                    if (!self.blocked) {
                        self.block("tree-push");
                        var result = origFuncs.push.apply(childField, arguments);
                        this.rebuildTree(row);
                        self.unblock("tree-push");
                    }
                    return result;
                }
            });
            origFuncs.unshift = childField.unshift;
            Object.defineProperty(childField, "unshift", {
                enumerable: false,
                configurable: true,
                value: ()=>{
                    if (!self.blocked) {
                        self.block("tree-unshift");
                        var result = origFuncs.unshift.apply(childField, arguments);
                        this.rebuildTree(row);
                        self.unblock("tree-unshift");
                    }
                    return result;
                }
            });
            origFuncs.shift = childField.shift;
            Object.defineProperty(childField, "shift", {
                enumerable: false,
                configurable: true,
                value: ()=>{
                    if (!self.blocked) {
                        self.block("tree-shift");
                        var result = origFuncs.shift.call(childField);
                        this.rebuildTree(row);
                        self.unblock("tree-shift");
                    }
                    return result;
                }
            });
            origFuncs.pop = childField.pop;
            Object.defineProperty(childField, "pop", {
                enumerable: false,
                configurable: true,
                value: ()=>{
                    if (!self.blocked) {
                        self.block("tree-pop");
                        var result = origFuncs.pop.call(childField);
                        this.rebuildTree(row);
                        self.unblock("tree-pop");
                    }
                    return result;
                }
            });
            origFuncs.splice = childField.splice;
            Object.defineProperty(childField, "splice", {
                enumerable: false,
                configurable: true,
                value: ()=>{
                    if (!self.blocked) {
                        self.block("tree-splice");
                        var result = origFuncs.splice.apply(childField, arguments);
                        this.rebuildTree(row);
                        self.unblock("tree-splice");
                    }
                    return result;
                }
            });
        }
    }
    rebuildTree(row) {
        this.table.modules.dataTree.initializeRow(row);
        this.table.modules.dataTree.layoutRow(row);
        this.table.rowManager.refreshActiveData("tree", false, true);
    }
    watchKey(row, data, key) {
        var self = this, props = Object.getOwnPropertyDescriptor(data, key), value = data[key], version = this.currentVersion;
        Object.defineProperty(data, key, {
            set: (newValue)=>{
                value = newValue;
                if (!self.blocked && version === self.currentVersion) {
                    self.block("key");
                    var update = {};
                    update[key] = newValue;
                    row.updateData(update);
                    self.unblock("key");
                }
                if (props.set) props.set(newValue);
            },
            get: ()=>{
                if (props.get) props.get();
                return value;
            }
        });
    }
    unwatchRow(row) {
        var data = row.getData();
        for(var key in data)Object.defineProperty(data, key, {
            value: data[key]
        });
    }
    block(key) {
        if (!this.blocked) this.blocked = key;
    }
    unblock(key) {
        if (this.blocked === key) this.blocked = false;
    }
}
class $c2a9788f40f9c90a$export$3a1ca422b395df54 extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "resizeColumns";
    constructor(table){
        super(table);
        this.startColumn = false;
        this.startX = false;
        this.startWidth = false;
        this.latestX = false;
        this.handle = null;
        this.initialNextColumn = null;
        this.nextColumn = null;
        this.initialized = false;
        this.registerColumnOption("resizable", true);
        this.registerTableOption("resizableColumnFit", false);
        this.registerTableOption("resizableColumnGuide", false);
    }
    initialize() {
        this.subscribe("column-rendered", this.layoutColumnHeader.bind(this));
    }
    initializeEventWatchers() {
        if (!this.initialized) {
            this.subscribe("cell-rendered", this.layoutCellHandles.bind(this));
            this.subscribe("cell-delete", this.deInitializeComponent.bind(this));
            this.subscribe("cell-height", this.resizeHandle.bind(this));
            this.subscribe("column-moved", this.columnLayoutUpdated.bind(this));
            this.subscribe("column-hide", this.deInitializeColumn.bind(this));
            this.subscribe("column-show", this.columnLayoutUpdated.bind(this));
            this.subscribe("column-width", this.columnWidthUpdated.bind(this));
            this.subscribe("column-delete", this.deInitializeComponent.bind(this));
            this.subscribe("column-height", this.resizeHandle.bind(this));
            this.initialized = true;
        }
    }
    layoutCellHandles(cell) {
        if (cell.row.type === "row") {
            this.deInitializeComponent(cell);
            this.initializeColumn("cell", cell, cell.column, cell.element);
        }
    }
    layoutColumnHeader(column) {
        if (column.definition.resizable) {
            this.initializeEventWatchers();
            this.deInitializeComponent(column);
            this.initializeColumn("header", column, column, column.element);
        }
    }
    columnLayoutUpdated(column) {
        var prev = column.prevColumn();
        this.reinitializeColumn(column);
        if (prev) this.reinitializeColumn(prev);
    }
    columnWidthUpdated(column) {
        if (column.modules.frozen) {
            if (this.table.modules.frozenColumns.leftColumns.includes(column)) this.table.modules.frozenColumns.leftColumns.forEach((col)=>{
                this.reinitializeColumn(col);
            });
            else if (this.table.modules.frozenColumns.rightColumns.includes(column)) this.table.modules.frozenColumns.rightColumns.forEach((col)=>{
                this.reinitializeColumn(col);
            });
        }
    }
    frozenColumnOffset(column) {
        var offset = false;
        if (column.modules.frozen) {
            offset = column.modules.frozen.marginValue;
            if (column.modules.frozen.position === "left") offset += column.getWidth() - 3;
            else if (offset) offset -= 3;
        }
        return offset !== false ? offset + "px" : false;
    }
    reinitializeColumn(column) {
        var frozenOffset = this.frozenColumnOffset(column);
        column.cells.forEach((cell)=>{
            if (cell.modules.resize && cell.modules.resize.handleEl) {
                if (frozenOffset) {
                    cell.modules.resize.handleEl.style[column.modules.frozen.position] = frozenOffset;
                    cell.modules.resize.handleEl.style["z-index"] = 11;
                }
                cell.element.after(cell.modules.resize.handleEl);
            }
        });
        if (column.modules.resize && column.modules.resize.handleEl) {
            if (frozenOffset) column.modules.resize.handleEl.style[column.modules.frozen.position] = frozenOffset;
            column.element.after(column.modules.resize.handleEl);
        }
    }
    initializeColumn(type, component, column, element) {
        var self = this, variableHeight = false, mode = column.definition.resizable, config = {}, nearestColumn = column.getLastColumn();
        //set column resize mode
        if (type === "header") {
            variableHeight = column.definition.formatter == "textarea" || column.definition.variableHeight;
            config = {
                variableHeight: variableHeight
            };
        }
        if ((mode === true || mode == type) && this._checkResizability(nearestColumn)) {
            var handle = document.createElement("span");
            handle.className = "tabulator-col-resize-handle";
            handle.addEventListener("click", function(e) {
                e.stopPropagation();
            });
            var handleDown = function(e) {
                self.startColumn = column;
                self.initialNextColumn = self.nextColumn = nearestColumn.nextColumn();
                self._mouseDown(e, nearestColumn, handle);
            };
            handle.addEventListener("mousedown", handleDown);
            handle.addEventListener("touchstart", handleDown, {
                passive: true
            });
            //resize column on  double click
            handle.addEventListener("dblclick", (e)=>{
                var oldWidth = nearestColumn.getWidth();
                e.stopPropagation();
                nearestColumn.reinitializeWidth(true);
                if (oldWidth !== nearestColumn.getWidth()) {
                    self.dispatch("column-resized", nearestColumn);
                    self.dispatchExternal("columnResized", nearestColumn.getComponent());
                }
            });
            if (column.modules.frozen) {
                handle.style.position = "sticky";
                handle.style[column.modules.frozen.position] = this.frozenColumnOffset(column);
            }
            config.handleEl = handle;
            if (element.parentNode && column.visible) element.after(handle);
        }
        component.modules.resize = config;
    }
    deInitializeColumn(column) {
        this.deInitializeComponent(column);
        column.cells.forEach((cell)=>{
            this.deInitializeComponent(cell);
        });
    }
    deInitializeComponent(component) {
        var handleEl;
        if (component.modules.resize) {
            handleEl = component.modules.resize.handleEl;
            if (handleEl && handleEl.parentElement) handleEl.parentElement.removeChild(handleEl);
        }
    }
    resizeHandle(component, height) {
        if (component.modules.resize && component.modules.resize.handleEl) component.modules.resize.handleEl.style.height = height;
    }
    resize(e, column) {
        var x = typeof e.clientX === "undefined" ? e.touches[0].clientX : e.clientX, startDiff = x - this.startX, moveDiff = x - this.latestX, blockedBefore, blockedAfter;
        this.latestX = x;
        if (this.table.rtl) {
            startDiff = -startDiff;
            moveDiff = -moveDiff;
        }
        blockedBefore = column.width == column.minWidth || column.width == column.maxWidth;
        column.setWidth(this.startWidth + startDiff);
        blockedAfter = column.width == column.minWidth || column.width == column.maxWidth;
        if (moveDiff < 0) this.nextColumn = this.initialNextColumn;
        if (this.table.options.resizableColumnFit && this.nextColumn && !(blockedBefore && blockedAfter)) {
            let colWidth = this.nextColumn.getWidth();
            if (moveDiff > 0) {
                if (colWidth <= this.nextColumn.minWidth) this.nextColumn = this.nextColumn.nextColumn();
            }
            if (this.nextColumn) this.nextColumn.setWidth(this.nextColumn.getWidth() - moveDiff);
        }
        this.table.columnManager.rerenderColumns(true);
        if (!this.table.browserSlow && column.modules.resize && column.modules.resize.variableHeight) column.checkCellHeights();
    }
    calcGuidePosition(e, column, handle) {
        var mouseX = typeof e.clientX === "undefined" ? e.touches[0].clientX : e.clientX, handleX = handle.getBoundingClientRect().x - this.table.element.getBoundingClientRect().x, tableX = this.table.element.getBoundingClientRect().x, columnX = column.element.getBoundingClientRect().left - tableX, mouseDiff = mouseX - this.startX, pos = Math.max(handleX + mouseDiff, columnX + column.minWidth);
        if (column.maxWidth) pos = Math.min(pos, columnX + column.maxWidth);
        return pos;
    }
    _checkResizability(column) {
        return column.definition.resizable;
    }
    _mouseDown(e, column, handle) {
        var self = this, guideEl;
        this.dispatchExternal("columnResizing", column.getComponent());
        if (self.table.options.resizableColumnGuide) {
            guideEl = document.createElement("span");
            guideEl.classList.add("tabulator-col-resize-guide");
            self.table.element.appendChild(guideEl);
            setTimeout(()=>{
                guideEl.style.left = self.calcGuidePosition(e, column, handle) + "px";
            });
        }
        self.table.element.classList.add("tabulator-block-select");
        function mouseMove(e) {
            if (self.table.options.resizableColumnGuide) guideEl.style.left = self.calcGuidePosition(e, column, handle) + "px";
            else self.resize(e, column);
        }
        function mouseUp(e) {
            if (self.table.options.resizableColumnGuide) {
                self.resize(e, column);
                guideEl.remove();
            }
            //block editor from taking action while resizing is taking place
            if (self.startColumn.modules.edit) self.startColumn.modules.edit.blocked = false;
            if (self.table.browserSlow && column.modules.resize && column.modules.resize.variableHeight) column.checkCellHeights();
            document.body.removeEventListener("mouseup", mouseUp);
            document.body.removeEventListener("mousemove", mouseMove);
            handle.removeEventListener("touchmove", mouseMove);
            handle.removeEventListener("touchend", mouseUp);
            self.table.element.classList.remove("tabulator-block-select");
            if (self.startWidth !== column.getWidth()) {
                self.table.columnManager.verticalAlignHeaders();
                self.dispatch("column-resized", column);
                self.dispatchExternal("columnResized", column.getComponent());
            }
        }
        e.stopPropagation(); //prevent resize from interfering with movable columns
        //block editor from taking action while resizing is taking place
        if (self.startColumn.modules.edit) self.startColumn.modules.edit.blocked = true;
        self.startX = typeof e.clientX === "undefined" ? e.touches[0].clientX : e.clientX;
        self.latestX = self.startX;
        self.startWidth = column.getWidth();
        document.body.addEventListener("mousemove", mouseMove);
        document.body.addEventListener("mouseup", mouseUp);
        handle.addEventListener("touchmove", mouseMove, {
            passive: true
        });
        handle.addEventListener("touchend", mouseUp);
    }
}
class $c2a9788f40f9c90a$export$5651a6c35bd86023 extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "resizeRows";
    constructor(table){
        super(table);
        this.startColumn = false;
        this.startY = false;
        this.startHeight = false;
        this.handle = null;
        this.prevHandle = null;
        this.registerTableOption("resizableRows", false); //resizable rows
        this.registerTableOption("resizableRowGuide", false);
    }
    initialize() {
        if (this.table.options.resizableRows) this.subscribe("row-layout-after", this.initializeRow.bind(this));
    }
    initializeRow(row) {
        var self = this, rowEl = row.getElement();
        var handle = document.createElement("div");
        handle.className = "tabulator-row-resize-handle";
        var prevHandle = document.createElement("div");
        prevHandle.className = "tabulator-row-resize-handle prev";
        handle.addEventListener("click", function(e) {
            e.stopPropagation();
        });
        var handleDown = function(e) {
            self.startRow = row;
            self._mouseDown(e, row, handle);
        };
        handle.addEventListener("mousedown", handleDown);
        handle.addEventListener("touchstart", handleDown, {
            passive: true
        });
        prevHandle.addEventListener("click", function(e) {
            e.stopPropagation();
        });
        var prevHandleDown = function(e) {
            var prevRow = self.table.rowManager.prevDisplayRow(row);
            if (prevRow) {
                self.startRow = prevRow;
                self._mouseDown(e, prevRow, prevHandle);
            }
        };
        prevHandle.addEventListener("mousedown", prevHandleDown);
        prevHandle.addEventListener("touchstart", prevHandleDown, {
            passive: true
        });
        rowEl.appendChild(handle);
        rowEl.appendChild(prevHandle);
    }
    resize(e, row) {
        row.setHeight(this.startHeight + ((typeof e.screenY === "undefined" ? e.touches[0].screenY : e.screenY) - this.startY));
    }
    calcGuidePosition(e, row, handle) {
        var mouseY = typeof e.screenY === "undefined" ? e.touches[0].screenY : e.screenY, handleY = handle.getBoundingClientRect().y - this.table.element.getBoundingClientRect().y, tableY = this.table.element.getBoundingClientRect().y, rowY = row.element.getBoundingClientRect().top - tableY, mouseDiff = mouseY - this.startY;
        return Math.max(handleY + mouseDiff, rowY);
    }
    _mouseDown(e, row, handle) {
        var self = this, guideEl;
        self.dispatchExternal("rowResizing", row.getComponent());
        if (self.table.options.resizableRowGuide) {
            guideEl = document.createElement("span");
            guideEl.classList.add("tabulator-row-resize-guide");
            self.table.element.appendChild(guideEl);
            setTimeout(()=>{
                guideEl.style.top = self.calcGuidePosition(e, row, handle) + "px";
            });
        }
        self.table.element.classList.add("tabulator-block-select");
        function mouseMove(e) {
            if (self.table.options.resizableRowGuide) guideEl.style.top = self.calcGuidePosition(e, row, handle) + "px";
            else self.resize(e, row);
        }
        function mouseUp(e) {
            if (self.table.options.resizableRowGuide) {
                self.resize(e, row);
                guideEl.remove();
            }
            // //block editor from taking action while resizing is taking place
            // if(self.startColumn.modules.edit){
            // 	self.startColumn.modules.edit.blocked = false;
            // }
            document.body.removeEventListener("mouseup", mouseMove);
            document.body.removeEventListener("mousemove", mouseMove);
            handle.removeEventListener("touchmove", mouseMove);
            handle.removeEventListener("touchend", mouseUp);
            self.table.element.classList.remove("tabulator-block-select");
            self.dispatchExternal("rowResized", row.getComponent());
        }
        e.stopPropagation(); //prevent resize from interfering with movable columns
        //block editor from taking action while resizing is taking place
        // if(self.startColumn.modules.edit){
        // 	self.startColumn.modules.edit.blocked = true;
        // }
        self.startY = typeof e.screenY === "undefined" ? e.touches[0].screenY : e.screenY;
        self.startHeight = row.getHeight();
        document.body.addEventListener("mousemove", mouseMove);
        document.body.addEventListener("mouseup", mouseUp);
        handle.addEventListener("touchmove", mouseMove, {
            passive: true
        });
        handle.addEventListener("touchend", mouseUp);
    }
}
class $c2a9788f40f9c90a$export$977e646a85a63aba extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "resizeTable";
    constructor(table){
        super(table);
        this.binding = false;
        this.visibilityObserver = false;
        this.resizeObserver = false;
        this.containerObserver = false;
        this.tableHeight = 0;
        this.tableWidth = 0;
        this.containerHeight = 0;
        this.containerWidth = 0;
        this.autoResize = false;
        this.visible = false;
        this.initialized = false;
        this.initialRedraw = false;
        this.registerTableOption("autoResize", true); //auto resize table
    }
    initialize() {
        if (this.table.options.autoResize) {
            var table = this.table, tableStyle;
            this.tableHeight = table.element.clientHeight;
            this.tableWidth = table.element.clientWidth;
            if (table.element.parentNode) {
                this.containerHeight = table.element.parentNode.clientHeight;
                this.containerWidth = table.element.parentNode.clientWidth;
            }
            if (typeof IntersectionObserver !== "undefined" && typeof ResizeObserver !== "undefined" && table.rowManager.getRenderMode() === "virtual") {
                this.initializeVisibilityObserver();
                this.autoResize = true;
                this.resizeObserver = new ResizeObserver((entry)=>{
                    if (!table.browserMobile || table.browserMobile && (!table.modules.edit || table.modules.edit && !table.modules.edit.currentCell)) {
                        var nodeHeight = Math.floor(entry[0].contentRect.height);
                        var nodeWidth = Math.floor(entry[0].contentRect.width);
                        if (this.tableHeight != nodeHeight || this.tableWidth != nodeWidth) {
                            this.tableHeight = nodeHeight;
                            this.tableWidth = nodeWidth;
                            if (table.element.parentNode) {
                                this.containerHeight = table.element.parentNode.clientHeight;
                                this.containerWidth = table.element.parentNode.clientWidth;
                            }
                            this.redrawTable();
                        }
                    }
                });
                this.resizeObserver.observe(table.element);
                tableStyle = window.getComputedStyle(table.element);
                if (this.table.element.parentNode && !this.table.rowManager.fixedHeight && (tableStyle.getPropertyValue("max-height") || tableStyle.getPropertyValue("min-height"))) {
                    this.containerObserver = new ResizeObserver((entry)=>{
                        if (!table.browserMobile || table.browserMobile && (!table.modules.edit || table.modules.edit && !table.modules.edit.currentCell)) {
                            var nodeHeight = Math.floor(entry[0].contentRect.height);
                            var nodeWidth = Math.floor(entry[0].contentRect.width);
                            if (this.containerHeight != nodeHeight || this.containerWidth != nodeWidth) {
                                this.containerHeight = nodeHeight;
                                this.containerWidth = nodeWidth;
                                this.tableHeight = table.element.clientHeight;
                                this.tableWidth = table.element.clientWidth;
                            }
                            this.redrawTable();
                        }
                    });
                    this.containerObserver.observe(this.table.element.parentNode);
                }
                this.subscribe("table-resize", this.tableResized.bind(this));
            } else {
                this.binding = function() {
                    if (!table.browserMobile || table.browserMobile && (!table.modules.edit || table.modules.edit && !table.modules.edit.currentCell)) {
                        table.columnManager.rerenderColumns(true);
                        table.redraw();
                    }
                };
                window.addEventListener("resize", this.binding);
            }
            this.subscribe("table-destroy", this.clearBindings.bind(this));
        }
    }
    initializeVisibilityObserver() {
        this.visibilityObserver = new IntersectionObserver((entries)=>{
            this.visible = entries[0].isIntersecting;
            if (!this.initialized) {
                this.initialized = true;
                this.initialRedraw = !this.visible;
            } else if (this.visible) {
                this.redrawTable(this.initialRedraw);
                this.initialRedraw = false;
            }
        });
        this.visibilityObserver.observe(this.table.element);
    }
    redrawTable(force) {
        if (this.initialized && this.visible) {
            this.table.columnManager.rerenderColumns(true);
            this.table.redraw(force);
        }
    }
    tableResized() {
        this.table.rowManager.redraw();
    }
    clearBindings() {
        if (this.binding) window.removeEventListener("resize", this.binding);
        if (this.resizeObserver) this.resizeObserver.unobserve(this.table.element);
        if (this.visibilityObserver) this.visibilityObserver.unobserve(this.table.element);
        if (this.containerObserver) this.containerObserver.unobserve(this.table.element.parentNode);
    }
}
function $c2a9788f40f9c90a$var$responsiveCollapse(cell, formatterParams, onRendered) {
    var el = document.createElement("div"), config = cell.getRow()._row.modules.responsiveLayout;
    el.classList.add("tabulator-responsive-collapse-toggle");
    el.innerHTML = `<svg class='tabulator-responsive-collapse-toggle-open' viewbox="0 0 24 24">
  <line x1="7" y1="12" x2="17" y2="12" fill="none" stroke-width="3" stroke-linecap="round" />
  <line y1="7" x1="12" y2="17" x2="12" fill="none" stroke-width="3" stroke-linecap="round" />
</svg>

<svg class='tabulator-responsive-collapse-toggle-close' viewbox="0 0 24 24">
  <line x1="7" y1="12" x2="17" y2="12"  fill="none" stroke-width="3" stroke-linecap="round" />
</svg>`;
    cell.getElement().classList.add("tabulator-row-handle");
    function toggleList(isOpen) {
        var collapseEl = config.element;
        config.open = isOpen;
        if (collapseEl) {
            if (config.open) {
                el.classList.add("open");
                collapseEl.style.display = "";
            } else {
                el.classList.remove("open");
                collapseEl.style.display = "none";
            }
        }
    }
    el.addEventListener("click", function(e) {
        e.stopImmediatePropagation();
        toggleList(!config.open);
        cell.getTable().rowManager.adjustTableSize();
    });
    toggleList(config.open);
    return el;
}
var $c2a9788f40f9c90a$var$extensions$2 = {
    format: {
        formatters: {
            responsiveCollapse: $c2a9788f40f9c90a$var$responsiveCollapse
        }
    }
};
class $c2a9788f40f9c90a$export$cc8706005768c818 extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "responsiveLayout";
    static moduleExtensions = $c2a9788f40f9c90a$var$extensions$2;
    constructor(table){
        super(table);
        this.columns = [];
        this.hiddenColumns = [];
        this.mode = "";
        this.index = 0;
        this.collapseFormatter = [];
        this.collapseStartOpen = true;
        this.collapseHandleColumn = false;
        this.registerTableOption("responsiveLayout", false); //responsive layout flags
        this.registerTableOption("responsiveLayoutCollapseStartOpen", true); //start showing collapsed data
        this.registerTableOption("responsiveLayoutCollapseUseFormatters", true); //responsive layout collapse formatter
        this.registerTableOption("responsiveLayoutCollapseFormatter", false); //responsive layout collapse formatter
        this.registerColumnOption("responsive");
    }
    //generate responsive columns list
    initialize() {
        if (this.table.options.responsiveLayout) {
            this.subscribe("column-layout", this.initializeColumn.bind(this));
            this.subscribe("column-show", this.updateColumnVisibility.bind(this));
            this.subscribe("column-hide", this.updateColumnVisibility.bind(this));
            this.subscribe("columns-loaded", this.initializeResponsivity.bind(this));
            this.subscribe("column-moved", this.initializeResponsivity.bind(this));
            this.subscribe("column-add", this.initializeResponsivity.bind(this));
            this.subscribe("column-delete", this.initializeResponsivity.bind(this));
            this.subscribe("table-redrawing", this.tableRedraw.bind(this));
            if (this.table.options.responsiveLayout === "collapse") {
                this.subscribe("row-data-changed", this.generateCollapsedRowContent.bind(this));
                this.subscribe("row-init", this.initializeRow.bind(this));
                this.subscribe("row-layout", this.layoutRow.bind(this));
            }
        }
    }
    tableRedraw(force) {
        if ([
            "fitColumns",
            "fitDataStretch"
        ].indexOf(this.layoutMode()) === -1) {
            if (!force) this.update();
        }
    }
    initializeResponsivity() {
        var columns = [];
        this.mode = this.table.options.responsiveLayout;
        this.collapseFormatter = this.table.options.responsiveLayoutCollapseFormatter || this.formatCollapsedData;
        this.collapseStartOpen = this.table.options.responsiveLayoutCollapseStartOpen;
        this.hiddenColumns = [];
        if (this.collapseFormatter) this.collapseFormatter = this.collapseFormatter.bind(this.table);
        //determine level of responsivity for each column
        this.table.columnManager.columnsByIndex.forEach((column, i)=>{
            if (column.modules.responsive) {
                if (column.modules.responsive.order && column.modules.responsive.visible) {
                    column.modules.responsive.index = i;
                    columns.push(column);
                    if (!column.visible && this.mode === "collapse") this.hiddenColumns.push(column);
                }
            }
        });
        //sort list by responsivity
        columns = columns.reverse();
        columns = columns.sort((a, b)=>{
            var diff = b.modules.responsive.order - a.modules.responsive.order;
            return diff || b.modules.responsive.index - a.modules.responsive.index;
        });
        this.columns = columns;
        if (this.mode === "collapse") this.generateCollapsedContent();
        //assign collapse column
        for (let col of this.table.columnManager.columnsByIndex)if (col.definition.formatter == "responsiveCollapse") {
            this.collapseHandleColumn = col;
            break;
        }
        if (this.collapseHandleColumn) {
            if (this.hiddenColumns.length) this.collapseHandleColumn.show();
            else this.collapseHandleColumn.hide();
        }
    }
    //define layout information
    initializeColumn(column) {
        var def = column.getDefinition();
        column.modules.responsive = {
            order: typeof def.responsive === "undefined" ? 1 : def.responsive,
            visible: def.visible === false ? false : true
        };
    }
    initializeRow(row) {
        var el;
        if (row.type !== "calc") {
            el = document.createElement("div");
            el.classList.add("tabulator-responsive-collapse");
            row.modules.responsiveLayout = {
                element: el,
                open: this.collapseStartOpen
            };
            if (!this.collapseStartOpen) el.style.display = "none";
        }
    }
    layoutRow(row) {
        var rowEl = row.getElement();
        if (row.modules.responsiveLayout) {
            rowEl.appendChild(row.modules.responsiveLayout.element);
            this.generateCollapsedRowContent(row);
        }
    }
    //update column visibility
    updateColumnVisibility(column, responsiveToggle) {
        if (!responsiveToggle && column.modules.responsive) {
            column.modules.responsive.visible = column.visible;
            this.initializeResponsivity();
        }
    }
    hideColumn(column) {
        var colCount = this.hiddenColumns.length;
        column.hide(false, true);
        if (this.mode === "collapse") {
            this.hiddenColumns.unshift(column);
            this.generateCollapsedContent();
            if (this.collapseHandleColumn && !colCount) this.collapseHandleColumn.show();
        }
    }
    showColumn(column) {
        var index;
        column.show(false, true);
        //set column width to prevent calculation loops on uninitialized columns
        column.setWidth(column.getWidth());
        if (this.mode === "collapse") {
            index = this.hiddenColumns.indexOf(column);
            if (index > -1) this.hiddenColumns.splice(index, 1);
            this.generateCollapsedContent();
            if (this.collapseHandleColumn && !this.hiddenColumns.length) this.collapseHandleColumn.hide();
        }
    }
    //redraw columns to fit space
    update() {
        var working = true;
        while(working){
            let width = this.table.modules.layout.getMode() == "fitColumns" ? this.table.columnManager.getFlexBaseWidth() : this.table.columnManager.getWidth();
            let diff = (this.table.options.headerVisible ? this.table.columnManager.element.clientWidth : this.table.element.clientWidth) - width;
            if (diff < 0) {
                //table is too wide
                let column = this.columns[this.index];
                if (column) {
                    this.hideColumn(column);
                    this.index++;
                } else working = false;
            } else {
                //table has spare space
                let column = this.columns[this.index - 1];
                if (column) {
                    if (diff > 0) {
                        if (diff >= column.getWidth()) {
                            this.showColumn(column);
                            this.index--;
                        } else working = false;
                    } else working = false;
                } else working = false;
            }
            if (!this.table.rowManager.activeRowsCount) this.table.rowManager.renderEmptyScroll();
        }
    }
    generateCollapsedContent() {
        var rows = this.table.rowManager.getDisplayRows();
        rows.forEach((row)=>{
            this.generateCollapsedRowContent(row);
        });
    }
    generateCollapsedRowContent(row) {
        var el, contents;
        if (row.modules.responsiveLayout) {
            el = row.modules.responsiveLayout.element;
            while(el.firstChild)el.removeChild(el.firstChild);
            contents = this.collapseFormatter(this.generateCollapsedRowData(row));
            if (contents) el.appendChild(contents);
            row.calcHeight(true);
        }
    }
    generateCollapsedRowData(row) {
        var data = row.getData(), output = [], mockCellComponent;
        this.hiddenColumns.forEach((column)=>{
            var value = column.getFieldValue(data);
            if (column.definition.title && column.field) {
                if (column.modules.format && this.table.options.responsiveLayoutCollapseUseFormatters) {
                    mockCellComponent = {
                        value: false,
                        data: {},
                        getValue: function() {
                            return value;
                        },
                        getData: function() {
                            return data;
                        },
                        getType: function() {
                            return "cell";
                        },
                        getElement: function() {
                            return document.createElement("div");
                        },
                        getRow: function() {
                            return row.getComponent();
                        },
                        getColumn: function() {
                            return column.getComponent();
                        },
                        getTable: ()=>{
                            return this.table;
                        }
                    };
                    function onRendered(callback) {
                        callback();
                    }
                    output.push({
                        field: column.field,
                        title: column.definition.title,
                        value: column.modules.format.formatter.call(this.table.modules.format, mockCellComponent, column.modules.format.params, onRendered)
                    });
                } else output.push({
                    field: column.field,
                    title: column.definition.title,
                    value: value
                });
            }
        });
        return output;
    }
    formatCollapsedData(data) {
        var list = document.createElement("table");
        data.forEach((item)=>{
            var row = document.createElement("tr");
            var titleData = document.createElement("td");
            var valueData = document.createElement("td");
            var node_content;
            var titleHighlight = document.createElement("strong");
            titleData.appendChild(titleHighlight);
            this.modules.localize.bind("columns|" + item.field, function(text) {
                titleHighlight.innerHTML = text || item.title;
            });
            if (item.value instanceof Node) {
                node_content = document.createElement("div");
                node_content.appendChild(item.value);
                valueData.appendChild(node_content);
            } else valueData.innerHTML = item.value;
            row.appendChild(titleData);
            row.appendChild(valueData);
            list.appendChild(row);
        });
        return Object.keys(data).length ? list : "";
    }
}
function $c2a9788f40f9c90a$var$rowSelection(cell, formatterParams, onRendered) {
    var checkbox = document.createElement("input");
    var blocked = false;
    checkbox.type = "checkbox";
    checkbox.setAttribute("aria-label", "Select Row");
    if (this.table.modExists("selectRow", true)) {
        checkbox.addEventListener("click", (e)=>{
            e.stopPropagation();
        });
        if (typeof cell.getRow == "function") {
            var row = cell.getRow();
            if (row instanceof $c2a9788f40f9c90a$export$5df91075f5ba4651) {
                checkbox.addEventListener("change", (e)=>{
                    if (this.table.options.selectableRowsRangeMode === "click") {
                        if (!blocked) row.toggleSelect();
                        else blocked = false;
                    } else row.toggleSelect();
                });
                if (this.table.options.selectableRowsRangeMode === "click") checkbox.addEventListener("click", (e)=>{
                    blocked = true;
                    this.table.modules.selectRow.handleComplexRowClick(row._row, e);
                });
                checkbox.checked = row.isSelected && row.isSelected();
                this.table.modules.selectRow.registerRowSelectCheckbox(row, checkbox);
            } else checkbox = "";
        } else {
            checkbox.addEventListener("change", (e)=>{
                if (this.table.modules.selectRow.selectedRows.length) this.table.deselectRow();
                else this.table.selectRow(formatterParams.rowRange);
            });
            this.table.modules.selectRow.registerHeaderSelectCheckbox(checkbox);
        }
    }
    return checkbox;
}
var $c2a9788f40f9c90a$var$extensions$1 = {
    format: {
        formatters: {
            rowSelection: $c2a9788f40f9c90a$var$rowSelection
        }
    }
};
class $c2a9788f40f9c90a$export$2e4fadc5338e55f5 extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "selectRow";
    static moduleExtensions = $c2a9788f40f9c90a$var$extensions$1;
    constructor(table){
        super(table);
        this.selecting = false; //flag selecting in progress
        this.lastClickedRow = false; //last clicked row
        this.selectPrev = []; //hold previously selected element for drag drop selection
        this.selectedRows = []; //hold selected rows
        this.headerCheckboxElement = null; // hold header select element
        this.registerTableOption("selectableRows", "highlight"); //highlight rows on hover
        this.registerTableOption("selectableRowsRangeMode", "drag"); //highlight rows on hover
        this.registerTableOption("selectableRowsRollingSelection", true); //roll selection once maximum number of selectable rows is reached
        this.registerTableOption("selectableRowsPersistence", true); // maintain selection when table view is updated
        this.registerTableOption("selectableRowsCheck", function(data, row) {
            return true;
        }); //check whether row is selectable
        this.registerTableFunction("selectRow", this.selectRows.bind(this));
        this.registerTableFunction("deselectRow", this.deselectRows.bind(this));
        this.registerTableFunction("toggleSelectRow", this.toggleRow.bind(this));
        this.registerTableFunction("getSelectedRows", this.getSelectedRows.bind(this));
        this.registerTableFunction("getSelectedData", this.getSelectedData.bind(this));
        //register component functions
        this.registerComponentFunction("row", "select", this.selectRows.bind(this));
        this.registerComponentFunction("row", "deselect", this.deselectRows.bind(this));
        this.registerComponentFunction("row", "toggleSelect", this.toggleRow.bind(this));
        this.registerComponentFunction("row", "isSelected", this.isRowSelected.bind(this));
    }
    initialize() {
        this.deprecatedOptionsCheck();
        if (this.table.options.selectableRows === "highlight" && this.table.options.selectableRange) this.table.options.selectableRows = false;
        if (this.table.options.selectableRows !== false) {
            this.subscribe("row-init", this.initializeRow.bind(this));
            this.subscribe("row-deleting", this.rowDeleted.bind(this));
            this.subscribe("rows-wipe", this.clearSelectionData.bind(this));
            this.subscribe("rows-retrieve", this.rowRetrieve.bind(this));
            if (this.table.options.selectableRows && !this.table.options.selectableRowsPersistence) this.subscribe("data-refreshing", this.deselectRows.bind(this));
        }
    }
    deprecatedOptionsCheck() {
    // this.deprecationCheck("selectable", "selectableRows", true);
    // this.deprecationCheck("selectableRollingSelection", "selectableRowsRollingSelection", true);
    // this.deprecationCheck("selectableRangeMode", "selectableRowsRangeMode", true);
    // this.deprecationCheck("selectablePersistence", "selectableRowsPersistence", true);
    // this.deprecationCheck("selectableCheck", "selectableRowsCheck", true);
    }
    rowRetrieve(type, prevValue) {
        return type === "selected" ? this.selectedRows : prevValue;
    }
    rowDeleted(row) {
        this._deselectRow(row, true);
    }
    clearSelectionData(silent) {
        var prevSelected = this.selectedRows.length;
        this.selecting = false;
        this.lastClickedRow = false;
        this.selectPrev = [];
        this.selectedRows = [];
        if (prevSelected && silent !== true) this._rowSelectionChanged();
    }
    initializeRow(row) {
        var self = this, selectable = self.checkRowSelectability(row), element = row.getElement();
        // trigger end of row selection
        var endSelect = function() {
            setTimeout(function() {
                self.selecting = false;
            }, 50);
            document.body.removeEventListener("mouseup", endSelect);
        };
        row.modules.select = {
            selected: false
        };
        element.classList.toggle("tabulator-selectable", selectable);
        element.classList.toggle("tabulator-unselectable", !selectable);
        //set row selection class
        if (self.checkRowSelectability(row)) {
            if (self.table.options.selectableRows && self.table.options.selectableRows != "highlight") {
                if (self.table.options.selectableRowsRangeMode === "click") element.addEventListener("click", this.handleComplexRowClick.bind(this, row));
                else {
                    element.addEventListener("click", function(e) {
                        if (!self.table.modExists("edit") || !self.table.modules.edit.getCurrentCell()) self.table._clearSelection();
                        if (!self.selecting) self.toggleRow(row);
                    });
                    element.addEventListener("mousedown", function(e) {
                        if (e.shiftKey) {
                            self.table._clearSelection();
                            self.selecting = true;
                            self.selectPrev = [];
                            document.body.addEventListener("mouseup", endSelect);
                            document.body.addEventListener("keyup", endSelect);
                            self.toggleRow(row);
                            return false;
                        }
                    });
                    element.addEventListener("mouseenter", function(e) {
                        if (self.selecting) {
                            self.table._clearSelection();
                            self.toggleRow(row);
                            if (self.selectPrev[1] == row) self.toggleRow(self.selectPrev[0]);
                        }
                    });
                    element.addEventListener("mouseout", function(e) {
                        if (self.selecting) {
                            self.table._clearSelection();
                            self.selectPrev.unshift(row);
                        }
                    });
                }
            }
        }
    }
    handleComplexRowClick(row, e) {
        if (e.shiftKey) {
            this.table._clearSelection();
            this.lastClickedRow = this.lastClickedRow || row;
            var lastClickedRowIdx = this.table.rowManager.getDisplayRowIndex(this.lastClickedRow);
            var rowIdx = this.table.rowManager.getDisplayRowIndex(row);
            var fromRowIdx = lastClickedRowIdx <= rowIdx ? lastClickedRowIdx : rowIdx;
            var toRowIdx = lastClickedRowIdx >= rowIdx ? lastClickedRowIdx : rowIdx;
            var rows = this.table.rowManager.getDisplayRows().slice(0);
            var toggledRows = rows.splice(fromRowIdx, toRowIdx - fromRowIdx + 1);
            if (e.ctrlKey || e.metaKey) {
                toggledRows.forEach((toggledRow)=>{
                    if (toggledRow !== this.lastClickedRow) {
                        if (this.table.options.selectableRows !== true && !this.isRowSelected(row)) {
                            if (this.selectedRows.length < this.table.options.selectableRows) this.toggleRow(toggledRow);
                        } else this.toggleRow(toggledRow);
                    }
                });
                this.lastClickedRow = row;
            } else {
                this.deselectRows(undefined, true);
                if (this.table.options.selectableRows !== true) {
                    if (toggledRows.length > this.table.options.selectableRows) toggledRows = toggledRows.slice(0, this.table.options.selectableRows);
                }
                this.selectRows(toggledRows);
            }
            this.table._clearSelection();
        } else if (e.ctrlKey || e.metaKey) {
            this.toggleRow(row);
            this.lastClickedRow = row;
        } else {
            this.deselectRows(undefined, true);
            this.selectRows(row);
            this.lastClickedRow = row;
        }
    }
    checkRowSelectability(row) {
        if (row && row.type === "row") return this.table.options.selectableRowsCheck.call(this.table, row.getComponent());
        return false;
    }
    //toggle row selection
    toggleRow(row) {
        if (this.checkRowSelectability(row)) {
            if (row.modules.select && row.modules.select.selected) this._deselectRow(row);
            else this._selectRow(row);
        }
    }
    //select a number of rows
    selectRows(rows) {
        var changes = [], rowMatch, change;
        switch(typeof rows){
            case "undefined":
                rowMatch = this.table.rowManager.rows;
                break;
            case "number":
                rowMatch = this.table.rowManager.findRow(rows);
                break;
            case "string":
                rowMatch = this.table.rowManager.findRow(rows);
                if (!rowMatch) rowMatch = this.table.rowManager.getRows(rows);
                break;
            default:
                rowMatch = rows;
                break;
        }
        if (Array.isArray(rowMatch)) {
            if (rowMatch.length) {
                rowMatch.forEach((row)=>{
                    change = this._selectRow(row, true, true);
                    if (change) changes.push(change);
                });
                this._rowSelectionChanged(false, changes);
            }
        } else if (rowMatch) this._selectRow(rowMatch, false, true);
    }
    //select an individual row
    _selectRow(rowInfo, silent, force) {
        //handle max row count
        if (!isNaN(this.table.options.selectableRows) && this.table.options.selectableRows !== true && !force) {
            if (this.selectedRows.length >= this.table.options.selectableRows) {
                if (this.table.options.selectableRowsRollingSelection) this._deselectRow(this.selectedRows[0]);
                else return false;
            }
        }
        var row = this.table.rowManager.findRow(rowInfo);
        if (row) {
            if (this.selectedRows.indexOf(row) == -1) {
                row.getElement().classList.add("tabulator-selected");
                if (!row.modules.select) row.modules.select = {};
                row.modules.select.selected = true;
                if (row.modules.select.checkboxEl) row.modules.select.checkboxEl.checked = true;
                this.selectedRows.push(row);
                if (this.table.options.dataTreeSelectPropagate) this.childRowSelection(row, true);
                this.dispatchExternal("rowSelected", row.getComponent());
                this._rowSelectionChanged(silent, row);
                return row;
            }
        } else if (!silent) console.warn("Selection Error - No such row found, ignoring selection:" + rowInfo);
    }
    isRowSelected(row) {
        return this.selectedRows.indexOf(row) !== -1;
    }
    //deselect a number of rows
    deselectRows(rows, silent) {
        var changes = [], rowMatch, change;
        switch(typeof rows){
            case "undefined":
                rowMatch = Object.assign([], this.selectedRows);
                break;
            case "number":
                rowMatch = this.table.rowManager.findRow(rows);
                break;
            case "string":
                rowMatch = this.table.rowManager.findRow(rows);
                if (!rowMatch) rowMatch = this.table.rowManager.getRows(rows);
                break;
            default:
                rowMatch = rows;
                break;
        }
        if (Array.isArray(rowMatch)) {
            if (rowMatch.length) {
                rowMatch.forEach((row)=>{
                    change = this._deselectRow(row, true, true);
                    if (change) changes.push(change);
                });
                this._rowSelectionChanged(silent, [], changes);
            }
        } else if (rowMatch) this._deselectRow(rowMatch, silent, true);
    }
    //deselect an individual row
    _deselectRow(rowInfo, silent) {
        var self = this, row = self.table.rowManager.findRow(rowInfo), index, element;
        if (row) {
            index = self.selectedRows.findIndex(function(selectedRow) {
                return selectedRow == row;
            });
            if (index > -1) {
                element = row.getElement();
                if (element) element.classList.remove("tabulator-selected");
                if (!row.modules.select) row.modules.select = {};
                row.modules.select.selected = false;
                if (row.modules.select.checkboxEl) row.modules.select.checkboxEl.checked = false;
                self.selectedRows.splice(index, 1);
                if (this.table.options.dataTreeSelectPropagate) this.childRowSelection(row, false);
                this.dispatchExternal("rowDeselected", row.getComponent());
                self._rowSelectionChanged(silent, undefined, row);
                return row;
            }
        } else if (!silent) console.warn("Deselection Error - No such row found, ignoring selection:" + rowInfo);
    }
    getSelectedData() {
        var data = [];
        this.selectedRows.forEach(function(row) {
            data.push(row.getData());
        });
        return data;
    }
    getSelectedRows() {
        var rows = [];
        this.selectedRows.forEach(function(row) {
            rows.push(row.getComponent());
        });
        return rows;
    }
    _rowSelectionChanged(silent, selected = [], deselected = []) {
        if (this.headerCheckboxElement) {
            if (this.selectedRows.length === 0) {
                this.headerCheckboxElement.checked = false;
                this.headerCheckboxElement.indeterminate = false;
            } else if (this.table.rowManager.rows.length === this.selectedRows.length) {
                this.headerCheckboxElement.checked = true;
                this.headerCheckboxElement.indeterminate = false;
            } else {
                this.headerCheckboxElement.indeterminate = true;
                this.headerCheckboxElement.checked = false;
            }
        }
        if (!silent) {
            if (!Array.isArray(selected)) selected = [
                selected
            ];
            selected = selected.map((row)=>row.getComponent());
            if (!Array.isArray(deselected)) deselected = [
                deselected
            ];
            deselected = deselected.map((row)=>row.getComponent());
            this.dispatchExternal("rowSelectionChanged", this.getSelectedData(), this.getSelectedRows(), selected, deselected);
        }
    }
    registerRowSelectCheckbox(row, element) {
        if (!row._row.modules.select) row._row.modules.select = {};
        row._row.modules.select.checkboxEl = element;
    }
    registerHeaderSelectCheckbox(element) {
        this.headerCheckboxElement = element;
    }
    childRowSelection(row, select) {
        var children = this.table.modules.dataTree.getChildren(row, true, true);
        if (select) for (let child of children)this._selectRow(child, true);
        else for (let child of children)this._deselectRow(child, true);
    }
}
class $c2a9788f40f9c90a$export$433bfdbc52491af1 {
    constructor(range){
        this._range = range;
        return new Proxy(this, {
            get: function(target, name, receiver) {
                if (typeof target[name] !== "undefined") return target[name];
                else return target._range.table.componentFunctionBinder.handle("range", target._range, name);
            }
        });
    }
    getElement() {
        return this._range.element;
    }
    getData() {
        return this._range.getData();
    }
    getCells() {
        return this._range.getCells(true, true);
    }
    getStructuredCells() {
        return this._range.getStructuredCells();
    }
    getRows() {
        return this._range.getRows().map((row)=>row.getComponent());
    }
    getColumns() {
        return this._range.getColumns().map((column)=>column.getComponent());
    }
    getBounds() {
        return this._range.getBounds();
    }
    getTopEdge() {
        return this._range.top;
    }
    getBottomEdge() {
        return this._range.bottom;
    }
    getLeftEdge() {
        return this._range.left;
    }
    getRightEdge() {
        return this._range.right;
    }
    setBounds(start, end) {
        if (this._range.destroyedGuard("setBounds")) this._range.setBounds(start ? start._cell : start, end ? end._cell : end);
    }
    setStartBound(start) {
        if (this._range.destroyedGuard("setStartBound")) {
            this._range.setEndBound(start ? start._cell : start);
            this._range.rangeManager.layoutElement();
        }
    }
    setEndBound(end) {
        if (this._range.destroyedGuard("setEndBound")) {
            this._range.setEndBound(end ? end._cell : end);
            this._range.rangeManager.layoutElement();
        }
    }
    clearValues() {
        if (this._range.destroyedGuard("clearValues")) this._range.clearValues();
    }
    remove() {
        if (this._range.destroyedGuard("remove")) this._range.destroy(true);
    }
}
class $c2a9788f40f9c90a$var$Range extends $c2a9788f40f9c90a$var$CoreFeature {
    constructor(table, rangeManager, start, end){
        super(table);
        this.rangeManager = rangeManager;
        this.element = null;
        this.initialized = false;
        this.initializing = {
            start: false,
            end: false
        };
        this.destroyed = false;
        this.top = 0;
        this.bottom = 0;
        this.left = 0;
        this.right = 0;
        this.table = table;
        this.start = {
            row: 0,
            col: 0
        };
        this.end = {
            row: 0,
            col: 0
        };
        if (this.rangeManager.rowHeader) {
            this.left = 1;
            this.right = 1;
            this.start.col = 1;
            this.end.col = 1;
        }
        this.initElement();
        setTimeout(()=>{
            this.initBounds(start, end);
        });
    }
    initElement() {
        this.element = document.createElement("div");
        this.element.classList.add("tabulator-range");
    }
    initBounds(start, end) {
        this._updateMinMax();
        if (start) this.setBounds(start, end || start);
    }
    ///////////////////////////////////
    ///////   Boundary Setup    ///////
    ///////////////////////////////////
    setStart(row, col) {
        if (this.start.row !== row || this.start.col !== col) {
            this.start.row = row;
            this.start.col = col;
            this.initializing.start = true;
            this._updateMinMax();
        }
    }
    setEnd(row, col) {
        if (this.end.row !== row || this.end.col !== col) {
            this.end.row = row;
            this.end.col = col;
            this.initializing.end = true;
            this._updateMinMax();
        }
    }
    setBounds(start, end, visibleRows) {
        if (start) this.setStartBound(start);
        this.setEndBound(end || start);
        this.rangeManager.layoutElement(visibleRows);
    }
    setStartBound(element) {
        var row, col;
        if (element.type === "column") {
            if (this.rangeManager.columnSelection) this.setStart(0, element.getPosition() - 1);
        } else {
            row = element.row.position - 1;
            col = element.column.getPosition() - 1;
            if (element.column === this.rangeManager.rowHeader) this.setStart(row, 1);
            else this.setStart(row, col);
        }
    }
    setEndBound(element) {
        var rowsCount = this._getTableRows().length, row, col, isRowHeader;
        if (element.type === "column") {
            if (this.rangeManager.columnSelection) {
                if (this.rangeManager.selecting === "column") this.setEnd(rowsCount - 1, element.getPosition() - 1);
                else if (this.rangeManager.selecting === "cell") this.setEnd(0, element.getPosition() - 1);
            }
        } else {
            row = element.row.position - 1;
            col = element.column.getPosition() - 1;
            isRowHeader = element.column === this.rangeManager.rowHeader;
            if (this.rangeManager.selecting === "row") this.setEnd(row, this._getTableColumns().length - 1);
            else if (this.rangeManager.selecting !== "row" && isRowHeader) this.setEnd(row, 0);
            else if (this.rangeManager.selecting === "column") this.setEnd(rowsCount - 1, col);
            else this.setEnd(row, col);
        }
    }
    _updateMinMax() {
        this.top = Math.min(this.start.row, this.end.row);
        this.bottom = Math.max(this.start.row, this.end.row);
        this.left = Math.min(this.start.col, this.end.col);
        this.right = Math.max(this.start.col, this.end.col);
        if (this.initialized) this.dispatchExternal("rangeChanged", this.getComponent());
        else if (this.initializing.start && this.initializing.end) {
            this.initialized = true;
            this.dispatchExternal("rangeAdded", this.getComponent());
        }
    }
    _getTableColumns() {
        return this.table.columnManager.getVisibleColumnsByIndex();
    }
    _getTableRows() {
        return this.table.rowManager.getDisplayRows().filter((row)=>row.type === "row");
    }
    ///////////////////////////////////
    ///////      Rendering      ///////
    ///////////////////////////////////
    layout() {
        var _vDomTop = this.table.rowManager.renderer.vDomTop, _vDomBottom = this.table.rowManager.renderer.vDomBottom, _vDomLeft = this.table.columnManager.renderer.leftCol, _vDomRight = this.table.columnManager.renderer.rightCol, top, bottom, left, right, topLeftCell, bottomRightCell, topLeftCellEl, bottomRightCellEl, topLeftRowEl, bottomRightRowEl;
        if (this.table.options.renderHorizontal === "virtual" && this.rangeManager.rowHeader) _vDomRight += 1;
        if (_vDomTop == null) _vDomTop = 0;
        if (_vDomBottom == null) _vDomBottom = Infinity;
        if (_vDomLeft == null) _vDomLeft = 0;
        if (_vDomRight == null) _vDomRight = Infinity;
        if (this.overlaps(_vDomLeft, _vDomTop, _vDomRight, _vDomBottom)) {
            top = Math.max(this.top, _vDomTop);
            bottom = Math.min(this.bottom, _vDomBottom);
            left = Math.max(this.left, _vDomLeft);
            right = Math.min(this.right, _vDomRight);
            topLeftCell = this.rangeManager.getCell(top, left);
            bottomRightCell = this.rangeManager.getCell(bottom, right);
            topLeftCellEl = topLeftCell.getElement();
            bottomRightCellEl = bottomRightCell.getElement();
            topLeftRowEl = topLeftCell.row.getElement();
            bottomRightRowEl = bottomRightCell.row.getElement();
            this.element.classList.add("tabulator-range-active");
            // this.element.classList.toggle("tabulator-range-active", this === this.rangeManager.activeRange);
            if (this.table.rtl) {
                this.element.style.right = topLeftRowEl.offsetWidth - topLeftCellEl.offsetLeft - topLeftCellEl.offsetWidth + "px";
                this.element.style.width = topLeftCellEl.offsetLeft + topLeftCellEl.offsetWidth - bottomRightCellEl.offsetLeft + "px";
            } else {
                this.element.style.left = topLeftRowEl.offsetLeft + topLeftCellEl.offsetLeft + "px";
                this.element.style.width = bottomRightCellEl.offsetLeft + bottomRightCellEl.offsetWidth - topLeftCellEl.offsetLeft + "px";
            }
            this.element.style.top = topLeftRowEl.offsetTop + "px";
            this.element.style.height = bottomRightRowEl.offsetTop + bottomRightRowEl.offsetHeight - topLeftRowEl.offsetTop + "px";
        }
    }
    atTopLeft(cell) {
        return cell.row.position - 1 === this.top && cell.column.getPosition() - 1 === this.left;
    }
    atBottomRight(cell) {
        return cell.row.position - 1 === this.bottom && cell.column.getPosition() - 1 === this.right;
    }
    occupies(cell) {
        return this.occupiesRow(cell.row) && this.occupiesColumn(cell.column);
    }
    occupiesRow(row) {
        return this.top <= row.position - 1 && row.position - 1 <= this.bottom;
    }
    occupiesColumn(col) {
        return this.left <= col.getPosition() - 1 && col.getPosition() - 1 <= this.right;
    }
    overlaps(left, top, right, bottom) {
        if (this.left > right || left > this.right || this.top > bottom || top > this.bottom) return false;
        return true;
    }
    getData() {
        var data = [], rows = this.getRows(), columns = this.getColumns();
        rows.forEach((row)=>{
            var rowData = row.getData(), result = {};
            columns.forEach((column)=>{
                result[column.field] = rowData[column.field];
            });
            data.push(result);
        });
        return data;
    }
    getCells(structured, component) {
        var cells = [], rows = this.getRows(), columns = this.getColumns();
        if (structured) cells = rows.map((row)=>{
            var arr = [];
            row.getCells().forEach((cell)=>{
                if (columns.includes(cell.column)) arr.push(component ? cell.getComponent() : cell);
            });
            return arr;
        });
        else rows.forEach((row)=>{
            row.getCells().forEach((cell)=>{
                if (columns.includes(cell.column)) cells.push(component ? cell.getComponent() : cell);
            });
        });
        return cells;
    }
    getStructuredCells() {
        return this.getCells(true, true);
    }
    getRows() {
        return this._getTableRows().slice(this.top, this.bottom + 1);
    }
    getColumns() {
        return this._getTableColumns().slice(this.left, this.right + 1);
    }
    clearValues() {
        var cells = this.getCells();
        var clearValue = this.table.options.selectableRangeClearCellsValue;
        this.table.blockRedraw();
        cells.forEach((cell)=>{
            cell.setValue(clearValue);
        });
        this.table.restoreRedraw();
    }
    getBounds(component) {
        var cells = this.getCells(false, component), output = {
            start: null,
            end: null
        };
        if (cells.length) {
            output.start = cells[0];
            output.end = cells[cells.length - 1];
        } else console.warn("No bounds defined on range");
        return output;
    }
    getComponent() {
        if (!this.component) this.component = new $c2a9788f40f9c90a$export$433bfdbc52491af1(this);
        return this.component;
    }
    destroy(notify) {
        this.destroyed = true;
        this.element.remove();
        if (notify) this.rangeManager.rangeRemoved(this);
        if (this.initialized) this.dispatchExternal("rangeRemoved", this.getComponent());
    }
    destroyedGuard(func) {
        if (this.destroyed) console.warn("You cannot call the " + func + " function on a destroyed range");
        return !this.destroyed;
    }
}
var $c2a9788f40f9c90a$var$bindings = {
    rangeJumpUp: [
        "ctrl + 38",
        "meta + 38"
    ],
    rangeJumpDown: [
        "ctrl + 40",
        "meta + 40"
    ],
    rangeJumpLeft: [
        "ctrl + 37",
        "meta + 37"
    ],
    rangeJumpRight: [
        "ctrl + 39",
        "meta + 39"
    ],
    rangeExpandUp: "shift + 38",
    rangeExpandDown: "shift + 40",
    rangeExpandLeft: "shift + 37",
    rangeExpandRight: "shift + 39",
    rangeExpandJumpUp: [
        "ctrl + shift + 38",
        "meta + shift + 38"
    ],
    rangeExpandJumpDown: [
        "ctrl + shift + 40",
        "meta + shift + 40"
    ],
    rangeExpandJumpLeft: [
        "ctrl + shift + 37",
        "meta + shift + 37"
    ],
    rangeExpandJumpRight: [
        "ctrl + shift + 39",
        "meta + shift + 39"
    ]
};
var $c2a9788f40f9c90a$var$actions = {
    rangeJumpLeft: function(e) {
        this.dispatch("keybinding-nav-range", e, "left", true, false);
    },
    rangeJumpRight: function(e) {
        this.dispatch("keybinding-nav-range", e, "right", true, false);
    },
    rangeJumpUp: function(e) {
        this.dispatch("keybinding-nav-range", e, "up", true, false);
    },
    rangeJumpDown: function(e) {
        this.dispatch("keybinding-nav-range", e, "down", true, false);
    },
    rangeExpandLeft: function(e) {
        this.dispatch("keybinding-nav-range", e, "left", false, true);
    },
    rangeExpandRight: function(e) {
        this.dispatch("keybinding-nav-range", e, "right", false, true);
    },
    rangeExpandUp: function(e) {
        this.dispatch("keybinding-nav-range", e, "up", false, true);
    },
    rangeExpandDown: function(e) {
        this.dispatch("keybinding-nav-range", e, "down", false, true);
    },
    rangeExpandJumpLeft: function(e) {
        this.dispatch("keybinding-nav-range", e, "left", true, true);
    },
    rangeExpandJumpRight: function(e) {
        this.dispatch("keybinding-nav-range", e, "right", true, true);
    },
    rangeExpandJumpUp: function(e) {
        this.dispatch("keybinding-nav-range", e, "up", true, true);
    },
    rangeExpandJumpDown: function(e) {
        this.dispatch("keybinding-nav-range", e, "down", true, true);
    }
};
var $c2a9788f40f9c90a$var$pasteActions = {
    range: function(data) {
        var rows = [], range = this.table.modules.selectRange.activeRange, singleCell = false, bounds, startCell, startRow, rowWidth, dataLength;
        dataLength = data.length;
        if (range) {
            bounds = range.getBounds();
            startCell = bounds.start;
            if (bounds.start === bounds.end) singleCell = true;
            if (startCell) {
                rows = this.table.rowManager.activeRows.slice();
                startRow = rows.indexOf(startCell.row);
                if (singleCell) rowWidth = data.length;
                else rowWidth = rows.indexOf(bounds.end.row) - startRow + 1;
                if (startRow > -1) {
                    this.table.blockRedraw();
                    rows = rows.slice(startRow, startRow + rowWidth);
                    rows.forEach((row, i)=>{
                        row.updateData(data[i % dataLength]);
                    });
                    this.table.restoreRedraw();
                }
            }
        }
        return rows;
    }
};
var $c2a9788f40f9c90a$var$pasteParsers = {
    range: function(clipboard) {
        var data = [], rows = [], range = this.table.modules.selectRange.activeRange, singleCell = false, bounds, startCell, colWidth, columnMap, startCol;
        if (range) {
            bounds = range.getBounds();
            startCell = bounds.start;
            if (bounds.start === bounds.end) singleCell = true;
            if (startCell) {
                //get data from clipboard into array of columns and rows.
                clipboard = clipboard.split("\n");
                clipboard.forEach(function(row) {
                    data.push(row.split("	"));
                });
                if (data.length) {
                    columnMap = this.table.columnManager.getVisibleColumnsByIndex();
                    startCol = columnMap.indexOf(startCell.column);
                    if (startCol > -1) {
                        if (singleCell) colWidth = data[0].length;
                        else colWidth = columnMap.indexOf(bounds.end.column) - startCol + 1;
                        columnMap = columnMap.slice(startCol, startCol + colWidth);
                        data.forEach((item)=>{
                            var row = {};
                            var itemLength = item.length;
                            columnMap.forEach(function(col, i) {
                                row[col.field] = item[i % itemLength];
                            });
                            rows.push(row);
                        });
                        return rows;
                    }
                }
            }
        }
        return false;
    }
};
var $c2a9788f40f9c90a$var$columnLookups = {
    range: function() {
        var columns = this.modules.selectRange.selectedColumns();
        if (this.columnManager.rowHeader) columns.unshift(this.columnManager.rowHeader);
        return columns;
    }
};
var $c2a9788f40f9c90a$var$rowLookups = {
    range: function() {
        return this.modules.selectRange.selectedRows();
    }
};
var $c2a9788f40f9c90a$var$extensions = {
    keybindings: {
        bindings: $c2a9788f40f9c90a$var$bindings,
        actions: $c2a9788f40f9c90a$var$actions
    },
    clipboard: {
        pasteActions: $c2a9788f40f9c90a$var$pasteActions,
        pasteParsers: $c2a9788f40f9c90a$var$pasteParsers
    },
    export: {
        columnLookups: $c2a9788f40f9c90a$var$columnLookups,
        rowLookups: $c2a9788f40f9c90a$var$rowLookups
    }
};
class $c2a9788f40f9c90a$export$cd9e469b2c8c819c extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "selectRange";
    static moduleInitOrder = 1;
    static moduleExtensions = $c2a9788f40f9c90a$var$extensions;
    constructor(table){
        super(table);
        this.selecting = "cell";
        this.mousedown = false;
        this.ranges = [];
        this.overlay = null;
        this.rowHeader = null;
        this.layoutChangeTimeout = null;
        this.columnSelection = false;
        this.rowSelection = false;
        this.maxRanges = 0;
        this.activeRange = false;
        this.blockKeydown = false;
        this.keyDownEvent = this._handleKeyDown.bind(this);
        this.mouseUpEvent = this._handleMouseUp.bind(this);
        this.registerTableOption("selectableRange", false); //enable selectable range
        this.registerTableOption("selectableRangeColumns", false); //enable selectable range
        this.registerTableOption("selectableRangeRows", false); //enable selectable range
        this.registerTableOption("selectableRangeClearCells", false); //allow clearing of active range
        this.registerTableOption("selectableRangeClearCellsValue", undefined); //value for cleared active range
        this.registerTableFunction("getRangesData", this.getRangesData.bind(this));
        this.registerTableFunction("getRanges", this.getRanges.bind(this));
        this.registerTableFunction("addRange", this.addRangeFromComponent.bind(this));
        this.registerComponentFunction("cell", "getRanges", this.cellGetRanges.bind(this));
        this.registerComponentFunction("row", "getRanges", this.rowGetRanges.bind(this));
        this.registerComponentFunction("column", "getRanges", this.colGetRanges.bind(this));
    }
    ///////////////////////////////////
    ///////    Initialization   ///////
    ///////////////////////////////////
    initialize() {
        if (this.options("selectableRange")) {
            if (!this.options("selectableRows")) {
                this.maxRanges = this.options("selectableRange");
                this.initializeTable();
                this.initializeWatchers();
            } else console.warn("SelectRange functionality cannot be used in conjunction with row selection");
            if (this.options("columns").findIndex((column)=>column.frozen) > 0) console.warn("Having frozen column in arbitrary position with selectRange option may result in unpredictable behavior.");
            if (this.options("columns").filter((column)=>column.frozen) > 1) console.warn("Having multiple frozen columns with selectRange option may result in unpredictable behavior.");
        }
    }
    initializeTable() {
        this.overlay = document.createElement("div");
        this.overlay.classList.add("tabulator-range-overlay");
        this.rangeContainer = document.createElement("div");
        this.rangeContainer.classList.add("tabulator-range-container");
        this.activeRangeCellElement = document.createElement("div");
        this.activeRangeCellElement.classList.add("tabulator-range-cell-active");
        this.overlay.appendChild(this.rangeContainer);
        this.overlay.appendChild(this.activeRangeCellElement);
        this.table.rowManager.element.addEventListener("keydown", this.keyDownEvent);
        this.resetRanges();
        this.table.rowManager.element.appendChild(this.overlay);
        this.table.columnManager.element.setAttribute("tabindex", 0);
        this.table.element.classList.add("tabulator-ranges");
    }
    initializeWatchers() {
        this.columnSelection = this.options("selectableRangeColumns");
        this.rowSelection = this.options("selectableRangeRows");
        this.subscribe("column-init", this.initializeColumn.bind(this));
        this.subscribe("column-mousedown", this.handleColumnMouseDown.bind(this));
        this.subscribe("column-mousemove", this.handleColumnMouseMove.bind(this));
        this.subscribe("column-resized", this.handleColumnResized.bind(this));
        this.subscribe("column-moving", this.handleColumnMoving.bind(this));
        this.subscribe("column-moved", this.handleColumnMoved.bind(this));
        this.subscribe("column-width", this.layoutChange.bind(this));
        this.subscribe("column-height", this.layoutChange.bind(this));
        this.subscribe("column-resized", this.layoutChange.bind(this));
        this.subscribe("columns-loaded", this.updateHeaderColumn.bind(this));
        this.subscribe("cell-height", this.layoutChange.bind(this));
        this.subscribe("cell-rendered", this.renderCell.bind(this));
        this.subscribe("cell-mousedown", this.handleCellMouseDown.bind(this));
        this.subscribe("cell-mousemove", this.handleCellMouseMove.bind(this));
        this.subscribe("cell-click", this.handleCellClick.bind(this));
        this.subscribe("cell-editing", this.handleEditingCell.bind(this));
        this.subscribe("page-changed", this.redraw.bind(this));
        this.subscribe("scroll-vertical", this.layoutChange.bind(this));
        this.subscribe("scroll-horizontal", this.layoutChange.bind(this));
        this.subscribe("data-destroy", this.tableDestroyed.bind(this));
        this.subscribe("data-processed", this.resetRanges.bind(this));
        this.subscribe("table-layout", this.layoutElement.bind(this));
        this.subscribe("table-redraw", this.redraw.bind(this));
        this.subscribe("table-destroy", this.tableDestroyed.bind(this));
        this.subscribe("edit-editor-clear", this.finishEditingCell.bind(this));
        this.subscribe("edit-blur", this.restoreFocus.bind(this));
        this.subscribe("keybinding-nav-prev", this.keyNavigate.bind(this, "left"));
        this.subscribe("keybinding-nav-next", this.keyNavigate.bind(this, "right"));
        this.subscribe("keybinding-nav-left", this.keyNavigate.bind(this, "left"));
        this.subscribe("keybinding-nav-right", this.keyNavigate.bind(this, "right"));
        this.subscribe("keybinding-nav-up", this.keyNavigate.bind(this, "up"));
        this.subscribe("keybinding-nav-down", this.keyNavigate.bind(this, "down"));
        this.subscribe("keybinding-nav-range", this.keyNavigateRange.bind(this));
    }
    initializeColumn(column) {
        if (this.columnSelection && column.definition.headerSort && this.options("headerSortClickElement") !== "icon") console.warn("Using column headerSort with selectableRangeColumns option may result in unpredictable behavior. Consider using headerSortClickElement: 'icon'.");
        column.modules.edit;
    }
    updateHeaderColumn() {
        var frozenCols;
        if (this.rowSelection) {
            this.rowHeader = this.table.columnManager.getVisibleColumnsByIndex()[0];
            if (this.rowHeader) {
                this.rowHeader.definition.cssClass = this.rowHeader.definition.cssClass + " tabulator-range-row-header";
                if (this.rowHeader.definition.headerSort) console.warn("Using column headerSort with selectableRangeRows option may result in unpredictable behavior");
                if (this.rowHeader.definition.editor) console.warn("Using column editor with selectableRangeRows option may result in unpredictable behavior");
            }
        }
        //warn if invalid frozen column configuration detected
        if (this.table.modules.frozenColumns && this.table.modules.frozenColumns.active) {
            frozenCols = this.table.modules.frozenColumns.getFrozenColumns();
            if (frozenCols.length > 1 || frozenCols.length === 1 && frozenCols[0] !== this.rowHeader) console.warn("Using frozen columns that are not the range header in combination with the selectRange option may result in unpredictable behavior");
        }
    }
    ///////////////////////////////////
    ///////   Table Functions   ///////
    ///////////////////////////////////
    getRanges() {
        return this.ranges.map((range)=>range.getComponent());
    }
    getRangesData() {
        return this.ranges.map((range)=>range.getData());
    }
    addRangeFromComponent(start, end) {
        start = start ? start._cell : null;
        end = end ? end._cell : null;
        return this.addRange(start, end);
    }
    ///////////////////////////////////
    /////// Component Functions ///////
    ///////////////////////////////////
    cellGetRanges(cell) {
        var ranges = [];
        if (cell.column === this.rowHeader) ranges = this.ranges.filter((range)=>range.occupiesRow(cell.row));
        else ranges = this.ranges.filter((range)=>range.occupies(cell));
        return ranges.map((range)=>range.getComponent());
    }
    rowGetRanges(row) {
        var ranges = this.ranges.filter((range)=>range.occupiesRow(row));
        return ranges.map((range)=>range.getComponent());
    }
    colGetRanges(col) {
        var ranges = this.ranges.filter((range)=>range.occupiesColumn(col));
        return ranges.map((range)=>range.getComponent());
    }
    ///////////////////////////////////
    ////////// Event Handlers /////////
    ///////////////////////////////////
    _handleMouseUp(e) {
        this.mousedown = false;
        document.removeEventListener("mouseup", this.mouseUpEvent);
    }
    _handleKeyDown(e) {
        if (!this.blockKeydown && (!this.table.modules.edit || this.table.modules.edit && !this.table.modules.edit.currentCell)) {
            if (e.key === "Enter") {
                // is editing a cell?
                if (this.table.modules.edit && this.table.modules.edit.currentCell) return;
                this.table.modules.edit.editCell(this.getActiveCell());
                e.preventDefault();
            }
            if ((e.key === "Backspace" || e.key === "Delete") && this.options("selectableRangeClearCells")) {
                if (this.activeRange) this.activeRange.clearValues();
            }
        }
    }
    initializeFocus(cell) {
        var range;
        this.restoreFocus();
        try {
            if (document.selection) {
                range = document.body.createTextRange();
                range.moveToElementText(cell.getElement());
                range.select();
            } else if (window.getSelection) {
                range = document.createRange();
                range.selectNode(cell.getElement());
                window.getSelection().removeAllRanges();
                window.getSelection().addRange(range);
            }
        } catch (e) {}
    }
    restoreFocus(element) {
        this.table.rowManager.element.focus();
        return true;
    }
    ///////////////////////////////////
    ////// Column Functionality ///////
    ///////////////////////////////////
    handleColumnResized(column) {
        var selected;
        if (this.selecting !== "column" && this.selecting !== "all") return;
        selected = this.ranges.some((range)=>range.occupiesColumn(column));
        if (!selected) return;
        this.ranges.forEach((range)=>{
            var selectedColumns = range.getColumns(true);
            selectedColumns.forEach((selectedColumn)=>{
                if (selectedColumn !== column) selectedColumn.setWidth(column.width);
            });
        });
    }
    handleColumnMoving(_event, column) {
        this.resetRanges().setBounds(column);
        this.overlay.style.visibility = "hidden";
    }
    handleColumnMoved(from, _to, _after) {
        this.activeRange.setBounds(from);
        this.layoutElement();
    }
    handleColumnMouseDown(event, column) {
        if (event.button === 2 && (this.selecting === "column" || this.selecting === "all") && this.activeRange.occupiesColumn(column)) return;
        //If columns are movable, allow dragging columns only if they are not
        //selected. Dragging selected columns should move the columns instead.
        if (this.table.options.movableColumns && this.selecting === "column" && this.activeRange.occupiesColumn(column)) return;
        this.mousedown = true;
        document.addEventListener("mouseup", this.mouseUpEvent);
        this.newSelection(event, column);
    }
    handleColumnMouseMove(e, column) {
        if (column === this.rowHeader || !this.mousedown || this.selecting === "all") return;
        this.activeRange.setBounds(false, column, true);
    }
    ///////////////////////////////////
    //////// Cell Functionality ///////
    ///////////////////////////////////
    renderCell(cell) {
        var el = cell.getElement(), rangeIdx = this.ranges.findIndex((range)=>range.occupies(cell));
        el.classList.toggle("tabulator-range-selected", rangeIdx !== -1);
        el.classList.toggle("tabulator-range-only-cell-selected", this.ranges.length === 1 && this.ranges[0].atTopLeft(cell) && this.ranges[0].atBottomRight(cell));
        el.dataset.range = rangeIdx;
    }
    handleCellMouseDown(event, cell) {
        if (event.button === 2 && (this.activeRange.occupies(cell) || (this.selecting === "row" || this.selecting === "all") && this.activeRange.occupiesRow(cell.row))) return;
        this.mousedown = true;
        document.addEventListener("mouseup", this.mouseUpEvent);
        this.newSelection(event, cell);
    }
    handleCellMouseMove(e, cell) {
        if (!this.mousedown || this.selecting === "all") return;
        this.activeRange.setBounds(false, cell, true);
    }
    handleCellClick(e, cell) {
        this.initializeFocus(cell);
    }
    handleEditingCell(cell) {
        if (this.activeRange) this.activeRange.setBounds(cell);
    }
    finishEditingCell() {
        this.blockKeydown = true;
        this.table.rowManager.element.focus();
        setTimeout(()=>{
            this.blockKeydown = false;
        }, 10);
    }
    ///////////////////////////////////
    ///////     Navigation      ///////
    ///////////////////////////////////
    keyNavigate(dir, e) {
        this.navigate(false, false, dir);
        e.preventDefault();
    }
    keyNavigateRange(e, dir, jump, expand) {
        this.navigate(jump, expand, dir);
        e.preventDefault();
    }
    navigate(jump, expand, dir) {
        var moved = false, range, rangeEdge, nextRow, nextCol, row, column;
        // Don't navigate while editing
        if (this.table.modules.edit && this.table.modules.edit.currentCell) return false;
        // If there are more than 1 range, use the active range and destroy the others
        if (this.ranges.length > 1) this.ranges = this.ranges.filter((range)=>{
            if (range === this.activeRange) {
                range.setEnd(range.start.row, range.start.col);
                return true;
            }
            range.destroy();
            return false;
        });
        range = this.activeRange;
        rangeEdge = expand ? range.end : range.start;
        nextRow = rangeEdge.row;
        nextCol = rangeEdge.col;
        if (jump) switch(dir){
            case "left":
                nextCol = this.findJumpCellLeft(range.start.row, rangeEdge.col);
                break;
            case "right":
                nextCol = this.findJumpCellRight(range.start.row, rangeEdge.col);
                break;
            case "up":
                nextRow = this.findJumpCellUp(rangeEdge.row, range.start.col);
                break;
            case "down":
                nextRow = this.findJumpCellDown(rangeEdge.row, range.start.col);
                break;
        }
        else {
            if (expand) {
                if (this.selecting === "row" && (dir === "left" || dir === "right") || this.selecting === "column" && (dir === "up" || dir === "down")) return;
            }
            switch(dir){
                case "left":
                    nextCol = Math.max(nextCol - 1, 0);
                    break;
                case "right":
                    nextCol = Math.min(nextCol + 1, this.getTableColumns().length - 1);
                    break;
                case "up":
                    nextRow = Math.max(nextRow - 1, 0);
                    break;
                case "down":
                    nextRow = Math.min(nextRow + 1, this.getTableRows().length - 1);
                    break;
            }
        }
        if (this.rowHeader && nextCol === 0) nextCol = 1;
        moved = nextCol !== rangeEdge.col || nextRow !== rangeEdge.row;
        if (!expand) range.setStart(nextRow, nextCol);
        range.setEnd(nextRow, nextCol);
        if (!expand) this.selecting = "cell";
        if (moved) {
            row = this.getRowByRangePos(range.end.row);
            column = this.getColumnByRangePos(range.end.col);
            if ((dir === "left" || dir === "right") && column.getElement().parentNode === null) column.getComponent().scrollTo(undefined, false);
            else if ((dir === "up" || dir === "down") && row.getElement().parentNode === null) row.getComponent().scrollTo(undefined, false);
            else // Use faster autoScroll when the elements are on the DOM
            this.autoScroll(range, row.getElement(), column.getElement());
            this.layoutElement();
            return true;
        }
    }
    rangeRemoved(removed) {
        this.ranges = this.ranges.filter((range)=>range !== removed);
        if (this.activeRange === removed) {
            if (this.ranges.length) this.activeRange = this.ranges[this.ranges.length - 1];
            else this.addRange();
        }
        this.layoutElement();
    }
    findJumpRow(column, rows, reverse, emptyStart, emptySide) {
        if (reverse) rows = rows.reverse();
        return this.findJumpItem(emptyStart, emptySide, rows, function(row) {
            return row.getData()[column.getField()];
        });
    }
    findJumpCol(row, columns, reverse, emptyStart, emptySide) {
        if (reverse) columns = columns.reverse();
        return this.findJumpItem(emptyStart, emptySide, columns, function(column) {
            return row.getData()[column.getField()];
        });
    }
    findJumpItem(emptyStart, emptySide, items, valueResolver) {
        var nextItem;
        for (let currentItem of items){
            let currentValue = valueResolver(currentItem);
            if (emptyStart) {
                nextItem = currentItem;
                if (currentValue) break;
            } else if (emptySide) {
                nextItem = currentItem;
                if (currentValue) break;
            } else {
                if (currentValue) nextItem = currentItem;
                else break;
            }
        }
        return nextItem;
    }
    findJumpCellLeft(rowPos, colPos) {
        var row = this.getRowByRangePos(rowPos), columns = this.getTableColumns(), isStartingCellEmpty = this.isEmpty(row.getData()[columns[colPos].getField()]), isLeftOfStartingCellEmpty = columns[colPos - 1] ? this.isEmpty(row.getData()[columns[colPos - 1].getField()]) : false, targetCols = this.rowHeader ? columns.slice(1, colPos) : columns.slice(0, colPos), jumpCol = this.findJumpCol(row, targetCols, true, isStartingCellEmpty, isLeftOfStartingCellEmpty);
        if (jumpCol) return jumpCol.getPosition() - 1;
        return colPos;
    }
    findJumpCellRight(rowPos, colPos) {
        var row = this.getRowByRangePos(rowPos), columns = this.getTableColumns(), isStartingCellEmpty = this.isEmpty(row.getData()[columns[colPos].getField()]), isRightOfStartingCellEmpty = columns[colPos + 1] ? this.isEmpty(row.getData()[columns[colPos + 1].getField()]) : false, jumpCol = this.findJumpCol(row, columns.slice(colPos + 1, columns.length), false, isStartingCellEmpty, isRightOfStartingCellEmpty);
        if (jumpCol) return jumpCol.getPosition() - 1;
        return colPos;
    }
    findJumpCellUp(rowPos, colPos) {
        var column = this.getColumnByRangePos(colPos), rows = this.getTableRows(), isStartingCellEmpty = this.isEmpty(rows[rowPos].getData()[column.getField()]), isTopOfStartingCellEmpty = rows[rowPos - 1] ? this.isEmpty(rows[rowPos - 1].getData()[column.getField()]) : false, jumpRow = this.findJumpRow(column, rows.slice(0, rowPos), true, isStartingCellEmpty, isTopOfStartingCellEmpty);
        if (jumpRow) return jumpRow.position - 1;
        return rowPos;
    }
    findJumpCellDown(rowPos, colPos) {
        var column = this.getColumnByRangePos(colPos), rows = this.getTableRows(), isStartingCellEmpty = this.isEmpty(rows[rowPos].getData()[column.getField()]), isBottomOfStartingCellEmpty = rows[rowPos + 1] ? this.isEmpty(rows[rowPos + 1].getData()[column.getField()]) : false, jumpRow = this.findJumpRow(column, rows.slice(rowPos + 1, rows.length), false, isStartingCellEmpty, isBottomOfStartingCellEmpty);
        if (jumpRow) return jumpRow.position - 1;
        return rowPos;
    }
    ///////////////////////////////////
    ///////      Selection      ///////
    ///////////////////////////////////
    newSelection(event, element) {
        var range;
        if (element.type === "column") {
            if (!this.columnSelection) return;
            if (element === this.rowHeader) {
                range = this.resetRanges();
                this.selecting = "all";
                var topLeftCell, bottomRightCell = this.getCell(-1, -1);
                if (this.rowHeader) topLeftCell = this.getCell(0, 1);
                else topLeftCell = this.getCell(0, 0);
                range.setBounds(topLeftCell, bottomRightCell);
                return;
            } else this.selecting = "column";
        } else if (element.column === this.rowHeader) this.selecting = "row";
        else this.selecting = "cell";
        if (event.shiftKey) this.activeRange.setBounds(false, element);
        else if (event.ctrlKey) this.addRange().setBounds(element);
        else this.resetRanges().setBounds(element);
    }
    autoScroll(range, row, column) {
        var tableHolder = this.table.rowManager.element, rowHeader, rect, view, withinHorizontalView, withinVerticalView;
        if (typeof row === "undefined") row = this.getRowByRangePos(range.end.row).getElement();
        if (typeof column === "undefined") column = this.getColumnByRangePos(range.end.col).getElement();
        if (this.rowHeader) rowHeader = this.rowHeader.getElement();
        rect = {
            left: column.offsetLeft,
            right: column.offsetLeft + column.offsetWidth,
            top: row.offsetTop,
            bottom: row.offsetTop + row.offsetHeight
        };
        view = {
            left: tableHolder.scrollLeft,
            right: Math.ceil(tableHolder.scrollLeft + tableHolder.clientWidth),
            top: tableHolder.scrollTop,
            bottom: tableHolder.scrollTop + tableHolder.offsetHeight - this.table.rowManager.scrollbarWidth
        };
        if (rowHeader) view.left += rowHeader.offsetWidth;
        withinHorizontalView = view.left < rect.left && rect.left < view.right && view.left < rect.right && rect.right < view.right;
        withinVerticalView = view.top < rect.top && rect.top < view.bottom && view.top < rect.bottom && rect.bottom < view.bottom;
        if (!withinHorizontalView) {
            if (rect.left < view.left) {
                tableHolder.scrollLeft = rect.left;
                if (rowHeader) tableHolder.scrollLeft -= rowHeader.offsetWidth;
            } else if (rect.right > view.right) tableHolder.scrollLeft = rect.right - tableHolder.clientWidth;
        }
        if (!withinVerticalView) {
            if (rect.top < view.top) tableHolder.scrollTop = rect.top;
            else if (rect.bottom > view.bottom) tableHolder.scrollTop = rect.bottom - tableHolder.clientHeight;
        }
    }
    ///////////////////////////////////
    ///////       Layout        ///////
    ///////////////////////////////////
    layoutChange() {
        this.overlay.style.visibility = "hidden";
        clearTimeout(this.layoutChangeTimeout);
        this.layoutChangeTimeout = setTimeout(this.layoutRanges.bind(this), 200);
    }
    redraw(force) {
        if (force) {
            this.selecting = "cell";
            this.resetRanges();
            this.layoutElement();
        }
    }
    layoutElement(visibleRows) {
        var rows;
        if (visibleRows) rows = this.table.rowManager.getVisibleRows(true);
        else rows = this.table.rowManager.getRows();
        rows.forEach((row)=>{
            if (row.type === "row") {
                this.layoutRow(row);
                row.cells.forEach((cell)=>this.renderCell(cell));
            }
        });
        this.getTableColumns().forEach((column)=>{
            this.layoutColumn(column);
        });
        this.layoutRanges();
    }
    layoutRow(row) {
        var el = row.getElement(), selected = false, occupied = this.ranges.some((range)=>range.occupiesRow(row));
        if (this.selecting === "row") selected = occupied;
        else if (this.selecting === "all") selected = true;
        el.classList.toggle("tabulator-range-selected", selected);
        el.classList.toggle("tabulator-range-highlight", occupied);
    }
    layoutColumn(column) {
        var el = column.getElement(), selected = false, occupied = this.ranges.some((range)=>range.occupiesColumn(column));
        if (this.selecting === "column") selected = occupied;
        else if (this.selecting === "all") selected = true;
        el.classList.toggle("tabulator-range-selected", selected);
        el.classList.toggle("tabulator-range-highlight", occupied);
    }
    layoutRanges() {
        var activeCell, activeCellEl, activeRowEl;
        if (!this.table.initialized) return;
        activeCell = this.getActiveCell();
        if (!activeCell) return;
        activeCellEl = activeCell.getElement();
        activeRowEl = activeCell.row.getElement();
        if (this.table.rtl) this.activeRangeCellElement.style.right = activeRowEl.offsetWidth - activeCellEl.offsetLeft - activeCellEl.offsetWidth + "px";
        else this.activeRangeCellElement.style.left = activeRowEl.offsetLeft + activeCellEl.offsetLeft + "px";
        this.activeRangeCellElement.style.top = activeRowEl.offsetTop + "px";
        this.activeRangeCellElement.style.width = activeCellEl.offsetWidth + "px";
        this.activeRangeCellElement.style.height = activeRowEl.offsetHeight + "px";
        this.ranges.forEach((range)=>range.layout());
        this.overlay.style.visibility = "visible";
    }
    ///////////////////////////////////
    ///////  Helper Functions   ///////
    ///////////////////////////////////	
    getCell(rowIdx, colIdx) {
        var row;
        if (colIdx < 0) {
            colIdx = this.getTableColumns().length + colIdx;
            if (colIdx < 0) return null;
        }
        if (rowIdx < 0) rowIdx = this.getTableRows().length + rowIdx;
        row = this.table.rowManager.getRowFromPosition(rowIdx + 1);
        return row ? row.getCells(false, true).filter((cell)=>cell.column.visible)[colIdx] : null;
    }
    getActiveCell() {
        return this.getCell(this.activeRange.start.row, this.activeRange.start.col);
    }
    getRowByRangePos(pos) {
        return this.getTableRows()[pos];
    }
    getColumnByRangePos(pos) {
        return this.getTableColumns()[pos];
    }
    getTableRows() {
        return this.table.rowManager.getDisplayRows().filter((row)=>row.type === "row");
    }
    getTableColumns() {
        return this.table.columnManager.getVisibleColumnsByIndex();
    }
    addRange(start, end) {
        var range;
        if (this.maxRanges !== true && this.ranges.length >= this.maxRanges) this.ranges.shift().destroy();
        range = new $c2a9788f40f9c90a$var$Range(this.table, this, start, end);
        this.activeRange = range;
        this.ranges.push(range);
        this.rangeContainer.appendChild(range.element);
        return range;
    }
    resetRanges() {
        var range, cell, visibleCells;
        this.ranges.forEach((range)=>range.destroy());
        this.ranges = [];
        range = this.addRange();
        if (this.table.rowManager.activeRows.length) {
            visibleCells = this.table.rowManager.activeRows[0].cells.filter((cell)=>cell.column.visible);
            cell = visibleCells[this.rowHeader ? 1 : 0];
            if (cell) {
                range.setBounds(cell);
                this.initializeFocus(cell);
            }
        }
        return range;
    }
    tableDestroyed() {
        document.removeEventListener("mouseup", this.mouseUpEvent);
        this.table.rowManager.element.removeEventListener("keydown", this.keyDownEvent);
    }
    selectedRows(component) {
        return component ? this.activeRange.getRows().map((row)=>row.getComponent()) : this.activeRange.getRows();
    }
    selectedColumns(component) {
        return component ? this.activeRange.getColumns().map((col)=>col.getComponent()) : this.activeRange.getColumns();
    }
    isEmpty(value) {
        return value === null || value === undefined || value === "";
    }
}
//sort numbers
function $c2a9788f40f9c90a$var$number(a, b, aRow, bRow, column, dir, params) {
    var alignEmptyValues = params.alignEmptyValues;
    var decimal = params.decimalSeparator;
    var thousand = params.thousandSeparator;
    var emptyAlign = 0;
    a = String(a);
    b = String(b);
    if (thousand) {
        a = a.split(thousand).join("");
        b = b.split(thousand).join("");
    }
    if (decimal) {
        a = a.split(decimal).join(".");
        b = b.split(decimal).join(".");
    }
    a = parseFloat(a);
    b = parseFloat(b);
    //handle non numeric values
    if (isNaN(a)) emptyAlign = isNaN(b) ? 0 : -1;
    else if (isNaN(b)) emptyAlign = 1;
    else //compare valid values
    return a - b;
    //fix empty values in position
    if (alignEmptyValues === "top" && dir === "desc" || alignEmptyValues === "bottom" && dir === "asc") emptyAlign *= -1;
    return emptyAlign;
}
//sort strings
function $c2a9788f40f9c90a$var$string(a, b, aRow, bRow, column, dir, params) {
    var alignEmptyValues = params.alignEmptyValues;
    var emptyAlign = 0;
    var locale;
    //handle empty values
    if (!a) emptyAlign = !b ? 0 : -1;
    else if (!b) emptyAlign = 1;
    else {
        //compare valid values
        switch(typeof params.locale){
            case "boolean":
                if (params.locale) locale = this.langLocale();
                break;
            case "string":
                locale = params.locale;
                break;
        }
        return String(a).toLowerCase().localeCompare(String(b).toLowerCase(), locale);
    }
    //fix empty values in position
    if (alignEmptyValues === "top" && dir === "desc" || alignEmptyValues === "bottom" && dir === "asc") emptyAlign *= -1;
    return emptyAlign;
}
//sort datetime
function $c2a9788f40f9c90a$var$datetime(a, b, aRow, bRow, column, dir, params) {
    var DT = window.DateTime || luxon.DateTime;
    var format = params.format || "dd/MM/yyyy HH:mm:ss", alignEmptyValues = params.alignEmptyValues, emptyAlign = 0;
    if (typeof DT != "undefined") {
        if (!DT.isDateTime(a)) {
            if (format === "iso") a = DT.fromISO(String(a));
            else a = DT.fromFormat(String(a), format);
        }
        if (!DT.isDateTime(b)) {
            if (format === "iso") b = DT.fromISO(String(b));
            else b = DT.fromFormat(String(b), format);
        }
        if (!a.isValid) emptyAlign = !b.isValid ? 0 : -1;
        else if (!b.isValid) emptyAlign = 1;
        else //compare valid values
        return a - b;
        //fix empty values in position
        if (alignEmptyValues === "top" && dir === "desc" || alignEmptyValues === "bottom" && dir === "asc") emptyAlign *= -1;
        return emptyAlign;
    } else console.error("Sort Error - 'datetime' sorter is dependant on luxon.js");
}
//sort date
function $c2a9788f40f9c90a$var$date(a, b, aRow, bRow, column, dir, params) {
    if (!params.format) params.format = "dd/MM/yyyy";
    return $c2a9788f40f9c90a$var$datetime.call(this, a, b, aRow, bRow, column, dir, params);
}
//sort times
function $c2a9788f40f9c90a$var$time(a, b, aRow, bRow, column, dir, params) {
    if (!params.format) params.format = "HH:mm";
    return $c2a9788f40f9c90a$var$datetime.call(this, a, b, aRow, bRow, column, dir, params);
}
//sort booleans
function $c2a9788f40f9c90a$var$boolean(a, b, aRow, bRow, column, dir, params) {
    var el1 = a === true || a === "true" || a === "True" || a === 1 ? 1 : 0;
    var el2 = b === true || b === "true" || b === "True" || b === 1 ? 1 : 0;
    return el1 - el2;
}
//sort if element contains any data
function $c2a9788f40f9c90a$var$array(a, b, aRow, bRow, column, dir, params) {
    var type = params.type || "length", alignEmptyValues = params.alignEmptyValues, emptyAlign = 0;
    function calc(value) {
        var result;
        switch(type){
            case "length":
                result = value.length;
                break;
            case "sum":
                result = value.reduce(function(c, d) {
                    return c + d;
                });
                break;
            case "max":
                result = Math.max.apply(null, value);
                break;
            case "min":
                result = Math.min.apply(null, value);
                break;
            case "avg":
                result = value.reduce(function(c, d) {
                    return c + d;
                }) / value.length;
                break;
        }
        return result;
    }
    //handle non array values
    if (!Array.isArray(a)) emptyAlign = !Array.isArray(b) ? 0 : -1;
    else if (!Array.isArray(b)) emptyAlign = 1;
    else return calc(b) - calc(a);
    //fix empty values in position
    if (alignEmptyValues === "top" && dir === "desc" || alignEmptyValues === "bottom" && dir === "asc") emptyAlign *= -1;
    return emptyAlign;
}
//sort if element contains any data
function $c2a9788f40f9c90a$var$exists(a, b, aRow, bRow, column, dir, params) {
    var el1 = typeof a == "undefined" ? 0 : 1;
    var el2 = typeof b == "undefined" ? 0 : 1;
    return el1 - el2;
}
//sort alpha numeric strings
function $c2a9788f40f9c90a$var$alphanum(as, bs, aRow, bRow, column, dir, params) {
    var a, b, a1, b1, i = 0, L, rx = /(\d+)|(\D+)/g, rd = /\d/;
    var alignEmptyValues = params.alignEmptyValues;
    var emptyAlign = 0;
    //handle empty values
    if (!as && as !== 0) emptyAlign = !bs && bs !== 0 ? 0 : -1;
    else if (!bs && bs !== 0) emptyAlign = 1;
    else {
        if (isFinite(as) && isFinite(bs)) return as - bs;
        a = String(as).toLowerCase();
        b = String(bs).toLowerCase();
        if (a === b) return 0;
        if (!(rd.test(a) && rd.test(b))) return a > b ? 1 : -1;
        a = a.match(rx);
        b = b.match(rx);
        L = a.length > b.length ? b.length : a.length;
        while(i < L){
            a1 = a[i];
            b1 = b[i++];
            if (a1 !== b1) {
                if (isFinite(a1) && isFinite(b1)) {
                    if (a1.charAt(0) === "0") a1 = "." + a1;
                    if (b1.charAt(0) === "0") b1 = "." + b1;
                    return a1 - b1;
                } else return a1 > b1 ? 1 : -1;
            }
        }
        return a.length > b.length;
    }
    //fix empty values in position
    if (alignEmptyValues === "top" && dir === "desc" || alignEmptyValues === "bottom" && dir === "asc") emptyAlign *= -1;
    return emptyAlign;
}
var $c2a9788f40f9c90a$var$defaultSorters = {
    number: $c2a9788f40f9c90a$var$number,
    string: $c2a9788f40f9c90a$var$string,
    date: $c2a9788f40f9c90a$var$date,
    time: $c2a9788f40f9c90a$var$time,
    datetime: $c2a9788f40f9c90a$var$datetime,
    boolean: $c2a9788f40f9c90a$var$boolean,
    array: $c2a9788f40f9c90a$var$array,
    exists: $c2a9788f40f9c90a$var$exists,
    alphanum: $c2a9788f40f9c90a$var$alphanum
};
class $c2a9788f40f9c90a$export$5b492eb49d632e3f extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "sort";
    //load defaults
    static sorters = $c2a9788f40f9c90a$var$defaultSorters;
    constructor(table){
        super(table);
        this.sortList = []; //holder current sort
        this.changed = false; //has the sort changed since last render
        this.registerTableOption("sortMode", "local"); //local or remote sorting
        this.registerTableOption("initialSort", false); //initial sorting criteria
        this.registerTableOption("columnHeaderSortMulti", true); //multiple or single column sorting
        this.registerTableOption("sortOrderReverse", false); //reverse internal sort ordering
        this.registerTableOption("headerSortElement", "<div class='tabulator-arrow'></div>"); //header sort element
        this.registerTableOption("headerSortClickElement", "header"); //element which triggers sort when clicked
        this.registerColumnOption("sorter");
        this.registerColumnOption("sorterParams");
        this.registerColumnOption("headerSort", true);
        this.registerColumnOption("headerSortStartingDir");
        this.registerColumnOption("headerSortTristate");
    }
    initialize() {
        this.subscribe("column-layout", this.initializeColumn.bind(this));
        this.subscribe("table-built", this.tableBuilt.bind(this));
        this.registerDataHandler(this.sort.bind(this), 20);
        this.registerTableFunction("setSort", this.userSetSort.bind(this));
        this.registerTableFunction("getSorters", this.getSort.bind(this));
        this.registerTableFunction("clearSort", this.clearSort.bind(this));
        if (this.table.options.sortMode === "remote") this.subscribe("data-params", this.remoteSortParams.bind(this));
    }
    tableBuilt() {
        if (this.table.options.initialSort) this.setSort(this.table.options.initialSort);
    }
    remoteSortParams(data, config, silent, params) {
        var sorters = this.getSort();
        sorters.forEach((item)=>{
            delete item.column;
        });
        params.sort = sorters;
        return params;
    }
    ///////////////////////////////////
    ///////// Table Functions /////////
    ///////////////////////////////////
    userSetSort(sortList, dir) {
        this.setSort(sortList, dir);
        // this.table.rowManager.sorterRefresh();
        this.refreshSort();
    }
    clearSort() {
        this.clear();
        // this.table.rowManager.sorterRefresh();
        this.refreshSort();
    }
    ///////////////////////////////////
    ///////// Internal Logic //////////
    ///////////////////////////////////
    //initialize column header for sorting
    initializeColumn(column) {
        var sorter = false, colEl, arrowEl;
        switch(typeof column.definition.sorter){
            case "string":
                if ($c2a9788f40f9c90a$export$5b492eb49d632e3f.sorters[column.definition.sorter]) sorter = $c2a9788f40f9c90a$export$5b492eb49d632e3f.sorters[column.definition.sorter];
                else console.warn("Sort Error - No such sorter found: ", column.definition.sorter);
                break;
            case "function":
                sorter = column.definition.sorter;
                break;
        }
        column.modules.sort = {
            sorter: sorter,
            dir: "none",
            params: column.definition.sorterParams || {},
            startingDir: column.definition.headerSortStartingDir || "asc",
            tristate: column.definition.headerSortTristate
        };
        if (column.definition.headerSort !== false) {
            colEl = column.getElement();
            colEl.classList.add("tabulator-sortable");
            arrowEl = document.createElement("div");
            arrowEl.classList.add("tabulator-col-sorter");
            switch(this.table.options.headerSortClickElement){
                case "icon":
                    arrowEl.classList.add("tabulator-col-sorter-element");
                    break;
                case "header":
                    colEl.classList.add("tabulator-col-sorter-element");
                    break;
                default:
                    colEl.classList.add("tabulator-col-sorter-element");
                    break;
            }
            switch(this.table.options.headerSortElement){
                case "function":
                    break;
                case "object":
                    arrowEl.appendChild(this.table.options.headerSortElement);
                    break;
                default:
                    arrowEl.innerHTML = this.table.options.headerSortElement;
            }
            //create sorter arrow
            column.titleHolderElement.appendChild(arrowEl);
            column.modules.sort.element = arrowEl;
            this.setColumnHeaderSortIcon(column, "none");
            if (this.table.options.headerSortClickElement === "icon") arrowEl.addEventListener("mousedown", (e)=>{
                e.stopPropagation();
            });
            //sort on click
            (this.table.options.headerSortClickElement === "icon" ? arrowEl : colEl).addEventListener("click", (e)=>{
                var dir = "", sorters = [], match = false;
                if (column.modules.sort) {
                    if (column.modules.sort.tristate) {
                        if (column.modules.sort.dir == "none") dir = column.modules.sort.startingDir;
                        else if (column.modules.sort.dir == column.modules.sort.startingDir) dir = column.modules.sort.dir == "asc" ? "desc" : "asc";
                        else dir = "none";
                    } else switch(column.modules.sort.dir){
                        case "asc":
                            dir = "desc";
                            break;
                        case "desc":
                            dir = "asc";
                            break;
                        default:
                            dir = column.modules.sort.startingDir;
                    }
                    if (this.table.options.columnHeaderSortMulti && (e.shiftKey || e.ctrlKey)) {
                        sorters = this.getSort();
                        match = sorters.findIndex((sorter)=>{
                            return sorter.field === column.getField();
                        });
                        if (match > -1) {
                            sorters[match].dir = dir;
                            match = sorters.splice(match, 1)[0];
                            if (dir != "none") sorters.push(match);
                        } else if (dir != "none") sorters.push({
                            column: column,
                            dir: dir
                        });
                        //add to existing sort
                        this.setSort(sorters);
                    } else if (dir == "none") this.clear();
                    else //sort by column only
                    this.setSort(column, dir);
                    // this.table.rowManager.sorterRefresh(!this.sortList.length);
                    this.refreshSort();
                }
            });
        }
    }
    refreshSort() {
        if (this.table.options.sortMode === "remote") this.reloadData(null, false, false);
        else this.refreshData(true);
    //TODO - Persist left position of row manager
    // left = this.scrollLeft;
    // this.scrollHorizontal(left);
    }
    //check if the sorters have changed since last use
    hasChanged() {
        var changed = this.changed;
        this.changed = false;
        return changed;
    }
    //return current sorters
    getSort() {
        var self = this, sorters = [];
        self.sortList.forEach(function(item) {
            if (item.column) sorters.push({
                column: item.column.getComponent(),
                field: item.column.getField(),
                dir: item.dir
            });
        });
        return sorters;
    }
    //change sort list and trigger sort
    setSort(sortList, dir) {
        var self = this, newSortList = [];
        if (!Array.isArray(sortList)) sortList = [
            {
                column: sortList,
                dir: dir
            }
        ];
        sortList.forEach(function(item) {
            var column;
            column = self.table.columnManager.findColumn(item.column);
            if (column) {
                item.column = column;
                newSortList.push(item);
                self.changed = true;
            } else console.warn("Sort Warning - Sort field does not exist and is being ignored: ", item.column);
        });
        self.sortList = newSortList;
        this.dispatch("sort-changed");
    }
    //clear sorters
    clear() {
        this.setSort([]);
    }
    //find appropriate sorter for column
    findSorter(column) {
        var row = this.table.rowManager.activeRows[0], sorter = "string", field, value;
        if (row) {
            row = row.getData();
            field = column.getField();
            if (field) {
                value = column.getFieldValue(row);
                switch(typeof value){
                    case "undefined":
                        sorter = "string";
                        break;
                    case "boolean":
                        sorter = "boolean";
                        break;
                    default:
                        if (!isNaN(value) && value !== "") sorter = "number";
                        else if (value.match(/((^[0-9]+[a-z]+)|(^[a-z]+[0-9]+))+$/i)) sorter = "alphanum";
                        break;
                }
            }
        }
        return $c2a9788f40f9c90a$export$5b492eb49d632e3f.sorters[sorter];
    }
    //work through sort list sorting data
    sort(data, sortOnly) {
        var self = this, sortList = this.table.options.sortOrderReverse ? self.sortList.slice().reverse() : self.sortList, sortListActual = [], rowComponents = [];
        if (this.subscribedExternal("dataSorting")) this.dispatchExternal("dataSorting", self.getSort());
        if (!sortOnly) self.clearColumnHeaders();
        if (this.table.options.sortMode !== "remote") {
            //build list of valid sorters and trigger column specific callbacks before sort begins
            sortList.forEach(function(item, i) {
                var sortObj;
                if (item.column) {
                    sortObj = item.column.modules.sort;
                    if (sortObj) {
                        //if no sorter has been defined, take a guess
                        if (!sortObj.sorter) sortObj.sorter = self.findSorter(item.column);
                        item.params = typeof sortObj.params === "function" ? sortObj.params(item.column.getComponent(), item.dir) : sortObj.params;
                        sortListActual.push(item);
                    }
                    if (!sortOnly) self.setColumnHeader(item.column, item.dir);
                }
            });
            //sort data
            if (sortListActual.length) self._sortItems(data, sortListActual);
        } else if (!sortOnly) sortList.forEach(function(item, i) {
            self.setColumnHeader(item.column, item.dir);
        });
        if (this.subscribedExternal("dataSorted")) {
            data.forEach((row)=>{
                rowComponents.push(row.getComponent());
            });
            this.dispatchExternal("dataSorted", self.getSort(), rowComponents);
        }
        return data;
    }
    //clear sort arrows on columns
    clearColumnHeaders() {
        this.table.columnManager.getRealColumns().forEach((column)=>{
            if (column.modules.sort) {
                column.modules.sort.dir = "none";
                column.getElement().setAttribute("aria-sort", "none");
                this.setColumnHeaderSortIcon(column, "none");
            }
        });
    }
    //set the column header sort direction
    setColumnHeader(column, dir) {
        column.modules.sort.dir = dir;
        column.getElement().setAttribute("aria-sort", dir === "asc" ? "ascending" : "descending");
        this.setColumnHeaderSortIcon(column, dir);
    }
    setColumnHeaderSortIcon(column, dir) {
        var sortEl = column.modules.sort.element, arrowEl;
        if (column.definition.headerSort && typeof this.table.options.headerSortElement === "function") {
            while(sortEl.firstChild)sortEl.removeChild(sortEl.firstChild);
            arrowEl = this.table.options.headerSortElement.call(this.table, column.getComponent(), dir);
            if (typeof arrowEl === "object") sortEl.appendChild(arrowEl);
            else sortEl.innerHTML = arrowEl;
        }
    }
    //sort each item in sort list
    _sortItems(data, sortList) {
        var sorterCount = sortList.length - 1;
        data.sort((a, b)=>{
            var result;
            for(var i = sorterCount; i >= 0; i--){
                let sortItem = sortList[i];
                result = this._sortRow(a, b, sortItem.column, sortItem.dir, sortItem.params);
                if (result !== 0) break;
            }
            return result;
        });
    }
    //process individual rows for a sort function on active data
    _sortRow(a, b, column, dir, params) {
        var el1Comp, el2Comp;
        //switch elements depending on search direction
        var el1 = dir == "asc" ? a : b;
        var el2 = dir == "asc" ? b : a;
        a = column.getFieldValue(el1.getData());
        b = column.getFieldValue(el2.getData());
        a = typeof a !== "undefined" ? a : "";
        b = typeof b !== "undefined" ? b : "";
        el1Comp = el1.getComponent();
        el2Comp = el2.getComponent();
        return column.modules.sort.sorter.call(this, a, b, el1Comp, el2Comp, column.getComponent(), dir, params);
    }
}
class $c2a9788f40f9c90a$var$GridCalculator {
    constructor(columns, rows){
        this.columnCount = columns;
        this.rowCount = rows;
        this.columnString = [];
        this.columns = [];
        this.rows = [];
    }
    genColumns(data) {
        var colCount = Math.max(this.columnCount, Math.max(...data.map((item)=>item.length)));
        this.columnString = [];
        this.columns = [];
        for(let i = 1; i <= colCount; i++){
            this.incrementChar(this.columnString.length - 1);
            this.columns.push(this.columnString.join(""));
        }
        return this.columns;
    }
    genRows(data) {
        var rowCount = Math.max(this.rowCount, data.length);
        this.rows = [];
        for(let i = 1; i <= rowCount; i++)this.rows.push(i);
        return this.rows;
    }
    incrementChar(i) {
        let char = this.columnString[i];
        if (char) {
            if (char !== "Z") this.columnString[i] = String.fromCharCode(this.columnString[i].charCodeAt(0) + 1);
            else {
                this.columnString[i] = "A";
                if (i) this.incrementChar(i - 1);
                else this.columnString.push("A");
            }
        } else this.columnString.push("A");
    }
    setRowCount(count) {
        this.rowCount = count;
    }
    setColumnCount(count) {
        this.columnCount = count;
    }
}
class $c2a9788f40f9c90a$export$bcf87d11d46ea94f {
    constructor(sheet){
        this._sheet = sheet;
        return new Proxy(this, {
            get: function(target, name, receiver) {
                if (typeof target[name] !== "undefined") return target[name];
                else return target._sheet.table.componentFunctionBinder.handle("sheet", target._sheet, name);
            }
        });
    }
    getTitle() {
        return this._sheet.title;
    }
    getKey() {
        return this._sheet.key;
    }
    getDefinition() {
        return this._sheet.getDefinition();
    }
    getData() {
        return this._sheet.getData();
    }
    setData(data) {
        return this._sheet.setData(data);
    }
    clear() {
        return this._sheet.clear();
    }
    remove() {
        return this._sheet.remove();
    }
    active() {
        return this._sheet.active();
    }
    setTitle(title) {
        return this._sheet.setTitle(title);
    }
    setRows(rows) {
        return this._sheet.setRows(rows);
    }
    setColumns(columns) {
        return this._sheet.setColumns(columns);
    }
}
class $c2a9788f40f9c90a$var$Sheet extends $c2a9788f40f9c90a$var$CoreFeature {
    constructor(spreadsheetManager, definition){
        super(spreadsheetManager.table);
        this.spreadsheetManager = spreadsheetManager;
        this.definition = definition;
        this.title = this.definition.title || "";
        this.key = this.definition.key || this.definition.title;
        this.rowCount = this.definition.rows;
        this.columnCount = this.definition.columns;
        this.data = this.definition.data || [];
        this.element = null;
        this.isActive = false;
        this.grid = new $c2a9788f40f9c90a$var$GridCalculator(this.columnCount, this.rowCount);
        this.defaultColumnDefinition = {
            width: 100,
            headerHozAlign: "center",
            headerSort: false
        };
        this.columnDefinition = Object.assign(this.defaultColumnDefinition, this.options("spreadsheetColumnDefinition"));
        this.columnDefs = [];
        this.rowDefs = [];
        this.columnFields = [];
        this.columns = [];
        this.rows = [];
        this.scrollTop = null;
        this.scrollLeft = null;
        this.initialize();
        this.dispatchExternal("sheetAdded", this.getComponent());
    }
    ///////////////////////////////////
    ///////// Initialization //////////
    ///////////////////////////////////
    initialize() {
        this.initializeElement();
        this.initializeColumns();
        this.initializeRows();
    }
    reinitialize() {
        this.initializeColumns();
        this.initializeRows();
    }
    initializeElement() {
        this.element = document.createElement("div");
        this.element.classList.add("tabulator-spreadsheet-tab");
        this.element.innerText = this.title;
        this.element.addEventListener("click", ()=>{
            this.spreadsheetManager.loadSheet(this);
        });
    }
    initializeColumns() {
        this.grid.setColumnCount(this.columnCount);
        this.columnFields = this.grid.genColumns(this.data);
        this.columnDefs = [];
        this.columnFields.forEach((ref)=>{
            var def = Object.assign({}, this.columnDefinition);
            def.field = ref;
            def.title = ref;
            this.columnDefs.push(def);
        });
    }
    initializeRows() {
        var refs;
        this.grid.setRowCount(this.rowCount);
        refs = this.grid.genRows(this.data);
        this.rowDefs = [];
        refs.forEach((ref, i)=>{
            var def = {
                "_id": ref
            };
            var data = this.data[i];
            if (data) data.forEach((val, j)=>{
                var field = this.columnFields[j];
                if (field) def[field] = val;
            });
            this.rowDefs.push(def);
        });
    }
    unload() {
        this.isActive = false;
        this.scrollTop = this.table.rowManager.scrollTop;
        this.scrollLeft = this.table.rowManager.scrollLeft;
        this.data = this.getData(true);
        this.element.classList.remove("tabulator-spreadsheet-tab-active");
    }
    load() {
        var wasInactive = !this.isActive;
        this.isActive = true;
        this.table.blockRedraw();
        this.table.setData([]);
        this.table.setColumns(this.columnDefs);
        this.table.setData(this.rowDefs);
        this.table.restoreRedraw();
        if (wasInactive && this.scrollTop !== null) {
            this.table.rowManager.element.scrollLeft = this.scrollLeft;
            this.table.rowManager.element.scrollTop = this.scrollTop;
        }
        this.element.classList.add("tabulator-spreadsheet-tab-active");
        this.dispatchExternal("sheetLoaded", this.getComponent());
    }
    ///////////////////////////////////
    //////// Helper Functions /////////
    ///////////////////////////////////
    getComponent() {
        return new $c2a9788f40f9c90a$export$bcf87d11d46ea94f(this);
    }
    getDefinition() {
        return {
            title: this.title,
            key: this.key,
            rows: this.rowCount,
            columns: this.columnCount,
            data: this.getData()
        };
    }
    getData(full) {
        var output = [], rowWidths, outputWidth, outputHeight;
        //map data to array format
        this.rowDefs.forEach((rowData)=>{
            var row = [];
            this.columnFields.forEach((field)=>{
                row.push(rowData[field]);
            });
            output.push(row);
        });
        //trim output
        if (!full && !this.options("spreadsheetOutputFull")) {
            //calculate used area of data
            rowWidths = output.map((row)=>row.findLastIndex((val)=>typeof val !== "undefined") + 1);
            outputWidth = Math.max(...rowWidths);
            outputHeight = rowWidths.findLastIndex((width)=>width > 0) + 1;
            output = output.slice(0, outputHeight);
            output = output.map((row)=>row.slice(0, outputWidth));
        }
        return output;
    }
    setData(data) {
        this.data = data;
        this.reinitialize();
        this.dispatchExternal("sheetUpdated", this.getComponent());
        if (this.isActive) this.load();
    }
    clear() {
        this.setData([]);
    }
    setTitle(title) {
        this.title = title;
        this.element.innerText = title;
        this.dispatchExternal("sheetUpdated", this.getComponent());
    }
    setRows(rows) {
        this.rowCount = rows;
        this.initializeRows();
        this.dispatchExternal("sheetUpdated", this.getComponent());
        if (this.isActive) this.load();
    }
    setColumns(columns) {
        this.columnCount = columns;
        this.reinitialize();
        this.dispatchExternal("sheetUpdated", this.getComponent());
        if (this.isActive) this.load();
    }
    remove() {
        this.spreadsheetManager.removeSheet(this);
    }
    destroy() {
        if (this.element.parentNode) this.element.parentNode.removeChild(this.element);
        this.dispatchExternal("sheetRemoved", this.getComponent());
    }
    active() {
        this.spreadsheetManager.loadSheet(this);
    }
}
class $c2a9788f40f9c90a$export$bbb96e34680d7364 extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "spreadsheet";
    constructor(table){
        super(table);
        this.sheets = [];
        this.element = null;
        this.registerTableOption("spreadsheet", false);
        this.registerTableOption("spreadsheetRows", 50);
        this.registerTableOption("spreadsheetColumns", 50);
        this.registerTableOption("spreadsheetColumnDefinition", {});
        this.registerTableOption("spreadsheetOutputFull", false);
        this.registerTableOption("spreadsheetData", false);
        this.registerTableOption("spreadsheetSheets", false);
        this.registerTableOption("spreadsheetSheetTabs", false);
        this.registerTableOption("spreadsheetSheetTabsElement", false);
        this.registerTableFunction("setSheets", this.setSheets.bind(this));
        this.registerTableFunction("addSheet", this.addSheet.bind(this));
        this.registerTableFunction("getSheets", this.getSheets.bind(this));
        this.registerTableFunction("getSheetDefinitions", this.getSheetDefinitions.bind(this));
        this.registerTableFunction("setSheetData", this.setSheetData.bind(this));
        this.registerTableFunction("getSheet", this.getSheet.bind(this));
        this.registerTableFunction("getSheetData", this.getSheetData.bind(this));
        this.registerTableFunction("clearSheet", this.clearSheet.bind(this));
        this.registerTableFunction("removeSheet", this.removeSheetFunc.bind(this));
        this.registerTableFunction("activeSheet", this.activeSheetFunc.bind(this));
    }
    ///////////////////////////////////
    ////// Module Initialization //////
    ///////////////////////////////////
    initialize() {
        if (this.options("spreadsheet")) {
            this.subscribe("table-initialized", this.tableInitialized.bind(this));
            this.subscribe("data-loaded", this.loadRemoteData.bind(this));
            this.table.options.index = "_id";
            if (this.options("spreadsheetData") && this.options("spreadsheetSheets")) {
                console.warn("You cannot use spreadsheetData and spreadsheetSheets at the same time, ignoring spreadsheetData");
                this.table.options.spreadsheetData = false;
            }
            this.compatibilityCheck();
            if (this.options("spreadsheetSheetTabs")) this.initializeTabset();
        }
    }
    compatibilityCheck() {
        if (this.options("data")) console.warn("Do not use the data option when working with spreadsheets, use either spreadsheetData or spreadsheetSheets to pass data into the table");
        if (this.options("pagination")) console.warn("The spreadsheet module is not compatible with the pagination module");
        if (this.options("groupBy")) console.warn("The spreadsheet module is not compatible with the row grouping module");
        if (this.options("responsiveCollapse")) console.warn("The spreadsheet module is not compatible with the responsive collapse module");
    }
    initializeTabset() {
        this.element = document.createElement("div");
        this.element.classList.add("tabulator-spreadsheet-tabs");
        var altContainer = this.options("spreadsheetSheetTabsElement");
        if (altContainer && !(altContainer instanceof HTMLElement)) {
            altContainer = document.querySelector(altContainer);
            if (!altContainer) console.warn("Unable to find element matching spreadsheetSheetTabsElement selector:", this.options("spreadsheetSheetTabsElement"));
        }
        if (altContainer) altContainer.appendChild(this.element);
        else this.footerAppend(this.element);
    }
    tableInitialized() {
        if (this.sheets.length) this.loadSheet(this.sheets[0]);
        else {
            if (this.options("spreadsheetSheets")) this.loadSheets(this.options("spreadsheetSheets"));
            else if (this.options("spreadsheetData")) this.loadData(this.options("spreadsheetData"));
        }
    }
    ///////////////////////////////////
    /////////// Ajax Parsing //////////
    ///////////////////////////////////
    loadRemoteData(data, data1, data2) {
        console.log("data", data, data1, data2);
        if (Array.isArray(data)) {
            this.table.dataLoader.clearAlert();
            this.dispatchExternal("dataLoaded", data);
            if (!data.length || Array.isArray(data[0])) this.loadData(data);
            else this.loadSheets(data);
        } else console.error("Spreadsheet Loading Error - Unable to process remote data due to invalid data type \nExpecting: array \nReceived: ", typeof data, "\nData:     ", data);
        return false;
    }
    ///////////////////////////////////
    ///////// Sheet Management ////////
    ///////////////////////////////////
    loadData(data) {
        var def = {
            data: data
        };
        this.loadSheet(this.newSheet(def));
    }
    destroySheets() {
        this.sheets.forEach((sheet)=>{
            sheet.destroy();
        });
        this.sheets = [];
        this.activeSheet = null;
    }
    loadSheets(sheets) {
        if (!Array.isArray(sheets)) sheets = [];
        this.destroySheets();
        sheets.forEach((def)=>{
            this.newSheet(def);
        });
        this.loadSheet(this.sheets[0]);
    }
    loadSheet(sheet) {
        if (this.activeSheet !== sheet) {
            if (this.activeSheet) this.activeSheet.unload();
            this.activeSheet = sheet;
            sheet.load();
        }
    }
    newSheet(definition = {}) {
        var sheet;
        if (!definition.rows) definition.rows = this.options("spreadsheetRows");
        if (!definition.columns) definition.columns = this.options("spreadsheetColumns");
        sheet = new $c2a9788f40f9c90a$var$Sheet(this, definition);
        this.sheets.push(sheet);
        if (this.element) this.element.appendChild(sheet.element);
        return sheet;
    }
    removeSheet(sheet) {
        var index = this.sheets.indexOf(sheet), prevSheet;
        if (this.sheets.length > 1) {
            if (index > -1) {
                this.sheets.splice(index, 1);
                sheet.destroy();
                if (this.activeSheet === sheet) {
                    prevSheet = this.sheets[index - 1] || this.sheets[0];
                    if (prevSheet) this.loadSheet(prevSheet);
                    else this.activeSheet = null;
                }
            }
        } else console.warn("Unable to remove sheet, at least one sheet must be active");
    }
    lookupSheet(key) {
        if (!key) return this.activeSheet;
        else if (key instanceof $c2a9788f40f9c90a$var$Sheet) return key;
        else if (key instanceof $c2a9788f40f9c90a$export$bcf87d11d46ea94f) return key._sheet;
        else return this.sheets.find((sheet)=>sheet.key === key) || false;
    }
    ///////////////////////////////////
    //////// Public Functions /////////
    ///////////////////////////////////
    setSheets(sheets) {
        this.loadSheets(sheets);
        return this.getSheets();
    }
    addSheet(sheet) {
        return this.newSheet(sheet).getComponent();
    }
    getSheetDefinitions() {
        return this.sheets.map((sheet)=>sheet.getDefinition());
    }
    getSheets() {
        return this.sheets.map((sheet)=>sheet.getComponent());
    }
    getSheet(key) {
        var sheet = this.lookupSheet(key);
        return sheet ? sheet.getComponent() : false;
    }
    setSheetData(key, data) {
        if (key && !data) {
            data = key;
            key = false;
        }
        var sheet = this.lookupSheet(key);
        return sheet ? sheet.setData(data) : false;
    }
    getSheetData(key) {
        var sheet = this.lookupSheet(key);
        return sheet ? sheet.getData() : false;
    }
    clearSheet(key) {
        var sheet = this.lookupSheet(key);
        return sheet ? sheet.clear() : false;
    }
    removeSheetFunc(key) {
        var sheet = this.lookupSheet(key);
        if (sheet) this.removeSheet(sheet);
    }
    activeSheetFunc(key) {
        var sheet = this.lookupSheet(key);
        return sheet ? this.loadSheet(sheet) : false;
    }
}
class $c2a9788f40f9c90a$export$d0c662c133b8814e extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "tooltip";
    constructor(table){
        super(table);
        this.tooltipSubscriber = null, this.headerSubscriber = null, this.timeout = null;
        this.popupInstance = null;
        // this.registerTableOption("tooltipGenerationMode", undefined);  //deprecated
        this.registerTableOption("tooltipDelay", 300);
        this.registerColumnOption("tooltip");
        this.registerColumnOption("headerTooltip");
    }
    initialize() {
        this.deprecatedOptionsCheck();
        this.subscribe("column-init", this.initializeColumn.bind(this));
    }
    deprecatedOptionsCheck() {
    // this.deprecationCheckMsg("tooltipGenerationMode", "This option is no longer needed as tooltips are always generated on hover now");
    }
    initializeColumn(column) {
        if (column.definition.headerTooltip && !this.headerSubscriber) {
            this.headerSubscriber = true;
            this.subscribe("column-mousemove", this.mousemoveCheck.bind(this, "headerTooltip"));
            this.subscribe("column-mouseout", this.mouseoutCheck.bind(this, "headerTooltip"));
        }
        if (column.definition.tooltip && !this.tooltipSubscriber) {
            this.tooltipSubscriber = true;
            this.subscribe("cell-mousemove", this.mousemoveCheck.bind(this, "tooltip"));
            this.subscribe("cell-mouseout", this.mouseoutCheck.bind(this, "tooltip"));
        }
    }
    mousemoveCheck(action, e, component) {
        var tooltip = action === "tooltip" ? component.column.definition.tooltip : component.definition.headerTooltip;
        if (tooltip) {
            this.clearPopup();
            this.timeout = setTimeout(this.loadTooltip.bind(this, e, component, tooltip), this.table.options.tooltipDelay);
        }
    }
    mouseoutCheck(action, e, component) {
        if (!this.popupInstance) this.clearPopup();
    }
    clearPopup(action, e, component) {
        clearTimeout(this.timeout);
        this.timeout = null;
        if (this.popupInstance) this.popupInstance.hide();
    }
    loadTooltip(e, component, tooltip) {
        var contentsEl, renderedCallback, coords;
        function onRendered(callback) {
            renderedCallback = callback;
        }
        if (typeof tooltip === "function") tooltip = tooltip(e, component.getComponent(), onRendered);
        if (tooltip instanceof HTMLElement) contentsEl = tooltip;
        else {
            contentsEl = document.createElement("div");
            if (tooltip === true) {
                if (component instanceof $c2a9788f40f9c90a$var$Cell) tooltip = component.value;
                else if (component.definition.field) this.langBind("columns|" + component.definition.field, (value)=>{
                    contentsEl.innerHTML = tooltip = value || component.definition.title;
                });
                else tooltip = component.definition.title;
            }
            contentsEl.innerHTML = tooltip;
        }
        if (tooltip || tooltip === 0 || tooltip === false) {
            contentsEl.classList.add("tabulator-tooltip");
            contentsEl.addEventListener("mousemove", (e)=>e.preventDefault());
            this.popupInstance = this.popup(contentsEl);
            if (typeof renderedCallback === "function") this.popupInstance.renderCallback(renderedCallback);
            coords = this.popupInstance.containerEventCoords(e);
            this.popupInstance.show(coords.x + 15, coords.y + 15).hideOnBlur(()=>{
                this.dispatchExternal("TooltipClosed", component.getComponent());
                this.popupInstance = null;
            });
            this.dispatchExternal("TooltipOpened", component.getComponent());
        }
    }
}
var $c2a9788f40f9c90a$var$defaultValidators = {
    //is integer
    integer: function(cell, value, parameters) {
        if (value === "" || value === null || typeof value === "undefined") return true;
        value = Number(value);
        return !isNaN(value) && isFinite(value) && Math.floor(value) === value;
    },
    //is float
    float: function(cell, value, parameters) {
        if (value === "" || value === null || typeof value === "undefined") return true;
        value = Number(value);
        return !isNaN(value) && isFinite(value) && value % 1 !== 0;
    },
    //must be a number
    numeric: function(cell, value, parameters) {
        if (value === "" || value === null || typeof value === "undefined") return true;
        return !isNaN(value);
    },
    //must be a string
    string: function(cell, value, parameters) {
        if (value === "" || value === null || typeof value === "undefined") return true;
        return isNaN(value);
    },
    //must be alphanumeric
    alphanumeric: function(cell, value, parameters) {
        if (value === "" || value === null || typeof value === "undefined") return true;
        var reg = new RegExp(/^[a-z0-9]+$/i);
        return reg.test(value);
    },
    //maximum value
    max: function(cell, value, parameters) {
        if (value === "" || value === null || typeof value === "undefined") return true;
        return parseFloat(value) <= parameters;
    },
    //minimum value
    min: function(cell, value, parameters) {
        if (value === "" || value === null || typeof value === "undefined") return true;
        return parseFloat(value) >= parameters;
    },
    //starts with  value
    starts: function(cell, value, parameters) {
        if (value === "" || value === null || typeof value === "undefined") return true;
        return String(value).toLowerCase().startsWith(String(parameters).toLowerCase());
    },
    //ends with  value
    ends: function(cell, value, parameters) {
        if (value === "" || value === null || typeof value === "undefined") return true;
        return String(value).toLowerCase().endsWith(String(parameters).toLowerCase());
    },
    //minimum string length
    minLength: function(cell, value, parameters) {
        if (value === "" || value === null || typeof value === "undefined") return true;
        return String(value).length >= parameters;
    },
    //maximum string length
    maxLength: function(cell, value, parameters) {
        if (value === "" || value === null || typeof value === "undefined") return true;
        return String(value).length <= parameters;
    },
    //in provided value list
    in: function(cell, value, parameters) {
        if (value === "" || value === null || typeof value === "undefined") return true;
        if (typeof parameters == "string") parameters = parameters.split("|");
        return parameters.indexOf(value) > -1;
    },
    //must match provided regex
    regex: function(cell, value, parameters) {
        if (value === "" || value === null || typeof value === "undefined") return true;
        var reg = new RegExp(parameters);
        return reg.test(value);
    },
    //value must be unique in this column
    unique: function(cell, value, parameters) {
        if (value === "" || value === null || typeof value === "undefined") return true;
        var unique = true;
        var cellData = cell.getData();
        var column = cell.getColumn()._getSelf();
        this.table.rowManager.rows.forEach(function(row) {
            var data = row.getData();
            if (data !== cellData) {
                if (value == column.getFieldValue(data)) unique = false;
            }
        });
        return unique;
    },
    //must have a value
    required: function(cell, value, parameters) {
        return value !== "" && value !== null && typeof value !== "undefined";
    }
};
class $c2a9788f40f9c90a$export$db48c5a2fa1f03d4 extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "validate";
    //load defaults
    static validators = $c2a9788f40f9c90a$var$defaultValidators;
    constructor(table){
        super(table);
        this.invalidCells = [];
        this.registerTableOption("validationMode", "blocking");
        this.registerColumnOption("validator");
        this.registerTableFunction("getInvalidCells", this.getInvalidCells.bind(this));
        this.registerTableFunction("clearCellValidation", this.userClearCellValidation.bind(this));
        this.registerTableFunction("validate", this.userValidate.bind(this));
        this.registerComponentFunction("cell", "isValid", this.cellIsValid.bind(this));
        this.registerComponentFunction("cell", "clearValidation", this.clearValidation.bind(this));
        this.registerComponentFunction("cell", "validate", this.cellValidate.bind(this));
        this.registerComponentFunction("column", "validate", this.columnValidate.bind(this));
        this.registerComponentFunction("row", "validate", this.rowValidate.bind(this));
    }
    initialize() {
        this.subscribe("cell-delete", this.clearValidation.bind(this));
        this.subscribe("column-layout", this.initializeColumnCheck.bind(this));
        this.subscribe("edit-success", this.editValidate.bind(this));
        this.subscribe("edit-editor-clear", this.editorClear.bind(this));
        this.subscribe("edit-edited-clear", this.editedClear.bind(this));
    }
    ///////////////////////////////////
    ///////// Event Handling //////////
    ///////////////////////////////////
    editValidate(cell, value, previousValue) {
        var valid = this.table.options.validationMode !== "manual" ? this.validate(cell.column.modules.validate, cell, value) : true;
        // allow time for editor to make render changes then style cell
        if (valid !== true) setTimeout(()=>{
            cell.getElement().classList.add("tabulator-validation-fail");
            this.dispatchExternal("validationFailed", cell.getComponent(), value, valid);
        });
        return valid;
    }
    editorClear(cell, cancelled) {
        if (cancelled) {
            if (cell.column.modules.validate) this.cellValidate(cell);
        }
        cell.getElement().classList.remove("tabulator-validation-fail");
    }
    editedClear(cell) {
        if (cell.modules.validate) cell.modules.validate.invalid = false;
    }
    ///////////////////////////////////
    ////////// Cell Functions /////////
    ///////////////////////////////////
    cellIsValid(cell) {
        return cell.modules.validate ? cell.modules.validate.invalid || true : true;
    }
    cellValidate(cell) {
        return this.validate(cell.column.modules.validate, cell, cell.getValue());
    }
    ///////////////////////////////////
    ///////// Column Functions ////////
    ///////////////////////////////////
    columnValidate(column) {
        var invalid = [];
        column.cells.forEach((cell)=>{
            if (this.cellValidate(cell) !== true) invalid.push(cell.getComponent());
        });
        return invalid.length ? invalid : true;
    }
    ///////////////////////////////////
    ////////// Row Functions //////////
    ///////////////////////////////////
    rowValidate(row) {
        var invalid = [];
        row.cells.forEach((cell)=>{
            if (this.cellValidate(cell) !== true) invalid.push(cell.getComponent());
        });
        return invalid.length ? invalid : true;
    }
    ///////////////////////////////////
    ///////// Table Functions /////////
    ///////////////////////////////////
    userClearCellValidation(cells) {
        if (!cells) cells = this.getInvalidCells();
        if (!Array.isArray(cells)) cells = [
            cells
        ];
        cells.forEach((cell)=>{
            this.clearValidation(cell._getSelf());
        });
    }
    userValidate(cells) {
        var output = [];
        //clear row data
        this.table.rowManager.rows.forEach((row)=>{
            row = row.getComponent();
            var valid = row.validate();
            if (valid !== true) output = output.concat(valid);
        });
        return output.length ? output : true;
    }
    ///////////////////////////////////
    ///////// Internal Logic //////////
    ///////////////////////////////////
    initializeColumnCheck(column) {
        if (typeof column.definition.validator !== "undefined") this.initializeColumn(column);
    }
    //validate
    initializeColumn(column) {
        var self = this, config = [], validator;
        if (column.definition.validator) {
            if (Array.isArray(column.definition.validator)) column.definition.validator.forEach((item)=>{
                validator = self._extractValidator(item);
                if (validator) config.push(validator);
            });
            else {
                validator = this._extractValidator(column.definition.validator);
                if (validator) config.push(validator);
            }
            column.modules.validate = config.length ? config : false;
        }
    }
    _extractValidator(value) {
        var type, params, pos;
        switch(typeof value){
            case "string":
                pos = value.indexOf(":");
                if (pos > -1) {
                    type = value.substring(0, pos);
                    params = value.substring(pos + 1);
                } else type = value;
                return this._buildValidator(type, params);
            case "function":
                return this._buildValidator(value);
            case "object":
                return this._buildValidator(value.type, value.parameters);
        }
    }
    _buildValidator(type, params) {
        var func = typeof type == "function" ? type : $c2a9788f40f9c90a$export$db48c5a2fa1f03d4.validators[type];
        if (!func) {
            console.warn("Validator Setup Error - No matching validator found:", type);
            return false;
        } else return {
            type: typeof type == "function" ? "function" : type,
            func: func,
            params: params
        };
    }
    validate(validators, cell, value) {
        var self = this, failedValidators = [], invalidIndex = this.invalidCells.indexOf(cell);
        if (validators) validators.forEach((item)=>{
            if (!item.func.call(self, cell.getComponent(), value, item.params)) failedValidators.push({
                type: item.type,
                parameters: item.params
            });
        });
        if (!cell.modules.validate) cell.modules.validate = {};
        if (!failedValidators.length) {
            cell.modules.validate.invalid = false;
            cell.getElement().classList.remove("tabulator-validation-fail");
            if (invalidIndex > -1) this.invalidCells.splice(invalidIndex, 1);
        } else {
            cell.modules.validate.invalid = failedValidators;
            if (this.table.options.validationMode !== "manual") cell.getElement().classList.add("tabulator-validation-fail");
            if (invalidIndex == -1) this.invalidCells.push(cell);
        }
        return failedValidators.length ? failedValidators : true;
    }
    getInvalidCells() {
        var output = [];
        this.invalidCells.forEach((cell)=>{
            output.push(cell.getComponent());
        });
        return output;
    }
    clearValidation(cell) {
        var invalidIndex;
        if (cell.modules.validate && cell.modules.validate.invalid) {
            cell.getElement().classList.remove("tabulator-validation-fail");
            cell.modules.validate.invalid = false;
            invalidIndex = this.invalidCells.indexOf(cell);
            if (invalidIndex > -1) this.invalidCells.splice(invalidIndex, 1);
        }
    }
}
var $c2a9788f40f9c90a$var$allModules = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    AccessorModule: $c2a9788f40f9c90a$export$bf9f5472bce61c69,
    AjaxModule: $c2a9788f40f9c90a$export$b25c9f93be571d3a,
    ClipboardModule: $c2a9788f40f9c90a$export$3a36bd45ca02edda,
    ColumnCalcsModule: $c2a9788f40f9c90a$export$840b3bc55b30dec6,
    DataTreeModule: $c2a9788f40f9c90a$export$a5a9878f12569c04,
    DownloadModule: $c2a9788f40f9c90a$export$6dd96c6d41f32a97,
    EditModule: $c2a9788f40f9c90a$export$2394e2d3d2175314,
    ExportModule: $c2a9788f40f9c90a$export$4e0f34fd9829977c,
    FilterModule: $c2a9788f40f9c90a$export$2e3bebbdf3339a4e,
    FormatModule: $c2a9788f40f9c90a$export$5634f967e02d772d,
    FrozenColumnsModule: $c2a9788f40f9c90a$export$c00c4e95a253fbf9,
    FrozenRowsModule: $c2a9788f40f9c90a$export$6e51ce5331c5fffa,
    GroupRowsModule: $c2a9788f40f9c90a$export$41e6b6ec902cbe0a,
    HistoryModule: $c2a9788f40f9c90a$export$173658fc60691186,
    HtmlTableImportModule: $c2a9788f40f9c90a$export$b0b448c470bac827,
    ImportModule: $c2a9788f40f9c90a$export$bceca318c211ca25,
    InteractionModule: $c2a9788f40f9c90a$export$69fa60f71dd0541a,
    KeybindingsModule: $c2a9788f40f9c90a$export$a0ff4f1c226a7cef,
    MenuModule: $c2a9788f40f9c90a$export$f1ab43fc4c3c5ce0,
    MoveColumnsModule: $c2a9788f40f9c90a$export$9ab7496e9b38c128,
    MoveRowsModule: $c2a9788f40f9c90a$export$7815d73158f0bb2d,
    MutatorModule: $c2a9788f40f9c90a$export$d0f669567356cabd,
    PageModule: $c2a9788f40f9c90a$export$7eba6c45a494ceac,
    PersistenceModule: $c2a9788f40f9c90a$export$6ce0215a06bec981,
    PopupModule: $c2a9788f40f9c90a$export$5a0eb14a9c37d425,
    PrintModule: $c2a9788f40f9c90a$export$94fbe99c03f5a051,
    ReactiveDataModule: $c2a9788f40f9c90a$export$1806fba60a0e8399,
    ResizeColumnsModule: $c2a9788f40f9c90a$export$3a1ca422b395df54,
    ResizeRowsModule: $c2a9788f40f9c90a$export$5651a6c35bd86023,
    ResizeTableModule: $c2a9788f40f9c90a$export$977e646a85a63aba,
    ResponsiveLayoutModule: $c2a9788f40f9c90a$export$cc8706005768c818,
    SelectRangeModule: $c2a9788f40f9c90a$export$cd9e469b2c8c819c,
    SelectRowModule: $c2a9788f40f9c90a$export$2e4fadc5338e55f5,
    SortModule: $c2a9788f40f9c90a$export$5b492eb49d632e3f,
    SpreadsheetModule: $c2a9788f40f9c90a$export$bbb96e34680d7364,
    TooltipModule: $c2a9788f40f9c90a$export$d0c662c133b8814e,
    ValidateModule: $c2a9788f40f9c90a$export$db48c5a2fa1f03d4
});
var $c2a9788f40f9c90a$var$defaultOptions = {
    debugEventsExternal: false,
    debugEventsInternal: false,
    debugInvalidOptions: true,
    debugInvalidComponentFuncs: true,
    debugInitialization: true,
    debugDeprecation: true,
    height: false,
    minHeight: false,
    maxHeight: false,
    columnHeaderVertAlign: "top",
    popupContainer: false,
    columns: [],
    columnDefaults: {},
    rowHeader: false,
    data: false,
    autoColumns: false,
    autoColumnsDefinitions: false,
    nestedFieldSeparator: ".",
    footerElement: false,
    index: "id",
    textDirection: "auto",
    addRowPos: "bottom",
    headerVisible: true,
    renderVertical: "virtual",
    renderHorizontal: "basic",
    renderVerticalBuffer: 0,
    scrollToRowPosition: "top",
    scrollToRowIfVisible: true,
    scrollToColumnPosition: "left",
    scrollToColumnIfVisible: true,
    rowFormatter: false,
    rowFormatterPrint: null,
    rowFormatterClipboard: null,
    rowFormatterHtmlOutput: null,
    rowHeight: null,
    placeholder: false,
    dataLoader: true,
    dataLoaderLoading: false,
    dataLoaderError: false,
    dataLoaderErrorTimeout: 3000,
    dataSendParams: {},
    dataReceiveParams: {}
};
class $c2a9788f40f9c90a$var$OptionsList {
    constructor(table, msgType, defaults = {}){
        this.table = table;
        this.msgType = msgType;
        this.registeredDefaults = Object.assign({}, defaults);
    }
    register(option, value) {
        this.registeredDefaults[option] = value;
    }
    generate(defaultOptions, userOptions = {}) {
        var output = Object.assign({}, this.registeredDefaults), warn = this.table.options.debugInvalidOptions || userOptions.debugInvalidOptions === true;
        Object.assign(output, defaultOptions);
        for(let key in userOptions)if (!output.hasOwnProperty(key)) {
            if (warn) console.warn("Invalid " + this.msgType + " option:", key);
            output[key] = userOptions.key;
        }
        for(let key in output)if (key in userOptions) output[key] = userOptions[key];
        else {
            if (Array.isArray(output[key])) output[key] = Object.assign([], output[key]);
            else if (typeof output[key] === "object" && output[key] !== null) output[key] = Object.assign({}, output[key]);
            else if (typeof output[key] === "undefined") delete output[key];
        }
        return output;
    }
}
class $c2a9788f40f9c90a$export$88530751e3977073 extends $c2a9788f40f9c90a$var$CoreFeature {
    constructor(table){
        super(table);
        this.elementVertical = table.rowManager.element;
        this.elementHorizontal = table.columnManager.element;
        this.tableElement = table.rowManager.tableElement;
        this.verticalFillMode = "fit"; // used by row manager to determine how to size the render area ("fit" - fits container to the contents, "fill" - fills the container without resizing it)
    }
    ///////////////////////////////////
    /////// Internal Bindings /////////
    ///////////////////////////////////
    initialize() {
    //initialize core functionality
    }
    clearRows() {
    //clear down existing rows layout
    }
    clearColumns() {
    //clear down existing columns layout
    }
    reinitializeColumnWidths(columns) {
    //resize columns to fit data
    }
    renderRows() {
    //render rows from a clean slate
    }
    renderColumns() {
    //render columns from a clean slate
    }
    rerenderRows(callback) {
        // rerender rows and keep position
        if (callback) callback();
    }
    rerenderColumns(update, blockRedraw) {
    //rerender columns
    }
    renderRowCells(row) {
    //render the cells in a row
    }
    rerenderRowCells(row, force) {
    //rerender the cells in a row
    }
    scrollColumns(left, dir) {
    //handle horizontal scrolling
    }
    scrollRows(top, dir) {
    //handle vertical scrolling
    }
    resize() {
    //container has resized, carry out any needed recalculations (DO NOT RERENDER IN THIS FUNCTION)
    }
    scrollToRow(row) {
    //scroll to a specific row
    }
    scrollToRowNearestTop(row) {
    //determine weather the row is nearest the top or bottom of the table, return true for top or false for bottom
    }
    visibleRows(includingBuffer) {
        //return the visible rows
        return [];
    }
    ///////////////////////////////////
    //////// Helper Functions /////////
    ///////////////////////////////////
    rows() {
        return this.table.rowManager.getDisplayRows();
    }
    styleRow(row, index) {
        var rowEl = row.getElement();
        if (index % 2) {
            rowEl.classList.add("tabulator-row-even");
            rowEl.classList.remove("tabulator-row-odd");
        } else {
            rowEl.classList.add("tabulator-row-odd");
            rowEl.classList.remove("tabulator-row-even");
        }
    }
    ///////////////////////////////////
    /////// External Triggers /////////
    /////// (DO NOT OVERRIDE) /////////
    ///////////////////////////////////
    clear() {
        //clear down existing layout
        this.clearRows();
        this.clearColumns();
    }
    render() {
        //render from a clean slate
        this.renderRows();
        this.renderColumns();
    }
    rerender(callback) {
        // rerender and keep position
        this.rerenderRows();
        this.rerenderColumns();
    }
    scrollToRowPosition(row, position, ifVisible) {
        var rowIndex = this.rows().indexOf(row), rowEl = row.getElement(), offset = 0;
        return new Promise((resolve, reject)=>{
            if (rowIndex > -1) {
                if (typeof ifVisible === "undefined") ifVisible = this.table.options.scrollToRowIfVisible;
                //check row visibility
                if (!ifVisible) {
                    if ($c2a9788f40f9c90a$var$Helpers.elVisible(rowEl)) {
                        offset = $c2a9788f40f9c90a$var$Helpers.elOffset(rowEl).top - $c2a9788f40f9c90a$var$Helpers.elOffset(this.elementVertical).top;
                        if (offset > 0 && offset < this.elementVertical.clientHeight - rowEl.offsetHeight) {
                            resolve();
                            return false;
                        }
                    }
                }
                if (typeof position === "undefined") position = this.table.options.scrollToRowPosition;
                if (position === "nearest") position = this.scrollToRowNearestTop(row) ? "top" : "bottom";
                //scroll to row
                this.scrollToRow(row);
                //align to correct position
                switch(position){
                    case "middle":
                    case "center":
                        if (this.elementVertical.scrollHeight - this.elementVertical.scrollTop == this.elementVertical.clientHeight) this.elementVertical.scrollTop = this.elementVertical.scrollTop + (rowEl.offsetTop - this.elementVertical.scrollTop) - (this.elementVertical.scrollHeight - rowEl.offsetTop) / 2;
                        else this.elementVertical.scrollTop = this.elementVertical.scrollTop - this.elementVertical.clientHeight / 2;
                        break;
                    case "bottom":
                        if (this.elementVertical.scrollHeight - this.elementVertical.scrollTop == this.elementVertical.clientHeight) this.elementVertical.scrollTop = this.elementVertical.scrollTop - (this.elementVertical.scrollHeight - rowEl.offsetTop) + rowEl.offsetHeight;
                        else this.elementVertical.scrollTop = this.elementVertical.scrollTop - this.elementVertical.clientHeight + rowEl.offsetHeight;
                        break;
                    case "top":
                        this.elementVertical.scrollTop = rowEl.offsetTop;
                        break;
                }
                resolve();
            } else {
                console.warn("Scroll Error - Row not visible");
                reject("Scroll Error - Row not visible");
            }
        });
    }
}
class $c2a9788f40f9c90a$var$BasicHorizontal extends $c2a9788f40f9c90a$export$88530751e3977073 {
    constructor(table){
        super(table);
    }
    renderRowCells(row, inFragment) {
        const rowFrag = document.createDocumentFragment();
        row.cells.forEach((cell)=>{
            rowFrag.appendChild(cell.getElement());
        });
        row.element.appendChild(rowFrag);
        if (!inFragment) row.cells.forEach((cell)=>{
            cell.cellRendered();
        });
    }
    reinitializeColumnWidths(columns) {
        columns.forEach(function(column) {
            column.reinitializeWidth();
        });
    }
}
class $c2a9788f40f9c90a$var$VirtualDomHorizontal extends $c2a9788f40f9c90a$export$88530751e3977073 {
    constructor(table){
        super(table);
        this.leftCol = 0;
        this.rightCol = 0;
        this.scrollLeft = 0;
        this.vDomScrollPosLeft = 0;
        this.vDomScrollPosRight = 0;
        this.vDomPadLeft = 0;
        this.vDomPadRight = 0;
        this.fitDataColAvg = 0;
        this.windowBuffer = 200; //pixel margin to make column visible before it is shown on screen
        this.visibleRows = null;
        this.initialized = false;
        this.isFitData = false;
        this.columns = [];
    }
    initialize() {
        this.compatibilityCheck();
        this.layoutCheck();
        this.vertScrollListen();
    }
    compatibilityCheck() {
        if (this.options("layout") == "fitDataTable") console.warn("Horizontal Virtual DOM is not compatible with fitDataTable layout mode");
        if (this.options("responsiveLayout")) console.warn("Horizontal Virtual DOM is not compatible with responsive columns");
        if (this.options("rtl")) console.warn("Horizontal Virtual DOM is not currently compatible with RTL text direction");
    }
    layoutCheck() {
        this.isFitData = this.options("layout").startsWith("fitData");
    }
    vertScrollListen() {
        this.subscribe("scroll-vertical", this.clearVisRowCache.bind(this));
        this.subscribe("data-refreshed", this.clearVisRowCache.bind(this));
    }
    clearVisRowCache() {
        this.visibleRows = null;
    }
    //////////////////////////////////////
    ///////// Public Functions ///////////
    //////////////////////////////////////
    renderColumns(row, force) {
        this.dataChange();
    }
    scrollColumns(left, dir) {
        if (this.scrollLeft != left) {
            this.scrollLeft = left;
            this.scroll(left - (this.vDomScrollPosLeft + this.windowBuffer));
        }
    }
    calcWindowBuffer() {
        var buffer = this.elementVertical.clientWidth;
        this.table.columnManager.columnsByIndex.forEach((column)=>{
            if (column.visible) {
                var width = column.getWidth();
                if (width > buffer) buffer = width;
            }
        });
        this.windowBuffer = buffer * 2;
    }
    rerenderColumns(update, blockRedraw) {
        var old = {
            cols: this.columns,
            leftCol: this.leftCol,
            rightCol: this.rightCol
        }, colPos = 0;
        if (update && !this.initialized) return;
        this.clear();
        this.calcWindowBuffer();
        this.scrollLeft = this.elementVertical.scrollLeft;
        this.vDomScrollPosLeft = this.scrollLeft - this.windowBuffer;
        this.vDomScrollPosRight = this.scrollLeft + this.elementVertical.clientWidth + this.windowBuffer;
        this.table.columnManager.columnsByIndex.forEach((column)=>{
            var config = {}, width;
            if (column.visible) {
                if (!column.modules.frozen) {
                    width = column.getWidth();
                    config.leftPos = colPos;
                    config.rightPos = colPos + width;
                    config.width = width;
                    if (this.isFitData) config.fitDataCheck = column.modules.vdomHoz ? column.modules.vdomHoz.fitDataCheck : true;
                    if (colPos + width > this.vDomScrollPosLeft && colPos < this.vDomScrollPosRight) {
                        //column is visible
                        if (this.leftCol == -1) {
                            this.leftCol = this.columns.length;
                            this.vDomPadLeft = colPos;
                        }
                        this.rightCol = this.columns.length;
                    } else // column is hidden
                    if (this.leftCol !== -1) this.vDomPadRight += width;
                    this.columns.push(column);
                    column.modules.vdomHoz = config;
                    colPos += width;
                }
            }
        });
        this.tableElement.style.paddingLeft = this.vDomPadLeft + "px";
        this.tableElement.style.paddingRight = this.vDomPadRight + "px";
        this.initialized = true;
        if (!blockRedraw) {
            if (!update || this.reinitChanged(old)) this.reinitializeRows();
        }
        this.elementVertical.scrollLeft = this.scrollLeft;
    }
    renderRowCells(row) {
        if (this.initialized) this.initializeRow(row);
        else {
            const rowFrag = document.createDocumentFragment();
            row.cells.forEach((cell)=>{
                rowFrag.appendChild(cell.getElement());
            });
            row.element.appendChild(rowFrag);
            row.cells.forEach((cell)=>{
                cell.cellRendered();
            });
        }
    }
    rerenderRowCells(row, force) {
        this.reinitializeRow(row, force);
    }
    reinitializeColumnWidths(columns) {
        for(let i = this.leftCol; i <= this.rightCol; i++)this.columns[i].reinitializeWidth();
    }
    //////////////////////////////////////
    //////// Internal Rendering //////////
    //////////////////////////////////////
    deinitialize() {
        this.initialized = false;
    }
    clear() {
        this.columns = [];
        this.leftCol = -1;
        this.rightCol = 0;
        this.vDomScrollPosLeft = 0;
        this.vDomScrollPosRight = 0;
        this.vDomPadLeft = 0;
        this.vDomPadRight = 0;
    }
    dataChange() {
        var change = false, row, rowEl;
        if (this.isFitData) {
            this.table.columnManager.columnsByIndex.forEach((column)=>{
                if (!column.definition.width && column.visible) change = true;
            });
            if (change && this.table.rowManager.getDisplayRows().length) {
                this.vDomScrollPosRight = this.scrollLeft + this.elementVertical.clientWidth + this.windowBuffer;
                row = this.chain("rows-sample", [
                    1
                ], [], ()=>{
                    return this.table.rowManager.getDisplayRows();
                })[0];
                if (row) {
                    rowEl = row.getElement();
                    row.generateCells();
                    this.tableElement.appendChild(rowEl);
                    for(let colEnd = 0; colEnd < row.cells.length; colEnd++){
                        let cell = row.cells[colEnd];
                        rowEl.appendChild(cell.getElement());
                        cell.column.reinitializeWidth();
                    }
                    rowEl.parentNode.removeChild(rowEl);
                    this.rerenderColumns(false, true);
                }
            }
        } else if (this.options("layout") === "fitColumns") {
            this.layoutRefresh();
            this.rerenderColumns(false, true);
        }
    }
    reinitChanged(old) {
        var match = true;
        if (old.cols.length !== this.columns.length || old.leftCol !== this.leftCol || old.rightCol !== this.rightCol) return true;
        old.cols.forEach((col, i)=>{
            if (col !== this.columns[i]) match = false;
        });
        return !match;
    }
    reinitializeRows() {
        var visibleRows = this.getVisibleRows(), otherRows = this.table.rowManager.getRows().filter((row)=>!visibleRows.includes(row));
        visibleRows.forEach((row)=>{
            this.reinitializeRow(row, true);
        });
        otherRows.forEach((row)=>{
            row.deinitialize();
        });
    }
    getVisibleRows() {
        if (!this.visibleRows) this.visibleRows = this.table.rowManager.getVisibleRows();
        return this.visibleRows;
    }
    scroll(diff) {
        this.vDomScrollPosLeft += diff;
        this.vDomScrollPosRight += diff;
        if (Math.abs(diff) > this.windowBuffer / 2) this.rerenderColumns();
        else if (diff > 0) {
            //scroll right
            this.addColRight();
            this.removeColLeft();
        } else {
            //scroll left
            this.addColLeft();
            this.removeColRight();
        }
    }
    colPositionAdjust(start, end, diff) {
        for(let i = start; i < end; i++){
            let column = this.columns[i];
            column.modules.vdomHoz.leftPos += diff;
            column.modules.vdomHoz.rightPos += diff;
        }
    }
    addColRight() {
        var changes = false, working = true;
        while(working){
            let column = this.columns[this.rightCol + 1];
            if (column) {
                if (column.modules.vdomHoz.leftPos <= this.vDomScrollPosRight) {
                    changes = true;
                    this.getVisibleRows().forEach((row)=>{
                        if (row.type !== "group") {
                            var cell = row.getCell(column);
                            row.getElement().insertBefore(cell.getElement(), row.getCell(this.columns[this.rightCol]).getElement().nextSibling);
                            cell.cellRendered();
                        }
                    });
                    this.fitDataColActualWidthCheck(column);
                    this.rightCol++; // Don't move this below the >= check below
                    this.getVisibleRows().forEach((row)=>{
                        if (row.type !== "group") row.modules.vdomHoz.rightCol = this.rightCol;
                    });
                    if (this.rightCol >= this.columns.length - 1) this.vDomPadRight = 0;
                    else this.vDomPadRight -= column.getWidth();
                } else working = false;
            } else working = false;
        }
        if (changes) this.tableElement.style.paddingRight = this.vDomPadRight + "px";
    }
    addColLeft() {
        var changes = false, working = true;
        while(working){
            let column = this.columns[this.leftCol - 1];
            if (column) {
                if (column.modules.vdomHoz.rightPos >= this.vDomScrollPosLeft) {
                    changes = true;
                    this.getVisibleRows().forEach((row)=>{
                        if (row.type !== "group") {
                            var cell = row.getCell(column);
                            row.getElement().insertBefore(cell.getElement(), row.getCell(this.columns[this.leftCol]).getElement());
                            cell.cellRendered();
                        }
                    });
                    this.leftCol--; // don't move this below the <= check below
                    this.getVisibleRows().forEach((row)=>{
                        if (row.type !== "group") row.modules.vdomHoz.leftCol = this.leftCol;
                    });
                    if (this.leftCol <= 0) this.vDomPadLeft = 0;
                    else this.vDomPadLeft -= column.getWidth();
                    let diff = this.fitDataColActualWidthCheck(column);
                    if (diff) {
                        this.scrollLeft = this.elementVertical.scrollLeft = this.elementVertical.scrollLeft + diff;
                        this.vDomPadRight -= diff;
                    }
                } else working = false;
            } else working = false;
        }
        if (changes) this.tableElement.style.paddingLeft = this.vDomPadLeft + "px";
    }
    removeColRight() {
        var changes = false, working = true;
        while(working){
            let column = this.columns[this.rightCol];
            if (column) {
                if (column.modules.vdomHoz.leftPos > this.vDomScrollPosRight) {
                    changes = true;
                    this.getVisibleRows().forEach((row)=>{
                        if (row.type !== "group") {
                            var cell = row.getCell(column);
                            try {
                                row.getElement().removeChild(cell.getElement());
                            } catch (ex) {
                                console.warn("Could not removeColRight", ex.message);
                            }
                        }
                    });
                    this.vDomPadRight += column.getWidth();
                    this.rightCol--;
                    this.getVisibleRows().forEach((row)=>{
                        if (row.type !== "group") row.modules.vdomHoz.rightCol = this.rightCol;
                    });
                } else working = false;
            } else working = false;
        }
        if (changes) this.tableElement.style.paddingRight = this.vDomPadRight + "px";
    }
    removeColLeft() {
        var changes = false, working = true;
        while(working){
            let column = this.columns[this.leftCol];
            if (column) {
                if (column.modules.vdomHoz.rightPos < this.vDomScrollPosLeft) {
                    changes = true;
                    this.getVisibleRows().forEach((row)=>{
                        if (row.type !== "group") {
                            var cell = row.getCell(column);
                            try {
                                row.getElement().removeChild(cell.getElement());
                            } catch (ex) {
                                console.warn("Could not removeColLeft", ex.message);
                            }
                        }
                    });
                    this.vDomPadLeft += column.getWidth();
                    this.leftCol++;
                    this.getVisibleRows().forEach((row)=>{
                        if (row.type !== "group") row.modules.vdomHoz.leftCol = this.leftCol;
                    });
                } else working = false;
            } else working = false;
        }
        if (changes) this.tableElement.style.paddingLeft = this.vDomPadLeft + "px";
    }
    fitDataColActualWidthCheck(column) {
        var newWidth, widthDiff;
        if (column.modules.vdomHoz.fitDataCheck) {
            column.reinitializeWidth();
            newWidth = column.getWidth();
            widthDiff = newWidth - column.modules.vdomHoz.width;
            if (widthDiff) {
                column.modules.vdomHoz.rightPos += widthDiff;
                column.modules.vdomHoz.width = newWidth;
                this.colPositionAdjust(this.columns.indexOf(column) + 1, this.columns.length, widthDiff);
            }
            column.modules.vdomHoz.fitDataCheck = false;
        }
        return widthDiff;
    }
    initializeRow(row) {
        if (row.type !== "group") {
            row.modules.vdomHoz = {
                leftCol: this.leftCol,
                rightCol: this.rightCol
            };
            if (this.table.modules.frozenColumns) this.table.modules.frozenColumns.leftColumns.forEach((column)=>{
                this.appendCell(row, column);
            });
            for(let i = this.leftCol; i <= this.rightCol; i++)this.appendCell(row, this.columns[i]);
            if (this.table.modules.frozenColumns) this.table.modules.frozenColumns.rightColumns.forEach((column)=>{
                this.appendCell(row, column);
            });
        }
    }
    appendCell(row, column) {
        if (column && column.visible) {
            let cell = row.getCell(column);
            row.getElement().appendChild(cell.getElement());
            cell.cellRendered();
        }
    }
    reinitializeRow(row, force) {
        if (row.type !== "group") {
            if (force || !row.modules.vdomHoz || row.modules.vdomHoz.leftCol !== this.leftCol || row.modules.vdomHoz.rightCol !== this.rightCol) {
                var rowEl = row.getElement();
                while(rowEl.firstChild)rowEl.removeChild(rowEl.firstChild);
                this.initializeRow(row);
            }
        }
    }
}
class $c2a9788f40f9c90a$var$ColumnManager extends $c2a9788f40f9c90a$var$CoreFeature {
    constructor(table){
        super(table);
        this.blockHozScrollEvent = false;
        this.headersElement = null;
        this.contentsElement = null;
        this.rowHeader = null;
        this.element = null; //containing element
        this.columns = []; // column definition object
        this.columnsByIndex = []; //columns by index
        this.columnsByField = {}; //columns by field
        this.scrollLeft = 0;
        this.optionsList = new $c2a9788f40f9c90a$var$OptionsList(this.table, "column definition", $c2a9788f40f9c90a$var$defaultColumnOptions);
        this.redrawBlock = false; //prevent redraws to allow multiple data manipulations before continuing
        this.redrawBlockUpdate = null; //store latest redraw update only status
        this.renderer = null;
    }
    ////////////// Setup Functions /////////////////
    initialize() {
        this.initializeRenderer();
        this.headersElement = this.createHeadersElement();
        this.contentsElement = this.createHeaderContentsElement();
        this.element = this.createHeaderElement();
        this.contentsElement.insertBefore(this.headersElement, this.contentsElement.firstChild);
        this.element.insertBefore(this.contentsElement, this.element.firstChild);
        this.initializeScrollWheelWatcher();
        this.subscribe("scroll-horizontal", this.scrollHorizontal.bind(this));
        this.subscribe("scrollbar-vertical", this.padVerticalScrollbar.bind(this));
    }
    padVerticalScrollbar(width) {
        if (this.table.rtl) this.headersElement.style.marginLeft = width + "px";
        else this.headersElement.style.marginRight = width + "px";
    }
    initializeRenderer() {
        var renderClass;
        var renderers = {
            "virtual": $c2a9788f40f9c90a$var$VirtualDomHorizontal,
            "basic": $c2a9788f40f9c90a$var$BasicHorizontal
        };
        if (typeof this.table.options.renderHorizontal === "string") renderClass = renderers[this.table.options.renderHorizontal];
        else renderClass = this.table.options.renderHorizontal;
        if (renderClass) {
            this.renderer = new renderClass(this.table, this.element, this.tableElement);
            this.renderer.initialize();
        } else console.error("Unable to find matching renderer:", this.table.options.renderHorizontal);
    }
    createHeadersElement() {
        var el = document.createElement("div");
        el.classList.add("tabulator-headers");
        el.setAttribute("role", "row");
        return el;
    }
    createHeaderContentsElement() {
        var el = document.createElement("div");
        el.classList.add("tabulator-header-contents");
        el.setAttribute("role", "rowgroup");
        return el;
    }
    createHeaderElement() {
        var el = document.createElement("div");
        el.classList.add("tabulator-header");
        el.setAttribute("role", "rowgroup");
        if (!this.table.options.headerVisible) el.classList.add("tabulator-header-hidden");
        return el;
    }
    //return containing element
    getElement() {
        return this.element;
    }
    //return containing contents element
    getContentsElement() {
        return this.contentsElement;
    }
    //return header containing element
    getHeadersElement() {
        return this.headersElement;
    }
    //scroll horizontally to match table body
    scrollHorizontal(left) {
        this.contentsElement.scrollLeft = left;
        this.scrollLeft = left;
        this.renderer.scrollColumns(left);
    }
    initializeScrollWheelWatcher() {
        this.contentsElement.addEventListener("wheel", (e)=>{
            var left;
            if (e.deltaX) {
                left = this.contentsElement.scrollLeft + e.deltaX;
                this.table.rowManager.scrollHorizontal(left);
                this.table.columnManager.scrollHorizontal(left);
            }
        });
    }
    ///////////// Column Setup Functions /////////////
    generateColumnsFromRowData(data) {
        var cols = [], collProgress = {}, rowSample = this.table.options.autoColumns === "full" ? data : [
            data[0]
        ], definitions = this.table.options.autoColumnsDefinitions;
        if (data && data.length) {
            rowSample.forEach((row)=>{
                Object.keys(row).forEach((key, index)=>{
                    let value = row[key], col;
                    if (!collProgress[key]) {
                        col = {
                            field: key,
                            title: key,
                            sorter: this.calculateSorterFromValue(value)
                        };
                        cols.splice(index, 0, col);
                        collProgress[key] = typeof value === "undefined" ? col : true;
                    } else if (collProgress[key] !== true) {
                        if (typeof value !== "undefined") {
                            collProgress[key].sorter = this.calculateSorterFromValue(value);
                            collProgress[key] = true;
                        }
                    }
                });
            });
            if (definitions) switch(typeof definitions){
                case "function":
                    this.table.options.columns = definitions.call(this.table, cols);
                    break;
                case "object":
                    if (Array.isArray(definitions)) cols.forEach((col)=>{
                        var match = definitions.find((def)=>{
                            return def.field === col.field;
                        });
                        if (match) Object.assign(col, match);
                    });
                    else cols.forEach((col)=>{
                        if (definitions[col.field]) Object.assign(col, definitions[col.field]);
                    });
                    this.table.options.columns = cols;
                    break;
            }
            else this.table.options.columns = cols;
            this.setColumns(this.table.options.columns);
        }
    }
    calculateSorterFromValue(value) {
        var sorter;
        switch(typeof value){
            case "undefined":
                sorter = "string";
                break;
            case "boolean":
                sorter = "boolean";
                break;
            case "number":
                sorter = "number";
                break;
            case "object":
                if (Array.isArray(value)) sorter = "array";
                else sorter = "string";
                break;
            default:
                if (!isNaN(value) && value !== "") sorter = "number";
                else if (value.match(/((^[0-9]+[a-z]+)|(^[a-z]+[0-9]+))+$/i)) sorter = "alphanum";
                else sorter = "string";
                break;
        }
        return sorter;
    }
    setColumns(cols, row) {
        while(this.headersElement.firstChild)this.headersElement.removeChild(this.headersElement.firstChild);
        this.columns = [];
        this.columnsByIndex = [];
        this.columnsByField = {};
        this.dispatch("columns-loading");
        this.dispatchExternal("columnsLoading");
        if (this.table.options.rowHeader) {
            this.rowHeader = new $c2a9788f40f9c90a$var$Column(this.table.options.rowHeader === true ? {} : this.table.options.rowHeader, this, true);
            this.columns.push(this.rowHeader);
            this.headersElement.appendChild(this.rowHeader.getElement());
            this.rowHeader.columnRendered();
        }
        cols.forEach((def, i)=>{
            this._addColumn(def);
        });
        this._reIndexColumns();
        this.dispatch("columns-loaded");
        if (this.subscribedExternal("columnsLoaded")) this.dispatchExternal("columnsLoaded", this.getComponents());
        this.rerenderColumns(false, true);
        this.redraw(true);
    }
    _addColumn(definition, before, nextToColumn) {
        var column = new $c2a9788f40f9c90a$var$Column(definition, this), colEl = column.getElement(), index = nextToColumn ? this.findColumnIndex(nextToColumn) : nextToColumn;
        //prevent adding of rows in front of row header
        if (before && this.rowHeader && (!nextToColumn || nextToColumn === this.rowHeader)) {
            before = false;
            nextToColumn = this.rowHeader;
            index = 0;
        }
        if (nextToColumn && index > -1) {
            var topColumn = nextToColumn.getTopColumn();
            var parentIndex = this.columns.indexOf(topColumn);
            var nextEl = topColumn.getElement();
            if (before) {
                this.columns.splice(parentIndex, 0, column);
                nextEl.parentNode.insertBefore(colEl, nextEl);
            } else {
                this.columns.splice(parentIndex + 1, 0, column);
                nextEl.parentNode.insertBefore(colEl, nextEl.nextSibling);
            }
        } else if (before) {
            this.columns.unshift(column);
            this.headersElement.insertBefore(column.getElement(), this.headersElement.firstChild);
        } else {
            this.columns.push(column);
            this.headersElement.appendChild(column.getElement());
        }
        column.columnRendered();
        return column;
    }
    registerColumnField(col) {
        if (col.definition.field) this.columnsByField[col.definition.field] = col;
    }
    registerColumnPosition(col) {
        this.columnsByIndex.push(col);
    }
    _reIndexColumns() {
        this.columnsByIndex = [];
        this.columns.forEach(function(column) {
            column.reRegisterPosition();
        });
    }
    //ensure column headers take up the correct amount of space in column groups
    verticalAlignHeaders() {
        var minHeight = 0;
        if (!this.redrawBlock) {
            this.headersElement.style.height = "";
            this.columns.forEach((column)=>{
                column.clearVerticalAlign();
            });
            this.columns.forEach((column)=>{
                var height = column.getHeight();
                if (height > minHeight) minHeight = height;
            });
            this.headersElement.style.height = minHeight + "px";
            this.columns.forEach((column)=>{
                column.verticalAlign(this.table.options.columnHeaderVertAlign, minHeight);
            });
            this.table.rowManager.adjustTableSize();
        }
    }
    //////////////// Column Details /////////////////
    findColumn(subject) {
        var columns;
        if (typeof subject == "object") {
            if (subject instanceof $c2a9788f40f9c90a$var$Column) //subject is column element
            return subject;
            else if (subject instanceof $c2a9788f40f9c90a$export$11bb209ad3a8e411) //subject is public column component
            return subject._getSelf() || false;
            else if (typeof HTMLElement !== "undefined" && subject instanceof HTMLElement) {
                columns = [];
                this.columns.forEach((column)=>{
                    columns.push(column);
                    columns = columns.concat(column.getColumns(true));
                });
                //subject is a HTML element of the column header
                let match = columns.find((column)=>{
                    return column.element === subject;
                });
                return match || false;
            }
        } else //subject should be treated as the field name of the column
        return this.columnsByField[subject] || false;
        //catch all for any other type of input
        return false;
    }
    getColumnByField(field) {
        return this.columnsByField[field];
    }
    getColumnsByFieldRoot(root) {
        var matches = [];
        Object.keys(this.columnsByField).forEach((field)=>{
            var fieldRoot = this.table.options.nestedFieldSeparator ? field.split(this.table.options.nestedFieldSeparator)[0] : field;
            if (fieldRoot === root) matches.push(this.columnsByField[field]);
        });
        return matches;
    }
    getColumnByIndex(index) {
        return this.columnsByIndex[index];
    }
    getFirstVisibleColumn() {
        var index = this.columnsByIndex.findIndex((col)=>{
            return col.visible;
        });
        return index > -1 ? this.columnsByIndex[index] : false;
    }
    getVisibleColumnsByIndex() {
        return this.columnsByIndex.filter((col)=>col.visible);
    }
    getColumns() {
        return this.columns;
    }
    findColumnIndex(column) {
        return this.columnsByIndex.findIndex((col)=>{
            return column === col;
        });
    }
    //return all columns that are not groups
    getRealColumns() {
        return this.columnsByIndex;
    }
    //traverse across columns and call action
    traverse(callback) {
        this.columnsByIndex.forEach((column, i)=>{
            callback(column, i);
        });
    }
    //get definitions of actual columns
    getDefinitions(active) {
        var output = [];
        this.columnsByIndex.forEach((column)=>{
            if (!active || active && column.visible) output.push(column.getDefinition());
        });
        return output;
    }
    //get full nested definition tree
    getDefinitionTree() {
        var output = [];
        this.columns.forEach((column)=>{
            output.push(column.getDefinition(true));
        });
        return output;
    }
    getComponents(structured) {
        var output = [], columns = structured ? this.columns : this.columnsByIndex;
        columns.forEach((column)=>{
            output.push(column.getComponent());
        });
        return output;
    }
    getWidth() {
        var width = 0;
        this.columnsByIndex.forEach((column)=>{
            if (column.visible) width += column.getWidth();
        });
        return width;
    }
    moveColumn(from, to, after) {
        to.element.parentNode.insertBefore(from.element, to.element);
        if (after) to.element.parentNode.insertBefore(to.element, from.element);
        this.moveColumnActual(from, to, after);
        this.verticalAlignHeaders();
        this.table.rowManager.reinitialize();
    }
    moveColumnActual(from, to, after) {
        if (from.parent.isGroup) this._moveColumnInArray(from.parent.columns, from, to, after);
        else this._moveColumnInArray(this.columns, from, to, after);
        this._moveColumnInArray(this.columnsByIndex, from, to, after, true);
        this.rerenderColumns(true);
        this.dispatch("column-moved", from, to, after);
        if (this.subscribedExternal("columnMoved")) this.dispatchExternal("columnMoved", from.getComponent(), this.table.columnManager.getComponents());
    }
    _moveColumnInArray(columns, from, to, after, updateRows) {
        var fromIndex = columns.indexOf(from), toIndex, rows = [];
        if (fromIndex > -1) {
            columns.splice(fromIndex, 1);
            toIndex = columns.indexOf(to);
            if (toIndex > -1) {
                if (after) toIndex = toIndex + 1;
            } else toIndex = fromIndex;
            columns.splice(toIndex, 0, from);
            if (updateRows) {
                rows = this.chain("column-moving-rows", [
                    from,
                    to,
                    after
                ], null, []) || [];
                rows = rows.concat(this.table.rowManager.rows);
                rows.forEach(function(row) {
                    if (row.cells.length) {
                        var cell = row.cells.splice(fromIndex, 1)[0];
                        row.cells.splice(toIndex, 0, cell);
                    }
                });
            }
        }
    }
    scrollToColumn(column, position, ifVisible) {
        var left = 0, offset = column.getLeftOffset(), adjust = 0, colEl = column.getElement();
        return new Promise((resolve, reject)=>{
            if (typeof position === "undefined") position = this.table.options.scrollToColumnPosition;
            if (typeof ifVisible === "undefined") ifVisible = this.table.options.scrollToColumnIfVisible;
            if (column.visible) {
                //align to correct position
                switch(position){
                    case "middle":
                    case "center":
                        adjust = -this.element.clientWidth / 2;
                        break;
                    case "right":
                        adjust = colEl.clientWidth - this.headersElement.clientWidth;
                        break;
                }
                //check column visibility
                if (!ifVisible) {
                    if (offset > 0 && offset + colEl.offsetWidth < this.element.clientWidth) return false;
                }
                //calculate scroll position
                left = offset + adjust;
                left = Math.max(Math.min(left, this.table.rowManager.element.scrollWidth - this.table.rowManager.element.clientWidth), 0);
                this.table.rowManager.scrollHorizontal(left);
                this.scrollHorizontal(left);
                resolve();
            } else {
                console.warn("Scroll Error - Column not visible");
                reject("Scroll Error - Column not visible");
            }
        });
    }
    //////////////// Cell Management /////////////////
    generateCells(row) {
        var cells = [];
        this.columnsByIndex.forEach((column)=>{
            cells.push(column.generateCell(row));
        });
        return cells;
    }
    //////////////// Column Management /////////////////
    getFlexBaseWidth() {
        var totalWidth = this.table.element.clientWidth, fixedWidth = 0;
        //adjust for vertical scrollbar if present
        if (this.table.rowManager.element.scrollHeight > this.table.rowManager.element.clientHeight) totalWidth -= this.table.rowManager.element.offsetWidth - this.table.rowManager.element.clientWidth;
        this.columnsByIndex.forEach(function(column) {
            var width, minWidth, colWidth;
            if (column.visible) {
                width = column.definition.width || 0;
                minWidth = parseInt(column.minWidth);
                if (typeof width == "string") {
                    if (width.indexOf("%") > -1) colWidth = totalWidth / 100 * parseInt(width);
                    else colWidth = parseInt(width);
                } else colWidth = width;
                fixedWidth += colWidth > minWidth ? colWidth : minWidth;
            }
        });
        return fixedWidth;
    }
    addColumn(definition, before, nextToColumn) {
        return new Promise((resolve, reject)=>{
            var column = this._addColumn(definition, before, nextToColumn);
            this._reIndexColumns();
            this.dispatch("column-add", definition, before, nextToColumn);
            if (this.layoutMode() != "fitColumns") column.reinitializeWidth();
            this.redraw(true);
            this.table.rowManager.reinitialize();
            this.rerenderColumns();
            resolve(column);
        });
    }
    //remove column from system
    deregisterColumn(column) {
        var field = column.getField(), index;
        //remove from field list
        if (field) delete this.columnsByField[field];
        //remove from index list
        index = this.columnsByIndex.indexOf(column);
        if (index > -1) this.columnsByIndex.splice(index, 1);
        //remove from column list
        index = this.columns.indexOf(column);
        if (index > -1) this.columns.splice(index, 1);
        this.verticalAlignHeaders();
        this.redraw();
    }
    rerenderColumns(update, silent) {
        if (!this.redrawBlock) this.renderer.rerenderColumns(update, silent);
        else if (update === false || update === true && this.redrawBlockUpdate === null) this.redrawBlockUpdate = update;
    }
    blockRedraw() {
        this.redrawBlock = true;
        this.redrawBlockUpdate = null;
    }
    restoreRedraw() {
        this.redrawBlock = false;
        this.verticalAlignHeaders();
        this.renderer.rerenderColumns(this.redrawBlockUpdate);
    }
    //redraw columns
    redraw(force) {
        if ($c2a9788f40f9c90a$var$Helpers.elVisible(this.element)) this.verticalAlignHeaders();
        if (force) {
            this.table.rowManager.resetScroll();
            this.table.rowManager.reinitialize();
        }
        if (!this.confirm("table-redrawing", force)) this.layoutRefresh(force);
        this.dispatch("table-redraw", force);
        this.table.footerManager.redraw();
    }
}
class $c2a9788f40f9c90a$var$BasicVertical extends $c2a9788f40f9c90a$export$88530751e3977073 {
    constructor(table){
        super(table);
        this.verticalFillMode = "fill";
        this.scrollTop = 0;
        this.scrollLeft = 0;
        this.scrollTop = 0;
        this.scrollLeft = 0;
    }
    clearRows() {
        var element = this.tableElement;
        // element.children.detach();
        while(element.firstChild)element.removeChild(element.firstChild);
        element.scrollTop = 0;
        element.scrollLeft = 0;
        element.style.minWidth = "";
        element.style.minHeight = "";
        element.style.display = "";
        element.style.visibility = "";
    }
    renderRows() {
        var element = this.tableElement, onlyGroupHeaders = true, tableFrag = document.createDocumentFragment(), rows = this.rows();
        rows.forEach((row, index)=>{
            this.styleRow(row, index);
            row.initialize(false, true);
            if (row.type !== "group") onlyGroupHeaders = false;
            tableFrag.appendChild(row.getElement());
        });
        element.appendChild(tableFrag);
        rows.forEach((row)=>{
            row.rendered();
            if (!row.heightInitialized) row.calcHeight(true);
        });
        rows.forEach((row)=>{
            if (!row.heightInitialized) row.setCellHeight();
        });
        if (onlyGroupHeaders) element.style.minWidth = this.table.columnManager.getWidth() + "px";
        else element.style.minWidth = "";
    }
    rerenderRows(callback) {
        this.clearRows();
        if (callback) callback();
        this.renderRows();
        if (!this.rows().length) this.table.rowManager.tableEmpty();
    }
    scrollToRowNearestTop(row) {
        var rowTop = $c2a9788f40f9c90a$var$Helpers.elOffset(row.getElement()).top;
        return !(Math.abs(this.elementVertical.scrollTop - rowTop) > Math.abs(this.elementVertical.scrollTop + this.elementVertical.clientHeight - rowTop));
    }
    scrollToRow(row) {
        var rowEl = row.getElement();
        this.elementVertical.scrollTop = $c2a9788f40f9c90a$var$Helpers.elOffset(rowEl).top - $c2a9788f40f9c90a$var$Helpers.elOffset(this.elementVertical).top + this.elementVertical.scrollTop;
    }
    visibleRows(includingBuffer) {
        return this.rows();
    }
}
class $c2a9788f40f9c90a$var$VirtualDomVertical extends $c2a9788f40f9c90a$export$88530751e3977073 {
    constructor(table){
        super(table);
        this.verticalFillMode = "fill";
        this.scrollTop = 0;
        this.scrollLeft = 0;
        this.vDomRowHeight = 20; //approximation of row heights for padding
        this.vDomTop = 0; //hold position for first rendered row in the virtual DOM
        this.vDomBottom = 0; //hold position for last rendered row in the virtual DOM
        this.vDomScrollPosTop = 0; //last scroll position of the vDom top;
        this.vDomScrollPosBottom = 0; //last scroll position of the vDom bottom;
        this.vDomTopPad = 0; //hold value of padding for top of virtual DOM
        this.vDomBottomPad = 0; //hold value of padding for bottom of virtual DOM
        this.vDomMaxRenderChain = 90; //the maximum number of dom elements that can be rendered in 1 go
        this.vDomWindowBuffer = 0; //window row buffer before removing elements, to smooth scrolling
        this.vDomWindowMinTotalRows = 20; //minimum number of rows to be generated in virtual dom (prevent buffering issues on tables with tall rows)
        this.vDomWindowMinMarginRows = 5; //minimum number of rows to be generated in virtual dom margin
        this.vDomTopNewRows = []; //rows to normalize after appending to optimize render speed
        this.vDomBottomNewRows = []; //rows to normalize after appending to optimize render speed
    }
    //////////////////////////////////////
    ///////// Public Functions ///////////
    //////////////////////////////////////
    clearRows() {
        var element = this.tableElement;
        // element.children.detach();
        while(element.firstChild)element.removeChild(element.firstChild);
        element.style.paddingTop = "";
        element.style.paddingBottom = "";
        element.style.minHeight = "";
        element.style.display = "";
        element.style.visibility = "";
        this.elementVertical.scrollTop = 0;
        this.elementVertical.scrollLeft = 0;
        this.scrollTop = 0;
        this.scrollLeft = 0;
        this.vDomTop = 0;
        this.vDomBottom = 0;
        this.vDomTopPad = 0;
        this.vDomBottomPad = 0;
        this.vDomScrollPosTop = 0;
        this.vDomScrollPosBottom = 0;
    }
    renderRows() {
        this._virtualRenderFill();
    }
    rerenderRows(callback) {
        var scrollTop = this.elementVertical.scrollTop;
        var topRow = false;
        var topOffset = false;
        var left = this.table.rowManager.scrollLeft;
        var rows = this.rows();
        for(var i = this.vDomTop; i <= this.vDomBottom; i++)if (rows[i]) {
            var diff = scrollTop - rows[i].getElement().offsetTop;
            if (topOffset === false || Math.abs(diff) < topOffset) {
                topOffset = diff;
                topRow = i;
            } else break;
        }
        rows.forEach((row)=>{
            row.deinitializeHeight();
        });
        if (callback) callback();
        if (this.rows().length) this._virtualRenderFill(topRow === false ? this.rows.length - 1 : topRow, true, topOffset || 0);
        else {
            this.clear();
            this.table.rowManager.tableEmpty();
        }
        this.scrollColumns(left);
    }
    scrollColumns(left) {
        this.table.rowManager.scrollHorizontal(left);
    }
    scrollRows(top, dir) {
        var topDiff = top - this.vDomScrollPosTop;
        var bottomDiff = top - this.vDomScrollPosBottom;
        var margin = this.vDomWindowBuffer * 2;
        var rows = this.rows();
        this.scrollTop = top;
        if (-topDiff > margin || bottomDiff > margin) {
            //if big scroll redraw table;
            var left = this.table.rowManager.scrollLeft;
            this._virtualRenderFill(Math.floor(this.elementVertical.scrollTop / this.elementVertical.scrollHeight * rows.length));
            this.scrollColumns(left);
        } else if (dir) {
            //scrolling up
            if (topDiff < 0) this._addTopRow(rows, -topDiff);
            if (bottomDiff < 0) {
                //hide bottom row if needed
                if (this.vDomScrollHeight - this.scrollTop > this.vDomWindowBuffer) this._removeBottomRow(rows, -bottomDiff);
                else this.vDomScrollPosBottom = this.scrollTop;
            }
        } else {
            if (bottomDiff >= 0) this._addBottomRow(rows, bottomDiff);
            //scrolling down
            if (topDiff >= 0) {
                //hide top row if needed
                if (this.scrollTop > this.vDomWindowBuffer) this._removeTopRow(rows, topDiff);
                else this.vDomScrollPosTop = this.scrollTop;
            }
        }
    }
    resize() {
        this.vDomWindowBuffer = this.table.options.renderVerticalBuffer || this.elementVertical.clientHeight;
    }
    scrollToRowNearestTop(row) {
        var rowIndex = this.rows().indexOf(row);
        return !(Math.abs(this.vDomTop - rowIndex) > Math.abs(this.vDomBottom - rowIndex));
    }
    scrollToRow(row) {
        var index = this.rows().indexOf(row);
        if (index > -1) this._virtualRenderFill(index, true);
    }
    visibleRows(includingBuffer) {
        var topEdge = this.elementVertical.scrollTop, bottomEdge = this.elementVertical.clientHeight + topEdge, topFound = false, topRow = 0, bottomRow = 0, rows = this.rows();
        if (includingBuffer) {
            topRow = this.vDomTop;
            bottomRow = this.vDomBottom;
        } else {
            for(var i = this.vDomTop; i <= this.vDomBottom; i++)if (rows[i]) {
                if (!topFound) {
                    if (topEdge - rows[i].getElement().offsetTop >= 0) topRow = i;
                    else {
                        topFound = true;
                        if (bottomEdge - rows[i].getElement().offsetTop >= 0) bottomRow = i;
                        else break;
                    }
                } else {
                    if (bottomEdge - rows[i].getElement().offsetTop >= 0) bottomRow = i;
                    else break;
                }
            }
        }
        return rows.slice(topRow, bottomRow + 1);
    }
    //////////////////////////////////////
    //////// Internal Rendering //////////
    //////////////////////////////////////
    //full virtual render
    _virtualRenderFill(position, forceMove, offset) {
        var element = this.tableElement, holder = this.elementVertical, topPad = 0, rowsHeight = 0, rowHeight = 0, heightOccupied = 0, topPadHeight = 0, i = 0, rows = this.rows(), rowsCount = rows.length, index = 0, row, rowFragment, renderedRows = [], totalRowsRendered = 0, rowsToRender = 0, fixedHeight = this.table.rowManager.fixedHeight, containerHeight = this.elementVertical.clientHeight, avgRowHeight = this.table.options.rowHeight, resized = true;
        position = position || 0;
        offset = offset || 0;
        if (!position) this.clear();
        else {
            while(element.firstChild)element.removeChild(element.firstChild);
            //check if position is too close to bottom of table
            heightOccupied = (rowsCount - position + 1) * this.vDomRowHeight;
            if (heightOccupied < containerHeight) {
                position -= Math.ceil((containerHeight - heightOccupied) / this.vDomRowHeight);
                if (position < 0) position = 0;
            }
            //calculate initial pad
            topPad = Math.min(Math.max(Math.floor(this.vDomWindowBuffer / this.vDomRowHeight), this.vDomWindowMinMarginRows), position);
            position -= topPad;
        }
        if (rowsCount && $c2a9788f40f9c90a$var$Helpers.elVisible(this.elementVertical)) {
            this.vDomTop = position;
            this.vDomBottom = position - 1;
            if (fixedHeight || this.table.options.maxHeight) {
                if (avgRowHeight) rowsToRender = containerHeight / avgRowHeight + this.vDomWindowBuffer / avgRowHeight;
                rowsToRender = Math.max(this.vDomWindowMinTotalRows, Math.ceil(rowsToRender));
            } else rowsToRender = rowsCount;
            while((rowsToRender == rowsCount || rowsHeight <= containerHeight + this.vDomWindowBuffer || totalRowsRendered < this.vDomWindowMinTotalRows) && this.vDomBottom < rowsCount - 1){
                renderedRows = [];
                rowFragment = document.createDocumentFragment();
                i = 0;
                while(i < rowsToRender && this.vDomBottom < rowsCount - 1){
                    index = this.vDomBottom + 1, row = rows[index];
                    this.styleRow(row, index);
                    row.initialize(false, true);
                    if (!row.heightInitialized && !this.table.options.rowHeight) row.clearCellHeight();
                    rowFragment.appendChild(row.getElement());
                    renderedRows.push(row);
                    this.vDomBottom++;
                    i++;
                }
                if (!renderedRows.length) break;
                element.appendChild(rowFragment);
                // NOTE: The next 3 loops are separate on purpose
                // This is to batch up the dom writes and reads which drastically improves performance 
                renderedRows.forEach((row)=>{
                    row.rendered();
                    if (!row.heightInitialized) row.calcHeight(true);
                });
                renderedRows.forEach((row)=>{
                    if (!row.heightInitialized) row.setCellHeight();
                });
                renderedRows.forEach((row)=>{
                    rowHeight = row.getHeight();
                    if (totalRowsRendered < topPad) topPadHeight += rowHeight;
                    else rowsHeight += rowHeight;
                    if (rowHeight > this.vDomWindowBuffer) this.vDomWindowBuffer = rowHeight * 2;
                    totalRowsRendered++;
                });
                resized = this.table.rowManager.adjustTableSize();
                containerHeight = this.elementVertical.clientHeight;
                if (resized && (fixedHeight || this.table.options.maxHeight)) {
                    avgRowHeight = rowsHeight / totalRowsRendered;
                    rowsToRender = Math.max(this.vDomWindowMinTotalRows, Math.ceil(containerHeight / avgRowHeight + this.vDomWindowBuffer / avgRowHeight));
                }
            }
            if (!position) {
                this.vDomTopPad = 0;
                //adjust row height to match average of rendered elements
                this.vDomRowHeight = Math.floor((rowsHeight + topPadHeight) / totalRowsRendered);
                this.vDomBottomPad = this.vDomRowHeight * (rowsCount - this.vDomBottom - 1);
                this.vDomScrollHeight = topPadHeight + rowsHeight + this.vDomBottomPad - containerHeight;
            } else {
                this.vDomTopPad = !forceMove ? this.scrollTop - topPadHeight : this.vDomRowHeight * this.vDomTop + offset;
                this.vDomBottomPad = this.vDomBottom == rowsCount - 1 ? 0 : Math.max(this.vDomScrollHeight - this.vDomTopPad - rowsHeight - topPadHeight, 0);
            }
            element.style.paddingTop = this.vDomTopPad + "px";
            element.style.paddingBottom = this.vDomBottomPad + "px";
            if (forceMove) this.scrollTop = this.vDomTopPad + topPadHeight + offset - (this.elementVertical.scrollWidth > this.elementVertical.clientWidth ? this.elementVertical.offsetHeight - containerHeight : 0);
            this.scrollTop = Math.min(this.scrollTop, this.elementVertical.scrollHeight - containerHeight);
            //adjust for horizontal scrollbar if present (and not at top of table)
            if (this.elementVertical.scrollWidth > this.elementVertical.clientWidth && forceMove) this.scrollTop += this.elementVertical.offsetHeight - containerHeight;
            this.vDomScrollPosTop = this.scrollTop;
            this.vDomScrollPosBottom = this.scrollTop;
            holder.scrollTop = this.scrollTop;
            this.dispatch("render-virtual-fill");
        }
    }
    _addTopRow(rows, fillableSpace) {
        var table = this.tableElement, addedRows = [], paddingAdjust = 0, index = this.vDomTop - 1, i = 0, working = true;
        while(working)if (this.vDomTop) {
            let row = rows[index], rowHeight, initialized;
            if (row && i < this.vDomMaxRenderChain) {
                rowHeight = row.getHeight() || this.vDomRowHeight;
                initialized = row.initialized;
                if (fillableSpace >= rowHeight) {
                    this.styleRow(row, index);
                    table.insertBefore(row.getElement(), table.firstChild);
                    if (!row.initialized || !row.heightInitialized) addedRows.push(row);
                    row.initialize();
                    if (!initialized) {
                        rowHeight = row.getElement().offsetHeight;
                        if (rowHeight > this.vDomWindowBuffer) this.vDomWindowBuffer = rowHeight * 2;
                    }
                    fillableSpace -= rowHeight;
                    paddingAdjust += rowHeight;
                    this.vDomTop--;
                    index--;
                    i++;
                } else working = false;
            } else working = false;
        } else working = false;
        for (let row of addedRows)row.clearCellHeight();
        this._quickNormalizeRowHeight(addedRows);
        if (paddingAdjust) {
            this.vDomTopPad -= paddingAdjust;
            if (this.vDomTopPad < 0) this.vDomTopPad = index * this.vDomRowHeight;
            if (index < 1) this.vDomTopPad = 0;
            table.style.paddingTop = this.vDomTopPad + "px";
            this.vDomScrollPosTop -= paddingAdjust;
        }
    }
    _removeTopRow(rows, fillableSpace) {
        var removableRows = [], paddingAdjust = 0, i = 0, working = true;
        while(working){
            let row = rows[this.vDomTop], rowHeight;
            if (row && i < this.vDomMaxRenderChain) {
                rowHeight = row.getHeight() || this.vDomRowHeight;
                if (fillableSpace >= rowHeight) {
                    this.vDomTop++;
                    fillableSpace -= rowHeight;
                    paddingAdjust += rowHeight;
                    removableRows.push(row);
                    i++;
                } else working = false;
            } else working = false;
        }
        for (let row of removableRows){
            let rowEl = row.getElement();
            if (rowEl.parentNode) rowEl.parentNode.removeChild(rowEl);
        }
        if (paddingAdjust) {
            this.vDomTopPad += paddingAdjust;
            this.tableElement.style.paddingTop = this.vDomTopPad + "px";
            this.vDomScrollPosTop += this.vDomTop ? paddingAdjust : paddingAdjust + this.vDomWindowBuffer;
        }
    }
    _addBottomRow(rows, fillableSpace) {
        var table = this.tableElement, addedRows = [], paddingAdjust = 0, index = this.vDomBottom + 1, i = 0, working = true;
        while(working){
            let row = rows[index], rowHeight, initialized;
            if (row && i < this.vDomMaxRenderChain) {
                rowHeight = row.getHeight() || this.vDomRowHeight;
                initialized = row.initialized;
                if (fillableSpace >= rowHeight) {
                    this.styleRow(row, index);
                    table.appendChild(row.getElement());
                    if (!row.initialized || !row.heightInitialized) addedRows.push(row);
                    row.initialize();
                    if (!initialized) {
                        rowHeight = row.getElement().offsetHeight;
                        if (rowHeight > this.vDomWindowBuffer) this.vDomWindowBuffer = rowHeight * 2;
                    }
                    fillableSpace -= rowHeight;
                    paddingAdjust += rowHeight;
                    this.vDomBottom++;
                    index++;
                    i++;
                } else working = false;
            } else working = false;
        }
        for (let row of addedRows)row.clearCellHeight();
        this._quickNormalizeRowHeight(addedRows);
        if (paddingAdjust) {
            this.vDomBottomPad -= paddingAdjust;
            if (this.vDomBottomPad < 0 || index == rows.length - 1) this.vDomBottomPad = 0;
            table.style.paddingBottom = this.vDomBottomPad + "px";
            this.vDomScrollPosBottom += paddingAdjust;
        }
    }
    _removeBottomRow(rows, fillableSpace) {
        var removableRows = [], paddingAdjust = 0, i = 0, working = true;
        while(working){
            let row = rows[this.vDomBottom], rowHeight;
            if (row && i < this.vDomMaxRenderChain) {
                rowHeight = row.getHeight() || this.vDomRowHeight;
                if (fillableSpace >= rowHeight) {
                    this.vDomBottom--;
                    fillableSpace -= rowHeight;
                    paddingAdjust += rowHeight;
                    removableRows.push(row);
                    i++;
                } else working = false;
            } else working = false;
        }
        for (let row of removableRows){
            let rowEl = row.getElement();
            if (rowEl.parentNode) rowEl.parentNode.removeChild(rowEl);
        }
        if (paddingAdjust) {
            this.vDomBottomPad += paddingAdjust;
            if (this.vDomBottomPad < 0) this.vDomBottomPad = 0;
            this.tableElement.style.paddingBottom = this.vDomBottomPad + "px";
            this.vDomScrollPosBottom -= paddingAdjust;
        }
    }
    _quickNormalizeRowHeight(rows) {
        for (let row of rows)row.calcHeight();
        for (let row of rows)row.setCellHeight();
    }
}
class $c2a9788f40f9c90a$var$RowManager extends $c2a9788f40f9c90a$var$CoreFeature {
    constructor(table){
        super(table);
        this.element = this.createHolderElement(); //containing element
        this.tableElement = this.createTableElement(); //table element
        this.heightFixer = this.createTableElement(); //table element
        this.placeholder = null; //placeholder element
        this.placeholderContents = null; //placeholder element
        this.firstRender = false; //handle first render
        this.renderMode = "virtual"; //current rendering mode
        this.fixedHeight = false; //current rendering mode
        this.rows = []; //hold row data objects
        this.activeRowsPipeline = []; //hold calculation of active rows
        this.activeRows = []; //rows currently available to on display in the table
        this.activeRowsCount = 0; //count of active rows
        this.displayRows = []; //rows currently on display in the table
        this.displayRowsCount = 0; //count of display rows
        this.scrollTop = 0;
        this.scrollLeft = 0;
        this.redrawBlock = false; //prevent redraws to allow multiple data manipulations before continuing
        this.redrawBlockRestoreConfig = false; //store latest redraw function calls for when redraw is needed
        this.redrawBlockRenderInPosition = false; //store latest redraw function calls for when redraw is needed
        this.dataPipeline = []; //hold data pipeline tasks
        this.displayPipeline = []; //hold data display pipeline tasks
        this.scrollbarWidth = 0;
        this.renderer = null;
    }
    //////////////// Setup Functions /////////////////
    createHolderElement() {
        var el = document.createElement("div");
        el.classList.add("tabulator-tableholder");
        el.setAttribute("tabindex", 0);
        // el.setAttribute("role", "rowgroup");
        return el;
    }
    createTableElement() {
        var el = document.createElement("div");
        el.classList.add("tabulator-table");
        el.setAttribute("role", "rowgroup");
        return el;
    }
    initializePlaceholder() {
        var placeholder = this.table.options.placeholder;
        if (typeof placeholder === "function") placeholder = placeholder.call(this.table);
        placeholder = this.chain("placeholder", [
            placeholder
        ], placeholder, placeholder) || placeholder;
        //configure placeholder element
        if (placeholder) {
            let el = document.createElement("div");
            el.classList.add("tabulator-placeholder");
            if (typeof placeholder == "string") {
                let contents = document.createElement("div");
                contents.classList.add("tabulator-placeholder-contents");
                contents.innerHTML = placeholder;
                el.appendChild(contents);
                this.placeholderContents = contents;
            } else if (typeof HTMLElement !== "undefined" && placeholder instanceof HTMLElement) {
                el.appendChild(placeholder);
                this.placeholderContents = placeholder;
            } else {
                console.warn("Invalid placeholder provided, must be string or HTML Element", placeholder);
                this.el = null;
            }
            this.placeholder = el;
        }
    }
    //return containing element
    getElement() {
        return this.element;
    }
    //return table element
    getTableElement() {
        return this.tableElement;
    }
    initialize() {
        this.initializePlaceholder();
        this.initializeRenderer();
        //initialize manager
        this.element.appendChild(this.tableElement);
        this.firstRender = true;
        //scroll header along with table body
        this.element.addEventListener("scroll", ()=>{
            var left = this.element.scrollLeft, leftDir = this.scrollLeft > left, top = this.element.scrollTop, topDir = this.scrollTop > top;
            //handle horizontal scrolling
            if (this.scrollLeft != left) {
                this.scrollLeft = left;
                this.dispatch("scroll-horizontal", left, leftDir);
                this.dispatchExternal("scrollHorizontal", left, leftDir);
                this._positionPlaceholder();
            }
            //handle vertical scrolling
            if (this.scrollTop != top) {
                this.scrollTop = top;
                this.renderer.scrollRows(top, topDir);
                this.dispatch("scroll-vertical", top, topDir);
                this.dispatchExternal("scrollVertical", top, topDir);
            }
        });
    }
    ////////////////// Row Manipulation //////////////////
    findRow(subject) {
        if (typeof subject == "object") {
            if (subject instanceof $c2a9788f40f9c90a$var$Row) //subject is row element
            return subject;
            else if (subject instanceof $c2a9788f40f9c90a$export$5df91075f5ba4651) //subject is public row component
            return subject._getSelf() || false;
            else if (typeof HTMLElement !== "undefined" && subject instanceof HTMLElement) {
                //subject is a HTML element of the row
                let match = this.rows.find((row)=>{
                    return row.getElement() === subject;
                });
                return match || false;
            } else if (subject === null) return false;
        } else if (typeof subject == "undefined") return false;
        else {
            //subject should be treated as the index of the row
            let match = this.rows.find((row)=>{
                return row.data[this.table.options.index] == subject;
            });
            return match || false;
        }
        //catch all for any other type of input
        return false;
    }
    getRowFromDataObject(data) {
        var match = this.rows.find((row)=>{
            return row.data === data;
        });
        return match || false;
    }
    getRowFromPosition(position) {
        return this.getDisplayRows().find((row)=>{
            return row.type === "row" && row.getPosition() === position && row.isDisplayed();
        });
    }
    scrollToRow(row, position, ifVisible) {
        return this.renderer.scrollToRowPosition(row, position, ifVisible);
    }
    ////////////////// Data Handling //////////////////
    setData(data, renderInPosition, columnsChanged) {
        return new Promise((resolve, reject)=>{
            if (renderInPosition && this.getDisplayRows().length) {
                if (this.table.options.pagination) this._setDataActual(data, true);
                else this.reRenderInPosition(()=>{
                    this._setDataActual(data);
                });
            } else {
                if (this.table.options.autoColumns && columnsChanged && this.table.initialized) this.table.columnManager.generateColumnsFromRowData(data);
                this.resetScroll();
                this._setDataActual(data);
            }
            resolve();
        });
    }
    _setDataActual(data, renderInPosition) {
        this.dispatchExternal("dataProcessing", data);
        this._wipeElements();
        if (Array.isArray(data)) {
            this.dispatch("data-processing", data);
            data.forEach((def, i)=>{
                if (def && typeof def === "object") {
                    var row = new $c2a9788f40f9c90a$var$Row(def, this);
                    this.rows.push(row);
                } else console.warn("Data Loading Warning - Invalid row data detected and ignored, expecting object but received:", def);
            });
            this.refreshActiveData(false, false, renderInPosition);
            this.dispatch("data-processed", data);
            this.dispatchExternal("dataProcessed", data);
        } else console.error("Data Loading Error - Unable to process data due to invalid data type \nExpecting: array \nReceived: ", typeof data, "\nData:     ", data);
    }
    _wipeElements() {
        this.dispatch("rows-wipe");
        this.destroy();
        this.adjustTableSize();
        this.dispatch("rows-wiped");
    }
    destroy() {
        this.rows.forEach((row)=>{
            row.wipe();
        });
        this.rows = [];
        this.activeRows = [];
        this.activeRowsPipeline = [];
        this.activeRowsCount = 0;
        this.displayRows = [];
        this.displayRowsCount = 0;
    }
    deleteRow(row, blockRedraw) {
        var allIndex = this.rows.indexOf(row), activeIndex = this.activeRows.indexOf(row);
        if (activeIndex > -1) this.activeRows.splice(activeIndex, 1);
        if (allIndex > -1) this.rows.splice(allIndex, 1);
        this.setActiveRows(this.activeRows);
        this.displayRowIterator((rows)=>{
            var displayIndex = rows.indexOf(row);
            if (displayIndex > -1) rows.splice(displayIndex, 1);
        });
        if (!blockRedraw) this.reRenderInPosition();
        this.regenerateRowPositions();
        this.dispatchExternal("rowDeleted", row.getComponent());
        if (!this.displayRowsCount) this.tableEmpty();
        if (this.subscribedExternal("dataChanged")) this.dispatchExternal("dataChanged", this.getData());
    }
    addRow(data, pos, index, blockRedraw) {
        var row = this.addRowActual(data, pos, index, blockRedraw);
        return row;
    }
    //add multiple rows
    addRows(data, pos, index, refreshDisplayOnly) {
        var rows = [];
        return new Promise((resolve, reject)=>{
            pos = this.findAddRowPos(pos);
            if (!Array.isArray(data)) data = [
                data
            ];
            if (typeof index == "undefined" && pos || typeof index !== "undefined" && !pos) data.reverse();
            data.forEach((item, i)=>{
                var row = this.addRow(item, pos, index, true);
                rows.push(row);
                this.dispatch("row-added", row, item, pos, index);
            });
            this.refreshActiveData(refreshDisplayOnly ? "displayPipeline" : false, false, true);
            this.regenerateRowPositions();
            if (this.displayRowsCount) this._clearPlaceholder();
            resolve(rows);
        });
    }
    findAddRowPos(pos) {
        if (typeof pos === "undefined") pos = this.table.options.addRowPos;
        if (pos === "pos") pos = true;
        if (pos === "bottom") pos = false;
        return pos;
    }
    addRowActual(data, pos, index, blockRedraw) {
        var row = data instanceof $c2a9788f40f9c90a$var$Row ? data : new $c2a9788f40f9c90a$var$Row(data || {}, this), top = this.findAddRowPos(pos), allIndex = -1, activeIndex, chainResult;
        if (!index) {
            chainResult = this.chain("row-adding-position", [
                row,
                top
            ], null, {
                index: index,
                top: top
            });
            index = chainResult.index;
            top = chainResult.top;
        }
        if (typeof index !== "undefined") index = this.findRow(index);
        index = this.chain("row-adding-index", [
            row,
            index,
            top
        ], null, index);
        if (index) allIndex = this.rows.indexOf(index);
        if (index && allIndex > -1) {
            activeIndex = this.activeRows.indexOf(index);
            this.displayRowIterator(function(rows) {
                var displayIndex = rows.indexOf(index);
                if (displayIndex > -1) rows.splice(top ? displayIndex : displayIndex + 1, 0, row);
            });
            if (activeIndex > -1) this.activeRows.splice(top ? activeIndex : activeIndex + 1, 0, row);
            this.rows.splice(top ? allIndex : allIndex + 1, 0, row);
        } else if (top) {
            this.displayRowIterator(function(rows) {
                rows.unshift(row);
            });
            this.activeRows.unshift(row);
            this.rows.unshift(row);
        } else {
            this.displayRowIterator(function(rows) {
                rows.push(row);
            });
            this.activeRows.push(row);
            this.rows.push(row);
        }
        this.setActiveRows(this.activeRows);
        this.dispatchExternal("rowAdded", row.getComponent());
        if (this.subscribedExternal("dataChanged")) this.dispatchExternal("dataChanged", this.table.rowManager.getData());
        if (!blockRedraw) this.reRenderInPosition();
        return row;
    }
    moveRow(from, to, after) {
        this.dispatch("row-move", from, to, after);
        this.moveRowActual(from, to, after);
        this.regenerateRowPositions();
        this.dispatch("row-moved", from, to, after);
        this.dispatchExternal("rowMoved", from.getComponent());
    }
    moveRowActual(from, to, after) {
        this.moveRowInArray(this.rows, from, to, after);
        this.moveRowInArray(this.activeRows, from, to, after);
        this.displayRowIterator((rows)=>{
            this.moveRowInArray(rows, from, to, after);
        });
        this.dispatch("row-moving", from, to, after);
    }
    moveRowInArray(rows, from, to, after) {
        var fromIndex, toIndex, start, end;
        if (from !== to) {
            fromIndex = rows.indexOf(from);
            if (fromIndex > -1) {
                rows.splice(fromIndex, 1);
                toIndex = rows.indexOf(to);
                if (toIndex > -1) {
                    if (after) rows.splice(toIndex + 1, 0, from);
                    else rows.splice(toIndex, 0, from);
                } else rows.splice(fromIndex, 0, from);
            }
            //restyle rows
            if (rows === this.getDisplayRows()) {
                start = fromIndex < toIndex ? fromIndex : toIndex;
                end = toIndex > fromIndex ? toIndex : fromIndex + 1;
                for(let i = start; i <= end; i++)if (rows[i]) this.styleRow(rows[i], i);
            }
        }
    }
    clearData() {
        this.setData([]);
    }
    getRowIndex(row) {
        return this.findRowIndex(row, this.rows);
    }
    getDisplayRowIndex(row) {
        var index = this.getDisplayRows().indexOf(row);
        return index > -1 ? index : false;
    }
    nextDisplayRow(row, rowOnly) {
        var index = this.getDisplayRowIndex(row), nextRow = false;
        if (index !== false && index < this.displayRowsCount - 1) nextRow = this.getDisplayRows()[index + 1];
        if (nextRow && (!(nextRow instanceof $c2a9788f40f9c90a$var$Row) || nextRow.type != "row")) return this.nextDisplayRow(nextRow, rowOnly);
        return nextRow;
    }
    prevDisplayRow(row, rowOnly) {
        var index = this.getDisplayRowIndex(row), prevRow = false;
        if (index) prevRow = this.getDisplayRows()[index - 1];
        if (rowOnly && prevRow && (!(prevRow instanceof $c2a9788f40f9c90a$var$Row) || prevRow.type != "row")) return this.prevDisplayRow(prevRow, rowOnly);
        return prevRow;
    }
    findRowIndex(row, list) {
        var rowIndex;
        row = this.findRow(row);
        if (row) {
            rowIndex = list.indexOf(row);
            if (rowIndex > -1) return rowIndex;
        }
        return false;
    }
    getData(active, transform) {
        var output = [], rows = this.getRows(active);
        rows.forEach(function(row) {
            if (row.type == "row") output.push(row.getData(transform || "data"));
        });
        return output;
    }
    getComponents(active) {
        var output = [], rows = this.getRows(active);
        rows.forEach(function(row) {
            output.push(row.getComponent());
        });
        return output;
    }
    getDataCount(active) {
        var rows = this.getRows(active);
        return rows.length;
    }
    scrollHorizontal(left) {
        this.scrollLeft = left;
        this.element.scrollLeft = left;
        this.dispatch("scroll-horizontal", left);
    }
    registerDataPipelineHandler(handler, priority) {
        if (typeof priority !== "undefined") {
            this.dataPipeline.push({
                handler: handler,
                priority: priority
            });
            this.dataPipeline.sort((a, b)=>{
                return a.priority - b.priority;
            });
        } else console.error("Data pipeline handlers must have a priority in order to be registered");
    }
    registerDisplayPipelineHandler(handler, priority) {
        if (typeof priority !== "undefined") {
            this.displayPipeline.push({
                handler: handler,
                priority: priority
            });
            this.displayPipeline.sort((a, b)=>{
                return a.priority - b.priority;
            });
        } else console.error("Display pipeline handlers must have a priority in order to be registered");
    }
    //set active data set
    refreshActiveData(handler, skipStage, renderInPosition) {
        var table = this.table, stage = "", index = 0, cascadeOrder = [
            "all",
            "dataPipeline",
            "display",
            "displayPipeline",
            "end"
        ];
        if (!this.table.destroyed) {
            if (typeof handler === "function") {
                index = this.dataPipeline.findIndex((item)=>{
                    return item.handler === handler;
                });
                if (index > -1) {
                    stage = "dataPipeline";
                    if (skipStage) {
                        if (index == this.dataPipeline.length - 1) stage = "display";
                        else index++;
                    }
                } else {
                    index = this.displayPipeline.findIndex((item)=>{
                        return item.handler === handler;
                    });
                    if (index > -1) {
                        stage = "displayPipeline";
                        if (skipStage) {
                            if (index == this.displayPipeline.length - 1) stage = "end";
                            else index++;
                        }
                    } else {
                        console.error("Unable to refresh data, invalid handler provided", handler);
                        return;
                    }
                }
            } else {
                stage = handler || "all";
                index = 0;
            }
            if (this.redrawBlock) {
                if (!this.redrawBlockRestoreConfig || this.redrawBlockRestoreConfig && (this.redrawBlockRestoreConfig.stage === stage && index < this.redrawBlockRestoreConfig.index || cascadeOrder.indexOf(stage) < cascadeOrder.indexOf(this.redrawBlockRestoreConfig.stage))) this.redrawBlockRestoreConfig = {
                    handler: handler,
                    skipStage: skipStage,
                    renderInPosition: renderInPosition,
                    stage: stage,
                    index: index
                };
                return;
            } else {
                if ($c2a9788f40f9c90a$var$Helpers.elVisible(this.element)) {
                    if (renderInPosition) this.reRenderInPosition(this.refreshPipelines.bind(this, handler, stage, index, renderInPosition));
                    else {
                        this.refreshPipelines(handler, stage, index, renderInPosition);
                        if (!handler) this.table.columnManager.renderer.renderColumns();
                        this.renderTable();
                        if (table.options.layoutColumnsOnNewData) this.table.columnManager.redraw(true);
                    }
                } else this.refreshPipelines(handler, stage, index, renderInPosition);
                this.dispatch("data-refreshed");
            }
        }
    }
    refreshPipelines(handler, stage, index, renderInPosition) {
        this.dispatch("data-refreshing");
        if (!handler || !this.activeRowsPipeline[0]) this.activeRowsPipeline[0] = this.rows.slice(0);
        //cascade through data refresh stages
        switch(stage){
            case "all":
            //handle case where all data needs refreshing
            case "dataPipeline":
                for(let i = index; i < this.dataPipeline.length; i++){
                    let result = this.dataPipeline[i].handler(this.activeRowsPipeline[i].slice(0));
                    this.activeRowsPipeline[i + 1] = result || this.activeRowsPipeline[i].slice(0);
                }
                this.setActiveRows(this.activeRowsPipeline[this.dataPipeline.length]);
            case "display":
                index = 0;
                this.resetDisplayRows();
            case "displayPipeline":
                for(let i = index; i < this.displayPipeline.length; i++){
                    let result = this.displayPipeline[i].handler((i ? this.getDisplayRows(i - 1) : this.activeRows).slice(0), renderInPosition);
                    this.setDisplayRows(result || this.getDisplayRows(i - 1).slice(0), i);
                }
            case "end":
                //case to handle scenario when trying to skip past end stage
                this.regenerateRowPositions();
        }
        if (this.getDisplayRows().length) this._clearPlaceholder();
    }
    //regenerate row positions
    regenerateRowPositions() {
        var rows = this.getDisplayRows();
        var index = 1;
        rows.forEach((row)=>{
            if (row.type === "row") {
                row.setPosition(index);
                index++;
            }
        });
    }
    setActiveRows(activeRows) {
        this.activeRows = this.activeRows = Object.assign([], activeRows);
        this.activeRowsCount = this.activeRows.length;
    }
    //reset display rows array
    resetDisplayRows() {
        this.displayRows = [];
        this.displayRows.push(this.activeRows.slice(0));
        this.displayRowsCount = this.displayRows[0].length;
    }
    //set display row pipeline data
    setDisplayRows(displayRows, index) {
        this.displayRows[index] = displayRows;
        if (index == this.displayRows.length - 1) this.displayRowsCount = this.displayRows[this.displayRows.length - 1].length;
    }
    getDisplayRows(index) {
        if (typeof index == "undefined") return this.displayRows.length ? this.displayRows[this.displayRows.length - 1] : [];
        else return this.displayRows[index] || [];
    }
    getVisibleRows(chain, viewable) {
        var rows = Object.assign([], this.renderer.visibleRows(!viewable));
        if (chain) rows = this.chain("rows-visible", [
            viewable
        ], rows, rows);
        return rows;
    }
    //repeat action across display rows
    displayRowIterator(callback) {
        this.activeRowsPipeline.forEach(callback);
        this.displayRows.forEach(callback);
        this.displayRowsCount = this.displayRows[this.displayRows.length - 1].length;
    }
    //return only actual rows (not group headers etc)
    getRows(type) {
        var rows = [];
        switch(type){
            case "active":
                rows = this.activeRows;
                break;
            case "display":
                rows = this.table.rowManager.getDisplayRows();
                break;
            case "visible":
                rows = this.getVisibleRows(false, true);
                break;
            default:
                rows = this.chain("rows-retrieve", type, null, this.rows) || this.rows;
        }
        return rows;
    }
    ///////////////// Table Rendering /////////////////
    //trigger rerender of table in current position
    reRenderInPosition(callback) {
        if (this.redrawBlock) {
            if (callback) callback();
            else this.redrawBlockRenderInPosition = true;
        } else {
            this.dispatchExternal("renderStarted");
            this.renderer.rerenderRows(callback);
            if (!this.fixedHeight) this.adjustTableSize();
            this.scrollBarCheck();
            this.dispatchExternal("renderComplete");
        }
    }
    scrollBarCheck() {
        var scrollbarWidth = 0;
        //adjust for vertical scrollbar moving table when present
        if (this.element.scrollHeight > this.element.clientHeight) scrollbarWidth = this.element.offsetWidth - this.element.clientWidth;
        if (scrollbarWidth !== this.scrollbarWidth) {
            this.scrollbarWidth = scrollbarWidth;
            this.dispatch("scrollbar-vertical", scrollbarWidth);
        }
    }
    initializeRenderer() {
        var renderClass;
        var renderers = {
            "virtual": $c2a9788f40f9c90a$var$VirtualDomVertical,
            "basic": $c2a9788f40f9c90a$var$BasicVertical
        };
        if (typeof this.table.options.renderVertical === "string") renderClass = renderers[this.table.options.renderVertical];
        else renderClass = this.table.options.renderVertical;
        if (renderClass) {
            this.renderMode = this.table.options.renderVertical;
            this.renderer = new renderClass(this.table, this.element, this.tableElement);
            this.renderer.initialize();
            if ((this.table.element.clientHeight || this.table.options.height) && !(this.table.options.minHeight && this.table.options.maxHeight)) this.fixedHeight = true;
            else this.fixedHeight = false;
        } else console.error("Unable to find matching renderer:", this.table.options.renderVertical);
    }
    getRenderMode() {
        return this.renderMode;
    }
    renderTable() {
        this.dispatchExternal("renderStarted");
        this.element.scrollTop = 0;
        this._clearTable();
        if (this.displayRowsCount) {
            this.renderer.renderRows();
            if (this.firstRender) {
                this.firstRender = false;
                if (!this.fixedHeight) this.adjustTableSize();
                this.layoutRefresh(true);
            }
        } else this.renderEmptyScroll();
        if (!this.fixedHeight) this.adjustTableSize();
        this.dispatch("table-layout");
        if (!this.displayRowsCount) this._showPlaceholder();
        this.scrollBarCheck();
        this.dispatchExternal("renderComplete");
    }
    //show scrollbars on empty table div
    renderEmptyScroll() {
        if (this.placeholder) this.tableElement.style.display = "none";
        else this.tableElement.style.minWidth = this.table.columnManager.getWidth() + "px";
    }
    _clearTable() {
        this._clearPlaceholder();
        this.scrollTop = 0;
        this.scrollLeft = 0;
        this.renderer.clearRows();
    }
    tableEmpty() {
        this.renderEmptyScroll();
        this._showPlaceholder();
    }
    checkPlaceholder() {
        if (this.displayRowsCount) this._clearPlaceholder();
        else this.tableEmpty();
    }
    _showPlaceholder() {
        if (this.placeholder) {
            if (this.placeholder && this.placeholder.parentNode) this.placeholder.parentNode.removeChild(this.placeholder);
            this.initializePlaceholder();
            this.placeholder.setAttribute("tabulator-render-mode", this.renderMode);
            this.getElement().appendChild(this.placeholder);
            this._positionPlaceholder();
            this.adjustTableSize();
        }
    }
    _clearPlaceholder() {
        if (this.placeholder && this.placeholder.parentNode) this.placeholder.parentNode.removeChild(this.placeholder);
        // clear empty table placeholder min
        this.tableElement.style.minWidth = "";
        this.tableElement.style.display = "";
    }
    _positionPlaceholder() {
        if (this.placeholder && this.placeholder.parentNode) {
            this.placeholder.style.width = this.table.columnManager.getWidth() + "px";
            this.placeholderContents.style.width = this.table.rowManager.element.clientWidth + "px";
            this.placeholderContents.style.marginLeft = this.scrollLeft + "px";
        }
    }
    styleRow(row, index) {
        var rowEl = row.getElement();
        if (index % 2) {
            rowEl.classList.add("tabulator-row-even");
            rowEl.classList.remove("tabulator-row-odd");
        } else {
            rowEl.classList.add("tabulator-row-odd");
            rowEl.classList.remove("tabulator-row-even");
        }
    }
    //normalize height of active rows
    normalizeHeight() {
        this.activeRows.forEach(function(row) {
            row.normalizeHeight();
        });
    }
    //adjust the height of the table holder to fit in the Tabulator element
    adjustTableSize() {
        let initialHeight = this.element.clientHeight, minHeight;
        let resized = false;
        if (this.renderer.verticalFillMode === "fill") {
            let otherHeight = Math.floor(this.table.columnManager.getElement().getBoundingClientRect().height + (this.table.footerManager && this.table.footerManager.active && !this.table.footerManager.external ? this.table.footerManager.getElement().getBoundingClientRect().height : 0));
            if (this.fixedHeight) {
                minHeight = isNaN(this.table.options.minHeight) ? this.table.options.minHeight : this.table.options.minHeight + "px";
                const height = "calc(100% - " + otherHeight + "px)";
                this.element.style.minHeight = minHeight || "calc(100% - " + otherHeight + "px)";
                this.element.style.height = height;
                this.element.style.maxHeight = height;
            } else {
                this.element.style.height = "";
                this.element.style.height = this.table.element.clientHeight - otherHeight + "px";
                this.element.scrollTop = this.scrollTop;
            }
            this.renderer.resize();
            //check if the table has changed size when dealing with variable height tables
            if (!this.fixedHeight && initialHeight != this.element.clientHeight) {
                resized = true;
                if (this.subscribed("table-resize")) this.dispatch("table-resize");
                else this.redraw();
            }
            this.scrollBarCheck();
        }
        this._positionPlaceholder();
        return resized;
    }
    //reinitialize all rows
    reinitialize() {
        this.rows.forEach(function(row) {
            row.reinitialize(true);
        });
    }
    //prevent table from being redrawn
    blockRedraw() {
        this.redrawBlock = true;
        this.redrawBlockRestoreConfig = false;
    }
    //restore table redrawing
    restoreRedraw() {
        this.redrawBlock = false;
        if (this.redrawBlockRestoreConfig) {
            this.refreshActiveData(this.redrawBlockRestoreConfig.handler, this.redrawBlockRestoreConfig.skipStage, this.redrawBlockRestoreConfig.renderInPosition);
            this.redrawBlockRestoreConfig = false;
        } else if (this.redrawBlockRenderInPosition) this.reRenderInPosition();
        this.redrawBlockRenderInPosition = false;
    }
    //redraw table
    redraw(force) {
        this.adjustTableSize();
        this.table.tableWidth = this.table.element.clientWidth;
        if (!force) {
            this.reRenderInPosition();
            this.scrollHorizontal(this.scrollLeft);
        } else this.renderTable();
    }
    resetScroll() {
        this.element.scrollLeft = 0;
        this.element.scrollTop = 0;
        if (this.table.browser === "ie") {
            var event = document.createEvent("Event");
            event.initEvent("scroll", false, true);
            this.element.dispatchEvent(event);
        } else this.element.dispatchEvent(new Event("scroll"));
    }
}
class $c2a9788f40f9c90a$var$FooterManager extends $c2a9788f40f9c90a$var$CoreFeature {
    constructor(table){
        super(table);
        this.active = false;
        this.element = this.createElement(); //containing element
        this.containerElement = this.createContainerElement(); //containing element
        this.external = false;
    }
    initialize() {
        this.initializeElement();
    }
    createElement() {
        var el = document.createElement("div");
        el.classList.add("tabulator-footer");
        return el;
    }
    createContainerElement() {
        var el = document.createElement("div");
        el.classList.add("tabulator-footer-contents");
        this.element.appendChild(el);
        return el;
    }
    initializeElement() {
        if (this.table.options.footerElement) switch(typeof this.table.options.footerElement){
            case "string":
                if (this.table.options.footerElement[0] === "<") this.containerElement.innerHTML = this.table.options.footerElement;
                else {
                    this.external = true;
                    this.containerElement = document.querySelector(this.table.options.footerElement);
                }
                break;
            default:
                this.element = this.table.options.footerElement;
                break;
        }
    }
    getElement() {
        return this.element;
    }
    append(element) {
        this.activate();
        this.containerElement.appendChild(element);
        this.table.rowManager.adjustTableSize();
    }
    prepend(element) {
        this.activate();
        this.element.insertBefore(element, this.element.firstChild);
        this.table.rowManager.adjustTableSize();
    }
    remove(element) {
        element.parentNode.removeChild(element);
        this.deactivate();
    }
    deactivate(force) {
        if (!this.element.firstChild || force) {
            if (!this.external) this.element.parentNode.removeChild(this.element);
            this.active = false;
        }
    }
    activate() {
        if (!this.active) {
            this.active = true;
            if (!this.external) {
                this.table.element.appendChild(this.getElement());
                this.table.element.style.display = "";
            }
        }
    }
    redraw() {
        this.dispatch("footer-redraw");
    }
}
class $c2a9788f40f9c90a$var$InteractionManager extends $c2a9788f40f9c90a$var$CoreFeature {
    constructor(table){
        super(table);
        this.el = null;
        this.abortClasses = [
            "tabulator-headers",
            "tabulator-table"
        ];
        this.previousTargets = {};
        this.listeners = [
            "click",
            "dblclick",
            "contextmenu",
            "mouseenter",
            "mouseleave",
            "mouseover",
            "mouseout",
            "mousemove",
            "mouseup",
            "mousedown",
            "touchstart",
            "touchend"
        ];
        this.componentMap = {
            "tabulator-cell": "cell",
            "tabulator-row": "row",
            "tabulator-group": "group",
            "tabulator-col": "column"
        };
        this.pseudoTrackers = {
            "row": {
                subscriber: null,
                target: null
            },
            "cell": {
                subscriber: null,
                target: null
            },
            "group": {
                subscriber: null,
                target: null
            },
            "column": {
                subscriber: null,
                target: null
            }
        };
        this.pseudoTracking = false;
    }
    initialize() {
        this.el = this.table.element;
        this.buildListenerMap();
        this.bindSubscriptionWatchers();
    }
    buildListenerMap() {
        var listenerMap = {};
        this.listeners.forEach((listener)=>{
            listenerMap[listener] = {
                handler: null,
                components: []
            };
        });
        this.listeners = listenerMap;
    }
    bindPseudoEvents() {
        Object.keys(this.pseudoTrackers).forEach((key)=>{
            this.pseudoTrackers[key].subscriber = this.pseudoMouseEnter.bind(this, key);
            this.subscribe(key + "-mouseover", this.pseudoTrackers[key].subscriber);
        });
        this.pseudoTracking = true;
    }
    pseudoMouseEnter(key, e, target) {
        if (this.pseudoTrackers[key].target !== target) {
            if (this.pseudoTrackers[key].target) this.dispatch(key + "-mouseleave", e, this.pseudoTrackers[key].target);
            this.pseudoMouseLeave(key, e);
            this.pseudoTrackers[key].target = target;
            this.dispatch(key + "-mouseenter", e, target);
        }
    }
    pseudoMouseLeave(key, e) {
        var leaveList = Object.keys(this.pseudoTrackers), linkedKeys = {
            "row": [
                "cell"
            ],
            "cell": [
                "row"
            ]
        };
        leaveList = leaveList.filter((item)=>{
            var links = linkedKeys[key];
            return item !== key && (!links || links && !links.includes(item));
        });
        leaveList.forEach((key)=>{
            var target = this.pseudoTrackers[key].target;
            if (this.pseudoTrackers[key].target) {
                this.dispatch(key + "-mouseleave", e, target);
                this.pseudoTrackers[key].target = null;
            }
        });
    }
    bindSubscriptionWatchers() {
        var listeners = Object.keys(this.listeners), components = Object.values(this.componentMap);
        for (let comp of components)for (let listener of listeners){
            let key = comp + "-" + listener;
            this.subscriptionChange(key, this.subscriptionChanged.bind(this, comp, listener));
        }
        this.subscribe("table-destroy", this.clearWatchers.bind(this));
    }
    subscriptionChanged(component, key, added) {
        var listener = this.listeners[key].components, index = listener.indexOf(component), changed = false;
        if (added) {
            if (index === -1) {
                listener.push(component);
                changed = true;
            }
        } else {
            if (!this.subscribed(component + "-" + key)) {
                if (index > -1) {
                    listener.splice(index, 1);
                    changed = true;
                }
            }
        }
        if ((key === "mouseenter" || key === "mouseleave") && !this.pseudoTracking) this.bindPseudoEvents();
        if (changed) this.updateEventListeners();
    }
    updateEventListeners() {
        for(let key in this.listeners){
            let listener = this.listeners[key];
            if (listener.components.length) {
                if (!listener.handler) {
                    listener.handler = this.track.bind(this, key);
                    this.el.addEventListener(key, listener.handler);
                // this.el.addEventListener(key, listener.handler, {passive: true})
                }
            } else if (listener.handler) {
                this.el.removeEventListener(key, listener.handler);
                listener.handler = null;
            }
        }
    }
    track(type, e) {
        var path = e.composedPath && e.composedPath() || e.path;
        var targets = this.findTargets(path);
        targets = this.bindComponents(type, targets);
        this.triggerEvents(type, e, targets);
        if (this.pseudoTracking && (type == "mouseover" || type == "mouseleave") && !Object.keys(targets).length) this.pseudoMouseLeave("none", e);
    }
    findTargets(path) {
        var targets = {};
        let componentMap = Object.keys(this.componentMap);
        for (let el of path){
            let classList = el.classList ? [
                ...el.classList
            ] : [];
            let abort = classList.filter((item)=>{
                return this.abortClasses.includes(item);
            });
            if (abort.length) break;
            let elTargets = classList.filter((item)=>{
                return componentMap.includes(item);
            });
            for (let target of elTargets)if (!targets[this.componentMap[target]]) targets[this.componentMap[target]] = el;
        }
        if (targets.group && targets.group === targets.row) delete targets.row;
        return targets;
    }
    bindComponents(type, targets) {
        //ensure row component is looked up before cell
        var keys = Object.keys(targets).reverse(), listener = this.listeners[type], matches = {}, targetMatches = {};
        for (let key of keys){
            let component, target = targets[key], previousTarget = this.previousTargets[key];
            if (previousTarget && previousTarget.target === target) component = previousTarget.component;
            else switch(key){
                case "row":
                case "group":
                    if (listener.components.includes("row") || listener.components.includes("cell") || listener.components.includes("group")) {
                        let rows = this.table.rowManager.getVisibleRows(true);
                        component = rows.find((row)=>{
                            return row.getElement() === target;
                        });
                        if (targets["row"] && targets["row"].parentNode && targets["row"].parentNode.closest(".tabulator-row")) targets[key] = false;
                    }
                    break;
                case "column":
                    if (listener.components.includes("column")) component = this.table.columnManager.findColumn(target);
                    break;
                case "cell":
                    if (listener.components.includes("cell")) {
                        if (matches["row"] instanceof $c2a9788f40f9c90a$var$Row) component = matches["row"].findCell(target);
                        else if (targets["row"]) console.warn("Event Target Lookup Error - The row this cell is attached to cannot be found, has the table been reinitialized without being destroyed first?");
                    }
                    break;
            }
            if (component) {
                matches[key] = component;
                targetMatches[key] = {
                    target: target,
                    component: component
                };
            }
        }
        this.previousTargets = targetMatches;
        return matches;
    }
    triggerEvents(type, e, targets) {
        var listener = this.listeners[type];
        for(let key in targets)if (targets[key] && listener.components.includes(key)) this.dispatch(key + "-" + type, e, targets[key]);
    }
    clearWatchers() {
        for(let key in this.listeners){
            let listener = this.listeners[key];
            if (listener.handler) {
                this.el.removeEventListener(key, listener.handler);
                listener.handler = null;
            }
        }
    }
}
class $c2a9788f40f9c90a$var$ComponentFunctionBinder {
    constructor(table){
        this.table = table;
        this.bindings = {};
    }
    bind(type, funcName, handler) {
        if (!this.bindings[type]) this.bindings[type] = {};
        if (this.bindings[type][funcName]) console.warn("Unable to bind component handler, a matching function name is already bound", type, funcName, handler);
        else this.bindings[type][funcName] = handler;
    }
    handle(type, component, name) {
        if (this.bindings[type] && this.bindings[type][name] && typeof this.bindings[type][name].bind === "function") return this.bindings[type][name].bind(null, component);
        else {
            if (name !== "then" && typeof name === "string" && !name.startsWith("_")) {
                if (this.table.options.debugInvalidComponentFuncs) console.error("The " + type + " component does not have a " + name + " function, have you checked that you have the correct Tabulator module installed?");
            }
        }
    }
}
class $c2a9788f40f9c90a$var$DataLoader extends $c2a9788f40f9c90a$var$CoreFeature {
    constructor(table){
        super(table);
        this.requestOrder = 0; //prevent requests coming out of sequence if overridden by another load request
        this.loading = false;
    }
    initialize() {}
    load(data, params, config, replace, silent, columnsChanged) {
        var requestNo = ++this.requestOrder;
        if (this.table.destroyed) return Promise.resolve();
        this.dispatchExternal("dataLoading", data);
        //parse json data to array
        if (data && (data.indexOf("{") == 0 || data.indexOf("[") == 0)) data = JSON.parse(data);
        if (this.confirm("data-loading", [
            data,
            params,
            config,
            silent
        ])) {
            this.loading = true;
            if (!silent) this.alertLoader();
            //get params for request
            params = this.chain("data-params", [
                data,
                config,
                silent
            ], params || {}, params || {});
            params = this.mapParams(params, this.table.options.dataSendParams);
            var result = this.chain("data-load", [
                data,
                params,
                config,
                silent
            ], false, Promise.resolve([]));
            return result.then((response)=>{
                if (!this.table.destroyed) {
                    if (!Array.isArray(response) && typeof response == "object") response = this.mapParams(response, this.objectInvert(this.table.options.dataReceiveParams));
                    var rowData = this.chain("data-loaded", [
                        response
                    ], null, response);
                    if (requestNo == this.requestOrder) {
                        this.clearAlert();
                        if (rowData !== false) {
                            this.dispatchExternal("dataLoaded", rowData);
                            this.table.rowManager.setData(rowData, replace, typeof columnsChanged === "undefined" ? !replace : columnsChanged);
                        }
                    } else console.warn("Data Load Response Blocked - An active data load request was blocked by an attempt to change table data while the request was being made");
                } else console.warn("Data Load Response Blocked - Table has been destroyed");
            }).catch((error)=>{
                console.error("Data Load Error: ", error);
                this.dispatchExternal("dataLoadError", error);
                if (!silent) this.alertError();
                setTimeout(()=>{
                    this.clearAlert();
                }, this.table.options.dataLoaderErrorTimeout);
            }).finally(()=>{
                this.loading = false;
            });
        } else {
            this.dispatchExternal("dataLoaded", data);
            if (!data) data = [];
            this.table.rowManager.setData(data, replace, typeof columnsChanged === "undefined" ? !replace : columnsChanged);
            return Promise.resolve();
        }
    }
    mapParams(params, map) {
        var output = {};
        for(let key in params)output[map.hasOwnProperty(key) ? map[key] : key] = params[key];
        return output;
    }
    objectInvert(obj) {
        var output = {};
        for(let key in obj)output[obj[key]] = key;
        return output;
    }
    blockActiveLoad() {
        this.requestOrder++;
    }
    alertLoader() {
        var shouldLoad = typeof this.table.options.dataLoader === "function" ? this.table.options.dataLoader() : this.table.options.dataLoader;
        if (shouldLoad) this.table.alertManager.alert(this.table.options.dataLoaderLoading || this.langText("data|loading"));
    }
    alertError() {
        this.table.alertManager.alert(this.table.options.dataLoaderError || this.langText("data|error"), "error");
    }
    clearAlert() {
        this.table.alertManager.clear();
    }
}
class $c2a9788f40f9c90a$var$ExternalEventBus {
    constructor(table, optionsList, debug){
        this.table = table;
        this.events = {};
        this.optionsList = optionsList || {};
        this.subscriptionNotifiers = {};
        this.dispatch = debug ? this._debugDispatch.bind(this) : this._dispatch.bind(this);
        this.debug = debug;
    }
    subscriptionChange(key, callback) {
        if (!this.subscriptionNotifiers[key]) this.subscriptionNotifiers[key] = [];
        this.subscriptionNotifiers[key].push(callback);
        if (this.subscribed(key)) this._notifySubscriptionChange(key, true);
    }
    subscribe(key, callback) {
        if (!this.events[key]) this.events[key] = [];
        this.events[key].push(callback);
        this._notifySubscriptionChange(key, true);
    }
    unsubscribe(key, callback) {
        var index;
        if (this.events[key]) {
            if (callback) {
                index = this.events[key].findIndex((item)=>{
                    return item === callback;
                });
                if (index > -1) this.events[key].splice(index, 1);
                else {
                    console.warn("Cannot remove event, no matching event found:", key, callback);
                    return;
                }
            } else delete this.events[key];
        } else {
            console.warn("Cannot remove event, no events set on:", key);
            return;
        }
        this._notifySubscriptionChange(key, false);
    }
    subscribed(key) {
        return this.events[key] && this.events[key].length;
    }
    _notifySubscriptionChange(key, subscribed) {
        var notifiers = this.subscriptionNotifiers[key];
        if (notifiers) notifiers.forEach((callback)=>{
            callback(subscribed);
        });
    }
    _dispatch() {
        var args = Array.from(arguments), key = args.shift(), result;
        if (this.events[key]) this.events[key].forEach((callback, i)=>{
            let callResult = callback.apply(this.table, args);
            if (!i) result = callResult;
        });
        return result;
    }
    _debugDispatch() {
        var args = Array.from(arguments), key = args[0];
        args[0] = "ExternalEvent:" + args[0];
        if (this.debug === true || this.debug.includes(key)) console.log(...args);
        return this._dispatch(...arguments);
    }
}
class $c2a9788f40f9c90a$var$InternalEventBus {
    constructor(debug){
        this.events = {};
        this.subscriptionNotifiers = {};
        this.dispatch = debug ? this._debugDispatch.bind(this) : this._dispatch.bind(this);
        this.chain = debug ? this._debugChain.bind(this) : this._chain.bind(this);
        this.confirm = debug ? this._debugConfirm.bind(this) : this._confirm.bind(this);
        this.debug = debug;
    }
    subscriptionChange(key, callback) {
        if (!this.subscriptionNotifiers[key]) this.subscriptionNotifiers[key] = [];
        this.subscriptionNotifiers[key].push(callback);
        if (this.subscribed(key)) this._notifySubscriptionChange(key, true);
    }
    subscribe(key, callback, priority = 10000) {
        if (!this.events[key]) this.events[key] = [];
        this.events[key].push({
            callback: callback,
            priority: priority
        });
        this.events[key].sort((a, b)=>{
            return a.priority - b.priority;
        });
        this._notifySubscriptionChange(key, true);
    }
    unsubscribe(key, callback) {
        var index;
        if (this.events[key]) {
            if (callback) {
                index = this.events[key].findIndex((item)=>{
                    return item.callback === callback;
                });
                if (index > -1) this.events[key].splice(index, 1);
                else {
                    console.warn("Cannot remove event, no matching event found:", key, callback);
                    return;
                }
            }
        } else {
            console.warn("Cannot remove event, no events set on:", key);
            return;
        }
        this._notifySubscriptionChange(key, false);
    }
    subscribed(key) {
        return this.events[key] && this.events[key].length;
    }
    _chain(key, args, initialValue, fallback) {
        var value = initialValue;
        if (!Array.isArray(args)) args = [
            args
        ];
        if (this.subscribed(key)) {
            this.events[key].forEach((subscriber, i)=>{
                value = subscriber.callback.apply(this, args.concat([
                    value
                ]));
            });
            return value;
        } else return typeof fallback === "function" ? fallback() : fallback;
    }
    _confirm(key, args) {
        var confirmed = false;
        if (!Array.isArray(args)) args = [
            args
        ];
        if (this.subscribed(key)) this.events[key].forEach((subscriber, i)=>{
            if (subscriber.callback.apply(this, args)) confirmed = true;
        });
        return confirmed;
    }
    _notifySubscriptionChange(key, subscribed) {
        var notifiers = this.subscriptionNotifiers[key];
        if (notifiers) notifiers.forEach((callback)=>{
            callback(subscribed);
        });
    }
    _dispatch() {
        var args = Array.from(arguments), key = args.shift();
        if (this.events[key]) this.events[key].forEach((subscriber)=>{
            subscriber.callback.apply(this, args);
        });
    }
    _debugDispatch() {
        var args = Array.from(arguments), key = args[0];
        args[0] = "InternalEvent:" + key;
        if (this.debug === true || this.debug.includes(key)) console.log(...args);
        return this._dispatch(...arguments);
    }
    _debugChain() {
        var args = Array.from(arguments), key = args[0];
        args[0] = "InternalEvent:" + key;
        if (this.debug === true || this.debug.includes(key)) console.log(...args);
        return this._chain(...arguments);
    }
    _debugConfirm() {
        var args = Array.from(arguments), key = args[0];
        args[0] = "InternalEvent:" + key;
        if (this.debug === true || this.debug.includes(key)) console.log(...args);
        return this._confirm(...arguments);
    }
}
class $c2a9788f40f9c90a$var$DeprecationAdvisor extends $c2a9788f40f9c90a$var$CoreFeature {
    constructor(table){
        super(table);
    }
    _warnUser() {
        if (this.options("debugDeprecation")) console.warn(...arguments);
    }
    check(oldOption, newOption, convert) {
        var msg = "";
        if (typeof this.options(oldOption) !== "undefined") {
            msg = "Deprecated Setup Option - Use of the %c" + oldOption + "%c option is now deprecated";
            if (newOption) {
                msg = msg + ", Please use the %c" + newOption + "%c option instead";
                this._warnUser(msg, "font-weight: bold;", "font-weight: normal;", "font-weight: bold;", "font-weight: normal;");
                if (convert) this.table.options[newOption] = this.table.options[oldOption];
            } else this._warnUser(msg, "font-weight: bold;", "font-weight: normal;");
            return false;
        } else return true;
    }
    checkMsg(oldOption, msg) {
        if (typeof this.options(oldOption) !== "undefined") {
            this._warnUser("%cDeprecated Setup Option - Use of the %c" + oldOption + " %c option is now deprecated, " + msg, "font-weight: normal;", "font-weight: bold;", "font-weight: normal;");
            return false;
        } else return true;
    }
    msg(msg) {
        this._warnUser(msg);
    }
}
//resize columns to fit data they contain
function $c2a9788f40f9c90a$var$fitData(columns, forced) {
    if (forced) this.table.columnManager.renderer.reinitializeColumnWidths(columns);
    if (this.table.options.responsiveLayout && this.table.modExists("responsiveLayout", true)) this.table.modules.responsiveLayout.update();
}
//resize columns to fit data they contain and stretch row to fill table, also used for fitDataTable
function $c2a9788f40f9c90a$var$fitDataGeneral(columns, forced) {
    columns.forEach(function(column) {
        column.reinitializeWidth();
    });
    if (this.table.options.responsiveLayout && this.table.modExists("responsiveLayout", true)) this.table.modules.responsiveLayout.update();
}
//resize columns to fit data the contain and stretch last column to fill table
function $c2a9788f40f9c90a$var$fitDataStretch(columns, forced) {
    var colsWidth = 0, tableWidth = this.table.rowManager.element.clientWidth, gap = 0, lastCol = false;
    columns.forEach((column, i)=>{
        if (!column.widthFixed) column.reinitializeWidth();
        if (this.table.options.responsiveLayout ? column.modules.responsive.visible : column.visible) lastCol = column;
        if (column.visible) colsWidth += column.getWidth();
    });
    if (lastCol) {
        gap = tableWidth - colsWidth + lastCol.getWidth();
        if (this.table.options.responsiveLayout && this.table.modExists("responsiveLayout", true)) {
            lastCol.setWidth(0);
            this.table.modules.responsiveLayout.update();
        }
        if (gap > 0) lastCol.setWidth(gap);
        else lastCol.reinitializeWidth();
    } else if (this.table.options.responsiveLayout && this.table.modExists("responsiveLayout", true)) this.table.modules.responsiveLayout.update();
}
//resize columns to fit
function $c2a9788f40f9c90a$var$fitColumns(columns, forced) {
    var totalWidth = this.table.rowManager.element.getBoundingClientRect().width; //table element width
    var fixedWidth = 0; //total width of columns with a defined width
    var flexWidth = 0; //total width available to flexible columns
    var flexGrowUnits = 0; //total number of widthGrow blocks across all columns
    var flexColWidth = 0; //desired width of flexible columns
    var flexColumns = []; //array of flexible width columns
    var fixedShrinkColumns = []; //array of fixed width columns that can shrink
    var flexShrinkUnits = 0; //total number of widthShrink blocks across all columns
    var overflowWidth = 0; //horizontal overflow width
    var gapFill = 0; //number of pixels to be added to final column to close and half pixel gaps
    function calcWidth(width) {
        var colWidth;
        if (typeof width == "string") {
            if (width.indexOf("%") > -1) colWidth = totalWidth / 100 * parseInt(width);
            else colWidth = parseInt(width);
        } else colWidth = width;
        return colWidth;
    }
    //ensure columns resize to take up the correct amount of space
    function scaleColumns(columns, freeSpace, colWidth, shrinkCols) {
        var oversizeCols = [], oversizeSpace = 0, remainingSpace = 0, nextColWidth = 0, remainingFlexGrowUnits = flexGrowUnits, gap = 0, changeUnits = 0, undersizeCols = [];
        function calcGrow(col) {
            return colWidth * (col.column.definition.widthGrow || 1);
        }
        function calcShrink(col) {
            return calcWidth(col.width) - colWidth * (col.column.definition.widthShrink || 0);
        }
        columns.forEach(function(col, i) {
            var width = shrinkCols ? calcShrink(col) : calcGrow(col);
            if (col.column.minWidth >= width) oversizeCols.push(col);
            else if (col.column.maxWidth && col.column.maxWidth < width) {
                col.width = col.column.maxWidth;
                freeSpace -= col.column.maxWidth;
                remainingFlexGrowUnits -= shrinkCols ? col.column.definition.widthShrink || 1 : col.column.definition.widthGrow || 1;
                if (remainingFlexGrowUnits) colWidth = Math.floor(freeSpace / remainingFlexGrowUnits);
            } else {
                undersizeCols.push(col);
                changeUnits += shrinkCols ? col.column.definition.widthShrink || 1 : col.column.definition.widthGrow || 1;
            }
        });
        if (oversizeCols.length) {
            oversizeCols.forEach(function(col) {
                oversizeSpace += shrinkCols ? col.width - col.column.minWidth : col.column.minWidth;
                col.width = col.column.minWidth;
            });
            remainingSpace = freeSpace - oversizeSpace;
            nextColWidth = changeUnits ? Math.floor(remainingSpace / changeUnits) : remainingSpace;
            gap = scaleColumns(undersizeCols, remainingSpace, nextColWidth, shrinkCols);
        } else {
            gap = changeUnits ? freeSpace - Math.floor(freeSpace / changeUnits) * changeUnits : freeSpace;
            undersizeCols.forEach(function(column) {
                column.width = shrinkCols ? calcShrink(column) : calcGrow(column);
            });
        }
        return gap;
    }
    if (this.table.options.responsiveLayout && this.table.modExists("responsiveLayout", true)) this.table.modules.responsiveLayout.update();
    //adjust for vertical scrollbar if present
    if (this.table.rowManager.element.scrollHeight > this.table.rowManager.element.clientHeight) totalWidth -= this.table.rowManager.element.offsetWidth - this.table.rowManager.element.clientWidth;
    columns.forEach(function(column) {
        var width, minWidth, colWidth;
        if (column.visible) {
            width = column.definition.width;
            minWidth = parseInt(column.minWidth);
            if (width) {
                colWidth = calcWidth(width);
                fixedWidth += colWidth > minWidth ? colWidth : minWidth;
                if (column.definition.widthShrink) {
                    fixedShrinkColumns.push({
                        column: column,
                        width: colWidth > minWidth ? colWidth : minWidth
                    });
                    flexShrinkUnits += column.definition.widthShrink;
                }
            } else {
                flexColumns.push({
                    column: column,
                    width: 0
                });
                flexGrowUnits += column.definition.widthGrow || 1;
            }
        }
    });
    //calculate available space
    flexWidth = totalWidth - fixedWidth;
    //calculate correct column size
    flexColWidth = Math.floor(flexWidth / flexGrowUnits);
    //generate column widths
    gapFill = scaleColumns(flexColumns, flexWidth, flexColWidth, false);
    //increase width of last column to account for rounding errors
    if (flexColumns.length && gapFill > 0) flexColumns[flexColumns.length - 1].width += gapFill;
    //calculate space for columns to be shrunk into
    flexColumns.forEach(function(col) {
        flexWidth -= col.width;
    });
    overflowWidth = Math.abs(gapFill) + flexWidth;
    //shrink oversize columns if there is no available space
    if (overflowWidth > 0 && flexShrinkUnits) gapFill = scaleColumns(fixedShrinkColumns, overflowWidth, Math.floor(overflowWidth / flexShrinkUnits), true);
    //decrease width of last column to account for rounding errors
    if (gapFill && fixedShrinkColumns.length) fixedShrinkColumns[fixedShrinkColumns.length - 1].width -= gapFill;
    flexColumns.forEach(function(col) {
        col.column.setWidth(col.width);
    });
    fixedShrinkColumns.forEach(function(col) {
        col.column.setWidth(col.width);
    });
}
var $c2a9788f40f9c90a$var$defaultModes = {
    fitData: $c2a9788f40f9c90a$var$fitData,
    fitDataFill: $c2a9788f40f9c90a$var$fitDataGeneral,
    fitDataTable: $c2a9788f40f9c90a$var$fitDataGeneral,
    fitDataStretch: $c2a9788f40f9c90a$var$fitDataStretch,
    fitColumns: $c2a9788f40f9c90a$var$fitColumns
};
class $c2a9788f40f9c90a$var$Layout extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "layout";
    //load defaults
    static modes = $c2a9788f40f9c90a$var$defaultModes;
    constructor(table){
        super(table, "layout");
        this.mode = null;
        this.registerTableOption("layout", "fitData"); //layout type
        this.registerTableOption("layoutColumnsOnNewData", false); //update column widths on setData
        this.registerColumnOption("widthGrow");
        this.registerColumnOption("widthShrink");
    }
    //initialize layout system
    initialize() {
        var layout = this.table.options.layout;
        if ($c2a9788f40f9c90a$var$Layout.modes[layout]) this.mode = layout;
        else {
            console.warn("Layout Error - invalid mode set, defaulting to 'fitData' : " + layout);
            this.mode = "fitData";
        }
        this.table.element.setAttribute("tabulator-layout", this.mode);
        this.subscribe("column-init", this.initializeColumn.bind(this));
    }
    initializeColumn(column) {
        if (column.definition.widthGrow) column.definition.widthGrow = Number(column.definition.widthGrow);
        if (column.definition.widthShrink) column.definition.widthShrink = Number(column.definition.widthShrink);
    }
    getMode() {
        return this.mode;
    }
    //trigger table layout
    layout(dataChanged) {
        this.dispatch("layout-refreshing");
        $c2a9788f40f9c90a$var$Layout.modes[this.mode].call(this, this.table.columnManager.columnsByIndex, dataChanged);
        this.dispatch("layout-refreshed");
    }
}
var $c2a9788f40f9c90a$var$defaultLangs = {
    "default": {
        "groups": {
            "item": "item",
            "items": "items"
        },
        "columns": {},
        "data": {
            "loading": "Loading",
            "error": "Error"
        },
        "pagination": {
            "page_size": "Page Size",
            "page_title": "Show Page",
            "first": "First",
            "first_title": "First Page",
            "last": "Last",
            "last_title": "Last Page",
            "prev": "Prev",
            "prev_title": "Prev Page",
            "next": "Next",
            "next_title": "Next Page",
            "all": "All",
            "counter": {
                "showing": "Showing",
                "of": "of",
                "rows": "rows",
                "pages": "pages"
            }
        },
        "headerFilters": {
            "default": "filter column...",
            "columns": {}
        }
    }
};
class $c2a9788f40f9c90a$var$Localize extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "localize";
    //load defaults
    static langs = $c2a9788f40f9c90a$var$defaultLangs;
    constructor(table){
        super(table);
        this.locale = "default"; //current locale
        this.lang = false; //current language
        this.bindings = {}; //update events to call when locale is changed
        this.langList = {};
        this.registerTableOption("locale", false); //current system language
        this.registerTableOption("langs", {});
    }
    initialize() {
        this.langList = $c2a9788f40f9c90a$var$Helpers.deepClone($c2a9788f40f9c90a$var$Localize.langs);
        if (this.table.options.columnDefaults.headerFilterPlaceholder !== false) this.setHeaderFilterPlaceholder(this.table.options.columnDefaults.headerFilterPlaceholder);
        for(let locale in this.table.options.langs)this.installLang(locale, this.table.options.langs[locale]);
        this.setLocale(this.table.options.locale);
        this.registerTableFunction("setLocale", this.setLocale.bind(this));
        this.registerTableFunction("getLocale", this.getLocale.bind(this));
        this.registerTableFunction("getLang", this.getLang.bind(this));
    }
    //set header placeholder
    setHeaderFilterPlaceholder(placeholder) {
        this.langList.default.headerFilters.default = placeholder;
    }
    //setup a lang description object
    installLang(locale, lang) {
        if (this.langList[locale]) this._setLangProp(this.langList[locale], lang);
        else this.langList[locale] = lang;
    }
    _setLangProp(lang, values) {
        for(let key in values)if (lang[key] && typeof lang[key] == "object") this._setLangProp(lang[key], values[key]);
        else lang[key] = values[key];
    }
    //set current locale
    setLocale(desiredLocale) {
        desiredLocale = desiredLocale || "default";
        //fill in any matching language values
        function traverseLang(trans, path) {
            for(var prop in trans)if (typeof trans[prop] == "object") {
                if (!path[prop]) path[prop] = {};
                traverseLang(trans[prop], path[prop]);
            } else path[prop] = trans[prop];
        }
        //determining correct locale to load
        if (desiredLocale === true && navigator.language) //get local from system
        desiredLocale = navigator.language.toLowerCase();
        if (desiredLocale) //if locale is not set, check for matching top level locale else use default
        {
            if (!this.langList[desiredLocale]) {
                let prefix = desiredLocale.split("-")[0];
                if (this.langList[prefix]) {
                    console.warn("Localization Error - Exact matching locale not found, using closest match: ", desiredLocale, prefix);
                    desiredLocale = prefix;
                } else {
                    console.warn("Localization Error - Matching locale not found, using default: ", desiredLocale);
                    desiredLocale = "default";
                }
            }
        }
        this.locale = desiredLocale;
        //load default lang template
        this.lang = $c2a9788f40f9c90a$var$Helpers.deepClone(this.langList.default || {});
        if (desiredLocale != "default") traverseLang(this.langList[desiredLocale], this.lang);
        this.dispatchExternal("localized", this.locale, this.lang);
        this._executeBindings();
    }
    //get current locale
    getLocale(locale) {
        return this.locale;
    }
    //get lang object for given local or current if none provided
    getLang(locale) {
        return locale ? this.langList[locale] : this.lang;
    }
    //get text for current locale
    getText(path, value) {
        var fillPath = value ? path + "|" + value : path, pathArray = fillPath.split("|"), text = this._getLangElement(pathArray, this.locale);
        // if(text === false){
        // 	console.warn("Localization Error - Matching localized text not found for given path: ", path);
        // }
        return text || "";
    }
    //traverse langs object and find localized copy
    _getLangElement(path, locale) {
        var root = this.lang;
        path.forEach(function(level) {
            var rootPath;
            if (root) {
                rootPath = root[level];
                if (typeof rootPath != "undefined") root = rootPath;
                else root = false;
            }
        });
        return root;
    }
    //set update binding
    bind(path, callback) {
        if (!this.bindings[path]) this.bindings[path] = [];
        this.bindings[path].push(callback);
        callback(this.getText(path), this.lang);
    }
    //iterate through bindings and trigger updates
    _executeBindings() {
        for(let path in this.bindings)this.bindings[path].forEach((binding)=>{
            binding(this.getText(path), this.lang);
        });
    }
}
class $c2a9788f40f9c90a$var$Comms extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "comms";
    constructor(table){
        super(table);
    }
    initialize() {
        this.registerTableFunction("tableComms", this.receive.bind(this));
    }
    getConnections(selectors) {
        var connections = [], connection;
        connection = this.table.constructor.registry.lookupTable(selectors);
        connection.forEach((con)=>{
            if (this.table !== con) connections.push(con);
        });
        return connections;
    }
    send(selectors, module, action, data) {
        var connections = this.getConnections(selectors);
        connections.forEach((connection)=>{
            connection.tableComms(this.table.element, module, action, data);
        });
        if (!connections.length && selectors) console.warn("Table Connection Error - No tables matching selector found", selectors);
    }
    receive(table, module, action, data) {
        if (this.table.modExists(module)) return this.table.modules[module].commsReceived(table, action, data);
        else console.warn("Inter-table Comms Error - no such module:", module);
    }
}
var $c2a9788f40f9c90a$var$coreModules = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    CommsModule: $c2a9788f40f9c90a$var$Comms,
    LayoutModule: $c2a9788f40f9c90a$var$Layout,
    LocalizeModule: $c2a9788f40f9c90a$var$Localize
});
class $c2a9788f40f9c90a$var$TableRegistry {
    static registry = {
        tables: [],
        register (table) {
            $c2a9788f40f9c90a$var$TableRegistry.registry.tables.push(table);
        },
        deregister (table) {
            var index = $c2a9788f40f9c90a$var$TableRegistry.registry.tables.indexOf(table);
            if (index > -1) $c2a9788f40f9c90a$var$TableRegistry.registry.tables.splice(index, 1);
        },
        lookupTable (query, silent) {
            var results = [], matches, match;
            if (typeof query === "string") {
                matches = document.querySelectorAll(query);
                if (matches.length) for(var i = 0; i < matches.length; i++){
                    match = $c2a9788f40f9c90a$var$TableRegistry.registry.matchElement(matches[i]);
                    if (match) results.push(match);
                }
            } else if (typeof HTMLElement !== "undefined" && query instanceof HTMLElement || query instanceof $c2a9788f40f9c90a$var$TableRegistry) {
                match = $c2a9788f40f9c90a$var$TableRegistry.registry.matchElement(query);
                if (match) results.push(match);
            } else if (Array.isArray(query)) query.forEach(function(item) {
                results = results.concat($c2a9788f40f9c90a$var$TableRegistry.registry.lookupTable(item));
            });
            else if (!silent) console.warn("Table Connection Error - Invalid Selector", query);
            return results;
        },
        matchElement (element) {
            return $c2a9788f40f9c90a$var$TableRegistry.registry.tables.find(function(table) {
                return element instanceof $c2a9788f40f9c90a$var$TableRegistry ? table === element : table.element === element;
            });
        }
    };
    static findTable(query) {
        var results = $c2a9788f40f9c90a$var$TableRegistry.registry.lookupTable(query, true);
        return Array.isArray(results) && !results.length ? false : results;
    }
}
class $c2a9788f40f9c90a$var$ModuleBinder extends $c2a9788f40f9c90a$var$TableRegistry {
    static moduleBindings = {};
    static moduleExtensions = {};
    static modulesRegistered = false;
    static defaultModules = false;
    constructor(){
        super();
    }
    static initializeModuleBinder(defaultModules) {
        if (!$c2a9788f40f9c90a$var$ModuleBinder.modulesRegistered) {
            $c2a9788f40f9c90a$var$ModuleBinder.modulesRegistered = true;
            $c2a9788f40f9c90a$var$ModuleBinder._registerModules($c2a9788f40f9c90a$var$coreModules, true);
            if (defaultModules) $c2a9788f40f9c90a$var$ModuleBinder._registerModules(defaultModules);
        }
    }
    static _extendModule(name, property, values) {
        if ($c2a9788f40f9c90a$var$ModuleBinder.moduleBindings[name]) {
            var source = $c2a9788f40f9c90a$var$ModuleBinder.moduleBindings[name][property];
            if (source) {
                if (typeof values == "object") for(let key in values)source[key] = values[key];
                else console.warn("Module Error - Invalid value type, it must be an object");
            } else console.warn("Module Error - property does not exist:", property);
        } else console.warn("Module Error - module does not exist:", name);
    }
    static _registerModules(modules, core) {
        var mods = Object.values(modules);
        if (core) mods.forEach((mod)=>{
            mod.prototype.moduleCore = true;
        });
        $c2a9788f40f9c90a$var$ModuleBinder._registerModule(mods);
    }
    static _registerModule(modules) {
        if (!Array.isArray(modules)) modules = [
            modules
        ];
        modules.forEach((mod)=>{
            $c2a9788f40f9c90a$var$ModuleBinder._registerModuleBinding(mod);
            $c2a9788f40f9c90a$var$ModuleBinder._registerModuleExtensions(mod);
        });
    }
    static _registerModuleBinding(mod) {
        if (mod.moduleName) $c2a9788f40f9c90a$var$ModuleBinder.moduleBindings[mod.moduleName] = mod;
        else console.error("Unable to bind module, no moduleName defined", mod.moduleName);
    }
    static _registerModuleExtensions(mod) {
        var extensions = mod.moduleExtensions;
        if (mod.moduleExtensions) for(let modKey in extensions){
            let ext = extensions[modKey];
            if ($c2a9788f40f9c90a$var$ModuleBinder.moduleBindings[modKey]) for(let propKey in ext)$c2a9788f40f9c90a$var$ModuleBinder._extendModule(modKey, propKey, ext[propKey]);
            else {
                if (!$c2a9788f40f9c90a$var$ModuleBinder.moduleExtensions[modKey]) $c2a9788f40f9c90a$var$ModuleBinder.moduleExtensions[modKey] = {};
                for(let propKey in ext){
                    if (!$c2a9788f40f9c90a$var$ModuleBinder.moduleExtensions[modKey][propKey]) $c2a9788f40f9c90a$var$ModuleBinder.moduleExtensions[modKey][propKey] = {};
                    Object.assign($c2a9788f40f9c90a$var$ModuleBinder.moduleExtensions[modKey][propKey], ext[propKey]);
                }
            }
        }
        $c2a9788f40f9c90a$var$ModuleBinder._extendModuleFromQueue(mod);
    }
    static _extendModuleFromQueue(mod) {
        var extensions = $c2a9788f40f9c90a$var$ModuleBinder.moduleExtensions[mod.moduleName];
        if (extensions) for(let propKey in extensions)$c2a9788f40f9c90a$var$ModuleBinder._extendModule(mod.moduleName, propKey, extensions[propKey]);
    }
    //ensure that module are bound to instantiated function
    _bindModules() {
        var orderedStartMods = [], orderedEndMods = [], unOrderedMods = [];
        this.modules = {};
        for(var name in $c2a9788f40f9c90a$var$ModuleBinder.moduleBindings){
            let mod = $c2a9788f40f9c90a$var$ModuleBinder.moduleBindings[name];
            let module = new mod(this);
            this.modules[name] = module;
            if (mod.prototype.moduleCore) this.modulesCore.push(module);
            else if (mod.moduleInitOrder) {
                if (mod.moduleInitOrder < 0) orderedStartMods.push(module);
                else orderedEndMods.push(module);
            } else unOrderedMods.push(module);
        }
        orderedStartMods.sort((a, b)=>a.moduleInitOrder > b.moduleInitOrder ? 1 : -1);
        orderedEndMods.sort((a, b)=>a.moduleInitOrder > b.moduleInitOrder ? 1 : -1);
        this.modulesRegular = orderedStartMods.concat(unOrderedMods.concat(orderedEndMods));
    }
}
class $c2a9788f40f9c90a$var$Alert extends $c2a9788f40f9c90a$var$CoreFeature {
    constructor(table){
        super(table);
        this.element = this._createAlertElement();
        this.msgElement = this._createMsgElement();
        this.type = null;
        this.element.appendChild(this.msgElement);
    }
    _createAlertElement() {
        var el = document.createElement("div");
        el.classList.add("tabulator-alert");
        return el;
    }
    _createMsgElement() {
        var el = document.createElement("div");
        el.classList.add("tabulator-alert-msg");
        el.setAttribute("role", "alert");
        return el;
    }
    _typeClass() {
        return "tabulator-alert-state-" + this.type;
    }
    alert(content, type = "msg") {
        if (content) {
            this.clear();
            this.dispatch("alert-show", type);
            this.type = type;
            while(this.msgElement.firstChild)this.msgElement.removeChild(this.msgElement.firstChild);
            this.msgElement.classList.add(this._typeClass());
            if (typeof content === "function") content = content();
            if (content instanceof HTMLElement) this.msgElement.appendChild(content);
            else this.msgElement.innerHTML = content;
            this.table.element.appendChild(this.element);
        }
    }
    clear() {
        this.dispatch("alert-hide", this.type);
        if (this.element.parentNode) this.element.parentNode.removeChild(this.element);
        this.msgElement.classList.remove(this._typeClass());
    }
}
class $c2a9788f40f9c90a$var$Tabulator extends $c2a9788f40f9c90a$var$ModuleBinder {
    //default setup options
    static defaultOptions = $c2a9788f40f9c90a$var$defaultOptions;
    static extendModule() {
        $c2a9788f40f9c90a$var$Tabulator.initializeModuleBinder();
        $c2a9788f40f9c90a$var$Tabulator._extendModule(...arguments);
    }
    static registerModule() {
        $c2a9788f40f9c90a$var$Tabulator.initializeModuleBinder();
        $c2a9788f40f9c90a$var$Tabulator._registerModule(...arguments);
    }
    constructor(element, options, modules){
        super();
        $c2a9788f40f9c90a$var$Tabulator.initializeModuleBinder(modules);
        this.options = {};
        this.columnManager = null; // hold Column Manager
        this.rowManager = null; //hold Row Manager
        this.footerManager = null; //holder Footer Manager
        this.alertManager = null; //hold Alert Manager
        this.vdomHoz = null; //holder horizontal virtual dom
        this.externalEvents = null; //handle external event messaging
        this.eventBus = null; //handle internal event messaging
        this.interactionMonitor = false; //track user interaction
        this.browser = ""; //hold current browser type
        this.browserSlow = false; //handle reduced functionality for slower browsers
        this.browserMobile = false; //check if running on mobile, prevent resize cancelling edit on keyboard appearance
        this.rtl = false; //check if the table is in RTL mode
        this.originalElement = null; //hold original table element if it has been replaced
        this.componentFunctionBinder = new $c2a9788f40f9c90a$var$ComponentFunctionBinder(this); //bind component functions
        this.dataLoader = false; //bind component functions
        this.modules = {}; //hold all modules bound to this table
        this.modulesCore = []; //hold core modules bound to this table (for initialization purposes)
        this.modulesRegular = []; //hold regular modules bound to this table (for initialization purposes)
        this.deprecationAdvisor = new $c2a9788f40f9c90a$var$DeprecationAdvisor(this);
        this.optionsList = new $c2a9788f40f9c90a$var$OptionsList(this, "table constructor");
        this.initialized = false;
        this.destroyed = false;
        if (this.initializeElement(element)) {
            this.initializeCoreSystems(options);
            //delay table creation to allow event bindings immediately after the constructor
            setTimeout(()=>{
                this._create();
            });
        }
        this.constructor.registry.register(this); //register table for inter-device communication
    }
    initializeElement(element) {
        if (typeof HTMLElement !== "undefined" && element instanceof HTMLElement) {
            this.element = element;
            return true;
        } else if (typeof element === "string") {
            this.element = document.querySelector(element);
            if (this.element) return true;
            else {
                console.error("Tabulator Creation Error - no element found matching selector: ", element);
                return false;
            }
        } else {
            console.error("Tabulator Creation Error - Invalid element provided:", element);
            return false;
        }
    }
    initializeCoreSystems(options) {
        this.columnManager = new $c2a9788f40f9c90a$var$ColumnManager(this);
        this.rowManager = new $c2a9788f40f9c90a$var$RowManager(this);
        this.footerManager = new $c2a9788f40f9c90a$var$FooterManager(this);
        this.dataLoader = new $c2a9788f40f9c90a$var$DataLoader(this);
        this.alertManager = new $c2a9788f40f9c90a$var$Alert(this);
        this._bindModules();
        this.options = this.optionsList.generate($c2a9788f40f9c90a$var$Tabulator.defaultOptions, options);
        this._clearObjectPointers();
        this._mapDeprecatedFunctionality();
        this.externalEvents = new $c2a9788f40f9c90a$var$ExternalEventBus(this, this.options, this.options.debugEventsExternal);
        this.eventBus = new $c2a9788f40f9c90a$var$InternalEventBus(this.options.debugEventsInternal);
        this.interactionMonitor = new $c2a9788f40f9c90a$var$InteractionManager(this);
        this.dataLoader.initialize();
        // this.columnManager.initialize();
        // this.rowManager.initialize();
        this.footerManager.initialize();
    }
    //convert deprecated functionality to new functions
    _mapDeprecatedFunctionality() {
    //all previously deprecated functionality removed in the 6.0 release
    }
    _clearSelection() {
        this.element.classList.add("tabulator-block-select");
        if (window.getSelection) {
            if (window.getSelection().empty) window.getSelection().empty();
            else if (window.getSelection().removeAllRanges) window.getSelection().removeAllRanges();
        } else if (document.selection) document.selection.empty();
        this.element.classList.remove("tabulator-block-select");
    }
    //create table
    _create() {
        this.externalEvents.dispatch("tableBuilding");
        this.eventBus.dispatch("table-building");
        this._rtlCheck();
        this._buildElement();
        this._initializeTable();
        this.initialized = true;
        this._loadInitialData().finally(()=>{
            this.eventBus.dispatch("table-initialized");
            this.externalEvents.dispatch("tableBuilt");
        });
    }
    _rtlCheck() {
        var style = window.getComputedStyle(this.element);
        switch(this.options.textDirection){
            case "auto":
                if (style.direction !== "rtl") break;
            case "rtl":
                this.element.classList.add("tabulator-rtl");
                this.rtl = true;
                break;
            case "ltr":
                this.element.classList.add("tabulator-ltr");
            default:
                this.rtl = false;
        }
    }
    //clear pointers to objects in default config object
    _clearObjectPointers() {
        this.options.columns = this.options.columns.slice(0);
        if (Array.isArray(this.options.data) && !this.options.reactiveData) this.options.data = this.options.data.slice(0);
    }
    //build tabulator element
    _buildElement() {
        var element = this.element, options = this.options, newElement;
        if (element.tagName === "TABLE") {
            this.originalElement = this.element;
            newElement = document.createElement("div");
            //transfer attributes to new element
            var attributes = element.attributes;
            // loop through attributes and apply them on div
            for(var i in attributes)if (typeof attributes[i] == "object") newElement.setAttribute(attributes[i].name, attributes[i].value);
            // replace table with div element
            element.parentNode.replaceChild(newElement, element);
            this.element = element = newElement;
        }
        element.classList.add("tabulator");
        element.setAttribute("role", "grid");
        //empty element
        while(element.firstChild)element.removeChild(element.firstChild);
        //set table height
        if (options.height) {
            options.height = isNaN(options.height) ? options.height : options.height + "px";
            element.style.height = options.height;
        }
        //set table min height
        if (options.minHeight !== false) {
            options.minHeight = isNaN(options.minHeight) ? options.minHeight : options.minHeight + "px";
            element.style.minHeight = options.minHeight;
        }
        //set table maxHeight
        if (options.maxHeight !== false) {
            options.maxHeight = isNaN(options.maxHeight) ? options.maxHeight : options.maxHeight + "px";
            element.style.maxHeight = options.maxHeight;
        }
    }
    //initialize core systems and modules
    _initializeTable() {
        var element = this.element, options = this.options;
        this.interactionMonitor.initialize();
        this.columnManager.initialize();
        this.rowManager.initialize();
        this._detectBrowser();
        //initialize core modules
        this.modulesCore.forEach((mod)=>{
            mod.initialize();
        });
        //build table elements
        element.appendChild(this.columnManager.getElement());
        element.appendChild(this.rowManager.getElement());
        if (options.footerElement) this.footerManager.activate();
        if (options.autoColumns && options.data) this.columnManager.generateColumnsFromRowData(this.options.data);
        //initialize regular modules
        this.modulesRegular.forEach((mod)=>{
            mod.initialize();
        });
        this.columnManager.setColumns(options.columns);
        this.eventBus.dispatch("table-built");
    }
    _loadInitialData() {
        return this.dataLoader.load(this.options.data).finally(()=>{
            this.columnManager.verticalAlignHeaders();
        });
    }
    //deconstructor
    destroy() {
        var element = this.element;
        this.destroyed = true;
        this.constructor.registry.deregister(this); //deregister table from inter-device communication
        this.eventBus.dispatch("table-destroy");
        //clear row data
        this.rowManager.destroy();
        //clear DOM
        while(element.firstChild)element.removeChild(element.firstChild);
        element.classList.remove("tabulator");
        this.externalEvents.dispatch("tableDestroyed");
    }
    _detectBrowser() {
        var ua = navigator.userAgent || navigator.vendor || window.opera;
        if (ua.indexOf("Trident") > -1) {
            this.browser = "ie";
            this.browserSlow = true;
        } else if (ua.indexOf("Edge") > -1) {
            this.browser = "edge";
            this.browserSlow = true;
        } else if (ua.indexOf("Firefox") > -1) {
            this.browser = "firefox";
            this.browserSlow = false;
        } else if (ua.indexOf("Mac OS") > -1) {
            this.browser = "safari";
            this.browserSlow = false;
        } else {
            this.browser = "other";
            this.browserSlow = false;
        }
        this.browserMobile = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(ua) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(ua.slice(0, 4));
    }
    initGuard(func, msg) {
        var stack, line;
        if (this.options.debugInitialization && !this.initialized) {
            if (!func) {
                stack = new Error().stack.split("\n");
                line = stack[0] == "Error" ? stack[2] : stack[1];
                if (line[0] == " ") func = line.trim().split(" ")[1].split(".")[1];
                else func = line.trim().split("@")[0];
            }
            console.warn("Table Not Initialized - Calling the " + func + " function before the table is initialized may result in inconsistent behavior, Please wait for the `tableBuilt` event before calling this function." + (msg ? " " + msg : ""));
        }
        return this.initialized;
    }
    ////////////////// Data Handling //////////////////
    //block table redrawing
    blockRedraw() {
        this.initGuard();
        this.eventBus.dispatch("redraw-blocking");
        this.rowManager.blockRedraw();
        this.columnManager.blockRedraw();
        this.eventBus.dispatch("redraw-blocked");
    }
    //restore table redrawing
    restoreRedraw() {
        this.initGuard();
        this.eventBus.dispatch("redraw-restoring");
        this.rowManager.restoreRedraw();
        this.columnManager.restoreRedraw();
        this.eventBus.dispatch("redraw-restored");
    }
    //load data
    setData(data, params, config) {
        this.initGuard(false, "To set initial data please use the 'data' property in the table constructor.");
        return this.dataLoader.load(data, params, config, false);
    }
    //clear data
    clearData() {
        this.initGuard();
        this.dataLoader.blockActiveLoad();
        this.rowManager.clearData();
    }
    //get table data array
    getData(active) {
        return this.rowManager.getData(active);
    }
    //get table data array count
    getDataCount(active) {
        return this.rowManager.getDataCount(active);
    }
    //replace data, keeping table in position with same sort
    replaceData(data, params, config) {
        this.initGuard();
        return this.dataLoader.load(data, params, config, true, true);
    }
    //update table data
    updateData(data) {
        var responses = 0;
        this.initGuard();
        return new Promise((resolve, reject)=>{
            this.dataLoader.blockActiveLoad();
            if (typeof data === "string") data = JSON.parse(data);
            if (data && data.length > 0) data.forEach((item)=>{
                var row = this.rowManager.findRow(item[this.options.index]);
                if (row) {
                    responses++;
                    row.updateData(item).then(()=>{
                        responses--;
                        if (!responses) resolve();
                    }).catch((e)=>{
                        reject("Update Error - Unable to update row", item, e);
                    });
                } else reject("Update Error - Unable to find row", item);
            });
            else {
                console.warn("Update Error - No data provided");
                reject("Update Error - No data provided");
            }
        });
    }
    addData(data, pos, index) {
        this.initGuard();
        return new Promise((resolve, reject)=>{
            this.dataLoader.blockActiveLoad();
            if (typeof data === "string") data = JSON.parse(data);
            if (data) this.rowManager.addRows(data, pos, index).then((rows)=>{
                var output = [];
                rows.forEach(function(row) {
                    output.push(row.getComponent());
                });
                resolve(output);
            });
            else {
                console.warn("Update Error - No data provided");
                reject("Update Error - No data provided");
            }
        });
    }
    //update table data
    updateOrAddData(data) {
        var rows = [], responses = 0;
        this.initGuard();
        return new Promise((resolve, reject)=>{
            this.dataLoader.blockActiveLoad();
            if (typeof data === "string") data = JSON.parse(data);
            if (data && data.length > 0) data.forEach((item)=>{
                var row = this.rowManager.findRow(item[this.options.index]);
                responses++;
                if (row) row.updateData(item).then(()=>{
                    responses--;
                    rows.push(row.getComponent());
                    if (!responses) resolve(rows);
                });
                else this.rowManager.addRows(item).then((newRows)=>{
                    responses--;
                    rows.push(newRows[0].getComponent());
                    if (!responses) resolve(rows);
                });
            });
            else {
                console.warn("Update Error - No data provided");
                reject("Update Error - No data provided");
            }
        });
    }
    //get row object
    getRow(index) {
        var row = this.rowManager.findRow(index);
        if (row) return row.getComponent();
        else {
            console.warn("Find Error - No matching row found:", index);
            return false;
        }
    }
    //get row object
    getRowFromPosition(position) {
        var row = this.rowManager.getRowFromPosition(position);
        if (row) return row.getComponent();
        else {
            console.warn("Find Error - No matching row found:", position);
            return false;
        }
    }
    //delete row from table
    deleteRow(index) {
        var foundRows = [];
        this.initGuard();
        if (!Array.isArray(index)) index = [
            index
        ];
        //find matching rows
        for (let item of index){
            let row = this.rowManager.findRow(item, true);
            if (row) foundRows.push(row);
            else {
                console.error("Delete Error - No matching row found:", item);
                return Promise.reject("Delete Error - No matching row found");
            }
        }
        //sort rows into correct order to ensure smooth delete from table
        foundRows.sort((a, b)=>{
            return this.rowManager.rows.indexOf(a) > this.rowManager.rows.indexOf(b) ? 1 : -1;
        });
        //delete rows
        foundRows.forEach((row)=>{
            row.delete();
        });
        this.rowManager.reRenderInPosition();
        return Promise.resolve();
    }
    //add row to table
    addRow(data, pos, index) {
        this.initGuard();
        if (typeof data === "string") data = JSON.parse(data);
        return this.rowManager.addRows(data, pos, index, true).then((rows)=>{
            return rows[0].getComponent();
        });
    }
    //update a row if it exists otherwise create it
    updateOrAddRow(index, data) {
        var row = this.rowManager.findRow(index);
        this.initGuard();
        if (typeof data === "string") data = JSON.parse(data);
        if (row) return row.updateData(data).then(()=>{
            return row.getComponent();
        });
        else return this.rowManager.addRows(data).then((rows)=>{
            return rows[0].getComponent();
        });
    }
    //update row data
    updateRow(index, data) {
        var row = this.rowManager.findRow(index);
        this.initGuard();
        if (typeof data === "string") data = JSON.parse(data);
        if (row) return row.updateData(data).then(()=>{
            return Promise.resolve(row.getComponent());
        });
        else {
            console.warn("Update Error - No matching row found:", index);
            return Promise.reject("Update Error - No matching row found");
        }
    }
    //scroll to row in DOM
    scrollToRow(index, position, ifVisible) {
        var row = this.rowManager.findRow(index);
        if (row) return this.rowManager.scrollToRow(row, position, ifVisible);
        else {
            console.warn("Scroll Error - No matching row found:", index);
            return Promise.reject("Scroll Error - No matching row found");
        }
    }
    moveRow(from, to, after) {
        var fromRow = this.rowManager.findRow(from);
        this.initGuard();
        if (fromRow) fromRow.moveToRow(to, after);
        else console.warn("Move Error - No matching row found:", from);
    }
    getRows(active) {
        return this.rowManager.getComponents(active);
    }
    //get position of row in table
    getRowPosition(index) {
        var row = this.rowManager.findRow(index);
        if (row) return row.getPosition();
        else {
            console.warn("Position Error - No matching row found:", index);
            return false;
        }
    }
    /////////////// Column Functions  ///////////////
    setColumns(definition) {
        this.initGuard(false, "To set initial columns please use the 'columns' property in the table constructor");
        this.columnManager.setColumns(definition);
    }
    getColumns(structured) {
        return this.columnManager.getComponents(structured);
    }
    getColumn(field) {
        var column = this.columnManager.findColumn(field);
        if (column) return column.getComponent();
        else {
            console.warn("Find Error - No matching column found:", field);
            return false;
        }
    }
    getColumnDefinitions() {
        return this.columnManager.getDefinitionTree();
    }
    showColumn(field) {
        var column = this.columnManager.findColumn(field);
        this.initGuard();
        if (column) column.show();
        else {
            console.warn("Column Show Error - No matching column found:", field);
            return false;
        }
    }
    hideColumn(field) {
        var column = this.columnManager.findColumn(field);
        this.initGuard();
        if (column) column.hide();
        else {
            console.warn("Column Hide Error - No matching column found:", field);
            return false;
        }
    }
    toggleColumn(field) {
        var column = this.columnManager.findColumn(field);
        this.initGuard();
        if (column) {
            if (column.visible) column.hide();
            else column.show();
        } else {
            console.warn("Column Visibility Toggle Error - No matching column found:", field);
            return false;
        }
    }
    addColumn(definition, before, field) {
        var column = this.columnManager.findColumn(field);
        this.initGuard();
        return this.columnManager.addColumn(definition, before, column).then((column)=>{
            return column.getComponent();
        });
    }
    deleteColumn(field) {
        var column = this.columnManager.findColumn(field);
        this.initGuard();
        if (column) return column.delete();
        else {
            console.warn("Column Delete Error - No matching column found:", field);
            return Promise.reject();
        }
    }
    updateColumnDefinition(field, definition) {
        var column = this.columnManager.findColumn(field);
        this.initGuard();
        if (column) return column.updateDefinition(definition);
        else {
            console.warn("Column Update Error - No matching column found:", field);
            return Promise.reject();
        }
    }
    moveColumn(from, to, after) {
        var fromColumn = this.columnManager.findColumn(from), toColumn = this.columnManager.findColumn(to);
        this.initGuard();
        if (fromColumn) {
            if (toColumn) this.columnManager.moveColumn(fromColumn, toColumn, after);
            else console.warn("Move Error - No matching column found:", toColumn);
        } else console.warn("Move Error - No matching column found:", from);
    }
    //scroll to column in DOM
    scrollToColumn(field, position, ifVisible) {
        return new Promise((resolve, reject)=>{
            var column = this.columnManager.findColumn(field);
            if (column) return this.columnManager.scrollToColumn(column, position, ifVisible);
            else {
                console.warn("Scroll Error - No matching column found:", field);
                return Promise.reject("Scroll Error - No matching column found");
            }
        });
    }
    //////////// General Public Functions ////////////
    //redraw list without updating data
    redraw(force) {
        this.initGuard();
        this.columnManager.redraw(force);
        this.rowManager.redraw(force);
    }
    setHeight(height) {
        this.options.height = isNaN(height) ? height : height + "px";
        this.element.style.height = this.options.height;
        this.rowManager.initializeRenderer();
        this.rowManager.redraw(true);
    }
    //////////////////// Event Bus ///////////////////
    on(key, callback) {
        this.externalEvents.subscribe(key, callback);
    }
    off(key, callback) {
        this.externalEvents.unsubscribe(key, callback);
    }
    dispatchEvent() {
        var args = Array.from(arguments);
        args.shift();
        this.externalEvents.dispatch(...arguments);
    }
    //////////////////// Alerts ///////////////////
    alert(contents, type) {
        this.initGuard();
        this.alertManager.alert(contents, type);
    }
    clearAlert() {
        this.initGuard();
        this.alertManager.clear();
    }
    ////////////// Extension Management //////////////
    modExists(plugin, required) {
        if (this.modules[plugin]) return true;
        else {
            if (required) console.error("Tabulator Module Not Installed: " + plugin);
            return false;
        }
    }
    module(key) {
        var mod = this.modules[key];
        if (!mod) console.error("Tabulator module not installed: " + key);
        return mod;
    }
}
var $c2a9788f40f9c90a$export$cd7cfffa934dc7d2 = $c2a9788f40f9c90a$var$Tabulator;
//tabulator with all modules installed
class $c2a9788f40f9c90a$var$TabulatorFull extends $c2a9788f40f9c90a$export$cd7cfffa934dc7d2 {
    static extendModule() {
        $c2a9788f40f9c90a$export$cd7cfffa934dc7d2.initializeModuleBinder($c2a9788f40f9c90a$var$allModules);
        $c2a9788f40f9c90a$export$cd7cfffa934dc7d2._extendModule(...arguments);
    }
    static registerModule() {
        $c2a9788f40f9c90a$export$cd7cfffa934dc7d2.initializeModuleBinder($c2a9788f40f9c90a$var$allModules);
        $c2a9788f40f9c90a$export$cd7cfffa934dc7d2._registerModule(...arguments);
    }
    constructor(element, options, modules){
        super(element, options, $c2a9788f40f9c90a$var$allModules);
    }
}
var $c2a9788f40f9c90a$export$62676a0a2827a643 = $c2a9788f40f9c90a$var$TabulatorFull;
class $c2a9788f40f9c90a$export$8d0cd4d1f07aaaa6 {
    constructor(type){
        this.type = type;
        this.element = this._createElement();
    }
    _createElement() {
        var el = document.createElement("div");
        el.classList.add("tabulator-row");
        return el;
    }
    getElement() {
        return this.element;
    }
    getComponent() {
        return false;
    }
    getData() {
        return {};
    }
    getHeight() {
        return this.element.outerHeight;
    }
    initialize() {}
    reinitialize() {}
    normalizeHeight() {}
    generateCells() {}
    reinitializeHeight() {}
    calcHeight() {}
    setCellHeight() {}
    clearCellHeight() {}
    rendered() {}
}


var $125d88de280575d0$exports = {};
/*! choices.js v10.2.0 | © 2022 Josh Johnson | https://github.com/jshjohnson/Choices#readme */ (function webpackUniversalModuleDefinition(root, factory) {
    $125d88de280575d0$exports = factory();
})(window, function() {
    return /******/ function() {
        /******/ "use strict";
        /******/ var __webpack_modules__ = {
            /***/ 282: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.clearChoices = exports.activateChoices = exports.filterChoices = exports.addChoice = void 0;
                var constants_1 = __webpack_require__(883);
                var addChoice = function(_a) {
                    var value = _a.value, label = _a.label, id = _a.id, groupId = _a.groupId, disabled = _a.disabled, elementId = _a.elementId, customProperties = _a.customProperties, placeholder = _a.placeholder, keyCode = _a.keyCode;
                    return {
                        type: constants_1.ACTION_TYPES.ADD_CHOICE,
                        value: value,
                        label: label,
                        id: id,
                        groupId: groupId,
                        disabled: disabled,
                        elementId: elementId,
                        customProperties: customProperties,
                        placeholder: placeholder,
                        keyCode: keyCode
                    };
                };
                exports.addChoice = addChoice;
                var filterChoices = function(results) {
                    return {
                        type: constants_1.ACTION_TYPES.FILTER_CHOICES,
                        results: results
                    };
                };
                exports.filterChoices = filterChoices;
                var activateChoices = function(active) {
                    if (active === void 0) active = true;
                    return {
                        type: constants_1.ACTION_TYPES.ACTIVATE_CHOICES,
                        active: active
                    };
                };
                exports.activateChoices = activateChoices;
                var clearChoices = function() {
                    return {
                        type: constants_1.ACTION_TYPES.CLEAR_CHOICES
                    };
                };
                exports.clearChoices = clearChoices;
            /***/ },
            /***/ 783: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.addGroup = void 0;
                var constants_1 = __webpack_require__(883);
                var addGroup = function(_a) {
                    var value = _a.value, id = _a.id, active = _a.active, disabled = _a.disabled;
                    return {
                        type: constants_1.ACTION_TYPES.ADD_GROUP,
                        value: value,
                        id: id,
                        active: active,
                        disabled: disabled
                    };
                };
                exports.addGroup = addGroup;
            /***/ },
            /***/ 464: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.highlightItem = exports.removeItem = exports.addItem = void 0;
                var constants_1 = __webpack_require__(883);
                var addItem = function(_a) {
                    var value = _a.value, label = _a.label, id = _a.id, choiceId = _a.choiceId, groupId = _a.groupId, customProperties = _a.customProperties, placeholder = _a.placeholder, keyCode = _a.keyCode;
                    return {
                        type: constants_1.ACTION_TYPES.ADD_ITEM,
                        value: value,
                        label: label,
                        id: id,
                        choiceId: choiceId,
                        groupId: groupId,
                        customProperties: customProperties,
                        placeholder: placeholder,
                        keyCode: keyCode
                    };
                };
                exports.addItem = addItem;
                var removeItem = function(id, choiceId) {
                    return {
                        type: constants_1.ACTION_TYPES.REMOVE_ITEM,
                        id: id,
                        choiceId: choiceId
                    };
                };
                exports.removeItem = removeItem;
                var highlightItem = function(id, highlighted) {
                    return {
                        type: constants_1.ACTION_TYPES.HIGHLIGHT_ITEM,
                        id: id,
                        highlighted: highlighted
                    };
                };
                exports.highlightItem = highlightItem;
            /***/ },
            /***/ 137: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.setIsLoading = exports.resetTo = exports.clearAll = void 0;
                var constants_1 = __webpack_require__(883);
                var clearAll = function() {
                    return {
                        type: constants_1.ACTION_TYPES.CLEAR_ALL
                    };
                };
                exports.clearAll = clearAll;
                var resetTo = function(state) {
                    return {
                        type: constants_1.ACTION_TYPES.RESET_TO,
                        state: state
                    };
                };
                exports.resetTo = resetTo;
                var setIsLoading = function(isLoading) {
                    return {
                        type: constants_1.ACTION_TYPES.SET_IS_LOADING,
                        isLoading: isLoading
                    };
                };
                exports.setIsLoading = setIsLoading;
            /***/ },
            /***/ 373: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var __spreadArray = this && this.__spreadArray || function(to, from, pack) {
                    if (pack || arguments.length === 2) {
                        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                            ar[i] = from[i];
                        }
                    }
                    return to.concat(ar || Array.prototype.slice.call(from));
                };
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var deepmerge_1 = __importDefault(__webpack_require__(996));
                /* eslint-disable @typescript-eslint/no-explicit-any */ var fuse_js_1 = __importDefault(__webpack_require__(221));
                var choices_1 = __webpack_require__(282);
                var groups_1 = __webpack_require__(783);
                var items_1 = __webpack_require__(464);
                var misc_1 = __webpack_require__(137);
                var components_1 = __webpack_require__(520);
                var constants_1 = __webpack_require__(883);
                var defaults_1 = __webpack_require__(789);
                var utils_1 = __webpack_require__(799);
                var reducers_1 = __webpack_require__(655);
                var store_1 = __importDefault(__webpack_require__(744));
                var templates_1 = __importDefault(__webpack_require__(686));
                /** @see {@link http://browserhacks.com/#hack-acea075d0ac6954f275a70023906050c} */ var IS_IE11 = "-ms-scroll-limit" in document.documentElement.style && "-ms-ime-align" in document.documentElement.style;
                var USER_DEFAULTS = {};
                /**
 * Choices
 * @author Josh Johnson<josh@joshuajohnson.co.uk>
 */ var Choices = /** @class */ function() {
                    function Choices(element, userConfig) {
                        if (element === void 0) element = "[data-choice]";
                        if (userConfig === void 0) userConfig = {};
                        var _this = this;
                        if (userConfig.allowHTML === undefined) console.warn("Deprecation warning: allowHTML will default to false in a future release. To render HTML in Choices, you will need to set it to true. Setting allowHTML will suppress this message.");
                        this.config = deepmerge_1.default.all([
                            defaults_1.DEFAULT_CONFIG,
                            Choices.defaults.options,
                            userConfig
                        ], // When merging array configs, replace with a copy of the userConfig array,
                        // instead of concatenating with the default array
                        {
                            arrayMerge: function(_, sourceArray) {
                                return __spreadArray([], sourceArray, true);
                            }
                        });
                        var invalidConfigOptions = (0, utils_1.diff)(this.config, defaults_1.DEFAULT_CONFIG);
                        if (invalidConfigOptions.length) console.warn("Unknown config option(s) passed", invalidConfigOptions.join(", "));
                        var passedElement = typeof element === "string" ? document.querySelector(element) : element;
                        if (!(passedElement instanceof HTMLInputElement || passedElement instanceof HTMLSelectElement)) throw TypeError("Expected one of the following types text|select-one|select-multiple");
                        this._isTextElement = passedElement.type === constants_1.TEXT_TYPE;
                        this._isSelectOneElement = passedElement.type === constants_1.SELECT_ONE_TYPE;
                        this._isSelectMultipleElement = passedElement.type === constants_1.SELECT_MULTIPLE_TYPE;
                        this._isSelectElement = this._isSelectOneElement || this._isSelectMultipleElement;
                        this.config.searchEnabled = this._isSelectMultipleElement || this.config.searchEnabled;
                        if (![
                            "auto",
                            "always"
                        ].includes("".concat(this.config.renderSelectedChoices))) this.config.renderSelectedChoices = "auto";
                        if (userConfig.addItemFilter && typeof userConfig.addItemFilter !== "function") {
                            var re = userConfig.addItemFilter instanceof RegExp ? userConfig.addItemFilter : new RegExp(userConfig.addItemFilter);
                            this.config.addItemFilter = re.test.bind(re);
                        }
                        if (this._isTextElement) this.passedElement = new components_1.WrappedInput({
                            element: passedElement,
                            classNames: this.config.classNames,
                            delimiter: this.config.delimiter
                        });
                        else this.passedElement = new components_1.WrappedSelect({
                            element: passedElement,
                            classNames: this.config.classNames,
                            template: function(data) {
                                return _this._templates.option(data);
                            }
                        });
                        this.initialised = false;
                        this._store = new store_1.default();
                        this._initialState = reducers_1.defaultState;
                        this._currentState = reducers_1.defaultState;
                        this._prevState = reducers_1.defaultState;
                        this._currentValue = "";
                        this._canSearch = !!this.config.searchEnabled;
                        this._isScrollingOnIe = false;
                        this._highlightPosition = 0;
                        this._wasTap = true;
                        this._placeholderValue = this._generatePlaceholderValue();
                        this._baseId = (0, utils_1.generateId)(this.passedElement.element, "choices-");
                        /**
     * setting direction in cases where it's explicitly set on passedElement
     * or when calculated direction is different from the document
     */ this._direction = this.passedElement.dir;
                        if (!this._direction) {
                            var elementDirection = window.getComputedStyle(this.passedElement.element).direction;
                            var documentDirection = window.getComputedStyle(document.documentElement).direction;
                            if (elementDirection !== documentDirection) this._direction = elementDirection;
                        }
                        this._idNames = {
                            itemChoice: "item-choice"
                        };
                        if (this._isSelectElement) {
                            // Assign preset groups from passed element
                            this._presetGroups = this.passedElement.optionGroups;
                            // Assign preset options from passed element
                            this._presetOptions = this.passedElement.options;
                        }
                        // Assign preset choices from passed object
                        this._presetChoices = this.config.choices;
                        // Assign preset items from passed object first
                        this._presetItems = this.config.items;
                        // Add any values passed from attribute
                        if (this.passedElement.value && this._isTextElement) {
                            var splitValues = this.passedElement.value.split(this.config.delimiter);
                            this._presetItems = this._presetItems.concat(splitValues);
                        }
                        // Create array of choices from option elements
                        if (this.passedElement.options) this.passedElement.options.forEach(function(option) {
                            _this._presetChoices.push({
                                value: option.value,
                                label: option.innerHTML,
                                selected: !!option.selected,
                                disabled: option.disabled || option.parentNode.disabled,
                                placeholder: option.value === "" || option.hasAttribute("placeholder"),
                                customProperties: (0, utils_1.parseCustomProperties)(option.dataset.customProperties)
                            });
                        });
                        this._render = this._render.bind(this);
                        this._onFocus = this._onFocus.bind(this);
                        this._onBlur = this._onBlur.bind(this);
                        this._onKeyUp = this._onKeyUp.bind(this);
                        this._onKeyDown = this._onKeyDown.bind(this);
                        this._onClick = this._onClick.bind(this);
                        this._onTouchMove = this._onTouchMove.bind(this);
                        this._onTouchEnd = this._onTouchEnd.bind(this);
                        this._onMouseDown = this._onMouseDown.bind(this);
                        this._onMouseOver = this._onMouseOver.bind(this);
                        this._onFormReset = this._onFormReset.bind(this);
                        this._onSelectKey = this._onSelectKey.bind(this);
                        this._onEnterKey = this._onEnterKey.bind(this);
                        this._onEscapeKey = this._onEscapeKey.bind(this);
                        this._onDirectionKey = this._onDirectionKey.bind(this);
                        this._onDeleteKey = this._onDeleteKey.bind(this);
                        // If element has already been initialised with Choices, fail silently
                        if (this.passedElement.isActive) {
                            if (!this.config.silent) console.warn("Trying to initialise Choices on element already initialised", {
                                element: element
                            });
                            this.initialised = true;
                            return;
                        }
                        // Let's go
                        this.init();
                    }
                    Object.defineProperty(Choices, "defaults", {
                        get: function() {
                            return Object.preventExtensions({
                                get options () {
                                    return USER_DEFAULTS;
                                },
                                get templates () {
                                    return templates_1.default;
                                }
                            });
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Choices.prototype.init = function() {
                        if (this.initialised) return;
                        this._createTemplates();
                        this._createElements();
                        this._createStructure();
                        this._store.subscribe(this._render);
                        this._render();
                        this._addEventListeners();
                        var shouldDisable = !this.config.addItems || this.passedElement.element.hasAttribute("disabled");
                        if (shouldDisable) this.disable();
                        this.initialised = true;
                        var callbackOnInit = this.config.callbackOnInit;
                        // Run callback if it is a function
                        if (callbackOnInit && typeof callbackOnInit === "function") callbackOnInit.call(this);
                    };
                    Choices.prototype.destroy = function() {
                        if (!this.initialised) return;
                        this._removeEventListeners();
                        this.passedElement.reveal();
                        this.containerOuter.unwrap(this.passedElement.element);
                        this.clearStore();
                        if (this._isSelectElement) this.passedElement.options = this._presetOptions;
                        this._templates = templates_1.default;
                        this.initialised = false;
                    };
                    Choices.prototype.enable = function() {
                        if (this.passedElement.isDisabled) this.passedElement.enable();
                        if (this.containerOuter.isDisabled) {
                            this._addEventListeners();
                            this.input.enable();
                            this.containerOuter.enable();
                        }
                        return this;
                    };
                    Choices.prototype.disable = function() {
                        if (!this.passedElement.isDisabled) this.passedElement.disable();
                        if (!this.containerOuter.isDisabled) {
                            this._removeEventListeners();
                            this.input.disable();
                            this.containerOuter.disable();
                        }
                        return this;
                    };
                    Choices.prototype.highlightItem = function(item, runEvent) {
                        if (runEvent === void 0) runEvent = true;
                        if (!item || !item.id) return this;
                        var id = item.id, _a = item.groupId, groupId = _a === void 0 ? -1 : _a, _b = item.value, value = _b === void 0 ? "" : _b, _c = item.label, label = _c === void 0 ? "" : _c;
                        var group = groupId >= 0 ? this._store.getGroupById(groupId) : null;
                        this._store.dispatch((0, items_1.highlightItem)(id, true));
                        if (runEvent) this.passedElement.triggerEvent(constants_1.EVENTS.highlightItem, {
                            id: id,
                            value: value,
                            label: label,
                            groupValue: group && group.value ? group.value : null
                        });
                        return this;
                    };
                    Choices.prototype.unhighlightItem = function(item) {
                        if (!item || !item.id) return this;
                        var id = item.id, _a = item.groupId, groupId = _a === void 0 ? -1 : _a, _b = item.value, value = _b === void 0 ? "" : _b, _c = item.label, label = _c === void 0 ? "" : _c;
                        var group = groupId >= 0 ? this._store.getGroupById(groupId) : null;
                        this._store.dispatch((0, items_1.highlightItem)(id, false));
                        this.passedElement.triggerEvent(constants_1.EVENTS.highlightItem, {
                            id: id,
                            value: value,
                            label: label,
                            groupValue: group && group.value ? group.value : null
                        });
                        return this;
                    };
                    Choices.prototype.highlightAll = function() {
                        var _this = this;
                        this._store.items.forEach(function(item) {
                            return _this.highlightItem(item);
                        });
                        return this;
                    };
                    Choices.prototype.unhighlightAll = function() {
                        var _this = this;
                        this._store.items.forEach(function(item) {
                            return _this.unhighlightItem(item);
                        });
                        return this;
                    };
                    Choices.prototype.removeActiveItemsByValue = function(value) {
                        var _this = this;
                        this._store.activeItems.filter(function(item) {
                            return item.value === value;
                        }).forEach(function(item) {
                            return _this._removeItem(item);
                        });
                        return this;
                    };
                    Choices.prototype.removeActiveItems = function(excludedId) {
                        var _this = this;
                        this._store.activeItems.filter(function(_a) {
                            var id = _a.id;
                            return id !== excludedId;
                        }).forEach(function(item) {
                            return _this._removeItem(item);
                        });
                        return this;
                    };
                    Choices.prototype.removeHighlightedItems = function(runEvent) {
                        var _this = this;
                        if (runEvent === void 0) runEvent = false;
                        this._store.highlightedActiveItems.forEach(function(item) {
                            _this._removeItem(item);
                            // If this action was performed by the user
                            // trigger the event
                            if (runEvent) _this._triggerChange(item.value);
                        });
                        return this;
                    };
                    Choices.prototype.showDropdown = function(preventInputFocus) {
                        var _this = this;
                        if (this.dropdown.isActive) return this;
                        requestAnimationFrame(function() {
                            _this.dropdown.show();
                            _this.containerOuter.open(_this.dropdown.distanceFromTopWindow);
                            if (!preventInputFocus && _this._canSearch) _this.input.focus();
                            _this.passedElement.triggerEvent(constants_1.EVENTS.showDropdown, {});
                        });
                        return this;
                    };
                    Choices.prototype.hideDropdown = function(preventInputBlur) {
                        var _this = this;
                        if (!this.dropdown.isActive) return this;
                        requestAnimationFrame(function() {
                            _this.dropdown.hide();
                            _this.containerOuter.close();
                            if (!preventInputBlur && _this._canSearch) {
                                _this.input.removeActiveDescendant();
                                _this.input.blur();
                            }
                            _this.passedElement.triggerEvent(constants_1.EVENTS.hideDropdown, {});
                        });
                        return this;
                    };
                    Choices.prototype.getValue = function(valueOnly) {
                        if (valueOnly === void 0) valueOnly = false;
                        var values = this._store.activeItems.reduce(function(selectedItems, item) {
                            var itemValue = valueOnly ? item.value : item;
                            selectedItems.push(itemValue);
                            return selectedItems;
                        }, []);
                        return this._isSelectOneElement ? values[0] : values;
                    };
                    Choices.prototype.setValue = function(items) {
                        var _this = this;
                        if (!this.initialised) return this;
                        items.forEach(function(value) {
                            return _this._setChoiceOrItem(value);
                        });
                        return this;
                    };
                    Choices.prototype.setChoiceByValue = function(value) {
                        var _this = this;
                        if (!this.initialised || this._isTextElement) return this;
                        // If only one value has been passed, convert to array
                        var choiceValue = Array.isArray(value) ? value : [
                            value
                        ];
                        // Loop through each value and
                        choiceValue.forEach(function(val) {
                            return _this._findAndSelectChoiceByValue(val);
                        });
                        return this;
                    };
                    /**
   * Set choices of select input via an array of objects (or function that returns array of object or promise of it),
   * a value field name and a label field name.
   * This behaves the same as passing items via the choices option but can be called after initialising Choices.
   * This can also be used to add groups of choices (see example 2); Optionally pass a true `replaceChoices` value to remove any existing choices.
   * Optionally pass a `customProperties` object to add additional data to your choices (useful when searching/filtering etc).
   *
   * **Input types affected:** select-one, select-multiple
   *
   * @example
   * ```js
   * const example = new Choices(element);
   *
   * example.setChoices([
   *   {value: 'One', label: 'Label One', disabled: true},
   *   {value: 'Two', label: 'Label Two', selected: true},
   *   {value: 'Three', label: 'Label Three'},
   * ], 'value', 'label', false);
   * ```
   *
   * @example
   * ```js
   * const example = new Choices(element);
   *
   * example.setChoices(async () => {
   *   try {
   *      const items = await fetch('/items');
   *      return items.json()
   *   } catch(err) {
   *      console.error(err)
   *   }
   * });
   * ```
   *
   * @example
   * ```js
   * const example = new Choices(element);
   *
   * example.setChoices([{
   *   label: 'Group one',
   *   id: 1,
   *   disabled: false,
   *   choices: [
   *     {value: 'Child One', label: 'Child One', selected: true},
   *     {value: 'Child Two', label: 'Child Two',  disabled: true},
   *     {value: 'Child Three', label: 'Child Three'},
   *   ]
   * },
   * {
   *   label: 'Group two',
   *   id: 2,
   *   disabled: false,
   *   choices: [
   *     {value: 'Child Four', label: 'Child Four', disabled: true},
   *     {value: 'Child Five', label: 'Child Five'},
   *     {value: 'Child Six', label: 'Child Six', customProperties: {
   *       description: 'Custom description about child six',
   *       random: 'Another random custom property'
   *     }},
   *   ]
   * }], 'value', 'label', false);
   * ```
   */ Choices.prototype.setChoices = function(choicesArrayOrFetcher, value, label, replaceChoices) {
                        var _this = this;
                        if (choicesArrayOrFetcher === void 0) choicesArrayOrFetcher = [];
                        if (value === void 0) value = "value";
                        if (label === void 0) label = "label";
                        if (replaceChoices === void 0) replaceChoices = false;
                        if (!this.initialised) throw new ReferenceError("setChoices was called on a non-initialized instance of Choices");
                        if (!this._isSelectElement) throw new TypeError("setChoices can't be used with INPUT based Choices");
                        if (typeof value !== "string" || !value) throw new TypeError("value parameter must be a name of 'value' field in passed objects");
                        // Clear choices if needed
                        if (replaceChoices) this.clearChoices();
                        if (typeof choicesArrayOrFetcher === "function") {
                            // it's a choices fetcher function
                            var fetcher_1 = choicesArrayOrFetcher(this);
                            if (typeof Promise === "function" && fetcher_1 instanceof Promise) // that's a promise
                            // eslint-disable-next-line no-promise-executor-return
                            return new Promise(function(resolve) {
                                return requestAnimationFrame(resolve);
                            }).then(function() {
                                return _this._handleLoadingState(true);
                            }).then(function() {
                                return fetcher_1;
                            }).then(function(data) {
                                return _this.setChoices(data, value, label, replaceChoices);
                            }).catch(function(err) {
                                if (!_this.config.silent) console.error(err);
                            }).then(function() {
                                return _this._handleLoadingState(false);
                            }).then(function() {
                                return _this;
                            });
                            // function returned something else than promise, let's check if it's an array of choices
                            if (!Array.isArray(fetcher_1)) throw new TypeError(".setChoices first argument function must return either array of choices or Promise, got: ".concat(typeof fetcher_1));
                            // recursion with results, it's sync and choices were cleared already
                            return this.setChoices(fetcher_1, value, label, false);
                        }
                        if (!Array.isArray(choicesArrayOrFetcher)) throw new TypeError(".setChoices must be called either with array of choices with a function resulting into Promise of array of choices");
                        this.containerOuter.removeLoadingState();
                        this._startLoading();
                        choicesArrayOrFetcher.forEach(function(groupOrChoice) {
                            if (groupOrChoice.choices) _this._addGroup({
                                id: groupOrChoice.id ? parseInt("".concat(groupOrChoice.id), 10) : null,
                                group: groupOrChoice,
                                valueKey: value,
                                labelKey: label
                            });
                            else {
                                var choice = groupOrChoice;
                                _this._addChoice({
                                    value: choice[value],
                                    label: choice[label],
                                    isSelected: !!choice.selected,
                                    isDisabled: !!choice.disabled,
                                    placeholder: !!choice.placeholder,
                                    customProperties: choice.customProperties
                                });
                            }
                        });
                        this._stopLoading();
                        return this;
                    };
                    Choices.prototype.clearChoices = function() {
                        this._store.dispatch((0, choices_1.clearChoices)());
                        return this;
                    };
                    Choices.prototype.clearStore = function() {
                        this._store.dispatch((0, misc_1.clearAll)());
                        return this;
                    };
                    Choices.prototype.clearInput = function() {
                        var shouldSetInputWidth = !this._isSelectOneElement;
                        this.input.clear(shouldSetInputWidth);
                        if (!this._isTextElement && this._canSearch) {
                            this._isSearching = false;
                            this._store.dispatch((0, choices_1.activateChoices)(true));
                        }
                        return this;
                    };
                    Choices.prototype._render = function() {
                        if (this._store.isLoading()) return;
                        this._currentState = this._store.state;
                        var stateChanged = this._currentState.choices !== this._prevState.choices || this._currentState.groups !== this._prevState.groups || this._currentState.items !== this._prevState.items;
                        var shouldRenderChoices = this._isSelectElement;
                        var shouldRenderItems = this._currentState.items !== this._prevState.items;
                        if (!stateChanged) return;
                        if (shouldRenderChoices) this._renderChoices();
                        if (shouldRenderItems) this._renderItems();
                        this._prevState = this._currentState;
                    };
                    Choices.prototype._renderChoices = function() {
                        var _this = this;
                        var _a = this._store, activeGroups = _a.activeGroups, activeChoices = _a.activeChoices;
                        var choiceListFragment = document.createDocumentFragment();
                        this.choiceList.clear();
                        if (this.config.resetScrollPosition) requestAnimationFrame(function() {
                            return _this.choiceList.scrollToTop();
                        });
                        // If we have grouped options
                        if (activeGroups.length >= 1 && !this._isSearching) {
                            // If we have a placeholder choice along with groups
                            var activePlaceholders = activeChoices.filter(function(activeChoice) {
                                return activeChoice.placeholder === true && activeChoice.groupId === -1;
                            });
                            if (activePlaceholders.length >= 1) choiceListFragment = this._createChoicesFragment(activePlaceholders, choiceListFragment);
                            choiceListFragment = this._createGroupsFragment(activeGroups, activeChoices, choiceListFragment);
                        } else if (activeChoices.length >= 1) choiceListFragment = this._createChoicesFragment(activeChoices, choiceListFragment);
                        // If we have choices to show
                        if (choiceListFragment.childNodes && choiceListFragment.childNodes.length > 0) {
                            var activeItems = this._store.activeItems;
                            var canAddItem = this._canAddItem(activeItems, this.input.value);
                            // ...and we can select them
                            if (canAddItem.response) {
                                // ...append them and highlight the first choice
                                this.choiceList.append(choiceListFragment);
                                this._highlightChoice();
                            } else {
                                var notice = this._getTemplate("notice", canAddItem.notice);
                                this.choiceList.append(notice);
                            }
                        } else {
                            // Otherwise show a notice
                            var dropdownItem = void 0;
                            var notice = void 0;
                            if (this._isSearching) {
                                notice = typeof this.config.noResultsText === "function" ? this.config.noResultsText() : this.config.noResultsText;
                                dropdownItem = this._getTemplate("notice", notice, "no-results");
                            } else {
                                notice = typeof this.config.noChoicesText === "function" ? this.config.noChoicesText() : this.config.noChoicesText;
                                dropdownItem = this._getTemplate("notice", notice, "no-choices");
                            }
                            this.choiceList.append(dropdownItem);
                        }
                    };
                    Choices.prototype._renderItems = function() {
                        var activeItems = this._store.activeItems || [];
                        this.itemList.clear();
                        // Create a fragment to store our list items
                        // (so we don't have to update the DOM for each item)
                        var itemListFragment = this._createItemsFragment(activeItems);
                        // If we have items to add, append them
                        if (itemListFragment.childNodes) this.itemList.append(itemListFragment);
                    };
                    Choices.prototype._createGroupsFragment = function(groups, choices, fragment) {
                        var _this = this;
                        if (fragment === void 0) fragment = document.createDocumentFragment();
                        var getGroupChoices = function(group) {
                            return choices.filter(function(choice) {
                                if (_this._isSelectOneElement) return choice.groupId === group.id;
                                return choice.groupId === group.id && (_this.config.renderSelectedChoices === "always" || !choice.selected);
                            });
                        };
                        // If sorting is enabled, filter groups
                        if (this.config.shouldSort) groups.sort(this.config.sorter);
                        groups.forEach(function(group) {
                            var groupChoices = getGroupChoices(group);
                            if (groupChoices.length >= 1) {
                                var dropdownGroup = _this._getTemplate("choiceGroup", group);
                                fragment.appendChild(dropdownGroup);
                                _this._createChoicesFragment(groupChoices, fragment, true);
                            }
                        });
                        return fragment;
                    };
                    Choices.prototype._createChoicesFragment = function(choices, fragment, withinGroup) {
                        var _this = this;
                        if (fragment === void 0) fragment = document.createDocumentFragment();
                        if (withinGroup === void 0) withinGroup = false;
                        // Create a fragment to store our list items (so we don't have to update the DOM for each item)
                        var _a = this.config, renderSelectedChoices = _a.renderSelectedChoices, searchResultLimit = _a.searchResultLimit, renderChoiceLimit = _a.renderChoiceLimit;
                        var filter = this._isSearching ? utils_1.sortByScore : this.config.sorter;
                        var appendChoice = function(choice) {
                            var shouldRender = renderSelectedChoices === "auto" ? _this._isSelectOneElement || !choice.selected : true;
                            if (shouldRender) {
                                var dropdownItem = _this._getTemplate("choice", choice, _this.config.itemSelectText);
                                fragment.appendChild(dropdownItem);
                            }
                        };
                        var rendererableChoices = choices;
                        if (renderSelectedChoices === "auto" && !this._isSelectOneElement) rendererableChoices = choices.filter(function(choice) {
                            return !choice.selected;
                        });
                        // Split array into placeholders and "normal" choices
                        var _b = rendererableChoices.reduce(function(acc, choice) {
                            if (choice.placeholder) acc.placeholderChoices.push(choice);
                            else acc.normalChoices.push(choice);
                            return acc;
                        }, {
                            placeholderChoices: [],
                            normalChoices: []
                        }), placeholderChoices = _b.placeholderChoices, normalChoices = _b.normalChoices;
                        // If sorting is enabled or the user is searching, filter choices
                        if (this.config.shouldSort || this._isSearching) normalChoices.sort(filter);
                        var choiceLimit = rendererableChoices.length;
                        // Prepend placeholeder
                        var sortedChoices = this._isSelectOneElement ? __spreadArray(__spreadArray([], placeholderChoices, true), normalChoices, true) : normalChoices;
                        if (this._isSearching) choiceLimit = searchResultLimit;
                        else if (renderChoiceLimit && renderChoiceLimit > 0 && !withinGroup) choiceLimit = renderChoiceLimit;
                        // Add each choice to dropdown within range
                        for(var i = 0; i < choiceLimit; i += 1)if (sortedChoices[i]) appendChoice(sortedChoices[i]);
                        return fragment;
                    };
                    Choices.prototype._createItemsFragment = function(items, fragment) {
                        var _this = this;
                        if (fragment === void 0) fragment = document.createDocumentFragment();
                        // Create fragment to add elements to
                        var _a = this.config, shouldSortItems = _a.shouldSortItems, sorter = _a.sorter, removeItemButton = _a.removeItemButton;
                        // If sorting is enabled, filter items
                        if (shouldSortItems && !this._isSelectOneElement) items.sort(sorter);
                        if (this._isTextElement) // Update the value of the hidden input
                        this.passedElement.value = items.map(function(_a) {
                            var value = _a.value;
                            return value;
                        }).join(this.config.delimiter);
                        else // Update the options of the hidden input
                        this.passedElement.options = items;
                        var addItemToFragment = function(item) {
                            // Create new list element
                            var listItem = _this._getTemplate("item", item, removeItemButton);
                            // Append it to list
                            fragment.appendChild(listItem);
                        };
                        // Add each list item to list
                        items.forEach(addItemToFragment);
                        return fragment;
                    };
                    Choices.prototype._triggerChange = function(value) {
                        if (value === undefined || value === null) return;
                        this.passedElement.triggerEvent(constants_1.EVENTS.change, {
                            value: value
                        });
                    };
                    Choices.prototype._selectPlaceholderChoice = function(placeholderChoice) {
                        this._addItem({
                            value: placeholderChoice.value,
                            label: placeholderChoice.label,
                            choiceId: placeholderChoice.id,
                            groupId: placeholderChoice.groupId,
                            placeholder: placeholderChoice.placeholder
                        });
                        this._triggerChange(placeholderChoice.value);
                    };
                    Choices.prototype._handleButtonAction = function(activeItems, element) {
                        if (!activeItems || !element || !this.config.removeItems || !this.config.removeItemButton) return;
                        var itemId = element.parentNode && element.parentNode.dataset.id;
                        var itemToRemove = itemId && activeItems.find(function(item) {
                            return item.id === parseInt(itemId, 10);
                        });
                        if (!itemToRemove) return;
                        // Remove item associated with button
                        this._removeItem(itemToRemove);
                        this._triggerChange(itemToRemove.value);
                        if (this._isSelectOneElement && this._store.placeholderChoice) this._selectPlaceholderChoice(this._store.placeholderChoice);
                    };
                    Choices.prototype._handleItemAction = function(activeItems, element, hasShiftKey) {
                        var _this = this;
                        if (hasShiftKey === void 0) hasShiftKey = false;
                        if (!activeItems || !element || !this.config.removeItems || this._isSelectOneElement) return;
                        var passedId = element.dataset.id;
                        // We only want to select one item with a click
                        // so we deselect any items that aren't the target
                        // unless shift is being pressed
                        activeItems.forEach(function(item) {
                            if (item.id === parseInt("".concat(passedId), 10) && !item.highlighted) _this.highlightItem(item);
                            else if (!hasShiftKey && item.highlighted) _this.unhighlightItem(item);
                        });
                        // Focus input as without focus, a user cannot do anything with a
                        // highlighted item
                        this.input.focus();
                    };
                    Choices.prototype._handleChoiceAction = function(activeItems, element) {
                        if (!activeItems || !element) return;
                        // If we are clicking on an option
                        var id = element.dataset.id;
                        var choice = id && this._store.getChoiceById(id);
                        if (!choice) return;
                        var passedKeyCode = activeItems[0] && activeItems[0].keyCode ? activeItems[0].keyCode : undefined;
                        var hasActiveDropdown = this.dropdown.isActive;
                        // Update choice keyCode
                        choice.keyCode = passedKeyCode;
                        this.passedElement.triggerEvent(constants_1.EVENTS.choice, {
                            choice: choice
                        });
                        if (!choice.selected && !choice.disabled) {
                            var canAddItem = this._canAddItem(activeItems, choice.value);
                            if (canAddItem.response) {
                                this._addItem({
                                    value: choice.value,
                                    label: choice.label,
                                    choiceId: choice.id,
                                    groupId: choice.groupId,
                                    customProperties: choice.customProperties,
                                    placeholder: choice.placeholder,
                                    keyCode: choice.keyCode
                                });
                                this._triggerChange(choice.value);
                            }
                        }
                        this.clearInput();
                        // We want to close the dropdown if we are dealing with a single select box
                        if (hasActiveDropdown && this._isSelectOneElement) {
                            this.hideDropdown(true);
                            this.containerOuter.focus();
                        }
                    };
                    Choices.prototype._handleBackspace = function(activeItems) {
                        if (!this.config.removeItems || !activeItems) return;
                        var lastItem = activeItems[activeItems.length - 1];
                        var hasHighlightedItems = activeItems.some(function(item) {
                            return item.highlighted;
                        });
                        // If editing the last item is allowed and there are not other selected items,
                        // we can edit the item value. Otherwise if we can remove items, remove all selected items
                        if (this.config.editItems && !hasHighlightedItems && lastItem) {
                            this.input.value = lastItem.value;
                            this.input.setWidth();
                            this._removeItem(lastItem);
                            this._triggerChange(lastItem.value);
                        } else {
                            if (!hasHighlightedItems) // Highlight last item if none already highlighted
                            this.highlightItem(lastItem, false);
                            this.removeHighlightedItems(true);
                        }
                    };
                    Choices.prototype._startLoading = function() {
                        this._store.dispatch((0, misc_1.setIsLoading)(true));
                    };
                    Choices.prototype._stopLoading = function() {
                        this._store.dispatch((0, misc_1.setIsLoading)(false));
                    };
                    Choices.prototype._handleLoadingState = function(setLoading) {
                        if (setLoading === void 0) setLoading = true;
                        var placeholderItem = this.itemList.getChild(".".concat(this.config.classNames.placeholder));
                        if (setLoading) {
                            this.disable();
                            this.containerOuter.addLoadingState();
                            if (this._isSelectOneElement) {
                                if (!placeholderItem) {
                                    placeholderItem = this._getTemplate("placeholder", this.config.loadingText);
                                    if (placeholderItem) this.itemList.append(placeholderItem);
                                } else placeholderItem.innerHTML = this.config.loadingText;
                            } else this.input.placeholder = this.config.loadingText;
                        } else {
                            this.enable();
                            this.containerOuter.removeLoadingState();
                            if (this._isSelectOneElement) {
                                if (placeholderItem) placeholderItem.innerHTML = this._placeholderValue || "";
                            } else this.input.placeholder = this._placeholderValue || "";
                        }
                    };
                    Choices.prototype._handleSearch = function(value) {
                        if (!this.input.isFocussed) return;
                        var choices = this._store.choices;
                        var _a = this.config, searchFloor = _a.searchFloor, searchChoices = _a.searchChoices;
                        var hasUnactiveChoices = choices.some(function(option) {
                            return !option.active;
                        });
                        // Check that we have a value to search and the input was an alphanumeric character
                        if (value !== null && typeof value !== "undefined" && value.length >= searchFloor) {
                            var resultCount = searchChoices ? this._searchChoices(value) : 0;
                            // Trigger search event
                            this.passedElement.triggerEvent(constants_1.EVENTS.search, {
                                value: value,
                                resultCount: resultCount
                            });
                        } else if (hasUnactiveChoices) {
                            // Otherwise reset choices to active
                            this._isSearching = false;
                            this._store.dispatch((0, choices_1.activateChoices)(true));
                        }
                    };
                    Choices.prototype._canAddItem = function(activeItems, value) {
                        var canAddItem = true;
                        var notice = typeof this.config.addItemText === "function" ? this.config.addItemText(value) : this.config.addItemText;
                        if (!this._isSelectOneElement) {
                            var isDuplicateValue = (0, utils_1.existsInArray)(activeItems, value);
                            if (this.config.maxItemCount > 0 && this.config.maxItemCount <= activeItems.length) {
                                // If there is a max entry limit and we have reached that limit
                                // don't update
                                canAddItem = false;
                                notice = typeof this.config.maxItemText === "function" ? this.config.maxItemText(this.config.maxItemCount) : this.config.maxItemText;
                            }
                            if (!this.config.duplicateItemsAllowed && isDuplicateValue && canAddItem) {
                                canAddItem = false;
                                notice = typeof this.config.uniqueItemText === "function" ? this.config.uniqueItemText(value) : this.config.uniqueItemText;
                            }
                            if (this._isTextElement && this.config.addItems && canAddItem && typeof this.config.addItemFilter === "function" && !this.config.addItemFilter(value)) {
                                canAddItem = false;
                                notice = typeof this.config.customAddItemText === "function" ? this.config.customAddItemText(value) : this.config.customAddItemText;
                            }
                        }
                        return {
                            response: canAddItem,
                            notice: notice
                        };
                    };
                    Choices.prototype._searchChoices = function(value) {
                        var newValue = typeof value === "string" ? value.trim() : value;
                        var currentValue = typeof this._currentValue === "string" ? this._currentValue.trim() : this._currentValue;
                        if (newValue.length < 1 && newValue === "".concat(currentValue, " ")) return 0;
                        // If new value matches the desired length and is not the same as the current value with a space
                        var haystack = this._store.searchableChoices;
                        var needle = newValue;
                        var options = Object.assign(this.config.fuseOptions, {
                            keys: __spreadArray([], this.config.searchFields, true),
                            includeMatches: true
                        });
                        var fuse = new fuse_js_1.default(haystack, options);
                        var results = fuse.search(needle); // see https://github.com/krisk/Fuse/issues/303
                        this._currentValue = newValue;
                        this._highlightPosition = 0;
                        this._isSearching = true;
                        this._store.dispatch((0, choices_1.filterChoices)(results));
                        return results.length;
                    };
                    Choices.prototype._addEventListeners = function() {
                        var documentElement = document.documentElement;
                        // capture events - can cancel event processing or propagation
                        documentElement.addEventListener("touchend", this._onTouchEnd, true);
                        this.containerOuter.element.addEventListener("keydown", this._onKeyDown, true);
                        this.containerOuter.element.addEventListener("mousedown", this._onMouseDown, true);
                        // passive events - doesn't call `preventDefault` or `stopPropagation`
                        documentElement.addEventListener("click", this._onClick, {
                            passive: true
                        });
                        documentElement.addEventListener("touchmove", this._onTouchMove, {
                            passive: true
                        });
                        this.dropdown.element.addEventListener("mouseover", this._onMouseOver, {
                            passive: true
                        });
                        if (this._isSelectOneElement) {
                            this.containerOuter.element.addEventListener("focus", this._onFocus, {
                                passive: true
                            });
                            this.containerOuter.element.addEventListener("blur", this._onBlur, {
                                passive: true
                            });
                        }
                        this.input.element.addEventListener("keyup", this._onKeyUp, {
                            passive: true
                        });
                        this.input.element.addEventListener("focus", this._onFocus, {
                            passive: true
                        });
                        this.input.element.addEventListener("blur", this._onBlur, {
                            passive: true
                        });
                        if (this.input.element.form) this.input.element.form.addEventListener("reset", this._onFormReset, {
                            passive: true
                        });
                        this.input.addEventListeners();
                    };
                    Choices.prototype._removeEventListeners = function() {
                        var documentElement = document.documentElement;
                        documentElement.removeEventListener("touchend", this._onTouchEnd, true);
                        this.containerOuter.element.removeEventListener("keydown", this._onKeyDown, true);
                        this.containerOuter.element.removeEventListener("mousedown", this._onMouseDown, true);
                        documentElement.removeEventListener("click", this._onClick);
                        documentElement.removeEventListener("touchmove", this._onTouchMove);
                        this.dropdown.element.removeEventListener("mouseover", this._onMouseOver);
                        if (this._isSelectOneElement) {
                            this.containerOuter.element.removeEventListener("focus", this._onFocus);
                            this.containerOuter.element.removeEventListener("blur", this._onBlur);
                        }
                        this.input.element.removeEventListener("keyup", this._onKeyUp);
                        this.input.element.removeEventListener("focus", this._onFocus);
                        this.input.element.removeEventListener("blur", this._onBlur);
                        if (this.input.element.form) this.input.element.form.removeEventListener("reset", this._onFormReset);
                        this.input.removeEventListeners();
                    };
                    Choices.prototype._onKeyDown = function(event) {
                        var keyCode = event.keyCode;
                        var activeItems = this._store.activeItems;
                        var hasFocusedInput = this.input.isFocussed;
                        var hasActiveDropdown = this.dropdown.isActive;
                        var hasItems = this.itemList.hasChildren();
                        var keyString = String.fromCharCode(keyCode);
                        // eslint-disable-next-line no-control-regex
                        var wasPrintableChar = /[^\x00-\x1F]/.test(keyString);
                        var BACK_KEY = constants_1.KEY_CODES.BACK_KEY, DELETE_KEY = constants_1.KEY_CODES.DELETE_KEY, ENTER_KEY = constants_1.KEY_CODES.ENTER_KEY, A_KEY = constants_1.KEY_CODES.A_KEY, ESC_KEY = constants_1.KEY_CODES.ESC_KEY, UP_KEY = constants_1.KEY_CODES.UP_KEY, DOWN_KEY = constants_1.KEY_CODES.DOWN_KEY, PAGE_UP_KEY = constants_1.KEY_CODES.PAGE_UP_KEY, PAGE_DOWN_KEY = constants_1.KEY_CODES.PAGE_DOWN_KEY;
                        if (!this._isTextElement && !hasActiveDropdown && wasPrintableChar) {
                            this.showDropdown();
                            if (!this.input.isFocussed) /*
          We update the input value with the pressed key as
          the input was not focussed at the time of key press
          therefore does not have the value of the key.
        */ this.input.value += event.key.toLowerCase();
                        }
                        switch(keyCode){
                            case A_KEY:
                                return this._onSelectKey(event, hasItems);
                            case ENTER_KEY:
                                return this._onEnterKey(event, activeItems, hasActiveDropdown);
                            case ESC_KEY:
                                return this._onEscapeKey(hasActiveDropdown);
                            case UP_KEY:
                            case PAGE_UP_KEY:
                            case DOWN_KEY:
                            case PAGE_DOWN_KEY:
                                return this._onDirectionKey(event, hasActiveDropdown);
                            case DELETE_KEY:
                            case BACK_KEY:
                                return this._onDeleteKey(event, activeItems, hasFocusedInput);
                            default:
                        }
                    };
                    Choices.prototype._onKeyUp = function(_a) {
                        var target = _a.target, keyCode = _a.keyCode;
                        var value = this.input.value;
                        var activeItems = this._store.activeItems;
                        var canAddItem = this._canAddItem(activeItems, value);
                        var backKey = constants_1.KEY_CODES.BACK_KEY, deleteKey = constants_1.KEY_CODES.DELETE_KEY;
                        // We are typing into a text input and have a value, we want to show a dropdown
                        // notice. Otherwise hide the dropdown
                        if (this._isTextElement) {
                            var canShowDropdownNotice = canAddItem.notice && value;
                            if (canShowDropdownNotice) {
                                var dropdownItem = this._getTemplate("notice", canAddItem.notice);
                                this.dropdown.element.innerHTML = dropdownItem.outerHTML;
                                this.showDropdown(true);
                            } else this.hideDropdown(true);
                        } else {
                            var wasRemovalKeyCode = keyCode === backKey || keyCode === deleteKey;
                            var userHasRemovedValue = wasRemovalKeyCode && target && !target.value;
                            var canReactivateChoices = !this._isTextElement && this._isSearching;
                            var canSearch = this._canSearch && canAddItem.response;
                            if (userHasRemovedValue && canReactivateChoices) {
                                this._isSearching = false;
                                this._store.dispatch((0, choices_1.activateChoices)(true));
                            } else if (canSearch) this._handleSearch(this.input.rawValue);
                        }
                        this._canSearch = this.config.searchEnabled;
                    };
                    Choices.prototype._onSelectKey = function(event, hasItems) {
                        var ctrlKey = event.ctrlKey, metaKey = event.metaKey;
                        var hasCtrlDownKeyPressed = ctrlKey || metaKey;
                        // If CTRL + A or CMD + A have been pressed and there are items to select
                        if (hasCtrlDownKeyPressed && hasItems) {
                            this._canSearch = false;
                            var shouldHightlightAll = this.config.removeItems && !this.input.value && this.input.element === document.activeElement;
                            if (shouldHightlightAll) this.highlightAll();
                        }
                    };
                    Choices.prototype._onEnterKey = function(event, activeItems, hasActiveDropdown) {
                        var target = event.target;
                        var enterKey = constants_1.KEY_CODES.ENTER_KEY;
                        var targetWasButton = target && target.hasAttribute("data-button");
                        if (this._isTextElement && target && target.value) {
                            var value = this.input.value;
                            var canAddItem = this._canAddItem(activeItems, value);
                            if (canAddItem.response) {
                                this.hideDropdown(true);
                                this._addItem({
                                    value: value
                                });
                                this._triggerChange(value);
                                this.clearInput();
                            }
                        }
                        if (targetWasButton) {
                            this._handleButtonAction(activeItems, target);
                            event.preventDefault();
                        }
                        if (hasActiveDropdown) {
                            var highlightedChoice = this.dropdown.getChild(".".concat(this.config.classNames.highlightedState));
                            if (highlightedChoice) {
                                // add enter keyCode value
                                if (activeItems[0]) activeItems[0].keyCode = enterKey; // eslint-disable-line no-param-reassign
                                this._handleChoiceAction(activeItems, highlightedChoice);
                            }
                            event.preventDefault();
                        } else if (this._isSelectOneElement) {
                            this.showDropdown();
                            event.preventDefault();
                        }
                    };
                    Choices.prototype._onEscapeKey = function(hasActiveDropdown) {
                        if (hasActiveDropdown) {
                            this.hideDropdown(true);
                            this.containerOuter.focus();
                        }
                    };
                    Choices.prototype._onDirectionKey = function(event, hasActiveDropdown) {
                        var keyCode = event.keyCode, metaKey = event.metaKey;
                        var downKey = constants_1.KEY_CODES.DOWN_KEY, pageUpKey = constants_1.KEY_CODES.PAGE_UP_KEY, pageDownKey = constants_1.KEY_CODES.PAGE_DOWN_KEY;
                        // If up or down key is pressed, traverse through options
                        if (hasActiveDropdown || this._isSelectOneElement) {
                            this.showDropdown();
                            this._canSearch = false;
                            var directionInt = keyCode === downKey || keyCode === pageDownKey ? 1 : -1;
                            var skipKey = metaKey || keyCode === pageDownKey || keyCode === pageUpKey;
                            var selectableChoiceIdentifier = "[data-choice-selectable]";
                            var nextEl = void 0;
                            if (skipKey) {
                                if (directionInt > 0) nextEl = this.dropdown.element.querySelector("".concat(selectableChoiceIdentifier, ":last-of-type"));
                                else nextEl = this.dropdown.element.querySelector(selectableChoiceIdentifier);
                            } else {
                                var currentEl = this.dropdown.element.querySelector(".".concat(this.config.classNames.highlightedState));
                                if (currentEl) nextEl = (0, utils_1.getAdjacentEl)(currentEl, selectableChoiceIdentifier, directionInt);
                                else nextEl = this.dropdown.element.querySelector(selectableChoiceIdentifier);
                            }
                            if (nextEl) {
                                // We prevent default to stop the cursor moving
                                // when pressing the arrow
                                if (!(0, utils_1.isScrolledIntoView)(nextEl, this.choiceList.element, directionInt)) this.choiceList.scrollToChildElement(nextEl, directionInt);
                                this._highlightChoice(nextEl);
                            }
                            // Prevent default to maintain cursor position whilst
                            // traversing dropdown options
                            event.preventDefault();
                        }
                    };
                    Choices.prototype._onDeleteKey = function(event, activeItems, hasFocusedInput) {
                        var target = event.target;
                        // If backspace or delete key is pressed and the input has no value
                        if (!this._isSelectOneElement && !target.value && hasFocusedInput) {
                            this._handleBackspace(activeItems);
                            event.preventDefault();
                        }
                    };
                    Choices.prototype._onTouchMove = function() {
                        if (this._wasTap) this._wasTap = false;
                    };
                    Choices.prototype._onTouchEnd = function(event) {
                        var target = (event || event.touches[0]).target;
                        var touchWasWithinContainer = this._wasTap && this.containerOuter.element.contains(target);
                        if (touchWasWithinContainer) {
                            var containerWasExactTarget = target === this.containerOuter.element || target === this.containerInner.element;
                            if (containerWasExactTarget) {
                                if (this._isTextElement) this.input.focus();
                                else if (this._isSelectMultipleElement) this.showDropdown();
                            }
                            // Prevents focus event firing
                            event.stopPropagation();
                        }
                        this._wasTap = true;
                    };
                    /**
   * Handles mousedown event in capture mode for containetOuter.element
   */ Choices.prototype._onMouseDown = function(event) {
                        var target = event.target;
                        if (!(target instanceof HTMLElement)) return;
                        // If we have our mouse down on the scrollbar and are on IE11...
                        if (IS_IE11 && this.choiceList.element.contains(target)) {
                            // check if click was on a scrollbar area
                            var firstChoice = this.choiceList.element.firstElementChild;
                            var isOnScrollbar = this._direction === "ltr" ? event.offsetX >= firstChoice.offsetWidth : event.offsetX < firstChoice.offsetLeft;
                            this._isScrollingOnIe = isOnScrollbar;
                        }
                        if (target === this.input.element) return;
                        var item = target.closest("[data-button],[data-item],[data-choice]");
                        if (item instanceof HTMLElement) {
                            var hasShiftKey = event.shiftKey;
                            var activeItems = this._store.activeItems;
                            var dataset = item.dataset;
                            if ("button" in dataset) this._handleButtonAction(activeItems, item);
                            else if ("item" in dataset) this._handleItemAction(activeItems, item, hasShiftKey);
                            else if ("choice" in dataset) this._handleChoiceAction(activeItems, item);
                        }
                        event.preventDefault();
                    };
                    /**
   * Handles mouseover event over this.dropdown
   * @param {MouseEvent} event
   */ Choices.prototype._onMouseOver = function(_a) {
                        var target = _a.target;
                        if (target instanceof HTMLElement && "choice" in target.dataset) this._highlightChoice(target);
                    };
                    Choices.prototype._onClick = function(_a) {
                        var target = _a.target;
                        var clickWasWithinContainer = this.containerOuter.element.contains(target);
                        if (clickWasWithinContainer) {
                            if (!this.dropdown.isActive && !this.containerOuter.isDisabled) {
                                if (this._isTextElement) {
                                    if (document.activeElement !== this.input.element) this.input.focus();
                                } else {
                                    this.showDropdown();
                                    this.containerOuter.focus();
                                }
                            } else if (this._isSelectOneElement && target !== this.input.element && !this.dropdown.element.contains(target)) this.hideDropdown();
                        } else {
                            var hasHighlightedItems = this._store.highlightedActiveItems.length > 0;
                            if (hasHighlightedItems) this.unhighlightAll();
                            this.containerOuter.removeFocusState();
                            this.hideDropdown(true);
                        }
                    };
                    Choices.prototype._onFocus = function(_a) {
                        var _b;
                        var _this = this;
                        var target = _a.target;
                        var focusWasWithinContainer = target && this.containerOuter.element.contains(target);
                        if (!focusWasWithinContainer) return;
                        var focusActions = (_b = {}, _b[constants_1.TEXT_TYPE] = function() {
                            if (target === _this.input.element) _this.containerOuter.addFocusState();
                        }, _b[constants_1.SELECT_ONE_TYPE] = function() {
                            _this.containerOuter.addFocusState();
                            if (target === _this.input.element) _this.showDropdown(true);
                        }, _b[constants_1.SELECT_MULTIPLE_TYPE] = function() {
                            if (target === _this.input.element) {
                                _this.showDropdown(true);
                                // If element is a select box, the focused element is the container and the dropdown
                                // isn't already open, focus and show dropdown
                                _this.containerOuter.addFocusState();
                            }
                        }, _b);
                        focusActions[this.passedElement.element.type]();
                    };
                    Choices.prototype._onBlur = function(_a) {
                        var _b;
                        var _this = this;
                        var target = _a.target;
                        var blurWasWithinContainer = target && this.containerOuter.element.contains(target);
                        if (blurWasWithinContainer && !this._isScrollingOnIe) {
                            var activeItems = this._store.activeItems;
                            var hasHighlightedItems_1 = activeItems.some(function(item) {
                                return item.highlighted;
                            });
                            var blurActions = (_b = {}, _b[constants_1.TEXT_TYPE] = function() {
                                if (target === _this.input.element) {
                                    _this.containerOuter.removeFocusState();
                                    if (hasHighlightedItems_1) _this.unhighlightAll();
                                    _this.hideDropdown(true);
                                }
                            }, _b[constants_1.SELECT_ONE_TYPE] = function() {
                                _this.containerOuter.removeFocusState();
                                if (target === _this.input.element || target === _this.containerOuter.element && !_this._canSearch) _this.hideDropdown(true);
                            }, _b[constants_1.SELECT_MULTIPLE_TYPE] = function() {
                                if (target === _this.input.element) {
                                    _this.containerOuter.removeFocusState();
                                    _this.hideDropdown(true);
                                    if (hasHighlightedItems_1) _this.unhighlightAll();
                                }
                            }, _b);
                            blurActions[this.passedElement.element.type]();
                        } else {
                            // On IE11, clicking the scollbar blurs our input and thus
                            // closes the dropdown. To stop this, we refocus our input
                            // if we know we are on IE *and* are scrolling.
                            this._isScrollingOnIe = false;
                            this.input.element.focus();
                        }
                    };
                    Choices.prototype._onFormReset = function() {
                        this._store.dispatch((0, misc_1.resetTo)(this._initialState));
                    };
                    Choices.prototype._highlightChoice = function(el) {
                        var _this = this;
                        if (el === void 0) el = null;
                        var choices = Array.from(this.dropdown.element.querySelectorAll("[data-choice-selectable]"));
                        if (!choices.length) return;
                        var passedEl = el;
                        var highlightedChoices = Array.from(this.dropdown.element.querySelectorAll(".".concat(this.config.classNames.highlightedState)));
                        // Remove any highlighted choices
                        highlightedChoices.forEach(function(choice) {
                            choice.classList.remove(_this.config.classNames.highlightedState);
                            choice.setAttribute("aria-selected", "false");
                        });
                        if (passedEl) this._highlightPosition = choices.indexOf(passedEl);
                        else {
                            // Highlight choice based on last known highlight location
                            if (choices.length > this._highlightPosition) // If we have an option to highlight
                            passedEl = choices[this._highlightPosition];
                            else // Otherwise highlight the option before
                            passedEl = choices[choices.length - 1];
                            if (!passedEl) passedEl = choices[0];
                        }
                        passedEl.classList.add(this.config.classNames.highlightedState);
                        passedEl.setAttribute("aria-selected", "true");
                        this.passedElement.triggerEvent(constants_1.EVENTS.highlightChoice, {
                            el: passedEl
                        });
                        if (this.dropdown.isActive) {
                            // IE11 ignores aria-label and blocks virtual keyboard
                            // if aria-activedescendant is set without a dropdown
                            this.input.setActiveDescendant(passedEl.id);
                            this.containerOuter.setActiveDescendant(passedEl.id);
                        }
                    };
                    Choices.prototype._addItem = function(_a) {
                        var value = _a.value, _b = _a.label, label = _b === void 0 ? null : _b, _c = _a.choiceId, choiceId = _c === void 0 ? -1 : _c, _d = _a.groupId, groupId = _d === void 0 ? -1 : _d, _e = _a.customProperties, customProperties = _e === void 0 ? {} : _e, _f = _a.placeholder, placeholder = _f === void 0 ? false : _f, _g = _a.keyCode, keyCode = _g === void 0 ? -1 : _g;
                        var passedValue = typeof value === "string" ? value.trim() : value;
                        var items = this._store.items;
                        var passedLabel = label || passedValue;
                        var passedOptionId = choiceId || -1;
                        var group = groupId >= 0 ? this._store.getGroupById(groupId) : null;
                        var id = items ? items.length + 1 : 1;
                        // If a prepended value has been passed, prepend it
                        if (this.config.prependValue) passedValue = this.config.prependValue + passedValue.toString();
                        // If an appended value has been passed, append it
                        if (this.config.appendValue) passedValue += this.config.appendValue.toString();
                        this._store.dispatch((0, items_1.addItem)({
                            value: passedValue,
                            label: passedLabel,
                            id: id,
                            choiceId: passedOptionId,
                            groupId: groupId,
                            customProperties: customProperties,
                            placeholder: placeholder,
                            keyCode: keyCode
                        }));
                        if (this._isSelectOneElement) this.removeActiveItems(id);
                        // Trigger change event
                        this.passedElement.triggerEvent(constants_1.EVENTS.addItem, {
                            id: id,
                            value: passedValue,
                            label: passedLabel,
                            customProperties: customProperties,
                            groupValue: group && group.value ? group.value : null,
                            keyCode: keyCode
                        });
                    };
                    Choices.prototype._removeItem = function(item) {
                        var id = item.id, value = item.value, label = item.label, customProperties = item.customProperties, choiceId = item.choiceId, groupId = item.groupId;
                        var group = groupId && groupId >= 0 ? this._store.getGroupById(groupId) : null;
                        if (!id || !choiceId) return;
                        this._store.dispatch((0, items_1.removeItem)(id, choiceId));
                        this.passedElement.triggerEvent(constants_1.EVENTS.removeItem, {
                            id: id,
                            value: value,
                            label: label,
                            customProperties: customProperties,
                            groupValue: group && group.value ? group.value : null
                        });
                    };
                    Choices.prototype._addChoice = function(_a) {
                        var value = _a.value, _b = _a.label, label = _b === void 0 ? null : _b, _c = _a.isSelected, isSelected = _c === void 0 ? false : _c, _d = _a.isDisabled, isDisabled = _d === void 0 ? false : _d, _e = _a.groupId, groupId = _e === void 0 ? -1 : _e, _f = _a.customProperties, customProperties = _f === void 0 ? {} : _f, _g = _a.placeholder, placeholder = _g === void 0 ? false : _g, _h = _a.keyCode, keyCode = _h === void 0 ? -1 : _h;
                        if (typeof value === "undefined" || value === null) return;
                        // Generate unique id
                        var choices = this._store.choices;
                        var choiceLabel = label || value;
                        var choiceId = choices ? choices.length + 1 : 1;
                        var choiceElementId = "".concat(this._baseId, "-").concat(this._idNames.itemChoice, "-").concat(choiceId);
                        this._store.dispatch((0, choices_1.addChoice)({
                            id: choiceId,
                            groupId: groupId,
                            elementId: choiceElementId,
                            value: value,
                            label: choiceLabel,
                            disabled: isDisabled,
                            customProperties: customProperties,
                            placeholder: placeholder,
                            keyCode: keyCode
                        }));
                        if (isSelected) this._addItem({
                            value: value,
                            label: choiceLabel,
                            choiceId: choiceId,
                            customProperties: customProperties,
                            placeholder: placeholder,
                            keyCode: keyCode
                        });
                    };
                    Choices.prototype._addGroup = function(_a) {
                        var _this = this;
                        var group = _a.group, id = _a.id, _b = _a.valueKey, valueKey = _b === void 0 ? "value" : _b, _c = _a.labelKey, labelKey = _c === void 0 ? "label" : _c;
                        var groupChoices = (0, utils_1.isType)("Object", group) ? group.choices : Array.from(group.getElementsByTagName("OPTION"));
                        var groupId = id || Math.floor(new Date().valueOf() * Math.random());
                        var isDisabled = group.disabled ? group.disabled : false;
                        if (groupChoices) {
                            this._store.dispatch((0, groups_1.addGroup)({
                                value: group.label,
                                id: groupId,
                                active: true,
                                disabled: isDisabled
                            }));
                            var addGroupChoices = function(choice) {
                                var isOptDisabled = choice.disabled || choice.parentNode && choice.parentNode.disabled;
                                _this._addChoice({
                                    value: choice[valueKey],
                                    label: (0, utils_1.isType)("Object", choice) ? choice[labelKey] : choice.innerHTML,
                                    isSelected: choice.selected,
                                    isDisabled: isOptDisabled,
                                    groupId: groupId,
                                    customProperties: choice.customProperties,
                                    placeholder: choice.placeholder
                                });
                            };
                            groupChoices.forEach(addGroupChoices);
                        } else this._store.dispatch((0, groups_1.addGroup)({
                            value: group.label,
                            id: group.id,
                            active: false,
                            disabled: group.disabled
                        }));
                    };
                    Choices.prototype._getTemplate = function(template) {
                        var _a;
                        var args = [];
                        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
                        return (_a = this._templates[template]).call.apply(_a, __spreadArray([
                            this,
                            this.config
                        ], args, false));
                    };
                    Choices.prototype._createTemplates = function() {
                        var callbackOnCreateTemplates = this.config.callbackOnCreateTemplates;
                        var userTemplates = {};
                        if (callbackOnCreateTemplates && typeof callbackOnCreateTemplates === "function") userTemplates = callbackOnCreateTemplates.call(this, utils_1.strToEl);
                        this._templates = (0, deepmerge_1.default)(templates_1.default, userTemplates);
                    };
                    Choices.prototype._createElements = function() {
                        this.containerOuter = new components_1.Container({
                            element: this._getTemplate("containerOuter", this._direction, this._isSelectElement, this._isSelectOneElement, this.config.searchEnabled, this.passedElement.element.type, this.config.labelId),
                            classNames: this.config.classNames,
                            type: this.passedElement.element.type,
                            position: this.config.position
                        });
                        this.containerInner = new components_1.Container({
                            element: this._getTemplate("containerInner"),
                            classNames: this.config.classNames,
                            type: this.passedElement.element.type,
                            position: this.config.position
                        });
                        this.input = new components_1.Input({
                            element: this._getTemplate("input", this._placeholderValue),
                            classNames: this.config.classNames,
                            type: this.passedElement.element.type,
                            preventPaste: !this.config.paste
                        });
                        this.choiceList = new components_1.List({
                            element: this._getTemplate("choiceList", this._isSelectOneElement)
                        });
                        this.itemList = new components_1.List({
                            element: this._getTemplate("itemList", this._isSelectOneElement)
                        });
                        this.dropdown = new components_1.Dropdown({
                            element: this._getTemplate("dropdown"),
                            classNames: this.config.classNames,
                            type: this.passedElement.element.type
                        });
                    };
                    Choices.prototype._createStructure = function() {
                        // Hide original element
                        this.passedElement.conceal();
                        // Wrap input in container preserving DOM ordering
                        this.containerInner.wrap(this.passedElement.element);
                        // Wrapper inner container with outer container
                        this.containerOuter.wrap(this.containerInner.element);
                        if (this._isSelectOneElement) this.input.placeholder = this.config.searchPlaceholderValue || "";
                        else if (this._placeholderValue) {
                            this.input.placeholder = this._placeholderValue;
                            this.input.setWidth();
                        }
                        this.containerOuter.element.appendChild(this.containerInner.element);
                        this.containerOuter.element.appendChild(this.dropdown.element);
                        this.containerInner.element.appendChild(this.itemList.element);
                        if (!this._isTextElement) this.dropdown.element.appendChild(this.choiceList.element);
                        if (!this._isSelectOneElement) this.containerInner.element.appendChild(this.input.element);
                        else if (this.config.searchEnabled) this.dropdown.element.insertBefore(this.input.element, this.dropdown.element.firstChild);
                        if (this._isSelectElement) {
                            this._highlightPosition = 0;
                            this._isSearching = false;
                            this._startLoading();
                            if (this._presetGroups.length) this._addPredefinedGroups(this._presetGroups);
                            else this._addPredefinedChoices(this._presetChoices);
                            this._stopLoading();
                        }
                        if (this._isTextElement) this._addPredefinedItems(this._presetItems);
                    };
                    Choices.prototype._addPredefinedGroups = function(groups) {
                        var _this = this;
                        // If we have a placeholder option
                        var placeholderChoice = this.passedElement.placeholderOption;
                        if (placeholderChoice && placeholderChoice.parentNode && placeholderChoice.parentNode.tagName === "SELECT") this._addChoice({
                            value: placeholderChoice.value,
                            label: placeholderChoice.innerHTML,
                            isSelected: placeholderChoice.selected,
                            isDisabled: placeholderChoice.disabled,
                            placeholder: true
                        });
                        groups.forEach(function(group) {
                            return _this._addGroup({
                                group: group,
                                id: group.id || null
                            });
                        });
                    };
                    Choices.prototype._addPredefinedChoices = function(choices) {
                        var _this = this;
                        // If sorting is enabled or the user is searching, filter choices
                        if (this.config.shouldSort) choices.sort(this.config.sorter);
                        var hasSelectedChoice = choices.some(function(choice) {
                            return choice.selected;
                        });
                        var firstEnabledChoiceIndex = choices.findIndex(function(choice) {
                            return choice.disabled === undefined || !choice.disabled;
                        });
                        choices.forEach(function(choice, index) {
                            var _a = choice.value, value = _a === void 0 ? "" : _a, label = choice.label, customProperties = choice.customProperties, placeholder = choice.placeholder;
                            if (_this._isSelectElement) {
                                // If the choice is actually a group
                                if (choice.choices) _this._addGroup({
                                    group: choice,
                                    id: choice.id || null
                                });
                                else {
                                    /**
           * If there is a selected choice already or the choice is not the first in
           * the array, add each choice normally.
           *
           * Otherwise we pre-select the first enabled choice in the array ("select-one" only)
           */ var shouldPreselect = _this._isSelectOneElement && !hasSelectedChoice && index === firstEnabledChoiceIndex;
                                    var isSelected = shouldPreselect ? true : choice.selected;
                                    var isDisabled = choice.disabled;
                                    _this._addChoice({
                                        value: value,
                                        label: label,
                                        isSelected: !!isSelected,
                                        isDisabled: !!isDisabled,
                                        placeholder: !!placeholder,
                                        customProperties: customProperties
                                    });
                                }
                            } else _this._addChoice({
                                value: value,
                                label: label,
                                isSelected: !!choice.selected,
                                isDisabled: !!choice.disabled,
                                placeholder: !!choice.placeholder,
                                customProperties: customProperties
                            });
                        });
                    };
                    Choices.prototype._addPredefinedItems = function(items) {
                        var _this = this;
                        items.forEach(function(item) {
                            if (typeof item === "object" && item.value) _this._addItem({
                                value: item.value,
                                label: item.label,
                                choiceId: item.id,
                                customProperties: item.customProperties,
                                placeholder: item.placeholder
                            });
                            if (typeof item === "string") _this._addItem({
                                value: item
                            });
                        });
                    };
                    Choices.prototype._setChoiceOrItem = function(item) {
                        var _this = this;
                        var itemType = (0, utils_1.getType)(item).toLowerCase();
                        var handleType = {
                            object: function() {
                                if (!item.value) return;
                                // If we are dealing with a select input, we need to create an option first
                                // that is then selected. For text inputs we can just add items normally.
                                if (!_this._isTextElement) _this._addChoice({
                                    value: item.value,
                                    label: item.label,
                                    isSelected: true,
                                    isDisabled: false,
                                    customProperties: item.customProperties,
                                    placeholder: item.placeholder
                                });
                                else _this._addItem({
                                    value: item.value,
                                    label: item.label,
                                    choiceId: item.id,
                                    customProperties: item.customProperties,
                                    placeholder: item.placeholder
                                });
                            },
                            string: function() {
                                if (!_this._isTextElement) _this._addChoice({
                                    value: item,
                                    label: item,
                                    isSelected: true,
                                    isDisabled: false
                                });
                                else _this._addItem({
                                    value: item
                                });
                            }
                        };
                        handleType[itemType]();
                    };
                    Choices.prototype._findAndSelectChoiceByValue = function(value) {
                        var _this = this;
                        var choices = this._store.choices;
                        // Check 'value' property exists and the choice isn't already selected
                        var foundChoice = choices.find(function(choice) {
                            return _this.config.valueComparer(choice.value, value);
                        });
                        if (foundChoice && !foundChoice.selected) this._addItem({
                            value: foundChoice.value,
                            label: foundChoice.label,
                            choiceId: foundChoice.id,
                            groupId: foundChoice.groupId,
                            customProperties: foundChoice.customProperties,
                            placeholder: foundChoice.placeholder,
                            keyCode: foundChoice.keyCode
                        });
                    };
                    Choices.prototype._generatePlaceholderValue = function() {
                        if (this._isSelectElement && this.passedElement.placeholderOption) {
                            var placeholderOption = this.passedElement.placeholderOption;
                            return placeholderOption ? placeholderOption.text : null;
                        }
                        var _a = this.config, placeholder = _a.placeholder, placeholderValue = _a.placeholderValue;
                        var dataset = this.passedElement.element.dataset;
                        if (placeholder) {
                            if (placeholderValue) return placeholderValue;
                            if (dataset.placeholder) return dataset.placeholder;
                        }
                        return null;
                    };
                    return Choices;
                }();
                exports["default"] = Choices;
            /***/ },
            /***/ 613: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var utils_1 = __webpack_require__(799);
                var constants_1 = __webpack_require__(883);
                var Container = /** @class */ function() {
                    function Container(_a) {
                        var element = _a.element, type = _a.type, classNames = _a.classNames, position = _a.position;
                        this.element = element;
                        this.classNames = classNames;
                        this.type = type;
                        this.position = position;
                        this.isOpen = false;
                        this.isFlipped = false;
                        this.isFocussed = false;
                        this.isDisabled = false;
                        this.isLoading = false;
                        this._onFocus = this._onFocus.bind(this);
                        this._onBlur = this._onBlur.bind(this);
                    }
                    Container.prototype.addEventListeners = function() {
                        this.element.addEventListener("focus", this._onFocus);
                        this.element.addEventListener("blur", this._onBlur);
                    };
                    Container.prototype.removeEventListeners = function() {
                        this.element.removeEventListener("focus", this._onFocus);
                        this.element.removeEventListener("blur", this._onBlur);
                    };
                    /**
   * Determine whether container should be flipped based on passed
   * dropdown position
   */ Container.prototype.shouldFlip = function(dropdownPos) {
                        if (typeof dropdownPos !== "number") return false;
                        // If flip is enabled and the dropdown bottom position is
                        // greater than the window height flip the dropdown.
                        var shouldFlip = false;
                        if (this.position === "auto") shouldFlip = !window.matchMedia("(min-height: ".concat(dropdownPos + 1, "px)")).matches;
                        else if (this.position === "top") shouldFlip = true;
                        return shouldFlip;
                    };
                    Container.prototype.setActiveDescendant = function(activeDescendantID) {
                        this.element.setAttribute("aria-activedescendant", activeDescendantID);
                    };
                    Container.prototype.removeActiveDescendant = function() {
                        this.element.removeAttribute("aria-activedescendant");
                    };
                    Container.prototype.open = function(dropdownPos) {
                        this.element.classList.add(this.classNames.openState);
                        this.element.setAttribute("aria-expanded", "true");
                        this.isOpen = true;
                        if (this.shouldFlip(dropdownPos)) {
                            this.element.classList.add(this.classNames.flippedState);
                            this.isFlipped = true;
                        }
                    };
                    Container.prototype.close = function() {
                        this.element.classList.remove(this.classNames.openState);
                        this.element.setAttribute("aria-expanded", "false");
                        this.removeActiveDescendant();
                        this.isOpen = false;
                        // A dropdown flips if it does not have space within the page
                        if (this.isFlipped) {
                            this.element.classList.remove(this.classNames.flippedState);
                            this.isFlipped = false;
                        }
                    };
                    Container.prototype.focus = function() {
                        if (!this.isFocussed) this.element.focus();
                    };
                    Container.prototype.addFocusState = function() {
                        this.element.classList.add(this.classNames.focusState);
                    };
                    Container.prototype.removeFocusState = function() {
                        this.element.classList.remove(this.classNames.focusState);
                    };
                    Container.prototype.enable = function() {
                        this.element.classList.remove(this.classNames.disabledState);
                        this.element.removeAttribute("aria-disabled");
                        if (this.type === constants_1.SELECT_ONE_TYPE) this.element.setAttribute("tabindex", "0");
                        this.isDisabled = false;
                    };
                    Container.prototype.disable = function() {
                        this.element.classList.add(this.classNames.disabledState);
                        this.element.setAttribute("aria-disabled", "true");
                        if (this.type === constants_1.SELECT_ONE_TYPE) this.element.setAttribute("tabindex", "-1");
                        this.isDisabled = true;
                    };
                    Container.prototype.wrap = function(element) {
                        (0, utils_1.wrap)(element, this.element);
                    };
                    Container.prototype.unwrap = function(element) {
                        if (this.element.parentNode) {
                            // Move passed element outside this element
                            this.element.parentNode.insertBefore(element, this.element);
                            // Remove this element
                            this.element.parentNode.removeChild(this.element);
                        }
                    };
                    Container.prototype.addLoadingState = function() {
                        this.element.classList.add(this.classNames.loadingState);
                        this.element.setAttribute("aria-busy", "true");
                        this.isLoading = true;
                    };
                    Container.prototype.removeLoadingState = function() {
                        this.element.classList.remove(this.classNames.loadingState);
                        this.element.removeAttribute("aria-busy");
                        this.isLoading = false;
                    };
                    Container.prototype._onFocus = function() {
                        this.isFocussed = true;
                    };
                    Container.prototype._onBlur = function() {
                        this.isFocussed = false;
                    };
                    return Container;
                }();
                exports["default"] = Container;
            /***/ },
            /***/ 217: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var Dropdown = /** @class */ function() {
                    function Dropdown(_a) {
                        var element = _a.element, type = _a.type, classNames = _a.classNames;
                        this.element = element;
                        this.classNames = classNames;
                        this.type = type;
                        this.isActive = false;
                    }
                    Object.defineProperty(Dropdown.prototype, "distanceFromTopWindow", {
                        /**
     * Bottom position of dropdown in viewport coordinates
     */ get: function() {
                            return this.element.getBoundingClientRect().bottom;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Dropdown.prototype.getChild = function(selector) {
                        return this.element.querySelector(selector);
                    };
                    /**
   * Show dropdown to user by adding active state class
   */ Dropdown.prototype.show = function() {
                        this.element.classList.add(this.classNames.activeState);
                        this.element.setAttribute("aria-expanded", "true");
                        this.isActive = true;
                        return this;
                    };
                    /**
   * Hide dropdown from user
   */ Dropdown.prototype.hide = function() {
                        this.element.classList.remove(this.classNames.activeState);
                        this.element.setAttribute("aria-expanded", "false");
                        this.isActive = false;
                        return this;
                    };
                    return Dropdown;
                }();
                exports["default"] = Dropdown;
            /***/ },
            /***/ 520: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.WrappedSelect = exports.WrappedInput = exports.List = exports.Input = exports.Container = exports.Dropdown = void 0;
                var dropdown_1 = __importDefault(__webpack_require__(217));
                exports.Dropdown = dropdown_1.default;
                var container_1 = __importDefault(__webpack_require__(613));
                exports.Container = container_1.default;
                var input_1 = __importDefault(__webpack_require__(11));
                exports.Input = input_1.default;
                var list_1 = __importDefault(__webpack_require__(624));
                exports.List = list_1.default;
                var wrapped_input_1 = __importDefault(__webpack_require__(541));
                exports.WrappedInput = wrapped_input_1.default;
                var wrapped_select_1 = __importDefault(__webpack_require__(982));
                exports.WrappedSelect = wrapped_select_1.default;
            /***/ },
            /***/ 11: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var utils_1 = __webpack_require__(799);
                var constants_1 = __webpack_require__(883);
                var Input = /** @class */ function() {
                    function Input(_a) {
                        var element = _a.element, type = _a.type, classNames = _a.classNames, preventPaste = _a.preventPaste;
                        this.element = element;
                        this.type = type;
                        this.classNames = classNames;
                        this.preventPaste = preventPaste;
                        this.isFocussed = this.element.isEqualNode(document.activeElement);
                        this.isDisabled = element.disabled;
                        this._onPaste = this._onPaste.bind(this);
                        this._onInput = this._onInput.bind(this);
                        this._onFocus = this._onFocus.bind(this);
                        this._onBlur = this._onBlur.bind(this);
                    }
                    Object.defineProperty(Input.prototype, "placeholder", {
                        set: function(placeholder) {
                            this.element.placeholder = placeholder;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Input.prototype, "value", {
                        get: function() {
                            return (0, utils_1.sanitise)(this.element.value);
                        },
                        set: function(value) {
                            this.element.value = value;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Input.prototype, "rawValue", {
                        get: function() {
                            return this.element.value;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Input.prototype.addEventListeners = function() {
                        this.element.addEventListener("paste", this._onPaste);
                        this.element.addEventListener("input", this._onInput, {
                            passive: true
                        });
                        this.element.addEventListener("focus", this._onFocus, {
                            passive: true
                        });
                        this.element.addEventListener("blur", this._onBlur, {
                            passive: true
                        });
                    };
                    Input.prototype.removeEventListeners = function() {
                        this.element.removeEventListener("input", this._onInput);
                        this.element.removeEventListener("paste", this._onPaste);
                        this.element.removeEventListener("focus", this._onFocus);
                        this.element.removeEventListener("blur", this._onBlur);
                    };
                    Input.prototype.enable = function() {
                        this.element.removeAttribute("disabled");
                        this.isDisabled = false;
                    };
                    Input.prototype.disable = function() {
                        this.element.setAttribute("disabled", "");
                        this.isDisabled = true;
                    };
                    Input.prototype.focus = function() {
                        if (!this.isFocussed) this.element.focus();
                    };
                    Input.prototype.blur = function() {
                        if (this.isFocussed) this.element.blur();
                    };
                    Input.prototype.clear = function(setWidth) {
                        if (setWidth === void 0) setWidth = true;
                        if (this.element.value) this.element.value = "";
                        if (setWidth) this.setWidth();
                        return this;
                    };
                    /**
   * Set the correct input width based on placeholder
   * value or input value
   */ Input.prototype.setWidth = function() {
                        // Resize input to contents or placeholder
                        var _a = this.element, style = _a.style, value = _a.value, placeholder = _a.placeholder;
                        style.minWidth = "".concat(placeholder.length + 1, "ch");
                        style.width = "".concat(value.length + 1, "ch");
                    };
                    Input.prototype.setActiveDescendant = function(activeDescendantID) {
                        this.element.setAttribute("aria-activedescendant", activeDescendantID);
                    };
                    Input.prototype.removeActiveDescendant = function() {
                        this.element.removeAttribute("aria-activedescendant");
                    };
                    Input.prototype._onInput = function() {
                        if (this.type !== constants_1.SELECT_ONE_TYPE) this.setWidth();
                    };
                    Input.prototype._onPaste = function(event) {
                        if (this.preventPaste) event.preventDefault();
                    };
                    Input.prototype._onFocus = function() {
                        this.isFocussed = true;
                    };
                    Input.prototype._onBlur = function() {
                        this.isFocussed = false;
                    };
                    return Input;
                }();
                exports["default"] = Input;
            /***/ },
            /***/ 624: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var constants_1 = __webpack_require__(883);
                var List = /** @class */ function() {
                    function List(_a) {
                        var element = _a.element;
                        this.element = element;
                        this.scrollPos = this.element.scrollTop;
                        this.height = this.element.offsetHeight;
                    }
                    List.prototype.clear = function() {
                        this.element.innerHTML = "";
                    };
                    List.prototype.append = function(node) {
                        this.element.appendChild(node);
                    };
                    List.prototype.getChild = function(selector) {
                        return this.element.querySelector(selector);
                    };
                    List.prototype.hasChildren = function() {
                        return this.element.hasChildNodes();
                    };
                    List.prototype.scrollToTop = function() {
                        this.element.scrollTop = 0;
                    };
                    List.prototype.scrollToChildElement = function(element, direction) {
                        var _this = this;
                        if (!element) return;
                        var listHeight = this.element.offsetHeight;
                        // Scroll position of dropdown
                        var listScrollPosition = this.element.scrollTop + listHeight;
                        var elementHeight = element.offsetHeight;
                        // Distance from bottom of element to top of parent
                        var elementPos = element.offsetTop + elementHeight;
                        // Difference between the element and scroll position
                        var destination = direction > 0 ? this.element.scrollTop + elementPos - listScrollPosition : element.offsetTop;
                        requestAnimationFrame(function() {
                            _this._animateScroll(destination, direction);
                        });
                    };
                    List.prototype._scrollDown = function(scrollPos, strength, destination) {
                        var easing = (destination - scrollPos) / strength;
                        var distance = easing > 1 ? easing : 1;
                        this.element.scrollTop = scrollPos + distance;
                    };
                    List.prototype._scrollUp = function(scrollPos, strength, destination) {
                        var easing = (scrollPos - destination) / strength;
                        var distance = easing > 1 ? easing : 1;
                        this.element.scrollTop = scrollPos - distance;
                    };
                    List.prototype._animateScroll = function(destination, direction) {
                        var _this = this;
                        var strength = constants_1.SCROLLING_SPEED;
                        var choiceListScrollTop = this.element.scrollTop;
                        var continueAnimation = false;
                        if (direction > 0) {
                            this._scrollDown(choiceListScrollTop, strength, destination);
                            if (choiceListScrollTop < destination) continueAnimation = true;
                        } else {
                            this._scrollUp(choiceListScrollTop, strength, destination);
                            if (choiceListScrollTop > destination) continueAnimation = true;
                        }
                        if (continueAnimation) requestAnimationFrame(function() {
                            _this._animateScroll(destination, direction);
                        });
                    };
                    return List;
                }();
                exports["default"] = List;
            /***/ },
            /***/ 730: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var utils_1 = __webpack_require__(799);
                var WrappedElement = /** @class */ function() {
                    function WrappedElement(_a) {
                        var element = _a.element, classNames = _a.classNames;
                        this.element = element;
                        this.classNames = classNames;
                        if (!(element instanceof HTMLInputElement) && !(element instanceof HTMLSelectElement)) throw new TypeError("Invalid element passed");
                        this.isDisabled = false;
                    }
                    Object.defineProperty(WrappedElement.prototype, "isActive", {
                        get: function() {
                            return this.element.dataset.choice === "active";
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(WrappedElement.prototype, "dir", {
                        get: function() {
                            return this.element.dir;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(WrappedElement.prototype, "value", {
                        get: function() {
                            return this.element.value;
                        },
                        set: function(value) {
                            // you must define setter here otherwise it will be readonly property
                            this.element.value = value;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    WrappedElement.prototype.conceal = function() {
                        // Hide passed input
                        this.element.classList.add(this.classNames.input);
                        this.element.hidden = true;
                        // Remove element from tab index
                        this.element.tabIndex = -1;
                        // Backup original styles if any
                        var origStyle = this.element.getAttribute("style");
                        if (origStyle) this.element.setAttribute("data-choice-orig-style", origStyle);
                        this.element.setAttribute("data-choice", "active");
                    };
                    WrappedElement.prototype.reveal = function() {
                        // Reinstate passed element
                        this.element.classList.remove(this.classNames.input);
                        this.element.hidden = false;
                        this.element.removeAttribute("tabindex");
                        // Recover original styles if any
                        var origStyle = this.element.getAttribute("data-choice-orig-style");
                        if (origStyle) {
                            this.element.removeAttribute("data-choice-orig-style");
                            this.element.setAttribute("style", origStyle);
                        } else this.element.removeAttribute("style");
                        this.element.removeAttribute("data-choice");
                        // Re-assign values - this is weird, I know
                        // @todo Figure out why we need to do this
                        this.element.value = this.element.value; // eslint-disable-line no-self-assign
                    };
                    WrappedElement.prototype.enable = function() {
                        this.element.removeAttribute("disabled");
                        this.element.disabled = false;
                        this.isDisabled = false;
                    };
                    WrappedElement.prototype.disable = function() {
                        this.element.setAttribute("disabled", "");
                        this.element.disabled = true;
                        this.isDisabled = true;
                    };
                    WrappedElement.prototype.triggerEvent = function(eventType, data) {
                        (0, utils_1.dispatchEvent)(this.element, eventType, data);
                    };
                    return WrappedElement;
                }();
                exports["default"] = WrappedElement;
            /***/ },
            /***/ 541: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var wrapped_element_1 = __importDefault(__webpack_require__(730));
                var WrappedInput = /** @class */ function(_super) {
                    __extends(WrappedInput, _super);
                    function WrappedInput(_a) {
                        var element = _a.element, classNames = _a.classNames, delimiter = _a.delimiter;
                        var _this = _super.call(this, {
                            element: element,
                            classNames: classNames
                        }) || this;
                        _this.delimiter = delimiter;
                        return _this;
                    }
                    Object.defineProperty(WrappedInput.prototype, "value", {
                        get: function() {
                            return this.element.value;
                        },
                        set: function(value) {
                            this.element.setAttribute("value", value);
                            this.element.value = value;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    return WrappedInput;
                }(wrapped_element_1.default);
                exports["default"] = WrappedInput;
            /***/ },
            /***/ 982: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var wrapped_element_1 = __importDefault(__webpack_require__(730));
                var WrappedSelect = /** @class */ function(_super) {
                    __extends(WrappedSelect, _super);
                    function WrappedSelect(_a) {
                        var element = _a.element, classNames = _a.classNames, template = _a.template;
                        var _this = _super.call(this, {
                            element: element,
                            classNames: classNames
                        }) || this;
                        _this.template = template;
                        return _this;
                    }
                    Object.defineProperty(WrappedSelect.prototype, "placeholderOption", {
                        get: function() {
                            return this.element.querySelector('option[value=""]') || // Backward compatibility layer for the non-standard placeholder attribute supported in older versions.
                            this.element.querySelector("option[placeholder]");
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(WrappedSelect.prototype, "optionGroups", {
                        get: function() {
                            return Array.from(this.element.getElementsByTagName("OPTGROUP"));
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(WrappedSelect.prototype, "options", {
                        get: function() {
                            return Array.from(this.element.options);
                        },
                        set: function(options) {
                            var _this = this;
                            var fragment = document.createDocumentFragment();
                            var addOptionToFragment = function(data) {
                                // Create a standard select option
                                var option = _this.template(data);
                                // Append it to fragment
                                fragment.appendChild(option);
                            };
                            // Add each list item to list
                            options.forEach(function(optionData) {
                                return addOptionToFragment(optionData);
                            });
                            this.appendDocFragment(fragment);
                        },
                        enumerable: false,
                        configurable: true
                    });
                    WrappedSelect.prototype.appendDocFragment = function(fragment) {
                        this.element.innerHTML = "";
                        this.element.appendChild(fragment);
                    };
                    return WrappedSelect;
                }(wrapped_element_1.default);
                exports["default"] = WrappedSelect;
            /***/ },
            /***/ 883: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.SCROLLING_SPEED = exports.SELECT_MULTIPLE_TYPE = exports.SELECT_ONE_TYPE = exports.TEXT_TYPE = exports.KEY_CODES = exports.ACTION_TYPES = exports.EVENTS = void 0;
                exports.EVENTS = {
                    showDropdown: "showDropdown",
                    hideDropdown: "hideDropdown",
                    change: "change",
                    choice: "choice",
                    search: "search",
                    addItem: "addItem",
                    removeItem: "removeItem",
                    highlightItem: "highlightItem",
                    highlightChoice: "highlightChoice",
                    unhighlightItem: "unhighlightItem"
                };
                exports.ACTION_TYPES = {
                    ADD_CHOICE: "ADD_CHOICE",
                    FILTER_CHOICES: "FILTER_CHOICES",
                    ACTIVATE_CHOICES: "ACTIVATE_CHOICES",
                    CLEAR_CHOICES: "CLEAR_CHOICES",
                    ADD_GROUP: "ADD_GROUP",
                    ADD_ITEM: "ADD_ITEM",
                    REMOVE_ITEM: "REMOVE_ITEM",
                    HIGHLIGHT_ITEM: "HIGHLIGHT_ITEM",
                    CLEAR_ALL: "CLEAR_ALL",
                    RESET_TO: "RESET_TO",
                    SET_IS_LOADING: "SET_IS_LOADING"
                };
                exports.KEY_CODES = {
                    BACK_KEY: 46,
                    DELETE_KEY: 8,
                    ENTER_KEY: 13,
                    A_KEY: 65,
                    ESC_KEY: 27,
                    UP_KEY: 38,
                    DOWN_KEY: 40,
                    PAGE_UP_KEY: 33,
                    PAGE_DOWN_KEY: 34
                };
                exports.TEXT_TYPE = "text";
                exports.SELECT_ONE_TYPE = "select-one";
                exports.SELECT_MULTIPLE_TYPE = "select-multiple";
                exports.SCROLLING_SPEED = 4;
            /***/ },
            /***/ 789: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.DEFAULT_CONFIG = exports.DEFAULT_CLASSNAMES = void 0;
                var utils_1 = __webpack_require__(799);
                exports.DEFAULT_CLASSNAMES = {
                    containerOuter: "choices",
                    containerInner: "choices__inner",
                    input: "choices__input",
                    inputCloned: "choices__input--cloned",
                    list: "choices__list",
                    listItems: "choices__list--multiple",
                    listSingle: "choices__list--single",
                    listDropdown: "choices__list--dropdown",
                    item: "choices__item",
                    itemSelectable: "choices__item--selectable",
                    itemDisabled: "choices__item--disabled",
                    itemChoice: "choices__item--choice",
                    placeholder: "choices__placeholder",
                    group: "choices__group",
                    groupHeading: "choices__heading",
                    button: "choices__button",
                    activeState: "is-active",
                    focusState: "is-focused",
                    openState: "is-open",
                    disabledState: "is-disabled",
                    highlightedState: "is-highlighted",
                    selectedState: "is-selected",
                    flippedState: "is-flipped",
                    loadingState: "is-loading",
                    noResults: "has-no-results",
                    noChoices: "has-no-choices"
                };
                exports.DEFAULT_CONFIG = {
                    items: [],
                    choices: [],
                    silent: false,
                    renderChoiceLimit: -1,
                    maxItemCount: -1,
                    addItems: true,
                    addItemFilter: null,
                    removeItems: true,
                    removeItemButton: false,
                    editItems: false,
                    allowHTML: true,
                    duplicateItemsAllowed: true,
                    delimiter: ",",
                    paste: true,
                    searchEnabled: true,
                    searchChoices: true,
                    searchFloor: 1,
                    searchResultLimit: 4,
                    searchFields: [
                        "label",
                        "value"
                    ],
                    position: "auto",
                    resetScrollPosition: true,
                    shouldSort: true,
                    shouldSortItems: false,
                    sorter: utils_1.sortByAlpha,
                    placeholder: true,
                    placeholderValue: null,
                    searchPlaceholderValue: null,
                    prependValue: null,
                    appendValue: null,
                    renderSelectedChoices: "auto",
                    loadingText: "Loading...",
                    noResultsText: "No results found",
                    noChoicesText: "No choices to choose from",
                    itemSelectText: "Press to select",
                    uniqueItemText: "Only unique values can be added",
                    customAddItemText: "Only values matching specific conditions can be added",
                    addItemText: function(value) {
                        return 'Press Enter to add <b>"'.concat((0, utils_1.sanitise)(value), '"</b>');
                    },
                    maxItemText: function(maxItemCount) {
                        return "Only ".concat(maxItemCount, " values can be added");
                    },
                    valueComparer: function(value1, value2) {
                        return value1 === value2;
                    },
                    fuseOptions: {
                        includeScore: true
                    },
                    labelId: "",
                    callbackOnInit: null,
                    callbackOnCreateTemplates: null,
                    classNames: exports.DEFAULT_CLASSNAMES
                };
            /***/ },
            /***/ 18: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 978: /***/ function(__unused_webpack_module, exports) {
                /* eslint-disable @typescript-eslint/no-explicit-any */ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 948: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 359: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 285: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 533: /***/ function(__unused_webpack_module, exports) {
                /* eslint-disable @typescript-eslint/no-explicit-any */ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 187: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
                    if (k2 === undefined) k2 = k;
                    var desc = Object.getOwnPropertyDescriptor(m, k);
                    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
                        enumerable: true,
                        get: function() {
                            return m[k];
                        }
                    };
                    Object.defineProperty(o, k2, desc);
                } : function(o, m, k, k2) {
                    if (k2 === undefined) k2 = k;
                    o[k2] = m[k];
                });
                var __exportStar = this && this.__exportStar || function(m, exports) {
                    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                __exportStar(__webpack_require__(18), exports);
                __exportStar(__webpack_require__(978), exports);
                __exportStar(__webpack_require__(948), exports);
                __exportStar(__webpack_require__(359), exports);
                __exportStar(__webpack_require__(285), exports);
                __exportStar(__webpack_require__(533), exports);
                __exportStar(__webpack_require__(287), exports);
                __exportStar(__webpack_require__(132), exports);
                __exportStar(__webpack_require__(837), exports);
                __exportStar(__webpack_require__(598), exports);
                __exportStar(__webpack_require__(369), exports);
                __exportStar(__webpack_require__(37), exports);
                __exportStar(__webpack_require__(47), exports);
                __exportStar(__webpack_require__(923), exports);
                __exportStar(__webpack_require__(876), exports);
            /***/ },
            /***/ 287: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 132: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 837: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 598: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 37: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 369: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 47: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 923: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 876: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 799: /***/ function(__unused_webpack_module, exports) {
                /* eslint-disable @typescript-eslint/no-explicit-any */ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.parseCustomProperties = exports.diff = exports.cloneObject = exports.existsInArray = exports.dispatchEvent = exports.sortByScore = exports.sortByAlpha = exports.strToEl = exports.sanitise = exports.isScrolledIntoView = exports.getAdjacentEl = exports.wrap = exports.isType = exports.getType = exports.generateId = exports.generateChars = exports.getRandomNumber = void 0;
                var getRandomNumber = function(min, max) {
                    return Math.floor(Math.random() * (max - min) + min);
                };
                exports.getRandomNumber = getRandomNumber;
                var generateChars = function(length) {
                    return Array.from({
                        length: length
                    }, function() {
                        return (0, exports.getRandomNumber)(0, 36).toString(36);
                    }).join("");
                };
                exports.generateChars = generateChars;
                var generateId = function(element, prefix) {
                    var id = element.id || element.name && "".concat(element.name, "-").concat((0, exports.generateChars)(2)) || (0, exports.generateChars)(4);
                    id = id.replace(/(:|\.|\[|\]|,)/g, "");
                    id = "".concat(prefix, "-").concat(id);
                    return id;
                };
                exports.generateId = generateId;
                var getType = function(obj) {
                    return Object.prototype.toString.call(obj).slice(8, -1);
                };
                exports.getType = getType;
                var isType = function(type, obj) {
                    return obj !== undefined && obj !== null && (0, exports.getType)(obj) === type;
                };
                exports.isType = isType;
                var wrap = function(element, wrapper) {
                    if (wrapper === void 0) wrapper = document.createElement("div");
                    if (element.parentNode) {
                        if (element.nextSibling) element.parentNode.insertBefore(wrapper, element.nextSibling);
                        else element.parentNode.appendChild(wrapper);
                    }
                    return wrapper.appendChild(element);
                };
                exports.wrap = wrap;
                var getAdjacentEl = function(startEl, selector, direction) {
                    if (direction === void 0) direction = 1;
                    var prop = "".concat(direction > 0 ? "next" : "previous", "ElementSibling");
                    var sibling = startEl[prop];
                    while(sibling){
                        if (sibling.matches(selector)) return sibling;
                        sibling = sibling[prop];
                    }
                    return sibling;
                };
                exports.getAdjacentEl = getAdjacentEl;
                var isScrolledIntoView = function(element, parent, direction) {
                    if (direction === void 0) direction = 1;
                    if (!element) return false;
                    var isVisible;
                    if (direction > 0) // In view from bottom
                    isVisible = parent.scrollTop + parent.offsetHeight >= element.offsetTop + element.offsetHeight;
                    else // In view from top
                    isVisible = element.offsetTop >= parent.scrollTop;
                    return isVisible;
                };
                exports.isScrolledIntoView = isScrolledIntoView;
                var sanitise = function(value) {
                    if (typeof value !== "string") return value;
                    return value.replace(/&/g, "&amp;").replace(/>/g, "&gt;").replace(/</g, "&lt;").replace(/"/g, "&quot;");
                };
                exports.sanitise = sanitise;
                exports.strToEl = function() {
                    var tmpEl = document.createElement("div");
                    return function(str) {
                        var cleanedInput = str.trim();
                        tmpEl.innerHTML = cleanedInput;
                        var firldChild = tmpEl.children[0];
                        while(tmpEl.firstChild)tmpEl.removeChild(tmpEl.firstChild);
                        return firldChild;
                    };
                }();
                var sortByAlpha = function(_a, _b) {
                    var value = _a.value, _c = _a.label, label = _c === void 0 ? value : _c;
                    var value2 = _b.value, _d = _b.label, label2 = _d === void 0 ? value2 : _d;
                    return label.localeCompare(label2, [], {
                        sensitivity: "base",
                        ignorePunctuation: true,
                        numeric: true
                    });
                };
                exports.sortByAlpha = sortByAlpha;
                var sortByScore = function(a, b) {
                    var _a = a.score, scoreA = _a === void 0 ? 0 : _a;
                    var _b = b.score, scoreB = _b === void 0 ? 0 : _b;
                    return scoreA - scoreB;
                };
                exports.sortByScore = sortByScore;
                var dispatchEvent = function(element, type, customArgs) {
                    if (customArgs === void 0) customArgs = null;
                    var event = new CustomEvent(type, {
                        detail: customArgs,
                        bubbles: true,
                        cancelable: true
                    });
                    return element.dispatchEvent(event);
                };
                exports.dispatchEvent = dispatchEvent;
                var existsInArray = function(array, value, key) {
                    if (key === void 0) key = "value";
                    return array.some(function(item) {
                        if (typeof value === "string") return item[key] === value.trim();
                        return item[key] === value;
                    });
                };
                exports.existsInArray = existsInArray;
                var cloneObject = function(obj) {
                    return JSON.parse(JSON.stringify(obj));
                };
                exports.cloneObject = cloneObject;
                /**
 * Returns an array of keys present on the first but missing on the second object
 */ var diff = function(a, b) {
                    var aKeys = Object.keys(a).sort();
                    var bKeys = Object.keys(b).sort();
                    return aKeys.filter(function(i) {
                        return bKeys.indexOf(i) < 0;
                    });
                };
                exports.diff = diff;
                var parseCustomProperties = function(customProperties) {
                    if (typeof customProperties !== "undefined") try {
                        return JSON.parse(customProperties);
                    } catch (e) {
                        return customProperties;
                    }
                    return {};
                };
                exports.parseCustomProperties = parseCustomProperties;
            /***/ },
            /***/ 273: /***/ function(__unused_webpack_module, exports) {
                var __spreadArray = this && this.__spreadArray || function(to, from, pack) {
                    if (pack || arguments.length === 2) {
                        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                            ar[i] = from[i];
                        }
                    }
                    return to.concat(ar || Array.prototype.slice.call(from));
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.defaultState = void 0;
                exports.defaultState = [];
                function choices(state, action) {
                    if (state === void 0) state = exports.defaultState;
                    if (action === void 0) action = {};
                    switch(action.type){
                        case "ADD_CHOICE":
                            var addChoiceAction = action;
                            var choice = {
                                id: addChoiceAction.id,
                                elementId: addChoiceAction.elementId,
                                groupId: addChoiceAction.groupId,
                                value: addChoiceAction.value,
                                label: addChoiceAction.label || addChoiceAction.value,
                                disabled: addChoiceAction.disabled || false,
                                selected: false,
                                active: true,
                                score: 9999,
                                customProperties: addChoiceAction.customProperties,
                                placeholder: addChoiceAction.placeholder || false
                            };
                            /*
          A disabled choice appears in the choice dropdown but cannot be selected
          A selected choice has been added to the passed input's value (added as an item)
          An active choice appears within the choice dropdown
        */ return __spreadArray(__spreadArray([], state, true), [
                                choice
                            ], false);
                        case "ADD_ITEM":
                            var addItemAction_1 = action;
                            // When an item is added and it has an associated choice,
                            // we want to disable it so it can't be chosen again
                            if (addItemAction_1.choiceId > -1) return state.map(function(obj) {
                                var choice = obj;
                                if (choice.id === parseInt("".concat(addItemAction_1.choiceId), 10)) choice.selected = true;
                                return choice;
                            });
                            return state;
                        case "REMOVE_ITEM":
                            var removeItemAction_1 = action;
                            // When an item is removed and it has an associated choice,
                            // we want to re-enable it so it can be chosen again
                            if (removeItemAction_1.choiceId && removeItemAction_1.choiceId > -1) return state.map(function(obj) {
                                var choice = obj;
                                if (choice.id === parseInt("".concat(removeItemAction_1.choiceId), 10)) choice.selected = false;
                                return choice;
                            });
                            return state;
                        case "FILTER_CHOICES":
                            var filterChoicesAction_1 = action;
                            return state.map(function(obj) {
                                var choice = obj;
                                // Set active state based on whether choice is
                                // within filtered results
                                choice.active = filterChoicesAction_1.results.some(function(_a) {
                                    var item = _a.item, score = _a.score;
                                    if (item.id === choice.id) {
                                        choice.score = score;
                                        return true;
                                    }
                                    return false;
                                });
                                return choice;
                            });
                        case "ACTIVATE_CHOICES":
                            var activateChoicesAction_1 = action;
                            return state.map(function(obj) {
                                var choice = obj;
                                choice.active = activateChoicesAction_1.active;
                                return choice;
                            });
                        case "CLEAR_CHOICES":
                            return exports.defaultState;
                        default:
                            return state;
                    }
                }
                exports["default"] = choices;
            /***/ },
            /***/ 871: /***/ function(__unused_webpack_module, exports) {
                var __spreadArray = this && this.__spreadArray || function(to, from, pack) {
                    if (pack || arguments.length === 2) {
                        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                            ar[i] = from[i];
                        }
                    }
                    return to.concat(ar || Array.prototype.slice.call(from));
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.defaultState = void 0;
                exports.defaultState = [];
                function groups(state, action) {
                    if (state === void 0) state = exports.defaultState;
                    if (action === void 0) action = {};
                    switch(action.type){
                        case "ADD_GROUP":
                            var addGroupAction = action;
                            return __spreadArray(__spreadArray([], state, true), [
                                {
                                    id: addGroupAction.id,
                                    value: addGroupAction.value,
                                    active: addGroupAction.active,
                                    disabled: addGroupAction.disabled
                                }
                            ], false);
                        case "CLEAR_CHOICES":
                            return [];
                        default:
                            return state;
                    }
                }
                exports["default"] = groups;
            /***/ },
            /***/ 655: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.defaultState = void 0;
                var redux_1 = __webpack_require__(791);
                var items_1 = __importDefault(__webpack_require__(52));
                var groups_1 = __importDefault(__webpack_require__(871));
                var choices_1 = __importDefault(__webpack_require__(273));
                var loading_1 = __importDefault(__webpack_require__(502));
                var utils_1 = __webpack_require__(799);
                exports.defaultState = {
                    groups: [],
                    items: [],
                    choices: [],
                    loading: false
                };
                var appReducer = (0, redux_1.combineReducers)({
                    items: items_1.default,
                    groups: groups_1.default,
                    choices: choices_1.default,
                    loading: loading_1.default
                });
                var rootReducer = function(passedState, action) {
                    var state = passedState;
                    // If we are clearing all items, groups and options we reassign
                    // state and then pass that state to our proper reducer. This isn't
                    // mutating our actual state
                    // See: http://stackoverflow.com/a/35641992
                    if (action.type === "CLEAR_ALL") state = exports.defaultState;
                    else if (action.type === "RESET_TO") return (0, utils_1.cloneObject)(action.state);
                    return appReducer(state, action);
                };
                exports["default"] = rootReducer;
            /***/ },
            /***/ 52: /***/ function(__unused_webpack_module, exports) {
                var __spreadArray = this && this.__spreadArray || function(to, from, pack) {
                    if (pack || arguments.length === 2) {
                        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                            ar[i] = from[i];
                        }
                    }
                    return to.concat(ar || Array.prototype.slice.call(from));
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.defaultState = void 0;
                exports.defaultState = [];
                function items(state, action) {
                    if (state === void 0) state = exports.defaultState;
                    if (action === void 0) action = {};
                    switch(action.type){
                        case "ADD_ITEM":
                            var addItemAction = action;
                            // Add object to items array
                            var newState = __spreadArray(__spreadArray([], state, true), [
                                {
                                    id: addItemAction.id,
                                    choiceId: addItemAction.choiceId,
                                    groupId: addItemAction.groupId,
                                    value: addItemAction.value,
                                    label: addItemAction.label,
                                    active: true,
                                    highlighted: false,
                                    customProperties: addItemAction.customProperties,
                                    placeholder: addItemAction.placeholder || false,
                                    keyCode: null
                                }
                            ], false);
                            return newState.map(function(obj) {
                                var item = obj;
                                item.highlighted = false;
                                return item;
                            });
                        case "REMOVE_ITEM":
                            // Set item to inactive
                            return state.map(function(obj) {
                                var item = obj;
                                if (item.id === action.id) item.active = false;
                                return item;
                            });
                        case "HIGHLIGHT_ITEM":
                            var highlightItemAction_1 = action;
                            return state.map(function(obj) {
                                var item = obj;
                                if (item.id === highlightItemAction_1.id) item.highlighted = highlightItemAction_1.highlighted;
                                return item;
                            });
                        default:
                            return state;
                    }
                }
                exports["default"] = items;
            /***/ },
            /***/ 502: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.defaultState = void 0;
                exports.defaultState = false;
                var general = function(state, action) {
                    if (state === void 0) state = exports.defaultState;
                    if (action === void 0) action = {};
                    switch(action.type){
                        case "SET_IS_LOADING":
                            return action.isLoading;
                        default:
                            return state;
                    }
                };
                exports["default"] = general;
            /***/ },
            /***/ 744: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var __spreadArray = this && this.__spreadArray || function(to, from, pack) {
                    if (pack || arguments.length === 2) {
                        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                            ar[i] = from[i];
                        }
                    }
                    return to.concat(ar || Array.prototype.slice.call(from));
                };
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                /* eslint-disable @typescript-eslint/no-explicit-any */ var redux_1 = __webpack_require__(791);
                var index_1 = __importDefault(__webpack_require__(655));
                var Store = /** @class */ function() {
                    function Store() {
                        this._store = (0, redux_1.createStore)(index_1.default, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());
                    }
                    /**
   * Subscribe store to function call (wrapped Redux method)
   */ Store.prototype.subscribe = function(onChange) {
                        this._store.subscribe(onChange);
                    };
                    /**
   * Dispatch event to store (wrapped Redux method)
   */ Store.prototype.dispatch = function(action) {
                        this._store.dispatch(action);
                    };
                    Object.defineProperty(Store.prototype, "state", {
                        /**
     * Get store object (wrapping Redux method)
     */ get: function() {
                            return this._store.getState();
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "items", {
                        /**
     * Get items from store
     */ get: function() {
                            return this.state.items;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "activeItems", {
                        /**
     * Get active items from store
     */ get: function() {
                            return this.items.filter(function(item) {
                                return item.active === true;
                            });
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "highlightedActiveItems", {
                        /**
     * Get highlighted items from store
     */ get: function() {
                            return this.items.filter(function(item) {
                                return item.active && item.highlighted;
                            });
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "choices", {
                        /**
     * Get choices from store
     */ get: function() {
                            return this.state.choices;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "activeChoices", {
                        /**
     * Get active choices from store
     */ get: function() {
                            return this.choices.filter(function(choice) {
                                return choice.active === true;
                            });
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "selectableChoices", {
                        /**
     * Get selectable choices from store
     */ get: function() {
                            return this.choices.filter(function(choice) {
                                return choice.disabled !== true;
                            });
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "searchableChoices", {
                        /**
     * Get choices that can be searched (excluding placeholders)
     */ get: function() {
                            return this.selectableChoices.filter(function(choice) {
                                return choice.placeholder !== true;
                            });
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "placeholderChoice", {
                        /**
     * Get placeholder choice from store
     */ get: function() {
                            return __spreadArray([], this.choices, true).reverse().find(function(choice) {
                                return choice.placeholder === true;
                            });
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "groups", {
                        /**
     * Get groups from store
     */ get: function() {
                            return this.state.groups;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "activeGroups", {
                        /**
     * Get active groups from store
     */ get: function() {
                            var _a = this, groups = _a.groups, choices = _a.choices;
                            return groups.filter(function(group) {
                                var isActive = group.active === true && group.disabled === false;
                                var hasActiveOptions = choices.some(function(choice) {
                                    return choice.active === true && choice.disabled === false;
                                });
                                return isActive && hasActiveOptions;
                            }, []);
                        },
                        enumerable: false,
                        configurable: true
                    });
                    /**
   * Get loading state from store
   */ Store.prototype.isLoading = function() {
                        return this.state.loading;
                    };
                    /**
   * Get single choice by it's ID
   */ Store.prototype.getChoiceById = function(id) {
                        return this.activeChoices.find(function(choice) {
                            return choice.id === parseInt(id, 10);
                        });
                    };
                    /**
   * Get group by group id
   */ Store.prototype.getGroupById = function(id) {
                        return this.groups.find(function(group) {
                            return group.id === id;
                        });
                    };
                    return Store;
                }();
                exports["default"] = Store;
            /***/ },
            /***/ 686: /***/ function(__unused_webpack_module, exports) {
                /**
 * Helpers to create HTML elements used by Choices
 * Can be overridden by providing `callbackOnCreateTemplates` option
 */ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var templates = {
                    containerOuter: function(_a, dir, isSelectElement, isSelectOneElement, searchEnabled, passedElementType, labelId) {
                        var containerOuter = _a.classNames.containerOuter;
                        var div = Object.assign(document.createElement("div"), {
                            className: containerOuter
                        });
                        div.dataset.type = passedElementType;
                        if (dir) div.dir = dir;
                        if (isSelectOneElement) div.tabIndex = 0;
                        if (isSelectElement) {
                            div.setAttribute("role", searchEnabled ? "combobox" : "listbox");
                            if (searchEnabled) div.setAttribute("aria-autocomplete", "list");
                        }
                        div.setAttribute("aria-haspopup", "true");
                        div.setAttribute("aria-expanded", "false");
                        if (labelId) div.setAttribute("aria-labelledby", labelId);
                        return div;
                    },
                    containerInner: function(_a) {
                        var containerInner = _a.classNames.containerInner;
                        return Object.assign(document.createElement("div"), {
                            className: containerInner
                        });
                    },
                    itemList: function(_a, isSelectOneElement) {
                        var _b = _a.classNames, list = _b.list, listSingle = _b.listSingle, listItems = _b.listItems;
                        return Object.assign(document.createElement("div"), {
                            className: "".concat(list, " ").concat(isSelectOneElement ? listSingle : listItems)
                        });
                    },
                    placeholder: function(_a, value) {
                        var _b;
                        var allowHTML = _a.allowHTML, placeholder = _a.classNames.placeholder;
                        return Object.assign(document.createElement("div"), (_b = {
                            className: placeholder
                        }, _b[allowHTML ? "innerHTML" : "innerText"] = value, _b));
                    },
                    item: function(_a, _b, removeItemButton) {
                        var _c, _d;
                        var allowHTML = _a.allowHTML, _e = _a.classNames, item = _e.item, button = _e.button, highlightedState = _e.highlightedState, itemSelectable = _e.itemSelectable, placeholder = _e.placeholder;
                        var id = _b.id, value = _b.value, label = _b.label, customProperties = _b.customProperties, active = _b.active, disabled = _b.disabled, highlighted = _b.highlighted, isPlaceholder = _b.placeholder;
                        var div = Object.assign(document.createElement("div"), (_c = {
                            className: item
                        }, _c[allowHTML ? "innerHTML" : "innerText"] = label, _c));
                        Object.assign(div.dataset, {
                            item: "",
                            id: id,
                            value: value,
                            customProperties: customProperties
                        });
                        if (active) div.setAttribute("aria-selected", "true");
                        if (disabled) div.setAttribute("aria-disabled", "true");
                        if (isPlaceholder) div.classList.add(placeholder);
                        div.classList.add(highlighted ? highlightedState : itemSelectable);
                        if (removeItemButton) {
                            if (disabled) div.classList.remove(itemSelectable);
                            div.dataset.deletable = "";
                            /** @todo This MUST be localizable, not hardcoded! */ var REMOVE_ITEM_TEXT = "Remove item";
                            var removeButton = Object.assign(document.createElement("button"), (_d = {
                                type: "button",
                                className: button
                            }, _d[allowHTML ? "innerHTML" : "innerText"] = REMOVE_ITEM_TEXT, _d));
                            removeButton.setAttribute("aria-label", "".concat(REMOVE_ITEM_TEXT, ": '").concat(value, "'"));
                            removeButton.dataset.button = "";
                            div.appendChild(removeButton);
                        }
                        return div;
                    },
                    choiceList: function(_a, isSelectOneElement) {
                        var list = _a.classNames.list;
                        var div = Object.assign(document.createElement("div"), {
                            className: list
                        });
                        if (!isSelectOneElement) div.setAttribute("aria-multiselectable", "true");
                        div.setAttribute("role", "listbox");
                        return div;
                    },
                    choiceGroup: function(_a, _b) {
                        var _c;
                        var allowHTML = _a.allowHTML, _d = _a.classNames, group = _d.group, groupHeading = _d.groupHeading, itemDisabled = _d.itemDisabled;
                        var id = _b.id, value = _b.value, disabled = _b.disabled;
                        var div = Object.assign(document.createElement("div"), {
                            className: "".concat(group, " ").concat(disabled ? itemDisabled : "")
                        });
                        div.setAttribute("role", "group");
                        Object.assign(div.dataset, {
                            group: "",
                            id: id,
                            value: value
                        });
                        if (disabled) div.setAttribute("aria-disabled", "true");
                        div.appendChild(Object.assign(document.createElement("div"), (_c = {
                            className: groupHeading
                        }, _c[allowHTML ? "innerHTML" : "innerText"] = value, _c)));
                        return div;
                    },
                    choice: function(_a, _b, selectText) {
                        var _c;
                        var allowHTML = _a.allowHTML, _d = _a.classNames, item = _d.item, itemChoice = _d.itemChoice, itemSelectable = _d.itemSelectable, selectedState = _d.selectedState, itemDisabled = _d.itemDisabled, placeholder = _d.placeholder;
                        var id = _b.id, value = _b.value, label = _b.label, groupId = _b.groupId, elementId = _b.elementId, isDisabled = _b.disabled, isSelected = _b.selected, isPlaceholder = _b.placeholder;
                        var div = Object.assign(document.createElement("div"), (_c = {
                            id: elementId
                        }, _c[allowHTML ? "innerHTML" : "innerText"] = label, _c.className = "".concat(item, " ").concat(itemChoice), _c));
                        if (isSelected) div.classList.add(selectedState);
                        if (isPlaceholder) div.classList.add(placeholder);
                        div.setAttribute("role", groupId && groupId > 0 ? "treeitem" : "option");
                        Object.assign(div.dataset, {
                            choice: "",
                            id: id,
                            value: value,
                            selectText: selectText
                        });
                        if (isDisabled) {
                            div.classList.add(itemDisabled);
                            div.dataset.choiceDisabled = "";
                            div.setAttribute("aria-disabled", "true");
                        } else {
                            div.classList.add(itemSelectable);
                            div.dataset.choiceSelectable = "";
                        }
                        return div;
                    },
                    input: function(_a, placeholderValue) {
                        var _b = _a.classNames, input = _b.input, inputCloned = _b.inputCloned;
                        var inp = Object.assign(document.createElement("input"), {
                            type: "search",
                            name: "search_terms",
                            className: "".concat(input, " ").concat(inputCloned),
                            autocomplete: "off",
                            autocapitalize: "off",
                            spellcheck: false
                        });
                        inp.setAttribute("role", "textbox");
                        inp.setAttribute("aria-autocomplete", "list");
                        inp.setAttribute("aria-label", placeholderValue);
                        return inp;
                    },
                    dropdown: function(_a) {
                        var _b = _a.classNames, list = _b.list, listDropdown = _b.listDropdown;
                        var div = document.createElement("div");
                        div.classList.add(list, listDropdown);
                        div.setAttribute("aria-expanded", "false");
                        return div;
                    },
                    notice: function(_a, innerText, type) {
                        var _b;
                        var allowHTML = _a.allowHTML, _c = _a.classNames, item = _c.item, itemChoice = _c.itemChoice, noResults = _c.noResults, noChoices = _c.noChoices;
                        if (type === void 0) type = "";
                        var classes = [
                            item,
                            itemChoice
                        ];
                        if (type === "no-choices") classes.push(noChoices);
                        else if (type === "no-results") classes.push(noResults);
                        return Object.assign(document.createElement("div"), (_b = {}, _b[allowHTML ? "innerHTML" : "innerText"] = innerText, _b.className = classes.join(" "), _b));
                    },
                    option: function(_a) {
                        var label = _a.label, value = _a.value, customProperties = _a.customProperties, active = _a.active, disabled = _a.disabled;
                        var opt = new Option(label, value, false, active);
                        if (customProperties) opt.dataset.customProperties = "".concat(customProperties);
                        opt.disabled = !!disabled;
                        return opt;
                    }
                };
                exports["default"] = templates;
            /***/ },
            /***/ 996: /***/ function(module1) {
                var isMergeableObject = function isMergeableObject(value) {
                    return isNonNullObject(value) && !isSpecial(value);
                };
                function isNonNullObject(value) {
                    return !!value && typeof value === "object";
                }
                function isSpecial(value) {
                    var stringValue = Object.prototype.toString.call(value);
                    return stringValue === "[object RegExp]" || stringValue === "[object Date]" || isReactElement(value);
                }
                // see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
                var canUseSymbol = typeof Symbol === "function" && Symbol.for;
                var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for("react.element") : 0xeac7;
                function isReactElement(value) {
                    return value.$$typeof === REACT_ELEMENT_TYPE;
                }
                function emptyTarget(val) {
                    return Array.isArray(val) ? [] : {};
                }
                function cloneUnlessOtherwiseSpecified(value, options) {
                    return options.clone !== false && options.isMergeableObject(value) ? deepmerge(emptyTarget(value), value, options) : value;
                }
                function defaultArrayMerge(target, source, options) {
                    return target.concat(source).map(function(element) {
                        return cloneUnlessOtherwiseSpecified(element, options);
                    });
                }
                function getMergeFunction(key, options) {
                    if (!options.customMerge) return deepmerge;
                    var customMerge = options.customMerge(key);
                    return typeof customMerge === "function" ? customMerge : deepmerge;
                }
                function getEnumerableOwnPropertySymbols(target) {
                    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target).filter(function(symbol) {
                        return target.propertyIsEnumerable(symbol);
                    }) : [];
                }
                function getKeys(target) {
                    return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target));
                }
                function propertyIsOnObject(object, property) {
                    try {
                        return property in object;
                    } catch (_) {
                        return false;
                    }
                }
                // Protects from prototype poisoning and unexpected merging up the prototype chain.
                function propertyIsUnsafe(target, key) {
                    return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
                     && !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
                     && Object.propertyIsEnumerable.call(target, key) // and also unsafe if they're nonenumerable.
                    );
                }
                function mergeObject(target, source, options) {
                    var destination = {};
                    if (options.isMergeableObject(target)) getKeys(target).forEach(function(key) {
                        destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
                    });
                    getKeys(source).forEach(function(key) {
                        if (propertyIsUnsafe(target, key)) return;
                        if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
                        else destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
                    });
                    return destination;
                }
                function deepmerge(target, source, options) {
                    options = options || {};
                    options.arrayMerge = options.arrayMerge || defaultArrayMerge;
                    options.isMergeableObject = options.isMergeableObject || isMergeableObject;
                    // cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
                    // implementations can use it. The caller may not replace it.
                    options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;
                    var sourceIsArray = Array.isArray(source);
                    var targetIsArray = Array.isArray(target);
                    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
                    if (!sourceAndTargetTypesMatch) return cloneUnlessOtherwiseSpecified(source, options);
                    else if (sourceIsArray) return options.arrayMerge(target, source, options);
                    else return mergeObject(target, source, options);
                }
                deepmerge.all = function deepmergeAll(array, options) {
                    if (!Array.isArray(array)) throw new Error("first argument should be an array");
                    return array.reduce(function(prev, next) {
                        return deepmerge(prev, next, options);
                    }, {});
                };
                var deepmerge_1 = deepmerge;
                module1.exports = deepmerge_1;
            /***/ },
            /***/ 221: /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ "default": function() {
                        return /* binding */ Fuse;
                    }
                });
                /**
 * Fuse.js v6.6.2 - Lightweight fuzzy-search (http://fusejs.io)
 *
 * Copyright (c) 2022 Kiro Risk (http://kiro.me)
 * All Rights Reserved. Apache Software License 2.0
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 */ function isArray(value) {
                    return !Array.isArray ? getTag(value) === "[object Array]" : Array.isArray(value);
                }
                // Adapted from: https://github.com/lodash/lodash/blob/master/.internal/baseToString.js
                const INFINITY = 1 / 0;
                function baseToString(value) {
                    // Exit early for strings to avoid a performance hit in some environments.
                    if (typeof value == "string") return value;
                    let result = value + "";
                    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
                }
                function toString(value) {
                    return value == null ? "" : baseToString(value);
                }
                function isString(value) {
                    return typeof value === "string";
                }
                function isNumber(value) {
                    return typeof value === "number";
                }
                // Adapted from: https://github.com/lodash/lodash/blob/master/isBoolean.js
                function isBoolean(value) {
                    return value === true || value === false || isObjectLike(value) && getTag(value) == "[object Boolean]";
                }
                function isObject(value) {
                    return typeof value === "object";
                }
                // Checks if `value` is object-like.
                function isObjectLike(value) {
                    return isObject(value) && value !== null;
                }
                function isDefined(value) {
                    return value !== undefined && value !== null;
                }
                function isBlank(value) {
                    return !value.trim().length;
                }
                // Gets the `toStringTag` of `value`.
                // Adapted from: https://github.com/lodash/lodash/blob/master/.internal/getTag.js
                function getTag(value) {
                    return value == null ? value === undefined ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(value);
                }
                const EXTENDED_SEARCH_UNAVAILABLE = "Extended search is not available";
                const INCORRECT_INDEX_TYPE = "Incorrect 'index' type";
                const LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY = (key)=>`Invalid value for key ${key}`;
                const PATTERN_LENGTH_TOO_LARGE = (max)=>`Pattern length exceeds max of ${max}.`;
                const MISSING_KEY_PROPERTY = (name)=>`Missing ${name} property in key`;
                const INVALID_KEY_WEIGHT_VALUE = (key)=>`Property 'weight' in key '${key}' must be a positive integer`;
                const hasOwn = Object.prototype.hasOwnProperty;
                class KeyStore {
                    constructor(keys){
                        this._keys = [];
                        this._keyMap = {};
                        let totalWeight = 0;
                        keys.forEach((key)=>{
                            let obj = createKey(key);
                            totalWeight += obj.weight;
                            this._keys.push(obj);
                            this._keyMap[obj.id] = obj;
                            totalWeight += obj.weight;
                        });
                        // Normalize weights so that their sum is equal to 1
                        this._keys.forEach((key)=>{
                            key.weight /= totalWeight;
                        });
                    }
                    get(keyId) {
                        return this._keyMap[keyId];
                    }
                    keys() {
                        return this._keys;
                    }
                    toJSON() {
                        return JSON.stringify(this._keys);
                    }
                }
                function createKey(key) {
                    let path = null;
                    let id = null;
                    let src = null;
                    let weight = 1;
                    let getFn = null;
                    if (isString(key) || isArray(key)) {
                        src = key;
                        path = createKeyPath(key);
                        id = createKeyId(key);
                    } else {
                        if (!hasOwn.call(key, "name")) throw new Error(MISSING_KEY_PROPERTY("name"));
                        const name = key.name;
                        src = name;
                        if (hasOwn.call(key, "weight")) {
                            weight = key.weight;
                            if (weight <= 0) throw new Error(INVALID_KEY_WEIGHT_VALUE(name));
                        }
                        path = createKeyPath(name);
                        id = createKeyId(name);
                        getFn = key.getFn;
                    }
                    return {
                        path: path,
                        id: id,
                        weight: weight,
                        src: src,
                        getFn: getFn
                    };
                }
                function createKeyPath(key) {
                    return isArray(key) ? key : key.split(".");
                }
                function createKeyId(key) {
                    return isArray(key) ? key.join(".") : key;
                }
                function get(obj, path) {
                    let list = [];
                    let arr = false;
                    const deepGet = (obj, path, index)=>{
                        if (!isDefined(obj)) return;
                        if (!path[index]) // If there's no path left, we've arrived at the object we care about.
                        list.push(obj);
                        else {
                            let key = path[index];
                            const value = obj[key];
                            if (!isDefined(value)) return;
                            // If we're at the last value in the path, and if it's a string/number/bool,
                            // add it to the list
                            if (index === path.length - 1 && (isString(value) || isNumber(value) || isBoolean(value))) list.push(toString(value));
                            else if (isArray(value)) {
                                arr = true;
                                // Search each item in the array.
                                for(let i = 0, len = value.length; i < len; i += 1)deepGet(value[i], path, index + 1);
                            } else if (path.length) // An object. Recurse further.
                            deepGet(value, path, index + 1);
                        }
                    };
                    // Backwards compatibility (since path used to be a string)
                    deepGet(obj, isString(path) ? path.split(".") : path, 0);
                    return arr ? list : list[0];
                }
                const MatchOptions = {
                    // Whether the matches should be included in the result set. When `true`, each record in the result
                    // set will include the indices of the matched characters.
                    // These can consequently be used for highlighting purposes.
                    includeMatches: false,
                    // When `true`, the matching function will continue to the end of a search pattern even if
                    // a perfect match has already been located in the string.
                    findAllMatches: false,
                    // Minimum number of characters that must be matched before a result is considered a match
                    minMatchCharLength: 1
                };
                const BasicOptions = {
                    // When `true`, the algorithm continues searching to the end of the input even if a perfect
                    // match is found before the end of the same input.
                    isCaseSensitive: false,
                    // When true, the matching function will continue to the end of a search pattern even if
                    includeScore: false,
                    // List of properties that will be searched. This also supports nested properties.
                    keys: [],
                    // Whether to sort the result list, by score
                    shouldSort: true,
                    // Default sort function: sort by ascending score, ascending index
                    sortFn: (a, b)=>a.score === b.score ? a.idx < b.idx ? -1 : 1 : a.score < b.score ? -1 : 1
                };
                const FuzzyOptions = {
                    // Approximately where in the text is the pattern expected to be found?
                    location: 0,
                    // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
                    // (of both letters and location), a threshold of '1.0' would match anything.
                    threshold: 0.6,
                    // Determines how close the match must be to the fuzzy location (specified above).
                    // An exact letter match which is 'distance' characters away from the fuzzy location
                    // would score as a complete mismatch. A distance of '0' requires the match be at
                    // the exact location specified, a threshold of '1000' would require a perfect match
                    // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
                    distance: 100
                };
                const AdvancedOptions = {
                    // When `true`, it enables the use of unix-like search commands
                    useExtendedSearch: false,
                    // The get function to use when fetching an object's properties.
                    // The default will search nested paths *ie foo.bar.baz*
                    getFn: get,
                    // When `true`, search will ignore `location` and `distance`, so it won't matter
                    // where in the string the pattern appears.
                    // More info: https://fusejs.io/concepts/scoring-theory.html#fuzziness-score
                    ignoreLocation: false,
                    // When `true`, the calculation for the relevance score (used for sorting) will
                    // ignore the field-length norm.
                    // More info: https://fusejs.io/concepts/scoring-theory.html#field-length-norm
                    ignoreFieldNorm: false,
                    // The weight to determine how much field length norm effects scoring.
                    fieldNormWeight: 1
                };
                var Config = {
                    ...BasicOptions,
                    ...MatchOptions,
                    ...FuzzyOptions,
                    ...AdvancedOptions
                };
                const SPACE = /[^ ]+/g;
                // Field-length norm: the shorter the field, the higher the weight.
                // Set to 3 decimals to reduce index size.
                function norm(weight = 1, mantissa = 3) {
                    const cache = new Map();
                    const m = Math.pow(10, mantissa);
                    return {
                        get (value) {
                            const numTokens = value.match(SPACE).length;
                            if (cache.has(numTokens)) return cache.get(numTokens);
                            // Default function is 1/sqrt(x), weight makes that variable
                            const norm = 1 / Math.pow(numTokens, 0.5 * weight);
                            // In place of `toFixed(mantissa)`, for faster computation
                            const n = parseFloat(Math.round(norm * m) / m);
                            cache.set(numTokens, n);
                            return n;
                        },
                        clear () {
                            cache.clear();
                        }
                    };
                }
                class FuseIndex {
                    constructor({ getFn: getFn = Config.getFn, fieldNormWeight: fieldNormWeight = Config.fieldNormWeight } = {}){
                        this.norm = norm(fieldNormWeight, 3);
                        this.getFn = getFn;
                        this.isCreated = false;
                        this.setIndexRecords();
                    }
                    setSources(docs = []) {
                        this.docs = docs;
                    }
                    setIndexRecords(records = []) {
                        this.records = records;
                    }
                    setKeys(keys = []) {
                        this.keys = keys;
                        this._keysMap = {};
                        keys.forEach((key, idx)=>{
                            this._keysMap[key.id] = idx;
                        });
                    }
                    create() {
                        if (this.isCreated || !this.docs.length) return;
                        this.isCreated = true;
                        // List is Array<String>
                        if (isString(this.docs[0])) this.docs.forEach((doc, docIndex)=>{
                            this._addString(doc, docIndex);
                        });
                        else // List is Array<Object>
                        this.docs.forEach((doc, docIndex)=>{
                            this._addObject(doc, docIndex);
                        });
                        this.norm.clear();
                    }
                    // Adds a doc to the end of the index
                    add(doc) {
                        const idx = this.size();
                        if (isString(doc)) this._addString(doc, idx);
                        else this._addObject(doc, idx);
                    }
                    // Removes the doc at the specified index of the index
                    removeAt(idx) {
                        this.records.splice(idx, 1);
                        // Change ref index of every subsquent doc
                        for(let i = idx, len = this.size(); i < len; i += 1)this.records[i].i -= 1;
                    }
                    getValueForItemAtKeyId(item, keyId) {
                        return item[this._keysMap[keyId]];
                    }
                    size() {
                        return this.records.length;
                    }
                    _addString(doc, docIndex) {
                        if (!isDefined(doc) || isBlank(doc)) return;
                        let record = {
                            v: doc,
                            i: docIndex,
                            n: this.norm.get(doc)
                        };
                        this.records.push(record);
                    }
                    _addObject(doc, docIndex) {
                        let record = {
                            i: docIndex,
                            $: {}
                        };
                        // Iterate over every key (i.e, path), and fetch the value at that key
                        this.keys.forEach((key, keyIndex)=>{
                            let value = key.getFn ? key.getFn(doc) : this.getFn(doc, key.path);
                            if (!isDefined(value)) return;
                            if (isArray(value)) {
                                let subRecords = [];
                                const stack = [
                                    {
                                        nestedArrIndex: -1,
                                        value: value
                                    }
                                ];
                                while(stack.length){
                                    const { nestedArrIndex: nestedArrIndex, value: value } = stack.pop();
                                    if (!isDefined(value)) continue;
                                    if (isString(value) && !isBlank(value)) {
                                        let subRecord = {
                                            v: value,
                                            i: nestedArrIndex,
                                            n: this.norm.get(value)
                                        };
                                        subRecords.push(subRecord);
                                    } else if (isArray(value)) value.forEach((item, k)=>{
                                        stack.push({
                                            nestedArrIndex: k,
                                            value: item
                                        });
                                    });
                                }
                                record.$[keyIndex] = subRecords;
                            } else if (isString(value) && !isBlank(value)) {
                                let subRecord = {
                                    v: value,
                                    n: this.norm.get(value)
                                };
                                record.$[keyIndex] = subRecord;
                            }
                        });
                        this.records.push(record);
                    }
                    toJSON() {
                        return {
                            keys: this.keys,
                            records: this.records
                        };
                    }
                }
                function createIndex(keys, docs, { getFn: getFn = Config.getFn, fieldNormWeight: fieldNormWeight = Config.fieldNormWeight } = {}) {
                    const myIndex = new FuseIndex({
                        getFn: getFn,
                        fieldNormWeight: fieldNormWeight
                    });
                    myIndex.setKeys(keys.map(createKey));
                    myIndex.setSources(docs);
                    myIndex.create();
                    return myIndex;
                }
                function parseIndex(data, { getFn: getFn = Config.getFn, fieldNormWeight: fieldNormWeight = Config.fieldNormWeight } = {}) {
                    const { keys: keys, records: records } = data;
                    const myIndex = new FuseIndex({
                        getFn: getFn,
                        fieldNormWeight: fieldNormWeight
                    });
                    myIndex.setKeys(keys);
                    myIndex.setIndexRecords(records);
                    return myIndex;
                }
                function computeScore$1(pattern, { errors: errors = 0, currentLocation: currentLocation = 0, expectedLocation: expectedLocation = 0, distance: distance = Config.distance, ignoreLocation: ignoreLocation = Config.ignoreLocation } = {}) {
                    const accuracy = errors / pattern.length;
                    if (ignoreLocation) return accuracy;
                    const proximity = Math.abs(expectedLocation - currentLocation);
                    if (!distance) // Dodge divide by zero error.
                    return proximity ? 1.0 : accuracy;
                    return accuracy + proximity / distance;
                }
                function convertMaskToIndices(matchmask = [], minMatchCharLength = Config.minMatchCharLength) {
                    let indices = [];
                    let start = -1;
                    let end = -1;
                    let i = 0;
                    for(let len = matchmask.length; i < len; i += 1){
                        let match = matchmask[i];
                        if (match && start === -1) start = i;
                        else if (!match && start !== -1) {
                            end = i - 1;
                            if (end - start + 1 >= minMatchCharLength) indices.push([
                                start,
                                end
                            ]);
                            start = -1;
                        }
                    }
                    // (i-1 - start) + 1 => i - start
                    if (matchmask[i - 1] && i - start >= minMatchCharLength) indices.push([
                        start,
                        i - 1
                    ]);
                    return indices;
                }
                // Machine word size
                const MAX_BITS = 32;
                function search(text, pattern, patternAlphabet, { location: location = Config.location, distance: distance = Config.distance, threshold: threshold = Config.threshold, findAllMatches: findAllMatches = Config.findAllMatches, minMatchCharLength: minMatchCharLength = Config.minMatchCharLength, includeMatches: includeMatches = Config.includeMatches, ignoreLocation: ignoreLocation = Config.ignoreLocation } = {}) {
                    if (pattern.length > MAX_BITS) throw new Error(PATTERN_LENGTH_TOO_LARGE(MAX_BITS));
                    const patternLen = pattern.length;
                    // Set starting location at beginning text and initialize the alphabet.
                    const textLen = text.length;
                    // Handle the case when location > text.length
                    const expectedLocation = Math.max(0, Math.min(location, textLen));
                    // Highest score beyond which we give up.
                    let currentThreshold = threshold;
                    // Is there a nearby exact match? (speedup)
                    let bestLocation = expectedLocation;
                    // Performance: only computer matches when the minMatchCharLength > 1
                    // OR if `includeMatches` is true.
                    const computeMatches = minMatchCharLength > 1 || includeMatches;
                    // A mask of the matches, used for building the indices
                    const matchMask = computeMatches ? Array(textLen) : [];
                    let index;
                    // Get all exact matches, here for speed up
                    while((index = text.indexOf(pattern, bestLocation)) > -1){
                        let score = computeScore$1(pattern, {
                            currentLocation: index,
                            expectedLocation: expectedLocation,
                            distance: distance,
                            ignoreLocation: ignoreLocation
                        });
                        currentThreshold = Math.min(score, currentThreshold);
                        bestLocation = index + patternLen;
                        if (computeMatches) {
                            let i = 0;
                            while(i < patternLen){
                                matchMask[index + i] = 1;
                                i += 1;
                            }
                        }
                    }
                    // Reset the best location
                    bestLocation = -1;
                    let lastBitArr = [];
                    let finalScore = 1;
                    let binMax = patternLen + textLen;
                    const mask = 1 << patternLen - 1;
                    for(let i = 0; i < patternLen; i += 1){
                        // Scan for the best match; each iteration allows for one more error.
                        // Run a binary search to determine how far from the match location we can stray
                        // at this error level.
                        let binMin = 0;
                        let binMid = binMax;
                        while(binMin < binMid){
                            const score = computeScore$1(pattern, {
                                errors: i,
                                currentLocation: expectedLocation + binMid,
                                expectedLocation: expectedLocation,
                                distance: distance,
                                ignoreLocation: ignoreLocation
                            });
                            if (score <= currentThreshold) binMin = binMid;
                            else binMax = binMid;
                            binMid = Math.floor((binMax - binMin) / 2 + binMin);
                        }
                        // Use the result from this iteration as the maximum for the next.
                        binMax = binMid;
                        let start = Math.max(1, expectedLocation - binMid + 1);
                        let finish = findAllMatches ? textLen : Math.min(expectedLocation + binMid, textLen) + patternLen;
                        // Initialize the bit array
                        let bitArr = Array(finish + 2);
                        bitArr[finish + 1] = (1 << i) - 1;
                        for(let j = finish; j >= start; j -= 1){
                            let currentLocation = j - 1;
                            let charMatch = patternAlphabet[text.charAt(currentLocation)];
                            if (computeMatches) // Speed up: quick bool to int conversion (i.e, `charMatch ? 1 : 0`)
                            matchMask[currentLocation] = +!!charMatch;
                            // First pass: exact match
                            bitArr[j] = (bitArr[j + 1] << 1 | 1) & charMatch;
                            // Subsequent passes: fuzzy match
                            if (i) bitArr[j] |= (lastBitArr[j + 1] | lastBitArr[j]) << 1 | 1 | lastBitArr[j + 1];
                            if (bitArr[j] & mask) {
                                finalScore = computeScore$1(pattern, {
                                    errors: i,
                                    currentLocation: currentLocation,
                                    expectedLocation: expectedLocation,
                                    distance: distance,
                                    ignoreLocation: ignoreLocation
                                });
                                // This match will almost certainly be better than any existing match.
                                // But check anyway.
                                if (finalScore <= currentThreshold) {
                                    // Indeed it is
                                    currentThreshold = finalScore;
                                    bestLocation = currentLocation;
                                    // Already passed `loc`, downhill from here on in.
                                    if (bestLocation <= expectedLocation) break;
                                    // When passing `bestLocation`, don't exceed our current distance from `expectedLocation`.
                                    start = Math.max(1, 2 * expectedLocation - bestLocation);
                                }
                            }
                        }
                        // No hope for a (better) match at greater error levels.
                        const score = computeScore$1(pattern, {
                            errors: i + 1,
                            currentLocation: expectedLocation,
                            expectedLocation: expectedLocation,
                            distance: distance,
                            ignoreLocation: ignoreLocation
                        });
                        if (score > currentThreshold) break;
                        lastBitArr = bitArr;
                    }
                    const result = {
                        isMatch: bestLocation >= 0,
                        // Count exact matches (those with a score of 0) to be "almost" exact
                        score: Math.max(0.001, finalScore)
                    };
                    if (computeMatches) {
                        const indices = convertMaskToIndices(matchMask, minMatchCharLength);
                        if (!indices.length) result.isMatch = false;
                        else if (includeMatches) result.indices = indices;
                    }
                    return result;
                }
                function createPatternAlphabet(pattern) {
                    let mask = {};
                    for(let i = 0, len = pattern.length; i < len; i += 1){
                        const char = pattern.charAt(i);
                        mask[char] = (mask[char] || 0) | 1 << len - i - 1;
                    }
                    return mask;
                }
                class BitapSearch {
                    constructor(pattern, { location: location = Config.location, threshold: threshold = Config.threshold, distance: distance = Config.distance, includeMatches: includeMatches = Config.includeMatches, findAllMatches: findAllMatches = Config.findAllMatches, minMatchCharLength: minMatchCharLength = Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = Config.isCaseSensitive, ignoreLocation: ignoreLocation = Config.ignoreLocation } = {}){
                        this.options = {
                            location: location,
                            threshold: threshold,
                            distance: distance,
                            includeMatches: includeMatches,
                            findAllMatches: findAllMatches,
                            minMatchCharLength: minMatchCharLength,
                            isCaseSensitive: isCaseSensitive,
                            ignoreLocation: ignoreLocation
                        };
                        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
                        this.chunks = [];
                        if (!this.pattern.length) return;
                        const addChunk = (pattern, startIndex)=>{
                            this.chunks.push({
                                pattern: pattern,
                                alphabet: createPatternAlphabet(pattern),
                                startIndex: startIndex
                            });
                        };
                        const len = this.pattern.length;
                        if (len > MAX_BITS) {
                            let i = 0;
                            const remainder = len % MAX_BITS;
                            const end = len - remainder;
                            while(i < end){
                                addChunk(this.pattern.substr(i, MAX_BITS), i);
                                i += MAX_BITS;
                            }
                            if (remainder) {
                                const startIndex = len - MAX_BITS;
                                addChunk(this.pattern.substr(startIndex), startIndex);
                            }
                        } else addChunk(this.pattern, 0);
                    }
                    searchIn(text) {
                        const { isCaseSensitive: isCaseSensitive, includeMatches: includeMatches } = this.options;
                        if (!isCaseSensitive) text = text.toLowerCase();
                        // Exact match
                        if (this.pattern === text) {
                            let result = {
                                isMatch: true,
                                score: 0
                            };
                            if (includeMatches) result.indices = [
                                [
                                    0,
                                    text.length - 1
                                ]
                            ];
                            return result;
                        }
                        // Otherwise, use Bitap algorithm
                        const { location: location, distance: distance, threshold: threshold, findAllMatches: findAllMatches, minMatchCharLength: minMatchCharLength, ignoreLocation: ignoreLocation } = this.options;
                        let allIndices = [];
                        let totalScore = 0;
                        let hasMatches = false;
                        this.chunks.forEach(({ pattern: pattern, alphabet: alphabet, startIndex: startIndex })=>{
                            const { isMatch: isMatch, score: score, indices: indices } = search(text, pattern, alphabet, {
                                location: location + startIndex,
                                distance: distance,
                                threshold: threshold,
                                findAllMatches: findAllMatches,
                                minMatchCharLength: minMatchCharLength,
                                includeMatches: includeMatches,
                                ignoreLocation: ignoreLocation
                            });
                            if (isMatch) hasMatches = true;
                            totalScore += score;
                            if (isMatch && indices) allIndices = [
                                ...allIndices,
                                ...indices
                            ];
                        });
                        let result = {
                            isMatch: hasMatches,
                            score: hasMatches ? totalScore / this.chunks.length : 1
                        };
                        if (hasMatches && includeMatches) result.indices = allIndices;
                        return result;
                    }
                }
                class BaseMatch {
                    constructor(pattern){
                        this.pattern = pattern;
                    }
                    static isMultiMatch(pattern) {
                        return getMatch(pattern, this.multiRegex);
                    }
                    static isSingleMatch(pattern) {
                        return getMatch(pattern, this.singleRegex);
                    }
                    search() {}
                }
                function getMatch(pattern, exp) {
                    const matches = pattern.match(exp);
                    return matches ? matches[1] : null;
                }
                // Token: 'file
                class ExactMatch extends BaseMatch {
                    constructor(pattern){
                        super(pattern);
                    }
                    static get type() {
                        return "exact";
                    }
                    static get multiRegex() {
                        return /^="(.*)"$/;
                    }
                    static get singleRegex() {
                        return /^=(.*)$/;
                    }
                    search(text) {
                        const isMatch = text === this.pattern;
                        return {
                            isMatch: isMatch,
                            score: isMatch ? 0 : 1,
                            indices: [
                                0,
                                this.pattern.length - 1
                            ]
                        };
                    }
                }
                // Token: !fire
                class InverseExactMatch extends BaseMatch {
                    constructor(pattern){
                        super(pattern);
                    }
                    static get type() {
                        return "inverse-exact";
                    }
                    static get multiRegex() {
                        return /^!"(.*)"$/;
                    }
                    static get singleRegex() {
                        return /^!(.*)$/;
                    }
                    search(text) {
                        const index = text.indexOf(this.pattern);
                        const isMatch = index === -1;
                        return {
                            isMatch: isMatch,
                            score: isMatch ? 0 : 1,
                            indices: [
                                0,
                                text.length - 1
                            ]
                        };
                    }
                }
                // Token: ^file
                class PrefixExactMatch extends BaseMatch {
                    constructor(pattern){
                        super(pattern);
                    }
                    static get type() {
                        return "prefix-exact";
                    }
                    static get multiRegex() {
                        return /^\^"(.*)"$/;
                    }
                    static get singleRegex() {
                        return /^\^(.*)$/;
                    }
                    search(text) {
                        const isMatch = text.startsWith(this.pattern);
                        return {
                            isMatch: isMatch,
                            score: isMatch ? 0 : 1,
                            indices: [
                                0,
                                this.pattern.length - 1
                            ]
                        };
                    }
                }
                // Token: !^fire
                class InversePrefixExactMatch extends BaseMatch {
                    constructor(pattern){
                        super(pattern);
                    }
                    static get type() {
                        return "inverse-prefix-exact";
                    }
                    static get multiRegex() {
                        return /^!\^"(.*)"$/;
                    }
                    static get singleRegex() {
                        return /^!\^(.*)$/;
                    }
                    search(text) {
                        const isMatch = !text.startsWith(this.pattern);
                        return {
                            isMatch: isMatch,
                            score: isMatch ? 0 : 1,
                            indices: [
                                0,
                                text.length - 1
                            ]
                        };
                    }
                }
                // Token: .file$
                class SuffixExactMatch extends BaseMatch {
                    constructor(pattern){
                        super(pattern);
                    }
                    static get type() {
                        return "suffix-exact";
                    }
                    static get multiRegex() {
                        return /^"(.*)"\$$/;
                    }
                    static get singleRegex() {
                        return /^(.*)\$$/;
                    }
                    search(text) {
                        const isMatch = text.endsWith(this.pattern);
                        return {
                            isMatch: isMatch,
                            score: isMatch ? 0 : 1,
                            indices: [
                                text.length - this.pattern.length,
                                text.length - 1
                            ]
                        };
                    }
                }
                // Token: !.file$
                class InverseSuffixExactMatch extends BaseMatch {
                    constructor(pattern){
                        super(pattern);
                    }
                    static get type() {
                        return "inverse-suffix-exact";
                    }
                    static get multiRegex() {
                        return /^!"(.*)"\$$/;
                    }
                    static get singleRegex() {
                        return /^!(.*)\$$/;
                    }
                    search(text) {
                        const isMatch = !text.endsWith(this.pattern);
                        return {
                            isMatch: isMatch,
                            score: isMatch ? 0 : 1,
                            indices: [
                                0,
                                text.length - 1
                            ]
                        };
                    }
                }
                class FuzzyMatch extends BaseMatch {
                    constructor(pattern, { location: location = Config.location, threshold: threshold = Config.threshold, distance: distance = Config.distance, includeMatches: includeMatches = Config.includeMatches, findAllMatches: findAllMatches = Config.findAllMatches, minMatchCharLength: minMatchCharLength = Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = Config.isCaseSensitive, ignoreLocation: ignoreLocation = Config.ignoreLocation } = {}){
                        super(pattern);
                        this._bitapSearch = new BitapSearch(pattern, {
                            location: location,
                            threshold: threshold,
                            distance: distance,
                            includeMatches: includeMatches,
                            findAllMatches: findAllMatches,
                            minMatchCharLength: minMatchCharLength,
                            isCaseSensitive: isCaseSensitive,
                            ignoreLocation: ignoreLocation
                        });
                    }
                    static get type() {
                        return "fuzzy";
                    }
                    static get multiRegex() {
                        return /^"(.*)"$/;
                    }
                    static get singleRegex() {
                        return /^(.*)$/;
                    }
                    search(text) {
                        return this._bitapSearch.searchIn(text);
                    }
                }
                // Token: 'file
                class IncludeMatch extends BaseMatch {
                    constructor(pattern){
                        super(pattern);
                    }
                    static get type() {
                        return "include";
                    }
                    static get multiRegex() {
                        return /^'"(.*)"$/;
                    }
                    static get singleRegex() {
                        return /^'(.*)$/;
                    }
                    search(text) {
                        let location = 0;
                        let index;
                        const indices = [];
                        const patternLen = this.pattern.length;
                        // Get all exact matches
                        while((index = text.indexOf(this.pattern, location)) > -1){
                            location = index + patternLen;
                            indices.push([
                                index,
                                location - 1
                            ]);
                        }
                        const isMatch = !!indices.length;
                        return {
                            isMatch: isMatch,
                            score: isMatch ? 0 : 1,
                            indices: indices
                        };
                    }
                }
                // ❗Order is important. DO NOT CHANGE.
                const searchers = [
                    ExactMatch,
                    IncludeMatch,
                    PrefixExactMatch,
                    InversePrefixExactMatch,
                    InverseSuffixExactMatch,
                    SuffixExactMatch,
                    InverseExactMatch,
                    FuzzyMatch
                ];
                const searchersLen = searchers.length;
                // Regex to split by spaces, but keep anything in quotes together
                const SPACE_RE = / +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/;
                const OR_TOKEN = "|";
                // Return a 2D array representation of the query, for simpler parsing.
                // Example:
                // "^core go$ | rb$ | py$ xy$" => [["^core", "go$"], ["rb$"], ["py$", "xy$"]]
                function parseQuery(pattern, options = {}) {
                    return pattern.split(OR_TOKEN).map((item)=>{
                        let query = item.trim().split(SPACE_RE).filter((item)=>item && !!item.trim());
                        let results = [];
                        for(let i = 0, len = query.length; i < len; i += 1){
                            const queryItem = query[i];
                            // 1. Handle multiple query match (i.e, once that are quoted, like `"hello world"`)
                            let found = false;
                            let idx = -1;
                            while(!found && ++idx < searchersLen){
                                const searcher = searchers[idx];
                                let token = searcher.isMultiMatch(queryItem);
                                if (token) {
                                    results.push(new searcher(token, options));
                                    found = true;
                                }
                            }
                            if (found) continue;
                            // 2. Handle single query matches (i.e, once that are *not* quoted)
                            idx = -1;
                            while(++idx < searchersLen){
                                const searcher = searchers[idx];
                                let token = searcher.isSingleMatch(queryItem);
                                if (token) {
                                    results.push(new searcher(token, options));
                                    break;
                                }
                            }
                        }
                        return results;
                    });
                }
                // These extended matchers can return an array of matches, as opposed
                // to a singl match
                const MultiMatchSet = new Set([
                    FuzzyMatch.type,
                    IncludeMatch.type
                ]);
                /**
 * Command-like searching
 * ======================
 *
 * Given multiple search terms delimited by spaces.e.g. `^jscript .python$ ruby !java`,
 * search in a given text.
 *
 * Search syntax:
 *
 * | Token       | Match type                 | Description                            |
 * | ----------- | -------------------------- | -------------------------------------- |
 * | `jscript`   | fuzzy-match                | Items that fuzzy match `jscript`       |
 * | `=scheme`   | exact-match                | Items that are `scheme`                |
 * | `'python`   | include-match              | Items that include `python`            |
 * | `!ruby`     | inverse-exact-match        | Items that do not include `ruby`       |
 * | `^java`     | prefix-exact-match         | Items that start with `java`           |
 * | `!^earlang` | inverse-prefix-exact-match | Items that do not start with `earlang` |
 * | `.js$`      | suffix-exact-match         | Items that end with `.js`              |
 * | `!.go$`     | inverse-suffix-exact-match | Items that do not end with `.go`       |
 *
 * A single pipe character acts as an OR operator. For example, the following
 * query matches entries that start with `core` and end with either`go`, `rb`,
 * or`py`.
 *
 * ```
 * ^core go$ | rb$ | py$
 * ```
 */ class ExtendedSearch {
                    constructor(pattern, { isCaseSensitive: isCaseSensitive = Config.isCaseSensitive, includeMatches: includeMatches = Config.includeMatches, minMatchCharLength: minMatchCharLength = Config.minMatchCharLength, ignoreLocation: ignoreLocation = Config.ignoreLocation, findAllMatches: findAllMatches = Config.findAllMatches, location: location = Config.location, threshold: threshold = Config.threshold, distance: distance = Config.distance } = {}){
                        this.query = null;
                        this.options = {
                            isCaseSensitive: isCaseSensitive,
                            includeMatches: includeMatches,
                            minMatchCharLength: minMatchCharLength,
                            findAllMatches: findAllMatches,
                            ignoreLocation: ignoreLocation,
                            location: location,
                            threshold: threshold,
                            distance: distance
                        };
                        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
                        this.query = parseQuery(this.pattern, this.options);
                    }
                    static condition(_, options) {
                        return options.useExtendedSearch;
                    }
                    searchIn(text) {
                        const query = this.query;
                        if (!query) return {
                            isMatch: false,
                            score: 1
                        };
                        const { includeMatches: includeMatches, isCaseSensitive: isCaseSensitive } = this.options;
                        text = isCaseSensitive ? text : text.toLowerCase();
                        let numMatches = 0;
                        let allIndices = [];
                        let totalScore = 0;
                        // ORs
                        for(let i = 0, qLen = query.length; i < qLen; i += 1){
                            const searchers = query[i];
                            // Reset indices
                            allIndices.length = 0;
                            numMatches = 0;
                            // ANDs
                            for(let j = 0, pLen = searchers.length; j < pLen; j += 1){
                                const searcher = searchers[j];
                                const { isMatch: isMatch, indices: indices, score: score } = searcher.search(text);
                                if (isMatch) {
                                    numMatches += 1;
                                    totalScore += score;
                                    if (includeMatches) {
                                        const type = searcher.constructor.type;
                                        if (MultiMatchSet.has(type)) allIndices = [
                                            ...allIndices,
                                            ...indices
                                        ];
                                        else allIndices.push(indices);
                                    }
                                } else {
                                    totalScore = 0;
                                    numMatches = 0;
                                    allIndices.length = 0;
                                    break;
                                }
                            }
                            // OR condition, so if TRUE, return
                            if (numMatches) {
                                let result = {
                                    isMatch: true,
                                    score: totalScore / numMatches
                                };
                                if (includeMatches) result.indices = allIndices;
                                return result;
                            }
                        }
                        // Nothing was matched
                        return {
                            isMatch: false,
                            score: 1
                        };
                    }
                }
                const registeredSearchers = [];
                function register(...args) {
                    registeredSearchers.push(...args);
                }
                function createSearcher(pattern, options) {
                    for(let i = 0, len = registeredSearchers.length; i < len; i += 1){
                        let searcherClass = registeredSearchers[i];
                        if (searcherClass.condition(pattern, options)) return new searcherClass(pattern, options);
                    }
                    return new BitapSearch(pattern, options);
                }
                const LogicalOperator = {
                    AND: "$and",
                    OR: "$or"
                };
                const KeyType = {
                    PATH: "$path",
                    PATTERN: "$val"
                };
                const isExpression = (query)=>!!(query[LogicalOperator.AND] || query[LogicalOperator.OR]);
                const isPath = (query)=>!!query[KeyType.PATH];
                const isLeaf = (query)=>!isArray(query) && isObject(query) && !isExpression(query);
                const convertToExplicit = (query)=>({
                        [LogicalOperator.AND]: Object.keys(query).map((key)=>({
                                [key]: query[key]
                            }))
                    });
                // When `auto` is `true`, the parse function will infer and initialize and add
                // the appropriate `Searcher` instance
                function parse(query, options, { auto: auto = true } = {}) {
                    const next = (query)=>{
                        let keys = Object.keys(query);
                        const isQueryPath = isPath(query);
                        if (!isQueryPath && keys.length > 1 && !isExpression(query)) return next(convertToExplicit(query));
                        if (isLeaf(query)) {
                            const key = isQueryPath ? query[KeyType.PATH] : keys[0];
                            const pattern = isQueryPath ? query[KeyType.PATTERN] : query[key];
                            if (!isString(pattern)) throw new Error(LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(key));
                            const obj = {
                                keyId: createKeyId(key),
                                pattern: pattern
                            };
                            if (auto) obj.searcher = createSearcher(pattern, options);
                            return obj;
                        }
                        let node = {
                            children: [],
                            operator: keys[0]
                        };
                        keys.forEach((key)=>{
                            const value = query[key];
                            if (isArray(value)) value.forEach((item)=>{
                                node.children.push(next(item));
                            });
                        });
                        return node;
                    };
                    if (!isExpression(query)) query = convertToExplicit(query);
                    return next(query);
                }
                // Practical scoring function
                function computeScore(results, { ignoreFieldNorm: ignoreFieldNorm = Config.ignoreFieldNorm }) {
                    results.forEach((result)=>{
                        let totalScore = 1;
                        result.matches.forEach(({ key: key, norm: norm, score: score })=>{
                            const weight = key ? key.weight : null;
                            totalScore *= Math.pow(score === 0 && weight ? Number.EPSILON : score, (weight || 1) * (ignoreFieldNorm ? 1 : norm));
                        });
                        result.score = totalScore;
                    });
                }
                function transformMatches(result, data) {
                    const matches = result.matches;
                    data.matches = [];
                    if (!isDefined(matches)) return;
                    matches.forEach((match)=>{
                        if (!isDefined(match.indices) || !match.indices.length) return;
                        const { indices: indices, value: value } = match;
                        let obj = {
                            indices: indices,
                            value: value
                        };
                        if (match.key) obj.key = match.key.src;
                        if (match.idx > -1) obj.refIndex = match.idx;
                        data.matches.push(obj);
                    });
                }
                function transformScore(result, data) {
                    data.score = result.score;
                }
                function format(results, docs, { includeMatches: includeMatches = Config.includeMatches, includeScore: includeScore = Config.includeScore } = {}) {
                    const transformers = [];
                    if (includeMatches) transformers.push(transformMatches);
                    if (includeScore) transformers.push(transformScore);
                    return results.map((result)=>{
                        const { idx: idx } = result;
                        const data = {
                            item: docs[idx],
                            refIndex: idx
                        };
                        if (transformers.length) transformers.forEach((transformer)=>{
                            transformer(result, data);
                        });
                        return data;
                    });
                }
                class Fuse {
                    constructor(docs, options = {}, index){
                        this.options = {
                            ...Config,
                            ...options
                        };
                        this.options.useExtendedSearch;
                        this._keyStore = new KeyStore(this.options.keys);
                        this.setCollection(docs, index);
                    }
                    setCollection(docs, index) {
                        this._docs = docs;
                        if (index && !(index instanceof FuseIndex)) throw new Error(INCORRECT_INDEX_TYPE);
                        this._myIndex = index || createIndex(this.options.keys, this._docs, {
                            getFn: this.options.getFn,
                            fieldNormWeight: this.options.fieldNormWeight
                        });
                    }
                    add(doc) {
                        if (!isDefined(doc)) return;
                        this._docs.push(doc);
                        this._myIndex.add(doc);
                    }
                    remove(predicate = ()=>false) {
                        const results = [];
                        for(let i = 0, len = this._docs.length; i < len; i += 1){
                            const doc = this._docs[i];
                            if (predicate(doc, i)) {
                                this.removeAt(i);
                                i -= 1;
                                len -= 1;
                                results.push(doc);
                            }
                        }
                        return results;
                    }
                    removeAt(idx) {
                        this._docs.splice(idx, 1);
                        this._myIndex.removeAt(idx);
                    }
                    getIndex() {
                        return this._myIndex;
                    }
                    search(query, { limit: limit = -1 } = {}) {
                        const { includeMatches: includeMatches, includeScore: includeScore, shouldSort: shouldSort, sortFn: sortFn, ignoreFieldNorm: ignoreFieldNorm } = this.options;
                        let results = isString(query) ? isString(this._docs[0]) ? this._searchStringList(query) : this._searchObjectList(query) : this._searchLogical(query);
                        computeScore(results, {
                            ignoreFieldNorm: ignoreFieldNorm
                        });
                        if (shouldSort) results.sort(sortFn);
                        if (isNumber(limit) && limit > -1) results = results.slice(0, limit);
                        return format(results, this._docs, {
                            includeMatches: includeMatches,
                            includeScore: includeScore
                        });
                    }
                    _searchStringList(query) {
                        const searcher = createSearcher(query, this.options);
                        const { records: records } = this._myIndex;
                        const results = [];
                        // Iterate over every string in the index
                        records.forEach(({ v: text, i: idx, n: norm })=>{
                            if (!isDefined(text)) return;
                            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
                            if (isMatch) results.push({
                                item: text,
                                idx: idx,
                                matches: [
                                    {
                                        score: score,
                                        value: text,
                                        norm: norm,
                                        indices: indices
                                    }
                                ]
                            });
                        });
                        return results;
                    }
                    _searchLogical(query) {
                        const expression = parse(query, this.options);
                        const evaluate = (node, item, idx)=>{
                            if (!node.children) {
                                const { keyId: keyId, searcher: searcher } = node;
                                const matches = this._findMatches({
                                    key: this._keyStore.get(keyId),
                                    value: this._myIndex.getValueForItemAtKeyId(item, keyId),
                                    searcher: searcher
                                });
                                if (matches && matches.length) return [
                                    {
                                        idx: idx,
                                        item: item,
                                        matches: matches
                                    }
                                ];
                                return [];
                            }
                            const res = [];
                            for(let i = 0, len = node.children.length; i < len; i += 1){
                                const child = node.children[i];
                                const result = evaluate(child, item, idx);
                                if (result.length) res.push(...result);
                                else if (node.operator === LogicalOperator.AND) return [];
                            }
                            return res;
                        };
                        const records = this._myIndex.records;
                        const resultMap = {};
                        const results = [];
                        records.forEach(({ $: item, i: idx })=>{
                            if (isDefined(item)) {
                                let expResults = evaluate(expression, item, idx);
                                if (expResults.length) {
                                    // Dedupe when adding
                                    if (!resultMap[idx]) {
                                        resultMap[idx] = {
                                            idx: idx,
                                            item: item,
                                            matches: []
                                        };
                                        results.push(resultMap[idx]);
                                    }
                                    expResults.forEach(({ matches: matches })=>{
                                        resultMap[idx].matches.push(...matches);
                                    });
                                }
                            }
                        });
                        return results;
                    }
                    _searchObjectList(query) {
                        const searcher = createSearcher(query, this.options);
                        const { keys: keys, records: records } = this._myIndex;
                        const results = [];
                        // List is Array<Object>
                        records.forEach(({ $: item, i: idx })=>{
                            if (!isDefined(item)) return;
                            let matches = [];
                            // Iterate over every key (i.e, path), and fetch the value at that key
                            keys.forEach((key, keyIndex)=>{
                                matches.push(...this._findMatches({
                                    key: key,
                                    value: item[keyIndex],
                                    searcher: searcher
                                }));
                            });
                            if (matches.length) results.push({
                                idx: idx,
                                item: item,
                                matches: matches
                            });
                        });
                        return results;
                    }
                    _findMatches({ key: key, value: value, searcher: searcher }) {
                        if (!isDefined(value)) return [];
                        let matches = [];
                        if (isArray(value)) value.forEach(({ v: text, i: idx, n: norm })=>{
                            if (!isDefined(text)) return;
                            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
                            if (isMatch) matches.push({
                                score: score,
                                key: key,
                                value: text,
                                idx: idx,
                                norm: norm,
                                indices: indices
                            });
                        });
                        else {
                            const { v: text, n: norm } = value;
                            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
                            if (isMatch) matches.push({
                                score: score,
                                key: key,
                                value: text,
                                norm: norm,
                                indices: indices
                            });
                        }
                        return matches;
                    }
                }
                Fuse.version = "6.6.2";
                Fuse.createIndex = createIndex;
                Fuse.parseIndex = parseIndex;
                Fuse.config = Config;
                Fuse.parseQuery = parse;
                register(ExtendedSearch);
            /***/ },
            /***/ 791: /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                // ESM COMPAT FLAG
                __webpack_require__.r(__webpack_exports__);
                // EXPORTS
                __webpack_require__.d(__webpack_exports__, {
                    "__DO_NOT_USE__ActionTypes": function() {
                        return /* binding */ ActionTypes;
                    },
                    "applyMiddleware": function() {
                        return /* binding */ applyMiddleware;
                    },
                    "bindActionCreators": function() {
                        return /* binding */ bindActionCreators;
                    },
                    "combineReducers": function() {
                        return /* binding */ combineReducers;
                    },
                    "compose": function() {
                        return /* binding */ compose;
                    },
                    "createStore": function() {
                        return /* binding */ createStore;
                    },
                    "legacy_createStore": function() {
                        return /* binding */ legacy_createStore;
                    }
                });
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                        return typeof obj;
                    } : function(obj) {
                        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    }, _typeof(obj);
                }
                function _toPrimitive(input, hint) {
                    if (_typeof(input) !== "object" || input === null) return input;
                    var prim = input[Symbol.toPrimitive];
                    if (prim !== undefined) {
                        var res = prim.call(input, hint || "default");
                        if (_typeof(res) !== "object") return res;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return (hint === "string" ? String : Number)(input);
                }
                function _toPropertyKey(arg) {
                    var key = _toPrimitive(arg, "string");
                    return _typeof(key) === "symbol" ? key : String(key);
                }
                function _defineProperty(obj, key, value) {
                    key = _toPropertyKey(key);
                    if (key in obj) Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                    else obj[key] = value;
                    return obj;
                }
                function ownKeys(object, enumerableOnly) {
                    var keys = Object.keys(object);
                    if (Object.getOwnPropertySymbols) {
                        var symbols = Object.getOwnPropertySymbols(object);
                        enumerableOnly && (symbols = symbols.filter(function(sym) {
                            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                        })), keys.push.apply(keys, symbols);
                    }
                    return keys;
                }
                function _objectSpread2(target) {
                    for(var i = 1; i < arguments.length; i++){
                        var source = null != arguments[i] ? arguments[i] : {};
                        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
                            _defineProperty(target, key, source[key]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
                            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                        });
                    }
                    return target;
                }
                /**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function formatProdErrorMessage(code) {
                    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + "use the non-minified dev environment for full errors. ";
                }
                // Inlined version of the `symbol-observable` polyfill
                var $$observable = function() {
                    return typeof Symbol === "function" && Symbol.observable || "@@observable";
                }();
                /**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var randomString = function randomString() {
                    return Math.random().toString(36).substring(7).split("").join(".");
                };
                var ActionTypes = {
                    INIT: "@@redux/INIT" + randomString(),
                    REPLACE: "@@redux/REPLACE" + randomString(),
                    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
                        return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
                    }
                };
                /**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function isPlainObject(obj) {
                    if (typeof obj !== "object" || obj === null) return false;
                    var proto = obj;
                    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
                    return Object.getPrototypeOf(obj) === proto;
                }
                // Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
                function miniKindOf(val) {
                    if (val === void 0) return "undefined";
                    if (val === null) return "null";
                    var type = typeof val;
                    switch(type){
                        case "boolean":
                        case "string":
                        case "number":
                        case "symbol":
                        case "function":
                            return type;
                    }
                    if (Array.isArray(val)) return "array";
                    if (isDate(val)) return "date";
                    if (isError(val)) return "error";
                    var constructorName = ctorName(val);
                    switch(constructorName){
                        case "Symbol":
                        case "Promise":
                        case "WeakMap":
                        case "WeakSet":
                        case "Map":
                        case "Set":
                            return constructorName;
                    } // other
                    return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
                }
                function ctorName(val) {
                    return typeof val.constructor === "function" ? val.constructor.name : null;
                }
                function isError(val) {
                    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
                }
                function isDate(val) {
                    if (val instanceof Date) return true;
                    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
                }
                function kindOf(val) {
                    var typeOfVal = typeof val;
                    return typeOfVal;
                }
                /**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function createStore(reducer, preloadedState, enhancer) {
                    var _ref2;
                    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error(formatProdErrorMessage(0));
                    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
                        enhancer = preloadedState;
                        preloadedState = undefined;
                    }
                    if (typeof enhancer !== "undefined") {
                        if (typeof enhancer !== "function") throw new Error(formatProdErrorMessage(1));
                        return enhancer(createStore)(reducer, preloadedState);
                    }
                    if (typeof reducer !== "function") throw new Error(formatProdErrorMessage(2));
                    var currentReducer = reducer;
                    var currentState = preloadedState;
                    var currentListeners = [];
                    var nextListeners = currentListeners;
                    var isDispatching = false;
                    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
                        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
                    }
                    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
                        if (isDispatching) throw new Error(formatProdErrorMessage(3));
                        return currentState;
                    }
                    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
                        if (typeof listener !== "function") throw new Error(formatProdErrorMessage(4));
                        if (isDispatching) throw new Error(formatProdErrorMessage(5));
                        var isSubscribed = true;
                        ensureCanMutateNextListeners();
                        nextListeners.push(listener);
                        return function unsubscribe() {
                            if (!isSubscribed) return;
                            if (isDispatching) throw new Error(formatProdErrorMessage(6));
                            isSubscribed = false;
                            ensureCanMutateNextListeners();
                            var index = nextListeners.indexOf(listener);
                            nextListeners.splice(index, 1);
                            currentListeners = null;
                        };
                    }
                    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
                        if (!isPlainObject(action)) throw new Error(formatProdErrorMessage(7));
                        if (typeof action.type === "undefined") throw new Error(formatProdErrorMessage(8));
                        if (isDispatching) throw new Error(formatProdErrorMessage(9));
                        try {
                            isDispatching = true;
                            currentState = currentReducer(currentState, action);
                        } finally{
                            isDispatching = false;
                        }
                        var listeners = currentListeners = nextListeners;
                        for(var i = 0; i < listeners.length; i++){
                            var listener = listeners[i];
                            listener();
                        }
                        return action;
                    }
                    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
                        if (typeof nextReducer !== "function") throw new Error(formatProdErrorMessage(10));
                        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
                        // Any reducers that existed in both the new and old rootReducer
                        // will receive the previous state. This effectively populates
                        // the new state tree with any relevant data from the old one.
                        dispatch({
                            type: ActionTypes.REPLACE
                        });
                    }
                    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
                        var _ref;
                        var outerSubscribe = subscribe;
                        return _ref = {
                            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                                if (typeof observer !== "object" || observer === null) throw new Error(formatProdErrorMessage(11));
                                function observeState() {
                                    if (observer.next) observer.next(getState());
                                }
                                observeState();
                                var unsubscribe = outerSubscribe(observeState);
                                return {
                                    unsubscribe: unsubscribe
                                };
                            }
                        }, _ref[$$observable] = function() {
                            return this;
                        }, _ref;
                    } // When a store is created, an "INIT" action is dispatched so that every
                    // reducer returns their initial state. This effectively populates
                    // the initial state tree.
                    dispatch({
                        type: ActionTypes.INIT
                    });
                    return _ref2 = {
                        dispatch: dispatch,
                        subscribe: subscribe,
                        getState: getState,
                        replaceReducer: replaceReducer
                    }, _ref2[$$observable] = observable, _ref2;
                }
                /**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var legacy_createStore = createStore;
                /**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function warning(message) {
                    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
                    /* eslint-enable no-console */ try {
                        // This error was thrown as a convenience so that if you enable
                        // "break on all exceptions" in your console,
                        // it would pause the execution at this line.
                        throw new Error(message);
                    } catch (e) {} // eslint-disable-line no-empty
                }
                function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
                    var reducerKeys = Object.keys(reducers);
                    var argumentName = action && action.type === ActionTypes.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
                    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
                    if (!isPlainObject(inputState)) return "The " + argumentName + ' has unexpected type of "' + kindOf(inputState) + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
                    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
                        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
                    });
                    unexpectedKeys.forEach(function(key) {
                        unexpectedKeyCache[key] = true;
                    });
                    if (action && action.type === ActionTypes.REPLACE) return;
                    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? "keys" : "key") + " " + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
                }
                function assertReducerShape(reducers) {
                    Object.keys(reducers).forEach(function(key) {
                        var reducer = reducers[key];
                        var initialState = reducer(undefined, {
                            type: ActionTypes.INIT
                        });
                        if (typeof initialState === "undefined") throw new Error(formatProdErrorMessage(12));
                        if (typeof reducer(undefined, {
                            type: ActionTypes.PROBE_UNKNOWN_ACTION()
                        }) === "undefined") throw new Error(formatProdErrorMessage(13));
                    });
                }
                /**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function combineReducers(reducers) {
                    var reducerKeys = Object.keys(reducers);
                    var finalReducers = {};
                    for(var i = 0; i < reducerKeys.length; i++){
                        var key = reducerKeys[i];
                        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
                    }
                    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
                    // keys multiple times.
                    var unexpectedKeyCache;
                    var shapeAssertionError;
                    try {
                        assertReducerShape(finalReducers);
                    } catch (e) {
                        shapeAssertionError = e;
                    }
                    return function combination(state, action) {
                        if (state === void 0) state = {};
                        if (shapeAssertionError) throw shapeAssertionError;
                        var warningMessage;
                        var hasChanged = false;
                        var nextState = {};
                        for(var _i = 0; _i < finalReducerKeys.length; _i++){
                            var _key = finalReducerKeys[_i];
                            var reducer = finalReducers[_key];
                            var previousStateForKey = state[_key];
                            var nextStateForKey = reducer(previousStateForKey, action);
                            if (typeof nextStateForKey === "undefined") {
                                var actionType = action && action.type;
                                throw new Error(formatProdErrorMessage(14));
                            }
                            nextState[_key] = nextStateForKey;
                            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
                        }
                        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
                        return hasChanged ? nextState : state;
                    };
                }
                function bindActionCreator(actionCreator, dispatch) {
                    return function() {
                        return dispatch(actionCreator.apply(this, arguments));
                    };
                }
                /**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function bindActionCreators(actionCreators, dispatch) {
                    if (typeof actionCreators === "function") return bindActionCreator(actionCreators, dispatch);
                    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error(formatProdErrorMessage(16));
                    var boundActionCreators = {};
                    for(var key in actionCreators){
                        var actionCreator = actionCreators[key];
                        if (typeof actionCreator === "function") boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
                    }
                    return boundActionCreators;
                }
                /**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function compose() {
                    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
                    if (funcs.length === 0) return function(arg) {
                        return arg;
                    };
                    if (funcs.length === 1) return funcs[0];
                    return funcs.reduce(function(a, b) {
                        return function() {
                            return a(b.apply(void 0, arguments));
                        };
                    });
                }
                /**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function applyMiddleware() {
                    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
                    return function(createStore) {
                        return function() {
                            var store = createStore.apply(void 0, arguments);
                            var _dispatch = function dispatch() {
                                throw new Error(formatProdErrorMessage(15));
                            };
                            var middlewareAPI = {
                                getState: store.getState,
                                dispatch: function dispatch() {
                                    return _dispatch.apply(void 0, arguments);
                                }
                            };
                            var chain = middlewares.map(function(middleware) {
                                return middleware(middlewareAPI);
                            });
                            _dispatch = compose.apply(void 0, chain)(store.dispatch);
                            return _objectSpread2(_objectSpread2({}, store), {}, {
                                dispatch: _dispatch
                            });
                        };
                    };
                }
                /*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */ function isCrushed() {}
            /***/ }
        };
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ var cachedModule = __webpack_module_cache__[moduleId];
            /******/ if (cachedModule !== undefined) /******/ return cachedModule.exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                /******/ // no module.id needed
                /******/ // no module.loaded needed
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /************************************************************************/ /******/ /* webpack/runtime/compat get default export */ /******/ !function() {
            /******/ // getDefaultExport function for compatibility with non-harmony modules
            /******/ __webpack_require__.n = function(module1) {
                /******/ var getter = module1 && module1.__esModule ? /******/ function() {
                    return module1["default"];
                } : /******/ function() {
                    return module1;
                };
                /******/ __webpack_require__.d(getter, {
                    a: getter
                });
                /******/ return getter;
            /******/ };
        /******/ }();
        /******/ /******/ /* webpack/runtime/define property getters */ /******/ !function() {
            /******/ // define getter functions for harmony exports
            /******/ __webpack_require__.d = function(exports, definition) {
                /******/ for(var key in definition)/******/ if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) /******/ Object.defineProperty(exports, key, {
                    enumerable: true,
                    get: definition[key]
                });
            /******/ };
        /******/ }();
        /******/ /******/ /* webpack/runtime/hasOwnProperty shorthand */ /******/ !function() {
            /******/ __webpack_require__.o = function(obj, prop) {
                return Object.prototype.hasOwnProperty.call(obj, prop);
            };
        /******/ }();
        /******/ /******/ /* webpack/runtime/make namespace object */ /******/ !function() {
            /******/ // define __esModule on exports
            /******/ __webpack_require__.r = function(exports) {
                /******/ if (typeof Symbol !== "undefined" && Symbol.toStringTag) /******/ Object.defineProperty(exports, Symbol.toStringTag, {
                    value: "Module"
                });
                /******/ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /******/ };
        /******/ }();
        /******/ /************************************************************************/ var __webpack_exports__ = {};
        // This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
        !function() {
            /* harmony import */ var _scripts_choices__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(373);
            /* harmony import */ var _scripts_choices__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_scripts_choices__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _scripts_interfaces__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(187);
            /* harmony import */ var _scripts_interfaces__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/ __webpack_require__.n(_scripts_interfaces__WEBPACK_IMPORTED_MODULE_1__);
            /* harmony import */ var _scripts_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(883);
            /* harmony import */ var _scripts_defaults__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(789);
            /* harmony import */ var _scripts_templates__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(686);
            /* harmony default export */ __webpack_exports__["default"] = _scripts_choices__WEBPACK_IMPORTED_MODULE_0___default();
        }();
        __webpack_exports__ = __webpack_exports__["default"];
        /******/ return __webpack_exports__;
    /******/ }();
});




const $261e7c68d74e4f8b$export$8e2ba63ee7f5f724 = {
    "1851_3GHG": [
        {
            "Country": "United States",
            "Abs_contribution": 0.281992796431578,
            "Perc_contribution": 17.26,
            "Fossil_abs": 0.221172179072526,
            "Land_abs": 0.0608206173590514,
            "Fossil_fraction": 78.431854242841,
            "Land_fraction": 21.568145757159,
            "Rank": 1,
            "Perc_contribution_rescale": 100
        },
        {
            "Country": "China",
            "Abs_contribution": 0.20688858992886,
            "Perc_contribution": 12.67,
            "Fossil_abs": 0.169442541235036,
            "Land_abs": 0.037446048693824,
            "Fossil_fraction": 81.9003799548829,
            "Land_fraction": 18.0996200451171,
            "Rank": 2,
            "Perc_contribution_rescale": 73.4067207415991
        },
        {
            "Country": "EU27",
            "Abs_contribution": 0.168565743159641,
            "Perc_contribution": 10.32,
            "Fossil_abs": 0.151240731624683,
            "Land_abs": 0.0173250115349577,
            "Fossil_fraction": 89.7221041415574,
            "Land_fraction": 10.2778958584426,
            "Rank": 3,
            "Perc_contribution_rescale": 59.7914252607184
        },
        {
            "Country": "Russia",
            "Abs_contribution": 0.104924459021737,
            "Perc_contribution": 6.42,
            "Fossil_abs": 0.0724955940322009,
            "Land_abs": 0.0324288649895365,
            "Fossil_fraction": 69.093131104142,
            "Land_fraction": 30.9068688958579,
            "Rank": 4,
            "Perc_contribution_rescale": 37.1958285052144
        },
        {
            "Country": "Brazil",
            "Abs_contribution": 0.081652540411128,
            "Perc_contribution": 5,
            "Fossil_abs": 0.0168226640696014,
            "Land_abs": 0.0648298763415265,
            "Fossil_fraction": 20.6027442439608,
            "Land_fraction": 79.3972557560392,
            "Rank": 5,
            "Perc_contribution_rescale": 28.9687137891078
        },
        {
            "Country": "India",
            "Abs_contribution": 0.0780014986701412,
            "Perc_contribution": 4.78,
            "Fossil_abs": 0.0413018131296691,
            "Land_abs": 0.036699685540472,
            "Fossil_fraction": 52.9500251069911,
            "Land_fraction": 47.0499748930088,
            "Rank": 6,
            "Perc_contribution_rescale": 27.694090382387
        },
        {
            "Country": "Indonesia",
            "Abs_contribution": 0.0596254833658213,
            "Perc_contribution": 3.65,
            "Fossil_abs": 0.0174973355930542,
            "Land_abs": 0.0421281477727669,
            "Fossil_fraction": 29.3453983185386,
            "Land_fraction": 70.6546016814611,
            "Rank": 7,
            "Perc_contribution_rescale": 21.1471610660487
        },
        {
            "Country": "Germany",
            "Abs_contribution": 0.0475285817899558,
            "Perc_contribution": 2.91,
            "Fossil_abs": 0.0456026516516033,
            "Land_abs": 0.0019259301383524,
            "Fossil_fraction": 95.9478485033201,
            "Land_fraction": 4.05215149667985,
            "Rank": 8,
            "Perc_contribution_rescale": 16.8597914252607
        },
        {
            "Country": "United Kingdom",
            "Abs_contribution": 0.0397424001320004,
            "Perc_contribution": 2.43,
            "Fossil_abs": 0.0362601228178971,
            "Land_abs": 0.00348227731410326,
            "Fossil_fraction": 91.2378786823713,
            "Land_fraction": 8.76212131762858,
            "Rank": 9,
            "Perc_contribution_rescale": 14.0787949015064
        },
        {
            "Country": "Canada",
            "Abs_contribution": 0.0347968906426257,
            "Perc_contribution": 2.13,
            "Fossil_abs": 0.0201965155396172,
            "Land_abs": 0.0146003751030085,
            "Fossil_fraction": 58.0411501333305,
            "Land_fraction": 41.9588498666695,
            "Rank": 10,
            "Perc_contribution_rescale": 12.3406720741599
        },
        {
            "Country": "Japan",
            "Abs_contribution": 0.0346073485281795,
            "Perc_contribution": 2.12,
            "Fossil_abs": 0.0321599604190179,
            "Land_abs": 0.00244738810916158,
            "Fossil_fraction": 92.9281259234041,
            "Land_fraction": 7.07187407659607,
            "Rank": 11,
            "Perc_contribution_rescale": 12.2827346465817
        },
        {
            "Country": "Australia",
            "Abs_contribution": 0.0248180993046489,
            "Perc_contribution": 1.52,
            "Fossil_abs": 0.0114823746569899,
            "Land_abs": 0.0133357246476591,
            "Fossil_fraction": 46.2661322933742,
            "Land_fraction": 53.7338677066258,
            "Rank": 12,
            "Perc_contribution_rescale": 8.80648899188876
        },
        {
            "Country": "Mexico",
            "Abs_contribution": 0.0232446004149544,
            "Perc_contribution": 1.42,
            "Fossil_abs": 0.0151309493353638,
            "Land_abs": 0.0081136510795905,
            "Fossil_fraction": 65.0944695337907,
            "Land_fraction": 34.9055304662093,
            "Rank": 13,
            "Perc_contribution_rescale": 8.2271147161066
        },
        {
            "Country": "Ukraine",
            "Abs_contribution": 0.0224167627763232,
            "Perc_contribution": 1.37,
            "Fossil_abs": 0.0166743789907257,
            "Land_abs": 0.00574238378559746,
            "Fossil_fraction": 74.3835278853795,
            "Land_fraction": 25.6164721146205,
            "Rank": 14,
            "Perc_contribution_rescale": 7.93742757821553
        },
        {
            "Country": "France",
            "Abs_contribution": 0.0214048255081505,
            "Perc_contribution": 1.31,
            "Fossil_abs": 0.0200059549876873,
            "Land_abs": 0.0013988705204632,
            "Fossil_fraction": 93.4646955195663,
            "Land_fraction": 6.53530448043385,
            "Rank": 15,
            "Perc_contribution_rescale": 7.58980301274623
        },
        {
            "Country": "Nigeria",
            "Abs_contribution": 0.0192327903235136,
            "Perc_contribution": 1.18,
            "Fossil_abs": 0.0116839765881343,
            "Land_abs": 0.00754881373537944,
            "Fossil_fraction": 60.7502935954627,
            "Land_fraction": 39.2497064045377,
            "Rank": 16,
            "Perc_contribution_rescale": 6.83661645422943
        },
        {
            "Country": "Argentina",
            "Abs_contribution": 0.0188684065271042,
            "Perc_contribution": 1.16,
            "Fossil_abs": 0.00586167089660972,
            "Land_abs": 0.0130067356304945,
            "Fossil_fraction": 31.0660621403801,
            "Land_fraction": 68.9339378596199,
            "Rank": 17,
            "Perc_contribution_rescale": 6.720741599073
        },
        {
            "Country": "Iran",
            "Abs_contribution": 0.0185308665666773,
            "Perc_contribution": 1.13,
            "Fossil_abs": 0.0166754910251401,
            "Land_abs": 0.00185537554153719,
            "Fossil_fraction": 89.9876482577801,
            "Land_fraction": 10.0123517422201,
            "Rank": 18,
            "Perc_contribution_rescale": 6.54692931633835
        },
        {
            "Country": "South Africa",
            "Abs_contribution": 0.0169976904759362,
            "Perc_contribution": 1.04,
            "Fossil_abs": 0.0133871141236915,
            "Land_abs": 0.00361057635224472,
            "Fossil_fraction": 78.7584298151785,
            "Land_fraction": 21.2415701848216,
            "Rank": 19,
            "Perc_contribution_rescale": 6.02549246813441
        },
        {
            "Country": "Poland",
            "Abs_contribution": 0.0162373864863337,
            "Perc_contribution": 0.99,
            "Fossil_abs": 0.0152020637268158,
            "Land_abs": 0.00103532275951803,
            "Fossil_fraction": 93.6238337346386,
            "Land_fraction": 6.3761662653618,
            "Rank": 20,
            "Perc_contribution_rescale": 5.73580533024334
        },
        {
            "Country": "Thailand",
            "Abs_contribution": 0.0144400084678937,
            "Perc_contribution": 0.88,
            "Fossil_abs": 0.00594867356522061,
            "Land_abs": 0.00849133490267313,
            "Fossil_fraction": 41.1957761551667,
            "Land_fraction": 58.8042238448334,
            "Rank": 21,
            "Perc_contribution_rescale": 5.09849362688297
        },
        {
            "Country": "Colombia",
            "Abs_contribution": 0.0144306349366217,
            "Perc_contribution": 0.88,
            "Fossil_abs": 0.00340550584965385,
            "Land_abs": 0.0110251290869678,
            "Fossil_fraction": 23.5991407489039,
            "Land_fraction": 76.400859251096,
            "Rank": 22,
            "Perc_contribution_rescale": 5.09849362688297
        },
        {
            "Country": "Italy",
            "Abs_contribution": 0.0144132747635377,
            "Perc_contribution": 0.88,
            "Fossil_abs": 0.0130726897885694,
            "Land_abs": 0.00134058497496826,
            "Fossil_fraction": 90.6989563651442,
            "Land_fraction": 9.30104363485555,
            "Rank": 23,
            "Perc_contribution_rescale": 5.09849362688297
        },
        {
            "Country": "Kazakhstan",
            "Abs_contribution": 0.0143981736578036,
            "Perc_contribution": 0.88,
            "Fossil_abs": 0.00854660744881777,
            "Land_abs": 0.00585156620898581,
            "Fossil_fraction": 59.3589690744259,
            "Land_fraction": 40.6410309255741,
            "Rank": 24,
            "Perc_contribution_rescale": 5.09849362688297
        },
        {
            "Country": "Saudi Arabia",
            "Abs_contribution": 0.012889036775948,
            "Perc_contribution": 0.79,
            "Fossil_abs": 0.0127448542601991,
            "Land_abs": 0.000144182515748858,
            "Fossil_fraction": 98.8813553855482,
            "Land_fraction": 1.11864461445183,
            "Rank": 25,
            "Perc_contribution_rescale": 4.57705677867903
        },
        {
            "Country": "Pakistan",
            "Abs_contribution": 0.012452071376938,
            "Perc_contribution": 0.76,
            "Fossil_abs": 0.00545832363581103,
            "Land_abs": 0.00699374774112704,
            "Fossil_fraction": 43.8346638931108,
            "Land_fraction": 56.1653361068896,
            "Rank": 26,
            "Perc_contribution_rescale": 4.40324449594438
        },
        {
            "Country": "Democratic Republic of the Congo",
            "Abs_contribution": 0.011547030800435,
            "Perc_contribution": 0.71,
            "Fossil_abs": 0.00141305173169621,
            "Land_abs": 0.0101339790687388,
            "Fossil_fraction": 12.2373600288914,
            "Land_fraction": 87.7626399711087,
            "Rank": 27,
            "Perc_contribution_rescale": 4.1135573580533
        },
        {
            "Country": "Viet Nam",
            "Abs_contribution": 0.0112862195449404,
            "Perc_contribution": 0.69,
            "Fossil_abs": 0.00453838988683326,
            "Land_abs": 0.00674782965810709,
            "Fossil_fraction": 40.2117810021499,
            "Land_fraction": 59.78821899785,
            "Rank": 28,
            "Perc_contribution_rescale": 3.99768250289687
        },
        {
            "Country": "Philippines",
            "Abs_contribution": 0.0111731139378926,
            "Perc_contribution": 0.68,
            "Fossil_abs": 0.00315017076686307,
            "Land_abs": 0.0080229431710296,
            "Fossil_fraction": 28.1942060590607,
            "Land_fraction": 71.8057939409398,
            "Rank": 29,
            "Perc_contribution_rescale": 3.93974507531866
        },
        {
            "Country": "South Korea",
            "Abs_contribution": 0.0110430551932504,
            "Perc_contribution": 0.68,
            "Fossil_abs": 0.0100438599803861,
            "Land_abs": 0.000999195212864293,
            "Fossil_fraction": 90.9518227032405,
            "Land_fraction": 9.0481772967594,
            "Rank": 30,
            "Perc_contribution_rescale": 3.93974507531866
        },
        {
            "Country": "Malaysia",
            "Abs_contribution": 0.0108959947392514,
            "Perc_contribution": 0.67,
            "Fossil_abs": 0.00517804100246124,
            "Land_abs": 0.00571795373679016,
            "Fossil_fraction": 47.5224256837057,
            "Land_fraction": 52.4775743162941,
            "Rank": 31,
            "Perc_contribution_rescale": 3.88180764774044
        },
        {
            "Country": "T\xfcrkiye",
            "Abs_contribution": 0.010659290944478,
            "Perc_contribution": 0.65,
            "Fossil_abs": 0.00808453700989928,
            "Land_abs": 0.00257475393457867,
            "Fossil_fraction": 75.8449792956207,
            "Land_fraction": 24.1550207043792,
            "Rank": 32,
            "Perc_contribution_rescale": 3.76593279258401
        },
        {
            "Country": "Myanmar",
            "Abs_contribution": 0.0103968246155729,
            "Perc_contribution": 0.64,
            "Fossil_abs": 0.00119714279217575,
            "Land_abs": 0.0091996818233971,
            "Fossil_fraction": 11.5145040571581,
            "Land_fraction": 88.4854959428414,
            "Rank": 33,
            "Perc_contribution_rescale": 3.70799536500579
        },
        {
            "Country": "Venezuela",
            "Abs_contribution": 0.0102591049524226,
            "Perc_contribution": 0.63,
            "Fossil_abs": 0.00577396150063711,
            "Land_abs": 0.00448514345178547,
            "Fossil_fraction": 56.2813376743322,
            "Land_fraction": 43.7186623256674,
            "Rank": 34,
            "Perc_contribution_rescale": 3.65005793742758
        },
        {
            "Country": "Spain",
            "Abs_contribution": 0.00992171982528501,
            "Perc_contribution": 0.61,
            "Fossil_abs": 0.00814612669513357,
            "Land_abs": 0.00177559313015148,
            "Fossil_fraction": 82.1039783281681,
            "Land_fraction": 17.8960216718322,
            "Rank": 35,
            "Perc_contribution_rescale": 3.53418308227115
        },
        {
            "Country": "Ethiopia",
            "Abs_contribution": 0.00808068319472726,
            "Perc_contribution": 0.49,
            "Fossil_abs": 0.00157615498080026,
            "Land_abs": 0.00650452821392696,
            "Fossil_fraction": 19.50521933379,
            "Land_fraction": 80.4947806662096,
            "Rank": 36,
            "Perc_contribution_rescale": 2.83893395133256
        },
        {
            "Country": "Netherlands",
            "Abs_contribution": 0.00756585982080089,
            "Perc_contribution": 0.46,
            "Fossil_abs": 0.00629987540482475,
            "Land_abs": 0.00126598441597615,
            "Fossil_fraction": 83.2671441718288,
            "Land_fraction": 16.7328558281713,
            "Rank": 37,
            "Perc_contribution_rescale": 2.66512166859791
        },
        {
            "Country": "Iraq",
            "Abs_contribution": 0.00755169982991757,
            "Perc_contribution": 0.46,
            "Fossil_abs": 0.00709631736315118,
            "Land_abs": 0.000455382466766404,
            "Fossil_fraction": 93.9698018059154,
            "Land_fraction": 6.03019819408493,
            "Rank": 38,
            "Perc_contribution_rescale": 2.66512166859791
        },
        {
            "Country": "Egypt",
            "Abs_contribution": 0.00707133328603377,
            "Perc_contribution": 0.43,
            "Fossil_abs": 0.00578348883354496,
            "Land_abs": 0.00128784445248884,
            "Fossil_fraction": 81.7878128438329,
            "Land_fraction": 18.2121871561675,
            "Rank": 39,
            "Perc_contribution_rescale": 2.49130938586327
        },
        {
            "Country": "Tanzania",
            "Abs_contribution": 0.00698171757154036,
            "Perc_contribution": 0.43,
            "Fossil_abs": 0.000904568017817066,
            "Land_abs": 0.00607714955372327,
            "Fossil_fraction": 12.9562390421573,
            "Land_fraction": 87.0437609578424,
            "Rank": 40,
            "Perc_contribution_rescale": 2.49130938586327
        },
        {
            "Country": "Bangladesh",
            "Abs_contribution": 0.00676543023477739,
            "Perc_contribution": 0.41,
            "Fossil_abs": 0.00246768688154983,
            "Land_abs": 0.00429774335322758,
            "Fossil_fraction": 36.4749438825752,
            "Land_fraction": 63.525056117425,
            "Rank": 41,
            "Perc_contribution_rescale": 2.37543453070684
        },
        {
            "Country": "Angola",
            "Abs_contribution": 0.00672822206986794,
            "Perc_contribution": 0.41,
            "Fossil_abs": 0.00209831901161452,
            "Land_abs": 0.00462990305825343,
            "Fossil_fraction": 31.186827512899,
            "Land_fraction": 68.813172487101,
            "Rank": 42,
            "Perc_contribution_rescale": 2.37543453070684
        },
        {
            "Country": "Belgium",
            "Abs_contribution": 0.00672275600198123,
            "Perc_contribution": 0.41,
            "Fossil_abs": 0.00616862409541811,
            "Land_abs": 0.000554131906563127,
            "Fossil_fraction": 91.7573699476849,
            "Land_fraction": 8.24263005231517,
            "Rank": 43,
            "Perc_contribution_rescale": 2.37543453070684
        },
        {
            "Country": "Algeria",
            "Abs_contribution": 0.00659406566388205,
            "Perc_contribution": 0.4,
            "Fossil_abs": 0.00595170161111901,
            "Land_abs": 0.000642364052763052,
            "Fossil_fraction": 90.258452288677,
            "Land_fraction": 9.74154771132322,
            "Rank": 44,
            "Perc_contribution_rescale": 2.31749710312862
        },
        {
            "Country": "Uzbekistan",
            "Abs_contribution": 0.00646516177449108,
            "Perc_contribution": 0.4,
            "Fossil_abs": 0.00489011776069181,
            "Land_abs": 0.00157504401379927,
            "Fossil_fraction": 75.6379798566873,
            "Land_fraction": 24.3620201433127,
            "Rank": 45,
            "Perc_contribution_rescale": 2.31749710312862
        },
        {
            "Country": "Romania",
            "Abs_contribution": 0.00588948941606115,
            "Perc_contribution": 0.36,
            "Fossil_abs": 0.00483772659242407,
            "Land_abs": 0.00105176282363706,
            "Fossil_fraction": 82.1416977035594,
            "Land_fraction": 17.8583022964404,
            "Rank": 46,
            "Perc_contribution_rescale": 2.08574739281576
        },
        {
            "Country": "Czechia",
            "Abs_contribution": 0.00584086426747249,
            "Perc_contribution": 0.36,
            "Fossil_abs": 0.00604864264091099,
            "Land_abs": -0.0002077783734385,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 47,
            "Perc_contribution_rescale": 2.08574739281576
        },
        {
            "Country": "Belarus",
            "Abs_contribution": 0.00572796553291305,
            "Perc_contribution": 0.35,
            "Fossil_abs": 0.00269870582646676,
            "Land_abs": 0.00302925970644627,
            "Fossil_fraction": 47.114561199084,
            "Land_fraction": 52.8854388009157,
            "Rank": 48,
            "Perc_contribution_rescale": 2.02780996523754
        },
        {
            "Country": "Peru",
            "Abs_contribution": 0.00523228277037295,
            "Perc_contribution": 0.32,
            "Fossil_abs": 0.00168313957720666,
            "Land_abs": 0.00354914319316628,
            "Fossil_fraction": 32.1683603710641,
            "Land_fraction": 67.8316396289359,
            "Rank": 49,
            "Perc_contribution_rescale": 1.8539976825029
        },
        {
            "Country": "Taiwan",
            "Abs_contribution": 0.00519510503336139,
            "Perc_contribution": 0.32,
            "Fossil_abs": 0.0050311685666466,
            "Land_abs": 0.000163936466714788,
            "Fossil_fraction": 96.8444051532732,
            "Land_fraction": 3.15559484672663,
            "Rank": 50,
            "Perc_contribution_rescale": 1.8539976825029
        },
        {
            "Country": "New Zealand",
            "Abs_contribution": 0.00505508121210817,
            "Perc_contribution": 0.31,
            "Fossil_abs": 0.00120405979572666,
            "Land_abs": 0.00385102141638149,
            "Fossil_fraction": 23.8188022151384,
            "Land_fraction": 76.1811977848614,
            "Rank": 51,
            "Perc_contribution_rescale": 1.79606025492468
        },
        {
            "Country": "C\xf4te d'Ivoire",
            "Abs_contribution": 0.00484085163755817,
            "Perc_contribution": 0.3,
            "Fossil_abs": 0.000627140498898971,
            "Land_abs": 0.00421371113865923,
            "Fossil_fraction": 12.9551687565313,
            "Land_fraction": 87.0448312434693,
            "Rank": 52,
            "Perc_contribution_rescale": 1.73812282734647
        },
        {
            "Country": "Bolivia",
            "Abs_contribution": 0.00472523030412252,
            "Perc_contribution": 0.29,
            "Fossil_abs": 0.000724058168267918,
            "Land_abs": 0.00400117213585459,
            "Fossil_fraction": 15.3232355179855,
            "Land_fraction": 84.6767644820143,
            "Rank": 53,
            "Perc_contribution_rescale": 1.68018539976825
        },
        {
            "Country": "Sudan",
            "Abs_contribution": 0.00462667482435357,
            "Perc_contribution": 0.28,
            "Fossil_abs": 0.000923499027204242,
            "Land_abs": 0.00370317579714933,
            "Fossil_fraction": 19.9603184201144,
            "Land_fraction": 80.0396815798855,
            "Rank": 54,
            "Perc_contribution_rescale": 1.62224797219003
        },
        {
            "Country": "United Arab Emirates",
            "Abs_contribution": 0.00442515404711608,
            "Perc_contribution": 0.27,
            "Fossil_abs": 0.00437819873773829,
            "Land_abs": 4.6955309377784e-05,
            "Fossil_fraction": 98.9389000048849,
            "Land_fraction": 1.06109999511509,
            "Rank": 55,
            "Perc_contribution_rescale": 1.56431054461182
        },
        {
            "Country": "Madagascar",
            "Abs_contribution": 0.00427544808928412,
            "Perc_contribution": 0.26,
            "Fossil_abs": 0.000385946001878363,
            "Land_abs": 0.00388950208740575,
            "Fossil_fraction": 9.02703047303249,
            "Land_fraction": 90.9729695269674,
            "Rank": 56,
            "Perc_contribution_rescale": 1.5063731170336
        },
        {
            "Country": "Chile",
            "Abs_contribution": 0.00415286368943435,
            "Perc_contribution": 0.25,
            "Fossil_abs": 0.00227654728336363,
            "Land_abs": 0.00187631640607071,
            "Fossil_fraction": 54.81873361641,
            "Land_fraction": 45.1812663835898,
            "Rank": 57,
            "Perc_contribution_rescale": 1.44843568945539
        },
        {
            "Country": "Qatar",
            "Abs_contribution": 0.00396527699768294,
            "Perc_contribution": 0.24,
            "Fossil_abs": 0.0039535266710386,
            "Land_abs": 1.17503266443299e-05,
            "Fossil_fraction": 99.7036694624057,
            "Land_fraction": 0.296330537594121,
            "Rank": 58,
            "Perc_contribution_rescale": 1.39049826187717
        },
        {
            "Country": "Ecuador",
            "Abs_contribution": 0.00395759960998297,
            "Perc_contribution": 0.24,
            "Fossil_abs": 0.00119730205794342,
            "Land_abs": 0.00276029755203954,
            "Fossil_fraction": 30.2532387289317,
            "Land_fraction": 69.746761271068,
            "Rank": 59,
            "Perc_contribution_rescale": 1.39049826187717
        },
        {
            "Country": "North Korea",
            "Abs_contribution": 0.00390699638483928,
            "Perc_contribution": 0.24,
            "Fossil_abs": 0.00313930171367722,
            "Land_abs": 0.000767694671162061,
            "Fossil_fraction": 80.3507708852503,
            "Land_fraction": 19.6492291147498,
            "Rank": 60,
            "Perc_contribution_rescale": 1.39049826187717
        },
        {
            "Country": "Sweden",
            "Abs_contribution": 0.0038995391196072,
            "Perc_contribution": 0.24,
            "Fossil_abs": 0.00285858705733867,
            "Land_abs": 0.00104095206226854,
            "Fossil_fraction": 73.305766903721,
            "Land_fraction": 26.6942330962793,
            "Rank": 61,
            "Perc_contribution_rescale": 1.39049826187717
        },
        {
            "Country": "Turkmenistan",
            "Abs_contribution": 0.00373972087728743,
            "Perc_contribution": 0.23,
            "Fossil_abs": 0.0028225784076591,
            "Land_abs": 0.000917142469628337,
            "Fossil_fraction": 75.475643778699,
            "Land_fraction": 24.5243562213011,
            "Rank": 62,
            "Perc_contribution_rescale": 1.33256083429896
        },
        {
            "Country": "Kenya",
            "Abs_contribution": 0.00369558020188129,
            "Perc_contribution": 0.23,
            "Fossil_abs": 0.00117384342434962,
            "Land_abs": 0.00252173677753167,
            "Fossil_fraction": 31.7634406568164,
            "Land_fraction": 68.2365593431836,
            "Rank": 63,
            "Perc_contribution_rescale": 1.33256083429896
        },
        {
            "Country": "Finland",
            "Abs_contribution": 0.00352524791088167,
            "Perc_contribution": 0.22,
            "Fossil_abs": 0.00232310855242217,
            "Land_abs": 0.00120213935845951,
            "Fossil_fraction": 65.8991540779655,
            "Land_fraction": 34.1008459220348,
            "Rank": 64,
            "Perc_contribution_rescale": 1.27462340672074
        },
        {
            "Country": "Zambia",
            "Abs_contribution": 0.0035041586928926,
            "Perc_contribution": 0.21,
            "Fossil_abs": 0.000457124592059758,
            "Land_abs": 0.00304703410083285,
            "Fossil_fraction": 13.0452023473404,
            "Land_fraction": 86.9547976526598,
            "Rank": 65,
            "Perc_contribution_rescale": 1.21668597914253
        },
        {
            "Country": "Paraguay",
            "Abs_contribution": 0.00330369688723135,
            "Perc_contribution": 0.2,
            "Fossil_abs": 0.000227260097861477,
            "Land_abs": 0.00307643678936988,
            "Fossil_fraction": 6.87896334375675,
            "Land_fraction": 93.1210366562434,
            "Rank": 66,
            "Perc_contribution_rescale": 1.15874855156431
        },
        {
            "Country": "Mongolia",
            "Abs_contribution": 0.00321306552381351,
            "Perc_contribution": 0.2,
            "Fossil_abs": 0.000797212111588938,
            "Land_abs": 0.00241585341222458,
            "Fossil_fraction": 24.8115734235867,
            "Land_fraction": 75.1884265764136,
            "Rank": 67,
            "Perc_contribution_rescale": 1.15874855156431
        },
        {
            "Country": "Mozambique",
            "Abs_contribution": 0.00315968789822662,
            "Perc_contribution": 0.19,
            "Fossil_abs": 0.000656978142526947,
            "Land_abs": 0.00250270975569966,
            "Fossil_fraction": 20.7925011484735,
            "Land_fraction": 79.2074988515264,
            "Rank": 68,
            "Perc_contribution_rescale": 1.10081112398609
        },
        {
            "Country": "Kuwait",
            "Abs_contribution": 0.0030833937891747,
            "Perc_contribution": 0.19,
            "Fossil_abs": 0.00307215020590225,
            "Land_abs": 1.12435832724454e-05,
            "Fossil_fraction": 99.6353503950122,
            "Land_fraction": 0.364649604987849,
            "Rank": 69,
            "Perc_contribution_rescale": 1.10081112398609
        },
        {
            "Country": "Cuba",
            "Abs_contribution": 0.00305453093086968,
            "Perc_contribution": 0.19,
            "Fossil_abs": 0.0010780960569198,
            "Land_abs": 0.00197643487394987,
            "Fossil_fraction": 35.2949792069333,
            "Land_fraction": 64.7050207930664,
            "Rank": 70,
            "Perc_contribution_rescale": 1.10081112398609
        },
        {
            "Country": "Hungary",
            "Abs_contribution": 0.00299503777175482,
            "Perc_contribution": 0.18,
            "Fossil_abs": 0.00267613172749958,
            "Land_abs": 0.000318906044255239,
            "Fossil_fraction": 89.352186230747,
            "Land_fraction": 10.647813769253,
            "Rank": 71,
            "Perc_contribution_rescale": 1.04287369640788
        },
        {
            "Country": "Greece",
            "Abs_contribution": 0.00298825882103034,
            "Perc_contribution": 0.18,
            "Fossil_abs": 0.00233061015722809,
            "Land_abs": 0.000657648663802241,
            "Fossil_fraction": 77.9922455453342,
            "Land_fraction": 22.0077544546655,
            "Rank": 72,
            "Perc_contribution_rescale": 1.04287369640788
        },
        {
            "Country": "Cameroon",
            "Abs_contribution": 0.0029540542987926,
            "Perc_contribution": 0.18,
            "Fossil_abs": 0.000817001577315447,
            "Land_abs": 0.00213705272147715,
            "Fossil_fraction": 27.6569586973868,
            "Land_fraction": 72.3430413026134,
            "Rank": 73,
            "Perc_contribution_rescale": 1.04287369640788
        },
        {
            "Country": "Austria",
            "Abs_contribution": 0.00292830198070806,
            "Perc_contribution": 0.18,
            "Fossil_abs": 0.00284894339196909,
            "Land_abs": 7.93585887389626e-05,
            "Fossil_fraction": 97.2899451879694,
            "Land_fraction": 2.71005481203048,
            "Rank": 74,
            "Perc_contribution_rescale": 1.04287369640788
        },
        {
            "Country": "Denmark",
            "Abs_contribution": 0.00291946373318207,
            "Perc_contribution": 0.18,
            "Fossil_abs": 0.00207639696085823,
            "Land_abs": 0.00084306677232383,
            "Fossil_fraction": 71.1225468314026,
            "Land_fraction": 28.8774531685971,
            "Rank": 75,
            "Perc_contribution_rescale": 1.04287369640788
        },
        {
            "Country": "Uganda",
            "Abs_contribution": 0.00290511792186464,
            "Perc_contribution": 0.18,
            "Fossil_abs": 0.000710057952886131,
            "Land_abs": 0.00219505996897851,
            "Fossil_fraction": 24.4416224051375,
            "Land_fraction": 75.5583775948627,
            "Rank": 76,
            "Perc_contribution_rescale": 1.04287369640788
        },
        {
            "Country": "Morocco",
            "Abs_contribution": 0.00284104377612112,
            "Perc_contribution": 0.17,
            "Fossil_abs": 0.00174532857281973,
            "Land_abs": 0.00109571520330139,
            "Fossil_fraction": 61.4326532906377,
            "Land_fraction": 38.5673467093623,
            "Rank": 77,
            "Perc_contribution_rescale": 0.984936268829664
        },
        {
            "Country": "Norway",
            "Abs_contribution": 0.00280809927872591,
            "Perc_contribution": 0.17,
            "Fossil_abs": 0.00225700891927495,
            "Land_abs": 0.00055109035945096,
            "Fossil_fraction": 80.3749688044861,
            "Land_fraction": 19.6250311955139,
            "Rank": 78,
            "Perc_contribution_rescale": 0.984936268829664
        },
        {
            "Country": "Libya",
            "Abs_contribution": 0.00269804788161482,
            "Perc_contribution": 0.17,
            "Fossil_abs": 0.00259994602011646,
            "Land_abs": 9.81018614983517e-05,
            "Fossil_fraction": 96.3639688470004,
            "Land_fraction": 3.63603115299927,
            "Rank": 79,
            "Perc_contribution_rescale": 0.984936268829664
        },
        {
            "Country": "Chad",
            "Abs_contribution": 0.0026755020331949,
            "Perc_contribution": 0.16,
            "Fossil_abs": 0.000230439328306079,
            "Land_abs": 0.00244506270488882,
            "Fossil_fraction": 8.61293788780659,
            "Land_fraction": 91.3870621121935,
            "Rank": 80,
            "Perc_contribution_rescale": 0.926998841251448
        },
        {
            "Country": "South Sudan",
            "Abs_contribution": 0.00261803072113932,
            "Perc_contribution": 0.16,
            "Fossil_abs": 0.000215611480091823,
            "Land_abs": 0.0024024192410475,
            "Fossil_fraction": 8.23563598207102,
            "Land_fraction": 91.764364017929,
            "Rank": 81,
            "Perc_contribution_rescale": 0.926998841251448
        },
        {
            "Country": "Guatemala",
            "Abs_contribution": 0.00261195950276097,
            "Perc_contribution": 0.16,
            "Fossil_abs": 0.000653903653178168,
            "Land_abs": 0.00195805584958281,
            "Fossil_fraction": 25.0349843666013,
            "Land_fraction": 74.9650156333987,
            "Rank": 82,
            "Perc_contribution_rescale": 0.926998841251448
        },
        {
            "Country": "Bulgaria",
            "Abs_contribution": 0.00260649982134581,
            "Perc_contribution": 0.16,
            "Fossil_abs": 0.00221309920410031,
            "Land_abs": 0.000393400617245497,
            "Fossil_fraction": 84.9069386453141,
            "Land_fraction": 15.0930613546857,
            "Rank": 83,
            "Perc_contribution_rescale": 0.926998841251448
        },
        {
            "Country": "Cambodia",
            "Abs_contribution": 0.00247209322446969,
            "Perc_contribution": 0.15,
            "Fossil_abs": 0.000293087647817626,
            "Land_abs": 0.00217900557665207,
            "Fossil_fraction": 11.8558493230165,
            "Land_fraction": 88.1441506769835,
            "Rank": 84,
            "Perc_contribution_rescale": 0.869061413673233
        },
        {
            "Country": "Uruguay",
            "Abs_contribution": 0.00232713369154048,
            "Perc_contribution": 0.14,
            "Fossil_abs": 0.000353134656846533,
            "Land_abs": 0.00197399903469395,
            "Fossil_fraction": 15.1746613497212,
            "Land_fraction": 84.8253386502788,
            "Rank": 85,
            "Perc_contribution_rescale": 0.811123986095017
        },
        {
            "Country": "Azerbaijan",
            "Abs_contribution": 0.00223379693854165,
            "Perc_contribution": 0.14,
            "Fossil_abs": 0.001735436990328,
            "Land_abs": 0.000498359948213647,
            "Fossil_fraction": 77.6900066601842,
            "Land_fraction": 22.3099933398157,
            "Rank": 86,
            "Perc_contribution_rescale": 0.811123986095017
        },
        {
            "Country": "Slovakia",
            "Abs_contribution": 0.00217492744515721,
            "Perc_contribution": 0.13,
            "Fossil_abs": 0.00204720898434001,
            "Land_abs": 0.000127718460817194,
            "Fossil_fraction": 94.1276909672741,
            "Land_fraction": 5.87230903272557,
            "Rank": 87,
            "Perc_contribution_rescale": 0.753186558516802
        },
        {
            "Country": "Nicaragua",
            "Abs_contribution": 0.00216931697955621,
            "Perc_contribution": 0.13,
            "Fossil_abs": 0.000191956245060197,
            "Land_abs": 0.00197736073449601,
            "Fossil_fraction": 8.84869509016921,
            "Land_fraction": 91.1513049098308,
            "Rank": 88,
            "Perc_contribution_rescale": 0.753186558516802
        },
        {
            "Country": "Nepal",
            "Abs_contribution": 0.0021452196101379,
            "Perc_contribution": 0.13,
            "Fossil_abs": 0.000411384295829978,
            "Land_abs": 0.00173383531430792,
            "Fossil_fraction": 19.1767916853759,
            "Land_fraction": 80.823208314624,
            "Rank": 89,
            "Perc_contribution_rescale": 0.753186558516802
        },
        {
            "Country": "Oman",
            "Abs_contribution": 0.00214345635563702,
            "Perc_contribution": 0.13,
            "Fossil_abs": 0.00209489624266544,
            "Land_abs": 4.85601129715882e-05,
            "Fossil_fraction": 97.7344949038091,
            "Land_fraction": 2.26550509619107,
            "Rank": 90,
            "Perc_contribution_rescale": 0.753186558516802
        },
        {
            "Country": "Guinea",
            "Abs_contribution": 0.00204652599920085,
            "Perc_contribution": 0.13,
            "Fossil_abs": 0.000250696940770503,
            "Land_abs": 0.00179582905843035,
            "Fossil_fraction": 12.2498781285162,
            "Land_fraction": 87.750121871484,
            "Rank": 91,
            "Perc_contribution_rescale": 0.753186558516802
        },
        {
            "Country": "Serbia",
            "Abs_contribution": 0.0020459571090332,
            "Perc_contribution": 0.13,
            "Fossil_abs": 0.00158565972728084,
            "Land_abs": 0.000460297381752369,
            "Fossil_fraction": 77.5021001310302,
            "Land_fraction": 22.4978998689703,
            "Rank": 92,
            "Perc_contribution_rescale": 0.753186558516802
        },
        {
            "Country": "Ghana",
            "Abs_contribution": 0.00193305370070596,
            "Perc_contribution": 0.12,
            "Fossil_abs": 0.000670787613275715,
            "Land_abs": 0.00126226608743025,
            "Fossil_fraction": 34.7009300895644,
            "Land_fraction": 65.2990699104353,
            "Rank": 93,
            "Perc_contribution_rescale": 0.695249130938586
        },
        {
            "Country": "Portugal",
            "Abs_contribution": 0.00191515830032165,
            "Perc_contribution": 0.12,
            "Fossil_abs": 0.00154540337946262,
            "Land_abs": 0.000369754920859028,
            "Fossil_fraction": 80.6932450024145,
            "Land_fraction": 19.3067549975858,
            "Rank": 94,
            "Perc_contribution_rescale": 0.695249130938586
        },
        {
            "Country": "Syria",
            "Abs_contribution": 0.00188832404754728,
            "Perc_contribution": 0.12,
            "Fossil_abs": 0.00150903872824619,
            "Land_abs": 0.000379285319301096,
            "Fossil_fraction": 79.9141826428711,
            "Land_fraction": 20.0858173571292,
            "Rank": 95,
            "Perc_contribution_rescale": 0.695249130938586
        },
        {
            "Country": "Congo",
            "Abs_contribution": 0.00185306186660128,
            "Perc_contribution": 0.11,
            "Fossil_abs": 0.000741175769951261,
            "Land_abs": 0.00111188609665001,
            "Fossil_fraction": 39.997356985747,
            "Land_fraction": 60.0026430142526,
            "Rank": 96,
            "Perc_contribution_rescale": 0.637311703360371
        },
        {
            "Country": "Switzerland",
            "Abs_contribution": 0.00179542959898708,
            "Perc_contribution": 0.11,
            "Fossil_abs": 0.00150417373971825,
            "Land_abs": 0.000291255859268833,
            "Fossil_fraction": 83.7779292803714,
            "Land_fraction": 16.2220707196289,
            "Rank": 97,
            "Perc_contribution_rescale": 0.637311703360371
        },
        {
            "Country": "Zimbabwe",
            "Abs_contribution": 0.0017903201762935,
            "Perc_contribution": 0.11,
            "Fossil_abs": 0.000645829466820316,
            "Land_abs": 0.00114449070947318,
            "Fossil_fraction": 36.0734060517252,
            "Land_fraction": 63.9265939482749,
            "Rank": 98,
            "Perc_contribution_rescale": 0.637311703360371
        },
        {
            "Country": "Lithuania",
            "Abs_contribution": 0.00178505348870557,
            "Perc_contribution": 0.11,
            "Fossil_abs": 0.000853733651151557,
            "Land_abs": 0.000931319837554012,
            "Fossil_fraction": 47.8267825896153,
            "Land_fraction": 52.1732174103846,
            "Rank": 99,
            "Perc_contribution_rescale": 0.637311703360371
        },
        {
            "Country": "Israel",
            "Abs_contribution": 0.0017161264641423,
            "Perc_contribution": 0.11,
            "Fossil_abs": 0.00164095809561595,
            "Land_abs": 7.5168368526359e-05,
            "Fossil_fraction": 95.6198817454912,
            "Land_fraction": 4.38011825450913,
            "Rank": 100,
            "Perc_contribution_rescale": 0.637311703360371
        },
        {
            "Country": "Niger",
            "Abs_contribution": 0.00168894953844993,
            "Perc_contribution": 0.1,
            "Fossil_abs": 0.000196500910902459,
            "Land_abs": 0.00149244862754747,
            "Fossil_fraction": 11.6345045502545,
            "Land_fraction": 88.3654954497457,
            "Rank": 101,
            "Perc_contribution_rescale": 0.579374275782155
        },
        {
            "Country": "Honduras",
            "Abs_contribution": 0.00163455949699934,
            "Perc_contribution": 0.1,
            "Fossil_abs": 0.000310973533097114,
            "Land_abs": 0.00132358596390222,
            "Fossil_fraction": 19.024913664384,
            "Land_fraction": 80.9750863356155,
            "Rank": 102,
            "Perc_contribution_rescale": 0.579374275782155
        },
        {
            "Country": "Sri Lanka",
            "Abs_contribution": 0.00159129526204192,
            "Perc_contribution": 0.1,
            "Fossil_abs": 0.000592606734506059,
            "Land_abs": 0.000998688527535861,
            "Fossil_fraction": 37.240526547263,
            "Land_fraction": 62.7594734527371,
            "Rank": 103,
            "Perc_contribution_rescale": 0.579374275782155
        },
        {
            "Country": "Trinidad and Tobago",
            "Abs_contribution": 0.0015854541925789,
            "Perc_contribution": 0.1,
            "Fossil_abs": 0.00155817619134561,
            "Land_abs": 2.7278001233301e-05,
            "Fossil_fraction": 98.2794834842294,
            "Land_fraction": 1.72051651577082,
            "Rank": 104,
            "Perc_contribution_rescale": 0.579374275782155
        },
        {
            "Country": "Bahrain",
            "Abs_contribution": 0.00155267698685062,
            "Perc_contribution": 0.1,
            "Fossil_abs": 0.00155129642747486,
            "Land_abs": 1.38055937575529e-06,
            "Fossil_fraction": 99.9110852168579,
            "Land_fraction": 0.0889147831420849,
            "Rank": 105,
            "Perc_contribution_rescale": 0.579374275782155
        },
        {
            "Country": "Somalia",
            "Abs_contribution": 0.00154103618624806,
            "Perc_contribution": 0.09,
            "Fossil_abs": 0.000282251026626858,
            "Land_abs": 0.0012587851596212,
            "Fossil_fraction": 18.3156650794847,
            "Land_fraction": 81.6843349205154,
            "Rank": 106,
            "Perc_contribution_rescale": 0.52143684820394
        },
        {
            "Country": "Laos",
            "Abs_contribution": 0.00149564437561497,
            "Perc_contribution": 0.09,
            "Fossil_abs": 0.000194031080326002,
            "Land_abs": 0.00130161329528896,
            "Fossil_fraction": 12.9730759189478,
            "Land_fraction": 87.0269240810519,
            "Rank": 107,
            "Perc_contribution_rescale": 0.52143684820394
        },
        {
            "Country": "Mali",
            "Abs_contribution": 0.00149511306232227,
            "Perc_contribution": 0.09,
            "Fossil_abs": 0.00020662136351243,
            "Land_abs": 0.00128849169880985,
            "Fossil_fraction": 13.8197818425516,
            "Land_fraction": 86.180218157449,
            "Rank": 108,
            "Perc_contribution_rescale": 0.52143684820394
        },
        {
            "Country": "Burkina Faso",
            "Abs_contribution": 0.00148842794381109,
            "Perc_contribution": 0.09,
            "Fossil_abs": 0.000285870705404306,
            "Land_abs": 0.00120255723840677,
            "Fossil_fraction": 19.2062173108857,
            "Land_fraction": 80.7937826891137,
            "Rank": 109,
            "Perc_contribution_rescale": 0.52143684820394
        },
        {
            "Country": "Gabon",
            "Abs_contribution": 0.00139222839691439,
            "Perc_contribution": 0.09,
            "Fossil_abs": 0.000789559850839215,
            "Land_abs": 0.000602668546075175,
            "Fossil_fraction": 56.7119484553773,
            "Land_fraction": 43.2880515446227,
            "Rank": 110,
            "Perc_contribution_rescale": 0.52143684820394
        },
        {
            "Country": "Dominican Republic",
            "Abs_contribution": 0.00138993993807716,
            "Perc_contribution": 0.09,
            "Fossil_abs": 0.000592504890112884,
            "Land_abs": 0.000797435047964277,
            "Fossil_fraction": 42.6280930478589,
            "Land_fraction": 57.3719069521412,
            "Rank": 111,
            "Perc_contribution_rescale": 0.52143684820394
        },
        {
            "Country": "Afghanistan",
            "Abs_contribution": 0.00134621058982505,
            "Perc_contribution": 0.08,
            "Fossil_abs": 0.00034602036403515,
            "Land_abs": 0.0010001902257899,
            "Fossil_fraction": 25.7032864434767,
            "Land_fraction": 74.2967135565232,
            "Rank": 112,
            "Perc_contribution_rescale": 0.463499420625724
        },
        {
            "Country": "Singapore",
            "Abs_contribution": 0.00130097604386224,
            "Perc_contribution": 0.08,
            "Fossil_abs": 0.00128958138107185,
            "Land_abs": 1.13946627903892e-05,
            "Fossil_fraction": 99.1241450721445,
            "Land_fraction": 0.875854927855673,
            "Rank": 113,
            "Perc_contribution_rescale": 0.463499420625724
        },
        {
            "Country": "Central African Republic",
            "Abs_contribution": 0.00125415614355622,
            "Perc_contribution": 0.08,
            "Fossil_abs": 6.64500894909945e-05,
            "Land_abs": 0.00118770605406523,
            "Fossil_fraction": 5.2983904621774,
            "Land_fraction": 94.701609537823,
            "Rank": 114,
            "Perc_contribution_rescale": 0.463499420625724
        },
        {
            "Country": "Tunisia",
            "Abs_contribution": 0.00122194685482941,
            "Perc_contribution": 0.07,
            "Fossil_abs": 0.000829583558907794,
            "Land_abs": 0.000392363295921617,
            "Fossil_fraction": 67.890314184213,
            "Land_fraction": 32.1096858157872,
            "Rank": 115,
            "Perc_contribution_rescale": 0.405561993047509
        },
        {
            "Country": "Panama",
            "Abs_contribution": 0.00116559191734897,
            "Perc_contribution": 0.07,
            "Fossil_abs": 0.000230618289084689,
            "Land_abs": 0.000934973628264274,
            "Fossil_fraction": 19.785508603149,
            "Land_fraction": 80.2144913968506,
            "Rank": 116,
            "Perc_contribution_rescale": 0.405561993047509
        },
        {
            "Country": "Yemen",
            "Abs_contribution": 0.00115875771837722,
            "Perc_contribution": 0.07,
            "Fossil_abs": 0.000890736898646303,
            "Land_abs": 0.000268020819730914,
            "Fossil_fraction": 76.8699862378248,
            "Land_fraction": 23.1300137621748,
            "Rank": 117,
            "Perc_contribution_rescale": 0.405561993047509
        },
        {
            "Country": "Costa Rica",
            "Abs_contribution": 0.00113625009159221,
            "Perc_contribution": 0.07,
            "Fossil_abs": 0.000229749177505515,
            "Land_abs": 0.000906500914086695,
            "Fossil_fraction": 20.2199479855329,
            "Land_fraction": 79.7800520144669,
            "Rank": 118,
            "Perc_contribution_rescale": 0.405561993047509
        },
        {
            "Country": "Estonia",
            "Abs_contribution": 0.00112115430127233,
            "Perc_contribution": 0.07,
            "Fossil_abs": 0.000861445937809567,
            "Land_abs": 0.000259708363462765,
            "Fossil_fraction": 76.8356270704185,
            "Land_fraction": 23.1643729295813,
            "Rank": 119,
            "Perc_contribution_rescale": 0.405561993047509
        },
        {
            "Country": "Papua New Guinea",
            "Abs_contribution": 0.0011196522534956,
            "Perc_contribution": 0.07,
            "Fossil_abs": 0.000219009626279273,
            "Land_abs": 0.000900642627216324,
            "Fossil_fraction": 19.5605042186551,
            "Land_fraction": 80.4394957813449,
            "Rank": 120,
            "Perc_contribution_rescale": 0.405561993047509
        },
        {
            "Country": "Malawi",
            "Abs_contribution": 0.00102716400549873,
            "Perc_contribution": 0.06,
            "Fossil_abs": 0.000210635622333588,
            "Land_abs": 0.000816528383165145,
            "Fossil_fraction": 20.5065229316827,
            "Land_fraction": 79.4934770683173,
            "Rank": 121,
            "Perc_contribution_rescale": 0.347624565469293
        },
        {
            "Country": "Hong Kong",
            "Abs_contribution": 0.0010152705858429,
            "Perc_contribution": 0.06,
            "Fossil_abs": 0.00101202943583745,
            "Land_abs": 3.24115000544532e-06,
            "Fossil_fraction": 99.6807599815616,
            "Land_fraction": 0.319240018438479,
            "Rank": 122,
            "Perc_contribution_rescale": 0.347624565469293
        },
        {
            "Country": "Croatia",
            "Abs_contribution": 0.000989121745555458,
            "Perc_contribution": 0.06,
            "Fossil_abs": 0.000694658703788573,
            "Land_abs": 0.000294463041766884,
            "Fossil_fraction": 70.2298485408867,
            "Land_fraction": 29.7701514591132,
            "Rank": 123,
            "Perc_contribution_rescale": 0.347624565469293
        },
        {
            "Country": "Kyrgyzstan",
            "Abs_contribution": 0.000963583988288071,
            "Perc_contribution": 0.06,
            "Fossil_abs": 0.000516827602608459,
            "Land_abs": 0.000446756385679613,
            "Fossil_fraction": 53.6359683110414,
            "Land_fraction": 46.3640316889587,
            "Rank": 124,
            "Perc_contribution_rescale": 0.347624565469293
        },
        {
            "Country": "Ireland",
            "Abs_contribution": 0.000960872047831334,
            "Perc_contribution": 0.06,
            "Fossil_abs": 0.000943698968886603,
            "Land_abs": 1.71730789447304e-05,
            "Fossil_fraction": 98.2127611076324,
            "Land_fraction": 1.78723889236758,
            "Rank": 125,
            "Perc_contribution_rescale": 0.347624565469293
        },
        {
            "Country": "Moldova",
            "Abs_contribution": 0.000956774664110854,
            "Perc_contribution": 0.06,
            "Fossil_abs": 0.00066914721151044,
            "Land_abs": 0.000287627452600414,
            "Fossil_fraction": 69.9378063206021,
            "Land_fraction": 30.062193679398,
            "Rank": 126,
            "Perc_contribution_rescale": 0.347624565469293
        },
        {
            "Country": "Bosnia and Herzegovina",
            "Abs_contribution": 0.000952261519859749,
            "Perc_contribution": 0.06,
            "Fossil_abs": 0.000607241954576677,
            "Land_abs": 0.000345019565283075,
            "Fossil_fraction": 63.7684020526328,
            "Land_fraction": 36.2315979473675,
            "Rank": 127,
            "Perc_contribution_rescale": 0.347624565469293
        },
        {
            "Country": "Senegal",
            "Abs_contribution": 0.000948156104961109,
            "Perc_contribution": 0.06,
            "Fossil_abs": 0.000285701370071925,
            "Land_abs": 0.000662454734889185,
            "Fossil_fraction": 30.1323135058698,
            "Land_fraction": 69.8676864941304,
            "Rank": 128,
            "Perc_contribution_rescale": 0.347624565469293
        },
        {
            "Country": "Sierra Leone",
            "Abs_contribution": 0.000934033720933209,
            "Perc_contribution": 0.06,
            "Fossil_abs": 0.000128191033968509,
            "Land_abs": 0.000805842686964702,
            "Fossil_fraction": 13.7244545989657,
            "Land_fraction": 86.2755454010344,
            "Rank": 129,
            "Perc_contribution_rescale": 0.347624565469293
        },
        {
            "Country": "Latvia",
            "Abs_contribution": 0.000932729543010866,
            "Perc_contribution": 0.06,
            "Fossil_abs": 0.000491827558795797,
            "Land_abs": 0.000440901984215065,
            "Fossil_fraction": 52.7299218172258,
            "Land_fraction": 47.2700781827738,
            "Rank": 130,
            "Perc_contribution_rescale": 0.347624565469293
        },
        {
            "Country": "Benin",
            "Abs_contribution": 0.000876189143692782,
            "Perc_contribution": 0.05,
            "Fossil_abs": 0.00021257653207798,
            "Land_abs": 0.000663612611614801,
            "Fossil_fraction": 24.2614889271575,
            "Land_fraction": 75.7385110728424,
            "Rank": 131,
            "Perc_contribution_rescale": 0.289687137891078
        },
        {
            "Country": "Haiti",
            "Abs_contribution": 0.000767815374529739,
            "Perc_contribution": 0.05,
            "Fossil_abs": 0.000338875711029239,
            "Land_abs": 0.0004289396635005,
            "Fossil_fraction": 44.135051507244,
            "Land_fraction": 55.864948492756,
            "Rank": 132,
            "Perc_contribution_rescale": 0.289687137891078
        },
        {
            "Country": "Botswana",
            "Abs_contribution": 0.000714363628239222,
            "Perc_contribution": 0.04,
            "Fossil_abs": 0.000140691095919752,
            "Land_abs": 0.00057367253231947,
            "Fossil_fraction": 19.6946051503953,
            "Land_fraction": 80.3053948496047,
            "Rank": 133,
            "Perc_contribution_rescale": 0.231749710312862
        },
        {
            "Country": "El Salvador",
            "Abs_contribution": 0.000686591328957686,
            "Perc_contribution": 0.04,
            "Fossil_abs": 0.000220605082009024,
            "Land_abs": 0.000465986246948661,
            "Fossil_fraction": 32.1304788896656,
            "Land_fraction": 67.8695211103342,
            "Rank": 134,
            "Perc_contribution_rescale": 0.231749710312862
        },
        {
            "Country": "Slovenia",
            "Abs_contribution": 0.000672389025614542,
            "Perc_contribution": 0.04,
            "Fossil_abs": 0.000510657307470269,
            "Land_abs": 0.000161731718144273,
            "Fossil_fraction": 75.946704663055,
            "Land_fraction": 24.0532953369451,
            "Rank": 135,
            "Perc_contribution_rescale": 0.231749710312862
        },
        {
            "Country": "Liberia",
            "Abs_contribution": 0.000663670576663134,
            "Perc_contribution": 0.04,
            "Fossil_abs": 0.000123801220399501,
            "Land_abs": 0.000539869356263633,
            "Fossil_fraction": 18.6540167294986,
            "Land_fraction": 81.3459832705014,
            "Rank": 136,
            "Perc_contribution_rescale": 0.231749710312862
        },
        {
            "Country": "Tajikistan",
            "Abs_contribution": 0.000662210041808804,
            "Perc_contribution": 0.04,
            "Fossil_abs": 0.000313510159415444,
            "Land_abs": 0.000348699882393362,
            "Fossil_fraction": 47.34300895817,
            "Land_fraction": 52.6569910418301,
            "Rank": 137,
            "Perc_contribution_rescale": 0.231749710312862
        },
        {
            "Country": "Guyana",
            "Abs_contribution": 0.000616013004488949,
            "Perc_contribution": 0.04,
            "Fossil_abs": 7.32063428584312e-05,
            "Land_abs": 0.000542806661630519,
            "Fossil_fraction": 11.8838956848263,
            "Land_fraction": 88.1161043151738,
            "Rank": 138,
            "Perc_contribution_rescale": 0.231749710312862
        },
        {
            "Country": "Equatorial Guinea",
            "Abs_contribution": 0.000608277535439671,
            "Perc_contribution": 0.04,
            "Fossil_abs": 0.000494542546206372,
            "Land_abs": 0.000113734989233302,
            "Fossil_fraction": 81.3021223690119,
            "Land_fraction": 18.6978776309884,
            "Rank": 139,
            "Perc_contribution_rescale": 0.231749710312862
        },
        {
            "Country": "Jordan",
            "Abs_contribution": 0.000593828769316586,
            "Perc_contribution": 0.04,
            "Fossil_abs": 0.000543393113504477,
            "Land_abs": 5.0435655812109e-05,
            "Fossil_fraction": 91.5067005139961,
            "Land_fraction": 8.49329948600391,
            "Rank": 140,
            "Perc_contribution_rescale": 0.231749710312862
        },
        {
            "Country": "Rwanda",
            "Abs_contribution": 0.000549087802953018,
            "Perc_contribution": 0.03,
            "Fossil_abs": 0.000176150265483459,
            "Land_abs": 0.000372937537469559,
            "Fossil_fraction": 32.0805278383739,
            "Land_fraction": 67.9194721616259,
            "Rank": 141,
            "Perc_contribution_rescale": 0.173812282734647
        },
        {
            "Country": "Lebanon",
            "Abs_contribution": 0.000536100467176911,
            "Perc_contribution": 0.03,
            "Fossil_abs": 0.000504787809175701,
            "Land_abs": 3.13126580012097e-05,
            "Fossil_fraction": 94.1591809896936,
            "Land_fraction": 5.84081901030626,
            "Rank": 142,
            "Perc_contribution_rescale": 0.173812282734647
        },
        {
            "Country": "Georgia",
            "Abs_contribution": 0.000522146608605556,
            "Perc_contribution": 0.03,
            "Fossil_abs": 0.000426829136244794,
            "Land_abs": 9.53174723607608e-05,
            "Fossil_fraction": 81.7450748908785,
            "Land_fraction": 18.2549251091213,
            "Rank": 143,
            "Perc_contribution_rescale": 0.173812282734647
        },
        {
            "Country": "Namibia",
            "Abs_contribution": 0.000517195779195509,
            "Perc_contribution": 0.03,
            "Fossil_abs": 8.14119402850478e-05,
            "Land_abs": 0.00043578383891046,
            "Fossil_fraction": 15.7410295210999,
            "Land_fraction": 84.2589704788997,
            "Rank": 144,
            "Perc_contribution_rescale": 0.173812282734647
        },
        {
            "Country": "Burundi",
            "Abs_contribution": 0.00051011056839646,
            "Perc_contribution": 0.03,
            "Fossil_abs": 0.000135419717857778,
            "Land_abs": 0.000374690850538683,
            "Fossil_fraction": 26.547130415955,
            "Land_fraction": 73.4528695840452,
            "Rank": 145,
            "Perc_contribution_rescale": 0.173812282734647
        },
        {
            "Country": "Brunei Darussalam",
            "Abs_contribution": 0.000499372670891554,
            "Perc_contribution": 0.03,
            "Fossil_abs": 0.000453619426571891,
            "Land_abs": 4.57532443196643e-05,
            "Fossil_fraction": 90.837855776533,
            "Land_fraction": 9.16214422346718,
            "Rank": 146,
            "Perc_contribution_rescale": 0.173812282734647
        },
        {
            "Country": "Togo",
            "Abs_contribution": 0.000474248341577951,
            "Perc_contribution": 0.03,
            "Fossil_abs": 0.000189536629222935,
            "Land_abs": 0.000284711712355018,
            "Fossil_fraction": 39.9656915177176,
            "Land_fraction": 60.034308482283,
            "Rank": 147,
            "Perc_contribution_rescale": 0.173812282734647
        },
        {
            "Country": "North Macedonia",
            "Abs_contribution": 0.0004190763012431,
            "Perc_contribution": 0.03,
            "Fossil_abs": 0.000281338265770801,
            "Land_abs": 0.000137738035472299,
            "Fossil_fraction": 67.132945703747,
            "Land_fraction": 32.867054296253,
            "Rank": 148,
            "Perc_contribution_rescale": 0.173812282734647
        },
        {
            "Country": "Jamaica",
            "Abs_contribution": 0.000409194054177952,
            "Perc_contribution": 0.03,
            "Fossil_abs": 0.000251498680678194,
            "Land_abs": 0.000157695373499758,
            "Fossil_fraction": 61.4619587235794,
            "Land_fraction": 38.5380412764206,
            "Rank": 149,
            "Perc_contribution_rescale": 0.173812282734647
        },
        {
            "Country": "Luxembourg",
            "Abs_contribution": 0.000383157032063812,
            "Perc_contribution": 0.02,
            "Fossil_abs": 0.000358274173788377,
            "Land_abs": 2.48828582754344e-05,
            "Fossil_fraction": 93.5058328066153,
            "Land_fraction": 6.49416719338465,
            "Rank": 150,
            "Perc_contribution_rescale": 0.115874855156431
        },
        {
            "Country": "Albania",
            "Abs_contribution": 0.000374861248005155,
            "Perc_contribution": 0.02,
            "Fossil_abs": 0.000173451052008196,
            "Land_abs": 0.000201410195996959,
            "Fossil_fraction": 46.2707342866795,
            "Land_fraction": 53.7292657133204,
            "Rank": 151,
            "Perc_contribution_rescale": 0.115874855156431
        },
        {
            "Country": "Mauritania",
            "Abs_contribution": 0.000369804288993161,
            "Perc_contribution": 0.02,
            "Fossil_abs": 0.000101972546265102,
            "Land_abs": 0.000267831742728059,
            "Fossil_fraction": 27.57473325762,
            "Land_fraction": 72.42526674238,
            "Rank": 152,
            "Perc_contribution_rescale": 0.115874855156431
        },
        {
            "Country": "Bhutan",
            "Abs_contribution": 0.000348484681297778,
            "Perc_contribution": 0.02,
            "Fossil_abs": 3.91061225026777e-05,
            "Land_abs": 0.0003093785587951,
            "Fossil_fraction": 11.2217622757604,
            "Land_fraction": 88.7782377242395,
            "Rank": 153,
            "Perc_contribution_rescale": 0.115874855156431
        },
        {
            "Country": "Armenia",
            "Abs_contribution": 0.000341897520601546,
            "Perc_contribution": 0.02,
            "Fossil_abs": 0.000211682377364105,
            "Land_abs": 0.000130215143237441,
            "Fossil_fraction": 61.9139843400046,
            "Land_fraction": 38.0860156599954,
            "Rank": 154,
            "Perc_contribution_rescale": 0.115874855156431
        },
        {
            "Country": "Eritrea",
            "Abs_contribution": 0.000303343072398219,
            "Perc_contribution": 0.02,
            "Fossil_abs": 7.54079283114248e-05,
            "Land_abs": 0.000227935144086795,
            "Fossil_fraction": 24.8589584443952,
            "Land_fraction": 75.141041555605,
            "Rank": 155,
            "Perc_contribution_rescale": 0.115874855156431
        },
        {
            "Country": "Cura\xe7ao",
            "Abs_contribution": 0.000263432370278384,
            "Perc_contribution": 0.02,
            "Fossil_abs": 0.000263432370278384,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 156,
            "Perc_contribution_rescale": 0.115874855156431
        },
        {
            "Country": "Timor-Leste",
            "Abs_contribution": 0.000229230630633432,
            "Perc_contribution": 0.01,
            "Fossil_abs": 8.17961622871746e-05,
            "Land_abs": 0.000147434468346257,
            "Fossil_fraction": 35.68291116294,
            "Land_fraction": 64.3170888370599,
            "Rank": 157,
            "Perc_contribution_rescale": 0.0579374275782155
        },
        {
            "Country": "Kuwaiti Oil Fires",
            "Abs_contribution": 0.0002152227,
            "Perc_contribution": 0.01,
            "Fossil_abs": 0.0002152227,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 158,
            "Perc_contribution_rescale": 0.0579374275782155
        },
        {
            "Country": "Guinea-Bissau",
            "Abs_contribution": 0.00019916207120185,
            "Perc_contribution": 0.01,
            "Fossil_abs": 4.19723673694596e-05,
            "Land_abs": 0.000157189703832391,
            "Fossil_fraction": 21.0744782458708,
            "Land_fraction": 78.9255217541294,
            "Rank": 159,
            "Perc_contribution_rescale": 0.0579374275782155
        },
        {
            "Country": "Lesotho",
            "Abs_contribution": 0.000197507297834412,
            "Perc_contribution": 0.01,
            "Fossil_abs": 7.3258633009866e-05,
            "Land_abs": 0.000124248664824547,
            "Fossil_fraction": 37.0916081649222,
            "Land_fraction": 62.9083918350783,
            "Rank": 160,
            "Perc_contribution_rescale": 0.0579374275782155
        },
        {
            "Country": "Cyprus",
            "Abs_contribution": 0.000188433549155469,
            "Perc_contribution": 0.01,
            "Fossil_abs": 0.000168565509124148,
            "Land_abs": 1.98680400313208e-05,
            "Fossil_fraction": 89.4562087694221,
            "Land_fraction": 10.5437912305778,
            "Rank": 161,
            "Perc_contribution_rescale": 0.0579374275782155
        },
        {
            "Country": "Iceland",
            "Abs_contribution": 0.000178073354852844,
            "Perc_contribution": 0.01,
            "Fossil_abs": 8.99105997233042e-05,
            "Land_abs": 8.81627551295401e-05,
            "Fossil_fraction": 50.4907653352207,
            "Land_fraction": 49.5092346647795,
            "Rank": 162,
            "Perc_contribution_rescale": 0.0579374275782155
        },
        {
            "Country": "Belize",
            "Abs_contribution": 0.000177436093227612,
            "Perc_contribution": 0.01,
            "Fossil_abs": 2.16356621410405e-05,
            "Land_abs": 0.000155800431086572,
            "Fossil_fraction": 12.1934955552063,
            "Land_fraction": 87.8065044447942,
            "Rank": 163,
            "Perc_contribution_rescale": 0.0579374275782155
        },
        {
            "Country": "Suriname",
            "Abs_contribution": 0.000169786035604849,
            "Perc_contribution": 0.01,
            "Fossil_abs": 7.86318630660758e-05,
            "Land_abs": 9.11541725387728e-05,
            "Fossil_fraction": 46.3123264442546,
            "Land_fraction": 53.6876735557454,
            "Rank": 164,
            "Perc_contribution_rescale": 0.0579374275782155
        },
        {
            "Country": "Fiji",
            "Abs_contribution": 0.000153587179696754,
            "Perc_contribution": 0.01,
            "Fossil_abs": 4.21041606229583e-05,
            "Land_abs": 0.000111483019073796,
            "Fossil_fraction": 27.4138510167904,
            "Land_fraction": 72.5861489832099,
            "Rank": 165,
            "Perc_contribution_rescale": 0.0579374275782155
        },
        {
            "Country": "Montenegro",
            "Abs_contribution": 0.000148204193528307,
            "Perc_contribution": 0.01,
            "Fossil_abs": 7.44953802856726e-05,
            "Land_abs": 7.37088132426336e-05,
            "Fossil_fraction": 50.2653659873964,
            "Land_fraction": 49.7346340126033,
            "Rank": 166,
            "Perc_contribution_rescale": 0.0579374275782155
        },
        {
            "Country": "Swaziland",
            "Abs_contribution": 0.000131599082297462,
            "Perc_contribution": 0.01,
            "Fossil_abs": 3.60607485389583e-05,
            "Land_abs": 9.5538333758504e-05,
            "Fossil_fraction": 27.4019756896539,
            "Land_fraction": 72.598024310346,
            "Rank": 167,
            "Perc_contribution_rescale": 0.0579374275782155
        },
        {
            "Country": "Gambia",
            "Abs_contribution": 0.000124270626549185,
            "Perc_contribution": 0.01,
            "Fossil_abs": 3.05519895543962e-05,
            "Land_abs": 9.37186369947884e-05,
            "Fossil_fraction": 24.5850450768461,
            "Land_fraction": 75.4149549231537,
            "Rank": 168,
            "Perc_contribution_rescale": 0.0579374275782155
        },
        {
            "Country": "Bahamas",
            "Abs_contribution": 9.84758592668228e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 9.44911760912141e-05,
            "Land_abs": 3.98468317560832e-06,
            "Fossil_fraction": 95.9536446746689,
            "Land_fraction": 4.04635532533077,
            "Rank": 169,
            "Perc_contribution_rescale": 0.0579374275782155
        },
        {
            "Country": "Mauritius",
            "Abs_contribution": 9.32902209823532e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 8.73339966096586e-05,
            "Land_abs": 5.95622437269444e-06,
            "Fossil_fraction": 93.6153818589183,
            "Land_fraction": 6.38461814108161,
            "Rank": 170,
            "Perc_contribution_rescale": 0.0579374275782155
        },
        {
            "Country": "Vanuatu",
            "Abs_contribution": 7.53686665368541e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 6.6839062669701e-06,
            "Land_abs": 6.8684760269884e-05,
            "Fossil_fraction": 8.86828250265219,
            "Land_fraction": 91.1317174973479,
            "Rank": 171,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "New Caledonia",
            "Abs_contribution": 7.26825995223799e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 7.26825995223799e-05,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 172,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Solomon Islands",
            "Abs_contribution": 6.82078512490318e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 1.09005663119652e-05,
            "Land_abs": 5.73072849370667e-05,
            "Fossil_fraction": 15.9813952680703,
            "Land_fraction": 84.0186047319298,
            "Rank": 173,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Djibouti",
            "Abs_contribution": 6.2912242811186e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 3.50223631902638e-05,
            "Land_abs": 2.78898796209221e-05,
            "Fossil_fraction": 55.668597438775,
            "Land_fraction": 44.3314025612249,
            "Rank": 174,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Malta",
            "Abs_contribution": 5.56396428642294e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 5.40248152621749e-05,
            "Land_abs": 1.61482760205433e-06,
            "Fossil_fraction": 97.0977031502611,
            "Land_fraction": 2.90229684973858,
            "Rank": 175,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Kosovo",
            "Abs_contribution": 5.48597714656113e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 5.48597714656113e-05,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 176,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Barbados",
            "Abs_contribution": 4.50147863147149e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 4.07622016538841e-05,
            "Land_abs": 4.25258466083081e-06,
            "Fossil_fraction": 90.5529160327465,
            "Land_fraction": 9.4470839672534,
            "Rank": 177,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Aruba",
            "Abs_contribution": 3.51807533038796e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 3.51802860170347e-05,
            "Land_abs": 4.67286844861081e-10,
            "Fossil_fraction": 99.9986717542946,
            "Land_fraction": 0.00132824570532874,
            "Rank": 178,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Macao",
            "Abs_contribution": 3.10739296087116e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 3.09930742155458e-05,
            "Land_abs": 8.08553931658471e-08,
            "Fossil_fraction": 99.7397966907178,
            "Land_fraction": 0.260203309282065,
            "Rank": 179,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Sint Maarten (Dutch part)",
            "Abs_contribution": 3.01400010507642e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 3.01400010507642e-05,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 180,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Comoros",
            "Abs_contribution": 2.85938195300392e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 1.52551724110045e-05,
            "Land_abs": 1.33386471190348e-05,
            "Fossil_fraction": 53.3512929078193,
            "Land_fraction": 46.6487070921807,
            "Rank": 181,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Samoa",
            "Abs_contribution": 2.61830047643229e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 5.73762560596897e-06,
            "Land_abs": 2.04453791583539e-05,
            "Fossil_fraction": 21.9135491041391,
            "Land_fraction": 78.0864508958611,
            "Rank": 182,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Maldives",
            "Abs_contribution": 1.92776917219389e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 1.92597625895141e-05,
            "Land_abs": 1.79291324247468e-08,
            "Fossil_fraction": 99.9069954396854,
            "Land_fraction": 0.0930045603143586,
            "Rank": 183,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Cape Verde",
            "Abs_contribution": 1.8115598909736e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 1.31990672888584e-05,
            "Land_abs": 4.91653162087755e-06,
            "Fossil_fraction": 72.8602314205838,
            "Land_fraction": 27.139768579416,
            "Rank": 184,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Greenland",
            "Abs_contribution": 1.5421003125e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 1.5421003125e-05,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 185,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "French Polynesia",
            "Abs_contribution": 1.45090511872271e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 1.45090511872271e-05,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 186,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Faeroe Islands",
            "Abs_contribution": 1.45006426719432e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 1.45006426719432e-05,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 187,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Antigua and Barbuda",
            "Abs_contribution": 1.39188785990711e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 1.4098451463902e-05,
            "Land_abs": -0.000000179572864830803,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 188,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Lucia",
            "Abs_contribution": 1.35858577736737e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 9.8113257365533e-06,
            "Land_abs": 3.7745320371204e-06,
            "Fossil_fraction": 72.2171974710747,
            "Land_fraction": 27.7828025289252,
            "Rank": 189,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Bermuda",
            "Abs_contribution": 1.34244274699782e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 1.34244274699782e-05,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 190,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Tonga",
            "Abs_contribution": 1.30345307509574e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 4.3299622614029e-06,
            "Land_abs": 8.70456848955447e-06,
            "Fossil_fraction": 33.2191648792947,
            "Land_fraction": 66.7808351207052,
            "Rank": 191,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Andorra",
            "Abs_contribution": 1.24390327684029e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 9.22207633880544e-06,
            "Land_abs": 3.21695642959735e-06,
            "Fossil_fraction": 74.1382108280234,
            "Land_fraction": 25.8617891719759,
            "Rank": 192,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Seychelles",
            "Abs_contribution": 1.00856707165785e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 9.87657258234357e-06,
            "Land_abs": 2.09098134234961e-07,
            "Fossil_fraction": 97.926780081257,
            "Land_fraction": 2.07321991874325,
            "Rank": 193,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Ryukyu Islands",
            "Abs_contribution": 9.40859091157205e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 9.40859091157205e-06,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 194,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Dominica",
            "Abs_contribution": 8.56710627976859e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 4.06297159403144e-06,
            "Land_abs": 4.5041346857371e-06,
            "Fossil_fraction": 47.4252502694666,
            "Land_fraction": 52.5747497305329,
            "Rank": 195,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Sao Tome and Principe",
            "Abs_contribution": 7.65110970841256e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 4.58740483347876e-06,
            "Land_abs": 3.06370487493385e-06,
            "Fossil_fraction": 59.9573788418535,
            "Land_fraction": 40.042621158147,
            "Rank": 196,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Vincent and the Grenadines",
            "Abs_contribution": 7.4456289998528e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 5.30657034910132e-06,
            "Land_abs": 2.13905865075145e-06,
            "Fossil_fraction": 71.2709476822742,
            "Land_fraction": 28.7290523177254,
            "Rank": 197,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Palau",
            "Abs_contribution": 7.31650233049336e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 7.06692329592492e-06,
            "Land_abs": 2.49579034568431e-07,
            "Fossil_fraction": 96.5888204049596,
            "Land_fraction": 3.41117959504021,
            "Rank": 198,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Panama Canal Zone",
            "Abs_contribution": 6.64785e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 6.64785e-06,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 199,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Grenada",
            "Abs_contribution": 6.13511093197231e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 5.89606107393631e-06,
            "Land_abs": 2.39049858036017e-07,
            "Fossil_fraction": 96.1035772508983,
            "Land_fraction": 3.89642274910208,
            "Rank": 200,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Liechtenstein",
            "Abs_contribution": 5.57640213666346e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 4.84380306261634e-06,
            "Land_abs": 7.3259907404712e-07,
            "Fossil_fraction": 86.8625135689111,
            "Land_fraction": 13.137486431089,
            "Rank": 201,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Micronesia (Federated States of)",
            "Abs_contribution": 5.51863172687818e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 2.24068654008635e-06,
            "Land_abs": 3.27794518679181e-06,
            "Fossil_fraction": 40.6022117615353,
            "Land_fraction": 59.3977882384643,
            "Rank": 202,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Bonaire, Saint Eustatius and Saba",
            "Abs_contribution": 3.72632955786026e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 3.72632955786026e-06,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 203,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Turks and Caicos Islands",
            "Abs_contribution": 3.67309011626451e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 3.67256944291298e-06,
            "Land_abs": 5.20673351528384e-10,
            "Fossil_fraction": 99.9858246507695,
            "Land_fraction": 0.0141753492304159,
            "Rank": 204,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Kitts and Nevis",
            "Abs_contribution": 3.55897718746079e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 3.37358085468161e-06,
            "Land_abs": 1.85396332779181e-07,
            "Fossil_fraction": 94.7907411873171,
            "Land_fraction": 5.20925881268306,
            "Rank": 205,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "British Virgin Islands",
            "Abs_contribution": 2.6172134279476e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 2.6172134279476e-06,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 206,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Cook Islands",
            "Abs_contribution": 2.56952924310241e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.40686929665077e-06,
            "Land_abs": 1.16265994645163e-06,
            "Fossil_fraction": 54.7520251200622,
            "Land_fraction": 45.2479748799378,
            "Rank": 207,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Nauru",
            "Abs_contribution": 2.42088488962875e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 2.36117862388401e-06,
            "Land_abs": 5.97062657447312e-08,
            "Fossil_fraction": 97.5337007554334,
            "Land_fraction": 2.4662992445662,
            "Rank": 208,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Kiribati",
            "Abs_contribution": 2.24151330367159e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.93284719767542e-06,
            "Land_abs": 3.0866610599617e-07,
            "Fossil_fraction": 86.2295661823383,
            "Land_fraction": 13.7704338176613,
            "Rank": 209,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Pacific Islands (Palau)",
            "Abs_contribution": 1.99485e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.99485e-06,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 210,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Pierre and Miquelon",
            "Abs_contribution": 1.71915859716157e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.71915859716157e-06,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 211,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Marshall Islands",
            "Abs_contribution": 1.67146125818777e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.67146125818777e-06,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 212,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Anguilla",
            "Abs_contribution": 1.49903986080786e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.49903986080786e-06,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 213,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Montserrat",
            "Abs_contribution": 7.35267740174672e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 7.35267740174672e-07,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 214,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Christmas Island",
            "Abs_contribution": 5.9895e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 5.9895e-07,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 215,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Tuvalu",
            "Abs_contribution": 5.77384758001243e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 2.95080443969442e-07,
            "Land_abs": 2.823043140318e-07,
            "Fossil_fraction": 51.1063792177219,
            "Land_fraction": 48.8936207822777,
            "Rank": 216,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Niue",
            "Abs_contribution": 5.67192008108215e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 1.35067523621061e-07,
            "Land_abs": 4.32124484487155e-07,
            "Fossil_fraction": 23.8133686106684,
            "Land_fraction": 76.186631389332,
            "Rank": 217,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Wallis and Futuna Islands",
            "Abs_contribution": 3.58918231441048e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 3.58918231441048e-07,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 218,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "St. Kitts-Nevis-Anguilla",
            "Abs_contribution": 2.805e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 2.805e-07,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 219,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Helena",
            "Abs_contribution": 1.92523116812227e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 1.92523116812227e-07,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 220,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Leeward Islands",
            "Abs_contribution": 8.085e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 8.085e-08,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 221,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Antarctica",
            "Abs_contribution": 6.93e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 6.93e-08,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 222,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Occupied Palestinian Territory",
            "Abs_contribution": 5.74145000000003e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 5.74145000000003e-08,
            "Fossil_fraction": 0,
            "Land_fraction": 100,
            "Rank": 223,
            "Perc_contribution_rescale": 0
        }
    ],
    "1851_CH4": [
        {
            "Country": "China",
            "Abs_contribution": 0.0628659230751354,
            "Perc_contribution": 15.11,
            "Fossil_abs": 0.0495532757174601,
            "Land_abs": 0.0133126473576753,
            "Fossil_fraction": 78.8237463056663,
            "Land_fraction": 21.1762536943337,
            "Rank": 1,
            "Perc_contribution_rescale": 100
        },
        {
            "Country": "United States",
            "Abs_contribution": 0.0350469915380694,
            "Perc_contribution": 8.42,
            "Fossil_abs": 0.0243278325617261,
            "Land_abs": 0.0107191589763432,
            "Fossil_fraction": 69.414895527624,
            "Land_fraction": 30.5851044723757,
            "Rank": 2,
            "Perc_contribution_rescale": 55.7246856386499
        },
        {
            "Country": "India",
            "Abs_contribution": 0.0342677376980543,
            "Perc_contribution": 8.23,
            "Fossil_abs": 0.0133161888521109,
            "Land_abs": 0.0209515488459435,
            "Fossil_fraction": 38.8592587273918,
            "Land_fraction": 61.1407412726084,
            "Rank": 3,
            "Perc_contribution_rescale": 54.4672402382528
        },
        {
            "Country": "Brazil",
            "Abs_contribution": 0.0245690141760346,
            "Perc_contribution": 5.9,
            "Fossil_abs": 0.00861013092604,
            "Land_abs": 0.0159588832499947,
            "Fossil_fraction": 35.0446740123524,
            "Land_fraction": 64.9553259876476,
            "Rank": 4,
            "Perc_contribution_rescale": 39.0469887491727
        },
        {
            "Country": "EU27",
            "Abs_contribution": 0.0219072695150885,
            "Perc_contribution": 5.26,
            "Fossil_abs": 0.0136641789774092,
            "Land_abs": 0.00824309053767939,
            "Fossil_fraction": 62.3728071999025,
            "Land_fraction": 37.6271928000978,
            "Rank": 5,
            "Perc_contribution_rescale": 34.8113831899404
        },
        {
            "Country": "Russia",
            "Abs_contribution": 0.0201696767336364,
            "Perc_contribution": 4.85,
            "Fossil_abs": 0.0173402847101469,
            "Land_abs": 0.00282939202348949,
            "Fossil_fraction": 85.9720507132821,
            "Land_fraction": 14.0279492867181,
            "Rank": 6,
            "Perc_contribution_rescale": 32.0979483785572
        },
        {
            "Country": "Indonesia",
            "Abs_contribution": 0.0143738996816175,
            "Perc_contribution": 3.45,
            "Fossil_abs": 0.0101892531252187,
            "Land_abs": 0.00418464655639877,
            "Fossil_fraction": 70.8871868519404,
            "Land_fraction": 29.1128131480591,
            "Rank": 7,
            "Perc_contribution_rescale": 22.8325612177366
        },
        {
            "Country": "Nigeria",
            "Abs_contribution": 0.0113589075488061,
            "Perc_contribution": 2.73,
            "Fossil_abs": 0.00948895414647452,
            "Land_abs": 0.00186995340233162,
            "Fossil_fraction": 83.5375594501769,
            "Land_fraction": 16.4624405498235,
            "Rank": 8,
            "Perc_contribution_rescale": 18.0675049636003
        },
        {
            "Country": "Iran",
            "Abs_contribution": 0.0084360942022021,
            "Perc_contribution": 2.03,
            "Fossil_abs": 0.00749939700364742,
            "Land_abs": 0.000936697198554679,
            "Fossil_fraction": 88.8965535933659,
            "Land_fraction": 11.1034464066341,
            "Rank": 9,
            "Perc_contribution_rescale": 13.4348113831899
        },
        {
            "Country": "Pakistan",
            "Abs_contribution": 0.00796686351397001,
            "Perc_contribution": 1.91,
            "Fossil_abs": 0.00283446361132617,
            "Land_abs": 0.00513239990264382,
            "Fossil_fraction": 35.5781620502962,
            "Land_fraction": 64.4218379497036,
            "Rank": 10,
            "Perc_contribution_rescale": 12.6406353408339
        },
        {
            "Country": "Mexico",
            "Abs_contribution": 0.00751163684040678,
            "Perc_contribution": 1.81,
            "Fossil_abs": 0.00473830286524816,
            "Land_abs": 0.0027733339751586,
            "Fossil_fraction": 63.0794987286894,
            "Land_fraction": 36.9205012713103,
            "Rank": 11,
            "Perc_contribution_rescale": 11.9788219722038
        },
        {
            "Country": "Australia",
            "Abs_contribution": 0.00730168002848128,
            "Perc_contribution": 1.75,
            "Fossil_abs": 0.0025904689814965,
            "Land_abs": 0.00471121104698479,
            "Fossil_fraction": 35.4777115868128,
            "Land_fraction": 64.5222884131873,
            "Rank": 12,
            "Perc_contribution_rescale": 11.5817339510258
        },
        {
            "Country": "Argentina",
            "Abs_contribution": 0.00629855994844547,
            "Perc_contribution": 1.51,
            "Fossil_abs": 0.00178950664483416,
            "Land_abs": 0.00450905330361129,
            "Fossil_fraction": 28.4113616363344,
            "Land_fraction": 71.5886383636653,
            "Rank": 13,
            "Perc_contribution_rescale": 9.9933818663137
        },
        {
            "Country": "Canada",
            "Abs_contribution": 0.00550006521484721,
            "Perc_contribution": 1.32,
            "Fossil_abs": 0.00416057512943699,
            "Land_abs": 0.00133949008541021,
            "Fossil_fraction": 75.6459235829728,
            "Land_fraction": 24.354076417027,
            "Rank": 14,
            "Perc_contribution_rescale": 8.73593646591661
        },
        {
            "Country": "Iraq",
            "Abs_contribution": 0.00507199384183304,
            "Perc_contribution": 1.22,
            "Fossil_abs": 0.00487320267230172,
            "Land_abs": 0.000198791169531308,
            "Fossil_fraction": 96.0806109839543,
            "Land_fraction": 3.91938901604548,
            "Rank": 15,
            "Perc_contribution_rescale": 8.07412309728657
        },
        {
            "Country": "Thailand",
            "Abs_contribution": 0.00496145639802835,
            "Perc_contribution": 1.19,
            "Fossil_abs": 0.0023209945404322,
            "Land_abs": 0.00264046185759615,
            "Fossil_fraction": 46.7805086698848,
            "Land_fraction": 53.2194913301154,
            "Rank": 16,
            "Perc_contribution_rescale": 7.87557908669755
        },
        {
            "Country": "Saudi Arabia",
            "Abs_contribution": 0.00483908748435082,
            "Perc_contribution": 1.16,
            "Fossil_abs": 0.00471671052322231,
            "Land_abs": 0.000122376961128522,
            "Fossil_fraction": 97.4710735955019,
            "Land_fraction": 2.52892640449833,
            "Rank": 17,
            "Perc_contribution_rescale": 7.67703507610854
        },
        {
            "Country": "Viet Nam",
            "Abs_contribution": 0.00455010228267704,
            "Perc_contribution": 1.09,
            "Fossil_abs": 0.00219953672186976,
            "Land_abs": 0.0023505655608073,
            "Fossil_fraction": 48.3403797370389,
            "Land_fraction": 51.6596202629613,
            "Rank": 18,
            "Perc_contribution_rescale": 7.21376571806751
        },
        {
            "Country": "South Africa",
            "Abs_contribution": 0.00421640709779999,
            "Perc_contribution": 1.01,
            "Fossil_abs": 0.00332377413087642,
            "Land_abs": 0.000892632966923567,
            "Fossil_fraction": 78.8295355211473,
            "Land_fraction": 21.1704644788526,
            "Rank": 19,
            "Perc_contribution_rescale": 6.68431502316347
        },
        {
            "Country": "Ethiopia",
            "Abs_contribution": 0.00421314362527713,
            "Perc_contribution": 1.01,
            "Fossil_abs": 0.0013619759746226,
            "Land_abs": 0.00285116765065453,
            "Fossil_fraction": 32.3268346811464,
            "Land_fraction": 67.6731653188536,
            "Rank": 20,
            "Perc_contribution_rescale": 6.68431502316347
        },
        {
            "Country": "Bangladesh",
            "Abs_contribution": 0.00419212593863488,
            "Perc_contribution": 1.01,
            "Fossil_abs": 0.00158018862937456,
            "Land_abs": 0.00261193730926034,
            "Fossil_fraction": 37.6942070087027,
            "Land_fraction": 62.3057929912975,
            "Rank": 21,
            "Perc_contribution_rescale": 6.68431502316347
        },
        {
            "Country": "Algeria",
            "Abs_contribution": 0.0039036976300617,
            "Perc_contribution": 0.94,
            "Fossil_abs": 0.0036189053164258,
            "Land_abs": 0.000284792313635899,
            "Fossil_fraction": 92.7045498748992,
            "Land_fraction": 7.29545012510096,
            "Rank": 22,
            "Perc_contribution_rescale": 6.22104566512244
        },
        {
            "Country": "Colombia",
            "Abs_contribution": 0.003900422736608,
            "Perc_contribution": 0.94,
            "Fossil_abs": 0.00171879289728761,
            "Land_abs": 0.0021816298393204,
            "Fossil_fraction": 44.0668361702341,
            "Land_fraction": 55.9331638297661,
            "Rank": 23,
            "Perc_contribution_rescale": 6.22104566512244
        },
        {
            "Country": "Germany",
            "Abs_contribution": 0.00387007130739155,
            "Perc_contribution": 0.93,
            "Fossil_abs": 0.00233583109157924,
            "Land_abs": 0.00153424021581231,
            "Fossil_fraction": 60.3562804416027,
            "Land_fraction": 39.6437195583973,
            "Rank": 24,
            "Perc_contribution_rescale": 6.15486432825943
        },
        {
            "Country": "Philippines",
            "Abs_contribution": 0.00382226030496496,
            "Perc_contribution": 0.92,
            "Fossil_abs": 0.00141841136048028,
            "Land_abs": 0.00240384894448468,
            "Fossil_fraction": 37.1092298093308,
            "Land_fraction": 62.8907701906691,
            "Rank": 25,
            "Perc_contribution_rescale": 6.08868299139643
        },
        {
            "Country": "Venezuela",
            "Abs_contribution": 0.00359841089668347,
            "Perc_contribution": 0.86,
            "Fossil_abs": 0.00228829244523929,
            "Land_abs": 0.00131011845144418,
            "Fossil_fraction": 63.5917495511235,
            "Land_fraction": 36.4082504488765,
            "Rank": 26,
            "Perc_contribution_rescale": 5.6915949702184
        },
        {
            "Country": "Myanmar",
            "Abs_contribution": 0.00344324862546958,
            "Perc_contribution": 0.83,
            "Fossil_abs": 0.000857511662660024,
            "Land_abs": 0.00258573696280955,
            "Fossil_fraction": 24.9041459369806,
            "Land_fraction": 75.0958540630192,
            "Rank": 27,
            "Perc_contribution_rescale": 5.49305095962939
        },
        {
            "Country": "T\xfcrkiye",
            "Abs_contribution": 0.00331079815878229,
            "Perc_contribution": 0.8,
            "Fossil_abs": 0.00249708211759269,
            "Land_abs": 0.000813716041189601,
            "Fossil_fraction": 75.4223603444045,
            "Land_fraction": 24.5776396555955,
            "Rank": 28,
            "Perc_contribution_rescale": 5.29450694904037
        },
        {
            "Country": "Egypt",
            "Abs_contribution": 0.00319326237614057,
            "Perc_contribution": 0.77,
            "Fossil_abs": 0.00248653564679701,
            "Land_abs": 0.000706726729343554,
            "Fossil_fraction": 77.8681910191882,
            "Land_fraction": 22.1318089808115,
            "Rank": 29,
            "Perc_contribution_rescale": 5.09596293845136
        },
        {
            "Country": "Ukraine",
            "Abs_contribution": 0.00310220549895983,
            "Perc_contribution": 0.75,
            "Fossil_abs": 0.00231003983797961,
            "Land_abs": 0.000792165660980219,
            "Fossil_fraction": 74.4644363100436,
            "Land_fraction": 25.5355636899564,
            "Rank": 30,
            "Perc_contribution_rescale": 4.96360026472535
        },
        {
            "Country": "France",
            "Abs_contribution": 0.00297480611820349,
            "Perc_contribution": 0.71,
            "Fossil_abs": 0.00158224644685652,
            "Land_abs": 0.00139255967134698,
            "Fossil_fraction": 53.1882208112455,
            "Land_fraction": 46.8117791887545,
            "Rank": 31,
            "Perc_contribution_rescale": 4.69887491727333
        },
        {
            "Country": "Qatar",
            "Abs_contribution": 0.00291469810600287,
            "Perc_contribution": 0.7,
            "Fossil_abs": 0.00290514648278155,
            "Land_abs": 9.55162322131345e-06,
            "Fossil_fraction": 99.6722945953942,
            "Land_fraction": 0.327705404605772,
            "Rank": 32,
            "Perc_contribution_rescale": 4.63269358041032
        },
        {
            "Country": "United Kingdom",
            "Abs_contribution": 0.0028987004657903,
            "Perc_contribution": 0.7,
            "Fossil_abs": 0.00165821850241161,
            "Land_abs": 0.00124048196337869,
            "Fossil_fraction": 57.2055830528703,
            "Land_fraction": 42.7944169471298,
            "Rank": 33,
            "Perc_contribution_rescale": 4.63269358041032
        },
        {
            "Country": "Kazakhstan",
            "Abs_contribution": 0.00286731717771207,
            "Perc_contribution": 0.69,
            "Fossil_abs": 0.00205585004867641,
            "Land_abs": 0.00081146712903566,
            "Fossil_fraction": 71.6994291617519,
            "Land_fraction": 28.3005708382481,
            "Rank": 34,
            "Perc_contribution_rescale": 4.56651224354732
        },
        {
            "Country": "Uzbekistan",
            "Abs_contribution": 0.00272979974465412,
            "Perc_contribution": 0.66,
            "Fossil_abs": 0.00191543373056134,
            "Land_abs": 0.000814366014092791,
            "Fossil_fraction": 70.1675547560738,
            "Land_fraction": 29.8324452439267,
            "Rank": 35,
            "Perc_contribution_rescale": 4.36796823295831
        },
        {
            "Country": "Poland",
            "Abs_contribution": 0.00268063009666069,
            "Perc_contribution": 0.64,
            "Fossil_abs": 0.0020034581870906,
            "Land_abs": 0.00067717190957009,
            "Fossil_fraction": 74.7383307225548,
            "Land_fraction": 25.2616692774455,
            "Rank": 36,
            "Perc_contribution_rescale": 4.2356055592323
        },
        {
            "Country": "Angola",
            "Abs_contribution": 0.0025879403581059,
            "Perc_contribution": 0.62,
            "Fossil_abs": 0.00177312838546608,
            "Land_abs": 0.000814811972639823,
            "Fossil_fraction": 68.5150405384081,
            "Land_fraction": 31.4849594615921,
            "Rank": 37,
            "Perc_contribution_rescale": 4.10324288550629
        },
        {
            "Country": "Sudan",
            "Abs_contribution": 0.00257974384786986,
            "Perc_contribution": 0.62,
            "Fossil_abs": 0.000675735184326032,
            "Land_abs": 0.00190400866354383,
            "Fossil_fraction": 26.1938868420598,
            "Land_fraction": 73.8061131579403,
            "Rank": 38,
            "Perc_contribution_rescale": 4.10324288550629
        },
        {
            "Country": "Malaysia",
            "Abs_contribution": 0.00245597938672616,
            "Perc_contribution": 0.59,
            "Fossil_abs": 0.00221015185637836,
            "Land_abs": 0.0002458275303478,
            "Fossil_fraction": 89.9906517262962,
            "Land_fraction": 10.009348273704,
            "Rank": 39,
            "Perc_contribution_rescale": 3.90469887491727
        },
        {
            "Country": "Tanzania",
            "Abs_contribution": 0.00221956407359122,
            "Perc_contribution": 0.53,
            "Fossil_abs": 0.000743242485901861,
            "Land_abs": 0.00147632158768935,
            "Fossil_fraction": 33.4859666699915,
            "Land_fraction": 66.5140333300081,
            "Rank": 40,
            "Perc_contribution_rescale": 3.50761085373925
        },
        {
            "Country": "Italy",
            "Abs_contribution": 0.00215599886426012,
            "Perc_contribution": 0.52,
            "Fossil_abs": 0.00121084263295318,
            "Land_abs": 0.000945156231306943,
            "Fossil_fraction": 56.1615617255301,
            "Land_fraction": 43.8384382744698,
            "Rank": 41,
            "Perc_contribution_rescale": 3.44142951687624
        },
        {
            "Country": "Kenya",
            "Abs_contribution": 0.00208828982550756,
            "Perc_contribution": 0.5,
            "Fossil_abs": 0.000897533082300263,
            "Land_abs": 0.00119075674320731,
            "Fossil_fraction": 42.9793351160976,
            "Land_fraction": 57.020664883903,
            "Rank": 42,
            "Perc_contribution_rescale": 3.30906684315023
        },
        {
            "Country": "Spain",
            "Abs_contribution": 0.00207957840967935,
            "Perc_contribution": 0.5,
            "Fossil_abs": 0.000993583994564128,
            "Land_abs": 0.00108599441511522,
            "Fossil_fraction": 47.7781453173159,
            "Land_fraction": 52.2218546826839,
            "Rank": 43,
            "Perc_contribution_rescale": 3.30906684315023
        },
        {
            "Country": "United Arab Emirates",
            "Abs_contribution": 0.00193873882831398,
            "Perc_contribution": 0.47,
            "Fossil_abs": 0.00189036065959655,
            "Land_abs": 4.83781687174277e-05,
            "Fossil_fraction": 97.5046577697367,
            "Land_fraction": 2.49534223026315,
            "Rank": 44,
            "Perc_contribution_rescale": 3.11052283256122
        },
        {
            "Country": "Turkmenistan",
            "Abs_contribution": 0.00193642670403762,
            "Perc_contribution": 0.47,
            "Fossil_abs": 0.00165501928073081,
            "Land_abs": 0.000281407423306809,
            "Fossil_fraction": 85.4676955900243,
            "Land_fraction": 14.5323044099759,
            "Rank": 45,
            "Perc_contribution_rescale": 3.11052283256122
        },
        {
            "Country": "Democratic Republic of the Congo",
            "Abs_contribution": 0.00191914656405108,
            "Perc_contribution": 0.46,
            "Fossil_abs": 0.00127892208298512,
            "Land_abs": 0.000640224481065952,
            "Fossil_fraction": 66.6401465600144,
            "Land_fraction": 33.3598534399851,
            "Rank": 46,
            "Perc_contribution_rescale": 3.04434149569821
        },
        {
            "Country": "Chad",
            "Abs_contribution": 0.0018114196210139,
            "Perc_contribution": 0.44,
            "Fossil_abs": 0.000203430817730825,
            "Land_abs": 0.00160798880328308,
            "Fossil_fraction": 11.2304634095196,
            "Land_fraction": 88.7695365904806,
            "Rank": 47,
            "Perc_contribution_rescale": 2.9119788219722
        },
        {
            "Country": "New Zealand",
            "Abs_contribution": 0.00173939193443699,
            "Perc_contribution": 0.42,
            "Fossil_abs": 0.000310067747706137,
            "Land_abs": 0.00142932418673086,
            "Fossil_fraction": 17.8262151023771,
            "Land_fraction": 82.1737848976229,
            "Rank": 48,
            "Perc_contribution_rescale": 2.77961614824619
        },
        {
            "Country": "Japan",
            "Abs_contribution": 0.00168836476685485,
            "Perc_contribution": 0.41,
            "Fossil_abs": 0.000992813607433411,
            "Land_abs": 0.00069555115942143,
            "Fossil_fraction": 58.8032649652398,
            "Land_fraction": 41.1967350347597,
            "Rank": 49,
            "Perc_contribution_rescale": 2.71343481138319
        },
        {
            "Country": "Kuwait",
            "Abs_contribution": 0.00163510526071783,
            "Perc_contribution": 0.39,
            "Fossil_abs": 0.00162787779078043,
            "Land_abs": 7.22746993740321e-06,
            "Fossil_fraction": 99.5579813660297,
            "Land_fraction": 0.442018633970407,
            "Rank": 50,
            "Perc_contribution_rescale": 2.58107213765718
        },
        {
            "Country": "Libya",
            "Abs_contribution": 0.00159762743560433,
            "Perc_contribution": 0.38,
            "Fossil_abs": 0.00152814150140403,
            "Land_abs": 6.9485934200313e-05,
            "Fossil_fraction": 95.6506797109415,
            "Land_fraction": 4.34932028905904,
            "Rank": 51,
            "Perc_contribution_rescale": 2.51489080079418
        },
        {
            "Country": "Peru",
            "Abs_contribution": 0.00159082609144777,
            "Perc_contribution": 0.38,
            "Fossil_abs": 0.000743410263165363,
            "Land_abs": 0.000847415828282408,
            "Fossil_fraction": 46.7310831247936,
            "Land_fraction": 53.2689168752064,
            "Rank": 52,
            "Perc_contribution_rescale": 2.51489080079418
        },
        {
            "Country": "South Korea",
            "Abs_contribution": 0.0015385137776061,
            "Perc_contribution": 0.37,
            "Fossil_abs": 0.00108660243451943,
            "Land_abs": 0.000451911343086662,
            "Fossil_fraction": 70.6267600807688,
            "Land_fraction": 29.3732399192309,
            "Rank": 53,
            "Perc_contribution_rescale": 2.44870946393117
        },
        {
            "Country": "Oman",
            "Abs_contribution": 0.00146241232342448,
            "Perc_contribution": 0.35,
            "Fossil_abs": 0.00142228140632359,
            "Land_abs": 4.01309171008784e-05,
            "Fossil_fraction": 97.2558411565547,
            "Land_fraction": 2.74415884344473,
            "Rank": 54,
            "Perc_contribution_rescale": 2.31634679020516
        },
        {
            "Country": "South Sudan",
            "Abs_contribution": 0.00141859526989212,
            "Perc_contribution": 0.34,
            "Fossil_abs": 0.000189725293647474,
            "Land_abs": 0.00122886997624464,
            "Fossil_fraction": 13.3741665205117,
            "Land_fraction": 86.6258334794881,
            "Rank": 55,
            "Perc_contribution_rescale": 2.25016545334216
        },
        {
            "Country": "Bolivia",
            "Abs_contribution": 0.00126988591747669,
            "Perc_contribution": 0.31,
            "Fossil_abs": 0.00045352122806264,
            "Land_abs": 0.000816364689414058,
            "Fossil_fraction": 35.71354102137,
            "Land_fraction": 64.2864589786303,
            "Rank": 56,
            "Perc_contribution_rescale": 2.05162144275314
        },
        {
            "Country": "Uganda",
            "Abs_contribution": 0.00125385935286156,
            "Perc_contribution": 0.3,
            "Fossil_abs": 0.000629172977141898,
            "Land_abs": 0.000624686375719662,
            "Fossil_fraction": 50.1789116702762,
            "Land_fraction": 49.8210883297239,
            "Rank": 57,
            "Perc_contribution_rescale": 1.98544010589014
        },
        {
            "Country": "Netherlands",
            "Abs_contribution": 0.00123004675587183,
            "Perc_contribution": 0.3,
            "Fossil_abs": 0.000644123868475291,
            "Land_abs": 0.000585922887396534,
            "Fossil_fraction": 52.3658036087215,
            "Land_fraction": 47.6341963912783,
            "Rank": 58,
            "Perc_contribution_rescale": 1.98544010589014
        },
        {
            "Country": "Uruguay",
            "Abs_contribution": 0.00121362525744601,
            "Perc_contribution": 0.29,
            "Fossil_abs": 0.000170314520385315,
            "Land_abs": 0.0010433107370607,
            "Fossil_fraction": 14.0335345973048,
            "Land_fraction": 85.9664654026954,
            "Rank": 59,
            "Perc_contribution_rescale": 1.91925876902713
        },
        {
            "Country": "Morocco",
            "Abs_contribution": 0.0011930885796345,
            "Perc_contribution": 0.29,
            "Fossil_abs": 0.000870799302090157,
            "Land_abs": 0.000322289277544343,
            "Fossil_fraction": 72.9869782474094,
            "Land_fraction": 27.0130217525907,
            "Rank": 60,
            "Perc_contribution_rescale": 1.91925876902713
        },
        {
            "Country": "Chile",
            "Abs_contribution": 0.00115732123601786,
            "Perc_contribution": 0.28,
            "Fossil_abs": 0.000843571566626102,
            "Land_abs": 0.000313749669391756,
            "Fossil_fraction": 72.8900101694052,
            "Land_fraction": 27.1099898305948,
            "Rank": 61,
            "Perc_contribution_rescale": 1.85307743216413
        },
        {
            "Country": "Nepal",
            "Abs_contribution": 0.00113239780762192,
            "Perc_contribution": 0.27,
            "Fossil_abs": 0.000295513419590914,
            "Land_abs": 0.000836884388031003,
            "Fossil_fraction": 26.0962550087856,
            "Land_fraction": 73.9037449912141,
            "Rank": 62,
            "Perc_contribution_rescale": 1.78689609530113
        },
        {
            "Country": "Bahrain",
            "Abs_contribution": 0.00109388342306702,
            "Perc_contribution": 0.26,
            "Fossil_abs": 0.00109297893358792,
            "Land_abs": 9.04489479094144e-07,
            "Fossil_fraction": 99.9173139056657,
            "Land_fraction": 0.0826860943333563,
            "Rank": 63,
            "Perc_contribution_rescale": 1.72071475843812
        },
        {
            "Country": "Romania",
            "Abs_contribution": 0.00108024770612728,
            "Perc_contribution": 0.26,
            "Fossil_abs": 0.000719977550932075,
            "Land_abs": 0.000360270155195206,
            "Fossil_fraction": 66.6493015304069,
            "Land_fraction": 33.3506984695932,
            "Rank": 64,
            "Perc_contribution_rescale": 1.72071475843812
        },
        {
            "Country": "Madagascar",
            "Abs_contribution": 0.00105880580724995,
            "Perc_contribution": 0.25,
            "Fossil_abs": 0.000327735251060984,
            "Land_abs": 0.000731070556188974,
            "Fossil_fraction": 30.9532917950473,
            "Land_fraction": 69.0467082049532,
            "Rank": 65,
            "Perc_contribution_rescale": 1.65453342157512
        },
        {
            "Country": "Ecuador",
            "Abs_contribution": 0.00105294400029978,
            "Perc_contribution": 0.25,
            "Fossil_abs": 0.000595790037676548,
            "Land_abs": 0.000457153962623228,
            "Fossil_fraction": 56.5832596516931,
            "Land_fraction": 43.4167403483067,
            "Rank": 66,
            "Perc_contribution_rescale": 1.65453342157512
        },
        {
            "Country": "Paraguay",
            "Abs_contribution": 0.0010483641273501,
            "Perc_contribution": 0.25,
            "Fossil_abs": 0.000130805739911431,
            "Land_abs": 0.000917558387438668,
            "Fossil_fraction": 12.477128556665,
            "Land_fraction": 87.5228714433347,
            "Rank": 67,
            "Perc_contribution_rescale": 1.65453342157512
        },
        {
            "Country": "Norway",
            "Abs_contribution": 0.00103685057240623,
            "Perc_contribution": 0.25,
            "Fossil_abs": 0.000919432274071848,
            "Land_abs": 0.000117418298334379,
            "Fossil_fraction": 88.6754850255919,
            "Land_fraction": 11.324514974408,
            "Rank": 68,
            "Perc_contribution_rescale": 1.65453342157512
        },
        {
            "Country": "Somalia",
            "Abs_contribution": 0.0010157138161113,
            "Perc_contribution": 0.24,
            "Fossil_abs": 0.000258204023318016,
            "Land_abs": 0.000757509792793281,
            "Fossil_fraction": 25.4209423188276,
            "Land_fraction": 74.5790576811723,
            "Rank": 69,
            "Perc_contribution_rescale": 1.58835208471211
        },
        {
            "Country": "Cameroon",
            "Abs_contribution": 0.00100738142905777,
            "Perc_contribution": 0.24,
            "Fossil_abs": 0.000671792148672681,
            "Land_abs": 0.000335589280385098,
            "Fossil_fraction": 66.6869697311199,
            "Land_fraction": 33.3130302688806,
            "Rank": 70,
            "Perc_contribution_rescale": 1.58835208471211
        },
        {
            "Country": "Mozambique",
            "Abs_contribution": 0.000987084252338299,
            "Perc_contribution": 0.24,
            "Fossil_abs": 0.000550876603058755,
            "Land_abs": 0.000436207649279546,
            "Fossil_fraction": 55.8084684011306,
            "Land_fraction": 44.1915315988697,
            "Rank": 71,
            "Perc_contribution_rescale": 1.58835208471211
        },
        {
            "Country": "Mongolia",
            "Abs_contribution": 0.000948756886461512,
            "Perc_contribution": 0.23,
            "Fossil_abs": 0.000446819720760309,
            "Land_abs": 0.000501937165701203,
            "Fossil_fraction": 47.0952809024417,
            "Land_fraction": 52.9047190975583,
            "Rank": 72,
            "Perc_contribution_rescale": 1.52217074784911
        },
        {
            "Country": "Cambodia",
            "Abs_contribution": 0.0009464726553354,
            "Perc_contribution": 0.23,
            "Fossil_abs": 0.000190544644851137,
            "Land_abs": 0.000755928010484265,
            "Fossil_fraction": 20.1320813419183,
            "Land_fraction": 79.8679186580819,
            "Rank": 73,
            "Perc_contribution_rescale": 1.52217074784911
        },
        {
            "Country": "Mali",
            "Abs_contribution": 0.000940041054666162,
            "Perc_contribution": 0.23,
            "Fossil_abs": 0.000160289346541287,
            "Land_abs": 0.000779751708124873,
            "Fossil_fraction": 17.0513134235622,
            "Land_fraction": 82.9486865764376,
            "Rank": 74,
            "Perc_contribution_rescale": 1.52217074784911
        },
        {
            "Country": "Niger",
            "Abs_contribution": 0.000873207212191585,
            "Perc_contribution": 0.21,
            "Fossil_abs": 0.00016342014126298,
            "Land_abs": 0.000709787070928605,
            "Fossil_fraction": 18.7149326049228,
            "Land_fraction": 81.2850673950772,
            "Rank": 75,
            "Perc_contribution_rescale": 1.3898080741231
        },
        {
            "Country": "Finland",
            "Abs_contribution": 0.000865941305475515,
            "Perc_contribution": 0.21,
            "Fossil_abs": 0.000749506075611176,
            "Land_abs": 0.00011643522986434,
            "Fossil_fraction": 86.5539120113458,
            "Land_fraction": 13.4460879886543,
            "Rank": 76,
            "Perc_contribution_rescale": 1.3898080741231
        },
        {
            "Country": "North Korea",
            "Abs_contribution": 0.000865209720777131,
            "Perc_contribution": 0.21,
            "Fossil_abs": 0.000726852210194688,
            "Land_abs": 0.000138357510582443,
            "Fossil_fraction": 84.0087891686919,
            "Land_fraction": 15.9912108313081,
            "Rank": 77,
            "Perc_contribution_rescale": 1.3898080741231
        },
        {
            "Country": "Zambia",
            "Abs_contribution": 0.000810280253564357,
            "Perc_contribution": 0.19,
            "Fossil_abs": 0.000303320947325859,
            "Land_abs": 0.000506959306238499,
            "Fossil_fraction": 37.4340786402698,
            "Land_fraction": 62.5659213597303,
            "Rank": 78,
            "Perc_contribution_rescale": 1.25744540039709
        },
        {
            "Country": "Burkina Faso",
            "Abs_contribution": 0.000805124000471105,
            "Perc_contribution": 0.19,
            "Fossil_abs": 0.000237502934847205,
            "Land_abs": 0.000567621065623902,
            "Fossil_fraction": 29.4989262161151,
            "Land_fraction": 70.5010737838851,
            "Rank": 79,
            "Perc_contribution_rescale": 1.25744540039709
        },
        {
            "Country": "Trinidad and Tobago",
            "Abs_contribution": 0.000778583553092873,
            "Perc_contribution": 0.19,
            "Fossil_abs": 0.000773568700670547,
            "Land_abs": 5.01485242232742e-06,
            "Fossil_fraction": 99.3559005449827,
            "Land_fraction": 0.644099455017543,
            "Rank": 80,
            "Perc_contribution_rescale": 1.25744540039709
        },
        {
            "Country": "Syria",
            "Abs_contribution": 0.000762559498262762,
            "Perc_contribution": 0.18,
            "Fossil_abs": 0.00059451120927887,
            "Land_abs": 0.000168048288983895,
            "Fossil_fraction": 77.9625997228106,
            "Land_fraction": 22.0374002771898,
            "Rank": 81,
            "Perc_contribution_rescale": 1.19126406353408
        },
        {
            "Country": "Azerbaijan",
            "Abs_contribution": 0.000748918054675449,
            "Perc_contribution": 0.18,
            "Fossil_abs": 0.000568020022993521,
            "Land_abs": 0.000180898031681931,
            "Fossil_fraction": 75.8454171918286,
            "Land_fraction": 24.1545828081718,
            "Rank": 82,
            "Perc_contribution_rescale": 1.19126406353408
        },
        {
            "Country": "Yemen",
            "Abs_contribution": 0.0007482226244139,
            "Perc_contribution": 0.18,
            "Fossil_abs": 0.000553638483876271,
            "Land_abs": 0.000194584140537629,
            "Fossil_fraction": 73.9938175900452,
            "Land_fraction": 26.0061824099546,
            "Rank": 83,
            "Perc_contribution_rescale": 1.19126406353408
        },
        {
            "Country": "Taiwan",
            "Abs_contribution": 0.000746225903701696,
            "Perc_contribution": 0.18,
            "Fossil_abs": 0.000622698244564188,
            "Land_abs": 0.000123527659137508,
            "Fossil_fraction": 83.446345332594,
            "Land_fraction": 16.553654667406,
            "Rank": 84,
            "Perc_contribution_rescale": 1.19126406353408
        },
        {
            "Country": "Congo",
            "Abs_contribution": 0.000725332058496136,
            "Perc_contribution": 0.17,
            "Fossil_abs": 0.000660323775082878,
            "Land_abs": 6.50082834132562e-05,
            "Fossil_fraction": 91.0374451740018,
            "Land_fraction": 8.96255482599802,
            "Rank": 85,
            "Perc_contribution_rescale": 1.12508272667108
        },
        {
            "Country": "Ghana",
            "Abs_contribution": 0.000706549152351889,
            "Perc_contribution": 0.17,
            "Fossil_abs": 0.000480802584202148,
            "Land_abs": 0.000225746568149736,
            "Fossil_fraction": 68.0494177371385,
            "Land_fraction": 31.9505822628608,
            "Rank": 86,
            "Perc_contribution_rescale": 1.12508272667108
        },
        {
            "Country": "Guinea",
            "Abs_contribution": 0.000687129291649254,
            "Perc_contribution": 0.17,
            "Fossil_abs": 0.000195703414627077,
            "Land_abs": 0.000491425877022181,
            "Fossil_fraction": 28.4813086860768,
            "Land_fraction": 71.5186913139237,
            "Rank": 87,
            "Perc_contribution_rescale": 1.12508272667108
        },
        {
            "Country": "Afghanistan",
            "Abs_contribution": 0.000685628723935492,
            "Perc_contribution": 0.16,
            "Fossil_abs": 0.000235947760668235,
            "Land_abs": 0.000449680963267256,
            "Fossil_fraction": 34.4133424448585,
            "Land_fraction": 65.5866575551412,
            "Rank": 88,
            "Perc_contribution_rescale": 1.05890138980807
        },
        {
            "Country": "Cuba",
            "Abs_contribution": 0.000682401578808601,
            "Perc_contribution": 0.16,
            "Fossil_abs": 0.000284810518267155,
            "Land_abs": 0.000397591060541446,
            "Fossil_fraction": 41.7364975568204,
            "Land_fraction": 58.2635024431798,
            "Rank": 89,
            "Perc_contribution_rescale": 1.05890138980807
        },
        {
            "Country": "Guatemala",
            "Abs_contribution": 0.000680819388370332,
            "Perc_contribution": 0.16,
            "Fossil_abs": 0.000420373326891532,
            "Land_abs": 0.000260446061478799,
            "Fossil_fraction": 61.7452049798074,
            "Land_fraction": 38.2547950201926,
            "Rank": 90,
            "Perc_contribution_rescale": 1.05890138980807
        },
        {
            "Country": "Belarus",
            "Abs_contribution": 0.000663879989886157,
            "Perc_contribution": 0.16,
            "Fossil_abs": 0.000247054868945122,
            "Land_abs": 0.000416825120941037,
            "Fossil_fraction": 37.2137845256471,
            "Land_fraction": 62.7862154743532,
            "Rank": 91,
            "Perc_contribution_rescale": 1.05890138980807
        },
        {
            "Country": "Gabon",
            "Abs_contribution": 0.000658348169092349,
            "Perc_contribution": 0.16,
            "Fossil_abs": 0.000648957615050907,
            "Land_abs": 9.39055404143856e-06,
            "Fossil_fraction": 98.5736188718519,
            "Land_fraction": 1.42638112814761,
            "Rank": 92,
            "Perc_contribution_rescale": 1.05890138980807
        },
        {
            "Country": "Sweden",
            "Abs_contribution": 0.000608844111108759,
            "Perc_contribution": 0.15,
            "Fossil_abs": 0.000442301996101064,
            "Land_abs": 0.000166542115007693,
            "Fossil_fraction": 72.6461811867727,
            "Land_fraction": 27.3538188132271,
            "Rank": 93,
            "Perc_contribution_rescale": 0.992720052945069
        },
        {
            "Country": "C\xf4te d'Ivoire",
            "Abs_contribution": 0.000606111450107263,
            "Perc_contribution": 0.15,
            "Fossil_abs": 0.000449537071588678,
            "Land_abs": 0.000156574378518585,
            "Fossil_fraction": 74.1673947108446,
            "Land_fraction": 25.8326052891554,
            "Rank": 94,
            "Perc_contribution_rescale": 0.992720052945069
        },
        {
            "Country": "Zimbabwe",
            "Abs_contribution": 0.000583083645637218,
            "Perc_contribution": 0.14,
            "Fossil_abs": 0.000259035029499747,
            "Land_abs": 0.000324048616137472,
            "Fossil_fraction": 44.4250205674459,
            "Land_fraction": 55.5749794325543,
            "Rank": 95,
            "Perc_contribution_rescale": 0.926538716082065
        },
        {
            "Country": "Greece",
            "Abs_contribution": 0.000574666529310793,
            "Perc_contribution": 0.14,
            "Fossil_abs": 0.000372043261331133,
            "Land_abs": 0.000202623267979659,
            "Fossil_fraction": 64.7407222023755,
            "Land_fraction": 35.2592777976243,
            "Rank": 96,
            "Perc_contribution_rescale": 0.926538716082065
        },
        {
            "Country": "Belgium",
            "Abs_contribution": 0.000565319782153385,
            "Perc_contribution": 0.14,
            "Fossil_abs": 0.000288645370364362,
            "Land_abs": 0.000276674411789022,
            "Fossil_fraction": 51.0587776116501,
            "Land_fraction": 48.9412223883497,
            "Rank": 97,
            "Perc_contribution_rescale": 0.926538716082065
        },
        {
            "Country": "Sri Lanka",
            "Abs_contribution": 0.000547378263695655,
            "Perc_contribution": 0.13,
            "Fossil_abs": 0.00032969206970209,
            "Land_abs": 0.000217686193993566,
            "Fossil_fraction": 60.2311219806493,
            "Land_fraction": 39.7688780193509,
            "Rank": 98,
            "Perc_contribution_rescale": 0.86035737921906
        },
        {
            "Country": "Czechia",
            "Abs_contribution": 0.00054137135380257,
            "Perc_contribution": 0.13,
            "Fossil_abs": 0.000439129115207837,
            "Land_abs": 0.000102242238594735,
            "Fossil_fraction": 81.1142133996216,
            "Land_fraction": 18.8857866003788,
            "Rank": 99,
            "Perc_contribution_rescale": 0.86035737921906
        },
        {
            "Country": "Central African Republic",
            "Abs_contribution": 0.000535108386421928,
            "Perc_contribution": 0.13,
            "Fossil_abs": 5.86224545103145e-05,
            "Land_abs": 0.000476485931911614,
            "Fossil_fraction": 10.9552486931295,
            "Land_fraction": 89.0447513068705,
            "Rank": 100,
            "Perc_contribution_rescale": 0.86035737921906
        },
        {
            "Country": "Israel",
            "Abs_contribution": 0.000521550068817151,
            "Perc_contribution": 0.13,
            "Fossil_abs": 0.000489135155999646,
            "Land_abs": 3.24149128175034e-05,
            "Fossil_fraction": 93.7848895522111,
            "Land_fraction": 6.2151104477886,
            "Rank": 101,
            "Perc_contribution_rescale": 0.86035737921906
        },
        {
            "Country": "Dominican Republic",
            "Abs_contribution": 0.000503052907250158,
            "Perc_contribution": 0.12,
            "Fossil_abs": 0.000220190292658642,
            "Land_abs": 0.000282862614591516,
            "Fossil_fraction": 43.7708021333719,
            "Land_fraction": 56.2291978666279,
            "Rank": 102,
            "Perc_contribution_rescale": 0.794176042356056
        },
        {
            "Country": "Portugal",
            "Abs_contribution": 0.000487957381810443,
            "Perc_contribution": 0.12,
            "Fossil_abs": 0.000280516363412341,
            "Land_abs": 0.000207441018398101,
            "Fossil_fraction": 57.4878819071361,
            "Land_fraction": 42.5121180928637,
            "Rank": 103,
            "Perc_contribution_rescale": 0.794176042356056
        },
        {
            "Country": "Bulgaria",
            "Abs_contribution": 0.000470361281005613,
            "Perc_contribution": 0.11,
            "Fossil_abs": 0.00038388553974268,
            "Land_abs": 8.64757412629318e-05,
            "Fossil_fraction": 81.6150383215958,
            "Land_fraction": 18.3849616784039,
            "Rank": 104,
            "Perc_contribution_rescale": 0.727994705493051
        },
        {
            "Country": "Tunisia",
            "Abs_contribution": 0.000462076276041897,
            "Perc_contribution": 0.11,
            "Fossil_abs": 0.000352769267231957,
            "Land_abs": 0.000109307008809941,
            "Fossil_fraction": 76.3443798183595,
            "Land_fraction": 23.6556201816408,
            "Rank": 105,
            "Perc_contribution_rescale": 0.727994705493051
        },
        {
            "Country": "Austria",
            "Abs_contribution": 0.000457414727355867,
            "Perc_contribution": 0.11,
            "Fossil_abs": 0.000244934163938067,
            "Land_abs": 0.000212480563417801,
            "Fossil_fraction": 53.5475027999063,
            "Land_fraction": 46.4524972000939,
            "Rank": 106,
            "Perc_contribution_rescale": 0.727994705493051
        },
        {
            "Country": "Senegal",
            "Abs_contribution": 0.000449314063312449,
            "Perc_contribution": 0.11,
            "Fossil_abs": 0.000156832308887914,
            "Land_abs": 0.000292481754424535,
            "Fossil_fraction": 34.9048297602147,
            "Land_fraction": 65.0951702397853,
            "Rank": 107,
            "Perc_contribution_rescale": 0.727994705493051
        },
        {
            "Country": "Denmark",
            "Abs_contribution": 0.000441915945449382,
            "Perc_contribution": 0.11,
            "Fossil_abs": 0.000133061434287702,
            "Land_abs": 0.000308854511161679,
            "Fossil_fraction": 30.1101228995918,
            "Land_fraction": 69.889877100408,
            "Rank": 108,
            "Perc_contribution_rescale": 0.727994705493051
        },
        {
            "Country": "Haiti",
            "Abs_contribution": 0.000436810066826484,
            "Perc_contribution": 0.1,
            "Fossil_abs": 0.000293607781753032,
            "Land_abs": 0.000143202285073452,
            "Fossil_fraction": 67.2163496336413,
            "Land_fraction": 32.7836503663587,
            "Rank": 109,
            "Perc_contribution_rescale": 0.661813368630046
        },
        {
            "Country": "Nicaragua",
            "Abs_contribution": 0.000435598293442088,
            "Perc_contribution": 0.1,
            "Fossil_abs": 0.000101224925033362,
            "Land_abs": 0.000334373368408726,
            "Fossil_fraction": 23.238136273098,
            "Land_fraction": 76.761863726902,
            "Rank": 110,
            "Perc_contribution_rescale": 0.661813368630046
        },
        {
            "Country": "Equatorial Guinea",
            "Abs_contribution": 0.000429564659509668,
            "Perc_contribution": 0.1,
            "Fossil_abs": 0.000429052232195002,
            "Land_abs": 5.12427314665996e-07,
            "Fossil_fraction": 99.8807100855897,
            "Land_fraction": 0.119289914410304,
            "Rank": 111,
            "Perc_contribution_rescale": 0.661813368630046
        },
        {
            "Country": "Serbia",
            "Abs_contribution": 0.000426185049350799,
            "Perc_contribution": 0.1,
            "Fossil_abs": 0.000243011482877149,
            "Land_abs": 0.00018317356647365,
            "Fossil_fraction": 57.0201801417775,
            "Land_fraction": 42.9798198582225,
            "Rank": 112,
            "Perc_contribution_rescale": 0.661813368630046
        },
        {
            "Country": "Laos",
            "Abs_contribution": 0.000410806317667166,
            "Perc_contribution": 0.1,
            "Fossil_abs": 9.97078383896093e-05,
            "Land_abs": 0.000311098479277557,
            "Fossil_fraction": 24.2712524373572,
            "Land_fraction": 75.7287475626428,
            "Rank": 113,
            "Perc_contribution_rescale": 0.661813368630046
        },
        {
            "Country": "Honduras",
            "Abs_contribution": 0.00038411692236543,
            "Perc_contribution": 0.09,
            "Fossil_abs": 0.000174513007141787,
            "Land_abs": 0.000209603915223643,
            "Fossil_fraction": 45.4322621526588,
            "Land_fraction": 54.5677378473412,
            "Rank": 114,
            "Perc_contribution_rescale": 0.595632031767042
        },
        {
            "Country": "Mauritania",
            "Abs_contribution": 0.00030979971612101,
            "Perc_contribution": 0.07,
            "Fossil_abs": 6.02420749116608e-05,
            "Land_abs": 0.000249557641209348,
            "Fossil_fraction": 19.4454906757016,
            "Land_fraction": 80.5545093242984,
            "Rank": 115,
            "Perc_contribution_rescale": 0.463269358041033
        },
        {
            "Country": "Hungary",
            "Abs_contribution": 0.00030840128903238,
            "Perc_contribution": 0.07,
            "Fossil_abs": 0.000253249718351025,
            "Land_abs": 5.51515706813543e-05,
            "Fossil_fraction": 82.1169454724412,
            "Land_fraction": 17.8830545275587,
            "Rank": 116,
            "Perc_contribution_rescale": 0.463269358041033
        },
        {
            "Country": "Botswana",
            "Abs_contribution": 0.000289619400296513,
            "Perc_contribution": 0.07,
            "Fossil_abs": 6.44998505114499e-05,
            "Land_abs": 0.000225119549785063,
            "Fossil_fraction": 22.2705559245737,
            "Land_fraction": 77.7294440754262,
            "Rank": 117,
            "Perc_contribution_rescale": 0.463269358041033
        },
        {
            "Country": "Malawi",
            "Abs_contribution": 0.000284620074604762,
            "Perc_contribution": 0.07,
            "Fossil_abs": 0.000176441715978968,
            "Land_abs": 0.000108178358625792,
            "Fossil_fraction": 61.9920138184155,
            "Land_fraction": 38.0079861815842,
            "Rank": 118,
            "Perc_contribution_rescale": 0.463269358041033
        },
        {
            "Country": "Namibia",
            "Abs_contribution": 0.000275817603063069,
            "Perc_contribution": 0.07,
            "Fossil_abs": 4.14263251530304e-05,
            "Land_abs": 0.000234391277910039,
            "Fossil_fraction": 15.0194638387738,
            "Land_fraction": 84.9805361612262,
            "Rank": 119,
            "Perc_contribution_rescale": 0.463269358041033
        },
        {
            "Country": "Benin",
            "Abs_contribution": 0.000274521554158457,
            "Perc_contribution": 0.07,
            "Fossil_abs": 0.000148047906706616,
            "Land_abs": 0.000126473647451841,
            "Fossil_fraction": 53.9294290244185,
            "Land_fraction": 46.0705709755815,
            "Rank": 120,
            "Perc_contribution_rescale": 0.463269358041033
        },
        {
            "Country": "Brunei Darussalam",
            "Abs_contribution": 0.000272958514865401,
            "Perc_contribution": 0.07,
            "Fossil_abs": 0.000271938459145789,
            "Land_abs": 1.02005571961073e-06,
            "Fossil_fraction": 99.6262964281902,
            "Land_fraction": 0.373703571809708,
            "Rank": 121,
            "Perc_contribution_rescale": 0.463269358041033
        },
        {
            "Country": "Kyrgyzstan",
            "Abs_contribution": 0.000268233128428615,
            "Perc_contribution": 0.06,
            "Fossil_abs": 0.000120428188662641,
            "Land_abs": 0.000147804939765974,
            "Fossil_fraction": 44.8968363334325,
            "Land_fraction": 55.1031636665675,
            "Rank": 122,
            "Perc_contribution_rescale": 0.397088021178028
        },
        {
            "Country": "Tajikistan",
            "Abs_contribution": 0.00026364591440194,
            "Perc_contribution": 0.06,
            "Fossil_abs": 8.51321527805975e-05,
            "Land_abs": 0.000178513761621344,
            "Fossil_fraction": 32.2903364437537,
            "Land_fraction": 67.7096635562465,
            "Rank": 123,
            "Perc_contribution_rescale": 0.397088021178028
        },
        {
            "Country": "Switzerland",
            "Abs_contribution": 0.00025491074784909,
            "Perc_contribution": 0.06,
            "Fossil_abs": 7.3431983614219e-05,
            "Land_abs": 0.000181478764234871,
            "Fossil_fraction": 28.8069389909333,
            "Land_fraction": 71.1930610090668,
            "Rank": 124,
            "Perc_contribution_rescale": 0.397088021178028
        },
        {
            "Country": "Slovakia",
            "Abs_contribution": 0.000254454600721425,
            "Perc_contribution": 0.06,
            "Fossil_abs": 0.000203836918511462,
            "Land_abs": 5.06176822099633e-05,
            "Fossil_fraction": 80.1073818015265,
            "Land_fraction": 19.8926181984735,
            "Rank": 125,
            "Perc_contribution_rescale": 0.397088021178028
        },
        {
            "Country": "Hong Kong",
            "Abs_contribution": 0.000240359673052291,
            "Perc_contribution": 0.06,
            "Fossil_abs": 0.000238390238274081,
            "Land_abs": 1.96943477820927e-06,
            "Fossil_fraction": 99.1806301143614,
            "Land_fraction": 0.819369885638351,
            "Rank": 126,
            "Perc_contribution_rescale": 0.397088021178028
        },
        {
            "Country": "Rwanda",
            "Abs_contribution": 0.000226457565801878,
            "Perc_contribution": 0.05,
            "Fossil_abs": 0.000152705001539768,
            "Land_abs": 7.37525642621091e-05,
            "Fossil_fraction": 67.4320599530625,
            "Land_fraction": 32.5679400469373,
            "Rank": 127,
            "Perc_contribution_rescale": 0.330906684315023
        },
        {
            "Country": "Costa Rica",
            "Abs_contribution": 0.000223757599131121,
            "Perc_contribution": 0.05,
            "Fossil_abs": 0.000102177792550564,
            "Land_abs": 0.000121579806580557,
            "Fossil_fraction": 45.6645016514895,
            "Land_fraction": 54.3354983485105,
            "Rank": 128,
            "Perc_contribution_rescale": 0.330906684315023
        },
        {
            "Country": "Bosnia and Herzegovina",
            "Abs_contribution": 0.000222200290772218,
            "Perc_contribution": 0.05,
            "Fossil_abs": 0.00014857147369987,
            "Land_abs": 7.36288170723485e-05,
            "Fossil_fraction": 66.8637620515868,
            "Land_fraction": 33.1362379484134,
            "Rank": 129,
            "Perc_contribution_rescale": 0.330906684315023
        },
        {
            "Country": "Jordan",
            "Abs_contribution": 0.000217970675077506,
            "Perc_contribution": 0.05,
            "Fossil_abs": 0.000193312331282196,
            "Land_abs": 2.46583437953108e-05,
            "Fossil_fraction": 88.687311361245,
            "Land_fraction": 11.3126886387551,
            "Rank": 130,
            "Perc_contribution_rescale": 0.330906684315023
        },
        {
            "Country": "Singapore",
            "Abs_contribution": 0.000216053300902288,
            "Perc_contribution": 0.05,
            "Fossil_abs": 0.000214728019501869,
            "Land_abs": 1.32528140041797e-06,
            "Fossil_fraction": 99.3865951619881,
            "Land_fraction": 0.613404838011401,
            "Rank": 131,
            "Perc_contribution_rescale": 0.330906684315023
        },
        {
            "Country": "Togo",
            "Abs_contribution": 0.000215729186288483,
            "Perc_contribution": 0.05,
            "Fossil_abs": 0.000153391437727747,
            "Land_abs": 6.23377485607361e-05,
            "Fossil_fraction": 71.1037019917303,
            "Land_fraction": 28.8962980082701,
            "Rank": 132,
            "Perc_contribution_rescale": 0.330906684315023
        },
        {
            "Country": "Croatia",
            "Abs_contribution": 0.000209470828240746,
            "Perc_contribution": 0.05,
            "Fossil_abs": 0.000137178683885803,
            "Land_abs": 7.22921443549436e-05,
            "Fossil_fraction": 65.4882042706887,
            "Land_fraction": 34.5117957293117,
            "Rank": 133,
            "Perc_contribution_rescale": 0.330906684315023
        },
        {
            "Country": "Sierra Leone",
            "Abs_contribution": 0.000205413312156437,
            "Perc_contribution": 0.05,
            "Fossil_abs": 0.000104364179498007,
            "Land_abs": 0.00010104913265843,
            "Fossil_fraction": 50.8069211300803,
            "Land_fraction": 49.1930788699197,
            "Rank": 134,
            "Perc_contribution_rescale": 0.330906684315023
        },
        {
            "Country": "Eritrea",
            "Abs_contribution": 0.000203387169494885,
            "Perc_contribution": 0.05,
            "Fossil_abs": 6.41520286108906e-05,
            "Land_abs": 0.000139235140883994,
            "Fossil_fraction": 31.5418267387334,
            "Land_fraction": 68.4581732612665,
            "Rank": 135,
            "Perc_contribution_rescale": 0.330906684315023
        },
        {
            "Country": "Panama",
            "Abs_contribution": 0.000197255598694505,
            "Perc_contribution": 0.05,
            "Fossil_abs": 7.57644557485922e-05,
            "Land_abs": 0.000121491142945913,
            "Fossil_fraction": 38.409280268861,
            "Land_fraction": 61.5907197311391,
            "Rank": 136,
            "Perc_contribution_rescale": 0.330906684315023
        },
        {
            "Country": "El Salvador",
            "Abs_contribution": 0.000190568324040081,
            "Perc_contribution": 0.05,
            "Fossil_abs": 0.000101019369834123,
            "Land_abs": 8.9548954205958e-05,
            "Fossil_fraction": 53.0095283898683,
            "Land_fraction": 46.9904716101317,
            "Rank": 137,
            "Perc_contribution_rescale": 0.330906684315023
        },
        {
            "Country": "Papua New Guinea",
            "Abs_contribution": 0.000169829320678628,
            "Perc_contribution": 0.04,
            "Fossil_abs": 0.000127472174202554,
            "Land_abs": 4.23571464760736e-05,
            "Fossil_fraction": 75.0589908109992,
            "Land_fraction": 24.9410091890004,
            "Rank": 138,
            "Perc_contribution_rescale": 0.264725347452019
        },
        {
            "Country": "Burundi",
            "Abs_contribution": 0.000167626455800423,
            "Perc_contribution": 0.04,
            "Fossil_abs": 0.00012198106312,
            "Land_abs": 4.56453926804228e-05,
            "Fossil_fraction": 72.7695771753544,
            "Land_fraction": 27.2304228246455,
            "Rank": 139,
            "Perc_contribution_rescale": 0.264725347452019
        },
        {
            "Country": "Slovenia",
            "Abs_contribution": 0.000155979890248754,
            "Perc_contribution": 0.04,
            "Fossil_abs": 0.000102379578707487,
            "Land_abs": 5.36003115412676e-05,
            "Fossil_fraction": 65.6363961688994,
            "Land_fraction": 34.3636038311007,
            "Rank": 140,
            "Perc_contribution_rescale": 0.264725347452019
        },
        {
            "Country": "Lithuania",
            "Abs_contribution": 0.00015560197648152,
            "Perc_contribution": 0.04,
            "Fossil_abs": 8.42404127462979e-05,
            "Land_abs": 7.13615637352222e-05,
            "Fossil_fraction": 54.1383950584348,
            "Land_fraction": 45.8616049415655,
            "Rank": 141,
            "Perc_contribution_rescale": 0.264725347452019
        },
        {
            "Country": "Lebanon",
            "Abs_contribution": 0.000154579168308705,
            "Perc_contribution": 0.04,
            "Fossil_abs": 0.000143785207084796,
            "Land_abs": 1.07939612239087e-05,
            "Fossil_fraction": 93.0171954332474,
            "Land_fraction": 6.98280456675277,
            "Rank": 142,
            "Perc_contribution_rescale": 0.264725347452019
        },
        {
            "Country": "Georgia",
            "Abs_contribution": 0.000136553351165959,
            "Perc_contribution": 0.03,
            "Fossil_abs": 8.58331155184997e-05,
            "Land_abs": 5.07202356474594e-05,
            "Fossil_fraction": 62.8568356511319,
            "Land_fraction": 37.1431643488683,
            "Rank": 143,
            "Perc_contribution_rescale": 0.198544010589014
        },
        {
            "Country": "Estonia",
            "Abs_contribution": 0.000135666054917046,
            "Perc_contribution": 0.03,
            "Fossil_abs": 0.000108866425934629,
            "Land_abs": 2.67996289824166e-05,
            "Fossil_fraction": 80.2458846475607,
            "Land_fraction": 19.7541153524391,
            "Rank": 144,
            "Perc_contribution_rescale": 0.198544010589014
        },
        {
            "Country": "Albania",
            "Abs_contribution": 0.000134383260752189,
            "Perc_contribution": 0.03,
            "Fossil_abs": 3.38483330324042e-05,
            "Land_abs": 0.000100534927719785,
            "Fossil_fraction": 25.1879087045094,
            "Land_fraction": 74.8120912954909,
            "Rank": 145,
            "Perc_contribution_rescale": 0.198544010589014
        },
        {
            "Country": "Liberia",
            "Abs_contribution": 0.00010715284631827,
            "Perc_contribution": 0.03,
            "Fossil_abs": 9.69532802758696e-05,
            "Land_abs": 1.01995660424e-05,
            "Fossil_fraction": 90.4812924781253,
            "Land_fraction": 9.51870752187473,
            "Rank": 146,
            "Perc_contribution_rescale": 0.198544010589014
        },
        {
            "Country": "Timor-Leste",
            "Abs_contribution": 0.000104507361760157,
            "Perc_contribution": 0.03,
            "Fossil_abs": 7.64308640438409e-05,
            "Land_abs": 2.80764977163164e-05,
            "Fossil_fraction": 73.1344306817816,
            "Land_fraction": 26.8655693182184,
            "Rank": 147,
            "Perc_contribution_rescale": 0.198544010589014
        },
        {
            "Country": "Moldova",
            "Abs_contribution": 8.95965716259956e-05,
            "Perc_contribution": 0.02,
            "Fossil_abs": 5.13489598201107e-05,
            "Land_abs": 3.8247611805885e-05,
            "Fossil_fraction": 57.3112998502415,
            "Land_fraction": 42.6887001497586,
            "Rank": 148,
            "Perc_contribution_rescale": 0.132362673726009
        },
        {
            "Country": "North Macedonia",
            "Abs_contribution": 8.43166277141347e-05,
            "Perc_contribution": 0.02,
            "Fossil_abs": 4.03310581552668e-05,
            "Land_abs": 4.39855695588682e-05,
            "Fossil_fraction": 47.8328643455765,
            "Land_fraction": 52.1671356544238,
            "Rank": 149,
            "Perc_contribution_rescale": 0.132362673726009
        },
        {
            "Country": "Guinea-Bissau",
            "Abs_contribution": 8.42009753013544e-05,
            "Perc_contribution": 0.02,
            "Fossil_abs": 3.53771661334159e-05,
            "Land_abs": 4.88238091679388e-05,
            "Fossil_fraction": 42.015150070176,
            "Land_fraction": 57.9848499298243,
            "Rank": 150,
            "Perc_contribution_rescale": 0.132362673726009
        },
        {
            "Country": "Lesotho",
            "Abs_contribution": 8.12667968520689e-05,
            "Perc_contribution": 0.02,
            "Fossil_abs": 3.76597522271647e-05,
            "Land_abs": 4.36070446249044e-05,
            "Fossil_fraction": 46.3408842060274,
            "Land_fraction": 53.6591157939729,
            "Rank": 151,
            "Perc_contribution_rescale": 0.132362673726009
        },
        {
            "Country": "Guyana",
            "Abs_contribution": 7.59847407767653e-05,
            "Perc_contribution": 0.02,
            "Fossil_abs": 2.19854772069786e-05,
            "Land_abs": 5.39992635697865e-05,
            "Fossil_fraction": 28.9340688435978,
            "Land_fraction": 71.0659311564019,
            "Rank": 152,
            "Perc_contribution_rescale": 0.132362673726009
        },
        {
            "Country": "Latvia",
            "Abs_contribution": 7.46284205213232e-05,
            "Perc_contribution": 0.02,
            "Fossil_abs": 4.30928375651263e-05,
            "Land_abs": 3.15355829561969e-05,
            "Fossil_fraction": 57.7431992585367,
            "Land_fraction": 42.2568007414634,
            "Rank": 153,
            "Perc_contribution_rescale": 0.132362673726009
        },
        {
            "Country": "Swaziland",
            "Abs_contribution": 6.55243279702079e-05,
            "Perc_contribution": 0.02,
            "Fossil_abs": 3.38657779704469e-05,
            "Land_abs": 3.16585499997611e-05,
            "Fossil_fraction": 51.6842812731246,
            "Land_fraction": 48.3157187268755,
            "Rank": 154,
            "Perc_contribution_rescale": 0.132362673726009
        },
        {
            "Country": "Armenia",
            "Abs_contribution": 6.17354636745717e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 2.91897024440029e-05,
            "Land_abs": 3.25457612305688e-05,
            "Fossil_fraction": 47.2819036362498,
            "Land_fraction": 52.7180963637504,
            "Rank": 155,
            "Perc_contribution_rescale": 0.0661813368630046
        },
        {
            "Country": "Gambia",
            "Abs_contribution": 5.90354861001883e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 2.24365664175402e-05,
            "Land_abs": 3.65989196826481e-05,
            "Fossil_fraction": 38.0052200797728,
            "Land_fraction": 61.9947799202272,
            "Rank": 156,
            "Perc_contribution_rescale": 0.0661813368630046
        },
        {
            "Country": "Jamaica",
            "Abs_contribution": 5.51864091518041e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 3.56890566308577e-05,
            "Land_abs": 1.94973525209464e-05,
            "Fossil_fraction": 64.6700105685186,
            "Land_fraction": 35.3299894314812,
            "Rank": 157,
            "Perc_contribution_rescale": 0.0661813368630046
        },
        {
            "Country": "Djibouti",
            "Abs_contribution": 4.68863543284549e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 2.51785742216805e-05,
            "Land_abs": 2.17077801067743e-05,
            "Fossil_fraction": 53.7012838432608,
            "Land_fraction": 46.2987161567392,
            "Rank": 158,
            "Perc_contribution_rescale": 0.0661813368630046
        },
        {
            "Country": "Bhutan",
            "Abs_contribution": 4.45907839936787e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 2.78940504391596e-05,
            "Land_abs": 1.6696733554519e-05,
            "Fossil_fraction": 62.5556402935503,
            "Land_fraction": 37.4443597064497,
            "Rank": 159,
            "Perc_contribution_rescale": 0.0661813368630046
        },
        {
            "Country": "Suriname",
            "Abs_contribution": 4.34506167164881e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 2.10097205744665e-05,
            "Land_abs": 2.24408961420217e-05,
            "Fossil_fraction": 48.3531009733492,
            "Land_fraction": 51.6468990266508,
            "Rank": 160,
            "Perc_contribution_rescale": 0.0661813368630046
        },
        {
            "Country": "Fiji",
            "Abs_contribution": 4.07910806360475e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 1.74398345028102e-05,
            "Land_abs": 2.33512461332372e-05,
            "Fossil_fraction": 42.7540389488933,
            "Land_fraction": 57.2459610511065,
            "Rank": 161,
            "Perc_contribution_rescale": 0.0661813368630046
        },
        {
            "Country": "Montenegro",
            "Abs_contribution": 3.92759786482398e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 2.21815050293237e-05,
            "Land_abs": 1.7094473618916e-05,
            "Fossil_fraction": 56.4760084732295,
            "Land_fraction": 43.5239915267702,
            "Rank": 162,
            "Perc_contribution_rescale": 0.0661813368630046
        },
        {
            "Country": "Cyprus",
            "Abs_contribution": 3.40747394964975e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 2.68777553902726e-05,
            "Land_abs": 7.19698410622485e-06,
            "Fossil_fraction": 78.8788286790436,
            "Land_fraction": 21.1211713209565,
            "Rank": 163,
            "Perc_contribution_rescale": 0.0661813368630046
        },
        {
            "Country": "Mauritius",
            "Abs_contribution": 2.96489687376836e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 2.85206523064683e-05,
            "Land_abs": 1.12831643121533e-06,
            "Fossil_fraction": 96.1944159299502,
            "Land_fraction": 3.8055840700498,
            "Rank": 164,
            "Perc_contribution_rescale": 0.0661813368630046
        },
        {
            "Country": "Iceland",
            "Abs_contribution": 2.8048230066216e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 1.32743781057269e-05,
            "Land_abs": 1.4773851960489e-05,
            "Fossil_fraction": 47.3269724128361,
            "Land_fraction": 52.6730275871635,
            "Rank": 165,
            "Perc_contribution_rescale": 0.0661813368630046
        },
        {
            "Country": "Luxembourg",
            "Abs_contribution": 2.32021738181736e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 5.33494598101797e-06,
            "Land_abs": 1.78672278371557e-05,
            "Fossil_fraction": 22.993302363933,
            "Land_fraction": 77.006697636067,
            "Rank": 166,
            "Perc_contribution_rescale": 0.0661813368630046
        },
        {
            "Country": "Comoros",
            "Abs_contribution": 2.13395931491189e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 1.21492884525585e-05,
            "Land_abs": 9.19030469656041e-06,
            "Fossil_fraction": 56.9330838112071,
            "Land_fraction": 43.0669161887927,
            "Rank": 167,
            "Perc_contribution_rescale": 0.0661813368630046
        },
        {
            "Country": "Belize",
            "Abs_contribution": 1.87800358763219e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 1.18085542111083e-05,
            "Land_abs": 6.97148166521365e-06,
            "Fossil_fraction": 62.8782303126304,
            "Land_fraction": 37.1217696873698,
            "Rank": 168,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Vanuatu",
            "Abs_contribution": 1.60654390230834e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 4.14161986418545e-06,
            "Land_abs": 1.1923819158898e-05,
            "Fossil_fraction": 25.7796868061596,
            "Land_fraction": 74.2203131938406,
            "Rank": 169,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Bahamas",
            "Abs_contribution": 1.54231867927844e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 1.48777858725781e-05,
            "Land_abs": 5.45400920206316e-07,
            "Fossil_fraction": 96.4637598731445,
            "Land_fraction": 3.53624012685547,
            "Rank": 170,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Barbados",
            "Abs_contribution": 9.13092925308378e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 8.26255729848427e-06,
            "Land_abs": 8.68371954599509e-07,
            "Fossil_fraction": 90.4897745833894,
            "Land_fraction": 9.51022541661064,
            "Rank": 171,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Samoa",
            "Abs_contribution": 8.37789791889468e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 2.22823288830043e-06,
            "Land_abs": 6.14966503059427e-06,
            "Fossil_fraction": 26.5965628833349,
            "Land_fraction": 73.4034371166654,
            "Rank": 172,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Cape Verde",
            "Abs_contribution": 8.32159612688345e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 5.76427316051963e-06,
            "Land_abs": 2.55732296636383e-06,
            "Fossil_fraction": 69.2688406482234,
            "Land_fraction": 30.7311593517767,
            "Rank": 173,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Solomon Islands",
            "Abs_contribution": 8.04133321772019e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 5.62380288144533e-06,
            "Land_abs": 2.41753033627486e-06,
            "Fossil_fraction": 69.9361999954498,
            "Land_fraction": 30.0638000045502,
            "Rank": 174,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Malta",
            "Abs_contribution": 7.86859313689646e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 4.80977271895687e-06,
            "Land_abs": 3.05882041793959e-06,
            "Fossil_fraction": 61.1262094160577,
            "Land_fraction": 38.8737905839423,
            "Rank": 175,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Maldives",
            "Abs_contribution": 6.05038747858304e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 6.05027290828293e-06,
            "Land_abs": 1.14570300115205e-10,
            "Fossil_fraction": 99.998106397309,
            "Land_fraction": 0.00189360269107982,
            "Rank": 176,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Macao",
            "Abs_contribution": 4.67717007564926e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 4.6598029618132e-06,
            "Land_abs": 1.73671138360716e-08,
            "Fossil_fraction": 99.6286832944887,
            "Land_fraction": 0.371316705511522,
            "Rank": 177,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Tonga",
            "Abs_contribution": 3.92526104873696e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.31713905749336e-06,
            "Land_abs": 2.6081219912436e-06,
            "Fossil_fraction": 33.555451246158,
            "Land_fraction": 66.444548753842,
            "Rank": 178,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Andorra",
            "Abs_contribution": 3.86293204713475e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.60712638241729e-06,
            "Land_abs": 2.25580566471746e-06,
            "Fossil_fraction": 41.6037963600561,
            "Land_fraction": 58.3962036399439,
            "Rank": 179,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Lucia",
            "Abs_contribution": 3.73376996618499e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 2.67169375011573e-06,
            "Land_abs": 1.06207621606926e-06,
            "Fossil_fraction": 71.5548567349359,
            "Land_fraction": 28.4451432650641,
            "Rank": 180,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Antigua and Barbuda",
            "Abs_contribution": 2.98201798492455e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 2.18443386187312e-06,
            "Land_abs": 7.97584123051423e-07,
            "Fossil_fraction": 73.2535441743284,
            "Land_fraction": 26.7464558256715,
            "Rank": 181,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Sao Tome and Principe",
            "Abs_contribution": 2.96957848238657e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 2.75361885645231e-06,
            "Land_abs": 2.15959625934264e-07,
            "Fossil_fraction": 92.7275999871637,
            "Land_fraction": 7.27240001283627,
            "Rank": 182,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Seychelles",
            "Abs_contribution": 2.94745725131109e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 2.87660189903438e-06,
            "Land_abs": 7.0855352276703e-08,
            "Fossil_fraction": 97.5960515713947,
            "Land_fraction": 2.4039484286052,
            "Rank": 183,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Dominica",
            "Abs_contribution": 2.82740317038503e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.63525942633893e-06,
            "Land_abs": 1.19214374404611e-06,
            "Fossil_fraction": 57.8360894359556,
            "Land_fraction": 42.1639105640447,
            "Rank": 184,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Palau",
            "Abs_contribution": 2.57045377418183e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 2.32298230046797e-06,
            "Land_abs": 2.47471473713864e-07,
            "Fossil_fraction": 90.3724596723148,
            "Land_fraction": 9.6275403276853,
            "Rank": 185,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Micronesia (Federated States of)",
            "Abs_contribution": 2.16446867055249e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.76525150257865e-07,
            "Land_abs": 1.98794352029463e-06,
            "Fossil_fraction": 8.15558814315412,
            "Land_fraction": 91.8444118568459,
            "Rank": 186,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Vincent and the Grenadines",
            "Abs_contribution": 2.14029059575896e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.79643938736118e-06,
            "Land_abs": 3.43851208397785e-07,
            "Fossil_fraction": 83.9343681143517,
            "Land_fraction": 16.0656318856483,
            "Rank": 187,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Grenada",
            "Abs_contribution": 2.05046933820796e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.7367240222059e-06,
            "Land_abs": 3.13745316002052e-07,
            "Fossil_fraction": 84.6988535670441,
            "Land_fraction": 15.3011464329554,
            "Rank": 188,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Kiribati",
            "Abs_contribution": 1.12928905424699e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 8.92986548828644e-07,
            "Land_abs": 2.36302505418342e-07,
            "Fossil_fraction": 79.0751088457231,
            "Land_fraction": 20.9248911542766,
            "Rank": 189,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Liechtenstein",
            "Abs_contribution": 1.0108472183021e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 3.24976084753065e-07,
            "Land_abs": 6.85871133549028e-07,
            "Fossil_fraction": 32.148882528353,
            "Land_fraction": 67.8511174716467,
            "Rank": 190,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Cook Islands",
            "Abs_contribution": 7.89232114908237e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 2.17722629671169e-07,
            "Land_abs": 5.7150948523707e-07,
            "Fossil_fraction": 27.5866409334449,
            "Land_fraction": 72.4133590665554,
            "Rank": 191,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Turks and Caicos Islands",
            "Abs_contribution": 5.73921487671202e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 5.7348687190701e-07,
            "Land_abs": 4.3461576419214e-10,
            "Fossil_fraction": 99.9242726098381,
            "Land_fraction": 0.0757273901619676,
            "Rank": 192,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Kitts and Nevis",
            "Abs_contribution": 4.23675931465438e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 1.74758340165097e-07,
            "Land_abs": 2.48917591300341e-07,
            "Fossil_fraction": 41.2481161156906,
            "Land_fraction": 58.7518838843094,
            "Rank": 193,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Tuvalu",
            "Abs_contribution": 4.06150509713384e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 1.55140809218316e-07,
            "Land_abs": 2.51009700495068e-07,
            "Fossil_fraction": 38.1978615089754,
            "Land_fraction": 61.8021384910246,
            "Rank": 194,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Nauru",
            "Abs_contribution": 1.71938716191068e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 1.18470220199208e-07,
            "Land_abs": 5.34684959918605e-08,
            "Fossil_fraction": 68.9025850742987,
            "Land_fraction": 31.0974149257014,
            "Rank": 195,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Niue",
            "Abs_contribution": 3.97724767609158e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 5.46386238540827e-10,
            "Land_abs": 3.92260905223751e-08,
            "Fossil_fraction": 1.37377976691096,
            "Land_fraction": 98.6262202330892,
            "Rank": 196,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Anguilla",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 197,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Antarctica",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 198,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Aruba",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 199,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Bermuda",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 200,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Bonaire, Saint Eustatius and Saba",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 201,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "British Virgin Islands",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 202,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Christmas Island",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 203,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Cura\xe7ao",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 204,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Faeroe Islands",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 205,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "French Polynesia",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 206,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Greenland",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 207,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Kosovo",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 208,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Kuwaiti Oil Fires",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 209,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Leeward Islands",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 210,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Marshall Islands",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 211,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Montserrat",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 212,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "New Caledonia",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 213,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Occupied Palestinian Territory",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 214,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Pacific Islands (Palau)",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 215,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Panama Canal Zone",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 216,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Ryukyu Islands",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 217,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Helena",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 218,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Pierre and Miquelon",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 219,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Sint Maarten (Dutch part)",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 220,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "St. Kitts-Nevis-Anguilla",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 221,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Wallis and Futuna Islands",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 222,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Ireland",
            "Abs_contribution": -0.000537250727192785,
            "Perc_contribution": -0.13,
            "Fossil_abs": -0.000129775164830391,
            "Land_abs": -0.000407475562362396,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 223,
            "Perc_contribution_rescale": 0
        }
    ],
    "1851_CO2": [
        {
            "Country": "United States",
            "Abs_contribution": 0.236385212207033,
            "Perc_contribution": 20.83,
            "Fossil_abs": 0.192154727782533,
            "Land_abs": 0.0442304844245,
            "Fossil_fraction": 81.2888107460116,
            "Land_fraction": 18.7111892539884,
            "Rank": 1,
            "Perc_contribution_rescale": 100
        },
        {
            "Country": "EU27",
            "Abs_contribution": 0.135017969335259,
            "Perc_contribution": 11.9,
            "Fossil_abs": 0.132868382500259,
            "Land_abs": 0.002149586835,
            "Fossil_fraction": 98.4079253705391,
            "Land_fraction": 1.59207462946093,
            "Rank": 2,
            "Perc_contribution_rescale": 57.129140662506
        },
        {
            "Country": "China",
            "Abs_contribution": 0.134845708297771,
            "Perc_contribution": 11.88,
            "Fossil_abs": 0.117364015409771,
            "Land_abs": 0.017481692888,
            "Fossil_fraction": 87.0357810354659,
            "Land_fraction": 12.9642189645341,
            "Rank": 3,
            "Perc_contribution_rescale": 57.033125300048
        },
        {
            "Country": "Russia",
            "Abs_contribution": 0.0807770615782149,
            "Perc_contribution": 7.12,
            "Fossil_abs": 0.0537198853332151,
            "Land_abs": 0.027057176245,
            "Fossil_fraction": 66.5038864792069,
            "Land_fraction": 33.4961135207933,
            "Rank": 4,
            "Perc_contribution_rescale": 34.1814690350456
        },
        {
            "Country": "Brazil",
            "Abs_contribution": 0.0536196351956021,
            "Perc_contribution": 4.73,
            "Fossil_abs": 0.00773517944660207,
            "Land_abs": 0.045884455749,
            "Fossil_fraction": 14.42602027855,
            "Land_fraction": 85.57397972145,
            "Rank": 5,
            "Perc_contribution_rescale": 22.7076332213154
        },
        {
            "Country": "Indonesia",
            "Abs_contribution": 0.0439055353421386,
            "Perc_contribution": 3.87,
            "Fossil_abs": 0.00707559687813865,
            "Land_abs": 0.036829938464,
            "Fossil_fraction": 16.1155007517875,
            "Land_fraction": 83.8844992482127,
            "Rank": 6,
            "Perc_contribution_rescale": 18.5789726356217
        },
        {
            "Country": "Germany",
            "Abs_contribution": 0.0413857975774105,
            "Perc_contribution": 3.65,
            "Fossil_abs": 0.0422021481894105,
            "Land_abs": -0.000816350612000001,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 7,
            "Perc_contribution_rescale": 17.5228036485838
        },
        {
            "Country": "India",
            "Abs_contribution": 0.0372715103257342,
            "Perc_contribution": 3.28,
            "Fossil_abs": 0.0269028809282342,
            "Land_abs": 0.0103686293975,
            "Fossil_fraction": 72.1808177160426,
            "Land_fraction": 27.8191822839574,
            "Rank": 8,
            "Perc_contribution_rescale": 15.7465194431109
        },
        {
            "Country": "United Kingdom",
            "Abs_contribution": 0.0350516871513821,
            "Perc_contribution": 3.09,
            "Fossil_abs": 0.0337772047003821,
            "Land_abs": 0.001274482451,
            "Fossil_fraction": 96.3639911382989,
            "Land_fraction": 3.6360088617011,
            "Rank": 9,
            "Perc_contribution_rescale": 14.83437349976
        },
        {
            "Country": "Japan",
            "Abs_contribution": 0.031947426937262,
            "Perc_contribution": 2.82,
            "Fossil_abs": 0.030502894485262,
            "Land_abs": 0.001444532452,
            "Fossil_fraction": 95.4784075260998,
            "Land_fraction": 4.52159247390019,
            "Rank": 10,
            "Perc_contribution_rescale": 13.5381661065771
        },
        {
            "Country": "Canada",
            "Abs_contribution": 0.0278166521479312,
            "Perc_contribution": 2.45,
            "Fossil_abs": 0.0155870528429312,
            "Land_abs": 0.012229599305,
            "Fossil_fraction": 56.0349705638119,
            "Land_fraction": 43.9650294361881,
            "Rank": 11,
            "Perc_contribution_rescale": 11.7618819011042
        },
        {
            "Country": "Ukraine",
            "Abs_contribution": 0.0178730323345906,
            "Perc_contribution": 1.58,
            "Fossil_abs": 0.0139428009745906,
            "Land_abs": 0.00393023136,
            "Fossil_fraction": 78.0102710808976,
            "Land_fraction": 21.9897289191024,
            "Rank": 12,
            "Perc_contribution_rescale": 7.58521363418147
        },
        {
            "Country": "France",
            "Abs_contribution": 0.0164586716720562,
            "Perc_contribution": 1.45,
            "Fossil_abs": 0.0175795393210562,
            "Land_abs": -0.001120867649,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 13,
            "Perc_contribution_rescale": 6.96111377820451
        },
        {
            "Country": "Australia",
            "Abs_contribution": 0.0145029922525191,
            "Perc_contribution": 1.28,
            "Fossil_abs": 0.00868413365751911,
            "Land_abs": 0.005818858595,
            "Fossil_fraction": 59.8782203445686,
            "Land_fraction": 40.1217796554313,
            "Rank": 14,
            "Perc_contribution_rescale": 6.14498319731157
        },
        {
            "Country": "Mexico",
            "Abs_contribution": 0.0139864485290486,
            "Perc_contribution": 1.23,
            "Fossil_abs": 0.00951068181054858,
            "Land_abs": 0.0044757667185,
            "Fossil_fraction": 67.9992622201108,
            "Land_fraction": 32.0007377798891,
            "Rank": 15,
            "Perc_contribution_rescale": 5.90494479116659
        },
        {
            "Country": "Poland",
            "Abs_contribution": 0.012447767098274,
            "Perc_contribution": 1.1,
            "Fossil_abs": 0.012805870376774,
            "Land_abs": -0.0003581032785,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 16,
            "Perc_contribution_rescale": 5.28084493518963
        },
        {
            "Country": "South Africa",
            "Abs_contribution": 0.0120441891862533,
            "Perc_contribution": 1.06,
            "Fossil_abs": 0.00984415142325327,
            "Land_abs": 0.002200037763,
            "Fossil_fraction": 81.7336166928443,
            "Land_fraction": 18.2663833071555,
            "Rank": 17,
            "Perc_contribution_rescale": 5.08881421027364
        },
        {
            "Country": "Italy",
            "Abs_contribution": 0.0113509228826539,
            "Perc_contribution": 1,
            "Fossil_abs": 0.0114457255741539,
            "Land_abs": -0.0000948026914999998,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 18,
            "Perc_contribution_rescale": 4.80076812289966
        },
        {
            "Country": "Argentina",
            "Abs_contribution": 0.0113025084253876,
            "Perc_contribution": 1,
            "Fossil_abs": 0.00396941694538755,
            "Land_abs": 0.00733309148000001,
            "Fossil_fraction": 35.119787537353,
            "Land_fraction": 64.8802124626466,
            "Rank": 19,
            "Perc_contribution_rescale": 4.80076812289966
        },
        {
            "Country": "Kazakhstan",
            "Abs_contribution": 0.0110605492766856,
            "Perc_contribution": 0.97,
            "Fossil_abs": 0.00640631101768559,
            "Land_abs": 0.00465423825900001,
            "Fossil_fraction": 57.9203695714224,
            "Land_fraction": 42.0796304285776,
            "Rank": 20,
            "Perc_contribution_rescale": 4.65674507921267
        },
        {
            "Country": "Colombia",
            "Abs_contribution": 0.0100196857099727,
            "Perc_contribution": 0.88,
            "Fossil_abs": 0.00163731531247271,
            "Land_abs": 0.00838237039750001,
            "Fossil_fraction": 16.3409847361088,
            "Land_fraction": 83.6590152638914,
            "Rank": 21,
            "Perc_contribution_rescale": 4.22467594815171
        },
        {
            "Country": "Iran",
            "Abs_contribution": 0.00945564805137442,
            "Perc_contribution": 0.83,
            "Fossil_abs": 0.00894023786487445,
            "Land_abs": 0.000515410186499997,
            "Fossil_fraction": 94.5491817832089,
            "Land_fraction": 5.45081821679139,
            "Rank": 22,
            "Perc_contribution_rescale": 3.98463754200672
        },
        {
            "Country": "South Korea",
            "Abs_contribution": 0.00920128566557043,
            "Perc_contribution": 0.81,
            "Fossil_abs": 0.00879436211557041,
            "Land_abs": 0.00040692355,
            "Fossil_fraction": 95.5775359575819,
            "Land_fraction": 4.42246404241785,
            "Rank": 23,
            "Perc_contribution_rescale": 3.88862217954873
        },
        {
            "Country": "Democratic Republic of the Congo",
            "Abs_contribution": 0.00919548003607043,
            "Perc_contribution": 0.81,
            "Fossil_abs": 0.000100465503070415,
            "Land_abs": 0.00909501453300002,
            "Fossil_fraction": 1.09255310953127,
            "Land_fraction": 98.9074468904688,
            "Rank": 24,
            "Perc_contribution_rescale": 3.88862217954873
        },
        {
            "Country": "Thailand",
            "Abs_contribution": 0.00895840037211463,
            "Perc_contribution": 0.79,
            "Fossil_abs": 0.00350022807011463,
            "Land_abs": 0.005458172302,
            "Fossil_fraction": 39.0720209492981,
            "Land_fraction": 60.9279790507019,
            "Rank": 25,
            "Perc_contribution_rescale": 3.79260681709074
        },
        {
            "Country": "Malaysia",
            "Abs_contribution": 0.00826703777918011,
            "Perc_contribution": 0.73,
            "Fossil_abs": 0.00292233711018013,
            "Land_abs": 0.00534470066899998,
            "Fossil_fraction": 35.3492652173407,
            "Land_fraction": 64.6507347826593,
            "Rank": 26,
            "Perc_contribution_rescale": 3.50456072971675
        },
        {
            "Country": "Saudi Arabia",
            "Abs_contribution": 0.00788134928629203,
            "Perc_contribution": 0.69,
            "Fossil_abs": 0.00792391248279203,
            "Land_abs": -0.0000425631965,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 27,
            "Perc_contribution_rescale": 3.31253000480077
        },
        {
            "Country": "Nigeria",
            "Abs_contribution": 0.00716474919548964,
            "Perc_contribution": 0.63,
            "Fossil_abs": 0.00199090325448963,
            "Land_abs": 0.00517384594100001,
            "Fossil_fraction": 27.7874800661961,
            "Land_fraction": 72.2125199338039,
            "Rank": 28,
            "Perc_contribution_rescale": 3.02448391742679
        },
        {
            "Country": "Spain",
            "Abs_contribution": 0.0071062510780502,
            "Perc_contribution": 0.63,
            "Fossil_abs": 0.00688824998155022,
            "Land_abs": 0.0002180010965,
            "Fossil_fraction": 96.932262959673,
            "Land_fraction": 3.06773704032724,
            "Rank": 29,
            "Perc_contribution_rescale": 3.02448391742679
        },
        {
            "Country": "Philippines",
            "Abs_contribution": 0.00703706585511848,
            "Perc_contribution": 0.62,
            "Fossil_abs": 0.00165738095661845,
            "Land_abs": 0.00537968489850003,
            "Fossil_fraction": 23.5521592484876,
            "Land_fraction": 76.4478407515124,
            "Rank": 30,
            "Perc_contribution_rescale": 2.97647623619779
        },
        {
            "Country": "Myanmar",
            "Abs_contribution": 0.00649382428790229,
            "Perc_contribution": 0.57,
            "Fossil_abs": 0.000303580409402293,
            "Land_abs": 0.0061902438785,
            "Fossil_fraction": 4.67490951314852,
            "Land_fraction": 95.3250904868515,
            "Rank": 31,
            "Perc_contribution_rescale": 2.73643783005281
        },
        {
            "Country": "Venezuela",
            "Abs_contribution": 0.00635353185131332,
            "Perc_contribution": 0.56,
            "Fossil_abs": 0.00344178218081332,
            "Land_abs": 0.0029117496705,
            "Fossil_fraction": 54.1711643438425,
            "Land_fraction": 45.8288356561575,
            "Rank": 32,
            "Perc_contribution_rescale": 2.68843014882381
        },
        {
            "Country": "T\xfcrkiye",
            "Abs_contribution": 0.00633084712776254,
            "Perc_contribution": 0.56,
            "Fossil_abs": 0.00530790962976255,
            "Land_abs": 0.001022937498,
            "Fossil_fraction": 83.8420123349035,
            "Land_fraction": 16.1579876650967,
            "Rank": 33,
            "Perc_contribution_rescale": 2.68843014882381
        },
        {
            "Country": "Viet Nam",
            "Abs_contribution": 0.00631657445934007,
            "Perc_contribution": 0.56,
            "Fossil_abs": 0.00226212289884007,
            "Land_abs": 0.0040544515605,
            "Fossil_fraction": 35.8124947849725,
            "Land_fraction": 64.1875052150275,
            "Rank": 34,
            "Perc_contribution_rescale": 2.68843014882381
        },
        {
            "Country": "Belgium",
            "Abs_contribution": 0.00581501869779147,
            "Perc_contribution": 0.51,
            "Fossil_abs": 0.00566254258829148,
            "Land_abs": 0.0001524761095,
            "Fossil_fraction": 97.3778913289152,
            "Land_fraction": 2.62210867108493,
            "Rank": 35,
            "Perc_contribution_rescale": 2.44839174267883
        },
        {
            "Country": "Netherlands",
            "Abs_contribution": 0.00580049817398857,
            "Perc_contribution": 0.51,
            "Fossil_abs": 0.00540417671548854,
            "Land_abs": 0.0003963214585,
            "Fossil_fraction": 93.1674582663042,
            "Land_fraction": 6.83254173369525,
            "Rank": 36,
            "Perc_contribution_rescale": 2.44839174267883
        },
        {
            "Country": "Czechia",
            "Abs_contribution": 0.00503186011632208,
            "Perc_contribution": 0.44,
            "Fossil_abs": 0.00548289668032205,
            "Land_abs": -0.000451036564,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 37,
            "Perc_contribution_rescale": 2.11233797407585
        },
        {
            "Country": "Romania",
            "Abs_contribution": 0.00433545679062009,
            "Perc_contribution": 0.38,
            "Fossil_abs": 0.00393291101512009,
            "Land_abs": 0.0004025457755,
            "Fossil_fraction": 90.7150320037574,
            "Land_fraction": 9.28496799624256,
            "Rank": 38,
            "Perc_contribution_rescale": 1.82429188670187
        },
        {
            "Country": "Taiwan",
            "Abs_contribution": 0.00432943357291212,
            "Perc_contribution": 0.38,
            "Fossil_abs": 0.00432943357291212,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 39,
            "Perc_contribution_rescale": 1.82429188670187
        },
        {
            "Country": "Tanzania",
            "Abs_contribution": 0.00425523659301419,
            "Perc_contribution": 0.38,
            "Fossil_abs": 0.000124559619514192,
            "Land_abs": 0.0041306769735,
            "Fossil_fraction": 2.92720784829406,
            "Land_fraction": 97.072792151706,
            "Rank": 40,
            "Perc_contribution_rescale": 1.82429188670187
        },
        {
            "Country": "C\xf4te d'Ivoire",
            "Abs_contribution": 0.00414910050116321,
            "Perc_contribution": 0.37,
            "Fossil_abs": 0.00016502710566321,
            "Land_abs": 0.0039840733955,
            "Fossil_fraction": 3.97741885541081,
            "Land_fraction": 96.0225811445892,
            "Rank": 41,
            "Perc_contribution_rescale": 1.77628420547288
        },
        {
            "Country": "Belarus",
            "Abs_contribution": 0.00408963344091812,
            "Perc_contribution": 0.36,
            "Fossil_abs": 0.00228372157491812,
            "Land_abs": 0.001805911866,
            "Fossil_fraction": 55.8417180392927,
            "Land_fraction": 44.1582819607073,
            "Rank": 42,
            "Perc_contribution_rescale": 1.72827652424388
        },
        {
            "Country": "Angola",
            "Abs_contribution": 0.00367577420703439,
            "Perc_contribution": 0.32,
            "Fossil_abs": 0.000305761341034389,
            "Land_abs": 0.003370012866,
            "Fossil_fraction": 8.31828408962793,
            "Land_fraction": 91.681715910372,
            "Rank": 43,
            "Perc_contribution_rescale": 1.53624579932789
        },
        {
            "Country": "Egypt",
            "Abs_contribution": 0.00341688683400655,
            "Perc_contribution": 0.3,
            "Fossil_abs": 0.00314275624650655,
            "Land_abs": 0.0002741305875,
            "Fossil_fraction": 91.9771827158068,
            "Land_fraction": 8.02281728419322,
            "Rank": 44,
            "Perc_contribution_rescale": 1.4402304368699
        },
        {
            "Country": "Uzbekistan",
            "Abs_contribution": 0.00341406903499618,
            "Perc_contribution": 0.3,
            "Fossil_abs": 0.00291954677599618,
            "Land_abs": 0.000494522259000002,
            "Fossil_fraction": 85.5151652198341,
            "Land_fraction": 14.4848347801659,
            "Rank": 45,
            "Perc_contribution_rescale": 1.4402304368699
        },
        {
            "Country": "Peru",
            "Abs_contribution": 0.00340388863619378,
            "Perc_contribution": 0.3,
            "Fossil_abs": 0.000903380560193777,
            "Land_abs": 0.002500508076,
            "Fossil_fraction": 26.5396626255063,
            "Land_fraction": 73.4603373744936,
            "Rank": 46,
            "Perc_contribution_rescale": 1.4402304368699
        },
        {
            "Country": "Pakistan",
            "Abs_contribution": 0.00337438593376692,
            "Perc_contribution": 0.3,
            "Fossil_abs": 0.00245658657326692,
            "Land_abs": 0.000917799360500003,
            "Fossil_fraction": 72.8009961363419,
            "Land_fraction": 27.1990038636582,
            "Rank": 47,
            "Perc_contribution_rescale": 1.4402304368699
        },
        {
            "Country": "Bolivia",
            "Abs_contribution": 0.00328174998702129,
            "Perc_contribution": 0.29,
            "Fossil_abs": 0.000262325073021288,
            "Land_abs": 0.003019424914,
            "Fossil_fraction": 7.99345087403778,
            "Land_fraction": 92.0065491259622,
            "Rank": 48,
            "Perc_contribution_rescale": 1.3922227556409
        },
        {
            "Country": "Sweden",
            "Abs_contribution": 0.00298237118665666,
            "Perc_contribution": 0.26,
            "Fossil_abs": 0.00227972525915666,
            "Land_abs": 0.000702645927500003,
            "Fossil_fraction": 76.4400242785443,
            "Land_fraction": 23.5599757214558,
            "Rank": 49,
            "Perc_contribution_rescale": 1.24819971195391
        },
        {
            "Country": "Madagascar",
            "Abs_contribution": 0.00294529875866484,
            "Perc_contribution": 0.26,
            "Fossil_abs": 4.73963391648472e-05,
            "Land_abs": 0.0028979024195,
            "Fossil_fraction": 1.60922008422442,
            "Land_fraction": 98.3907799157758,
            "Rank": 50,
            "Perc_contribution_rescale": 1.24819971195391
        },
        {
            "Country": "North Korea",
            "Abs_contribution": 0.00289170510259443,
            "Perc_contribution": 0.25,
            "Fossil_abs": 0.00234732237359443,
            "Land_abs": 0.000544382728999997,
            "Fossil_fraction": 81.17433452977,
            "Land_fraction": 18.8256654702299,
            "Rank": 51,
            "Perc_contribution_rescale": 1.20019203072492
        },
        {
            "Country": "Ethiopia",
            "Abs_contribution": 0.00287077180367904,
            "Perc_contribution": 0.25,
            "Fossil_abs": 0.000135224071179039,
            "Land_abs": 0.0027355477325,
            "Fossil_fraction": 4.71037339177369,
            "Land_fraction": 95.2896266082263,
            "Rank": 52,
            "Perc_contribution_rescale": 1.20019203072492
        },
        {
            "Country": "Chile",
            "Abs_contribution": 0.00282124250253712,
            "Perc_contribution": 0.25,
            "Fossil_abs": 0.00138969838853712,
            "Land_abs": 0.001431544114,
            "Fossil_fraction": 49.2583812730517,
            "Land_fraction": 50.7416187269483,
            "Rank": 53,
            "Perc_contribution_rescale": 1.20019203072492
        },
        {
            "Country": "Ecuador",
            "Abs_contribution": 0.00279128984374126,
            "Perc_contribution": 0.25,
            "Fossil_abs": 0.000585209681741266,
            "Land_abs": 0.002206080162,
            "Fossil_fraction": 20.9655648285127,
            "Land_fraction": 79.0344351714875,
            "Rank": 54,
            "Perc_contribution_rescale": 1.20019203072492
        },
        {
            "Country": "New Zealand",
            "Abs_contribution": 0.00271111242802347,
            "Perc_contribution": 0.24,
            "Fossil_abs": 0.000877765313523472,
            "Land_abs": 0.0018333471145,
            "Fossil_fraction": 32.3765737064399,
            "Land_fraction": 67.6234262935601,
            "Rank": 55,
            "Perc_contribution_rescale": 1.15218434949592
        },
        {
            "Country": "Algeria",
            "Abs_contribution": 0.00253917457114738,
            "Perc_contribution": 0.22,
            "Fossil_abs": 0.00228624309014738,
            "Land_abs": 0.000252931481,
            "Fossil_fraction": 90.0388305761227,
            "Land_fraction": 9.96116942387729,
            "Rank": 56,
            "Perc_contribution_rescale": 1.05616898703793
        },
        {
            "Country": "United Arab Emirates",
            "Abs_contribution": 0.00245233491310044,
            "Perc_contribution": 0.22,
            "Fossil_abs": 0.00246325887560044,
            "Land_abs": -0.0000109239625,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 57,
            "Perc_contribution_rescale": 1.05616898703793
        },
        {
            "Country": "Finland",
            "Abs_contribution": 0.00237770062323089,
            "Perc_contribution": 0.21,
            "Fossil_abs": 0.0014693948237309,
            "Land_abs": 0.0009083057995,
            "Fossil_fraction": 61.7989838322977,
            "Land_fraction": 38.2010161677027,
            "Rank": 58,
            "Perc_contribution_rescale": 1.00816130580893
        },
        {
            "Country": "Hungary",
            "Abs_contribution": 0.00236524498406823,
            "Perc_contribution": 0.21,
            "Fossil_abs": 0.00229856937506823,
            "Land_abs": 6.66756090000001e-05,
            "Fossil_fraction": 97.1810273587255,
            "Land_fraction": 2.81897264127447,
            "Rank": 59,
            "Perc_contribution_rescale": 1.00816130580893
        },
        {
            "Country": "Zambia",
            "Abs_contribution": 0.00232884963116266,
            "Perc_contribution": 0.21,
            "Fossil_abs": 0.000120894623662664,
            "Land_abs": 0.0022079550075,
            "Fossil_fraction": 5.19117344653585,
            "Land_fraction": 94.8088265534643,
            "Rank": 60,
            "Perc_contribution_rescale": 1.00816130580893
        },
        {
            "Country": "Iraq",
            "Abs_contribution": 0.00231264480510262,
            "Perc_contribution": 0.2,
            "Fossil_abs": 0.00216692974110262,
            "Land_abs": 0.000145715064,
            "Fossil_fraction": 93.6992025892392,
            "Land_fraction": 6.3007974107608,
            "Rank": 61,
            "Perc_contribution_rescale": 0.960153624579933
        },
        {
            "Country": "Austria",
            "Abs_contribution": 0.00228198047950491,
            "Perc_contribution": 0.2,
            "Fossil_abs": 0.00252280401300491,
            "Land_abs": -0.0002408235335,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 62,
            "Perc_contribution_rescale": 0.960153624579933
        },
        {
            "Country": "Denmark",
            "Abs_contribution": 0.00220407359587118,
            "Perc_contribution": 0.19,
            "Fossil_abs": 0.00186436796037118,
            "Land_abs": 0.0003397056355,
            "Fossil_fraction": 84.5873733011294,
            "Land_fraction": 15.4126266988707,
            "Rank": 63,
            "Perc_contribution_rescale": 0.912145943350936
        },
        {
            "Country": "Cuba",
            "Abs_contribution": 0.00219802966270742,
            "Perc_contribution": 0.19,
            "Fossil_abs": 0.000749330735207424,
            "Land_abs": 0.0014486989275,
            "Fossil_fraction": 34.0910201495842,
            "Land_fraction": 65.908979850416,
            "Rank": 64,
            "Perc_contribution_rescale": 0.912145943350936
        },
        {
            "Country": "Greece",
            "Abs_contribution": 0.00218824029328002,
            "Perc_contribution": 0.19,
            "Fossil_abs": 0.00188849076628002,
            "Land_abs": 0.000299749527,
            "Fossil_fraction": 86.3018002218259,
            "Land_fraction": 13.6981997781741,
            "Rank": 65,
            "Perc_contribution_rescale": 0.912145943350936
        },
        {
            "Country": "Paraguay",
            "Abs_contribution": 0.00207685904158133,
            "Perc_contribution": 0.18,
            "Fossil_abs": 8.79773555813319e-05,
            "Land_abs": 0.001988881686,
            "Fossil_fraction": 4.23607735623432,
            "Land_fraction": 95.7639226437658,
            "Rank": 66,
            "Perc_contribution_rescale": 0.86413826212194
        },
        {
            "Country": "Mongolia",
            "Abs_contribution": 0.0019270693248095,
            "Perc_contribution": 0.17,
            "Fossil_abs": 0.000345416581809498,
            "Land_abs": 0.001581652743,
            "Fossil_fraction": 17.924450218917,
            "Land_fraction": 82.0755497810829,
            "Rank": 67,
            "Perc_contribution_rescale": 0.816130580892943
        },
        {
            "Country": "Bulgaria",
            "Abs_contribution": 0.00191961416869378,
            "Perc_contribution": 0.17,
            "Fossil_abs": 0.00176379946019378,
            "Land_abs": 0.0001558147085,
            "Fossil_fraction": 91.8830194608313,
            "Land_fraction": 8.11698053916875,
            "Rank": 68,
            "Perc_contribution_rescale": 0.816130580892943
        },
        {
            "Country": "Mozambique",
            "Abs_contribution": 0.0018977652428679,
            "Perc_contribution": 0.17,
            "Fossil_abs": 8.63436308679039e-05,
            "Land_abs": 0.001811421612,
            "Fossil_fraction": 4.54975298933295,
            "Land_fraction": 95.4502470106673,
            "Rank": 69,
            "Perc_contribution_rescale": 0.816130580892943
        },
        {
            "Country": "Bangladesh",
            "Abs_contribution": 0.00188845611461681,
            "Perc_contribution": 0.17,
            "Fossil_abs": 0.000797054660616812,
            "Land_abs": 0.001091401454,
            "Fossil_fraction": 42.2066816616781,
            "Land_fraction": 57.793318338322,
            "Rank": 70,
            "Perc_contribution_rescale": 0.816130580892943
        },
        {
            "Country": "Guatemala",
            "Abs_contribution": 0.00184853305305895,
            "Perc_contribution": 0.16,
            "Fossil_abs": 0.000216107181058952,
            "Land_abs": 0.001632425872,
            "Fossil_fraction": 11.6907393514732,
            "Land_fraction": 88.3092606485269,
            "Rank": 71,
            "Perc_contribution_rescale": 0.768122899663946
        },
        {
            "Country": "Slovakia",
            "Abs_contribution": 0.00180573197632314,
            "Perc_contribution": 0.16,
            "Fossil_abs": 0.00178710155682314,
            "Land_abs": 1.86304195e-05,
            "Fossil_fraction": 98.9682621926021,
            "Land_fraction": 1.03173780739795,
            "Rank": 72,
            "Perc_contribution_rescale": 0.768122899663946
        },
        {
            "Country": "Cameroon",
            "Abs_contribution": 0.00179854078263209,
            "Perc_contribution": 0.16,
            "Fossil_abs": 0.000130602081632096,
            "Land_abs": 0.001667938701,
            "Fossil_fraction": 7.26155797484699,
            "Land_fraction": 92.7384420251533,
            "Rank": 73,
            "Perc_contribution_rescale": 0.768122899663946
        },
        {
            "Country": "Turkmenistan",
            "Abs_contribution": 0.00167515615496943,
            "Perc_contribution": 0.15,
            "Fossil_abs": 0.00113351090796943,
            "Land_abs": 0.000541645247,
            "Fossil_fraction": 67.6659847266666,
            "Land_fraction": 32.3340152733334,
            "Rank": 74,
            "Perc_contribution_rescale": 0.72011521843495
        },
        {
            "Country": "Nicaragua",
            "Abs_contribution": 0.00166940819647598,
            "Perc_contribution": 0.15,
            "Fossil_abs": 8.44079169759825e-05,
            "Land_abs": 0.0015850002795,
            "Fossil_fraction": 5.05615805374399,
            "Land_fraction": 94.9438419462562,
            "Rank": 75,
            "Perc_contribution_rescale": 0.72011521843495
        },
        {
            "Country": "Norway",
            "Abs_contribution": 0.0015508980683559,
            "Perc_contribution": 0.14,
            "Fossil_abs": 0.0012200106268559,
            "Land_abs": 0.0003308874415,
            "Fossil_fraction": 78.6647847301291,
            "Land_fraction": 21.3352152698708,
            "Rank": 76,
            "Perc_contribution_rescale": 0.672107537205953
        },
        {
            "Country": "Sudan",
            "Abs_contribution": 0.00152532265554367,
            "Perc_contribution": 0.13,
            "Fossil_abs": 0.000225531822543668,
            "Land_abs": 0.001299790833,
            "Fossil_fraction": 14.7858436196427,
            "Land_fraction": 85.2141563803572,
            "Rank": 77,
            "Perc_contribution_rescale": 0.624099855976956
        },
        {
            "Country": "Serbia",
            "Abs_contribution": 0.00146107557459389,
            "Perc_contribution": 0.13,
            "Fossil_abs": 0.00130409261659389,
            "Land_abs": 0.000156982958,
            "Fossil_fraction": 89.2556579050585,
            "Land_fraction": 10.7443420949415,
            "Rank": 78,
            "Perc_contribution_rescale": 0.624099855976956
        },
        {
            "Country": "Uganda",
            "Abs_contribution": 0.00143767922437445,
            "Perc_contribution": 0.13,
            "Fossil_abs": 5.33056898744541e-05,
            "Land_abs": 0.0013843735345,
            "Fossil_fraction": 3.70775962890108,
            "Land_fraction": 96.2922403710992,
            "Rank": 79,
            "Perc_contribution_rescale": 0.624099855976956
        },
        {
            "Country": "Kuwait",
            "Abs_contribution": 0.00143136838291157,
            "Perc_contribution": 0.13,
            "Fossil_abs": 0.00143144129091157,
            "Land_abs": -0.0000000729079999999999,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 80,
            "Perc_contribution_rescale": 0.624099855976956
        },
        {
            "Country": "Switzerland",
            "Abs_contribution": 0.00143114416306059,
            "Perc_contribution": 0.13,
            "Fossil_abs": 0.00139410921456059,
            "Land_abs": 3.70349485e-05,
            "Fossil_fraction": 97.4122139854312,
            "Land_fraction": 2.58778601456882,
            "Rank": 81,
            "Perc_contribution_rescale": 0.624099855976956
        },
        {
            "Country": "Cambodia",
            "Abs_contribution": 0.00142538138163483,
            "Perc_contribution": 0.13,
            "Fossil_abs": 9.32845166348253e-05,
            "Land_abs": 0.001332096865,
            "Fossil_fraction": 6.54453031565723,
            "Land_fraction": 93.4554696843424,
            "Rank": 82,
            "Perc_contribution_rescale": 0.624099855976956
        },
        {
            "Country": "Morocco",
            "Abs_contribution": 0.00142380189157478,
            "Perc_contribution": 0.13,
            "Fossil_abs": 0.000846003021574782,
            "Land_abs": 0.00057779887,
            "Fossil_fraction": 59.4185909276374,
            "Land_fraction": 40.5814090723627,
            "Rank": 83,
            "Perc_contribution_rescale": 0.624099855976956
        },
        {
            "Country": "Azerbaijan",
            "Abs_contribution": 0.00138619784529148,
            "Perc_contribution": 0.12,
            "Fossil_abs": 0.00114370367579148,
            "Land_abs": 0.0002424941695,
            "Fossil_fraction": 82.5065252897569,
            "Land_fraction": 17.4934747102431,
            "Rank": 84,
            "Perc_contribution_rescale": 0.57609217474796
        },
        {
            "Country": "Lithuania",
            "Abs_contribution": 0.00136627595604476,
            "Perc_contribution": 0.12,
            "Fossil_abs": 0.00071179204904476,
            "Land_abs": 0.000654483906999998,
            "Fossil_fraction": 52.0972389139695,
            "Land_fraction": 47.9027610860303,
            "Rank": 85,
            "Perc_contribution_rescale": 0.57609217474796
        },
        {
            "Country": "Portugal",
            "Abs_contribution": 0.00128466600522925,
            "Perc_contribution": 0.11,
            "Fossil_abs": 0.00121344084022926,
            "Land_abs": 7.12251649999997e-05,
            "Fossil_fraction": 94.4557445507185,
            "Land_fraction": 5.54425544928228,
            "Rank": 86,
            "Perc_contribution_rescale": 0.528084493518963
        },
        {
            "Country": "Kenya",
            "Abs_contribution": 0.00125440196813646,
            "Perc_contribution": 0.11,
            "Fossil_abs": 0.000240519587636463,
            "Land_abs": 0.0010138823805,
            "Fossil_fraction": 19.1740441856751,
            "Land_fraction": 80.8259558143251,
            "Rank": 87,
            "Perc_contribution_rescale": 0.528084493518963
        },
        {
            "Country": "Guinea",
            "Abs_contribution": 0.0012356369748286,
            "Perc_contribution": 0.11,
            "Fossil_abs": 4.42260893286026e-05,
            "Land_abs": 0.0011914108855,
            "Fossil_fraction": 3.57921381680387,
            "Land_fraction": 96.4207861831964,
            "Rank": 88,
            "Perc_contribution_rescale": 0.528084493518963
        },
        {
            "Country": "Honduras",
            "Abs_contribution": 0.0011916037788881,
            "Perc_contribution": 0.11,
            "Fossil_abs": 0.0001273522773881,
            "Land_abs": 0.0010642515015,
            "Fossil_fraction": 10.6874684055579,
            "Land_fraction": 89.3125315944421,
            "Rank": 89,
            "Perc_contribution_rescale": 0.528084493518963
        },
        {
            "Country": "Ireland",
            "Abs_contribution": 0.00117675470606441,
            "Perc_contribution": 0.1,
            "Fossil_abs": 0.00103652527606441,
            "Land_abs": 0.00014022943,
            "Fossil_fraction": 88.0833763164637,
            "Land_fraction": 11.9166236835363,
            "Rank": 90,
            "Perc_contribution_rescale": 0.480076812289966
        },
        {
            "Country": "Israel",
            "Abs_contribution": 0.0011363689112833,
            "Perc_contribution": 0.1,
            "Fossil_abs": 0.0011192801582833,
            "Land_abs": 1.7088753e-05,
            "Fossil_fraction": 98.4961967165485,
            "Land_fraction": 1.50380328345147,
            "Rank": 91,
            "Perc_contribution_rescale": 0.480076812289966
        },
        {
            "Country": "Ghana",
            "Abs_contribution": 0.00110463100799181,
            "Perc_contribution": 0.1,
            "Fossil_abs": 0.000174969907491812,
            "Land_abs": 0.000929661100499998,
            "Fossil_fraction": 15.8396701003263,
            "Land_fraction": 84.1603298996737,
            "Rank": 92,
            "Perc_contribution_rescale": 0.480076812289966
        },
        {
            "Country": "Congo",
            "Abs_contribution": 0.0010825370384203,
            "Perc_contribution": 0.1,
            "Fossil_abs": 7.75657029203057e-05,
            "Land_abs": 0.0010049713355,
            "Fossil_fraction": 7.16517774149271,
            "Land_fraction": 92.8348222585078,
            "Rank": 93,
            "Perc_contribution_rescale": 0.480076812289966
        },
        {
            "Country": "Libya",
            "Abs_contribution": 0.0010576481819798,
            "Perc_contribution": 0.09,
            "Fossil_abs": 0.0010580113909798,
            "Land_abs": -0.000000363209,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 94,
            "Perc_contribution_rescale": 0.43206913106097
        },
        {
            "Country": "Qatar",
            "Abs_contribution": 0.00104068606625164,
            "Perc_contribution": 0.09,
            "Fossil_abs": 0.00104027137725164,
            "Land_abs": 4.14689e-07,
            "Fossil_fraction": 99.9601523443575,
            "Land_fraction": 0.0398476556425545,
            "Rank": 95,
            "Perc_contribution_rescale": 0.43206913106097
        },
        {
            "Country": "Zimbabwe",
            "Abs_contribution": 0.00103429015713537,
            "Perc_contribution": 0.09,
            "Fossil_abs": 0.000359674061135371,
            "Land_abs": 0.000674616096,
            "Fossil_fraction": 34.774967029711,
            "Land_fraction": 65.2250329702891,
            "Rank": 96,
            "Perc_contribution_rescale": 0.43206913106097
        },
        {
            "Country": "Laos",
            "Abs_contribution": 0.00103420305561681,
            "Perc_contribution": 0.09,
            "Fossil_abs": 8.99360231168122e-05,
            "Land_abs": 0.0009442670325,
            "Fossil_fraction": 8.69616683381131,
            "Land_fraction": 91.3038331661889,
            "Rank": 97,
            "Perc_contribution_rescale": 0.43206913106097
        },
        {
            "Country": "Syria",
            "Abs_contribution": 0.00100906272769596,
            "Perc_contribution": 0.09,
            "Fossil_abs": 0.000877691025695961,
            "Land_abs": 0.000131371702,
            "Fossil_fraction": 86.9808190913992,
            "Land_fraction": 13.0191809086009,
            "Rank": 98,
            "Perc_contribution_rescale": 0.43206913106097
        },
        {
            "Country": "Singapore",
            "Abs_contribution": 0.000994374729037121,
            "Perc_contribution": 0.09,
            "Fossil_abs": 0.000986392601037118,
            "Land_abs": 7.98212800000003e-06,
            "Fossil_fraction": 99.1972716354394,
            "Land_fraction": 0.802728364560243,
            "Rank": 99,
            "Perc_contribution_rescale": 0.43206913106097
        },
        {
            "Country": "Sri Lanka",
            "Abs_contribution": 0.00095243869475109,
            "Perc_contribution": 0.08,
            "Fossil_abs": 0.000240461582751092,
            "Land_abs": 0.000711977111999998,
            "Fossil_fraction": 25.2469354800767,
            "Land_fraction": 74.7530645199233,
            "Rank": 100,
            "Perc_contribution_rescale": 0.384061449831973
        },
        {
            "Country": "Panama",
            "Abs_contribution": 0.000935014287420853,
            "Perc_contribution": 0.08,
            "Fossil_abs": 0.000150103759920852,
            "Land_abs": 0.000784910527500001,
            "Fossil_fraction": 16.0536327562329,
            "Land_fraction": 83.9463672437671,
            "Rank": 101,
            "Perc_contribution_rescale": 0.384061449831973
        },
        {
            "Country": "Papua New Guinea",
            "Abs_contribution": 0.000901018977597162,
            "Perc_contribution": 0.08,
            "Fossil_abs": 8.78574085971616e-05,
            "Land_abs": 0.000813161569,
            "Fossil_fraction": 9.75089435202129,
            "Land_fraction": 90.2491056479787,
            "Rank": 102,
            "Perc_contribution_rescale": 0.384061449831973
        },
        {
            "Country": "Estonia",
            "Abs_contribution": 0.000897168162900655,
            "Perc_contribution": 0.08,
            "Fossil_abs": 0.000745127625900655,
            "Land_abs": 0.000152040537,
            "Fossil_fraction": 83.053284402287,
            "Land_fraction": 16.9467155977129,
            "Rank": 103,
            "Perc_contribution_rescale": 0.384061449831973
        },
        {
            "Country": "Uruguay",
            "Abs_contribution": 0.000880229070454694,
            "Perc_contribution": 0.08,
            "Fossil_abs": 0.000174630093954694,
            "Land_abs": 0.0007055989765,
            "Fossil_fraction": 19.8391645784303,
            "Land_fraction": 80.1608354215697,
            "Rank": 104,
            "Perc_contribution_rescale": 0.384061449831973
        },
        {
            "Country": "Costa Rica",
            "Abs_contribution": 0.000867808794868999,
            "Perc_contribution": 0.08,
            "Fossil_abs": 0.000120590069868996,
            "Land_abs": 0.000747218725000003,
            "Fossil_fraction": 13.8959262203836,
            "Land_fraction": 86.1040737796164,
            "Rank": 105,
            "Perc_contribution_rescale": 0.384061449831973
        },
        {
            "Country": "Nepal",
            "Abs_contribution": 0.000835736113566594,
            "Perc_contribution": 0.07,
            "Fossil_abs": 8.73047540665939e-05,
            "Land_abs": 0.0007484313595,
            "Fossil_fraction": 10.4464498601133,
            "Land_fraction": 89.5535501398867,
            "Rank": 106,
            "Perc_contribution_rescale": 0.336053768602977
        },
        {
            "Country": "Dominican Republic",
            "Abs_contribution": 0.000818060997040393,
            "Perc_contribution": 0.07,
            "Fossil_abs": 0.000356562443040393,
            "Land_abs": 0.000461498554,
            "Fossil_fraction": 43.5862905492837,
            "Land_fraction": 56.4137094507163,
            "Rank": 107,
            "Perc_contribution_rescale": 0.336053768602977
        },
        {
            "Country": "Moldova",
            "Abs_contribution": 0.000811350306274017,
            "Perc_contribution": 0.07,
            "Fossil_abs": 0.000607479364274017,
            "Land_abs": 0.000203870942,
            "Fossil_fraction": 74.872636341725,
            "Land_fraction": 25.127363658275,
            "Rank": 108,
            "Perc_contribution_rescale": 0.336053768602977
        },
        {
            "Country": "Hong Kong",
            "Abs_contribution": 0.000759129163387009,
            "Perc_contribution": 0.07,
            "Fossil_abs": 0.000759129163387009,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 109,
            "Perc_contribution_rescale": 0.336053768602977
        },
        {
            "Country": "Trinidad and Tobago",
            "Abs_contribution": 0.000755712114542579,
            "Perc_contribution": 0.07,
            "Fossil_abs": 0.000737345458542576,
            "Land_abs": 1.8366656e-05,
            "Fossil_fraction": 97.5696226583426,
            "Land_fraction": 2.43037734165702,
            "Rank": 110,
            "Perc_contribution_rescale": 0.336053768602977
        },
        {
            "Country": "Latvia",
            "Abs_contribution": 0.00074577674666048,
            "Perc_contribution": 0.07,
            "Fossil_abs": 0.00043430827066048,
            "Land_abs": 0.000311468476,
            "Fossil_fraction": 58.2356948785642,
            "Land_fraction": 41.7643051214358,
            "Rank": 111,
            "Perc_contribution_rescale": 0.336053768602977
        },
        {
            "Country": "Gabon",
            "Abs_contribution": 0.000723078182059498,
            "Perc_contribution": 0.06,
            "Fossil_abs": 0.000135719938059498,
            "Land_abs": 0.000587358244,
            "Fossil_fraction": 18.7697459869326,
            "Land_fraction": 81.2302540130674,
            "Rank": 112,
            "Perc_contribution_rescale": 0.28804608737398
        },
        {
            "Country": "Sierra Leone",
            "Abs_contribution": 0.000698093351189409,
            "Perc_contribution": 0.06,
            "Fossil_abs": 1.74767166894105e-05,
            "Land_abs": 0.000680616634499998,
            "Fossil_fraction": 2.50349278640654,
            "Land_fraction": 97.4965072135934,
            "Rank": 113,
            "Perc_contribution_rescale": 0.28804608737398
        },
        {
            "Country": "Bosnia and Herzegovina",
            "Abs_contribution": 0.000692996205672489,
            "Perc_contribution": 0.06,
            "Fossil_abs": 0.000451341374672489,
            "Land_abs": 0.000241654831,
            "Fossil_fraction": 65.1289820893758,
            "Land_fraction": 34.8710179106242,
            "Rank": 114,
            "Perc_contribution_rescale": 0.28804608737398
        },
        {
            "Country": "Malawi",
            "Abs_contribution": 0.000684357006926854,
            "Perc_contribution": 0.06,
            "Fossil_abs": 2.46295869268559e-05,
            "Land_abs": 0.000659727419999999,
            "Fossil_fraction": 3.5989383724522,
            "Land_fraction": 96.4010616275479,
            "Rank": 115,
            "Perc_contribution_rescale": 0.28804608737398
        },
        {
            "Country": "Croatia",
            "Abs_contribution": 0.000676548396613537,
            "Perc_contribution": 0.06,
            "Fossil_abs": 0.000516290243613537,
            "Land_abs": 0.000160258153,
            "Fossil_fraction": 76.3123889137611,
            "Land_fraction": 23.6876110862389,
            "Rank": 116,
            "Perc_contribution_rescale": 0.28804608737398
        },
        {
            "Country": "Tunisia",
            "Abs_contribution": 0.000674009607781656,
            "Perc_contribution": 0.06,
            "Fossil_abs": 0.000448828437281659,
            "Land_abs": 0.0002251811705,
            "Fossil_fraction": 66.5908070300173,
            "Land_fraction": 33.4091929699831,
            "Rank": 117,
            "Perc_contribution_rescale": 0.28804608737398
        },
        {
            "Country": "Oman",
            "Abs_contribution": 0.00066386662969432,
            "Perc_contribution": 0.06,
            "Fossil_abs": 0.000663852879694323,
            "Land_abs": 1.375e-08,
            "Fossil_fraction": 99.9979288008491,
            "Land_fraction": 0.0020711991513011,
            "Rank": 118,
            "Perc_contribution_rescale": 0.28804608737398
        },
        {
            "Country": "Kyrgyzstan",
            "Abs_contribution": 0.000631748087398472,
            "Perc_contribution": 0.06,
            "Fossil_abs": 0.000387611260398472,
            "Land_abs": 0.000244136827,
            "Fossil_fraction": 61.3553516235639,
            "Land_fraction": 38.6446483764361,
            "Rank": 119,
            "Perc_contribution_rescale": 0.28804608737398
        },
        {
            "Country": "Niger",
            "Abs_contribution": 0.000621744226227077,
            "Perc_contribution": 0.05,
            "Fossil_abs": 2.49044497270742e-05,
            "Land_abs": 0.000596839776500003,
            "Fossil_fraction": 4.00557796542826,
            "Land_fraction": 95.9944220345718,
            "Rank": 120,
            "Perc_contribution_rescale": 0.240038406144983
        },
        {
            "Country": "South Sudan",
            "Abs_contribution": 0.000608130979644103,
            "Perc_contribution": 0.05,
            "Fossil_abs": 1.95102106441048e-05,
            "Land_abs": 0.000588620768999998,
            "Fossil_fraction": 3.20822508590547,
            "Land_fraction": 96.7917749140945,
            "Rank": 121,
            "Perc_contribution_rescale": 0.240038406144983
        },
        {
            "Country": "Benin",
            "Abs_contribution": 0.000547239440168122,
            "Perc_contribution": 0.05,
            "Fossil_abs": 5.83234686681223e-05,
            "Land_abs": 0.0004889159715,
            "Fossil_fraction": 10.6577604586037,
            "Land_fraction": 89.3422395413964,
            "Rank": 122,
            "Perc_contribution_rescale": 0.240038406144983
        },
        {
            "Country": "Liberia",
            "Abs_contribution": 0.000545600306979261,
            "Perc_contribution": 0.05,
            "Fossil_abs": 2.28876714792576e-05,
            "Land_abs": 0.000522712635500003,
            "Fossil_fraction": 4.19495208974059,
            "Land_fraction": 95.8050479102593,
            "Rank": 123,
            "Perc_contribution_rescale": 0.240038406144983
        },
        {
            "Country": "Guyana",
            "Abs_contribution": 0.000526236695352619,
            "Perc_contribution": 0.05,
            "Fossil_abs": 4.90835848526201e-05,
            "Land_abs": 0.000477153110499998,
            "Fossil_fraction": 9.32728281514658,
            "Land_fraction": 90.6727171848532,
            "Rank": 124,
            "Perc_contribution_rescale": 0.240038406144983
        },
        {
            "Country": "Afghanistan",
            "Abs_contribution": 0.00052457815529367,
            "Perc_contribution": 0.05,
            "Fossil_abs": 0.000103915891293668,
            "Land_abs": 0.000420662264,
            "Fossil_fraction": 19.8094202446333,
            "Land_fraction": 80.1905797553664,
            "Rank": 125,
            "Perc_contribution_rescale": 0.240038406144983
        },
        {
            "Country": "Chad",
            "Abs_contribution": 0.000521518069652838,
            "Perc_contribution": 0.05,
            "Fossil_abs": 2.02342976528384e-05,
            "Land_abs": 0.000501283772,
            "Fossil_fraction": 3.87988428978269,
            "Land_fraction": 96.1201157102174,
            "Rank": 126,
            "Perc_contribution_rescale": 0.240038406144983
        },
        {
            "Country": "Burkina Faso",
            "Abs_contribution": 0.000514113369060044,
            "Perc_contribution": 0.05,
            "Fossil_abs": 3.63972950600437e-05,
            "Land_abs": 0.000477716074,
            "Fossil_fraction": 7.07962431060469,
            "Land_fraction": 92.9203756893953,
            "Rank": 127,
            "Perc_contribution_rescale": 0.240038406144983
        },
        {
            "Country": "Slovenia",
            "Abs_contribution": 0.00047812918439192,
            "Perc_contribution": 0.04,
            "Fossil_abs": 0.000399355126391921,
            "Land_abs": 7.87740579999999e-05,
            "Fossil_fraction": 83.5245242140609,
            "Land_fraction": 16.4754757859393,
            "Rank": 128,
            "Perc_contribution_rescale": 0.192030724915987
        },
        {
            "Country": "Central African Republic",
            "Abs_contribution": 0.000472649426313319,
            "Perc_contribution": 0.04,
            "Fossil_abs": 5.31274331331878e-06,
            "Land_abs": 0.000467336683,
            "Fossil_fraction": 1.12403464757344,
            "Land_fraction": 98.8759653524265,
            "Rank": 129,
            "Perc_contribution_rescale": 0.192030724915987
        },
        {
            "Country": "Bahrain",
            "Abs_contribution": 0.000455498379496725,
            "Perc_contribution": 0.04,
            "Fossil_abs": 0.000455434645496725,
            "Land_abs": 6.3734e-08,
            "Fossil_fraction": 99.9860078536239,
            "Land_fraction": 0.013992146376112,
            "Rank": 130,
            "Perc_contribution_rescale": 0.192030724915987
        },
        {
            "Country": "El Salvador",
            "Abs_contribution": 0.000455335201347709,
            "Perc_contribution": 0.04,
            "Fossil_abs": 0.000111693446847707,
            "Land_abs": 0.0003436417545,
            "Fossil_fraction": 24.5299389366591,
            "Land_fraction": 75.4700610633404,
            "Rank": 131,
            "Perc_contribution_rescale": 0.192030724915987
        },
        {
            "Country": "Senegal",
            "Abs_contribution": 0.000363084076866812,
            "Perc_contribution": 0.03,
            "Fossil_abs": 0.000121994491866812,
            "Land_abs": 0.000241089585,
            "Fossil_fraction": 33.5995158255212,
            "Land_fraction": 66.4004841744788,
            "Rank": 132,
            "Perc_contribution_rescale": 0.14402304368699
        },
        {
            "Country": "Lebanon",
            "Abs_contribution": 0.000358245493200874,
            "Perc_contribution": 0.03,
            "Fossil_abs": 0.000349238726200873,
            "Land_abs": 9.00676700000003e-06,
            "Fossil_fraction": 97.4858673253565,
            "Land_fraction": 2.51413267464325,
            "Rank": 133,
            "Perc_contribution_rescale": 0.14402304368699
        },
        {
            "Country": "Jordan",
            "Abs_contribution": 0.000347733156969432,
            "Perc_contribution": 0.03,
            "Fossil_abs": 0.000334142007969432,
            "Land_abs": 1.3591149e-05,
            "Fossil_fraction": 96.0915004141539,
            "Land_fraction": 3.90849958584615,
            "Rank": 134,
            "Perc_contribution_rescale": 0.14402304368699
        },
        {
            "Country": "Luxembourg",
            "Abs_contribution": 0.000346019415704148,
            "Perc_contribution": 0.03,
            "Fossil_abs": 0.000346513343204148,
            "Land_abs": -0.0000004939275,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 135,
            "Perc_contribution_rescale": 0.14402304368699
        },
        {
            "Country": "Tajikistan",
            "Abs_contribution": 0.000344065493737991,
            "Perc_contribution": 0.03,
            "Fossil_abs": 0.000222186577237991,
            "Land_abs": 0.0001218789165,
            "Fossil_fraction": 64.5768265873207,
            "Land_fraction": 35.4231734126794,
            "Rank": 136,
            "Perc_contribution_rescale": 0.14402304368699
        },
        {
            "Country": "Jamaica",
            "Abs_contribution": 0.000337543683155022,
            "Perc_contribution": 0.03,
            "Fossil_abs": 0.000209318663155022,
            "Land_abs": 0.00012822502,
            "Fossil_fraction": 62.0123182867828,
            "Land_fraction": 37.9876817132172,
            "Rank": 137,
            "Perc_contribution_rescale": 0.14402304368699
        },
        {
            "Country": "Georgia",
            "Abs_contribution": 0.000312207215813319,
            "Perc_contribution": 0.03,
            "Fossil_abs": 0.000307390205813319,
            "Land_abs": 4.81701000000001e-06,
            "Fossil_fraction": 98.4571112530338,
            "Land_fraction": 1.54288874696615,
            "Rank": 138,
            "Perc_contribution_rescale": 0.14402304368699
        },
        {
            "Country": "Burundi",
            "Abs_contribution": 0.000311196025147926,
            "Perc_contribution": 0.03,
            "Fossil_abs": 6.54857214792576e-06,
            "Land_abs": 0.000304647453,
            "Fossil_fraction": 2.10432384051593,
            "Land_fraction": 97.895676159484,
            "Rank": 139,
            "Perc_contribution_rescale": 0.14402304368699
        },
        {
            "Country": "Yemen",
            "Abs_contribution": 0.000309385059962337,
            "Perc_contribution": 0.03,
            "Fossil_abs": 0.000309632966962336,
            "Land_abs": -0.000000247906999999998,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 140,
            "Perc_contribution_rescale": 0.14402304368699
        },
        {
            "Country": "North Macedonia",
            "Abs_contribution": 0.000304938202502183,
            "Perc_contribution": 0.03,
            "Fossil_abs": 0.000236851040502183,
            "Land_abs": 6.80871619999999e-05,
            "Fossil_fraction": 77.6718163085806,
            "Land_fraction": 22.3281836914194,
            "Rank": 141,
            "Perc_contribution_rescale": 0.14402304368699
        },
        {
            "Country": "Somalia",
            "Abs_contribution": 0.000302543929130459,
            "Perc_contribution": 0.03,
            "Fossil_abs": 1.53246231304585e-05,
            "Land_abs": 0.000287219306,
            "Fossil_fraction": 5.0652555397502,
            "Land_fraction": 94.9347444602496,
            "Rank": 142,
            "Perc_contribution_rescale": 0.14402304368699
        },
        {
            "Country": "Bhutan",
            "Abs_contribution": 0.000298371754567685,
            "Perc_contribution": 0.03,
            "Fossil_abs": 9.58219306768559e-06,
            "Land_abs": 0.0002887895615,
            "Fossil_fraction": 3.21149469445235,
            "Land_fraction": 96.7885053055478,
            "Rank": 143,
            "Perc_contribution_rescale": 0.14402304368699
        },
        {
            "Country": "Botswana",
            "Abs_contribution": 0.000291517409439411,
            "Perc_contribution": 0.03,
            "Fossil_abs": 7.33434479394105e-05,
            "Land_abs": 0.0002181739615,
            "Fossil_fraction": 25.159199953255,
            "Land_fraction": 74.8408000467448,
            "Rank": 144,
            "Perc_contribution_rescale": 0.14402304368699
        },
        {
            "Country": "Rwanda",
            "Abs_contribution": 0.00028659427860262,
            "Perc_contribution": 0.03,
            "Fossil_abs": 1.46940786026201e-05,
            "Land_abs": 0.0002719002,
            "Fossil_fraction": 5.12713605947253,
            "Land_fraction": 94.8728639405275,
            "Rank": 145,
            "Perc_contribution_rescale": 0.14402304368699
        },
        {
            "Country": "Haiti",
            "Abs_contribution": 0.000286269399174672,
            "Perc_contribution": 0.03,
            "Fossil_abs": 3.62770026746725e-05,
            "Land_abs": 0.0002499923965,
            "Fossil_fraction": 12.6723299029728,
            "Land_fraction": 87.3276700970274,
            "Rank": 146,
            "Perc_contribution_rescale": 0.14402304368699
        },
        {
            "Country": "Mali",
            "Abs_contribution": 0.00028518632335917,
            "Perc_contribution": 0.03,
            "Fossil_abs": 3.86304313591703e-05,
            "Land_abs": 0.000246555892,
            "Fossil_fraction": 13.5456816105863,
            "Land_fraction": 86.4543183894138,
            "Rank": 147,
            "Perc_contribution_rescale": 0.14402304368699
        },
        {
            "Country": "Cura\xe7ao",
            "Abs_contribution": 0.000263432370278384,
            "Perc_contribution": 0.02,
            "Fossil_abs": 0.000263432370278384,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 148,
            "Perc_contribution_rescale": 0.0960153624579933
        },
        {
            "Country": "Armenia",
            "Abs_contribution": 0.000251166232144651,
            "Perc_contribution": 0.02,
            "Fossil_abs": 0.000175504442644651,
            "Land_abs": 7.56617894999999e-05,
            "Fossil_fraction": 69.8758113883617,
            "Land_fraction": 30.1241886116383,
            "Rank": 149,
            "Perc_contribution_rescale": 0.0960153624579933
        },
        {
            "Country": "Togo",
            "Abs_contribution": 0.00022505970139083,
            "Perc_contribution": 0.02,
            "Fossil_abs": 3.20718623908297e-05,
            "Land_abs": 0.000192987839,
            "Fossil_fraction": 14.2503798737096,
            "Land_fraction": 85.7496201262903,
            "Rank": 150,
            "Perc_contribution_rescale": 0.0960153624579933
        },
        {
            "Country": "Brunei Darussalam",
            "Abs_contribution": 0.000224014522706878,
            "Perc_contribution": 0.02,
            "Fossil_abs": 0.000180763078206878,
            "Land_abs": 4.32514445e-05,
            "Fossil_fraction": 80.6925711880768,
            "Land_fraction": 19.3074288119232,
            "Rank": 151,
            "Perc_contribution_rescale": 0.0960153624579933
        },
        {
            "Country": "Kuwaiti Oil Fires",
            "Abs_contribution": 0.0002152227,
            "Perc_contribution": 0.02,
            "Fossil_abs": 0.0002152227,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 152,
            "Perc_contribution_rescale": 0.0960153624579933
        },
        {
            "Country": "Albania",
            "Abs_contribution": 0.000202646266096615,
            "Perc_contribution": 0.02,
            "Fossil_abs": 0.000134597439096616,
            "Land_abs": 6.80488269999997e-05,
            "Fossil_fraction": 66.4198959542854,
            "Land_fraction": 33.580104045715,
            "Rank": 153,
            "Perc_contribution_rescale": 0.0960153624579933
        },
        {
            "Country": "Equatorial Guinea",
            "Abs_contribution": 0.000177743186506005,
            "Perc_contribution": 0.02,
            "Fossil_abs": 6.48995270060044e-05,
            "Land_abs": 0.0001128436595,
            "Fossil_fraction": 36.5130885080716,
            "Land_fraction": 63.4869114919281,
            "Rank": 154,
            "Perc_contribution_rescale": 0.0960153624579933
        },
        {
            "Country": "Belize",
            "Abs_contribution": 0.000155772152225983,
            "Perc_contribution": 0.01,
            "Fossil_abs": 9.26464822598253e-06,
            "Land_abs": 0.000146507504,
            "Fossil_fraction": 5.94756385758993,
            "Land_fraction": 94.0524361424098,
            "Rank": 155,
            "Perc_contribution_rescale": 0.0480076812289966
        },
        {
            "Country": "Cyprus",
            "Abs_contribution": 0.000143430923414847,
            "Perc_contribution": 0.01,
            "Fossil_abs": 0.000138387032914847,
            "Land_abs": 5.04389049999998e-06,
            "Fossil_fraction": 96.4834009431763,
            "Land_fraction": 3.51659905682366,
            "Rank": 156,
            "Perc_contribution_rescale": 0.0480076812289966
        },
        {
            "Country": "Iceland",
            "Abs_contribution": 0.000133872874806769,
            "Perc_contribution": 0.01,
            "Fossil_abs": 7.40245093067685e-05,
            "Land_abs": 5.98483655000002e-05,
            "Fossil_fraction": 55.2946288884995,
            "Land_fraction": 44.7053711115003,
            "Rank": 157,
            "Perc_contribution_rescale": 0.0480076812289966
        },
        {
            "Country": "Suriname",
            "Abs_contribution": 0.000121362401424672,
            "Perc_contribution": 0.01,
            "Fossil_abs": 5.61374339246725e-05,
            "Land_abs": 6.52249674999997e-05,
            "Fossil_fraction": 46.2560342129652,
            "Land_fraction": 53.7439657870349,
            "Rank": 158,
            "Perc_contribution_rescale": 0.0480076812289966
        },
        {
            "Country": "Timor-Leste",
            "Abs_contribution": 0.000118359674797489,
            "Perc_contribution": 0.01,
            "Fossil_abs": 4.89396529748908e-06,
            "Land_abs": 0.0001134657095,
            "Fossil_fraction": 4.13482489358183,
            "Land_fraction": 95.8651751064182,
            "Rank": 159,
            "Perc_contribution_rescale": 0.0480076812289966
        },
        {
            "Country": "Namibia",
            "Abs_contribution": 0.000111907120784934,
            "Perc_contribution": 0.01,
            "Fossil_abs": 3.70944542849345e-05,
            "Land_abs": 7.48126665e-05,
            "Fossil_fraction": 33.1475370152929,
            "Land_fraction": 66.8524629847076,
            "Rank": 160,
            "Perc_contribution_rescale": 0.0480076812289966
        },
        {
            "Country": "Fiji",
            "Abs_contribution": 0.00010240009122762,
            "Perc_contribution": 0.01,
            "Fossil_abs": 2.29037567276201e-05,
            "Land_abs": 7.94963345e-05,
            "Fossil_fraction": 22.3669300027365,
            "Land_fraction": 77.6330699972636,
            "Rank": 161,
            "Perc_contribution_rescale": 0.0480076812289966
        },
        {
            "Country": "Montenegro",
            "Abs_contribution": 0.000100872940752729,
            "Perc_contribution": 0.01,
            "Fossil_abs": 4.92288537527293e-05,
            "Land_abs": 5.1644087e-05,
            "Fossil_fraction": 48.8028339268948,
            "Land_fraction": 51.1971660731055,
            "Rank": 162,
            "Perc_contribution_rescale": 0.0480076812289966
        },
        {
            "Country": "Guinea-Bissau",
            "Abs_contribution": 9.45135601086243e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 4.85561810862445e-06,
            "Land_abs": 8.96579419999998e-05,
            "Fossil_fraction": 5.13748302682059,
            "Land_fraction": 94.8625169731793,
            "Rank": 163,
            "Perc_contribution_rescale": 0.0480076812289966
        },
        {
            "Country": "Lesotho",
            "Abs_contribution": 9.17466552942141e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 3.1298085794214e-05,
            "Land_abs": 6.04485695000001e-05,
            "Fossil_fraction": 34.1135986852567,
            "Land_fraction": 65.8864013147433,
            "Rank": 164,
            "Perc_contribution_rescale": 0.0480076812289966
        },
        {
            "Country": "Bahamas",
            "Abs_contribution": 8.08724483100438e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 7.79890513100437e-05,
            "Land_abs": 2.883397e-06,
            "Fossil_fraction": 96.4346361953259,
            "Land_fraction": 3.56536380467401,
            "Rank": 165,
            "Perc_contribution_rescale": 0.0480076812289966
        },
        {
            "Country": "New Caledonia",
            "Abs_contribution": 7.26825995223799e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 7.26825995223799e-05,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 166,
            "Perc_contribution_rescale": 0.0480076812289966
        },
        {
            "Country": "Solomon Islands",
            "Abs_contribution": 5.940956217631e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 4.96309867631004e-06,
            "Land_abs": 5.44464635e-05,
            "Fossil_fraction": 8.35404014858927,
            "Land_fraction": 91.6459598514108,
            "Rank": 167,
            "Perc_contribution_rescale": 0.0480076812289966
        },
        {
            "Country": "Mauritius",
            "Abs_contribution": 5.65121978422489e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 5.58461643422489e-05,
            "Land_abs": 6.660335e-07,
            "Fossil_fraction": 98.8214340878067,
            "Land_fraction": 1.17856591219333,
            "Rank": 168,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Vanuatu",
            "Abs_contribution": 5.63186930114629e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 2.35642201146288e-06,
            "Land_abs": 5.3962271e-05,
            "Fossil_fraction": 4.18408504434445,
            "Land_fraction": 95.8159149556555,
            "Rank": 169,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Gambia",
            "Abs_contribution": 5.5661879474891e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 7.23837797489083e-06,
            "Land_abs": 4.84235015000001e-05,
            "Fossil_fraction": 13.0041925338796,
            "Land_fraction": 86.9958074661203,
            "Rank": 170,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Kosovo",
            "Abs_contribution": 5.48597714656113e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 5.48597714656113e-05,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 171,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Eritrea",
            "Abs_contribution": 5.08701401075327e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 8.30549160753275e-06,
            "Land_abs": 4.25646485e-05,
            "Fossil_fraction": 16.3268502700721,
            "Land_fraction": 83.673149729928,
            "Rank": 172,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Swaziland",
            "Abs_contribution": 4.92332444999998e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 4.92332444999998e-05,
            "Fossil_fraction": 0,
            "Land_fraction": 100,
            "Rank": 173,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Malta",
            "Abs_contribution": 4.59984434394108e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 4.83290354394105e-05,
            "Land_abs": -0.000002330592,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 174,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Aruba",
            "Abs_contribution": 3.50449435316594e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 3.50449435316594e-05,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 175,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Barbados",
            "Abs_contribution": 3.36083607581878e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 3.15587362581878e-05,
            "Land_abs": 2.0496245e-06,
            "Fossil_fraction": 93.901444599613,
            "Land_fraction": 6.09855540038698,
            "Rank": 176,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Sint Maarten (Dutch part)",
            "Abs_contribution": 3.01400010507642e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 3.01400010507642e-05,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 177,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Macao",
            "Abs_contribution": 2.58682420169214e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 2.58682420169214e-05,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 178,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Samoa",
            "Abs_contribution": 1.64654730534934e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 3.29003605349345e-06,
            "Land_abs": 1.3175437e-05,
            "Fossil_fraction": 19.9814244194789,
            "Land_fraction": 80.0185755805214,
            "Rank": 179,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Greenland",
            "Abs_contribution": 1.5421003125e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 1.5421003125e-05,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 180,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "French Polynesia",
            "Abs_contribution": 1.45090511872271e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 1.45090511872271e-05,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 181,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Faeroe Islands",
            "Abs_contribution": 1.45006426719432e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 1.45006426719432e-05,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 182,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Bermuda",
            "Abs_contribution": 1.34244274699782e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 1.34244274699782e-05,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 183,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Maldives",
            "Abs_contribution": 1.27502705420306e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 1.27426640420306e-05,
            "Land_abs": 7.6065e-09,
            "Fossil_fraction": 99.9403424423433,
            "Land_fraction": 0.0596575576567224,
            "Rank": 184,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Antigua and Barbuda",
            "Abs_contribution": 1.01598143979257e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 1.14562908979258e-05,
            "Land_abs": -0.0000012964765,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 185,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Djibouti",
            "Abs_contribution": 9.78599206713975e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 8.98537356713974e-06,
            "Land_abs": 8.00618500000001e-07,
            "Fossil_fraction": 91.8187293173025,
            "Land_fraction": 8.18127068269743,
            "Rank": 186,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Ryukyu Islands",
            "Abs_contribution": 9.40859091157205e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 9.40859091157205e-06,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 187,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Lucia",
            "Abs_contribution": 9.14080683351531e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 6.90783983351528e-06,
            "Land_abs": 2.232967e-06,
            "Fossil_fraction": 75.5714452709719,
            "Land_fraction": 24.4285547290278,
            "Rank": 188,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Cape Verde",
            "Abs_contribution": 7.95247428766374e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 6.96552678766376e-06,
            "Land_abs": 9.86947499999998e-07,
            "Fossil_fraction": 87.58942859418,
            "Land_fraction": 12.4105714058202,
            "Rank": 189,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Tonga",
            "Abs_contribution": 7.77318596015282e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 2.15615146015284e-06,
            "Land_abs": 5.61703449999998e-06,
            "Fossil_fraction": 27.7383234005436,
            "Land_fraction": 72.2616765994564,
            "Rank": 190,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Andorra",
            "Abs_contribution": 7.24465608679041e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 7.06645058679039e-06,
            "Land_abs": 1.782055e-07,
            "Fossil_fraction": 97.540179991084,
            "Land_fraction": 2.4598200089157,
            "Rank": 191,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Seychelles",
            "Abs_contribution": 6.72153033569869e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 6.72153033569869e-06,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 192,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Panama Canal Zone",
            "Abs_contribution": 6.64785e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 6.64785e-06,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 193,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Comoros",
            "Abs_contribution": 5.39358464301311e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 2.8181216430131e-06,
            "Land_abs": 2.575463e-06,
            "Fossil_fraction": 52.249511772541,
            "Land_fraction": 47.7504882274588,
            "Rank": 194,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Dominica",
            "Abs_contribution": 5.28624285425766e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 2.31371835425764e-06,
            "Land_abs": 2.9725245e-06,
            "Fossil_fraction": 43.7686731019957,
            "Land_fraction": 56.231326898004,
            "Rank": 195,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Vincent and the Grenadines",
            "Abs_contribution": 4.78562326528387e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 3.36388976528384e-06,
            "Land_abs": 1.4217335e-06,
            "Fossil_fraction": 70.291570790504,
            "Land_fraction": 29.7084292094954,
            "Rank": 196,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Sao Tome and Principe",
            "Abs_contribution": 4.31961648526201e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.68277348526201e-06,
            "Land_abs": 2.636843e-06,
            "Fossil_fraction": 38.956548364963,
            "Land_fraction": 61.043451635037,
            "Rank": 197,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Liechtenstein",
            "Abs_contribution": 4.19884202128821e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 4.37809802128821e-06,
            "Land_abs": -0.000000179256,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 198,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Grenada",
            "Abs_contribution": 3.73805411681223e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 4.01928561681223e-06,
            "Land_abs": -0.0000002812315,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 199,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Bonaire, Saint Eustatius and Saba",
            "Abs_contribution": 3.72632955786026e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 3.72632955786026e-06,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 200,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Micronesia (Federated States of)",
            "Abs_contribution": 3.15103275818777e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 2.06416125818777e-06,
            "Land_abs": 1.0868715e-06,
            "Fossil_fraction": 65.5074515751755,
            "Land_fraction": 34.4925484248245,
            "Rank": 201,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Turks and Caicos Islands",
            "Abs_contribution": 3.08012263919214e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 3.08012263919214e-06,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 202,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Palau",
            "Abs_contribution": 2.95739353165939e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 2.95739353165939e-06,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 203,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Kitts and Nevis",
            "Abs_contribution": 2.78817527183406e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 3.07061127183406e-06,
            "Land_abs": -0.000000282436,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 204,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "British Virgin Islands",
            "Abs_contribution": 2.6172134279476e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 2.6172134279476e-06,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 205,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Nauru",
            "Abs_contribution": 2.2325364628821e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 2.2325364628821e-06,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 206,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Pacific Islands (Palau)",
            "Abs_contribution": 1.99485e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.99485e-06,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 207,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Pierre and Miquelon",
            "Abs_contribution": 1.71915859716157e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.71915859716157e-06,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 208,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Marshall Islands",
            "Abs_contribution": 1.67146125818777e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.67146125818777e-06,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 209,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Cook Islands",
            "Abs_contribution": 1.64618272379913e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.15228272379913e-06,
            "Land_abs": 4.939e-07,
            "Fossil_fraction": 69.9972552949555,
            "Land_fraction": 30.0027447050444,
            "Rank": 210,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Anguilla",
            "Abs_contribution": 1.49903986080786e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.49903986080786e-06,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 211,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Kiribati",
            "Abs_contribution": 9.67482723799127e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 9.67482723799127e-07,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 212,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Montserrat",
            "Abs_contribution": 7.35267740174672e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 7.35267740174672e-07,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 213,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Christmas Island",
            "Abs_contribution": 5.9895e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 5.9895e-07,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 214,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Niue",
            "Abs_contribution": 5.14052630458512e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 1.33898130458515e-07,
            "Land_abs": 3.801545e-07,
            "Fossil_fraction": 26.0475528233527,
            "Land_fraction": 73.9524471766479,
            "Rank": 215,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Wallis and Futuna Islands",
            "Abs_contribution": 3.58918231441048e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 3.58918231441048e-07,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 216,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "St. Kitts-Nevis-Anguilla",
            "Abs_contribution": 2.805e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 2.805e-07,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 217,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Helena",
            "Abs_contribution": 1.92523116812227e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 1.92523116812227e-07,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 218,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Tuvalu",
            "Abs_contribution": 1.35671970524017e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 1.35671970524017e-07,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 219,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Leeward Islands",
            "Abs_contribution": 8.085e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 8.085e-08,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 220,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Antarctica",
            "Abs_contribution": 6.93e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 6.93e-08,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 221,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Occupied Palestinian Territory",
            "Abs_contribution": 5.74145000000003e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 5.74145000000003e-08,
            "Fossil_fraction": 0,
            "Land_fraction": 100,
            "Rank": 222,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Mauritania",
            "Abs_contribution": -0.0000266873834781659,
            "Perc_contribution": -0,
            "Fossil_abs": 3.88997425218341e-05,
            "Land_abs": -0.0000655871259999999,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 223,
            "Perc_contribution_rescale": -0
        }
    ],
    "1851_N2O": [
        {
            "Country": "EU27",
            "Abs_contribution": 0.011640504309293,
            "Perc_contribution": 14.09,
            "Fossil_abs": 0.00470817014701476,
            "Land_abs": 0.00693233416227824,
            "Fossil_fraction": 40.4464447752155,
            "Land_fraction": 59.5535552247848,
            "Rank": 1,
            "Perc_contribution_rescale": 100
        },
        {
            "Country": "United States",
            "Abs_contribution": 0.0105605926864757,
            "Perc_contribution": 12.78,
            "Fossil_abs": 0.00468961872826772,
            "Land_abs": 0.00587097395820798,
            "Fossil_fraction": 44.4067759025818,
            "Land_fraction": 55.5932240974179,
            "Rank": 2,
            "Perc_contribution_rescale": 90.7026259758694
        },
        {
            "Country": "China",
            "Abs_contribution": 0.0091769585559535,
            "Perc_contribution": 11.1,
            "Fossil_abs": 0.00252525010780482,
            "Land_abs": 0.00665170844814868,
            "Fossil_fraction": 27.5172879163389,
            "Land_fraction": 72.4827120836611,
            "Rank": 3,
            "Perc_contribution_rescale": 78.7792760823279
        },
        {
            "Country": "India",
            "Abs_contribution": 0.0064622506463526,
            "Perc_contribution": 7.82,
            "Fossil_abs": 0.0010827433493241,
            "Land_abs": 0.00537950729702849,
            "Fossil_fraction": 16.7548956018167,
            "Land_fraction": 83.2451043981833,
            "Rank": 4,
            "Perc_contribution_rescale": 55.500354861604
        },
        {
            "Country": "Russia",
            "Abs_contribution": 0.00397772070988596,
            "Perc_contribution": 4.81,
            "Fossil_abs": 0.0014354239888389,
            "Land_abs": 0.00254229672104705,
            "Fossil_fraction": 36.0865956544259,
            "Land_fraction": 63.9134043455739,
            "Rank": 5,
            "Perc_contribution_rescale": 34.1376863023421
        },
        {
            "Country": "Brazil",
            "Abs_contribution": 0.00346389103949125,
            "Perc_contribution": 4.19,
            "Fossil_abs": 0.000477353696959331,
            "Land_abs": 0.00298653734253192,
            "Fossil_fraction": 13.7808519816905,
            "Land_fraction": 86.2191480183094,
            "Rank": 6,
            "Perc_contribution_rescale": 29.7374024130589
        },
        {
            "Country": "Australia",
            "Abs_contribution": 0.00301342702364852,
            "Perc_contribution": 3.65,
            "Fossil_abs": 0.000207772017974263,
            "Land_abs": 0.00280565500567426,
            "Fossil_fraction": 6.89487471718171,
            "Land_fraction": 93.1051252828183,
            "Rank": 7,
            "Perc_contribution_rescale": 25.9048970901348
        },
        {
            "Country": "Germany",
            "Abs_contribution": 0.00227271290515374,
            "Perc_contribution": 2.75,
            "Fossil_abs": 0.00106467237061365,
            "Land_abs": 0.00120804053454008,
            "Fossil_fraction": 46.8458804541189,
            "Land_fraction": 53.1541195458811,
            "Rank": 8,
            "Perc_contribution_rescale": 19.5173882185947
        },
        {
            "Country": "France",
            "Abs_contribution": 0.00197134771789075,
            "Perc_contribution": 2.39,
            "Fossil_abs": 0.000844169219774535,
            "Land_abs": 0.00112717849811622,
            "Fossil_fraction": 42.8219340562484,
            "Land_fraction": 57.1780659437517,
            "Rank": 9,
            "Perc_contribution_rescale": 16.9623846699787
        },
        {
            "Country": "United Kingdom",
            "Abs_contribution": 0.00179201251482801,
            "Perc_contribution": 2.17,
            "Fossil_abs": 0.000824699615103447,
            "Land_abs": 0.000967312899724568,
            "Fossil_fraction": 46.0208624816773,
            "Land_fraction": 53.9791375183228,
            "Rank": 10,
            "Perc_contribution_rescale": 15.4009936124911
        },
        {
            "Country": "Mexico",
            "Abs_contribution": 0.00174651504549903,
            "Perc_contribution": 2.11,
            "Fossil_abs": 0.000881964659567121,
            "Land_abs": 0.000864550385931902,
            "Fossil_fraction": 50.4985434760523,
            "Land_fraction": 49.5014565239474,
            "Rank": 11,
            "Perc_contribution_rescale": 14.9751596877218
        },
        {
            "Country": "Canada",
            "Abs_contribution": 0.00148017327984727,
            "Perc_contribution": 1.79,
            "Fossil_abs": 0.000448887567249027,
            "Land_abs": 0.00103128571259824,
            "Fossil_fraction": 30.3266903517773,
            "Land_fraction": 69.6733096482227,
            "Rank": 12,
            "Perc_contribution_rescale": 12.7040454222853
        },
        {
            "Country": "Ukraine",
            "Abs_contribution": 0.00144152494277276,
            "Perc_contribution": 1.74,
            "Fossil_abs": 0.000421538178155527,
            "Land_abs": 0.00101998676461723,
            "Fossil_fraction": 29.2425171183442,
            "Land_fraction": 70.7574828816555,
            "Rank": 13,
            "Perc_contribution_rescale": 12.3491838183109
        },
        {
            "Country": "Indonesia",
            "Abs_contribution": 0.00134604834206501,
            "Perc_contribution": 1.63,
            "Fossil_abs": 0.000232485589696896,
            "Land_abs": 0.00111356275236811,
            "Fossil_fraction": 17.2717117529548,
            "Land_fraction": 82.7282882470448,
            "Rank": 14,
            "Perc_contribution_rescale": 11.5684882895671
        },
        {
            "Country": "Argentina",
            "Abs_contribution": 0.00126733815327114,
            "Perc_contribution": 1.53,
            "Fossil_abs": 0.000102747306387982,
            "Land_abs": 0.00116459084688317,
            "Fossil_fraction": 8.10733158492699,
            "Land_fraction": 91.8926684150736,
            "Rank": 15,
            "Perc_contribution_rescale": 10.8587650816182
        },
        {
            "Country": "Pakistan",
            "Abs_contribution": 0.00111082192920115,
            "Perc_contribution": 1.34,
            "Fossil_abs": 0.000167273451217963,
            "Land_abs": 0.000943548477983192,
            "Fossil_fraction": 15.0585297985841,
            "Land_fraction": 84.9414702014159,
            "Rank": 16,
            "Perc_contribution_rescale": 9.51029098651526
        },
        {
            "Country": "Poland",
            "Abs_contribution": 0.00110898929139907,
            "Perc_contribution": 1.34,
            "Fossil_abs": 0.000392735162951135,
            "Land_abs": 0.000716254128447937,
            "Fossil_fraction": 35.4137921796947,
            "Land_fraction": 64.5862078203055,
            "Rank": 17,
            "Perc_contribution_rescale": 9.51029098651526
        },
        {
            "Country": "T\xfcrkiye",
            "Abs_contribution": 0.00101764565793311,
            "Perc_contribution": 1.23,
            "Fossil_abs": 0.000279545262544037,
            "Land_abs": 0.000738100395389071,
            "Fossil_fraction": 27.4698034983816,
            "Land_fraction": 72.5301965016185,
            "Rank": 18,
            "Perc_contribution_rescale": 8.72959545777147
        },
        {
            "Country": "Ethiopia",
            "Abs_contribution": 0.00099676776577107,
            "Perc_contribution": 1.21,
            "Fossil_abs": 7.89549349986231e-05,
            "Land_abs": 0.000917812830772447,
            "Fossil_fraction": 7.92109633857852,
            "Land_fraction": 92.0789036614215,
            "Rank": 19,
            "Perc_contribution_rescale": 8.58765081618169
        },
        {
            "Country": "Belarus",
            "Abs_contribution": 0.000974452102108748,
            "Perc_contribution": 1.18,
            "Fossil_abs": 0.000167929382603515,
            "Land_abs": 0.000806522719505231,
            "Fossil_fraction": 17.2332105641837,
            "Land_fraction": 82.7667894358162,
            "Rank": 20,
            "Perc_contribution_rescale": 8.37473385379702
        },
        {
            "Country": "Japan",
            "Abs_contribution": 0.000971556824062606,
            "Perc_contribution": 1.18,
            "Fossil_abs": 0.000664252326322465,
            "Land_abs": 0.000307304497740142,
            "Fossil_fraction": 68.3698894260106,
            "Land_fraction": 31.6301105739894,
            "Rank": 21,
            "Perc_contribution_rescale": 8.37473385379702
        },
        {
            "Country": "Italy",
            "Abs_contribution": 0.000906353016623616,
            "Perc_contribution": 1.1,
            "Fossil_abs": 0.000416121581462297,
            "Land_abs": 0.000490231435161319,
            "Fossil_fraction": 45.9116452232322,
            "Land_fraction": 54.0883547767679,
            "Rank": 22,
            "Perc_contribution_rescale": 7.8069552874379
        },
        {
            "Country": "South Africa",
            "Abs_contribution": 0.000737094191882902,
            "Perc_contribution": 0.89,
            "Fossil_abs": 0.000219188569561752,
            "Land_abs": 0.000517905622321151,
            "Fossil_fraction": 29.7368466575264,
            "Land_fraction": 70.2631533424737,
            "Rank": 23,
            "Perc_contribution_rescale": 6.31653655074521
        },
        {
            "Country": "Spain",
            "Abs_contribution": 0.000735890337555462,
            "Perc_contribution": 0.89,
            "Fossil_abs": 0.000264292719019204,
            "Land_abs": 0.000471597618536258,
            "Fossil_fraction": 35.9146880358767,
            "Land_fraction": 64.0853119641233,
            "Rank": 24,
            "Perc_contribution_rescale": 6.31653655074521
        },
        {
            "Country": "Nigeria",
            "Abs_contribution": 0.000709133579217929,
            "Perc_contribution": 0.86,
            "Fossil_abs": 0.000204119187170097,
            "Land_abs": 0.000505014392047831,
            "Fossil_fraction": 28.7843070970086,
            "Land_fraction": 71.2156929029914,
            "Rank": 25,
            "Perc_contribution_rescale": 6.10361958836054
        },
        {
            "Country": "Bangladesh",
            "Abs_contribution": 0.000684848181525696,
            "Perc_contribution": 0.83,
            "Fossil_abs": 9.04435915584621e-05,
            "Land_abs": 0.000594404589967234,
            "Fossil_fraction": 13.2063709882347,
            "Land_fraction": 86.7936290117654,
            "Rank": 26,
            "Perc_contribution_rescale": 5.89070262597587
        },
        {
            "Country": "Iran",
            "Abs_contribution": 0.000639124313100745,
            "Perc_contribution": 0.77,
            "Fossil_abs": 0.000235856156618233,
            "Land_abs": 0.000403268156482512,
            "Fossil_fraction": 36.9030174230056,
            "Land_fraction": 63.0969825769944,
            "Rank": 27,
            "Perc_contribution_rescale": 5.46486870120653
        },
        {
            "Country": "New Zealand",
            "Abs_contribution": 0.000604576849647693,
            "Perc_contribution": 0.73,
            "Fossil_abs": 1.62267344970603e-05,
            "Land_abs": 0.000588350115150632,
            "Fossil_fraction": 2.6839821118715,
            "Land_fraction": 97.3160178881283,
            "Rank": 28,
            "Perc_contribution_rescale": 5.18097941802697
        },
        {
            "Country": "South Sudan",
            "Abs_contribution": 0.000591304471603097,
            "Perc_contribution": 0.72,
            "Fossil_abs": 6.37597580024427e-06,
            "Land_abs": 0.000584928495802852,
            "Fossil_fraction": 1.07828979932424,
            "Land_fraction": 98.9217102006756,
            "Rank": 29,
            "Perc_contribution_rescale": 5.11000709723208
        },
        {
            "Country": "Netherlands",
            "Abs_contribution": 0.000535314890940524,
            "Perc_contribution": 0.65,
            "Fossil_abs": 0.000251574820860901,
            "Land_abs": 0.000283740070079623,
            "Fossil_fraction": 46.995670234186,
            "Land_fraction": 53.004329765814,
            "Rank": 30,
            "Perc_contribution_rescale": 4.61320085166785
        },
        {
            "Country": "Sudan",
            "Abs_contribution": 0.000521608320940038,
            "Perc_contribution": 0.63,
            "Fossil_abs": 2.22320203345415e-05,
            "Land_abs": 0.000499376300605496,
            "Fossil_fraction": 4.26220584335678,
            "Land_fraction": 95.7377941566432,
            "Rank": 31,
            "Perc_contribution_rescale": 4.47125621007807
        },
        {
            "Country": "Thailand",
            "Abs_contribution": 0.000520151697750728,
            "Perc_contribution": 0.63,
            "Fossil_abs": 0.000127450954673756,
            "Land_abs": 0.000392700743076974,
            "Fossil_fraction": 24.5026509045125,
            "Land_fraction": 75.4973490954877,
            "Rank": 32,
            "Perc_contribution_rescale": 4.47125621007807
        },
        {
            "Country": "Colombia",
            "Abs_contribution": 0.00051052649004098,
            "Perc_contribution": 0.62,
            "Fossil_abs": 4.93976398935397e-05,
            "Land_abs": 0.00046112885014744,
            "Fossil_fraction": 9.67582306837291,
            "Land_fraction": 90.324176931627,
            "Rank": 33,
            "Perc_contribution_rescale": 4.40028388928318
        },
        {
            "Country": "Tanzania",
            "Abs_contribution": 0.000506916904934943,
            "Perc_contribution": 0.61,
            "Fossil_abs": 3.67659124010126e-05,
            "Land_abs": 0.00047015099253393,
            "Fossil_fraction": 7.25284796050175,
            "Land_fraction": 92.7471520394982,
            "Rank": 34,
            "Perc_contribution_rescale": 4.32931156848829
        },
        {
            "Country": "Romania",
            "Abs_contribution": 0.000473784919313765,
            "Perc_contribution": 0.57,
            "Fossil_abs": 0.000184838026371907,
            "Land_abs": 0.000288946892941858,
            "Fossil_fraction": 39.0130666547235,
            "Land_fraction": 60.9869333452765,
            "Rank": 35,
            "Perc_contribution_rescale": 4.04542228530873
        },
        {
            "Country": "Kazakhstan",
            "Abs_contribution": 0.000470307203405887,
            "Perc_contribution": 0.57,
            "Fossil_abs": 8.44463824557519e-05,
            "Land_abs": 0.000385860820950135,
            "Fossil_fraction": 17.9555792138001,
            "Land_fraction": 82.0444207861998,
            "Rank": 36,
            "Perc_contribution_rescale": 4.04542228530873
        },
        {
            "Country": "Angola",
            "Abs_contribution": 0.000464507504727642,
            "Perc_contribution": 0.56,
            "Fossil_abs": 1.94292851140489e-05,
            "Land_abs": 0.000445078219613593,
            "Fossil_fraction": 4.18277098137327,
            "Land_fraction": 95.8172290186267,
            "Rank": 37,
            "Perc_contribution_rescale": 3.97444996451384
        },
        {
            "Country": "Egypt",
            "Abs_contribution": 0.00046118407588665,
            "Perc_contribution": 0.56,
            "Fossil_abs": 0.000154196940241367,
            "Land_abs": 0.000306987135645283,
            "Fossil_fraction": 33.4350096422813,
            "Land_fraction": 66.5649903577187,
            "Rank": 38,
            "Perc_contribution_rescale": 3.97444996451384
        },
        {
            "Country": "Myanmar",
            "Abs_contribution": 0.000459751702201003,
            "Perc_contribution": 0.56,
            "Fossil_abs": 3.6050720113432e-05,
            "Land_abs": 0.000423700982087571,
            "Fossil_fraction": 7.84134565263027,
            "Land_fraction": 92.1586543473698,
            "Rank": 39,
            "Perc_contribution_rescale": 3.97444996451384
        },
        {
            "Country": "Democratic Republic of the Congo",
            "Abs_contribution": 0.000432404200313511,
            "Perc_contribution": 0.52,
            "Fossil_abs": 3.36641456406714e-05,
            "Land_abs": 0.00039874005467284,
            "Fossil_fraction": 7.78534195927411,
            "Land_fraction": 92.214658040726,
            "Rank": 40,
            "Perc_contribution_rescale": 3.69056068133428
        },
        {
            "Country": "Viet Nam",
            "Abs_contribution": 0.000419542802923239,
            "Perc_contribution": 0.51,
            "Fossil_abs": 7.67302661234279e-05,
            "Land_abs": 0.000342812536799812,
            "Fossil_fraction": 18.2890197588413,
            "Land_fraction": 81.7109802411588,
            "Rank": 41,
            "Perc_contribution_rescale": 3.61958836053939
        },
        {
            "Country": "Zambia",
            "Abs_contribution": 0.000365028808165583,
            "Perc_contribution": 0.44,
            "Fossil_abs": 3.29090210712363e-05,
            "Land_abs": 0.000332119787094347,
            "Fossil_fraction": 9.01545859808093,
            "Land_fraction": 90.9845414019192,
            "Rank": 42,
            "Perc_contribution_rescale": 3.12278211497516
        },
        {
            "Country": "Kenya",
            "Abs_contribution": 0.000352888408237266,
            "Perc_contribution": 0.43,
            "Fossil_abs": 3.5790754412896e-05,
            "Land_abs": 0.00031709765382437,
            "Fossil_fraction": 10.1422301150884,
            "Land_fraction": 89.8577698849116,
            "Rank": 43,
            "Perc_contribution_rescale": 3.05180979418027
        },
        {
            "Country": "Chad",
            "Abs_contribution": 0.000342564342528159,
            "Perc_contribution": 0.41,
            "Fossil_abs": 6.77421292241471e-06,
            "Land_abs": 0.000335790129605744,
            "Fossil_fraction": 1.97750089002853,
            "Land_fraction": 98.0224991099715,
            "Rank": 44,
            "Perc_contribution_rescale": 2.90986515259049
        },
        {
            "Country": "Belgium",
            "Abs_contribution": 0.000342417522036382,
            "Perc_contribution": 0.41,
            "Fossil_abs": 0.000217436136762277,
            "Land_abs": 0.000124981385274105,
            "Fossil_fraction": 63.500295040151,
            "Land_fraction": 36.499704959849,
            "Rank": 45,
            "Perc_contribution_rescale": 2.90986515259049
        },
        {
            "Country": "Mongolia",
            "Abs_contribution": 0.000337239312542501,
            "Perc_contribution": 0.41,
            "Fossil_abs": 4.97580901913073e-06,
            "Land_abs": 0.000332263503523371,
            "Fossil_fraction": 1.47545343442237,
            "Land_fraction": 98.5245465655778,
            "Rank": 46,
            "Perc_contribution_rescale": 2.90986515259049
        },
        {
            "Country": "Hungary",
            "Abs_contribution": 0.000321391498654208,
            "Perc_contribution": 0.39,
            "Fossil_abs": 0.000124312634080324,
            "Land_abs": 0.000197078864573885,
            "Fossil_fraction": 38.6795029118286,
            "Land_fraction": 61.3204970881717,
            "Rank": 47,
            "Perc_contribution_rescale": 2.76792051100071
        },
        {
            "Country": "Ireland",
            "Abs_contribution": 0.000321368068959711,
            "Perc_contribution": 0.39,
            "Fossil_abs": 3.69488576525846e-05,
            "Land_abs": 0.000284419211307127,
            "Fossil_fraction": 11.4973643063514,
            "Land_fraction": 88.5026356936486,
            "Rank": 48,
            "Perc_contribution_rescale": 2.76792051100071
        },
        {
            "Country": "Uzbekistan",
            "Abs_contribution": 0.000321292994840776,
            "Perc_contribution": 0.39,
            "Fossil_abs": 5.51372541342986e-05,
            "Land_abs": 0.000266155740706478,
            "Fossil_fraction": 17.1610508226683,
            "Land_fraction": 82.8389491773317,
            "Rank": 49,
            "Perc_contribution_rescale": 2.76792051100071
        },
        {
            "Country": "Philippines",
            "Abs_contribution": 0.000313787777809237,
            "Perc_contribution": 0.38,
            "Fossil_abs": 7.43784497643414e-05,
            "Land_abs": 0.000239409328044896,
            "Fossil_fraction": 23.7034247425529,
            "Land_fraction": 76.2965752574474,
            "Rank": 50,
            "Perc_contribution_rescale": 2.69694819020582
        },
        {
            "Country": "Sweden",
            "Abs_contribution": 0.000308323821841789,
            "Perc_contribution": 0.37,
            "Fossil_abs": 0.00013655980208094,
            "Land_abs": 0.000171764019760849,
            "Fossil_fraction": 44.291031833088,
            "Land_fraction": 55.708968166912,
            "Rank": 51,
            "Perc_contribution_rescale": 2.62597586941093
        },
        {
            "Country": "Venezuela",
            "Abs_contribution": 0.000307162204425769,
            "Perc_contribution": 0.37,
            "Fossil_abs": 4.38868745845005e-05,
            "Land_abs": 0.000263275329841268,
            "Fossil_fraction": 14.2878498565752,
            "Land_fraction": 85.7121501434246,
            "Rank": 52,
            "Perc_contribution_rescale": 2.62597586941093
        },
        {
            "Country": "South Korea",
            "Abs_contribution": 0.000303255750073887,
            "Perc_contribution": 0.37,
            "Fossil_abs": 0.000162895430296261,
            "Land_abs": 0.000140360319777625,
            "Fossil_fraction": 53.7155289740004,
            "Land_fraction": 46.2844710259993,
            "Rank": 53,
            "Perc_contribution_rescale": 2.62597586941093
        },
        {
            "Country": "Finland",
            "Abs_contribution": 0.000281605982175258,
            "Perc_contribution": 0.34,
            "Fossil_abs": 0.000104207653080099,
            "Land_abs": 0.00017739832909516,
            "Fossil_fraction": 37.0047725105658,
            "Land_fraction": 62.9952274894342,
            "Rank": 54,
            "Perc_contribution_rescale": 2.41305890702626
        },
        {
            "Country": "Mozambique",
            "Abs_contribution": 0.000274838403020404,
            "Perc_contribution": 0.33,
            "Fossil_abs": 1.97579086002879e-05,
            "Land_abs": 0.000255080494420116,
            "Fossil_fraction": 7.18891842739355,
            "Land_fraction": 92.8110815726066,
            "Rank": 55,
            "Perc_contribution_rescale": 2.34208658623137
        },
        {
            "Country": "Denmark",
            "Abs_contribution": 0.000273474191861503,
            "Perc_contribution": 0.33,
            "Fossil_abs": 7.89675661993559e-05,
            "Land_abs": 0.000194506625662148,
            "Fossil_fraction": 28.8756923137185,
            "Land_fraction": 71.1243076862818,
            "Rank": 56,
            "Perc_contribution_rescale": 2.34208658623137
        },
        {
            "Country": "Madagascar",
            "Abs_contribution": 0.000271343523369314,
            "Perc_contribution": 0.33,
            "Fossil_abs": 1.08144116525314e-05,
            "Land_abs": 0.000260529111716783,
            "Fossil_fraction": 3.9855057228738,
            "Land_fraction": 96.0144942771262,
            "Rank": 57,
            "Perc_contribution_rescale": 2.34208658623137
        },
        {
            "Country": "Mali",
            "Abs_contribution": 0.000269885684296941,
            "Perc_contribution": 0.33,
            "Fossil_abs": 7.70158561197134e-06,
            "Land_abs": 0.000262184098684969,
            "Fossil_fraction": 2.85364732554607,
            "Land_fraction": 97.1463526744539,
            "Rank": 58,
            "Perc_contribution_rescale": 2.34208658623137
        },
        {
            "Country": "Czechia",
            "Abs_contribution": 0.000267632797347855,
            "Perc_contribution": 0.32,
            "Fossil_abs": 0.00012661684538109,
            "Land_abs": 0.000141015951966764,
            "Fossil_fraction": 47.3099136712008,
            "Land_fraction": 52.6900863287988,
            "Rank": 59,
            "Perc_contribution_rescale": 2.27111426543648
        },
        {
            "Country": "Lithuania",
            "Abs_contribution": 0.000263175556179289,
            "Perc_contribution": 0.32,
            "Fossil_abs": 5.77011893604981e-05,
            "Land_abs": 0.000205474366818791,
            "Fossil_fraction": 21.9249804952209,
            "Land_fraction": 78.0750195047793,
            "Rank": 60,
            "Perc_contribution_rescale": 2.27111426543648
        },
        {
            "Country": "Central African Republic",
            "Abs_contribution": 0.000246398330820973,
            "Perc_contribution": 0.3,
            "Fossil_abs": 2.51489166736122e-06,
            "Land_abs": 0.000243883439153612,
            "Fossil_fraction": 1.02066100000835,
            "Land_fraction": 98.9793389999917,
            "Rank": 61,
            "Perc_contribution_rescale": 2.1291696238467
        },
        {
            "Country": "Peru",
            "Abs_contribution": 0.000237568042731397,
            "Perc_contribution": 0.29,
            "Fossil_abs": 3.63487538475196e-05,
            "Land_abs": 0.000201219288883878,
            "Fossil_fraction": 15.3003549760339,
            "Land_fraction": 84.6996450239663,
            "Rank": 62,
            "Perc_contribution_rescale": 2.05819730305181
        },
        {
            "Country": "Uruguay",
            "Abs_contribution": 0.000233279363639784,
            "Perc_contribution": 0.28,
            "Fossil_abs": 8.1900425065247e-06,
            "Land_abs": 0.00022508932113326,
            "Fossil_fraction": 3.51083026751191,
            "Land_fraction": 96.4891697324884,
            "Rank": 63,
            "Perc_contribution_rescale": 1.98722498225692
        },
        {
            "Country": "Greece",
            "Abs_contribution": 0.000225351998439526,
            "Perc_contribution": 0.27,
            "Fossil_abs": 7.00761296169432e-05,
            "Land_abs": 0.000155275868822584,
            "Fossil_fraction": 31.0962982809972,
            "Land_fraction": 68.9037017190031,
            "Rank": 64,
            "Perc_contribution_rescale": 1.91625266146203
        },
        {
            "Country": "Morocco",
            "Abs_contribution": 0.000224153304911836,
            "Perc_contribution": 0.27,
            "Fossil_abs": 2.85262491547877e-05,
            "Land_abs": 0.000195627055757048,
            "Fossil_fraction": 12.7262228705518,
            "Land_fraction": 87.2737771294481,
            "Rank": 65,
            "Perc_contribution_rescale": 1.91625266146203
        },
        {
            "Country": "Somalia",
            "Abs_contribution": 0.0002227784410063,
            "Perc_contribution": 0.27,
            "Fossil_abs": 8.72238017838414e-06,
            "Land_abs": 0.000214056060827916,
            "Fossil_fraction": 3.91527121699243,
            "Land_fraction": 96.0847287830075,
            "Rank": 66,
            "Perc_contribution_rescale": 1.91625266146203
        },
        {
            "Country": "Norway",
            "Abs_contribution": 0.000220350637963788,
            "Perc_contribution": 0.27,
            "Fossil_abs": 0.000117566018347207,
            "Land_abs": 0.000102784619616582,
            "Fossil_fraction": 53.3540630667597,
            "Land_fraction": 46.6459369332407,
            "Rank": 67,
            "Perc_contribution_rescale": 1.91625266146203
        },
        {
            "Country": "Bulgaria",
            "Abs_contribution": 0.000216524371646416,
            "Perc_contribution": 0.26,
            "Fossil_abs": 6.54142041638511e-05,
            "Land_abs": 0.000151110167482565,
            "Fossil_fraction": 30.2110121213849,
            "Land_fraction": 69.7889878786152,
            "Rank": 68,
            "Perc_contribution_rescale": 1.84528034066714
        },
        {
            "Country": "Uganda",
            "Abs_contribution": 0.000213579344628623,
            "Perc_contribution": 0.26,
            "Fossil_abs": 2.75792858697798e-05,
            "Land_abs": 0.000186000058758843,
            "Fossil_fraction": 12.9128993806659,
            "Land_fraction": 87.0871006193341,
            "Rank": 69,
            "Perc_contribution_rescale": 1.84528034066714
        },
        {
            "Country": "Niger",
            "Abs_contribution": 0.00019399810003127,
            "Perc_contribution": 0.23,
            "Fossil_abs": 8.17631991240475e-06,
            "Land_abs": 0.000185821780118866,
            "Fossil_fraction": 4.21463916970673,
            "Land_fraction": 95.7853608302934,
            "Rank": 70,
            "Perc_contribution_rescale": 1.63236337828247
        },
        {
            "Country": "Austria",
            "Abs_contribution": 0.000188906773847276,
            "Perc_contribution": 0.23,
            "Fossil_abs": 8.12052150261153e-05,
            "Land_abs": 0.000107701558821161,
            "Fossil_fraction": 42.9869259700377,
            "Land_fraction": 57.0130740299622,
            "Rank": 71,
            "Perc_contribution_rescale": 1.63236337828247
        },
        {
            "Country": "Paraguay",
            "Abs_contribution": 0.000178473718299924,
            "Perc_contribution": 0.22,
            "Fossil_abs": 8.47700236871479e-06,
            "Land_abs": 0.00016999671593121,
            "Fossil_fraction": 4.7497202666385,
            "Land_fraction": 95.2502797333617,
            "Rank": 72,
            "Perc_contribution_rescale": 1.56139105748758
        },
        {
            "Country": "Nepal",
            "Abs_contribution": 0.000177085688949383,
            "Perc_contribution": 0.21,
            "Fossil_abs": 2.856612217247e-05,
            "Land_abs": 0.000148519566776913,
            "Fossil_fraction": 16.1312426441389,
            "Land_fraction": 83.8687573558611,
            "Rank": 73,
            "Perc_contribution_rescale": 1.49041873669269
        },
        {
            "Country": "Chile",
            "Abs_contribution": 0.000174299950879366,
            "Perc_contribution": 0.21,
            "Fossil_abs": 4.32773282004109e-05,
            "Land_abs": 0.000131022622678955,
            "Fossil_fraction": 24.8292257009087,
            "Land_fraction": 75.1707742990912,
            "Rank": 74,
            "Perc_contribution_rescale": 1.49041873669269
        },
        {
            "Country": "Cuba",
            "Abs_contribution": 0.000174099689353655,
            "Perc_contribution": 0.21,
            "Fossil_abs": 4.39548034452273e-05,
            "Land_abs": 0.000130144885908428,
            "Fossil_fraction": 25.2469166420741,
            "Land_fraction": 74.7530833579258,
            "Rank": 75,
            "Perc_contribution_rescale": 1.49041873669269
        },
        {
            "Country": "Bolivia",
            "Abs_contribution": 0.000173594399624525,
            "Perc_contribution": 0.21,
            "Fossil_abs": 8.2118671839899e-06,
            "Land_abs": 0.000165382532440535,
            "Fossil_fraction": 4.7304908463359,
            "Land_fraction": 95.2695091536641,
            "Rank": 76,
            "Perc_contribution_rescale": 1.49041873669269
        },
        {
            "Country": "Malaysia",
            "Abs_contribution": 0.000172977573345133,
            "Perc_contribution": 0.21,
            "Fossil_abs": 4.55520359027358e-05,
            "Land_abs": 0.000127425537442397,
            "Fossil_fraction": 26.334070377926,
            "Land_fraction": 73.665929622074,
            "Rank": 77,
            "Perc_contribution_rescale": 1.49041873669269
        },
        {
            "Country": "Zimbabwe",
            "Abs_contribution": 0.000172946373520909,
            "Perc_contribution": 0.21,
            "Fossil_abs": 2.71203761851949e-05,
            "Land_abs": 0.000145825997335714,
            "Fossil_fraction": 15.6813789344453,
            "Land_fraction": 84.3186210655543,
            "Rank": 78,
            "Perc_contribution_rescale": 1.49041873669269
        },
        {
            "Country": "Burkina Faso",
            "Abs_contribution": 0.000169190574279938,
            "Perc_contribution": 0.2,
            "Fossil_abs": 1.19704754970565e-05,
            "Land_abs": 0.000157220098782881,
            "Fossil_fraction": 7.07514325074072,
            "Land_fraction": 92.9248567492588,
            "Rank": 79,
            "Perc_contribution_rescale": 1.4194464158978
        },
        {
            "Country": "Saudi Arabia",
            "Abs_contribution": 0.000168600005305172,
            "Perc_contribution": 0.2,
            "Fossil_abs": 0.000104231254184836,
            "Land_abs": 6.43687511203364e-05,
            "Fossil_fraction": 61.8216197539104,
            "Land_fraction": 38.1783802460899,
            "Rank": 80,
            "Perc_contribution_rescale": 1.4194464158978
        },
        {
            "Country": "Iraq",
            "Abs_contribution": 0.000167061182981924,
            "Perc_contribution": 0.2,
            "Fossil_abs": 5.61849497468266e-05,
            "Land_abs": 0.000110876233235098,
            "Fossil_fraction": 33.6313611240893,
            "Land_fraction": 66.3686388759108,
            "Rank": 81,
            "Perc_contribution_rescale": 1.4194464158978
        },
        {
            "Country": "Serbia",
            "Abs_contribution": 0.000158696485088517,
            "Perc_contribution": 0.19,
            "Fossil_abs": 3.85556278097985e-05,
            "Land_abs": 0.000120140857278718,
            "Fossil_fraction": 24.2951995995961,
            "Land_fraction": 75.7048004004038,
            "Rank": 82,
            "Perc_contribution_rescale": 1.34847409510291
        },
        {
            "Country": "Algeria",
            "Abs_contribution": 0.000151193462672982,
            "Perc_contribution": 0.18,
            "Fossil_abs": 4.65532045458283e-05,
            "Land_abs": 0.000104640258127154,
            "Fossil_fraction": 30.7904877121036,
            "Land_fraction": 69.2095122878965,
            "Rank": 83,
            "Perc_contribution_rescale": 1.27750177430802
        },
        {
            "Country": "North Korea",
            "Abs_contribution": 0.00015008156146772,
            "Perc_contribution": 0.18,
            "Fossil_abs": 6.51271298880987e-05,
            "Land_abs": 8.49544315796214e-05,
            "Fossil_fraction": 43.3944911361456,
            "Land_fraction": 56.6055088638544,
            "Rank": 84,
            "Perc_contribution_rescale": 1.27750177430802
        },
        {
            "Country": "Cameroon",
            "Abs_contribution": 0.000148132087102727,
            "Perc_contribution": 0.18,
            "Fossil_abs": 1.46073470106701e-05,
            "Land_abs": 0.000133524740092057,
            "Fossil_fraction": 9.86102828655901,
            "Land_fraction": 90.138971713441,
            "Rank": 85,
            "Perc_contribution_rescale": 1.27750177430802
        },
        {
            "Country": "Portugal",
            "Abs_contribution": 0.000142534913281951,
            "Perc_contribution": 0.17,
            "Fossil_abs": 5.14461758210236e-05,
            "Land_abs": 9.10887374609275e-05,
            "Fossil_fraction": 36.0937363600572,
            "Land_fraction": 63.9062636399428,
            "Rank": 86,
            "Perc_contribution_rescale": 1.20652945351313
        },
        {
            "Country": "Afghanistan",
            "Abs_contribution": 0.000136003710595892,
            "Perc_contribution": 0.16,
            "Fossil_abs": 6.15671207324754e-06,
            "Land_abs": 0.000129846998522644,
            "Fossil_fraction": 4.52687066130201,
            "Land_fraction": 95.4731293386973,
            "Rank": 87,
            "Perc_contribution_rescale": 1.13555713271824
        },
        {
            "Country": "Senegal",
            "Abs_contribution": 0.00013575796478185,
            "Perc_contribution": 0.16,
            "Fossil_abs": 6.87456931719964e-06,
            "Land_abs": 0.00012888339546465,
            "Fossil_fraction": 5.06384235226746,
            "Land_fraction": 94.9361576477326,
            "Rank": 88,
            "Perc_contribution_rescale": 1.13555713271824
        },
        {
            "Country": "Botswana",
            "Abs_contribution": 0.000133226818503299,
            "Perc_contribution": 0.16,
            "Fossil_abs": 2.84779746889192e-06,
            "Land_abs": 0.000130379021034407,
            "Fossil_fraction": 2.13755571204412,
            "Land_fraction": 97.8624442879562,
            "Rank": 89,
            "Perc_contribution_rescale": 1.13555713271824
        },
        {
            "Country": "Namibia",
            "Abs_contribution": 0.000129471055347504,
            "Perc_contribution": 0.16,
            "Fossil_abs": 2.89116084708325e-06,
            "Land_abs": 0.000126579894500421,
            "Fossil_fraction": 2.23305575081881,
            "Land_fraction": 97.7669442491809,
            "Rank": 90,
            "Perc_contribution_rescale": 1.13555713271824
        },
        {
            "Country": "Turkmenistan",
            "Abs_contribution": 0.000128138018280379,
            "Perc_contribution": 0.16,
            "Fossil_abs": 3.4048218958848e-05,
            "Land_abs": 9.40897993215311e-05,
            "Fossil_fraction": 26.5715198469411,
            "Land_fraction": 73.4284801530587,
            "Rank": 91,
            "Perc_contribution_rescale": 1.13555713271824
        },
        {
            "Country": "Guinea",
            "Abs_contribution": 0.000123759732722991,
            "Perc_contribution": 0.15,
            "Fossil_abs": 1.07674368148235e-05,
            "Land_abs": 0.000112992295908167,
            "Fossil_fraction": 8.70027478075122,
            "Land_fraction": 91.2997252192482,
            "Rank": 92,
            "Perc_contribution_rescale": 1.06458481192335
        },
        {
            "Country": "Ghana",
            "Abs_contribution": 0.000121873540362263,
            "Perc_contribution": 0.15,
            "Fossil_abs": 1.50151215817495e-05,
            "Land_abs": 0.000106858418780514,
            "Fossil_fraction": 12.3202473130081,
            "Land_fraction": 87.6797526869918,
            "Rank": 93,
            "Perc_contribution_rescale": 1.06458481192335
        },
        {
            "Country": "Taiwan",
            "Abs_contribution": 0.000119445556747575,
            "Perc_contribution": 0.14,
            "Fossil_abs": 7.90367491702954e-05,
            "Land_abs": 4.04088075772795e-05,
            "Fossil_fraction": 66.1696854386338,
            "Land_fraction": 33.8303145613659,
            "Rank": 94,
            "Perc_contribution_rescale": 0.99361249112846
        },
        {
            "Country": "Syria",
            "Abs_contribution": 0.000116701821588563,
            "Perc_contribution": 0.14,
            "Fossil_abs": 3.68364932713617e-05,
            "Land_abs": 7.98653283172013e-05,
            "Fossil_fraction": 31.5646257872736,
            "Land_fraction": 68.4353742127261,
            "Rank": 95,
            "Perc_contribution_rescale": 0.99361249112846
        },
        {
            "Country": "Slovakia",
            "Abs_contribution": 0.00011474086811264,
            "Perc_contribution": 0.14,
            "Fossil_abs": 5.62705090054093e-05,
            "Land_abs": 5.8470359107231e-05,
            "Fossil_fraction": 49.0413833632224,
            "Land_fraction": 50.9586166367776,
            "Rank": 96,
            "Perc_contribution_rescale": 0.99361249112846
        },
        {
            "Country": "Ecuador",
            "Abs_contribution": 0.000113365765941922,
            "Perc_contribution": 0.14,
            "Fossil_abs": 1.63023385256036e-05,
            "Land_abs": 9.70634274163184e-05,
            "Fossil_fraction": 14.3803011342554,
            "Land_fraction": 85.6196988657444,
            "Rank": 97,
            "Perc_contribution_rescale": 0.99361249112846
        },
        {
            "Country": "Latvia",
            "Abs_contribution": 0.000112324375829058,
            "Perc_contribution": 0.14,
            "Fossil_abs": 1.44264505701911e-05,
            "Land_abs": 9.78979252588674e-05,
            "Fossil_fraction": 12.8435617502528,
            "Land_fraction": 87.1564382497474,
            "Rank": 98,
            "Perc_contribution_rescale": 0.99361249112846
        },
        {
            "Country": "Switzerland",
            "Abs_contribution": 0.000109374688077404,
            "Perc_contribution": 0.13,
            "Fossil_abs": 3.66325415434417e-05,
            "Land_abs": 7.27421465339619e-05,
            "Fossil_fraction": 33.4927049277773,
            "Land_fraction": 66.5072950722225,
            "Rank": 99,
            "Perc_contribution_rescale": 0.92264017033357
        },
        {
            "Country": "Croatia",
            "Abs_contribution": 0.000103102520701175,
            "Perc_contribution": 0.12,
            "Fossil_abs": 4.11897762892337e-05,
            "Land_abs": 6.19127444119409e-05,
            "Fossil_fraction": 39.9503096617932,
            "Land_fraction": 60.0496903382068,
            "Rank": 100,
            "Perc_contribution_rescale": 0.85166784953868
        },
        {
            "Country": "Yemen",
            "Abs_contribution": 0.000101150034000982,
            "Perc_contribution": 0.12,
            "Fossil_abs": 2.74654478076964e-05,
            "Land_abs": 7.36845861932858e-05,
            "Fossil_fraction": 27.1531770393964,
            "Land_fraction": 72.8468229606033,
            "Rank": 101,
            "Perc_contribution_rescale": 0.85166784953868
        },
        {
            "Country": "Cambodia",
            "Abs_contribution": 0.00010023918749946,
            "Perc_contribution": 0.12,
            "Fossil_abs": 9.25848633166334e-06,
            "Land_abs": 9.09807011677975e-05,
            "Fossil_fraction": 9.23639403173851,
            "Land_fraction": 90.7636059682619,
            "Rank": 102,
            "Perc_contribution_rescale": 0.85166784953868
        },
        {
            "Country": "Azerbaijan",
            "Abs_contribution": 9.86810385747048e-05,
            "Perc_contribution": 0.12,
            "Fossil_abs": 2.37132915429891e-05,
            "Land_abs": 7.49677470317157e-05,
            "Fossil_fraction": 24.0302411542187,
            "Land_fraction": 75.9697588457813,
            "Rank": 103,
            "Perc_contribution_rescale": 0.85166784953868
        },
        {
            "Country": "Sri Lanka",
            "Abs_contribution": 9.14783035951719e-05,
            "Perc_contribution": 0.11,
            "Fossil_abs": 2.24530820528752e-05,
            "Land_abs": 6.90252215422967e-05,
            "Fossil_fraction": 24.5447075103612,
            "Land_fraction": 75.4552924896388,
            "Rank": 104,
            "Perc_contribution_rescale": 0.78069552874379
        },
        {
            "Country": "Singapore",
            "Abs_contribution": 9.05480139228375e-05,
            "Perc_contribution": 0.11,
            "Fossil_abs": 8.84607605328662e-05,
            "Land_abs": 2.0872533899712e-06,
            "Fossil_fraction": 97.6948656303495,
            "Land_fraction": 2.30513436965045,
            "Rank": 105,
            "Perc_contribution_rescale": 0.78069552874379
        },
        {
            "Country": "Estonia",
            "Abs_contribution": 8.83200834546325e-05,
            "Perc_contribution": 0.11,
            "Fossil_abs": 7.45188597428385e-06,
            "Land_abs": 8.08681974803487e-05,
            "Fossil_fraction": 8.4373629222301,
            "Land_fraction": 91.5626370777699,
            "Rank": 106,
            "Perc_contribution_rescale": 0.78069552874379
        },
        {
            "Country": "Mauritania",
            "Abs_contribution": 8.66919563503169e-05,
            "Perc_contribution": 0.1,
            "Fossil_abs": 2.83072883160753e-06,
            "Land_abs": 8.38612275187094e-05,
            "Fossil_fraction": 3.2652727551432,
            "Land_fraction": 96.7347272448568,
            "Rank": 107,
            "Perc_contribution_rescale": 0.7097232079489
        },
        {
            "Country": "Tunisia",
            "Abs_contribution": 8.58609710058537e-05,
            "Perc_contribution": 0.1,
            "Fossil_abs": 2.79858543941778e-05,
            "Land_abs": 5.78751166116759e-05,
            "Fossil_fraction": 32.5943837652032,
            "Land_fraction": 67.4056162347967,
            "Rank": 108,
            "Perc_contribution_rescale": 0.7097232079489
        },
        {
            "Country": "C\xf4te d'Ivoire",
            "Abs_contribution": 8.56396862877232e-05,
            "Perc_contribution": 0.1,
            "Fossil_abs": 1.25763216470814e-05,
            "Land_abs": 7.30633646406419e-05,
            "Fossil_fraction": 14.6851561375748,
            "Land_fraction": 85.3148438624252,
            "Rank": 109,
            "Perc_contribution_rescale": 0.7097232079489
        },
        {
            "Country": "Guatemala",
            "Abs_contribution": 8.26070613316912e-05,
            "Perc_contribution": 0.1,
            "Fossil_abs": 1.74231452276842e-05,
            "Land_abs": 6.5183916104007e-05,
            "Fossil_fraction": 21.0915930754699,
            "Land_fraction": 78.9084069245301,
            "Rank": 110,
            "Perc_contribution_rescale": 0.7097232079489
        },
        {
            "Country": "Georgia",
            "Abs_contribution": 7.33860416262773e-05,
            "Perc_contribution": 0.09,
            "Fossil_abs": 3.3605814912976e-05,
            "Land_abs": 3.97802267133014e-05,
            "Fossil_fraction": 45.7931974095503,
            "Land_fraction": 54.2068025904497,
            "Rank": 111,
            "Perc_contribution_rescale": 0.63875088715401
        },
        {
            "Country": "Dominican Republic",
            "Abs_contribution": 6.88260337866083e-05,
            "Perc_contribution": 0.08,
            "Fossil_abs": 1.57521544138474e-05,
            "Land_abs": 5.30738793727609e-05,
            "Fossil_fraction": 22.8869129124688,
            "Land_fraction": 77.1130870875312,
            "Rank": 112,
            "Perc_contribution_rescale": 0.56777856635912
        },
        {
            "Country": "Nicaragua",
            "Abs_contribution": 6.43104896381409e-05,
            "Perc_contribution": 0.08,
            "Fossil_abs": 6.32340305085299e-06,
            "Land_abs": 5.79870865872879e-05,
            "Fossil_fraction": 9.83261531117738,
            "Land_fraction": 90.1673846888226,
            "Rank": 113,
            "Perc_contribution_rescale": 0.56777856635912
        },
        {
            "Country": "Kyrgyzstan",
            "Abs_contribution": 6.36027724609843e-05,
            "Perc_contribution": 0.08,
            "Fossil_abs": 8.78815354734457e-06,
            "Land_abs": 5.48146189136398e-05,
            "Fossil_fraction": 13.8172491658842,
            "Land_fraction": 86.1827508341159,
            "Rank": 114,
            "Perc_contribution_rescale": 0.56777856635912
        },
        {
            "Country": "Honduras",
            "Abs_contribution": 5.88387957458065e-05,
            "Perc_contribution": 0.07,
            "Fossil_abs": 9.10824856722622e-06,
            "Land_abs": 4.97305471785803e-05,
            "Fossil_fraction": 15.4800050745011,
            "Land_fraction": 84.5199949254988,
            "Rank": 115,
            "Perc_contribution_rescale": 0.49680624556423
        },
        {
            "Country": "Israel",
            "Abs_contribution": 5.82074840418578e-05,
            "Perc_contribution": 0.07,
            "Fossil_abs": 3.25427813330024e-05,
            "Land_abs": 2.56647027088554e-05,
            "Fossil_fraction": 55.9082425029752,
            "Land_fraction": 44.0917574970248,
            "Rank": 116,
            "Perc_contribution_rescale": 0.49680624556423
        },
        {
            "Country": "Malawi",
            "Abs_contribution": 5.81869239671152e-05,
            "Perc_contribution": 0.07,
            "Fossil_abs": 9.56431942776354e-06,
            "Land_abs": 4.86226045393516e-05,
            "Fossil_fraction": 16.4372315559573,
            "Land_fraction": 83.5627684440427,
            "Rank": 117,
            "Perc_contribution_rescale": 0.49680624556423
        },
        {
            "Country": "Moldova",
            "Abs_contribution": 5.58277862108396e-05,
            "Perc_contribution": 0.07,
            "Fossil_abs": 1.03188874163101e-05,
            "Land_abs": 4.55088987945295e-05,
            "Fossil_fraction": 18.483425757453,
            "Land_fraction": 81.516574242547,
            "Rank": 118,
            "Perc_contribution_rescale": 0.49680624556423
        },
        {
            "Country": "Tajikistan",
            "Abs_contribution": 5.44986336688735e-05,
            "Perc_contribution": 0.07,
            "Fossil_abs": 6.19142939685467e-06,
            "Land_abs": 4.83072042720188e-05,
            "Fossil_fraction": 11.3607057279142,
            "Land_fraction": 88.6392942720857,
            "Rank": 119,
            "Perc_contribution_rescale": 0.49680624556423
        },
        {
            "Country": "Benin",
            "Abs_contribution": 5.44281493662019e-05,
            "Perc_contribution": 0.07,
            "Fossil_abs": 6.20515670324222e-06,
            "Land_abs": 4.82229926629598e-05,
            "Fossil_fraction": 11.4006387788291,
            "Land_fraction": 88.5993612211711,
            "Rank": 120,
            "Perc_contribution_rescale": 0.49680624556423
        },
        {
            "Country": "Trinidad and Tobago",
            "Abs_contribution": 5.11585249434539e-05,
            "Perc_contribution": 0.06,
            "Fossil_abs": 4.72620321324802e-05,
            "Land_abs": 3.89649281097359e-06,
            "Fossil_fraction": 92.3834926529243,
            "Land_fraction": 7.61650734707544,
            "Rank": 121,
            "Perc_contribution_rescale": 0.42583392476934
        },
        {
            "Country": "Laos",
            "Abs_contribution": 5.06350023309862e-05,
            "Perc_contribution": 0.06,
            "Fossil_abs": 4.38721881958075e-06,
            "Land_abs": 4.62477835114054e-05,
            "Fossil_fraction": 8.66439936331549,
            "Land_fraction": 91.3356006366844,
            "Rank": 122,
            "Perc_contribution_rescale": 0.42583392476934
        },
        {
            "Country": "Eritrea",
            "Abs_contribution": 4.90857627958023e-05,
            "Perc_contribution": 0.06,
            "Fossil_abs": 2.95040809300137e-06,
            "Land_abs": 4.61353547028009e-05,
            "Fossil_fraction": 6.01072067531092,
            "Land_fraction": 93.989279324689,
            "Rank": 123,
            "Perc_contribution_rescale": 0.42583392476934
        },
        {
            "Country": "Papua New Guinea",
            "Abs_contribution": 4.88039552198069e-05,
            "Perc_contribution": 0.06,
            "Fossil_abs": 3.68004347955786e-06,
            "Land_abs": 4.5123911740249e-05,
            "Fossil_fraction": 7.54046155272335,
            "Land_fraction": 92.4595384472766,
            "Rank": 124,
            "Perc_contribution_rescale": 0.42583392476934
        },
        {
            "Country": "Congo",
            "Abs_contribution": 4.51927696848357e-05,
            "Perc_contribution": 0.05,
            "Fossil_abs": 3.28629194807669e-06,
            "Land_abs": 4.1906477736759e-05,
            "Fossil_fraction": 7.27172061149286,
            "Land_fraction": 92.7282793885071,
            "Rank": 125,
            "Perc_contribution_rescale": 0.35486160397445
        },
        {
            "Country": "Haiti",
            "Abs_contribution": 4.47359085285831e-05,
            "Perc_contribution": 0.05,
            "Fossil_abs": 8.99092660153461e-06,
            "Land_abs": 3.57449819270485e-05,
            "Fossil_fraction": 20.0977847488892,
            "Land_fraction": 79.9022152511108,
            "Rank": 126,
            "Perc_contribution_rescale": 0.35486160397445
        },
        {
            "Country": "Costa Rica",
            "Abs_contribution": 4.46836975920898e-05,
            "Perc_contribution": 0.05,
            "Fossil_abs": 6.98131508595537e-06,
            "Land_abs": 3.77023825061344e-05,
            "Fossil_fraction": 15.6238526849023,
            "Land_fraction": 84.3761473150976,
            "Rank": 127,
            "Perc_contribution_rescale": 0.35486160397445
        },
        {
            "Country": "Libya",
            "Abs_contribution": 4.27722640306752e-05,
            "Perc_contribution": 0.05,
            "Fossil_abs": 1.37931277326365e-05,
            "Land_abs": 2.89791362980388e-05,
            "Fossil_fraction": 32.2478317321345,
            "Land_fraction": 67.7521682678655,
            "Rank": 128,
            "Perc_contribution_rescale": 0.35486160397445
        },
        {
            "Country": "El Salvador",
            "Abs_contribution": 4.0687803569896e-05,
            "Perc_contribution": 0.05,
            "Fossil_abs": 7.89226532719351e-06,
            "Land_abs": 3.27955382427025e-05,
            "Fossil_fraction": 19.3971279713728,
            "Land_fraction": 80.6028720286272,
            "Rank": 129,
            "Perc_contribution_rescale": 0.35486160397445
        },
        {
            "Country": "Slovenia",
            "Abs_contribution": 3.82799509738661e-05,
            "Perc_contribution": 0.05,
            "Fossil_abs": 8.92260237086013e-06,
            "Land_abs": 2.9357348603006e-05,
            "Fossil_fraction": 23.3088134751051,
            "Land_fraction": 76.6911865248949,
            "Rank": 130,
            "Perc_contribution_rescale": 0.35486160397445
        },
        {
            "Country": "Albania",
            "Abs_contribution": 3.78317211563503e-05,
            "Perc_contribution": 0.05,
            "Fossil_abs": 5.00527987917654e-06,
            "Land_abs": 3.28264412771737e-05,
            "Fossil_fraction": 13.2303784395397,
            "Land_fraction": 86.7696215604601,
            "Rank": 131,
            "Perc_contribution_rescale": 0.35486160397445
        },
        {
            "Country": "Bosnia and Herzegovina",
            "Abs_contribution": 3.7065023415043e-05,
            "Perc_contribution": 0.04,
            "Fossil_abs": 7.32910620431619e-06,
            "Land_abs": 2.97359172107268e-05,
            "Fossil_fraction": 19.7736451485463,
            "Land_fraction": 80.2263548514538,
            "Rank": 132,
            "Perc_contribution_rescale": 0.28388928317956
        },
        {
            "Country": "Rwanda",
            "Abs_contribution": 3.60359585485189e-05,
            "Perc_contribution": 0.04,
            "Fossil_abs": 8.75118534106957e-06,
            "Land_abs": 2.72847732074494e-05,
            "Fossil_fraction": 24.2845915401056,
            "Land_fraction": 75.7154084598946,
            "Rank": 133,
            "Perc_contribution_rescale": 0.28388928317956
        },
        {
            "Country": "United Arab Emirates",
            "Abs_contribution": 3.40803057016639e-05,
            "Perc_contribution": 0.04,
            "Fossil_abs": 2.45792025413077e-05,
            "Land_abs": 9.50110316035612e-06,
            "Fossil_fraction": 72.1214262467947,
            "Land_fraction": 27.8785737532051,
            "Rank": 134,
            "Perc_contribution_rescale": 0.28388928317956
        },
        {
            "Country": "Togo",
            "Abs_contribution": 3.34594538986404e-05,
            "Perc_contribution": 0.04,
            "Fossil_abs": 4.0733291043587e-06,
            "Land_abs": 2.93861247942817e-05,
            "Fossil_fraction": 12.1739258408046,
            "Land_fraction": 87.8260741591953,
            "Rank": 135,
            "Perc_contribution_rescale": 0.28388928317956
        },
        {
            "Country": "Panama",
            "Abs_contribution": 3.33220312336073e-05,
            "Perc_contribution": 0.04,
            "Fossil_abs": 4.750073415246e-06,
            "Land_abs": 2.85719578183614e-05,
            "Fossil_fraction": 14.2550536068619,
            "Land_fraction": 85.7449463931382,
            "Rank": 136,
            "Perc_contribution_rescale": 0.28388928317956
        },
        {
            "Country": "Burundi",
            "Abs_contribution": 3.1288087448112e-05,
            "Perc_contribution": 0.04,
            "Fossil_abs": 6.8900825898517e-06,
            "Land_abs": 2.43980048582603e-05,
            "Fossil_fraction": 22.0214246117733,
            "Land_fraction": 77.9785753882265,
            "Rank": 137,
            "Perc_contribution_rescale": 0.28388928317956
        },
        {
            "Country": "Sierra Leone",
            "Abs_contribution": 3.05270575873637e-05,
            "Perc_contribution": 0.04,
            "Fossil_abs": 6.35013778109136e-06,
            "Land_abs": 2.41769198062723e-05,
            "Fossil_fraction": 20.8016700034658,
            "Land_fraction": 79.1983299965341,
            "Rank": 138,
            "Perc_contribution_rescale": 0.28388928317956
        },
        {
            "Country": "North Macedonia",
            "Abs_contribution": 2.98214710267819e-05,
            "Perc_contribution": 0.04,
            "Fossil_abs": 4.15616711335153e-06,
            "Land_abs": 2.56653039134304e-05,
            "Fossil_fraction": 13.9368279640497,
            "Land_fraction": 86.0631720359502,
            "Rank": 139,
            "Perc_contribution_rescale": 0.28388928317956
        },
        {
            "Country": "Armenia",
            "Abs_contribution": 2.8995824782324e-05,
            "Perc_contribution": 0.04,
            "Fossil_abs": 6.98823227545128e-06,
            "Land_abs": 2.20075925068727e-05,
            "Fossil_fraction": 24.1008225422556,
            "Land_fraction": 75.8991774577443,
            "Rank": 140,
            "Perc_contribution_rescale": 0.28388928317956
        },
        {
            "Country": "Jordan",
            "Abs_contribution": 2.81249372696459e-05,
            "Perc_contribution": 0.03,
            "Fossil_abs": 1.5938774252848e-05,
            "Land_abs": 1.21861630167979e-05,
            "Fossil_fraction": 56.6713237438934,
            "Land_fraction": 43.3286762561066,
            "Rank": 141,
            "Perc_contribution_rescale": 0.21291696238467
        },
        {
            "Country": "Lesotho",
            "Abs_contribution": 2.44938456881295e-05,
            "Perc_contribution": 0.03,
            "Fossil_abs": 4.30079498848727e-06,
            "Land_abs": 2.01930506996422e-05,
            "Fossil_fraction": 17.558675935366,
            "Land_fraction": 82.441324064634,
            "Rank": 142,
            "Perc_contribution_rescale": 0.21291696238467
        },
        {
            "Country": "Lebanon",
            "Abs_contribution": 2.32758056673336e-05,
            "Perc_contribution": 0.03,
            "Fossil_abs": 1.17638758900326e-05,
            "Land_abs": 1.1511929777301e-05,
            "Fossil_fraction": 50.541218886969,
            "Land_fraction": 49.458781113031,
            "Rank": 143,
            "Perc_contribution_rescale": 0.21291696238467
        },
        {
            "Country": "Guinea-Bissau",
            "Abs_contribution": 2.04475357918709e-05,
            "Perc_contribution": 0.02,
            "Fossil_abs": 1.73958312741915e-06,
            "Land_abs": 1.87079526644518e-05,
            "Fossil_fraction": 8.50754411253181,
            "Land_fraction": 91.4924558874682,
            "Rank": 144,
            "Perc_contribution_rescale": 0.14194464158978
        },
        {
            "Country": "Oman",
            "Abs_contribution": 1.71774025182312e-05,
            "Perc_contribution": 0.02,
            "Fossil_abs": 8.76195664752159e-06,
            "Land_abs": 8.41544587070961e-06,
            "Fossil_fraction": 51.008623907032,
            "Land_fraction": 48.991376092968,
            "Rank": 145,
            "Perc_contribution_rescale": 0.14194464158978
        },
        {
            "Country": "Kuwait",
            "Abs_contribution": 1.69201455452915e-05,
            "Perc_contribution": 0.02,
            "Fossil_abs": 1.28311242102494e-05,
            "Land_abs": 4.0890213350422e-06,
            "Fossil_fraction": 75.8334151198834,
            "Land_fraction": 24.166584880117,
            "Rank": 146,
            "Perc_contribution_rescale": 0.14194464158978
        },
        {
            "Country": "Swaziland",
            "Abs_contribution": 1.68415098272545e-05,
            "Perc_contribution": 0.02,
            "Fossil_abs": 2.19497056851125e-06,
            "Land_abs": 1.46465392587433e-05,
            "Fossil_fraction": 13.0330985227888,
            "Land_fraction": 86.9669014772113,
            "Rank": 147,
            "Perc_contribution_rescale": 0.14194464158978
        },
        {
            "Country": "Jamaica",
            "Abs_contribution": 1.64639618711254e-05,
            "Perc_contribution": 0.02,
            "Fossil_abs": 6.49096089231382e-06,
            "Land_abs": 9.9730009788115e-06,
            "Fossil_fraction": 39.4252667925436,
            "Land_fraction": 60.5747332074562,
            "Rank": 148,
            "Perc_contribution_rescale": 0.14194464158978
        },
        {
            "Country": "Iceland",
            "Abs_contribution": 1.61522499798594e-05,
            "Perc_contribution": 0.02,
            "Fossil_abs": 2.61171231080859e-06,
            "Land_abs": 1.35405376690508e-05,
            "Fossil_fraction": 16.1693405814372,
            "Land_fraction": 83.8306594185628,
            "Rank": 149,
            "Perc_contribution_rescale": 0.14194464158978
        },
        {
            "Country": "Hong Kong",
            "Abs_contribution": 1.57817494036031e-05,
            "Perc_contribution": 0.02,
            "Fossil_abs": 1.4510034176367e-05,
            "Land_abs": 1.27171522723606e-06,
            "Fossil_fraction": 91.94186148371,
            "Land_fraction": 8.05813851628971,
            "Rank": 150,
            "Perc_contribution_rescale": 0.14194464158978
        },
        {
            "Country": "Luxembourg",
            "Abs_contribution": 1.39354425414899e-05,
            "Perc_contribution": 0.02,
            "Fossil_abs": 6.42588460321122e-06,
            "Land_abs": 7.50955793827868e-06,
            "Fossil_fraction": 46.1118086783356,
            "Land_fraction": 53.8881913216643,
            "Rank": 151,
            "Perc_contribution_rescale": 0.14194464158978
        },
        {
            "Country": "Guyana",
            "Abs_contribution": 1.37915683595647e-05,
            "Perc_contribution": 0.02,
            "Fossil_abs": 2.13728079883277e-06,
            "Land_abs": 1.16542875607319e-05,
            "Fossil_fraction": 15.4970105147652,
            "Land_fraction": 84.5029894852346,
            "Rank": 152,
            "Perc_contribution_rescale": 0.14194464158978
        },
        {
            "Country": "Cyprus",
            "Abs_contribution": 1.09278862441248e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 3.30072081902882e-06,
            "Land_abs": 7.62716542509592e-06,
            "Fossil_fraction": 30.2045678852432,
            "Land_fraction": 69.7954321147566,
            "Rank": 153,
            "Perc_contribution_rescale": 0.07097232079489
        },
        {
            "Country": "Liberia",
            "Abs_contribution": 1.09174233656069e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 3.96026864437352e-06,
            "Land_abs": 6.95715472123342e-06,
            "Fossil_fraction": 36.2747556062499,
            "Land_fraction": 63.7252443937505,
            "Rank": 154,
            "Perc_contribution_rescale": 0.07097232079489
        },
        {
            "Country": "Gabon",
            "Abs_contribution": 1.08020457625457e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 4.88229772881014e-06,
            "Land_abs": 5.91974803373556e-06,
            "Fossil_fraction": 45.1978989548321,
            "Land_fraction": 54.8021010451678,
            "Rank": 155,
            "Perc_contribution_rescale": 0.07097232079489
        },
        {
            "Country": "Fiji",
            "Abs_contribution": 1.0396007833087e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 1.7605693925279e-06,
            "Land_abs": 8.63543844055906e-06,
            "Fossil_fraction": 16.9350525778232,
            "Land_fraction": 83.0649474221764,
            "Rank": 156,
            "Perc_contribution_rescale": 0.07097232079489
        },
        {
            "Country": "Qatar",
            "Abs_contribution": 9.89282542843027e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 8.10881100541384e-06,
            "Land_abs": 1.78401442301643e-06,
            "Fossil_fraction": 81.9665834000317,
            "Land_fraction": 18.0334165999683,
            "Rank": 157,
            "Perc_contribution_rescale": 0.07097232079489
        },
        {
            "Country": "Gambia",
            "Abs_contribution": 9.57326097410543e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 8.77045161965134e-07,
            "Land_abs": 8.6962158121403e-06,
            "Fossil_fraction": 9.16140450299474,
            "Land_fraction": 90.8385954970053,
            "Rank": 158,
            "Perc_contribution_rescale": 0.07097232079489
        },
        {
            "Country": "Montenegro",
            "Abs_contribution": 8.05527412733712e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 3.08502150361973e-06,
            "Land_abs": 4.97025262371739e-06,
            "Fossil_fraction": 38.2981566468373,
            "Land_fraction": 61.7018433531626,
            "Rank": 159,
            "Perc_contribution_rescale": 0.07097232079489
        },
        {
            "Country": "Mauritius",
            "Abs_contribution": 7.12905440242083e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 2.9671799609417e-06,
            "Land_abs": 4.16187444147912e-06,
            "Fossil_fraction": 41.6209470913019,
            "Land_fraction": 58.379052908698,
            "Rank": 160,
            "Perc_contribution_rescale": 0.07097232079489
        },
        {
            "Country": "Timor-Leste",
            "Abs_contribution": 6.36359407578546e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 4.71332945844678e-07,
            "Land_abs": 5.89226112994078e-06,
            "Fossil_fraction": 7.40670979687687,
            "Land_fraction": 92.5932902031231,
            "Rank": 161,
            "Perc_contribution_rescale": 0.07097232079489
        },
        {
            "Country": "Djibouti",
            "Abs_contribution": 6.23989641559127e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 8.5841540144349e-07,
            "Land_abs": 5.38148101414778e-06,
            "Fossil_fraction": 13.7568854396143,
            "Land_fraction": 86.2431145603857,
            "Rank": 162,
            "Perc_contribution_rescale": 0.07097232079489
        },
        {
            "Country": "Bhutan",
            "Abs_contribution": 5.52214273641326e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 1.62987899583243e-06,
            "Land_abs": 3.89226374058083e-06,
            "Fossil_fraction": 29.5153362314403,
            "Land_fraction": 70.4846637685597,
            "Rank": 163,
            "Perc_contribution_rescale": 0.07097232079489
        },
        {
            "Country": "Suriname",
            "Abs_contribution": 4.97301746368829e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 1.48470856693685e-06,
            "Land_abs": 3.48830889675144e-06,
            "Fossil_fraction": 29.85528560432,
            "Land_fraction": 70.14471439568,
            "Rank": 164,
            "Perc_contribution_rescale": 0.07097232079489
        },
        {
            "Country": "Bahrain",
            "Abs_contribution": 3.29518428687456e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 2.88284839021341e-06,
            "Land_abs": 4.12335896661143e-07,
            "Fossil_fraction": 87.4867120997278,
            "Land_fraction": 12.5132879002722,
            "Rank": 165,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Vanuatu",
            "Abs_contribution": 2.98453450230799e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.8586439132178e-07,
            "Land_abs": 2.7986701109862e-06,
            "Fossil_fraction": 6.2275839390715,
            "Land_fraction": 93.7724160609283,
            "Rank": 166,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Belize",
            "Abs_contribution": 2.88390512530754e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 5.62459703949703e-07,
            "Land_abs": 2.32144542135784e-06,
            "Fossil_fraction": 19.5034052616319,
            "Land_fraction": 80.4965947383682,
            "Rank": 167,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Brunei Darussalam",
            "Abs_contribution": 2.39963331927779e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 9.17889219224324e-07,
            "Land_abs": 1.48174410005347e-06,
            "Fossil_fraction": 38.2512282960206,
            "Land_fraction": 61.7487717039794,
            "Rank": 168,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Barbados",
            "Abs_contribution": 2.27549630344335e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 9.40908097212052e-07,
            "Land_abs": 1.33458820623131e-06,
            "Fossil_fraction": 41.3495770477957,
            "Land_fraction": 58.6504229522045,
            "Rank": 169,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Bahamas",
            "Abs_contribution": 2.18022416399452e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.62433890859251e-06,
            "Land_abs": 5.55885255402005e-07,
            "Fossil_fraction": 74.5032981203393,
            "Land_fraction": 25.4967018796606,
            "Rank": 170,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Comoros",
            "Abs_contribution": 1.86064173790719e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 2.87762315432841e-07,
            "Land_abs": 1.57287942247435e-06,
            "Fossil_fraction": 15.4657562264786,
            "Land_fraction": 84.5342437735213,
            "Rank": 171,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Cape Verde",
            "Abs_contribution": 1.84152849518876e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 4.69267340675048e-07,
            "Land_abs": 1.37226115451371e-06,
            "Fossil_fraction": 25.48249141412,
            "Land_fraction": 74.51750858588,
            "Rank": 172,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Palau",
            "Abs_contribution": 1.78865502465213e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.78654746379756e-06,
            "Land_abs": 2.10756085456674e-09,
            "Fossil_fraction": 99.882170635169,
            "Land_fraction": 0.117829364831077,
            "Rank": 173,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Malta",
            "Abs_contribution": 1.77260628792245e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 8.86007103807699e-07,
            "Land_abs": 8.86599184114749e-07,
            "Fossil_fraction": 49.9832991592356,
            "Land_fraction": 50.0167008407643,
            "Rank": 174,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Samoa",
            "Abs_contribution": 1.33963379193476e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 2.1935666417512e-07,
            "Land_abs": 1.12027712775964e-06,
            "Fossil_fraction": 16.3743752580559,
            "Land_fraction": 83.6256247419441,
            "Rank": 175,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Tonga",
            "Abs_contribution": 1.33608374206758e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 8.56671743756704e-07,
            "Land_abs": 4.79411998310879e-07,
            "Fossil_fraction": 64.1181175089376,
            "Land_fraction": 35.8818824910624,
            "Rank": 176,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Andorra",
            "Abs_contribution": 1.33144463447766e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 5.48499369597765e-07,
            "Land_abs": 7.8294526487989e-07,
            "Fossil_fraction": 41.1958075758026,
            "Land_fraction": 58.8041924241971,
            "Rank": 177,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Equatorial Guinea",
            "Abs_contribution": 9.69689423998874e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 5.90787005363413e-07,
            "Land_abs": 3.78902418635461e-07,
            "Fossil_fraction": 60.9253840190485,
            "Land_fraction": 39.0746159809515,
            "Rank": 178,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Antigua and Barbuda",
            "Abs_contribution": 7.77046216220837e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 4.57726704103064e-07,
            "Land_abs": 3.19319512117775e-07,
            "Fossil_fraction": 58.9059819799672,
            "Land_fraction": 41.0940180200329,
            "Rank": 179,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Solomon Islands",
            "Abs_contribution": 7.56955855001962e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 3.13664754209849e-07,
            "Land_abs": 4.43291100792114e-07,
            "Fossil_fraction": 41.4376548034014,
            "Land_fraction": 58.5623451965987,
            "Rank": 180,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Lucia",
            "Abs_contribution": 7.11280973973439e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 2.31792152922297e-07,
            "Land_abs": 4.79488821051142e-07,
            "Fossil_fraction": 32.5879872235909,
            "Land_fraction": 67.4120127764091,
            "Rank": 181,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Macao",
            "Abs_contribution": 5.2851751614097e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 4.65029236811195e-07,
            "Land_abs": 6.34882793297755e-08,
            "Fossil_fraction": 87.9874786755713,
            "Land_fraction": 12.0125213244288,
            "Rank": 182,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Vincent and the Grenadines",
            "Abs_contribution": 5.19715138809953e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 1.46241196456295e-07,
            "Land_abs": 3.73473942353658e-07,
            "Fossil_fraction": 28.1387216834128,
            "Land_fraction": 71.8612783165872,
            "Rank": 183,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Maldives",
            "Abs_contribution": 4.77033701325267e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 4.66825639200636e-07,
            "Land_abs": 1.02080621246316e-08,
            "Fossil_fraction": 97.8600962371691,
            "Land_fraction": 2.13990376283105,
            "Rank": 184,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Dominica",
            "Abs_contribution": 4.5346025512588e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 1.13993813434866e-07,
            "Land_abs": 3.39466441691014e-07,
            "Fossil_fraction": 25.1386559563465,
            "Land_fraction": 74.8613440436535,
            "Rank": 185,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Seychelles",
            "Abs_contribution": 4.16683129568765e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 2.78440347610507e-07,
            "Land_abs": 1.38242781958258e-07,
            "Fossil_fraction": 66.8230431835988,
            "Land_fraction": 33.1769568164012,
            "Rank": 186,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Liechtenstein",
            "Abs_contribution": 3.66712897073175e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 1.40728956575084e-07,
            "Land_abs": 2.25983940498091e-07,
            "Fossil_fraction": 38.3757859890602,
            "Land_fraction": 61.6242140109399,
            "Rank": 187,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Sao Tome and Principe",
            "Abs_contribution": 3.61914740763996e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 1.51012491764414e-07,
            "Land_abs": 2.10902248999582e-07,
            "Fossil_fraction": 41.7259853648483,
            "Land_fraction": 58.2740146351517,
            "Rank": 188,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Kitts and Nevis",
            "Abs_contribution": 3.47125984161288e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 1.28211242682449e-07,
            "Land_abs": 2.1891474147884e-07,
            "Fossil_fraction": 36.9350750253479,
            "Land_fraction": 63.0649249746524,
            "Rank": 189,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Grenada",
            "Abs_contribution": 3.46587476952147e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 1.40051434918182e-07,
            "Land_abs": 2.06536042033964e-07,
            "Fossil_fraction": 40.4086830112212,
            "Land_fraction": 59.5913169887788,
            "Rank": 190,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Micronesia (Federated States of)",
            "Abs_contribution": 2.03130298137892e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 1.31640719199495e-13,
            "Land_abs": 2.03130166497172e-07,
            "Fossil_fraction": 6.48060483375712e-05,
            "Land_fraction": 99.9999351939516,
            "Rank": 191,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Kiribati",
            "Abs_contribution": 1.44741525625476e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 7.23779250476488e-08,
            "Land_abs": 7.23636005778275e-08,
            "Fossil_fraction": 50.00494829309,
            "Land_fraction": 49.9950517069104,
            "Rank": 192,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Aruba",
            "Abs_contribution": 1.35809772220257e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 1.35342485375396e-07,
            "Land_abs": 4.67286844861081e-10,
            "Fossil_fraction": 99.6559254630785,
            "Land_fraction": 0.344074536921566,
            "Rank": 193,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Cook Islands",
            "Abs_contribution": 1.34114404395041e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 3.68639431804749e-08,
            "Land_abs": 9.7250461214566e-08,
            "Fossil_fraction": 27.486937996526,
            "Land_fraction": 72.5130620034743,
            "Rank": 194,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Tuvalu",
            "Abs_contribution": 3.55622777638403e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 4.26766422710904e-09,
            "Land_abs": 3.12946135367313e-08,
            "Fossil_fraction": 12.000536791961,
            "Land_fraction": 87.9994632080389,
            "Rank": 195,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Turks and Caicos Islands",
            "Abs_contribution": 1.90459894011668e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 1.89599318138306e-08,
            "Land_abs": 8.60575873362445e-11,
            "Fossil_fraction": 99.5481590085788,
            "Land_fraction": 0.451840991421387,
            "Rank": 196,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Nauru",
            "Abs_contribution": 1.64097105555844e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 1.01719408027137e-08,
            "Land_abs": 6.23776975287076e-09,
            "Fossil_fraction": 61.9873261521485,
            "Land_fraction": 38.0126738478515,
            "Rank": 197,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Niue",
            "Abs_contribution": 1.33669008887853e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 6.23006924004531e-10,
            "Land_abs": 1.27438939647807e-08,
            "Fossil_fraction": 4.66081801000881,
            "Land_fraction": 95.339181989991,
            "Rank": 198,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Anguilla",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 199,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Antarctica",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 200,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Bermuda",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 201,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Bonaire, Saint Eustatius and Saba",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 202,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "British Virgin Islands",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 203,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Christmas Island",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 204,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Cura\xe7ao",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 205,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Faeroe Islands",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 206,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "French Polynesia",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 207,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Greenland",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 208,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Kosovo",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 209,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Kuwaiti Oil Fires",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 210,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Leeward Islands",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 211,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Marshall Islands",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 212,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Montserrat",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 213,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "New Caledonia",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 214,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Occupied Palestinian Territory",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 215,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Pacific Islands (Palau)",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 216,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Panama Canal Zone",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 217,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Ryukyu Islands",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 218,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Helena",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 219,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Pierre and Miquelon",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 220,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Sint Maarten (Dutch part)",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 221,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "St. Kitts-Nevis-Anguilla",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 222,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Wallis and Futuna Islands",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 223,
            "Perc_contribution_rescale": 0
        }
    ],
    "1990_3GHG": [
        {
            "Country": "China",
            "Abs_contribution": 0.138695958278841,
            "Perc_contribution": 20.9,
            "Fossil_abs": 0.129194408202738,
            "Land_abs": 0.00950155007610219,
            "Fossil_fraction": 93.1493677292313,
            "Land_fraction": 6.85063227076873,
            "Rank": 1,
            "Perc_contribution_rescale": 100
        },
        {
            "Country": "United States",
            "Abs_contribution": 0.080179424819573,
            "Perc_contribution": 12.08,
            "Fossil_abs": 0.079407277290351,
            "Land_abs": 0.000772147529221799,
            "Fossil_fraction": 99.0369754697548,
            "Land_fraction": 0.963024530244954,
            "Rank": 2,
            "Perc_contribution_rescale": 57.799043062201
        },
        {
            "Country": "EU27",
            "Abs_contribution": 0.041425765171826,
            "Perc_contribution": 6.24,
            "Fossil_abs": 0.044023723494854,
            "Land_abs": -0.0025979583230284,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 3,
            "Perc_contribution_rescale": 29.8564593301435
        },
        {
            "Country": "Brazil",
            "Abs_contribution": 0.0396343790596497,
            "Perc_contribution": 5.97,
            "Fossil_abs": 0.0103453368111825,
            "Land_abs": 0.0292890422484672,
            "Fossil_fraction": 26.1019273081402,
            "Land_fraction": 73.8980726918598,
            "Rank": 4,
            "Perc_contribution_rescale": 28.5645933014354
        },
        {
            "Country": "India",
            "Abs_contribution": 0.0389758677104836,
            "Perc_contribution": 5.87,
            "Fossil_abs": 0.0294652069662681,
            "Land_abs": 0.0095106607442154,
            "Fossil_fraction": 75.5985913774606,
            "Land_fraction": 24.4014086225391,
            "Rank": 5,
            "Perc_contribution_rescale": 28.0861244019139
        },
        {
            "Country": "Indonesia",
            "Abs_contribution": 0.0291381939450636,
            "Perc_contribution": 4.39,
            "Fossil_abs": 0.0127655625901301,
            "Land_abs": 0.0163726313549333,
            "Fossil_fraction": 43.8104112224594,
            "Land_fraction": 56.18958877754,
            "Rank": 6,
            "Perc_contribution_rescale": 21.0047846889952
        },
        {
            "Country": "Russia",
            "Abs_contribution": 0.0256651079262507,
            "Perc_contribution": 3.87,
            "Fossil_abs": 0.0284815069024589,
            "Land_abs": -0.0028163989762082,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 7,
            "Perc_contribution_rescale": 18.5167464114833
        },
        {
            "Country": "Japan",
            "Abs_contribution": 0.0165912709749246,
            "Perc_contribution": 2.5,
            "Fossil_abs": 0.0169146758840286,
            "Land_abs": -0.000323404909104,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 8,
            "Perc_contribution_rescale": 11.9617224880383
        },
        {
            "Country": "Canada",
            "Abs_contribution": 0.0120012973688744,
            "Perc_contribution": 1.81,
            "Fossil_abs": 0.0096821335139899,
            "Land_abs": 0.0023191638548845,
            "Fossil_fraction": 80.6757237688377,
            "Land_fraction": 19.3242762311623,
            "Rank": 9,
            "Perc_contribution_rescale": 8.66028708133971
        },
        {
            "Country": "Mexico",
            "Abs_contribution": 0.0115312615853565,
            "Perc_contribution": 1.74,
            "Fossil_abs": 0.00938613552783929,
            "Land_abs": 0.00214512605751712,
            "Fossil_fraction": 81.3972994920062,
            "Land_fraction": 18.602700507993,
            "Rank": 10,
            "Perc_contribution_rescale": 8.32535885167464
        },
        {
            "Country": "Iran",
            "Abs_contribution": 0.0113559733258719,
            "Perc_contribution": 1.71,
            "Fossil_abs": 0.0109191985289089,
            "Land_abs": 0.00043677479696305,
            "Fossil_fraction": 96.1537881040286,
            "Land_fraction": 3.84621189597161,
            "Rank": 11,
            "Perc_contribution_rescale": 8.18181818181818
        },
        {
            "Country": "Germany",
            "Abs_contribution": 0.0094608546434737,
            "Perc_contribution": 1.43,
            "Fossil_abs": 0.0102121921464897,
            "Land_abs": -0.00075133750301604,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 12,
            "Perc_contribution_rescale": 6.84210526315789
        },
        {
            "Country": "Saudi Arabia",
            "Abs_contribution": 0.00943189146813621,
            "Perc_contribution": 1.42,
            "Fossil_abs": 0.00935100841587587,
            "Land_abs": 8.08830522603399e-05,
            "Fossil_fraction": 99.142451410371,
            "Land_fraction": 0.857548589628998,
            "Rank": 13,
            "Perc_contribution_rescale": 6.79425837320574
        },
        {
            "Country": "South Africa",
            "Abs_contribution": 0.00827454999057969,
            "Perc_contribution": 1.25,
            "Fossil_abs": 0.0077155309921187,
            "Land_abs": 0.00055901899846098,
            "Fossil_fraction": 93.2441160051312,
            "Land_fraction": 6.75588399486867,
            "Rank": 14,
            "Perc_contribution_rescale": 5.98086124401914
        },
        {
            "Country": "Australia",
            "Abs_contribution": 0.0078474197167757,
            "Perc_contribution": 1.18,
            "Fossil_abs": 0.00616094877622613,
            "Land_abs": 0.0016864709405496,
            "Fossil_fraction": 78.5092297670234,
            "Land_fraction": 21.490770232977,
            "Rank": 15,
            "Perc_contribution_rescale": 5.64593301435407
        },
        {
            "Country": "South Korea",
            "Abs_contribution": 0.00782681545802156,
            "Perc_contribution": 1.18,
            "Fossil_abs": 0.00785610348942135,
            "Land_abs": -0.0000292880313998,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 16,
            "Perc_contribution_rescale": 5.64593301435407
        },
        {
            "Country": "Pakistan",
            "Abs_contribution": 0.00779523836823727,
            "Perc_contribution": 1.17,
            "Fossil_abs": 0.00396078252311562,
            "Land_abs": 0.00383445584512172,
            "Fossil_fraction": 50.8102810461108,
            "Land_fraction": 49.1897189538901,
            "Rank": 17,
            "Perc_contribution_rescale": 5.59808612440191
        },
        {
            "Country": "Nigeria",
            "Abs_contribution": 0.0071110865739638,
            "Perc_contribution": 1.07,
            "Fossil_abs": 0.004505985926207,
            "Land_abs": 0.00260510064775688,
            "Fossil_fraction": 63.3656457327493,
            "Land_fraction": 36.6343542672518,
            "Rank": 18,
            "Perc_contribution_rescale": 5.11961722488038
        },
        {
            "Country": "Democratic Republic of the Congo",
            "Abs_contribution": 0.00662729902435969,
            "Perc_contribution": 1,
            "Fossil_abs": 0.000891704822427076,
            "Land_abs": 0.00573559420193264,
            "Fossil_fraction": 13.4550262354162,
            "Land_fraction": 86.5449737645842,
            "Rank": 19,
            "Perc_contribution_rescale": 4.78468899521531
        },
        {
            "Country": "T\xfcrkiye",
            "Abs_contribution": 0.00640381072759766,
            "Perc_contribution": 0.97,
            "Fossil_abs": 0.00630246137458356,
            "Land_abs": 0.00010134935301409,
            "Fossil_fraction": 98.4173587052264,
            "Land_fraction": 1.58264129477341,
            "Rank": 20,
            "Perc_contribution_rescale": 4.64114832535885
        },
        {
            "Country": "Malaysia",
            "Abs_contribution": 0.00614279676665898,
            "Perc_contribution": 0.93,
            "Fossil_abs": 0.00428290879989814,
            "Land_abs": 0.00185988796676079,
            "Fossil_fraction": 69.7224564410843,
            "Land_fraction": 30.2775435589149,
            "Rank": 21,
            "Perc_contribution_rescale": 4.44976076555024
        },
        {
            "Country": "Viet Nam",
            "Abs_contribution": 0.00603510318525871,
            "Perc_contribution": 0.91,
            "Fossil_abs": 0.00352446148449169,
            "Land_abs": 0.002510641700767,
            "Fossil_fraction": 58.3993574973251,
            "Land_fraction": 41.6006425026745,
            "Rank": 22,
            "Perc_contribution_rescale": 4.35406698564593
        },
        {
            "Country": "Thailand",
            "Abs_contribution": 0.0058128326936065,
            "Perc_contribution": 0.88,
            "Fossil_abs": 0.00454394322004566,
            "Land_abs": 0.00126888947356086,
            "Fossil_fraction": 78.170892911532,
            "Land_fraction": 21.8291070884683,
            "Rank": 23,
            "Perc_contribution_rescale": 4.21052631578947
        },
        {
            "Country": "Italy",
            "Abs_contribution": 0.00576551202855551,
            "Perc_contribution": 0.87,
            "Fossil_abs": 0.00615908245369944,
            "Land_abs": -0.000393570425144,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 24,
            "Perc_contribution_rescale": 4.16267942583732
        },
        {
            "Country": "Argentina",
            "Abs_contribution": 0.0054326518811946,
            "Perc_contribution": 0.82,
            "Fossil_abs": 0.00308211012277898,
            "Land_abs": 0.0023505417584157,
            "Fossil_fraction": 56.733068677709,
            "Land_fraction": 43.2669313222925,
            "Rank": 25,
            "Perc_contribution_rescale": 3.92344497607656
        },
        {
            "Country": "France",
            "Abs_contribution": 0.0050223558755305,
            "Perc_contribution": 0.76,
            "Fossil_abs": 0.0052533117916839,
            "Land_abs": -0.00023095591615329,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 26,
            "Perc_contribution_rescale": 3.63636363636364
        },
        {
            "Country": "Spain",
            "Abs_contribution": 0.00481027769603109,
            "Perc_contribution": 0.72,
            "Fossil_abs": 0.00449641476341033,
            "Land_abs": 0.00031386293262079,
            "Fossil_fraction": 93.4751598046049,
            "Land_fraction": 6.52484019539568,
            "Rank": 27,
            "Perc_contribution_rescale": 3.44497607655502
        },
        {
            "Country": "United Kingdom",
            "Abs_contribution": 0.0047376363756424,
            "Perc_contribution": 0.71,
            "Fossil_abs": 0.0044557893168692,
            "Land_abs": 0.00028184705877313,
            "Fossil_fraction": 94.0508929680154,
            "Land_fraction": 5.94910703198307,
            "Rank": 28,
            "Perc_contribution_rescale": 3.39712918660287
        },
        {
            "Country": "Egypt",
            "Abs_contribution": 0.00460184257022942,
            "Perc_contribution": 0.69,
            "Fossil_abs": 0.00406393443931231,
            "Land_abs": 0.000537908130917142,
            "Fossil_fraction": 88.311027100384,
            "Land_fraction": 11.6889728996167,
            "Rank": 29,
            "Perc_contribution_rescale": 3.30143540669856
        },
        {
            "Country": "Venezuela",
            "Abs_contribution": 0.00407432008847084,
            "Perc_contribution": 0.61,
            "Fossil_abs": 0.0028602922581899,
            "Land_abs": 0.00121402783028092,
            "Fossil_fraction": 70.2029343812164,
            "Land_fraction": 29.7970656187832,
            "Rank": 30,
            "Perc_contribution_rescale": 2.91866028708134
        },
        {
            "Country": "Colombia",
            "Abs_contribution": 0.0039066828728165,
            "Perc_contribution": 0.59,
            "Fossil_abs": 0.00210025142012448,
            "Land_abs": 0.001806431452692,
            "Fossil_fraction": 53.7604788640117,
            "Land_fraction": 46.2395211359878,
            "Rank": 31,
            "Perc_contribution_rescale": 2.82296650717703
        },
        {
            "Country": "Ethiopia",
            "Abs_contribution": 0.00381033576259747,
            "Perc_contribution": 0.57,
            "Fossil_abs": 0.00104726148261754,
            "Land_abs": 0.0027630742799799,
            "Fossil_fraction": 27.4847558815561,
            "Land_fraction": 72.5152441184432,
            "Rank": 32,
            "Perc_contribution_rescale": 2.72727272727273
        },
        {
            "Country": "Taiwan",
            "Abs_contribution": 0.00379897291357619,
            "Perc_contribution": 0.57,
            "Fossil_abs": 0.00383226306823251,
            "Land_abs": -0.000033290154656333,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 33,
            "Perc_contribution_rescale": 2.72727272727273
        },
        {
            "Country": "Myanmar",
            "Abs_contribution": 0.00365029076772543,
            "Perc_contribution": 0.55,
            "Fossil_abs": 0.000668175127581432,
            "Land_abs": 0.00298211564014396,
            "Fossil_fraction": 18.3047096820121,
            "Land_fraction": 81.6952903179868,
            "Rank": 34,
            "Perc_contribution_rescale": 2.63157894736842
        },
        {
            "Country": "Philippines",
            "Abs_contribution": 0.00356192534824403,
            "Perc_contribution": 0.54,
            "Fossil_abs": 0.00202579387672861,
            "Land_abs": 0.00153613147151545,
            "Fossil_fraction": 56.8735635553758,
            "Land_fraction": 43.126436444625,
            "Rank": 35,
            "Perc_contribution_rescale": 2.58373205741627
        },
        {
            "Country": "Tanzania",
            "Abs_contribution": 0.0035166263151522,
            "Perc_contribution": 0.53,
            "Fossil_abs": 0.000640652074822209,
            "Land_abs": 0.00287597424032997,
            "Fossil_fraction": 18.2178035824225,
            "Land_fraction": 81.7821964175769,
            "Rank": 36,
            "Perc_contribution_rescale": 2.53588516746411
        },
        {
            "Country": "Algeria",
            "Abs_contribution": 0.00343457432378808,
            "Perc_contribution": 0.52,
            "Fossil_abs": 0.00321760531229117,
            "Land_abs": 0.000216969011496922,
            "Fossil_fraction": 93.6827976033545,
            "Land_fraction": 6.3172023966458,
            "Rank": 37,
            "Perc_contribution_rescale": 2.48803827751196
        },
        {
            "Country": "Angola",
            "Abs_contribution": 0.00342830325149398,
            "Perc_contribution": 0.52,
            "Fossil_abs": 0.00163755348716832,
            "Land_abs": 0.00179074976432566,
            "Fossil_fraction": 47.7657128626154,
            "Land_fraction": 52.2342871373847,
            "Rank": 38,
            "Perc_contribution_rescale": 2.48803827751196
        },
        {
            "Country": "Ukraine",
            "Abs_contribution": 0.0034038097902614,
            "Perc_contribution": 0.51,
            "Fossil_abs": 0.0048844256643771,
            "Land_abs": -0.00148061587411572,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 39,
            "Perc_contribution_rescale": 2.44019138755981
        },
        {
            "Country": "Qatar",
            "Abs_contribution": 0.00339237778478872,
            "Perc_contribution": 0.51,
            "Fossil_abs": 0.00338283337894251,
            "Land_abs": 9.54440584620436e-06,
            "Fossil_fraction": 99.7186514459265,
            "Land_fraction": 0.281348554073225,
            "Rank": 40,
            "Perc_contribution_rescale": 2.44019138755981
        },
        {
            "Country": "United Arab Emirates",
            "Abs_contribution": 0.00335490679034688,
            "Perc_contribution": 0.51,
            "Fossil_abs": 0.00331148769462997,
            "Land_abs": 4.34190957169091e-05,
            "Fossil_fraction": 98.7058032180852,
            "Land_fraction": 1.29419678191476,
            "Rank": 41,
            "Perc_contribution_rescale": 2.44019138755981
        },
        {
            "Country": "Uzbekistan",
            "Abs_contribution": 0.00325647703484816,
            "Perc_contribution": 0.49,
            "Fossil_abs": 0.00287383505702249,
            "Land_abs": 0.00038264197782567,
            "Fossil_fraction": 88.2498180171103,
            "Land_fraction": 11.7501819828897,
            "Rank": 42,
            "Perc_contribution_rescale": 2.3444976076555
        },
        {
            "Country": "Iraq",
            "Abs_contribution": 0.00308295034210188,
            "Perc_contribution": 0.46,
            "Fossil_abs": 0.00300118013452961,
            "Land_abs": 8.1770207572293e-05,
            "Fossil_fraction": 97.3476638123038,
            "Land_fraction": 2.65233618769688,
            "Rank": 43,
            "Perc_contribution_rescale": 2.20095693779904
        },
        {
            "Country": "Sudan",
            "Abs_contribution": 0.00279643251874383,
            "Perc_contribution": 0.42,
            "Fossil_abs": 0.00057870832796251,
            "Land_abs": 0.00221772419078131,
            "Fossil_fraction": 20.6945214691778,
            "Land_fraction": 79.3054785308219,
            "Rank": 44,
            "Perc_contribution_rescale": 2.00956937799043
        },
        {
            "Country": "Bangladesh",
            "Abs_contribution": 0.00274121423604174,
            "Perc_contribution": 0.41,
            "Fossil_abs": 0.00177664779030636,
            "Land_abs": 0.00096456644573539,
            "Fossil_fraction": 64.8124384787889,
            "Land_fraction": 35.1875615212113,
            "Rank": 45,
            "Perc_contribution_rescale": 1.96172248803828
        },
        {
            "Country": "Kazakhstan",
            "Abs_contribution": 0.0025547390033899,
            "Perc_contribution": 0.39,
            "Fossil_abs": 0.00241100497871536,
            "Land_abs": 0.00014373402467459,
            "Fossil_fraction": 94.3738274444544,
            "Land_fraction": 5.62617255554749,
            "Rank": 46,
            "Perc_contribution_rescale": 1.86602870813397
        },
        {
            "Country": "Netherlands",
            "Abs_contribution": 0.00225465844216567,
            "Perc_contribution": 0.34,
            "Fossil_abs": 0.00210064670795108,
            "Land_abs": 0.00015401173421459,
            "Fossil_fraction": 93.1691766994802,
            "Land_fraction": 6.83082330051983,
            "Rank": 47,
            "Perc_contribution_rescale": 1.62679425837321
        },
        {
            "Country": "Peru",
            "Abs_contribution": 0.00210760809811551,
            "Perc_contribution": 0.32,
            "Fossil_abs": 0.00085713336065656,
            "Land_abs": 0.00125047473745895,
            "Fossil_fraction": 40.6685361203041,
            "Land_fraction": 59.3314638796959,
            "Rank": 48,
            "Perc_contribution_rescale": 1.5311004784689
        },
        {
            "Country": "Chad",
            "Abs_contribution": 0.00201477120536045,
            "Perc_contribution": 0.3,
            "Fossil_abs": 0.000173516592587086,
            "Land_abs": 0.00184125461277336,
            "Fossil_fraction": 8.61222317082119,
            "Land_fraction": 91.3877768291789,
            "Rank": 49,
            "Perc_contribution_rescale": 1.43540669856459
        },
        {
            "Country": "Kenya",
            "Abs_contribution": 0.00196258393523325,
            "Perc_contribution": 0.3,
            "Fossil_abs": 0.000757954353961944,
            "Land_abs": 0.0012046295812713,
            "Fossil_fraction": 38.6202261393657,
            "Land_fraction": 61.379773860634,
            "Rank": 50,
            "Perc_contribution_rescale": 1.43540669856459
        },
        {
            "Country": "Paraguay",
            "Abs_contribution": 0.00175951240671723,
            "Perc_contribution": 0.27,
            "Fossil_abs": 0.000152745472664549,
            "Land_abs": 0.00160676693405268,
            "Fossil_fraction": 8.68112507086725,
            "Land_fraction": 91.3188749291327,
            "Rank": 51,
            "Perc_contribution_rescale": 1.29186602870813
        },
        {
            "Country": "C\xf4te d'Ivoire",
            "Abs_contribution": 0.00174060530720794,
            "Perc_contribution": 0.26,
            "Fossil_abs": 0.000413246982430664,
            "Land_abs": 0.00132735832477731,
            "Fossil_fraction": 23.7415674144728,
            "Land_fraction": 76.2584325855292,
            "Rank": 52,
            "Perc_contribution_rescale": 1.24401913875598
        },
        {
            "Country": "Turkmenistan",
            "Abs_contribution": 0.00170128674933663,
            "Perc_contribution": 0.26,
            "Fossil_abs": 0.00144301243466021,
            "Land_abs": 0.000258274314676422,
            "Fossil_fraction": 84.8188840136957,
            "Land_fraction": 15.1811159863044,
            "Rank": 53,
            "Perc_contribution_rescale": 1.24401913875598
        },
        {
            "Country": "Kuwait",
            "Abs_contribution": 0.00168682184572675,
            "Perc_contribution": 0.25,
            "Fossil_abs": 0.00167933776425162,
            "Land_abs": 7.48408147512793e-06,
            "Fossil_fraction": 99.5563205744525,
            "Land_fraction": 0.443679425547367,
            "Rank": 54,
            "Perc_contribution_rescale": 1.19617224880383
        },
        {
            "Country": "Oman",
            "Abs_contribution": 0.00167574633907665,
            "Perc_contribution": 0.25,
            "Fossil_abs": 0.00163905132960399,
            "Land_abs": 3.66950094726589e-05,
            "Fossil_fraction": 97.8102288743248,
            "Land_fraction": 2.18977112567516,
            "Rank": 55,
            "Perc_contribution_rescale": 1.19617224880383
        },
        {
            "Country": "Bolivia",
            "Abs_contribution": 0.00164212886156694,
            "Perc_contribution": 0.25,
            "Fossil_abs": 3.4199566834728e-05,
            "Land_abs": 0.00160792929473221,
            "Fossil_fraction": 2.0826359998383,
            "Land_fraction": 97.9173640001616,
            "Rank": 56,
            "Perc_contribution_rescale": 1.19617224880383
        },
        {
            "Country": "Belgium",
            "Abs_contribution": 0.00161037355951551,
            "Perc_contribution": 0.24,
            "Fossil_abs": 0.00156446272402113,
            "Land_abs": 4.59108354943901e-05,
            "Fossil_fraction": 97.1490567997035,
            "Land_fraction": 2.85094320029712,
            "Rank": 57,
            "Perc_contribution_rescale": 1.14832535885167
        },
        {
            "Country": "Ecuador",
            "Abs_contribution": 0.0014732825448233,
            "Perc_contribution": 0.22,
            "Fossil_abs": 0.000786271017550821,
            "Land_abs": 0.00068701152727247,
            "Fossil_fraction": 53.3686508615442,
            "Land_fraction": 46.6313491384551,
            "Rank": 58,
            "Perc_contribution_rescale": 1.05263157894737
        },
        {
            "Country": "Chile",
            "Abs_contribution": 0.00145206777162458,
            "Perc_contribution": 0.22,
            "Fossil_abs": 0.00123381750708055,
            "Land_abs": 0.00021825026454401,
            "Fossil_fraction": 84.9696915799012,
            "Land_fraction": 15.0303084200974,
            "Rank": 59,
            "Perc_contribution_rescale": 1.05263157894737
        },
        {
            "Country": "Morocco",
            "Abs_contribution": 0.0014102835506361,
            "Perc_contribution": 0.21,
            "Fossil_abs": 0.00121311794387522,
            "Land_abs": 0.000197165606760879,
            "Fossil_fraction": 86.019435121969,
            "Land_fraction": 13.980564878031,
            "Rank": 60,
            "Perc_contribution_rescale": 1.00478468899522
        },
        {
            "Country": "Greece",
            "Abs_contribution": 0.00139296316992082,
            "Perc_contribution": 0.21,
            "Fossil_abs": 0.00141949117822706,
            "Land_abs": -0.000026528008306251,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 61,
            "Perc_contribution_rescale": 1.00478468899522
        },
        {
            "Country": "Mozambique",
            "Abs_contribution": 0.00137746369095669,
            "Perc_contribution": 0.21,
            "Fossil_abs": 0.00043579184897423,
            "Land_abs": 0.00094167184198245,
            "Fossil_fraction": 31.6372657831409,
            "Land_fraction": 68.3627342168584,
            "Rank": 62,
            "Perc_contribution_rescale": 1.00478468899522
        },
        {
            "Country": "Norway",
            "Abs_contribution": 0.00131995120019402,
            "Perc_contribution": 0.2,
            "Fossil_abs": 0.00122754188730019,
            "Land_abs": 9.2409312893826e-05,
            "Fossil_fraction": 92.9990356552389,
            "Land_fraction": 7.00096434476083,
            "Rank": 63,
            "Perc_contribution_rescale": 0.956937799043062
        },
        {
            "Country": "Czechia",
            "Abs_contribution": 0.00129516777380214,
            "Perc_contribution": 0.2,
            "Fossil_abs": 0.00160721990801575,
            "Land_abs": -0.000312052134213586,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 64,
            "Perc_contribution_rescale": 0.956937799043062
        },
        {
            "Country": "Zambia",
            "Abs_contribution": 0.00127133633812241,
            "Perc_contribution": 0.19,
            "Fossil_abs": 0.000244620044010171,
            "Land_abs": 0.00102671629411225,
            "Fossil_fraction": 19.2411745558568,
            "Land_fraction": 80.7588254441441,
            "Rank": 65,
            "Perc_contribution_rescale": 0.909090909090909
        },
        {
            "Country": "Uganda",
            "Abs_contribution": 0.00124071035241299,
            "Perc_contribution": 0.19,
            "Fossil_abs": 0.000414159814800504,
            "Land_abs": 0.00082655053761248,
            "Fossil_fraction": 33.3808623418856,
            "Land_fraction": 66.6191376581139,
            "Rank": 66,
            "Perc_contribution_rescale": 0.909090909090909
        },
        {
            "Country": "Mongolia",
            "Abs_contribution": 0.00117724776857382,
            "Perc_contribution": 0.18,
            "Fossil_abs": 0.000689478570958261,
            "Land_abs": 0.00048776919761557,
            "Fossil_fraction": 58.5669889859746,
            "Land_fraction": 41.4330110140263,
            "Rank": 67,
            "Perc_contribution_rescale": 0.861244019138756
        },
        {
            "Country": "Madagascar",
            "Abs_contribution": 0.00116176820168833,
            "Perc_contribution": 0.18,
            "Fossil_abs": 0.000282244051620918,
            "Land_abs": 0.00087952415006741,
            "Fossil_fraction": 24.2943515936096,
            "Land_fraction": 75.7056484063903,
            "Rank": 68,
            "Perc_contribution_rescale": 0.861244019138756
        },
        {
            "Country": "Belarus",
            "Abs_contribution": 0.00116027523637245,
            "Perc_contribution": 0.17,
            "Fossil_abs": 0.00113004621283394,
            "Land_abs": 3.02290235385102e-05,
            "Fossil_fraction": 97.394667869236,
            "Land_fraction": 2.60533213076407,
            "Rank": 69,
            "Perc_contribution_rescale": 0.813397129186603
        },
        {
            "Country": "South Sudan",
            "Abs_contribution": 0.00113074249259824,
            "Perc_contribution": 0.17,
            "Fossil_abs": 0.000126273966289769,
            "Land_abs": 0.00100446852630847,
            "Fossil_fraction": 11.1673495173613,
            "Land_fraction": 88.8326504826386,
            "Rank": 70,
            "Perc_contribution_rescale": 0.813397129186603
        },
        {
            "Country": "North Korea",
            "Abs_contribution": 0.00110264796314501,
            "Perc_contribution": 0.17,
            "Fossil_abs": 0.00096266584838163,
            "Land_abs": 0.000139982114763378,
            "Fossil_fraction": 87.3049133139359,
            "Land_fraction": 12.695086686064,
            "Rank": 71,
            "Perc_contribution_rescale": 0.813397129186603
        },
        {
            "Country": "Cambodia",
            "Abs_contribution": 0.00109601316326886,
            "Perc_contribution": 0.17,
            "Fossil_abs": 0.000223962791758594,
            "Land_abs": 0.00087205037151027,
            "Fossil_fraction": 20.4343158699504,
            "Land_fraction": 79.56568413005,
            "Rank": 72,
            "Perc_contribution_rescale": 0.813397129186603
        },
        {
            "Country": "Trinidad and Tobago",
            "Abs_contribution": 0.00108954832399481,
            "Perc_contribution": 0.16,
            "Fossil_abs": 0.0010946324759479,
            "Land_abs": -0.0000050841519530791,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 73,
            "Perc_contribution_rescale": 0.76555023923445
        },
        {
            "Country": "Cameroon",
            "Abs_contribution": 0.00107836385915486,
            "Perc_contribution": 0.16,
            "Fossil_abs": 0.000411564385068063,
            "Land_abs": 0.0006667994740868,
            "Fossil_fraction": 38.1656322746773,
            "Land_fraction": 61.8343677253229,
            "Rank": 74,
            "Perc_contribution_rescale": 0.76555023923445
        },
        {
            "Country": "Guatemala",
            "Abs_contribution": 0.00107430797547018,
            "Perc_contribution": 0.16,
            "Fossil_abs": 0.00044697811456169,
            "Land_abs": 0.00062732986090849,
            "Fossil_fraction": 41.6061431886947,
            "Land_fraction": 58.3938568113053,
            "Rank": 75,
            "Perc_contribution_rescale": 0.76555023923445
        },
        {
            "Country": "Poland",
            "Abs_contribution": 0.0010396304737195,
            "Perc_contribution": 0.16,
            "Fossil_abs": 0.0018229777303721,
            "Land_abs": -0.00078334725665254,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 76,
            "Perc_contribution_rescale": 0.76555023923445
        },
        {
            "Country": "Finland",
            "Abs_contribution": 0.00103669947878668,
            "Perc_contribution": 0.16,
            "Fossil_abs": 0.00089791958170292,
            "Land_abs": 0.00013877989708377,
            "Fossil_fraction": 86.613295374067,
            "Land_fraction": 13.386704625934,
            "Rank": 77,
            "Perc_contribution_rescale": 0.76555023923445
        },
        {
            "Country": "Ghana",
            "Abs_contribution": 0.00099599120872215,
            "Perc_contribution": 0.15,
            "Fossil_abs": 0.000492954418734781,
            "Land_abs": 0.000503036789987365,
            "Fossil_fraction": 49.4938523972755,
            "Land_fraction": 50.5061476027241,
            "Rank": 78,
            "Perc_contribution_rescale": 0.717703349282297
        },
        {
            "Country": "Sweden",
            "Abs_contribution": 0.00095198647330861,
            "Perc_contribution": 0.14,
            "Fossil_abs": 0.00081120801673509,
            "Land_abs": 0.000140778456573529,
            "Fossil_fraction": 85.2121368821295,
            "Land_fraction": 14.7878631178714,
            "Rank": 79,
            "Perc_contribution_rescale": 0.669856459330144
        },
        {
            "Country": "Azerbaijan",
            "Abs_contribution": 0.00094957671076582,
            "Perc_contribution": 0.14,
            "Fossil_abs": 0.000830299920330718,
            "Land_abs": 0.000119276790435093,
            "Fossil_fraction": 87.4389515788665,
            "Land_fraction": 12.5610484211326,
            "Rank": 80,
            "Perc_contribution_rescale": 0.669856459330144
        },
        {
            "Country": "Mali",
            "Abs_contribution": 0.000935144607466708,
            "Perc_contribution": 0.14,
            "Fossil_abs": 0.000140708482544981,
            "Land_abs": 0.000794436124921736,
            "Fossil_fraction": 15.04670843648,
            "Land_fraction": 84.953291563521,
            "Rank": 81,
            "Perc_contribution_rescale": 0.669856459330144
        },
        {
            "Country": "Burkina Faso",
            "Abs_contribution": 0.000912781961180636,
            "Perc_contribution": 0.14,
            "Fossil_abs": 0.000191800425562867,
            "Land_abs": 0.00072098153561776,
            "Fossil_fraction": 21.0127318154692,
            "Land_fraction": 78.9872681845299,
            "Rank": 82,
            "Perc_contribution_rescale": 0.669856459330144
        },
        {
            "Country": "Syria",
            "Abs_contribution": 0.00091149254538452,
            "Perc_contribution": 0.14,
            "Fossil_abs": 0.000797507372715863,
            "Land_abs": 0.000113985172668662,
            "Fossil_fraction": 87.4946675926382,
            "Land_fraction": 12.5053324073623,
            "Rank": 83,
            "Perc_contribution_rescale": 0.669856459330144
        },
        {
            "Country": "Yemen",
            "Abs_contribution": 0.000897789918260219,
            "Perc_contribution": 0.14,
            "Fossil_abs": 0.000739009991940162,
            "Land_abs": 0.000158779926320053,
            "Fossil_fraction": 82.3143562774966,
            "Land_fraction": 17.685643722503,
            "Rank": 84,
            "Perc_contribution_rescale": 0.669856459330144
        },
        {
            "Country": "Niger",
            "Abs_contribution": 0.000880928049795566,
            "Perc_contribution": 0.13,
            "Fossil_abs": 0.000133085162322007,
            "Land_abs": 0.000747842887473562,
            "Fossil_fraction": 15.1073816247413,
            "Land_fraction": 84.8926183752591,
            "Rank": 85,
            "Perc_contribution_rescale": 0.62200956937799
        },
        {
            "Country": "Singapore",
            "Abs_contribution": 0.000877751650868184,
            "Perc_contribution": 0.13,
            "Fossil_abs": 0.000883182052141388,
            "Land_abs": -0.0000054304012732019,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 86,
            "Perc_contribution_rescale": 0.62200956937799
        },
        {
            "Country": "Portugal",
            "Abs_contribution": 0.00086211715387119,
            "Perc_contribution": 0.13,
            "Fossil_abs": 0.000860525814157532,
            "Land_abs": 1.591339713664e-06,
            "Fossil_fraction": 99.8154149112435,
            "Land_fraction": 0.184585088757179,
            "Rank": 87,
            "Perc_contribution_rescale": 0.62200956937799
        },
        {
            "Country": "Nicaragua",
            "Abs_contribution": 0.00085882333530313,
            "Perc_contribution": 0.13,
            "Fossil_abs": 0.000114181711552798,
            "Land_abs": 0.00074464162375033,
            "Fossil_fraction": 13.2951338021686,
            "Land_fraction": 86.7048661978312,
            "Rank": 88,
            "Perc_contribution_rescale": 0.62200956937799
        },
        {
            "Country": "Bahrain",
            "Abs_contribution": 0.000817016899627084,
            "Perc_contribution": 0.12,
            "Fossil_abs": 0.000816253189472788,
            "Land_abs": 7.63710154293869e-07,
            "Fossil_fraction": 99.9065245584706,
            "Land_fraction": 0.0934754415291108,
            "Rank": 89,
            "Perc_contribution_rescale": 0.574162679425837
        },
        {
            "Country": "Laos",
            "Abs_contribution": 0.000795281485454443,
            "Perc_contribution": 0.12,
            "Fossil_abs": 0.000157979667504057,
            "Land_abs": 0.00063730181795038,
            "Fossil_fraction": 19.8646228277003,
            "Land_fraction": 80.135377172299,
            "Rank": 90,
            "Perc_contribution_rescale": 0.574162679425837
        },
        {
            "Country": "Austria",
            "Abs_contribution": 0.00079464017801857,
            "Perc_contribution": 0.12,
            "Fossil_abs": 0.00091216462535383,
            "Land_abs": -0.000117524447335267,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 91,
            "Perc_contribution_rescale": 0.574162679425837
        },
        {
            "Country": "Congo",
            "Abs_contribution": 0.00077697646928591,
            "Perc_contribution": 0.12,
            "Fossil_abs": 0.000550380986977115,
            "Land_abs": 0.000226595482308781,
            "Fossil_fraction": 70.8362490672272,
            "Land_fraction": 29.163750932771,
            "Rank": 92,
            "Perc_contribution_rescale": 0.574162679425837
        },
        {
            "Country": "Denmark",
            "Abs_contribution": 0.00077532684665261,
            "Perc_contribution": 0.12,
            "Fossil_abs": 0.00075726270955877,
            "Land_abs": 1.8064137093836e-05,
            "Fossil_fraction": 97.670126196219,
            "Land_fraction": 2.32987380378043,
            "Rank": 93,
            "Perc_contribution_rescale": 0.574162679425837
        },
        {
            "Country": "Romania",
            "Abs_contribution": 0.000750831782827009,
            "Perc_contribution": 0.11,
            "Fossil_abs": 0.00110826687488619,
            "Land_abs": -0.00035743509205919,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 94,
            "Perc_contribution_rescale": 0.526315789473684
        },
        {
            "Country": "Nepal",
            "Abs_contribution": 0.00074998593734989,
            "Perc_contribution": 0.11,
            "Fossil_abs": 0.000246123870961254,
            "Land_abs": 0.00050386206638863,
            "Fossil_fraction": 32.8171314559502,
            "Land_fraction": 67.1828685440489,
            "Rank": 95,
            "Perc_contribution_rescale": 0.526315789473684
        },
        {
            "Country": "Ireland",
            "Abs_contribution": 0.00074828073374162,
            "Perc_contribution": 0.11,
            "Fossil_abs": 0.000566087897915766,
            "Land_abs": 0.000182192835825853,
            "Fossil_fraction": 75.6518071880807,
            "Land_fraction": 24.3481928119191,
            "Rank": 96,
            "Perc_contribution_rescale": 0.526315789473684
        },
        {
            "Country": "Guinea",
            "Abs_contribution": 0.00072075266400603,
            "Perc_contribution": 0.11,
            "Fossil_abs": 0.000154084938646471,
            "Land_abs": 0.00056666772535957,
            "Fossil_fraction": 21.3783377212993,
            "Land_fraction": 78.6216622787022,
            "Rank": 97,
            "Perc_contribution_rescale": 0.526315789473684
        },
        {
            "Country": "Hong Kong",
            "Abs_contribution": 0.000677031356213714,
            "Perc_contribution": 0.1,
            "Fossil_abs": 0.00067897461044873,
            "Land_abs": -0.00000194325423501628,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 98,
            "Perc_contribution_rescale": 0.478468899521531
        },
        {
            "Country": "Zimbabwe",
            "Abs_contribution": 0.00067389300809587,
            "Perc_contribution": 0.1,
            "Fossil_abs": 0.000291382518817468,
            "Land_abs": 0.000382510489278403,
            "Fossil_fraction": 43.2386915010127,
            "Land_fraction": 56.7613084989874,
            "Rank": 99,
            "Perc_contribution_rescale": 0.478468899521531
        },
        {
            "Country": "Papua New Guinea",
            "Abs_contribution": 0.000667466808987801,
            "Perc_contribution": 0.1,
            "Fossil_abs": 0.000175314090248961,
            "Land_abs": 0.000492152718738839,
            "Fossil_fraction": 26.2655892230539,
            "Land_fraction": 73.7344107769461,
            "Rank": 100,
            "Perc_contribution_rescale": 0.478468899521531
        },
        {
            "Country": "Israel",
            "Abs_contribution": 0.00064423411142645,
            "Perc_contribution": 0.1,
            "Fossil_abs": 0.00060634342940597,
            "Land_abs": 3.78906820204902e-05,
            "Fossil_fraction": 94.1184918109065,
            "Land_fraction": 5.88150818909502,
            "Rank": 101,
            "Perc_contribution_rescale": 0.478468899521531
        },
        {
            "Country": "Hungary",
            "Abs_contribution": 0.00062829288396931,
            "Perc_contribution": 0.09,
            "Fossil_abs": 0.00077821155076281,
            "Land_abs": -0.000149918666793499,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 102,
            "Perc_contribution_rescale": 0.430622009569378
        },
        {
            "Country": "Somalia",
            "Abs_contribution": 0.000626977125772842,
            "Perc_contribution": 0.09,
            "Fossil_abs": 0.000198615575714254,
            "Land_abs": 0.000428361550058592,
            "Fossil_fraction": 31.6782810009904,
            "Land_fraction": 68.3217189990102,
            "Rank": 103,
            "Perc_contribution_rescale": 0.430622009569378
        },
        {
            "Country": "New Zealand",
            "Abs_contribution": 0.00060114920690393,
            "Perc_contribution": 0.09,
            "Fossil_abs": 0.000591778346242957,
            "Land_abs": 9.37086066096033e-06,
            "Fossil_fraction": 98.4411755761543,
            "Land_fraction": 1.55882442384356,
            "Rank": 104,
            "Perc_contribution_rescale": 0.430622009569378
        },
        {
            "Country": "Tunisia",
            "Abs_contribution": 0.000596134546324528,
            "Perc_contribution": 0.09,
            "Fossil_abs": 0.000526932126065902,
            "Land_abs": 6.9202420258628e-05,
            "Fossil_fraction": 88.3914762723794,
            "Land_fraction": 11.6085237276209,
            "Rank": 105,
            "Perc_contribution_rescale": 0.430622009569378
        },
        {
            "Country": "Switzerland",
            "Abs_contribution": 0.00058553144740461,
            "Perc_contribution": 0.09,
            "Fossil_abs": 0.000604027380910427,
            "Land_abs": -0.000018495933505809,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 106,
            "Perc_contribution_rescale": 0.430622009569378
        },
        {
            "Country": "Equatorial Guinea",
            "Abs_contribution": 0.000544696148647506,
            "Perc_contribution": 0.08,
            "Fossil_abs": 0.000490833088983987,
            "Land_abs": 5.38630596635209e-05,
            "Fossil_fraction": 90.1113566164802,
            "Land_fraction": 9.8886433835202,
            "Rank": 107,
            "Perc_contribution_rescale": 0.382775119617225
        },
        {
            "Country": "Benin",
            "Abs_contribution": 0.000539688494882849,
            "Perc_contribution": 0.08,
            "Fossil_abs": 0.000149877782584698,
            "Land_abs": 0.00038981071229815,
            "Fossil_fraction": 27.7711650342356,
            "Land_fraction": 72.2288349657642,
            "Rank": 108,
            "Perc_contribution_rescale": 0.382775119617225
        },
        {
            "Country": "Dominican Republic",
            "Abs_contribution": 0.000527195522161975,
            "Perc_contribution": 0.08,
            "Fossil_abs": 0.000398490164647971,
            "Land_abs": 0.000128705357514005,
            "Fossil_fraction": 75.5867885625818,
            "Land_fraction": 24.4132114374184,
            "Rank": 109,
            "Perc_contribution_rescale": 0.382775119617225
        },
        {
            "Country": "Uruguay",
            "Abs_contribution": 0.00050460326584861,
            "Perc_contribution": 0.08,
            "Fossil_abs": 0.0002251308415273,
            "Land_abs": 0.00027947242432131,
            "Fossil_fraction": 44.6154150724112,
            "Land_fraction": 55.3845849275887,
            "Rank": 110,
            "Perc_contribution_rescale": 0.382775119617225
        },
        {
            "Country": "Central African Republic",
            "Abs_contribution": 0.00049605997948589,
            "Perc_contribution": 0.07,
            "Fossil_abs": 3.15906279286496e-05,
            "Land_abs": 0.00046446935155725,
            "Fossil_fraction": 6.36830811495612,
            "Land_fraction": 93.6316918850458,
            "Rank": 111,
            "Perc_contribution_rescale": 0.334928229665072
        },
        {
            "Country": "Serbia",
            "Abs_contribution": 0.0004918786673038,
            "Perc_contribution": 0.07,
            "Fossil_abs": 0.000731211976768973,
            "Land_abs": -0.000239333309465164,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 112,
            "Perc_contribution_rescale": 0.334928229665072
        },
        {
            "Country": "Slovakia",
            "Abs_contribution": 0.00047961063911565,
            "Perc_contribution": 0.07,
            "Fossil_abs": 0.00058714586635369,
            "Land_abs": -0.000107535227238042,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 113,
            "Perc_contribution_rescale": 0.334928229665072
        },
        {
            "Country": "Honduras",
            "Abs_contribution": 0.00047732597003519,
            "Perc_contribution": 0.07,
            "Fossil_abs": 0.00022141805894406,
            "Land_abs": 0.00025590791109113,
            "Fossil_fraction": 46.3871804267713,
            "Land_fraction": 53.6128195732287,
            "Rank": 114,
            "Perc_contribution_rescale": 0.334928229665072
        },
        {
            "Country": "Cuba",
            "Abs_contribution": 0.0004758179188173,
            "Perc_contribution": 0.07,
            "Fossil_abs": 0.000457289398580185,
            "Land_abs": 1.85285202370998e-05,
            "Fossil_fraction": 96.1059641715113,
            "Land_fraction": 3.89403582848552,
            "Rank": 115,
            "Perc_contribution_rescale": 0.334928229665072
        },
        {
            "Country": "Gabon",
            "Abs_contribution": 0.000468174043419809,
            "Perc_contribution": 0.07,
            "Fossil_abs": 0.000355482441793434,
            "Land_abs": 0.000112691601626374,
            "Fossil_fraction": 75.929549446353,
            "Land_fraction": 24.0704505536468,
            "Rank": 116,
            "Perc_contribution_rescale": 0.334928229665072
        },
        {
            "Country": "Sri Lanka",
            "Abs_contribution": 0.00046767846076014,
            "Perc_contribution": 0.07,
            "Fossil_abs": 0.000313459446742577,
            "Land_abs": 0.000154219014017564,
            "Fossil_fraction": 67.0245634646283,
            "Land_fraction": 32.9754365353718,
            "Rank": 117,
            "Perc_contribution_rescale": 0.334928229665072
        },
        {
            "Country": "Jordan",
            "Abs_contribution": 0.000465630971461405,
            "Perc_contribution": 0.07,
            "Fossil_abs": 0.000442252175479072,
            "Land_abs": 2.33787959823325e-05,
            "Fossil_fraction": 94.9791149182028,
            "Land_fraction": 5.02088508179708,
            "Rank": 118,
            "Perc_contribution_rescale": 0.334928229665072
        },
        {
            "Country": "Afghanistan",
            "Abs_contribution": 0.00045553795323984,
            "Perc_contribution": 0.07,
            "Fossil_abs": 0.000215103747804957,
            "Land_abs": 0.000240434205434882,
            "Fossil_fraction": 47.2197203932435,
            "Land_fraction": 52.7802796067562,
            "Rank": 119,
            "Perc_contribution_rescale": 0.334928229665072
        },
        {
            "Country": "Malawi",
            "Abs_contribution": 0.000452523460911528,
            "Perc_contribution": 0.07,
            "Fossil_abs": 0.000132266322664904,
            "Land_abs": 0.000320257138246621,
            "Fossil_fraction": 29.2286111306754,
            "Land_fraction": 70.771388869324,
            "Rank": 120,
            "Perc_contribution_rescale": 0.334928229665072
        },
        {
            "Country": "Senegal",
            "Abs_contribution": 0.000417151726955042,
            "Perc_contribution": 0.06,
            "Fossil_abs": 0.000175406156752541,
            "Land_abs": 0.000241745570202503,
            "Fossil_fraction": 42.0485270510327,
            "Land_fraction": 57.9514729489678,
            "Rank": 121,
            "Perc_contribution_rescale": 0.287081339712919
        },
        {
            "Country": "Sierra Leone",
            "Abs_contribution": 0.000392391187404063,
            "Perc_contribution": 0.06,
            "Fossil_abs": 6.6337740346482e-05,
            "Land_abs": 0.000326053447057581,
            "Fossil_fraction": 16.9060219688805,
            "Land_fraction": 83.0939780311195,
            "Rank": 122,
            "Perc_contribution_rescale": 0.287081339712919
        },
        {
            "Country": "Lebanon",
            "Abs_contribution": 0.000376673117474576,
            "Perc_contribution": 0.06,
            "Fossil_abs": 0.000365069110824909,
            "Land_abs": 1.1604006649666e-05,
            "Fossil_fraction": 96.9193430294504,
            "Land_fraction": 3.08065697054933,
            "Rank": 123,
            "Perc_contribution_rescale": 0.287081339712919
        },
        {
            "Country": "Panama",
            "Abs_contribution": 0.000348647132327529,
            "Perc_contribution": 0.05,
            "Fossil_abs": 0.0001570091667723,
            "Land_abs": 0.000191637965555226,
            "Fossil_fraction": 45.0338328395603,
            "Land_fraction": 54.9661671604388,
            "Rank": 124,
            "Perc_contribution_rescale": 0.239234449760766
        },
        {
            "Country": "Bulgaria",
            "Abs_contribution": 0.00033805026953316,
            "Perc_contribution": 0.05,
            "Fossil_abs": 0.00052540042157161,
            "Land_abs": -0.000187350152038452,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 125,
            "Perc_contribution_rescale": 0.239234449760766
        },
        {
            "Country": "Botswana",
            "Abs_contribution": 0.000334345572403187,
            "Perc_contribution": 0.05,
            "Fossil_abs": 0.000113740321046979,
            "Land_abs": 0.000220605251356208,
            "Fossil_fraction": 34.0187908664211,
            "Land_fraction": 65.9812091335788,
            "Rank": 126,
            "Perc_contribution_rescale": 0.239234449760766
        },
        {
            "Country": "Haiti",
            "Abs_contribution": 0.00029815612275619,
            "Perc_contribution": 0.04,
            "Fossil_abs": 0.00019262682112733,
            "Land_abs": 0.000105529301628858,
            "Fossil_fraction": 64.6060256441039,
            "Land_fraction": 35.3939743558954,
            "Rank": 127,
            "Perc_contribution_rescale": 0.191387559808612
        },
        {
            "Country": "Liberia",
            "Abs_contribution": 0.000284641338746574,
            "Perc_contribution": 0.04,
            "Fossil_abs": 7.9081214983286e-05,
            "Land_abs": 0.000205560123763288,
            "Fossil_fraction": 27.7827582358635,
            "Land_fraction": 72.2172417641364,
            "Rank": 128,
            "Perc_contribution_rescale": 0.191387559808612
        },
        {
            "Country": "Croatia",
            "Abs_contribution": 0.000274618637577817,
            "Perc_contribution": 0.04,
            "Fossil_abs": 0.000345468529960205,
            "Land_abs": -0.000070849892382388,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 129,
            "Perc_contribution_rescale": 0.191387559808612
        },
        {
            "Country": "Mauritania",
            "Abs_contribution": 0.000265804472373167,
            "Perc_contribution": 0.04,
            "Fossil_abs": 7.50067930978584e-05,
            "Land_abs": 0.000190797679275308,
            "Fossil_fraction": 28.2187851950644,
            "Land_fraction": 71.7812148049355,
            "Rank": 130,
            "Perc_contribution_rescale": 0.191387559808612
        },
        {
            "Country": "Namibia",
            "Abs_contribution": 0.000259101904312788,
            "Perc_contribution": 0.04,
            "Fossil_abs": 7.06469190708811e-05,
            "Land_abs": 0.000188454985241905,
            "Fossil_fraction": 27.2660748126328,
            "Land_fraction": 72.7339251873664,
            "Rank": 131,
            "Perc_contribution_rescale": 0.191387559808612
        },
        {
            "Country": "Estonia",
            "Abs_contribution": 0.000257184931726774,
            "Perc_contribution": 0.04,
            "Fossil_abs": 0.000291696988132517,
            "Land_abs": -0.000034512056405746,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 132,
            "Perc_contribution_rescale": 0.191387559808612
        },
        {
            "Country": "Bosnia and Herzegovina",
            "Abs_contribution": 0.000248577523215435,
            "Perc_contribution": 0.04,
            "Fossil_abs": 0.000259291890919545,
            "Land_abs": -0.000010714367704108,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 133,
            "Perc_contribution_rescale": 0.191387559808612
        },
        {
            "Country": "Lithuania",
            "Abs_contribution": 0.00024051582042864,
            "Perc_contribution": 0.04,
            "Fossil_abs": 0.000259515162089532,
            "Land_abs": -0.000018999341660891,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 134,
            "Perc_contribution_rescale": 0.191387559808612
        },
        {
            "Country": "Togo",
            "Abs_contribution": 0.000239344443878311,
            "Perc_contribution": 0.04,
            "Fossil_abs": 0.000135228441504005,
            "Land_abs": 0.00010411600237431,
            "Fossil_fraction": 56.4995114625508,
            "Land_fraction": 43.5004885374508,
            "Rank": 135,
            "Perc_contribution_rescale": 0.191387559808612
        },
        {
            "Country": "Brunei Darussalam",
            "Abs_contribution": 0.000229396865092568,
            "Perc_contribution": 0.03,
            "Fossil_abs": 0.000211131974813614,
            "Land_abs": 1.82648902789547e-05,
            "Fossil_fraction": 92.037864043354,
            "Land_fraction": 7.96213595664627,
            "Rank": 136,
            "Perc_contribution_rescale": 0.143540669856459
        },
        {
            "Country": "Slovenia",
            "Abs_contribution": 0.000228291160784492,
            "Perc_contribution": 0.03,
            "Fossil_abs": 0.00023578132528628,
            "Land_abs": -0.000007490164501786,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 137,
            "Perc_contribution_rescale": 0.143540669856459
        },
        {
            "Country": "Kuwaiti Oil Fires",
            "Abs_contribution": 0.0002152227,
            "Perc_contribution": 0.03,
            "Fossil_abs": 0.0002152227,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 138,
            "Perc_contribution_rescale": 0.143540669856459
        },
        {
            "Country": "Kyrgyzstan",
            "Abs_contribution": 0.000185051322740512,
            "Perc_contribution": 0.03,
            "Fossil_abs": 0.000120340451182165,
            "Land_abs": 6.4710871558347e-05,
            "Fossil_fraction": 65.0308516577924,
            "Land_fraction": 34.9691483422076,
            "Rank": 139,
            "Perc_contribution_rescale": 0.143540669856459
        },
        {
            "Country": "Tajikistan",
            "Abs_contribution": 0.000184660647615766,
            "Perc_contribution": 0.03,
            "Fossil_abs": 9.8219157079272e-05,
            "Land_abs": 8.6441490536497e-05,
            "Fossil_fraction": 53.1890028262233,
            "Land_fraction": 46.8109971737783,
            "Rank": 140,
            "Perc_contribution_rescale": 0.143540669856459
        },
        {
            "Country": "Costa Rica",
            "Abs_contribution": 0.000177808237992733,
            "Perc_contribution": 0.03,
            "Fossil_abs": 0.00015922738697672,
            "Land_abs": 1.858085101601e-05,
            "Fossil_fraction": 89.5500617824175,
            "Land_fraction": 10.449938217581,
            "Rank": 141,
            "Perc_contribution_rescale": 0.143540669856459
        },
        {
            "Country": "Jamaica",
            "Abs_contribution": 0.000163666682222629,
            "Perc_contribution": 0.02,
            "Fossil_abs": 0.000139648917443616,
            "Land_abs": 2.4017764779013e-05,
            "Fossil_fraction": 85.3251960308313,
            "Land_fraction": 14.6748039691686,
            "Rank": 142,
            "Perc_contribution_rescale": 0.0956937799043062
        },
        {
            "Country": "El Salvador",
            "Abs_contribution": 0.000160825848578117,
            "Perc_contribution": 0.02,
            "Fossil_abs": 0.00011521684983495,
            "Land_abs": 4.5608998743164e-05,
            "Fossil_fraction": 71.6407535564697,
            "Land_fraction": 28.3592464435284,
            "Rank": 143,
            "Perc_contribution_rescale": 0.0956937799043062
        },
        {
            "Country": "Guyana",
            "Abs_contribution": 0.000159773850737482,
            "Perc_contribution": 0.02,
            "Fossil_abs": 3.12017138633313e-05,
            "Land_abs": 0.00012857213687415,
            "Fossil_fraction": 19.5286736342091,
            "Land_fraction": 80.4713263657904,
            "Rank": 144,
            "Perc_contribution_rescale": 0.0956937799043062
        },
        {
            "Country": "Luxembourg",
            "Abs_contribution": 0.000149040778064509,
            "Perc_contribution": 0.02,
            "Fossil_abs": 0.000145377840318,
            "Land_abs": 3.6629377465084e-06,
            "Fossil_fraction": 97.5423251313653,
            "Land_fraction": 2.45767486863426,
            "Rank": 145,
            "Perc_contribution_rescale": 0.0956937799043062
        },
        {
            "Country": "Burundi",
            "Abs_contribution": 0.000148851448810827,
            "Perc_contribution": 0.02,
            "Fossil_abs": 8.01692949569959e-05,
            "Land_abs": 6.8682153853832e-05,
            "Fossil_fraction": 53.8585923062676,
            "Land_fraction": 46.141407693733,
            "Rank": 146,
            "Perc_contribution_rescale": 0.0956937799043062
        },
        {
            "Country": "Timor-Leste",
            "Abs_contribution": 0.000137934925812679,
            "Perc_contribution": 0.02,
            "Fossil_abs": 7.75941550570704e-05,
            "Land_abs": 6.03407707556086e-05,
            "Fossil_fraction": 56.2541753655968,
            "Land_fraction": 43.745824634403,
            "Rank": 147,
            "Perc_contribution_rescale": 0.0956937799043062
        },
        {
            "Country": "Eritrea",
            "Abs_contribution": 0.000130264261712126,
            "Perc_contribution": 0.02,
            "Fossil_abs": 4.43247134246641e-05,
            "Land_abs": 8.5939548287463e-05,
            "Fossil_fraction": 34.0267643957621,
            "Land_fraction": 65.9732356042387,
            "Rank": 148,
            "Perc_contribution_rescale": 0.0956937799043062
        },
        {
            "Country": "Cyprus",
            "Abs_contribution": 0.000113441921652855,
            "Perc_contribution": 0.02,
            "Fossil_abs": 0.000118772022752767,
            "Land_abs": -0.0000053301010999124,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 149,
            "Perc_contribution_rescale": 0.0956937799043062
        },
        {
            "Country": "Latvia",
            "Abs_contribution": 0.000107450668564274,
            "Perc_contribution": 0.02,
            "Fossil_abs": 0.000149604878377274,
            "Land_abs": -0.000042154209813001,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 150,
            "Perc_contribution_rescale": 0.0956937799043062
        },
        {
            "Country": "Rwanda",
            "Abs_contribution": 0.000107034254895513,
            "Perc_contribution": 0.02,
            "Fossil_abs": 8.26078989040399e-06,
            "Land_abs": 9.8773465005108e-05,
            "Fossil_fraction": 7.71789358319744,
            "Land_fraction": 92.2821064168016,
            "Rank": 151,
            "Perc_contribution_rescale": 0.0956937799043062
        },
        {
            "Country": "Armenia",
            "Abs_contribution": 9.9577659536488e-05,
            "Perc_contribution": 0.02,
            "Fossil_abs": 6.79256578195e-05,
            "Land_abs": 3.16520017169876e-05,
            "Fossil_fraction": 68.2137520962824,
            "Land_fraction": 31.7862479037172,
            "Rank": 152,
            "Perc_contribution_rescale": 0.0956937799043062
        },
        {
            "Country": "Belize",
            "Abs_contribution": 9.76353962285472e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 1.48305010184716e-05,
            "Land_abs": 8.28048952100769e-05,
            "Fossil_fraction": 15.1896766862665,
            "Land_fraction": 84.8103233137348,
            "Rank": 153,
            "Perc_contribution_rescale": 0.0478468899521531
        },
        {
            "Country": "Bhutan",
            "Abs_contribution": 9.3953042533203e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 3.21466572066447e-05,
            "Land_abs": 6.1806385326558e-05,
            "Fossil_fraction": 34.2156638464199,
            "Land_fraction": 65.7843361535797,
            "Rank": 154,
            "Perc_contribution_rescale": 0.0478468899521531
        },
        {
            "Country": "North Macedonia",
            "Abs_contribution": 9.0419083930301e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 0.000128501965898695,
            "Land_abs": -0.000038082881968394,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 155,
            "Perc_contribution_rescale": 0.0478468899521531
        },
        {
            "Country": "Guinea-Bissau",
            "Abs_contribution": 8.8339352001845e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 2.59056675080533e-05,
            "Land_abs": 6.24336844937921e-05,
            "Fossil_fraction": 29.325172667683,
            "Land_fraction": 70.6748273323175,
            "Rank": 156,
            "Perc_contribution_rescale": 0.0478468899521531
        },
        {
            "Country": "Suriname",
            "Abs_contribution": 8.11829159737361e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 4.56460611009512e-05,
            "Land_abs": 3.55368548727844e-05,
            "Fossil_fraction": 56.2261906380874,
            "Land_fraction": 43.7738093619119,
            "Rank": 157,
            "Perc_contribution_rescale": 0.0478468899521531
        },
        {
            "Country": "Lesotho",
            "Abs_contribution": 7.3953800283395e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 4.94864408292581e-05,
            "Land_abs": 2.44673594541372e-05,
            "Fossil_fraction": 66.9153453096709,
            "Land_fraction": 33.0846546903296,
            "Rank": 158,
            "Perc_contribution_rescale": 0.0478468899521531
        },
        {
            "Country": "Gambia",
            "Abs_contribution": 6.69301343027787e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 2.26737537474865e-05,
            "Land_abs": 4.42563805552917e-05,
            "Fossil_fraction": 33.8767492157045,
            "Land_fraction": 66.1232507842948,
            "Rank": 159,
            "Perc_contribution_rescale": 0.0478468899521531
        },
        {
            "Country": "Cura\xe7ao",
            "Abs_contribution": 6.4805964710698e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 6.4805964710698e-05,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 160,
            "Perc_contribution_rescale": 0.0478468899521531
        },
        {
            "Country": "Iceland",
            "Abs_contribution": 5.8913167163695e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 4.96672627420579e-05,
            "Land_abs": 9.24590442163811e-06,
            "Fossil_fraction": 84.3058778423054,
            "Land_fraction": 15.6941221576963,
            "Rank": 161,
            "Perc_contribution_rescale": 0.0478468899521531
        },
        {
            "Country": "Mauritius",
            "Abs_contribution": 5.85954209368129e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 5.6816674072049e-05,
            "Land_abs": 1.77874686476387e-06,
            "Fossil_fraction": 96.9643585858321,
            "Land_fraction": 3.03564141416785,
            "Rank": 162,
            "Perc_contribution_rescale": 0.0478468899521531
        },
        {
            "Country": "Kosovo",
            "Abs_contribution": 5.48597714656113e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 5.48597714656113e-05,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 163,
            "Perc_contribution_rescale": 0.0478468899521531
        },
        {
            "Country": "Georgia",
            "Abs_contribution": 5.2541932522992e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 0.00011845035823985,
            "Land_abs": -0.0000659084257168584,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 164,
            "Perc_contribution_rescale": 0.0478468899521531
        },
        {
            "Country": "Moldova",
            "Abs_contribution": 5.1720538909528e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 0.000116916004129671,
            "Land_abs": -0.00006519546522014,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 165,
            "Perc_contribution_rescale": 0.0478468899521531
        },
        {
            "Country": "Albania",
            "Abs_contribution": 5.0841396650411e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 1.8490004851349e-05,
            "Land_abs": 3.2351391799062e-05,
            "Fossil_fraction": 36.3680112458113,
            "Land_fraction": 63.6319887541887,
            "Rank": 166,
            "Perc_contribution_rescale": 0.0478468899521531
        },
        {
            "Country": "New Caledonia",
            "Abs_contribution": 4.74855008597161e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 4.74855008597161e-05,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 167,
            "Perc_contribution_rescale": 0.0478468899521531
        },
        {
            "Country": "Fiji",
            "Abs_contribution": 4.6080582915704e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 2.44660570345659e-05,
            "Land_abs": 2.16145258811385e-05,
            "Fossil_fraction": 53.0940701842294,
            "Land_fraction": 46.9059298157715,
            "Rank": 168,
            "Perc_contribution_rescale": 0.0478468899521531
        },
        {
            "Country": "Solomon Islands",
            "Abs_contribution": 4.2278986369607e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 8.29453788072943e-06,
            "Land_abs": 3.39844484888777e-05,
            "Fossil_fraction": 19.6185826410732,
            "Land_fraction": 80.3814173589271,
            "Rank": 169,
            "Perc_contribution_rescale": 0.0478468899521531
        },
        {
            "Country": "Djibouti",
            "Abs_contribution": 3.84942530789118e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 2.35499258568426e-05,
            "Land_abs": 1.49443272220691e-05,
            "Fossil_fraction": 61.1777706364795,
            "Land_fraction": 38.8222293635203,
            "Rank": 170,
            "Perc_contribution_rescale": 0.0478468899521531
        },
        {
            "Country": "Bahamas",
            "Abs_contribution": 3.79161027974842e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 3.78227583393604e-05,
            "Land_abs": 9.33444581237207e-08,
            "Fossil_fraction": 99.7538131526271,
            "Land_fraction": 0.246186847372706,
            "Rank": 171,
            "Perc_contribution_rescale": 0.0478468899521531
        },
        {
            "Country": "Malta",
            "Abs_contribution": 3.75911504881676e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 3.75139850692905e-05,
            "Land_abs": 7.716541887694e-08,
            "Fossil_fraction": 99.7947245086277,
            "Land_fraction": 0.205275491371909,
            "Rank": 172,
            "Perc_contribution_rescale": 0.0478468899521531
        },
        {
            "Country": "Macao",
            "Abs_contribution": 2.29644735506317e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 2.29215360440347e-05,
            "Land_abs": 4.29375065970023e-08,
            "Fossil_fraction": 99.8130263839823,
            "Land_fraction": 0.186973616017516,
            "Rank": 173,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Vanuatu",
            "Abs_contribution": 2.28108958399042e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 4.51276923370171e-06,
            "Land_abs": 1.82981266062024e-05,
            "Fossil_fraction": 19.7833932756262,
            "Land_fraction": 80.2166067243734,
            "Rank": 174,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Barbados",
            "Abs_contribution": 2.25485557549942e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 2.31329918341473e-05,
            "Land_abs": -0.0000005844360791532,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 175,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Aruba",
            "Abs_contribution": 2.13958203594954e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 2.13953530726505e-05,
            "Land_abs": 4.67286844861081e-10,
            "Fossil_fraction": 99.997815990053,
            "Land_fraction": 0.00218400994684787,
            "Rank": 176,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Maldives",
            "Abs_contribution": 1.72984435605854e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 1.72858094483844e-05,
            "Land_abs": 1.26341122009477e-08,
            "Fossil_fraction": 99.9269638788209,
            "Land_fraction": 0.0730361211787549,
            "Rank": 177,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Swaziland",
            "Abs_contribution": 1.564455533199e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 5.6097710585333e-06,
            "Land_abs": 1.00347842734574e-05,
            "Fossil_fraction": 35.8576574372967,
            "Land_fraction": 64.1423425627079,
            "Rank": 178,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Comoros",
            "Abs_contribution": 1.5558369646903e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 1.09726727179756e-05,
            "Land_abs": 4.5856969289274e-06,
            "Fossil_fraction": 70.5258517891027,
            "Land_fraction": 29.474148210897,
            "Rank": 179,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Cape Verde",
            "Abs_contribution": 1.21325840254487e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 9.5234087810456e-06,
            "Land_abs": 2.6091752444031e-06,
            "Fossil_fraction": 78.4944803272721,
            "Land_fraction": 21.5055196727278,
            "Rank": 180,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "French Polynesia",
            "Abs_contribution": 1.05457511872271e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 1.05457511872271e-05,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 181,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Faeroe Islands",
            "Abs_contribution": 9.5093926719432e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 9.5093926719432e-06,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 182,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Andorra",
            "Abs_contribution": 9.12033564927104e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 7.62961697151563e-06,
            "Land_abs": 1.49071867775533e-06,
            "Fossil_fraction": 83.6550020187628,
            "Land_fraction": 16.3449979812363,
            "Rank": 183,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Greenland",
            "Abs_contribution": 8.57267722434498e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 8.57267722434498e-06,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 184,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Sint Maarten (Dutch part)",
            "Abs_contribution": 8.1475685043668e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 8.1475685043668e-06,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 185,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Bermuda",
            "Abs_contribution": 7.9117774699782e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 7.9117774699782e-06,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 186,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Seychelles",
            "Abs_contribution": 7.3051222837878e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 7.29825168339937e-06,
            "Land_abs": 6.87060038844699e-09,
            "Fossil_fraction": 99.9059481809952,
            "Land_fraction": 0.094051819005068,
            "Rank": 187,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Antigua and Barbuda",
            "Abs_contribution": 7.0997589550542e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 7.14755258578528e-06,
            "Land_abs": -0.000000047793630730988,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 188,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Lucia",
            "Abs_contribution": 6.04563847333617e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 6.52989479489909e-06,
            "Land_abs": -0.00000048425632156293,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 189,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Samoa",
            "Abs_contribution": 4.1683968237656e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 3.28356277615632e-06,
            "Land_abs": 8.84834047609301e-07,
            "Fossil_fraction": 78.7727971923281,
            "Land_fraction": 21.2272028076725,
            "Rank": 190,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Sao Tome and Principe",
            "Abs_contribution": 4.08410324731472e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 3.09989724147661e-06,
            "Land_abs": 9.8420600583816e-07,
            "Fossil_fraction": 75.9015395488539,
            "Land_fraction": 24.0984604511473,
            "Rank": 191,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Vincent and the Grenadines",
            "Abs_contribution": 3.53998397792665e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 3.74910113673265e-06,
            "Land_abs": -0.00000020911715880603,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 192,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Turks and Caicos Islands",
            "Abs_contribution": 3.50379584227823e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 3.5032973149529e-06,
            "Land_abs": 4.98527325327511e-10,
            "Fossil_fraction": 99.985771792999,
            "Land_fraction": 0.0142282070008782,
            "Rank": 193,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Grenada",
            "Abs_contribution": 3.36187276928486e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 3.91697072392077e-06,
            "Land_abs": -0.000000555097954635888,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 194,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Micronesia (Federated States of)",
            "Abs_contribution": 3.33289396935491e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 2.12346375734459e-06,
            "Land_abs": 1.2094302120103e-06,
            "Fossil_fraction": 63.7123105886142,
            "Land_fraction": 36.2876894113853,
            "Rank": 195,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Dominica",
            "Abs_contribution": 3.28355679671169e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 2.50262565039409e-06,
            "Land_abs": 7.8093114631753e-07,
            "Fossil_fraction": 76.2169137107766,
            "Land_fraction": 23.7830862892212,
            "Rank": 196,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Tonga",
            "Abs_contribution": 3.16273236719084e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 2.32200630163992e-06,
            "Land_abs": 8.4072606555089e-07,
            "Fossil_fraction": 73.4177297367194,
            "Land_fraction": 26.5822702632796,
            "Rank": 197,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Liechtenstein",
            "Abs_contribution": 2.7859999308104e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 2.83451088093087e-06,
            "Land_abs": -0.0000000485109501204589,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 198,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Kitts and Nevis",
            "Abs_contribution": 2.68936117898165e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 3.16297737741889e-06,
            "Land_abs": -0.000000473616198437238,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 199,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "British Virgin Islands",
            "Abs_contribution": 2.2228634279476e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 2.2228634279476e-06,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 200,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Montenegro",
            "Abs_contribution": 2.137056020458e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 3.50732829852679e-05,
            "Land_abs": -0.000032936226964811,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 201,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Marshall Islands",
            "Abs_contribution": 1.67146125818777e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.67146125818777e-06,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 202,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Anguilla",
            "Abs_contribution": 1.47758986080786e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.47758986080786e-06,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 203,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Kiribati",
            "Abs_contribution": 1.36342201799937e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.24672832243823e-06,
            "Land_abs": 1.16693695561128e-07,
            "Fossil_fraction": 91.4411169820795,
            "Land_fraction": 8.55888301791983,
            "Rank": 204,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Nauru",
            "Abs_contribution": 1.09695198418722e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.07255332091385e-06,
            "Land_abs": 2.43986632733674e-08,
            "Fossil_fraction": 97.7757765494678,
            "Land_fraction": 2.22422345053192,
            "Rank": 205,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Bonaire, Saint Eustatius and Saba",
            "Abs_contribution": 1.06408878275109e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.06408878275109e-06,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 206,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Cook Islands",
            "Abs_contribution": 1.03782808152926e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 9.96056054451206e-07,
            "Land_abs": 4.177202707806e-08,
            "Fossil_fraction": 95.9750533039632,
            "Land_fraction": 4.02494669603738,
            "Rank": 207,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Palau",
            "Abs_contribution": 1.00757969369837e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 7.5928329074849e-07,
            "Land_abs": 2.48296402949863e-07,
            "Fossil_fraction": 75.3571449977822,
            "Land_fraction": 24.6428550022162,
            "Rank": 208,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Pierre and Miquelon",
            "Abs_contribution": 9.4035859716157e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 9.4035859716157e-07,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 209,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Montserrat",
            "Abs_contribution": 5.15817740174672e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 5.15817740174672e-07,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 210,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Tuvalu",
            "Abs_contribution": 3.51055055566787e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 2.01913837294071e-07,
            "Land_abs": 1.49141218272715e-07,
            "Fossil_fraction": 57.5162881412079,
            "Land_fraction": 42.4837118587917,
            "Rank": 211,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Wallis and Futuna Islands",
            "Abs_contribution": 3.50668231441048e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 3.50668231441048e-07,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 212,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Helena",
            "Abs_contribution": 1.67773116812227e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 1.67773116812227e-07,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 213,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Niue",
            "Abs_contribution": 1.09255273283314e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 9.37144230064809e-08,
            "Land_abs": 1.5540850276838e-08,
            "Fossil_fraction": 85.7756520030539,
            "Land_fraction": 14.2243479969506,
            "Rank": 214,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Pacific Islands (Palau)",
            "Abs_contribution": 1.056e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 1.056e-07,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 215,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Antarctica",
            "Abs_contribution": 5.61e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 5.61e-08,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 216,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Christmas Island",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 217,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Leeward Islands",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 218,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Panama Canal Zone",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 219,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Ryukyu Islands",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 220,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "St. Kitts-Nevis-Anguilla",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 221,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Occupied Palestinian Territory",
            "Abs_contribution": -0.0000000722149999999997,
            "Perc_contribution": -0,
            "Fossil_abs": 0,
            "Land_abs": -0.0000000722149999999997,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 222,
            "Perc_contribution_rescale": -0
        },
        {
            "Country": "Libya",
            "Abs_contribution": -0.00000172113200323006,
            "Perc_contribution": -0,
            "Fossil_abs": -0.0000299382414276103,
            "Land_abs": 2.82171094243716e-05,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 223,
            "Perc_contribution_rescale": -0
        }
    ],
    "1990_CH4": [
        {
            "Country": "China",
            "Abs_contribution": 0.0328749742509789,
            "Perc_contribution": 25.24,
            "Fossil_abs": 0.0297935117792786,
            "Land_abs": 0.0030814624717003,
            "Fossil_fraction": 90.6267227825781,
            "Land_fraction": 9.37327721742184,
            "Rank": 1,
            "Perc_contribution_rescale": 100
        },
        {
            "Country": "India",
            "Abs_contribution": 0.0131065559926192,
            "Perc_contribution": 10.06,
            "Fossil_abs": 0.00688821847356948,
            "Land_abs": 0.0062183375190498,
            "Fossil_fraction": 52.5555186080042,
            "Land_fraction": 47.4444813919964,
            "Rank": 2,
            "Perc_contribution_rescale": 39.8573692551506
        },
        {
            "Country": "Brazil",
            "Abs_contribution": 0.0115059525176516,
            "Perc_contribution": 8.83,
            "Fossil_abs": 0.00445502305496399,
            "Land_abs": 0.00705092946268765,
            "Fossil_fraction": 38.7192894124099,
            "Land_fraction": 61.2807105875904,
            "Rank": 3,
            "Perc_contribution_rescale": 34.9841521394612
        },
        {
            "Country": "Indonesia",
            "Abs_contribution": 0.00814651021213506,
            "Perc_contribution": 6.25,
            "Fossil_abs": 0.00684848858469672,
            "Land_abs": 0.00129802162743828,
            "Fossil_fraction": 84.0665316357819,
            "Land_fraction": 15.9334683642174,
            "Rank": 4,
            "Perc_contribution_rescale": 24.7622820919176
        },
        {
            "Country": "Pakistan",
            "Abs_contribution": 0.00496950520018168,
            "Perc_contribution": 3.81,
            "Fossil_abs": 0.00184680758585063,
            "Land_abs": 0.00312269761433103,
            "Fossil_fraction": 37.1628061840666,
            "Land_fraction": 62.837193815933,
            "Rank": 5,
            "Perc_contribution_rescale": 15.095087163233
        },
        {
            "Country": "Nigeria",
            "Abs_contribution": 0.00417789850067963,
            "Perc_contribution": 3.21,
            "Fossil_abs": 0.00297964272882601,
            "Land_abs": 0.00119825577185365,
            "Fossil_fraction": 71.3191746602103,
            "Land_fraction": 28.6808253397905,
            "Rank": 6,
            "Perc_contribution_rescale": 12.7179080824089
        },
        {
            "Country": "Iran",
            "Abs_contribution": 0.00407427798157339,
            "Perc_contribution": 3.13,
            "Fossil_abs": 0.00386172842857794,
            "Land_abs": 0.000212549552995448,
            "Fossil_fraction": 94.7831357124688,
            "Land_fraction": 5.21686428753117,
            "Rank": 7,
            "Perc_contribution_rescale": 12.4009508716323
        },
        {
            "Country": "Mexico",
            "Abs_contribution": 0.00297490077412926,
            "Perc_contribution": 2.28,
            "Fossil_abs": 0.00238020851579017,
            "Land_abs": 0.00059469225833905,
            "Fossil_fraction": 80.0096775156088,
            "Land_fraction": 19.9903224843899,
            "Rank": 8,
            "Perc_contribution_rescale": 9.03328050713154
        },
        {
            "Country": "Saudi Arabia",
            "Abs_contribution": 0.0028474953012195,
            "Perc_contribution": 2.19,
            "Fossil_abs": 0.00278924459659986,
            "Land_abs": 5.8250704619646e-05,
            "Fossil_fraction": 97.954317796602,
            "Land_fraction": 2.04568220339815,
            "Rank": 9,
            "Perc_contribution_rescale": 8.67670364500792
        },
        {
            "Country": "Qatar",
            "Abs_contribution": 0.00247726746114802,
            "Perc_contribution": 1.9,
            "Fossil_abs": 0.00246939890492928,
            "Land_abs": 7.86855621873932e-06,
            "Fossil_fraction": 99.682369532473,
            "Land_fraction": 0.317630467527025,
            "Rank": 10,
            "Perc_contribution_rescale": 7.52773375594295
        },
        {
            "Country": "Viet Nam",
            "Abs_contribution": 0.00244609066325684,
            "Perc_contribution": 1.88,
            "Fossil_abs": 0.00154554836397599,
            "Land_abs": 0.00090054229928086,
            "Fossil_fraction": 63.1844267750146,
            "Land_fraction": 36.8155732249857,
            "Rank": 11,
            "Perc_contribution_rescale": 7.44849445324881
        },
        {
            "Country": "Ethiopia",
            "Abs_contribution": 0.00233658717730442,
            "Perc_contribution": 1.79,
            "Fossil_abs": 0.000879756138532115,
            "Land_abs": 0.0014568310387723,
            "Fossil_fraction": 37.651329557797,
            "Land_fraction": 62.3486704422027,
            "Rank": 12,
            "Perc_contribution_rescale": 7.0919175911252
        },
        {
            "Country": "T\xfcrkiye",
            "Abs_contribution": 0.00177068170040899,
            "Perc_contribution": 1.36,
            "Fossil_abs": 0.00187533246209113,
            "Land_abs": -0.00010465076168214,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 13,
            "Perc_contribution_rescale": 5.38827258320127
        },
        {
            "Country": "Thailand",
            "Abs_contribution": 0.00176988317135668,
            "Perc_contribution": 1.36,
            "Fossil_abs": 0.00137502137096609,
            "Land_abs": 0.0003948618003906,
            "Fossil_fraction": 77.6899511345759,
            "Land_fraction": 22.3100488654245,
            "Rank": 14,
            "Perc_contribution_rescale": 5.38827258320127
        },
        {
            "Country": "Canada",
            "Abs_contribution": 0.00176813922828789,
            "Perc_contribution": 1.36,
            "Fossil_abs": 0.0016676311124056,
            "Land_abs": 0.00010050811588228,
            "Fossil_fraction": 94.3155994576506,
            "Land_fraction": 5.68440054234888,
            "Rank": 15,
            "Perc_contribution_rescale": 5.38827258320127
        },
        {
            "Country": "Angola",
            "Abs_contribution": 0.00176806936537364,
            "Perc_contribution": 1.36,
            "Fossil_abs": 0.00137171811817726,
            "Land_abs": 0.00039635124719639,
            "Fossil_fraction": 77.5828225431289,
            "Land_fraction": 22.4171774568714,
            "Rank": 16,
            "Perc_contribution_rescale": 5.38827258320127
        },
        {
            "Country": "South Africa",
            "Abs_contribution": 0.00173587080747598,
            "Perc_contribution": 1.33,
            "Fossil_abs": 0.00165672609830196,
            "Land_abs": 7.91447091740149e-05,
            "Fossil_fraction": 95.4406336673696,
            "Land_fraction": 4.55936633263015,
            "Rank": 17,
            "Perc_contribution_rescale": 5.26941362916006
        },
        {
            "Country": "Egypt",
            "Abs_contribution": 0.00172963342467245,
            "Perc_contribution": 1.33,
            "Fossil_abs": 0.00145562251514316,
            "Land_abs": 0.000274010909529273,
            "Fossil_fraction": 84.1578622602543,
            "Land_fraction": 15.8421377397447,
            "Rank": 18,
            "Perc_contribution_rescale": 5.26941362916006
        },
        {
            "Country": "Malaysia",
            "Abs_contribution": 0.00172352112722099,
            "Perc_contribution": 1.32,
            "Fossil_abs": 0.00169779948034495,
            "Land_abs": 2.5721646876048e-05,
            "Fossil_fraction": 98.5076105845296,
            "Land_fraction": 1.49238941547073,
            "Rank": 19,
            "Perc_contribution_rescale": 5.229793977813
        },
        {
            "Country": "Sudan",
            "Abs_contribution": 0.00170317459297689,
            "Perc_contribution": 1.31,
            "Fossil_abs": 0.000389148992814107,
            "Land_abs": 0.00131402560016279,
            "Fossil_fraction": 22.8484498546877,
            "Land_fraction": 77.1515501453125,
            "Rank": 20,
            "Perc_contribution_rescale": 5.19017432646593
        },
        {
            "Country": "Bangladesh",
            "Abs_contribution": 0.00164604038263033,
            "Perc_contribution": 1.26,
            "Fossil_abs": 0.0010211311272891,
            "Land_abs": 0.00062490925534125,
            "Fossil_fraction": 62.0356060558706,
            "Land_fraction": 37.9643939441304,
            "Rank": 21,
            "Perc_contribution_rescale": 4.99207606973059
        },
        {
            "Country": "Algeria",
            "Abs_contribution": 0.00158213479747128,
            "Perc_contribution": 1.21,
            "Fossil_abs": 0.00145352060958175,
            "Land_abs": 0.00012861418788954,
            "Fossil_fraction": 91.8708451331016,
            "Land_fraction": 8.12915486689905,
            "Rank": 22,
            "Perc_contribution_rescale": 4.79397781299525
        },
        {
            "Country": "Chad",
            "Abs_contribution": 0.0014835553630687,
            "Perc_contribution": 1.14,
            "Fossil_abs": 0.000151334827925254,
            "Land_abs": 0.00133222053514346,
            "Fossil_fraction": 10.2008210608481,
            "Land_fraction": 89.7991789391523,
            "Rank": 23,
            "Perc_contribution_rescale": 4.51664025356577
        },
        {
            "Country": "Myanmar",
            "Abs_contribution": 0.00148070331175623,
            "Perc_contribution": 1.14,
            "Fossil_abs": 0.000431988254478029,
            "Land_abs": 0.0010487150572782,
            "Fossil_fraction": 29.1745315248642,
            "Land_fraction": 70.8254684751358,
            "Rank": 24,
            "Perc_contribution_rescale": 4.51664025356577
        },
        {
            "Country": "Uzbekistan",
            "Abs_contribution": 0.00142892091429141,
            "Perc_contribution": 1.1,
            "Fossil_abs": 0.00119473768517602,
            "Land_abs": 0.000234183229115402,
            "Fossil_fraction": 83.6111833220999,
            "Land_fraction": 16.3888166779007,
            "Rank": 25,
            "Perc_contribution_rescale": 4.3581616481775
        },
        {
            "Country": "Colombia",
            "Abs_contribution": 0.00141258882083749,
            "Perc_contribution": 1.08,
            "Fossil_abs": 0.00102096213790669,
            "Land_abs": 0.00039162668293081,
            "Fossil_fraction": 72.2759604809404,
            "Land_fraction": 27.72403951906,
            "Rank": 26,
            "Perc_contribution_rescale": 4.27892234548336
        },
        {
            "Country": "Philippines",
            "Abs_contribution": 0.00138981232908015,
            "Perc_contribution": 1.07,
            "Fossil_abs": 0.000737858194634488,
            "Land_abs": 0.00065195413444566,
            "Fossil_fraction": 53.0904913703594,
            "Land_fraction": 46.9095086296405,
            "Rank": 27,
            "Perc_contribution_rescale": 4.23930269413629
        },
        {
            "Country": "Iraq",
            "Abs_contribution": 0.00134806393270029,
            "Perc_contribution": 1.03,
            "Fossil_abs": 0.00133669571711915,
            "Land_abs": 1.1368215581124e-05,
            "Fossil_fraction": 99.1567005610506,
            "Land_fraction": 0.843299438948156,
            "Rank": 28,
            "Perc_contribution_rescale": 4.08082408874802
        },
        {
            "Country": "Tanzania",
            "Abs_contribution": 0.001335891594231,
            "Perc_contribution": 1.03,
            "Fossil_abs": 0.000521006438365877,
            "Land_abs": 0.000814885155865115,
            "Fossil_fraction": 39.000652494246,
            "Land_fraction": 60.9993475057531,
            "Rank": 29,
            "Perc_contribution_rescale": 4.08082408874802
        },
        {
            "Country": "Venezuela",
            "Abs_contribution": 0.0013308739454542,
            "Perc_contribution": 1.02,
            "Fossil_abs": 0.00084765032494253,
            "Land_abs": 0.000483223620511665,
            "Fossil_fraction": 63.6912554970219,
            "Land_fraction": 36.3087445029777,
            "Rank": 30,
            "Perc_contribution_rescale": 4.04120443740095
        },
        {
            "Country": "United Arab Emirates",
            "Abs_contribution": 0.00124173412566692,
            "Perc_contribution": 0.95,
            "Fossil_abs": 0.00120162650815279,
            "Land_abs": 4.01076175141251e-05,
            "Fossil_fraction": 96.7700317898096,
            "Land_fraction": 3.22996821019023,
            "Rank": 31,
            "Perc_contribution_rescale": 3.76386687797147
        },
        {
            "Country": "Kenya",
            "Abs_contribution": 0.00123216385728375,
            "Perc_contribution": 0.95,
            "Fossil_abs": 0.000562407540884492,
            "Land_abs": 0.00066975631639927,
            "Fossil_fraction": 45.6438920489271,
            "Land_fraction": 54.3561079510737,
            "Rank": 32,
            "Perc_contribution_rescale": 3.76386687797147
        },
        {
            "Country": "Democratic Republic of the Congo",
            "Abs_contribution": 0.00107741464012447,
            "Perc_contribution": 0.83,
            "Fossil_abs": 0.000827887762091606,
            "Land_abs": 0.000249526878032861,
            "Fossil_fraction": 76.8402183578979,
            "Land_fraction": 23.1597816421014,
            "Rank": 33,
            "Perc_contribution_rescale": 3.28843106180666
        },
        {
            "Country": "Oman",
            "Abs_contribution": 0.00106253352859373,
            "Perc_contribution": 0.82,
            "Fossil_abs": 0.00103315428003839,
            "Land_abs": 2.93792485553293e-05,
            "Fossil_fraction": 97.2349815074334,
            "Land_fraction": 2.76501849256588,
            "Rank": 34,
            "Perc_contribution_rescale": 3.24881141045959
        },
        {
            "Country": "Argentina",
            "Abs_contribution": 0.00098046866112132,
            "Perc_contribution": 0.75,
            "Fossil_abs": 0.00071502279061821,
            "Land_abs": 0.00026544587050307,
            "Fossil_fraction": 72.9266338610424,
            "Land_fraction": 27.0733661389535,
            "Rank": 35,
            "Perc_contribution_rescale": 2.97147385103011
        },
        {
            "Country": "Turkmenistan",
            "Abs_contribution": 0.00083660094251687,
            "Perc_contribution": 0.64,
            "Fossil_abs": 0.000709982557968868,
            "Land_abs": 0.000126618384548001,
            "Fossil_fraction": 84.8651396247443,
            "Land_fraction": 15.1348603752556,
            "Rank": 36,
            "Perc_contribution_rescale": 2.53565768621236
        },
        {
            "Country": "Russia",
            "Abs_contribution": 0.000826684678387497,
            "Perc_contribution": 0.63,
            "Fossil_abs": 0.0042844937330924,
            "Land_abs": -0.0034578090547048,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 37,
            "Perc_contribution_rescale": 2.49603803486529
        },
        {
            "Country": "Uganda",
            "Abs_contribution": 0.00076137249302285,
            "Perc_contribution": 0.58,
            "Fossil_abs": 0.000358530881103329,
            "Land_abs": 0.000402841611919521,
            "Fossil_fraction": 47.0900754084071,
            "Land_fraction": 52.9099245915929,
            "Rank": 38,
            "Perc_contribution_rescale": 2.29793977812995
        },
        {
            "Country": "South Sudan",
            "Abs_contribution": 0.000680865171517249,
            "Perc_contribution": 0.52,
            "Fossil_abs": 0.000107454999055393,
            "Land_abs": 0.000573410172461851,
            "Fossil_fraction": 15.7821259701005,
            "Land_fraction": 84.2178740298988,
            "Rank": 39,
            "Perc_contribution_rescale": 2.06022187004754
        },
        {
            "Country": "Mongolia",
            "Abs_contribution": 0.000643701807963127,
            "Perc_contribution": 0.49,
            "Fossil_abs": 0.000413837645048176,
            "Land_abs": 0.000229864162914951,
            "Fossil_fraction": 64.29027228581,
            "Land_fraction": 35.70972771419,
            "Rank": 40,
            "Perc_contribution_rescale": 1.94136291600634
        },
        {
            "Country": "Spain",
            "Abs_contribution": 0.0006249036023696,
            "Perc_contribution": 0.48,
            "Fossil_abs": 0.000311397944884369,
            "Land_abs": 0.00031350565748523,
            "Fossil_fraction": 49.8313569810712,
            "Land_fraction": 50.1686430189287,
            "Rank": 41,
            "Perc_contribution_rescale": 1.90174326465927
        },
        {
            "Country": "Yemen",
            "Abs_contribution": 0.000600945164743904,
            "Perc_contribution": 0.46,
            "Fossil_abs": 0.000484358400013602,
            "Land_abs": 0.000116586764730301,
            "Fossil_fraction": 80.599433763647,
            "Land_fraction": 19.4005662363529,
            "Rank": 42,
            "Perc_contribution_rescale": 1.82250396196513
        },
        {
            "Country": "Kuwait",
            "Abs_contribution": 0.00059620706242538,
            "Perc_contribution": 0.46,
            "Fossil_abs": 0.00059199953472742,
            "Land_abs": 4.20752769796635e-06,
            "Fossil_fraction": 99.2942841567754,
            "Land_fraction": 0.705715843225684,
            "Rank": 43,
            "Perc_contribution_rescale": 1.82250396196513
        },
        {
            "Country": "Trinidad and Tobago",
            "Abs_contribution": 0.000595787664956525,
            "Perc_contribution": 0.46,
            "Fossil_abs": 0.000597278644828244,
            "Land_abs": -0.000001490979871717,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 44,
            "Perc_contribution_rescale": 1.82250396196513
        },
        {
            "Country": "Norway",
            "Abs_contribution": 0.000591016922948904,
            "Perc_contribution": 0.45,
            "Fossil_abs": 0.000590442175581004,
            "Land_abs": 5.74747367897995e-07,
            "Fossil_fraction": 99.90275280697,
            "Land_fraction": 0.097247193029646,
            "Rank": 45,
            "Perc_contribution_rescale": 1.78288431061807
        },
        {
            "Country": "Morocco",
            "Abs_contribution": 0.000582854025119299,
            "Perc_contribution": 0.45,
            "Fossil_abs": 0.000529924048696918,
            "Land_abs": 5.2929976422383e-05,
            "Fossil_fraction": 90.9188280184653,
            "Land_fraction": 9.08117198153504,
            "Rank": 46,
            "Perc_contribution_rescale": 1.78288431061807
        },
        {
            "Country": "Peru",
            "Abs_contribution": 0.00056834750073287,
            "Perc_contribution": 0.44,
            "Fossil_abs": 0.000307970354988557,
            "Land_abs": 0.000260377145744309,
            "Fossil_fraction": 54.1869814842921,
            "Land_fraction": 45.8130185157072,
            "Rank": 47,
            "Perc_contribution_rescale": 1.743264659271
        },
        {
            "Country": "Mali",
            "Abs_contribution": 0.000567774988644712,
            "Perc_contribution": 0.44,
            "Fossil_abs": 0.000101272544137652,
            "Land_abs": 0.000466502444507058,
            "Fossil_fraction": 17.8367392299881,
            "Land_fraction": 82.1632607700115,
            "Rank": 48,
            "Perc_contribution_rescale": 1.743264659271
        },
        {
            "Country": "Mozambique",
            "Abs_contribution": 0.000561204455143388,
            "Perc_contribution": 0.43,
            "Fossil_abs": 0.000376985238138736,
            "Land_abs": 0.000184219217004655,
            "Fossil_fraction": 67.1743131551613,
            "Land_fraction": 32.8256868448393,
            "Rank": 49,
            "Perc_contribution_rescale": 1.70364500792393
        },
        {
            "Country": "Cambodia",
            "Abs_contribution": 0.000551796019938925,
            "Perc_contribution": 0.42,
            "Fossil_abs": 0.000129742561599716,
            "Land_abs": 0.000422053458339211,
            "Fossil_fraction": 23.512775901152,
            "Land_fraction": 76.4872240988482,
            "Rank": 50,
            "Perc_contribution_rescale": 1.66402535657686
        },
        {
            "Country": "Niger",
            "Abs_contribution": 0.000541453375598622,
            "Perc_contribution": 0.42,
            "Fossil_abs": 0.00010943785288493,
            "Land_abs": 0.000432015522713692,
            "Fossil_fraction": 20.2118700920346,
            "Land_fraction": 79.7881299079653,
            "Rank": 51,
            "Perc_contribution_rescale": 1.66402535657686
        },
        {
            "Country": "Paraguay",
            "Abs_contribution": 0.000539058223720302,
            "Perc_contribution": 0.41,
            "Fossil_abs": 7.49090996278e-05,
            "Land_abs": 0.0004641491240925,
            "Fossil_fraction": 13.8962910371381,
            "Land_fraction": 86.1037089628616,
            "Rank": 52,
            "Perc_contribution_rescale": 1.62440570522979
        },
        {
            "Country": "Burkina Faso",
            "Abs_contribution": 0.000537769306589068,
            "Perc_contribution": 0.41,
            "Fossil_abs": 0.000152060793543708,
            "Land_abs": 0.000385708513045362,
            "Fossil_fraction": 28.2762128073448,
            "Land_fraction": 71.7237871926554,
            "Rank": 53,
            "Perc_contribution_rescale": 1.62440570522979
        },
        {
            "Country": "Ecuador",
            "Abs_contribution": 0.000514003846502557,
            "Perc_contribution": 0.39,
            "Fossil_abs": 0.000334372576658011,
            "Land_abs": 0.000179631269844544,
            "Fossil_fraction": 65.0525436595828,
            "Land_fraction": 34.9474563404168,
            "Rank": 54,
            "Perc_contribution_rescale": 1.54516640253566
        },
        {
            "Country": "Congo",
            "Abs_contribution": 0.000511143387178988,
            "Perc_contribution": 0.39,
            "Fossil_abs": 0.000482047462560683,
            "Land_abs": 2.90959246183029e-05,
            "Fossil_fraction": 94.3076785598487,
            "Land_fraction": 5.69232144015087,
            "Rank": 55,
            "Perc_contribution_rescale": 1.54516640253566
        },
        {
            "Country": "Australia",
            "Abs_contribution": 0.000510379019046841,
            "Perc_contribution": 0.39,
            "Fossil_abs": 0.0007135234858671,
            "Land_abs": -0.000203144466820239,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 56,
            "Perc_contribution_rescale": 1.54516640253566
        },
        {
            "Country": "Nepal",
            "Abs_contribution": 0.000470800251339862,
            "Perc_contribution": 0.36,
            "Fossil_abs": 0.000148504517221926,
            "Land_abs": 0.000322295734117932,
            "Fossil_fraction": 31.5429987132108,
            "Land_fraction": 68.4570012867883,
            "Rank": 57,
            "Perc_contribution_rescale": 1.42630744849445
        },
        {
            "Country": "Bahrain",
            "Abs_contribution": 0.000465887355201631,
            "Perc_contribution": 0.36,
            "Fossil_abs": 0.000465413997378023,
            "Land_abs": 4.73357823598156e-07,
            "Fossil_fraction": 99.8983965075843,
            "Land_fraction": 0.101603492413588,
            "Rank": 58,
            "Perc_contribution_rescale": 1.42630744849445
        },
        {
            "Country": "Cameroon",
            "Abs_contribution": 0.000461964526070201,
            "Perc_contribution": 0.35,
            "Fossil_abs": 0.000302916341679785,
            "Land_abs": 0.000159048184390421,
            "Fossil_fraction": 65.5713425133759,
            "Land_fraction": 34.4286574866252,
            "Rank": 59,
            "Perc_contribution_rescale": 1.38668779714738
        },
        {
            "Country": "Guinea",
            "Abs_contribution": 0.00046192363012008,
            "Perc_contribution": 0.35,
            "Fossil_abs": 0.000116403953257526,
            "Land_abs": 0.000345519676862557,
            "Fossil_fraction": 25.1998264793827,
            "Land_fraction": 74.8001735206179,
            "Rank": 60,
            "Perc_contribution_rescale": 1.38668779714738
        },
        {
            "Country": "Ghana",
            "Abs_contribution": 0.000453653648257697,
            "Perc_contribution": 0.35,
            "Fossil_abs": 0.000347150475552871,
            "Land_abs": 0.000106503172704821,
            "Fossil_fraction": 76.5232412185238,
            "Land_fraction": 23.4767587814751,
            "Rank": 61,
            "Perc_contribution_rescale": 1.38668779714738
        },
        {
            "Country": "Equatorial Guinea",
            "Abs_contribution": 0.000426610361070929,
            "Perc_contribution": 0.33,
            "Fossil_abs": 0.000426416654947283,
            "Land_abs": 1.93706123646047e-07,
            "Fossil_fraction": 99.9545941352292,
            "Land_fraction": 0.0454058647707905,
            "Rank": 62,
            "Perc_contribution_rescale": 1.30744849445325
        },
        {
            "Country": "Guatemala",
            "Abs_contribution": 0.000394622525206643,
            "Perc_contribution": 0.3,
            "Fossil_abs": 0.000266451039287524,
            "Land_abs": 0.000128171485919119,
            "Fossil_fraction": 67.5204840747491,
            "Land_fraction": 32.4795159252509,
            "Rank": 63,
            "Perc_contribution_rescale": 1.18858954041204
        },
        {
            "Country": "Zambia",
            "Abs_contribution": 0.000386666714360855,
            "Perc_contribution": 0.3,
            "Fossil_abs": 0.000176180396726889,
            "Land_abs": 0.000210486317633966,
            "Fossil_fraction": 45.563890085059,
            "Land_fraction": 54.436109914941,
            "Rank": 64,
            "Perc_contribution_rescale": 1.18858954041204
        },
        {
            "Country": "South Korea",
            "Abs_contribution": 0.00038520843338601,
            "Perc_contribution": 0.3,
            "Fossil_abs": 0.000335752131625273,
            "Land_abs": 4.945630176073e-05,
            "Fossil_fraction": 87.1611580966666,
            "Land_fraction": 12.8388419033315,
            "Rank": 65,
            "Perc_contribution_rescale": 1.18858954041204
        },
        {
            "Country": "Azerbaijan",
            "Abs_contribution": 0.000370340790919845,
            "Perc_contribution": 0.28,
            "Fossil_abs": 0.000324931678215581,
            "Land_abs": 4.5409112704267e-05,
            "Fossil_fraction": 87.7385603158978,
            "Land_fraction": 12.2614396841031,
            "Rank": 66,
            "Perc_contribution_rescale": 1.10935023771791
        },
        {
            "Country": "C\xf4te d'Ivoire",
            "Abs_contribution": 0.000359876032637688,
            "Perc_contribution": 0.28,
            "Fossil_abs": 0.000292502621532124,
            "Land_abs": 6.73734111055644e-05,
            "Fossil_fraction": 81.2787168370856,
            "Land_fraction": 18.7212831629146,
            "Rank": 67,
            "Perc_contribution_rescale": 1.10935023771791
        },
        {
            "Country": "Madagascar",
            "Abs_contribution": 0.000357377461280953,
            "Perc_contribution": 0.27,
            "Fossil_abs": 0.00024249941808249,
            "Land_abs": 0.000114878043198466,
            "Fossil_fraction": 67.8552635113853,
            "Land_fraction": 32.1447364886154,
            "Rank": 68,
            "Perc_contribution_rescale": 1.06973058637084
        },
        {
            "Country": "Somalia",
            "Abs_contribution": 0.000322713455057084,
            "Perc_contribution": 0.25,
            "Fossil_abs": 0.000184243032354497,
            "Land_abs": 0.000138470422702584,
            "Fossil_fraction": 57.0918347119759,
            "Land_fraction": 42.9081652880232,
            "Rank": 69,
            "Perc_contribution_rescale": 0.990491283676704
        },
        {
            "Country": "Afghanistan",
            "Abs_contribution": 0.000302852130198889,
            "Perc_contribution": 0.23,
            "Fossil_abs": 0.000133314057751544,
            "Land_abs": 0.000169538072447343,
            "Fossil_fraction": 44.0195212310357,
            "Land_fraction": 55.9804787689636,
            "Rank": 70,
            "Perc_contribution_rescale": 0.911251980982567
        },
        {
            "Country": "Uruguay",
            "Abs_contribution": 0.000298410589379901,
            "Perc_contribution": 0.23,
            "Fossil_abs": 0.000132486952809437,
            "Land_abs": 0.000165923636570464,
            "Fossil_fraction": 44.3975373275949,
            "Land_fraction": 55.6024626724053,
            "Rank": 71,
            "Perc_contribution_rescale": 0.911251980982567
        },
        {
            "Country": "Chile",
            "Abs_contribution": 0.000280133195527029,
            "Perc_contribution": 0.22,
            "Fossil_abs": 0.000267523144467959,
            "Land_abs": 1.2610051059069e-05,
            "Fossil_fraction": 95.4985516674145,
            "Land_fraction": 4.50144833258517,
            "Rank": 72,
            "Perc_contribution_rescale": 0.871632329635499
        },
        {
            "Country": "Gabon",
            "Abs_contribution": 0.000275175226613723,
            "Perc_contribution": 0.21,
            "Fossil_abs": 0.000269043713413254,
            "Land_abs": 6.13151320046595e-06,
            "Fossil_fraction": 97.7717786314114,
            "Land_fraction": 2.22822136858746,
            "Rank": 73,
            "Perc_contribution_rescale": 0.832012678288431
        },
        {
            "Country": "Taiwan",
            "Abs_contribution": 0.000264077593333458,
            "Perc_contribution": 0.2,
            "Fossil_abs": 0.000320693705143473,
            "Land_abs": -0.000056616111810013,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 74,
            "Perc_contribution_rescale": 0.792393026941363
        },
        {
            "Country": "Central African Republic",
            "Abs_contribution": 0.000246605791690207,
            "Perc_contribution": 0.19,
            "Fossil_abs": 2.72546266257566e-05,
            "Land_abs": 0.00021935116506445,
            "Fossil_fraction": 11.0519004598216,
            "Land_fraction": 88.9480995401782,
            "Rank": 75,
            "Perc_contribution_rescale": 0.752773375594295
        },
        {
            "Country": "Dominican Republic",
            "Abs_contribution": 0.000216535858734555,
            "Perc_contribution": 0.17,
            "Fossil_abs": 0.000110247728875095,
            "Land_abs": 0.000106288129859459,
            "Fossil_fraction": 50.9143056117299,
            "Land_fraction": 49.0856943882697,
            "Rank": 76,
            "Perc_contribution_rescale": 0.673534072900159
        },
        {
            "Country": "Laos",
            "Abs_contribution": 0.000216312455500199,
            "Perc_contribution": 0.17,
            "Fossil_abs": 6.85499010103101e-05,
            "Land_abs": 0.000147762554489889,
            "Fossil_fraction": 31.6902236867479,
            "Land_fraction": 68.3097763132521,
            "Rank": 77,
            "Perc_contribution_rescale": 0.673534072900159
        },
        {
            "Country": "Nicaragua",
            "Abs_contribution": 0.000210990541096994,
            "Perc_contribution": 0.16,
            "Fossil_abs": 5.11390186375617e-05,
            "Land_abs": 0.000159851522459432,
            "Fossil_fraction": 24.2375882689702,
            "Land_fraction": 75.7624117310297,
            "Rank": 78,
            "Perc_contribution_rescale": 0.63391442155309
        },
        {
            "Country": "Haiti",
            "Abs_contribution": 0.000208408000729415,
            "Perc_contribution": 0.16,
            "Fossil_abs": 0.000160857978937083,
            "Land_abs": 4.75500217923313e-05,
            "Fossil_fraction": 77.184166814177,
            "Land_fraction": 22.8158331858226,
            "Rank": 79,
            "Perc_contribution_rescale": 0.63391442155309
        },
        {
            "Country": "Senegal",
            "Abs_contribution": 0.000205402459114925,
            "Perc_contribution": 0.16,
            "Fossil_abs": 7.82816734152598e-05,
            "Land_abs": 0.000127120785699665,
            "Fossil_fraction": 38.1113613500899,
            "Land_fraction": 61.88863864991,
            "Rank": 80,
            "Perc_contribution_rescale": 0.63391442155309
        },
        {
            "Country": "Syria",
            "Abs_contribution": 0.000202450563581918,
            "Perc_contribution": 0.16,
            "Fossil_abs": 0.000126829010143517,
            "Land_abs": 7.56215534384015e-05,
            "Fossil_fraction": 62.6469039648773,
            "Land_fraction": 37.353096035123,
            "Rank": 81,
            "Perc_contribution_rescale": 0.63391442155309
        },
        {
            "Country": "Bolivia",
            "Abs_contribution": 0.00020152308512773,
            "Perc_contribution": 0.15,
            "Fossil_abs": -0.000181073162839139,
            "Land_abs": 0.000382596247966868,
            "Fossil_fraction": 0,
            "Land_fraction": 100,
            "Rank": 82,
            "Perc_contribution_rescale": 0.594294770206022
        },
        {
            "Country": "Tunisia",
            "Abs_contribution": 0.000192702119423802,
            "Perc_contribution": 0.15,
            "Fossil_abs": 0.000168068419016392,
            "Land_abs": 2.46337004074112e-05,
            "Fossil_fraction": 87.216694615987,
            "Land_fraction": 12.7833053840136,
            "Rank": 83,
            "Perc_contribution_rescale": 0.594294770206022
        },
        {
            "Country": "New Zealand",
            "Abs_contribution": 0.00018968995617488,
            "Perc_contribution": 0.15,
            "Fossil_abs": 0.000101221967131214,
            "Land_abs": 8.84679890436602e-05,
            "Fossil_fraction": 53.3617958337736,
            "Land_fraction": 46.6382041662234,
            "Rank": 84,
            "Perc_contribution_rescale": 0.594294770206022
        },
        {
            "Country": "Mauritania",
            "Abs_contribution": 0.000183202079279753,
            "Perc_contribution": 0.14,
            "Fossil_abs": 4.38103207434182e-05,
            "Land_abs": 0.000139391758536334,
            "Fossil_fraction": 23.9136591220229,
            "Land_fraction": 76.0863408779767,
            "Rank": 85,
            "Perc_contribution_rescale": 0.554675118858954
        },
        {
            "Country": "Malawi",
            "Abs_contribution": 0.00017638938195398,
            "Perc_contribution": 0.14,
            "Fossil_abs": 0.000110603254853196,
            "Land_abs": 6.57861271007832e-05,
            "Fossil_fraction": 62.7040321973871,
            "Land_fraction": 37.2959678026123,
            "Rank": 86,
            "Perc_contribution_rescale": 0.554675118858954
        },
        {
            "Country": "Jordan",
            "Abs_contribution": 0.000169272795884737,
            "Perc_contribution": 0.13,
            "Fossil_abs": 0.000156121549735941,
            "Land_abs": 1.31512461487966e-05,
            "Fossil_fraction": 92.2307385070006,
            "Land_fraction": 7.76926149299955,
            "Rank": 87,
            "Perc_contribution_rescale": 0.515055467511886
        },
        {
            "Country": "Honduras",
            "Abs_contribution": 0.00016861593929813,
            "Perc_contribution": 0.13,
            "Fossil_abs": 0.000112067772520755,
            "Land_abs": 5.6548166777375e-05,
            "Fossil_fraction": 66.4633325812737,
            "Land_fraction": 33.5366674187261,
            "Rank": 88,
            "Perc_contribution_rescale": 0.515055467511886
        },
        {
            "Country": "Benin",
            "Abs_contribution": 0.000165622020180131,
            "Perc_contribution": 0.13,
            "Fossil_abs": 9.26809387227865e-05,
            "Land_abs": 7.29410814573444e-05,
            "Fossil_fraction": 55.9593094094532,
            "Land_fraction": 44.0406905905468,
            "Rank": 89,
            "Perc_contribution_rescale": 0.515055467511886
        },
        {
            "Country": "Singapore",
            "Abs_contribution": 0.000159515290360969,
            "Perc_contribution": 0.12,
            "Fossil_abs": 0.000166688642808307,
            "Land_abs": -0.0000071733524473383,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 90,
            "Perc_contribution_rescale": 0.475435816164818
        },
        {
            "Country": "Zimbabwe",
            "Abs_contribution": 0.000155669507868522,
            "Perc_contribution": 0.12,
            "Fossil_abs": 0.00010842048683638,
            "Land_abs": 4.7249021032143e-05,
            "Fossil_fraction": 69.6478638115511,
            "Land_fraction": 30.3521361884496,
            "Rank": 91,
            "Perc_contribution_rescale": 0.475435816164818
        },
        {
            "Country": "Togo",
            "Abs_contribution": 0.000140652384706074,
            "Perc_contribution": 0.11,
            "Fossil_abs": 0.000107333239656815,
            "Land_abs": 3.33191450492602e-05,
            "Fossil_fraction": 76.3109988366801,
            "Land_fraction": 23.6890011633207,
            "Rank": 92,
            "Perc_contribution_rescale": 0.43581616481775
        },
        {
            "Country": "Papua New Guinea",
            "Abs_contribution": 0.000124645282422472,
            "Perc_contribution": 0.1,
            "Fossil_abs": 0.000103471597942037,
            "Land_abs": 2.11736844804339e-05,
            "Fossil_fraction": 83.0128472823635,
            "Land_fraction": 16.9871527176359,
            "Rank": 93,
            "Perc_contribution_rescale": 0.396196513470682
        },
        {
            "Country": "Sri Lanka",
            "Abs_contribution": 0.000110549278317074,
            "Perc_contribution": 0.08,
            "Fossil_abs": 0.000116318280563365,
            "Land_abs": -0.00000576900224628999,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 94,
            "Perc_contribution_rescale": 0.316957210776545
        },
        {
            "Country": "Hong Kong",
            "Abs_contribution": 0.000108689540434991,
            "Perc_contribution": 0.08,
            "Fossil_abs": 0.000110955902862673,
            "Land_abs": -0.00000226636242768335,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 95,
            "Perc_contribution_rescale": 0.316957210776545
        },
        {
            "Country": "Sierra Leone",
            "Abs_contribution": 0.000105789181090749,
            "Perc_contribution": 0.08,
            "Fossil_abs": 5.43282351218038e-05,
            "Land_abs": 5.14609459689451e-05,
            "Fossil_fraction": 51.3551901637272,
            "Land_fraction": 48.6448098362728,
            "Rank": 96,
            "Perc_contribution_rescale": 0.316957210776545
        },
        {
            "Country": "Brunei Darussalam",
            "Abs_contribution": 0.000102110760734264,
            "Perc_contribution": 0.08,
            "Fossil_abs": 0.000102465851889497,
            "Land_abs": -0.00000035509115523325,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 97,
            "Perc_contribution_rescale": 0.316957210776545
        },
        {
            "Country": "Ireland",
            "Abs_contribution": 0.000101711538022379,
            "Perc_contribution": 0.08,
            "Fossil_abs": -0.000027278492776863,
            "Land_abs": 0.000128990030799243,
            "Fossil_fraction": 0,
            "Land_fraction": 100,
            "Rank": 98,
            "Perc_contribution_rescale": 0.316957210776545
        },
        {
            "Country": "Lebanon",
            "Abs_contribution": 9.67174575290367e-05,
            "Perc_contribution": 0.07,
            "Fossil_abs": 9.24449905574582e-05,
            "Land_abs": 4.27246697157923e-06,
            "Fossil_fraction": 95.5825276214526,
            "Land_fraction": 4.41747237854815,
            "Rank": 99,
            "Perc_contribution_rescale": 0.277337559429477
        },
        {
            "Country": "Namibia",
            "Abs_contribution": 9.3371905545982e-05,
            "Perc_contribution": 0.07,
            "Fossil_abs": 3.13858541825844e-05,
            "Land_abs": 6.1986051363398e-05,
            "Fossil_fraction": 33.6138092063764,
            "Land_fraction": 66.386190793624,
            "Rank": 100,
            "Perc_contribution_rescale": 0.277337559429477
        },
        {
            "Country": "Burundi",
            "Abs_contribution": 9.10674870637452e-05,
            "Perc_contribution": 0.07,
            "Fossil_abs": 7.15265718234016e-05,
            "Land_abs": 1.95409152403436e-05,
            "Fossil_fraction": 78.5423800849304,
            "Land_fraction": 21.4576199150696,
            "Rank": 101,
            "Perc_contribution_rescale": 0.277337559429477
        },
        {
            "Country": "Botswana",
            "Abs_contribution": 9.094763564038e-05,
            "Perc_contribution": 0.07,
            "Fossil_abs": 4.62584818739369e-05,
            "Land_abs": 4.4689153766443e-05,
            "Fossil_fraction": 50.8627646537724,
            "Land_fraction": 49.1372353462275,
            "Rank": 102,
            "Perc_contribution_rescale": 0.277337559429477
        },
        {
            "Country": "Timor-Leste",
            "Abs_contribution": 8.97563503395245e-05,
            "Perc_contribution": 0.07,
            "Fossil_abs": 7.24417713621717e-05,
            "Land_abs": 1.73145789773528e-05,
            "Fossil_fraction": 80.709354923795,
            "Land_fraction": 19.290645076205,
            "Rank": 103,
            "Perc_contribution_rescale": 0.277337559429477
        },
        {
            "Country": "Greece",
            "Abs_contribution": 8.4867843156036e-05,
            "Perc_contribution": 0.07,
            "Fossil_abs": 0.000101075973002434,
            "Land_abs": -0.000016208129846398,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 104,
            "Perc_contribution_rescale": 0.277337559429477
        },
        {
            "Country": "Eritrea",
            "Abs_contribution": 8.3288782078639e-05,
            "Perc_contribution": 0.06,
            "Fossil_abs": 3.4507736456831e-05,
            "Land_abs": 4.87810456218081e-05,
            "Fossil_fraction": 41.431433616414,
            "Land_fraction": 58.5685663835862,
            "Rank": 105,
            "Perc_contribution_rescale": 0.237717908082409
        },
        {
            "Country": "Tajikistan",
            "Abs_contribution": 8.0620112435021e-05,
            "Perc_contribution": 0.06,
            "Fossil_abs": 3.24306450710555e-05,
            "Land_abs": 4.8189467363966e-05,
            "Fossil_fraction": 40.226494470836,
            "Land_fraction": 59.7735055291646,
            "Rank": 106,
            "Perc_contribution_rescale": 0.237717908082409
        },
        {
            "Country": "Liberia",
            "Abs_contribution": 6.86739416527921e-05,
            "Perc_contribution": 0.05,
            "Fossil_abs": 6.77641513020396e-05,
            "Land_abs": 9.09790350752539e-07,
            "Fossil_fraction": 98.6752029534691,
            "Land_fraction": 1.32479704653089,
            "Rank": 107,
            "Perc_contribution_rescale": 0.198098256735341
        },
        {
            "Country": "Panama",
            "Abs_contribution": 6.5467813960294e-05,
            "Perc_contribution": 0.05,
            "Fossil_abs": 4.26793409859971e-05,
            "Land_abs": 2.27884729742967e-05,
            "Fossil_fraction": 65.1913335794013,
            "Land_fraction": 34.8086664205984,
            "Rank": 108,
            "Perc_contribution_rescale": 0.198098256735341
        },
        {
            "Country": "North Korea",
            "Abs_contribution": 6.0446340910921e-05,
            "Perc_contribution": 0.05,
            "Fossil_abs": 6.9773785955732e-05,
            "Land_abs": -0.00000932744504481198,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 109,
            "Perc_contribution_rescale": 0.198098256735341
        },
        {
            "Country": "Portugal",
            "Abs_contribution": 5.2125675336834e-05,
            "Perc_contribution": 0.04,
            "Fossil_abs": 4.825692106966e-05,
            "Land_abs": 3.868754267173e-06,
            "Fossil_fraction": 92.5780256233146,
            "Land_fraction": 7.42197437668339,
            "Rank": 110,
            "Perc_contribution_rescale": 0.158478605388273
        },
        {
            "Country": "Guinea-Bissau",
            "Abs_contribution": 4.38640075365695e-05,
            "Perc_contribution": 0.03,
            "Fossil_abs": 2.15004182656323e-05,
            "Land_abs": 2.23635892709374e-05,
            "Fossil_fraction": 49.0160828276061,
            "Land_fraction": 50.9839171723943,
            "Rank": 111,
            "Perc_contribution_rescale": 0.118858954041204
        },
        {
            "Country": "Rwanda",
            "Abs_contribution": 3.6227914008562e-05,
            "Perc_contribution": 0.03,
            "Fossil_abs": -0.00000579171390357601,
            "Land_abs": 4.20196279121372e-05,
            "Fossil_fraction": 0,
            "Land_fraction": 100,
            "Rank": 112,
            "Perc_contribution_rescale": 0.118858954041204
        },
        {
            "Country": "Costa Rica",
            "Abs_contribution": 3.6087244085007e-05,
            "Perc_contribution": 0.03,
            "Fossil_abs": 6.15416773514859e-05,
            "Land_abs": -0.000025454433266479,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 113,
            "Perc_contribution_rescale": 0.118858954041204
        },
        {
            "Country": "Gambia",
            "Abs_contribution": 3.41529413957806e-05,
            "Perc_contribution": 0.03,
            "Fossil_abs": 1.63069686027854e-05,
            "Land_abs": 1.78459727929952e-05,
            "Fossil_fraction": 47.7468936388596,
            "Land_fraction": 52.2531063611404,
            "Rank": 114,
            "Perc_contribution_rescale": 0.118858954041204
        },
        {
            "Country": "Cuba",
            "Abs_contribution": 3.2620849330601e-05,
            "Perc_contribution": 0.03,
            "Fossil_abs": 7.4907565149389e-05,
            "Land_abs": -0.000042286715818785,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 115,
            "Perc_contribution_rescale": 0.118858954041204
        },
        {
            "Country": "El Salvador",
            "Abs_contribution": 3.0926559641753e-05,
            "Perc_contribution": 0.02,
            "Fossil_abs": 2.61333684881461e-05,
            "Land_abs": 4.79319115360741e-06,
            "Fossil_fraction": 84.5013761338789,
            "Land_fraction": 15.4986238661227,
            "Rank": 116,
            "Perc_contribution_rescale": 0.0792393026941363
        },
        {
            "Country": "Djibouti",
            "Abs_contribution": 2.88264465309427e-05,
            "Perc_contribution": 0.02,
            "Fossil_abs": 1.72286016762047e-05,
            "Land_abs": 1.1597844854738e-05,
            "Fossil_fraction": 59.7666509387875,
            "Land_fraction": 40.2333490612126,
            "Rank": 117,
            "Perc_contribution_rescale": 0.0792393026941363
        },
        {
            "Country": "Bhutan",
            "Abs_contribution": 2.35777500707698e-05,
            "Perc_contribution": 0.02,
            "Fossil_abs": 2.19992396502681e-05,
            "Land_abs": 1.5785104205017e-06,
            "Fossil_fraction": 93.3050845998294,
            "Land_fraction": 6.69491540017059,
            "Rank": 118,
            "Perc_contribution_rescale": 0.0792393026941363
        },
        {
            "Country": "Lesotho",
            "Abs_contribution": 1.96703973859891e-05,
            "Perc_contribution": 0.02,
            "Fossil_abs": 1.67938381877133e-05,
            "Land_abs": 2.8765591982761e-06,
            "Fossil_fraction": 85.3762019046716,
            "Land_fraction": 14.6237980953299,
            "Rank": 119,
            "Perc_contribution_rescale": 0.0792393026941363
        },
        {
            "Country": "Cyprus",
            "Abs_contribution": 1.77701104685767e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 1.47955678687776e-05,
            "Land_abs": 2.9745425997991e-06,
            "Fossil_fraction": 83.2609785681465,
            "Land_fraction": 16.7390214318535,
            "Rank": 120,
            "Perc_contribution_rescale": 0.0396196513470682
        },
        {
            "Country": "Guyana",
            "Abs_contribution": 1.77013193573785e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 1.7327211483697e-06,
            "Land_abs": 1.59685982090087e-05,
            "Fossil_fraction": 9.78865537301006,
            "Land_fraction": 90.2113446269894,
            "Rank": 121,
            "Perc_contribution_rescale": 0.0396196513470682
        },
        {
            "Country": "Fiji",
            "Abs_contribution": 1.28813411557923e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 9.23544458564307e-06,
            "Land_abs": 3.6458965701491e-06,
            "Fossil_fraction": 71.6962967904177,
            "Land_fraction": 28.3037032095813,
            "Rank": 122,
            "Perc_contribution_rescale": 0.0396196513470682
        },
        {
            "Country": "Suriname",
            "Abs_contribution": 1.18067591693573e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 1.15436778179605e-05,
            "Land_abs": 2.63081351396798e-07,
            "Fossil_fraction": 97.771773374699,
            "Land_fraction": 2.22822662530109,
            "Rank": 123,
            "Perc_contribution_rescale": 0.0396196513470682
        },
        {
            "Country": "Comoros",
            "Abs_contribution": 1.17594265191932e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 8.39716622047498e-06,
            "Land_abs": 3.36226029871821e-06,
            "Fossil_fraction": 71.4079568996796,
            "Land_fraction": 28.5920431003202,
            "Rank": 124,
            "Perc_contribution_rescale": 0.0396196513470682
        },
        {
            "Country": "Croatia",
            "Abs_contribution": 1.1593121958511e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 4.91800834314997e-05,
            "Land_abs": -0.0000375869614729882,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 125,
            "Perc_contribution_rescale": 0.0396196513470682
        },
        {
            "Country": "Belize",
            "Abs_contribution": 1.09153984149603e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 7.64658826737963e-06,
            "Land_abs": 3.26881014758076e-06,
            "Fossil_fraction": 70.0532218494145,
            "Land_fraction": 29.9467781505861,
            "Rank": 126,
            "Perc_contribution_rescale": 0.0396196513470682
        },
        {
            "Country": "Kyrgyzstan",
            "Abs_contribution": 9.922167057477e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 7.619681911776e-06,
            "Land_abs": 2.30248514570099e-06,
            "Fossil_fraction": 76.7945335694995,
            "Land_fraction": 23.2054664305003,
            "Rank": 127,
            "Perc_contribution_rescale": 0.0396196513470682
        },
        {
            "Country": "Mauritius",
            "Abs_contribution": 7.9333284295005e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 8.7425562444215e-06,
            "Land_abs": -0.00000080922781492103,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 128,
            "Perc_contribution_rescale": 0.0396196513470682
        },
        {
            "Country": "Bahamas",
            "Abs_contribution": 7.80513496132323e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 7.74425051853002e-06,
            "Land_abs": 6.0884442793199e-08,
            "Fossil_fraction": 99.2199437537607,
            "Land_fraction": 0.78005624623917,
            "Rank": 129,
            "Perc_contribution_rescale": 0.0396196513470682
        },
        {
            "Country": "Vanuatu",
            "Abs_contribution": 7.1848823106011e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 2.8186101029988e-06,
            "Land_abs": 4.36627220760233e-06,
            "Fossil_fraction": 39.2297323901885,
            "Land_fraction": 60.770267609812,
            "Rank": 130,
            "Perc_contribution_rescale": 0.0396196513470682
        },
        {
            "Country": "Swaziland",
            "Abs_contribution": 6.22889823225281e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 4.4509892203455e-06,
            "Land_abs": 1.7779090119075e-06,
            "Fossil_fraction": 71.4570868616633,
            "Land_fraction": 28.5429131383398,
            "Rank": 131,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Bosnia and Herzegovina",
            "Abs_contribution": 5.87824032228799e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 2.276350692047e-05,
            "Land_abs": -0.0000168852665981819,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 132,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Jamaica",
            "Abs_contribution": 5.23511547614e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 9.2149052645583e-06,
            "Land_abs": -0.0000039797897884184,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 133,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Cape Verde",
            "Abs_contribution": 4.80173546183312e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 3.34465113826711e-06,
            "Land_abs": 1.45708432356602e-06,
            "Fossil_fraction": 69.6550479478153,
            "Land_fraction": 30.3449520521849,
            "Rank": 134,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Maldives",
            "Abs_contribution": 4.56425699618126e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 4.56415453698923e-06,
            "Land_abs": 1.02459192036602e-10,
            "Fossil_fraction": 99.9977551835465,
            "Land_fraction": 0.00224481645363804,
            "Rank": 135,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Solomon Islands",
            "Abs_contribution": 4.23047228067307e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 4.26164186857643e-06,
            "Land_abs": -0.0000000311695879033603,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 136,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Malta",
            "Abs_contribution": 3.80290228177222e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 3.27121691369492e-06,
            "Land_abs": 5.316853680773e-07,
            "Fossil_fraction": 86.0189579252211,
            "Land_fraction": 13.9810420747789,
            "Rank": 137,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Samoa",
            "Abs_contribution": 3.24995739247507e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 6.4490509607652e-07,
            "Land_abs": 2.60505229639859e-06,
            "Fossil_fraction": 19.8434938737883,
            "Land_fraction": 80.1565061262129,
            "Rank": 138,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Iceland",
            "Abs_contribution": 3.1151977130419e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 3.91869582169466e-06,
            "Land_abs": -0.0000008034981086529,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 139,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Macao",
            "Abs_contribution": 2.42768068297268e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 2.4193667954412e-06,
            "Land_abs": 8.31388753148645e-09,
            "Fossil_fraction": 99.6575378471398,
            "Land_fraction": 0.342462152860488,
            "Rank": 140,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Micronesia (Federated States of)",
            "Abs_contribution": 2.04724598730068e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 5.9302467006051e-08,
            "Land_abs": 1.98794352029463e-06,
            "Fossil_fraction": 2.89669474864826,
            "Land_fraction": 97.1033052513518,
            "Rank": 141,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Sao Tome and Principe",
            "Abs_contribution": 1.80226017460449e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.73896245566761e-06,
            "Land_abs": 6.3297718936874e-08,
            "Fossil_fraction": 96.487870073988,
            "Land_fraction": 3.51212992601164,
            "Rank": 142,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Andorra",
            "Abs_contribution": 1.47869281688492e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 5.2848622714746e-07,
            "Land_abs": 9.5020658973745e-07,
            "Fossil_fraction": 35.7400956515629,
            "Land_fraction": 64.2599043484365,
            "Rank": 143,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Seychelles",
            "Abs_contribution": 1.31647511350562e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.37537654624255e-06,
            "Land_abs": -0.0000000589014327369319,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 144,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Dominica",
            "Abs_contribution": 1.12645780710667e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 5.7457987504415e-07,
            "Land_abs": 5.51877932062537e-07,
            "Fossil_fraction": 51.0076694767619,
            "Land_fraction": 48.9923305232396,
            "Rank": 145,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Lucia",
            "Abs_contribution": 8.3126522010932e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 6.9347316994832e-07,
            "Land_abs": 1.3779205016101e-07,
            "Fossil_fraction": 83.4238162709515,
            "Land_fraction": 16.5761837290497,
            "Rank": 146,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Tonga",
            "Abs_contribution": 8.2484186202256e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 2.5104544466249e-07,
            "Land_abs": 5.7379641736007e-07,
            "Fossil_fraction": 30.4355848340326,
            "Land_fraction": 69.5644151659675,
            "Rank": 147,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Vincent and the Grenadines",
            "Abs_contribution": 7.5390431678336e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 8.67899926411349e-07,
            "Land_abs": -0.000000113995609627992,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 148,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Kiribati",
            "Abs_contribution": 6.28088236063577e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 5.46334208516239e-07,
            "Land_abs": 8.1754027547332e-08,
            "Fossil_fraction": 86.9836715841526,
            "Land_fraction": 13.0163284158464,
            "Rank": 149,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Grenada",
            "Abs_contribution": 5.1687651844616e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 5.5755804440209e-07,
            "Land_abs": -0.000000040681525955948,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 150,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Turks and Caicos Islands",
            "Abs_contribution": 4.36670817178578e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 4.36258347440587e-07,
            "Land_abs": 4.12469737991267e-10,
            "Fossil_fraction": 99.9055421791967,
            "Land_fraction": 0.0944578208033961,
            "Rank": 151,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Cook Islands",
            "Abs_contribution": 2.95707848836468e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 7.1022850283114e-08,
            "Land_abs": 2.24684998553353e-07,
            "Fossil_fraction": 24.0179117877899,
            "Land_fraction": 75.9820882122098,
            "Rank": 152,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Antigua and Barbuda",
            "Abs_contribution": 2.4995124644806e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 3.2130854710784e-07,
            "Land_abs": -0.000000071357300659782,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 153,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Kitts and Nevis",
            "Abs_contribution": 2.37667884768631e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 3.1042136780898e-07,
            "Land_abs": -0.00000007275348304035,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 154,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Tuvalu",
            "Abs_contribution": 1.98788411263285e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 6.58164481340973e-08,
            "Land_abs": 1.32971963129188e-07,
            "Fossil_fraction": 33.108795284312,
            "Land_fraction": 66.8912047156881,
            "Rank": 155,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Nauru",
            "Abs_contribution": 8.27079540679299e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 6.14568732018278e-08,
            "Land_abs": 2.12510808661023e-08,
            "Fossil_fraction": 74.3058801229104,
            "Land_fraction": 25.6941198770898,
            "Rank": 156,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Liechtenstein",
            "Abs_contribution": 3.091624508955e-08,
            "Perc_contribution": 0,
            "Fossil_abs": -0.000000012900760759086,
            "Land_abs": 4.38170058486309e-08,
            "Fossil_fraction": 0,
            "Land_fraction": 100,
            "Rank": 157,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Anguilla",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 158,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Antarctica",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 159,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Aruba",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 160,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Bermuda",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 161,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Bonaire, Saint Eustatius and Saba",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 162,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "British Virgin Islands",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 163,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Christmas Island",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 164,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Cura\xe7ao",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 165,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Faeroe Islands",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 166,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "French Polynesia",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 167,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Greenland",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 168,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Kosovo",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 169,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Kuwaiti Oil Fires",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 170,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Leeward Islands",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 171,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Marshall Islands",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 172,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Montserrat",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 173,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "New Caledonia",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 174,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Occupied Palestinian Territory",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 175,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Pacific Islands (Palau)",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 176,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Panama Canal Zone",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 177,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Ryukyu Islands",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 178,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Helena",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 179,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Pierre and Miquelon",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 180,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Sint Maarten (Dutch part)",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 181,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "St. Kitts-Nevis-Anguilla",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 182,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Wallis and Futuna Islands",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 183,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Niue",
            "Abs_contribution": -0.0000000125933634752862,
            "Perc_contribution": -0,
            "Fossil_abs": -0.00000000414397245471287,
            "Land_abs": -0.0000000084493910205735,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 184,
            "Perc_contribution_rescale": -0
        },
        {
            "Country": "Barbados",
            "Abs_contribution": -0.00000101078436666682,
            "Perc_contribution": -0,
            "Fossil_abs": -0.00000042391736585416,
            "Land_abs": -0.000000586867000812708,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 185,
            "Perc_contribution_rescale": -0
        },
        {
            "Country": "Luxembourg",
            "Abs_contribution": -0.0000014142861338246,
            "Perc_contribution": -0,
            "Fossil_abs": -0.00000196022538334872,
            "Land_abs": 5.459392495241e-07,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 186,
            "Perc_contribution_rescale": -0
        },
        {
            "Country": "Armenia",
            "Abs_contribution": -0.0000018098440942488,
            "Perc_contribution": -0,
            "Fossil_abs": -0.000000967596066218999,
            "Land_abs": -0.000000842248028029501,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 187,
            "Perc_contribution_rescale": -0
        },
        {
            "Country": "Palau",
            "Abs_contribution": -0.00000247745689053796,
            "Perc_contribution": -0,
            "Fossil_abs": -0.00000272492836425182,
            "Land_abs": 2.47471473713864e-07,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 188,
            "Perc_contribution_rescale": -0
        },
        {
            "Country": "Estonia",
            "Abs_contribution": -0.00000380049707970499,
            "Perc_contribution": -0,
            "Fossil_abs": 3.6613453746637e-05,
            "Land_abs": -0.0000404139508263426,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 189,
            "Perc_contribution_rescale": -0
        },
        {
            "Country": "Georgia",
            "Abs_contribution": -0.00000529489014403599,
            "Perc_contribution": -0,
            "Fossil_abs": -0.0000010678241767397,
            "Land_abs": -0.0000042270659672964,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 190,
            "Perc_contribution_rescale": -0
        },
        {
            "Country": "Montenegro",
            "Abs_contribution": -0.0000113963418138098,
            "Perc_contribution": -0.01,
            "Fossil_abs": 6.1006764042111e-06,
            "Land_abs": -0.000017497018218021,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 191,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Slovenia",
            "Abs_contribution": -0.000013146221185428,
            "Perc_contribution": -0.01,
            "Fossil_abs": 1.12845508550489e-05,
            "Land_abs": -0.0000244307720404769,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 192,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Finland",
            "Abs_contribution": -0.000016293689949794,
            "Perc_contribution": -0.01,
            "Fossil_abs": 5.4276075373971e-05,
            "Land_abs": -0.000070569765323767,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 193,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Albania",
            "Abs_contribution": -0.000019379887159968,
            "Perc_contribution": -0.01,
            "Fossil_abs": -0.0000402951417538405,
            "Land_abs": 2.09152545938723e-05,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 194,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "North Macedonia",
            "Abs_contribution": -0.0000196068218082368,
            "Perc_contribution": -0.02,
            "Fossil_abs": 1.05090900622267e-05,
            "Land_abs": -0.0000301159118704629,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 195,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Sweden",
            "Abs_contribution": -0.000024194896467398,
            "Perc_contribution": -0.02,
            "Fossil_abs": 1.0758672721822e-05,
            "Land_abs": -0.000034953569189223,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 196,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Denmark",
            "Abs_contribution": -0.000027350544729098,
            "Perc_contribution": -0.02,
            "Fossil_abs": 2.2200079760079e-05,
            "Land_abs": -0.000049550624489177,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 197,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Switzerland",
            "Abs_contribution": -0.00004417008114732,
            "Perc_contribution": -0.03,
            "Fossil_abs": -0.0000143033268367876,
            "Land_abs": -0.000029866754310532,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 198,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Latvia",
            "Abs_contribution": -0.0000467879932474304,
            "Perc_contribution": -0.04,
            "Fossil_abs": 2.34660128790184e-05,
            "Land_abs": -0.0000702540061264488,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 199,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Moldova",
            "Abs_contribution": -0.0000606338108849306,
            "Perc_contribution": -0.05,
            "Fossil_abs": 1.01801579984517e-05,
            "Land_abs": -0.0000708139688833819,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 200,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Lithuania",
            "Abs_contribution": -0.000093929587709311,
            "Perc_contribution": -0.07,
            "Fossil_abs": 1.86869484022104e-05,
            "Land_abs": -0.00011261653611152,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 201,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Belarus",
            "Abs_contribution": -0.000111431071768166,
            "Perc_contribution": -0.09,
            "Fossil_abs": 0.000123945043913312,
            "Land_abs": -0.000235376115681476,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 202,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Slovakia",
            "Abs_contribution": -0.000112167543651256,
            "Perc_contribution": -0.09,
            "Fossil_abs": -0.000015501785979905,
            "Land_abs": -0.000096665757671351,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 203,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Serbia",
            "Abs_contribution": -0.000125939277046891,
            "Perc_contribution": -0.1,
            "Fossil_abs": 4.5594249630652e-05,
            "Land_abs": -0.000171533526677542,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 204,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Austria",
            "Abs_contribution": -0.000149571576021418,
            "Perc_contribution": -0.11,
            "Fossil_abs": -0.000094549039092514,
            "Land_abs": -0.000055022536928902,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 205,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Hungary",
            "Abs_contribution": -0.000181582222066613,
            "Perc_contribution": -0.14,
            "Fossil_abs": -0.000058236777000053,
            "Land_abs": -0.000123345445066562,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 206,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Belgium",
            "Abs_contribution": -0.000188179596482485,
            "Perc_contribution": -0.14,
            "Fossil_abs": -0.000167752313859192,
            "Land_abs": -0.000020427282623294,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 207,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Italy",
            "Abs_contribution": -0.00021920132725278,
            "Perc_contribution": -0.17,
            "Fossil_abs": -0.00007531469717081,
            "Land_abs": -0.000143886630081971,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 208,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Israel",
            "Abs_contribution": -0.000230901245966221,
            "Perc_contribution": -0.18,
            "Fossil_abs": -0.000248077313550068,
            "Land_abs": 1.71760675838443e-05,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 209,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Czechia",
            "Abs_contribution": -0.00032595655300611,
            "Perc_contribution": -0.25,
            "Fossil_abs": -0.000158380707375695,
            "Land_abs": -0.000167575845630413,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 210,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Bulgaria",
            "Abs_contribution": -0.000380444224966488,
            "Perc_contribution": -0.29,
            "Fossil_abs": -0.000205881448683125,
            "Land_abs": -0.000174562776283363,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 211,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Netherlands",
            "Abs_contribution": -0.00043279207333411,
            "Perc_contribution": -0.33,
            "Fossil_abs": -0.000402139786428843,
            "Land_abs": -0.00003065228690527,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 212,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "France",
            "Abs_contribution": -0.00065261512062492,
            "Perc_contribution": -0.5,
            "Fossil_abs": -0.00031633476084411,
            "Land_abs": -0.00033628035978082,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 213,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Romania",
            "Abs_contribution": -0.00069755809879607,
            "Perc_contribution": -0.54,
            "Fossil_abs": -0.000360084501674089,
            "Land_abs": -0.000337473597121981,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 214,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Libya",
            "Abs_contribution": -0.00078619843819958,
            "Perc_contribution": -0.6,
            "Fossil_abs": -0.00080980634440722,
            "Land_abs": 2.36079062076577e-05,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 215,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Japan",
            "Abs_contribution": -0.00099758931528995,
            "Perc_contribution": -0.77,
            "Fossil_abs": -0.000869303008038316,
            "Land_abs": -0.000128286307251638,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 216,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Kazakhstan",
            "Abs_contribution": -0.00107611154348906,
            "Perc_contribution": -0.83,
            "Fossil_abs": -0.00076950134812203,
            "Land_abs": -0.00030661019536703,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 217,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Ukraine",
            "Abs_contribution": -0.00155435374052674,
            "Perc_contribution": -1.19,
            "Fossil_abs": 0.00022685884926663,
            "Land_abs": -0.00178121258979336,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 218,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "United States",
            "Abs_contribution": -0.0022364796328875,
            "Perc_contribution": -1.72,
            "Fossil_abs": -0.0020221926421271,
            "Land_abs": -0.0002142869907604,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 219,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Germany",
            "Abs_contribution": -0.00298179952840691,
            "Perc_contribution": -2.29,
            "Fossil_abs": -0.00229125971401319,
            "Land_abs": -0.00069053981439368,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 220,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "United Kingdom",
            "Abs_contribution": -0.00313228445017504,
            "Perc_contribution": -2.4,
            "Fossil_abs": -0.00296825772850293,
            "Land_abs": -0.0001640267216721,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 221,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Poland",
            "Abs_contribution": -0.00367585483937071,
            "Perc_contribution": -2.82,
            "Fossil_abs": -0.00311242983969276,
            "Land_abs": -0.000563424999677924,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 222,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "EU27",
            "Abs_contribution": -0.0093278656268884,
            "Perc_contribution": -7.16,
            "Fossil_abs": -0.0065818405890652,
            "Land_abs": -0.00274602503782313,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 223,
            "Perc_contribution_rescale": 0
        }
    ],
    "1990_CO2": [
        {
            "Country": "China",
            "Abs_contribution": 0.100023253966103,
            "Perc_contribution": 20.16,
            "Fossil_abs": 0.0978177234411029,
            "Land_abs": 0.002205530525,
            "Fossil_fraction": 97.794982229085,
            "Land_fraction": 2.20501777091499,
            "Rank": 1,
            "Perc_contribution_rescale": 100
        },
        {
            "Country": "United States",
            "Abs_contribution": 0.078770215519521,
            "Perc_contribution": 15.88,
            "Fossil_abs": 0.080023256253521,
            "Land_abs": -0.0012530407339997,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 2,
            "Perc_contribution_rescale": 78.7698412698413
        },
        {
            "Country": "EU27",
            "Abs_contribution": 0.0468540454156092,
            "Perc_contribution": 9.44,
            "Fossil_abs": 0.0491722613376089,
            "Land_abs": -0.00231821592199997,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 3,
            "Perc_contribution_rescale": 46.8253968253968
        },
        {
            "Country": "Brazil",
            "Abs_contribution": 0.0260476733732353,
            "Perc_contribution": 5.25,
            "Fossil_abs": 0.00564018425473526,
            "Land_abs": 0.0204074891185,
            "Fossil_fraction": 21.6533130384332,
            "Land_fraction": 78.3466869615666,
            "Rank": 4,
            "Perc_contribution_rescale": 26.0416666666667
        },
        {
            "Country": "Russia",
            "Abs_contribution": 0.0237435967174398,
            "Perc_contribution": 4.79,
            "Fossil_abs": 0.02376808629244,
            "Land_abs": -0.0000244895750000015,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 5,
            "Perc_contribution_rescale": 23.7599206349206
        },
        {
            "Country": "India",
            "Abs_contribution": 0.0227637752061393,
            "Perc_contribution": 4.59,
            "Fossil_abs": 0.0219468351976392,
            "Land_abs": 0.000816940008500029,
            "Fossil_fraction": 96.4112279219848,
            "Land_fraction": 3.588772078015,
            "Rank": 6,
            "Perc_contribution_rescale": 22.7678571428571
        },
        {
            "Country": "Indonesia",
            "Abs_contribution": 0.0202123082042281,
            "Perc_contribution": 4.07,
            "Fossil_abs": 0.00576784151372817,
            "Land_abs": 0.0144444666905,
            "Fossil_fraction": 28.53628321639,
            "Land_fraction": 71.4637167836103,
            "Rank": 7,
            "Perc_contribution_rescale": 20.1884920634921
        },
        {
            "Country": "Japan",
            "Abs_contribution": 0.0172191367662713,
            "Perc_contribution": 3.47,
            "Fossil_abs": 0.0175276212667713,
            "Land_abs": -0.0003084845005,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 8,
            "Perc_contribution_rescale": 17.2123015873016
        },
        {
            "Country": "Germany",
            "Abs_contribution": 0.0117789316696157,
            "Perc_contribution": 2.37,
            "Fossil_abs": 0.0122450922216157,
            "Land_abs": -0.000466160552000001,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 9,
            "Perc_contribution_rescale": 11.7559523809524
        },
        {
            "Country": "Canada",
            "Abs_contribution": 0.0096377258782161,
            "Perc_contribution": 1.94,
            "Fossil_abs": 0.00785665349721614,
            "Land_abs": 0.001781072381,
            "Fossil_fraction": 81.5197858550255,
            "Land_fraction": 18.4802141449749,
            "Rank": 10,
            "Perc_contribution_rescale": 9.62301587301587
        },
        {
            "Country": "United Kingdom",
            "Abs_contribution": 0.0073560924837708,
            "Perc_contribution": 1.48,
            "Fossil_abs": 0.0072608387097707,
            "Land_abs": 9.52537739999999e-05,
            "Fossil_fraction": 98.7051036374236,
            "Land_fraction": 1.29489636257498,
            "Rank": 11,
            "Perc_contribution_rescale": 7.34126984126984
        },
        {
            "Country": "Mexico",
            "Abs_contribution": 0.00731363383269381,
            "Perc_contribution": 1.47,
            "Fossil_abs": 0.00621197588519378,
            "Land_abs": 0.0011016579475,
            "Fossil_fraction": 84.9369277611994,
            "Land_fraction": 15.0630722388002,
            "Rank": 12,
            "Perc_contribution_rescale": 7.29166666666667
        },
        {
            "Country": "South Korea",
            "Abs_contribution": 0.00724406066780842,
            "Perc_contribution": 1.46,
            "Fossil_abs": 0.0073896730303084,
            "Land_abs": -0.000145612362499998,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 13,
            "Perc_contribution_rescale": 7.24206349206349
        },
        {
            "Country": "Iran",
            "Abs_contribution": 0.00688639773035641,
            "Perc_contribution": 1.39,
            "Fossil_abs": 0.00688767517135644,
            "Land_abs": -0.000001277441000001,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 14,
            "Perc_contribution_rescale": 6.89484126984127
        },
        {
            "Country": "Saudi Arabia",
            "Abs_contribution": 0.00646453828439465,
            "Perc_contribution": 1.3,
            "Fossil_abs": 0.00648745383639465,
            "Land_abs": -0.000022915552,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 15,
            "Perc_contribution_rescale": 6.4484126984127
        },
        {
            "Country": "Australia",
            "Abs_contribution": 0.00628925354451584,
            "Perc_contribution": 1.27,
            "Fossil_abs": 0.00532082727801583,
            "Land_abs": 0.000968426266500001,
            "Fossil_fraction": 84.6018886081566,
            "Land_fraction": 15.3981113918433,
            "Rank": 16,
            "Perc_contribution_rescale": 6.29960317460317
        },
        {
            "Country": "South Africa",
            "Abs_contribution": 0.00624600686326206,
            "Perc_contribution": 1.26,
            "Fossil_abs": 0.005961991147762,
            "Land_abs": 0.0002840157155,
            "Fossil_fraction": 95.4528433650851,
            "Land_fraction": 4.54715663491393,
            "Rank": 17,
            "Perc_contribution_rescale": 6.25
        },
        {
            "Country": "Italy",
            "Abs_contribution": 0.0056799923018002,
            "Perc_contribution": 1.14,
            "Fossil_abs": 0.00609921111280019,
            "Land_abs": -0.000419218811,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 18,
            "Perc_contribution_rescale": 5.6547619047619
        },
        {
            "Country": "Democratic Republic of the Congo",
            "Abs_contribution": 0.00536104271105951,
            "Perc_contribution": 1.08,
            "Fossil_abs": 4.1666638059498e-05,
            "Land_abs": 0.00531937607300002,
            "Fossil_fraction": 0.777211455031728,
            "Land_fraction": 99.2227885449684,
            "Rank": 19,
            "Perc_contribution_rescale": 5.35714285714286
        },
        {
            "Country": "France",
            "Abs_contribution": 0.0050280700433313,
            "Perc_contribution": 1.01,
            "Fossil_abs": 0.0053742430243313,
            "Land_abs": -0.000346172980999999,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 20,
            "Perc_contribution_rescale": 5.00992063492064
        },
        {
            "Country": "Ukraine",
            "Abs_contribution": 0.0045872563414061,
            "Perc_contribution": 0.92,
            "Fossil_abs": 0.0045514777084061,
            "Land_abs": 3.57786329999998e-05,
            "Fossil_fraction": 99.2200428679546,
            "Land_fraction": 0.779957132045358,
            "Rank": 21,
            "Perc_contribution_rescale": 4.56349206349206
        },
        {
            "Country": "Poland",
            "Abs_contribution": 0.00433123069874674,
            "Perc_contribution": 0.87,
            "Fossil_abs": 0.00480426477674671,
            "Land_abs": -0.000473034078,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 22,
            "Perc_contribution_rescale": 4.31547619047619
        },
        {
            "Country": "Malaysia",
            "Abs_contribution": 0.00430958719356766,
            "Perc_contribution": 0.87,
            "Fossil_abs": 0.00255137955556769,
            "Land_abs": 0.00175820763799998,
            "Fossil_fraction": 59.2024117617526,
            "Land_fraction": 40.7975882382475,
            "Rank": 23,
            "Perc_contribution_rescale": 4.31547619047619
        },
        {
            "Country": "T\xfcrkiye",
            "Abs_contribution": 0.00411580601868012,
            "Perc_contribution": 0.83,
            "Fossil_abs": 0.00422491723518013,
            "Land_abs": -0.0001091112165,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 24,
            "Perc_contribution_rescale": 4.11706349206349
        },
        {
            "Country": "Argentina",
            "Abs_contribution": 0.00387560441582539,
            "Perc_contribution": 0.78,
            "Fossil_abs": 0.00231606282232532,
            "Land_abs": 0.00155954159350003,
            "Fossil_fraction": 59.7600418883842,
            "Land_fraction": 40.2399581116148,
            "Rank": 25,
            "Perc_contribution_rescale": 3.86904761904762
        },
        {
            "Country": "Spain",
            "Abs_contribution": 0.00387287441661134,
            "Perc_contribution": 0.78,
            "Fossil_abs": 0.00408621772811136,
            "Land_abs": -0.0002133433115,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 26,
            "Perc_contribution_rescale": 3.86904761904762
        },
        {
            "Country": "Thailand",
            "Abs_contribution": 0.00374257962181058,
            "Perc_contribution": 0.75,
            "Fossil_abs": 0.00307739074581059,
            "Land_abs": 0.00066518887599999,
            "Fossil_fraction": 82.2264602702511,
            "Land_fraction": 17.7735397297489,
            "Rank": 27,
            "Perc_contribution_rescale": 3.7202380952381
        },
        {
            "Country": "Kazakhstan",
            "Abs_contribution": 0.00347486844586352,
            "Perc_contribution": 0.7,
            "Fossil_abs": 0.00314843479986354,
            "Land_abs": 0.000326433646000011,
            "Fossil_fraction": 90.6058703779544,
            "Land_fraction": 9.39412962204646,
            "Rank": 28,
            "Perc_contribution_rescale": 3.47222222222222
        },
        {
            "Country": "Taiwan",
            "Abs_contribution": 0.00346084128578057,
            "Perc_contribution": 0.7,
            "Fossil_abs": 0.00346084128578057,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 29,
            "Perc_contribution_rescale": 3.47222222222222
        },
        {
            "Country": "Viet Nam",
            "Abs_contribution": 0.00331372188117195,
            "Perc_contribution": 0.67,
            "Fossil_abs": 0.00192916683017195,
            "Land_abs": 0.001384555051,
            "Fossil_fraction": 58.217523960993,
            "Land_fraction": 41.7824760390069,
            "Rank": 30,
            "Perc_contribution_rescale": 3.3234126984127
        },
        {
            "Country": "Egypt",
            "Abs_contribution": 0.00259438880887664,
            "Perc_contribution": 0.52,
            "Fossil_abs": 0.00250986543037664,
            "Land_abs": 8.45233785e-05,
            "Fossil_fraction": 96.7420697232888,
            "Land_fraction": 3.25793027671124,
            "Rank": 31,
            "Perc_contribution_rescale": 2.57936507936508
        },
        {
            "Country": "Venezuela",
            "Abs_contribution": 0.00257471470928057,
            "Perc_contribution": 0.52,
            "Fossil_abs": 0.00198743624828057,
            "Land_abs": 0.000587278461,
            "Fossil_fraction": 77.1905423586096,
            "Land_fraction": 22.8094576413904,
            "Rank": 32,
            "Perc_contribution_rescale": 2.57936507936508
        },
        {
            "Country": "Nigeria",
            "Abs_contribution": 0.00249852878453328,
            "Perc_contribution": 0.5,
            "Fossil_abs": 0.0014066018770333,
            "Land_abs": 0.00109192690750001,
            "Fossil_fraction": 56.2972052089465,
            "Land_fraction": 43.7027947910546,
            "Rank": 33,
            "Perc_contribution_rescale": 2.48015873015873
        },
        {
            "Country": "Netherlands",
            "Abs_contribution": 0.00249736037859556,
            "Perc_contribution": 0.5,
            "Fossil_abs": 0.00241463852509553,
            "Land_abs": 8.27218535e-05,
            "Fossil_fraction": 96.6876284973116,
            "Land_fraction": 3.31237150268718,
            "Rank": 34,
            "Perc_contribution_rescale": 2.48015873015873
        },
        {
            "Country": "Colombia",
            "Abs_contribution": 0.00223406669954146,
            "Perc_contribution": 0.45,
            "Fossil_abs": 0.00105053745704149,
            "Land_abs": 0.0011835292425,
            "Fossil_fraction": 47.0235493531643,
            "Land_fraction": 52.9764506468369,
            "Rank": 35,
            "Perc_contribution_rescale": 2.23214285714286
        },
        {
            "Country": "Pakistan",
            "Abs_contribution": 0.0021525670024405,
            "Perc_contribution": 0.43,
            "Fossil_abs": 0.0020108739619405,
            "Land_abs": 0.0001416930405,
            "Fossil_fraction": 93.4174852471792,
            "Land_fraction": 6.58251475282088,
            "Rank": 36,
            "Perc_contribution_rescale": 2.13293650793651
        },
        {
            "Country": "United Arab Emirates",
            "Abs_contribution": 0.00208711977363592,
            "Perc_contribution": 0.42,
            "Fossil_abs": 0.00209169384313592,
            "Land_abs": -0.00000457406949999998,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 37,
            "Perc_contribution_rescale": 2.08333333333333
        },
        {
            "Country": "Philippines",
            "Abs_contribution": 0.00200860690168943,
            "Perc_contribution": 0.4,
            "Fossil_abs": 0.00125075230418941,
            "Land_abs": 0.00075785459750002,
            "Fossil_fraction": 62.2696408708647,
            "Land_fraction": 37.7303591291353,
            "Rank": 38,
            "Perc_contribution_rescale": 1.98412698412698
        },
        {
            "Country": "Myanmar",
            "Abs_contribution": 0.00197874854269323,
            "Perc_contribution": 0.4,
            "Fossil_abs": 0.000213980928193232,
            "Land_abs": 0.0017647676145,
            "Fossil_fraction": 10.8139525349688,
            "Land_fraction": 89.1860474650314,
            "Rank": 39,
            "Perc_contribution_rescale": 1.98412698412698
        },
        {
            "Country": "Tanzania",
            "Abs_contribution": 0.00192057119796507,
            "Perc_contribution": 0.39,
            "Fossil_abs": 9.51520144650654e-05,
            "Land_abs": 0.0018254191835,
            "Fossil_fraction": 4.95436016982256,
            "Land_fraction": 95.0456398301772,
            "Rank": 40,
            "Perc_contribution_rescale": 1.93452380952381
        },
        {
            "Country": "Algeria",
            "Abs_contribution": 0.00176394642762718,
            "Perc_contribution": 0.36,
            "Fossil_abs": 0.00173354799362718,
            "Land_abs": 3.0398434e-05,
            "Fossil_fraction": 98.2766804295248,
            "Land_fraction": 1.72331957047535,
            "Rank": 41,
            "Perc_contribution_rescale": 1.78571428571429
        },
        {
            "Country": "Uzbekistan",
            "Abs_contribution": 0.00168639537050437,
            "Perc_contribution": 0.34,
            "Fossil_abs": 0.00166527763100437,
            "Land_abs": 2.1117739500001e-05,
            "Fossil_fraction": 98.7477586887775,
            "Land_fraction": 1.25224131122259,
            "Rank": 42,
            "Perc_contribution_rescale": 1.68650793650794
        },
        {
            "Country": "Belgium",
            "Abs_contribution": 0.00166941659038863,
            "Perc_contribution": 0.34,
            "Fossil_abs": 0.00164748194688864,
            "Land_abs": 2.19346435e-05,
            "Fossil_fraction": 98.6860892825508,
            "Land_fraction": 1.31391071744972,
            "Rank": 43,
            "Perc_contribution_rescale": 1.68650793650794
        },
        {
            "Country": "Iraq",
            "Abs_contribution": 0.00164886389926092,
            "Perc_contribution": 0.33,
            "Fossil_abs": 0.00162406538376092,
            "Land_abs": 2.47985155e-05,
            "Fossil_fraction": 98.4960241102303,
            "Land_fraction": 1.50397588976965,
            "Rank": 44,
            "Perc_contribution_rescale": 1.63690476190476
        },
        {
            "Country": "Czechia",
            "Abs_contribution": 0.0015342889631687,
            "Perc_contribution": 0.31,
            "Fossil_abs": 0.00172395220066867,
            "Land_abs": -0.0001896632375,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 45,
            "Perc_contribution_rescale": 1.53769841269841
        },
        {
            "Country": "Angola",
            "Abs_contribution": 0.00143485103277784,
            "Perc_contribution": 0.29,
            "Fossil_abs": 0.000253675163277839,
            "Land_abs": 0.0011811758695,
            "Fossil_fraction": 17.6795470388817,
            "Land_fraction": 82.3204529611182,
            "Rank": 46,
            "Perc_contribution_rescale": 1.43849206349206
        },
        {
            "Country": "Peru",
            "Abs_contribution": 0.00142746524122107,
            "Perc_contribution": 0.29,
            "Fossil_abs": 0.00053282841022107,
            "Land_abs": 0.000894636831,
            "Fossil_fraction": 37.326892090576,
            "Land_fraction": 62.6731079094239,
            "Rank": 47,
            "Perc_contribution_rescale": 1.43849206349206
        },
        {
            "Country": "Bolivia",
            "Abs_contribution": 0.00134012953232587,
            "Perc_contribution": 0.27,
            "Fossil_abs": 0.000209346879325873,
            "Land_abs": 0.001130782653,
            "Fossil_fraction": 15.6213913861401,
            "Land_fraction": 84.3786086138601,
            "Rank": 48,
            "Perc_contribution_rescale": 1.33928571428571
        },
        {
            "Country": "C\xf4te d'Ivoire",
            "Abs_contribution": 0.00133565019071288,
            "Perc_contribution": 0.27,
            "Fossil_abs": 0.000112071180212883,
            "Land_abs": 0.0012235790105,
            "Fossil_fraction": 8.39075837312362,
            "Land_fraction": 91.6092416268766,
            "Rank": 49,
            "Perc_contribution_rescale": 1.33928571428571
        },
        {
            "Country": "Romania",
            "Abs_contribution": 0.0012984516731976,
            "Perc_contribution": 0.26,
            "Fossil_abs": 0.0014139218466976,
            "Land_abs": -0.0001154701735,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 50,
            "Perc_contribution_rescale": 1.28968253968254
        },
        {
            "Country": "Greece",
            "Abs_contribution": 0.00122658885473363,
            "Perc_contribution": 0.25,
            "Fossil_abs": 0.00129189490873362,
            "Land_abs": -0.000065306054,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 51,
            "Perc_contribution_rescale": 1.24007936507937
        },
        {
            "Country": "Paraguay",
            "Abs_contribution": 0.0011159497270595,
            "Perc_contribution": 0.22,
            "Fossil_abs": 7.23768505594978e-05,
            "Land_abs": 0.0010435728765,
            "Fossil_fraction": 6.48567303745925,
            "Land_fraction": 93.5143269625409,
            "Rank": 52,
            "Perc_contribution_rescale": 1.09126984126984
        },
        {
            "Country": "Kuwait",
            "Abs_contribution": 0.00107936543515175,
            "Perc_contribution": 0.22,
            "Fossil_abs": 0.00107907697115175,
            "Land_abs": 2.88464e-07,
            "Fossil_fraction": 99.9732746676329,
            "Land_fraction": 0.0267253323671094,
            "Rank": 53,
            "Perc_contribution_rescale": 1.09126984126984
        },
        {
            "Country": "Chile",
            "Abs_contribution": 0.00107439373821616,
            "Perc_contribution": 0.22,
            "Fossil_abs": 0.000936979197216159,
            "Land_abs": 0.000137414541,
            "Fossil_fraction": 87.2100389166309,
            "Land_fraction": 12.789961083369,
            "Rank": 54,
            "Perc_contribution_rescale": 1.09126984126984
        },
        {
            "Country": "Ethiopia",
            "Abs_contribution": 0.00099664682760043,
            "Perc_contribution": 0.2,
            "Fossil_abs": 0.000113301650600436,
            "Land_abs": 0.000883345177,
            "Fossil_fraction": 11.3682848791308,
            "Land_fraction": 88.6317151208699,
            "Rank": 55,
            "Perc_contribution_rescale": 0.992063492063492
        },
        {
            "Country": "North Korea",
            "Abs_contribution": 0.0009915632908428,
            "Perc_contribution": 0.2,
            "Fossil_abs": 0.00087292980884279,
            "Land_abs": 0.000118633481999997,
            "Fossil_fraction": 88.0357125868209,
            "Land_fraction": 11.9642874131778,
            "Rank": 56,
            "Perc_contribution_rescale": 0.992063492063492
        },
        {
            "Country": "Belarus",
            "Abs_contribution": 0.00098034795340775,
            "Perc_contribution": 0.2,
            "Fossil_abs": 0.00091077849190775,
            "Land_abs": 6.95694615000001e-05,
            "Fossil_fraction": 92.9035949676671,
            "Land_fraction": 7.0964050323329,
            "Rank": 57,
            "Perc_contribution_rescale": 0.992063492063492
        },
        {
            "Country": "Finland",
            "Abs_contribution": 0.00094638099700873,
            "Perc_contribution": 0.19,
            "Fossil_abs": 0.000797413387008738,
            "Land_abs": 0.00014896761,
            "Fossil_fraction": 84.2592348672637,
            "Land_fraction": 15.7407651327371,
            "Rank": 58,
            "Perc_contribution_rescale": 0.942460317460317
        },
        {
            "Country": "Qatar",
            "Abs_contribution": 0.00090847885299509,
            "Perc_contribution": 0.18,
            "Fossil_abs": 0.00090823444949509,
            "Land_abs": 2.444035e-07,
            "Fossil_fraction": 99.9730975025787,
            "Land_fraction": 0.0269024974212934,
            "Rank": 59,
            "Perc_contribution_rescale": 0.892857142857143
        },
        {
            "Country": "Ecuador",
            "Abs_contribution": 0.00089268458143012,
            "Perc_contribution": 0.18,
            "Fossil_abs": 0.000442068866430131,
            "Land_abs": 0.000450615715,
            "Fossil_fraction": 49.521283959214,
            "Land_fraction": 50.4787160407872,
            "Rank": 60,
            "Perc_contribution_rescale": 0.892857142857143
        },
        {
            "Country": "Austria",
            "Abs_contribution": 0.00088417610628821,
            "Perc_contribution": 0.18,
            "Fossil_abs": 0.00098256095878821,
            "Land_abs": -0.0000983848525,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 61,
            "Perc_contribution_rescale": 0.892857142857143
        },
        {
            "Country": "Sweden",
            "Abs_contribution": 0.0008528828097571,
            "Perc_contribution": 0.17,
            "Fossil_abs": 0.0007350355472571,
            "Land_abs": 0.000117847262500003,
            "Fossil_fraction": 86.1824788644101,
            "Land_fraction": 13.8175211355902,
            "Rank": 62,
            "Perc_contribution_rescale": 0.843253968253968
        },
        {
            "Country": "Israel",
            "Abs_contribution": 0.000843153412371728,
            "Perc_contribution": 0.17,
            "Fossil_abs": 0.000836222367371728,
            "Land_abs": 6.931045e-06,
            "Fossil_fraction": 99.1779615787235,
            "Land_fraction": 0.822038421276561,
            "Rank": 63,
            "Perc_contribution_rescale": 0.843253968253968
        },
        {
            "Country": "Turkmenistan",
            "Abs_contribution": 0.000801972489777836,
            "Perc_contribution": 0.16,
            "Fossil_abs": 0.000719640113277836,
            "Land_abs": 8.23323765e-05,
            "Fossil_fraction": 89.7337654907829,
            "Land_fraction": 10.2662345092171,
            "Rank": 64,
            "Perc_contribution_rescale": 0.793650793650794
        },
        {
            "Country": "Bangladesh",
            "Abs_contribution": 0.0007709237040988,
            "Perc_contribution": 0.16,
            "Fossil_abs": 0.000702533767098799,
            "Land_abs": 6.8389937e-05,
            "Fossil_fraction": 91.1288319925318,
            "Land_fraction": 8.871168007468,
            "Rank": 65,
            "Perc_contribution_rescale": 0.793650793650794
        },
        {
            "Country": "Sudan",
            "Abs_contribution": 0.000764003587130457,
            "Perc_contribution": 0.15,
            "Fossil_abs": 0.000175298723130458,
            "Land_abs": 0.000588704863999997,
            "Fossil_fraction": 22.9447513183633,
            "Land_fraction": 77.0552486816365,
            "Rank": 66,
            "Perc_contribution_rescale": 0.744047619047619
        },
        {
            "Country": "Libya",
            "Abs_contribution": 0.000760629491382638,
            "Perc_contribution": 0.15,
            "Fossil_abs": 0.000771180894882638,
            "Land_abs": -0.0000105514035,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 67,
            "Perc_contribution_rescale": 0.744047619047619
        },
        {
            "Country": "Portugal",
            "Abs_contribution": 0.000759368616424665,
            "Perc_contribution": 0.15,
            "Fossil_abs": 0.000793000621424675,
            "Land_abs": -0.0000336320050000003,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 68,
            "Perc_contribution_rescale": 0.744047619047619
        },
        {
            "Country": "Zambia",
            "Abs_contribution": 0.00072422762196779,
            "Perc_contribution": 0.15,
            "Fossil_abs": 5.4380174467795e-05,
            "Land_abs": 0.0006698474475,
            "Fossil_fraction": 7.50871311978398,
            "Land_fraction": 92.4912868802167,
            "Rank": 69,
            "Perc_contribution_rescale": 0.744047619047619
        },
        {
            "Country": "Morocco",
            "Abs_contribution": 0.000723642359078055,
            "Perc_contribution": 0.15,
            "Fossil_abs": 0.000665268213578057,
            "Land_abs": 5.83741455e-05,
            "Fossil_fraction": 91.9332879332315,
            "Land_fraction": 8.06671206676882,
            "Rank": 70,
            "Perc_contribution_rescale": 0.744047619047619
        },
        {
            "Country": "Denmark",
            "Abs_contribution": 0.00071954826764301,
            "Perc_contribution": 0.15,
            "Fossil_abs": 0.00071546054664301,
            "Land_abs": 4.087721e-06,
            "Fossil_fraction": 99.4319045456965,
            "Land_fraction": 0.568095454303566,
            "Rank": 71,
            "Perc_contribution_rescale": 0.744047619047619
        },
        {
            "Country": "Hungary",
            "Abs_contribution": 0.00070436892588974,
            "Perc_contribution": 0.14,
            "Fossil_abs": 0.00079874862338974,
            "Land_abs": -0.0000943796974999999,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 72,
            "Perc_contribution_rescale": 0.694444444444445
        },
        {
            "Country": "Madagascar",
            "Abs_contribution": 0.00070173405237609,
            "Perc_contribution": 0.14,
            "Fossil_abs": 3.29993483760917e-05,
            "Land_abs": 0.000668734704,
            "Fossil_fraction": 4.70254340150019,
            "Land_fraction": 95.2974565985,
            "Rank": 73,
            "Perc_contribution_rescale": 0.694444444444445
        },
        {
            "Country": "Mozambique",
            "Abs_contribution": 0.00069379579976747,
            "Perc_contribution": 0.14,
            "Fossil_abs": 4.81264677674672e-05,
            "Land_abs": 0.000645669332,
            "Fossil_fraction": 6.93669056278477,
            "Land_fraction": 93.0633094372148,
            "Rank": 74,
            "Perc_contribution_rescale": 0.694444444444445
        },
        {
            "Country": "Singapore",
            "Abs_contribution": 0.000684029358134828,
            "Perc_contribution": 0.14,
            "Fossil_abs": 0.000682549841634825,
            "Land_abs": 1.47951650000002e-06,
            "Fossil_fraction": 99.7837057017498,
            "Land_fraction": 0.216294298249754,
            "Rank": 75,
            "Perc_contribution_rescale": 0.694444444444445
        },
        {
            "Country": "Norway",
            "Abs_contribution": 0.000664514736989088,
            "Perc_contribution": 0.13,
            "Fossil_abs": 0.000609327797489088,
            "Land_abs": 5.51869395e-05,
            "Fossil_fraction": 91.6951519013631,
            "Land_fraction": 8.30484809863685,
            "Rank": 76,
            "Perc_contribution_rescale": 0.64484126984127
        },
        {
            "Country": "Bulgaria",
            "Abs_contribution": 0.00066147211186081,
            "Perc_contribution": 0.13,
            "Fossil_abs": 0.00071691057736081,
            "Land_abs": -0.0000554384655,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 77,
            "Perc_contribution_rescale": 0.64484126984127
        },
        {
            "Country": "Syria",
            "Abs_contribution": 0.000639728769835152,
            "Perc_contribution": 0.13,
            "Fossil_abs": 0.000647386073335153,
            "Land_abs": -0.00000765730350000001,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 78,
            "Perc_contribution_rescale": 0.64484126984127
        },
        {
            "Country": "Guatemala",
            "Abs_contribution": 0.00062833575596288,
            "Perc_contribution": 0.13,
            "Fossil_abs": 0.000170167473962882,
            "Land_abs": 0.000458168282,
            "Fossil_fraction": 27.0822521793484,
            "Land_fraction": 72.917747820652,
            "Rank": 79,
            "Perc_contribution_rescale": 0.64484126984127
        },
        {
            "Country": "Nicaragua",
            "Abs_contribution": 0.00061251666229749,
            "Perc_contribution": 0.12,
            "Fossil_abs": 5.98208152974891e-05,
            "Land_abs": 0.000552695847,
            "Fossil_fraction": 9.76639803937856,
            "Land_fraction": 90.2336019606213,
            "Rank": 80,
            "Perc_contribution_rescale": 0.595238095238095
        },
        {
            "Country": "Oman",
            "Abs_contribution": 0.000600904020689953,
            "Perc_contribution": 0.12,
            "Fossil_abs": 0.000599920048689956,
            "Land_abs": 9.83972e-07,
            "Fossil_fraction": 99.8362513868908,
            "Land_fraction": 0.163748613109663,
            "Rank": 81,
            "Perc_contribution_rescale": 0.595238095238095
        },
        {
            "Country": "Switzerland",
            "Abs_contribution": 0.000594415088416485,
            "Perc_contribution": 0.12,
            "Fossil_abs": 0.000607291666416485,
            "Land_abs": -0.000012876578,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 82,
            "Perc_contribution_rescale": 0.595238095238095
        },
        {
            "Country": "Serbia",
            "Abs_contribution": 0.000563056505372277,
            "Perc_contribution": 0.11,
            "Fossil_abs": 0.000670789174372274,
            "Land_abs": -0.000107732669,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 83,
            "Perc_contribution_rescale": 0.545634920634921
        },
        {
            "Country": "Hong Kong",
            "Abs_contribution": 0.000558679447925764,
            "Perc_contribution": 0.11,
            "Fossil_abs": 0.000558679447925764,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 84,
            "Perc_contribution_rescale": 0.545634920634921
        },
        {
            "Country": "Slovakia",
            "Abs_contribution": 0.0005498579138346,
            "Perc_contribution": 0.11,
            "Fossil_abs": 0.0005789024788346,
            "Land_abs": -0.000029044565,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 85,
            "Perc_contribution_rescale": 0.545634920634921
        },
        {
            "Country": "Laos",
            "Abs_contribution": 0.00054818555661681,
            "Perc_contribution": 0.11,
            "Fossil_abs": 8.63109731168122e-05,
            "Land_abs": 0.0004618745835,
            "Fossil_fraction": 15.7448462614539,
            "Land_fraction": 84.2551537385465,
            "Rank": 86,
            "Perc_contribution_rescale": 0.545634920634921
        },
        {
            "Country": "Azerbaijan",
            "Abs_contribution": 0.000538974255280566,
            "Perc_contribution": 0.11,
            "Fossil_abs": 0.000499401485780563,
            "Land_abs": 3.95727695e-05,
            "Fossil_fraction": 92.65776257172,
            "Land_fraction": 7.34223742827943,
            "Rank": 87,
            "Perc_contribution_rescale": 0.545634920634921
        },
        {
            "Country": "Kenya",
            "Abs_contribution": 0.000537604742641373,
            "Perc_contribution": 0.11,
            "Fossil_abs": 0.000175451638141376,
            "Land_abs": 0.0003621531045,
            "Fossil_fraction": 32.6358054951938,
            "Land_fraction": 67.3641945048067,
            "Rank": 88,
            "Perc_contribution_rescale": 0.545634920634921
        },
        {
            "Country": "Cameroon",
            "Abs_contribution": 0.00053638469527019,
            "Perc_contribution": 0.11,
            "Fossil_abs": 9.97274027701964e-05,
            "Land_abs": 0.0004366572925,
            "Fossil_fraction": 18.5925145981209,
            "Land_fraction": 81.4074854018803,
            "Rank": 89,
            "Perc_contribution_rescale": 0.545634920634921
        },
        {
            "Country": "Papua New Guinea",
            "Abs_contribution": 0.000520775630597162,
            "Perc_contribution": 0.1,
            "Fossil_abs": 6.94483585971616e-05,
            "Land_abs": 0.000451327272,
            "Fossil_fraction": 13.3355622876452,
            "Land_fraction": 86.6644377123547,
            "Rank": 90,
            "Perc_contribution_rescale": 0.496031746031746
        },
        {
            "Country": "Ireland",
            "Abs_contribution": 0.000512681082381005,
            "Perc_contribution": 0.1,
            "Fossil_abs": 0.000582241248881004,
            "Land_abs": -0.0000695601665,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 91,
            "Perc_contribution_rescale": 0.496031746031746
        },
        {
            "Country": "Cambodia",
            "Abs_contribution": 0.000490335212094983,
            "Perc_contribution": 0.1,
            "Fossil_abs": 8.75747055949781e-05,
            "Land_abs": 0.0004027605065,
            "Fossil_fraction": 17.8601706413885,
            "Land_fraction": 82.1398293586106,
            "Rank": 92,
            "Perc_contribution_rescale": 0.496031746031746
        },
        {
            "Country": "Ghana",
            "Abs_contribution": 0.000479899240811682,
            "Perc_contribution": 0.1,
            "Fossil_abs": 0.000136297784811681,
            "Land_abs": 0.000343601456000001,
            "Fossil_fraction": 28.4013337010395,
            "Land_fraction": 71.5986662989605,
            "Rank": 93,
            "Perc_contribution_rescale": 0.496031746031746
        },
        {
            "Country": "Trinidad and Tobago",
            "Abs_contribution": 0.000475466449073147,
            "Perc_contribution": 0.1,
            "Fossil_abs": 0.000481241850573144,
            "Land_abs": -0.0000057754015,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 94,
            "Perc_contribution_rescale": 0.496031746031746
        },
        {
            "Country": "Zimbabwe",
            "Abs_contribution": 0.00044050510210098,
            "Perc_contribution": 0.09,
            "Fossil_abs": 0.000169394157600982,
            "Land_abs": 0.0002711109445,
            "Fossil_fraction": 38.4545279482712,
            "Land_fraction": 61.5454720517293,
            "Rank": 95,
            "Perc_contribution_rescale": 0.446428571428571
        },
        {
            "Country": "Mongolia",
            "Abs_contribution": 0.0003881934160464,
            "Perc_contribution": 0.08,
            "Fossil_abs": 0.000272497082546398,
            "Land_abs": 0.0001156963335,
            "Fossil_fraction": 70.196214382427,
            "Land_fraction": 29.8037856175724,
            "Rank": 96,
            "Perc_contribution_rescale": 0.396825396825397
        },
        {
            "Country": "Cuba",
            "Abs_contribution": 0.00038318203437118,
            "Perc_contribution": 0.08,
            "Fossil_abs": 0.000366028535371179,
            "Land_abs": 1.7153499e-05,
            "Fossil_fraction": 95.5234072943554,
            "Land_fraction": 4.47659270564438,
            "Rank": 97,
            "Perc_contribution_rescale": 0.396825396825397
        },
        {
            "Country": "Tunisia",
            "Abs_contribution": 0.000362376819167573,
            "Perc_contribution": 0.07,
            "Fossil_abs": 0.000347059099167576,
            "Land_abs": 1.531772e-05,
            "Fossil_fraction": 95.7729856906455,
            "Land_fraction": 4.22701430935533,
            "Rank": 98,
            "Perc_contribution_rescale": 0.347222222222222
        },
        {
            "Country": "Uganda",
            "Abs_contribution": 0.0003608533033941,
            "Perc_contribution": 0.07,
            "Fossil_abs": 4.10829293941048e-05,
            "Land_abs": 0.000319770374,
            "Fossil_fraction": 11.3849392558385,
            "Land_fraction": 88.6150607441628,
            "Rank": 99,
            "Perc_contribution_rescale": 0.347222222222222
        },
        {
            "Country": "Bahrain",
            "Abs_contribution": 0.000348558906386463,
            "Perc_contribution": 0.07,
            "Fossil_abs": 0.000348549831386463,
            "Land_abs": 9.07499999999999e-09,
            "Fossil_fraction": 99.9973964228618,
            "Land_fraction": 0.00260357713824651,
            "Rank": 100,
            "Perc_contribution_rescale": 0.347222222222222
        },
        {
            "Country": "Benin",
            "Abs_contribution": 0.000342910880046943,
            "Perc_contribution": 0.07,
            "Fossil_abs": 5.30103020469433e-05,
            "Land_abs": 0.000289900578,
            "Fossil_fraction": 15.4589151676046,
            "Land_fraction": 84.5410848323955,
            "Rank": 101,
            "Perc_contribution_rescale": 0.347222222222222
        },
        {
            "Country": "Sri Lanka",
            "Abs_contribution": 0.000323307429301853,
            "Perc_contribution": 0.07,
            "Fossil_abs": 0.000185600596301856,
            "Land_abs": 0.000137706832999997,
            "Fossil_fraction": 57.40684546057,
            "Land_fraction": 42.5931545394301,
            "Rank": 102,
            "Perc_contribution_rescale": 0.347222222222222
        },
        {
            "Country": "Chad",
            "Abs_contribution": 0.000315237817215065,
            "Perc_contribution": 0.06,
            "Fossil_abs": 1.78447707150655e-05,
            "Land_abs": 0.0002973930465,
            "Fossil_fraction": 5.66073286279965,
            "Land_fraction": 94.3392671372005,
            "Rank": 103,
            "Perc_contribution_rescale": 0.297619047619048
        },
        {
            "Country": "Jordan",
            "Abs_contribution": 0.000279188242254366,
            "Perc_contribution": 0.06,
            "Fossil_abs": 0.000275559149754367,
            "Land_abs": 3.6290925e-06,
            "Fossil_fraction": 98.7001270287402,
            "Land_fraction": 1.29987297125986,
            "Rank": 104,
            "Perc_contribution_rescale": 0.297619047619048
        },
        {
            "Country": "Honduras",
            "Abs_contribution": 0.000276646600159388,
            "Perc_contribution": 0.06,
            "Fossil_abs": 0.000103754831659388,
            "Land_abs": 0.0001728917685,
            "Fossil_fraction": 37.5044665647836,
            "Land_fraction": 62.4955334352165,
            "Rank": 105,
            "Perc_contribution_rescale": 0.297619047619048
        },
        {
            "Country": "Dominican Republic",
            "Abs_contribution": 0.000272420164349892,
            "Perc_contribution": 0.05,
            "Fossil_abs": 0.000281794562349891,
            "Land_abs": -0.00000937439799999796,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 106,
            "Perc_contribution_rescale": 0.248015873015873
        },
        {
            "Country": "Sierra Leone",
            "Abs_contribution": 0.000272251121189409,
            "Perc_contribution": 0.05,
            "Fossil_abs": 9.0089166894105e-06,
            "Land_abs": 0.000263242204499998,
            "Fossil_fraction": 3.30904668089241,
            "Land_fraction": 96.6909533191074,
            "Rank": 107,
            "Perc_contribution_rescale": 0.248015873015873
        },
        {
            "Country": "Burkina Faso",
            "Abs_contribution": 0.000272203196885372,
            "Perc_contribution": 0.05,
            "Fossil_abs": 3.22074298853712e-05,
            "Land_abs": 0.000239995767,
            "Fossil_fraction": 11.8321277097029,
            "Land_fraction": 88.1678722902968,
            "Rank": 108,
            "Perc_contribution_rescale": 0.248015873015873
        },
        {
            "Country": "Lebanon",
            "Abs_contribution": 0.000267064431307315,
            "Perc_contribution": 0.05,
            "Fossil_abs": 0.000265591503807314,
            "Land_abs": 1.47292750000003e-06,
            "Fossil_fraction": 99.4484748520083,
            "Land_fraction": 0.551525147991388,
            "Rank": 109,
            "Perc_contribution_rescale": 0.248015873015873
        },
        {
            "Country": "Panama",
            "Abs_contribution": 0.000266558088049674,
            "Perc_contribution": 0.05,
            "Fossil_abs": 0.000111706649549673,
            "Land_abs": 0.000154851438500001,
            "Fossil_fraction": 41.9070568696667,
            "Land_fraction": 58.0929431303333,
            "Rank": 110,
            "Perc_contribution_rescale": 0.248015873015873
        },
        {
            "Country": "Lithuania",
            "Abs_contribution": 0.00025639208851146,
            "Perc_contribution": 0.05,
            "Fossil_abs": 0.000214005634511463,
            "Land_abs": 4.2386454e-05,
            "Fossil_fraction": 83.4681115762656,
            "Land_fraction": 16.5318884237356,
            "Rank": 111,
            "Perc_contribution_rescale": 0.248015873015873
        },
        {
            "Country": "Congo",
            "Abs_contribution": 0.000247478105256546,
            "Perc_contribution": 0.05,
            "Fossil_abs": 6.63108277565502e-05,
            "Land_abs": 0.000181167277500001,
            "Fossil_fraction": 26.7946239881745,
            "Land_fraction": 73.2053760118276,
            "Rank": 112,
            "Perc_contribution_rescale": 0.248015873015873
        },
        {
            "Country": "Yemen",
            "Abs_contribution": 0.000240501818187228,
            "Perc_contribution": 0.05,
            "Fossil_abs": 0.000234583576187227,
            "Land_abs": 5.918242e-06,
            "Fossil_fraction": 97.53921111923,
            "Land_fraction": 2.46078888076959,
            "Rank": 113,
            "Perc_contribution_rescale": 0.248015873015873
        },
        {
            "Country": "Malawi",
            "Abs_contribution": 0.000238001558644649,
            "Perc_contribution": 0.05,
            "Fossil_abs": 1.57741301446507e-05,
            "Land_abs": 0.000222227428499999,
            "Fossil_fraction": 6.6277423704617,
            "Land_fraction": 93.3722576295386,
            "Rank": 114,
            "Perc_contribution_rescale": 0.248015873015873
        },
        {
            "Country": "Estonia",
            "Abs_contribution": 0.000237940006589523,
            "Perc_contribution": 0.05,
            "Fossil_abs": 0.00025226889808952,
            "Land_abs": -0.0000143288915,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 115,
            "Perc_contribution_rescale": 0.248015873015873
        },
        {
            "Country": "Niger",
            "Abs_contribution": 0.000235954722836793,
            "Perc_contribution": 0.05,
            "Fossil_abs": 1.86174818367904e-05,
            "Land_abs": 0.000217337241000003,
            "Fossil_fraction": 7.8902772586874,
            "Land_fraction": 92.1097227413128,
            "Rank": 116,
            "Perc_contribution_rescale": 0.248015873015873
        },
        {
            "Country": "Mali",
            "Abs_contribution": 0.000233811655582423,
            "Perc_contribution": 0.05,
            "Fossil_abs": 3.44528695824236e-05,
            "Land_abs": 0.000199358786,
            "Fossil_fraction": 14.7353088521621,
            "Land_fraction": 85.264691147838,
            "Rank": 117,
            "Perc_contribution_rescale": 0.248015873015873
        },
        {
            "Country": "Slovenia",
            "Abs_contribution": 0.000229462027806767,
            "Perc_contribution": 0.05,
            "Fossil_abs": 0.000220688059306768,
            "Land_abs": 8.7739684999997e-06,
            "Fossil_fraction": 96.1762873866923,
            "Land_fraction": 3.82371261330802,
            "Rank": 118,
            "Perc_contribution_rescale": 0.248015873015873
        },
        {
            "Country": "Croatia",
            "Abs_contribution": 0.000227719029573688,
            "Perc_contribution": 0.05,
            "Fossil_abs": 0.00028031262007369,
            "Land_abs": -0.0000525935905,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 119,
            "Perc_contribution_rescale": 0.248015873015873
        },
        {
            "Country": "Bosnia and Herzegovina",
            "Abs_contribution": 0.000227648524875547,
            "Perc_contribution": 0.05,
            "Fossil_abs": 0.000233282191375546,
            "Land_abs": -0.0000056336665,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 120,
            "Perc_contribution_rescale": 0.248015873015873
        },
        {
            "Country": "Kuwaiti Oil Fires",
            "Abs_contribution": 0.0002152227,
            "Perc_contribution": 0.04,
            "Fossil_abs": 0.0002152227,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 121,
            "Perc_contribution_rescale": 0.198412698412698
        },
        {
            "Country": "Somalia",
            "Abs_contribution": 0.000213810426680132,
            "Perc_contribution": 0.04,
            "Fossil_abs": 8.58231018013099e-06,
            "Land_abs": 0.0002052281165,
            "Fossil_fraction": 4.01398112963427,
            "Land_fraction": 95.9860188703655,
            "Rank": 122,
            "Perc_contribution_rescale": 0.198412698412698
        },
        {
            "Country": "New Zealand",
            "Abs_contribution": 0.0002130898859405,
            "Perc_contribution": 0.04,
            "Fossil_abs": 0.000482369649440503,
            "Land_abs": -0.0002692797635,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 123,
            "Perc_contribution_rescale": 0.198412698412698
        },
        {
            "Country": "Liberia",
            "Abs_contribution": 0.000210558552983082,
            "Perc_contribution": 0.04,
            "Fossil_abs": 8.5643704830786e-06,
            "Land_abs": 0.000201994182500003,
            "Fossil_fraction": 4.06745314390849,
            "Land_fraction": 95.9325468560913,
            "Rank": 124,
            "Perc_contribution_rescale": 0.198412698412698
        },
        {
            "Country": "Nepal",
            "Abs_contribution": 0.000204378646183405,
            "Perc_contribution": 0.04,
            "Fossil_abs": 8.14636396834061e-05,
            "Land_abs": 0.000122915006499999,
            "Fossil_fraction": 39.8591737467047,
            "Land_fraction": 60.1408262532955,
            "Rank": 125,
            "Perc_contribution_rescale": 0.198412698412698
        },
        {
            "Country": "Guinea",
            "Abs_contribution": 0.00019615189175327,
            "Perc_contribution": 0.04,
            "Fossil_abs": 3.16678357532751e-05,
            "Land_abs": 0.000164484056,
            "Fossil_fraction": 16.1445477126005,
            "Land_fraction": 83.8554522874022,
            "Rank": 126,
            "Perc_contribution_rescale": 0.198412698412698
        },
        {
            "Country": "South Sudan",
            "Abs_contribution": 0.000187001160932313,
            "Perc_contribution": 0.04,
            "Fossil_abs": 1.49421694323144e-05,
            "Land_abs": 0.000172058991499998,
            "Fossil_fraction": 7.99041533101652,
            "Land_fraction": 92.0095846689832,
            "Rank": 127,
            "Perc_contribution_rescale": 0.198412698412698
        },
        {
            "Country": "Gabon",
            "Abs_contribution": 0.000186313992235265,
            "Perc_contribution": 0.04,
            "Fossil_abs": 8.30465422352622e-05,
            "Land_abs": 0.000103267450000003,
            "Fossil_fraction": 44.5734328586532,
            "Land_fraction": 55.4265671413469,
            "Rank": 128,
            "Perc_contribution_rescale": 0.198412698412698
        },
        {
            "Country": "Botswana",
            "Abs_contribution": 0.000184190431439411,
            "Perc_contribution": 0.04,
            "Fossil_abs": 6.54382979394105e-05,
            "Land_abs": 0.0001187521335,
            "Fossil_fraction": 35.5275230249603,
            "Land_fraction": 64.4724769750394,
            "Rank": 129,
            "Perc_contribution_rescale": 0.198412698412698
        },
        {
            "Country": "Kyrgyzstan",
            "Abs_contribution": 0.000152848104960155,
            "Perc_contribution": 0.03,
            "Fossil_abs": 0.000110118126460153,
            "Land_abs": 4.27299785e-05,
            "Fossil_fraction": 72.0441555286924,
            "Land_fraction": 27.9558444713063,
            "Rank": 130,
            "Perc_contribution_rescale": 0.148809523809524
        },
        {
            "Country": "Jamaica",
            "Abs_contribution": 0.000151471799484716,
            "Perc_contribution": 0.03,
            "Fossil_abs": 0.000127661166484716,
            "Land_abs": 2.3810633e-05,
            "Fossil_fraction": 84.2804844987649,
            "Land_fraction": 15.7195155012353,
            "Rank": 131,
            "Perc_contribution_rescale": 0.148809523809524
        },
        {
            "Country": "Senegal",
            "Abs_contribution": 0.000149444420923581,
            "Perc_contribution": 0.03,
            "Fossil_abs": 9.28983324235806e-05,
            "Land_abs": 5.65460885e-05,
            "Fossil_fraction": 62.1624627065098,
            "Land_fraction": 37.8375372934899,
            "Rank": 132,
            "Perc_contribution_rescale": 0.148809523809524
        },
        {
            "Country": "Luxembourg",
            "Abs_contribution": 0.000145761328564956,
            "Perc_contribution": 0.03,
            "Fossil_abs": 0.000145418370564956,
            "Land_abs": 3.42958000000003e-07,
            "Fossil_fraction": 99.7647126275697,
            "Land_fraction": 0.235287372430315,
            "Rank": 133,
            "Perc_contribution_rescale": 0.148809523809524
        },
        {
            "Country": "Guyana",
            "Abs_contribution": 0.000135267985352619,
            "Perc_contribution": 0.03,
            "Fossil_abs": 2.82770848526201e-05,
            "Land_abs": 0.000106990900499998,
            "Fossil_fraction": 20.9044917604908,
            "Land_fraction": 79.0955082395085,
            "Rank": 134,
            "Perc_contribution_rescale": 0.148809523809524
        },
        {
            "Country": "Central African Republic",
            "Abs_contribution": 0.000132150780668668,
            "Perc_contribution": 0.03,
            "Fossil_abs": 2.96631316866813e-06,
            "Land_abs": 0.0001291844675,
            "Fossil_fraction": 2.24464294017706,
            "Land_fraction": 97.755357059823,
            "Rank": 135,
            "Perc_contribution_rescale": 0.148809523809524
        },
        {
            "Country": "Brunei Darussalam",
            "Abs_contribution": 0.000125840495528385,
            "Perc_contribution": 0.03,
            "Fossil_abs": 0.000108076826528385,
            "Land_abs": 1.7763669e-05,
            "Fossil_fraction": 85.8839804107468,
            "Land_fraction": 14.1160195892531,
            "Rank": 136,
            "Perc_contribution_rescale": 0.148809523809524
        },
        {
            "Country": "Latvia",
            "Abs_contribution": 0.000125353030180134,
            "Perc_contribution": 0.03,
            "Fossil_abs": 0.000122447985180131,
            "Land_abs": 2.90504499999997e-06,
            "Fossil_fraction": 97.682509153685,
            "Land_fraction": 2.31749084631251,
            "Rank": 137,
            "Perc_contribution_rescale": 0.148809523809524
        },
        {
            "Country": "Costa Rica",
            "Abs_contribution": 0.00011918430126583,
            "Perc_contribution": 0.02,
            "Fossil_abs": 9.37161717658301e-05,
            "Land_abs": 2.54681295e-05,
            "Fossil_fraction": 78.6313052730028,
            "Land_fraction": 21.3686947269973,
            "Rank": 138,
            "Perc_contribution_rescale": 0.0992063492063492
        },
        {
            "Country": "Equatorial Guinea",
            "Abs_contribution": 0.000117514930506005,
            "Perc_contribution": 0.02,
            "Fossil_abs": 6.39936770060044e-05,
            "Land_abs": 5.35212535e-05,
            "Fossil_fraction": 54.455784239888,
            "Land_fraction": 45.5442157601115,
            "Rank": 139,
            "Perc_contribution_rescale": 0.0992063492063492
        },
        {
            "Country": "Namibia",
            "Abs_contribution": 0.000115858540784934,
            "Perc_contribution": 0.02,
            "Fossil_abs": 3.70944542849345e-05,
            "Land_abs": 7.87640865e-05,
            "Fossil_fraction": 32.0170218212848,
            "Land_fraction": 67.9829781787156,
            "Rank": 140,
            "Perc_contribution_rescale": 0.0992063492063492
        },
        {
            "Country": "El Salvador",
            "Abs_contribution": 0.000112428014202512,
            "Perc_contribution": 0.02,
            "Fossil_abs": 8.57199097025105e-05,
            "Land_abs": 2.67081045e-05,
            "Fossil_fraction": 76.2442619933736,
            "Land_fraction": 23.7557380066251,
            "Rank": 141,
            "Perc_contribution_rescale": 0.0992063492063492
        },
        {
            "Country": "Uruguay",
            "Abs_contribution": 0.000105338686509825,
            "Perc_contribution": 0.02,
            "Fossil_abs": 8.8706901009825e-05,
            "Land_abs": 1.66317855e-05,
            "Fossil_fraction": 84.2111326322179,
            "Land_fraction": 15.7888673677821,
            "Rank": 142,
            "Perc_contribution_rescale": 0.0992063492063492
        },
        {
            "Country": "North Macedonia",
            "Abs_contribution": 0.000101518400181768,
            "Perc_contribution": 0.02,
            "Fossil_abs": 0.000116184793681768,
            "Land_abs": -0.0000146663934999998,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 143,
            "Perc_contribution_rescale": 0.0992063492063492
        },
        {
            "Country": "Afghanistan",
            "Abs_contribution": 9.8957829110264e-05,
            "Perc_contribution": 0.02,
            "Fossil_abs": 7.75251266102619e-05,
            "Land_abs": 2.14327025e-05,
            "Fossil_fraction": 78.3415797489649,
            "Land_fraction": 21.658420251033,
            "Rank": 144,
            "Perc_contribution_rescale": 0.0992063492063492
        },
        {
            "Country": "Moldova",
            "Abs_contribution": 9.7735065009278e-05,
            "Perc_contribution": 0.02,
            "Fossil_abs": 0.000104231819009279,
            "Land_abs": -0.00000649675400000001,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 145,
            "Perc_contribution_rescale": 0.0992063492063492
        },
        {
            "Country": "Cyprus",
            "Abs_contribution": 9.0513501314956e-05,
            "Perc_contribution": 0.02,
            "Fossil_abs": 0.000102135776814956,
            "Land_abs": -0.0000116222755,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 146,
            "Perc_contribution_rescale": 0.0992063492063492
        },
        {
            "Country": "Armenia",
            "Abs_contribution": 8.9988766111354e-05,
            "Perc_contribution": 0.02,
            "Fossil_abs": 6.7354390611354e-05,
            "Land_abs": 2.26343754999999e-05,
            "Fossil_fraction": 74.8475543358471,
            "Land_fraction": 25.1524456641528,
            "Rank": 147,
            "Perc_contribution_rescale": 0.0992063492063492
        },
        {
            "Country": "Belize",
            "Abs_contribution": 8.49115327259828e-05,
            "Perc_contribution": 0.02,
            "Fossil_abs": 6.92824822598253e-06,
            "Land_abs": 7.79832844999999e-05,
            "Fossil_fraction": 8.15937247104067,
            "Land_fraction": 91.8406275289589,
            "Rank": 148,
            "Perc_contribution_rescale": 0.0992063492063492
        },
        {
            "Country": "Tajikistan",
            "Abs_contribution": 8.2702017581877e-05,
            "Perc_contribution": 0.02,
            "Fossil_abs": 6.3496650081877e-05,
            "Land_abs": 1.92053675e-05,
            "Fossil_fraction": 76.7776312337408,
            "Land_fraction": 23.2223687662592,
            "Rank": 149,
            "Perc_contribution_rescale": 0.0992063492063492
        },
        {
            "Country": "Togo",
            "Abs_contribution": 8.0191050968341e-05,
            "Perc_contribution": 0.02,
            "Fossil_abs": 2.51004439683406e-05,
            "Land_abs": 5.5090607e-05,
            "Fossil_fraction": 31.3008043481687,
            "Land_fraction": 68.6991956518309,
            "Rank": 150,
            "Perc_contribution_rescale": 0.0992063492063492
        },
        {
            "Country": "Haiti",
            "Abs_contribution": 6.8302834598799e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 2.71871170987991e-05,
            "Land_abs": 4.11157175e-05,
            "Fossil_fraction": 39.8037903675482,
            "Land_fraction": 60.196209632452,
            "Rank": 151,
            "Perc_contribution_rescale": 0.0496031746031746
        },
        {
            "Country": "Bhutan",
            "Abs_contribution": 6.8019078652838e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 9.01182265283843e-06,
            "Land_abs": 5.9007256e-05,
            "Fossil_fraction": 13.2489631311147,
            "Land_fraction": 86.7510368688859,
            "Rank": 152,
            "Perc_contribution_rescale": 0.0496031746031746
        },
        {
            "Country": "Suriname",
            "Abs_contribution": 6.65354894868994e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 3.32165444868996e-05,
            "Land_abs": 3.33189449999997e-05,
            "Fossil_fraction": 49.9230482003741,
            "Land_fraction": 50.0769517996258,
            "Rank": 153,
            "Perc_contribution_rescale": 0.0496031746031746
        },
        {
            "Country": "Cura\xe7ao",
            "Abs_contribution": 6.4805964710698e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 6.4805964710698e-05,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 154,
            "Perc_contribution_rescale": 0.0496031746031746
        },
        {
            "Country": "Kosovo",
            "Abs_contribution": 5.48597714656113e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 5.48597714656113e-05,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 155,
            "Perc_contribution_rescale": 0.0496031746031746
        },
        {
            "Country": "Albania",
            "Abs_contribution": 5.4397994551855e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 5.68900775518562e-05,
            "Land_abs": -0.00000249208300000031,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 156,
            "Perc_contribution_rescale": 0.0496031746031746
        },
        {
            "Country": "Rwanda",
            "Abs_contribution": 5.2768528303493e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 1.05296173034935e-05,
            "Land_abs": 4.2238911e-05,
            "Fossil_fraction": 19.9543509019873,
            "Land_fraction": 80.0456490980136,
            "Rank": 157,
            "Perc_contribution_rescale": 0.0496031746031746
        },
        {
            "Country": "Iceland",
            "Abs_contribution": 5.05991879274023e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 4.50771439274017e-05,
            "Land_abs": 5.5220440000004e-06,
            "Fossil_fraction": 89.0866944190421,
            "Land_fraction": 10.9133055809576,
            "Rank": 158,
            "Perc_contribution_rescale": 0.0496031746031746
        },
        {
            "Country": "Mauritius",
            "Abs_contribution": 4.77844843422489e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 4.68091143422489e-05,
            "Land_abs": 9.7537e-07,
            "Fossil_fraction": 97.9588144281017,
            "Land_fraction": 2.04118557189833,
            "Rank": 159,
            "Perc_contribution_rescale": 0.0496031746031746
        },
        {
            "Country": "New Caledonia",
            "Abs_contribution": 4.74855008597161e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 4.74855008597161e-05,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 160,
            "Perc_contribution_rescale": 0.0496031746031746
        },
        {
            "Country": "Mauritania",
            "Abs_contribution": 4.64906574252182e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 2.92176159252184e-05,
            "Land_abs": 1.72730414999999e-05,
            "Fossil_fraction": 62.8462094179156,
            "Land_fraction": 37.1537905820845,
            "Rank": 161,
            "Perc_contribution_rescale": 0.0496031746031746
        },
        {
            "Country": "Timor-Leste",
            "Abs_contribution": 4.52259932974892e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 4.89396529748908e-06,
            "Land_abs": 4.03320280000002e-05,
            "Fossil_fraction": 10.8211339114154,
            "Land_fraction": 89.1788660885847,
            "Rank": 162,
            "Perc_contribution_rescale": 0.0496031746031746
        },
        {
            "Country": "Lesotho",
            "Abs_contribution": 4.4754891794214e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 3.0634785794214e-05,
            "Land_abs": 1.41201059999999e-05,
            "Fossil_fraction": 68.4501393391248,
            "Land_fraction": 31.549860660875,
            "Rank": 163,
            "Perc_contribution_rescale": 0.0496031746031746
        },
        {
            "Country": "Burundi",
            "Abs_contribution": 4.3076389143013e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 4.8513341430131e-06,
            "Land_abs": 3.8225055e-05,
            "Fossil_fraction": 11.2621652824863,
            "Land_fraction": 88.7378347175138,
            "Rank": 164,
            "Perc_contribution_rescale": 0.0496031746031746
        },
        {
            "Country": "Solomon Islands",
            "Abs_contribution": 3.763614567631e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 3.82789867631004e-06,
            "Land_abs": 3.3808247e-05,
            "Fossil_fraction": 10.1708041764742,
            "Land_fraction": 89.8291958235259,
            "Rank": 165,
            "Perc_contribution_rescale": 0.0496031746031746
        },
        {
            "Country": "Guinea-Bissau",
            "Abs_contribution": 3.48435321086243e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 3.30626810862445e-06,
            "Land_abs": 3.15372639999998e-05,
            "Fossil_fraction": 9.48890054635448,
            "Land_fraction": 90.5110994536453,
            "Rank": 166,
            "Perc_contribution_rescale": 0.0496031746031746
        },
        {
            "Country": "Malta",
            "Abs_contribution": 3.29619817903933e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 3.3791711790393e-05,
            "Land_abs": -0.00000082973,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 167,
            "Perc_contribution_rescale": 0.0496031746031746
        },
        {
            "Country": "Georgia",
            "Abs_contribution": 3.1919982484716e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 0.000107416903984716,
            "Land_abs": -0.0000754969215,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 168,
            "Perc_contribution_rescale": 0.0496031746031746
        },
        {
            "Country": "Bahamas",
            "Abs_contribution": 2.91605872658295e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 2.94061842658297e-05,
            "Land_abs": -0.000000245597,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 169,
            "Perc_contribution_rescale": 0.0496031746031746
        },
        {
            "Country": "Fiji",
            "Abs_contribution": 2.8704958757642e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 1.44714042576419e-05,
            "Land_abs": 1.42335545000002e-05,
            "Fossil_fraction": 50.414300817587,
            "Land_fraction": 49.5856991824134,
            "Rank": 170,
            "Perc_contribution_rescale": 0.0496031746031746
        },
        {
            "Country": "Gambia",
            "Abs_contribution": 2.8036402474891e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 5.77812797489083e-06,
            "Land_abs": 2.22582745000001e-05,
            "Fossil_fraction": 20.6093773267296,
            "Land_fraction": 79.3906226732702,
            "Rank": 171,
            "Perc_contribution_rescale": 0.0496031746031746
        },
        {
            "Country": "Eritrea",
            "Abs_contribution": 2.63326890425764e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 8.27439604257642e-06,
            "Land_abs": 1.8058293e-05,
            "Fossil_fraction": 31.4225259304047,
            "Land_fraction": 68.5774740695953,
            "Rank": 172,
            "Perc_contribution_rescale": 0.0496031746031746
        },
        {
            "Country": "Barbados",
            "Abs_contribution": 2.26994527729258e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 2.31782002729258e-05,
            "Land_abs": -0.0000004787475,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 173,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Aruba",
            "Abs_contribution": 2.12808430267467e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 2.12808430267467e-05,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 174,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Macao",
            "Abs_contribution": 2.01592420169214e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 2.01592420169214e-05,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 175,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Vanuatu",
            "Abs_contribution": 1.40647120114629e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 1.59247201146288e-06,
            "Land_abs": 1.247224e-05,
            "Fossil_fraction": 11.3224644071276,
            "Land_fraction": 88.6775355928723,
            "Rank": 176,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Maldives",
            "Abs_contribution": 1.23095720420306e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 1.23070640420306e-05,
            "Land_abs": 2.508e-09,
            "Fossil_fraction": 99.979625611748,
            "Land_fraction": 0.020374388251976,
            "Rank": 177,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Montenegro",
            "Abs_contribution": 1.07238679246724e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 2.77042214246725e-05,
            "Land_abs": -0.0000169803534999998,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 178,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "French Polynesia",
            "Abs_contribution": 1.05457511872271e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 1.05457511872271e-05,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 179,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Faeroe Islands",
            "Abs_contribution": 9.5093926719432e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 9.5093926719432e-06,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 180,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Greenland",
            "Abs_contribution": 8.57267722434498e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 8.57267722434498e-06,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 181,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Sint Maarten (Dutch part)",
            "Abs_contribution": 8.1475685043668e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 8.1475685043668e-06,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 182,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Bermuda",
            "Abs_contribution": 7.9117774699782e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 7.9117774699782e-06,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 183,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Andorra",
            "Abs_contribution": 6.94673208679041e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 6.88330058679039e-06,
            "Land_abs": 6.34315e-08,
            "Fossil_fraction": 99.0868871980735,
            "Land_fraction": 0.913112801926224,
            "Rank": 184,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Antigua and Barbuda",
            "Abs_contribution": 6.5613843979257e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 6.6811908979258e-06,
            "Land_abs": -0.0000001198065,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 185,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Cape Verde",
            "Abs_contribution": 6.22291051310042e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 5.88185551310044e-06,
            "Land_abs": 3.41054999999999e-07,
            "Fossil_fraction": 94.5193651864028,
            "Land_fraction": 5.48063481359748,
            "Rank": 186,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Djibouti",
            "Abs_contribution": 6.00909806713975e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 5.81902356713974e-06,
            "Land_abs": 1.90074500000001e-07,
            "Fossil_fraction": 96.8368880341724,
            "Land_fraction": 3.16311196582741,
            "Rank": 187,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Seychelles",
            "Abs_contribution": 5.70513033569869e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 5.70513033569869e-06,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 188,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Lucia",
            "Abs_contribution": 4.88467033351531e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 5.70168983351528e-06,
            "Land_abs": -0.0000008170195,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 189,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Turks and Caicos Islands",
            "Abs_contribution": 3.05207263919214e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 3.05207263919214e-06,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 190,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Comoros",
            "Abs_contribution": 2.99548014301311e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 2.3627216430131e-06,
            "Land_abs": 6.327585e-07,
            "Fossil_fraction": 78.8762245186,
            "Land_fraction": 21.1237754813997,
            "Rank": 191,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Palau",
            "Abs_contribution": 2.95739353165939e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 2.95739353165939e-06,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 192,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Swaziland",
            "Abs_contribution": 2.7965299999996e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 2.7965299999996e-06,
            "Fossil_fraction": 0,
            "Land_fraction": 100,
            "Rank": 193,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Grenada",
            "Abs_contribution": 2.67361161681223e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 3.27018561681223e-06,
            "Land_abs": -0.000000596574,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 194,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Liechtenstein",
            "Abs_contribution": 2.61121365447598e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 2.79730615447598e-06,
            "Land_abs": -0.0000001860925,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 195,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Vincent and the Grenadines",
            "Abs_contribution": 2.59050176528387e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 2.80618976528384e-06,
            "Land_abs": -0.000000215688,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 196,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Kitts and Nevis",
            "Abs_contribution": 2.30403227183406e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 2.78846127183406e-06,
            "Land_abs": -0.000000484429,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 197,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "British Virgin Islands",
            "Abs_contribution": 2.2228634279476e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 2.2228634279476e-06,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 198,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Sao Tome and Principe",
            "Abs_contribution": 2.07925748526201e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.27027348526201e-06,
            "Land_abs": 8.08984e-07,
            "Fossil_fraction": 61.0926493840151,
            "Land_fraction": 38.9073506159849,
            "Rank": 199,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Dominica",
            "Abs_contribution": 1.91501235425766e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.86821835425764e-06,
            "Land_abs": 4.6794e-08,
            "Fossil_fraction": 97.5564648501623,
            "Land_fraction": 2.44353514983663,
            "Rank": 200,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Tonga",
            "Abs_contribution": 1.69144546015284e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.67270146015284e-06,
            "Land_abs": 1.87439999999897e-08,
            "Fossil_fraction": 98.8918353892235,
            "Land_fraction": 1.10816461077592,
            "Rank": 201,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Marshall Islands",
            "Abs_contribution": 1.67146125818777e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.67146125818777e-06,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 202,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Anguilla",
            "Abs_contribution": 1.47758986080786e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.47758986080786e-06,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 203,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Micronesia (Federated States of)",
            "Abs_contribution": 1.11340375818777e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 2.06416125818777e-06,
            "Land_abs": -0.0000009507575,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 204,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Bonaire, Saint Eustatius and Saba",
            "Abs_contribution": 1.06408878275109e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.06408878275109e-06,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 205,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Nauru",
            "Abs_contribution": 1.0065864628821e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.0065864628821e-06,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 206,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Pierre and Miquelon",
            "Abs_contribution": 9.4035859716157e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 9.4035859716157e-07,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 207,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Cook Islands",
            "Abs_contribution": 6.8163672379913e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 9.0313272379913e-07,
            "Land_abs": -0.000000221496,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 208,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Kiribati",
            "Abs_contribution": 6.60582723799127e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 6.60582723799127e-07,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 209,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Montserrat",
            "Abs_contribution": 5.15817740174672e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 5.15817740174672e-07,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 210,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Wallis and Futuna Islands",
            "Abs_contribution": 3.50668231441048e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 3.50668231441048e-07,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 211,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Samoa",
            "Abs_contribution": 2.62473053493399e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 2.51453605349345e-06,
            "Land_abs": -0.000002252063,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 212,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Helena",
            "Abs_contribution": 1.67773116812227e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 1.67773116812227e-07,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 213,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Tuvalu",
            "Abs_contribution": 1.34021970524017e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 1.34021970524017e-07,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 214,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Niue",
            "Abs_contribution": 1.16743630458512e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 9.7598130458515e-08,
            "Land_abs": 1.91455e-08,
            "Fossil_fraction": 83.6003900814093,
            "Land_fraction": 16.3996099185933,
            "Rank": 215,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Pacific Islands (Palau)",
            "Abs_contribution": 1.056e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 1.056e-07,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 216,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Antarctica",
            "Abs_contribution": 5.61e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 5.61e-08,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 217,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Christmas Island",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 218,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Leeward Islands",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 219,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Panama Canal Zone",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 220,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Ryukyu Islands",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 221,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "St. Kitts-Nevis-Anguilla",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 222,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Occupied Palestinian Territory",
            "Abs_contribution": -0.0000000722149999999997,
            "Perc_contribution": -0,
            "Fossil_abs": 0,
            "Land_abs": -0.0000000722149999999997,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 223,
            "Perc_contribution_rescale": -0
        }
    ],
    "1990_N2O": [
        {
            "Country": "China",
            "Abs_contribution": 0.005797730061759,
            "Perc_contribution": 15.64,
            "Fossil_abs": 0.00158317298235712,
            "Land_abs": 0.00421455707940188,
            "Fossil_fraction": 27.306772917896,
            "Land_fraction": 72.693227082104,
            "Rank": 1,
            "Perc_contribution_rescale": 100
        },
        {
            "Country": "EU27",
            "Abs_contribution": 0.00389958538310531,
            "Perc_contribution": 10.52,
            "Fossil_abs": 0.00143330274631062,
            "Land_abs": 0.00246628263679472,
            "Fossil_fraction": 36.7552599955961,
            "Land_fraction": 63.2447400044046,
            "Rank": 2,
            "Perc_contribution_rescale": 67.2634271099744
        },
        {
            "Country": "United States",
            "Abs_contribution": 0.00364568893293958,
            "Perc_contribution": 9.83,
            "Fossil_abs": 0.00140621367895742,
            "Land_abs": 0.00223947525398212,
            "Fossil_fraction": 38.5719600553953,
            "Land_fraction": 61.4280399446037,
            "Rank": 3,
            "Perc_contribution_rescale": 62.8516624040921
        },
        {
            "Country": "India",
            "Abs_contribution": 0.00310553651172503,
            "Perc_contribution": 8.38,
            "Fossil_abs": 0.000630153295059502,
            "Land_abs": 0.00247538321666553,
            "Fossil_fraction": 20.2912859881165,
            "Land_fraction": 79.7087140118836,
            "Rank": 4,
            "Perc_contribution_rescale": 53.5805626598465
        },
        {
            "Country": "Brazil",
            "Abs_contribution": 0.00208075316876283,
            "Perc_contribution": 5.61,
            "Fossil_abs": 0.000250129501483215,
            "Land_abs": 0.00183062366727961,
            "Fossil_fraction": 12.0211039559265,
            "Land_fraction": 87.9788960440732,
            "Rank": 5,
            "Perc_contribution_rescale": 35.8695652173913
        },
        {
            "Country": "Mexico",
            "Abs_contribution": 0.00124272697853344,
            "Perc_contribution": 3.35,
            "Fossil_abs": 0.000793951126855349,
            "Land_abs": 0.000448775851678084,
            "Fossil_fraction": 63.8878161148722,
            "Land_fraction": 36.1121838851275,
            "Rank": 6,
            "Perc_contribution_rescale": 21.4194373401535
        },
        {
            "Country": "Russia",
            "Abs_contribution": 0.00109482653042318,
            "Perc_contribution": 2.95,
            "Fossil_abs": 0.00042892687692658,
            "Land_abs": 0.00066589965349658,
            "Fossil_fraction": 39.177610791071,
            "Land_fraction": 60.8223892089272,
            "Rank": 7,
            "Perc_contribution_rescale": 18.8618925831202
        },
        {
            "Country": "Australia",
            "Abs_contribution": 0.00104778715321301,
            "Perc_contribution": 2.83,
            "Fossil_abs": 0.000126598012343204,
            "Land_abs": 0.00092118914086981,
            "Fossil_fraction": 12.0824169255173,
            "Land_fraction": 87.9175830744832,
            "Rank": 8,
            "Perc_contribution_rescale": 18.0946291560102
        },
        {
            "Country": "Indonesia",
            "Abs_contribution": 0.000779375528700332,
            "Perc_contribution": 2.1,
            "Fossil_abs": 0.00014923249170524,
            "Land_abs": 0.000630143036995085,
            "Fossil_fraction": 19.1477004614319,
            "Land_fraction": 80.8522995385673,
            "Rank": 9,
            "Perc_contribution_rescale": 13.4271099744246
        },
        {
            "Country": "Pakistan",
            "Abs_contribution": 0.000673166165615175,
            "Perc_contribution": 1.82,
            "Fossil_abs": 0.000103100975324509,
            "Land_abs": 0.000570065190290666,
            "Fossil_fraction": 15.3158284820049,
            "Land_fraction": 84.6841715179951,
            "Rank": 10,
            "Perc_contribution_rescale": 11.6368286445013
        },
        {
            "Country": "Germany",
            "Abs_contribution": 0.00066372250226487,
            "Perc_contribution": 1.79,
            "Fossil_abs": 0.00025835963888724,
            "Land_abs": 0.000405362863377631,
            "Fossil_fraction": 38.9258519947147,
            "Land_fraction": 61.0741480052855,
            "Rank": 11,
            "Perc_contribution_rescale": 11.4450127877238
        },
        {
            "Country": "France",
            "Abs_contribution": 0.00064690095282412,
            "Perc_contribution": 1.74,
            "Fossil_abs": 0.00019540352819661,
            "Land_abs": 0.000451497424627515,
            "Fossil_fraction": 30.2060968288196,
            "Land_fraction": 69.7939031711812,
            "Rank": 12,
            "Perc_contribution_rescale": 11.1253196930946
        },
        {
            "Country": "Canada",
            "Abs_contribution": 0.000595432262370359,
            "Perc_contribution": 1.61,
            "Fossil_abs": 0.000157848904368177,
            "Land_abs": 0.000437583358002182,
            "Fossil_fraction": 26.5099683614381,
            "Land_fraction": 73.4900316385619,
            "Rank": 13,
            "Perc_contribution_rescale": 10.2941176470588
        },
        {
            "Country": "Argentina",
            "Abs_contribution": 0.00057657880424795,
            "Perc_contribution": 1.55,
            "Fossil_abs": 5.10245098354259e-05,
            "Land_abs": 0.000525554294412531,
            "Fossil_fraction": 8.84952923338533,
            "Land_fraction": 91.1504707666159,
            "Rank": 14,
            "Perc_contribution_rescale": 9.91048593350384
        },
        {
            "Country": "T\xfcrkiye",
            "Abs_contribution": 0.000517323008508528,
            "Perc_contribution": 1.4,
            "Fossil_abs": 0.000202211677312295,
            "Land_abs": 0.000315111331196234,
            "Fossil_fraction": 39.0880888702947,
            "Land_fraction": 60.9119111297056,
            "Rank": 15,
            "Perc_contribution_rescale": 8.95140664961637
        },
        {
            "Country": "United Kingdom",
            "Abs_contribution": 0.00051382834204667,
            "Perc_contribution": 1.39,
            "Fossil_abs": 0.000163208335601446,
            "Land_abs": 0.000350620006445223,
            "Fossil_fraction": 31.7632022693334,
            "Land_fraction": 68.2367977306664,
            "Rank": 16,
            "Perc_contribution_rescale": 8.88746803069054
        },
        {
            "Country": "Ethiopia",
            "Abs_contribution": 0.000477101757692603,
            "Perc_contribution": 1.29,
            "Fossil_abs": 5.42036934849891e-05,
            "Land_abs": 0.000422898064207614,
            "Fossil_fraction": 11.3610341213441,
            "Land_fraction": 88.6389658786559,
            "Rank": 17,
            "Perc_contribution_rescale": 8.24808184143222
        },
        {
            "Country": "Nigeria",
            "Abs_contribution": 0.000434659288750914,
            "Perc_contribution": 1.17,
            "Fossil_abs": 0.000119741320347667,
            "Land_abs": 0.000314917968403247,
            "Fossil_fraction": 27.5483173710078,
            "Land_fraction": 72.4516826289922,
            "Rank": 18,
            "Perc_contribution_rescale": 7.48081841432225
        },
        {
            "Country": "Iran",
            "Abs_contribution": 0.000395297613942126,
            "Perc_contribution": 1.07,
            "Fossil_abs": 0.000169794928974522,
            "Land_abs": 0.000225502684967603,
            "Fossil_fraction": 42.9536943775687,
            "Land_fraction": 57.0463056224311,
            "Rank": 19,
            "Perc_contribution_rescale": 6.84143222506394
        },
        {
            "Country": "Poland",
            "Abs_contribution": 0.000384254614343489,
            "Perc_contribution": 1.04,
            "Fossil_abs": 0.000131142793318109,
            "Land_abs": 0.000253111821025383,
            "Fossil_fraction": 34.1291394879332,
            "Land_fraction": 65.8708605120676,
            "Rank": 20,
            "Perc_contribution_rescale": 6.64961636828644
        },
        {
            "Country": "Ukraine",
            "Abs_contribution": 0.00037090718938199,
            "Perc_contribution": 1,
            "Fossil_abs": 0.000106089106704367,
            "Land_abs": 0.000264818082677617,
            "Fossil_fraction": 28.6026018749148,
            "Land_fraction": 71.3973981250835,
            "Rank": 21,
            "Perc_contribution_rescale": 6.39386189258312
        },
        {
            "Country": "Japan",
            "Abs_contribution": 0.000369723523943245,
            "Perc_contribution": 1,
            "Fossil_abs": 0.000256357625295606,
            "Land_abs": 0.000113365898647639,
            "Fossil_fraction": 69.3376560304988,
            "Land_fraction": 30.6623439695012,
            "Rank": 22,
            "Perc_contribution_rescale": 6.39386189258312
        },
        {
            "Country": "Sudan",
            "Abs_contribution": 0.000329254338636476,
            "Perc_contribution": 0.89,
            "Fossil_abs": 1.42606120179449e-05,
            "Land_abs": 0.000314993726618531,
            "Fossil_fraction": 4.33118423799716,
            "Land_fraction": 95.6688157620028,
            "Rank": 23,
            "Perc_contribution_rescale": 5.69053708439898
        },
        {
            "Country": "Bangladesh",
            "Abs_contribution": 0.000324250149312609,
            "Perc_contribution": 0.87,
            "Fossil_abs": 5.29828959184635e-05,
            "Land_abs": 0.000271267253394146,
            "Fossil_fraction": 16.3401299986397,
            "Land_fraction": 83.6598700013605,
            "Rank": 24,
            "Perc_contribution_rescale": 5.56265984654731
        },
        {
            "Country": "Spain",
            "Abs_contribution": 0.00031249967705015,
            "Perc_contribution": 0.84,
            "Fossil_abs": 9.8799090414588e-05,
            "Land_abs": 0.000213700586635562,
            "Fossil_fraction": 31.615741605625,
            "Land_fraction": 68.384258394375,
            "Rank": 25,
            "Perc_contribution_rescale": 5.37084398976982
        },
        {
            "Country": "Italy",
            "Abs_contribution": 0.000304721054008044,
            "Perc_contribution": 0.82,
            "Fossil_abs": 0.000135186038070068,
            "Land_abs": 0.000169535015937976,
            "Fossil_fraction": 44.3638653423991,
            "Land_fraction": 55.6361346576009,
            "Rank": 26,
            "Perc_contribution_rescale": 5.24296675191816
        },
        {
            "Country": "Thailand",
            "Abs_contribution": 0.000300369900439233,
            "Perc_contribution": 0.81,
            "Fossil_abs": 9.1531103268955e-05,
            "Land_abs": 0.000208838797170279,
            "Fossil_fraction": 30.4727947557689,
            "Land_fraction": 69.5272052442314,
            "Rank": 27,
            "Perc_contribution_rescale": 5.17902813299233
        },
        {
            "Country": "South Africa",
            "Abs_contribution": 0.000292672319841648,
            "Perc_contribution": 0.79,
            "Fossil_abs": 9.6813746054681e-05,
            "Land_abs": 0.000195858573786968,
            "Fossil_fraction": 33.0792287111616,
            "Land_fraction": 66.9207712888388,
            "Rank": 28,
            "Perc_contribution_rescale": 5.05115089514066
        },
        {
            "Country": "Belarus",
            "Abs_contribution": 0.000291358354732861,
            "Perc_contribution": 0.79,
            "Fossil_abs": 9.53226770128819e-05,
            "Land_abs": 0.000196035677719978,
            "Fossil_fraction": 32.7166444567141,
            "Land_fraction": 67.2833555432855,
            "Rank": 29,
            "Perc_contribution_rescale": 5.05115089514066
        },
        {
            "Country": "Egypt",
            "Abs_contribution": 0.000277820336680349,
            "Perc_contribution": 0.75,
            "Fossil_abs": 9.84464937924811e-05,
            "Land_abs": 0.000179373842887868,
            "Fossil_fraction": 35.4353086490391,
            "Land_fraction": 64.564691350961,
            "Rank": 30,
            "Perc_contribution_rescale": 4.79539641943734
        },
        {
            "Country": "Viet Nam",
            "Abs_contribution": 0.000275290640829899,
            "Perc_contribution": 0.74,
            "Fossil_abs": 4.974629034375e-05,
            "Land_abs": 0.000225544350486149,
            "Fossil_fraction": 18.0704618921237,
            "Land_fraction": 81.9295381078763,
            "Rank": 31,
            "Perc_contribution_rescale": 4.73145780051151
        },
        {
            "Country": "South Sudan",
            "Abs_contribution": 0.000262876160148677,
            "Perc_contribution": 0.71,
            "Fossil_abs": 3.87679780206059e-06,
            "Land_abs": 0.000258999362346615,
            "Fossil_fraction": 1.4747620323836,
            "Land_fraction": 98.5252379676159,
            "Rank": 32,
            "Perc_contribution_rescale": 4.53964194373401
        },
        {
            "Country": "Tanzania",
            "Abs_contribution": 0.000260163522956128,
            "Perc_contribution": 0.7,
            "Fossil_abs": 2.44936219912664e-05,
            "Land_abs": 0.000235669900964861,
            "Fossil_fraction": 9.41470261201714,
            "Land_fraction": 90.5852973879826,
            "Rank": 33,
            "Perc_contribution_rescale": 4.47570332480818
        },
        {
            "Country": "Colombia",
            "Abs_contribution": 0.000260027352437473,
            "Perc_contribution": 0.7,
            "Fossil_abs": 2.875182517631e-05,
            "Land_abs": 0.000231275527261163,
            "Fossil_fraction": 11.0572310592686,
            "Land_fraction": 88.9427689407314,
            "Rank": 34,
            "Perc_contribution_rescale": 4.47570332480818
        },
        {
            "Country": "Angola",
            "Abs_contribution": 0.000225382853342481,
            "Perc_contribution": 0.61,
            "Fossil_abs": 1.21602057132233e-05,
            "Land_abs": 0.000213222647629257,
            "Fossil_fraction": 5.39535529561568,
            "Land_fraction": 94.604644704384,
            "Rank": 35,
            "Perc_contribution_rescale": 3.9002557544757
        },
        {
            "Country": "Chad",
            "Abs_contribution": 0.000215978025076679,
            "Perc_contribution": 0.58,
            "Fossil_abs": 4.33699394676583e-06,
            "Land_abs": 0.000211641031129913,
            "Fossil_fraction": 2.00807186065622,
            "Land_fraction": 97.9919281393437,
            "Rank": 36,
            "Perc_contribution_rescale": 3.70843989769821
        },
        {
            "Country": "New Zealand",
            "Abs_contribution": 0.000198369364788535,
            "Perc_contribution": 0.53,
            "Fossil_abs": 8.18672967124239e-06,
            "Land_abs": 0.000190182635117292,
            "Fossil_fraction": 4.12701310001652,
            "Land_fraction": 95.8729868999832,
            "Rank": 37,
            "Perc_contribution_rescale": 3.38874680306905
        },
        {
            "Country": "South Korea",
            "Abs_contribution": 0.000197546356827143,
            "Perc_contribution": 0.53,
            "Fossil_abs": 0.000130678327487677,
            "Land_abs": 6.68680293394646e-05,
            "Fossil_fraction": 66.1507149949738,
            "Land_fraction": 33.8492850050257,
            "Rank": 38,
            "Perc_contribution_rescale": 3.38874680306905
        },
        {
            "Country": "Kenya",
            "Abs_contribution": 0.000192815335308119,
            "Perc_contribution": 0.52,
            "Fossil_abs": 2.00951749360808e-05,
            "Land_abs": 0.000172720160372039,
            "Fossil_fraction": 10.4219796127568,
            "Land_fraction": 89.5780203872436,
            "Rank": 39,
            "Perc_contribution_rescale": 3.32480818414322
        },
        {
            "Country": "Myanmar",
            "Abs_contribution": 0.000190838913275928,
            "Perc_contribution": 0.51,
            "Fossil_abs": 2.22059449101665e-05,
            "Land_abs": 0.000168632968365762,
            "Fossil_fraction": 11.6359627756105,
            "Land_fraction": 88.3640372243898,
            "Rank": 40,
            "Perc_contribution_rescale": 3.26086956521739
        },
        {
            "Country": "Netherlands",
            "Abs_contribution": 0.000190090136904244,
            "Perc_contribution": 0.51,
            "Fossil_abs": 8.8147969284375e-05,
            "Land_abs": 0.000101942167619869,
            "Fossil_fraction": 46.3716691038939,
            "Land_fraction": 53.6283308961061,
            "Rank": 41,
            "Perc_contribution_rescale": 3.26086956521739
        },
        {
            "Country": "Democratic Republic of the Congo",
            "Abs_contribution": 0.000188841673175723,
            "Perc_contribution": 0.51,
            "Fossil_abs": 2.21504222759689e-05,
            "Land_abs": 0.000166691250899755,
            "Fossil_fraction": 11.7296261484388,
            "Land_fraction": 88.2703738515617,
            "Rank": 42,
            "Perc_contribution_rescale": 3.26086956521739
        },
        {
            "Country": "Venezuela",
            "Abs_contribution": 0.00016873143373604,
            "Perc_contribution": 0.46,
            "Fossil_abs": 2.52056849667986e-05,
            "Land_abs": 0.000143525748769241,
            "Fossil_fraction": 14.9383457537793,
            "Land_fraction": 85.0616542462205,
            "Rank": 43,
            "Perc_contribution_rescale": 2.94117647058824
        },
        {
            "Country": "Philippines",
            "Abs_contribution": 0.000163506117474481,
            "Perc_contribution": 0.44,
            "Fossil_abs": 3.71833779047079e-05,
            "Land_abs": 0.000126322739569774,
            "Fossil_fraction": 22.7412762770245,
            "Land_fraction": 77.2587237229761,
            "Rank": 44,
            "Perc_contribution_rescale": 2.81329923273657
        },
        {
            "Country": "Zambia",
            "Abs_contribution": 0.000160442001793764,
            "Perc_contribution": 0.43,
            "Fossil_abs": 1.40594728154885e-05,
            "Land_abs": 0.000146382528978276,
            "Fossil_fraction": 8.76296272690544,
            "Land_fraction": 91.2370372730949,
            "Rank": 45,
            "Perc_contribution_rescale": 2.74936061381074
        },
        {
            "Country": "Kazakhstan",
            "Abs_contribution": 0.000155982101015461,
            "Perc_contribution": 0.42,
            "Fossil_abs": 3.20715269738401e-05,
            "Land_abs": 0.000123910574041621,
            "Fossil_fraction": 20.5610302496574,
            "Land_fraction": 79.4389697503427,
            "Rank": 46,
            "Perc_contribution_rescale": 2.68542199488491
        },
        {
            "Country": "Romania",
            "Abs_contribution": 0.000149938208425464,
            "Perc_contribution": 0.4,
            "Fossil_abs": 5.4429529862677e-05,
            "Land_abs": 9.5508678562787e-05,
            "Fossil_fraction": 36.3013073413736,
            "Land_fraction": 63.6986926586264,
            "Rank": 47,
            "Perc_contribution_rescale": 2.55754475703325
        },
        {
            "Country": "Mongolia",
            "Abs_contribution": 0.000145352544564301,
            "Perc_contribution": 0.39,
            "Fossil_abs": 3.14384336368722e-06,
            "Land_abs": 0.000142208701200614,
            "Fossil_fraction": 2.16290906575526,
            "Land_fraction": 97.8370909342449,
            "Rank": 48,
            "Perc_contribution_rescale": 2.49360613810742
        },
        {
            "Country": "Uzbekistan",
            "Abs_contribution": 0.000141160750052374,
            "Perc_contribution": 0.38,
            "Fossil_abs": 1.38197408421125e-05,
            "Land_abs": 0.000127341009210262,
            "Fossil_fraction": 9.7900732583137,
            "Land_fraction": 90.2099267416867,
            "Rank": 49,
            "Perc_contribution_rescale": 2.42966751918159
        },
        {
            "Country": "Ireland",
            "Abs_contribution": 0.000133888113338237,
            "Perc_contribution": 0.36,
            "Fossil_abs": 1.11251418116267e-05,
            "Land_abs": 0.000122762971526611,
            "Fossil_fraction": 8.30928267957711,
            "Land_fraction": 91.6907173204234,
            "Rank": 50,
            "Perc_contribution_rescale": 2.30179028132992
        },
        {
            "Country": "Mali",
            "Abs_contribution": 0.000133557963239574,
            "Perc_contribution": 0.36,
            "Fossil_abs": 4.98306882490448e-06,
            "Land_abs": 0.00012857489441467,
            "Fossil_fraction": 3.73101588556418,
            "Land_fraction": 96.2689841144361,
            "Rank": 51,
            "Perc_contribution_rescale": 2.30179028132992
        },
        {
            "Country": "Belgium",
            "Abs_contribution": 0.000129136565609361,
            "Perc_contribution": 0.35,
            "Fossil_abs": 8.4733090991676e-05,
            "Land_abs": 4.44034746176854e-05,
            "Fossil_fraction": 65.6151033534485,
            "Land_fraction": 34.3848966465519,
            "Rank": 52,
            "Perc_contribution_rescale": 2.23785166240409
        },
        {
            "Country": "Sweden",
            "Abs_contribution": 0.000123298560018914,
            "Perc_contribution": 0.33,
            "Fossil_abs": 6.54137967561683e-05,
            "Land_abs": 5.7884763262746e-05,
            "Fossil_fraction": 53.053171704628,
            "Land_fraction": 46.9468282953722,
            "Rank": 53,
            "Perc_contribution_rescale": 2.10997442455243
        },
        {
            "Country": "Mozambique",
            "Abs_contribution": 0.000122463436045824,
            "Perc_contribution": 0.33,
            "Fossil_abs": 1.06801430680267e-05,
            "Land_abs": 0.000111783292977798,
            "Fossil_fraction": 8.72108721825378,
            "Land_fraction": 91.2789127817468,
            "Rank": 54,
            "Perc_contribution_rescale": 2.10997442455243
        },
        {
            "Country": "Saudi Arabia",
            "Abs_contribution": 0.000119857882522107,
            "Perc_contribution": 0.32,
            "Fossil_abs": 7.4309982881414e-05,
            "Land_abs": 4.55478996406933e-05,
            "Fossil_fraction": 61.998411216474,
            "Land_fraction": 38.0015887835265,
            "Rank": 55,
            "Perc_contribution_rescale": 2.0460358056266
        },
        {
            "Country": "Uganda",
            "Abs_contribution": 0.000118484555996029,
            "Perc_contribution": 0.32,
            "Fossil_abs": 1.45460043030704e-05,
            "Land_abs": 0.000103938551692959,
            "Fossil_fraction": 12.2767091295492,
            "Land_fraction": 87.7232908704507,
            "Rank": 56,
            "Perc_contribution_rescale": 2.0460358056266
        },
        {
            "Country": "Central African Republic",
            "Abs_contribution": 0.00011730340712702,
            "Perc_contribution": 0.32,
            "Fossil_abs": 1.36968813422489e-06,
            "Land_abs": 0.000115933718992795,
            "Fossil_fraction": 1.16764565307276,
            "Land_fraction": 98.8323543469271,
            "Rank": 57,
            "Perc_contribution_rescale": 2.0460358056266
        },
        {
            "Country": "Peru",
            "Abs_contribution": 0.000111795356161572,
            "Perc_contribution": 0.3,
            "Fossil_abs": 1.63345954469296e-05,
            "Land_abs": 9.5460760714643e-05,
            "Fossil_fraction": 14.6111573930871,
            "Land_fraction": 85.3888426069134,
            "Rank": 58,
            "Perc_contribution_rescale": 1.91815856777494
        },
        {
            "Country": "Malaysia",
            "Abs_contribution": 0.000109688445870279,
            "Perc_contribution": 0.3,
            "Fossil_abs": 3.3729763985494e-05,
            "Land_abs": 7.59586818847848e-05,
            "Fossil_fraction": 30.7505168095681,
            "Land_fraction": 69.249483190432,
            "Rank": 59,
            "Perc_contribution_rescale": 1.91815856777494
        },
        {
            "Country": "Finland",
            "Abs_contribution": 0.000106612171727743,
            "Perc_contribution": 0.29,
            "Fossil_abs": 4.62301193202105e-05,
            "Land_abs": 6.0382052407533e-05,
            "Fossil_fraction": 43.3628905321139,
            "Land_fraction": 56.6371094678866,
            "Rank": 60,
            "Perc_contribution_rescale": 1.8542199488491
        },
        {
            "Country": "Hungary",
            "Abs_contribution": 0.000105506180146179,
            "Perc_contribution": 0.28,
            "Fossil_abs": 3.76997043731172e-05,
            "Land_abs": 6.7806475773063e-05,
            "Fossil_fraction": 35.7322237625172,
            "Land_fraction": 64.2677762374839,
            "Rank": 61,
            "Perc_contribution_rescale": 1.79028132992327
        },
        {
            "Country": "Paraguay",
            "Abs_contribution": 0.000104504455937432,
            "Perc_contribution": 0.28,
            "Fossil_abs": 5.45952247725163e-06,
            "Land_abs": 9.90449334601805e-05,
            "Fossil_fraction": 5.22420066041999,
            "Land_fraction": 94.7757993395803,
            "Rank": 62,
            "Perc_contribution_rescale": 1.79028132992327
        },
        {
            "Country": "Morocco",
            "Abs_contribution": 0.000103787166438742,
            "Perc_contribution": 0.28,
            "Fossil_abs": 1.79256816002456e-05,
            "Land_abs": 8.5861484838496e-05,
            "Fossil_fraction": 17.2715781876807,
            "Land_fraction": 82.7284218123189,
            "Rank": 63,
            "Perc_contribution_rescale": 1.79028132992327
        },
        {
            "Country": "Niger",
            "Abs_contribution": 0.000103519951360152,
            "Perc_contribution": 0.28,
            "Fossil_abs": 5.02982760028657e-06,
            "Land_abs": 9.8490123759866e-05,
            "Fossil_fraction": 4.85880019667657,
            "Land_fraction": 95.1411998033236,
            "Rank": 64,
            "Perc_contribution_rescale": 1.79028132992327
        },
        {
            "Country": "Burkina Faso",
            "Abs_contribution": 0.000102809457706196,
            "Perc_contribution": 0.28,
            "Fossil_abs": 7.53220213378823e-06,
            "Land_abs": 9.52772555724068e-05,
            "Fossil_fraction": 7.32637084353992,
            "Land_fraction": 92.6736291564593,
            "Rank": 65,
            "Perc_contribution_rescale": 1.79028132992327
        },
        {
            "Country": "Madagascar",
            "Abs_contribution": 0.000102656688031278,
            "Perc_contribution": 0.28,
            "Fossil_abs": 6.74528516233628e-06,
            "Land_abs": 9.5911402868942e-05,
            "Fossil_fraction": 6.5707215883305,
            "Land_fraction": 93.4292784116697,
            "Rank": 66,
            "Perc_contribution_rescale": 1.79028132992327
        },
        {
            "Country": "Uruguay",
            "Abs_contribution": 0.000100853989958883,
            "Perc_contribution": 0.27,
            "Fossil_abs": 3.93698770803767e-06,
            "Land_abs": 9.6917002250846e-05,
            "Fossil_fraction": 3.90365092114128,
            "Land_fraction": 96.0963490788594,
            "Rank": 67,
            "Perc_contribution_rescale": 1.72634271099744
        },
        {
            "Country": "Bolivia",
            "Abs_contribution": 0.000100476244113332,
            "Perc_contribution": 0.27,
            "Fossil_abs": 5.925850347994e-06,
            "Land_abs": 9.45503937653383e-05,
            "Fossil_fraction": 5.89776260078942,
            "Land_fraction": 94.1022373992105,
            "Rank": 68,
            "Perc_contribution_rescale": 1.72634271099744
        },
        {
            "Country": "Chile",
            "Abs_contribution": 9.75408378813864e-05,
            "Perc_contribution": 0.26,
            "Fossil_abs": 2.93151653964383e-05,
            "Land_abs": 6.82256724849479e-05,
            "Fossil_fraction": 30.0542480802623,
            "Land_fraction": 69.9457519197375,
            "Rank": 69,
            "Perc_contribution_rescale": 1.66240409207161
        },
        {
            "Country": "Somalia",
            "Abs_contribution": 9.0453244035631e-05,
            "Perc_contribution": 0.24,
            "Fossil_abs": 5.79023317962609e-06,
            "Land_abs": 8.4663010856004e-05,
            "Fossil_fraction": 6.40135491143383,
            "Land_fraction": 93.5986450885652,
            "Rank": 70,
            "Perc_contribution_rescale": 1.53452685421995
        },
        {
            "Country": "Algeria",
            "Abs_contribution": 8.84930986896286e-05,
            "Perc_contribution": 0.24,
            "Fossil_abs": 3.05367090822462e-05,
            "Land_abs": 5.79563896073826e-05,
            "Fossil_fraction": 34.5074469471879,
            "Land_fraction": 65.4925530528124,
            "Rank": 71,
            "Perc_contribution_rescale": 1.53452685421995
        },
        {
            "Country": "Czechia",
            "Abs_contribution": 8.6835363639588e-05,
            "Perc_contribution": 0.23,
            "Fossil_abs": 4.16484147227616e-05,
            "Land_abs": 4.51869489168257e-05,
            "Fossil_fraction": 47.9625039582079,
            "Land_fraction": 52.0374960417913,
            "Rank": 72,
            "Perc_contribution_rescale": 1.47058823529412
        },
        {
            "Country": "Iraq",
            "Abs_contribution": 8.60225101407065e-05,
            "Perc_contribution": 0.23,
            "Fossil_abs": 4.04190336495361e-05,
            "Land_abs": 4.56034764911706e-05,
            "Fossil_fraction": 46.9865777962337,
            "Land_fraction": 53.0134222037665,
            "Rank": 73,
            "Perc_contribution_rescale": 1.47058823529412
        },
        {
            "Country": "Denmark",
            "Abs_contribution": 8.3129123738687e-05,
            "Perc_contribution": 0.22,
            "Fossil_abs": 1.96020831556769e-05,
            "Land_abs": 6.3527040583011e-05,
            "Fossil_fraction": 23.58028362875,
            "Land_fraction": 76.4197163712512,
            "Rank": 74,
            "Perc_contribution_rescale": 1.40664961636829
        },
        {
            "Country": "Greece",
            "Abs_contribution": 8.1506472031154e-05,
            "Perc_contribution": 0.22,
            "Fossil_abs": 2.65202964910071e-05,
            "Land_abs": 5.4986175540148e-05,
            "Fossil_fraction": 32.5376572315267,
            "Land_fraction": 67.4623427684746,
            "Rank": 75,
            "Perc_contribution_rescale": 1.40664961636829
        },
        {
            "Country": "Cameroon",
            "Abs_contribution": 8.00146378144651e-05,
            "Perc_contribution": 0.22,
            "Fossil_abs": 8.92064061808128e-06,
            "Land_abs": 7.10939971963838e-05,
            "Fossil_fraction": 11.1487608539404,
            "Land_fraction": 88.8512391460596,
            "Rank": 76,
            "Perc_contribution_rescale": 1.40664961636829
        },
        {
            "Country": "Lithuania",
            "Abs_contribution": 7.8053319626487e-05,
            "Perc_contribution": 0.21,
            "Fossil_abs": 2.68225791758597e-05,
            "Land_abs": 5.1230740450628e-05,
            "Fossil_fraction": 34.3644310123071,
            "Land_fraction": 65.6355689876938,
            "Rank": 77,
            "Perc_contribution_rescale": 1.34271099744246
        },
        {
            "Country": "Zimbabwe",
            "Abs_contribution": 7.77183981263651e-05,
            "Perc_contribution": 0.21,
            "Fossil_abs": 1.35678743801037e-05,
            "Land_abs": 6.41505237462606e-05,
            "Fossil_fraction": 17.4577380738641,
            "Land_fraction": 82.5422619261349,
            "Rank": 78,
            "Perc_contribution_rescale": 1.34271099744246
        },
        {
            "Country": "Nepal",
            "Abs_contribution": 7.4807039826624e-05,
            "Perc_contribution": 0.2,
            "Fossil_abs": 1.61557140559225e-05,
            "Land_abs": 5.86513257707013e-05,
            "Fossil_fraction": 21.596515639926,
            "Land_fraction": 78.4034843600738,
            "Rank": 79,
            "Perc_contribution_rescale": 1.27877237851662
        },
        {
            "Country": "Taiwan",
            "Abs_contribution": 7.40540344621592e-05,
            "Perc_contribution": 0.2,
            "Fossil_abs": 5.07280773084784e-05,
            "Land_abs": 2.33259571536804e-05,
            "Fossil_fraction": 68.5014363861565,
            "Land_fraction": 31.498563613843,
            "Rank": 80,
            "Perc_contribution_rescale": 1.27877237851662
        },
        {
            "Country": "Syria",
            "Abs_contribution": 6.9313211967454e-05,
            "Perc_contribution": 0.19,
            "Fossil_abs": 2.3292289237193e-05,
            "Land_abs": 4.60209227302607e-05,
            "Fossil_fraction": 33.6044003387549,
            "Land_fraction": 66.3955996612447,
            "Rank": 81,
            "Perc_contribution_rescale": 1.21483375959079
        },
        {
            "Country": "Ecuador",
            "Abs_contribution": 6.65941168906115e-05,
            "Perc_contribution": 0.18,
            "Fossil_abs": 9.82957446267737e-06,
            "Land_abs": 5.6764542427934e-05,
            "Fossil_fraction": 14.7604246765875,
            "Land_fraction": 85.2395753234123,
            "Rank": 82,
            "Perc_contribution_rescale": 1.15089514066496
        },
        {
            "Country": "Norway",
            "Abs_contribution": 6.4419540256031e-05,
            "Perc_contribution": 0.17,
            "Fossil_abs": 2.77719142301041e-05,
            "Land_abs": 3.66476260259283e-05,
            "Fossil_fraction": 43.1110096714856,
            "Land_fraction": 56.8889903285166,
            "Rank": 83,
            "Perc_contribution_rescale": 1.08695652173913
        },
        {
            "Country": "Turkmenistan",
            "Abs_contribution": 6.27133170419217e-05,
            "Perc_contribution": 0.17,
            "Fossil_abs": 1.33897634135003e-05,
            "Land_abs": 4.93235536284211e-05,
            "Fossil_fraction": 21.3507498009549,
            "Land_fraction": 78.6492501990446,
            "Rank": 84,
            "Perc_contribution_rescale": 1.08695652173913
        },
        {
            "Country": "Guinea",
            "Abs_contribution": 6.26771421326819e-05,
            "Perc_contribution": 0.17,
            "Fossil_abs": 6.01314963567001e-06,
            "Land_abs": 5.66639924970112e-05,
            "Fossil_fraction": 9.59384782244971,
            "Land_fraction": 90.4061521775492,
            "Rank": 85,
            "Perc_contribution_rescale": 1.08695652173913
        },
        {
            "Country": "Ghana",
            "Abs_contribution": 6.24383196527698e-05,
            "Perc_contribution": 0.17,
            "Fossil_abs": 9.50615837022375e-06,
            "Land_abs": 5.29321612825459e-05,
            "Fossil_fraction": 15.2248786051404,
            "Land_fraction": 84.7751213948593,
            "Rank": 86,
            "Perc_contribution_rescale": 1.08695652173913
        },
        {
            "Country": "Senegal",
            "Abs_contribution": 6.23048469165389e-05,
            "Perc_contribution": 0.17,
            "Fossil_abs": 4.22615091370087e-06,
            "Land_abs": 5.80786960028382e-05,
            "Fossil_fraction": 6.7830211016521,
            "Land_fraction": 93.2169788983482,
            "Rank": 87,
            "Perc_contribution_rescale": 1.08695652173913
        },
        {
            "Country": "Austria",
            "Abs_contribution": 6.0035647751774e-05,
            "Perc_contribution": 0.16,
            "Fossil_abs": 2.415270565814e-05,
            "Land_abs": 3.58829420936341e-05,
            "Fossil_fraction": 40.2306072518828,
            "Land_fraction": 59.7693927481173,
            "Rank": 88,
            "Perc_contribution_rescale": 1.0230179028133
        },
        {
            "Country": "Cuba",
            "Abs_contribution": 6.0015035115515e-05,
            "Perc_contribution": 0.16,
            "Fossil_abs": 1.63532980596247e-05,
            "Land_abs": 4.36617370558907e-05,
            "Fossil_fraction": 27.2486686513611,
            "Land_fraction": 72.7513313486395,
            "Rank": 89,
            "Perc_contribution_rescale": 1.0230179028133
        },
        {
            "Country": "Botswana",
            "Abs_contribution": 5.92075053233961e-05,
            "Perc_contribution": 0.16,
            "Fossil_abs": 2.04354123363127e-06,
            "Land_abs": 5.71639640897652e-05,
            "Fossil_fraction": 3.45149018265385,
            "Land_fraction": 96.5485098173468,
            "Rank": 90,
            "Perc_contribution_rescale": 1.0230179028133
        },
        {
            "Country": "Bulgaria",
            "Abs_contribution": 5.7022382638837e-05,
            "Perc_contribution": 0.15,
            "Fossil_abs": 1.43712928939274e-05,
            "Land_abs": 4.265108974491e-05,
            "Fossil_fraction": 25.2028979303635,
            "Land_fraction": 74.7971020696372,
            "Rank": 91,
            "Perc_contribution_rescale": 0.959079283887468
        },
        {
            "Country": "Yemen",
            "Abs_contribution": 5.63429353290847e-05,
            "Perc_contribution": 0.15,
            "Fossil_abs": 2.00680157393327e-05,
            "Land_abs": 3.62749195897517e-05,
            "Fossil_fraction": 35.6176255676431,
            "Land_fraction": 64.3823744323563,
            "Rank": 92,
            "Perc_contribution_rescale": 0.959079283887468
        },
        {
            "Country": "Serbia",
            "Abs_contribution": 5.4761438978426e-05,
            "Perc_contribution": 0.15,
            "Fossil_abs": 1.48285527660467e-05,
            "Land_abs": 3.99328862123786e-05,
            "Fossil_fraction": 27.0784571090044,
            "Land_fraction": 72.9215428909943,
            "Rank": 93,
            "Perc_contribution_rescale": 0.959079283887468
        },
        {
            "Country": "Cambodia",
            "Abs_contribution": 5.38819312349546e-05,
            "Perc_contribution": 0.15,
            "Fossil_abs": 6.64552456389874e-06,
            "Land_abs": 4.72364066710562e-05,
            "Fossil_fraction": 12.3334936435753,
            "Land_fraction": 87.6665063564253,
            "Rank": 94,
            "Perc_contribution_rescale": 0.959079283887468
        },
        {
            "Country": "Afghanistan",
            "Abs_contribution": 5.37279939306923e-05,
            "Perc_contribution": 0.14,
            "Fossil_abs": 4.26456344315093e-06,
            "Land_abs": 4.94634304875405e-05,
            "Fossil_fraction": 7.93732118242141,
            "Land_fraction": 92.062678817577,
            "Rank": 95,
            "Perc_contribution_rescale": 0.895140664961637
        },
        {
            "Country": "Guatemala",
            "Abs_contribution": 5.13496943006536e-05,
            "Perc_contribution": 0.14,
            "Fossil_abs": 1.03596013112841e-05,
            "Land_abs": 4.09900929893695e-05,
            "Fossil_fraction": 20.1746114604469,
            "Land_fraction": 79.8253885395531,
            "Rank": 96,
            "Perc_contribution_rescale": 0.895140664961637
        },
        {
            "Country": "North Korea",
            "Abs_contribution": 5.06383313913005e-05,
            "Perc_contribution": 0.14,
            "Fossil_abs": 1.99622535831059e-05,
            "Land_abs": 3.06760778081946e-05,
            "Fossil_fraction": 39.4212309818237,
            "Land_fraction": 60.5787690181763,
            "Rank": 97,
            "Perc_contribution_rescale": 0.895140664961637
        },
        {
            "Country": "Portugal",
            "Abs_contribution": 5.06228621096888e-05,
            "Perc_contribution": 0.14,
            "Fossil_abs": 1.92682716631974e-05,
            "Land_abs": 3.13545904464915e-05,
            "Fossil_fraction": 38.0623909044242,
            "Land_fraction": 61.937609095576,
            "Rank": 98,
            "Perc_contribution_rescale": 0.895140664961637
        },
        {
            "Country": "Namibia",
            "Abs_contribution": 4.98714579818698e-05,
            "Perc_contribution": 0.13,
            "Fossil_abs": 2.16661060336245e-06,
            "Land_abs": 4.7704847378507e-05,
            "Fossil_fraction": 4.34438993973285,
            "Land_fraction": 95.6556100602664,
            "Rank": 99,
            "Perc_contribution_rescale": 0.831202046035806
        },
        {
            "Country": "C\xf4te d'Ivoire",
            "Abs_contribution": 4.50790838573949e-05,
            "Perc_contribution": 0.12,
            "Fossil_abs": 8.67318068565642e-06,
            "Land_abs": 3.64059031717385e-05,
            "Fossil_fraction": 19.2399222510678,
            "Land_fraction": 80.7600777489323,
            "Rank": 100,
            "Perc_contribution_rescale": 0.767263427109974
        },
        {
            "Country": "Slovakia",
            "Abs_contribution": 4.19202689322993e-05,
            "Perc_contribution": 0.11,
            "Fossil_abs": 2.37451734989901e-05,
            "Land_abs": 1.81750954333092e-05,
            "Fossil_fraction": 56.6436573614026,
            "Land_fraction": 43.3563426385975,
            "Rank": 101,
            "Perc_contribution_rescale": 0.703324808184143
        },
        {
            "Country": "Tunisia",
            "Abs_contribution": 4.1055607733151e-05,
            "Perc_contribution": 0.11,
            "Fossil_abs": 1.18046078819337e-05,
            "Land_abs": 2.92509998512172e-05,
            "Fossil_fraction": 28.7527296116527,
            "Land_fraction": 71.247270388347,
            "Rank": 102,
            "Perc_contribution_rescale": 0.703324808184143
        },
        {
            "Country": "Azerbaijan",
            "Abs_contribution": 4.0261664565393e-05,
            "Perc_contribution": 0.11,
            "Fossil_abs": 5.9667563345675e-06,
            "Land_abs": 3.42949082308256e-05,
            "Fossil_fraction": 14.8199444781432,
            "Land_fraction": 85.180055521857,
            "Rank": 103,
            "Perc_contribution_rescale": 0.703324808184143
        },
        {
            "Country": "Dominican Republic",
            "Abs_contribution": 3.82394990775286e-05,
            "Perc_contribution": 0.1,
            "Fossil_abs": 6.44787342298443e-06,
            "Land_abs": 3.17916256545442e-05,
            "Fossil_fraction": 16.8618145596303,
            "Land_fraction": 83.1381854403697,
            "Rank": 104,
            "Perc_contribution_rescale": 0.639386189258312
        },
        {
            "Country": "Malawi",
            "Abs_contribution": 3.81325203128957e-05,
            "Perc_contribution": 0.1,
            "Fossil_abs": 5.88893766705787e-06,
            "Land_abs": 3.22435826458379e-05,
            "Fossil_fraction": 15.4433476170374,
            "Land_fraction": 84.5566523829628,
            "Rank": 105,
            "Perc_contribution_rescale": 0.639386189258312
        },
        {
            "Country": "Mauritania",
            "Abs_contribution": 3.61117356681959e-05,
            "Perc_contribution": 0.1,
            "Fossil_abs": 1.97885642922216e-06,
            "Land_abs": 3.41328792389738e-05,
            "Fossil_fraction": 5.47981533594622,
            "Land_fraction": 94.520184664054,
            "Rank": 106,
            "Perc_contribution_rescale": 0.639386189258312
        },
        {
            "Country": "Nicaragua",
            "Abs_contribution": 3.5316131908645e-05,
            "Perc_contribution": 0.1,
            "Fossil_abs": 3.221877617747e-06,
            "Land_abs": 3.20942542908979e-05,
            "Fossil_fraction": 9.12296291700711,
            "Land_fraction": 90.8770370829926,
            "Rank": 107,
            "Perc_contribution_rescale": 0.639386189258312
        },
        {
            "Country": "Croatia",
            "Abs_contribution": 3.53064860456169e-05,
            "Perc_contribution": 0.1,
            "Fossil_abs": 1.59758264550164e-05,
            "Land_abs": 1.93306595906004e-05,
            "Fossil_fraction": 45.2489846607086,
            "Land_fraction": 54.7510153392912,
            "Rank": 108,
            "Perc_contribution_rescale": 0.639386189258312
        },
        {
            "Country": "Switzerland",
            "Abs_contribution": 3.52864401354532e-05,
            "Perc_contribution": 0.1,
            "Fossil_abs": 1.10390413307301e-05,
            "Land_abs": 2.42473988047229e-05,
            "Fossil_fraction": 31.2840889824953,
            "Land_fraction": 68.7159110175042,
            "Rank": 109,
            "Perc_contribution_rescale": 0.639386189258312
        },
        {
            "Country": "Singapore",
            "Abs_contribution": 3.42070023723922e-05,
            "Perc_contribution": 0.09,
            "Fossil_abs": 3.39435676982558e-05,
            "Land_abs": 2.6343467413636e-07,
            "Fossil_fraction": 99.229880855187,
            "Land_fraction": 0.770119144812797,
            "Rank": 110,
            "Perc_contribution_rescale": 0.575447570332481
        },
        {
            "Country": "Sri Lanka",
            "Abs_contribution": 3.38217531412132e-05,
            "Perc_contribution": 0.09,
            "Fossil_abs": 1.15405698773539e-05,
            "Land_abs": 2.22811832638592e-05,
            "Fossil_fraction": 34.1217376555541,
            "Land_fraction": 65.8782623444456,
            "Rank": 111,
            "Perc_contribution_rescale": 0.575447570332481
        },
        {
            "Country": "Honduras",
            "Abs_contribution": 3.2063430577672e-05,
            "Perc_contribution": 0.09,
            "Fossil_abs": 5.59545476391649e-06,
            "Land_abs": 2.64679758137554e-05,
            "Fossil_fraction": 17.451204263255,
            "Land_fraction": 82.5487957367447,
            "Rank": 112,
            "Perc_contribution_rescale": 0.575447570332481
        },
        {
            "Country": "Israel",
            "Abs_contribution": 3.19819450209539e-05,
            "Perc_contribution": 0.09,
            "Fossil_abs": 1.81983755843081e-05,
            "Land_abs": 1.37835694366458e-05,
            "Fossil_fraction": 56.902028855296,
            "Land_fraction": 43.097971144704,
            "Rank": 113,
            "Perc_contribution_rescale": 0.575447570332481
        },
        {
            "Country": "Benin",
            "Abs_contribution": 3.11555946557751e-05,
            "Perc_contribution": 0.08,
            "Fossil_abs": 4.18654181496862e-06,
            "Land_abs": 2.69690528408065e-05,
            "Fossil_fraction": 13.4375281910807,
            "Land_fraction": 86.5624718089194,
            "Rank": 114,
            "Perc_contribution_rescale": 0.51150895140665
        },
        {
            "Country": "Laos",
            "Abs_contribution": 3.07834733374291e-05,
            "Perc_contribution": 0.08,
            "Fossil_abs": 3.11879337693504e-06,
            "Land_abs": 2.76646799604939e-05,
            "Fossil_fraction": 10.1313888226607,
            "Land_fraction": 89.8686111773387,
            "Rank": 115,
            "Perc_contribution_rescale": 0.51150895140665
        },
        {
            "Country": "Latvia",
            "Abs_contribution": 2.88856316315705e-05,
            "Perc_contribution": 0.08,
            "Fossil_abs": 3.690880318125e-06,
            "Land_abs": 2.51947513134457e-05,
            "Fossil_fraction": 12.7775648640865,
            "Land_fraction": 87.2224351359142,
            "Rank": 116,
            "Perc_contribution_rescale": 0.51150895140665
        },
        {
            "Country": "United Arab Emirates",
            "Abs_contribution": 2.6052891044038e-05,
            "Perc_contribution": 0.07,
            "Fossil_abs": 1.81673433412541e-05,
            "Land_abs": 7.88554770278385e-06,
            "Fossil_fraction": 69.7325425824922,
            "Land_fraction": 30.2674574175077,
            "Rank": 117,
            "Perc_contribution_rescale": 0.447570332480818
        },
        {
            "Country": "Georgia",
            "Abs_contribution": 2.59168401823117e-05,
            "Perc_contribution": 0.07,
            "Fossil_abs": 1.21012784318736e-05,
            "Land_abs": 1.38155617504381e-05,
            "Fossil_fraction": 46.6927231357963,
            "Land_fraction": 53.3072768642037,
            "Rank": 118,
            "Perc_contribution_rescale": 0.447570332480818
        },
        {
            "Country": "Libya",
            "Abs_contribution": 2.38478148136941e-05,
            "Perc_contribution": 0.06,
            "Fossil_abs": 8.6872080969801e-06,
            "Land_abs": 1.5160606716714e-05,
            "Fossil_fraction": 36.4276901881662,
            "Land_fraction": 63.5723098118338,
            "Rank": 119,
            "Perc_contribution_rescale": 0.383631713554987
        },
        {
            "Country": "Estonia",
            "Abs_contribution": 2.30454222169569e-05,
            "Perc_contribution": 0.06,
            "Fossil_abs": 2.81463629636054e-06,
            "Land_abs": 2.02307859205964e-05,
            "Fossil_fraction": 12.2134290700455,
            "Land_fraction": 87.7865709299546,
            "Rank": 120,
            "Perc_contribution_rescale": 0.383631713554987
        },
        {
            "Country": "Costa Rica",
            "Abs_contribution": 2.25366926418914e-05,
            "Perc_contribution": 0.06,
            "Fossil_abs": 3.96953785940503e-06,
            "Land_abs": 1.85671547824864e-05,
            "Fossil_fraction": 17.6136663994184,
            "Land_fraction": 82.3863336005817,
            "Rank": 121,
            "Perc_contribution_rescale": 0.383631713554987
        },
        {
            "Country": "Kyrgyzstan",
            "Abs_contribution": 2.22810507228807e-05,
            "Perc_contribution": 0.06,
            "Fossil_abs": 2.60264281023471e-06,
            "Land_abs": 1.9678407912646e-05,
            "Fossil_fraction": 11.6809698187259,
            "Land_fraction": 88.3190301812741,
            "Rank": 122,
            "Perc_contribution_rescale": 0.383631713554987
        },
        {
            "Country": "Papua New Guinea",
            "Abs_contribution": 2.2045895968166e-05,
            "Perc_contribution": 0.06,
            "Fossil_abs": 2.39413370976256e-06,
            "Land_abs": 1.96517622584034e-05,
            "Fossil_fraction": 10.8597705133856,
            "Land_fraction": 89.1402294866142,
            "Rank": 123,
            "Perc_contribution_rescale": 0.383631713554987
        },
        {
            "Country": "Haiti",
            "Abs_contribution": 2.14452874279749e-05,
            "Perc_contribution": 0.06,
            "Fossil_abs": 4.58172509144787e-06,
            "Land_abs": 1.6863562336527e-05,
            "Fossil_fraction": 21.3647175718014,
            "Land_fraction": 78.6352824281985,
            "Rank": 124,
            "Perc_contribution_rescale": 0.383631713554987
        },
        {
            "Country": "Tajikistan",
            "Abs_contribution": 2.13385175988701e-05,
            "Perc_contribution": 0.06,
            "Fossil_abs": 2.2918619263387e-06,
            "Land_abs": 1.90466556725313e-05,
            "Fossil_fraction": 10.7404927062977,
            "Land_fraction": 89.2595072937018,
            "Rank": 125,
            "Perc_contribution_rescale": 0.383631713554987
        },
        {
            "Country": "Eritrea",
            "Abs_contribution": 2.06427905909116e-05,
            "Perc_contribution": 0.06,
            "Fossil_abs": 1.54258092525655e-06,
            "Land_abs": 1.9100209665655e-05,
            "Fossil_fraction": 7.47273445643392,
            "Land_fraction": 92.5272655435659,
            "Rank": 126,
            "Perc_contribution_rescale": 0.383631713554987
        },
        {
            "Country": "Togo",
            "Abs_contribution": 1.85010082038988e-05,
            "Perc_contribution": 0.05,
            "Fossil_abs": 2.79475787884961e-06,
            "Land_abs": 1.57062503250492e-05,
            "Fossil_fraction": 15.1059761070786,
            "Land_fraction": 84.8940238929214,
            "Rank": 127,
            "Perc_contribution_rescale": 0.319693094629156
        },
        {
            "Country": "Congo",
            "Abs_contribution": 1.8354976850363e-05,
            "Perc_contribution": 0.05,
            "Fossil_abs": 2.02269665988128e-06,
            "Land_abs": 1.63322801904817e-05,
            "Fossil_fraction": 11.0198812908951,
            "Land_fraction": 88.9801187091048,
            "Rank": 128,
            "Perc_contribution_rescale": 0.319693094629156
        },
        {
            "Country": "Trinidad and Tobago",
            "Abs_contribution": 1.82942099651447e-05,
            "Perc_contribution": 0.05,
            "Fossil_abs": 1.61119805465067e-05,
            "Land_abs": 2.18222941863783e-06,
            "Fossil_fraction": 88.0714749486546,
            "Land_fraction": 11.9285250513444,
            "Rank": 129,
            "Perc_contribution_rescale": 0.319693094629156
        },
        {
            "Country": "Rwanda",
            "Abs_contribution": 1.80378125834566e-05,
            "Perc_contribution": 0.05,
            "Fossil_abs": 3.52288649048581e-06,
            "Land_abs": 1.45149260929708e-05,
            "Fossil_fraction": 19.530563776435,
            "Land_fraction": 80.4694362235651,
            "Rank": 130,
            "Perc_contribution_rescale": 0.319693094629156
        },
        {
            "Country": "El Salvador",
            "Abs_contribution": 1.74712747338496e-05,
            "Perc_contribution": 0.05,
            "Fossil_abs": 3.36357164429312e-06,
            "Land_abs": 1.41077030895565e-05,
            "Fossil_fraction": 19.2520104888305,
            "Land_fraction": 80.7479895111696,
            "Rank": 131,
            "Perc_contribution_rescale": 0.319693094629156
        },
        {
            "Country": "Jordan",
            "Abs_contribution": 1.71699333222994e-05,
            "Perc_contribution": 0.05,
            "Fossil_abs": 1.05714759887637e-05,
            "Land_abs": 6.59845733353572e-06,
            "Fossil_fraction": 61.5696973909268,
            "Land_fraction": 38.430302609073,
            "Rank": 132,
            "Perc_contribution_rescale": 0.319693094629156
        },
        {
            "Country": "Panama",
            "Abs_contribution": 1.66212303175586e-05,
            "Perc_contribution": 0.04,
            "Fossil_abs": 2.62317623663073e-06,
            "Land_abs": 1.39980540809279e-05,
            "Fossil_fraction": 15.7820822316602,
            "Land_fraction": 84.21791776834,
            "Rank": 133,
            "Perc_contribution_rescale": 0.255754475703325
        },
        {
            "Country": "Albania",
            "Abs_contribution": 1.58232892585235e-05,
            "Perc_contribution": 0.04,
            "Fossil_abs": 1.89506905333379e-06,
            "Land_abs": 1.39282202051896e-05,
            "Fossil_fraction": 11.9764545940597,
            "Land_fraction": 88.0235454059397,
            "Rank": 134,
            "Perc_contribution_rescale": 0.255754475703325
        },
        {
            "Country": "Bosnia and Herzegovina",
            "Abs_contribution": 1.5050758017601e-05,
            "Perc_contribution": 0.04,
            "Fossil_abs": 3.24619262352757e-06,
            "Land_abs": 1.18045653940734e-05,
            "Fossil_fraction": 21.5682998805199,
            "Land_fraction": 78.4317001194799,
            "Rank": 135,
            "Perc_contribution_rescale": 0.255754475703325
        },
        {
            "Country": "Burundi",
            "Abs_contribution": 1.47075726040693e-05,
            "Perc_contribution": 0.04,
            "Fossil_abs": 3.79138899058133e-06,
            "Land_abs": 1.09161836134879e-05,
            "Fossil_fraction": 25.7784822325632,
            "Land_fraction": 74.2215177674364,
            "Rank": 136,
            "Perc_contribution_rescale": 0.255754475703325
        },
        {
            "Country": "Moldova",
            "Abs_contribution": 1.46192847851814e-05,
            "Perc_contribution": 0.04,
            "Fossil_abs": 2.5040271219391e-06,
            "Land_abs": 1.21152576632423e-05,
            "Fossil_fraction": 17.1282464137867,
            "Land_fraction": 82.8717535862133,
            "Rank": 137,
            "Perc_contribution_rescale": 0.255754475703325
        },
        {
            "Country": "Sierra Leone",
            "Abs_contribution": 1.43508851239029e-05,
            "Perc_contribution": 0.04,
            "Fossil_abs": 3.00058853526747e-06,
            "Land_abs": 1.13502965886354e-05,
            "Fossil_fraction": 20.9087349620664,
            "Land_fraction": 79.0912650379334,
            "Rank": 138,
            "Perc_contribution_rescale": 0.255754475703325
        },
        {
            "Country": "Lebanon",
            "Abs_contribution": 1.28912286382246e-05,
            "Perc_contribution": 0.03,
            "Fossil_abs": 7.03261646013783e-06,
            "Land_abs": 5.85861217808679e-06,
            "Fossil_fraction": 54.5535003489502,
            "Land_fraction": 45.4464996510499,
            "Rank": 139,
            "Perc_contribution_rescale": 0.191815856777494
        },
        {
            "Country": "Oman",
            "Abs_contribution": 1.23087897929722e-05,
            "Perc_contribution": 0.03,
            "Fossil_abs": 5.97700087564274e-06,
            "Land_abs": 6.33178891732942e-06,
            "Fossil_fraction": 48.5588020932437,
            "Land_fraction": 51.4411979067562,
            "Rank": 140,
            "Perc_contribution_rescale": 0.191815856777494
        },
        {
            "Country": "Slovenia",
            "Abs_contribution": 1.19753541631523e-05,
            "Perc_contribution": 0.03,
            "Fossil_abs": 3.80871512446097e-06,
            "Land_abs": 8.1666390386913e-06,
            "Fossil_fraction": 31.8046136470873,
            "Land_fraction": 68.1953863529125,
            "Rank": 141,
            "Perc_contribution_rescale": 0.191815856777494
        },
        {
            "Country": "Armenia",
            "Abs_contribution": 1.13987375193832e-05,
            "Perc_contribution": 0.03,
            "Fossil_abs": 1.53886327436545e-06,
            "Land_abs": 9.8598742450177e-06,
            "Fossil_fraction": 13.5002957279143,
            "Land_fraction": 86.4997042720853,
            "Rank": 142,
            "Perc_contribution_rescale": 0.191815856777494
        },
        {
            "Country": "Kuwait",
            "Abs_contribution": 1.12493481496138e-05,
            "Perc_contribution": 0.03,
            "Fossil_abs": 8.26125837245229e-06,
            "Land_abs": 2.98808977716157e-06,
            "Fossil_fraction": 73.4376628990357,
            "Land_fraction": 26.5623371009649,
            "Rank": 143,
            "Perc_contribution_rescale": 0.191815856777494
        },
        {
            "Country": "Hong Kong",
            "Abs_contribution": 9.66236785296538e-06,
            "Perc_contribution": 0.03,
            "Fossil_abs": 9.33925966029824e-06,
            "Land_abs": 3.23108192667089e-07,
            "Fossil_fraction": 96.6560143684865,
            "Land_fraction": 3.34398563151295,
            "Rank": 144,
            "Perc_contribution_rescale": 0.191815856777494
        },
        {
            "Country": "Guinea-Bissau",
            "Abs_contribution": 9.6318123566512e-06,
            "Perc_contribution": 0.03,
            "Fossil_abs": 1.0989811337964e-06,
            "Land_abs": 8.5328312228548e-06,
            "Fossil_fraction": 11.4099101301273,
            "Land_fraction": 88.5900898698727,
            "Rank": 145,
            "Perc_contribution_rescale": 0.191815856777494
        },
        {
            "Country": "Lesotho",
            "Abs_contribution": 9.5285111031918e-06,
            "Perc_contribution": 0.03,
            "Fossil_abs": 2.05781684733079e-06,
            "Land_abs": 7.4706942558611e-06,
            "Fossil_fraction": 21.5964154844871,
            "Land_fraction": 78.4035845155138,
            "Rank": 146,
            "Perc_contribution_rescale": 0.191815856777494
        },
        {
            "Country": "North Macedonia",
            "Abs_contribution": 8.5075055567685e-06,
            "Perc_contribution": 0.02,
            "Fossil_abs": 1.80808215469979e-06,
            "Land_abs": 6.6994234020688e-06,
            "Fossil_fraction": 21.2527884070707,
            "Land_fraction": 78.7472115929304,
            "Rank": 147,
            "Perc_contribution_rescale": 0.127877237851662
        },
        {
            "Country": "Jamaica",
            "Abs_contribution": 6.95976726177268e-06,
            "Perc_contribution": 0.02,
            "Fossil_abs": 2.77284569434143e-06,
            "Land_abs": 4.18692156743122e-06,
            "Fossil_fraction": 39.8410692491343,
            "Land_fraction": 60.1589307508653,
            "Rank": 148,
            "Perc_contribution_rescale": 0.127877237851662
        },
        {
            "Country": "Guyana",
            "Abs_contribution": 6.80454602748231e-06,
            "Perc_contribution": 0.02,
            "Fossil_abs": 1.19190786234171e-06,
            "Land_abs": 5.61263816514057e-06,
            "Fossil_fraction": 17.5163465355045,
            "Land_fraction": 82.483653464495,
            "Rank": 149,
            "Perc_contribution_rescale": 0.127877237851662
        },
        {
            "Country": "Gabon",
            "Abs_contribution": 6.68482457082397e-06,
            "Perc_contribution": 0.02,
            "Fossil_abs": 3.39218614491853e-06,
            "Land_abs": 3.29263842590543e-06,
            "Fossil_fraction": 50.7445798910533,
            "Land_fraction": 49.2554201089465,
            "Rank": 150,
            "Perc_contribution_rescale": 0.127877237851662
        },
        {
            "Country": "Qatar",
            "Abs_contribution": 6.63147064560876e-06,
            "Perc_contribution": 0.02,
            "Fossil_abs": 5.20002451814369e-06,
            "Land_abs": 1.43144612746507e-06,
            "Fossil_fraction": 78.4143487325402,
            "Land_fraction": 21.5856512674598,
            "Rank": 151,
            "Perc_contribution_rescale": 0.127877237851662
        },
        {
            "Country": "Swaziland",
            "Abs_contribution": 6.619127099738e-06,
            "Perc_contribution": 0.02,
            "Fossil_abs": 1.15878183818778e-06,
            "Land_abs": 5.46034526155021e-06,
            "Fossil_fraction": 17.5065657559839,
            "Land_fraction": 82.493434244016,
            "Rank": 152,
            "Perc_contribution_rescale": 0.127877237851662
        },
        {
            "Country": "Liberia",
            "Abs_contribution": 5.40884411070274e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 2.75269319816757e-06,
            "Land_abs": 2.65615091253521e-06,
            "Fossil_fraction": 50.8924484016961,
            "Land_fraction": 49.1075515983046,
            "Rank": 153,
            "Perc_contribution_rescale": 0.0639386189258312
        },
        {
            "Country": "Iceland",
            "Abs_contribution": 5.1987815232519e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 6.7142299296125e-07,
            "Land_abs": 4.52735853029062e-06,
            "Fossil_fraction": 12.9150069099512,
            "Land_fraction": 87.0849930900482,
            "Rank": 154,
            "Perc_contribution_rescale": 0.0639386189258312
        },
        {
            "Country": "Cyprus",
            "Abs_contribution": 5.15830986932181e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 1.84067806903329e-06,
            "Land_abs": 3.31763180028848e-06,
            "Fossil_fraction": 35.6837436227012,
            "Land_fraction": 64.316256377298,
            "Rank": 155,
            "Perc_contribution_rescale": 0.0639386189258312
        },
        {
            "Country": "Gambia",
            "Abs_contribution": 4.74079043210699e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 5.88657169810316e-07,
            "Land_abs": 4.15213326229667e-06,
            "Fossil_fraction": 12.416857025015,
            "Land_fraction": 87.5831429749849,
            "Rank": 156,
            "Perc_contribution_rescale": 0.0639386189258312
        },
        {
            "Country": "Luxembourg",
            "Abs_contribution": 4.69373563337719e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 1.91969513639287e-06,
            "Land_abs": 2.77404049698431e-06,
            "Fossil_fraction": 40.8990894745308,
            "Land_fraction": 59.100910525469,
            "Rank": 157,
            "Perc_contribution_rescale": 0.0639386189258312
        },
        {
            "Country": "Fiji",
            "Abs_contribution": 4.49428300227024e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 7.5920819128084e-07,
            "Land_abs": 3.73507481098936e-06,
            "Fossil_fraction": 16.8927544370778,
            "Land_fraction": 83.1072455629213,
            "Rank": 158,
            "Perc_contribution_rescale": 0.0639386189258312
        },
        {
            "Country": "Djibouti",
            "Abs_contribution": 3.65870848082915e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 5.02300613498089e-07,
            "Land_abs": 3.15640786733106e-06,
            "Fossil_fraction": 13.7289050529726,
            "Land_fraction": 86.2710949470274,
            "Rank": 159,
            "Perc_contribution_rescale": 0.0639386189258312
        },
        {
            "Country": "Timor-Leste",
            "Abs_contribution": 2.9525821756654e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 2.58418397409661e-07,
            "Land_abs": 2.69416377825573e-06,
            "Fossil_fraction": 8.75228467947461,
            "Land_fraction": 91.2477153205251,
            "Rank": 160,
            "Perc_contribution_rescale": 0.0639386189258312
        },
        {
            "Country": "Mauritius",
            "Abs_contribution": 2.87760816506373e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 1.26500348537882e-06,
            "Land_abs": 1.6126046796849e-06,
            "Fossil_fraction": 43.9602410340952,
            "Land_fraction": 56.0397589659045,
            "Rank": 161,
            "Perc_contribution_rescale": 0.0639386189258312
        },
        {
            "Country": "Suriname",
            "Abs_contribution": 2.84066731747926e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 8.85838796091161e-07,
            "Land_abs": 1.9548285213881e-06,
            "Fossil_fraction": 31.1841795285353,
            "Land_fraction": 68.8158204714647,
            "Rank": 162,
            "Perc_contribution_rescale": 0.0639386189258312
        },
        {
            "Country": "Montenegro",
            "Abs_contribution": 2.80952990959471e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 1.26838515638441e-06,
            "Land_abs": 1.54114475321029e-06,
            "Fossil_fraction": 45.1458143247666,
            "Land_fraction": 54.8541856752331,
            "Rank": 163,
            "Perc_contribution_rescale": 0.0639386189258312
        },
        {
            "Country": "Bahrain",
            "Abs_contribution": 2.57063803899195e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 2.28936070829623e-06,
            "Land_abs": 2.81277330695715e-07,
            "Fossil_fraction": 89.058073270945,
            "Land_fraction": 10.941926729055,
            "Rank": 164,
            "Perc_contribution_rescale": 0.0639386189258312
        },
        {
            "Country": "Bhutan",
            "Abs_contribution": 2.35621380959485e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 1.13559490353808e-06,
            "Land_abs": 1.22061890605677e-06,
            "Fossil_fraction": 48.1957494228142,
            "Land_fraction": 51.8042505771857,
            "Rank": 165,
            "Perc_contribution_rescale": 0.0639386189258312
        },
        {
            "Country": "Belize",
            "Abs_contribution": 1.80846508760494e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 2.55664525109444e-07,
            "Land_abs": 1.5528005624955e-06,
            "Fossil_fraction": 14.1371003986611,
            "Land_fraction": 85.8628996013391,
            "Rank": 166,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Vanuatu",
            "Abs_contribution": 1.56130151784048e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.01687119240038e-07,
            "Land_abs": 1.45961439860043e-06,
            "Fossil_fraction": 6.5129712664782,
            "Land_fraction": 93.4870287335211,
            "Rank": 167,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Brunei Darussalam",
            "Abs_contribution": 1.44560882992181e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 5.89296395733897e-07,
            "Land_abs": 8.56312434187908e-07,
            "Fossil_fraction": 40.7645819212223,
            "Land_fraction": 59.2354180787777,
            "Rank": 168,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Cape Verde",
            "Abs_contribution": 1.10793805051515e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 2.96902129678084e-07,
            "Land_abs": 8.11035920837067e-07,
            "Fossil_fraction": 26.7977193797104,
            "Land_fraction": 73.2022806202896,
            "Rank": 169,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Bahamas",
            "Abs_contribution": 9.5038057033134e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 6.72323555000806e-07,
            "Land_abs": 2.78057015330527e-07,
            "Fossil_fraction": 70.7425610317778,
            "Land_fraction": 29.2574389682215,
            "Rank": 170,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Barbados",
            "Abs_contribution": 8.5988734873526e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 3.78708927075737e-07,
            "Land_abs": 4.81178421659528e-07,
            "Fossil_fraction": 44.0416907671394,
            "Land_fraction": 55.9583092328612,
            "Rank": 171,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Malta",
            "Abs_contribution": 8.26266416002321e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 4.51056365202675e-07,
            "Land_abs": 3.75210050799645e-07,
            "Fossil_fraction": 54.5897009084547,
            "Land_fraction": 45.4102990915452,
            "Rank": 172,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Comoros",
            "Abs_contribution": 8.0346298469664e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 2.12784854487445e-07,
            "Land_abs": 5.90678130209197e-07,
            "Fossil_fraction": 26.4834670097198,
            "Land_fraction": 73.5165329902804,
            "Rank": 173,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Andorra",
            "Abs_contribution": 6.94910745595665e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 2.17830157577784e-07,
            "Land_abs": 4.77080588017877e-07,
            "Fossil_fraction": 31.3464943459845,
            "Land_fraction": 68.6535056540149,
            "Rank": 174,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Samoa",
            "Abs_contribution": 6.55966377797078e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 1.24121626586381e-07,
            "Land_abs": 5.31844751210697e-07,
            "Fossil_fraction": 18.9219494760108,
            "Land_fraction": 81.0780505239892,
            "Rank": 175,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Tonga",
            "Abs_contribution": 6.4644504501542e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 3.9825939682459e-07,
            "Land_abs": 2.4818564819083e-07,
            "Fossil_fraction": 61.6076184503959,
            "Land_fraction": 38.3923815496041,
            "Rank": 176,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Equatorial Guinea",
            "Abs_contribution": 5.70857070571998e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 4.2275703069764e-07,
            "Land_abs": 1.48100039874358e-07,
            "Fossil_fraction": 74.0565462864528,
            "Land_fraction": 25.9434537135472,
            "Rank": 177,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Palau",
            "Abs_contribution": 5.2764305257692e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 5.2681812334093e-07,
            "Land_abs": 8.2492923599877e-10,
            "Fossil_fraction": 99.8436577091347,
            "Land_fraction": 0.156342290866895,
            "Rank": 178,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Maldives",
            "Abs_contribution": 4.24614522373526e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 4.14590869364616e-07,
            "Land_abs": 1.00236530089111e-08,
            "Fossil_fraction": 97.6393522876043,
            "Land_fraction": 2.36064771239582,
            "Rank": 179,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Solomon Islands",
            "Abs_contribution": 4.1236841262429e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 2.04997335842973e-07,
            "Land_abs": 2.07371076781318e-07,
            "Fossil_fraction": 49.7121820118038,
            "Land_fraction": 50.2878179881965,
            "Rank": 180,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Macao",
            "Abs_contribution": 3.7755085073765e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 3.42927231672135e-07,
            "Land_abs": 3.46236190655158e-08,
            "Fossil_fraction": 90.8294156938415,
            "Land_fraction": 9.17058430615876,
            "Rank": 181,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Lucia",
            "Abs_contribution": 3.29702919711559e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 1.34731791435508e-07,
            "Land_abs": 1.94971128276051e-07,
            "Fossil_fraction": 40.8646036721112,
            "Land_fraction": 59.1353963278887,
            "Rank": 182,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Antigua and Barbuda",
            "Abs_contribution": 2.88423310680417e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 1.45053140751624e-07,
            "Land_abs": 1.43370169928794e-07,
            "Fossil_fraction": 50.2917536066798,
            "Land_fraction": 49.7082463933205,
            "Rank": 183,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Seychelles",
            "Abs_contribution": 2.83516834583515e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 2.17744801458136e-07,
            "Land_abs": 6.57720331253795e-08,
            "Fossil_fraction": 76.8013658793849,
            "Land_fraction": 23.1986341206152,
            "Rank": 184,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Dominica",
            "Abs_contribution": 2.42086635347325e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 5.98274210923037e-08,
            "Land_abs": 1.82259214255022e-07,
            "Fossil_fraction": 24.7132275627147,
            "Land_fraction": 75.2867724372856,
            "Rank": 185,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Sao Tome and Principe",
            "Abs_contribution": 2.0258558744824e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 9.06613005469567e-08,
            "Land_abs": 1.11924286901283e-07,
            "Fossil_fraction": 44.752097959644,
            "Land_fraction": 55.2479020403558,
            "Rank": 186,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Vincent and the Grenadines",
            "Abs_contribution": 1.95577895859416e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 7.50114450374593e-08,
            "Land_abs": 1.20566450821957e-07,
            "Fossil_fraction": 38.3537437642639,
            "Land_fraction": 61.6462562357362,
            "Rank": 187,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Micronesia (Federated States of)",
            "Abs_contribution": 1.72244223866438e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 3.21507718742818e-14,
            "Land_abs": 1.72244191715666e-07,
            "Fossil_fraction": 1.86658055362206e-05,
            "Land_fraction": 99.9999813341943,
            "Rank": 188,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Grenada",
            "Abs_contribution": 1.71384634026501e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 8.92270627064415e-08,
            "Land_abs": 8.215757132006e-08,
            "Fossil_fraction": 52.0624636002341,
            "Land_fraction": 47.9375363997662,
            "Rank": 189,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Kitts and Nevis",
            "Abs_contribution": 1.47661022378957e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 6.40947377758464e-08,
            "Land_abs": 8.3566284603112e-08,
            "Fossil_fraction": 43.4066734356977,
            "Land_fraction": 56.5933265643032,
            "Rank": 190,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Liechtenstein",
            "Abs_contribution": 1.43870031244896e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 5.01054872139871e-08,
            "Land_abs": 9.3764544030909e-08,
            "Fossil_fraction": 34.8269106362377,
            "Land_fraction": 65.1730893637624,
            "Rank": 191,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Aruba",
            "Abs_contribution": 1.14977332748663e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 1.14510045903802e-07,
            "Land_abs": 4.67286844861081e-10,
            "Fossil_fraction": 99.5935835058181,
            "Land_fraction": 0.406416494181994,
            "Rank": 192,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Kiribati",
            "Abs_contribution": 7.47510581366671e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 3.98113901228712e-08,
            "Land_abs": 3.49396680137964e-08,
            "Fossil_fraction": 53.2586308679192,
            "Land_fraction": 46.7413691320815,
            "Rank": 193,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Cook Islands",
            "Abs_contribution": 6.04835088936677e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 2.19004803689615e-08,
            "Land_abs": 3.85830285247066e-08,
            "Fossil_fraction": 36.2090109677059,
            "Land_fraction": 63.7909890322948,
            "Rank": 194,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Tuvalu",
            "Abs_contribution": 1.82446737794828e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 2.07541863595661e-09,
            "Land_abs": 1.61692551435262e-08,
            "Fossil_fraction": 11.3754768160916,
            "Land_fraction": 88.6245231839085,
            "Rank": 195,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Turks and Caicos Islands",
            "Abs_contribution": 1.50523859075109e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 1.49663283201747e-08,
            "Land_abs": 8.60575873362445e-11,
            "Fossil_fraction": 99.4282794245047,
            "Land_fraction": 0.571720575495632,
            "Rank": 196,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Nauru",
            "Abs_contribution": 7.65756723718888e-09,
            "Perc_contribution": 0,
            "Fossil_abs": 4.50998482992374e-09,
            "Land_abs": 3.14758240726514e-09,
            "Fossil_fraction": 58.895791446937,
            "Land_fraction": 41.104208553063,
            "Rank": 197,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Niue",
            "Abs_contribution": 5.10500630008916e-09,
            "Perc_contribution": 0,
            "Fossil_abs": 2.60265002677812e-10,
            "Land_abs": 4.84474129741132e-09,
            "Fossil_fraction": 5.09823078324637,
            "Land_fraction": 94.9017692167531,
            "Rank": 198,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Anguilla",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 199,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Antarctica",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 200,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Bermuda",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 201,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Bonaire, Saint Eustatius and Saba",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 202,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "British Virgin Islands",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 203,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Christmas Island",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 204,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Cura\xe7ao",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 205,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Faeroe Islands",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 206,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "French Polynesia",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 207,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Greenland",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 208,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Kosovo",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 209,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Kuwaiti Oil Fires",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 210,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Leeward Islands",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 211,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Marshall Islands",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 212,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Montserrat",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 213,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "New Caledonia",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 214,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Occupied Palestinian Territory",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 215,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Pacific Islands (Palau)",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 216,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Panama Canal Zone",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 217,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Ryukyu Islands",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 218,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Helena",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 219,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Pierre and Miquelon",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 220,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Sint Maarten (Dutch part)",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 221,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "St. Kitts-Nevis-Anguilla",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 222,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Wallis and Futuna Islands",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 223,
            "Perc_contribution_rescale": 0
        }
    ],
    "2005_3GHG": [
        {
            "Country": "China",
            "Abs_contribution": 0.097890817390708,
            "Perc_contribution": 24.87,
            "Fossil_abs": 0.0946509060568998,
            "Land_abs": 0.0032399113338081,
            "Fossil_fraction": 96.6902806410566,
            "Land_fraction": 3.3097193589433,
            "Rank": 1,
            "Perc_contribution_rescale": 100
        },
        {
            "Country": "United States",
            "Abs_contribution": 0.041122204211359,
            "Perc_contribution": 10.45,
            "Fossil_abs": 0.040341523754056,
            "Land_abs": 0.000780680457303104,
            "Fossil_fraction": 98.1015597965263,
            "Land_fraction": 1.89844020347397,
            "Rank": 2,
            "Perc_contribution_rescale": 42.0184961801367
        },
        {
            "Country": "India",
            "Abs_contribution": 0.0250261239807581,
            "Perc_contribution": 6.36,
            "Fossil_abs": 0.0202405830775389,
            "Land_abs": 0.0047855409032189,
            "Fossil_fraction": 80.8778182874077,
            "Land_fraction": 19.1221817125911,
            "Rank": 3,
            "Perc_contribution_rescale": 25.5729794933655
        },
        {
            "Country": "Brazil",
            "Abs_contribution": 0.0200814433272164,
            "Perc_contribution": 5.1,
            "Fossil_abs": 0.0060685749326553,
            "Land_abs": 0.0140128683945608,
            "Fossil_fraction": 30.2198145510316,
            "Land_fraction": 69.7801854489669,
            "Rank": 4,
            "Perc_contribution_rescale": 20.5066344993969
        },
        {
            "Country": "EU27",
            "Abs_contribution": 0.020005777803518,
            "Perc_contribution": 5.08,
            "Fossil_abs": 0.021256473289007,
            "Land_abs": -0.0012506954854891,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 5,
            "Perc_contribution_rescale": 20.4262163248894
        },
        {
            "Country": "Indonesia",
            "Abs_contribution": 0.0161851793425439,
            "Perc_contribution": 4.11,
            "Fossil_abs": 0.00864004534028739,
            "Land_abs": 0.0075451340022563,
            "Fossil_fraction": 53.3824504346172,
            "Land_fraction": 46.6175495653816,
            "Rank": 6,
            "Perc_contribution_rescale": 16.5259348612786
        },
        {
            "Country": "Russia",
            "Abs_contribution": 0.0150434103633509,
            "Perc_contribution": 3.82,
            "Fossil_abs": 0.0163334631673855,
            "Land_abs": -0.0012900528040346,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 7,
            "Perc_contribution_rescale": 15.3598713309208
        },
        {
            "Country": "Japan",
            "Abs_contribution": 0.0086343634909795,
            "Perc_contribution": 2.19,
            "Fossil_abs": 0.0088090558088514,
            "Land_abs": -0.00017469231787191,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 8,
            "Perc_contribution_rescale": 8.80579010856454
        },
        {
            "Country": "Iran",
            "Abs_contribution": 0.0077177610593807,
            "Perc_contribution": 1.96,
            "Fossil_abs": 0.00770267514482606,
            "Land_abs": 1.50859145546601e-05,
            "Fossil_fraction": 99.8045299091463,
            "Land_fraction": 0.195470090853922,
            "Rank": 9,
            "Perc_contribution_rescale": 7.88098110172899
        },
        {
            "Country": "Saudi Arabia",
            "Abs_contribution": 0.00640041438952232,
            "Perc_contribution": 1.63,
            "Fossil_abs": 0.00635470010812681,
            "Land_abs": 4.57142813954979e-05,
            "Fossil_fraction": 99.2857605990271,
            "Land_fraction": 0.71423940097275,
            "Rank": 10,
            "Perc_contribution_rescale": 6.55408122235625
        },
        {
            "Country": "Mexico",
            "Abs_contribution": 0.0063634155594876,
            "Perc_contribution": 1.62,
            "Fossil_abs": 0.00527228601687585,
            "Land_abs": 0.00109112954261172,
            "Fossil_fraction": 82.8530836559162,
            "Land_fraction": 17.1469163440833,
            "Rank": 11,
            "Perc_contribution_rescale": 6.51387213510253
        },
        {
            "Country": "Canada",
            "Abs_contribution": 0.0060920676848912,
            "Perc_contribution": 1.55,
            "Fossil_abs": 0.0050677710966041,
            "Land_abs": 0.0010242965882871,
            "Fossil_fraction": 83.1863885749753,
            "Land_fraction": 16.8136114250246,
            "Rank": 12,
            "Perc_contribution_rescale": 6.2324085243265
        },
        {
            "Country": "Pakistan",
            "Abs_contribution": 0.0049413343146682,
            "Perc_contribution": 1.26,
            "Fossil_abs": 0.00242302698487682,
            "Land_abs": 0.00251830732979143,
            "Fossil_fraction": 49.0358844509698,
            "Land_fraction": 50.9641155490312,
            "Rank": 13,
            "Perc_contribution_rescale": 5.06634499396864
        },
        {
            "Country": "Democratic Republic of the Congo",
            "Abs_contribution": 0.00481558897250781,
            "Perc_contribution": 1.22,
            "Fossil_abs": 0.000618983316628257,
            "Land_abs": 0.00419660565587957,
            "Fossil_fraction": 12.8537406361305,
            "Land_fraction": 87.1462593638698,
            "Rank": 14,
            "Perc_contribution_rescale": 4.90550864495376
        },
        {
            "Country": "South Korea",
            "Abs_contribution": 0.00480540530547103,
            "Perc_contribution": 1.22,
            "Fossil_abs": 0.00482614924842904,
            "Land_abs": -0.0000207439429580401,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 15,
            "Perc_contribution_rescale": 4.90550864495376
        },
        {
            "Country": "Germany",
            "Abs_contribution": 0.0044957901492663,
            "Perc_contribution": 1.14,
            "Fossil_abs": 0.00482695255476481,
            "Land_abs": -0.00033116240549856,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 16,
            "Perc_contribution_rescale": 4.583835946924
        },
        {
            "Country": "T\xfcrkiye",
            "Abs_contribution": 0.00439392325768266,
            "Perc_contribution": 1.12,
            "Fossil_abs": 0.00429815980075228,
            "Land_abs": 9.57634569303499e-05,
            "Fossil_fraction": 97.8205478039941,
            "Land_fraction": 2.17945219600524,
            "Rank": 17,
            "Perc_contribution_rescale": 4.50341777241657
        },
        {
            "Country": "South Africa",
            "Abs_contribution": 0.0043864971632573,
            "Perc_contribution": 1.11,
            "Fossil_abs": 0.00422409421549292,
            "Land_abs": 0.0001624029477644,
            "Fossil_fraction": 96.2976620816099,
            "Land_fraction": 3.70233791839054,
            "Rank": 18,
            "Perc_contribution_rescale": 4.46320868516285
        },
        {
            "Country": "Viet Nam",
            "Abs_contribution": 0.00403145547335967,
            "Perc_contribution": 1.02,
            "Fossil_abs": 0.00264107315943091,
            "Land_abs": 0.00139038231392872,
            "Fossil_fraction": 65.5116539642675,
            "Land_fraction": 34.4883460357315,
            "Rank": 19,
            "Perc_contribution_rescale": 4.10132689987937
        },
        {
            "Country": "Australia",
            "Abs_contribution": 0.003990015614464,
            "Perc_contribution": 1.01,
            "Fossil_abs": 0.0034666395382464,
            "Land_abs": 0.000523376076217599,
            "Fossil_fraction": 86.8828564399514,
            "Land_fraction": 13.1171435600486,
            "Rank": 20,
            "Perc_contribution_rescale": 4.06111781262565
        },
        {
            "Country": "Malaysia",
            "Abs_contribution": 0.00376204233784844,
            "Perc_contribution": 0.96,
            "Fossil_abs": 0.00262992614189076,
            "Land_abs": 0.00113211619595763,
            "Fossil_fraction": 69.9068725365501,
            "Land_fraction": 30.0931274634485,
            "Rank": 21,
            "Perc_contribution_rescale": 3.86007237635706
        },
        {
            "Country": "Thailand",
            "Abs_contribution": 0.00361722387088,
            "Perc_contribution": 0.92,
            "Fossil_abs": 0.00282299039543259,
            "Land_abs": 0.000794233475447441,
            "Fossil_fraction": 78.0430102255687,
            "Land_fraction": 21.9569897744322,
            "Rank": 22,
            "Perc_contribution_rescale": 3.69923602734218
        },
        {
            "Country": "Iraq",
            "Abs_contribution": 0.00326623883426062,
            "Perc_contribution": 0.83,
            "Fossil_abs": 0.00318804953462908,
            "Land_abs": 7.8189299631559e-05,
            "Fossil_fraction": 97.6061364891205,
            "Land_fraction": 2.39386351088005,
            "Rank": 23,
            "Perc_contribution_rescale": 3.3373542420587
        },
        {
            "Country": "Argentina",
            "Abs_contribution": 0.0030786865804517,
            "Perc_contribution": 0.78,
            "Fossil_abs": 0.00162629007107932,
            "Land_abs": 0.0014523965093724,
            "Fossil_fraction": 52.824151747227,
            "Land_fraction": 47.1758482527736,
            "Rank": 24,
            "Perc_contribution_rescale": 3.13630880579011
        },
        {
            "Country": "Ethiopia",
            "Abs_contribution": 0.00284928725694911,
            "Perc_contribution": 0.72,
            "Fossil_abs": 0.000681157998555351,
            "Land_abs": 0.00216812925839375,
            "Fossil_fraction": 23.9062592546286,
            "Land_fraction": 76.093740745371,
            "Rank": 25,
            "Perc_contribution_rescale": 2.89505428226779
        },
        {
            "Country": "Egypt",
            "Abs_contribution": 0.00274667023989842,
            "Perc_contribution": 0.7,
            "Fossil_abs": 0.00252570524274389,
            "Land_abs": 0.00022096499715456,
            "Fossil_fraction": 91.9551683363816,
            "Land_fraction": 8.04483166361944,
            "Rank": 26,
            "Perc_contribution_rescale": 2.81463610776035
        },
        {
            "Country": "Qatar",
            "Abs_contribution": 0.00264983782550035,
            "Perc_contribution": 0.67,
            "Fossil_abs": 0.002643512279809,
            "Land_abs": 6.32554569134082e-06,
            "Fossil_fraction": 99.7612855537619,
            "Land_fraction": 0.238714446237721,
            "Rank": 27,
            "Perc_contribution_rescale": 2.6940088459992
        },
        {
            "Country": "Italy",
            "Abs_contribution": 0.0026236477010763,
            "Perc_contribution": 0.67,
            "Fossil_abs": 0.0028470279028277,
            "Land_abs": -0.00022338020175138,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 28,
            "Perc_contribution_rescale": 2.6940088459992
        },
        {
            "Country": "Kazakhstan",
            "Abs_contribution": 0.0025293164327753,
            "Perc_contribution": 0.64,
            "Fossil_abs": 0.00233429231710778,
            "Land_abs": 0.0001950241156675,
            "Fossil_fraction": 92.2894536586895,
            "Land_fraction": 7.71054634130967,
            "Rank": 29,
            "Perc_contribution_rescale": 2.57338158423804
        },
        {
            "Country": "France",
            "Abs_contribution": 0.0024721070913846,
            "Perc_contribution": 0.63,
            "Fossil_abs": 0.0025940897408789,
            "Land_abs": -0.00012198264949422,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 30,
            "Perc_contribution_rescale": 2.53317249698432
        },
        {
            "Country": "Spain",
            "Abs_contribution": 0.00242219582242017,
            "Perc_contribution": 0.62,
            "Fossil_abs": 0.00232759655054375,
            "Land_abs": 9.459927187649e-05,
            "Fossil_fraction": 96.0944829067577,
            "Land_fraction": 3.90551709324516,
            "Rank": 31,
            "Perc_contribution_rescale": 2.4929634097306
        },
        {
            "Country": "Tanzania",
            "Abs_contribution": 0.00235026401344789,
            "Perc_contribution": 0.6,
            "Fossil_abs": 0.000433964557426751,
            "Land_abs": 0.00191629945602111,
            "Fossil_fraction": 18.4645024960458,
            "Land_fraction": 81.535497503953,
            "Rank": 32,
            "Perc_contribution_rescale": 2.41254523522316
        },
        {
            "Country": "Taiwan",
            "Abs_contribution": 0.00231279270033576,
            "Perc_contribution": 0.59,
            "Fossil_abs": 0.00233074665492663,
            "Land_abs": -0.000017953954590885,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 33,
            "Perc_contribution_rescale": 2.37233614796944
        },
        {
            "Country": "Myanmar",
            "Abs_contribution": 0.00224360765800467,
            "Perc_contribution": 0.57,
            "Fossil_abs": 0.000463630281153433,
            "Land_abs": 0.00177997737685122,
            "Fossil_fraction": 20.6644989599366,
            "Land_fraction": 79.3355010400626,
            "Rank": 34,
            "Perc_contribution_rescale": 2.291917973462
        },
        {
            "Country": "Philippines",
            "Abs_contribution": 0.00224081278793798,
            "Perc_contribution": 0.57,
            "Fossil_abs": 0.00133704034168709,
            "Land_abs": 0.00090377244625094,
            "Fossil_fraction": 59.6676504563082,
            "Land_fraction": 40.3323495436939,
            "Rank": 35,
            "Perc_contribution_rescale": 2.291917973462
        },
        {
            "Country": "Nigeria",
            "Abs_contribution": 0.0022047099830377,
            "Perc_contribution": 0.56,
            "Fossil_abs": 0.0010852323257795,
            "Land_abs": 0.00111947765725832,
            "Fossil_fraction": 49.2233597220911,
            "Land_fraction": 50.7766402779144,
            "Rank": 36,
            "Perc_contribution_rescale": 2.25170888620828
        },
        {
            "Country": "United Arab Emirates",
            "Abs_contribution": 0.00219175837727757,
            "Perc_contribution": 0.56,
            "Fossil_abs": 0.00216337559694228,
            "Land_abs": 2.83827803352934e-05,
            "Fossil_fraction": 98.7050223861562,
            "Land_fraction": 1.29497761384392,
            "Rank": 37,
            "Perc_contribution_rescale": 2.25170888620828
        },
        {
            "Country": "Colombia",
            "Abs_contribution": 0.0021070271763677,
            "Perc_contribution": 0.54,
            "Fossil_abs": 0.0012288224010442,
            "Land_abs": 0.0008782047753235,
            "Fossil_fraction": 58.320197044756,
            "Land_fraction": 41.6798029552441,
            "Rank": 38,
            "Perc_contribution_rescale": 2.17129071170084
        },
        {
            "Country": "Venezuela",
            "Abs_contribution": 0.00188322901892721,
            "Perc_contribution": 0.48,
            "Fossil_abs": 0.00130920956119005,
            "Land_abs": 0.00057401945773708,
            "Fossil_fraction": 69.5194024747903,
            "Land_fraction": 30.4805975252056,
            "Rank": 39,
            "Perc_contribution_rescale": 1.93003618817853
        },
        {
            "Country": "Uzbekistan",
            "Abs_contribution": 0.00183056799615001,
            "Perc_contribution": 0.47,
            "Fossil_abs": 0.00146472201733617,
            "Land_abs": 0.00036584597881382,
            "Fossil_fraction": 80.0146195288416,
            "Land_fraction": 19.9853804711573,
            "Rank": 40,
            "Perc_contribution_rescale": 1.88982710092481
        },
        {
            "Country": "Bangladesh",
            "Abs_contribution": 0.00182879930250309,
            "Perc_contribution": 0.46,
            "Fossil_abs": 0.0012011366001802,
            "Land_abs": 0.0006276627023229,
            "Fossil_fraction": 65.6789730035546,
            "Land_fraction": 34.3210269964459,
            "Rank": 41,
            "Perc_contribution_rescale": 1.84961801367109
        },
        {
            "Country": "Angola",
            "Abs_contribution": 0.00177583311383751,
            "Perc_contribution": 0.45,
            "Fossil_abs": 0.00059242049235123,
            "Land_abs": 0.00118341262148629,
            "Fossil_fraction": 33.3601444716295,
            "Land_fraction": 66.6398555283711,
            "Rank": 42,
            "Perc_contribution_rescale": 1.80940892641737
        },
        {
            "Country": "Algeria",
            "Abs_contribution": 0.00172586819220786,
            "Perc_contribution": 0.44,
            "Fossil_abs": 0.00160140729051838,
            "Land_abs": 0.000124460901689487,
            "Fossil_fraction": 92.7885048086865,
            "Land_fraction": 7.21149519131396,
            "Rank": 43,
            "Perc_contribution_rescale": 1.76919983916365
        },
        {
            "Country": "Sudan",
            "Abs_contribution": 0.00160515629993837,
            "Perc_contribution": 0.41,
            "Fossil_abs": 0.00035817408075583,
            "Land_abs": 0.00124698221918253,
            "Fossil_fraction": 22.3139690988088,
            "Land_fraction": 77.6860309011906,
            "Rank": 44,
            "Perc_contribution_rescale": 1.64857257740249
        },
        {
            "Country": "Chad",
            "Abs_contribution": 0.00144746323220407,
            "Perc_contribution": 0.37,
            "Fossil_abs": 0.00012467909661655,
            "Land_abs": 0.00132278413558752,
            "Fossil_fraction": 8.61362788654048,
            "Land_fraction": 91.3863721134595,
            "Rank": 45,
            "Perc_contribution_rescale": 1.48773622838762
        },
        {
            "Country": "United Kingdom",
            "Abs_contribution": 0.0013794511215502,
            "Perc_contribution": 0.35,
            "Fossil_abs": 0.0012862726905888,
            "Land_abs": 9.31784309614e-05,
            "Fossil_fraction": 93.2452531658617,
            "Land_fraction": 6.7547468341385,
            "Rank": 46,
            "Perc_contribution_rescale": 1.40731805388018
        },
        {
            "Country": "Kenya",
            "Abs_contribution": 0.0012634650799388,
            "Perc_contribution": 0.32,
            "Fossil_abs": 0.000483506389827787,
            "Land_abs": 0.00077995869011101,
            "Fossil_fraction": 38.2682827966411,
            "Land_fraction": 61.7317172033587,
            "Rank": 47,
            "Perc_contribution_rescale": 1.28669079211902
        },
        {
            "Country": "Kuwait",
            "Abs_contribution": 0.00120498751686374,
            "Perc_contribution": 0.31,
            "Fossil_abs": 0.00119973695869776,
            "Land_abs": 5.25055816597948e-06,
            "Fossil_fraction": 99.5642645178893,
            "Land_fraction": 0.435735482110659,
            "Rank": 48,
            "Perc_contribution_rescale": 1.2464817048653
        },
        {
            "Country": "Peru",
            "Abs_contribution": 0.00119569294901189,
            "Perc_contribution": 0.3,
            "Fossil_abs": 0.0005726890232381,
            "Land_abs": 0.00062300392577379,
            "Fossil_fraction": 47.8959940101148,
            "Land_fraction": 52.1040059898852,
            "Rank": 49,
            "Perc_contribution_rescale": 1.20627261761158
        },
        {
            "Country": "Turkmenistan",
            "Abs_contribution": 0.00117547717911479,
            "Perc_contribution": 0.3,
            "Fossil_abs": 0.00100332137956411,
            "Land_abs": 0.000172155799550679,
            "Fossil_fraction": 85.354390318294,
            "Land_fraction": 14.6456096817059,
            "Rank": 50,
            "Perc_contribution_rescale": 1.20627261761158
        },
        {
            "Country": "Ukraine",
            "Abs_contribution": 0.0011577280270137,
            "Perc_contribution": 0.29,
            "Fossil_abs": 0.0021333632314852,
            "Land_abs": -0.00097563520447148,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 51,
            "Perc_contribution_rescale": 1.16606353035786
        },
        {
            "Country": "Oman",
            "Abs_contribution": 0.00099757458660735,
            "Perc_contribution": 0.25,
            "Fossil_abs": 0.00097369276080995,
            "Land_abs": 2.38818257974023e-05,
            "Fossil_fraction": 97.6060110072952,
            "Land_fraction": 2.39398899270499,
            "Rank": 52,
            "Perc_contribution_rescale": 1.00522718134298
        },
        {
            "Country": "Paraguay",
            "Abs_contribution": 0.00097796922001617,
            "Perc_contribution": 0.25,
            "Fossil_abs": 9.4979266389549e-05,
            "Land_abs": 0.00088298995362662,
            "Fossil_fraction": 9.7118870865873,
            "Land_fraction": 90.2881129134126,
            "Rank": 53,
            "Perc_contribution_rescale": 1.00522718134298
        },
        {
            "Country": "Netherlands",
            "Abs_contribution": 0.00096438651368606,
            "Perc_contribution": 0.25,
            "Fossil_abs": 0.000895257527681759,
            "Land_abs": 6.912898600431e-05,
            "Fossil_fraction": 92.8318174276331,
            "Land_fraction": 7.16818257236784,
            "Rank": 54,
            "Perc_contribution_rescale": 1.00522718134298
        },
        {
            "Country": "Bolivia",
            "Abs_contribution": 0.00096128462297634,
            "Perc_contribution": 0.24,
            "Fossil_abs": 0.000160235679443979,
            "Land_abs": 0.00080104894353236,
            "Fossil_fraction": 16.6689111231027,
            "Land_fraction": 83.3310888768972,
            "Rank": 55,
            "Perc_contribution_rescale": 0.965018094089264
        },
        {
            "Country": "Morocco",
            "Abs_contribution": 0.00088261781510647,
            "Perc_contribution": 0.22,
            "Fossil_abs": 0.000776665533292682,
            "Land_abs": 0.000105952281813792,
            "Fossil_fraction": 87.9956783105486,
            "Land_fraction": 12.0043216894518,
            "Rank": 56,
            "Perc_contribution_rescale": 0.884599919581825
        },
        {
            "Country": "Mozambique",
            "Abs_contribution": 0.00087635683929554,
            "Perc_contribution": 0.22,
            "Fossil_abs": 0.000377208547084475,
            "Land_abs": 0.00049914829221106,
            "Fossil_fraction": 43.0428029052292,
            "Land_fraction": 56.9571970947703,
            "Rank": 57,
            "Perc_contribution_rescale": 0.884599919581825
        },
        {
            "Country": "Mongolia",
            "Abs_contribution": 0.0008628073325209,
            "Perc_contribution": 0.22,
            "Fossil_abs": 0.000613817800182037,
            "Land_abs": 0.00024898953233887,
            "Fossil_fraction": 71.1419313496815,
            "Land_fraction": 28.8580686503193,
            "Rank": 58,
            "Perc_contribution_rescale": 0.884599919581825
        },
        {
            "Country": "Chile",
            "Abs_contribution": 0.00085460827183833,
            "Perc_contribution": 0.22,
            "Fossil_abs": 0.00074955732503063,
            "Land_abs": 0.0001050509468077,
            "Fossil_fraction": 87.7077076984374,
            "Land_fraction": 12.2922923015626,
            "Rank": 59,
            "Perc_contribution_rescale": 0.884599919581825
        },
        {
            "Country": "Uganda",
            "Abs_contribution": 0.00081176816612031,
            "Perc_contribution": 0.21,
            "Fossil_abs": 0.000266934922212956,
            "Land_abs": 0.00054483324390736,
            "Fossil_fraction": 32.8831473508896,
            "Land_fraction": 67.1168526491111,
            "Rank": 60,
            "Perc_contribution_rescale": 0.844390832328106
        },
        {
            "Country": "Belgium",
            "Abs_contribution": 0.00078632586041773,
            "Perc_contribution": 0.2,
            "Fossil_abs": 0.000784598494018959,
            "Land_abs": 1.72736639877209e-06,
            "Fossil_fraction": 99.780324355878,
            "Land_fraction": 0.219675644122201,
            "Rank": 61,
            "Perc_contribution_rescale": 0.804181745074387
        },
        {
            "Country": "C\xf4te d'Ivoire",
            "Abs_contribution": 0.0007785738002134,
            "Perc_contribution": 0.2,
            "Fossil_abs": 0.000258839156001985,
            "Land_abs": 0.00051973464421145,
            "Fossil_fraction": 33.2452949137307,
            "Land_fraction": 66.7547050862738,
            "Rank": 62,
            "Perc_contribution_rescale": 0.804181745074387
        },
        {
            "Country": "Trinidad and Tobago",
            "Abs_contribution": 0.000775129817550352,
            "Perc_contribution": 0.2,
            "Fossil_abs": 0.000776955565894189,
            "Land_abs": -0.0000018257483438354,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 63,
            "Perc_contribution_rescale": 0.804181745074387
        },
        {
            "Country": "Zambia",
            "Abs_contribution": 0.00075740239232159,
            "Perc_contribution": 0.19,
            "Fossil_abs": 0.00015488570973101,
            "Land_abs": 0.00060251668259059,
            "Fossil_fraction": 20.4495934131201,
            "Land_fraction": 79.5504065868812,
            "Rank": 64,
            "Perc_contribution_rescale": 0.763972657820667
        },
        {
            "Country": "Poland",
            "Abs_contribution": 0.000751740769246499,
            "Perc_contribution": 0.19,
            "Fossil_abs": 0.0010979444569394,
            "Land_abs": -0.00034620368769281,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 65,
            "Perc_contribution_rescale": 0.763972657820667
        },
        {
            "Country": "Israel",
            "Abs_contribution": 0.00069024861577921,
            "Perc_contribution": 0.18,
            "Fossil_abs": 0.000668582730656571,
            "Land_abs": 2.16658851226408e-05,
            "Fossil_fraction": 96.8611476173435,
            "Land_fraction": 3.13885238265673,
            "Rank": 66,
            "Perc_contribution_rescale": 0.723763570566948
        },
        {
            "Country": "Ecuador",
            "Abs_contribution": 0.00067971566004774,
            "Perc_contribution": 0.17,
            "Fossil_abs": 0.0004675667930264,
            "Land_abs": 0.00021214886702133,
            "Fossil_fraction": 68.7885862440716,
            "Land_fraction": 31.2114137559269,
            "Rank": 67,
            "Perc_contribution_rescale": 0.683554483313229
        },
        {
            "Country": "Belarus",
            "Abs_contribution": 0.00066674407432902,
            "Perc_contribution": 0.17,
            "Fossil_abs": 0.00064741663383688,
            "Land_abs": 1.93274404921002e-05,
            "Fossil_fraction": 97.1012205077953,
            "Land_fraction": 2.89877949219878,
            "Rank": 68,
            "Perc_contribution_rescale": 0.683554483313229
        },
        {
            "Country": "Azerbaijan",
            "Abs_contribution": 0.00064093317505864,
            "Perc_contribution": 0.16,
            "Fossil_abs": 0.00055055400156519,
            "Land_abs": 9.0379173493449e-05,
            "Fossil_fraction": 85.8988148826621,
            "Land_fraction": 14.1011851173377,
            "Rank": 69,
            "Perc_contribution_rescale": 0.643345396059509
        },
        {
            "Country": "Cambodia",
            "Abs_contribution": 0.00063911212712493,
            "Perc_contribution": 0.16,
            "Fossil_abs": 0.000153844271664643,
            "Land_abs": 0.00048526785546028,
            "Fossil_fraction": 24.0715619584184,
            "Land_fraction": 75.9284380415806,
            "Rank": 70,
            "Perc_contribution_rescale": 0.643345396059509
        },
        {
            "Country": "Czechia",
            "Abs_contribution": 0.00063869898332247,
            "Perc_contribution": 0.16,
            "Fossil_abs": 0.00081228129555141,
            "Land_abs": -0.000173582312228971,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 71,
            "Perc_contribution_rescale": 0.643345396059509
        },
        {
            "Country": "Greece",
            "Abs_contribution": 0.00061774870198221,
            "Perc_contribution": 0.16,
            "Fossil_abs": 0.00065401318185471,
            "Land_abs": -0.0000362644798725,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 72,
            "Perc_contribution_rescale": 0.643345396059509
        },
        {
            "Country": "Niger",
            "Abs_contribution": 0.00061549005798216,
            "Perc_contribution": 0.16,
            "Fossil_abs": 9.1522668575371e-05,
            "Land_abs": 0.000523967389406792,
            "Fossil_fraction": 14.8698857745033,
            "Land_fraction": 85.1301142254972,
            "Rank": 73,
            "Perc_contribution_rescale": 0.643345396059509
        },
        {
            "Country": "Norway",
            "Abs_contribution": 0.00059434420216441,
            "Perc_contribution": 0.15,
            "Fossil_abs": 0.00055531819449324,
            "Land_abs": 3.90260076711751e-05,
            "Fossil_fraction": 93.4337699385222,
            "Land_fraction": 6.56623006147867,
            "Rank": 74,
            "Perc_contribution_rescale": 0.60313630880579
        },
        {
            "Country": "Mali",
            "Abs_contribution": 0.0005898333682185,
            "Perc_contribution": 0.15,
            "Fossil_abs": 0.000101703976453947,
            "Land_abs": 0.000488129391764559,
            "Fossil_fraction": 17.2428319477971,
            "Land_fraction": 82.757168052204,
            "Rank": 75,
            "Perc_contribution_rescale": 0.60313630880579
        },
        {
            "Country": "South Sudan",
            "Abs_contribution": 0.00058451268128765,
            "Perc_contribution": 0.15,
            "Fossil_abs": 8.2164803530969e-05,
            "Land_abs": 0.00050234787775668,
            "Fossil_fraction": 14.0569753508109,
            "Land_fraction": 85.9430246491889,
            "Rank": 76,
            "Perc_contribution_rescale": 0.60313630880579
        },
        {
            "Country": "Burkina Faso",
            "Abs_contribution": 0.000571131569045244,
            "Perc_contribution": 0.15,
            "Fossil_abs": 0.000132672729784299,
            "Land_abs": 0.000438458839260935,
            "Fossil_fraction": 23.2298014984686,
            "Land_fraction": 76.7701985015297,
            "Rank": 77,
            "Perc_contribution_rescale": 0.60313630880579
        },
        {
            "Country": "Ghana",
            "Abs_contribution": 0.00056575813513472,
            "Perc_contribution": 0.14,
            "Fossil_abs": 0.000368151920641898,
            "Land_abs": 0.00019760621449282,
            "Fossil_fraction": 65.0723158499935,
            "Land_fraction": 34.9276841500062,
            "Rank": 78,
            "Perc_contribution_rescale": 0.562927221552071
        },
        {
            "Country": "Guatemala",
            "Abs_contribution": 0.00054784803224315,
            "Perc_contribution": 0.14,
            "Fossil_abs": 0.000298384871724581,
            "Land_abs": 0.00024946316051857,
            "Fossil_fraction": 54.464897957715,
            "Land_fraction": 45.5351020422852,
            "Rank": 79,
            "Perc_contribution_rescale": 0.562927221552071
        },
        {
            "Country": "Laos",
            "Abs_contribution": 0.000546955344072292,
            "Perc_contribution": 0.14,
            "Fossil_abs": 0.000130361392864423,
            "Land_abs": 0.000416593951207866,
            "Fossil_fraction": 23.8340102674256,
            "Land_fraction": 76.1659897325739,
            "Rank": 80,
            "Perc_contribution_rescale": 0.562927221552071
        },
        {
            "Country": "Guinea",
            "Abs_contribution": 0.0005223936953067,
            "Perc_contribution": 0.13,
            "Fossil_abs": 9.6924397890303e-05,
            "Land_abs": 0.00042546929741639,
            "Fossil_fraction": 18.5538988623127,
            "Land_fraction": 81.446101137686,
            "Rank": 81,
            "Perc_contribution_rescale": 0.522718134298351
        },
        {
            "Country": "Bahrain",
            "Abs_contribution": 0.00051649861353956,
            "Perc_contribution": 0.13,
            "Fossil_abs": 0.00051623952049809,
            "Land_abs": 2.5909304146663e-07,
            "Fossil_fraction": 99.9498366433755,
            "Land_fraction": 0.0501633566237608,
            "Rank": 82,
            "Perc_contribution_rescale": 0.522718134298351
        },
        {
            "Country": "Madagascar",
            "Abs_contribution": 0.00050501576727869,
            "Perc_contribution": 0.13,
            "Fossil_abs": 0.000187191207768453,
            "Land_abs": 0.00031782455951023,
            "Fossil_fraction": 37.0664085949524,
            "Land_fraction": 62.9335914050463,
            "Rank": 83,
            "Perc_contribution_rescale": 0.522718134298351
        },
        {
            "Country": "Yemen",
            "Abs_contribution": 0.000499247893319203,
            "Perc_contribution": 0.13,
            "Fossil_abs": 0.000405416492395185,
            "Land_abs": 9.3831400924015e-05,
            "Fossil_fraction": 81.2054488001564,
            "Land_fraction": 18.794551199843,
            "Rank": 84,
            "Perc_contribution_rescale": 0.522718134298351
        },
        {
            "Country": "Singapore",
            "Abs_contribution": 0.000476144824062094,
            "Perc_contribution": 0.12,
            "Fossil_abs": 0.000475912020196351,
            "Land_abs": 2.328038657446e-07,
            "Fossil_fraction": 99.9511065008002,
            "Land_fraction": 0.0488934992002014,
            "Rank": 85,
            "Perc_contribution_rescale": 0.482509047044632
        },
        {
            "Country": "Cameroon",
            "Abs_contribution": 0.00046555781276234,
            "Perc_contribution": 0.12,
            "Fossil_abs": 0.000127614167826957,
            "Land_abs": 0.00033794364493538,
            "Fossil_fraction": 27.4110248670882,
            "Land_fraction": 72.5889751329111,
            "Rank": 86,
            "Perc_contribution_rescale": 0.482509047044632
        },
        {
            "Country": "Sweden",
            "Abs_contribution": 0.00046171572997901,
            "Perc_contribution": 0.12,
            "Fossil_abs": 0.00034892437516412,
            "Land_abs": 0.000112791354814904,
            "Fossil_fraction": 75.5712557551336,
            "Land_fraction": 24.4287442448693,
            "Rank": 87,
            "Perc_contribution_rescale": 0.482509047044632
        },
        {
            "Country": "Finland",
            "Abs_contribution": 0.00044956937412536,
            "Perc_contribution": 0.11,
            "Fossil_abs": 0.00032870312647756,
            "Land_abs": 0.00012086624764781,
            "Fossil_fraction": 73.1151064542718,
            "Land_fraction": 26.8848935457305,
            "Rank": 88,
            "Perc_contribution_rescale": 0.442299959790913
        },
        {
            "Country": "Nepal",
            "Abs_contribution": 0.00042166746782387,
            "Perc_contribution": 0.11,
            "Fossil_abs": 0.000158399674174298,
            "Land_abs": 0.00026326779364957,
            "Fossil_fraction": 37.5650687475993,
            "Land_fraction": 62.4349312524001,
            "Rank": 89,
            "Perc_contribution_rescale": 0.442299959790913
        },
        {
            "Country": "Romania",
            "Abs_contribution": 0.00041856010079381,
            "Perc_contribution": 0.11,
            "Fossil_abs": 0.00061534601533581,
            "Land_abs": -0.000196785914542,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 90,
            "Perc_contribution_rescale": 0.442299959790913
        },
        {
            "Country": "North Korea",
            "Abs_contribution": 0.0004055244991794,
            "Perc_contribution": 0.1,
            "Fossil_abs": 0.00034123835929872,
            "Land_abs": 6.4286139880686e-05,
            "Fossil_fraction": 84.1474090934663,
            "Land_fraction": 15.8525909065352,
            "Rank": 91,
            "Perc_contribution_rescale": 0.402090872537193
        },
        {
            "Country": "Nicaragua",
            "Abs_contribution": 0.0004032448209308,
            "Perc_contribution": 0.1,
            "Fossil_abs": 6.7528487566575e-05,
            "Land_abs": 0.00033571633336423,
            "Fossil_fraction": 16.74627523069,
            "Land_fraction": 83.2537247693112,
            "Rank": 92,
            "Perc_contribution_rescale": 0.402090872537193
        },
        {
            "Country": "Afghanistan",
            "Abs_contribution": 0.000400276053852572,
            "Perc_contribution": 0.1,
            "Fossil_abs": 0.000191238890570155,
            "Land_abs": 0.000209037163282416,
            "Fossil_fraction": 47.7767502526122,
            "Land_fraction": 52.2232497473875,
            "Rank": 93,
            "Perc_contribution_rescale": 0.402090872537193
        },
        {
            "Country": "Austria",
            "Abs_contribution": 0.00039990218778873,
            "Perc_contribution": 0.1,
            "Fossil_abs": 0.0004615218702872,
            "Land_abs": -0.0000616196824984767,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 94,
            "Perc_contribution_rescale": 0.402090872537193
        },
        {
            "Country": "Papua New Guinea",
            "Abs_contribution": 0.000390722630479545,
            "Perc_contribution": 0.1,
            "Fossil_abs": 0.000107830859269086,
            "Land_abs": 0.000282891771210456,
            "Fossil_fraction": 27.5978023429926,
            "Land_fraction": 72.4021976570067,
            "Rank": 95,
            "Perc_contribution_rescale": 0.402090872537193
        },
        {
            "Country": "Congo",
            "Abs_contribution": 0.00038608901525881,
            "Perc_contribution": 0.1,
            "Fossil_abs": 0.000251199112175853,
            "Land_abs": 0.000134889903082955,
            "Fossil_fraction": 65.0624861749731,
            "Land_fraction": 34.9375138250264,
            "Rank": 96,
            "Perc_contribution_rescale": 0.402090872537193
        },
        {
            "Country": "Hong Kong",
            "Abs_contribution": 0.000368233284106686,
            "Perc_contribution": 0.09,
            "Fossil_abs": 0.000368475288063675,
            "Land_abs": -0.0000002420039569868,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 97,
            "Perc_contribution_rescale": 0.361881785283474
        },
        {
            "Country": "Uruguay",
            "Abs_contribution": 0.0003664888481414,
            "Perc_contribution": 0.09,
            "Fossil_abs": 0.000184431046279587,
            "Land_abs": 0.00018205780186182,
            "Fossil_fraction": 50.3237812596221,
            "Land_fraction": 49.6762187403797,
            "Rank": 98,
            "Perc_contribution_rescale": 0.361881785283474
        },
        {
            "Country": "Ireland",
            "Abs_contribution": 0.000363353956480397,
            "Perc_contribution": 0.09,
            "Fossil_abs": 0.000269606016496984,
            "Land_abs": 9.3747939983411e-05,
            "Fossil_fraction": 74.1992791570248,
            "Land_fraction": 25.8007208429747,
            "Rank": 99,
            "Perc_contribution_rescale": 0.361881785283474
        },
        {
            "Country": "Portugal",
            "Abs_contribution": 0.00035802609553606,
            "Perc_contribution": 0.09,
            "Fossil_abs": 0.00037367208026929,
            "Land_abs": -0.000015645984733227,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 100,
            "Perc_contribution_rescale": 0.361881785283474
        },
        {
            "Country": "Tunisia",
            "Abs_contribution": 0.000356843811458775,
            "Perc_contribution": 0.09,
            "Fossil_abs": 0.000320826165966033,
            "Land_abs": 3.6017645492745e-05,
            "Fossil_fraction": 89.9066077829675,
            "Land_fraction": 10.0933922170333,
            "Rank": 101,
            "Perc_contribution_rescale": 0.361881785283474
        },
        {
            "Country": "Denmark",
            "Abs_contribution": 0.0003441339275014,
            "Perc_contribution": 0.09,
            "Fossil_abs": 0.00031372958770303,
            "Land_abs": 3.0404339798372e-05,
            "Fossil_fraction": 91.1649688192262,
            "Land_fraction": 8.83503118077432,
            "Rank": 102,
            "Perc_contribution_rescale": 0.361881785283474
        },
        {
            "Country": "Somalia",
            "Abs_contribution": 0.00034133903616746,
            "Perc_contribution": 0.09,
            "Fossil_abs": 0.00013171399528434,
            "Land_abs": 0.00020962504088312,
            "Fossil_fraction": 38.5874398554643,
            "Land_fraction": 61.4125601445357,
            "Rank": 103,
            "Perc_contribution_rescale": 0.361881785283474
        },
        {
            "Country": "Dominican Republic",
            "Abs_contribution": 0.0003312796602345,
            "Perc_contribution": 0.08,
            "Fossil_abs": 0.000255867550517079,
            "Land_abs": 7.5412109717423e-05,
            "Fossil_fraction": 77.2361183707929,
            "Land_fraction": 22.7638816292077,
            "Rank": 104,
            "Perc_contribution_rescale": 0.321672698029755
        },
        {
            "Country": "Equatorial Guinea",
            "Abs_contribution": 0.000311862781644581,
            "Perc_contribution": 0.08,
            "Fossil_abs": 0.000293648402798579,
            "Land_abs": 1.82143788460045e-05,
            "Fossil_fraction": 94.1594893914721,
            "Land_fraction": 5.84051060852871,
            "Rank": 105,
            "Perc_contribution_rescale": 0.321672698029755
        },
        {
            "Country": "Jordan",
            "Abs_contribution": 0.000303008858432123,
            "Perc_contribution": 0.08,
            "Fossil_abs": 0.000289943833661023,
            "Land_abs": 1.30650247711003e-05,
            "Fossil_fraction": 95.6882366942329,
            "Land_fraction": 4.31176330576718,
            "Rank": 106,
            "Perc_contribution_rescale": 0.321672698029755
        },
        {
            "Country": "Switzerland",
            "Abs_contribution": 0.00029738462691921,
            "Perc_contribution": 0.08,
            "Fossil_abs": 0.00030665423751643,
            "Land_abs": -0.000009269610597215,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 107,
            "Perc_contribution_rescale": 0.321672698029755
        },
        {
            "Country": "Benin",
            "Abs_contribution": 0.000296897235146423,
            "Perc_contribution": 0.08,
            "Fossil_abs": 0.000112697629835442,
            "Land_abs": 0.000184199605310977,
            "Fossil_fraction": 37.9584639041391,
            "Land_fraction": 62.0415360958595,
            "Rank": 108,
            "Perc_contribution_rescale": 0.321672698029755
        },
        {
            "Country": "New Zealand",
            "Abs_contribution": 0.000296164614903741,
            "Perc_contribution": 0.08,
            "Fossil_abs": 0.000302686359055022,
            "Land_abs": -0.0000065217441513098,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 109,
            "Perc_contribution_rescale": 0.321672698029755
        },
        {
            "Country": "Sri Lanka",
            "Abs_contribution": 0.00028743411926968,
            "Perc_contribution": 0.07,
            "Fossil_abs": 0.000194226816957561,
            "Land_abs": 9.32073023121199e-05,
            "Fossil_fraction": 67.572638019125,
            "Land_fraction": 32.4273619808753,
            "Rank": 110,
            "Perc_contribution_rescale": 0.281463610776035
        },
        {
            "Country": "Zimbabwe",
            "Abs_contribution": 0.00028310235701068,
            "Perc_contribution": 0.07,
            "Fossil_abs": 0.000128076510919194,
            "Land_abs": 0.000155025846091488,
            "Fossil_fraction": 45.2403548566578,
            "Land_fraction": 54.7596451433429,
            "Rank": 111,
            "Perc_contribution_rescale": 0.281463610776035
        },
        {
            "Country": "Hungary",
            "Abs_contribution": 0.00027790074942467,
            "Perc_contribution": 0.07,
            "Fossil_abs": 0.00033995487943967,
            "Land_abs": -0.000062054130015007,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 112,
            "Perc_contribution_rescale": 0.281463610776035
        },
        {
            "Country": "Malawi",
            "Abs_contribution": 0.000272867928965192,
            "Perc_contribution": 0.07,
            "Fossil_abs": 7.8504936938468e-05,
            "Land_abs": 0.000194362992026723,
            "Fossil_fraction": 28.7703055599775,
            "Land_fraction": 71.2296944400222,
            "Rank": 113,
            "Perc_contribution_rescale": 0.281463610776035
        },
        {
            "Country": "Honduras",
            "Abs_contribution": 0.00027018407147585,
            "Perc_contribution": 0.07,
            "Fossil_abs": 0.000147944072859626,
            "Land_abs": 0.00012223999861622,
            "Fossil_fraction": 54.7567708383023,
            "Land_fraction": 45.2432291616963,
            "Rank": 114,
            "Perc_contribution_rescale": 0.281463610776035
        },
        {
            "Country": "Senegal",
            "Abs_contribution": 0.000256092029077896,
            "Perc_contribution": 0.07,
            "Fossil_abs": 0.000118830799328322,
            "Land_abs": 0.000137261229749577,
            "Fossil_fraction": 46.4016001420243,
            "Land_fraction": 53.5983998579768,
            "Rank": 115,
            "Perc_contribution_rescale": 0.281463610776035
        },
        {
            "Country": "Serbia",
            "Abs_contribution": 0.00024839320536703,
            "Perc_contribution": 0.06,
            "Fossil_abs": 0.00037849590410176,
            "Land_abs": -0.000130102698734718,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 116,
            "Perc_contribution_rescale": 0.241254523522316
        },
        {
            "Country": "Lebanon",
            "Abs_contribution": 0.000245742110615817,
            "Perc_contribution": 0.06,
            "Fossil_abs": 0.000238348338442775,
            "Land_abs": 7.3937721730407e-06,
            "Fossil_fraction": 96.9912473875505,
            "Land_fraction": 3.008752612449,
            "Rank": 117,
            "Perc_contribution_rescale": 0.241254523522316
        },
        {
            "Country": "Slovakia",
            "Abs_contribution": 0.00023672891718301,
            "Perc_contribution": 0.06,
            "Fossil_abs": 0.00029778483382435,
            "Land_abs": -0.000061055916641344,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 118,
            "Perc_contribution_rescale": 0.241254523522316
        },
        {
            "Country": "Sierra Leone",
            "Abs_contribution": 0.000229654855543674,
            "Perc_contribution": 0.06,
            "Fossil_abs": 4.54654400448049e-05,
            "Land_abs": 0.000184189415498871,
            "Fossil_fraction": 19.7972909987782,
            "Land_fraction": 80.2027090012227,
            "Rank": 119,
            "Perc_contribution_rescale": 0.241254523522316
        },
        {
            "Country": "Central African Republic",
            "Abs_contribution": 0.00021086594677768,
            "Perc_contribution": 0.05,
            "Fossil_abs": 1.8501895992226e-05,
            "Land_abs": 0.00019236405078546,
            "Fossil_fraction": 8.77424556926344,
            "Land_fraction": 91.2257544307394,
            "Rank": 120,
            "Perc_contribution_rescale": 0.201045436268597
        },
        {
            "Country": "Bosnia and Herzegovina",
            "Abs_contribution": 0.000201464240473896,
            "Perc_contribution": 0.05,
            "Fossil_abs": 0.000193453418580208,
            "Land_abs": 8.01082189369202e-06,
            "Fossil_fraction": 96.0237003475929,
            "Land_fraction": 3.97629965240903,
            "Rank": 121,
            "Perc_contribution_rescale": 0.201045436268597
        },
        {
            "Country": "Cuba",
            "Abs_contribution": 0.00019281856473363,
            "Perc_contribution": 0.05,
            "Fossil_abs": 0.000239609420920752,
            "Land_abs": -0.00004679085618713,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 122,
            "Perc_contribution_rescale": 0.201045436268597
        },
        {
            "Country": "Panama",
            "Abs_contribution": 0.000191437489591523,
            "Perc_contribution": 0.05,
            "Fossil_abs": 0.000105662447273791,
            "Land_abs": 8.5775042317729e-05,
            "Fossil_fraction": 55.1942294580057,
            "Land_fraction": 44.8057705419927,
            "Rank": 123,
            "Perc_contribution_rescale": 0.201045436268597
        },
        {
            "Country": "Haiti",
            "Abs_contribution": 0.000188725189789548,
            "Perc_contribution": 0.05,
            "Fossil_abs": 0.000128036660656238,
            "Land_abs": 6.0688529133312e-05,
            "Fossil_fraction": 67.8429099999925,
            "Land_fraction": 32.1570900000086,
            "Rank": 124,
            "Perc_contribution_rescale": 0.201045436268597
        },
        {
            "Country": "Liberia",
            "Abs_contribution": 0.000180305205981805,
            "Perc_contribution": 0.05,
            "Fossil_abs": 5.58972980387626e-05,
            "Land_abs": 0.000124407907943044,
            "Fossil_fraction": 31.0014886893523,
            "Land_fraction": 68.9985113106486,
            "Rank": 125,
            "Perc_contribution_rescale": 0.201045436268597
        },
        {
            "Country": "Bulgaria",
            "Abs_contribution": 0.00017236823117044,
            "Perc_contribution": 0.04,
            "Fossil_abs": 0.00026073655636839,
            "Land_abs": -0.000088368325197954,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 126,
            "Perc_contribution_rescale": 0.160836349014877
        },
        {
            "Country": "Botswana",
            "Abs_contribution": 0.000168638765367003,
            "Perc_contribution": 0.04,
            "Fossil_abs": 6.80389870193071e-05,
            "Land_abs": 0.000100599778347696,
            "Fossil_fraction": 40.3459945115443,
            "Land_fraction": 59.6540054884557,
            "Rank": 127,
            "Perc_contribution_rescale": 0.160836349014877
        },
        {
            "Country": "Namibia",
            "Abs_contribution": 0.000166137946715066,
            "Perc_contribution": 0.04,
            "Fossil_abs": 4.87785307091442e-05,
            "Land_abs": 0.000117359416005919,
            "Fossil_fraction": 29.3602585523713,
            "Land_fraction": 70.639741447627,
            "Rank": 128,
            "Perc_contribution_rescale": 0.160836349014877
        },
        {
            "Country": "Mauritania",
            "Abs_contribution": 0.000161409958610672,
            "Perc_contribution": 0.04,
            "Fossil_abs": 5.20972328656395e-05,
            "Land_abs": 0.000109312725745033,
            "Fossil_fraction": 32.2763436122924,
            "Land_fraction": 67.7236563877079,
            "Rank": 129,
            "Perc_contribution_rescale": 0.160836349014877
        },
        {
            "Country": "Tajikistan",
            "Abs_contribution": 0.00015613765518735,
            "Perc_contribution": 0.04,
            "Fossil_abs": 7.1869401236997e-05,
            "Land_abs": 8.4268253950354e-05,
            "Fossil_fraction": 46.029512324084,
            "Land_fraction": 53.9704876759167,
            "Rank": 130,
            "Perc_contribution_rescale": 0.160836349014877
        },
        {
            "Country": "Croatia",
            "Abs_contribution": 0.00015421400249561,
            "Perc_contribution": 0.04,
            "Fossil_abs": 0.000186287296154762,
            "Land_abs": -0.00003207329365915,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 131,
            "Perc_contribution_rescale": 0.160836349014877
        },
        {
            "Country": "Estonia",
            "Abs_contribution": 0.00014415685678355,
            "Perc_contribution": 0.04,
            "Fossil_abs": 0.000153542364351457,
            "Land_abs": -0.00000938550756791,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 132,
            "Perc_contribution_rescale": 0.160836349014877
        },
        {
            "Country": "Togo",
            "Abs_contribution": 0.00014091819589665,
            "Perc_contribution": 0.04,
            "Fossil_abs": 8.7654356980818e-05,
            "Land_abs": 5.3263838915835e-05,
            "Fossil_fraction": 62.2022985910947,
            "Land_fraction": 37.7977014089074,
            "Rank": 133,
            "Perc_contribution_rescale": 0.160836349014877
        },
        {
            "Country": "Kyrgyzstan",
            "Abs_contribution": 0.000135905198282964,
            "Perc_contribution": 0.03,
            "Fossil_abs": 8.5844223594272e-05,
            "Land_abs": 5.0060974688693e-05,
            "Fossil_fraction": 63.1647830096524,
            "Land_fraction": 36.8352169903483,
            "Rank": 134,
            "Perc_contribution_rescale": 0.120627261761158
        },
        {
            "Country": "Brunei Darussalam",
            "Abs_contribution": 0.000128309883395679,
            "Perc_contribution": 0.03,
            "Fossil_abs": 0.000118011110914241,
            "Land_abs": 1.02987724814384e-05,
            "Fossil_fraction": 91.9735158283334,
            "Land_fraction": 8.02648417166688,
            "Rank": 135,
            "Perc_contribution_rescale": 0.120627261761158
        },
        {
            "Country": "Slovenia",
            "Abs_contribution": 0.000113637471668756,
            "Perc_contribution": 0.03,
            "Fossil_abs": 0.00010593164504356,
            "Land_abs": 7.705826625198e-06,
            "Fossil_fraction": 93.2189386898208,
            "Land_fraction": 6.78106131018109,
            "Rank": 136,
            "Perc_contribution_rescale": 0.120627261761158
        },
        {
            "Country": "Lithuania",
            "Abs_contribution": 0.00011057766865604,
            "Perc_contribution": 0.03,
            "Fossil_abs": 0.000125716585815918,
            "Land_abs": -0.000015138917159883,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 137,
            "Perc_contribution_rescale": 0.120627261761158
        },
        {
            "Country": "Timor-Leste",
            "Abs_contribution": 0.000103320038415958,
            "Perc_contribution": 0.03,
            "Fossil_abs": 7.29163976911736e-05,
            "Land_abs": 3.0403640724784e-05,
            "Fossil_fraction": 70.5733358301883,
            "Land_fraction": 29.4266641698113,
            "Rank": 138,
            "Perc_contribution_rescale": 0.120627261761158
        },
        {
            "Country": "Burundi",
            "Abs_contribution": 0.000101808813555594,
            "Perc_contribution": 0.03,
            "Fossil_abs": 4.97305069795781e-05,
            "Land_abs": 5.2078306576017e-05,
            "Fossil_fraction": 48.846956606976,
            "Land_fraction": 51.1530433930251,
            "Rank": 139,
            "Perc_contribution_rescale": 0.120627261761158
        },
        {
            "Country": "Costa Rica",
            "Abs_contribution": 9.81235995089599e-05,
            "Perc_contribution": 0.02,
            "Fossil_abs": 9.140554440817e-05,
            "Land_abs": 6.718055100794e-06,
            "Fossil_fraction": 93.1534767024354,
            "Land_fraction": 6.84652329756876,
            "Rank": 140,
            "Perc_contribution_rescale": 0.0804181745074387
        },
        {
            "Country": "Guyana",
            "Abs_contribution": 8.11725406157431e-05,
            "Perc_contribution": 0.02,
            "Fossil_abs": 1.94548861340697e-05,
            "Land_abs": 6.1717654481676e-05,
            "Fossil_fraction": 23.9673244011984,
            "Land_fraction": 76.0326755988048,
            "Rank": 141,
            "Perc_contribution_rescale": 0.0804181745074387
        },
        {
            "Country": "Eritrea",
            "Abs_contribution": 7.9303691201778e-05,
            "Perc_contribution": 0.02,
            "Fossil_abs": 2.60483945516154e-05,
            "Land_abs": 5.3255296650163e-05,
            "Fossil_fraction": 32.8463835123874,
            "Land_fraction": 67.1536164876132,
            "Rank": 142,
            "Perc_contribution_rescale": 0.0804181745074387
        },
        {
            "Country": "Luxembourg",
            "Abs_contribution": 7.6716816316492e-05,
            "Perc_contribution": 0.02,
            "Fossil_abs": 7.505220809664e-05,
            "Land_abs": 1.664608219852e-06,
            "Fossil_fraction": 97.8301912152028,
            "Land_fraction": 2.16980878479723,
            "Rank": 143,
            "Perc_contribution_rescale": 0.0804181745074387
        },
        {
            "Country": "Rwanda",
            "Abs_contribution": 6.9346889121703e-05,
            "Perc_contribution": 0.02,
            "Fossil_abs": 6.44181551571799e-06,
            "Land_abs": 6.2905073605986e-05,
            "Fossil_fraction": 9.28926386937513,
            "Land_fraction": 90.7107361306264,
            "Rank": 144,
            "Perc_contribution_rescale": 0.0804181745074387
        },
        {
            "Country": "Jamaica",
            "Abs_contribution": 6.7966239895132e-05,
            "Perc_contribution": 0.02,
            "Fossil_abs": 6.9004699327453e-05,
            "Land_abs": -0.00000103845943232099,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 145,
            "Perc_contribution_rescale": 0.0804181745074387
        },
        {
            "Country": "Libya",
            "Abs_contribution": 6.789644612836e-05,
            "Perc_contribution": 0.02,
            "Fossil_abs": 4.55814765537399e-05,
            "Land_abs": 2.2314969574606e-05,
            "Fossil_fraction": 67.1338179726917,
            "Land_fraction": 32.8661820272875,
            "Rank": 146,
            "Perc_contribution_rescale": 0.0804181745074387
        },
        {
            "Country": "Cyprus",
            "Abs_contribution": 6.6939725994711e-05,
            "Perc_contribution": 0.02,
            "Fossil_abs": 6.90370522380865e-05,
            "Land_abs": -0.0000020973262433758,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 147,
            "Perc_contribution_rescale": 0.0804181745074387
        },
        {
            "Country": "Latvia",
            "Abs_contribution": 6.6792241300134e-05,
            "Perc_contribution": 0.02,
            "Fossil_abs": 7.2522428533325e-05,
            "Land_abs": -0.00000573018723319402,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 148,
            "Perc_contribution_rescale": 0.0804181745074387
        },
        {
            "Country": "Armenia",
            "Abs_contribution": 6.088451962769e-05,
            "Perc_contribution": 0.02,
            "Fossil_abs": 4.0573629639575e-05,
            "Land_abs": 2.0310889988115e-05,
            "Fossil_fraction": 66.6403051016638,
            "Land_fraction": 33.3596948983362,
            "Rank": 149,
            "Perc_contribution_rescale": 0.0804181745074387
        },
        {
            "Country": "Gabon",
            "Abs_contribution": 5.95750589291899e-05,
            "Perc_contribution": 0.02,
            "Fossil_abs": 6.72348291914709e-06,
            "Land_abs": 5.2851576010042e-05,
            "Fossil_fraction": 11.2857343995891,
            "Land_fraction": 88.7142656004094,
            "Rank": 150,
            "Perc_contribution_rescale": 0.0804181745074387
        },
        {
            "Country": "El Salvador",
            "Abs_contribution": 5.6236612467948e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 5.5870345543795e-05,
            "Land_abs": 3.66266924150985e-07,
            "Fossil_fraction": 99.3487037926373,
            "Land_fraction": 0.651296207359108,
            "Rank": 151,
            "Perc_contribution_rescale": 0.0402090872537193
        },
        {
            "Country": "Belize",
            "Abs_contribution": 5.5925403023662e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 9.5777678031434e-06,
            "Land_abs": 4.634763522052e-05,
            "Fossil_fraction": 17.125970105376,
            "Land_fraction": 82.8740298946265,
            "Rank": 152,
            "Perc_contribution_rescale": 0.0402090872537193
        },
        {
            "Country": "Kosovo",
            "Abs_contribution": 5.47126544213973e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 5.47126544213973e-05,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 153,
            "Perc_contribution_rescale": 0.0402090872537193
        },
        {
            "Country": "North Macedonia",
            "Abs_contribution": 4.8102781780292e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 6.4386960007026e-05,
            "Land_abs": -0.000016284178226734,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 154,
            "Perc_contribution_rescale": 0.0402090872537193
        },
        {
            "Country": "Guinea-Bissau",
            "Abs_contribution": 4.7858419035842e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 1.58114512355302e-05,
            "Land_abs": 3.2046967800313e-05,
            "Fossil_fraction": 33.0379723235085,
            "Land_fraction": 66.962027676494,
            "Rank": 155,
            "Perc_contribution_rescale": 0.0402090872537193
        },
        {
            "Country": "Gambia",
            "Abs_contribution": 4.64501232331314e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 1.4523333009301e-05,
            "Land_abs": 3.19267902238303e-05,
            "Fossil_fraction": 31.266511256405,
            "Land_fraction": 68.7334887435949,
            "Rank": 156,
            "Perc_contribution_rescale": 0.0402090872537193
        },
        {
            "Country": "Suriname",
            "Abs_contribution": 4.6028819794203e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 2.75000966267291e-05,
            "Land_abs": 1.85287231674737e-05,
            "Fossil_fraction": 59.7453872371339,
            "Land_fraction": 40.2546127628657,
            "Rank": 157,
            "Perc_contribution_rescale": 0.0402090872537193
        },
        {
            "Country": "Lesotho",
            "Abs_contribution": 4.2189060760392e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 2.82452518488293e-05,
            "Land_abs": 1.3943808911564e-05,
            "Fossil_fraction": 66.9492312456184,
            "Land_fraction": 33.0507687543847,
            "Rank": 158,
            "Perc_contribution_rescale": 0.0402090872537193
        },
        {
            "Country": "Bhutan",
            "Abs_contribution": 4.0415968923346e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 2.16462267790466e-05,
            "Land_abs": 1.8769742144299e-05,
            "Fossil_fraction": 53.5585991272445,
            "Land_fraction": 46.4414008727545,
            "Rank": 159,
            "Perc_contribution_rescale": 0.0402090872537193
        },
        {
            "Country": "Mauritius",
            "Abs_contribution": 3.67204836109518e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 3.59638303852164e-05,
            "Land_abs": 7.5665322573547e-07,
            "Fossil_fraction": 97.9394246716573,
            "Land_fraction": 2.0605753283429,
            "Rank": 160,
            "Perc_contribution_rescale": 0.0402090872537193
        },
        {
            "Country": "Cura\xe7ao",
            "Abs_contribution": 3.6709200450327e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 3.6709200450327e-05,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 161,
            "Perc_contribution_rescale": 0.0402090872537193
        },
        {
            "Country": "Iceland",
            "Abs_contribution": 3.4814912932984e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 2.93663521900923e-05,
            "Land_abs": 5.4485607428923e-06,
            "Fossil_fraction": 84.3499228236481,
            "Land_fraction": 15.6500771763536,
            "Rank": 162,
            "Perc_contribution_rescale": 0.0402090872537193
        },
        {
            "Country": "New Caledonia",
            "Abs_contribution": 3.32537771151747e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 3.32537771151747e-05,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 163,
            "Perc_contribution_rescale": 0.0402090872537193
        },
        {
            "Country": "Solomon Islands",
            "Abs_contribution": 2.99852180774993e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 5.3267482502975e-06,
            "Land_abs": 2.46584698272019e-05,
            "Fossil_fraction": 17.7645806561422,
            "Land_fraction": 82.2354193438581,
            "Rank": 164,
            "Perc_contribution_rescale": 0.0402090872537193
        },
        {
            "Country": "Albania",
            "Abs_contribution": 2.3117004187392e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 2.7639035279761e-05,
            "Land_abs": -0.00000452203109236799,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 165,
            "Perc_contribution_rescale": 0.0402090872537193
        },
        {
            "Country": "Georgia",
            "Abs_contribution": 2.2594630591176e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 6.6853647957585e-05,
            "Land_abs": -0.0000442590173664104,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 166,
            "Perc_contribution_rescale": 0.0402090872537193
        },
        {
            "Country": "Bahamas",
            "Abs_contribution": 2.10734824729385e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 2.10046181260511e-05,
            "Land_abs": 6.88643468871708e-08,
            "Fossil_fraction": 99.6732180028819,
            "Land_fraction": 0.326781997117007,
            "Rank": 167,
            "Perc_contribution_rescale": 0.0402090872537193
        },
        {
            "Country": "Djibouti",
            "Abs_contribution": 1.80927005006384e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 1.24364259470245e-05,
            "Land_abs": 5.6562745536138e-06,
            "Fossil_fraction": 68.7372564785765,
            "Land_fraction": 31.262743521423,
            "Rank": 168,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Malta",
            "Abs_contribution": 1.78421575173492e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 1.86426623455463e-05,
            "Land_abs": -0.0000008005048281973,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 169,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Maldives",
            "Abs_contribution": 1.33577181334124e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 1.33461493779363e-05,
            "Land_abs": 1.15687554760568e-08,
            "Fossil_fraction": 99.9133927265079,
            "Land_fraction": 0.0866072734917145,
            "Rank": 170,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Fiji",
            "Abs_contribution": 1.2811399377744e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 1.41963028175336e-05,
            "Land_abs": -0.00000138490343979001,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 171,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Barbados",
            "Abs_contribution": 1.22969592813812e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 1.33156090003925e-05,
            "Land_abs": -0.00000101864971901124,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 172,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Macao",
            "Abs_contribution": 1.20586566150507e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 1.20324950442943e-05,
            "Land_abs": 2.61615707563909e-08,
            "Fossil_fraction": 99.7830473858609,
            "Land_fraction": 0.216952614138942,
            "Rank": 173,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Aruba",
            "Abs_contribution": 1.17562084905848e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 1.17557412037399e-05,
            "Land_abs": 4.67286844861081e-10,
            "Fossil_fraction": 99.9960251909,
            "Land_fraction": 0.00397480909967969,
            "Rank": 174,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Comoros",
            "Abs_contribution": 9.6526438399072e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 6.77004070728984e-06,
            "Land_abs": 2.8826031326174e-06,
            "Fossil_fraction": 70.1366467008787,
            "Land_fraction": 29.8633532991218,
            "Rank": 175,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Cape Verde",
            "Abs_contribution": 6.8416931254039e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 5.85919968417221e-06,
            "Land_abs": 9.824934412317e-07,
            "Fossil_fraction": 85.6396154691067,
            "Land_fraction": 14.3603845308934,
            "Rank": 176,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "French Polynesia",
            "Abs_contribution": 6.5989511872271e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 6.5989511872271e-06,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 177,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Vanuatu",
            "Abs_contribution": 5.8491261330053e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 2.93313657216307e-06,
            "Land_abs": 2.91598956084221e-06,
            "Fossil_fraction": 50.1465775479185,
            "Land_fraction": 49.8534224520812,
            "Rank": 178,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Faeroe Islands",
            "Abs_contribution": 5.0708926719432e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 5.0708926719432e-06,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 179,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Sint Maarten (Dutch part)",
            "Abs_contribution": 5.0366209470524e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 5.0366209470524e-06,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 180,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Seychelles",
            "Abs_contribution": 4.79185689206364e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 4.84310266509864e-06,
            "Land_abs": -0.000000051245773034966,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 181,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Greenland",
            "Abs_contribution": 4.5253978984716e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 4.5253978984716e-06,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 182,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Bermuda",
            "Abs_contribution": 4.3032274699782e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 4.3032274699782e-06,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 183,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Antigua and Barbuda",
            "Abs_contribution": 4.29286056735524e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 4.6533668730863e-06,
            "Land_abs": -0.000000360506305730987,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 184,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Andorra",
            "Abs_contribution": 4.20345164274912e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 3.79296501928313e-06,
            "Land_abs": 4.1048662346592e-07,
            "Fossil_fraction": 90.2345344171123,
            "Land_fraction": 9.76546558288596,
            "Rank": 185,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Lucia",
            "Abs_contribution": 3.3531740188486e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 3.74786386211455e-06,
            "Land_abs": -0.00000039468984326599,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 186,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Samoa",
            "Abs_contribution": 2.788450837835e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 2.04174927200869e-06,
            "Land_abs": 7.467015658263e-07,
            "Fossil_fraction": 73.221634188607,
            "Land_fraction": 26.7783658113927,
            "Rank": 187,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Turks and Caicos Islands",
            "Abs_contribution": 2.59732842476701e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 2.59694062757269e-06,
            "Land_abs": 3.87797194323144e-10,
            "Fossil_fraction": 99.985069381653,
            "Land_fraction": 0.0149306183471168,
            "Rank": 188,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Grenada",
            "Abs_contribution": 2.23276827337727e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 2.49655490563327e-06,
            "Land_abs": -0.000000263786632255976,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 189,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Vincent and the Grenadines",
            "Abs_contribution": 2.19126389981718e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 2.29569650390156e-06,
            "Land_abs": -0.00000010443260408442,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 190,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Sao Tome and Principe",
            "Abs_contribution": 2.15371792080664e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 2.00997180474474e-06,
            "Land_abs": 1.4374611606196e-07,
            "Fossil_fraction": 93.3256758151475,
            "Land_fraction": 6.67432418485529,
            "Rank": 191,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Tonga",
            "Abs_contribution": 1.981751835018e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.45219123659922e-06,
            "Land_abs": 5.2956059841877e-07,
            "Fossil_fraction": 73.2781577863926,
            "Land_fraction": 26.7218422136069,
            "Rank": 192,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Kitts and Nevis",
            "Abs_contribution": 1.77474033380629e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 2.02001959789856e-06,
            "Land_abs": -0.00000024527926409226,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 193,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Micronesia (Federated States of)",
            "Abs_contribution": 1.68951911903475e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.04113650171876e-06,
            "Land_abs": 6.4838261731598e-07,
            "Fossil_fraction": 61.6232447439587,
            "Land_fraction": 38.3767552560406,
            "Rank": 194,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Montenegro",
            "Abs_contribution": 1.556381209237e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 2.16375588190218e-05,
            "Land_abs": -0.0000200811776097858,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 195,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Dominica",
            "Abs_contribution": 1.54401345723466e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.56657923663759e-06,
            "Land_abs": -0.0000000225657794029997,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 196,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "British Virgin Islands",
            "Abs_contribution": 1.4671634279476e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.4671634279476e-06,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 197,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Liechtenstein",
            "Abs_contribution": 1.25194254688415e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.3398459308131e-06,
            "Land_abs": -0.000000087903383928933,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 198,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Marshall Islands",
            "Abs_contribution": 1.06921125818777e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.06921125818777e-06,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 199,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Anguilla",
            "Abs_contribution": 9.9743986080786e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 9.9743986080786e-07,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 200,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Kiribati",
            "Abs_contribution": 8.5216475898083e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 7.5814773447877e-07,
            "Land_abs": 9.401702450205e-08,
            "Fossil_fraction": 88.9672714681956,
            "Land_fraction": 11.0327285318032,
            "Rank": 201,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Bonaire, Saint Eustatius and Saba",
            "Abs_contribution": 6.8750060043668e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 6.8750060043668e-07,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 202,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Cook Islands",
            "Abs_contribution": 5.308750187048e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 6.25060638497752e-07,
            "Land_abs": -0.00000009418561979296,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 203,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Pierre and Miquelon",
            "Abs_contribution": 4.9485859716157e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 4.9485859716157e-07,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 204,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Nauru",
            "Abs_contribution": 4.2668037294553e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 4.1768028423547e-07,
            "Land_abs": 9.0000887100486e-09,
            "Fossil_fraction": 97.8906719688254,
            "Land_fraction": 2.10932803117184,
            "Rank": 205,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Montserrat",
            "Abs_contribution": 2.84817740174672e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 2.84817740174672e-07,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 206,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Wallis and Futuna Islands",
            "Abs_contribution": 1.97218231441048e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 1.97218231441048e-07,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 207,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Tuvalu",
            "Abs_contribution": 1.78220605812977e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 1.27709582010784e-07,
            "Land_abs": 5.051102380219e-08,
            "Fossil_fraction": 71.6581460534374,
            "Land_fraction": 28.3418539465609,
            "Rank": 208,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Occupied Palestinian Territory",
            "Abs_contribution": 1.32418e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 1.32418e-07,
            "Fossil_fraction": 0,
            "Land_fraction": 100,
            "Rank": 209,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Helena",
            "Abs_contribution": 9.6823116812227e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 9.6823116812227e-08,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 210,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Niue",
            "Abs_contribution": 6.1434595335963e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 5.26905237626603e-08,
            "Land_abs": 8.74407157330399e-09,
            "Fossil_fraction": 85.7668606336794,
            "Land_fraction": 14.2331393663227,
            "Rank": 211,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Antarctica",
            "Abs_contribution": 8.25000000000001e-09,
            "Perc_contribution": 0,
            "Fossil_abs": 8.25000000000001e-09,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 212,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Christmas Island",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 213,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Kuwaiti Oil Fires",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 214,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Leeward Islands",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 215,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Pacific Islands (Palau)",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 216,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Panama Canal Zone",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 217,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Ryukyu Islands",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 218,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "St. Kitts-Nevis-Anguilla",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 219,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Palau",
            "Abs_contribution": -0.00000014992449592263,
            "Perc_contribution": -0,
            "Fossil_abs": -0.00000031941781035314,
            "Land_abs": 1.69493314430456e-07,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 220,
            "Perc_contribution_rescale": -0
        },
        {
            "Country": "Swaziland",
            "Abs_contribution": -0.00000152910970481501,
            "Perc_contribution": -0,
            "Fossil_abs": -0.0000046810568120758,
            "Land_abs": 3.1519471072612e-06,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 221,
            "Perc_contribution_rescale": -0
        },
        {
            "Country": "Moldova",
            "Abs_contribution": -0.00000359590978565199,
            "Perc_contribution": -0,
            "Fossil_abs": 4.5309313579276e-05,
            "Land_abs": -0.000048905223364926,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 222,
            "Perc_contribution_rescale": -0
        },
        {
            "Country": "Syria",
            "Abs_contribution": -0.0000530329039256901,
            "Perc_contribution": -0.01,
            "Fossil_abs": -0.00011390809862611,
            "Land_abs": 6.087519470042e-05,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 223,
            "Perc_contribution_rescale": 0
        }
    ],
    "2005_CH4": [
        {
            "Country": "China",
            "Abs_contribution": 0.0216067761992983,
            "Perc_contribution": 27.46,
            "Fossil_abs": 0.0210930374033623,
            "Land_abs": 0.000513738795936001,
            "Fossil_fraction": 97.622325555662,
            "Land_fraction": 2.37767444433791,
            "Rank": 1,
            "Perc_contribution_rescale": 100
        },
        {
            "Country": "India",
            "Abs_contribution": 0.0068257519744824,
            "Perc_contribution": 8.67,
            "Fossil_abs": 0.00386950247054106,
            "Land_abs": 0.0029562495039414,
            "Fossil_fraction": 56.689760849895,
            "Land_fraction": 43.3102391501059,
            "Rank": 2,
            "Perc_contribution_rescale": 31.5731973780044
        },
        {
            "Country": "Brazil",
            "Abs_contribution": 0.0059120918848556,
            "Perc_contribution": 7.51,
            "Fossil_abs": 0.00234166039214408,
            "Land_abs": 0.0035704314927116,
            "Fossil_fraction": 39.6079837348684,
            "Land_fraction": 60.3920162651329,
            "Rank": 3,
            "Perc_contribution_rescale": 27.3488710852149
        },
        {
            "Country": "Indonesia",
            "Abs_contribution": 0.00505226847247435,
            "Perc_contribution": 6.42,
            "Fossil_abs": 0.00459946247967805,
            "Land_abs": 0.0004528059927962,
            "Fossil_fraction": 91.0375706425091,
            "Land_fraction": 8.96242935748896,
            "Rank": 4,
            "Perc_contribution_rescale": 23.3794610342316
        },
        {
            "Country": "Pakistan",
            "Abs_contribution": 0.00308919470626598,
            "Perc_contribution": 3.93,
            "Fossil_abs": 0.00100812374776576,
            "Land_abs": 0.00208107095850019,
            "Fossil_fraction": 32.6338688112125,
            "Land_fraction": 67.3661311887866,
            "Rank": 5,
            "Perc_contribution_rescale": 14.3117261471231
        },
        {
            "Country": "Iran",
            "Abs_contribution": 0.00284856764807586,
            "Perc_contribution": 3.62,
            "Fossil_abs": 0.00290615430845987,
            "Land_abs": -0.0000575866603840119,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 6,
            "Perc_contribution_rescale": 13.1828113619811
        },
        {
            "Country": "Iraq",
            "Abs_contribution": 0.00212842678539184,
            "Perc_contribution": 2.7,
            "Fossil_abs": 0.0020970125829332,
            "Land_abs": 3.1414202458621e-05,
            "Fossil_fraction": 98.5240646906792,
            "Land_fraction": 1.47593530931992,
            "Rank": 7,
            "Perc_contribution_rescale": 9.83248361252731
        },
        {
            "Country": "Qatar",
            "Abs_contribution": 0.00198991550522588,
            "Perc_contribution": 2.53,
            "Fossil_abs": 0.00198465306811014,
            "Land_abs": 5.26243711573167e-06,
            "Fossil_fraction": 99.7355446951433,
            "Land_fraction": 0.264455304856491,
            "Rank": 8,
            "Perc_contribution_rescale": 9.21340131099781
        },
        {
            "Country": "Saudi Arabia",
            "Abs_contribution": 0.00189385827710091,
            "Perc_contribution": 2.41,
            "Fossil_abs": 0.00186840762730655,
            "Land_abs": 2.54506497943786e-05,
            "Fossil_fraction": 98.6561481340979,
            "Land_fraction": 1.34385186590298,
            "Rank": 9,
            "Perc_contribution_rescale": 8.77640203932993
        },
        {
            "Country": "Ethiopia",
            "Abs_contribution": 0.00175004836279464,
            "Perc_contribution": 2.22,
            "Fossil_abs": 0.000555749425940719,
            "Land_abs": 0.00119429893685392,
            "Fossil_fraction": 31.7562324422421,
            "Land_fraction": 68.2437675577578,
            "Rank": 10,
            "Perc_contribution_rescale": 8.08448652585579
        },
        {
            "Country": "Russia",
            "Abs_contribution": 0.0014436453579613,
            "Perc_contribution": 1.83,
            "Fossil_abs": 0.0034355660820633,
            "Land_abs": -0.00199192072410195,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 11,
            "Perc_contribution_rescale": 6.66423889293518
        },
        {
            "Country": "Viet Nam",
            "Abs_contribution": 0.00142448735019525,
            "Perc_contribution": 1.81,
            "Fossil_abs": 0.00101381990253049,
            "Land_abs": 0.00041066744766477,
            "Fossil_fraction": 71.1708603373367,
            "Land_fraction": 28.829139662664,
            "Rank": 12,
            "Perc_contribution_rescale": 6.59140568099053
        },
        {
            "Country": "T\xfcrkiye",
            "Abs_contribution": 0.00137906030422111,
            "Perc_contribution": 1.75,
            "Fossil_abs": 0.00131578897345097,
            "Land_abs": 6.3271330770147e-05,
            "Fossil_fraction": 95.411996808517,
            "Land_fraction": 4.58800319148353,
            "Rank": 13,
            "Perc_contribution_rescale": 6.37290604515659
        },
        {
            "Country": "Mexico",
            "Abs_contribution": 0.00134455350458313,
            "Perc_contribution": 1.71,
            "Fossil_abs": 0.00107817220046661,
            "Land_abs": 0.00026638130411648,
            "Fossil_fraction": 80.1881216918095,
            "Land_fraction": 19.8118783081875,
            "Rank": 14,
            "Perc_contribution_rescale": 6.2272396212673
        },
        {
            "Country": "Chad",
            "Abs_contribution": 0.00107586419245463,
            "Perc_contribution": 1.37,
            "Fossil_abs": 0.000107636903327808,
            "Land_abs": 0.000968227289126825,
            "Fossil_fraction": 10.0046924214691,
            "Land_fraction": 89.9953075785312,
            "Rank": 15,
            "Perc_contribution_rescale": 4.9890750182083
        },
        {
            "Country": "Bangladesh",
            "Abs_contribution": 0.00105298678004478,
            "Perc_contribution": 1.34,
            "Fossil_abs": 0.00063259868574731,
            "Land_abs": 0.00042038809429747,
            "Fossil_fraction": 60.0766028345016,
            "Land_fraction": 39.9233971654983,
            "Rank": 16,
            "Perc_contribution_rescale": 4.87982520029133
        },
        {
            "Country": "Thailand",
            "Abs_contribution": 0.00098710953751327,
            "Perc_contribution": 1.25,
            "Fossil_abs": 0.00077729117088159,
            "Land_abs": 0.00020981836663169,
            "Fossil_fraction": 78.7441658034978,
            "Land_fraction": 21.2558341965032,
            "Rank": 17,
            "Perc_contribution_rescale": 4.55207574654042
        },
        {
            "Country": "Myanmar",
            "Abs_contribution": 0.00096381969664753,
            "Perc_contribution": 1.22,
            "Fossil_abs": 0.000289937772978103,
            "Land_abs": 0.00067388192366942,
            "Fossil_fraction": 30.0821589335224,
            "Land_fraction": 69.9178410664769,
            "Rank": 18,
            "Perc_contribution_rescale": 4.44282592862345
        },
        {
            "Country": "Philippines",
            "Abs_contribution": 0.00094976068409754,
            "Perc_contribution": 1.21,
            "Fossil_abs": 0.000493090094500732,
            "Land_abs": 0.0004566705895968,
            "Fossil_fraction": 51.9172990372059,
            "Land_fraction": 48.0827009627933,
            "Rank": 19,
            "Perc_contribution_rescale": 4.40640932265113
        },
        {
            "Country": "Sudan",
            "Abs_contribution": 0.00092095491831389,
            "Perc_contribution": 1.17,
            "Fossil_abs": 0.000212841718272806,
            "Land_abs": 0.00070811320004109,
            "Fossil_fraction": 23.1109812261476,
            "Land_fraction": 76.8890187738531,
            "Rank": 20,
            "Perc_contribution_rescale": 4.26074289876184
        },
        {
            "Country": "Tanzania",
            "Abs_contribution": 0.00089989649017047,
            "Perc_contribution": 1.14,
            "Fossil_abs": 0.000342677280197725,
            "Land_abs": 0.000557219209972741,
            "Fossil_fraction": 38.0796329289839,
            "Land_fraction": 61.9203670710156,
            "Rank": 21,
            "Perc_contribution_rescale": 4.15149308084486
        },
        {
            "Country": "Uzbekistan",
            "Abs_contribution": 0.00087478577475765,
            "Perc_contribution": 1.11,
            "Fossil_abs": 0.00058814369083969,
            "Land_abs": 0.000286642083917972,
            "Fossil_fraction": 67.232882359413,
            "Land_fraction": 32.7671176405884,
            "Rank": 22,
            "Perc_contribution_rescale": 4.0422432629279
        },
        {
            "Country": "Kenya",
            "Abs_contribution": 0.0008631942244796,
            "Perc_contribution": 1.1,
            "Fossil_abs": 0.000348471438037575,
            "Land_abs": 0.00051472278644203,
            "Fossil_fraction": 40.369991846002,
            "Land_fraction": 59.6300081539985,
            "Rank": 23,
            "Perc_contribution_rescale": 4.00582665695557
        },
        {
            "Country": "Malaysia",
            "Abs_contribution": 0.00085118054906099,
            "Perc_contribution": 1.08,
            "Fossil_abs": 0.00084251696606615,
            "Land_abs": 8.66358299484701e-06,
            "Fossil_fraction": 98.9821685887445,
            "Land_fraction": 1.01783141125635,
            "Rank": 24,
            "Perc_contribution_rescale": 3.93299344501093
        },
        {
            "Country": "Nigeria",
            "Abs_contribution": 0.000843507236154201,
            "Perc_contribution": 1.07,
            "Fossil_abs": 0.00016307301581113,
            "Land_abs": 0.00068043422034308,
            "Fossil_fraction": 19.3327346608937,
            "Land_fraction": 80.6672653391074,
            "Rank": 25,
            "Perc_contribution_rescale": 3.8965768390386
        },
        {
            "Country": "Egypt",
            "Abs_contribution": 0.0008397816917317,
            "Perc_contribution": 1.07,
            "Fossil_abs": 0.00074784886443716,
            "Land_abs": 9.19328272945291e-05,
            "Fossil_fraction": 89.0527707141404,
            "Land_fraction": 10.9472292858583,
            "Rank": 26,
            "Perc_contribution_rescale": 3.8965768390386
        },
        {
            "Country": "Canada",
            "Abs_contribution": 0.00074226628427072,
            "Perc_contribution": 0.94,
            "Fossil_abs": 0.00069390726288157,
            "Land_abs": 4.835902138913e-05,
            "Fossil_fraction": 93.4849497526803,
            "Land_fraction": 6.51505024731697,
            "Rank": 27,
            "Perc_contribution_rescale": 3.4231609613984
        },
        {
            "Country": "Colombia",
            "Abs_contribution": 0.00072321226350302,
            "Perc_contribution": 0.92,
            "Fossil_abs": 0.00056548152316559,
            "Land_abs": 0.00015773074033744,
            "Fossil_fraction": 78.1902564022587,
            "Land_fraction": 21.8097435977427,
            "Rank": 28,
            "Perc_contribution_rescale": 3.35032774945375
        },
        {
            "Country": "Democratic Republic of the Congo",
            "Abs_contribution": 0.00071734775466977,
            "Perc_contribution": 0.91,
            "Fossil_abs": 0.000579570756712915,
            "Land_abs": 0.000137776997956845,
            "Fossil_fraction": 80.7935555579622,
            "Land_fraction": 19.2064444420364,
            "Rank": 29,
            "Perc_contribution_rescale": 3.31391114348143
        },
        {
            "Country": "South Africa",
            "Abs_contribution": 0.000717185653424619,
            "Perc_contribution": 0.91,
            "Fossil_abs": 0.00070210940479735,
            "Land_abs": 1.50762486272709e-05,
            "Fossil_fraction": 97.8978597026754,
            "Land_fraction": 2.10214029732478,
            "Rank": 30,
            "Perc_contribution_rescale": 3.31391114348143
        },
        {
            "Country": "United Arab Emirates",
            "Abs_contribution": 0.00065561110027304,
            "Perc_contribution": 0.83,
            "Fossil_abs": 0.00062824045276334,
            "Land_abs": 2.73706475096928e-05,
            "Fossil_fraction": 95.8251702116848,
            "Land_fraction": 4.17482978831412,
            "Rank": 31,
            "Perc_contribution_rescale": 3.02257829570284
        },
        {
            "Country": "Turkmenistan",
            "Abs_contribution": 0.00062979228447423,
            "Perc_contribution": 0.8,
            "Fossil_abs": 0.00051694348698544,
            "Land_abs": 0.000112848797488793,
            "Fossil_fraction": 82.0815846318283,
            "Land_fraction": 17.9184153681722,
            "Rank": 32,
            "Perc_contribution_rescale": 2.91332847778587
        },
        {
            "Country": "Angola",
            "Abs_contribution": 0.00060065634498484,
            "Perc_contribution": 0.76,
            "Fossil_abs": 0.00042182646550091,
            "Land_abs": 0.000178829879483936,
            "Fossil_fraction": 70.22758837444,
            "Land_fraction": 29.7724116255609,
            "Rank": 33,
            "Perc_contribution_rescale": 2.76766205389658
        },
        {
            "Country": "Mongolia",
            "Abs_contribution": 0.000570746223637561,
            "Perc_contribution": 0.73,
            "Fossil_abs": 0.000396275152713013,
            "Land_abs": 0.000174471070924547,
            "Fossil_fraction": 69.4310599529535,
            "Land_fraction": 30.5689400470463,
            "Rank": 34,
            "Perc_contribution_rescale": 2.65841223597961
        },
        {
            "Country": "Algeria",
            "Abs_contribution": 0.00055082595921801,
            "Perc_contribution": 0.7,
            "Fossil_abs": 0.00046509360768968,
            "Land_abs": 8.5732351528339e-05,
            "Fossil_fraction": 84.4356733567819,
            "Land_fraction": 15.5643266432197,
            "Rank": 35,
            "Perc_contribution_rescale": 2.54916241806264
        },
        {
            "Country": "Uganda",
            "Abs_contribution": 0.000547521026728922,
            "Perc_contribution": 0.7,
            "Fossil_abs": 0.000224348247307102,
            "Land_abs": 0.000323172779421822,
            "Fossil_fraction": 40.9752751684141,
            "Land_fraction": 59.0247248315862,
            "Rank": 36,
            "Perc_contribution_rescale": 2.54916241806264
        },
        {
            "Country": "Oman",
            "Abs_contribution": 0.000531450258660807,
            "Perc_contribution": 0.68,
            "Fossil_abs": 0.000512644076318389,
            "Land_abs": 1.8806182342409e-05,
            "Fossil_fraction": 96.4613466573885,
            "Land_fraction": 3.53865334260979,
            "Rank": 37,
            "Perc_contribution_rescale": 2.47632920611799
        },
        {
            "Country": "Kuwait",
            "Abs_contribution": 0.00047841806095054,
            "Perc_contribution": 0.61,
            "Fossil_abs": 0.00047530113922712,
            "Land_abs": 3.11692172342487e-06,
            "Fossil_fraction": 99.3484941356045,
            "Land_fraction": 0.651505864396517,
            "Rank": 38,
            "Perc_contribution_rescale": 2.22141296431173
        },
        {
            "Country": "Argentina",
            "Abs_contribution": 0.00045628593926487,
            "Perc_contribution": 0.58,
            "Fossil_abs": 0.0001844441226871,
            "Land_abs": 0.00027184181657777,
            "Fossil_fraction": 40.4229249282284,
            "Land_fraction": 59.5770750717717,
            "Rank": 39,
            "Perc_contribution_rescale": 2.11216314639476
        },
        {
            "Country": "Trinidad and Tobago",
            "Abs_contribution": 0.000442666609042892,
            "Perc_contribution": 0.56,
            "Fossil_abs": 0.000442871410713118,
            "Land_abs": -0.000000204801670224341,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 40,
            "Perc_contribution_rescale": 2.03932993445011
        },
        {
            "Country": "Venezuela",
            "Abs_contribution": 0.0004362272311479,
            "Perc_contribution": 0.55,
            "Fossil_abs": 0.00022273759612276,
            "Land_abs": 0.00021348963502514,
            "Fossil_fraction": 51.0599935580918,
            "Land_fraction": 48.9400064419082,
            "Rank": 41,
            "Perc_contribution_rescale": 2.00291332847779
        },
        {
            "Country": "Niger",
            "Abs_contribution": 0.000432907815098128,
            "Perc_contribution": 0.55,
            "Fossil_abs": 7.39121782787153e-05,
            "Land_abs": 0.000358995636819413,
            "Fossil_fraction": 17.0734220314229,
            "Land_fraction": 82.9265779685771,
            "Rank": 42,
            "Perc_contribution_rescale": 2.00291332847779
        },
        {
            "Country": "Mali",
            "Abs_contribution": 0.000431223876892123,
            "Perc_contribution": 0.55,
            "Fossil_abs": 6.98973872515719e-05,
            "Land_abs": 0.000361326489640549,
            "Fossil_fraction": 16.2090716672115,
            "Land_fraction": 83.7909283327881,
            "Rank": 43,
            "Perc_contribution_rescale": 2.00291332847779
        },
        {
            "Country": "Mozambique",
            "Abs_contribution": 0.000427149450461443,
            "Perc_contribution": 0.54,
            "Fossil_abs": 0.000331463804315793,
            "Land_abs": 9.5685646145651e-05,
            "Fossil_fraction": 77.5990239382768,
            "Land_fraction": 22.4009760617234,
            "Rank": 44,
            "Perc_contribution_rescale": 1.96649672250546
        },
        {
            "Country": "Peru",
            "Abs_contribution": 0.0003859970657265,
            "Perc_contribution": 0.49,
            "Fossil_abs": 0.000204527732837104,
            "Land_abs": 0.000181469332889391,
            "Fossil_fraction": 52.9868620768281,
            "Land_fraction": 47.0131379231706,
            "Rank": 45,
            "Perc_contribution_rescale": 1.78441369264385
        },
        {
            "Country": "Morocco",
            "Abs_contribution": 0.000373812651176454,
            "Perc_contribution": 0.48,
            "Fossil_abs": 0.000318445840394388,
            "Land_abs": 5.5366810782064e-05,
            "Fossil_fraction": 85.1886203937141,
            "Land_fraction": 14.8113796062854,
            "Rank": 46,
            "Perc_contribution_rescale": 1.74799708667152
        },
        {
            "Country": "Burkina Faso",
            "Abs_contribution": 0.000353561190349251,
            "Perc_contribution": 0.45,
            "Fossil_abs": 0.000101234514276166,
            "Land_abs": 0.000252326676073088,
            "Fossil_fraction": 28.6328129442504,
            "Land_fraction": 71.3671870557505,
            "Rank": 47,
            "Perc_contribution_rescale": 1.63874726875455
        },
        {
            "Country": "South Sudan",
            "Abs_contribution": 0.00035215923916345,
            "Perc_contribution": 0.45,
            "Fossil_abs": 6.8238128138774e-05,
            "Land_abs": 0.000283921111024672,
            "Fossil_fraction": 19.377065983239,
            "Land_fraction": 80.6229340167599,
            "Rank": 48,
            "Perc_contribution_rescale": 1.63874726875455
        },
        {
            "Country": "Guinea",
            "Abs_contribution": 0.000341187605487601,
            "Perc_contribution": 0.43,
            "Fossil_abs": 7.0914097784108e-05,
            "Land_abs": 0.000270273507703496,
            "Fossil_fraction": 20.7844882532478,
            "Land_fraction": 79.2155117467531,
            "Rank": 49,
            "Perc_contribution_rescale": 1.56591405680991
        },
        {
            "Country": "Azerbaijan",
            "Abs_contribution": 0.000333946948200073,
            "Perc_contribution": 0.42,
            "Fossil_abs": 0.000288445620065566,
            "Land_abs": 4.5501328134511e-05,
            "Fossil_fraction": 86.3746836496777,
            "Land_fraction": 13.6253163503235,
            "Rank": 50,
            "Perc_contribution_rescale": 1.52949745083758
        },
        {
            "Country": "Yemen",
            "Abs_contribution": 0.000325719239456798,
            "Perc_contribution": 0.41,
            "Fossil_abs": 0.000252691814778374,
            "Land_abs": 7.3027424678423e-05,
            "Fossil_fraction": 77.579640428913,
            "Land_fraction": 22.4203595710867,
            "Rank": 51,
            "Perc_contribution_rescale": 1.49308084486526
        },
        {
            "Country": "Ghana",
            "Abs_contribution": 0.000320865921579632,
            "Perc_contribution": 0.41,
            "Fossil_abs": 0.00026131546983114,
            "Land_abs": 5.9550451748487e-05,
            "Fossil_fraction": 81.4407053714762,
            "Land_fraction": 18.5592946285222,
            "Rank": 52,
            "Perc_contribution_rescale": 1.49308084486526
        },
        {
            "Country": "Paraguay",
            "Abs_contribution": 0.000312236242212869,
            "Perc_contribution": 0.4,
            "Fossil_abs": 4.3976698146045e-05,
            "Land_abs": 0.00026825954406682,
            "Fossil_fraction": 14.0844310174805,
            "Land_fraction": 85.9155689825182,
            "Rank": 53,
            "Perc_contribution_rescale": 1.45666423889294
        },
        {
            "Country": "Cambodia",
            "Abs_contribution": 0.000299041574430898,
            "Perc_contribution": 0.38,
            "Fossil_abs": 7.4370372713455e-05,
            "Land_abs": 0.000224671201717443,
            "Fossil_fraction": 24.8695763640852,
            "Land_fraction": 75.1304236359148,
            "Rank": 54,
            "Perc_contribution_rescale": 1.38383102694829
        },
        {
            "Country": "Afghanistan",
            "Abs_contribution": 0.000289274054322896,
            "Perc_contribution": 0.37,
            "Fossil_abs": 0.000120078205629544,
            "Land_abs": 0.00016919584869335,
            "Fossil_fraction": 41.5101886377647,
            "Land_fraction": 58.4898113622346,
            "Rank": 55,
            "Perc_contribution_rescale": 1.34741442097596
        },
        {
            "Country": "Bahrain",
            "Abs_contribution": 0.00027569678047652,
            "Perc_contribution": 0.35,
            "Fossil_abs": 0.00027559824143195,
            "Land_abs": 9.85390445591241e-08,
            "Fossil_fraction": 99.9642581808901,
            "Land_fraction": 0.0357418191060509,
            "Rank": 56,
            "Perc_contribution_rescale": 1.27458120903132
        },
        {
            "Country": "Bolivia",
            "Abs_contribution": 0.000271810813445339,
            "Perc_contribution": 0.35,
            "Fossil_abs": 1.7839952994101e-05,
            "Land_abs": 0.000253970860451241,
            "Fossil_fraction": 6.56337132727377,
            "Land_fraction": 93.4366286727273,
            "Rank": 57,
            "Perc_contribution_rescale": 1.27458120903132
        },
        {
            "Country": "Nepal",
            "Abs_contribution": 0.000269995093725814,
            "Perc_contribution": 0.34,
            "Fossil_abs": 8.2726578331653e-05,
            "Land_abs": 0.000187268515394155,
            "Fossil_fraction": 30.6400302279802,
            "Land_fraction": 69.3599697720175,
            "Rank": 58,
            "Perc_contribution_rescale": 1.238164603059
        },
        {
            "Country": "Guatemala",
            "Abs_contribution": 0.000265266167318972,
            "Perc_contribution": 0.34,
            "Fossil_abs": 0.000178464541768209,
            "Land_abs": 8.6801625550762e-05,
            "Fossil_fraction": 67.2775362089853,
            "Land_fraction": 32.7224637910143,
            "Rank": 59,
            "Perc_contribution_rescale": 1.238164603059
        },
        {
            "Country": "Kazakhstan",
            "Abs_contribution": 0.00026276186804065,
            "Perc_contribution": 0.33,
            "Fossil_abs": 0.0003448405183032,
            "Land_abs": -0.0000820786502625581,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 60,
            "Perc_contribution_rescale": 1.20174799708667
        },
        {
            "Country": "Spain",
            "Abs_contribution": 0.00025720739349755,
            "Perc_contribution": 0.33,
            "Fossil_abs": 0.000152240654043736,
            "Land_abs": 0.000104966739453811,
            "Fossil_fraction": 59.1898436407841,
            "Land_fraction": 40.8101563592148,
            "Rank": 61,
            "Perc_contribution_rescale": 1.20174799708667
        },
        {
            "Country": "Equatorial Guinea",
            "Abs_contribution": 0.000245108112371796,
            "Perc_contribution": 0.31,
            "Fossil_abs": 0.000245013110609334,
            "Land_abs": 9.5001762461651e-08,
            "Fossil_fraction": 99.9612408738566,
            "Land_fraction": 0.0387591261433021,
            "Rank": 62,
            "Perc_contribution_rescale": 1.12891478514202
        },
        {
            "Country": "Congo",
            "Abs_contribution": 0.000232579572154497,
            "Perc_contribution": 0.3,
            "Fossil_abs": 0.000205525688545045,
            "Land_abs": 2.70538836094521e-05,
            "Fossil_fraction": 88.3679020651561,
            "Land_fraction": 11.6320979348439,
            "Rank": 63,
            "Perc_contribution_rescale": 1.0924981791697
        },
        {
            "Country": "Uruguay",
            "Abs_contribution": 0.00021357346331204,
            "Perc_contribution": 0.27,
            "Fossil_abs": 0.000127738526615096,
            "Land_abs": 8.58349366969429e-05,
            "Fossil_fraction": 59.810111534533,
            "Land_fraction": 40.1898884654665,
            "Rank": 64,
            "Perc_contribution_rescale": 0.983248361252731
        },
        {
            "Country": "Madagascar",
            "Abs_contribution": 0.000213081519570167,
            "Perc_contribution": 0.27,
            "Fossil_abs": 0.000159535345021127,
            "Land_abs": 5.35461745490449e-05,
            "Fossil_fraction": 74.8705684767714,
            "Land_fraction": 25.1294315232309,
            "Rank": 65,
            "Perc_contribution_rescale": 0.983248361252731
        },
        {
            "Country": "C\xf4te d'Ivoire",
            "Abs_contribution": 0.000213021823301957,
            "Perc_contribution": 0.27,
            "Fossil_abs": 0.000183006125269354,
            "Land_abs": 3.0015698032603e-05,
            "Fossil_fraction": 85.9095666503352,
            "Land_fraction": 14.0904333496648,
            "Rank": 66,
            "Perc_contribution_rescale": 0.983248361252731
        },
        {
            "Country": "Norway",
            "Abs_contribution": 0.000202117999128075,
            "Perc_contribution": 0.26,
            "Fossil_abs": 0.000207271391162411,
            "Land_abs": -0.000005153392034337,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 67,
            "Perc_contribution_rescale": 0.946831755280408
        },
        {
            "Country": "Zambia",
            "Abs_contribution": 0.000201170546587749,
            "Perc_contribution": 0.26,
            "Fossil_abs": 0.000107032729294221,
            "Land_abs": 9.413781729353e-05,
            "Fossil_fraction": 53.2049701657167,
            "Land_fraction": 46.7950298342843,
            "Rank": 68,
            "Perc_contribution_rescale": 0.946831755280408
        },
        {
            "Country": "Ecuador",
            "Abs_contribution": 0.000193224592404931,
            "Perc_contribution": 0.25,
            "Fossil_abs": 0.000175038446316984,
            "Land_abs": 1.8186146087945e-05,
            "Fossil_fraction": 90.5880789491664,
            "Land_fraction": 9.41192105083248,
            "Rank": 69,
            "Perc_contribution_rescale": 0.910415149308084
        },
        {
            "Country": "Israel",
            "Abs_contribution": 0.000190830085372433,
            "Perc_contribution": 0.24,
            "Fossil_abs": 0.000181355714329995,
            "Land_abs": 9.474371042436e-06,
            "Fossil_fraction": 95.0351795819053,
            "Land_fraction": 4.9648204180936,
            "Rank": 70,
            "Perc_contribution_rescale": 0.873998543335761
        },
        {
            "Country": "Somalia",
            "Abs_contribution": 0.000170719301516464,
            "Perc_contribution": 0.22,
            "Fossil_abs": 0.000123008467531379,
            "Land_abs": 4.77108339850809e-05,
            "Fossil_fraction": 72.0530522552051,
            "Land_fraction": 27.9469477447925,
            "Rank": 71,
            "Perc_contribution_rescale": 0.801165331391114
        },
        {
            "Country": "Taiwan",
            "Abs_contribution": 0.000158121711911026,
            "Perc_contribution": 0.2,
            "Fossil_abs": 0.000189893120830809,
            "Land_abs": -0.000031771408919784,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 72,
            "Perc_contribution_rescale": 0.728332119446468
        },
        {
            "Country": "Dominican Republic",
            "Abs_contribution": 0.000148830804508455,
            "Perc_contribution": 0.19,
            "Fossil_abs": 7.9699592124614e-05,
            "Land_abs": 6.913121238384e-05,
            "Fossil_fraction": 53.55046785364,
            "Land_fraction": 46.4495321463593,
            "Rank": 73,
            "Perc_contribution_rescale": 0.691915513474144
        },
        {
            "Country": "South Korea",
            "Abs_contribution": 0.00014685972864578,
            "Perc_contribution": 0.19,
            "Fossil_abs": 0.00013926873607538,
            "Land_abs": 7.59099257039699e-06,
            "Fossil_fraction": 94.8311271984512,
            "Land_fraction": 5.16887280154669,
            "Rank": 74,
            "Perc_contribution_rescale": 0.691915513474144
        },
        {
            "Country": "Nicaragua",
            "Abs_contribution": 0.000146335242225732,
            "Perc_contribution": 0.19,
            "Fossil_abs": 2.80213980497798e-05,
            "Land_abs": 0.000118313844175952,
            "Fossil_fraction": 19.1487693761117,
            "Land_fraction": 80.8512306238882,
            "Rank": 75,
            "Perc_contribution_rescale": 0.691915513474144
        },
        {
            "Country": "Laos",
            "Abs_contribution": 0.000139388326139661,
            "Perc_contribution": 0.18,
            "Fossil_abs": 4.78444636905964e-05,
            "Land_abs": 9.1543862449064e-05,
            "Fossil_fraction": 34.3245844294438,
            "Land_fraction": 65.6754155705558,
            "Rank": 76,
            "Perc_contribution_rescale": 0.655498907501821
        },
        {
            "Country": "Haiti",
            "Abs_contribution": 0.000129829757814279,
            "Perc_contribution": 0.16,
            "Fossil_abs": 0.000106110984156413,
            "Land_abs": 2.3718773657866e-05,
            "Fossil_fraction": 81.7308650519124,
            "Land_fraction": 18.2691349480876,
            "Rank": 77,
            "Perc_contribution_rescale": 0.582665695557174
        },
        {
            "Country": "Malawi",
            "Abs_contribution": 0.000122320921277062,
            "Perc_contribution": 0.16,
            "Fossil_abs": 6.4834164039463e-05,
            "Land_abs": 5.7486757237598e-05,
            "Fossil_fraction": 53.0033320241359,
            "Land_fraction": 46.9966679758633,
            "Rank": 78,
            "Perc_contribution_rescale": 0.582665695557174
        },
        {
            "Country": "Senegal",
            "Abs_contribution": 0.000120197379551315,
            "Perc_contribution": 0.15,
            "Fossil_abs": 5.0018736877995e-05,
            "Land_abs": 7.017864267332e-05,
            "Fossil_fraction": 41.6138330675012,
            "Land_fraction": 58.3861669324989,
            "Rank": 79,
            "Perc_contribution_rescale": 0.546249089584851
        },
        {
            "Country": "Singapore",
            "Abs_contribution": 0.000114336958296799,
            "Perc_contribution": 0.15,
            "Fossil_abs": 0.000115115010710539,
            "Land_abs": -0.00000077805241374115,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 80,
            "Perc_contribution_rescale": 0.546249089584851
        },
        {
            "Country": "Honduras",
            "Abs_contribution": 0.000114184510881154,
            "Perc_contribution": 0.15,
            "Fossil_abs": 7.2093630745715e-05,
            "Land_abs": 4.209088013544e-05,
            "Fossil_fraction": 63.1378373383337,
            "Land_fraction": 36.8621626616671,
            "Rank": 81,
            "Perc_contribution_rescale": 0.546249089584851
        },
        {
            "Country": "Jordan",
            "Abs_contribution": 0.000113322657369078,
            "Perc_contribution": 0.14,
            "Fossil_abs": 0.000106548228578348,
            "Land_abs": 6.7744287907303e-06,
            "Fossil_fraction": 94.0219997059668,
            "Land_fraction": 5.97800029403371,
            "Rank": 82,
            "Perc_contribution_rescale": 0.509832483612527
        },
        {
            "Country": "Mauritania",
            "Abs_contribution": 0.000110624452223426,
            "Perc_contribution": 0.14,
            "Fossil_abs": 2.91024922271927e-05,
            "Land_abs": 8.1521959996233e-05,
            "Fossil_fraction": 26.3074678719448,
            "Land_fraction": 73.6925321280549,
            "Rank": 83,
            "Perc_contribution_rescale": 0.509832483612527
        },
        {
            "Country": "Cameroon",
            "Abs_contribution": 0.000109693855862671,
            "Perc_contribution": 0.14,
            "Fossil_abs": 5.5642698558166e-05,
            "Land_abs": 5.4051157304507e-05,
            "Fossil_fraction": 50.7254468544043,
            "Land_fraction": 49.2745531455975,
            "Rank": 84,
            "Perc_contribution_rescale": 0.509832483612527
        },
        {
            "Country": "Chile",
            "Abs_contribution": 0.00010716605443005,
            "Perc_contribution": 0.14,
            "Fossil_abs": 0.000127757758736933,
            "Land_abs": -0.000020591704306886,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 85,
            "Perc_contribution_rescale": 0.509832483612527
        },
        {
            "Country": "Benin",
            "Abs_contribution": 0.000106001349308989,
            "Perc_contribution": 0.13,
            "Fossil_abs": 6.65391719982039e-05,
            "Land_abs": 3.94621773107847e-05,
            "Fossil_fraction": 62.7720047263222,
            "Land_fraction": 37.2279952736774,
            "Rank": 86,
            "Perc_contribution_rescale": 0.473415877640204
        },
        {
            "Country": "Tunisia",
            "Abs_contribution": 0.000101301081074117,
            "Perc_contribution": 0.13,
            "Fossil_abs": 9.1831389653114e-05,
            "Land_abs": 9.4696914210043e-06,
            "Fossil_fraction": 90.6519344901418,
            "Land_fraction": 9.34806550985946,
            "Rank": 87,
            "Perc_contribution_rescale": 0.473415877640204
        },
        {
            "Country": "New Zealand",
            "Abs_contribution": 9.319921133123e-05,
            "Perc_contribution": 0.12,
            "Fossil_abs": 2.7733909718013e-05,
            "Land_abs": 6.54653016132201e-05,
            "Fossil_fraction": 29.7576656732069,
            "Land_fraction": 70.2423343267964,
            "Rank": 88,
            "Perc_contribution_rescale": 0.43699927166788
        },
        {
            "Country": "Tajikistan",
            "Abs_contribution": 9.2446390491457e-05,
            "Perc_contribution": 0.12,
            "Fossil_abs": 3.00379741995301e-05,
            "Land_abs": 6.2408416291928e-05,
            "Fossil_fraction": 32.4923169415748,
            "Land_fraction": 67.5076830584264,
            "Rank": 89,
            "Perc_contribution_rescale": 0.43699927166788
        },
        {
            "Country": "Togo",
            "Abs_contribution": 9.032747838091e-05,
            "Perc_contribution": 0.11,
            "Fossil_abs": 6.9552261633466e-05,
            "Land_abs": 2.07752167474444e-05,
            "Fossil_fraction": 77.0001143396972,
            "Land_fraction": 22.9998856603032,
            "Rank": 90,
            "Perc_contribution_rescale": 0.400582665695557
        },
        {
            "Country": "Central African Republic",
            "Abs_contribution": 8.73873114076771e-05,
            "Perc_contribution": 0.11,
            "Fossil_abs": 1.62199017457469e-05,
            "Land_abs": 7.1167409661931e-05,
            "Fossil_fraction": 18.5609346305189,
            "Land_fraction": 81.4390653694821,
            "Rank": 91,
            "Perc_contribution_rescale": 0.400582665695557
        },
        {
            "Country": "Sierra Leone",
            "Abs_contribution": 8.4305042278729e-05,
            "Perc_contribution": 0.11,
            "Fossil_abs": 3.68523156960041e-05,
            "Land_abs": 4.74527265827246e-05,
            "Fossil_fraction": 43.7130623506043,
            "Land_fraction": 56.2869376493954,
            "Rank": 92,
            "Perc_contribution_rescale": 0.400582665695557
        },
        {
            "Country": "Timor-Leste",
            "Abs_contribution": 7.97944236182187e-05,
            "Perc_contribution": 0.1,
            "Fossil_abs": 6.86980262934151e-05,
            "Land_abs": 1.10963973248037e-05,
            "Fossil_fraction": 86.0937684343771,
            "Land_fraction": 13.906231565623,
            "Rank": 93,
            "Perc_contribution_rescale": 0.364166059723234
        },
        {
            "Country": "Papua New Guinea",
            "Abs_contribution": 6.95395816241e-05,
            "Perc_contribution": 0.09,
            "Fossil_abs": 5.73424710514114e-05,
            "Land_abs": 1.21971105726875e-05,
            "Fossil_fraction": 82.4601898834814,
            "Land_fraction": 17.539810116517,
            "Rank": 94,
            "Perc_contribution_rescale": 0.32774945375091
        },
        {
            "Country": "Burundi",
            "Abs_contribution": 6.7418932098132e-05,
            "Perc_contribution": 0.09,
            "Fossil_abs": 4.39985676517057e-05,
            "Land_abs": 2.3420364446426e-05,
            "Fossil_fraction": 65.2614425687778,
            "Land_fraction": 34.7385574312218,
            "Rank": 95,
            "Perc_contribution_rescale": 0.32774945375091
        },
        {
            "Country": "Lebanon",
            "Abs_contribution": 6.62927773820737e-05,
            "Perc_contribution": 0.08,
            "Fossil_abs": 6.4045568572437e-05,
            "Land_abs": 2.24720880963736e-06,
            "Fossil_fraction": 96.6101754996851,
            "Land_fraction": 3.38982450031582,
            "Rank": 96,
            "Perc_contribution_rescale": 0.291332847778587
        },
        {
            "Country": "Namibia",
            "Abs_contribution": 6.4599113161402e-05,
            "Perc_contribution": 0.08,
            "Fossil_abs": 2.16056850503644e-05,
            "Land_abs": 4.2993428111037e-05,
            "Fossil_fraction": 33.4457920442069,
            "Land_fraction": 66.5542079557922,
            "Rank": 97,
            "Perc_contribution_rescale": 0.291332847778587
        },
        {
            "Country": "Zimbabwe",
            "Abs_contribution": 6.3728380969786e-05,
            "Perc_contribution": 0.08,
            "Fossil_abs": 4.4876352041587e-05,
            "Land_abs": 1.8852028928199e-05,
            "Fossil_fraction": 70.4181580618895,
            "Land_fraction": 29.5818419381105,
            "Rank": 98,
            "Perc_contribution_rescale": 0.291332847778587
        },
        {
            "Country": "Sri Lanka",
            "Abs_contribution": 5.9669956295876e-05,
            "Perc_contribution": 0.08,
            "Fossil_abs": 5.6968714612241e-05,
            "Land_abs": 2.70124168363402e-06,
            "Fossil_fraction": 95.4730288887079,
            "Land_fraction": 4.52697111129057,
            "Rank": 99,
            "Perc_contribution_rescale": 0.291332847778587
        },
        {
            "Country": "Liberia",
            "Abs_contribution": 5.11930211283844e-05,
            "Perc_contribution": 0.07,
            "Fossil_abs": 4.83606718328642e-05,
            "Land_abs": 2.83234929552044e-06,
            "Fossil_fraction": 94.4673136433634,
            "Land_fraction": 5.53268635663704,
            "Rank": 100,
            "Perc_contribution_rescale": 0.254916241806264
        },
        {
            "Country": "Hong Kong",
            "Abs_contribution": 5.0312070316066e-05,
            "Perc_contribution": 0.06,
            "Fossil_abs": 5.0729397000381e-05,
            "Land_abs": -0.00000041732668431545,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 101,
            "Perc_contribution_rescale": 0.21849963583394
        },
        {
            "Country": "Eritrea",
            "Abs_contribution": 5.019364873728e-05,
            "Perc_contribution": 0.06,
            "Fossil_abs": 2.07447702519566e-05,
            "Land_abs": 2.9448878485323e-05,
            "Fossil_fraction": 41.3294725006691,
            "Land_fraction": 58.6705274993301,
            "Rank": 102,
            "Perc_contribution_rescale": 0.21849963583394
        },
        {
            "Country": "Brunei Darussalam",
            "Abs_contribution": 4.9087917897365e-05,
            "Perc_contribution": 0.06,
            "Fossil_abs": 4.8863141308903e-05,
            "Land_abs": 2.24776588462163e-07,
            "Fossil_fraction": 99.5420938632354,
            "Land_fraction": 0.457906136764926,
            "Rank": 103,
            "Perc_contribution_rescale": 0.21849963583394
        },
        {
            "Country": "Kyrgyzstan",
            "Abs_contribution": 4.2554672385398e-05,
            "Perc_contribution": 0.05,
            "Fossil_abs": 1.8219069473726e-05,
            "Land_abs": 2.4335602911671e-05,
            "Fossil_fraction": 42.8133233143574,
            "Land_fraction": 57.1866766856403,
            "Rank": 104,
            "Perc_contribution_rescale": 0.182083029861617
        },
        {
            "Country": "Panama",
            "Abs_contribution": 4.1115878731499e-05,
            "Perc_contribution": 0.05,
            "Fossil_abs": 2.6839226532906e-05,
            "Land_abs": 1.4276652198593e-05,
            "Fossil_fraction": 65.2770349581375,
            "Land_fraction": 34.7229650418626,
            "Rank": 105,
            "Perc_contribution_rescale": 0.182083029861617
        },
        {
            "Country": "Rwanda",
            "Abs_contribution": 3.4317411464929e-05,
            "Perc_contribution": 0.04,
            "Fossil_abs": -0.00000284323687559801,
            "Land_abs": 3.71606483405264e-05,
            "Fossil_fraction": 0,
            "Land_fraction": 100,
            "Rank": 106,
            "Perc_contribution_rescale": 0.145666423889294
        },
        {
            "Country": "Bosnia and Herzegovina",
            "Abs_contribution": 3.261898831733e-05,
            "Perc_contribution": 0.04,
            "Fossil_abs": 3.4131270447844e-05,
            "Land_abs": -0.0000015122821305132,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 107,
            "Perc_contribution_rescale": 0.145666423889294
        },
        {
            "Country": "Botswana",
            "Abs_contribution": 2.8887952810316e-05,
            "Perc_contribution": 0.04,
            "Fossil_abs": 2.39442520237282e-05,
            "Land_abs": 4.943700786587e-06,
            "Fossil_fraction": 82.886635065319,
            "Land_fraction": 17.1133649346782,
            "Rank": 108,
            "Perc_contribution_rescale": 0.145666423889294
        },
        {
            "Country": "Guinea-Bissau",
            "Abs_contribution": 2.78115517381446e-05,
            "Perc_contribution": 0.04,
            "Fossil_abs": 1.30543891050103e-05,
            "Land_abs": 1.47571626331347e-05,
            "Fossil_fraction": 46.9387297333205,
            "Land_fraction": 53.0612702666809,
            "Rank": 109,
            "Perc_contribution_rescale": 0.145666423889294
        },
        {
            "Country": "Gambia",
            "Abs_contribution": 2.5474116511981e-05,
            "Perc_contribution": 0.03,
            "Fossil_abs": 1.00637061527945e-05,
            "Land_abs": 1.54104103591865e-05,
            "Fossil_fraction": 39.5056140536271,
            "Land_fraction": 60.4943859463729,
            "Rank": 110,
            "Perc_contribution_rescale": 0.10924981791697
        },
        {
            "Country": "Costa Rica",
            "Abs_contribution": 1.8239053222943e-05,
            "Perc_contribution": 0.02,
            "Fossil_abs": 3.11762011374432e-05,
            "Land_abs": -0.0000129371479145,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 111,
            "Perc_contribution_rescale": 0.0728332119446468
        },
        {
            "Country": "Guyana",
            "Abs_contribution": 1.41661288335399e-05,
            "Perc_contribution": 0.02,
            "Fossil_abs": 1.2760081510105e-06,
            "Land_abs": 1.28901206825292e-05,
            "Fossil_fraction": 9.00745832544886,
            "Land_fraction": 90.9925416745497,
            "Rank": 112,
            "Perc_contribution_rescale": 0.0728332119446468
        },
        {
            "Country": "Bhutan",
            "Abs_contribution": 1.37714402806113e-05,
            "Perc_contribution": 0.02,
            "Fossil_abs": 1.40597118371293e-05,
            "Land_abs": -0.000000288271556517901,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 113,
            "Perc_contribution_rescale": 0.0728332119446468
        },
        {
            "Country": "Croatia",
            "Abs_contribution": 1.2549749081745e-05,
            "Perc_contribution": 0.02,
            "Fossil_abs": 2.7617906288089e-05,
            "Land_abs": -0.0000150681572063438,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 114,
            "Perc_contribution_rescale": 0.0728332119446468
        },
        {
            "Country": "Djibouti",
            "Abs_contribution": 1.24425227005415e-05,
            "Perc_contribution": 0.02,
            "Fossil_abs": 8.7229283906234e-06,
            "Land_abs": 3.7195943099181e-06,
            "Fossil_fraction": 70.1057864274081,
            "Land_fraction": 29.8942135725919,
            "Rank": 115,
            "Perc_contribution_rescale": 0.0728332119446468
        },
        {
            "Country": "Ireland",
            "Abs_contribution": 1.1708020369508e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": -0.0000420728516058527,
            "Land_abs": 5.3780871975359e-05,
            "Fossil_fraction": 0,
            "Land_fraction": 100,
            "Rank": 116,
            "Perc_contribution_rescale": 0.0364166059723234
        },
        {
            "Country": "Cyprus",
            "Abs_contribution": 1.14321521732086e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 1.03305586996786e-05,
            "Land_abs": 1.10159347353e-06,
            "Fossil_fraction": 90.3640761875826,
            "Land_fraction": 9.6359238124174,
            "Rank": 117,
            "Perc_contribution_rescale": 0.0364166059723234
        },
        {
            "Country": "Belize",
            "Abs_contribution": 7.8027918505902e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 5.12835440872371e-06,
            "Land_abs": 2.67443744186645e-06,
            "Fossil_fraction": 65.7246086647282,
            "Land_fraction": 34.2753913352713,
            "Rank": 118,
            "Perc_contribution_rescale": 0.0364166059723234
        },
        {
            "Country": "Comoros",
            "Abs_contribution": 7.4535960018406e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 4.91253388480359e-06,
            "Land_abs": 2.54106211703698e-06,
            "Fossil_fraction": 65.9082392390261,
            "Land_fraction": 34.0917607609735,
            "Rank": 119,
            "Perc_contribution_rescale": 0.0364166059723234
        },
        {
            "Country": "Lesotho",
            "Abs_contribution": 6.96491257513591e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 8.5487608108093e-06,
            "Land_abs": -0.0000015838482356733,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 120,
            "Perc_contribution_rescale": 0.0364166059723234
        },
        {
            "Country": "Estonia",
            "Abs_contribution": 6.22694374944301e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 2.81222770928968e-05,
            "Land_abs": -0.0000218953333434539,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 121,
            "Perc_contribution_rescale": 0.0364166059723234
        },
        {
            "Country": "Cuba",
            "Abs_contribution": 5.34007734955195e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 2.9149131636243e-05,
            "Land_abs": -0.000023809054286689,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 122,
            "Perc_contribution_rescale": 0.0364166059723234
        },
        {
            "Country": "Suriname",
            "Abs_contribution": 4.7317829143154e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 6.917080057804e-06,
            "Land_abs": -0.0000021852971434886,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 123,
            "Perc_contribution_rescale": 0.0364166059723234
        },
        {
            "Country": "Bahamas",
            "Abs_contribution": 4.185165635238e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 4.1538938484412e-06,
            "Land_abs": 3.1271786796821e-08,
            "Fossil_fraction": 99.2527945242239,
            "Land_fraction": 0.747205475776651,
            "Rank": 124,
            "Perc_contribution_rescale": 0.0364166059723234
        },
        {
            "Country": "Mauritius",
            "Abs_contribution": 3.4304324054292e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 4.1518685280468e-06,
            "Land_abs": -0.00000072143612261753,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 125,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Maldives",
            "Abs_contribution": 3.25370152513008e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 3.25363851354722e-06,
            "Land_abs": 6.30115828662967e-11,
            "Fossil_fraction": 99.9980633877332,
            "Land_fraction": 0.00193661226697116,
            "Rank": 126,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Solomon Islands",
            "Abs_contribution": 3.23176696791279e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 2.82238046612726e-06,
            "Land_abs": 4.0938650178551e-07,
            "Fossil_fraction": 87.3324250835471,
            "Land_fraction": 12.6675749164522,
            "Rank": 127,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Vanuatu",
            "Abs_contribution": 3.1823754466514e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.78677465395087e-06,
            "Land_abs": 1.3956007927006e-06,
            "Fossil_fraction": 56.1459414171566,
            "Land_fraction": 43.8540585828457,
            "Rank": 128,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Cape Verde",
            "Abs_contribution": 2.11526084229759e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.64282240869338e-06,
            "Land_abs": 4.7243843360423e-07,
            "Fossil_fraction": 77.6652399478521,
            "Land_fraction": 22.3347600521489,
            "Rank": 129,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Iceland",
            "Abs_contribution": 1.9964254972269e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.9669469909572e-06,
            "Land_abs": 2.94785062696005e-08,
            "Fossil_fraction": 98.5234356949134,
            "Land_fraction": 1.47656430508161,
            "Rank": 130,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Malta",
            "Abs_contribution": 1.56734654454059e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 2.26652970001135e-06,
            "Land_abs": -0.00000069918315547074,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 131,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Macao",
            "Abs_contribution": 1.45556289404646e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.4499729677377e-06,
            "Land_abs": 5.589926308779e-09,
            "Fossil_fraction": 99.615961197443,
            "Land_fraction": 0.384038802558302,
            "Rank": 132,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Samoa",
            "Abs_contribution": 1.2332696565569e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 3.4350096994349e-07,
            "Land_abs": 8.8976868661339e-07,
            "Fossil_fraction": 27.8528680339458,
            "Land_fraction": 72.1471319660525,
            "Rank": 133,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Micronesia (Federated States of)",
            "Abs_contribution": 1.06506699950426e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.1525226196532e-08,
            "Land_abs": 1.05354177330773e-06,
            "Fossil_fraction": 1.08211278744872,
            "Land_fraction": 98.9178872125515,
            "Rank": 134,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Sao Tome and Principe",
            "Abs_contribution": 1.04495619863834e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.04181573765452e-06,
            "Land_abs": 3.140460983817e-09,
            "Fossil_fraction": 99.6994648208306,
            "Land_fraction": 0.300535179169162,
            "Rank": 135,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Seychelles",
            "Abs_contribution": 7.8239297187154e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 8.5698438747512e-07,
            "Land_abs": -0.0000000745914156035769,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 136,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Dominica",
            "Abs_contribution": 3.8031417058429e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 2.7493611402395e-07,
            "Land_abs": 1.0537805656035e-07,
            "Fossil_fraction": 72.2918406120803,
            "Land_fraction": 27.7081593879224,
            "Rank": 137,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Vincent and the Grenadines",
            "Abs_contribution": 3.6585297749427e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 4.6087740139628e-07,
            "Land_abs": -0.000000095024423902009,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 138,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Tonga",
            "Abs_contribution": 3.6522095489711e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 2.157751291233e-07,
            "Land_abs": 1.4944582577381e-07,
            "Fossil_fraction": 59.0807088777499,
            "Land_fraction": 40.9192911222501,
            "Rank": 139,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Kiribati",
            "Abs_contribution": 3.64765535437055e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 2.93185240902946e-07,
            "Land_abs": 7.1580294534105e-08,
            "Fossil_fraction": 80.3763547868241,
            "Land_fraction": 19.6236452131748,
            "Rank": 140,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Grenada",
            "Abs_contribution": 3.5669721988347e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 3.2304422476953e-07,
            "Land_abs": 3.3652995113922e-08,
            "Fossil_fraction": 90.5653890083769,
            "Land_fraction": 9.43461099161809,
            "Rank": 141,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Andorra",
            "Abs_contribution": 2.7309048552456e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 9.19959439546601e-08,
            "Land_abs": 1.810945415699e-07,
            "Fossil_fraction": 33.6869824585619,
            "Land_fraction": 66.3130175414382,
            "Rank": 142,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Turks and Caicos Islands",
            "Abs_contribution": 2.34378797574018e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 2.34077057967032e-07,
            "Land_abs": 3.017396069869e-10,
            "Fossil_fraction": 99.8712598536603,
            "Land_fraction": 0.128740146340075,
            "Rank": 143,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Greece",
            "Abs_contribution": 2.09849522832977e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 4.26905314454199e-06,
            "Land_abs": -0.00000405920362170898,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 144,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Kitts and Nevis",
            "Abs_contribution": 1.86746720120076e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 2.36781840594924e-07,
            "Land_abs": -0.000000050035120474848,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 145,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Cook Islands",
            "Abs_contribution": 9.1903370466886e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 3.9815679810747e-08,
            "Land_abs": 5.2087690656141e-08,
            "Fossil_fraction": 43.3234163322586,
            "Land_fraction": 56.6765836677436,
            "Rank": 146,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Tuvalu",
            "Abs_contribution": 8.3386530155933e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 4.1988039335698e-08,
            "Land_abs": 4.1398490820236e-08,
            "Fossil_fraction": 50.3535034461564,
            "Land_fraction": 49.6464965538447,
            "Rank": 147,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Nauru",
            "Abs_contribution": 4.9483184837023e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 4.23398147241959e-08,
            "Land_abs": 7.1433701128271e-09,
            "Fossil_fraction": 85.5640453694434,
            "Land_fraction": 14.4359546305566,
            "Rank": 148,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Lucia",
            "Abs_contribution": 4.64286714987e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 5.93963867634601e-08,
            "Land_abs": -0.0000000129677152647499,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 149,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Niue",
            "Abs_contribution": 6.4273180984774e-09,
            "Perc_contribution": 0,
            "Fossil_abs": -0.000000000495366980908704,
            "Land_abs": 6.9226850793862e-09,
            "Fossil_fraction": 0,
            "Land_fraction": 100,
            "Rank": 150,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Anguilla",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 151,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Antarctica",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 152,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Aruba",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 153,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Bermuda",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 154,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Bonaire, Saint Eustatius and Saba",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 155,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "British Virgin Islands",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 156,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Christmas Island",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 157,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Cura\xe7ao",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 158,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Faeroe Islands",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 159,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "French Polynesia",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 160,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Greenland",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 161,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Kosovo",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 162,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Kuwaiti Oil Fires",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 163,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Leeward Islands",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 164,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Marshall Islands",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 165,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Montserrat",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 166,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "New Caledonia",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 167,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Occupied Palestinian Territory",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 168,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Pacific Islands (Palau)",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 169,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Panama Canal Zone",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 170,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Ryukyu Islands",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 171,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Helena",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 172,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Pierre and Miquelon",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 173,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Sint Maarten (Dutch part)",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 174,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "St. Kitts-Nevis-Anguilla",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 175,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Wallis and Futuna Islands",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 176,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Liechtenstein",
            "Abs_contribution": -0.0000000180883976012901,
            "Perc_contribution": -0,
            "Fossil_abs": -0.000000017223075157961,
            "Land_abs": -0.000000000865322443330961,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 177,
            "Perc_contribution_rescale": -0
        },
        {
            "Country": "Fiji",
            "Abs_contribution": -0.0000001785103458115,
            "Perc_contribution": -0,
            "Fossil_abs": 5.0988353640284e-06,
            "Land_abs": -0.00000527734570984,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 178,
            "Perc_contribution_rescale": -0
        },
        {
            "Country": "Antigua and Barbuda",
            "Abs_contribution": -0.00000023836455634113,
            "Perc_contribution": -0,
            "Fossil_abs": 1.5266371189507e-07,
            "Land_abs": -0.000000391028268236205,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 179,
            "Perc_contribution_rescale": -0
        },
        {
            "Country": "Armenia",
            "Abs_contribution": -0.000000248777932413801,
            "Perc_contribution": -0,
            "Fossil_abs": -0.000002886488058051,
            "Land_abs": 2.6377101256373e-06,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 180,
            "Perc_contribution_rescale": -0
        },
        {
            "Country": "Barbados",
            "Abs_contribution": -0.000000662859014403739,
            "Perc_contribution": -0,
            "Fossil_abs": 1.28237255906789e-07,
            "Land_abs": -0.000000791096270310528,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 181,
            "Perc_contribution_rescale": -0
        },
        {
            "Country": "El Salvador",
            "Abs_contribution": -0.00000076304881525401,
            "Perc_contribution": -0,
            "Fossil_abs": 3.37875211024951e-06,
            "Land_abs": -0.0000041418009255031,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 182,
            "Perc_contribution_rescale": -0
        },
        {
            "Country": "Palau",
            "Abs_contribution": -0.00000204750245394594,
            "Perc_contribution": -0,
            "Fossil_abs": -0.00000221653823936286,
            "Land_abs": 1.69035785416921e-07,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 183,
            "Perc_contribution_rescale": -0
        },
        {
            "Country": "Luxembourg",
            "Abs_contribution": -0.0000023411801107472,
            "Perc_contribution": -0,
            "Fossil_abs": -0.00000224143050550131,
            "Land_abs": -0.0000000997496052457991,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 184,
            "Perc_contribution_rescale": -0
        },
        {
            "Country": "Swaziland",
            "Abs_contribution": -0.0000051432111130923,
            "Perc_contribution": -0.01,
            "Fossil_abs": -0.0000053596461891529,
            "Land_abs": 2.16435076060702e-07,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 185,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Montenegro",
            "Abs_contribution": -0.0000056765710270391,
            "Perc_contribution": -0.01,
            "Fossil_abs": 3.8146120327746e-06,
            "Land_abs": -0.0000094911830598138,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 186,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Jamaica",
            "Abs_contribution": -0.00000649510725349569,
            "Perc_contribution": -0.01,
            "Fossil_abs": 4.3565521280799e-06,
            "Land_abs": -0.0000108516593815759,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 187,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Georgia",
            "Abs_contribution": -0.000008100958434281,
            "Perc_contribution": -0.01,
            "Fossil_abs": -0.0000061913937776566,
            "Land_abs": -0.0000019095646566247,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 188,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "North Macedonia",
            "Abs_contribution": -0.0000088893706038605,
            "Perc_contribution": -0.01,
            "Fossil_abs": 3.9556910816976e-06,
            "Land_abs": -0.0000128450616855576,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 189,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Denmark",
            "Abs_contribution": -0.000015498396091696,
            "Perc_contribution": -0.02,
            "Fossil_abs": -0.000003285399786858,
            "Land_abs": -0.000012212996304837,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 190,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Switzerland",
            "Abs_contribution": -0.000018832704341611,
            "Perc_contribution": -0.02,
            "Fossil_abs": -0.0000062087098676215,
            "Land_abs": -0.00001262399447399,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 191,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Slovenia",
            "Abs_contribution": -0.000020679337354029,
            "Perc_contribution": -0.03,
            "Fossil_abs": -0.000011530713640092,
            "Land_abs": -0.0000091486237139367,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 192,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Belarus",
            "Abs_contribution": -0.000021860645737241,
            "Perc_contribution": -0.03,
            "Fossil_abs": 9.4549105701827e-05,
            "Land_abs": -0.000116409751439068,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 193,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Albania",
            "Abs_contribution": -0.000022937761848801,
            "Perc_contribution": -0.03,
            "Fossil_abs": -0.0000104288426530447,
            "Land_abs": -0.000012508919195756,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 194,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Latvia",
            "Abs_contribution": -0.000024458177006782,
            "Perc_contribution": -0.03,
            "Fossil_abs": 1.25142708597254e-05,
            "Land_abs": -0.0000369724478665074,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 195,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Portugal",
            "Abs_contribution": -0.000030734456124799,
            "Perc_contribution": -0.04,
            "Fossil_abs": -0.000029611005240389,
            "Land_abs": -0.00000112345088441201,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 196,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "North Korea",
            "Abs_contribution": -0.000032647876409422,
            "Perc_contribution": -0.04,
            "Fossil_abs": -0.000024592921268213,
            "Land_abs": -0.00000805495514120901,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 197,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Gabon",
            "Abs_contribution": -0.000037118849245307,
            "Perc_contribution": -0.05,
            "Fossil_abs": -0.00003997063013621,
            "Land_abs": 2.85178089090257e-06,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 198,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Moldova",
            "Abs_contribution": -0.0000401404837541006,
            "Perc_contribution": -0.05,
            "Fossil_abs": 5.17259101891269e-06,
            "Land_abs": -0.0000453130747730128,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 199,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Slovakia",
            "Abs_contribution": -0.000049210328118041,
            "Perc_contribution": -0.06,
            "Fossil_abs": 4.960155781985e-06,
            "Land_abs": -0.000054170483900026,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 200,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Australia",
            "Abs_contribution": -0.0000521041347065097,
            "Perc_contribution": -0.07,
            "Fossil_abs": 0.00030696297017691,
            "Land_abs": -0.000359067104883429,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 201,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Lithuania",
            "Abs_contribution": -0.000061490454137909,
            "Perc_contribution": -0.08,
            "Fossil_abs": 3.3642942384329e-06,
            "Land_abs": -0.0000648547483763412,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 202,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Sweden",
            "Abs_contribution": -0.000064048389150556,
            "Perc_contribution": -0.08,
            "Fossil_abs": -0.000043334226903856,
            "Land_abs": -0.000020714162246701,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 203,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Serbia",
            "Abs_contribution": -0.000079012372544537,
            "Perc_contribution": -0.1,
            "Fossil_abs": 1.3051820825034e-05,
            "Land_abs": -0.000092064193369573,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 204,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Belgium",
            "Abs_contribution": -0.000093394635143636,
            "Perc_contribution": -0.12,
            "Fossil_abs": -0.000058522879430755,
            "Land_abs": -0.000034871755712882,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 205,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Hungary",
            "Abs_contribution": -0.000102582136579621,
            "Perc_contribution": -0.13,
            "Fossil_abs": -0.00005909373599379,
            "Land_abs": -0.0000434884005858314,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 206,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Austria",
            "Abs_contribution": -0.000104513535131206,
            "Perc_contribution": -0.13,
            "Fossil_abs": -0.000072241126474136,
            "Land_abs": -0.000032272408657068,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 207,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Finland",
            "Abs_contribution": -0.000106342580445011,
            "Perc_contribution": -0.14,
            "Fossil_abs": -0.000082057672154172,
            "Land_abs": -0.000024284908290841,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 208,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Czechia",
            "Abs_contribution": -0.000133342921186032,
            "Perc_contribution": -0.17,
            "Fossil_abs": -0.000046672348966898,
            "Land_abs": -0.000086670572219133,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 209,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Bulgaria",
            "Abs_contribution": -0.00017560381372022,
            "Perc_contribution": -0.22,
            "Fossil_abs": -0.000103222388127791,
            "Land_abs": -0.0000723814255924293,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 210,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Romania",
            "Abs_contribution": -0.0002340738574337,
            "Perc_contribution": -0.3,
            "Fossil_abs": -0.000066523459213744,
            "Land_abs": -0.000167550398219959,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 211,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "France",
            "Abs_contribution": -0.00023729014814449,
            "Perc_contribution": -0.3,
            "Fossil_abs": -0.00010790811728716,
            "Land_abs": -0.00012938203085733,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 212,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Italy",
            "Abs_contribution": -0.00026772429414725,
            "Perc_contribution": -0.34,
            "Fossil_abs": -0.00018110635923103,
            "Land_abs": -0.000086617934916221,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 213,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Libya",
            "Abs_contribution": -0.00036749065794908,
            "Perc_contribution": -0.47,
            "Fossil_abs": -0.00038694622265358,
            "Land_abs": 1.94555647045081e-05,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 214,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Syria",
            "Abs_contribution": -0.000406765077378045,
            "Perc_contribution": -0.52,
            "Fossil_abs": -0.000446208562681447,
            "Land_abs": 3.9443485303401e-05,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 215,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Netherlands",
            "Abs_contribution": -0.0004103441342051,
            "Perc_contribution": -0.52,
            "Fossil_abs": -0.000378713901274863,
            "Land_abs": -0.000031630232930243,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 216,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Japan",
            "Abs_contribution": -0.00054436592990836,
            "Perc_contribution": -0.69,
            "Fossil_abs": -0.000455179565514086,
            "Land_abs": -0.0000891863643942799,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 217,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Ukraine",
            "Abs_contribution": -0.00103744596423575,
            "Perc_contribution": -1.32,
            "Fossil_abs": 8.472268096972e-05,
            "Land_abs": -0.00112216864520547,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 218,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Germany",
            "Abs_contribution": -0.00157337819601052,
            "Perc_contribution": -2,
            "Fossil_abs": -0.00124814752392144,
            "Land_abs": -0.00032523067208908,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 219,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Poland",
            "Abs_contribution": -0.00165760655482005,
            "Perc_contribution": -2.11,
            "Fossil_abs": -0.00146522457457292,
            "Land_abs": -0.000192381980247124,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 220,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "United States",
            "Abs_contribution": -0.001715086940969,
            "Perc_contribution": -2.18,
            "Fossil_abs": -0.0020175668228278,
            "Land_abs": 0.0003024798818587,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 221,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "United Kingdom",
            "Abs_contribution": -0.00230837136175942,
            "Perc_contribution": -2.93,
            "Fossil_abs": -0.00214279599304333,
            "Land_abs": -0.00016557536871608,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 222,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "EU27",
            "Abs_contribution": -0.0050637560701223,
            "Perc_contribution": -6.44,
            "Fossil_abs": -0.0037558240144818,
            "Land_abs": -0.00130793205564048,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 223,
            "Perc_contribution_rescale": 0
        }
    ],
    "2005_CO2": [
        {
            "Country": "China",
            "Abs_contribution": 0.0729238618019762,
            "Perc_contribution": 24.83,
            "Fossil_abs": 0.0725581532169762,
            "Land_abs": 0.000365708585000003,
            "Fossil_fraction": 99.4985062831792,
            "Land_fraction": 0.501493716820812,
            "Rank": 1,
            "Perc_contribution_rescale": 100
        },
        {
            "Country": "United States",
            "Abs_contribution": 0.040887444438284,
            "Perc_contribution": 13.92,
            "Fossil_abs": 0.041629654390284,
            "Land_abs": -0.000742209951999799,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 2,
            "Perc_contribution_rescale": 56.0612162706404
        },
        {
            "Country": "EU27",
            "Abs_contribution": 0.023151268657762,
            "Perc_contribution": 7.88,
            "Fossil_abs": 0.024365928967262,
            "Land_abs": -0.0012146603095,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 3,
            "Perc_contribution_rescale": 31.7358034635522
        },
        {
            "Country": "India",
            "Abs_contribution": 0.0162858505401583,
            "Perc_contribution": 5.55,
            "Fossil_abs": 0.0159617164551583,
            "Land_abs": 0.000324134085,
            "Fossil_fraction": 98.0097196385246,
            "Land_fraction": 1.99028036147537,
            "Rank": 4,
            "Perc_contribution_rescale": 22.351993556182
        },
        {
            "Country": "Russia",
            "Abs_contribution": 0.0130240507909866,
            "Perc_contribution": 4.43,
            "Fossil_abs": 0.0126535484444869,
            "Land_abs": 0.000370502346500001,
            "Fossil_fraction": 97.1552449199899,
            "Land_fraction": 2.84475508001251,
            "Rank": 5,
            "Perc_contribution_rescale": 17.8413209826822
        },
        {
            "Country": "Brazil",
            "Abs_contribution": 0.0129016255682353,
            "Perc_contribution": 4.39,
            "Fossil_abs": 0.00357974675473526,
            "Land_abs": 0.0093218788135,
            "Fossil_fraction": 27.7464784247719,
            "Land_fraction": 72.2535215752278,
            "Rank": 6,
            "Perc_contribution_rescale": 17.6802255336287
        },
        {
            "Country": "Indonesia",
            "Abs_contribution": 0.0106527667425878,
            "Perc_contribution": 3.63,
            "Fossil_abs": 0.00394962416458789,
            "Land_abs": 0.006703142578,
            "Fossil_fraction": 37.0760409950405,
            "Land_fraction": 62.9239590049604,
            "Rank": 7,
            "Perc_contribution_rescale": 14.619412001611
        },
        {
            "Country": "Japan",
            "Abs_contribution": 0.0090204230097975,
            "Perc_contribution": 3.07,
            "Fossil_abs": 0.0091614043777975,
            "Land_abs": -0.000140981368,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 8,
            "Perc_contribution_rescale": 12.3640757148611
        },
        {
            "Country": "Germany",
            "Abs_contribution": 0.0057736634133931,
            "Perc_contribution": 1.97,
            "Fossil_abs": 0.005984288190393,
            "Land_abs": -0.000210624777,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 9,
            "Perc_contribution_rescale": 7.93395086588804
        },
        {
            "Country": "Canada",
            "Abs_contribution": 0.0050324654107161,
            "Perc_contribution": 1.71,
            "Fossil_abs": 0.0043073455097161,
            "Land_abs": 0.000725119900999998,
            "Fossil_fraction": 85.5911597632458,
            "Land_fraction": 14.4088402367542,
            "Rank": 10,
            "Perc_contribution_rescale": 6.88683044703987
        },
        {
            "Country": "Iran",
            "Abs_contribution": 0.00463774469462442,
            "Perc_contribution": 1.58,
            "Fossil_abs": 0.00468765718362445,
            "Land_abs": -0.0000499124890000031,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 11,
            "Perc_contribution_rescale": 6.36327023761579
        },
        {
            "Country": "South Korea",
            "Abs_contribution": 0.00455948494658408,
            "Perc_contribution": 1.55,
            "Fossil_abs": 0.00462168325308406,
            "Land_abs": -0.0000621983065,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 12,
            "Perc_contribution_rescale": 6.24244865082562
        },
        {
            "Country": "Saudi Arabia",
            "Abs_contribution": 0.00443327773417249,
            "Perc_contribution": 1.51,
            "Fossil_abs": 0.00443772734967249,
            "Land_abs": -0.0000044496155,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 13,
            "Perc_contribution_rescale": 6.08135320177205
        },
        {
            "Country": "Mexico",
            "Abs_contribution": 0.00421945722269598,
            "Perc_contribution": 1.44,
            "Fossil_abs": 0.00364304936319596,
            "Land_abs": 0.0005764078595,
            "Fossil_fraction": 86.3392889398288,
            "Land_fraction": 13.6607110601707,
            "Rank": 14,
            "Perc_contribution_rescale": 5.79943616592831
        },
        {
            "Country": "Democratic Republic of the Congo",
            "Abs_contribution": 0.00398893525073473,
            "Perc_contribution": 1.36,
            "Fossil_abs": 2.46935352347163e-05,
            "Land_abs": 0.00396424171550002,
            "Fossil_fraction": 0.619050791314999,
            "Land_fraction": 99.3809492086851,
            "Rank": 15,
            "Perc_contribution_rescale": 5.47724526782119
        },
        {
            "Country": "South Africa",
            "Abs_contribution": 0.00351661748666434,
            "Perc_contribution": 1.2,
            "Fossil_abs": 0.0034736754446643,
            "Land_abs": 4.29420420000001e-05,
            "Fossil_fraction": 98.778882202489,
            "Land_fraction": 1.2211177975098,
            "Rank": 16,
            "Perc_contribution_rescale": 4.83286347160693
        },
        {
            "Country": "Australia",
            "Abs_contribution": 0.0035062850915972,
            "Perc_contribution": 1.19,
            "Fossil_abs": 0.00308229019609716,
            "Land_abs": 0.000423994895499991,
            "Fossil_fraction": 87.9075749853843,
            "Land_fraction": 12.0924250146143,
            "Rank": 17,
            "Perc_contribution_rescale": 4.79258960934354
        },
        {
            "Country": "United Kingdom",
            "Abs_contribution": 0.0034604355532063,
            "Perc_contribution": 1.18,
            "Fossil_abs": 0.0033765957587063,
            "Land_abs": 8.38397944999999e-05,
            "Fossil_fraction": 97.5771895412901,
            "Land_fraction": 2.42281045870996,
            "Rank": 18,
            "Perc_contribution_rescale": 4.75231574708015
        },
        {
            "Country": "Malaysia",
            "Abs_contribution": 0.00284105093763373,
            "Perc_contribution": 0.97,
            "Fossil_abs": 0.00176456511513373,
            "Land_abs": 0.00107648582249998,
            "Fossil_fraction": 62.1095909179091,
            "Land_fraction": 37.8904090820902,
            "Rank": 19,
            "Perc_contribution_rescale": 3.90656463954893
        },
        {
            "Country": "Italy",
            "Abs_contribution": 0.00276235604188424,
            "Perc_contribution": 0.94,
            "Fossil_abs": 0.00298141055338425,
            "Land_abs": -0.0002190545115,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 20,
            "Perc_contribution_rescale": 3.78574305275876
        },
        {
            "Country": "T\xfcrkiye",
            "Abs_contribution": 0.00268820746901145,
            "Perc_contribution": 0.92,
            "Fossil_abs": 0.00283555904701146,
            "Land_abs": -0.000147351578,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 21,
            "Perc_contribution_rescale": 3.70519532823198
        },
        {
            "Country": "Thailand",
            "Abs_contribution": 0.00244575740087719,
            "Perc_contribution": 0.83,
            "Fossil_abs": 0.00198234344987718,
            "Land_abs": 0.000463413951,
            "Fossil_fraction": 81.0523336928755,
            "Land_fraction": 18.9476663071241,
            "Rank": 22,
            "Perc_contribution_rescale": 3.34273056786146
        },
        {
            "Country": "Viet Nam",
            "Abs_contribution": 0.00243560382024291,
            "Perc_contribution": 0.83,
            "Fossil_abs": 0.00159275516524291,
            "Land_abs": 0.000842848655,
            "Fossil_fraction": 65.3946734688591,
            "Land_fraction": 34.6053265311409,
            "Rank": 23,
            "Perc_contribution_rescale": 3.34273056786146
        },
        {
            "Country": "France",
            "Abs_contribution": 0.0024174517375742,
            "Perc_contribution": 0.82,
            "Fossil_abs": 0.0026394540895742,
            "Land_abs": -0.000222002352000002,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 24,
            "Perc_contribution_rescale": 3.30245670559807
        },
        {
            "Country": "Argentina",
            "Abs_contribution": 0.00229070074741598,
            "Perc_contribution": 0.78,
            "Fossil_abs": 0.00141176119691593,
            "Land_abs": 0.00087893955050001,
            "Fossil_fraction": 61.630101553355,
            "Land_fraction": 38.3698984466433,
            "Rank": 25,
            "Perc_contribution_rescale": 3.1413612565445
        },
        {
            "Country": "Poland",
            "Abs_contribution": 0.0021999376901998,
            "Perc_contribution": 0.75,
            "Fossil_abs": 0.0024888656371998,
            "Land_abs": -0.000288927947,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 26,
            "Perc_contribution_rescale": 3.02053966975433
        },
        {
            "Country": "Kazakhstan",
            "Abs_contribution": 0.00218223479874563,
            "Perc_contribution": 0.74,
            "Fossil_abs": 0.00197081148774563,
            "Land_abs": 0.00021142331100001,
            "Fossil_fraction": 90.311614904064,
            "Land_fraction": 9.68838509593644,
            "Rank": 27,
            "Perc_contribution_rescale": 2.98026580749094
        },
        {
            "Country": "Taiwan",
            "Abs_contribution": 0.00210914453359716,
            "Perc_contribution": 0.72,
            "Fossil_abs": 0.00210914453359716,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 28,
            "Perc_contribution_rescale": 2.89971808296416
        },
        {
            "Country": "Ukraine",
            "Abs_contribution": 0.0020048437250316,
            "Perc_contribution": 0.68,
            "Fossil_abs": 0.0019942343185316,
            "Land_abs": 1.06094064999994e-05,
            "Fossil_fraction": 99.4708112972829,
            "Land_fraction": 0.529188702717076,
            "Rank": 29,
            "Perc_contribution_rescale": 2.73862263391059
        },
        {
            "Country": "Spain",
            "Abs_contribution": 0.00200432801125106,
            "Perc_contribution": 0.68,
            "Fossil_abs": 0.00212694907025109,
            "Land_abs": -0.000122621059,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 30,
            "Perc_contribution_rescale": 2.73862263391059
        },
        {
            "Country": "Egypt",
            "Abs_contribution": 0.001739456002619,
            "Perc_contribution": 0.59,
            "Fossil_abs": 0.001712271026119,
            "Land_abs": 2.71849765e-05,
            "Fossil_fraction": 98.4371564179221,
            "Land_fraction": 1.56284358207791,
            "Rank": 31,
            "Perc_contribution_rescale": 2.37615787354007
        },
        {
            "Country": "United Arab Emirates",
            "Abs_contribution": 0.00151856770909935,
            "Perc_contribution": 0.52,
            "Fossil_abs": 0.00152263773659935,
            "Land_abs": -0.00000407002749999999,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 32,
            "Perc_contribution_rescale": 2.09424083769634
        },
        {
            "Country": "Pakistan",
            "Abs_contribution": 0.00141794773074126,
            "Perc_contribution": 0.48,
            "Fossil_abs": 0.00134807810674127,
            "Land_abs": 6.9869624000002e-05,
            "Fossil_fraction": 95.0724823993713,
            "Land_fraction": 4.92751760062949,
            "Rank": 33,
            "Perc_contribution_rescale": 1.93314538864277
        },
        {
            "Country": "Venezuela",
            "Abs_contribution": 0.00135167482104152,
            "Perc_contribution": 0.46,
            "Fossil_abs": 0.00107178986954149,
            "Land_abs": 0.0002798849515,
            "Fossil_fraction": 79.2934700607675,
            "Land_fraction": 20.7065299392303,
            "Rank": 34,
            "Perc_contribution_rescale": 1.85259766411599
        },
        {
            "Country": "Tanzania",
            "Abs_contribution": 0.00128945180040557,
            "Perc_contribution": 0.44,
            "Fossil_abs": 7.53334389055675e-05,
            "Land_abs": 0.0012141183615,
            "Fossil_fraction": 5.84228420805438,
            "Land_fraction": 94.1577157919454,
            "Rank": 35,
            "Perc_contribution_rescale": 1.77204993958921
        },
        {
            "Country": "Netherlands",
            "Abs_contribution": 0.00128149372649345,
            "Perc_contribution": 0.44,
            "Fossil_abs": 0.00123136694099345,
            "Land_abs": 5.01267855e-05,
            "Fossil_fraction": 96.0884096064082,
            "Land_fraction": 3.91159039359185,
            "Rank": 36,
            "Perc_contribution_rescale": 1.77204993958921
        },
        {
            "Country": "Colombia",
            "Abs_contribution": 0.00123951895643391,
            "Perc_contribution": 0.42,
            "Fossil_abs": 0.000647082127933955,
            "Land_abs": 0.00059243682849998,
            "Fossil_fraction": 52.2042946237472,
            "Land_fraction": 47.7957053762548,
            "Rank": 37,
            "Perc_contribution_rescale": 1.69150221506242
        },
        {
            "Country": "Philippines",
            "Abs_contribution": 0.00119660805450931,
            "Perc_contribution": 0.41,
            "Fossil_abs": 0.00082206390650928,
            "Land_abs": 0.00037454414800003,
            "Fossil_fraction": 68.6995130453456,
            "Land_fraction": 31.3004869546543,
            "Rank": 38,
            "Perc_contribution_rescale": 1.65122835279903
        },
        {
            "Country": "Myanmar",
            "Abs_contribution": 0.001162191662518,
            "Perc_contribution": 0.4,
            "Fossil_abs": 0.000159285456018014,
            "Land_abs": 0.00100290620649998,
            "Fossil_fraction": 13.7056099398362,
            "Land_fraction": 86.2943900601634,
            "Rank": 39,
            "Perc_contribution_rescale": 1.61095449053564
        },
        {
            "Country": "Algeria",
            "Abs_contribution": 0.00111866966652129,
            "Perc_contribution": 0.38,
            "Fossil_abs": 0.00111541426052129,
            "Land_abs": 3.25540599999997e-06,
            "Fossil_fraction": 99.7089930926505,
            "Land_fraction": 0.291006907349446,
            "Rank": 40,
            "Perc_contribution_rescale": 1.53040676600886
        },
        {
            "Country": "Nigeria",
            "Abs_contribution": 0.00109111700478382,
            "Perc_contribution": 0.37,
            "Fossil_abs": 0.00084534667778384,
            "Land_abs": 0.000245770326999979,
            "Fossil_fraction": 77.4753462806976,
            "Land_fraction": 22.5246537193024,
            "Rank": 41,
            "Perc_contribution_rescale": 1.49013290374547
        },
        {
            "Country": "Iraq",
            "Abs_contribution": 0.00108695405628494,
            "Perc_contribution": 0.37,
            "Fossil_abs": 0.00106506136678493,
            "Land_abs": 2.18926895e-05,
            "Fossil_fraction": 97.9858679975089,
            "Land_fraction": 2.01413200249017,
            "Rank": 42,
            "Perc_contribution_rescale": 1.49013290374547
        },
        {
            "Country": "Angola",
            "Abs_contribution": 0.00104765871275328,
            "Perc_contribution": 0.36,
            "Fossil_abs": 0.000162382485753275,
            "Land_abs": 0.000885276227,
            "Fossil_fraction": 15.499559520345,
            "Land_fraction": 84.5004404796545,
            "Rank": 43,
            "Perc_contribution_rescale": 1.44985904148208
        },
        {
            "Country": "Uzbekistan",
            "Abs_contribution": 0.00086392569639738,
            "Perc_contribution": 0.29,
            "Fossil_abs": 0.00086886565889738,
            "Land_abs": -0.00000493996250000106,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 44,
            "Perc_contribution_rescale": 1.16794200563834
        },
        {
            "Country": "Belgium",
            "Abs_contribution": 0.0008103362546119,
            "Perc_contribution": 0.28,
            "Fossil_abs": 0.000796957510111889,
            "Land_abs": 1.33787445e-05,
            "Fossil_fraction": 98.3489885311353,
            "Land_fraction": 1.65101146886333,
            "Rank": 45,
            "Perc_contribution_rescale": 1.12766814337495
        },
        {
            "Country": "Ethiopia",
            "Abs_contribution": 0.00078117497877129,
            "Perc_contribution": 0.27,
            "Fossil_abs": 8.95459417712879e-05,
            "Land_abs": 0.000691629037,
            "Fossil_fraction": 11.4629813044108,
            "Land_fraction": 88.5370186955889,
            "Rank": 46,
            "Perc_contribution_rescale": 1.08739428111156
        },
        {
            "Country": "Peru",
            "Abs_contribution": 0.00074295821127456,
            "Perc_contribution": 0.25,
            "Fossil_abs": 0.000358146146274563,
            "Land_abs": 0.000384812065,
            "Fossil_fraction": 48.2054227060975,
            "Land_fraction": 51.7945772939028,
            "Rank": 47,
            "Perc_contribution_rescale": 1.00684655658478
        },
        {
            "Country": "Czechia",
            "Abs_contribution": 0.00072710083502732,
            "Perc_contribution": 0.25,
            "Fossil_abs": 0.00083809100002729,
            "Land_abs": -0.000110990165,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 48,
            "Perc_contribution_rescale": 1.00684655658478
        },
        {
            "Country": "Kuwait",
            "Abs_contribution": 0.000719197231908295,
            "Perc_contribution": 0.24,
            "Fossil_abs": 0.000719096273908295,
            "Land_abs": 1.00958e-07,
            "Fossil_fraction": 99.9859624042584,
            "Land_fraction": 0.0140375957415911,
            "Rank": 49,
            "Perc_contribution_rescale": 0.966572694321385
        },
        {
            "Country": "Chile",
            "Abs_contribution": 0.00069083224424236,
            "Perc_contribution": 0.24,
            "Fossil_abs": 0.00060325270824236,
            "Land_abs": 8.7579536e-05,
            "Fossil_fraction": 87.3226044774374,
            "Land_fraction": 12.6773955225626,
            "Rank": 50,
            "Perc_contribution_rescale": 0.966572694321385
        },
        {
            "Country": "Qatar",
            "Abs_contribution": 0.000654941252300767,
            "Perc_contribution": 0.22,
            "Fossil_abs": 0.000654856607300767,
            "Land_abs": 8.4645e-08,
            "Fossil_fraction": 99.987075940063,
            "Land_fraction": 0.0129240599370779,
            "Rank": 51,
            "Perc_contribution_rescale": 0.886024969794603
        },
        {
            "Country": "Bolivia",
            "Abs_contribution": 0.00062716569205732,
            "Perc_contribution": 0.21,
            "Fossil_abs": 0.000138403935057314,
            "Land_abs": 0.000488761757,
            "Fossil_fraction": 22.0681610633549,
            "Land_fraction": 77.9318389366441,
            "Rank": 52,
            "Perc_contribution_rescale": 0.845751107531212
        },
        {
            "Country": "Paraguay",
            "Abs_contribution": 0.00060078485020851,
            "Perc_contribution": 0.2,
            "Fossil_abs": 4.77992742085153e-05,
            "Land_abs": 0.000552985576,
            "Fossil_fraction": 7.95613840660695,
            "Land_fraction": 92.0438615933939,
            "Rank": 53,
            "Perc_contribution_rescale": 0.805477245267821
        },
        {
            "Country": "Greece",
            "Abs_contribution": 0.00058014729707096,
            "Perc_contribution": 0.2,
            "Fossil_abs": 0.00063832954757096,
            "Land_abs": -0.0000581822505,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 54,
            "Perc_contribution_rescale": 0.805477245267821
        },
        {
            "Country": "Bangladesh",
            "Abs_contribution": 0.00057579688970633,
            "Perc_contribution": 0.2,
            "Fossil_abs": 0.000533986071206332,
            "Land_abs": 4.18108185e-05,
            "Fossil_fraction": 92.7386168200175,
            "Land_fraction": 7.26138317998287,
            "Rank": 55,
            "Perc_contribution_rescale": 0.805477245267821
        },
        {
            "Country": "Romania",
            "Abs_contribution": 0.00057548569063374,
            "Perc_contribution": 0.2,
            "Fossil_abs": 0.00065500487763374,
            "Land_abs": -0.000079519186999998,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 56,
            "Perc_contribution_rescale": 0.805477245267821
        },
        {
            "Country": "C\xf4te d'Ivoire",
            "Abs_contribution": 0.00053945423067358,
            "Perc_contribution": 0.18,
            "Fossil_abs": 7.01128636735812e-05,
            "Land_abs": 0.000469341367,
            "Fossil_fraction": 12.9969995018921,
            "Land_fraction": 87.0030004981081,
            "Rank": 57,
            "Perc_contribution_rescale": 0.724929520741039
        },
        {
            "Country": "Turkmenistan",
            "Abs_contribution": 0.00050163389665611,
            "Perc_contribution": 0.17,
            "Fossil_abs": 0.000477278939656111,
            "Land_abs": 2.43549570000001e-05,
            "Fossil_fraction": 95.14487414779,
            "Land_fraction": 4.85512585221017,
            "Rank": 58,
            "Perc_contribution_rescale": 0.684655658477648
        },
        {
            "Country": "Finland",
            "Abs_contribution": 0.00049870003784061,
            "Perc_contribution": 0.17,
            "Fossil_abs": 0.00038591896834062,
            "Land_abs": 0.000112781069500003,
            "Fossil_fraction": 77.3849887823678,
            "Land_fraction": 22.6150112176348,
            "Rank": 59,
            "Perc_contribution_rescale": 0.684655658477648
        },
        {
            "Country": "Belarus",
            "Abs_contribution": 0.00049785796991757,
            "Perc_contribution": 0.17,
            "Fossil_abs": 0.00046780548041757,
            "Land_abs": 3.00524895e-05,
            "Fossil_fraction": 93.9636419790617,
            "Land_fraction": 6.03635802093834,
            "Rank": 60,
            "Perc_contribution_rescale": 0.684655658477648
        },
        {
            "Country": "Sudan",
            "Abs_contribution": 0.00048779106707369,
            "Perc_contribution": 0.17,
            "Fossil_abs": 0.00013661164507369,
            "Land_abs": 0.000351179421999999,
            "Fossil_fraction": 28.0061801650525,
            "Land_fraction": 71.9938198349472,
            "Rank": 61,
            "Perc_contribution_rescale": 0.684655658477648
        },
        {
            "Country": "Israel",
            "Abs_contribution": 0.000481685958442692,
            "Perc_contribution": 0.16,
            "Fossil_abs": 0.000477385552442689,
            "Land_abs": 4.300406e-06,
            "Fossil_fraction": 99.1072179031528,
            "Land_fraction": 0.892782096846536,
            "Rank": 62,
            "Perc_contribution_rescale": 0.644381796214257
        },
        {
            "Country": "Austria",
            "Abs_contribution": 0.00047496176655131,
            "Perc_contribution": 0.16,
            "Fossil_abs": 0.00052249910805131,
            "Land_abs": -0.0000475373415,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 63,
            "Perc_contribution_rescale": 0.644381796214257
        },
        {
            "Country": "Zambia",
            "Abs_contribution": 0.00046567419601855,
            "Perc_contribution": 0.16,
            "Fossil_abs": 3.99210880185592e-05,
            "Land_abs": 0.000425753108,
            "Fossil_fraction": 8.57275072569599,
            "Land_fraction": 91.427249274306,
            "Rank": 64,
            "Perc_contribution_rescale": 0.644381796214257
        },
        {
            "Country": "Oman",
            "Abs_contribution": 0.000457821288344975,
            "Perc_contribution": 0.16,
            "Fossil_abs": 0.000456924936844978,
            "Land_abs": 8.96351500000001e-07,
            "Fossil_fraction": 99.8042136696532,
            "Land_fraction": 0.195786330347441,
            "Rank": 65,
            "Perc_contribution_rescale": 0.644381796214257
        },
        {
            "Country": "Ecuador",
            "Abs_contribution": 0.00044898175375654,
            "Perc_contribution": 0.15,
            "Fossil_abs": 0.00028630615275655,
            "Land_abs": 0.000162675601,
            "Fossil_fraction": 63.7678815143564,
            "Land_fraction": 36.2321184856459,
            "Rank": 66,
            "Perc_contribution_rescale": 0.604107933950866
        },
        {
            "Country": "Sweden",
            "Abs_contribution": 0.00044841804116376,
            "Perc_contribution": 0.15,
            "Fossil_abs": 0.00034591942516376,
            "Land_abs": 0.000102498616000003,
            "Fossil_fraction": 77.1421739112036,
            "Land_fraction": 22.8578260887972,
            "Rank": 67,
            "Perc_contribution_rescale": 0.604107933950866
        },
        {
            "Country": "Morocco",
            "Abs_contribution": 0.000446604691097707,
            "Perc_contribution": 0.15,
            "Fossil_abs": 0.000446762865597708,
            "Land_abs": -0.00000015817449999908,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 68,
            "Perc_contribution_rescale": 0.604107933950866
        },
        {
            "Country": "Libya",
            "Abs_contribution": 0.00042093044687609,
            "Perc_contribution": 0.14,
            "Fossil_abs": 0.000427209510876088,
            "Land_abs": -0.00000627906399999998,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 69,
            "Perc_contribution_rescale": 0.563834071687475
        },
        {
            "Country": "North Korea",
            "Abs_contribution": 0.00041918389558297,
            "Perc_contribution": 0.14,
            "Fossil_abs": 0.00036079640158297,
            "Land_abs": 5.8387494e-05,
            "Fossil_fraction": 86.0711504866381,
            "Land_fraction": 13.9288495133619,
            "Rank": 70,
            "Perc_contribution_rescale": 0.563834071687475
        },
        {
            "Country": "Laos",
            "Abs_contribution": 0.000387724645396289,
            "Perc_contribution": 0.13,
            "Fossil_abs": 8.03266698962882e-05,
            "Land_abs": 0.000307397975500003,
            "Fossil_fraction": 20.7174526690681,
            "Land_fraction": 79.2825473309325,
            "Rank": 71,
            "Perc_contribution_rescale": 0.523560209424084
        },
        {
            "Country": "Mozambique",
            "Abs_contribution": 0.00038044873159061,
            "Perc_contribution": 0.13,
            "Fossil_abs": 3.92178745906113e-05,
            "Land_abs": 0.000341230857,
            "Fossil_fraction": 10.3083205000175,
            "Land_fraction": 89.6916794999829,
            "Rank": 72,
            "Perc_contribution_rescale": 0.523560209424084
        },
        {
            "Country": "Portugal",
            "Abs_contribution": 0.000363531632497809,
            "Perc_contribution": 0.12,
            "Fossil_abs": 0.000393903121997819,
            "Land_abs": -0.0000303714895000003,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 73,
            "Perc_contribution_rescale": 0.483286347160693
        },
        {
            "Country": "Norway",
            "Abs_contribution": 0.00036072602713756,
            "Perc_contribution": 0.12,
            "Fossil_abs": 0.00033588037663756,
            "Land_abs": 2.48456505e-05,
            "Fossil_fraction": 93.1123210883463,
            "Land_fraction": 6.88767891165372,
            "Rank": 74,
            "Perc_contribution_rescale": 0.483286347160693
        },
        {
            "Country": "Singapore",
            "Abs_contribution": 0.00035654467741594,
            "Perc_contribution": 0.12,
            "Fossil_abs": 0.000355656834415939,
            "Land_abs": 8.8784300000001e-07,
            "Fossil_fraction": 99.7509868871313,
            "Land_fraction": 0.249013112868395,
            "Rank": 75,
            "Perc_contribution_rescale": 0.483286347160693
        },
        {
            "Country": "Hungary",
            "Abs_contribution": 0.00032563694154858,
            "Perc_contribution": 0.11,
            "Fossil_abs": 0.00038115921054858,
            "Land_abs": -0.0000555222689999999,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 76,
            "Perc_contribution_rescale": 0.443012484897302
        },
        {
            "Country": "Trinidad and Tobago",
            "Abs_contribution": 0.000322181784699238,
            "Perc_contribution": 0.11,
            "Fossil_abs": 0.000325164192699235,
            "Land_abs": -0.000002982408,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 77,
            "Perc_contribution_rescale": 0.443012484897302
        },
        {
            "Country": "Denmark",
            "Abs_contribution": 0.00031944490582587,
            "Perc_contribution": 0.11,
            "Fossil_abs": 0.00030899574182587,
            "Land_abs": 1.0449164e-05,
            "Fossil_fraction": 96.7289620809619,
            "Land_fraction": 3.27103791903817,
            "Rank": 78,
            "Perc_contribution_rescale": 0.443012484897302
        },
        {
            "Country": "Bulgaria",
            "Abs_contribution": 0.00031902101324236,
            "Perc_contribution": 0.11,
            "Fossil_abs": 0.00035838775824236,
            "Land_abs": -0.000039366745,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 79,
            "Perc_contribution_rescale": 0.443012484897302
        },
        {
            "Country": "Syria",
            "Abs_contribution": 0.000317571505390828,
            "Perc_contribution": 0.11,
            "Fossil_abs": 0.00031914339989083,
            "Land_abs": -0.00000157189450000002,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 80,
            "Perc_contribution_rescale": 0.443012484897302
        },
        {
            "Country": "Hong Kong",
            "Abs_contribution": 0.000313045075095524,
            "Perc_contribution": 0.11,
            "Fossil_abs": 0.000313045075095524,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 81,
            "Perc_contribution_rescale": 0.443012484897302
        },
        {
            "Country": "Cameroon",
            "Abs_contribution": 0.00031177149735316,
            "Perc_contribution": 0.11,
            "Fossil_abs": 6.65042168531659e-05,
            "Land_abs": 0.0002452672805,
            "Fossil_fraction": 21.3310765794068,
            "Land_fraction": 78.668923420595,
            "Rank": 82,
            "Perc_contribution_rescale": 0.443012484897302
        },
        {
            "Country": "Papua New Guinea",
            "Abs_contribution": 0.000308711491954693,
            "Perc_contribution": 0.11,
            "Fossil_abs": 4.90242564546943e-05,
            "Land_abs": 0.000259687235499998,
            "Fossil_fraction": 15.8802823128752,
            "Land_fraction": 84.1197176871246,
            "Rank": 83,
            "Perc_contribution_rescale": 0.443012484897302
        },
        {
            "Country": "Cambodia",
            "Abs_contribution": 0.00030736838404094,
            "Perc_contribution": 0.1,
            "Fossil_abs": 7.49020125409388e-05,
            "Land_abs": 0.0002324663715,
            "Fossil_fraction": 24.3688083843269,
            "Land_fraction": 75.6311916156727,
            "Rank": 84,
            "Perc_contribution_rescale": 0.402738622633911
        },
        {
            "Country": "Switzerland",
            "Abs_contribution": 0.00029852059497926,
            "Perc_contribution": 0.1,
            "Fossil_abs": 0.00030744914647926,
            "Land_abs": -0.0000089285515000001,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 85,
            "Perc_contribution_rescale": 0.402738622633911
        },
        {
            "Country": "Serbia",
            "Abs_contribution": 0.00029715390668014,
            "Perc_contribution": 0.1,
            "Fossil_abs": 0.000357454185180135,
            "Land_abs": -0.0000603002785,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 86,
            "Perc_contribution_rescale": 0.402738622633911
        },
        {
            "Country": "Ireland",
            "Abs_contribution": 0.000283421165878276,
            "Perc_contribution": 0.1,
            "Fossil_abs": 0.000307565676378275,
            "Land_abs": -0.0000241445105,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 87,
            "Perc_contribution_rescale": 0.402738622633911
        },
        {
            "Country": "Azerbaijan",
            "Abs_contribution": 0.00028118888357423,
            "Perc_contribution": 0.1,
            "Fossil_abs": 0.000258492539574231,
            "Land_abs": 2.2696344e-05,
            "Fossil_fraction": 91.9284348259069,
            "Land_fraction": 8.07156517409355,
            "Rank": 88,
            "Perc_contribution_rescale": 0.402738622633911
        },
        {
            "Country": "Kenya",
            "Abs_contribution": 0.000272321289036571,
            "Perc_contribution": 0.09,
            "Fossil_abs": 0.000121967569036572,
            "Land_abs": 0.000150353720000001,
            "Fossil_fraction": 44.7881138739001,
            "Land_fraction": 55.2118861261006,
            "Rank": 89,
            "Perc_contribution_rescale": 0.36246476037052
        },
        {
            "Country": "Slovakia",
            "Abs_contribution": 0.00026279811909279,
            "Perc_contribution": 0.09,
            "Fossil_abs": 0.00027914162759279,
            "Land_abs": -0.0000163435085,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 90,
            "Perc_contribution_rescale": 0.36246476037052
        },
        {
            "Country": "Guatemala",
            "Abs_contribution": 0.00025032401479094,
            "Perc_contribution": 0.09,
            "Fossil_abs": 0.000113312156290939,
            "Land_abs": 0.0001370118585,
            "Fossil_fraction": 45.2661948497321,
            "Land_fraction": 54.7338051502676,
            "Rank": 91,
            "Perc_contribution_rescale": 0.36246476037052
        },
        {
            "Country": "Bahrain",
            "Abs_contribution": 0.000239155035625,
            "Perc_contribution": 0.08,
            "Fossil_abs": 0.000239159765625,
            "Land_abs": -0.00000000473000000000011,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 92,
            "Perc_contribution_rescale": 0.322190898107129
        },
        {
            "Country": "Madagascar",
            "Abs_contribution": 0.0002360973016965,
            "Perc_contribution": 0.08,
            "Fossil_abs": 2.32132951965066e-05,
            "Land_abs": 0.0002128840065,
            "Fossil_fraction": 9.83208830838185,
            "Land_fraction": 90.1679116916208,
            "Rank": 93,
            "Perc_contribution_rescale": 0.322190898107129
        },
        {
            "Country": "Nicaragua",
            "Abs_contribution": 0.00023457710304148,
            "Perc_contribution": 0.08,
            "Fossil_abs": 3.75376945414847e-05,
            "Land_abs": 0.0001970394085,
            "Fossil_fraction": 16.0022841337788,
            "Land_fraction": 83.9977158662231,
            "Rank": 94,
            "Perc_contribution_rescale": 0.322190898107129
        },
        {
            "Country": "Tunisia",
            "Abs_contribution": 0.000231931502078054,
            "Perc_contribution": 0.08,
            "Fossil_abs": 0.000222309626078056,
            "Land_abs": 9.62187600000002e-06,
            "Fossil_fraction": 95.8514147867848,
            "Land_fraction": 4.14858521321605,
            "Rank": 95,
            "Perc_contribution_rescale": 0.322190898107129
        },
        {
            "Country": "Chad",
            "Abs_contribution": 0.000222873836498908,
            "Perc_contribution": 0.08,
            "Fossil_abs": 1.41959109989083e-05,
            "Land_abs": 0.0002086779255,
            "Fossil_fraction": 6.36948294241699,
            "Land_fraction": 93.6305170575831,
            "Rank": 96,
            "Perc_contribution_rescale": 0.322190898107129
        },
        {
            "Country": "Sri Lanka",
            "Abs_contribution": 0.000208537213139738,
            "Perc_contribution": 0.07,
            "Fossil_abs": 0.000130364767139738,
            "Land_abs": 7.8172446e-05,
            "Fossil_fraction": 62.5139106718484,
            "Land_fraction": 37.4860893281516,
            "Rank": 97,
            "Perc_contribution_rescale": 0.281917035843738
        },
        {
            "Country": "Ghana",
            "Abs_contribution": 0.000207431698254914,
            "Perc_contribution": 0.07,
            "Fossil_abs": 0.000100852956754912,
            "Land_abs": 0.000106578741500001,
            "Fossil_fraction": 48.6198385316085,
            "Land_fraction": 51.3801614683913,
            "Rank": 98,
            "Perc_contribution_rescale": 0.281917035843738
        },
        {
            "Country": "Mongolia",
            "Abs_contribution": 0.00020510953332369,
            "Perc_contribution": 0.07,
            "Fossil_abs": 0.00021537913882369,
            "Land_abs": -0.0000102696055,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 99,
            "Perc_contribution_rescale": 0.281917035843738
        },
        {
            "Country": "Uganda",
            "Abs_contribution": 0.00018491417442194,
            "Perc_contribution": 0.06,
            "Fossil_abs": 3.30154989219432e-05,
            "Land_abs": 0.0001518986755,
            "Fossil_fraction": 17.8544987290201,
            "Land_fraction": 82.1455012709816,
            "Rank": 100,
            "Perc_contribution_rescale": 0.241643173580346
        },
        {
            "Country": "Jordan",
            "Abs_contribution": 0.000178867586763646,
            "Perc_contribution": 0.06,
            "Fossil_abs": 0.000176550568763646,
            "Land_abs": 2.317018e-06,
            "Fossil_fraction": 98.7046182922669,
            "Land_fraction": 1.29538170773315,
            "Rank": 101,
            "Perc_contribution_rescale": 0.241643173580346
        },
        {
            "Country": "Zimbabwe",
            "Abs_contribution": 0.000178333179888096,
            "Perc_contribution": 0.06,
            "Fossil_abs": 7.55806398881e-05,
            "Land_abs": 0.000102752539999997,
            "Fossil_fraction": 42.3817036939098,
            "Land_fraction": 57.6182963060908,
            "Rank": 102,
            "Perc_contribution_rescale": 0.241643173580346
        },
        {
            "Country": "Benin",
            "Abs_contribution": 0.000172412543953057,
            "Perc_contribution": 0.06,
            "Fossil_abs": 4.32387354530568e-05,
            "Land_abs": 0.0001291738085,
            "Fossil_fraction": 25.078648259392,
            "Land_fraction": 74.9213517406079,
            "Rank": 103,
            "Perc_contribution_rescale": 0.241643173580346
        },
        {
            "Country": "Lebanon",
            "Abs_contribution": 0.000171508229912118,
            "Perc_contribution": 0.06,
            "Fossil_abs": 0.000169836372912118,
            "Land_abs": 1.67185700000002e-06,
            "Fossil_fraction": 99.025203046608,
            "Land_fraction": 0.974796953392085,
            "Rank": 104,
            "Perc_contribution_rescale": 0.241643173580346
        },
        {
            "Country": "Bosnia and Herzegovina",
            "Abs_contribution": 0.000159260882966702,
            "Perc_contribution": 0.05,
            "Fossil_abs": 0.000157276372966703,
            "Land_abs": 1.98451000000001e-06,
            "Fossil_fraction": 98.7539250297803,
            "Land_fraction": 1.24607497022036,
            "Rank": 105,
            "Perc_contribution_rescale": 0.201369311316955
        },
        {
            "Country": "Dominican Republic",
            "Abs_contribution": 0.000158887429400109,
            "Perc_contribution": 0.05,
            "Fossil_abs": 0.000172305443900109,
            "Land_abs": -0.0000134180145,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 106,
            "Perc_contribution_rescale": 0.201369311316955
        },
        {
            "Country": "Cuba",
            "Abs_contribution": 0.00015802510292958,
            "Perc_contribution": 0.05,
            "Fossil_abs": 0.000202740971929586,
            "Land_abs": -0.0000447158690000001,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 107,
            "Perc_contribution_rescale": 0.201369311316955
        },
        {
            "Country": "Burkina Faso",
            "Abs_contribution": 0.000151865988825873,
            "Perc_contribution": 0.05,
            "Fossil_abs": 2.64637668258734e-05,
            "Land_abs": 0.000125402222,
            "Fossil_fraction": 17.4257363551073,
            "Land_fraction": 82.5742636448929,
            "Rank": 108,
            "Perc_contribution_rescale": 0.201369311316955
        },
        {
            "Country": "Congo",
            "Abs_contribution": 0.000141512102616808,
            "Perc_contribution": 0.05,
            "Fossil_abs": 4.41839981168123e-05,
            "Land_abs": 9.73281045000011e-05,
            "Fossil_fraction": 31.2227698548551,
            "Land_fraction": 68.7772301451487,
            "Rank": 109,
            "Perc_contribution_rescale": 0.201369311316955
        },
        {
            "Country": "Panama",
            "Abs_contribution": 0.0001408438450393,
            "Perc_contribution": 0.05,
            "Fossil_abs": 7.71635415393018e-05,
            "Land_abs": 6.3680303499998e-05,
            "Fossil_fraction": 54.7865911483535,
            "Land_fraction": 45.2134088516464,
            "Rank": 110,
            "Perc_contribution_rescale": 0.201369311316955
        },
        {
            "Country": "Guinea",
            "Abs_contribution": 0.00013945547175327,
            "Perc_contribution": 0.05,
            "Fossil_abs": 2.23255357532751e-05,
            "Land_abs": 0.000117129936,
            "Fossil_fraction": 16.0090783621415,
            "Land_fraction": 83.9909216378622,
            "Rank": 111,
            "Perc_contribution_rescale": 0.201369311316955
        },
        {
            "Country": "Yemen",
            "Abs_contribution": 0.00013878728785535,
            "Perc_contribution": 0.05,
            "Fossil_abs": 0.000140416519855349,
            "Land_abs": -0.000001629232,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 112,
            "Perc_contribution_rescale": 0.201369311316955
        },
        {
            "Country": "Honduras",
            "Abs_contribution": 0.00013645232629148,
            "Perc_contribution": 0.05,
            "Fossil_abs": 7.21883132914843e-05,
            "Land_abs": 6.4264013e-05,
            "Fossil_fraction": 52.9036882356117,
            "Land_fraction": 47.0963117643913,
            "Rank": 113,
            "Perc_contribution_rescale": 0.201369311316955
        },
        {
            "Country": "Sierra Leone",
            "Abs_contribution": 0.00013565257118941,
            "Perc_contribution": 0.05,
            "Fossil_abs": 6.7319166894105e-06,
            "Land_abs": 0.000128920654499999,
            "Fossil_fraction": 4.96261635911848,
            "Land_fraction": 95.0373836408812,
            "Rank": 114,
            "Perc_contribution_rescale": 0.201369311316955
        },
        {
            "Country": "Slovenia",
            "Abs_contribution": 0.000128190485902291,
            "Perc_contribution": 0.04,
            "Fossil_abs": 0.000115365321902292,
            "Land_abs": 1.28251639999998e-05,
            "Fossil_fraction": 89.9952294355335,
            "Land_fraction": 10.0047705644671,
            "Rank": 115,
            "Perc_contribution_rescale": 0.161095449053564
        },
        {
            "Country": "Lithuania",
            "Abs_contribution": 0.00012651719023799,
            "Perc_contribution": 0.04,
            "Fossil_abs": 0.000104413289737991,
            "Land_abs": 2.2103900499998e-05,
            "Fossil_fraction": 82.528935033714,
            "Land_fraction": 17.4710649662853,
            "Rank": 116,
            "Perc_contribution_rescale": 0.161095449053564
        },
        {
            "Country": "Liberia",
            "Abs_contribution": 0.000125333888787121,
            "Perc_contribution": 0.04,
            "Fossil_abs": 5.5709322871179e-06,
            "Land_abs": 0.000119762956500003,
            "Fossil_fraction": 4.44487308343245,
            "Land_fraction": 95.5551269165675,
            "Rank": 117,
            "Perc_contribution_rescale": 0.161095449053564
        },
        {
            "Country": "Estonia",
            "Abs_contribution": 0.000125209171987991,
            "Perc_contribution": 0.04,
            "Fossil_abs": 0.000123862458487991,
            "Land_abs": 1.34671349999999e-06,
            "Fossil_fraction": 98.9244290345366,
            "Land_fraction": 1.07557096546342,
            "Rank": 118,
            "Perc_contribution_rescale": 0.161095449053564
        },
        {
            "Country": "Croatia",
            "Abs_contribution": 0.000122656211301307,
            "Perc_contribution": 0.04,
            "Fossil_abs": 0.00014984021430131,
            "Land_abs": -0.000027184003,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 119,
            "Perc_contribution_rescale": 0.161095449053564
        },
        {
            "Country": "Malawi",
            "Abs_contribution": 0.000122451233566595,
            "Perc_contribution": 0.04,
            "Fossil_abs": 9.8970665665939e-06,
            "Land_abs": 0.000112554167000002,
            "Fossil_fraction": 8.08245558523622,
            "Land_fraction": 91.9175444147645,
            "Rank": 120,
            "Perc_contribution_rescale": 0.161095449053564
        },
        {
            "Country": "Somalia",
            "Abs_contribution": 0.000122202410114083,
            "Perc_contribution": 0.04,
            "Fossil_abs": 4.745625614083e-06,
            "Land_abs": 0.0001174567845,
            "Fossil_fraction": 3.88341409114001,
            "Land_fraction": 96.11658590886,
            "Rank": 121,
            "Perc_contribution_rescale": 0.161095449053564
        },
        {
            "Country": "Niger",
            "Abs_contribution": 0.000111571638071509,
            "Perc_contribution": 0.04,
            "Fossil_abs": 1.42359545715065e-05,
            "Land_abs": 9.73356835000031e-05,
            "Fossil_fraction": 12.7594743767967,
            "Land_fraction": 87.2405256232039,
            "Rank": 122,
            "Perc_contribution_rescale": 0.161095449053564
        },
        {
            "Country": "Botswana",
            "Abs_contribution": 0.000107460728939411,
            "Perc_contribution": 0.04,
            "Fossil_abs": 4.28547479394105e-05,
            "Land_abs": 6.4605981e-05,
            "Fossil_fraction": 39.8794502534717,
            "Land_fraction": 60.1205497465278,
            "Rank": 123,
            "Perc_contribution_rescale": 0.161095449053564
        },
        {
            "Country": "Nepal",
            "Abs_contribution": 0.00010582468867194,
            "Perc_contribution": 0.04,
            "Fossil_abs": 6.55928926719432e-05,
            "Land_abs": 4.0231795999997e-05,
            "Fossil_fraction": 61.9825992356882,
            "Land_fraction": 38.0174007643121,
            "Rank": 124,
            "Perc_contribution_rescale": 0.161095449053564
        },
        {
            "Country": "Senegal",
            "Abs_contribution": 9.949762909607e-05,
            "Perc_contribution": 0.03,
            "Fossil_abs": 6.60169070960696e-05,
            "Land_abs": 3.3480722e-05,
            "Fossil_fraction": 66.3502313530777,
            "Land_fraction": 33.6497686469219,
            "Rank": 125,
            "Perc_contribution_rescale": 0.120821586790173
        },
        {
            "Country": "New Zealand",
            "Abs_contribution": 9.74042729432302e-05,
            "Perc_contribution": 0.03,
            "Fossil_abs": 0.000270452384443232,
            "Land_abs": -0.0001730481115,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 126,
            "Perc_contribution_rescale": 0.120821586790173
        },
        {
            "Country": "Uruguay",
            "Abs_contribution": 9.6245900014192e-05,
            "Perc_contribution": 0.03,
            "Fossil_abs": 5.4206507014192e-05,
            "Land_abs": 4.20393930000001e-05,
            "Fossil_fraction": 56.3208479594444,
            "Land_fraction": 43.6791520405556,
            "Rank": 127,
            "Perc_contribution_rescale": 0.120821586790173
        },
        {
            "Country": "Gabon",
            "Abs_contribution": 9.22159761064431e-05,
            "Perc_contribution": 0.03,
            "Fossil_abs": 4.41972526064412e-05,
            "Land_abs": 4.8018723500002e-05,
            "Fossil_fraction": 47.9279778543201,
            "Land_fraction": 52.07202214568,
            "Rank": 128,
            "Perc_contribution_rescale": 0.120821586790173
        },
        {
            "Country": "South Sudan",
            "Abs_contribution": 8.6945267353713e-05,
            "Perc_contribution": 0.03,
            "Fossil_abs": 1.15055238537118e-05,
            "Land_abs": 7.5439743500001e-05,
            "Fossil_fraction": 13.2330651269433,
            "Land_fraction": 86.7669348730565,
            "Rank": 129,
            "Perc_contribution_rescale": 0.120821586790173
        },
        {
            "Country": "Kyrgyzstan",
            "Abs_contribution": 8.0504434537664e-05,
            "Perc_contribution": 0.03,
            "Fossil_abs": 6.6154533037664e-05,
            "Land_abs": 1.43499015e-05,
            "Fossil_fraction": 82.1750173361116,
            "Land_fraction": 17.8249826638884,
            "Rank": 130,
            "Perc_contribution_rescale": 0.120821586790173
        },
        {
            "Country": "Brunei Darussalam",
            "Abs_contribution": 7.8298368061682e-05,
            "Perc_contribution": 0.03,
            "Fossil_abs": 6.8796903561681e-05,
            "Land_abs": 9.5014645e-06,
            "Fossil_fraction": 87.8650542339325,
            "Land_fraction": 12.1349457660662,
            "Rank": 131,
            "Perc_contribution_rescale": 0.120821586790173
        },
        {
            "Country": "Afghanistan",
            "Abs_contribution": 7.7875093285482e-05,
            "Perc_contribution": 0.03,
            "Fossil_abs": 6.80941737854802e-05,
            "Land_abs": 9.78091949999999e-06,
            "Fossil_fraction": 87.4402468268693,
            "Land_fraction": 12.5597531731283,
            "Rank": 132,
            "Perc_contribution_rescale": 0.120821586790173
        },
        {
            "Country": "Luxembourg",
            "Abs_contribution": 7.6550160199781e-05,
            "Perc_contribution": 0.03,
            "Fossil_abs": 7.6300399699781e-05,
            "Land_abs": 2.497605e-07,
            "Fossil_fraction": 99.6737296181377,
            "Land_fraction": 0.326270381862263,
            "Rank": 133,
            "Perc_contribution_rescale": 0.120821586790173
        },
        {
            "Country": "Latvia",
            "Abs_contribution": 7.5233321817141e-05,
            "Perc_contribution": 0.03,
            "Fossil_abs": 5.8125054817139e-05,
            "Land_abs": 1.7108267e-05,
            "Fossil_fraction": 77.259721375078,
            "Land_fraction": 22.7402786249192,
            "Rank": 134,
            "Perc_contribution_rescale": 0.120821586790173
        },
        {
            "Country": "Namibia",
            "Abs_contribution": 7.2677864784934e-05,
            "Perc_contribution": 0.02,
            "Fossil_abs": 2.56880042849345e-05,
            "Land_abs": 4.69898605e-05,
            "Fossil_fraction": 35.3450178550919,
            "Land_fraction": 64.6549821449087,
            "Rank": 135,
            "Perc_contribution_rescale": 0.0805477245267821
        },
        {
            "Country": "Mali",
            "Abs_contribution": 7.1438764711244e-05,
            "Perc_contribution": 0.02,
            "Fossil_abs": 2.84378342112445e-05,
            "Land_abs": 4.30009305e-05,
            "Fossil_fraction": 39.8072871587162,
            "Land_fraction": 60.1927128412845,
            "Rank": 136,
            "Perc_contribution_rescale": 0.0805477245267821
        },
        {
            "Country": "Jamaica",
            "Abs_contribution": 7.1218695462882e-05,
            "Perc_contribution": 0.02,
            "Fossil_abs": 6.3272636462882e-05,
            "Land_abs": 7.94605899999999e-06,
            "Fossil_fraction": 88.8427344135483,
            "Land_fraction": 11.1572655864517,
            "Rank": 137,
            "Perc_contribution_rescale": 0.0805477245267821
        },
        {
            "Country": "Costa Rica",
            "Abs_contribution": 6.7926277098799e-05,
            "Perc_contribution": 0.02,
            "Fossil_abs": 5.82982795987995e-05,
            "Land_abs": 9.62799749999993e-06,
            "Fossil_fraction": 85.8258130561232,
            "Land_fraction": 14.1741869438774,
            "Rank": 138,
            "Perc_contribution_rescale": 0.0805477245267821
        },
        {
            "Country": "Equatorial Guinea",
            "Abs_contribution": 6.6370043086245e-05,
            "Perc_contribution": 0.02,
            "Fossil_abs": 4.83404435862446e-05,
            "Land_abs": 1.80295994999997e-05,
            "Fossil_fraction": 72.8347328680024,
            "Land_fraction": 27.1652671319966,
            "Rank": 139,
            "Perc_contribution_rescale": 0.0805477245267821
        },
        {
            "Country": "Guyana",
            "Abs_contribution": 6.3022394352619e-05,
            "Perc_contribution": 0.02,
            "Fossil_abs": 1.74926848526201e-05,
            "Land_abs": 4.5529709499998e-05,
            "Fossil_fraction": 27.7563000141602,
            "Land_fraction": 72.2436999858383,
            "Rank": 140,
            "Perc_contribution_rescale": 0.0805477245267821
        },
        {
            "Country": "Central African Republic",
            "Abs_contribution": 6.1892631168668e-05,
            "Perc_contribution": 0.02,
            "Fossil_abs": 1.49781316866813e-06,
            "Land_abs": 6.0394818e-05,
            "Fossil_fraction": 2.42001857149413,
            "Land_fraction": 97.5799814285061,
            "Rank": 141,
            "Perc_contribution_rescale": 0.0805477245267821
        },
        {
            "Country": "Kosovo",
            "Abs_contribution": 5.47126544213973e-05,
            "Perc_contribution": 0.02,
            "Fossil_abs": 5.47126544213973e-05,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 142,
            "Perc_contribution_rescale": 0.0805477245267821
        },
        {
            "Country": "Armenia",
            "Abs_contribution": 5.3458432157752e-05,
            "Perc_contribution": 0.02,
            "Fossil_abs": 4.2394835657751e-05,
            "Land_abs": 1.10635965000001e-05,
            "Fossil_fraction": 79.304300456562,
            "Land_fraction": 20.6956995434363,
            "Rank": 143,
            "Perc_contribution_rescale": 0.0805477245267821
        },
        {
            "Country": "North Macedonia",
            "Abs_contribution": 5.2934641356987e-05,
            "Perc_contribution": 0.02,
            "Fossil_abs": 5.9511453356987e-05,
            "Land_abs": -0.0000065768120000001,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 144,
            "Perc_contribution_rescale": 0.0805477245267821
        },
        {
            "Country": "Cyprus",
            "Abs_contribution": 5.28036550862442e-05,
            "Perc_contribution": 0.02,
            "Fossil_abs": 5.76608810862444e-05,
            "Land_abs": -0.00000485722600000002,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 145,
            "Perc_contribution_rescale": 0.0805477245267821
        },
        {
            "Country": "Tajikistan",
            "Abs_contribution": 5.0280848912118e-05,
            "Perc_contribution": 0.02,
            "Fossil_abs": 4.0802660412118e-05,
            "Land_abs": 9.47818849999999e-06,
            "Fossil_fraction": 81.149505815691,
            "Land_fraction": 18.850494184309,
            "Rank": 146,
            "Perc_contribution_rescale": 0.0805477245267821
        },
        {
            "Country": "El Salvador",
            "Abs_contribution": 4.7781336270744e-05,
            "Perc_contribution": 0.02,
            "Fossil_abs": 5.07330597707419e-05,
            "Land_abs": -0.00000295172349999999,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 147,
            "Perc_contribution_rescale": 0.0805477245267821
        },
        {
            "Country": "Belize",
            "Abs_contribution": 4.6913165725983e-05,
            "Perc_contribution": 0.02,
            "Fossil_abs": 4.30474822598253e-06,
            "Land_abs": 4.26084175e-05,
            "Fossil_fraction": 9.17599176982919,
            "Land_fraction": 90.8240082301698,
            "Rank": 148,
            "Perc_contribution_rescale": 0.0805477245267821
        },
        {
            "Country": "Haiti",
            "Abs_contribution": 4.6286458306768e-05,
            "Perc_contribution": 0.02,
            "Fossil_abs": 1.88794468067686e-05,
            "Land_abs": 2.74070115e-05,
            "Fossil_fraction": 40.7882726339596,
            "Land_fraction": 59.2117273660415,
            "Rank": 149,
            "Perc_contribution_rescale": 0.0805477245267821
        },
        {
            "Country": "Suriname",
            "Abs_contribution": 3.95542618919212e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 1.99743388919214e-05,
            "Land_abs": 1.9579923e-05,
            "Fossil_fraction": 50.4985757198546,
            "Land_fraction": 49.501424280146,
            "Rank": 150,
            "Perc_contribution_rescale": 0.0402738622633911
        },
        {
            "Country": "Togo",
            "Abs_contribution": 3.8928828827511e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 1.62298503275109e-05,
            "Land_abs": 2.26989785e-05,
            "Fossil_fraction": 41.6910829745827,
            "Land_fraction": 58.308917025417,
            "Rank": 151,
            "Perc_contribution_rescale": 0.0402738622633911
        },
        {
            "Country": "Albania",
            "Abs_contribution": 3.7951756379366e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 3.69878153793671e-05,
            "Land_abs": 9.63940999999693e-07,
            "Fossil_fraction": 97.4600885651685,
            "Land_fraction": 2.53991143483356,
            "Rank": 152,
            "Perc_contribution_rescale": 0.0402738622633911
        },
        {
            "Country": "Cura\xe7ao",
            "Abs_contribution": 3.6709200450327e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 3.6709200450327e-05,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 153,
            "Perc_contribution_rescale": 0.0402738622633911
        },
        {
            "Country": "New Caledonia",
            "Abs_contribution": 3.32537771151747e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 3.32537771151747e-05,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 154,
            "Perc_contribution_rescale": 0.0402738622633911
        },
        {
            "Country": "Mauritius",
            "Abs_contribution": 3.17449608422489e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 3.11060643422489e-05,
            "Land_abs": 6.388965e-07,
            "Fossil_fraction": 97.9874081332943,
            "Land_fraction": 2.01259186670567,
            "Rank": 155,
            "Perc_contribution_rescale": 0.0402738622633911
        },
        {
            "Country": "Lesotho",
            "Abs_contribution": 3.03264942942141e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 1.8556785794214e-05,
            "Land_abs": 1.17697085000001e-05,
            "Fossil_fraction": 61.19001297738,
            "Land_fraction": 38.80998702262,
            "Rank": 156,
            "Perc_contribution_rescale": 0.0402738622633911
        },
        {
            "Country": "Iceland",
            "Abs_contribution": 3.0065363258734e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 2.70360182587336e-05,
            "Land_abs": 3.0293450000002e-06,
            "Fossil_fraction": 89.9241363760328,
            "Land_fraction": 10.0758636239666,
            "Rank": 157,
            "Perc_contribution_rescale": 0.0402738622633911
        },
        {
            "Country": "Moldova",
            "Abs_contribution": 2.9410339221615e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 3.87482172216151e-05,
            "Land_abs": -0.00000933787799999998,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 158,
            "Perc_contribution_rescale": 0.0402738622633911
        },
        {
            "Country": "Mauritania",
            "Abs_contribution": 2.91222460813319e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 2.17310930813319e-05,
            "Land_abs": 7.39115300000009e-06,
            "Fossil_fraction": 74.6202508578556,
            "Land_fraction": 25.3797491421447,
            "Rank": 159,
            "Perc_contribution_rescale": 0.0402738622633911
        },
        {
            "Country": "Solomon Islands",
            "Abs_contribution": 2.650988217631e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 2.37919867631004e-06,
            "Land_abs": 2.41306835e-05,
            "Fossil_fraction": 8.97476141344815,
            "Land_fraction": 91.025238586552,
            "Rank": 160,
            "Perc_contribution_rescale": 0.0402738622633911
        },
        {
            "Country": "Bhutan",
            "Abs_contribution": 2.5254517756004e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 6.86015825600437e-06,
            "Land_abs": 1.83943595e-05,
            "Fossil_fraction": 27.1640833623657,
            "Land_fraction": 72.8359166376359,
            "Rank": 161,
            "Perc_contribution_rescale": 0.0402738622633911
        },
        {
            "Country": "Burundi",
            "Abs_contribution": 2.4613956143013e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 3.3432341430131e-06,
            "Land_abs": 2.1270722e-05,
            "Fossil_fraction": 13.5826769316891,
            "Land_fraction": 86.4173230683112,
            "Rank": 162,
            "Perc_contribution_rescale": 0.0402738622633911
        },
        {
            "Country": "Rwanda",
            "Abs_contribution": 2.2695294052402e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 7.20727205240176e-06,
            "Land_abs": 1.5488022e-05,
            "Fossil_fraction": 31.756680639434,
            "Land_fraction": 68.243319360565,
            "Rank": 163,
            "Perc_contribution_rescale": 0.0402738622633911
        },
        {
            "Country": "Timor-Leste",
            "Abs_contribution": 2.17148297254368e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 4.04700372543668e-06,
            "Land_abs": 1.76678260000002e-05,
            "Fossil_fraction": 18.6370502398921,
            "Land_fraction": 81.3629497601083,
            "Rank": 164,
            "Perc_contribution_rescale": 0.0402738622633911
        },
        {
            "Country": "Gambia",
            "Abs_contribution": 1.8215679474891e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 4.06707797489083e-06,
            "Land_abs": 1.41486015000001e-05,
            "Fossil_fraction": 22.3273470555793,
            "Land_fraction": 77.6726529444203,
            "Rank": 165,
            "Perc_contribution_rescale": 0.0402738622633911
        },
        {
            "Country": "Eritrea",
            "Abs_contribution": 1.72381122729257e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 4.42182527292576e-06,
            "Land_abs": 1.2816287e-05,
            "Fossil_fraction": 25.6514472287706,
            "Land_fraction": 74.3485527712298,
            "Rank": 166,
            "Perc_contribution_rescale": 0.0402738622633911
        },
        {
            "Country": "Georgia",
            "Abs_contribution": 1.7114420641376e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 6.6102013141376e-05,
            "Land_abs": -0.0000489875925,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 167,
            "Perc_contribution_rescale": 0.0402738622633911
        },
        {
            "Country": "Bahamas",
            "Abs_contribution": 1.63606957658295e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 1.64833842658297e-05,
            "Land_abs": -0.0000001226885,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 168,
            "Perc_contribution_rescale": 0.0402738622633911
        },
        {
            "Country": "Malta",
            "Abs_contribution": 1.58741394486903e-05,
            "Perc_contribution": 0.01,
            "Fossil_abs": 1.615329194869e-05,
            "Land_abs": -0.0000002791525,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 169,
            "Perc_contribution_rescale": 0.0402738622633911
        },
        {
            "Country": "Guinea-Bissau",
            "Abs_contribution": 1.42850436086243e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 2.07371810862445e-06,
            "Land_abs": 1.22113254999998e-05,
            "Fossil_fraction": 14.5167082820278,
            "Land_fraction": 85.4832917179717,
            "Rank": 170,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Barbados",
            "Abs_contribution": 1.25137619437773e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 1.29698164437773e-05,
            "Land_abs": -0.0000004560545,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 171,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Aruba",
            "Abs_contribution": 1.16877430267467e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 1.16877430267467e-05,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 172,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Fiji",
            "Abs_contribution": 1.09584318286024e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 8.6949893286026e-06,
            "Land_abs": 2.26344249999979e-06,
            "Fossil_fraction": 79.3451970555492,
            "Land_fraction": 20.6548029444507,
            "Rank": 173,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Macao",
            "Abs_contribution": 1.03730920169214e-05,
            "Perc_contribution": 0,
            "Fossil_abs": 1.03730920169214e-05,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 174,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Maldives",
            "Abs_contribution": 9.7644305420306e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 9.7627640420306e-06,
            "Land_abs": 1.6665e-09,
            "Fossil_fraction": 99.9829329524868,
            "Land_fraction": 0.0170670475131818,
            "Rank": 175,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "French Polynesia",
            "Abs_contribution": 6.5989511872271e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 6.5989511872271e-06,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 176,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Montenegro",
            "Abs_contribution": 5.66584364956321e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.70869181495634e-05,
            "Land_abs": -0.0000114210744999999,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 177,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Faeroe Islands",
            "Abs_contribution": 5.0708926719432e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 5.0708926719432e-06,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 178,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Sint Maarten (Dutch part)",
            "Abs_contribution": 5.0366209470524e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 5.0366209470524e-06,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 179,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Greenland",
            "Abs_contribution": 4.5253978984716e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 4.5253978984716e-06,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 180,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Antigua and Barbuda",
            "Abs_contribution": 4.37069039792573e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 4.4058408979258e-06,
            "Land_abs": -0.0000000351505000000001,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 181,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Bermuda",
            "Abs_contribution": 4.3032274699782e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 4.3032274699782e-06,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 182,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Cape Verde",
            "Abs_contribution": 4.11336901310042e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 4.00085551310044e-06,
            "Land_abs": 1.125135e-07,
            "Fossil_fraction": 97.2646874218763,
            "Land_fraction": 2.73531257812422,
            "Rank": 183,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Seychelles",
            "Abs_contribution": 3.84558033569869e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 3.84558033569869e-06,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 184,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Djibouti",
            "Abs_contribution": 3.62450156713975e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 3.42982356713974e-06,
            "Land_abs": 1.94678000000001e-07,
            "Fossil_fraction": 94.6288338853268,
            "Land_fraction": 5.37116611467297,
            "Rank": 185,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Andorra",
            "Abs_contribution": 3.60932658679041e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 3.62785058679039e-06,
            "Land_abs": -0.000000018524,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 186,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Lucia",
            "Abs_contribution": 3.12915833351528e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 3.60288983351528e-06,
            "Land_abs": -0.0000004737315,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 187,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Turks and Caicos Islands",
            "Abs_contribution": 2.35082263919214e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 2.35082263919214e-06,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 188,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Vanuatu",
            "Abs_contribution": 1.8169270114628e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.07932201146288e-06,
            "Land_abs": 7.37604999999897e-07,
            "Fossil_fraction": 59.4037077248318,
            "Land_fraction": 40.5962922751672,
            "Rank": 189,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Grenada",
            "Abs_contribution": 1.77254661681223e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 2.11683561681223e-06,
            "Land_abs": -0.000000344289,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 190,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Vincent and the Grenadines",
            "Abs_contribution": 1.73094526528387e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.78813976528384e-06,
            "Land_abs": -0.0000000571945,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 191,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Comoros",
            "Abs_contribution": 1.72656964301311e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.7093216430131e-06,
            "Land_abs": 1.72480000000001e-08,
            "Fossil_fraction": 99.0010249473685,
            "Land_fraction": 0.998975052630942,
            "Rank": 192,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Palau",
            "Abs_contribution": 1.66544353165939e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.66544353165939e-06,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 193,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Kitts and Nevis",
            "Abs_contribution": 1.51729027183406e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.74401127183406e-06,
            "Land_abs": -0.000000226721,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 194,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "British Virgin Islands",
            "Abs_contribution": 1.4671634279476e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.4671634279476e-06,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 195,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Tonga",
            "Abs_contribution": 1.27216946015282e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.02920146015284e-06,
            "Land_abs": 2.4296799999998e-07,
            "Fossil_fraction": 80.9012865337301,
            "Land_fraction": 19.0987134662699,
            "Rank": 196,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Liechtenstein",
            "Abs_contribution": 1.19836714574236e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.33236914574236e-06,
            "Land_abs": -0.000000134002,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 197,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Samoa",
            "Abs_contribution": 1.1667775534934e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.62188605349345e-06,
            "Land_abs": -0.0000004551085,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 198,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Marshall Islands",
            "Abs_contribution": 1.06921125818777e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.06921125818777e-06,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 199,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Dominica",
            "Abs_contribution": 1.04553935425766e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.25276835425764e-06,
            "Land_abs": -0.000000207229,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 200,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Anguilla",
            "Abs_contribution": 9.9743986080786e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 9.9743986080786e-07,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 201,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Sao Tome and Principe",
            "Abs_contribution": 9.71425485262009e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 9.0892348526201e-07,
            "Land_abs": 6.25019999999999e-08,
            "Fossil_fraction": 93.5659501476697,
            "Land_fraction": 6.43404985233037,
            "Rank": 202,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Bonaire, Saint Eustatius and Saba",
            "Abs_contribution": 6.8750060043668e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 6.8750060043668e-07,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 203,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Micronesia (Federated States of)",
            "Abs_contribution": 5.1399725818777e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 1.02961125818777e-06,
            "Land_abs": -0.000000515614,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 204,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Pierre and Miquelon",
            "Abs_contribution": 4.9485859716157e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 4.9485859716157e-07,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 205,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Kiribati",
            "Abs_contribution": 4.39482723799127e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 4.39482723799127e-07,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 206,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Cook Islands",
            "Abs_contribution": 4.0602622379913e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 5.7148272379913e-07,
            "Land_abs": -0.000000165456500000001,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 207,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Nauru",
            "Abs_contribution": 3.729864628821e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 3.729864628821e-07,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 208,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Montserrat",
            "Abs_contribution": 2.84817740174672e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 2.84817740174672e-07,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 209,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Wallis and Futuna Islands",
            "Abs_contribution": 1.97218231441048e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 1.97218231441048e-07,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 210,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Occupied Palestinian Territory",
            "Abs_contribution": 1.32418e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 1.32418e-07,
            "Fossil_fraction": 0,
            "Land_fraction": 100,
            "Rank": 211,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Helena",
            "Abs_contribution": 9.6823116812227e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 9.6823116812227e-08,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 212,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Tuvalu",
            "Abs_contribution": 8.4521970524017e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 8.4521970524017e-08,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 213,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Niue",
            "Abs_contribution": 5.1942630458515e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 5.3048130458515e-08,
            "Land_abs": -0.00000000110549999999997,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 214,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Swaziland",
            "Abs_contribution": 2.05534999996008e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 2.05534999996008e-08,
            "Fossil_fraction": 0,
            "Land_fraction": 100,
            "Rank": 215,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Antarctica",
            "Abs_contribution": 8.25000000000001e-09,
            "Perc_contribution": 0,
            "Fossil_abs": 8.25000000000001e-09,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 216,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Christmas Island",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 217,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Kuwaiti Oil Fires",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 218,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Leeward Islands",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 219,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Pacific Islands (Palau)",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 220,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Panama Canal Zone",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 221,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Ryukyu Islands",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 222,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "St. Kitts-Nevis-Anguilla",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 223,
            "Perc_contribution_rescale": 0
        }
    ],
    "2005_N2O": [
        {
            "Country": "China",
            "Abs_contribution": 0.00336017938943368,
            "Perc_contribution": 15.85,
            "Fossil_abs": 0.00099971543656154,
            "Land_abs": 0.00236046395287213,
            "Fossil_fraction": 29.7518471693867,
            "Land_fraction": 70.248152830613,
            "Rank": 1,
            "Perc_contribution_rescale": 100
        },
        {
            "Country": "United States",
            "Abs_contribution": 0.00194984671404452,
            "Perc_contribution": 9.2,
            "Fossil_abs": 0.000729436186600299,
            "Land_abs": 0.00122041052744418,
            "Fossil_fraction": 37.4099246543975,
            "Land_fraction": 62.5900753456004,
            "Rank": 2,
            "Perc_contribution_rescale": 58.0441640378549
        },
        {
            "Country": "EU27",
            "Abs_contribution": 0.00191826521587794,
            "Perc_contribution": 9.05,
            "Fossil_abs": 0.00064636833622664,
            "Land_abs": 0.00127189687965134,
            "Fossil_fraction": 33.6954624874858,
            "Land_fraction": 66.3045375125162,
            "Rank": 3,
            "Perc_contribution_rescale": 57.0977917981073
        },
        {
            "Country": "India",
            "Abs_contribution": 0.00191452146611709,
            "Perc_contribution": 9.03,
            "Fossil_abs": 0.000409364151839661,
            "Land_abs": 0.00150515731427743,
            "Fossil_fraction": 21.3820612139652,
            "Land_fraction": 78.6179387860348,
            "Rank": 4,
            "Perc_contribution_rescale": 56.9716088328076
        },
        {
            "Country": "Brazil",
            "Abs_contribution": 0.00126772587412541,
            "Perc_contribution": 5.98,
            "Fossil_abs": 0.000147167785775928,
            "Land_abs": 0.00112055808834948,
            "Fossil_fraction": 11.6088019326305,
            "Land_fraction": 88.3911980673693,
            "Rank": 5,
            "Perc_contribution_rescale": 37.7287066246057
        },
        {
            "Country": "Mexico",
            "Abs_contribution": 0.000799404832208519,
            "Perc_contribution": 3.77,
            "Fossil_abs": 0.000551064453213291,
            "Land_abs": 0.000248340378995224,
            "Fossil_fraction": 68.9343410260435,
            "Land_fraction": 31.065658973956,
            "Rank": 6,
            "Perc_contribution_rescale": 23.7854889589905
        },
        {
            "Country": "Russia",
            "Abs_contribution": 0.00057571421440284,
            "Perc_contribution": 2.72,
            "Fossil_abs": 0.00024434864083543,
            "Land_abs": 0.00033136557356741,
            "Fossil_fraction": 42.4426972137349,
            "Land_fraction": 57.5573027862651,
            "Rank": 7,
            "Perc_contribution_rescale": 17.1608832807571
        },
        {
            "Country": "Australia",
            "Abs_contribution": 0.00053583465757328,
            "Perc_contribution": 2.53,
            "Fossil_abs": 7.7386371972298e-05,
            "Land_abs": 0.00045844828560098,
            "Fossil_fraction": 14.4422110213569,
            "Land_fraction": 85.5577889786428,
            "Rank": 8,
            "Perc_contribution_rescale": 15.9621451104101
        },
        {
            "Country": "Indonesia",
            "Abs_contribution": 0.000480144127481582,
            "Perc_contribution": 2.26,
            "Fossil_abs": 9.0958696021425e-05,
            "Land_abs": 0.000389185431460151,
            "Fossil_fraction": 18.9440400944848,
            "Land_fraction": 81.055959905514,
            "Rank": 9,
            "Perc_contribution_rescale": 14.2586750788644
        },
        {
            "Country": "Pakistan",
            "Abs_contribution": 0.000434191877661026,
            "Perc_contribution": 2.05,
            "Fossil_abs": 6.6825130369815e-05,
            "Land_abs": 0.000367366747291212,
            "Fossil_fraction": 15.3906910303802,
            "Land_fraction": 84.60930896962,
            "Rank": 10,
            "Perc_contribution_rescale": 12.9337539432177
        },
        {
            "Country": "Argentina",
            "Abs_contribution": 0.000331699893770875,
            "Perc_contribution": 1.56,
            "Fossil_abs": 3.00847514762556e-05,
            "Land_abs": 0.000301615142294627,
            "Fossil_fraction": 9.06987069975878,
            "Land_fraction": 90.9301293002435,
            "Rank": 11,
            "Perc_contribution_rescale": 9.8422712933754
        },
        {
            "Country": "T\xfcrkiye",
            "Abs_contribution": 0.000326655484450054,
            "Perc_contribution": 1.54,
            "Fossil_abs": 0.000146811780289847,
            "Land_abs": 0.000179843704160207,
            "Fossil_fraction": 44.9439202090895,
            "Land_fraction": 55.0560797909105,
            "Rank": 12,
            "Perc_contribution_rescale": 9.71608832807571
        },
        {
            "Country": "Ethiopia",
            "Abs_contribution": 0.000318063915383188,
            "Perc_contribution": 1.5,
            "Fossil_abs": 3.58626308433406e-05,
            "Land_abs": 0.000282201284539847,
            "Fossil_fraction": 11.2752906283427,
            "Land_fraction": 88.7247093716571,
            "Rank": 13,
            "Perc_contribution_rescale": 9.46372239747634
        },
        {
            "Country": "Canada",
            "Abs_contribution": 0.00031733598990434,
            "Perc_contribution": 1.5,
            "Fossil_abs": 6.6518324006414e-05,
            "Land_abs": 0.000250817665897924,
            "Fossil_fraction": 20.9614812446788,
            "Land_fraction": 79.0385187553206,
            "Rank": 14,
            "Perc_contribution_rescale": 9.46372239747634
        },
        {
            "Country": "Germany",
            "Abs_contribution": 0.00029550493188373,
            "Perc_contribution": 1.39,
            "Fossil_abs": 9.0811888293217e-05,
            "Land_abs": 0.00020469304359051,
            "Fossil_fraction": 30.7310905825924,
            "Land_fraction": 69.2689094174066,
            "Rank": 15,
            "Perc_contribution_rescale": 8.76971608832807
        },
        {
            "Country": "France",
            "Abs_contribution": 0.00029194550195493,
            "Perc_contribution": 1.38,
            "Fossil_abs": 6.2543768591834e-05,
            "Land_abs": 0.000229401733363097,
            "Fossil_fraction": 21.4230971784211,
            "Land_fraction": 78.5769028215792,
            "Rank": 16,
            "Perc_contribution_rescale": 8.70662460567823
        },
        {
            "Country": "Nigeria",
            "Abs_contribution": 0.000270085742099754,
            "Perc_contribution": 1.27,
            "Fossil_abs": 7.6812632184498e-05,
            "Land_abs": 0.000193273109915256,
            "Fossil_fraction": 28.4400915010641,
            "Land_fraction": 71.5599084989359,
            "Rank": 17,
            "Perc_contribution_rescale": 8.01261829652997
        },
        {
            "Country": "Iran",
            "Abs_contribution": 0.000231448716680404,
            "Perc_contribution": 1.09,
            "Fossil_abs": 0.00010886365274173,
            "Land_abs": 0.000122585063938673,
            "Fossil_fraction": 47.0357556106282,
            "Land_fraction": 52.9642443893714,
            "Rank": 18,
            "Perc_contribution_rescale": 6.87697160883281
        },
        {
            "Country": "United Kingdom",
            "Abs_contribution": 0.0002273869301033,
            "Perc_contribution": 1.07,
            "Fossil_abs": 5.2472924925818e-05,
            "Land_abs": 0.000174914005177483,
            "Fossil_fraction": 23.0764912046528,
            "Land_fraction": 76.9235087953477,
            "Rank": 19,
            "Perc_contribution_rescale": 6.75078864353312
        },
        {
            "Country": "Poland",
            "Abs_contribution": 0.000209409633866838,
            "Perc_contribution": 0.99,
            "Fossil_abs": 7.4303394312527e-05,
            "Land_abs": 0.000135106239554313,
            "Fossil_fraction": 35.4823190034208,
            "Land_fraction": 64.5176809965802,
            "Rank": 20,
            "Perc_contribution_rescale": 6.24605678233438
        },
        {
            "Country": "Bangladesh",
            "Abs_contribution": 0.000200015632751978,
            "Perc_contribution": 0.94,
            "Fossil_abs": 3.45518432265557e-05,
            "Land_abs": 0.000165463789525423,
            "Fossil_fraction": 17.2745713678292,
            "Land_fraction": 82.7254286321711,
            "Rank": 21,
            "Perc_contribution_rescale": 5.93059936908517
        },
        {
            "Country": "Sudan",
            "Abs_contribution": 0.000196410314550778,
            "Perc_contribution": 0.93,
            "Fossil_abs": 8.7207174093341e-06,
            "Land_abs": 0.000187689597141443,
            "Fossil_fraction": 4.44005063037539,
            "Land_fraction": 95.5599493696241,
            "Rank": 22,
            "Perc_contribution_rescale": 5.86750788643533
        },
        {
            "Country": "Belarus",
            "Abs_contribution": 0.000190746750148649,
            "Perc_contribution": 0.9,
            "Fossil_abs": 8.50620477174807e-05,
            "Land_abs": 0.000105684702431168,
            "Fossil_fraction": 44.5942316978883,
            "Land_fraction": 55.4057683021114,
            "Rank": 23,
            "Perc_contribution_rescale": 5.6782334384858
        },
        {
            "Country": "Ukraine",
            "Abs_contribution": 0.0001903302662178,
            "Perc_contribution": 0.9,
            "Fossil_abs": 5.4406231983816e-05,
            "Land_abs": 0.000135924034233976,
            "Fossil_fraction": 28.5851709583369,
            "Land_fraction": 71.4148290416588,
            "Rank": 24,
            "Perc_contribution_rescale": 5.6782334384858
        },
        {
            "Country": "Thailand",
            "Abs_contribution": 0.000184356932489533,
            "Perc_contribution": 0.87,
            "Fossil_abs": 6.33557746737858e-05,
            "Land_abs": 0.000121001157815748,
            "Fossil_fraction": 34.3658216798453,
            "Land_fraction": 65.6341783201551,
            "Rank": 25,
            "Perc_contribution_rescale": 5.48895899053628
        },
        {
            "Country": "Viet Nam",
            "Abs_contribution": 0.000171364302921493,
            "Perc_contribution": 0.81,
            "Fossil_abs": 3.44980916575054e-05,
            "Land_abs": 0.000136866211263988,
            "Fossil_fraction": 20.1314340672865,
            "Land_fraction": 79.8685659327138,
            "Rank": 26,
            "Perc_contribution_rescale": 5.11041009463722
        },
        {
            "Country": "Egypt",
            "Abs_contribution": 0.000167432545547735,
            "Perc_contribution": 0.79,
            "Fossil_abs": 6.55853521877049e-05,
            "Land_abs": 0.00010184719336003,
            "Fossil_fraction": 39.1712089027557,
            "Land_fraction": 60.8287910972442,
            "Rank": 27,
            "Perc_contribution_rescale": 4.98422712933754
        },
        {
            "Country": "Tanzania",
            "Abs_contribution": 0.000160915722871834,
            "Perc_contribution": 0.76,
            "Fossil_abs": 1.5953838323458e-05,
            "Land_abs": 0.000144961884548376,
            "Fossil_fraction": 9.91440614921445,
            "Land_fraction": 90.0855938507855,
            "Rank": 28,
            "Perc_contribution_rescale": 4.79495268138801
        },
        {
            "Country": "Spain",
            "Abs_contribution": 0.000160660417671574,
            "Perc_contribution": 0.76,
            "Fossil_abs": 4.8406826248894e-05,
            "Land_abs": 0.00011225359142268,
            "Fossil_fraction": 30.1299019076674,
            "Land_fraction": 69.8700980923325,
            "Rank": 29,
            "Perc_contribution_rescale": 4.79495268138801
        },
        {
            "Country": "Japan",
            "Abs_contribution": 0.000158306411090338,
            "Perc_contribution": 0.75,
            "Fossil_abs": 0.000102830996567972,
            "Land_abs": 5.5475414522366e-05,
            "Fossil_fraction": 64.9569375363397,
            "Land_fraction": 35.0430624636603,
            "Rank": 30,
            "Perc_contribution_rescale": 4.73186119873817
        },
        {
            "Country": "South Africa",
            "Abs_contribution": 0.000152694023168368,
            "Perc_contribution": 0.72,
            "Fossil_abs": 4.8309366031236e-05,
            "Land_abs": 0.000104384657137132,
            "Fossil_fraction": 31.6380202897449,
            "Land_fraction": 68.3619797102551,
            "Rank": 31,
            "Perc_contribution_rescale": 4.54258675078864
        },
        {
            "Country": "Chad",
            "Abs_contribution": 0.000148725203250532,
            "Perc_contribution": 0.7,
            "Fossil_abs": 2.84628228983352e-06,
            "Land_abs": 0.000145878920960699,
            "Fossil_fraction": 1.91378611534917,
            "Land_fraction": 98.0862138846512,
            "Rank": 32,
            "Perc_contribution_rescale": 4.41640378548896
        },
        {
            "Country": "South Sudan",
            "Abs_contribution": 0.000145408174770484,
            "Perc_contribution": 0.69,
            "Fossil_abs": 2.42115153848253e-06,
            "Land_abs": 0.000142987023232,
            "Fossil_fraction": 1.66507250524541,
            "Land_fraction": 98.3349274947536,
            "Rank": 33,
            "Perc_contribution_rescale": 4.35331230283912
        },
        {
            "Country": "Colombia",
            "Abs_contribution": 0.000144295956430718,
            "Perc_contribution": 0.68,
            "Fossil_abs": 1.62587499446643e-05,
            "Land_abs": 0.000128037206486053,
            "Fossil_fraction": 11.2676407203903,
            "Land_fraction": 88.7323592796091,
            "Rank": 34,
            "Perc_contribution_rescale": 4.29022082018927
        },
        {
            "Country": "Italy",
            "Abs_contribution": 0.000129015953339283,
            "Perc_contribution": 0.61,
            "Fossil_abs": 4.6723708674443e-05,
            "Land_abs": 8.2292244664842e-05,
            "Fossil_fraction": 36.2154504657033,
            "Land_fraction": 63.7845495342982,
            "Rank": 35,
            "Perc_contribution_rescale": 3.84858044164038
        },
        {
            "Country": "Kenya",
            "Abs_contribution": 0.000127949566422625,
            "Perc_contribution": 0.6,
            "Fossil_abs": 1.30673827536435e-05,
            "Land_abs": 0.000114882183668982,
            "Fossil_fraction": 10.212916791356,
            "Land_fraction": 89.7870832086444,
            "Rank": 36,
            "Perc_contribution_rescale": 3.78548895899054
        },
        {
            "Country": "Angola",
            "Abs_contribution": 0.000127518056099386,
            "Perc_contribution": 0.6,
            "Fossil_abs": 8.2115410970388e-06,
            "Land_abs": 0.000119306515002347,
            "Fossil_fraction": 6.43951244884005,
            "Land_fraction": 93.5604875511598,
            "Rank": 37,
            "Perc_contribution_rescale": 3.78548895899054
        },
        {
            "Country": "Myanmar",
            "Abs_contribution": 0.000117596298839124,
            "Perc_contribution": 0.55,
            "Fossil_abs": 1.44070521573144e-05,
            "Land_abs": 0.00010318924668181,
            "Fossil_fraction": 12.2512802694784,
            "Land_fraction": 87.748719730522,
            "Rank": 38,
            "Perc_contribution_rescale": 3.47003154574133
        },
        {
            "Country": "Democratic Republic of the Congo",
            "Abs_contribution": 0.000109305967103302,
            "Perc_contribution": 0.52,
            "Fossil_abs": 1.47190246806223e-05,
            "Land_abs": 9.458694242268e-05,
            "Fossil_fraction": 13.4658930986922,
            "Land_fraction": 86.5341069013081,
            "Rank": 39,
            "Perc_contribution_rescale": 3.2807570977918
        },
        {
            "Country": "New Zealand",
            "Abs_contribution": 0.00010556113062925,
            "Perc_contribution": 0.5,
            "Fossil_abs": 4.5000648937797e-06,
            "Land_abs": 0.000101061065735469,
            "Fossil_fraction": 4.26299421667313,
            "Land_fraction": 95.7370057833256,
            "Rank": 40,
            "Perc_contribution_rescale": 3.15457413249211
        },
        {
            "Country": "South Korea",
            "Abs_contribution": 9.9060630241171e-05,
            "Perc_contribution": 0.47,
            "Fossil_abs": 6.51972592696096e-05,
            "Land_abs": 3.3863370971561e-05,
            "Fossil_fraction": 65.8155102697022,
            "Land_fraction": 34.1844897302974,
            "Rank": 41,
            "Perc_contribution_rescale": 2.96529968454259
        },
        {
            "Country": "Venezuela",
            "Abs_contribution": 9.5326966737732e-05,
            "Perc_contribution": 0.45,
            "Fossil_abs": 1.46820955258051e-05,
            "Land_abs": 8.0644871211927e-05,
            "Fossil_fraction": 15.4018280747348,
            "Land_fraction": 84.5981719252654,
            "Rank": 42,
            "Perc_contribution_rescale": 2.8391167192429
        },
        {
            "Country": "Philippines",
            "Abs_contribution": 9.4444049331181e-05,
            "Perc_contribution": 0.45,
            "Fossil_abs": 2.18863406770742e-05,
            "Land_abs": 7.2557708654108e-05,
            "Fossil_fraction": 23.1738694307004,
            "Land_fraction": 76.8261305693008,
            "Rank": 43,
            "Perc_contribution_rescale": 2.8391167192429
        },
        {
            "Country": "Netherlands",
            "Abs_contribution": 9.3236921397707e-05,
            "Perc_contribution": 0.44,
            "Fossil_abs": 4.2604487963155e-05,
            "Land_abs": 5.0632433434552e-05,
            "Fossil_fraction": 45.6948677889345,
            "Land_fraction": 54.3051322110656,
            "Rank": 44,
            "Perc_contribution_rescale": 2.77602523659306
        },
        {
            "Country": "Uzbekistan",
            "Abs_contribution": 9.1856524994951e-05,
            "Perc_contribution": 0.43,
            "Fossil_abs": 7.7126675990994e-06,
            "Land_abs": 8.4143857395851e-05,
            "Fossil_fraction": 8.39642866908294,
            "Land_fraction": 91.6035713309164,
            "Rank": 45,
            "Perc_contribution_rescale": 2.71293375394322
        },
        {
            "Country": "Zambia",
            "Abs_contribution": 9.0557649715284e-05,
            "Perc_contribution": 0.43,
            "Fossil_abs": 7.9318924182314e-06,
            "Land_abs": 8.2625757297053e-05,
            "Fossil_fraction": 8.758942445138,
            "Land_fraction": 91.2410575548625,
            "Rank": 46,
            "Perc_contribution_rescale": 2.71293375394322
        },
        {
            "Country": "Mali",
            "Abs_contribution": 8.7170726615134e-05,
            "Perc_contribution": 0.41,
            "Fossil_abs": 3.36875499112991e-06,
            "Land_abs": 8.3801971624004e-05,
            "Fossil_fraction": 3.86454848082573,
            "Land_fraction": 96.1354515191741,
            "Rank": 47,
            "Perc_contribution_rescale": 2.58675078864353
        },
        {
            "Country": "Mongolia",
            "Abs_contribution": 8.6951575559648e-05,
            "Perc_contribution": 0.41,
            "Fossil_abs": 2.16350864533297e-06,
            "Land_abs": 8.4788066914315e-05,
            "Fossil_fraction": 2.4881764722582,
            "Land_fraction": 97.5118235277418,
            "Rank": 48,
            "Perc_contribution_rescale": 2.58675078864353
        },
        {
            "Country": "Kazakhstan",
            "Abs_contribution": 8.4319765988974e-05,
            "Perc_contribution": 0.4,
            "Fossil_abs": 1.8640311058911e-05,
            "Land_abs": 6.5679454930062e-05,
            "Fossil_fraction": 22.1066921145731,
            "Land_fraction": 77.8933078854258,
            "Rank": 49,
            "Perc_contribution_rescale": 2.52365930599369
        },
        {
            "Country": "Uganda",
            "Abs_contribution": 7.9332964969446e-05,
            "Perc_contribution": 0.37,
            "Fossil_abs": 9.5711759839111e-06,
            "Land_abs": 6.9761788985535e-05,
            "Fossil_fraction": 12.0645635614367,
            "Land_fraction": 87.9354364385635,
            "Rank": 50,
            "Perc_contribution_rescale": 2.33438485804416
        },
        {
            "Country": "Sweden",
            "Abs_contribution": 7.7346077965817e-05,
            "Perc_contribution": 0.36,
            "Fossil_abs": 4.63391769042169e-05,
            "Land_abs": 3.10069010616e-05,
            "Fossil_fraction": 59.9114759570569,
            "Land_fraction": 40.088524042943,
            "Rank": 51,
            "Perc_contribution_rescale": 2.27129337539432
        },
        {
            "Country": "Romania",
            "Abs_contribution": 7.7148267593777e-05,
            "Perc_contribution": 0.36,
            "Fossil_abs": 2.6864596915816e-05,
            "Land_abs": 5.0283670677961e-05,
            "Fossil_fraction": 34.8220352234882,
            "Land_fraction": 65.1779647765117,
            "Rank": 52,
            "Perc_contribution_rescale": 2.27129337539432
        },
        {
            "Country": "Saudi Arabia",
            "Abs_contribution": 7.3278378248949e-05,
            "Perc_contribution": 0.35,
            "Fossil_abs": 4.85651311478305e-05,
            "Land_abs": 2.4713247101119e-05,
            "Fossil_fraction": 66.2748443788425,
            "Land_fraction": 33.7251556211582,
            "Rank": 53,
            "Perc_contribution_rescale": 2.20820189274448
        },
        {
            "Country": "Niger",
            "Abs_contribution": 7.1010604812527e-05,
            "Perc_contribution": 0.33,
            "Fossil_abs": 3.37453572515011e-06,
            "Land_abs": 6.7636069087377e-05,
            "Fossil_fraction": 4.75215741938704,
            "Land_fraction": 95.2478425806131,
            "Rank": 54,
            "Perc_contribution_rescale": 2.08201892744479
        },
        {
            "Country": "Malaysia",
            "Abs_contribution": 6.9810851153712e-05,
            "Perc_contribution": 0.33,
            "Fossil_abs": 2.28440606908706e-05,
            "Land_abs": 4.69667904628416e-05,
            "Fossil_fraction": 32.7227935390327,
            "Land_fraction": 67.2772064609676,
            "Rank": 55,
            "Perc_contribution_rescale": 2.08201892744479
        },
        {
            "Country": "Belgium",
            "Abs_contribution": 6.9384240949495e-05,
            "Perc_contribution": 0.33,
            "Fossil_abs": 4.6163863337841e-05,
            "Land_abs": 2.3220377611654e-05,
            "Fossil_fraction": 66.5336432395993,
            "Land_fraction": 33.4663567604006,
            "Rank": 56,
            "Perc_contribution_rescale": 2.08201892744479
        },
        {
            "Country": "Mozambique",
            "Abs_contribution": 6.8758657243477e-05,
            "Perc_contribution": 0.32,
            "Fossil_abs": 6.5268681780704e-06,
            "Land_abs": 6.2231789065407e-05,
            "Fossil_fraction": 9.49243112028571,
            "Land_fraction": 90.5075688797149,
            "Rank": 57,
            "Perc_contribution_rescale": 2.01892744479495
        },
        {
            "Country": "Ireland",
            "Abs_contribution": 6.8224770232615e-05,
            "Perc_contribution": 0.32,
            "Fossil_abs": 4.1131917245634e-06,
            "Land_abs": 6.4111578508052e-05,
            "Fossil_fraction": 6.02888322018427,
            "Land_fraction": 93.9711167798163,
            "Rank": 58,
            "Perc_contribution_rescale": 2.01892744479495
        },
        {
            "Country": "Peru",
            "Abs_contribution": 6.6737672010835e-05,
            "Perc_contribution": 0.31,
            "Fossil_abs": 1.00151441264328e-05,
            "Land_abs": 5.6722527884402e-05,
            "Fossil_fraction": 15.0067328162223,
            "Land_fraction": 84.9932671837774,
            "Rank": 59,
            "Perc_contribution_rescale": 1.95583596214511
        },
        {
            "Country": "Burkina Faso",
            "Abs_contribution": 6.5704389870115e-05,
            "Perc_contribution": 0.31,
            "Fossil_abs": 4.97444868225985e-06,
            "Land_abs": 6.07299411878544e-05,
            "Fossil_fraction": 7.57095331391613,
            "Land_fraction": 92.4290466860827,
            "Rank": 60,
            "Perc_contribution_rescale": 1.95583596214511
        },
        {
            "Country": "Paraguay",
            "Abs_contribution": 6.4948127594787e-05,
            "Perc_contribution": 0.31,
            "Fossil_abs": 3.20329403498908e-06,
            "Land_abs": 6.1744833559798e-05,
            "Fossil_fraction": 4.93208065207747,
            "Land_fraction": 95.0679193479226,
            "Rank": 61,
            "Perc_contribution_rescale": 1.95583596214511
        },
        {
            "Country": "Bolivia",
            "Abs_contribution": 6.2308117473676e-05,
            "Perc_contribution": 0.29,
            "Fossil_abs": 3.99179139256277e-06,
            "Land_abs": 5.8316326081113e-05,
            "Fossil_fraction": 6.40653506222399,
            "Land_fraction": 93.5934649377756,
            "Rank": 62,
            "Perc_contribution_rescale": 1.82965299684543
        },
        {
            "Country": "Morocco",
            "Abs_contribution": 6.2200472832315e-05,
            "Perc_contribution": 0.29,
            "Fossil_abs": 1.14568273005868e-05,
            "Land_abs": 5.0743645531728e-05,
            "Fossil_fraction": 18.4191964769674,
            "Land_fraction": 81.5808035230323,
            "Rank": 63,
            "Perc_contribution_rescale": 1.82965299684543
        },
        {
            "Country": "Central African Republic",
            "Abs_contribution": 6.1586004201337e-05,
            "Perc_contribution": 0.29,
            "Fossil_abs": 7.8418107781114e-07,
            "Land_abs": 6.0801823123526e-05,
            "Fossil_fraction": 1.27331053212593,
            "Land_fraction": 98.7266894678743,
            "Rank": 64,
            "Perc_contribution_rescale": 1.82965299684543
        },
        {
            "Country": "Finland",
            "Abs_contribution": 5.7211916729763e-05,
            "Perc_contribution": 0.27,
            "Fossil_abs": 2.48418302911167e-05,
            "Land_abs": 3.2370086438646e-05,
            "Fossil_fraction": 43.4207272034873,
            "Land_fraction": 56.5792727965122,
            "Rank": 65,
            "Perc_contribution_rescale": 1.70347003154574
        },
        {
            "Country": "Uruguay",
            "Abs_contribution": 5.6669484815174e-05,
            "Perc_contribution": 0.27,
            "Fossil_abs": 2.48601265030022e-06,
            "Land_abs": 5.4183472164875e-05,
            "Fossil_fraction": 4.38686297997641,
            "Land_fraction": 95.6131370200257,
            "Rank": 66,
            "Perc_contribution_rescale": 1.70347003154574
        },
        {
            "Country": "Chile",
            "Abs_contribution": 5.6609973165925e-05,
            "Perc_contribution": 0.27,
            "Fossil_abs": 1.85468580513373e-05,
            "Land_abs": 3.80631151145876e-05,
            "Fossil_fraction": 32.7625275443535,
            "Land_fraction": 67.2374724556463,
            "Rank": 67,
            "Perc_contribution_rescale": 1.70347003154574
        },
        {
            "Country": "Algeria",
            "Abs_contribution": 5.63725664685588e-05,
            "Perc_contribution": 0.27,
            "Fossil_abs": 2.08994223074099e-05,
            "Land_abs": 3.54731441611489e-05,
            "Fossil_fraction": 37.0737463568673,
            "Land_fraction": 62.9262536431327,
            "Rank": 68,
            "Perc_contribution_rescale": 1.70347003154574
        },
        {
            "Country": "Madagascar",
            "Abs_contribution": 5.5836946012009e-05,
            "Perc_contribution": 0.26,
            "Fossil_abs": 4.44256755081882e-06,
            "Land_abs": 5.139437846119e-05,
            "Fossil_fraction": 7.95632259304322,
            "Land_fraction": 92.0436774069564,
            "Rank": 69,
            "Perc_contribution_rescale": 1.6403785488959
        },
        {
            "Country": "Hungary",
            "Abs_contribution": 5.4845944455704e-05,
            "Perc_contribution": 0.26,
            "Fossil_abs": 1.788940488488e-05,
            "Land_abs": 3.6956539570825e-05,
            "Fossil_fraction": 32.6175527879336,
            "Land_fraction": 67.3824472120683,
            "Rank": 70,
            "Perc_contribution_rescale": 1.6403785488959
        },
        {
            "Country": "Iraq",
            "Abs_contribution": 5.085799258387e-05,
            "Perc_contribution": 0.24,
            "Fossil_abs": 2.59755849109307e-05,
            "Land_abs": 2.48824076729392e-05,
            "Fossil_fraction": 51.0747349457302,
            "Land_fraction": 48.9252650542697,
            "Rank": 71,
            "Perc_contribution_rescale": 1.51419558359621
        },
        {
            "Country": "Somalia",
            "Abs_contribution": 4.8417324536913e-05,
            "Perc_contribution": 0.23,
            "Fossil_abs": 3.95990213887828e-06,
            "Land_abs": 4.4457422398035e-05,
            "Fossil_fraction": 8.17868846895759,
            "Land_fraction": 91.821311531043,
            "Rank": 72,
            "Perc_contribution_rescale": 1.45110410094637
        },
        {
            "Country": "Nepal",
            "Abs_contribution": 4.5847685426119e-05,
            "Perc_contribution": 0.22,
            "Fossil_abs": 1.00802031707014e-05,
            "Land_abs": 3.5767482255417e-05,
            "Fossil_fraction": 21.9862858441242,
            "Land_fraction": 78.0137141558745,
            "Rank": 73,
            "Perc_contribution_rescale": 1.38801261829653
        },
        {
            "Country": "Lithuania",
            "Abs_contribution": 4.5550932555949e-05,
            "Perc_contribution": 0.21,
            "Fossil_abs": 1.79390018394924e-05,
            "Land_abs": 2.7611930716458e-05,
            "Fossil_fraction": 39.3822932548272,
            "Land_fraction": 60.6177067451759,
            "Rank": 74,
            "Perc_contribution_rescale": 1.32492113564669
        },
        {
            "Country": "Taiwan",
            "Abs_contribution": 4.55264548275659e-05,
            "Perc_contribution": 0.21,
            "Fossil_abs": 3.17090004986667e-05,
            "Land_abs": 1.38174543288988e-05,
            "Fossil_fraction": 69.6496149739012,
            "Land_fraction": 30.3503850260979,
            "Rank": 75,
            "Perc_contribution_rescale": 1.32492113564669
        },
        {
            "Country": "Czechia",
            "Abs_contribution": 4.4941069481169e-05,
            "Perc_contribution": 0.21,
            "Fossil_abs": 2.0862644491007e-05,
            "Land_abs": 2.4078424990161e-05,
            "Fossil_fraction": 46.4222252204051,
            "Land_fraction": 53.5777747795927,
            "Rank": 76,
            "Perc_contribution_rescale": 1.32492113564669
        },
        {
            "Country": "Cameroon",
            "Abs_contribution": 4.4092459546507e-05,
            "Perc_contribution": 0.21,
            "Fossil_abs": 5.46725241562495e-06,
            "Land_abs": 3.86252071308816e-05,
            "Fossil_fraction": 12.3995179036413,
            "Land_fraction": 87.6004820963577,
            "Rank": 77,
            "Perc_contribution_rescale": 1.32492113564669
        },
        {
            "Country": "Turkmenistan",
            "Abs_contribution": 4.40509979844435e-05,
            "Perc_contribution": 0.21,
            "Fossil_abs": 9.0989529225573e-06,
            "Land_abs": 3.49520450618859e-05,
            "Fossil_fraction": 20.655497806816,
            "Land_fraction": 79.3445021931833,
            "Rank": 78,
            "Perc_contribution_rescale": 1.32492113564669
        },
        {
            "Country": "Guinea",
            "Abs_contribution": 4.17506180658164e-05,
            "Perc_contribution": 0.2,
            "Fossil_abs": 3.68476435292028e-06,
            "Land_abs": 3.80658537128954e-05,
            "Fossil_fraction": 8.82565222654082,
            "Land_fraction": 91.1743477734574,
            "Rank": 79,
            "Perc_contribution_rescale": 1.26182965299685
        },
        {
            "Country": "Zimbabwe",
            "Abs_contribution": 4.1040796152798e-05,
            "Perc_contribution": 0.19,
            "Fossil_abs": 7.619518989506e-06,
            "Land_abs": 3.3421277163291e-05,
            "Fossil_fraction": 18.5657192446705,
            "Land_fraction": 81.434280755327,
            "Rank": 80,
            "Perc_contribution_rescale": 1.198738170347
        },
        {
            "Country": "Denmark",
            "Abs_contribution": 4.0187417767221e-05,
            "Perc_contribution": 0.19,
            "Fossil_abs": 8.0192456640148e-06,
            "Land_abs": 3.2168172103207e-05,
            "Fossil_fraction": 19.9546179116682,
            "Land_fraction": 80.0453820883338,
            "Rank": 81,
            "Perc_contribution_rescale": 1.198738170347
        },
        {
            "Country": "Ecuador",
            "Abs_contribution": 3.75093138862584e-05,
            "Perc_contribution": 0.18,
            "Fossil_abs": 6.2221939528657e-06,
            "Land_abs": 3.12871199333925e-05,
            "Fossil_fraction": 16.5883971424634,
            "Land_fraction": 83.4116028575361,
            "Rank": 82,
            "Perc_contribution_rescale": 1.13564668769716
        },
        {
            "Country": "Ghana",
            "Abs_contribution": 3.7460515300177e-05,
            "Perc_contribution": 0.18,
            "Fossil_abs": 5.98349405584056e-06,
            "Land_abs": 3.14770212443363e-05,
            "Fossil_fraction": 15.9728023170367,
            "Land_fraction": 84.0271976829629,
            "Rank": 83,
            "Perc_contribution_rescale": 1.13564668769716
        },
        {
            "Country": "Greece",
            "Abs_contribution": 3.7391555388414e-05,
            "Perc_contribution": 0.18,
            "Fossil_abs": 1.14145811392058e-05,
            "Land_abs": 2.5976974249209e-05,
            "Fossil_fraction": 30.5271632073981,
            "Land_fraction": 69.472836792604,
            "Rank": 84,
            "Perc_contribution_rescale": 1.13564668769716
        },
        {
            "Country": "Senegal",
            "Abs_contribution": 3.63970204305127e-05,
            "Perc_contribution": 0.17,
            "Fossil_abs": 2.79515535425764e-06,
            "Land_abs": 3.36018650762552e-05,
            "Fossil_fraction": 7.6796268518573,
            "Land_fraction": 92.3203731481431,
            "Rank": 85,
            "Perc_contribution_rescale": 1.07255520504732
        },
        {
            "Country": "Syria",
            "Abs_contribution": 3.61606680615315e-05,
            "Perc_contribution": 0.17,
            "Fossil_abs": 1.31570641645129e-05,
            "Land_abs": 2.30036038970183e-05,
            "Fossil_fraction": 36.3850140769652,
            "Land_fraction": 63.6149859230339,
            "Rank": 86,
            "Perc_contribution_rescale": 1.07255520504732
        },
        {
            "Country": "Yemen",
            "Abs_contribution": 3.47413660070555e-05,
            "Perc_contribution": 0.16,
            "Fossil_abs": 1.23081577614629e-05,
            "Land_abs": 2.24332082455923e-05,
            "Fossil_fraction": 35.4279614651977,
            "Land_fraction": 64.5720385348015,
            "Rank": 87,
            "Perc_contribution_rescale": 1.00946372239748
        },
        {
            "Country": "Afghanistan",
            "Abs_contribution": 3.3126906244201e-05,
            "Perc_contribution": 0.16,
            "Fossil_abs": 3.066511155131e-06,
            "Land_abs": 3.00603950890689e-05,
            "Fossil_fraction": 9.25685946199037,
            "Land_fraction": 90.7431405380063,
            "Rank": 88,
            "Perc_contribution_rescale": 1.00946372239748
        },
        {
            "Country": "Cambodia",
            "Abs_contribution": 3.27021686530837e-05,
            "Perc_contribution": 0.15,
            "Fossil_abs": 4.57188641024836e-06,
            "Land_abs": 2.81302822428357e-05,
            "Fossil_fraction": 13.9803768329513,
            "Land_fraction": 86.0196231670499,
            "Rank": 89,
            "Perc_contribution_rescale": 0.946372239747634
        },
        {
            "Country": "Botswana",
            "Abs_contribution": 3.2290083617276e-05,
            "Perc_contribution": 0.15,
            "Fossil_abs": 1.23998705616812e-06,
            "Land_abs": 3.1050096561108e-05,
            "Fossil_fraction": 3.84014817324504,
            "Land_fraction": 96.1598518267553,
            "Rank": 90,
            "Perc_contribution_rescale": 0.946372239747634
        },
        {
            "Country": "Guatemala",
            "Abs_contribution": 3.22578501332423e-05,
            "Perc_contribution": 0.15,
            "Fossil_abs": 6.608173665434e-06,
            "Land_abs": 2.56496764678084e-05,
            "Fossil_fraction": 20.4854745066354,
            "Land_fraction": 79.5145254933649,
            "Rank": 91,
            "Perc_contribution_rescale": 0.946372239747634
        },
        {
            "Country": "Norway",
            "Abs_contribution": 3.1500175898785e-05,
            "Perc_contribution": 0.15,
            "Fossil_abs": 1.2166426693273e-05,
            "Land_abs": 1.93337492055135e-05,
            "Fossil_fraction": 38.6233611277779,
            "Land_fraction": 61.3766388722268,
            "Rank": 92,
            "Perc_contribution_rescale": 0.946372239747634
        },
        {
            "Country": "Serbia",
            "Abs_contribution": 3.0251671231441e-05,
            "Perc_contribution": 0.14,
            "Fossil_abs": 7.9898980965843e-06,
            "Land_abs": 2.22617731348567e-05,
            "Fossil_fraction": 26.4114271091254,
            "Land_fraction": 73.5885728908746,
            "Rank": 93,
            "Perc_contribution_rescale": 0.883280757097792
        },
        {
            "Country": "Austria",
            "Abs_contribution": 2.9453956368627e-05,
            "Perc_contribution": 0.14,
            "Fossil_abs": 1.12638887100368e-05,
            "Land_abs": 1.81900676585904e-05,
            "Fossil_fraction": 38.2423623131138,
            "Land_fraction": 61.7576376868868,
            "Rank": 94,
            "Perc_contribution_rescale": 0.883280757097792
        },
        {
            "Country": "Cuba",
            "Abs_contribution": 2.9453384454489e-05,
            "Perc_contribution": 0.14,
            "Fossil_abs": 7.7193173549304e-06,
            "Land_abs": 2.1734067099559e-05,
            "Fossil_fraction": 26.208591976444,
            "Land_fraction": 73.7914080235574,
            "Rank": 95,
            "Perc_contribution_rescale": 0.883280757097792
        },
        {
            "Country": "Bulgaria",
            "Abs_contribution": 2.8951031648294e-05,
            "Perc_contribution": 0.14,
            "Fossil_abs": 5.5711862538209e-06,
            "Land_abs": 2.3379845394473e-05,
            "Fossil_fraction": 19.2434809284221,
            "Land_fraction": 80.7565190715776,
            "Rank": 96,
            "Perc_contribution_rescale": 0.883280757097792
        },
        {
            "Country": "Namibia",
            "Abs_contribution": 2.8860968768728e-05,
            "Perc_contribution": 0.14,
            "Fossil_abs": 1.48484137384553e-06,
            "Land_abs": 2.73761273948825e-05,
            "Fossil_fraction": 5.14480780511573,
            "Land_fraction": 94.8551921948843,
            "Rank": 97,
            "Perc_contribution_rescale": 0.883280757097792
        },
        {
            "Country": "Malawi",
            "Abs_contribution": 2.80957741215352e-05,
            "Perc_contribution": 0.13,
            "Fossil_abs": 3.7737063324113e-06,
            "Land_abs": 2.43220677891239e-05,
            "Fossil_fraction": 13.4315798386163,
            "Land_fraction": 86.5684201613837,
            "Rank": 98,
            "Perc_contribution_rescale": 0.82018927444795
        },
        {
            "Country": "C\xf4te d'Ivoire",
            "Abs_contribution": 2.60977462378821e-05,
            "Perc_contribution": 0.12,
            "Fossil_abs": 5.72016705904752e-06,
            "Land_abs": 2.03775791788346e-05,
            "Fossil_fraction": 21.9182415481703,
            "Land_fraction": 78.0817584518298,
            "Rank": 99,
            "Perc_contribution_rescale": 0.757097791798107
        },
        {
            "Country": "Azerbaijan",
            "Abs_contribution": 2.57973432843218e-05,
            "Perc_contribution": 0.12,
            "Fossil_abs": 3.6158419253835e-06,
            "Land_abs": 2.21815013589383e-05,
            "Fossil_fraction": 14.0163344943392,
            "Land_fraction": 85.9836655056608,
            "Rank": 100,
            "Perc_contribution_rescale": 0.757097791798107
        },
        {
            "Country": "Portugal",
            "Abs_contribution": 2.5228919163046e-05,
            "Perc_contribution": 0.12,
            "Fossil_abs": 9.37996351186e-06,
            "Land_abs": 1.58489556511859e-05,
            "Fossil_fraction": 37.1794108627502,
            "Land_fraction": 62.8205891372493,
            "Rank": 101,
            "Perc_contribution_rescale": 0.757097791798107
        },
        {
            "Country": "Tunisia",
            "Abs_contribution": 2.36112283066048e-05,
            "Perc_contribution": 0.11,
            "Fossil_abs": 6.6851502348635e-06,
            "Land_abs": 1.69260780717412e-05,
            "Fossil_fraction": 28.3134369294691,
            "Land_fraction": 71.6865630705305,
            "Rank": 102,
            "Perc_contribution_rescale": 0.694006309148265
        },
        {
            "Country": "Dominican Republic",
            "Abs_contribution": 2.35614263259375e-05,
            "Perc_contribution": 0.11,
            "Fossil_abs": 3.862514492354e-06,
            "Land_abs": 1.96989118335835e-05,
            "Fossil_fraction": 16.3933814486518,
            "Land_fraction": 83.6066185513482,
            "Rank": 103,
            "Perc_contribution_rescale": 0.694006309148265
        },
        {
            "Country": "Slovakia",
            "Abs_contribution": 2.31411262082546e-05,
            "Perc_contribution": 0.11,
            "Fossil_abs": 1.36830504495728e-05,
            "Land_abs": 9.4580757586818e-06,
            "Fossil_fraction": 59.1287145078184,
            "Land_fraction": 40.8712854921816,
            "Rank": 104,
            "Perc_contribution_rescale": 0.694006309148265
        },
        {
            "Country": "Nicaragua",
            "Abs_contribution": 2.23324756635876e-05,
            "Perc_contribution": 0.11,
            "Fossil_abs": 1.96939497530977e-06,
            "Land_abs": 2.03630806882778e-05,
            "Fossil_fraction": 8.8185251155151,
            "Land_fraction": 91.1814748844848,
            "Rank": 105,
            "Perc_contribution_rescale": 0.694006309148265
        },
        {
            "Country": "Mauritania",
            "Abs_contribution": 2.16632603059143e-05,
            "Perc_contribution": 0.1,
            "Fossil_abs": 1.26364755711517e-06,
            "Land_abs": 2.03996127487991e-05,
            "Fossil_fraction": 5.83313656056739,
            "Land_fraction": 94.1668634394325,
            "Rank": 106,
            "Perc_contribution_rescale": 0.630914826498423
        },
        {
            "Country": "Laos",
            "Abs_contribution": 1.98423725363401e-05,
            "Perc_contribution": 0.09,
            "Fossil_abs": 2.19025927753821e-06,
            "Land_abs": 1.76521132588018e-05,
            "Fossil_fraction": 11.0382932964638,
            "Land_fraction": 88.9617067035357,
            "Rank": 107,
            "Perc_contribution_rescale": 0.56782334384858
        },
        {
            "Country": "Honduras",
            "Abs_contribution": 1.95472343032124e-05,
            "Perc_contribution": 0.09,
            "Fossil_abs": 3.66212882242631e-06,
            "Land_abs": 1.5885105480786e-05,
            "Fossil_fraction": 18.734767106283,
            "Land_fraction": 81.2652328937165,
            "Rank": 108,
            "Perc_contribution_rescale": 0.56782334384858
        },
        {
            "Country": "Sri Lanka",
            "Abs_contribution": 1.9226949834068e-05,
            "Perc_contribution": 0.09,
            "Fossil_abs": 6.8933352055799e-06,
            "Land_abs": 1.2333614628488e-05,
            "Fossil_fraction": 35.8524636776536,
            "Land_fraction": 64.147536322346,
            "Rank": 109,
            "Perc_contribution_rescale": 0.56782334384858
        },
        {
            "Country": "Croatia",
            "Abs_contribution": 1.90080421125574e-05,
            "Perc_contribution": 0.09,
            "Fossil_abs": 8.829175565363e-06,
            "Land_abs": 1.01788665471943e-05,
            "Fossil_fraction": 46.4496843655988,
            "Land_fraction": 53.5503156344007,
            "Rank": 110,
            "Perc_contribution_rescale": 0.56782334384858
        },
        {
            "Country": "North Korea",
            "Abs_contribution": 1.8988480005856e-05,
            "Perc_contribution": 0.09,
            "Fossil_abs": 5.0348789839602e-06,
            "Land_abs": 1.39536010218955e-05,
            "Fossil_fraction": 26.515439795115,
            "Land_fraction": 73.4845602048834,
            "Rank": 111,
            "Perc_contribution_rescale": 0.56782334384858
        },
        {
            "Country": "Benin",
            "Abs_contribution": 1.84833418843763e-05,
            "Perc_contribution": 0.09,
            "Fossil_abs": 2.91972238418122e-06,
            "Land_abs": 1.55636195001952e-05,
            "Fossil_fraction": 15.7965069436346,
            "Land_fraction": 84.2034930563661,
            "Rank": 112,
            "Perc_contribution_rescale": 0.56782334384858
        },
        {
            "Country": "Israel",
            "Abs_contribution": 1.77325719640939e-05,
            "Perc_contribution": 0.08,
            "Fossil_abs": 9.8414638838892e-06,
            "Land_abs": 7.8911080802047e-06,
            "Fossil_fraction": 55.4993596180907,
            "Land_fraction": 44.5006403819093,
            "Rank": 113,
            "Perc_contribution_rescale": 0.504731861198738
        },
        {
            "Country": "Switzerland",
            "Abs_contribution": 1.76967362815695e-05,
            "Perc_contribution": 0.08,
            "Fossil_abs": 5.4138009047939e-06,
            "Land_abs": 1.22829353767753e-05,
            "Fossil_fraction": 30.5920866913306,
            "Land_fraction": 69.4079133086676,
            "Rank": 114,
            "Perc_contribution_rescale": 0.504731861198738
        },
        {
            "Country": "United Arab Emirates",
            "Abs_contribution": 1.75795679051897e-05,
            "Perc_contribution": 0.08,
            "Fossil_abs": 1.24974075795892e-05,
            "Land_abs": 5.08216032560044e-06,
            "Fossil_fraction": 71.0905276340712,
            "Land_fraction": 28.9094723659284,
            "Rank": 115,
            "Perc_contribution_rescale": 0.504731861198738
        },
        {
            "Country": "Latvia",
            "Abs_contribution": 1.60170964897719e-05,
            "Perc_contribution": 0.08,
            "Fossil_abs": 1.8831028564602e-06,
            "Land_abs": 1.41339936333119e-05,
            "Fossil_fraction": 11.7568303197942,
            "Land_fraction": 88.2431696802071,
            "Rank": 116,
            "Perc_contribution_rescale": 0.504731861198738
        },
        {
            "Country": "Libya",
            "Abs_contribution": 1.44566572013401e-05,
            "Perc_contribution": 0.07,
            "Fossil_abs": 5.31818833124183e-06,
            "Land_abs": 9.1384688700983e-06,
            "Fossil_fraction": 36.7871234489038,
            "Land_fraction": 63.2128765510964,
            "Rank": 117,
            "Perc_contribution_rescale": 0.441640378548896
        },
        {
            "Country": "Georgia",
            "Abs_contribution": 1.35811683840803e-05,
            "Perc_contribution": 0.06,
            "Fossil_abs": 6.943028593866e-06,
            "Land_abs": 6.6381397902143e-06,
            "Fossil_fraction": 51.122468977003,
            "Land_fraction": 48.8775310229969,
            "Rank": 118,
            "Perc_contribution_rescale": 0.378548895899054
        },
        {
            "Country": "Tajikistan",
            "Abs_contribution": 1.3410415783776e-05,
            "Perc_contribution": 0.06,
            "Fossil_abs": 1.02876662534935e-06,
            "Land_abs": 1.23816491584265e-05,
            "Fossil_fraction": 7.67139991732365,
            "Land_fraction": 92.3286000826752,
            "Rank": 119,
            "Perc_contribution_rescale": 0.378548895899054
        },
        {
            "Country": "Kyrgyzstan",
            "Abs_contribution": 1.28460913599031e-05,
            "Perc_contribution": 0.06,
            "Fossil_abs": 1.47062108288073e-06,
            "Land_abs": 1.13754702770224e-05,
            "Fossil_fraction": 11.4480042347435,
            "Land_fraction": 88.5519957652567,
            "Rank": 120,
            "Perc_contribution_rescale": 0.378548895899054
        },
        {
            "Country": "Estonia",
            "Abs_contribution": 1.27207410461136e-05,
            "Perc_contribution": 0.06,
            "Fossil_abs": 1.55762877056906e-06,
            "Land_abs": 1.11631122755445e-05,
            "Fossil_fraction": 12.2447958410799,
            "Land_fraction": 87.7552041589197,
            "Rank": 121,
            "Perc_contribution_rescale": 0.378548895899054
        },
        {
            "Country": "Haiti",
            "Abs_contribution": 1.2608973668503e-05,
            "Perc_contribution": 0.06,
            "Fossil_abs": 3.04622969305677e-06,
            "Land_abs": 9.5627439754462e-06,
            "Fossil_fraction": 24.1592200376007,
            "Land_fraction": 75.8407799623991,
            "Rank": 122,
            "Perc_contribution_rescale": 0.378548895899054
        },
        {
            "Country": "Papua New Guinea",
            "Abs_contribution": 1.24715569007506e-05,
            "Perc_contribution": 0.06,
            "Fossil_abs": 1.46413176298035e-06,
            "Land_abs": 1.10074251377702e-05,
            "Fossil_fraction": 11.7397673332367,
            "Land_fraction": 88.2602326667629,
            "Rank": 123,
            "Perc_contribution_rescale": 0.378548895899054
        },
        {
            "Country": "Rwanda",
            "Abs_contribution": 1.23341836043736e-05,
            "Perc_contribution": 0.06,
            "Fossil_abs": 2.07778033891376e-06,
            "Land_abs": 1.02564032654599e-05,
            "Fossil_fraction": 16.8457062547455,
            "Land_fraction": 83.154293745255,
            "Rank": 124,
            "Perc_contribution_rescale": 0.378548895899054
        },
        {
            "Country": "Congo",
            "Abs_contribution": 1.19973404875014e-05,
            "Perc_contribution": 0.06,
            "Fossil_abs": 1.48942551399564e-06,
            "Land_abs": 1.05079149735057e-05,
            "Fossil_fraction": 12.4146306887539,
            "Land_fraction": 87.5853693112457,
            "Rank": 125,
            "Perc_contribution_rescale": 0.378548895899054
        },
        {
            "Country": "Costa Rica",
            "Abs_contribution": 1.19582691872203e-05,
            "Perc_contribution": 0.06,
            "Fossil_abs": 1.93106367192822e-06,
            "Land_abs": 1.0027205515292e-05,
            "Fossil_fraction": 16.1483542617683,
            "Land_fraction": 83.851645738231,
            "Rank": 126,
            "Perc_contribution_rescale": 0.378548895899054
        },
        {
            "Country": "Eritrea",
            "Abs_contribution": 1.18719301915734e-05,
            "Perc_contribution": 0.06,
            "Fossil_abs": 8.8179902673308e-07,
            "Land_abs": 1.09901311648403e-05,
            "Fossil_fraction": 7.42759612382975,
            "Land_fraction": 92.5724038761701,
            "Rank": 127,
            "Perc_contribution_rescale": 0.378548895899054
        },
        {
            "Country": "Togo",
            "Abs_contribution": 1.16618886882315e-05,
            "Perc_contribution": 0.05,
            "Fossil_abs": 1.8722450198417e-06,
            "Land_abs": 9.7896436683898e-06,
            "Fossil_fraction": 16.0543893866099,
            "Land_fraction": 83.9456106133901,
            "Rank": 128,
            "Perc_contribution_rescale": 0.315457413249211
        },
        {
            "Country": "Jordan",
            "Abs_contribution": 1.08186142993968e-05,
            "Perc_contribution": 0.05,
            "Fossil_abs": 6.84503631902703e-06,
            "Land_abs": 3.97357798036978e-06,
            "Fossil_fraction": 63.2709155682598,
            "Land_fraction": 36.7290844317403,
            "Rank": 129,
            "Perc_contribution_rescale": 0.315457413249211
        },
        {
            "Country": "Trinidad and Tobago",
            "Abs_contribution": 1.02814238082233e-05,
            "Perc_contribution": 0.05,
            "Fossil_abs": 8.9199624818343e-06,
            "Land_abs": 1.36146132638892e-06,
            "Fossil_fraction": 86.758046825187,
            "Land_fraction": 13.2419531748122,
            "Rank": 130,
            "Perc_contribution_rescale": 0.315457413249211
        },
        {
            "Country": "Burundi",
            "Abs_contribution": 9.77592531445e-06,
            "Perc_contribution": 0.05,
            "Fossil_abs": 2.38870518485944e-06,
            "Land_abs": 7.3872201295906e-06,
            "Fossil_fraction": 24.4345686778994,
            "Land_fraction": 75.565431322101,
            "Rank": 131,
            "Perc_contribution_rescale": 0.315457413249211
        },
        {
            "Country": "Sierra Leone",
            "Abs_contribution": 9.6972420755363e-06,
            "Perc_contribution": 0.05,
            "Fossil_abs": 1.88120765939001e-06,
            "Land_abs": 7.8160344161463e-06,
            "Fossil_fraction": 19.3994090766881,
            "Land_fraction": 80.6005909233119,
            "Rank": 132,
            "Perc_contribution_rescale": 0.315457413249211
        },
        {
            "Country": "Bosnia and Herzegovina",
            "Abs_contribution": 9.5843691898649e-06,
            "Perc_contribution": 0.05,
            "Fossil_abs": 2.04577516565912e-06,
            "Land_abs": 7.5385940242058e-06,
            "Fossil_fraction": 21.3449119616808,
            "Land_fraction": 78.6550880383194,
            "Rank": 133,
            "Perc_contribution_rescale": 0.315457413249211
        },
        {
            "Country": "Panama",
            "Abs_contribution": 9.4777658207218e-06,
            "Perc_contribution": 0.04,
            "Fossil_abs": 1.65967920158433e-06,
            "Land_abs": 7.8180866191376e-06,
            "Fossil_fraction": 17.5112915108714,
            "Land_fraction": 82.4887084891299,
            "Rank": 134,
            "Perc_contribution_rescale": 0.252365930599369
        },
        {
            "Country": "El Salvador",
            "Abs_contribution": 9.2183250124577e-06,
            "Perc_contribution": 0.04,
            "Fossil_abs": 1.75853366280294e-06,
            "Land_abs": 7.4597913496547e-06,
            "Fossil_fraction": 19.0764988262667,
            "Land_fraction": 80.9235011737326,
            "Rank": 135,
            "Perc_contribution_rescale": 0.252365930599369
        },
        {
            "Country": "Oman",
            "Abs_contribution": 8.30303960157069e-06,
            "Perc_contribution": 0.04,
            "Fossil_abs": 4.12374764657751e-06,
            "Land_abs": 4.17929195499318e-06,
            "Fossil_fraction": 49.6655182253668,
            "Land_fraction": 50.3344817746333,
            "Rank": 136,
            "Perc_contribution_rescale": 0.252365930599369
        },
        {
            "Country": "Albania",
            "Abs_contribution": 8.1030096568273e-06,
            "Perc_contribution": 0.04,
            "Fossil_abs": 1.08006255343887e-06,
            "Land_abs": 7.0229471033883e-06,
            "Fossil_fraction": 13.3291529836553,
            "Land_fraction": 86.6708470163432,
            "Rank": 137,
            "Perc_contribution_rescale": 0.252365930599369
        },
        {
            "Country": "Lebanon",
            "Abs_contribution": 7.9411033216253e-06,
            "Perc_contribution": 0.04,
            "Fossil_abs": 4.46639695822189e-06,
            "Land_abs": 3.47470636340338e-06,
            "Fossil_fraction": 56.2440353352279,
            "Land_fraction": 43.7559646647717,
            "Rank": 138,
            "Perc_contribution_rescale": 0.252365930599369
        },
        {
            "Country": "Armenia",
            "Abs_contribution": 7.6748654023526e-06,
            "Perc_contribution": 0.04,
            "Fossil_abs": 1.06528203987445e-06,
            "Land_abs": 6.6095833624782e-06,
            "Fossil_fraction": 13.8801397031394,
            "Land_fraction": 86.1198602968613,
            "Rank": 139,
            "Perc_contribution_rescale": 0.252365930599369
        },
        {
            "Country": "Kuwait",
            "Abs_contribution": 7.37222400488809e-06,
            "Perc_contribution": 0.03,
            "Fossil_abs": 5.33954556233356e-06,
            "Land_abs": 2.03267844255458e-06,
            "Fossil_fraction": 72.4278800914516,
            "Land_fraction": 27.572119908549,
            "Rank": 140,
            "Perc_contribution_rescale": 0.189274447949527
        },
        {
            "Country": "Moldova",
            "Abs_contribution": 7.1342347468313e-06,
            "Perc_contribution": 0.03,
            "Fossil_abs": 1.3885053387445e-06,
            "Land_abs": 5.7457294080868e-06,
            "Fossil_fraction": 19.4625686989233,
            "Land_fraction": 80.5374313010767,
            "Rank": 141,
            "Perc_contribution_rescale": 0.189274447949527
        },
        {
            "Country": "Slovenia",
            "Abs_contribution": 6.126323120494e-06,
            "Perc_contribution": 0.03,
            "Fossil_abs": 2.09703678135917e-06,
            "Land_abs": 4.0292863391348e-06,
            "Fossil_fraction": 34.229940865249,
            "Land_fraction": 65.7700591347506,
            "Rank": 142,
            "Perc_contribution_rescale": 0.189274447949527
        },
        {
            "Country": "Guinea-Bissau",
            "Abs_contribution": 5.7618236890734e-06,
            "Perc_contribution": 0.03,
            "Fossil_abs": 6.8334402189547e-07,
            "Land_abs": 5.0784796671779e-06,
            "Fossil_fraction": 11.8598565102113,
            "Land_fraction": 88.1401434897881,
            "Rank": 143,
            "Perc_contribution_rescale": 0.189274447949527
        },
        {
            "Country": "Singapore",
            "Abs_contribution": 5.26318834936e-06,
            "Perc_contribution": 0.02,
            "Fossil_abs": 5.1401750698743e-06,
            "Land_abs": 1.2301327948571e-07,
            "Fossil_fraction": 97.6627612139196,
            "Land_fraction": 2.33723878608046,
            "Rank": 144,
            "Perc_contribution_rescale": 0.126182965299685
        },
        {
            "Country": "Qatar",
            "Abs_contribution": 4.98106797370497e-06,
            "Perc_contribution": 0.02,
            "Fossil_abs": 4.00260439809579e-06,
            "Land_abs": 9.78463575609174e-07,
            "Fossil_fraction": 80.356349666889,
            "Land_fraction": 19.6436503331108,
            "Rank": 145,
            "Perc_contribution_rescale": 0.126182965299685
        },
        {
            "Country": "Lesotho",
            "Abs_contribution": 4.8976538910426e-06,
            "Perc_contribution": 0.02,
            "Fossil_abs": 1.13970524380595e-06,
            "Land_abs": 3.7579486472366e-06,
            "Fossil_fraction": 23.2704325205661,
            "Land_fraction": 76.7295674794329,
            "Rank": 146,
            "Perc_contribution_rescale": 0.126182965299685
        },
        {
            "Country": "Hong Kong",
            "Abs_contribution": 4.8761386951024e-06,
            "Perc_contribution": 0.02,
            "Fossil_abs": 4.70081596777367e-06,
            "Land_abs": 1.7532272732866e-07,
            "Fossil_fraction": 96.4044761994808,
            "Land_fraction": 3.5955238005177,
            "Rank": 147,
            "Perc_contribution_rescale": 0.126182965299685
        },
        {
            "Country": "Gabon",
            "Abs_contribution": 4.47793206805268e-06,
            "Perc_contribution": 0.02,
            "Fossil_abs": 2.4968604489158e-06,
            "Land_abs": 1.98107161913687e-06,
            "Fossil_fraction": 55.7592301752271,
            "Land_fraction": 44.2407698247727,
            "Rank": 148,
            "Perc_contribution_rescale": 0.126182965299685
        },
        {
            "Country": "North Macedonia",
            "Abs_contribution": 4.0575110271657e-06,
            "Perc_contribution": 0.02,
            "Fossil_abs": 9.1981556834198e-07,
            "Land_abs": 3.1376954588237e-06,
            "Fossil_fraction": 22.6694533220899,
            "Land_fraction": 77.3305466779096,
            "Rank": 149,
            "Perc_contribution_rescale": 0.126182965299685
        },
        {
            "Country": "Guyana",
            "Abs_contribution": 3.98401742958656e-06,
            "Perc_contribution": 0.02,
            "Fossil_abs": 6.8619313043941e-07,
            "Land_abs": 3.29782429914712e-06,
            "Fossil_fraction": 17.2236478019279,
            "Land_fraction": 82.7763521980714,
            "Rank": 150,
            "Perc_contribution_rescale": 0.126182965299685
        },
        {
            "Country": "Liberia",
            "Abs_contribution": 3.77829606630454e-06,
            "Perc_contribution": 0.02,
            "Fossil_abs": 1.96569391878029e-06,
            "Land_abs": 1.81260214752429e-06,
            "Fossil_fraction": 52.0259366731651,
            "Land_fraction": 47.9740633268359,
            "Rank": 151,
            "Perc_contribution_rescale": 0.126182965299685
        },
        {
            "Country": "Swaziland",
            "Abs_contribution": 3.5935479082778e-06,
            "Perc_contribution": 0.02,
            "Fossil_abs": 6.7858937707697e-07,
            "Land_abs": 2.9149585312009e-06,
            "Fossil_fraction": 18.8835489159287,
            "Land_fraction": 81.1164510840733,
            "Rank": 152,
            "Perc_contribution_rescale": 0.126182965299685
        },
        {
            "Country": "Jamaica",
            "Abs_contribution": 3.2426516857451e-06,
            "Perc_contribution": 0.02,
            "Fossil_abs": 1.37551073649072e-06,
            "Land_abs": 1.86714094925436e-06,
            "Fossil_fraction": 42.4193181937348,
            "Land_fraction": 57.5806818062646,
            "Rank": 153,
            "Perc_contribution_rescale": 0.126182965299685
        },
        {
            "Country": "Gambia",
            "Abs_contribution": 2.76032724625955e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 3.9254888161572e-07,
            "Land_abs": 2.36777836464383e-06,
            "Fossil_fraction": 14.2210994057916,
            "Land_fraction": 85.7789005942085,
            "Rank": 154,
            "Perc_contribution_rescale": 0.0630914826498423
        },
        {
            "Country": "Iceland",
            "Abs_contribution": 2.7531241770237e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 3.633869404012e-07,
            "Land_abs": 2.3897372366225e-06,
            "Fossil_fraction": 13.1990755605526,
            "Land_fraction": 86.8009244394475,
            "Rank": 155,
            "Perc_contribution_rescale": 0.0630914826498423
        },
        {
            "Country": "Cyprus",
            "Abs_contribution": 2.70391873525794e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 1.04561245216375e-06,
            "Land_abs": 1.65830628309416e-06,
            "Fossil_fraction": 38.6702617400964,
            "Land_fraction": 61.3297382599025,
            "Rank": 156,
            "Perc_contribution_rescale": 0.0630914826498423
        },
        {
            "Country": "Luxembourg",
            "Abs_contribution": 2.5078362274577e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 9.9323890235985e-07,
            "Land_abs": 1.51459732509784e-06,
            "Fossil_fraction": 39.6054132835755,
            "Land_fraction": 60.3945867164241,
            "Rank": 157,
            "Perc_contribution_rescale": 0.0630914826498423
        },
        {
            "Country": "Fiji",
            "Abs_contribution": 2.0314778949531e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 4.0247812490256e-07,
            "Land_abs": 1.62899977005049e-06,
            "Fossil_fraction": 19.8120848817728,
            "Land_fraction": 80.1879151182247,
            "Rank": 158,
            "Perc_contribution_rescale": 0.0630914826498423
        },
        {
            "Country": "Djibouti",
            "Abs_contribution": 2.02567623295702e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 2.83673989261326e-07,
            "Land_abs": 1.74200224369569e-06,
            "Fossil_fraction": 14.0039155639017,
            "Land_fraction": 85.9960844360981,
            "Rank": 159,
            "Perc_contribution_rescale": 0.0630914826498423
        },
        {
            "Country": "Timor-Leste",
            "Abs_contribution": 1.81078507230254e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 1.71367672321916e-07,
            "Land_abs": 1.63941739998062e-06,
            "Fossil_fraction": 9.46372238998028,
            "Land_fraction": 90.5362776100195,
            "Rank": 160,
            "Perc_contribution_rescale": 0.0630914826498423
        },
        {
            "Country": "Suriname",
            "Abs_contribution": 1.74277498796602e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 6.08677677003689e-07,
            "Land_abs": 1.13409731096234e-06,
            "Fossil_fraction": 34.9257753414325,
            "Land_fraction": 65.074224658568,
            "Rank": 161,
            "Perc_contribution_rescale": 0.0630914826498423
        },
        {
            "Country": "Bahrain",
            "Abs_contribution": 1.64679743803903e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 1.48151344113152e-06,
            "Land_abs": 1.65283996907505e-07,
            "Fossil_fraction": 89.9633073813664,
            "Land_fraction": 10.0366926186333,
            "Rank": 162,
            "Perc_contribution_rescale": 0.0630914826498423
        },
        {
            "Country": "Montenegro",
            "Abs_contribution": 1.56710858671179e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 7.3602863668395e-07,
            "Land_abs": 8.3107995002784e-07,
            "Fossil_fraction": 46.967302899433,
            "Land_fraction": 53.032697100567,
            "Rank": 163,
            "Perc_contribution_rescale": 0.0630914826498423
        },
        {
            "Country": "Mauritius",
            "Abs_contribution": 1.54509036327389e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 7.0589751492085e-07,
            "Land_abs": 8.3919284835303e-07,
            "Fossil_fraction": 45.6864874508132,
            "Land_fraction": 54.3135125491862,
            "Rank": 164,
            "Perc_contribution_rescale": 0.0630914826498423
        },
        {
            "Country": "Bhutan",
            "Abs_contribution": 1.39001088672954e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 7.26356685912941e-07,
            "Land_abs": 6.6365420081659e-07,
            "Fossil_fraction": 52.2554674101823,
            "Land_fraction": 47.744532589817,
            "Rank": 165,
            "Perc_contribution_rescale": 0.0630914826498423
        },
        {
            "Country": "Belize",
            "Abs_contribution": 1.20944544708979e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 1.44665168437091e-07,
            "Land_abs": 1.0647802786527e-06,
            "Fossil_fraction": 11.9612809974348,
            "Land_fraction": 88.0387190025653,
            "Rank": 166,
            "Perc_contribution_rescale": 0.0630914826498423
        },
        {
            "Country": "Brunei Darussalam",
            "Abs_contribution": 9.2359743663414e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 3.51066043658024e-07,
            "Land_abs": 5.72531392976118e-07,
            "Fossil_fraction": 38.0107208761224,
            "Land_fraction": 61.9892791238779,
            "Rank": 167,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Vanuatu",
            "Abs_contribution": 8.4982367489124e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 6.7039906749318e-08,
            "Land_abs": 7.8278376814192e-07,
            "Fossil_fraction": 7.88868429182062,
            "Land_fraction": 92.1113157081791,
            "Rank": 168,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Cape Verde",
            "Abs_contribution": 6.1306327000587e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 2.15521762378412e-07,
            "Land_abs": 3.9754150762746e-07,
            "Fossil_fraction": 35.1548972060173,
            "Land_fraction": 64.845102793983,
            "Rank": 169,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Bahamas",
            "Abs_contribution": 5.2762107187091e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 3.6734001178056e-07,
            "Land_abs": 1.60281060090352e-07,
            "Fossil_fraction": 69.6219372888191,
            "Land_fraction": 30.3780627111813,
            "Rank": 170,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Comoros",
            "Abs_contribution": 4.7247819505349e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 1.48185179473116e-07,
            "Land_abs": 3.2429301558038e-07,
            "Fossil_fraction": 31.3633901044555,
            "Land_fraction": 68.6366098955458,
            "Rank": 171,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Barbados",
            "Abs_contribution": 4.4605635200764e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 2.17555300708379e-07,
            "Land_abs": 2.2850105129927e-07,
            "Fossil_fraction": 48.7730529403273,
            "Land_fraction": 51.2269470596747,
            "Rank": 172,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Malta",
            "Abs_contribution": 4.0067152411859e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 2.22840696845142e-07,
            "Land_abs": 1.77830827273444e-07,
            "Fossil_fraction": 55.6168041478251,
            "Land_fraction": 44.3831958521739,
            "Rank": 173,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Samoa",
            "Abs_contribution": 3.8840362778466e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 7.636224857178e-08,
            "Land_abs": 3.1204137921288e-07,
            "Fossil_fraction": 19.6605394772772,
            "Land_fraction": 80.3394605227228,
            "Rank": 174,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Equatorial Guinea",
            "Abs_contribution": 3.84626186540666e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 2.94848602998186e-07,
            "Land_abs": 8.9777583542481e-08,
            "Fossil_fraction": 76.6584838255708,
            "Land_fraction": 23.3415161744295,
            "Rank": 175,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Tonga",
            "Abs_contribution": 3.44361419968067e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 2.07214647323089e-07,
            "Land_abs": 1.37146772644978e-07,
            "Fossil_fraction": 60.1735953296697,
            "Land_fraction": 39.8264046703303,
            "Rank": 176,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Maldives",
            "Abs_contribution": 3.39586066251747e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 3.29746822358557e-07,
            "Land_abs": 9.83924389319055e-09,
            "Fossil_fraction": 97.1025772636102,
            "Land_fraction": 2.89742273639001,
            "Rank": 177,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Andorra",
            "Abs_contribution": 3.2103457043409e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 7.31184885380729e-08,
            "Land_abs": 2.47916081896016e-07,
            "Fossil_fraction": 22.7758924651651,
            "Land_fraction": 77.2241075348346,
            "Rank": 178,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Solomon Islands",
            "Abs_contribution": 2.43568933276883e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 1.25169107860194e-07,
            "Land_abs": 1.1839982541669e-07,
            "Fossil_fraction": 51.3896030073363,
            "Land_fraction": 48.6103969926641,
            "Rank": 179,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Palau",
            "Abs_contribution": 2.321344263639e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 2.3167689735037e-07,
            "Land_abs": 4.5752901353548e-10,
            "Fossil_fraction": 99.8029034207908,
            "Land_fraction": 0.197096579211498,
            "Rank": 180,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Macao",
            "Abs_contribution": 2.30001704082805e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 2.09430059635194e-07,
            "Land_abs": 2.05716444476119e-08,
            "Fossil_fraction": 91.0558730294429,
            "Land_fraction": 8.94412697055746,
            "Rank": 181,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Lucia",
            "Abs_contribution": 1.7758701383458e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 8.5577641835822e-08,
            "Land_abs": 9.2009371998758e-08,
            "Fossil_fraction": 48.1891327456728,
            "Land_fraction": 51.8108672543272,
            "Rank": 182,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Seychelles",
            "Abs_contribution": 1.6388358449345e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 1.40537941924839e-07,
            "Land_abs": 2.3345642568611e-08,
            "Fossil_fraction": 85.7547400853048,
            "Land_fraction": 14.2452599146952,
            "Rank": 183,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Antigua and Barbuda",
            "Abs_contribution": 1.60534725770633e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 9.4862263265421e-08,
            "Land_abs": 6.5672462505213e-08,
            "Fossil_fraction": 59.0914288544382,
            "Land_fraction": 40.9085711455625,
            "Rank": 184,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Sao Tome and Principe",
            "Abs_contribution": 1.37336236906318e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 5.92325818281794e-08,
            "Land_abs": 7.8103655078139e-08,
            "Fossil_fraction": 43.1296088799812,
            "Land_fraction": 56.870391120019,
            "Rank": 185,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Dominica",
            "Abs_contribution": 1.18159932392686e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 3.88747683560046e-08,
            "Land_abs": 7.9285164036681e-08,
            "Fossil_fraction": 32.9001274533658,
            "Land_fraction": 67.0998725466338,
            "Rank": 186,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Micronesia (Federated States of)",
            "Abs_contribution": 1.10454861342699e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 1.733445687543e-14,
            "Land_abs": 1.10454844008242e-07,
            "Fossil_fraction": 1.56937020831051e-05,
            "Land_fraction": 99.9999843062977,
            "Rank": 187,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Grenada",
            "Abs_contribution": 1.03524436681605e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 5.66750640515016e-08,
            "Land_abs": 4.6849372630103e-08,
            "Fossil_fraction": 54.7455903824995,
            "Land_fraction": 45.2544096175,
            "Rank": 188,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Vincent and the Grenadines",
            "Abs_contribution": 9.4465657039029e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 4.66793372214385e-08,
            "Land_abs": 4.778631981759e-08,
            "Fossil_fraction": 49.4140819897676,
            "Land_fraction": 50.5859180102318,
            "Rank": 189,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Liechtenstein",
            "Abs_contribution": 7.1663798743109e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 2.4699860228711e-08,
            "Land_abs": 4.6963938514397e-08,
            "Fossil_fraction": 34.4663005058549,
            "Land_fraction": 65.5336994941437,
            "Rank": 190,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Kitts and Nevis",
            "Abs_contribution": 7.0703341852156e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 3.92264854695691e-08,
            "Land_abs": 3.1476856382588e-08,
            "Fossil_fraction": 55.4803838715199,
            "Land_fraction": 44.5196161284818,
            "Rank": 191,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Aruba",
            "Abs_contribution": 6.84654638380597e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 6.79981769931987e-08,
            "Land_abs": 4.67286844861081e-10,
            "Fossil_fraction": 99.3174853149812,
            "Land_fraction": 0.682514685018928,
            "Rank": 192,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Kiribati",
            "Abs_contribution": 4.79164997446502e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 2.54797697767058e-08,
            "Land_abs": 2.24367299679449e-08,
            "Fossil_fraction": 53.1753569490446,
            "Land_fraction": 46.8246430509564,
            "Rank": 193,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Cook Islands",
            "Abs_contribution": 3.2945424438782e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 1.37622348878753e-08,
            "Land_abs": 1.91831895509075e-08,
            "Fossil_fraction": 41.7728261884978,
            "Land_fraction": 58.2271738115046,
            "Rank": 194,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Turks and Caicos Islands",
            "Abs_contribution": 1.21269880008569e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 1.20409304135207e-08,
            "Land_abs": 8.60575873362445e-11,
            "Fossil_fraction": 99.2903630536278,
            "Land_fraction": 0.709636946372532,
            "Rank": 195,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Tuvalu",
            "Abs_contribution": 1.0312105133024e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 1.19957215106987e-09,
            "Land_abs": 9.1125329819541e-09,
            "Fossil_fraction": 11.6326602143368,
            "Land_fraction": 88.3673397856629,
            "Rank": 196,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Nauru",
            "Abs_contribution": 4.2107252264042e-09,
            "Perc_contribution": 0,
            "Fossil_abs": 2.35400662918274e-09,
            "Land_abs": 1.85671859722147e-09,
            "Fossil_fraction": 55.9050164190593,
            "Land_fraction": 44.0949835809409,
            "Rank": 197,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Niue",
            "Abs_contribution": 3.0646467789711e-09,
            "Perc_contribution": 0,
            "Fossil_abs": 1.37760285053221e-10,
            "Land_abs": 2.92688649391787e-09,
            "Fossil_fraction": 4.495143975433,
            "Land_fraction": 95.5048560245667,
            "Rank": 198,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Anguilla",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 199,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Antarctica",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 200,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Bermuda",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 201,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Bonaire, Saint Eustatius and Saba",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 202,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "British Virgin Islands",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 203,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Christmas Island",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 204,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Cura\xe7ao",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 205,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Faeroe Islands",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 206,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "French Polynesia",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 207,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Greenland",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 208,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Kosovo",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 209,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Kuwaiti Oil Fires",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 210,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Leeward Islands",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 211,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Marshall Islands",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 212,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Montserrat",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 213,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "New Caledonia",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 214,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Occupied Palestinian Territory",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 215,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Pacific Islands (Palau)",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 216,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Panama Canal Zone",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 217,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Ryukyu Islands",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 218,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Helena",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 219,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Pierre and Miquelon",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 220,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Sint Maarten (Dutch part)",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 221,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "St. Kitts-Nevis-Anguilla",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 222,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Wallis and Futuna Islands",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 223,
            "Perc_contribution_rescale": 0
        }
    ],
    "2020_3GHG": [
        {
            "Country": "China",
            "Abs_contribution": 0.013946682117337,
            "Perc_contribution": 28.18,
            "Fossil_abs": 0.01349110802144,
            "Land_abs": 0.000455574095897297,
            "Fossil_fraction": 96.7334589541504,
            "Land_fraction": 3.26654104585188,
            "Rank": 1,
            "Perc_contribution_rescale": 100
        },
        {
            "Country": "United States",
            "Abs_contribution": 0.00471779529431299,
            "Perc_contribution": 9.53,
            "Fossil_abs": 0.00452584086785401,
            "Land_abs": 0.000191954426459404,
            "Fossil_fraction": 95.9312684318804,
            "Land_fraction": 4.06873156812872,
            "Rank": 2,
            "Perc_contribution_rescale": 33.8183108587651
        },
        {
            "Country": "India",
            "Abs_contribution": 0.00362288555614651,
            "Perc_contribution": 7.32,
            "Fossil_abs": 0.0030267213973417,
            "Land_abs": 0.000596164158804799,
            "Fossil_fraction": 83.5444937587563,
            "Land_fraction": 16.4555062412435,
            "Rank": 3,
            "Perc_contribution_rescale": 25.9758694109297
        },
        {
            "Country": "Russia",
            "Abs_contribution": 0.002270703909884,
            "Perc_contribution": 4.59,
            "Fossil_abs": 0.00224611511633391,
            "Land_abs": 2.45887935498013e-05,
            "Fossil_fraction": 98.9171290258029,
            "Land_fraction": 1.08287097418427,
            "Rank": 4,
            "Perc_contribution_rescale": 16.2881476224273
        },
        {
            "Country": "Indonesia",
            "Abs_contribution": 0.0022399390946111,
            "Perc_contribution": 4.53,
            "Fossil_abs": 0.0013422208343555,
            "Land_abs": 0.000897718260255496,
            "Fossil_fraction": 59.922202241331,
            "Land_fraction": 40.0777977586645,
            "Rank": 5,
            "Perc_contribution_rescale": 16.0752306600426
        },
        {
            "Country": "EU27",
            "Abs_contribution": 0.00217828637509998,
            "Perc_contribution": 4.4,
            "Fossil_abs": 0.00220411453528102,
            "Land_abs": -0.0000258281601816998,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 6,
            "Perc_contribution_rescale": 15.6139105748758
        },
        {
            "Country": "Brazil",
            "Abs_contribution": 0.0021137240914338,
            "Perc_contribution": 4.27,
            "Fossil_abs": 0.000735389053999898,
            "Land_abs": 0.0013783350374337,
            "Fossil_fraction": 34.7911563756205,
            "Land_fraction": 65.20884362437,
            "Rank": 7,
            "Perc_contribution_rescale": 15.152590489709
        },
        {
            "Country": "Iran",
            "Abs_contribution": 0.000988625863225501,
            "Perc_contribution": 2,
            "Fossil_abs": 0.000991888553059199,
            "Land_abs": -0.00000326268983367995,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 8,
            "Perc_contribution_rescale": 7.097232079489
        },
        {
            "Country": "Japan",
            "Abs_contribution": 0.000922842244264102,
            "Perc_contribution": 1.86,
            "Fossil_abs": 0.0009315817547133,
            "Land_abs": -0.00000873951044920006,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 9,
            "Perc_contribution_rescale": 6.60042583392477
        },
        {
            "Country": "Saudi Arabia",
            "Abs_contribution": 0.0008378883056019,
            "Perc_contribution": 1.69,
            "Fossil_abs": 0.000828044050890299,
            "Land_abs": 9.84425471152399e-06,
            "Fossil_fraction": 98.8251113369425,
            "Land_fraction": 1.17488866304827,
            "Rank": 10,
            "Perc_contribution_rescale": 5.9971611071682
        },
        {
            "Country": "Mexico",
            "Abs_contribution": 0.000804624108725602,
            "Perc_contribution": 1.63,
            "Fossil_abs": 0.0005913902481784,
            "Land_abs": 0.000213233860547229,
            "Fossil_fraction": 73.4989471189311,
            "Land_fraction": 26.5010528810724,
            "Rank": 11,
            "Perc_contribution_rescale": 5.78424414478353
        },
        {
            "Country": "Pakistan",
            "Abs_contribution": 0.000698253611315999,
            "Perc_contribution": 1.41,
            "Fossil_abs": 0.00030948950992642,
            "Land_abs": 0.00038876410138964,
            "Fossil_fraction": 44.3233668842937,
            "Land_fraction": 55.676633115715,
            "Rank": 12,
            "Perc_contribution_rescale": 5.00354861603974
        },
        {
            "Country": "T\xfcrkiye",
            "Abs_contribution": 0.000632498268846,
            "Perc_contribution": 1.28,
            "Fossil_abs": 0.00057607703737229,
            "Land_abs": 5.64212314736897e-05,
            "Fossil_fraction": 91.0796227827388,
            "Land_fraction": 8.92037721725798,
            "Rank": 13,
            "Perc_contribution_rescale": 4.54222853087296
        },
        {
            "Country": "Democratic Republic of the Congo",
            "Abs_contribution": 0.000614452998321099,
            "Perc_contribution": 1.24,
            "Fossil_abs": 0.0001036191799198,
            "Land_abs": 0.00051083381840129,
            "Fossil_fraction": 16.8636462354198,
            "Land_fraction": 83.1363537645787,
            "Rank": 14,
            "Perc_contribution_rescale": 4.40028388928318
        },
        {
            "Country": "Canada",
            "Abs_contribution": 0.000596775798227506,
            "Perc_contribution": 1.21,
            "Fossil_abs": 0.000506946386608,
            "Land_abs": 8.98294116195002e-05,
            "Fossil_fraction": 84.947544473769,
            "Land_fraction": 15.0524555262301,
            "Rank": 15,
            "Perc_contribution_rescale": 4.29382540809084
        },
        {
            "Country": "Viet Nam",
            "Abs_contribution": 0.0005886990008798,
            "Perc_contribution": 1.19,
            "Fossil_abs": 0.00042466979481023,
            "Land_abs": 0.00016402920606953,
            "Fossil_fraction": 72.1369994132093,
            "Land_fraction": 27.863000586784,
            "Rank": 16,
            "Perc_contribution_rescale": 4.22285308729595
        },
        {
            "Country": "South Korea",
            "Abs_contribution": 0.000578264589152,
            "Perc_contribution": 1.17,
            "Fossil_abs": 0.0005755824100465,
            "Land_abs": 2.68217910550598e-06,
            "Fossil_fraction": 99.5361674991316,
            "Land_fraction": 0.463832500869417,
            "Rank": 17,
            "Perc_contribution_rescale": 4.15188076650106
        },
        {
            "Country": "Iraq",
            "Abs_contribution": 0.000539449436368,
            "Perc_contribution": 1.09,
            "Fossil_abs": 0.00052745259839732,
            "Land_abs": 1.1996837970702e-05,
            "Fossil_fraction": 97.7760959300556,
            "Land_fraction": 2.22390406994847,
            "Rank": 18,
            "Perc_contribution_rescale": 3.8679914833215
        },
        {
            "Country": "Germany",
            "Abs_contribution": 0.000501895461685296,
            "Perc_contribution": 1.01,
            "Fossil_abs": 0.000526486066931606,
            "Land_abs": -0.0000245906052463701,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 19,
            "Perc_contribution_rescale": 3.58410220014194
        },
        {
            "Country": "Malaysia",
            "Abs_contribution": 0.0004464638587962,
            "Perc_contribution": 0.9,
            "Fossil_abs": 0.00033000534090184,
            "Land_abs": 0.0001164585178943,
            "Fossil_fraction": 73.9153538187017,
            "Land_fraction": 26.0846461812849,
            "Rank": 20,
            "Perc_contribution_rescale": 3.19375443577005
        },
        {
            "Country": "South Africa",
            "Abs_contribution": 0.000433119162254202,
            "Perc_contribution": 0.88,
            "Fossil_abs": 0.0004200633229166,
            "Land_abs": 1.30558393376403e-05,
            "Fossil_fraction": 96.9856241710359,
            "Land_fraction": 3.01437582897283,
            "Rank": 21,
            "Perc_contribution_rescale": 3.12278211497516
        },
        {
            "Country": "Ethiopia",
            "Abs_contribution": 0.000409010684640991,
            "Perc_contribution": 0.83,
            "Fossil_abs": 9.31801282771099e-05,
            "Land_abs": 0.00031583055636383,
            "Fossil_fraction": 22.7818323032071,
            "Land_fraction": 77.2181676967803,
            "Rank": 22,
            "Perc_contribution_rescale": 2.94535131298793
        },
        {
            "Country": "Thailand",
            "Abs_contribution": 0.0003661979372441,
            "Perc_contribution": 0.74,
            "Fossil_abs": 0.00030300760891198,
            "Land_abs": 6.31903283321213e-05,
            "Fossil_fraction": 82.7442151073617,
            "Land_fraction": 17.2557848926385,
            "Rank": 23,
            "Perc_contribution_rescale": 2.62597586941093
        },
        {
            "Country": "Kazakhstan",
            "Abs_contribution": 0.0003602713322284,
            "Perc_contribution": 0.73,
            "Fossil_abs": 0.000308628602026939,
            "Land_abs": 5.16427302015001e-05,
            "Fossil_fraction": 85.6656010118725,
            "Land_fraction": 14.3343989881383,
            "Rank": 24,
            "Perc_contribution_rescale": 2.59048970901348
        },
        {
            "Country": "Qatar",
            "Abs_contribution": 0.00032135079995253,
            "Perc_contribution": 0.65,
            "Fossil_abs": 0.0003198837195999,
            "Land_abs": 1.4670803526236e-06,
            "Fossil_fraction": 99.5434645400457,
            "Land_fraction": 0.456535459952276,
            "Rank": 25,
            "Perc_contribution_rescale": 2.30660042583392
        },
        {
            "Country": "Egypt",
            "Abs_contribution": 0.000318861413073711,
            "Perc_contribution": 0.64,
            "Fossil_abs": 0.00032924506827544,
            "Land_abs": -0.0000103836552016901,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 26,
            "Perc_contribution_rescale": 2.27111426543648
        },
        {
            "Country": "United Arab Emirates",
            "Abs_contribution": 0.00029553898376629,
            "Perc_contribution": 0.6,
            "Fossil_abs": 0.0002921301136584,
            "Land_abs": 3.4088701078917e-06,
            "Fossil_fraction": 98.8465582223881,
            "Land_fraction": 1.15344177761246,
            "Rank": 27,
            "Perc_contribution_rescale": 2.1291696238467
        },
        {
            "Country": "Philippines",
            "Abs_contribution": 0.0002743416282025,
            "Perc_contribution": 0.55,
            "Fossil_abs": 0.00021103396373954,
            "Land_abs": 6.33076644630196e-05,
            "Fossil_fraction": 76.9237848161233,
            "Land_fraction": 23.0762151838985,
            "Rank": 28,
            "Perc_contribution_rescale": 1.95173882185947
        },
        {
            "Country": "Taiwan",
            "Abs_contribution": 0.00026898376785141,
            "Perc_contribution": 0.54,
            "Fossil_abs": 0.00027004406109445,
            "Land_abs": -0.00000106029324306299,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 29,
            "Perc_contribution_rescale": 1.91625266146203
        },
        {
            "Country": "Italy",
            "Abs_contribution": 0.000266791864264999,
            "Perc_contribution": 0.54,
            "Fossil_abs": 0.0002699110017476,
            "Land_abs": -0.00000311913748260993,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 30,
            "Perc_contribution_rescale": 1.91625266146203
        },
        {
            "Country": "Tanzania",
            "Abs_contribution": 0.000260740711790631,
            "Perc_contribution": 0.53,
            "Fossil_abs": 5.86499747179631e-05,
            "Land_abs": 0.00020209073707266,
            "Fossil_fraction": 22.4936007557799,
            "Land_fraction": 77.5063992442173,
            "Rank": 31,
            "Perc_contribution_rescale": 1.88076650106458
        },
        {
            "Country": "Algeria",
            "Abs_contribution": 0.00025715253527167,
            "Perc_contribution": 0.52,
            "Fossil_abs": 0.00023990507855626,
            "Land_abs": 1.7247456715423e-05,
            "Fossil_fraction": 93.2929081577248,
            "Land_fraction": 6.70709184228026,
            "Rank": 32,
            "Perc_contribution_rescale": 1.84528034066714
        },
        {
            "Country": "Argentina",
            "Abs_contribution": 0.000256313942284602,
            "Perc_contribution": 0.52,
            "Fossil_abs": 0.00016771545800449,
            "Land_abs": 8.85984842802015e-05,
            "Fossil_fraction": 65.4336071263203,
            "Land_fraction": 34.5663928737145,
            "Rank": 33,
            "Perc_contribution_rescale": 1.84528034066714
        },
        {
            "Country": "Bangladesh",
            "Abs_contribution": 0.00025110129753375,
            "Perc_contribution": 0.51,
            "Fossil_abs": 0.00016802284552636,
            "Land_abs": 8.30784520073997e-05,
            "Fossil_fraction": 66.9143676980705,
            "Land_fraction": 33.0856323019331,
            "Rank": 34,
            "Perc_contribution_rescale": 1.80979418026969
        },
        {
            "Country": "Colombia",
            "Abs_contribution": 0.0002403594379548,
            "Perc_contribution": 0.49,
            "Fossil_abs": 0.00013627000191093,
            "Land_abs": 0.000104089436043901,
            "Fossil_fraction": 56.6942588443546,
            "Land_fraction": 43.3057411556582,
            "Rank": 35,
            "Perc_contribution_rescale": 1.7388218594748
        },
        {
            "Country": "France",
            "Abs_contribution": 0.000234933861565402,
            "Perc_contribution": 0.47,
            "Fossil_abs": 0.000260884732026401,
            "Land_abs": -0.000025950870461,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 36,
            "Perc_contribution_rescale": 1.66784953867991
        },
        {
            "Country": "Chad",
            "Abs_contribution": 0.00022843267746313,
            "Perc_contribution": 0.46,
            "Fossil_abs": 1.6074004627079e-05,
            "Land_abs": 0.00021235867283605,
            "Fossil_fraction": 7.03664852401575,
            "Land_fraction": 92.9633514759838,
            "Rank": 37,
            "Perc_contribution_rescale": 1.63236337828247
        },
        {
            "Country": "Spain",
            "Abs_contribution": 0.000227296979574371,
            "Perc_contribution": 0.46,
            "Fossil_abs": 0.000221601241004949,
            "Land_abs": 5.69573856943999e-06,
            "Fossil_fraction": 97.4941424298342,
            "Land_fraction": 2.50585757017345,
            "Rank": 38,
            "Perc_contribution_rescale": 1.63236337828247
        },
        {
            "Country": "Poland",
            "Abs_contribution": 0.0002051996774378,
            "Perc_contribution": 0.41,
            "Fossil_abs": 0.0002140796730053,
            "Land_abs": -0.00000887999556750999,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 39,
            "Perc_contribution_rescale": 1.45493257629524
        },
        {
            "Country": "Uzbekistan",
            "Abs_contribution": 0.00019892583268265,
            "Perc_contribution": 0.4,
            "Fossil_abs": 0.00012475802559095,
            "Land_abs": 7.416780709172e-05,
            "Fossil_fraction": 62.7158493738613,
            "Land_fraction": 37.2841506261488,
            "Rank": 40,
            "Perc_contribution_rescale": 1.4194464158978
        },
        {
            "Country": "Myanmar",
            "Abs_contribution": 0.0001958813017079,
            "Perc_contribution": 0.4,
            "Fossil_abs": 6.607389242897e-05,
            "Land_abs": 0.0001298074092789,
            "Fossil_fraction": 33.7315975812229,
            "Land_fraction": 66.2684024187616,
            "Rank": 41,
            "Perc_contribution_rescale": 1.4194464158978
        },
        {
            "Country": "Australia",
            "Abs_contribution": 0.000195096155762801,
            "Perc_contribution": 0.39,
            "Fossil_abs": 0.000353700034994001,
            "Land_abs": -0.000158603879231301,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 42,
            "Perc_contribution_rescale": 1.38396025550035
        },
        {
            "Country": "Kenya",
            "Abs_contribution": 0.0001789283811,
            "Perc_contribution": 0.36,
            "Fossil_abs": 6.93730388065499e-05,
            "Land_abs": 0.00010955534229345,
            "Fossil_fraction": 38.7714002552667,
            "Land_fraction": 61.2285997447334,
            "Rank": 43,
            "Perc_contribution_rescale": 1.27750177430802
        },
        {
            "Country": "Turkmenistan",
            "Abs_contribution": 0.00015379411343582,
            "Perc_contribution": 0.31,
            "Fossil_abs": 0.00013656750953319,
            "Land_abs": 1.7226603902635e-05,
            "Fossil_fraction": 88.7989185556056,
            "Land_fraction": 11.2010814443973,
            "Rank": 44,
            "Perc_contribution_rescale": 1.10007097232079
        },
        {
            "Country": "Kuwait",
            "Abs_contribution": 0.00015333704689194,
            "Perc_contribution": 0.31,
            "Fossil_abs": 0.00015256990675732,
            "Land_abs": 7.67140134620299e-07,
            "Fossil_fraction": 99.4997033331673,
            "Land_fraction": 0.50029666683285,
            "Rank": 45,
            "Perc_contribution_rescale": 1.10007097232079
        },
        {
            "Country": "Sudan",
            "Abs_contribution": 0.00014129864274894,
            "Perc_contribution": 0.29,
            "Fossil_abs": 4.0586469479464e-05,
            "Land_abs": 0.00010071217326947,
            "Fossil_fraction": 28.7238919566823,
            "Land_fraction": 71.2761080433137,
            "Rank": 46,
            "Perc_contribution_rescale": 1.0290986515259
        },
        {
            "Country": "Mongolia",
            "Abs_contribution": 0.00013966056526463,
            "Perc_contribution": 0.28,
            "Fossil_abs": 8.8816110514592e-05,
            "Land_abs": 5.08444547500401e-05,
            "Fossil_fraction": 63.5942653864407,
            "Land_fraction": 36.4057346135608,
            "Rank": 47,
            "Perc_contribution_rescale": 0.99361249112846
        },
        {
            "Country": "United Kingdom",
            "Abs_contribution": 0.000132592169417897,
            "Perc_contribution": 0.27,
            "Fossil_abs": 0.000106533217285501,
            "Land_abs": 2.60589521324599e-05,
            "Fossil_fraction": 80.3465376222446,
            "Land_fraction": 19.6534623778035,
            "Rank": 48,
            "Perc_contribution_rescale": 0.958126330731015
        },
        {
            "Country": "Peru",
            "Abs_contribution": 0.00012898934330258,
            "Perc_contribution": 0.26,
            "Fossil_abs": 8.01110191240202e-05,
            "Land_abs": 4.88783241785599e-05,
            "Fossil_fraction": 62.1066958501351,
            "Land_fraction": 37.8933041498647,
            "Rank": 49,
            "Perc_contribution_rescale": 0.92264017033357
        },
        {
            "Country": "Oman",
            "Abs_contribution": 0.00012344643141021,
            "Perc_contribution": 0.25,
            "Fossil_abs": 0.00011995548023307,
            "Land_abs": 3.4909511771459e-06,
            "Fossil_fraction": 97.1720922692858,
            "Land_fraction": 2.82790773071887,
            "Rank": 50,
            "Perc_contribution_rescale": 0.887154009936125
        },
        {
            "Country": "Morocco",
            "Abs_contribution": 0.00012087554930903,
            "Perc_contribution": 0.24,
            "Fossil_abs": 0.00010866678608346,
            "Land_abs": 1.22087632255801e-05,
            "Fossil_fraction": 89.8997247207066,
            "Land_fraction": 10.1002752793017,
            "Rank": 51,
            "Perc_contribution_rescale": 0.85166784953868
        },
        {
            "Country": "Bolivia",
            "Abs_contribution": 0.00011557528206455,
            "Perc_contribution": 0.23,
            "Fossil_abs": 3.5236000164435e-05,
            "Land_abs": 8.03392819001304e-05,
            "Fossil_fraction": 30.4874879256234,
            "Land_fraction": 69.5125120743897,
            "Rank": 52,
            "Perc_contribution_rescale": 0.816181689141235
        },
        {
            "Country": "Ukraine",
            "Abs_contribution": 0.0001111252071582,
            "Perc_contribution": 0.22,
            "Fossil_abs": 0.000149870040270998,
            "Land_abs": -0.0000387448331128195,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 53,
            "Perc_contribution_rescale": 0.78069552874379
        },
        {
            "Country": "Mozambique",
            "Abs_contribution": 0.00010958724679004,
            "Perc_contribution": 0.22,
            "Fossil_abs": 6.2947042207905e-05,
            "Land_abs": 4.664020458213e-05,
            "Fossil_fraction": 57.440116484089,
            "Land_fraction": 42.5598835159066,
            "Rank": 54,
            "Perc_contribution_rescale": 0.78069552874379
        },
        {
            "Country": "Uganda",
            "Abs_contribution": 0.00010190686536328,
            "Perc_contribution": 0.21,
            "Fossil_abs": 3.8884456590091e-05,
            "Land_abs": 6.302240877319e-05,
            "Fossil_fraction": 38.1568567058508,
            "Land_fraction": 61.8431432941503,
            "Rank": 55,
            "Perc_contribution_rescale": 0.745209368346345
        },
        {
            "Country": "Azerbaijan",
            "Abs_contribution": 0.00010145402885508,
            "Perc_contribution": 0.21,
            "Fossil_abs": 9.034005212938e-05,
            "Land_abs": 1.1113976725698e-05,
            "Fossil_fraction": 89.0453076618817,
            "Land_fraction": 10.9546923381166,
            "Rank": 56,
            "Perc_contribution_rescale": 0.745209368346345
        },
        {
            "Country": "Paraguay",
            "Abs_contribution": 0.00010069538337187,
            "Perc_contribution": 0.2,
            "Fossil_abs": 1.3628705786312e-05,
            "Land_abs": 8.70666775855604e-05,
            "Fossil_fraction": 13.5345885083738,
            "Land_fraction": 86.4654114916287,
            "Rank": 57,
            "Perc_contribution_rescale": 0.7097232079489
        },
        {
            "Country": "Angola",
            "Abs_contribution": 9.91420882184299e-05,
            "Perc_contribution": 0.2,
            "Fossil_abs": -0.0000163452779995197,
            "Land_abs": 0.00011548736621795,
            "Fossil_fraction": 0,
            "Land_fraction": 100,
            "Rank": 58,
            "Perc_contribution_rescale": 0.7097232079489
        },
        {
            "Country": "Niger",
            "Abs_contribution": 9.711367426543e-05,
            "Perc_contribution": 0.2,
            "Fossil_abs": 1.5336841325257e-05,
            "Land_abs": 8.17768329401699e-05,
            "Fossil_fraction": 15.7926692005685,
            "Land_fraction": 84.2073307994284,
            "Rank": 59,
            "Perc_contribution_rescale": 0.7097232079489
        },
        {
            "Country": "Belarus",
            "Abs_contribution": 9.67605972654806e-05,
            "Perc_contribution": 0.2,
            "Fossil_abs": 7.96682197918503e-05,
            "Land_abs": 1.70923774735999e-05,
            "Fossil_fraction": 82.3353948232314,
            "Land_fraction": 17.6646051767372,
            "Rank": 60,
            "Perc_contribution_rescale": 0.7097232079489
        },
        {
            "Country": "Netherlands",
            "Abs_contribution": 9.22939755302098e-05,
            "Perc_contribution": 0.19,
            "Fossil_abs": 8.30898567338702e-05,
            "Land_abs": 9.20411879638014e-06,
            "Fossil_fraction": 90.0273893897583,
            "Land_fraction": 9.97261061028564,
            "Rank": 61,
            "Perc_contribution_rescale": 0.674237047551455
        },
        {
            "Country": "Chile",
            "Abs_contribution": 9.05338238505705e-05,
            "Perc_contribution": 0.18,
            "Fossil_abs": 8.75844064917399e-05,
            "Land_abs": 2.94941735881995e-06,
            "Fossil_fraction": 96.7421928806424,
            "Land_fraction": 3.25780711934589,
            "Rank": 62,
            "Perc_contribution_rescale": 0.63875088715401
        },
        {
            "Country": "Israel",
            "Abs_contribution": 9.00856749479402e-05,
            "Perc_contribution": 0.18,
            "Fossil_abs": 8.66310389269801e-05,
            "Land_abs": 3.45463602095961e-06,
            "Fossil_fraction": 96.165166078895,
            "Land_fraction": 3.83483392110457,
            "Rank": 63,
            "Perc_contribution_rescale": 0.63875088715401
        },
        {
            "Country": "Mali",
            "Abs_contribution": 8.675422561596e-05,
            "Perc_contribution": 0.18,
            "Fossil_abs": 1.6504697644578e-05,
            "Land_abs": 7.02495279714e-05,
            "Fossil_fraction": 19.0246613665141,
            "Land_fraction": 80.9753386335066,
            "Rank": 64,
            "Perc_contribution_rescale": 0.63875088715401
        },
        {
            "Country": "C\xf4te d'Ivoire",
            "Abs_contribution": 8.49962331264499e-05,
            "Perc_contribution": 0.17,
            "Fossil_abs": 3.2834931250688e-05,
            "Land_abs": 5.21613018758102e-05,
            "Fossil_fraction": 38.6310428626162,
            "Land_fraction": 61.3689571374406,
            "Rank": 65,
            "Perc_contribution_rescale": 0.603264726756565
        },
        {
            "Country": "Zambia",
            "Abs_contribution": 8.43921624434497e-05,
            "Perc_contribution": 0.17,
            "Fossil_abs": 2.2875234656013e-05,
            "Land_abs": 6.15169277874399e-05,
            "Fossil_fraction": 27.1058757042059,
            "Land_fraction": 72.8941242957979,
            "Rank": 66,
            "Perc_contribution_rescale": 0.603264726756565
        },
        {
            "Country": "Ghana",
            "Abs_contribution": 8.14894543572299e-05,
            "Perc_contribution": 0.16,
            "Fossil_abs": 6.68529742587359e-05,
            "Land_abs": 1.463648009849e-05,
            "Fossil_fraction": 82.0388046355897,
            "Land_fraction": 17.9611953644053,
            "Rank": 67,
            "Perc_contribution_rescale": 0.56777856635912
        },
        {
            "Country": "Czechia",
            "Abs_contribution": 8.06387733653796e-05,
            "Perc_contribution": 0.16,
            "Fossil_abs": 8.88036861655594e-05,
            "Land_abs": -0.00000816491280021,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 68,
            "Perc_contribution_rescale": 0.56777856635912
        },
        {
            "Country": "Belgium",
            "Abs_contribution": 7.83372004133e-05,
            "Perc_contribution": 0.16,
            "Fossil_abs": 7.71595207728695e-05,
            "Land_abs": 1.17767964046109e-06,
            "Fossil_fraction": 98.4966533981082,
            "Land_fraction": 1.50334660193083,
            "Rank": 69,
            "Perc_contribution_rescale": 0.56777856635912
        },
        {
            "Country": "Cambodia",
            "Abs_contribution": 7.72530099404701e-05,
            "Perc_contribution": 0.16,
            "Fossil_abs": 2.491217303683e-05,
            "Land_abs": 5.23408369036303e-05,
            "Fossil_fraction": 32.2475112050999,
            "Land_fraction": 67.7524887948874,
            "Rank": 70,
            "Perc_contribution_rescale": 0.56777856635912
        },
        {
            "Country": "Bahrain",
            "Abs_contribution": 7.44397473317901e-05,
            "Perc_contribution": 0.15,
            "Fossil_abs": 7.441859442748e-05,
            "Land_abs": 2.11529043115999e-08,
            "Fossil_fraction": 99.9715838579948,
            "Land_fraction": 0.0284161420071967,
            "Rank": 71,
            "Perc_contribution_rescale": 0.532292405961675
        },
        {
            "Country": "Nigeria",
            "Abs_contribution": 7.18123785815004e-05,
            "Perc_contribution": 0.15,
            "Fossil_abs": -0.0000601993461666998,
            "Land_abs": 0.00013201172474833,
            "Fossil_fraction": 0,
            "Land_fraction": 100,
            "Rank": 72,
            "Perc_contribution_rescale": 0.532292405961675
        },
        {
            "Country": "Laos",
            "Abs_contribution": 7.064175927572e-05,
            "Perc_contribution": 0.14,
            "Fossil_abs": 2.764873726258e-05,
            "Land_abs": 4.29930220131399e-05,
            "Fossil_fraction": 39.1393667797329,
            "Land_fraction": 60.860633220267,
            "Rank": 73,
            "Perc_contribution_rescale": 0.49680624556423
        },
        {
            "Country": "Burkina Faso",
            "Abs_contribution": 7.015477149606e-05,
            "Perc_contribution": 0.14,
            "Fossil_abs": 2.0175395323267e-05,
            "Land_abs": 4.99793761727901e-05,
            "Fossil_fraction": 28.7584078645315,
            "Land_fraction": 71.2415921354644,
            "Rank": 74,
            "Perc_contribution_rescale": 0.49680624556423
        },
        {
            "Country": "Guinea",
            "Abs_contribution": 6.823338504611e-05,
            "Perc_contribution": 0.14,
            "Fossil_abs": 1.3754896866439e-05,
            "Land_abs": 5.447848817968e-05,
            "Fossil_fraction": 20.1586025039559,
            "Land_fraction": 79.8413974960573,
            "Rank": 75,
            "Perc_contribution_rescale": 0.49680624556423
        },
        {
            "Country": "Guatemala",
            "Abs_contribution": 6.72104325558599e-05,
            "Perc_contribution": 0.14,
            "Fossil_abs": 4.25004023887081e-05,
            "Land_abs": 2.47100301671601e-05,
            "Fossil_fraction": 63.2348294342328,
            "Land_fraction": 36.7651705657795,
            "Rank": 76,
            "Perc_contribution_rescale": 0.49680624556423
        },
        {
            "Country": "South Sudan",
            "Abs_contribution": 6.49836966294297e-05,
            "Perc_contribution": 0.13,
            "Fossil_abs": 9.47169149775301e-06,
            "Land_abs": 5.551200513168e-05,
            "Fossil_fraction": 14.57548891342,
            "Land_fraction": 85.4245110865851,
            "Rank": 77,
            "Perc_contribution_rescale": 0.461320085166785
        },
        {
            "Country": "Singapore",
            "Abs_contribution": 6.445597347354e-05,
            "Perc_contribution": 0.13,
            "Fossil_abs": 6.43125587622502e-05,
            "Land_abs": 1.43414711290501e-07,
            "Fossil_fraction": 99.7774997357713,
            "Land_fraction": 0.222500264229776,
            "Rank": 78,
            "Perc_contribution_rescale": 0.461320085166785
        },
        {
            "Country": "Ecuador",
            "Abs_contribution": 6.43582614589001e-05,
            "Perc_contribution": 0.13,
            "Fossil_abs": 5.635451734661e-05,
            "Land_abs": 8.00374411227996e-06,
            "Fossil_fraction": 87.5637658152071,
            "Land_fraction": 12.4362341847771,
            "Rank": 79,
            "Perc_contribution_rescale": 0.461320085166785
        },
        {
            "Country": "Romania",
            "Abs_contribution": 6.41162905998995e-05,
            "Perc_contribution": 0.13,
            "Fossil_abs": 7.28863018128103e-05,
            "Land_abs": -0.00000877001121292009,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 80,
            "Perc_contribution_rescale": 0.461320085166785
        },
        {
            "Country": "Madagascar",
            "Abs_contribution": 5.653346461578e-05,
            "Perc_contribution": 0.11,
            "Fossil_abs": 2.5499856477975e-05,
            "Land_abs": 3.10336081377999e-05,
            "Fossil_fraction": 45.1057734587476,
            "Land_fraction": 54.8942265412432,
            "Rank": 81,
            "Perc_contribution_rescale": 0.390347764371895
        },
        {
            "Country": "Cameroon",
            "Abs_contribution": 5.59421419290204e-05,
            "Perc_contribution": 0.11,
            "Fossil_abs": 2.5237262110873e-05,
            "Land_abs": 3.07048798181496e-05,
            "Fossil_fraction": 45.1131494802151,
            "Land_fraction": 54.886850519789,
            "Rank": 82,
            "Perc_contribution_rescale": 0.390347764371895
        },
        {
            "Country": "Libya",
            "Abs_contribution": 5.52704624715199e-05,
            "Perc_contribution": 0.11,
            "Fossil_abs": 5.17443400032398e-05,
            "Land_abs": 3.5261224682688e-06,
            "Fossil_fraction": 93.6202407025325,
            "Land_fraction": 6.37975929744709,
            "Rank": 83,
            "Perc_contribution_rescale": 0.390347764371895
        },
        {
            "Country": "Nepal",
            "Abs_contribution": 5.51296354848801e-05,
            "Perc_contribution": 0.11,
            "Fossil_abs": 2.4617632666638e-05,
            "Land_abs": 3.05120028182399e-05,
            "Fossil_fraction": 44.6540820560833,
            "Land_fraction": 55.3459179439127,
            "Rank": 84,
            "Perc_contribution_rescale": 0.390347764371895
        },
        {
            "Country": "Trinidad and Tobago",
            "Abs_contribution": 5.20464989120898e-05,
            "Perc_contribution": 0.11,
            "Fossil_abs": 5.209171275926e-05,
            "Land_abs": -0.0000000452138471645996,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 85,
            "Perc_contribution_rescale": 0.390347764371895
        },
        {
            "Country": "Afghanistan",
            "Abs_contribution": 4.914370122615e-05,
            "Perc_contribution": 0.1,
            "Fossil_abs": 2.7849609023557e-05,
            "Land_abs": 2.12940922025889e-05,
            "Fossil_fraction": 56.6697426703747,
            "Land_fraction": 43.3302573296169,
            "Rank": 86,
            "Perc_contribution_rescale": 0.35486160397445
        },
        {
            "Country": "Uruguay",
            "Abs_contribution": 4.75135839200602e-05,
            "Perc_contribution": 0.1,
            "Fossil_abs": 3.3990722104536e-05,
            "Land_abs": 1.35228618155197e-05,
            "Fossil_fraction": 71.5389564418548,
            "Land_fraction": 28.4610435581358,
            "Rank": 87,
            "Perc_contribution_rescale": 0.35486160397445
        },
        {
            "Country": "Ireland",
            "Abs_contribution": 4.665054789069e-05,
            "Perc_contribution": 0.09,
            "Fossil_abs": 2.9116969848332e-05,
            "Land_abs": 1.75335780423539e-05,
            "Fossil_fraction": 62.4150651275477,
            "Land_fraction": 37.5849348724436,
            "Rank": 88,
            "Perc_contribution_rescale": 0.319375443577005
        },
        {
            "Country": "Austria",
            "Abs_contribution": 4.57604168867601e-05,
            "Perc_contribution": 0.09,
            "Fossil_abs": 5.03308114788701e-05,
            "Land_abs": -0.00000457039459211241,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 89,
            "Perc_contribution_rescale": 0.319375443577005
        },
        {
            "Country": "Norway",
            "Abs_contribution": 4.52359971566401e-05,
            "Perc_contribution": 0.09,
            "Fossil_abs": 3.96220109598901e-05,
            "Land_abs": 5.61398619675405e-06,
            "Fossil_fraction": 87.5895601962521,
            "Land_fraction": 12.410439803757,
            "Rank": 90,
            "Perc_contribution_rescale": 0.319375443577005
        },
        {
            "Country": "Nicaragua",
            "Abs_contribution": 4.45342984569099e-05,
            "Perc_contribution": 0.09,
            "Fossil_abs": 8.608338613644e-06,
            "Land_abs": 3.59259598432698e-05,
            "Fossil_fraction": 19.3296827656849,
            "Land_fraction": 80.6703172343237,
            "Rank": 91,
            "Perc_contribution_rescale": 0.319375443577005
        },
        {
            "Country": "Dominican Republic",
            "Abs_contribution": 4.39259842874001e-05,
            "Perc_contribution": 0.09,
            "Fossil_abs": 3.3787937823786e-05,
            "Land_abs": 1.0138046463611e-05,
            "Fossil_fraction": 76.9201609751473,
            "Land_fraction": 23.0798390248458,
            "Rank": 92,
            "Perc_contribution_rescale": 0.319375443577005
        },
        {
            "Country": "North Korea",
            "Abs_contribution": 4.14267820254299e-05,
            "Perc_contribution": 0.08,
            "Fossil_abs": 3.45791645469801e-05,
            "Land_abs": 6.84761747844602e-06,
            "Fossil_fraction": 83.4705542075501,
            "Land_fraction": 16.5294457924407,
            "Rank": 93,
            "Perc_contribution_rescale": 0.28388928317956
        },
        {
            "Country": "Papua New Guinea",
            "Abs_contribution": 4.01513729643599e-05,
            "Perc_contribution": 0.08,
            "Fossil_abs": 1.3287855523118e-05,
            "Land_abs": 2.68635174412431e-05,
            "Fossil_fraction": 33.0943988762548,
            "Land_fraction": 66.9056011237481,
            "Rank": 94,
            "Perc_contribution_rescale": 0.28388928317956
        },
        {
            "Country": "Honduras",
            "Abs_contribution": 3.97348382663899e-05,
            "Perc_contribution": 0.08,
            "Fossil_abs": 1.9936762807828e-05,
            "Land_abs": 1.97980754585501e-05,
            "Fossil_fraction": 50.1745160611153,
            "Land_fraction": 49.825483938855,
            "Rank": 95,
            "Perc_contribution_rescale": 0.28388928317956
        },
        {
            "Country": "Jordan",
            "Abs_contribution": 3.95188844252049e-05,
            "Perc_contribution": 0.08,
            "Fossil_abs": 3.7739699320516e-05,
            "Land_abs": 1.7791851046866e-06,
            "Fossil_fraction": 95.4978863129187,
            "Land_fraction": 4.50211368707525,
            "Rank": 96,
            "Perc_contribution_rescale": 0.28388928317956
        },
        {
            "Country": "Somalia",
            "Abs_contribution": 3.85337749774801e-05,
            "Perc_contribution": 0.08,
            "Fossil_abs": 1.7772435689324e-05,
            "Land_abs": 2.07613392881501e-05,
            "Fossil_fraction": 46.1217093308678,
            "Land_fraction": 53.8782906691167,
            "Rank": 97,
            "Perc_contribution_rescale": 0.28388928317956
        },
        {
            "Country": "Sweden",
            "Abs_contribution": 3.83336891363502e-05,
            "Perc_contribution": 0.08,
            "Fossil_abs": 2.56704907875003e-05,
            "Land_abs": 1.26631983488599e-05,
            "Fossil_fraction": 66.9658761414592,
            "Land_fraction": 33.0341238585668,
            "Rank": 98,
            "Perc_contribution_rescale": 0.28388928317956
        },
        {
            "Country": "Tunisia",
            "Abs_contribution": 3.82718998865701e-05,
            "Perc_contribution": 0.08,
            "Fossil_abs": 3.6762167033926e-05,
            "Land_abs": 1.50973285264696e-06,
            "Fossil_fraction": 96.0552445603208,
            "Land_fraction": 3.94475543968681,
            "Rank": 99,
            "Perc_contribution_rescale": 0.28388928317956
        },
        {
            "Country": "Malawi",
            "Abs_contribution": 3.81281843195771e-05,
            "Perc_contribution": 0.08,
            "Fossil_abs": 1.1804267503617e-05,
            "Land_abs": 2.63239168159591e-05,
            "Fossil_fraction": 30.9594272957709,
            "Land_fraction": 69.0405727042264,
            "Rank": 100,
            "Perc_contribution_rescale": 0.28388928317956
        },
        {
            "Country": "Serbia",
            "Abs_contribution": 3.678123038712e-05,
            "Perc_contribution": 0.07,
            "Fossil_abs": 4.57792969375999e-05,
            "Land_abs": -0.00000899806655047398,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 101,
            "Perc_contribution_rescale": 0.248403122782115
        },
        {
            "Country": "Benin",
            "Abs_contribution": 3.6694235838594e-05,
            "Perc_contribution": 0.07,
            "Fossil_abs": 1.8890688935241e-05,
            "Land_abs": 1.78035469033531e-05,
            "Fossil_fraction": 51.4813525980893,
            "Land_fraction": 48.518647401911,
            "Rank": 102,
            "Perc_contribution_rescale": 0.248403122782115
        },
        {
            "Country": "Congo",
            "Abs_contribution": 3.525158588931e-05,
            "Perc_contribution": 0.07,
            "Fossil_abs": 2.3831349373449e-05,
            "Land_abs": 1.14202365158499e-05,
            "Fossil_fraction": 67.6036234179065,
            "Land_fraction": 32.3963765820621,
            "Rank": 103,
            "Perc_contribution_rescale": 0.248403122782115
        },
        {
            "Country": "Bulgaria",
            "Abs_contribution": 3.47583708796002e-05,
            "Perc_contribution": 0.07,
            "Fossil_abs": 3.73425406138498e-05,
            "Land_abs": -0.000002584169734255,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 104,
            "Perc_contribution_rescale": 0.248403122782115
        },
        {
            "Country": "Switzerland",
            "Abs_contribution": 3.441695811076e-05,
            "Perc_contribution": 0.07,
            "Fossil_abs": 3.493463019133e-05,
            "Land_abs": -0.000000517672080561026,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 105,
            "Perc_contribution_rescale": 0.248403122782115
        },
        {
            "Country": "Hong Kong",
            "Abs_contribution": 3.43176213333139e-05,
            "Perc_contribution": 0.07,
            "Fossil_abs": 3.4355131854544e-05,
            "Land_abs": -0.0000000375105212280598,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 106,
            "Perc_contribution_rescale": 0.248403122782115
        },
        {
            "Country": "Sri Lanka",
            "Abs_contribution": 3.39900205394502e-05,
            "Perc_contribution": 0.07,
            "Fossil_abs": 2.38058991264271e-05,
            "Land_abs": 1.01841214130169e-05,
            "Fossil_fraction": 70.0379074463842,
            "Land_fraction": 29.9620925535976,
            "Rank": 107,
            "Perc_contribution_rescale": 0.248403122782115
        },
        {
            "Country": "Venezuela",
            "Abs_contribution": 3.39528865110992e-05,
            "Perc_contribution": 0.07,
            "Fossil_abs": -0.00000333730263956961,
            "Land_abs": 3.72901891506098e-05,
            "Fossil_fraction": 0,
            "Land_fraction": 100,
            "Rank": 108,
            "Perc_contribution_rescale": 0.248403122782115
        },
        {
            "Country": "Hungary",
            "Abs_contribution": 3.35332221612699e-05,
            "Perc_contribution": 0.07,
            "Fossil_abs": 3.46134093647801e-05,
            "Land_abs": -0.00000108018720350599,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 109,
            "Perc_contribution_rescale": 0.248403122782115
        },
        {
            "Country": "Greece",
            "Abs_contribution": 3.311067899922e-05,
            "Perc_contribution": 0.07,
            "Fossil_abs": 4.38549040798803e-05,
            "Land_abs": -0.000010744225080678,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 110,
            "Perc_contribution_rescale": 0.248403122782115
        },
        {
            "Country": "Senegal",
            "Abs_contribution": 3.2806647084011e-05,
            "Perc_contribution": 0.07,
            "Fossil_abs": 1.616836990834e-05,
            "Land_abs": 1.6638277175677e-05,
            "Fossil_fraction": 49.2838230829751,
            "Land_fraction": 50.7161769170431,
            "Rank": 111,
            "Perc_contribution_rescale": 0.248403122782115
        },
        {
            "Country": "Lebanon",
            "Abs_contribution": 3.24528515752999e-05,
            "Perc_contribution": 0.07,
            "Fossil_abs": 3.1257349561761e-05,
            "Land_abs": 1.1955020135374e-06,
            "Fossil_fraction": 96.3161880836109,
            "Land_fraction": 3.68381191638427,
            "Rank": 112,
            "Perc_contribution_rescale": 0.248403122782115
        },
        {
            "Country": "Portugal",
            "Abs_contribution": 3.09110104136899e-05,
            "Perc_contribution": 0.06,
            "Fossil_abs": 3.102933818896e-05,
            "Land_abs": -0.000000118327775263001,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 113,
            "Perc_contribution_rescale": 0.21291696238467
        },
        {
            "Country": "New Zealand",
            "Abs_contribution": 3.089347312169e-05,
            "Perc_contribution": 0.06,
            "Fossil_abs": 2.79346330728299e-05,
            "Land_abs": 2.95884004883036e-06,
            "Fossil_fraction": 90.4224428337819,
            "Land_fraction": 9.57755716612191,
            "Rank": 114,
            "Perc_contribution_rescale": 0.21291696238467
        },
        {
            "Country": "Slovakia",
            "Abs_contribution": 3.04925047221699e-05,
            "Perc_contribution": 0.06,
            "Fossil_abs": 3.41899041957699e-05,
            "Land_abs": -0.00000369739947360102,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 115,
            "Perc_contribution_rescale": 0.21291696238467
        },
        {
            "Country": "Tajikistan",
            "Abs_contribution": 3.04766298201079e-05,
            "Perc_contribution": 0.06,
            "Fossil_abs": 1.6124499770436e-05,
            "Land_abs": 1.4352130049674e-05,
            "Fossil_fraction": 52.9077521550542,
            "Land_fraction": 47.0922478449528,
            "Rank": 116,
            "Perc_contribution_rescale": 0.21291696238467
        },
        {
            "Country": "Denmark",
            "Abs_contribution": 2.86466263660903e-05,
            "Perc_contribution": 0.06,
            "Fossil_abs": 2.476338098371e-05,
            "Land_abs": 3.88324538237402e-06,
            "Fossil_fraction": 86.4443186686129,
            "Land_fraction": 13.5556813313651,
            "Rank": 117,
            "Perc_contribution_rescale": 0.21291696238467
        },
        {
            "Country": "Bosnia and Herzegovina",
            "Abs_contribution": 2.7884972234184e-05,
            "Perc_contribution": 0.06,
            "Fossil_abs": 2.7074349287924e-05,
            "Land_abs": 8.10622946261972e-07,
            "Fossil_fraction": 97.092975601868,
            "Land_fraction": 2.90702439813884,
            "Rank": 118,
            "Perc_contribution_rescale": 0.21291696238467
        },
        {
            "Country": "Yemen",
            "Abs_contribution": 2.73073163975701e-05,
            "Perc_contribution": 0.06,
            "Fossil_abs": 1.8980616759483e-05,
            "Land_abs": 8.32669963807698e-06,
            "Fossil_fraction": 69.5074407281266,
            "Land_fraction": 30.4925592718365,
            "Rank": 119,
            "Perc_contribution_rescale": 0.21291696238467
        },
        {
            "Country": "Kyrgyzstan",
            "Abs_contribution": 2.634836257599e-05,
            "Perc_contribution": 0.05,
            "Fossil_abs": 1.5605343726988e-05,
            "Land_abs": 1.0743018848999e-05,
            "Fossil_fraction": 59.2269962961888,
            "Land_fraction": 40.7730037037997,
            "Rank": 120,
            "Perc_contribution_rescale": 0.177430801987225
        },
        {
            "Country": "Botswana",
            "Abs_contribution": 2.50283107139461e-05,
            "Perc_contribution": 0.05,
            "Fossil_abs": 9.518572985085e-06,
            "Land_abs": 1.5509737728862e-05,
            "Fossil_fraction": 38.0312242958576,
            "Land_fraction": 61.9687757041459,
            "Rank": 121,
            "Perc_contribution_rescale": 0.177430801987225
        },
        {
            "Country": "Finland",
            "Abs_contribution": 2.35940550487e-05,
            "Perc_contribution": 0.05,
            "Fossil_abs": 6.4541807703101e-06,
            "Land_abs": 1.71398742783999e-05,
            "Fossil_fraction": 27.3551144853572,
            "Land_fraction": 72.644885514685,
            "Rank": 122,
            "Perc_contribution_rescale": 0.177430801987225
        },
        {
            "Country": "Namibia",
            "Abs_contribution": 2.2969068514795e-05,
            "Perc_contribution": 0.05,
            "Fossil_abs": 7.1460320933097e-06,
            "Land_abs": 1.5823036421482e-05,
            "Fossil_fraction": 31.1115450272036,
            "Land_fraction": 68.8884549727818,
            "Rank": 123,
            "Perc_contribution_rescale": 0.177430801987225
        },
        {
            "Country": "Sierra Leone",
            "Abs_contribution": 2.2619889796118e-05,
            "Perc_contribution": 0.05,
            "Fossil_abs": 6.13078503070399e-06,
            "Land_abs": 1.6489104765416e-05,
            "Fossil_fraction": 27.1035141460157,
            "Land_fraction": 72.8964858539934,
            "Rank": 124,
            "Perc_contribution_rescale": 0.177430801987225
        },
        {
            "Country": "Zimbabwe",
            "Abs_contribution": 2.192594071428e-05,
            "Perc_contribution": 0.04,
            "Fossil_abs": 1.37364913434289e-05,
            "Land_abs": 8.18944937085002e-06,
            "Fossil_fraction": 62.6494959665861,
            "Land_fraction": 37.350504033409,
            "Rank": 125,
            "Perc_contribution_rescale": 0.14194464158978
        },
        {
            "Country": "Central African Republic",
            "Abs_contribution": 2.18565646590699e-05,
            "Perc_contribution": 0.04,
            "Fossil_abs": 2.63980978900419e-06,
            "Land_abs": 1.92167548700699e-05,
            "Fossil_fraction": 12.0778806284579,
            "Land_fraction": 87.9221193715613,
            "Rank": 126,
            "Perc_contribution_rescale": 0.14194464158978
        },
        {
            "Country": "Liberia",
            "Abs_contribution": 2.144920218896e-05,
            "Perc_contribution": 0.04,
            "Fossil_abs": 7.81894318230599e-06,
            "Land_abs": 1.3630259006656e-05,
            "Fossil_fraction": 36.4533054116597,
            "Land_fraction": 63.5466945883496,
            "Rank": 127,
            "Perc_contribution_rescale": 0.14194464158978
        },
        {
            "Country": "Panama",
            "Abs_contribution": 2.13094135693601e-05,
            "Perc_contribution": 0.04,
            "Fossil_abs": 1.465803738519e-05,
            "Land_abs": 6.65137618416204e-06,
            "Fossil_fraction": 68.7866765431131,
            "Land_fraction": 31.213323456849,
            "Rank": 128,
            "Perc_contribution_rescale": 0.14194464158978
        },
        {
            "Country": "Mauritania",
            "Abs_contribution": 1.9227425582121e-05,
            "Perc_contribution": 0.04,
            "Fossil_abs": 8.07747497559009e-06,
            "Land_abs": 1.1149950606531e-05,
            "Fossil_fraction": 42.0101741706965,
            "Land_fraction": 57.989825829304,
            "Rank": 129,
            "Perc_contribution_rescale": 0.14194464158978
        },
        {
            "Country": "Haiti",
            "Abs_contribution": 1.817506106552e-05,
            "Perc_contribution": 0.04,
            "Fossil_abs": 1.4856950756894e-05,
            "Land_abs": 3.31811030862805e-06,
            "Fossil_fraction": 81.7436084717163,
            "Land_fraction": 18.2563915282951,
            "Rank": 130,
            "Perc_contribution_rescale": 0.14194464158978
        },
        {
            "Country": "Togo",
            "Abs_contribution": 1.6743103845146e-05,
            "Perc_contribution": 0.03,
            "Fossil_abs": 1.1786911735608e-05,
            "Land_abs": 4.95619210954103e-06,
            "Fossil_fraction": 70.3986061642036,
            "Land_fraction": 29.6013938358142,
            "Rank": 131,
            "Perc_contribution_rescale": 0.106458481192335
        },
        {
            "Country": "Cuba",
            "Abs_contribution": 1.55449791185e-05,
            "Perc_contribution": 0.03,
            "Fossil_abs": 2.18501778247102e-05,
            "Land_abs": -0.00000630519870622017,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 132,
            "Perc_contribution_rescale": 0.106458481192335
        },
        {
            "Country": "Lithuania",
            "Abs_contribution": 1.493607029686e-05,
            "Perc_contribution": 0.03,
            "Fossil_abs": 1.18692167799839e-05,
            "Land_abs": 3.06685351686897e-06,
            "Fossil_fraction": 79.4667977860223,
            "Land_fraction": 20.5332022139298,
            "Rank": 133,
            "Perc_contribution_rescale": 0.106458481192335
        },
        {
            "Country": "Rwanda",
            "Abs_contribution": 1.4917983058066e-05,
            "Perc_contribution": 0.03,
            "Fossil_abs": 8.091498173366e-06,
            "Land_abs": 6.826484884701e-06,
            "Fossil_fraction": 54.239893837331,
            "Land_fraction": 45.7601061626759,
            "Rank": 134,
            "Perc_contribution_rescale": 0.106458481192335
        },
        {
            "Country": "Croatia",
            "Abs_contribution": 1.4189866226899e-05,
            "Perc_contribution": 0.03,
            "Fossil_abs": 1.6831749790276e-05,
            "Land_abs": -0.00000264188356337498,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 135,
            "Perc_contribution_rescale": 0.106458481192335
        },
        {
            "Country": "Burundi",
            "Abs_contribution": 1.4177110262262e-05,
            "Perc_contribution": 0.03,
            "Fossil_abs": 7.51327242991902e-06,
            "Land_abs": 6.66383783234703e-06,
            "Fossil_fraction": 52.9957959762688,
            "Land_fraction": 47.0042040237599,
            "Rank": 136,
            "Perc_contribution_rescale": 0.106458481192335
        },
        {
            "Country": "Costa Rica",
            "Abs_contribution": 1.37553476418e-05,
            "Perc_contribution": 0.03,
            "Fossil_abs": 1.0498681963775e-05,
            "Land_abs": 3.25666567801996e-06,
            "Fossil_fraction": 76.3243666184885,
            "Land_fraction": 23.6756333814753,
            "Rank": 137,
            "Perc_contribution_rescale": 0.106458481192335
        },
        {
            "Country": "Estonia",
            "Abs_contribution": 1.29477157312899e-05,
            "Perc_contribution": 0.03,
            "Fossil_abs": 1.0599060566518e-05,
            "Land_abs": 2.34865516477399e-06,
            "Fossil_fraction": 81.8604670235686,
            "Land_fraction": 18.1395329764474,
            "Rank": 138,
            "Perc_contribution_rescale": 0.106458481192335
        },
        {
            "Country": "Latvia",
            "Abs_contribution": 1.282859908012e-05,
            "Perc_contribution": 0.03,
            "Fossil_abs": 7.69281357800494e-06,
            "Land_abs": 5.13578550211097e-06,
            "Fossil_fraction": 59.9661235802917,
            "Land_fraction": 40.0338764196762,
            "Rank": 139,
            "Perc_contribution_rescale": 0.106458481192335
        },
        {
            "Country": "Guyana",
            "Abs_contribution": 1.15981037190501e-05,
            "Perc_contribution": 0.02,
            "Fossil_abs": 3.52212271226149e-06,
            "Land_abs": 8.07598100679193e-06,
            "Fossil_fraction": 30.3680911774943,
            "Land_fraction": 69.6319088225344,
            "Rank": 140,
            "Perc_contribution_rescale": 0.07097232079489
        },
        {
            "Country": "Eritrea",
            "Abs_contribution": 1.030792044708e-05,
            "Perc_contribution": 0.02,
            "Fossil_abs": 3.83402030613051e-06,
            "Land_abs": 6.47390014095001e-06,
            "Fossil_fraction": 37.1948961559614,
            "Land_fraction": 62.8051038440439,
            "Rank": 141,
            "Perc_contribution_rescale": 0.07097232079489
        },
        {
            "Country": "Slovenia",
            "Abs_contribution": 9.29807313316698e-06,
            "Perc_contribution": 0.02,
            "Fossil_abs": 8.28610112543705e-06,
            "Land_abs": 1.01197200772901e-06,
            "Fossil_fraction": 89.1163255737348,
            "Land_fraction": 10.8836744262553,
            "Rank": 142,
            "Perc_contribution_rescale": 0.07097232079489
        },
        {
            "Country": "Armenia",
            "Abs_contribution": 8.10731330601203e-06,
            "Perc_contribution": 0.02,
            "Fossil_abs": 6.01692020009e-06,
            "Land_abs": 2.090393105921e-06,
            "Fossil_fraction": 74.2159575309383,
            "Land_fraction": 25.784042469049,
            "Rank": 143,
            "Perc_contribution_rescale": 0.07097232079489
        },
        {
            "Country": "Cyprus",
            "Abs_contribution": 8.02200059659601e-06,
            "Perc_contribution": 0.02,
            "Fossil_abs": 7.97929361046802e-06,
            "Land_abs": 4.2706986127499e-08,
            "Fossil_fraction": 99.4676267395678,
            "Land_fraction": 0.532373260426095,
            "Rank": 144,
            "Perc_contribution_rescale": 0.07097232079489
        },
        {
            "Country": "Belize",
            "Abs_contribution": 7.38021114845302e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 1.2134099737826e-06,
            "Land_abs": 6.16680117467101e-06,
            "Fossil_fraction": 16.441399160198,
            "Land_fraction": 83.5586008398098,
            "Rank": 145,
            "Perc_contribution_rescale": 0.035486160397445
        },
        {
            "Country": "Brunei Darussalam",
            "Abs_contribution": 7.28769844884794e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 6.39142050407602e-06,
            "Land_abs": 8.96277944773499e-07,
            "Fossil_fraction": 87.7014951831108,
            "Land_fraction": 12.2985048169108,
            "Rank": 146,
            "Perc_contribution_rescale": 0.035486160397445
        },
        {
            "Country": "Kosovo",
            "Abs_contribution": 7.2529005867903e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 7.2529005867903e-06,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 147,
            "Perc_contribution_rescale": 0.035486160397445
        },
        {
            "Country": "Luxembourg",
            "Abs_contribution": 7.22480563959303e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 6.921788756082e-06,
            "Land_abs": 3.03016883511398e-07,
            "Fossil_fraction": 95.8058818655211,
            "Land_fraction": 4.19411813448405,
            "Rank": 148,
            "Perc_contribution_rescale": 0.035486160397445
        },
        {
            "Country": "Suriname",
            "Abs_contribution": 7.077222628095e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 4.02809182683921e-06,
            "Land_abs": 3.0491308012562e-06,
            "Fossil_fraction": 56.9162797118827,
            "Land_fraction": 43.083720288123,
            "Rank": 149,
            "Perc_contribution_rescale": 0.035486160397445
        },
        {
            "Country": "Timor-Leste",
            "Abs_contribution": 6.81123410329999e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 4.1698016916102e-06,
            "Land_abs": 2.64143241168901e-06,
            "Fossil_fraction": 61.2194740097094,
            "Land_fraction": 38.7805259902791,
            "Rank": 150,
            "Perc_contribution_rescale": 0.035486160397445
        },
        {
            "Country": "North Macedonia",
            "Abs_contribution": 5.83161607728704e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 7.38506577635403e-06,
            "Land_abs": -0.000001553449699067,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 151,
            "Perc_contribution_rescale": 0.035486160397445
        },
        {
            "Country": "Gambia",
            "Abs_contribution": 5.518084913813e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 2.0674230393697e-06,
            "Land_abs": 3.4506618744428e-06,
            "Fossil_fraction": 37.4663143402249,
            "Land_fraction": 62.5336856597662,
            "Rank": 152,
            "Perc_contribution_rescale": 0.035486160397445
        },
        {
            "Country": "Guinea-Bissau",
            "Abs_contribution": 5.002226461795e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 2.1531971322678e-06,
            "Land_abs": 2.84902932952798e-06,
            "Fossil_fraction": 43.044775135893,
            "Land_fraction": 56.9552248641225,
            "Rank": 153,
            "Perc_contribution_rescale": 0.035486160397445
        },
        {
            "Country": "Jamaica",
            "Abs_contribution": 4.71947260175502e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 6.26005049365902e-06,
            "Land_abs": -0.000001540577891905,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 154,
            "Perc_contribution_rescale": 0.035486160397445
        },
        {
            "Country": "Georgia",
            "Abs_contribution": 4.61132255426505e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 1.0647759352675e-05,
            "Land_abs": -0.00000603643679841239,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 155,
            "Perc_contribution_rescale": 0.035486160397445
        },
        {
            "Country": "Lesotho",
            "Abs_contribution": 4.55599842943898e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 3.5869617519048e-06,
            "Land_abs": 9.69036677535002e-07,
            "Fossil_fraction": 78.7305309134292,
            "Land_fraction": 21.269469086589,
            "Rank": 156,
            "Perc_contribution_rescale": 0.035486160397445
        },
        {
            "Country": "New Caledonia",
            "Abs_contribution": 4.34655888373359e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 4.34655888373359e-06,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 157,
            "Perc_contribution_rescale": 0.035486160397445
        },
        {
            "Country": "Mauritius",
            "Abs_contribution": 4.33255336846029e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 4.23684841393659e-06,
            "Land_abs": 9.57049545236702e-08,
            "Fossil_fraction": 97.7910265290578,
            "Land_fraction": 2.2089734709415,
            "Rank": 158,
            "Perc_contribution_rescale": 0.035486160397445
        },
        {
            "Country": "Iceland",
            "Abs_contribution": 3.90378703601802e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 3.2780715248505e-06,
            "Land_abs": 6.2571551116761e-07,
            "Fossil_fraction": 83.9715766922121,
            "Land_fraction": 16.0284233077904,
            "Rank": 159,
            "Perc_contribution_rescale": 0.035486160397445
        },
        {
            "Country": "Bhutan",
            "Abs_contribution": 3.45133471760998e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 2.4817556671099e-06,
            "Land_abs": 9.69579050499035e-07,
            "Fossil_fraction": 71.9071278264338,
            "Land_fraction": 28.0928721735358,
            "Rank": 160,
            "Perc_contribution_rescale": 0.035486160397445
        },
        {
            "Country": "Solomon Islands",
            "Abs_contribution": 3.36184559242781e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 7.137687332882e-07,
            "Land_abs": 2.6480768591395e-06,
            "Fossil_fraction": 21.2314549750853,
            "Land_fraction": 78.7685450249115,
            "Rank": 161,
            "Perc_contribution_rescale": 0.035486160397445
        },
        {
            "Country": "El Salvador",
            "Abs_contribution": 2.584632920903e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 6.88988237021999e-06,
            "Land_abs": -0.00000430524944932,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 162,
            "Perc_contribution_rescale": 0.035486160397445
        },
        {
            "Country": "Moldova",
            "Abs_contribution": 2.44744096143993e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 6.76662009450207e-06,
            "Land_abs": -0.00000431917913305997,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 163,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Bahamas",
            "Abs_contribution": 2.4033837002982e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 2.41395588249179e-06,
            "Land_abs": -0.0000000105721821939295,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 164,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Albania",
            "Abs_contribution": 2.317545574091e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 5.73218367802e-06,
            "Land_abs": -0.00000341463810392899,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 165,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Maldives",
            "Abs_contribution": 2.0799404530521e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 2.0785334783621e-06,
            "Land_abs": 1.4069746900306e-09,
            "Fossil_fraction": 99.9323550494952,
            "Land_fraction": 0.067644950506444,
            "Rank": 166,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Djibouti",
            "Abs_contribution": 2.0233341362149e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.60655915646551e-06,
            "Land_abs": 4.16774979749198e-07,
            "Fossil_fraction": 79.4015742486773,
            "Land_fraction": 20.5984257513131,
            "Rank": 167,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Cura\xe7ao",
            "Abs_contribution": 1.57494751637499e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.57494751637499e-06,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 168,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Malta",
            "Abs_contribution": 1.5440374538545e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.6665005615602e-06,
            "Land_abs": -0.00000012246310770603,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 169,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Comoros",
            "Abs_contribution": 1.4089110965094e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.0454056938484e-06,
            "Land_abs": 3.63505402661099e-07,
            "Fossil_fraction": 74.1995500240157,
            "Land_fraction": 25.8004499759914,
            "Rank": 170,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Macao",
            "Abs_contribution": 1.1803998356763e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.1773660440029e-06,
            "Land_abs": 3.03379167342151e-09,
            "Fossil_fraction": 99.7429860982938,
            "Land_fraction": 0.257013901707578,
            "Rank": 171,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Montenegro",
            "Abs_contribution": 1.09153868814899e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 2.9674268362032e-06,
            "Land_abs": -0.00000187588814805501,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 172,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Barbados",
            "Abs_contribution": 1.0024571143923e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.1002696336219e-06,
            "Land_abs": -0.0000000978125192295996,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 173,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "French Polynesia",
            "Abs_contribution": 7.90951187227099e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 7.90951187227099e-07,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 174,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Aruba",
            "Abs_contribution": 7.84897358645498e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 7.84872653678402e-07,
            "Land_abs": 2.4704967131823e-11,
            "Fossil_fraction": 99.9968524588821,
            "Land_fraction": 0.00314754112237764,
            "Rank": 175,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Seychelles",
            "Abs_contribution": 7.19805577813881e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 7.21820806251001e-07,
            "Land_abs": -0.00000000201522843708799,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 176,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Cape Verde",
            "Abs_contribution": 7.14613332904803e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 6.576697125355e-07,
            "Land_abs": 5.694362036924e-08,
            "Fossil_fraction": 92.0315480068312,
            "Land_fraction": 7.96845199316001,
            "Rank": 177,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Faeroe Islands",
            "Abs_contribution": 6.68692671943199e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 6.68692671943199e-07,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 178,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Sint Maarten (Dutch part)",
            "Abs_contribution": 5.686420578603e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 5.686420578603e-07,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 179,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Greenland",
            "Abs_contribution": 5.21674249454201e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 5.21674249454201e-07,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 180,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Antigua and Barbuda",
            "Abs_contribution": 4.83750677298898e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 5.56647527577e-07,
            "Land_abs": -0.000000072896850277933,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 181,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Bermuda",
            "Abs_contribution": 3.993274699782e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 3.993274699782e-07,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 182,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Lucia",
            "Abs_contribution": 3.908274475469e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 4.2733951938824e-07,
            "Land_abs": -0.0000000365120718413204,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 183,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Turks and Caicos Islands",
            "Abs_contribution": 3.2478668195758e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 3.2478668195758e-07,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 184,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Grenada",
            "Abs_contribution": 3.2295885455881e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 3.4441027772641e-07,
            "Land_abs": -0.000000021451423167546,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 185,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Andorra",
            "Abs_contribution": 3.206132093683e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 3.1345706264632e-07,
            "Land_abs": 7.15614672188009e-09,
            "Fossil_fraction": 97.7679813205202,
            "Land_fraction": 2.23201867944859,
            "Rank": 186,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Fiji",
            "Abs_contribution": 2.8737165961898e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 1.6824396743871e-06,
            "Land_abs": -0.00000139506801476801,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 187,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Sao Tome and Principe",
            "Abs_contribution": 2.8046470967003e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 2.6753080105898e-07,
            "Land_abs": 1.29339086110797e-08,
            "Fossil_fraction": 95.3884006917421,
            "Land_fraction": 4.61159930826827,
            "Rank": 188,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Tonga",
            "Abs_contribution": 2.74533952864799e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 2.209533903884e-07,
            "Land_abs": 5.35805624764495e-08,
            "Fossil_fraction": 80.4830834520545,
            "Land_fraction": 19.516916547964,
            "Rank": 189,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Vincent and the Grenadines",
            "Abs_contribution": 2.4244185049358e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 2.7151454839349e-07,
            "Land_abs": -0.0000000290726978999198,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 190,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Samoa",
            "Abs_contribution": 2.04624479732299e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 2.7032495136411e-07,
            "Land_abs": -0.0000000657004716317991,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 191,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Kitts and Nevis",
            "Abs_contribution": 1.9212465699039e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 2.3343760070056e-07,
            "Land_abs": -0.000000041312943710164,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 192,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Palau",
            "Abs_contribution": 1.7971347040987e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 1.5901800669194e-07,
            "Land_abs": 2.0695463717944e-08,
            "Fossil_fraction": 88.4841889310079,
            "Land_fraction": 11.5158110690001,
            "Rank": 193,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Dominica",
            "Abs_contribution": 1.60015743843739e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 1.7629350462223e-07,
            "Land_abs": -0.00000001627776077853,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 194,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Micronesia (Federated States of)",
            "Abs_contribution": 1.5092816887257e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 1.383290767749e-07,
            "Land_abs": 1.25990920976301e-08,
            "Fossil_fraction": 91.6522593550391,
            "Land_fraction": 8.34774064493392,
            "Rank": 195,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "British Virgin Islands",
            "Abs_contribution": 1.405634279476e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 1.405634279476e-07,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 196,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Marshall Islands",
            "Abs_contribution": 1.3696125818777e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 1.3696125818777e-07,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 197,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Liechtenstein",
            "Abs_contribution": 1.3136906319502e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 1.4620207157986e-07,
            "Land_abs": -0.000000014833008384828,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 198,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Anguilla",
            "Abs_contribution": 1.2458986080786e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 1.2458986080786e-07,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 199,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Kiribati",
            "Abs_contribution": 1.1660050086423e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 1.0601584765392e-07,
            "Land_abs": 1.0584653210298e-08,
            "Fossil_fraction": 90.922291815337,
            "Land_fraction": 9.07770818465249,
            "Rank": 200,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Bonaire, Saint Eustatius and Saba",
            "Abs_contribution": 9.90333242358102e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 9.90333242358102e-08,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 201,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Occupied Palestinian Territory",
            "Abs_contribution": 6.36900000000003e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 6.36900000000003e-08,
            "Fossil_fraction": 0,
            "Land_fraction": 100,
            "Rank": 202,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Nauru",
            "Abs_contribution": 5.62456892313302e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 5.53462962363399e-08,
            "Land_abs": 8.993929949831e-10,
            "Fossil_fraction": 98.4009565759053,
            "Land_fraction": 1.59904342408185,
            "Rank": 203,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Pierre and Miquelon",
            "Abs_contribution": 5.43085971615701e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 5.43085971615701e-08,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 204,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Cook Islands",
            "Abs_contribution": 4.50811153515801e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 6.39931217532199e-08,
            "Land_abs": -0.00000001891200640164,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 205,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Wallis and Futuna Islands",
            "Abs_contribution": 2.3968231441048e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 2.3968231441048e-08,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 206,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Tuvalu",
            "Abs_contribution": 2.1159938477911e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 1.6425412634236e-08,
            "Land_abs": 4.73452584367496e-09,
            "Fossil_fraction": 77.6250491058026,
            "Land_fraction": 22.3749508941974,
            "Rank": 207,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Montserrat",
            "Abs_contribution": 1.9167740174672e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 1.9167740174672e-08,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 208,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Helena",
            "Abs_contribution": 1.5973116812227e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 1.5973116812227e-08,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 209,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Niue",
            "Abs_contribution": 6.37845652184392e-09,
            "Perc_contribution": 0,
            "Fossil_abs": 6.865382143162e-09,
            "Land_abs": -0.000000000486925621317026,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 210,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Antarctica",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 211,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Christmas Island",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 212,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Kuwaiti Oil Fires",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 213,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Leeward Islands",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 214,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Pacific Islands (Palau)",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 215,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Panama Canal Zone",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 216,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Ryukyu Islands",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 217,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "St. Kitts-Nevis-Anguilla",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 218,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Vanuatu",
            "Abs_contribution": -0.00000000938069404949205,
            "Perc_contribution": -0,
            "Fossil_abs": 4.1999778682742e-07,
            "Land_abs": -0.0000004293784808773,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 219,
            "Perc_contribution_rescale": -0
        },
        {
            "Country": "Swaziland",
            "Abs_contribution": -0.00000094849831425102,
            "Perc_contribution": -0,
            "Fossil_abs": -0.00000169107392156,
            "Land_abs": 7.42575607308698e-07,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 220,
            "Perc_contribution_rescale": -0
        },
        {
            "Country": "Equatorial Guinea",
            "Abs_contribution": -0.00000124932002441402,
            "Perc_contribution": -0,
            "Fossil_abs": -0.00000351497343604491,
            "Land_abs": 2.26565341163199e-06,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 221,
            "Perc_contribution_rescale": -0
        },
        {
            "Country": "Gabon",
            "Abs_contribution": -0.00002005070220024,
            "Perc_contribution": -0.04,
            "Fossil_abs": -0.0000246560620447049,
            "Land_abs": 4.60535984446496e-06,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 222,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Syria",
            "Abs_contribution": -0.0000279664334278001,
            "Perc_contribution": -0.06,
            "Fossil_abs": -0.0000330644501158601,
            "Land_abs": 5.09801668806698e-06,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 223,
            "Perc_contribution_rescale": 0
        }
    ],
    "2020_CH4": [
        {
            "Country": "China",
            "Abs_contribution": 0.0031094221386631,
            "Perc_contribution": 29.55,
            "Fossil_abs": 0.003116453546966,
            "Land_abs": -0.00000703140830289953,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 1,
            "Perc_contribution_rescale": 100
        },
        {
            "Country": "India",
            "Abs_contribution": 0.000887477866174498,
            "Perc_contribution": 8.43,
            "Fossil_abs": 0.000490583992442001,
            "Land_abs": 0.000396893873732602,
            "Fossil_fraction": 55.2784481889874,
            "Land_fraction": 44.7215518110245,
            "Rank": 2,
            "Perc_contribution_rescale": 28.5279187817259
        },
        {
            "Country": "Indonesia",
            "Abs_contribution": 0.000769636775583199,
            "Perc_contribution": 7.31,
            "Fossil_abs": 0.0007244776702683,
            "Land_abs": 4.51591053147998e-05,
            "Fossil_fraction": 94.1324132697949,
            "Land_fraction": 5.86758673019231,
            "Rank": 3,
            "Perc_contribution_rescale": 24.7377326565144
        },
        {
            "Country": "Russia",
            "Abs_contribution": 0.000638673138959597,
            "Perc_contribution": 6.07,
            "Fossil_abs": 0.000700811110159599,
            "Land_abs": -0.0000621379711999602,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 4,
            "Perc_contribution_rescale": 20.5414551607445
        },
        {
            "Country": "Brazil",
            "Abs_contribution": 0.000624881357062901,
            "Perc_contribution": 5.94,
            "Fossil_abs": 0.000274825792396041,
            "Land_abs": 0.000350055564666798,
            "Fossil_fraction": 43.9804755398354,
            "Land_fraction": 56.0195244601546,
            "Rank": 5,
            "Perc_contribution_rescale": 20.1015228426396
        },
        {
            "Country": "Pakistan",
            "Abs_contribution": 0.000431804475135131,
            "Perc_contribution": 4.1,
            "Fossil_abs": 0.00010724577472857,
            "Land_abs": 0.00032455870040654,
            "Fossil_fraction": 24.8366519812024,
            "Land_fraction": 75.1633480187928,
            "Rank": 6,
            "Perc_contribution_rescale": 13.8747884940778
        },
        {
            "Country": "Iraq",
            "Abs_contribution": 0.00037194337218308,
            "Perc_contribution": 3.53,
            "Fossil_abs": 0.00036683976757146,
            "Land_abs": 5.103604611629e-06,
            "Fossil_fraction": 98.6278544011513,
            "Land_fraction": 1.37214559885123,
            "Rank": 7,
            "Perc_contribution_rescale": 11.9458544839255
        },
        {
            "Country": "Iran",
            "Abs_contribution": 0.00034197588967066,
            "Perc_contribution": 3.25,
            "Fossil_abs": 0.00035790025210239,
            "Land_abs": -0.0000159243624317359,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 8,
            "Perc_contribution_rescale": 10.9983079526227
        },
        {
            "Country": "Ethiopia",
            "Abs_contribution": 0.00024755763344758,
            "Perc_contribution": 2.35,
            "Fossil_abs": 7.10165570867399e-05,
            "Land_abs": 0.00017654107636084,
            "Fossil_fraction": 28.6868783231351,
            "Land_fraction": 71.3131216768648,
            "Rank": 9,
            "Perc_contribution_rescale": 7.95262267343486
        },
        {
            "Country": "Saudi Arabia",
            "Abs_contribution": 0.0002439753878604,
            "Perc_contribution": 2.32,
            "Fossil_abs": 0.00023846345530215,
            "Land_abs": 5.511932558276e-06,
            "Fossil_fraction": 97.7407833607361,
            "Land_fraction": 2.25921663927423,
            "Rank": 10,
            "Perc_contribution_rescale": 7.85109983079526
        },
        {
            "Country": "Qatar",
            "Abs_contribution": 0.00022663838821876,
            "Perc_contribution": 2.15,
            "Fossil_abs": 0.00022533937039317,
            "Land_abs": 1.29901782559519e-06,
            "Fossil_fraction": 99.4268323933118,
            "Land_fraction": 0.573167606690412,
            "Rank": 11,
            "Perc_contribution_rescale": 7.27580372250423
        },
        {
            "Country": "T\xfcrkiye",
            "Abs_contribution": 0.00019880893673163,
            "Perc_contribution": 1.89,
            "Fossil_abs": 0.00014913167666241,
            "Land_abs": 4.9677260069214e-05,
            "Fossil_fraction": 75.0125618667339,
            "Land_fraction": 24.987438133263,
            "Rank": 12,
            "Perc_contribution_rescale": 6.39593908629442
        },
        {
            "Country": "Chad",
            "Abs_contribution": 0.00017768204793038,
            "Perc_contribution": 1.69,
            "Fossil_abs": 1.3490992708956e-05,
            "Land_abs": 0.00016419105522143,
            "Fossil_fraction": 7.59277195760489,
            "Land_fraction": 92.4072280423984,
            "Rank": 13,
            "Perc_contribution_rescale": 5.71912013536379
        },
        {
            "Country": "Kenya",
            "Abs_contribution": 0.00013473127393088,
            "Perc_contribution": 1.28,
            "Fossil_abs": 4.5298158305056e-05,
            "Land_abs": 8.943311562583e-05,
            "Fossil_fraction": 33.6211163031791,
            "Land_fraction": 66.3788836968253,
            "Rank": 14,
            "Perc_contribution_rescale": 4.33164128595601
        },
        {
            "Country": "Mexico",
            "Abs_contribution": 0.000130416795983561,
            "Perc_contribution": 1.24,
            "Fossil_abs": 7.65499648649097e-05,
            "Land_abs": 5.38668311185998e-05,
            "Fossil_fraction": 58.6964004809312,
            "Land_fraction": 41.3035995190296,
            "Rank": 15,
            "Perc_contribution_rescale": 4.19627749576988
        },
        {
            "Country": "Viet Nam",
            "Abs_contribution": 0.00012639234471066,
            "Perc_contribution": 1.2,
            "Fossil_abs": 0.00010597811457458,
            "Land_abs": 2.04142301360902e-05,
            "Fossil_fraction": 83.8485232766174,
            "Land_fraction": 16.1514767233909,
            "Rank": 16,
            "Perc_contribution_rescale": 4.06091370558376
        },
        {
            "Country": "Bangladesh",
            "Abs_contribution": 0.0001250647302132,
            "Perc_contribution": 1.19,
            "Fossil_abs": 7.285518416218e-05,
            "Land_abs": 5.220954605102e-05,
            "Fossil_fraction": 58.2539809888707,
            "Land_fraction": 41.7460190111293,
            "Rank": 17,
            "Perc_contribution_rescale": 4.02707275803722
        },
        {
            "Country": "Tanzania",
            "Abs_contribution": 0.00011749592631639,
            "Perc_contribution": 1.12,
            "Fossil_abs": 4.24443362959099e-05,
            "Land_abs": 7.505159002048e-05,
            "Fossil_fraction": 36.1240918103126,
            "Land_fraction": 63.8759081896874,
            "Rank": 18,
            "Perc_contribution_rescale": 3.79018612521151
        },
        {
            "Country": "Democratic Republic of the Congo",
            "Abs_contribution": 0.00011646753653372,
            "Perc_contribution": 1.11,
            "Fossil_abs": 9.81640309364201e-05,
            "Land_abs": 1.830350559729e-05,
            "Fossil_fraction": 84.2844571611588,
            "Land_fraction": 15.7155428388328,
            "Rank": 19,
            "Perc_contribution_rescale": 3.75634517766498
        },
        {
            "Country": "Philippines",
            "Abs_contribution": 0.00011280142866078,
            "Perc_contribution": 1.07,
            "Fossil_abs": 7.59403019888699e-05,
            "Land_abs": 3.686112667191e-05,
            "Fossil_fraction": 67.3221100924527,
            "Land_fraction": 32.6778899075471,
            "Rank": 20,
            "Perc_contribution_rescale": 3.62098138747885
        },
        {
            "Country": "Kazakhstan",
            "Abs_contribution": 0.00010059425346132,
            "Perc_contribution": 0.96,
            "Fossil_abs": 6.91169212635903e-05,
            "Land_abs": 3.14773321977349e-05,
            "Fossil_fraction": 68.7086179233557,
            "Land_fraction": 31.2913820766496,
            "Rank": 21,
            "Perc_contribution_rescale": 3.24873096446701
        },
        {
            "Country": "Mongolia",
            "Abs_contribution": 9.60506501263109e-05,
            "Perc_contribution": 0.91,
            "Fossil_abs": 5.4187330894843e-05,
            "Land_abs": 4.1863319231466e-05,
            "Fossil_fraction": 56.4153712896105,
            "Land_fraction": 43.5846287103875,
            "Rank": 22,
            "Perc_contribution_rescale": 3.07952622673435
        },
        {
            "Country": "Algeria",
            "Abs_contribution": 8.85097545537498e-05,
            "Perc_contribution": 0.84,
            "Fossil_abs": 7.662469179507e-05,
            "Land_abs": 1.1885062758694e-05,
            "Fossil_fraction": 86.5720305986586,
            "Land_fraction": 13.4279694013573,
            "Rank": 23,
            "Perc_contribution_rescale": 2.84263959390863
        },
        {
            "Country": "Thailand",
            "Abs_contribution": 8.70861745053998e-05,
            "Perc_contribution": 0.83,
            "Fossil_abs": 5.269235772047e-05,
            "Land_abs": 3.43938167849302e-05,
            "Fossil_fraction": 60.5059965255482,
            "Land_fraction": 39.4940034744523,
            "Rank": 24,
            "Perc_contribution_rescale": 2.8087986463621
        },
        {
            "Country": "Colombia",
            "Abs_contribution": 8.40627363919901e-05,
            "Perc_contribution": 0.8,
            "Fossil_abs": 4.59843070217199e-05,
            "Land_abs": 3.80784293702798e-05,
            "Fossil_fraction": 54.7023675357081,
            "Land_fraction": 45.2976324643032,
            "Rank": 25,
            "Perc_contribution_rescale": 2.7072758037225
        },
        {
            "Country": "Turkmenistan",
            "Abs_contribution": 8.25887747161801e-05,
            "Perc_contribution": 0.78,
            "Fossil_abs": 7.19788634674101e-05,
            "Land_abs": 1.0609911248774e-05,
            "Fossil_fraction": 87.1533252730393,
            "Land_fraction": 12.8466747269655,
            "Rank": 26,
            "Perc_contribution_rescale": 2.63959390862944
        },
        {
            "Country": "Uzbekistan",
            "Abs_contribution": 7.83029960606399e-05,
            "Perc_contribution": 0.74,
            "Fossil_abs": 1.691491006976e-05,
            "Land_abs": 6.1388085990901e-05,
            "Fossil_fraction": 21.601868281848,
            "Land_fraction": 78.398131718179,
            "Rank": 27,
            "Perc_contribution_rescale": 2.50423011844332
        },
        {
            "Country": "United Arab Emirates",
            "Abs_contribution": 7.68892514143701e-05,
            "Perc_contribution": 0.73,
            "Fossil_abs": 7.37292003187601e-05,
            "Land_abs": 3.1600510956099e-06,
            "Fossil_fraction": 95.8901263343299,
            "Land_fraction": 4.10987366566988,
            "Rank": 28,
            "Perc_contribution_rescale": 2.47038917089679
        },
        {
            "Country": "Uganda",
            "Abs_contribution": 7.455907985838e-05,
            "Perc_contribution": 0.71,
            "Fossil_abs": 3.2062002327823e-05,
            "Land_abs": 4.2497077530556e-05,
            "Fossil_fraction": 43.0021432516638,
            "Land_fraction": 56.9978567483349,
            "Rank": 29,
            "Perc_contribution_rescale": 2.40270727580372
        },
        {
            "Country": "Sudan",
            "Abs_contribution": 7.13056245309398e-05,
            "Perc_contribution": 0.68,
            "Fossil_abs": 1.94408595808831e-05,
            "Land_abs": 5.18647649500601e-05,
            "Fossil_fraction": 27.2641319794452,
            "Land_fraction": 72.7358680205596,
            "Rank": 30,
            "Perc_contribution_rescale": 2.30118443316413
        },
        {
            "Country": "Niger",
            "Abs_contribution": 7.0497988860668e-05,
            "Perc_contribution": 0.67,
            "Fossil_abs": 1.2065101202196e-05,
            "Land_abs": 5.84328876584739e-05,
            "Fossil_fraction": 17.1141069372084,
            "Land_fraction": 82.8858930627943,
            "Rank": 31,
            "Perc_contribution_rescale": 2.2673434856176
        },
        {
            "Country": "Malaysia",
            "Abs_contribution": 7.03277473270802e-05,
            "Perc_contribution": 0.67,
            "Fossil_abs": 7.02666295544501e-05,
            "Land_abs": 6.11177726340235e-08,
            "Fossil_fraction": 99.9130957908464,
            "Land_fraction": 0.0869042091591203,
            "Rank": 32,
            "Perc_contribution_rescale": 2.2673434856176
        },
        {
            "Country": "Egypt",
            "Abs_contribution": 6.978205284265e-05,
            "Perc_contribution": 0.66,
            "Fossil_abs": 9.28657735585602e-05,
            "Land_abs": -0.0000230837207159239,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 33,
            "Perc_contribution_rescale": 2.23350253807107
        },
        {
            "Country": "Mali",
            "Abs_contribution": 6.74604696046149e-05,
            "Perc_contribution": 0.64,
            "Fossil_abs": 9.709450134138e-06,
            "Land_abs": 5.77510194704771e-05,
            "Fossil_fraction": 14.3927995032424,
            "Land_fraction": 85.6072004967578,
            "Rank": 34,
            "Perc_contribution_rescale": 2.165820642978
        },
        {
            "Country": "Mozambique",
            "Abs_contribution": 6.1916909652676e-05,
            "Perc_contribution": 0.59,
            "Fossil_abs": 5.5149087644423e-05,
            "Land_abs": 6.76782200825701e-06,
            "Fossil_fraction": 89.0695093695451,
            "Land_fraction": 10.9304906304614,
            "Rank": 35,
            "Perc_contribution_rescale": 1.99661590524535
        },
        {
            "Country": "Azerbaijan",
            "Abs_contribution": 5.94520732585269e-05,
            "Perc_contribution": 0.56,
            "Fossil_abs": 5.5448579419064e-05,
            "Land_abs": 4.003493839467e-06,
            "Fossil_fraction": 93.2660147577128,
            "Land_fraction": 6.73398524229396,
            "Rank": 36,
            "Perc_contribution_rescale": 1.89509306260575
        },
        {
            "Country": "Oman",
            "Abs_contribution": 5.760838248297e-05,
            "Perc_contribution": 0.55,
            "Fossil_abs": 5.49759334019101e-05,
            "Land_abs": 2.6324490810498e-06,
            "Fossil_fraction": 95.4304409053004,
            "Land_fraction": 4.5695590946821,
            "Rank": 37,
            "Perc_contribution_rescale": 1.86125211505922
        },
        {
            "Country": "Kuwait",
            "Abs_contribution": 5.663028591151e-05,
            "Perc_contribution": 0.54,
            "Fossil_abs": 5.61706676020898e-05,
            "Land_abs": 4.5961830942379e-07,
            "Fossil_fraction": 99.1883877998809,
            "Land_fraction": 0.811612200125541,
            "Rank": 38,
            "Perc_contribution_rescale": 1.82741116751269
        },
        {
            "Country": "Ghana",
            "Abs_contribution": 5.6114696249996e-05,
            "Perc_contribution": 0.53,
            "Fossil_abs": 4.7149164818051e-05,
            "Land_abs": 8.96553143194001e-06,
            "Fossil_fraction": 84.0228460081067,
            "Land_fraction": 15.9771539918843,
            "Rank": 39,
            "Perc_contribution_rescale": 1.79357021996616
        },
        {
            "Country": "Myanmar",
            "Abs_contribution": 5.37267241210002e-05,
            "Perc_contribution": 0.51,
            "Fossil_abs": 3.21290785129751e-05,
            "Land_abs": 2.15976456080197e-05,
            "Fossil_fraction": 59.8009259611955,
            "Land_fraction": 40.1990740387944,
            "Rank": 40,
            "Perc_contribution_rescale": 1.7258883248731
        },
        {
            "Country": "Morocco",
            "Abs_contribution": 5.197263635806e-05,
            "Perc_contribution": 0.49,
            "Fossil_abs": 4.35294506505709e-05,
            "Land_abs": 8.44318570749199e-06,
            "Fossil_fraction": 83.75455566787,
            "Land_fraction": 16.2454443321358,
            "Rank": 41,
            "Perc_contribution_rescale": 1.65820642978003
        },
        {
            "Country": "Bolivia",
            "Abs_contribution": 4.925883554058e-05,
            "Perc_contribution": 0.47,
            "Fossil_abs": 1.5196516254867e-05,
            "Land_abs": 3.4062319285717e-05,
            "Fossil_fraction": 30.8503359612469,
            "Land_fraction": 69.1496640387612,
            "Rank": 42,
            "Perc_contribution_rescale": 1.59052453468697
        },
        {
            "Country": "Burkina Faso",
            "Abs_contribution": 4.9039673799471e-05,
            "Perc_contribution": 0.47,
            "Fossil_abs": 1.4133130070538e-05,
            "Land_abs": 3.4906543728934e-05,
            "Fossil_fraction": 28.8197880930653,
            "Land_fraction": 71.1802119069366,
            "Rank": 43,
            "Perc_contribution_rescale": 1.59052453468697
        },
        {
            "Country": "Guinea",
            "Abs_contribution": 4.6393534550177e-05,
            "Perc_contribution": 0.44,
            "Fossil_abs": 8.82730068847798e-06,
            "Land_abs": 3.7566233861702e-05,
            "Fossil_fraction": 19.0270061853787,
            "Land_fraction": 80.9729938146279,
            "Rank": 44,
            "Perc_contribution_rescale": 1.48900169204738
        },
        {
            "Country": "Peru",
            "Abs_contribution": 4.13784586688699e-05,
            "Perc_contribution": 0.39,
            "Fossil_abs": 2.5751363454134e-05,
            "Land_abs": 1.562709521474e-05,
            "Fossil_fraction": 62.2337425862299,
            "Land_fraction": 37.76625741378,
            "Rank": 45,
            "Perc_contribution_rescale": 1.31979695431472
        },
        {
            "Country": "Bahrain",
            "Abs_contribution": 4.00339105279899e-05,
            "Perc_contribution": 0.38,
            "Fossil_abs": 4.00286391642501e-05,
            "Land_abs": 5.27136373597302e-09,
            "Fossil_fraction": 99.9868327533576,
            "Land_fraction": 0.0131672466327953,
            "Rank": 46,
            "Perc_contribution_rescale": 1.28595600676819
        },
        {
            "Country": "South Sudan",
            "Abs_contribution": 3.92503541943501e-05,
            "Perc_contribution": 0.37,
            "Fossil_abs": 7.45088140108199e-06,
            "Land_abs": 3.17994727932602e-05,
            "Fossil_fraction": 18.9829660241754,
            "Land_fraction": 81.0170339758044,
            "Rank": 47,
            "Perc_contribution_rescale": 1.25211505922166
        },
        {
            "Country": "Paraguay",
            "Abs_contribution": 3.84893684830302e-05,
            "Perc_contribution": 0.37,
            "Fossil_abs": 4.94501097745502e-06,
            "Land_abs": 3.35443575055671e-05,
            "Fossil_fraction": 12.8477321721588,
            "Land_fraction": 87.1522678278202,
            "Rank": 48,
            "Perc_contribution_rescale": 1.25211505922166
        },
        {
            "Country": "South Africa",
            "Abs_contribution": 3.78727374188495e-05,
            "Perc_contribution": 0.36,
            "Fossil_abs": 4.07802245600501e-05,
            "Land_abs": -0.00000290748714119806,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 49,
            "Perc_contribution_rescale": 1.21827411167513
        },
        {
            "Country": "Israel",
            "Abs_contribution": 3.65030883892601e-05,
            "Perc_contribution": 0.35,
            "Fossil_abs": 3.54910413041239e-05,
            "Land_abs": 1.01204708513249e-06,
            "Fossil_fraction": 97.2275028503235,
            "Land_fraction": 2.77249714966655,
            "Rank": 50,
            "Perc_contribution_rescale": 1.1844331641286
        },
        {
            "Country": "Guatemala",
            "Abs_contribution": 3.5803511527006e-05,
            "Perc_contribution": 0.34,
            "Fossil_abs": 2.4043298859588e-05,
            "Land_abs": 1.1760212667416e-05,
            "Fossil_fraction": 67.1534657751447,
            "Land_fraction": 32.8465342248496,
            "Rank": 51,
            "Perc_contribution_rescale": 1.15059221658206
        },
        {
            "Country": "Uruguay",
            "Abs_contribution": 3.41330563125601e-05,
            "Perc_contribution": 0.32,
            "Fossil_abs": 2.6428542242965e-05,
            "Land_abs": 7.70451406959991e-06,
            "Fossil_fraction": 77.4279982459115,
            "Land_fraction": 22.5720017541027,
            "Rank": 52,
            "Perc_contribution_rescale": 1.082910321489
        },
        {
            "Country": "Afghanistan",
            "Abs_contribution": 3.3099064966079e-05,
            "Perc_contribution": 0.31,
            "Fossil_abs": 1.6429170541966e-05,
            "Land_abs": 1.6669894424109e-05,
            "Fossil_fraction": 49.6363584856645,
            "Land_fraction": 50.3636415143231,
            "Rank": 53,
            "Perc_contribution_rescale": 1.04906937394247
        },
        {
            "Country": "Madagascar",
            "Abs_contribution": 3.237068153918e-05,
            "Perc_contribution": 0.31,
            "Fossil_abs": 2.0953837817535e-05,
            "Land_abs": 1.14168437216459e-05,
            "Fossil_fraction": 64.7309133487764,
            "Land_fraction": 35.2690866512263,
            "Rank": 54,
            "Perc_contribution_rescale": 1.04906937394247
        },
        {
            "Country": "Cambodia",
            "Abs_contribution": 3.1724322952907e-05,
            "Perc_contribution": 0.3,
            "Fossil_abs": 6.185748382448e-06,
            "Land_abs": 2.5538574570459e-05,
            "Fossil_fraction": 19.4984409647777,
            "Land_fraction": 80.5015590352221,
            "Rank": 55,
            "Perc_contribution_rescale": 1.01522842639594
        },
        {
            "Country": "Nepal",
            "Abs_contribution": 3.03773788898299e-05,
            "Perc_contribution": 0.29,
            "Fossil_abs": 9.21158376858899e-06,
            "Land_abs": 2.1165795121235e-05,
            "Fossil_fraction": 30.3238268252069,
            "Land_fraction": 69.6761731747735,
            "Rank": 56,
            "Perc_contribution_rescale": 0.981387478849408
        },
        {
            "Country": "South Korea",
            "Abs_contribution": 2.579295461596e-05,
            "Perc_contribution": 0.25,
            "Fossil_abs": 1.928625674866e-05,
            "Land_abs": 6.50669786729101e-06,
            "Fossil_fraction": 74.7733520095682,
            "Land_fraction": 25.2266479903967,
            "Rank": 57,
            "Perc_contribution_rescale": 0.846023688663283
        },
        {
            "Country": "Argentina",
            "Abs_contribution": 2.49223212542699e-05,
            "Perc_contribution": 0.24,
            "Fossil_abs": -0.00000856508082427011,
            "Land_abs": 3.34874020785402e-05,
            "Fossil_fraction": 0,
            "Land_fraction": 100,
            "Rank": 58,
            "Perc_contribution_rescale": 0.812182741116751
        },
        {
            "Country": "C\xf4te d'Ivoire",
            "Abs_contribution": 2.3733836964308e-05,
            "Perc_contribution": 0.23,
            "Fossil_abs": 2.147449321193e-05,
            "Land_abs": 2.25934375237702e-06,
            "Fossil_fraction": 90.4804951859416,
            "Land_fraction": 9.51950481405395,
            "Rank": 59,
            "Perc_contribution_rescale": 0.77834179357022
        },
        {
            "Country": "Malawi",
            "Abs_contribution": 2.2382560085901e-05,
            "Perc_contribution": 0.21,
            "Fossil_abs": 9.385242020307e-06,
            "Land_abs": 1.29973180655926e-05,
            "Fossil_fraction": 41.931048031538,
            "Land_fraction": 58.0689519684558,
            "Rank": 60,
            "Perc_contribution_rescale": 0.710659898477157
        },
        {
            "Country": "Zambia",
            "Abs_contribution": 2.1479156423878e-05,
            "Perc_contribution": 0.2,
            "Fossil_abs": 1.382505217722e-05,
            "Land_abs": 7.65410424665802e-06,
            "Fossil_fraction": 64.3649680852965,
            "Land_fraction": 35.6350319147035,
            "Rank": 61,
            "Perc_contribution_rescale": 0.676818950930626
        },
        {
            "Country": "Dominican Republic",
            "Abs_contribution": 2.109931637577e-05,
            "Perc_contribution": 0.2,
            "Fossil_abs": 1.1917488443068e-05,
            "Land_abs": 9.18182793270203e-06,
            "Fossil_fraction": 56.4828178829232,
            "Land_fraction": 43.5171821170767,
            "Rank": 62,
            "Perc_contribution_rescale": 0.676818950930626
        },
        {
            "Country": "Congo",
            "Abs_contribution": 2.0228161173937e-05,
            "Perc_contribution": 0.19,
            "Fossil_abs": 1.6993956407243e-05,
            "Land_abs": 3.23420476669319e-06,
            "Fossil_fraction": 84.011375335188,
            "Land_fraction": 15.9886246648079,
            "Rank": 63,
            "Perc_contribution_rescale": 0.642978003384095
        },
        {
            "Country": "Nicaragua",
            "Abs_contribution": 1.9987425381435e-05,
            "Perc_contribution": 0.19,
            "Fossil_abs": 3.4184223009524e-06,
            "Land_abs": 1.6569003080483e-05,
            "Fossil_fraction": 17.1028646047006,
            "Land_fraction": 82.8971353953013,
            "Rank": 64,
            "Perc_contribution_rescale": 0.642978003384095
        },
        {
            "Country": "Laos",
            "Abs_contribution": 1.9633327432228e-05,
            "Perc_contribution": 0.19,
            "Fossil_abs": 6.352143678983e-06,
            "Land_abs": 1.3281183753246e-05,
            "Fossil_fraction": 32.3538824527318,
            "Land_fraction": 67.6461175472732,
            "Rank": 65,
            "Perc_contribution_rescale": 0.642978003384095
        },
        {
            "Country": "Trinidad and Tobago",
            "Abs_contribution": 1.95985026916041e-05,
            "Perc_contribution": 0.19,
            "Fossil_abs": 1.95903415542949e-05,
            "Land_abs": 8.16113730889951e-09,
            "Fossil_fraction": 99.9583583631997,
            "Land_fraction": 0.0416416367990995,
            "Rank": 66,
            "Perc_contribution_rescale": 0.642978003384095
        },
        {
            "Country": "Cameroon",
            "Abs_contribution": 1.9200043228391e-05,
            "Perc_contribution": 0.18,
            "Fossil_abs": 1.5511449410396e-05,
            "Land_abs": 3.68859381799798e-06,
            "Fossil_fraction": 80.7886171186289,
            "Land_fraction": 19.2113828813869,
            "Rank": 67,
            "Perc_contribution_rescale": 0.609137055837563
        },
        {
            "Country": "Tajikistan",
            "Abs_contribution": 1.8445312841293e-05,
            "Perc_contribution": 0.18,
            "Fossil_abs": 6.9634681105255e-06,
            "Land_abs": 1.1481844730768e-05,
            "Fossil_fraction": 37.7519653390566,
            "Land_fraction": 62.248034660946,
            "Rank": 68,
            "Perc_contribution_rescale": 0.609137055837563
        },
        {
            "Country": "Jordan",
            "Abs_contribution": 1.7637315465148e-05,
            "Perc_contribution": 0.17,
            "Fossil_abs": 1.6322646516869e-05,
            "Land_abs": 1.3146689482794e-06,
            "Fossil_fraction": 92.5460938152587,
            "Land_fraction": 7.45390618474357,
            "Rank": 69,
            "Perc_contribution_rescale": 0.575296108291032
        },
        {
            "Country": "Somalia",
            "Abs_contribution": 1.74333490899001e-05,
            "Perc_contribution": 0.17,
            "Fossil_abs": 1.6622029904472e-05,
            "Land_abs": 8.11319185425028e-07,
            "Fossil_fraction": 95.3461656664804,
            "Land_fraction": 4.653834333502,
            "Rank": 70,
            "Perc_contribution_rescale": 0.575296108291032
        },
        {
            "Country": "Honduras",
            "Abs_contribution": 1.6783986869944e-05,
            "Perc_contribution": 0.16,
            "Fossil_abs": 9.53803582394501e-06,
            "Land_abs": 7.24595104599902e-06,
            "Fossil_fraction": 56.828189260713,
            "Land_fraction": 43.171810739287,
            "Rank": 71,
            "Perc_contribution_rescale": 0.541455160744501
        },
        {
            "Country": "Senegal",
            "Abs_contribution": 1.6106724862536e-05,
            "Perc_contribution": 0.15,
            "Fossil_abs": 5.31517557479701e-06,
            "Land_abs": 1.0791549287738e-05,
            "Fossil_fraction": 32.9997291203504,
            "Land_fraction": 67.0002708796437,
            "Rank": 72,
            "Perc_contribution_rescale": 0.50761421319797
        },
        {
            "Country": "Benin",
            "Abs_contribution": 1.5814307923475e-05,
            "Perc_contribution": 0.15,
            "Fossil_abs": 1.0887089905142e-05,
            "Land_abs": 4.92721801833399e-06,
            "Fossil_fraction": 68.8432902522471,
            "Land_fraction": 31.1567097477593,
            "Rank": 73,
            "Perc_contribution_rescale": 0.50761421319797
        },
        {
            "Country": "Kyrgyzstan",
            "Abs_contribution": 1.4903561080355e-05,
            "Perc_contribution": 0.14,
            "Fossil_abs": 6.92441587000501e-06,
            "Land_abs": 7.97914521035001e-06,
            "Fossil_fraction": 46.4614854978007,
            "Land_fraction": 53.5385145021994,
            "Rank": 74,
            "Perc_contribution_rescale": 0.473773265651438
        },
        {
            "Country": "Singapore",
            "Abs_contribution": 1.4745808783999e-05,
            "Perc_contribution": 0.14,
            "Fossil_abs": 1.4741923768132e-05,
            "Land_abs": 3.88501586584008e-09,
            "Fossil_fraction": 99.9736534229899,
            "Land_fraction": 0.0263465770019736,
            "Rank": 75,
            "Perc_contribution_rescale": 0.473773265651438
        },
        {
            "Country": "Ecuador",
            "Abs_contribution": 1.45505231223001e-05,
            "Perc_contribution": 0.14,
            "Fossil_abs": 1.87585555143579e-05,
            "Land_abs": -0.00000420803239206203,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 76,
            "Perc_contribution_rescale": 0.473773265651438
        },
        {
            "Country": "Haiti",
            "Abs_contribution": 1.357920888771e-05,
            "Perc_contribution": 0.13,
            "Fossil_abs": 1.2244920151962e-05,
            "Land_abs": 1.33428873574798e-06,
            "Fossil_fraction": 90.1740318837305,
            "Land_fraction": 9.82596811626925,
            "Rank": 77,
            "Perc_contribution_rescale": 0.439932318104907
        },
        {
            "Country": "Yemen",
            "Abs_contribution": 1.3263805886071e-05,
            "Perc_contribution": 0.13,
            "Fossil_abs": 7.10320618545191e-06,
            "Land_abs": 6.160599700618e-06,
            "Fossil_fraction": 53.5533032258211,
            "Land_fraction": 46.4466967741707,
            "Rank": 78,
            "Perc_contribution_rescale": 0.439932318104907
        },
        {
            "Country": "Sierra Leone",
            "Abs_contribution": 1.2879738533799e-05,
            "Perc_contribution": 0.12,
            "Fossil_abs": 4.86464014959339e-06,
            "Land_abs": 8.0150983842055e-06,
            "Fossil_fraction": 37.769711992426,
            "Land_fraction": 62.2302880075731,
            "Rank": 79,
            "Perc_contribution_rescale": 0.406091370558376
        },
        {
            "Country": "Belarus",
            "Abs_contribution": 1.2638241841595e-05,
            "Perc_contribution": 0.12,
            "Fossil_abs": 1.1663762915436e-05,
            "Land_abs": 9.74478926158004e-07,
            "Fossil_fraction": 92.2894423261331,
            "Land_fraction": 7.71055767385935,
            "Rank": 80,
            "Perc_contribution_rescale": 0.406091370558376
        },
        {
            "Country": "Togo",
            "Abs_contribution": 1.224860927563e-05,
            "Perc_contribution": 0.12,
            "Fossil_abs": 9.20114942154298e-06,
            "Land_abs": 3.0474598540873e-06,
            "Fossil_fraction": 75.1199521063156,
            "Land_fraction": 24.8800478936867,
            "Rank": 81,
            "Perc_contribution_rescale": 0.406091370558376
        },
        {
            "Country": "Sri Lanka",
            "Abs_contribution": 1.17713362245471e-05,
            "Perc_contribution": 0.11,
            "Fossil_abs": 6.11540113788301e-06,
            "Land_abs": 5.65593508666402e-06,
            "Fossil_fraction": 51.9516308193662,
            "Land_fraction": 48.0483691806336,
            "Rank": 82,
            "Perc_contribution_rescale": 0.372250423011844
        },
        {
            "Country": "Mauritania",
            "Abs_contribution": 1.173173307669e-05,
            "Perc_contribution": 0.11,
            "Fossil_abs": 3.8388184714147e-06,
            "Land_abs": 7.89291460527499e-06,
            "Fossil_fraction": 32.7216656424116,
            "Land_fraction": 67.278334357586,
            "Rank": 83,
            "Perc_contribution_rescale": 0.372250423011844
        },
        {
            "Country": "Rwanda",
            "Abs_contribution": 1.115193923523e-05,
            "Perc_contribution": 0.11,
            "Fossil_abs": 6.401957262549e-06,
            "Land_abs": 4.7499819726805e-06,
            "Fossil_fraction": 57.4066727544984,
            "Land_fraction": 42.5933272454971,
            "Rank": 84,
            "Perc_contribution_rescale": 0.372250423011844
        },
        {
            "Country": "Burundi",
            "Abs_contribution": 1.0904564614442e-05,
            "Perc_contribution": 0.1,
            "Fossil_abs": 6.48310597118399e-06,
            "Land_abs": 4.4214586432574e-06,
            "Fossil_fraction": 59.4531391248558,
            "Land_fraction": 40.5468608751387,
            "Rank": 85,
            "Perc_contribution_rescale": 0.338409475465313
        },
        {
            "Country": "Lebanon",
            "Abs_contribution": 9.550673398177e-06,
            "Perc_contribution": 0.09,
            "Fossil_abs": 9.28205527724599e-06,
            "Land_abs": 2.68618120931001e-07,
            "Fossil_fraction": 97.1874431285413,
            "Land_fraction": 2.81255687145865,
            "Rank": 86,
            "Perc_contribution_rescale": 0.304568527918782
        },
        {
            "Country": "Namibia",
            "Abs_contribution": 9.37164748366498e-06,
            "Perc_contribution": 0.09,
            "Fossil_abs": 3.4844167387251e-06,
            "Land_abs": 5.88723074493999e-06,
            "Fossil_fraction": 37.1804076582962,
            "Land_fraction": 62.819592341705,
            "Rank": 87,
            "Perc_contribution_rescale": 0.304568527918782
        },
        {
            "Country": "Central African Republic",
            "Abs_contribution": 9.14509376691904e-06,
            "Perc_contribution": 0.09,
            "Fossil_abs": 2.3247873375168e-06,
            "Land_abs": 6.820306429401e-06,
            "Fossil_fraction": 25.4211427107107,
            "Land_fraction": 74.5788572892757,
            "Rank": 88,
            "Perc_contribution_rescale": 0.304568527918782
        },
        {
            "Country": "Spain",
            "Abs_contribution": 8.72214473948999e-06,
            "Perc_contribution": 0.08,
            "Fossil_abs": 1.98251759846104e-06,
            "Land_abs": 6.73962714103004e-06,
            "Fossil_fraction": 22.7297030452278,
            "Land_fraction": 77.2702969547846,
            "Rank": 89,
            "Perc_contribution_rescale": 0.27072758037225
        },
        {
            "Country": "Bosnia and Herzegovina",
            "Abs_contribution": 7.98727375630101e-06,
            "Perc_contribution": 0.08,
            "Fossil_abs": 8.95370729412498e-06,
            "Land_abs": -0.000000966433537823497,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 90,
            "Perc_contribution_rescale": 0.27072758037225
        },
        {
            "Country": "Liberia",
            "Abs_contribution": 7.16633296742e-06,
            "Perc_contribution": 0.07,
            "Fossil_abs": 6.7363708861262e-06,
            "Land_abs": 4.29962081293879e-07,
            "Fossil_fraction": 94.0002497337408,
            "Land_fraction": 5.99975026626027,
            "Rank": 91,
            "Perc_contribution_rescale": 0.236886632825719
        },
        {
            "Country": "Taiwan",
            "Abs_contribution": 6.98287831801608e-06,
            "Perc_contribution": 0.07,
            "Fossil_abs": 9.48902401634404e-06,
            "Land_abs": -0.00000250614569832601,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 92,
            "Perc_contribution_rescale": 0.236886632825719
        },
        {
            "Country": "Papua New Guinea",
            "Abs_contribution": 6.824543871555e-06,
            "Perc_contribution": 0.06,
            "Fossil_abs": 6.01137906398901e-06,
            "Land_abs": 8.13164807565802e-07,
            "Fossil_fraction": 88.0847010016993,
            "Land_fraction": 11.915298998298,
            "Rank": 93,
            "Perc_contribution_rescale": 0.203045685279188
        },
        {
            "Country": "Botswana",
            "Abs_contribution": 6.39974487336202e-06,
            "Perc_contribution": 0.06,
            "Fossil_abs": 3.22505083906931e-06,
            "Land_abs": 3.174694034292e-06,
            "Fossil_fraction": 50.3934282207576,
            "Land_fraction": 49.6065717792312,
            "Rank": 94,
            "Perc_contribution_rescale": 0.203045685279188
        },
        {
            "Country": "Eritrea",
            "Abs_contribution": 5.79574863007799e-06,
            "Perc_contribution": 0.06,
            "Fossil_abs": 3.08290754998279e-06,
            "Land_abs": 2.71284108009501e-06,
            "Fossil_fraction": 53.1925683247119,
            "Land_fraction": 46.8074316752848,
            "Rank": 95,
            "Perc_contribution_rescale": 0.203045685279188
        },
        {
            "Country": "Hong Kong",
            "Abs_contribution": 5.233285983009e-06,
            "Perc_contribution": 0.05,
            "Fossil_abs": 5.29116639859598e-06,
            "Land_abs": -0.0000000578804155872798,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 96,
            "Perc_contribution_rescale": 0.169204737732657
        },
        {
            "Country": "Costa Rica",
            "Abs_contribution": 4.75268800732698e-06,
            "Perc_contribution": 0.05,
            "Fossil_abs": 3.24790789509361e-06,
            "Land_abs": 1.504780112233e-06,
            "Fossil_fraction": 68.338335907732,
            "Land_fraction": 31.66166409226,
            "Rank": 97,
            "Perc_contribution_rescale": 0.169204737732657
        },
        {
            "Country": "Panama",
            "Abs_contribution": 4.19342897696299e-06,
            "Perc_contribution": 0.04,
            "Fossil_abs": 3.7953068188712e-06,
            "Land_abs": 3.98122158091997e-07,
            "Fossil_fraction": 90.5060474308992,
            "Land_fraction": 9.4939525691056,
            "Rank": 98,
            "Perc_contribution_rescale": 0.135363790186125
        },
        {
            "Country": "Timor-Leste",
            "Abs_contribution": 4.036716758776e-06,
            "Perc_contribution": 0.04,
            "Fossil_abs": 3.54550222932671e-06,
            "Land_abs": 4.91214529448899e-07,
            "Fossil_fraction": 87.8313352458686,
            "Land_fraction": 12.1686647541217,
            "Rank": 99,
            "Perc_contribution_rescale": 0.135363790186125
        },
        {
            "Country": "Tunisia",
            "Abs_contribution": 3.53245755960901e-06,
            "Perc_contribution": 0.03,
            "Fossil_abs": 3.96462193863798e-06,
            "Land_abs": -0.000000432164379028007,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 100,
            "Perc_contribution_rescale": 0.101522842639594
        },
        {
            "Country": "Gambia",
            "Abs_contribution": 3.4508402883606e-06,
            "Perc_contribution": 0.03,
            "Fossil_abs": 1.3234148637147e-06,
            "Land_abs": 2.1274254246458e-06,
            "Fossil_fraction": 38.350510401147,
            "Land_fraction": 61.6494895988502,
            "Rank": 101,
            "Perc_contribution_rescale": 0.101522842639594
        },
        {
            "Country": "Guinea-Bissau",
            "Abs_contribution": 3.0237085934046e-06,
            "Perc_contribution": 0.03,
            "Fossil_abs": 1.7682545481398e-06,
            "Land_abs": 1.2554540452651e-06,
            "Fossil_fraction": 58.4796614328765,
            "Land_fraction": 41.5203385671334,
            "Rank": 102,
            "Perc_contribution_rescale": 0.101522842639594
        },
        {
            "Country": "New Zealand",
            "Abs_contribution": 2.81493141442006e-06,
            "Perc_contribution": 0.03,
            "Fossil_abs": -0.00000257898441505001,
            "Land_abs": 5.39391582946003e-06,
            "Fossil_fraction": 0,
            "Land_fraction": 100,
            "Rank": 103,
            "Perc_contribution_rescale": 0.101522842639594
        },
        {
            "Country": "Zimbabwe",
            "Abs_contribution": 2.75096257788799e-06,
            "Perc_contribution": 0.03,
            "Fossil_abs": 4.99104032556497e-06,
            "Land_abs": -0.00000224007774767698,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 104,
            "Perc_contribution_rescale": 0.101522842639594
        },
        {
            "Country": "Canada",
            "Abs_contribution": 1.90672449392002e-06,
            "Perc_contribution": 0.02,
            "Fossil_abs": 1.067334550898e-05,
            "Land_abs": -0.00000876662101507997,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 105,
            "Perc_contribution_rescale": 0.0676818950930626
        },
        {
            "Country": "Bhutan",
            "Abs_contribution": 1.687673611127e-06,
            "Perc_contribution": 0.02,
            "Fossil_abs": 1.4338651192497e-06,
            "Land_abs": 2.538084918773e-07,
            "Fossil_fraction": 84.961043995479,
            "Land_fraction": 15.038956004521,
            "Rank": 106,
            "Perc_contribution_rescale": 0.0676818950930626
        },
        {
            "Country": "Cyprus",
            "Abs_contribution": 1.6097180960641e-06,
            "Perc_contribution": 0.02,
            "Fossil_abs": 1.5231514001268e-06,
            "Land_abs": 8.65666959372006e-08,
            "Fossil_fraction": 94.6222449664348,
            "Land_fraction": 5.37775503355922,
            "Rank": 107,
            "Perc_contribution_rescale": 0.0676818950930626
        },
        {
            "Country": "Guyana",
            "Abs_contribution": 1.5674179047517e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 2.353068431253e-07,
            "Land_abs": 1.3321110616264e-06,
            "Fossil_fraction": 15.0123870865553,
            "Land_fraction": 84.9876129134445,
            "Rank": 108,
            "Perc_contribution_rescale": 0.0338409475465313
        },
        {
            "Country": "Switzerland",
            "Abs_contribution": 1.55449450297505e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 2.2781636614575e-06,
            "Land_abs": -0.000000723669158482016,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 109,
            "Perc_contribution_rescale": 0.0338409475465313
        },
        {
            "Country": "Chile",
            "Abs_contribution": 1.32851091664003e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 7.17457607442599e-06,
            "Land_abs": -0.00000584606515778699,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 110,
            "Perc_contribution_rescale": 0.0338409475465313
        },
        {
            "Country": "Djibouti",
            "Abs_contribution": 1.3241957698735e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 1.1594103031975e-06,
            "Land_abs": 1.647854666757e-07,
            "Fossil_fraction": 87.5558078023657,
            "Land_fraction": 12.4441921976115,
            "Rank": 111,
            "Perc_contribution_rescale": 0.0338409475465313
        },
        {
            "Country": "Latvia",
            "Abs_contribution": 1.0098121224676e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 1.2410661600559e-06,
            "Land_abs": -0.000000231254037588198,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 112,
            "Perc_contribution_rescale": 0.0338409475465313
        },
        {
            "Country": "Comoros",
            "Abs_contribution": 9.90375624468201e-07,
            "Perc_contribution": 0.01,
            "Fossil_abs": 6.498831596037e-07,
            "Land_abs": 3.40492464864491e-07,
            "Fossil_fraction": 65.6198661949768,
            "Land_fraction": 34.3801338050221,
            "Rank": 113,
            "Perc_contribution_rescale": 0.0338409475465313
        },
        {
            "Country": "Norway",
            "Abs_contribution": 9.64298085369972e-07,
            "Perc_contribution": 0.01,
            "Fossil_abs": 1.34120681410596e-06,
            "Land_abs": -0.000000376908728737005,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 114,
            "Perc_contribution_rescale": 0.0338409475465313
        },
        {
            "Country": "Suriname",
            "Abs_contribution": 9.24414648328199e-07,
            "Perc_contribution": 0.01,
            "Fossil_abs": 6.53003622826599e-07,
            "Land_abs": 2.71411025501599e-07,
            "Fossil_fraction": 70.6396879373942,
            "Land_fraction": 29.3603120626058,
            "Rank": 115,
            "Perc_contribution_rescale": 0.0338409475465313
        },
        {
            "Country": "Belize",
            "Abs_contribution": 9.005101586492e-07,
            "Perc_contribution": 0.01,
            "Fossil_abs": 5.51328526004901e-07,
            "Land_abs": 3.4918163264437e-07,
            "Fossil_fraction": 61.2240207075416,
            "Land_fraction": 38.7759792924664,
            "Rank": 116,
            "Perc_contribution_rescale": 0.0338409475465313
        },
        {
            "Country": "Estonia",
            "Abs_contribution": 8.61426149873016e-07,
            "Perc_contribution": 0.01,
            "Fossil_abs": 1.093147274836e-06,
            "Land_abs": -0.000000231721124963202,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 117,
            "Perc_contribution_rescale": 0.0338409475465313
        },
        {
            "Country": "Serbia",
            "Abs_contribution": 8.11415441254995e-07,
            "Perc_contribution": 0.01,
            "Fossil_abs": 5.52069514241299e-06,
            "Land_abs": -0.000004709279701158,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 118,
            "Perc_contribution_rescale": 0.0338409475465313
        },
        {
            "Country": "Solomon Islands",
            "Abs_contribution": 4.875929131688e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 4.2736723506779e-07,
            "Land_abs": 6.022567810101e-08,
            "Fossil_fraction": 87.6483688596678,
            "Land_fraction": 12.3516311403321,
            "Rank": 119,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Maldives",
            "Abs_contribution": 4.8668431208021e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 4.8668358619604e-07,
            "Land_abs": 7.2588417634e-13,
            "Fossil_fraction": 99.9998508511262,
            "Land_fraction": 0.000149148875014563,
            "Rank": 120,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Bahamas",
            "Abs_contribution": 4.67905165901799e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 4.698447979241e-07,
            "Land_abs": -0.00000000193963202227,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 121,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Mauritius",
            "Abs_contribution": 3.67016547032301e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 3.94348456145398e-07,
            "Land_abs": -0.0000000273319091131699,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 122,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Armenia",
            "Abs_contribution": 2.87842930510798e-07,
            "Perc_contribution": 0,
            "Fossil_abs": -0.000000190300806655301,
            "Land_abs": 4.78143737166197e-07,
            "Fossil_fraction": 0,
            "Land_fraction": 100,
            "Rank": 123,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Montenegro",
            "Abs_contribution": 2.242380869521e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 8.093670032667e-07,
            "Land_abs": -0.0000005851289163146,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 124,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Macao",
            "Abs_contribution": 1.96400348305e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 1.9587840167964e-07,
            "Land_abs": 5.21946625372898e-10,
            "Fossil_fraction": 99.7342435337489,
            "Land_fraction": 0.265756466257555,
            "Rank": 125,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Cape Verde",
            "Abs_contribution": 1.6680198195852e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 1.18935397601051e-07,
            "Land_abs": 4.78665843575101e-08,
            "Fossil_fraction": 71.3033479605937,
            "Land_fraction": 28.6966520394304,
            "Rank": 126,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Sao Tome and Principe",
            "Abs_contribution": 1.3466541660994e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 1.3411500259664e-07,
            "Land_abs": 5.50414013293025e-10,
            "Fossil_fraction": 99.5912729287476,
            "Land_fraction": 0.40872707124748,
            "Rank": 127,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Seychelles",
            "Abs_contribution": 1.0384929557999e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 1.0823670315773e-07,
            "Land_abs": -0.00000000438740757775149,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 128,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Iceland",
            "Abs_contribution": 8.24831367042006e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 5.89093146703005e-08,
            "Land_abs": 2.35738220338002e-08,
            "Fossil_fraction": 71.4198283723858,
            "Land_fraction": 28.580171627493,
            "Rank": 129,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Malta",
            "Abs_contribution": 7.86182859289992e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 1.7572088739319e-07,
            "Land_abs": -0.00000009710260146419,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 130,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Micronesia (Federated States of)",
            "Abs_contribution": 6.61621864614298e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 1.36781637422502e-09,
            "Land_abs": 6.479437008721e-08,
            "Fossil_fraction": 2.06736876058714,
            "Land_fraction": 97.9326312394207,
            "Rank": 131,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Tonga",
            "Abs_contribution": 5.69990644277606e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 2.599294326441e-08,
            "Land_abs": 3.10061211633502e-08,
            "Fossil_fraction": 45.6024033470811,
            "Land_fraction": 54.3975966529182,
            "Rank": 132,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Vanuatu",
            "Abs_contribution": 5.42154685845976e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 2.2269542393536e-07,
            "Land_abs": -0.0000001684799553507,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 133,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Samoa",
            "Abs_contribution": 4.90142055538194e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 3.42531797609802e-08,
            "Land_abs": 1.47610257928599e-08,
            "Fossil_fraction": 69.8841884183331,
            "Land_fraction": 30.1158115817092,
            "Rank": 134,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Kiribati",
            "Abs_contribution": 4.88619276839199e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 4.1142050293092e-08,
            "Land_abs": 7.71987739082402e-09,
            "Fossil_fraction": 84.2006286760387,
            "Land_fraction": 15.7993713239532,
            "Rank": 135,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Dominica",
            "Abs_contribution": 4.753473786908e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 3.353187747685e-08,
            "Land_abs": 1.400286039223e-08,
            "Fossil_fraction": 70.5418373594556,
            "Land_fraction": 29.4581626405444,
            "Rank": 136,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Grenada",
            "Abs_contribution": 3.92392925560299e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 3.481386155236e-08,
            "Land_abs": 4.42543100366002e-09,
            "Fossil_fraction": 88.7219398837254,
            "Land_fraction": 11.2780601162494,
            "Rank": 137,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Vincent and the Grenadines",
            "Abs_contribution": 3.72986207834099e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 5.18218934135899e-08,
            "Land_abs": -0.000000014523272630175,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 138,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Turks and Caicos Islands",
            "Abs_contribution": 9.81137106520105e-09,
            "Perc_contribution": 0,
            "Fossil_abs": 9.81137106520105e-09,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 139,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Tuvalu",
            "Abs_contribution": 9.60102702979301e-09,
            "Perc_contribution": 0,
            "Fossil_abs": 6.000266427898e-09,
            "Land_abs": 3.600760601895e-09,
            "Fossil_fraction": 62.4960893170964,
            "Land_fraction": 37.5039106829036,
            "Rank": 140,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Liechtenstein",
            "Abs_contribution": 9.16822951516999e-09,
            "Perc_contribution": 0,
            "Fossil_abs": 1.0227848735239e-08,
            "Land_abs": -0.00000000105961922007804,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 141,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Nauru",
            "Abs_contribution": 7.81939639726402e-09,
            "Perc_contribution": 0,
            "Fossil_abs": 7.14162784011401e-09,
            "Land_abs": 6.77768557150202e-10,
            "Fossil_fraction": 91.3322138600473,
            "Land_fraction": 8.66778613995513,
            "Rank": 142,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Kitts and Nevis",
            "Abs_contribution": 5.18441118468602e-09,
            "Perc_contribution": 0,
            "Fossil_abs": 2.7015183166084e-08,
            "Land_abs": -0.000000021830771981398,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 143,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Lucia",
            "Abs_contribution": 1.88025094996997e-09,
            "Perc_contribution": 0,
            "Fossil_abs": -0.00000000597448888898969,
            "Land_abs": 7.85473983896008e-09,
            "Fossil_fraction": 0,
            "Land_fraction": 100,
            "Rank": 144,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Niue",
            "Abs_contribution": 9.34233165451096e-10,
            "Perc_contribution": 0,
            "Fossil_abs": 8.17660598257987e-13,
            "Land_abs": 9.33415504852901e-10,
            "Fossil_fraction": 0.0875221120910622,
            "Land_fraction": 99.9124778879156,
            "Rank": 145,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Anguilla",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 146,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Antarctica",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 147,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Aruba",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 148,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Bermuda",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 149,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Bonaire, Saint Eustatius and Saba",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 150,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "British Virgin Islands",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 151,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Christmas Island",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 152,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Cura\xe7ao",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 153,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Faeroe Islands",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 154,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "French Polynesia",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 155,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Greenland",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 156,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Kosovo",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 157,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Kuwaiti Oil Fires",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 158,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Leeward Islands",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 159,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Marshall Islands",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 160,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Montserrat",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 161,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "New Caledonia",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 162,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Occupied Palestinian Territory",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 163,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Pacific Islands (Palau)",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 164,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Panama Canal Zone",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 165,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Ryukyu Islands",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 166,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Helena",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 167,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Pierre and Miquelon",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 168,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Sint Maarten (Dutch part)",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 169,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "St. Kitts-Nevis-Anguilla",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 170,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Wallis and Futuna Islands",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 171,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Cook Islands",
            "Abs_contribution": -0.00000000447281829119107,
            "Perc_contribution": -0,
            "Fossil_abs": 7.28096547819997e-10,
            "Land_abs": -0.000000005200914839009,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 172,
            "Perc_contribution_rescale": -0
        },
        {
            "Country": "Andorra",
            "Abs_contribution": -0.0000000395512924352703,
            "Perc_contribution": -0,
            "Fossil_abs": -0.0000000241834703689399,
            "Land_abs": -0.0000000153678220663301,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 173,
            "Perc_contribution_rescale": -0
        },
        {
            "Country": "Palau",
            "Abs_contribution": -0.0000000418882657236898,
            "Perc_contribution": -0,
            "Fossil_abs": -0.0000000625019173308001,
            "Land_abs": 2.0613651607105e-08,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 174,
            "Perc_contribution_rescale": -0
        },
        {
            "Country": "Barbados",
            "Abs_contribution": -0.000000067946132751529,
            "Perc_contribution": -0,
            "Fossil_abs": -0.000000035178243991231,
            "Land_abs": -0.0000000327678887603049,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 175,
            "Perc_contribution_rescale": -0
        },
        {
            "Country": "Antigua and Barbuda",
            "Abs_contribution": -0.00000007022682750505,
            "Perc_contribution": -0,
            "Fossil_abs": 3.37864084578004e-09,
            "Land_abs": -0.00000007360546835083,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 176,
            "Perc_contribution_rescale": -0
        },
        {
            "Country": "Lesotho",
            "Abs_contribution": -0.0000000830922254731951,
            "Perc_contribution": -0,
            "Fossil_abs": 9.33374126870501e-07,
            "Land_abs": -0.0000010164663523435,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 177,
            "Perc_contribution_rescale": -0
        },
        {
            "Country": "Luxembourg",
            "Abs_contribution": -0.000000271865051555498,
            "Perc_contribution": -0,
            "Fossil_abs": -0.00000035628276908471,
            "Land_abs": 8.44177175292992e-08,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 178,
            "Perc_contribution_rescale": -0
        },
        {
            "Country": "North Macedonia",
            "Abs_contribution": -0.000000496123327241299,
            "Perc_contribution": -0,
            "Fossil_abs": 3.95921694732302e-07,
            "Land_abs": -0.000000892045021973499,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 179,
            "Perc_contribution_rescale": -0
        },
        {
            "Country": "Croatia",
            "Abs_contribution": -0.000000893652964535001,
            "Perc_contribution": -0.01,
            "Fossil_abs": 9.15661891569969e-08,
            "Land_abs": -0.000000985219153691293,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 180,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Fiji",
            "Abs_contribution": -0.000000933740442931204,
            "Perc_contribution": -0.01,
            "Fossil_abs": 6.611889445069e-07,
            "Land_abs": -0.0000015949293874382,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 181,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Jamaica",
            "Abs_contribution": -0.0000010561838263379,
            "Perc_contribution": -0.01,
            "Fossil_abs": 2.210719021029e-07,
            "Land_abs": -0.0000012772557284411,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 182,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Georgia",
            "Abs_contribution": -0.00000106112488194,
            "Perc_contribution": -0.01,
            "Fossil_abs": -0.000000184659630922106,
            "Land_abs": -0.000000876465251017497,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 183,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Slovakia",
            "Abs_contribution": -0.00000111938455901099,
            "Perc_contribution": -0.01,
            "Fossil_abs": 1.212532966939e-06,
            "Land_abs": -0.0000023319175259508,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 184,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Swaziland",
            "Abs_contribution": -0.0000013141803208916,
            "Perc_contribution": -0.01,
            "Fossil_abs": -0.0000017737971216174,
            "Land_abs": 4.596168007258e-07,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 185,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Moldova",
            "Abs_contribution": -0.00000132864803425641,
            "Perc_contribution": -0.01,
            "Fossil_abs": 1.60721111469539e-06,
            "Land_abs": -0.0000029358591489517,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 186,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Cuba",
            "Abs_contribution": -0.00000199293932527699,
            "Perc_contribution": -0.02,
            "Fossil_abs": 2.13661246358199e-06,
            "Land_abs": -0.00000412955178885605,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 187,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Albania",
            "Abs_contribution": -0.00000263244258588301,
            "Perc_contribution": -0.03,
            "Fossil_abs": 1.1663323908123e-06,
            "Land_abs": -0.00000379877497669499,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 188,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "El Salvador",
            "Abs_contribution": -0.00000306949341257002,
            "Perc_contribution": -0.03,
            "Fossil_abs": -0.000000167773567196993,
            "Land_abs": -0.000002901719845373,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 189,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Libya",
            "Abs_contribution": -0.00000306977545483996,
            "Perc_contribution": -0.03,
            "Fossil_abs": -0.00000615092583711998,
            "Land_abs": 3.08115038228649e-06,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 190,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Czechia",
            "Abs_contribution": -0.00000331349276124697,
            "Perc_contribution": -0.03,
            "Fossil_abs": -0.00000118585758604803,
            "Land_abs": -0.000002127635175197,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 191,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Denmark",
            "Abs_contribution": -0.00000342283096285202,
            "Perc_contribution": -0.03,
            "Fossil_abs": -0.000002607927719913,
            "Land_abs": -0.000000814903242940047,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 192,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Brunei Darussalam",
            "Abs_contribution": -0.00000357742782058099,
            "Perc_contribution": -0.03,
            "Fossil_abs": -0.00000358255423864496,
            "Land_abs": 5.12641806369018e-09,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 193,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Slovenia",
            "Abs_contribution": -0.00000384528992044701,
            "Perc_contribution": -0.04,
            "Fossil_abs": -0.000003557514739424,
            "Land_abs": -0.000000287775181023205,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 194,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Lithuania",
            "Abs_contribution": -0.00000426675288768799,
            "Perc_contribution": -0.04,
            "Fossil_abs": -0.0000019014525248893,
            "Land_abs": -0.0000023653003627985,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 195,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Romania",
            "Abs_contribution": -0.00000430767088455998,
            "Perc_contribution": -0.04,
            "Fossil_abs": 1.89132019819593e-06,
            "Land_abs": -0.00000619899108275103,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 196,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Portugal",
            "Abs_contribution": -0.00000461033090599005,
            "Perc_contribution": -0.04,
            "Fossil_abs": -0.00000669742854149499,
            "Land_abs": 2.087097635506e-06,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 197,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Ireland",
            "Abs_contribution": -0.00000463269531811208,
            "Perc_contribution": -0.04,
            "Fossil_abs": -0.00000569720614553902,
            "Land_abs": 1.06451082742496e-06,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 198,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Bulgaria",
            "Abs_contribution": -0.00000470248365865402,
            "Perc_contribution": -0.04,
            "Fossil_abs": -0.00000306411654329796,
            "Land_abs": -0.0000016383671153555,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 199,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Equatorial Guinea",
            "Abs_contribution": -0.00000835716054583798,
            "Perc_contribution": -0.08,
            "Fossil_abs": -0.00000836780495716902,
            "Land_abs": 1.0644411331881e-08,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 200,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Hungary",
            "Abs_contribution": -0.000009497349119166,
            "Perc_contribution": -0.09,
            "Fossil_abs": -0.00000933848584592801,
            "Land_abs": -0.000000158863273238397,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 201,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Austria",
            "Abs_contribution": -0.000009768230916572,
            "Perc_contribution": -0.09,
            "Fossil_abs": -0.00000832330596281104,
            "Land_abs": -0.00000144492495376001,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 202,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "North Korea",
            "Abs_contribution": -0.000012673929647332,
            "Perc_contribution": -0.12,
            "Fossil_abs": -0.000011949125781832,
            "Land_abs": -0.000000724803865500005,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 203,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Greece",
            "Abs_contribution": -0.0000130307474730591,
            "Perc_contribution": -0.12,
            "Fossil_abs": -0.000009989096314026,
            "Land_abs": -0.00000304165115903399,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 204,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Belgium",
            "Abs_contribution": -0.000015612046001711,
            "Perc_contribution": -0.15,
            "Fossil_abs": -0.000011650518466657,
            "Land_abs": -0.000003961527535055,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 205,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Sweden",
            "Abs_contribution": -0.000016157753260823,
            "Perc_contribution": -0.15,
            "Fossil_abs": -0.000014006364396336,
            "Land_abs": -0.00000215138886448701,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 206,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Angola",
            "Abs_contribution": -0.0000208278359560598,
            "Perc_contribution": -0.2,
            "Fossil_abs": -0.0000326467861135301,
            "Land_abs": 1.181895015747e-05,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 207,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Gabon",
            "Abs_contribution": -0.000029962833818904,
            "Perc_contribution": -0.28,
            "Fossil_abs": -0.0000301940207789499,
            "Land_abs": 2.31186960043101e-07,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 208,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Finland",
            "Abs_contribution": -0.000031181157726383,
            "Perc_contribution": -0.3,
            "Fossil_abs": -0.000029471914773279,
            "Land_abs": -0.000001709242953101,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 209,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Italy",
            "Abs_contribution": -0.0000346291994106898,
            "Perc_contribution": -0.33,
            "Fossil_abs": -0.0000390022690894701,
            "Land_abs": 4.37306967877502e-06,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 210,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Japan",
            "Abs_contribution": -0.0000391301587051799,
            "Perc_contribution": -0.37,
            "Fossil_abs": -0.000032258683328596,
            "Land_abs": -0.00000687147537658899,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 211,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Netherlands",
            "Abs_contribution": -0.00004164972462274,
            "Perc_contribution": -0.4,
            "Fossil_abs": -0.000041489014301711,
            "Land_abs": -0.000000160710321029018,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 212,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "France",
            "Abs_contribution": -0.0000451829847813701,
            "Perc_contribution": -0.43,
            "Fossil_abs": -0.0000183664751984801,
            "Land_abs": -0.00002681650958289,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 213,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "United States",
            "Abs_contribution": -0.0000499453028052974,
            "Perc_contribution": -0.47,
            "Fossil_abs": -0.0000980139111727008,
            "Land_abs": 4.80686083672004e-05,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 214,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Syria",
            "Abs_contribution": -0.000055570283674697,
            "Perc_contribution": -0.53,
            "Fossil_abs": -0.000059113195049807,
            "Land_abs": 3.54291137511e-06,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 215,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Venezuela",
            "Abs_contribution": -0.0000573088703253199,
            "Perc_contribution": -0.54,
            "Fossil_abs": -0.0000718106363958,
            "Land_abs": 1.45017660704799e-05,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 216,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Ukraine",
            "Abs_contribution": -0.0000708952784345303,
            "Perc_contribution": -0.67,
            "Fossil_abs": -0.00001250247660601,
            "Land_abs": -0.0000583928018285109,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 217,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Poland",
            "Abs_contribution": -0.0000885688203352501,
            "Perc_contribution": -0.84,
            "Fossil_abs": -0.0000897810832901098,
            "Land_abs": 1.21226295487402e-06,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 218,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Nigeria",
            "Abs_contribution": -0.0001002195837944,
            "Perc_contribution": -0.95,
            "Fossil_abs": -0.000187823755659049,
            "Land_abs": 8.76041718647399e-05,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 219,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Germany",
            "Abs_contribution": -0.00011187425722241,
            "Perc_contribution": -1.06,
            "Fossil_abs": -0.0000892531551595398,
            "Land_abs": -0.0000226211020628701,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 220,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "United Kingdom",
            "Abs_contribution": -0.00020446579750743,
            "Perc_contribution": -1.94,
            "Fossil_abs": -0.00019920508545641,
            "Land_abs": -0.00000526071205101991,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 221,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Australia",
            "Abs_contribution": -0.0002056628179265,
            "Perc_contribution": -1.95,
            "Fossil_abs": -0.00000690005346625031,
            "Land_abs": -0.000198762764460229,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 222,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "EU27",
            "Abs_contribution": -0.000440257001350999,
            "Perc_contribution": -4.18,
            "Fossil_abs": -0.0003765284466928,
            "Land_abs": -0.0000637285546580806,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 223,
            "Perc_contribution_rescale": 0
        }
    ],
    "2020_CO2": [
        {
            "Country": "China",
            "Abs_contribution": 0.010454366426421,
            "Perc_contribution": 28.8,
            "Fossil_abs": 0.010237300384921,
            "Land_abs": 0.0002170660415,
            "Fossil_fraction": 97.9236805689972,
            "Land_fraction": 2.07631943100268,
            "Rank": 1,
            "Perc_contribution_rescale": 100
        },
        {
            "Country": "United States",
            "Abs_contribution": 0.004541143903106,
            "Perc_contribution": 12.51,
            "Fossil_abs": 0.00454358692610599,
            "Land_abs": -0.00000244302299999555,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 2,
            "Perc_contribution_rescale": 43.4375
        },
        {
            "Country": "India",
            "Abs_contribution": 0.002479494738737,
            "Perc_contribution": 6.83,
            "Fossil_abs": 0.0024785423257369,
            "Land_abs": 9.52413000000762e-07,
            "Fossil_fraction": 99.9615884242373,
            "Land_fraction": 0.038411575758612,
            "Rank": 3,
            "Perc_contribution_rescale": 23.7152777777778
        },
        {
            "Country": "EU27",
            "Abs_contribution": 0.00239975554345701,
            "Perc_contribution": 6.61,
            "Fossil_abs": 0.002507274421957,
            "Land_abs": -0.0001075188785,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 4,
            "Perc_contribution_rescale": 22.9513888888889
        },
        {
            "Country": "Russia",
            "Abs_contribution": 0.001557565508191,
            "Perc_contribution": 4.29,
            "Fossil_abs": 0.0015149785626911,
            "Land_abs": 4.25869454999984e-05,
            "Fossil_fraction": 97.2658006821582,
            "Land_fraction": 2.73419931784828,
            "Rank": 5,
            "Perc_contribution_rescale": 14.8958333333333
        },
        {
            "Country": "Indonesia",
            "Abs_contribution": 0.001403129861465,
            "Perc_contribution": 3.87,
            "Fossil_abs": 0.00060560343946507,
            "Land_abs": 0.000797526421999997,
            "Fossil_fraction": 43.1608973693114,
            "Land_fraction": 56.8391026306934,
            "Rank": 6,
            "Perc_contribution_rescale": 13.4375
        },
        {
            "Country": "Brazil",
            "Abs_contribution": 0.0013156150047504,
            "Perc_contribution": 3.62,
            "Fossil_abs": 0.000441628825750539,
            "Land_abs": 0.000873986179000003,
            "Fossil_fraction": 33.5682417847101,
            "Land_fraction": 66.4317582153007,
            "Rank": 7,
            "Perc_contribution_rescale": 12.5694444444444
        },
        {
            "Country": "Japan",
            "Abs_contribution": 0.000944623511529397,
            "Perc_contribution": 2.6,
            "Fossil_abs": 0.000952860190529498,
            "Land_abs": -0.00000823667900000011,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 8,
            "Perc_contribution_rescale": 9.02777777777778
        },
        {
            "Country": "Iran",
            "Abs_contribution": 0.000618637459276169,
            "Perc_contribution": 1.7,
            "Fossil_abs": 0.0006208717297762,
            "Land_abs": -0.00000223427050000309,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 9,
            "Perc_contribution_rescale": 5.90277777777778
        },
        {
            "Country": "Saudi Arabia",
            "Abs_contribution": 0.000583751219019099,
            "Perc_contribution": 1.61,
            "Fossil_abs": 0.0005827178075191,
            "Land_abs": 1.0334115e-06,
            "Fossil_fraction": 99.8229705624023,
            "Land_fraction": 0.177029437597832,
            "Rank": 10,
            "Perc_contribution_rescale": 5.59027777777778
        },
        {
            "Country": "Germany",
            "Abs_contribution": 0.000582710216498396,
            "Perc_contribution": 1.61,
            "Fossil_abs": 0.0006054219164984,
            "Land_abs": -0.0000227117000000009,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 11,
            "Perc_contribution_rescale": 5.59027777777778
        },
        {
            "Country": "Mexico",
            "Abs_contribution": 0.0005696275238368,
            "Perc_contribution": 1.57,
            "Fossil_abs": 0.000441664694336789,
            "Land_abs": 0.0001279628295,
            "Fossil_fraction": 77.5357011125269,
            "Land_fraction": 22.4642988874713,
            "Rank": 12,
            "Perc_contribution_rescale": 5.45138888888889
        },
        {
            "Country": "Canada",
            "Abs_contribution": 0.000555488561164802,
            "Perc_contribution": 1.53,
            "Fossil_abs": 0.0004886583141648,
            "Land_abs": 6.68302469999989e-05,
            "Fossil_fraction": 87.9691047355023,
            "Land_fraction": 12.030895264497,
            "Rank": 13,
            "Perc_contribution_rescale": 5.3125
        },
        {
            "Country": "South Korea",
            "Abs_contribution": 0.00054001138978222,
            "Perc_contribution": 1.49,
            "Fossil_abs": 0.000548082056782199,
            "Land_abs": -0.00000807066699999999,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 14,
            "Perc_contribution_rescale": 5.17361111111111
        },
        {
            "Country": "Democratic Republic of the Congo",
            "Abs_contribution": 0.000484294252377742,
            "Perc_contribution": 1.33,
            "Fossil_abs": 3.39649437772941e-06,
            "Land_abs": 0.00048089775800002,
            "Fossil_fraction": 0.70132865733046,
            "Land_fraction": 99.2986713426711,
            "Rank": 15,
            "Perc_contribution_rescale": 4.61805555555556
        },
        {
            "Country": "Viet Nam",
            "Abs_contribution": 0.0004394842851867,
            "Perc_contribution": 1.21,
            "Fossil_abs": 0.00031349984418669,
            "Land_abs": 0.000125984441,
            "Fossil_fraction": 71.333573179644,
            "Land_fraction": 28.6664268203536,
            "Rank": 16,
            "Perc_contribution_rescale": 4.20138888888889
        },
        {
            "Country": "T\xfcrkiye",
            "Abs_contribution": 0.00038042015026418,
            "Perc_contribution": 1.05,
            "Fossil_abs": 0.00040006527576419,
            "Land_abs": -0.0000196451254999999,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 17,
            "Perc_contribution_rescale": 3.64583333333333
        },
        {
            "Country": "South Africa",
            "Abs_contribution": 0.0003762259580726,
            "Perc_contribution": 1.04,
            "Fossil_abs": 0.000373628506072589,
            "Land_abs": 2.59745200000038e-06,
            "Fossil_fraction": 99.3096031934327,
            "Land_fraction": 0.690396806564621,
            "Rank": 18,
            "Perc_contribution_rescale": 3.61111111111111
        },
        {
            "Country": "Malaysia",
            "Abs_contribution": 0.00036776665248635,
            "Perc_contribution": 1.01,
            "Fossil_abs": 0.00025665631248635,
            "Land_abs": 0.00011111034,
            "Fossil_fraction": 69.78781538543,
            "Land_fraction": 30.2121846145699,
            "Rank": 19,
            "Perc_contribution_rescale": 3.50694444444444
        },
        {
            "Country": "Australia",
            "Abs_contribution": 0.0003460622476807,
            "Perc_contribution": 0.95,
            "Fossil_abs": 0.00035075387968068,
            "Land_abs": -0.00000469163200002981,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 20,
            "Perc_contribution_rescale": 3.29861111111111
        },
        {
            "Country": "United Kingdom",
            "Abs_contribution": 0.000310837281031096,
            "Perc_contribution": 0.86,
            "Fossil_abs": 0.000299971899031096,
            "Land_abs": 1.08653819999999e-05,
            "Fossil_fraction": 96.5044791397101,
            "Land_fraction": 3.49552086028989,
            "Rank": 21,
            "Perc_contribution_rescale": 2.98611111111111
        },
        {
            "Country": "Italy",
            "Abs_contribution": 0.000287123960275601,
            "Perc_contribution": 0.79,
            "Fossil_abs": 0.000304118410275601,
            "Land_abs": -0.0000169944499999996,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 22,
            "Perc_contribution_rescale": 2.74305555555556
        },
        {
            "Country": "Poland",
            "Abs_contribution": 0.0002691173104864,
            "Perc_contribution": 0.74,
            "Fossil_abs": 0.000294601774986299,
            "Land_abs": -0.0000254844645,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 23,
            "Perc_contribution_rescale": 2.56944444444444
        },
        {
            "Country": "Thailand",
            "Abs_contribution": 0.00025727712988592,
            "Perc_contribution": 0.71,
            "Fossil_abs": 0.00024226061188592,
            "Land_abs": 1.50165180000002e-05,
            "Fossil_fraction": 94.1632907648425,
            "Land_fraction": 5.83670923515771,
            "Rank": 24,
            "Perc_contribution_rescale": 2.46527777777778
        },
        {
            "Country": "Taiwan",
            "Abs_contribution": 0.00025628244473253,
            "Perc_contribution": 0.71,
            "Fossil_abs": 0.00025628244473253,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 25,
            "Perc_contribution_rescale": 2.46527777777778
        },
        {
            "Country": "France",
            "Abs_contribution": 0.000248539942659901,
            "Perc_contribution": 0.68,
            "Fossil_abs": 0.000272137263659898,
            "Land_abs": -0.000023597321,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 26,
            "Perc_contribution_rescale": 2.36111111111111
        },
        {
            "Country": "Kazakhstan",
            "Abs_contribution": 0.000248297454342801,
            "Perc_contribution": 0.68,
            "Fossil_abs": 0.00023701692134279,
            "Land_abs": 1.12805330000102e-05,
            "Fossil_fraction": 95.4568470990294,
            "Land_fraction": 4.54315290097025,
            "Rank": 27,
            "Perc_contribution_rescale": 2.36111111111111
        },
        {
            "Country": "Egypt",
            "Abs_contribution": 0.00022961569148417,
            "Perc_contribution": 0.63,
            "Fossil_abs": 0.00022779189698417,
            "Land_abs": 1.8237945e-06,
            "Fossil_fraction": 99.2057186997057,
            "Land_fraction": 0.794281300294205,
            "Rank": 28,
            "Perc_contribution_rescale": 2.1875
        },
        {
            "Country": "United Arab Emirates",
            "Abs_contribution": 0.00021626243902784,
            "Perc_contribution": 0.6,
            "Fossil_abs": 0.00021667246952784,
            "Land_abs": -0.0000004100305,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 29,
            "Perc_contribution_rescale": 2.08333333333333
        },
        {
            "Country": "Pakistan",
            "Abs_contribution": 0.00020157645576474,
            "Perc_contribution": 0.56,
            "Fossil_abs": 0.00019078127026474,
            "Land_abs": 1.07951855000011e-05,
            "Fossil_fraction": 94.6446198495527,
            "Land_fraction": 5.3553801504478,
            "Rank": 30,
            "Perc_contribution_rescale": 1.94444444444444
        },
        {
            "Country": "Spain",
            "Abs_contribution": 0.000199431630774001,
            "Perc_contribution": 0.55,
            "Fossil_abs": 0.00021430333927402,
            "Land_abs": -0.0000148717085,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 31,
            "Perc_contribution_rescale": 1.90972222222222
        },
        {
            "Country": "Argentina",
            "Abs_contribution": 0.0001875676331262,
            "Perc_contribution": 0.52,
            "Fossil_abs": 0.00017229915462609,
            "Land_abs": 1.52684785000301e-05,
            "Fossil_fraction": 91.8597477370539,
            "Land_fraction": 8.14025226290352,
            "Rank": 32,
            "Perc_contribution_rescale": 1.80555555555556
        },
        {
            "Country": "Algeria",
            "Abs_contribution": 0.00016141894443395,
            "Perc_contribution": 0.44,
            "Fossil_abs": 0.00016057344043395,
            "Land_abs": 8.45504000000015e-07,
            "Fossil_fraction": 99.4762052230209,
            "Land_fraction": 0.523794776979218,
            "Rank": 33,
            "Perc_contribution_rescale": 1.52777777777778
        },
        {
            "Country": "Iraq",
            "Abs_contribution": 0.00016038963182697,
            "Perc_contribution": 0.44,
            "Fossil_abs": 0.00015656406832696,
            "Land_abs": 3.8255635e-06,
            "Fossil_fraction": 97.6148311730418,
            "Land_fraction": 2.38516882695202,
            "Rank": 34,
            "Perc_contribution_rescale": 1.52777777777778
        },
        {
            "Country": "Ukraine",
            "Abs_contribution": 0.000158233770744001,
            "Perc_contribution": 0.44,
            "Fossil_abs": 0.000158247916743999,
            "Land_abs": -0.0000000141460000007212,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 35,
            "Perc_contribution_rescale": 1.52777777777778
        },
        {
            "Country": "Philippines",
            "Abs_contribution": 0.00014909556944542,
            "Perc_contribution": 0.41,
            "Fossil_abs": 0.00013201339994542,
            "Land_abs": 1.70821694999998e-05,
            "Fossil_fraction": 88.5428054210201,
            "Land_fraction": 11.4571945789799,
            "Rank": 36,
            "Perc_contribution_rescale": 1.42361111111111
        },
        {
            "Country": "Colombia",
            "Abs_contribution": 0.000137201600988511,
            "Perc_contribution": 0.38,
            "Fossil_abs": 8.80314029885398e-05,
            "Land_abs": 4.91701979999891e-05,
            "Fossil_fraction": 64.1620814584457,
            "Land_fraction": 35.8379185415676,
            "Rank": 37,
            "Perc_contribution_rescale": 1.31944444444444
        },
        {
            "Country": "Nigeria",
            "Abs_contribution": 0.00013519922770906,
            "Perc_contribution": 0.37,
            "Fossil_abs": 0.00011702784370906,
            "Land_abs": 1.81713839999993e-05,
            "Fossil_fraction": 86.5595504442499,
            "Land_fraction": 13.4404495557497,
            "Rank": 38,
            "Perc_contribution_rescale": 1.28472222222222
        },
        {
            "Country": "Myanmar",
            "Abs_contribution": 0.00012941340472378,
            "Perc_contribution": 0.36,
            "Fossil_abs": 3.17667952238e-05,
            "Land_abs": 9.76466094999807e-05,
            "Fossil_fraction": 24.5467579588089,
            "Land_fraction": 75.4532420411918,
            "Rank": 39,
            "Perc_contribution_rescale": 1.25
        },
        {
            "Country": "Netherlands",
            "Abs_contribution": 0.00012318081689467,
            "Perc_contribution": 0.34,
            "Fossil_abs": 0.00011945621139465,
            "Land_abs": 3.7246055e-06,
            "Fossil_fraction": 96.9763104402823,
            "Land_fraction": 3.02368955970219,
            "Rank": 40,
            "Perc_contribution_rescale": 1.18055555555556
        },
        {
            "Country": "Tanzania",
            "Abs_contribution": 0.00012152113383843,
            "Perc_contribution": 0.33,
            "Fossil_abs": 1.3954377838428e-05,
            "Land_abs": 0.000107566755999999,
            "Fossil_fraction": 11.4830872603454,
            "Land_fraction": 88.5169127396524,
            "Rank": 41,
            "Perc_contribution_rescale": 1.14583333333333
        },
        {
            "Country": "Ethiopia",
            "Abs_contribution": 0.00011573224218941,
            "Perc_contribution": 0.32,
            "Fossil_abs": 1.710917918941e-05,
            "Land_abs": 9.86230630000001e-05,
            "Fossil_fraction": 14.7834163287088,
            "Land_fraction": 85.2165836712914,
            "Rank": 42,
            "Perc_contribution_rescale": 1.11111111111111
        },
        {
            "Country": "Uzbekistan",
            "Abs_contribution": 0.00010620403182587,
            "Perc_contribution": 0.29,
            "Fossil_abs": 0.00010672677932587,
            "Land_abs": -0.000000522747500001004,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 43,
            "Perc_contribution_rescale": 1.00694444444444
        },
        {
            "Country": "Angola",
            "Abs_contribution": 0.00010461297685099,
            "Perc_contribution": 0.29,
            "Fossil_abs": 1.5120188850983e-05,
            "Land_abs": 8.94927879999999e-05,
            "Fossil_fraction": 14.4534543477527,
            "Land_fraction": 85.5465456522406,
            "Rank": 44,
            "Perc_contribution_rescale": 1.00694444444444
        },
        {
            "Country": "Bangladesh",
            "Abs_contribution": 9.90753140878802e-05,
            "Perc_contribution": 0.27,
            "Fossil_abs": 9.0454427087882e-05,
            "Land_abs": 8.62088699999991e-06,
            "Fossil_fraction": 91.2986528689161,
            "Land_fraction": 8.7013471310857,
            "Rank": 45,
            "Perc_contribution_rescale": 0.9375
        },
        {
            "Country": "Kuwait",
            "Abs_contribution": 9.56852975092801e-05,
            "Perc_contribution": 0.26,
            "Fossil_abs": 9.56823440092802e-05,
            "Land_abs": 2.9535e-09,
            "Fossil_fraction": 99.9969133188935,
            "Land_fraction": 0.00308668110658647,
            "Rank": 46,
            "Perc_contribution_rescale": 0.902777777777778
        },
        {
            "Country": "Qatar",
            "Abs_contribution": 9.3920751735266e-05,
            "Perc_contribution": 0.26,
            "Fossil_abs": 9.39196297352641e-05,
            "Land_abs": 1.122e-09,
            "Fossil_fraction": 99.9988053758289,
            "Land_fraction": 0.00119462416906817,
            "Rank": 47,
            "Perc_contribution_rescale": 0.902777777777778
        },
        {
            "Country": "Belgium",
            "Abs_contribution": 8.59364264251903e-05,
            "Perc_contribution": 0.24,
            "Fossil_abs": 8.34337284252099e-05,
            "Land_abs": 2.50269799999999e-06,
            "Fossil_fraction": 97.08773321851,
            "Land_fraction": 2.91226678151278,
            "Rank": 48,
            "Perc_contribution_rescale": 0.833333333333333
        },
        {
            "Country": "Chile",
            "Abs_contribution": 8.27069887052402e-05,
            "Perc_contribution": 0.23,
            "Fossil_abs": 7.80932697052399e-05,
            "Land_abs": 4.61371900000005e-06,
            "Fossil_fraction": 94.4216092591122,
            "Land_fraction": 5.57839074088757,
            "Rank": 49,
            "Perc_contribution_rescale": 0.798611111111111
        },
        {
            "Country": "Venezuela",
            "Abs_contribution": 8.087759802132e-05,
            "Perc_contribution": 0.22,
            "Fossil_abs": 6.68759730212899e-05,
            "Land_abs": 1.40016250000001e-05,
            "Fossil_fraction": 82.6878822534528,
            "Land_fraction": 17.3121177465102,
            "Rank": 50,
            "Perc_contribution_rescale": 0.763888888888889
        },
        {
            "Country": "Peru",
            "Abs_contribution": 7.89154708597203e-05,
            "Perc_contribution": 0.22,
            "Fossil_abs": 5.28645008597159e-05,
            "Land_abs": 2.60509699999997e-05,
            "Fossil_fraction": 66.9887669474691,
            "Land_fraction": 33.011233052525,
            "Rank": 51,
            "Perc_contribution_rescale": 0.763888888888889
        },
        {
            "Country": "Czechia",
            "Abs_contribution": 7.88175131818001e-05,
            "Perc_contribution": 0.22,
            "Fossil_abs": 8.76492811817701e-05,
            "Land_abs": -0.00000883176800000002,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 52,
            "Perc_contribution_rescale": 0.763888888888889
        },
        {
            "Country": "Turkmenistan",
            "Abs_contribution": 6.54830974268501e-05,
            "Perc_contribution": 0.18,
            "Fossil_abs": 6.34660494268501e-05,
            "Land_abs": 2.01704799999806e-06,
            "Fossil_fraction": 96.919742530119,
            "Land_fraction": 3.08025746987804,
            "Rank": 53,
            "Perc_contribution_rescale": 0.625
        },
        {
            "Country": "Oman",
            "Abs_contribution": 6.4601566013099e-05,
            "Perc_contribution": 0.18,
            "Fossil_abs": 6.43314555130999e-05,
            "Land_abs": 2.701105e-07,
            "Fossil_fraction": 99.5818824268993,
            "Land_fraction": 0.418117573102223,
            "Rank": 54,
            "Perc_contribution_rescale": 0.625
        },
        {
            "Country": "Morocco",
            "Abs_contribution": 6.074234941812e-05,
            "Perc_contribution": 0.17,
            "Fossil_abs": 6.3519937418123e-05,
            "Land_abs": -0.00000277758799999703,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 55,
            "Perc_contribution_rescale": 0.590277777777778
        },
        {
            "Country": "Romania",
            "Abs_contribution": 5.85438852330799e-05,
            "Perc_contribution": 0.16,
            "Fossil_abs": 6.786970173308e-05,
            "Land_abs": -0.00000932581649999996,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 56,
            "Perc_contribution_rescale": 0.555555555555556
        },
        {
            "Country": "Belarus",
            "Abs_contribution": 5.79953776364594e-05,
            "Perc_contribution": 0.16,
            "Fossil_abs": 5.39219126364601e-05,
            "Land_abs": 4.07346500000015e-06,
            "Fossil_fraction": 92.9762247165049,
            "Land_fraction": 7.0237752834966,
            "Rank": 57,
            "Perc_contribution_rescale": 0.555555555555556
        },
        {
            "Country": "C\xf4te d'Ivoire",
            "Abs_contribution": 5.78898183700794e-05,
            "Perc_contribution": 0.16,
            "Fossil_abs": 1.0566283870088e-05,
            "Land_abs": 4.73235345e-05,
            "Fossil_fraction": 18.2524045982311,
            "Land_fraction": 81.7475954017838,
            "Rank": 58,
            "Perc_contribution_rescale": 0.555555555555556
        },
        {
            "Country": "Bolivia",
            "Abs_contribution": 5.78518206353698e-05,
            "Perc_contribution": 0.16,
            "Fossil_abs": 1.9463036135371e-05,
            "Land_abs": 3.83887845e-05,
            "Fossil_fraction": 33.6429103209097,
            "Land_fraction": 66.3570896790923,
            "Rank": 59,
            "Perc_contribution_rescale": 0.555555555555556
        },
        {
            "Country": "Libya",
            "Abs_contribution": 5.65273900131002e-05,
            "Perc_contribution": 0.16,
            "Fossil_abs": 5.71407555131e-05,
            "Land_abs": -0.0000006133655,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 60,
            "Perc_contribution_rescale": 0.555555555555556
        },
        {
            "Country": "Paraguay",
            "Abs_contribution": 5.35991626091701e-05,
            "Perc_contribution": 0.15,
            "Fossil_abs": 8.2331001091703e-06,
            "Land_abs": 4.53660625000002e-05,
            "Fossil_fraction": 15.3605013742542,
            "Land_fraction": 84.6394986257465,
            "Rank": 61,
            "Perc_contribution_rescale": 0.520833333333333
        },
        {
            "Country": "North Korea",
            "Abs_contribution": 5.238735046124e-05,
            "Perc_contribution": 0.14,
            "Fossil_abs": 4.602704046124e-05,
            "Land_abs": 6.36030999999905e-06,
            "Fossil_fraction": 87.8590729555872,
            "Land_fraction": 12.140927044411,
            "Rank": 62,
            "Perc_contribution_rescale": 0.486111111111111
        },
        {
            "Country": "Austria",
            "Abs_contribution": 5.22077873018599e-05,
            "Perc_contribution": 0.14,
            "Fossil_abs": 5.741993380185e-05,
            "Land_abs": -0.0000052121465,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 63,
            "Perc_contribution_rescale": 0.486111111111111
        },
        {
            "Country": "Zambia",
            "Abs_contribution": 5.19391654945399e-05,
            "Perc_contribution": 0.14,
            "Fossil_abs": 7.91902999454201e-06,
            "Land_abs": 4.40201355000002e-05,
            "Fossil_fraction": 15.246740911489,
            "Land_fraction": 84.7532590885153,
            "Rank": 64,
            "Perc_contribution_rescale": 0.486111111111111
        },
        {
            "Country": "Israel",
            "Abs_contribution": 5.14069616812298e-05,
            "Perc_contribution": 0.14,
            "Fossil_abs": 4.997159918123e-05,
            "Land_abs": 1.4353625e-06,
            "Fossil_fraction": 97.2078441264428,
            "Land_fraction": 2.79215587355767,
            "Rank": 65,
            "Perc_contribution_rescale": 0.486111111111111
        },
        {
            "Country": "Singapore",
            "Abs_contribution": 4.92464114159421e-05,
            "Perc_contribution": 0.14,
            "Fossil_abs": 4.91231344159391e-05,
            "Land_abs": 1.2327700000003e-07,
            "Fossil_fraction": 99.7496731305723,
            "Land_fraction": 0.250326869421643,
            "Rank": 66,
            "Perc_contribution_rescale": 0.486111111111111
        },
        {
            "Country": "Finland",
            "Abs_contribution": 4.83068218340601e-05,
            "Perc_contribution": 0.13,
            "Fossil_abs": 3.33737718340701e-05,
            "Land_abs": 1.4933050000003e-05,
            "Fossil_fraction": 69.0870783193172,
            "Land_fraction": 30.9129216807098,
            "Rank": 67,
            "Perc_contribution_rescale": 0.451388888888889
        },
        {
            "Country": "Laos",
            "Abs_contribution": 4.8176672632095e-05,
            "Perc_contribution": 0.13,
            "Fossil_abs": 2.0967419132096e-05,
            "Land_abs": 2.72092535000021e-05,
            "Fossil_fraction": 43.5219328910806,
            "Land_fraction": 56.4780671089257,
            "Rank": 68,
            "Perc_contribution_rescale": 0.451388888888889
        },
        {
            "Country": "Sudan",
            "Abs_contribution": 4.55282802265301e-05,
            "Perc_contribution": 0.13,
            "Fossil_abs": 1.9903780226528e-05,
            "Land_abs": 2.56245000000001e-05,
            "Fossil_fraction": 43.7173996634508,
            "Land_fraction": 56.2826003365448,
            "Rank": 69,
            "Perc_contribution_rescale": 0.451388888888889
        },
        {
            "Country": "Sweden",
            "Abs_contribution": 4.53394657068799e-05,
            "Perc_contribution": 0.12,
            "Fossil_abs": 3.44839782068797e-05,
            "Land_abs": 1.08554875000031e-05,
            "Fossil_fraction": 76.0573104893185,
            "Land_fraction": 23.9426895106879,
            "Rank": 70,
            "Perc_contribution_rescale": 0.416666666666667
        },
        {
            "Country": "Ecuador",
            "Abs_contribution": 4.52048186997804e-05,
            "Perc_contribution": 0.12,
            "Fossil_abs": 3.6631924699781e-05,
            "Land_abs": 8.57289400000042e-06,
            "Fossil_fraction": 81.0354421351965,
            "Land_fraction": 18.9645578648059,
            "Rank": 71,
            "Perc_contribution_rescale": 0.416666666666667
        },
        {
            "Country": "Ireland",
            "Abs_contribution": 4.30993155327501e-05,
            "Perc_contribution": 0.12,
            "Fossil_abs": 3.43740825327499e-05,
            "Land_abs": 8.725233e-06,
            "Fossil_fraction": 79.7555184063884,
            "Land_fraction": 20.2444815936112,
            "Rank": 72,
            "Perc_contribution_rescale": 0.416666666666667
        },
        {
            "Country": "Greece",
            "Abs_contribution": 4.231419083297e-05,
            "Perc_contribution": 0.12,
            "Fossil_abs": 5.27869828329699e-05,
            "Land_abs": -0.000010472792,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 73,
            "Perc_contribution_rescale": 0.416666666666667
        },
        {
            "Country": "Cambodia",
            "Abs_contribution": 4.129984271725e-05,
            "Perc_contribution": 0.11,
            "Fossil_abs": 1.80515737172489e-05,
            "Land_abs": 2.3248269e-05,
            "Fossil_fraction": 43.7085773929816,
            "Land_fraction": 56.2914226070158,
            "Rank": 74,
            "Perc_contribution_rescale": 0.381944444444444
        },
        {
            "Country": "Norway",
            "Abs_contribution": 4.05238066834099e-05,
            "Perc_contribution": 0.11,
            "Fossil_abs": 3.685300218341e-05,
            "Land_abs": 3.67080449999998e-06,
            "Fossil_fraction": 90.9416098821172,
            "Land_fraction": 9.05839011788291,
            "Rank": 75,
            "Perc_contribution_rescale": 0.381944444444444
        },
        {
            "Country": "Mozambique",
            "Abs_contribution": 3.92395426992299e-05,
            "Perc_contribution": 0.11,
            "Fossil_abs": 6.84206769923581e-06,
            "Land_abs": 3.2397475e-05,
            "Fossil_fraction": 17.4366652325183,
            "Land_fraction": 82.5633347674968,
            "Rank": 76,
            "Perc_contribution_rescale": 0.381944444444444
        },
        {
            "Country": "Azerbaijan",
            "Abs_contribution": 3.81159447150599e-05,
            "Perc_contribution": 0.1,
            "Fossil_abs": 3.440334571506e-05,
            "Land_abs": 3.712599e-06,
            "Fossil_fraction": 90.2597219411618,
            "Land_fraction": 9.74027805883852,
            "Rank": 77,
            "Perc_contribution_rescale": 0.347222222222222
        },
        {
            "Country": "Hungary",
            "Abs_contribution": 3.61581955354798e-05,
            "Perc_contribution": 0.1,
            "Fossil_abs": 4.184329253548e-05,
            "Land_abs": -0.00000568509699999989,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 78,
            "Perc_contribution_rescale": 0.347222222222222
        },
        {
            "Country": "Bulgaria",
            "Abs_contribution": 3.577609153767e-05,
            "Perc_contribution": 0.1,
            "Fossil_abs": 3.982218303767e-05,
            "Land_abs": -0.0000040460915,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 79,
            "Perc_contribution_rescale": 0.347222222222222
        },
        {
            "Country": "Bahrain",
            "Abs_contribution": 3.4187035218341e-05,
            "Perc_contribution": 0.09,
            "Fossil_abs": 3.4188025218341e-05,
            "Land_abs": -0.000000000990000000000011,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 80,
            "Perc_contribution_rescale": 0.3125
        },
        {
            "Country": "Serbia",
            "Abs_contribution": 3.30788827833e-05,
            "Perc_contribution": 0.09,
            "Fossil_abs": 3.93642332833001e-05,
            "Land_abs": -0.00000628535050000001,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 81,
            "Perc_contribution_rescale": 0.3125
        },
        {
            "Country": "Portugal",
            "Abs_contribution": 3.27083752412599e-05,
            "Perc_contribution": 0.09,
            "Fossil_abs": 3.67212192412699e-05,
            "Land_abs": -0.0000040128440000001,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 82,
            "Perc_contribution_rescale": 0.3125
        },
        {
            "Country": "Papua New Guinea",
            "Abs_contribution": 3.1836878283299e-05,
            "Perc_contribution": 0.09,
            "Fossil_abs": 7.101370783297e-06,
            "Land_abs": 2.4735507500002e-05,
            "Fossil_fraction": 22.3054871149922,
            "Land_fraction": 77.6945128850078,
            "Rank": 83,
            "Perc_contribution_rescale": 0.3125
        },
        {
            "Country": "Tunisia",
            "Abs_contribution": 3.1688243521286e-05,
            "Perc_contribution": 0.09,
            "Fossil_abs": 3.1892673021288e-05,
            "Land_abs": -0.000000204429499999978,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 84,
            "Perc_contribution_rescale": 0.3125
        },
        {
            "Country": "Mongolia",
            "Abs_contribution": 3.138223548199e-05,
            "Perc_contribution": 0.09,
            "Fossil_abs": 3.4292956481987e-05,
            "Land_abs": -0.000002910721,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 85,
            "Perc_contribution_rescale": 0.3125
        },
        {
            "Country": "Cameroon",
            "Abs_contribution": 3.12838546703e-05,
            "Perc_contribution": 0.09,
            "Fossil_abs": 8.948184170306e-06,
            "Land_abs": 2.23356705e-05,
            "Fossil_fraction": 28.6032020817471,
            "Land_fraction": 71.3967979182719,
            "Rank": 86,
            "Perc_contribution_rescale": 0.3125
        },
        {
            "Country": "Trinidad and Tobago",
            "Abs_contribution": 3.123127584116e-05,
            "Perc_contribution": 0.09,
            "Fossil_abs": 3.1461775341157e-05,
            "Land_abs": -0.000000230499499999999,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 87,
            "Perc_contribution_rescale": 0.3125
        },
        {
            "Country": "Switzerland",
            "Abs_contribution": 3.08641173848302e-05,
            "Perc_contribution": 0.09,
            "Fossil_abs": 3.20486853848299e-05,
            "Land_abs": -0.000001184568,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 88,
            "Perc_contribution_rescale": 0.3125
        },
        {
            "Country": "Slovakia",
            "Abs_contribution": 2.86827588602601e-05,
            "Perc_contribution": 0.08,
            "Fossil_abs": 3.12160203602601e-05,
            "Land_abs": -0.0000025332615,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 89,
            "Perc_contribution_rescale": 0.277777777777778
        },
        {
            "Country": "Hong Kong",
            "Abs_contribution": 2.8525730485808e-05,
            "Perc_contribution": 0.08,
            "Fossil_abs": 2.8525730485808e-05,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 90,
            "Perc_contribution_rescale": 0.277777777777778
        },
        {
            "Country": "Denmark",
            "Abs_contribution": 2.73438354317702e-05,
            "Perc_contribution": 0.08,
            "Fossil_abs": 2.64196374317701e-05,
            "Land_abs": 9.24197999999988e-07,
            "Fossil_fraction": 96.620086445787,
            "Land_fraction": 3.3799135542126,
            "Rank": 91,
            "Perc_contribution_rescale": 0.277777777777778
        },
        {
            "Country": "Guatemala",
            "Abs_contribution": 2.70473081975999e-05,
            "Perc_contribution": 0.07,
            "Fossil_abs": 1.7507046697598e-05,
            "Land_abs": 9.54026149999998e-06,
            "Fossil_fraction": 64.7275010499992,
            "Land_fraction": 35.2724989499937,
            "Rank": 92,
            "Perc_contribution_rescale": 0.243055555555556
        },
        {
            "Country": "Chad",
            "Abs_contribution": 2.6227580764192e-05,
            "Perc_contribution": 0.07,
            "Fossil_abs": 2.1776757641921e-06,
            "Land_abs": 2.4049905e-05,
            "Fossil_fraction": 8.30299898328875,
            "Land_fraction": 91.6970010167116,
            "Rank": 93,
            "Perc_contribution_rescale": 0.243055555555556
        },
        {
            "Country": "Kenya",
            "Abs_contribution": 2.590145379694e-05,
            "Perc_contribution": 0.07,
            "Fossil_abs": 2.2205420796943e-05,
            "Land_abs": 3.69603299999995e-06,
            "Fossil_fraction": 85.730403285573,
            "Land_fraction": 14.2695967144385,
            "Rank": 94,
            "Perc_contribution_rescale": 0.243055555555556
        },
        {
            "Country": "Syria",
            "Abs_contribution": 2.4148018869541e-05,
            "Perc_contribution": 0.07,
            "Fossil_abs": 2.4701489369542e-05,
            "Land_abs": -0.000000553470500000024,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 95,
            "Perc_contribution_rescale": 0.243055555555556
        },
        {
            "Country": "Lebanon",
            "Abs_contribution": 2.1858291725437e-05,
            "Perc_contribution": 0.06,
            "Fossil_abs": 2.1334878725436e-05,
            "Land_abs": 5.23413e-07,
            "Fossil_fraction": 97.6054258650422,
            "Land_fraction": 2.39457413495352,
            "Rank": 96,
            "Perc_contribution_rescale": 0.208333333333333
        },
        {
            "Country": "Nicaragua",
            "Abs_contribution": 2.144975160535e-05,
            "Perc_contribution": 0.06,
            "Fossil_abs": 4.9240886053493e-06,
            "Land_abs": 1.6525663e-05,
            "Fossil_fraction": 22.9563898731636,
            "Land_fraction": 77.0436101268334,
            "Rank": 97,
            "Perc_contribution_rescale": 0.208333333333333
        },
        {
            "Country": "Jordan",
            "Abs_contribution": 2.0438157110262e-05,
            "Perc_contribution": 0.06,
            "Fossil_abs": 2.05258766102621e-05,
            "Land_abs": -0.0000000877195000000009,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 98,
            "Perc_contribution_rescale": 0.208333333333333
        },
        {
            "Country": "Honduras",
            "Abs_contribution": 2.04347514153901e-05,
            "Perc_contribution": 0.06,
            "Fossil_abs": 9.90476491539299e-06,
            "Land_abs": 1.05299865e-05,
            "Fossil_fraction": 48.4702001705456,
            "Land_fraction": 51.5297998294682,
            "Rank": 99,
            "Perc_contribution_rescale": 0.208333333333333
        },
        {
            "Country": "Ghana",
            "Abs_contribution": 2.031780257369e-05,
            "Perc_contribution": 0.06,
            "Fossil_abs": 1.881154507369e-05,
            "Land_abs": 1.50625749999796e-06,
            "Fossil_fraction": 92.5865137505054,
            "Land_fraction": 7.41348624948475,
            "Rank": 100,
            "Perc_contribution_rescale": 0.208333333333333
        },
        {
            "Country": "Sri Lanka",
            "Abs_contribution": 2.008672402456e-05,
            "Perc_contribution": 0.06,
            "Fossil_abs": 1.6862827524564e-05,
            "Land_abs": 3.22389649999697e-06,
            "Fossil_fraction": 83.950113039567,
            "Land_fraction": 16.0498869604377,
            "Rank": 101,
            "Perc_contribution_rescale": 0.208333333333333
        },
        {
            "Country": "Dominican Republic",
            "Abs_contribution": 1.9705030233079e-05,
            "Perc_contribution": 0.05,
            "Fossil_abs": 2.1355789233079e-05,
            "Land_abs": -0.00000165075899999996,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 102,
            "Perc_contribution_rescale": 0.173611111111111
        },
        {
            "Country": "Bosnia and Herzegovina",
            "Abs_contribution": 1.8956845911026e-05,
            "Perc_contribution": 0.05,
            "Fossil_abs": 1.7866146411026e-05,
            "Land_abs": 1.0906995e-06,
            "Fossil_fraction": 94.2464083681473,
            "Land_fraction": 5.75359163185269,
            "Rank": 103,
            "Perc_contribution_rescale": 0.173611111111111
        },
        {
            "Country": "Nepal",
            "Abs_contribution": 1.83234826331849e-05,
            "Perc_contribution": 0.05,
            "Fossil_abs": 1.40178956331878e-05,
            "Land_abs": 4.30558699999702e-06,
            "Fossil_fraction": 76.5023544585381,
            "Land_fraction": 23.4976455414614,
            "Rank": 104,
            "Perc_contribution_rescale": 0.173611111111111
        },
        {
            "Country": "Benin",
            "Abs_contribution": 1.8186780307313e-05,
            "Perc_contribution": 0.05,
            "Fossil_abs": 7.5405788073144e-06,
            "Land_abs": 1.0646201499999e-05,
            "Fossil_fraction": 41.4618677957103,
            "Land_fraction": 58.5381322042917,
            "Rank": 105,
            "Perc_contribution_rescale": 0.173611111111111
        },
        {
            "Country": "Madagascar",
            "Abs_contribution": 1.81146562074201e-05,
            "Perc_contribution": 0.05,
            "Fossil_abs": 3.9044602074236e-06,
            "Land_abs": 1.42101959999998e-05,
            "Fossil_fraction": 21.5541502014499,
            "Land_fraction": 78.4458497985686,
            "Rank": 106,
            "Perc_contribution_rescale": 0.173611111111111
        },
        {
            "Country": "Uganda",
            "Abs_contribution": 1.672256119268e-05,
            "Perc_contribution": 0.05,
            "Fossil_abs": 5.4374961926855e-06,
            "Land_abs": 1.12850649999999e-05,
            "Fossil_fraction": 32.515929408383,
            "Land_fraction": 67.4840705916492,
            "Rank": 107,
            "Perc_contribution_rescale": 0.173611111111111
        },
        {
            "Country": "Panama",
            "Abs_contribution": 1.5884105058406e-05,
            "Perc_contribution": 0.04,
            "Fossil_abs": 1.0631099058407e-05,
            "Land_abs": 5.25300599999996e-06,
            "Fossil_fraction": 66.9291661023166,
            "Land_fraction": 33.0708338976897,
            "Rank": 108,
            "Perc_contribution_rescale": 0.138888888888889
        },
        {
            "Country": "Guinea",
            "Abs_contribution": 1.586636247871e-05,
            "Perc_contribution": 0.04,
            "Fossil_abs": 4.4225894787118e-06,
            "Land_abs": 1.1443773e-05,
            "Fossil_fraction": 27.8739974877428,
            "Land_fraction": 72.1260025122685,
            "Rank": 109,
            "Perc_contribution_rescale": 0.138888888888889
        },
        {
            "Country": "New Zealand",
            "Abs_contribution": 1.58404152920304e-05,
            "Perc_contribution": 0.04,
            "Fossil_abs": 2.9960207792031e-05,
            "Land_abs": -0.0000141197925,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 110,
            "Perc_contribution_rescale": 0.138888888888889
        },
        {
            "Country": "Somalia",
            "Abs_contribution": 1.5433885614084e-05,
            "Perc_contribution": 0.04,
            "Fossil_abs": 5.84325614082999e-07,
            "Land_abs": 1.484956e-05,
            "Fossil_fraction": 3.78599160764662,
            "Land_fraction": 96.2140083923468,
            "Rank": 111,
            "Perc_contribution_rescale": 0.138888888888889
        },
        {
            "Country": "Niger",
            "Abs_contribution": 1.52975207276199e-05,
            "Perc_contribution": 0.04,
            "Fossil_abs": 2.7457067276201e-06,
            "Land_abs": 1.25518140000001e-05,
            "Fossil_fraction": 17.9487040842029,
            "Land_fraction": 82.0512959157987,
            "Rank": 112,
            "Perc_contribution_rescale": 0.138888888888889
        },
        {
            "Country": "Zimbabwe",
            "Abs_contribution": 1.470460181386e-05,
            "Perc_contribution": 0.04,
            "Fossil_abs": 7.76911281386402e-06,
            "Land_abs": 6.93548899999698e-06,
            "Fossil_fraction": 52.8345677918403,
            "Land_fraction": 47.1654322081667,
            "Rank": 113,
            "Perc_contribution_rescale": 0.138888888888889
        },
        {
            "Country": "Cuba",
            "Abs_contribution": 1.42791044792498e-05,
            "Perc_contribution": 0.04,
            "Fossil_abs": 1.8851358979258e-05,
            "Land_abs": -0.00000457225450000006,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 114,
            "Perc_contribution_rescale": 0.138888888888889
        },
        {
            "Country": "Lithuania",
            "Abs_contribution": 1.39673614710698e-05,
            "Perc_contribution": 0.04,
            "Fossil_abs": 1.19322789710701e-05,
            "Land_abs": 2.03508249999799e-06,
            "Fossil_fraction": 85.4297284120917,
            "Land_fraction": 14.5702715878958,
            "Rank": 115,
            "Perc_contribution_rescale": 0.138888888888889
        },
        {
            "Country": "Liberia",
            "Abs_contribution": 1.3778404635917e-05,
            "Perc_contribution": 0.04,
            "Fossil_abs": 7.84555635916998e-07,
            "Land_abs": 1.2993849e-05,
            "Fossil_fraction": 5.6940963533024,
            "Land_fraction": 94.3059036466973,
            "Rank": 116,
            "Perc_contribution_rescale": 0.138888888888889
        },
        {
            "Country": "Congo",
            "Abs_contribution": 1.36625643684502e-05,
            "Perc_contribution": 0.04,
            "Fossil_abs": 6.61432536844979e-06,
            "Land_abs": 7.04823900000203e-06,
            "Fossil_fraction": 48.4120344473816,
            "Land_fraction": 51.5879655526303,
            "Rank": 117,
            "Perc_contribution_rescale": 0.138888888888889
        },
        {
            "Country": "Croatia",
            "Abs_contribution": 1.29688115049101e-05,
            "Perc_contribution": 0.04,
            "Fossil_abs": 1.5732963004913e-05,
            "Land_abs": -0.00000276415149999998,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 118,
            "Perc_contribution_rescale": 0.138888888888889
        },
        {
            "Country": "Botswana",
            "Abs_contribution": 1.281551572107e-05,
            "Perc_contribution": 0.04,
            "Fossil_abs": 6.1261352210699e-06,
            "Land_abs": 6.68938050000001e-06,
            "Fossil_fraction": 47.802486879228,
            "Land_fraction": 52.1975131207712,
            "Rank": 119,
            "Perc_contribution_rescale": 0.138888888888889
        },
        {
            "Country": "Slovenia",
            "Abs_contribution": 1.2427680717249e-05,
            "Perc_contribution": 0.03,
            "Fossil_abs": 1.1607086217249e-05,
            "Land_abs": 8.205945000001e-07,
            "Fossil_fraction": 93.3970423068475,
            "Land_fraction": 6.60295769315311,
            "Rank": 120,
            "Perc_contribution_rescale": 0.104166666666667
        },
        {
            "Country": "Burkina Faso",
            "Abs_contribution": 1.2254365822051e-05,
            "Perc_contribution": 0.03,
            "Fossil_abs": 5.3322803220524e-06,
            "Land_abs": 6.922085499998e-06,
            "Fossil_fraction": 43.5133110883411,
            "Land_fraction": 56.4866889116541,
            "Rank": 121,
            "Perc_contribution_rescale": 0.104166666666667
        },
        {
            "Country": "Afghanistan",
            "Abs_contribution": 1.2130963150658e-05,
            "Perc_contribution": 0.03,
            "Fossil_abs": 1.10019946506549e-05,
            "Land_abs": 1.12896850000001e-06,
            "Fossil_fraction": 90.6934965840541,
            "Land_fraction": 9.30650341592022,
            "Rank": 122,
            "Perc_contribution_rescale": 0.104166666666667
        },
        {
            "Country": "Senegal",
            "Abs_contribution": 1.177618039083e-05,
            "Perc_contribution": 0.03,
            "Fossil_abs": 1.0451499890829e-05,
            "Land_abs": 1.32468049999999e-06,
            "Fossil_fraction": 88.7511870909134,
            "Land_fraction": 11.248812909078,
            "Rank": 123,
            "Perc_contribution_rescale": 0.104166666666667
        },
        {
            "Country": "Brunei Darussalam",
            "Abs_contribution": 1.0743349675219e-05,
            "Perc_contribution": 0.03,
            "Fossil_abs": 9.93220967521901e-06,
            "Land_abs": 8.11140000000006e-07,
            "Fossil_fraction": 92.4498408362243,
            "Land_fraction": 7.55015916377561,
            "Rank": 124,
            "Perc_contribution_rescale": 0.104166666666667
        },
        {
            "Country": "Estonia",
            "Abs_contribution": 1.05127202287151e-05,
            "Perc_contribution": 0.03,
            "Fossil_abs": 9.33608322871199e-06,
            "Land_abs": 1.17663700000001e-06,
            "Fossil_fraction": 88.8074925004745,
            "Land_fraction": 11.1925074994964,
            "Rank": 125,
            "Perc_contribution_rescale": 0.104166666666667
        },
        {
            "Country": "Malawi",
            "Abs_contribution": 1.0067943436679e-05,
            "Perc_contribution": 0.03,
            "Fossil_abs": 1.8789879366812e-06,
            "Land_abs": 8.18895549999901e-06,
            "Fossil_fraction": 18.6630760144695,
            "Land_fraction": 81.3369239855422,
            "Rank": 126,
            "Perc_contribution_rescale": 0.104166666666667
        },
        {
            "Country": "Namibia",
            "Abs_contribution": 1.0008228423581e-05,
            "Perc_contribution": 0.03,
            "Fossil_abs": 3.4609074235808e-06,
            "Land_abs": 6.54732100000029e-06,
            "Fossil_fraction": 34.5806198370367,
            "Land_fraction": 65.4193801629642,
            "Rank": 127,
            "Perc_contribution_rescale": 0.104166666666667
        },
        {
            "Country": "Tajikistan",
            "Abs_contribution": 9.87798583569898e-06,
            "Perc_contribution": 0.03,
            "Fossil_abs": 9.005542835698e-06,
            "Land_abs": 8.72442999999993e-07,
            "Fossil_fraction": 91.1678047072311,
            "Land_fraction": 8.83219529275887,
            "Rank": 128,
            "Perc_contribution_rescale": 0.104166666666667
        },
        {
            "Country": "Yemen",
            "Abs_contribution": 9.83296134661601e-06,
            "Perc_contribution": 0.03,
            "Fossil_abs": 1.0332432846615e-05,
            "Land_abs": -0.000000499471499999998,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 129,
            "Perc_contribution_rescale": 0.104166666666667
        },
        {
            "Country": "Latvia",
            "Abs_contribution": 9.80186161463005e-06,
            "Perc_contribution": 0.03,
            "Fossil_abs": 6.22890761462798e-06,
            "Land_abs": 3.57295400000001e-06,
            "Fossil_fraction": 63.548210120931,
            "Land_fraction": 36.451789879048,
            "Rank": 130,
            "Perc_contribution_rescale": 0.104166666666667
        },
        {
            "Country": "Kyrgyzstan",
            "Abs_contribution": 9.70439115502496e-06,
            "Perc_contribution": 0.03,
            "Fossil_abs": 8.50376315502202e-06,
            "Land_abs": 1.20062799999999e-06,
            "Fossil_fraction": 87.6279925157257,
            "Land_fraction": 12.3720074842439,
            "Rank": 131,
            "Perc_contribution_rescale": 0.104166666666667
        },
        {
            "Country": "Guyana",
            "Abs_contribution": 9.52254401255699e-06,
            "Perc_contribution": 0.03,
            "Fossil_abs": 3.1977860125546e-06,
            "Land_abs": 6.32475800000097e-06,
            "Fossil_fraction": 33.581215359444,
            "Land_fraction": 66.4187846405411,
            "Rank": 132,
            "Perc_contribution_rescale": 0.104166666666667
        },
        {
            "Country": "Gabon",
            "Abs_contribution": 9.37759521725198e-06,
            "Perc_contribution": 0.03,
            "Fossil_abs": 5.217461217249e-06,
            "Land_abs": 4.16013400000306e-06,
            "Fossil_fraction": 55.6375178963838,
            "Land_fraction": 44.362482103617,
            "Rank": 133,
            "Perc_contribution_rescale": 0.104166666666667
        },
        {
            "Country": "Sierra Leone",
            "Abs_contribution": 8.4800755376619e-06,
            "Perc_contribution": 0.02,
            "Fossil_abs": 1.0084080376638e-06,
            "Land_abs": 7.47166749999798e-06,
            "Fossil_fraction": 11.891498291321,
            "Land_fraction": 88.1085017086775,
            "Rank": 134,
            "Perc_contribution_rescale": 0.0694444444444444
        },
        {
            "Country": "Costa Rica",
            "Abs_contribution": 7.58355890557007e-06,
            "Perc_contribution": 0.02,
            "Fossil_abs": 6.999926405568e-06,
            "Land_abs": 5.8363250000199e-07,
            "Fossil_fraction": 92.3039761770243,
            "Land_fraction": 7.69602382297467,
            "Rank": 135,
            "Perc_contribution_rescale": 0.0694444444444444
        },
        {
            "Country": "South Sudan",
            "Abs_contribution": 7.58029754967195e-06,
            "Perc_contribution": 0.02,
            "Fossil_abs": 1.6561870496725e-06,
            "Land_abs": 5.92411050000003e-06,
            "Fossil_fraction": 21.8485757164529,
            "Land_fraction": 78.1514242835547,
            "Rank": 136,
            "Perc_contribution_rescale": 0.0694444444444444
        },
        {
            "Country": "Kosovo",
            "Abs_contribution": 7.2529005867903e-06,
            "Perc_contribution": 0.02,
            "Fossil_abs": 7.2529005867903e-06,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 137,
            "Perc_contribution_rescale": 0.0694444444444444
        },
        {
            "Country": "Luxembourg",
            "Abs_contribution": 7.22871950054597e-06,
            "Perc_contribution": 0.02,
            "Fossil_abs": 7.18444450054502e-06,
            "Land_abs": 4.4275e-08,
            "Fossil_fraction": 99.3875125463423,
            "Land_fraction": 0.612487453644536,
            "Rank": 138,
            "Perc_contribution_rescale": 0.0694444444444444
        },
        {
            "Country": "Equatorial Guinea",
            "Abs_contribution": 7.06429401637598e-06,
            "Perc_contribution": 0.02,
            "Fossil_abs": 4.82091001637561e-06,
            "Land_abs": 2.243384e-06,
            "Fossil_fraction": 68.243337624398,
            "Land_fraction": 31.7566623755966,
            "Rank": 139,
            "Perc_contribution_rescale": 0.0694444444444444
        },
        {
            "Country": "Armenia",
            "Abs_contribution": 6.78853904530598e-06,
            "Perc_contribution": 0.02,
            "Fossil_abs": 6.06676854530597e-06,
            "Land_abs": 7.21770500000196e-07,
            "Fossil_fraction": 89.3678080779533,
            "Land_fraction": 10.6321919220495,
            "Rank": 140,
            "Perc_contribution_rescale": 0.0694444444444444
        },
        {
            "Country": "Uruguay",
            "Abs_contribution": 6.32107348635198e-06,
            "Perc_contribution": 0.02,
            "Fossil_abs": 7.20312498635298e-06,
            "Land_abs": -0.000000882051500000996,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 141,
            "Perc_contribution_rescale": 0.0694444444444444
        },
        {
            "Country": "Belize",
            "Abs_contribution": 6.29844195305701e-06,
            "Perc_contribution": 0.02,
            "Fossil_abs": 6.42747953056769e-07,
            "Land_abs": 5.65569399999999e-06,
            "Fossil_fraction": 10.2048722183556,
            "Land_fraction": 89.7951277816404,
            "Rank": 142,
            "Perc_contribution_rescale": 0.0694444444444444
        },
        {
            "Country": "Cyprus",
            "Abs_contribution": 6.08512708296901e-06,
            "Perc_contribution": 0.02,
            "Fossil_abs": 6.331026582969e-06,
            "Land_abs": -0.0000002458995,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 143,
            "Perc_contribution_rescale": 0.0694444444444444
        },
        {
            "Country": "Mali",
            "Abs_contribution": 5.92352861681202e-06,
            "Perc_contribution": 0.02,
            "Fossil_abs": 6.2896856168122e-06,
            "Land_abs": -0.000000366156999999985,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 144,
            "Perc_contribution_rescale": 0.0694444444444444
        },
        {
            "Country": "Suriname",
            "Abs_contribution": 5.92201946124399e-06,
            "Perc_contribution": 0.02,
            "Fossil_abs": 3.2734779612446e-06,
            "Land_abs": 2.6485414999997e-06,
            "Fossil_fraction": 55.2763796652057,
            "Land_fraction": 44.7236203347994,
            "Rank": 145,
            "Perc_contribution_rescale": 0.0694444444444444
        },
        {
            "Country": "North Macedonia",
            "Abs_contribution": 5.91519812827496e-06,
            "Perc_contribution": 0.02,
            "Fossil_abs": 6.87978262827498e-06,
            "Land_abs": -0.000000964584500000103,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 146,
            "Perc_contribution_rescale": 0.0694444444444444
        },
        {
            "Country": "Central African Republic",
            "Abs_contribution": 5.71282616866701e-06,
            "Perc_contribution": 0.02,
            "Fossil_abs": 2.1411316866813e-07,
            "Land_abs": 5.49871299999801e-06,
            "Fossil_fraction": 3.74793775176411,
            "Land_fraction": 96.2520622482207,
            "Rank": 147,
            "Perc_contribution_rescale": 0.0694444444444444
        },
        {
            "Country": "Jamaica",
            "Abs_contribution": 5.415593523472e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 5.89747602347201e-06,
            "Land_abs": -0.000000481882500000009,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 148,
            "Perc_contribution_rescale": 0.0347222222222222
        },
        {
            "Country": "El Salvador",
            "Abs_contribution": 4.68725982423902e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 6.84588332423501e-06,
            "Land_abs": -0.00000215862349999999,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 149,
            "Perc_contribution_rescale": 0.0347222222222222
        },
        {
            "Country": "Mauritania",
            "Abs_contribution": 4.6461952270743e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 4.0480372270743e-06,
            "Land_abs": 5.98157999999894e-07,
            "Fossil_fraction": 87.1258530740504,
            "Land_fraction": 12.8741469259472,
            "Rank": 150,
            "Perc_contribution_rescale": 0.0347222222222222
        },
        {
            "Country": "New Caledonia",
            "Abs_contribution": 4.34655888373359e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 4.34655888373359e-06,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 151,
            "Perc_contribution_rescale": 0.0347222222222222
        },
        {
            "Country": "Albania",
            "Abs_contribution": 4.26702062772901e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 4.43950062772999e-06,
            "Land_abs": -0.000000172480000000302,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 152,
            "Perc_contribution_rescale": 0.0347222222222222
        },
        {
            "Country": "Georgia",
            "Abs_contribution": 4.153922446507e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 9.97431394650703e-06,
            "Land_abs": -0.0000058203915,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 153,
            "Perc_contribution_rescale": 0.0347222222222222
        },
        {
            "Country": "Lesotho",
            "Abs_contribution": 4.15101529421401e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 2.528685794214e-06,
            "Land_abs": 1.6223294999999e-06,
            "Fossil_fraction": 60.9172844469803,
            "Land_fraction": 39.0827155530172,
            "Rank": 154,
            "Perc_contribution_rescale": 0.0347222222222222
        },
        {
            "Country": "Mauritius",
            "Abs_contribution": 3.7817673422489e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 3.7556643422489e-06,
            "Land_abs": 2.61029999999999e-08,
            "Fossil_fraction": 99.3097671634005,
            "Land_fraction": 0.690232836599548,
            "Rank": 155,
            "Perc_contribution_rescale": 0.0347222222222222
        },
        {
            "Country": "Iceland",
            "Abs_contribution": 3.49807758842898e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 3.17595908842791e-06,
            "Land_abs": 3.221185000003e-07,
            "Fossil_fraction": 90.791556451847,
            "Land_fraction": 9.20844354813087,
            "Rank": 156,
            "Perc_contribution_rescale": 0.0347222222222222
        },
        {
            "Country": "Haiti",
            "Abs_contribution": 3.05759260971601e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 2.1940321097162e-06,
            "Land_abs": 8.63560499999964e-07,
            "Fossil_fraction": 71.7568489256644,
            "Land_fraction": 28.2431510743405,
            "Rank": 157,
            "Perc_contribution_rescale": 0.0347222222222222
        },
        {
            "Country": "Eritrea",
            "Abs_contribution": 3.0468729656112e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 6.29221465611351e-07,
            "Land_abs": 2.4176515e-06,
            "Fossil_fraction": 20.6513849679036,
            "Land_fraction": 79.3486150321013,
            "Rank": 158,
            "Perc_contribution_rescale": 0.0347222222222222
        },
        {
            "Country": "Togo",
            "Abs_contribution": 2.90442909607001e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 2.3108195960699e-06,
            "Land_abs": 5.9360949999999e-07,
            "Fossil_fraction": 79.561921452883,
            "Land_fraction": 20.4380785471129,
            "Rank": 159,
            "Perc_contribution_rescale": 0.0347222222222222
        },
        {
            "Country": "Solomon Islands",
            "Abs_contribution": 2.8445591763097e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 2.7049867631004e-07,
            "Land_abs": 2.5740604999997e-06,
            "Fossil_fraction": 9.50933552596938,
            "Land_fraction": 90.4906644740321,
            "Rank": 160,
            "Perc_contribution_rescale": 0.0347222222222222
        },
        {
            "Country": "Moldova",
            "Abs_contribution": 2.77507718394999e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 4.96214668395205e-06,
            "Land_abs": -0.0000021870695,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 161,
            "Perc_contribution_rescale": 0.0347222222222222
        },
        {
            "Country": "Timor-Leste",
            "Abs_contribution": 2.549059487445e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 6.0010148744541e-07,
            "Land_abs": 1.948958e-06,
            "Fossil_fraction": 23.5420746514986,
            "Land_fraction": 76.4579253485172,
            "Rank": 162,
            "Perc_contribution_rescale": 0.0347222222222222
        },
        {
            "Country": "Rwanda",
            "Abs_contribution": 2.082297928493e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 1.3965579284935e-06,
            "Land_abs": 6.85739999999968e-07,
            "Fossil_fraction": 67.0681130391468,
            "Land_fraction": 32.9318869608755,
            "Rank": 163,
            "Perc_contribution_rescale": 0.0347222222222222
        },
        {
            "Country": "Bahamas",
            "Abs_contribution": 1.8756097658295e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 1.9006842658297e-06,
            "Land_abs": -0.0000000250744999999998,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 164,
            "Perc_contribution_rescale": 0.0347222222222222
        },
        {
            "Country": "Burundi",
            "Abs_contribution": 1.821954960153e-06,
            "Perc_contribution": 0.01,
            "Fossil_abs": 7.19826460152829e-07,
            "Land_abs": 1.10212849999998e-06,
            "Fossil_fraction": 39.5084662297241,
            "Land_fraction": 60.4915337702656,
            "Rank": 165,
            "Perc_contribution_rescale": 0.0347222222222222
        },
        {
            "Country": "Gambia",
            "Abs_contribution": 1.7356664748912e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 6.87877974890829e-07,
            "Land_abs": 1.0477885000003e-06,
            "Fossil_fraction": 39.6319215034644,
            "Land_fraction": 60.3680784965312,
            "Rank": 166,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Bhutan",
            "Abs_contribution": 1.58965467248899e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 9.5366217248908e-07,
            "Land_abs": 6.35992499999961e-07,
            "Fossil_fraction": 59.9917824288145,
            "Land_fraction": 40.0082175711886,
            "Rank": 167,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Cura\xe7ao",
            "Abs_contribution": 1.57494751637499e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.57494751637499e-06,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 168,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Maldives",
            "Abs_contribution": 1.5409130420306e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.5408140420306e-06,
            "Land_abs": 9.89999999999998e-11,
            "Fossil_fraction": 99.993575237713,
            "Land_fraction": 0.00642476228700995,
            "Rank": 169,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Malta",
            "Abs_contribution": 1.4247210927951e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.4689025927948e-06,
            "Land_abs": -0.0000000441815000000002,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 170,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Guinea-Bissau",
            "Abs_contribution": 1.2744196086242e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 2.91718108624451e-07,
            "Land_abs": 9.82701499999594e-07,
            "Fossil_fraction": 22.8902715126437,
            "Land_fraction": 77.109728487344,
            "Rank": 171,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Fiji",
            "Abs_contribution": 1.05547276255399e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 9.725547625546e-07,
            "Land_abs": 8.29179999997914e-08,
            "Fossil_fraction": 92.143994336836,
            "Land_fraction": 7.85600566320152,
            "Rank": 172,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Barbados",
            "Abs_contribution": 1.0162469246725e-06,
            "Perc_contribution": 0,
            "Fossil_abs": 1.1074589246725e-06,
            "Land_abs": -0.000000091212,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 173,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Macao",
            "Abs_contribution": 9.54892016921399e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 9.54892016921399e-07,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 174,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "French Polynesia",
            "Abs_contribution": 7.90951187227099e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 7.90951187227099e-07,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 175,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Aruba",
            "Abs_contribution": 7.76293026746701e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 7.76293026746701e-07,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 176,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Montenegro",
            "Abs_contribution": 6.91302649563001e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 2.0702681495634e-06,
            "Land_abs": -0.0000013789654999997,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 177,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Faeroe Islands",
            "Abs_contribution": 6.68692671943199e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 6.68692671943199e-07,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 178,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Seychelles",
            "Abs_contribution": 5.9508033569869e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 5.9508033569869e-07,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 179,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Sint Maarten (Dutch part)",
            "Abs_contribution": 5.686420578603e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 5.686420578603e-07,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 180,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Antigua and Barbuda",
            "Abs_contribution": 5.348968979257e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 5.39890897925801e-07,
            "Land_abs": -0.000000004994,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 181,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Greenland",
            "Abs_contribution": 5.21674249454201e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 5.21674249454201e-07,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 182,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Cape Verde",
            "Abs_contribution": 4.71439513100439e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 5.0780551310044e-07,
            "Land_abs": -0.000000036366000000002,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 183,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Djibouti",
            "Abs_contribution": 4.52729737991259e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 4.08839737991269e-07,
            "Land_abs": 4.389e-08,
            "Fossil_fraction": 90.3054744769521,
            "Land_fraction": 9.69452552304998,
            "Rank": 184,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Bermuda",
            "Abs_contribution": 3.993274699782e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 3.993274699782e-07,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 185,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Lucia",
            "Abs_contribution": 3.6671183351528e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 4.2168983351528e-07,
            "Land_abs": -0.0000000549780000000001,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 186,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Comoros",
            "Abs_contribution": 3.5687164301313e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 3.728216430131e-07,
            "Land_abs": -0.0000000159500000000002,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 187,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Andorra",
            "Abs_contribution": 3.2598608679039e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 3.2950058679039e-07,
            "Land_abs": -0.0000000035145,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 188,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Turks and Caicos Islands",
            "Abs_contribution": 3.1307263919214e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 3.1307263919214e-07,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 189,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Grenada",
            "Abs_contribution": 2.7065061681223e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 3.0183561681223e-07,
            "Land_abs": -0.000000031185,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 190,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Palau",
            "Abs_contribution": 1.9859353165939e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 1.9859353165939e-07,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 191,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Vincent and the Grenadines",
            "Abs_contribution": 1.9401976528385e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 2.1403976528384e-07,
            "Land_abs": -0.0000000200200000000001,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 192,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Kitts and Nevis",
            "Abs_contribution": 1.7905777183406e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 2.0126127183406e-07,
            "Land_abs": -0.0000000222035,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 193,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Tonga",
            "Abs_contribution": 1.7688846015285e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 1.7120146015284e-07,
            "Land_abs": 5.68700000000939e-09,
            "Fossil_fraction": 96.784979644746,
            "Land_fraction": 3.21502035525395,
            "Rank": 194,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "British Virgin Islands",
            "Abs_contribution": 1.405634279476e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 1.405634279476e-07,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 195,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Marshall Islands",
            "Abs_contribution": 1.3696125818777e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 1.3696125818777e-07,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 196,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Sao Tome and Principe",
            "Abs_contribution": 1.2608648526201e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 1.2517348526201e-07,
            "Land_abs": 9.13000000000003e-10,
            "Fossil_fraction": 99.2758938453218,
            "Land_fraction": 0.724106154678493,
            "Rank": 197,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Anguilla",
            "Abs_contribution": 1.2458986080786e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 1.2458986080786e-07,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 198,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Liechtenstein",
            "Abs_contribution": 1.1406948362446e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 1.33214983624459e-07,
            "Land_abs": -0.0000000191455,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 199,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Samoa",
            "Abs_contribution": 1.102935534934e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 2.2598605349345e-07,
            "Land_abs": -0.000000115692500000001,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 200,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Bonaire, Saint Eustatius and Saba",
            "Abs_contribution": 9.90333242358102e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 9.90333242358102e-08,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 201,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Dominica",
            "Abs_contribution": 9.80378542576802e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 1.3736835425764e-07,
            "Land_abs": -0.0000000393304999999999,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 202,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Micronesia (Federated States of)",
            "Abs_contribution": 7.02407581877703e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 1.3696125818777e-07,
            "Land_abs": -0.0000000667205000000002,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 203,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Occupied Palestinian Territory",
            "Abs_contribution": 6.36900000000003e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 6.36900000000003e-08,
            "Fossil_fraction": 0,
            "Land_fraction": 100,
            "Rank": 204,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Kiribati",
            "Abs_contribution": 6.16327237991271e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 6.16327237991271e-08,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 205,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Pierre and Miquelon",
            "Abs_contribution": 5.43085971615701e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 5.43085971615701e-08,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 206,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Nauru",
            "Abs_contribution": 4.79364628821e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 4.79364628821e-08,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 207,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Cook Islands",
            "Abs_contribution": 4.60237237991299e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 6.16327237991298e-08,
            "Land_abs": -0.000000015609,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 208,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Wallis and Futuna Islands",
            "Abs_contribution": 2.3968231441048e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 2.3968231441048e-08,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 209,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Montserrat",
            "Abs_contribution": 1.9167740174672e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 1.9167740174672e-08,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 210,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Helena",
            "Abs_contribution": 1.5973116812227e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 1.5973116812227e-08,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 211,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Tuvalu",
            "Abs_contribution": 1.0271970524017e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 1.0271970524017e-08,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 212,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Niue",
            "Abs_contribution": 5.08263045851498e-09,
            "Perc_contribution": 0,
            "Fossil_abs": 6.84813045851501e-09,
            "Land_abs": -0.00000000176549999999998,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 213,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Antarctica",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 214,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Christmas Island",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 215,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Kuwaiti Oil Fires",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 216,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Leeward Islands",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 217,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Pacific Islands (Palau)",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 218,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Panama Canal Zone",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 219,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Ryukyu Islands",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 220,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "St. Kitts-Nevis-Anguilla",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 221,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Swaziland",
            "Abs_contribution": -0.0000000616440000001016,
            "Perc_contribution": -0,
            "Fossil_abs": 0,
            "Land_abs": -0.0000000616440000001016,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 222,
            "Perc_contribution_rescale": -0
        },
        {
            "Country": "Vanuatu",
            "Abs_contribution": -0.000000136656488537204,
            "Perc_contribution": -0,
            "Fossil_abs": 1.8832201146288e-07,
            "Land_abs": -0.000000324978500000202,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 223,
            "Perc_contribution_rescale": -0
        }
    ],
    "2020_N2O": [
        {
            "Country": "China",
            "Abs_contribution": 0.000382893552252999,
            "Perc_contribution": 14.38,
            "Fossil_abs": 0.00013735408955281,
            "Land_abs": 0.00024553946270019,
            "Fossil_fraction": 35.8726567069618,
            "Land_fraction": 64.1273432930384,
            "Rank": 1,
            "Perc_contribution_rescale": 100
        },
        {
            "Country": "India",
            "Abs_contribution": 0.000255912951234991,
            "Perc_contribution": 9.61,
            "Fossil_abs": 5.75950791627999e-05,
            "Land_abs": 0.00019831787207219,
            "Fossil_fraction": 22.5057305169028,
            "Land_fraction": 77.4942694830967,
            "Rank": 2,
            "Perc_contribution_rescale": 66.8289290681502
        },
        {
            "Country": "United States",
            "Abs_contribution": 0.0002265966940137,
            "Perc_contribution": 8.51,
            "Fossil_abs": 8.02678529218002e-05,
            "Land_abs": 0.00014632884109184,
            "Fossil_fraction": 35.4232233048146,
            "Land_fraction": 64.576776695159,
            "Rank": 3,
            "Perc_contribution_rescale": 59.1794158553547
        },
        {
            "Country": "EU27",
            "Abs_contribution": 0.0002187878329938,
            "Perc_contribution": 8.22,
            "Fossil_abs": 7.33685600174602e-05,
            "Land_abs": 0.00014541927297635,
            "Fossil_fraction": 33.5341133981336,
            "Land_fraction": 66.4658866018707,
            "Rank": 4,
            "Perc_contribution_rescale": 57.1627260083449
        },
        {
            "Country": "Brazil",
            "Abs_contribution": 0.00017322772962036,
            "Perc_contribution": 6.51,
            "Fossil_abs": 1.8934435853302e-05,
            "Land_abs": 0.00015429329376706,
            "Fossil_fraction": 10.9303723455812,
            "Land_fraction": 89.0696276544199,
            "Rank": 5,
            "Perc_contribution_rescale": 45.2712100139082
        },
        {
            "Country": "Mexico",
            "Abs_contribution": 0.0001045797889053,
            "Perc_contribution": 3.93,
            "Fossil_abs": 7.3175588976665e-05,
            "Land_abs": 3.14041999286299e-05,
            "Fossil_fraction": 69.9710620404174,
            "Land_fraction": 30.0289379595777,
            "Rank": 6,
            "Perc_contribution_rescale": 27.3296244784423
        },
        {
            "Country": "Russia",
            "Abs_contribution": 7.44652627332199e-05,
            "Perc_contribution": 2.8,
            "Fossil_abs": 3.032544348349e-05,
            "Land_abs": 4.41398192497196e-05,
            "Fossil_fraction": 40.7242818603009,
            "Land_fraction": 59.2757181396854,
            "Rank": 7,
            "Perc_contribution_rescale": 19.471488178025
        },
        {
            "Country": "Indonesia",
            "Abs_contribution": 6.717245756291e-05,
            "Perc_contribution": 2.52,
            "Fossil_abs": 1.2139724622135e-05,
            "Land_abs": 5.50327329407699e-05,
            "Fossil_fraction": 18.0724735443327,
            "Land_fraction": 81.9275264556598,
            "Rank": 8,
            "Perc_contribution_rescale": 17.5243393602225
        },
        {
            "Country": "Pakistan",
            "Abs_contribution": 6.487268041621e-05,
            "Perc_contribution": 2.44,
            "Fossil_abs": 1.1462464933133e-05,
            "Land_abs": 5.3410215483079e-05,
            "Fossil_fraction": 17.6691711512337,
            "Land_fraction": 82.3308288487694,
            "Rank": 9,
            "Perc_contribution_rescale": 16.9680111265647
        },
        {
            "Country": "Australia",
            "Abs_contribution": 5.469672600859e-05,
            "Perc_contribution": 2.05,
            "Fossil_abs": 9.84620877961199e-06,
            "Land_abs": 4.48505172289801e-05,
            "Fossil_fraction": 18.0014591331585,
            "Land_fraction": 81.9985408668453,
            "Rank": 10,
            "Perc_contribution_rescale": 14.2559109874826
        },
        {
            "Country": "T\xfcrkiye",
            "Abs_contribution": 5.32691818501631e-05,
            "Perc_contribution": 2,
            "Fossil_abs": 2.6880084945688e-05,
            "Land_abs": 2.6389096904476e-05,
            "Fossil_fraction": 50.4608556243589,
            "Land_fraction": 49.5391443756428,
            "Rank": 11,
            "Perc_contribution_rescale": 13.9082058414465
        },
        {
            "Country": "Ethiopia",
            "Abs_contribution": 4.57208090039571e-05,
            "Perc_contribution": 1.72,
            "Fossil_abs": 5.05439200095531e-06,
            "Land_abs": 4.06664170030021e-05,
            "Fossil_fraction": 11.0549050007358,
            "Land_fraction": 88.9450949992649,
            "Rank": 12,
            "Perc_contribution_rescale": 11.9610570236439
        },
        {
            "Country": "Argentina",
            "Abs_contribution": 4.38239879042e-05,
            "Perc_contribution": 1.65,
            "Fossil_abs": 3.98138420264749e-06,
            "Land_abs": 3.98426037015601e-05,
            "Fossil_fraction": 9.08494272897043,
            "Land_fraction": 90.9150572710469,
            "Rank": 13,
            "Perc_contribution_rescale": 11.4742698191933
        },
        {
            "Country": "Canada",
            "Abs_contribution": 3.93805125687801e-05,
            "Perc_contribution": 1.48,
            "Fossil_abs": 7.61472693422503e-06,
            "Land_abs": 3.176578563455e-05,
            "Fossil_fraction": 19.3362819260555,
            "Land_fraction": 80.6637180739319,
            "Rank": 14,
            "Perc_contribution_rescale": 10.2920723226704
        },
        {
            "Country": "Nigeria",
            "Abs_contribution": 3.68327346668939e-05,
            "Perc_contribution": 1.38,
            "Fossil_abs": 1.0596565783297e-05,
            "Land_abs": 2.62361688835971e-05,
            "Fossil_fraction": 28.7694244783334,
            "Land_fraction": 71.2305755216669,
            "Rank": 15,
            "Perc_contribution_rescale": 9.59666203059805
        },
        {
            "Country": "France",
            "Abs_contribution": 3.15769036867901e-05,
            "Perc_contribution": 1.19,
            "Fossil_abs": 7.11394356491901e-06,
            "Land_abs": 2.44629601218701e-05,
            "Fossil_fraction": 22.5289459520221,
            "Land_fraction": 77.4710540479748,
            "Rank": 16,
            "Perc_contribution_rescale": 8.27538247566064
        },
        {
            "Country": "Germany",
            "Abs_contribution": 3.10595024095202e-05,
            "Perc_contribution": 1.17,
            "Fossil_abs": 1.031730559303e-05,
            "Land_abs": 2.07421968165e-05,
            "Fossil_fraction": 33.2178714809918,
            "Land_fraction": 66.7821285190396,
            "Rank": 17,
            "Perc_contribution_rescale": 8.13630041724617
        },
        {
            "Country": "Iran",
            "Abs_contribution": 2.8012514278657e-05,
            "Perc_contribution": 1.05,
            "Fossil_abs": 1.3116571180595e-05,
            "Land_abs": 1.4895943098062e-05,
            "Fossil_fraction": 46.823969637701,
            "Land_fraction": 53.1760303622991,
            "Rank": 18,
            "Perc_contribution_rescale": 7.30180806675939
        },
        {
            "Country": "Bangladesh",
            "Abs_contribution": 2.6961253232669e-05,
            "Perc_contribution": 1.01,
            "Fossil_abs": 4.71323427629639e-06,
            "Land_abs": 2.22480189563729e-05,
            "Fossil_fraction": 17.4815103571868,
            "Land_fraction": 82.5184896428143,
            "Rank": 19,
            "Perc_contribution_rescale": 7.02364394993046
        },
        {
            "Country": "United Kingdom",
            "Abs_contribution": 2.62206858942398e-05,
            "Perc_contribution": 0.98,
            "Fossil_abs": 5.76640371075302e-06,
            "Land_abs": 2.0454282183488e-05,
            "Fossil_fraction": 21.9918110991131,
            "Land_fraction": 78.0081889008914,
            "Rank": 20,
            "Perc_contribution_rescale": 6.81502086230876
        },
        {
            "Country": "Belarus",
            "Abs_contribution": 2.6126977787391e-05,
            "Perc_contribution": 0.98,
            "Fossil_abs": 1.4082544239956e-05,
            "Land_abs": 1.2044433547434e-05,
            "Fossil_fraction": 53.9003950420637,
            "Land_fraction": 46.0996049579323,
            "Rank": 21,
            "Perc_contribution_rescale": 6.81502086230876
        },
        {
            "Country": "Poland",
            "Abs_contribution": 2.46511872867099e-05,
            "Perc_contribution": 0.93,
            "Fossil_abs": 9.25898130908802e-06,
            "Land_abs": 1.5392205977621e-05,
            "Fossil_fraction": 37.559981194414,
            "Land_fraction": 62.4400188055822,
            "Rank": 22,
            "Perc_contribution_rescale": 6.4673157162726
        },
        {
            "Country": "Chad",
            "Abs_contribution": 2.4523048768559e-05,
            "Perc_contribution": 0.92,
            "Fossil_abs": 4.0533615393013e-07,
            "Land_abs": 2.4117712614629e-05,
            "Fossil_fraction": 1.65287830952655,
            "Land_fraction": 98.3471216904739,
            "Rank": 23,
            "Perc_contribution_rescale": 6.39777468706537
        },
        {
            "Country": "Sudan",
            "Abs_contribution": 2.44647379914711e-05,
            "Perc_contribution": 0.92,
            "Fossil_abs": 1.2418296720524e-06,
            "Land_abs": 2.3222908319418e-05,
            "Fossil_fraction": 5.07599824893006,
            "Land_fraction": 94.9240017510671,
            "Rank": 24,
            "Perc_contribution_rescale": 6.39777468706537
        },
        {
            "Country": "Ukraine",
            "Abs_contribution": 2.37867148487299e-05,
            "Perc_contribution": 0.89,
            "Fossil_abs": 4.12460013303798e-06,
            "Land_abs": 1.966211471569e-05,
            "Fossil_fraction": 17.3399318033957,
            "Land_fraction": 82.660068196596,
            "Rank": 25,
            "Perc_contribution_rescale": 6.18915159944367
        },
        {
            "Country": "Viet Nam",
            "Abs_contribution": 2.2822370982437e-05,
            "Perc_contribution": 0.86,
            "Fossil_abs": 5.1918360489629e-06,
            "Land_abs": 1.7630534933474e-05,
            "Fossil_fraction": 22.7488899070053,
            "Land_fraction": 77.2511100929943,
            "Rank": 26,
            "Perc_contribution_rescale": 5.98052851182197
        },
        {
            "Country": "Thailand",
            "Abs_contribution": 2.1834632852784e-05,
            "Perc_contribution": 0.82,
            "Fossil_abs": 8.054639305595e-06,
            "Land_abs": 1.3779993547189e-05,
            "Fossil_fraction": 36.8892820864079,
            "Land_fraction": 63.110717913592,
            "Rank": 27,
            "Perc_contribution_rescale": 5.70236439499305
        },
        {
            "Country": "Tanzania",
            "Abs_contribution": 2.1723651635822e-05,
            "Perc_contribution": 0.82,
            "Fossil_abs": 2.2512605836245e-06,
            "Land_abs": 1.9472391052197e-05,
            "Fossil_fraction": 10.3631775235808,
            "Land_fraction": 89.6368224764168,
            "Rank": 28,
            "Perc_contribution_rescale": 5.70236439499305
        },
        {
            "Country": "Egypt",
            "Abs_contribution": 1.9463668746902e-05,
            "Perc_contribution": 0.73,
            "Fossil_abs": 8.58739773266899e-06,
            "Land_abs": 1.0876271014233e-05,
            "Fossil_fraction": 44.1201391389064,
            "Land_fraction": 55.8798608610938,
            "Rank": 29,
            "Perc_contribution_rescale": 5.07649513212796
        },
        {
            "Country": "Spain",
            "Abs_contribution": 1.91432040608761e-05,
            "Perc_contribution": 0.72,
            "Fossil_abs": 5.315384132464e-06,
            "Land_abs": 1.3827819928411e-05,
            "Fossil_fraction": 27.7664288358463,
            "Land_fraction": 72.233571164148,
            "Rank": 30,
            "Perc_contribution_rescale": 5.00695410292072
        },
        {
            "Country": "Colombia",
            "Abs_contribution": 1.9095100574223e-05,
            "Perc_contribution": 0.72,
            "Fossil_abs": 2.2542919006687e-06,
            "Land_abs": 1.6840808673554e-05,
            "Fossil_fraction": 11.8056037039775,
            "Land_fraction": 88.1943962960207,
            "Rank": 31,
            "Perc_contribution_rescale": 5.00695410292072
        },
        {
            "Country": "South Africa",
            "Abs_contribution": 1.9020466762786e-05,
            "Perc_contribution": 0.71,
            "Fossil_abs": 5.65459228395201e-06,
            "Land_abs": 1.33658744788349e-05,
            "Fossil_fraction": 29.7289880131404,
            "Land_fraction": 70.2710119868645,
            "Rank": 32,
            "Perc_contribution_rescale": 4.93741307371349
        },
        {
            "Country": "Kenya",
            "Abs_contribution": 1.8295653372175e-05,
            "Perc_contribution": 0.69,
            "Fossil_abs": 1.8694597045578e-06,
            "Land_abs": 1.6426193667617e-05,
            "Fossil_fraction": 10.2180537996034,
            "Land_fraction": 89.7819462003955,
            "Rank": 33,
            "Perc_contribution_rescale": 4.79833101529903
        },
        {
            "Country": "South Sudan",
            "Abs_contribution": 1.8153044885413e-05,
            "Perc_contribution": 0.68,
            "Fossil_abs": 3.6462304699782e-07,
            "Land_abs": 1.77884218384141e-05,
            "Fossil_fraction": 2.00860543946991,
            "Land_fraction": 97.9913945605238,
            "Rank": 34,
            "Perc_contribution_rescale": 4.72878998609179
        },
        {
            "Country": "Japan",
            "Abs_contribution": 1.73488914397919e-05,
            "Perc_contribution": 0.65,
            "Fossil_abs": 1.0980247512404e-05,
            "Land_abs": 6.368643927388e-06,
            "Fossil_fraction": 63.2907730762518,
            "Land_fraction": 36.7092269237486,
            "Rank": 35,
            "Perc_contribution_rescale": 4.5201668984701
        },
        {
            "Country": "Angola",
            "Abs_contribution": 1.5356947323512e-05,
            "Perc_contribution": 0.58,
            "Fossil_abs": 1.1813192630322e-06,
            "Land_abs": 1.417562806048e-05,
            "Fossil_fraction": 7.6924094232163,
            "Land_fraction": 92.3075905767848,
            "Rank": 36,
            "Perc_contribution_rescale": 4.03337969401947
        },
        {
            "Country": "Uzbekistan",
            "Abs_contribution": 1.4418804796138e-05,
            "Perc_contribution": 0.54,
            "Fossil_abs": 1.11633619531931e-06,
            "Land_abs": 1.3302468600819e-05,
            "Fossil_fraction": 7.74222420722633,
            "Land_fraction": 92.2577757927759,
            "Rank": 37,
            "Perc_contribution_rescale": 3.75521557719054
        },
        {
            "Country": "Italy",
            "Abs_contribution": 1.42971034000081e-05,
            "Perc_contribution": 0.54,
            "Fossil_abs": 4.79486056139398e-06,
            "Land_abs": 9.50224283861504e-06,
            "Fossil_fraction": 33.5372867303405,
            "Land_fraction": 66.4627132696659,
            "Rank": 38,
            "Perc_contribution_rescale": 3.75521557719054
        },
        {
            "Country": "Democratic Republic of the Congo",
            "Abs_contribution": 1.3691209409607e-05,
            "Perc_contribution": 0.51,
            "Fossil_abs": 2.05865460564961e-06,
            "Land_abs": 1.1632554803958e-05,
            "Fossil_fraction": 15.0363239949063,
            "Land_fraction": 84.9636760050983,
            "Rank": 39,
            "Perc_contribution_rescale": 3.54659248956885
        },
        {
            "Country": "Mali",
            "Abs_contribution": 1.3370227394542e-05,
            "Perc_contribution": 0.5,
            "Fossil_abs": 5.05561893627191e-07,
            "Land_abs": 1.2864665500914e-05,
            "Fossil_fraction": 3.78125127350916,
            "Land_fraction": 96.2187487264847,
            "Rank": 40,
            "Perc_contribution_rescale": 3.47705146036161
        },
        {
            "Country": "Myanmar",
            "Abs_contribution": 1.2741172863087e-05,
            "Perc_contribution": 0.48,
            "Fossil_abs": 2.1780186921943e-06,
            "Land_abs": 1.0563154170893e-05,
            "Fossil_fraction": 17.0943343724998,
            "Land_fraction": 82.9056656275027,
            "Rank": 41,
            "Perc_contribution_rescale": 3.33796940194715
        },
        {
            "Country": "South Korea",
            "Abs_contribution": 1.2460244753835e-05,
            "Perc_contribution": 0.47,
            "Fossil_abs": 8.21409651562499e-06,
            "Land_abs": 4.24614823820899e-06,
            "Fossil_fraction": 65.9224331295489,
            "Land_fraction": 34.0775668704431,
            "Rank": 42,
            "Perc_contribution_rescale": 3.26842837273992
        },
        {
            "Country": "Philippines",
            "Abs_contribution": 1.244463009637e-05,
            "Perc_contribution": 0.47,
            "Fossil_abs": 3.0802618052538e-06,
            "Land_abs": 9.36436829111699e-06,
            "Fossil_fraction": 24.7517345344986,
            "Land_fraction": 75.2482654655082,
            "Rank": 43,
            "Perc_contribution_rescale": 3.26842837273992
        },
        {
            "Country": "New Zealand",
            "Abs_contribution": 1.2238126415224e-05,
            "Perc_contribution": 0.46,
            "Fossil_abs": 5.534096958583e-07,
            "Land_abs": 1.1684716719366e-05,
            "Fossil_fraction": 4.52201323210608,
            "Land_fraction": 95.4779867678964,
            "Rank": 44,
            "Perc_contribution_rescale": 3.19888734353268
        },
        {
            "Country": "Mongolia",
            "Abs_contribution": 1.2227679656332e-05,
            "Perc_contribution": 0.46,
            "Fossil_abs": 3.3582313775928e-07,
            "Land_abs": 1.1891856518573e-05,
            "Fossil_fraction": 2.74641753135377,
            "Land_fraction": 97.2535824686487,
            "Rank": 45,
            "Perc_contribution_rescale": 3.19888734353268
        },
        {
            "Country": "Kazakhstan",
            "Abs_contribution": 1.137962442429e-05,
            "Perc_contribution": 0.43,
            "Fossil_abs": 2.49475942053771e-06,
            "Land_abs": 8.88486500375197e-06,
            "Fossil_fraction": 21.9230382965241,
            "Land_fraction": 78.076961703473,
            "Rank": 46,
            "Perc_contribution_rescale": 2.99026425591099
        },
        {
            "Country": "Niger",
            "Abs_contribution": 1.1318164677142e-05,
            "Perc_contribution": 0.43,
            "Fossil_abs": 5.26033395442141e-07,
            "Land_abs": 1.07921312817e-05,
            "Fossil_fraction": 4.64769165715101,
            "Land_fraction": 95.3523083428503,
            "Rank": 47,
            "Perc_contribution_rescale": 2.99026425591099
        },
        {
            "Country": "Zambia",
            "Abs_contribution": 1.0973840525027e-05,
            "Perc_contribution": 0.41,
            "Fossil_abs": 1.1311524842522e-06,
            "Land_abs": 9.84268804077597e-06,
            "Fossil_fraction": 10.307717536741,
            "Land_fraction": 89.6922824632699,
            "Rank": 48,
            "Perc_contribution_rescale": 2.85118219749652
        },
        {
            "Country": "Netherlands",
            "Abs_contribution": 1.076288325831e-05,
            "Perc_contribution": 0.4,
            "Fossil_abs": 5.12265964089798e-06,
            "Land_abs": 5.64022361741203e-06,
            "Fossil_fraction": 47.5956072174506,
            "Land_fraction": 52.4043927825494,
            "Rank": 49,
            "Perc_contribution_rescale": 2.78164116828929
        },
        {
            "Country": "Uganda",
            "Abs_contribution": 1.0625224312214e-05,
            "Perc_contribution": 0.4,
            "Fossil_abs": 1.3849580695825e-06,
            "Land_abs": 9.24026624263098e-06,
            "Fossil_fraction": 13.0346242948532,
            "Land_fraction": 86.9653757051418,
            "Rank": 50,
            "Perc_contribution_rescale": 2.78164116828929
        },
        {
            "Country": "Venezuela",
            "Abs_contribution": 1.0384158815052e-05,
            "Perc_contribution": 0.39,
            "Fossil_abs": 1.5973607349481e-06,
            "Land_abs": 8.78679808010303e-06,
            "Fossil_fraction": 15.382668576223,
            "Land_fraction": 84.6173314237687,
            "Rank": 51,
            "Perc_contribution_rescale": 2.71210013908206
        },
        {
            "Country": "Saudi Arabia",
            "Abs_contribution": 1.0161698722393e-05,
            "Perc_contribution": 0.38,
            "Fossil_abs": 6.862788069146e-06,
            "Land_abs": 3.2989106532478e-06,
            "Fossil_fraction": 67.535834870037,
            "Land_fraction": 32.4641651299709,
            "Rank": 52,
            "Perc_contribution_rescale": 2.64255910987483
        },
        {
            "Country": "Romania",
            "Abs_contribution": 9.88007625135102e-06,
            "Perc_contribution": 0.37,
            "Fossil_abs": 3.125279881523e-06,
            "Land_abs": 6.75479636982803e-06,
            "Fossil_fraction": 31.6321433358942,
            "Land_fraction": 68.3678566641058,
            "Rank": 53,
            "Perc_contribution_rescale": 2.57301808066759
        },
        {
            "Country": "Sweden",
            "Abs_contribution": 9.15197669029797e-06,
            "Perc_contribution": 0.34,
            "Fossil_abs": 5.192876976952e-06,
            "Land_abs": 3.959099713346e-06,
            "Fossil_fraction": 56.7404960991321,
            "Land_fraction": 43.2595039008682,
            "Rank": 54,
            "Perc_contribution_rescale": 2.3643949930459
        },
        {
            "Country": "Burkina Faso",
            "Abs_contribution": 8.86073187453601e-06,
            "Perc_contribution": 0.33,
            "Fossil_abs": 7.099849306769e-07,
            "Land_abs": 8.15074694385901e-06,
            "Fossil_fraction": 8.01271205053903,
            "Land_fraction": 91.9872879494599,
            "Rank": 55,
            "Perc_contribution_rescale": 2.29485396383866
        },
        {
            "Country": "Peru",
            "Abs_contribution": 8.69541377399e-06,
            "Perc_contribution": 0.33,
            "Fossil_abs": 1.4951548101665e-06,
            "Land_abs": 7.200258963824e-06,
            "Fossil_fraction": 17.194751728076,
            "Land_fraction": 82.8052482719298,
            "Rank": 56,
            "Perc_contribution_rescale": 2.29485396383866
        },
        {
            "Country": "Paraguay",
            "Abs_contribution": 8.606852279681e-06,
            "Perc_contribution": 0.32,
            "Fossil_abs": 4.5059469968613e-07,
            "Land_abs": 8.15625757999498e-06,
            "Fossil_fraction": 5.23530188556729,
            "Land_fraction": 94.764698114434,
            "Rank": 57,
            "Perc_contribution_rescale": 2.22531293463143
        },
        {
            "Country": "Bolivia",
            "Abs_contribution": 8.46462588860501e-06,
            "Perc_contribution": 0.32,
            "Fossil_abs": 5.7644777419487e-07,
            "Land_abs": 7.88817811441e-06,
            "Fossil_fraction": 6.81007975758123,
            "Land_fraction": 93.189920242417,
            "Rank": 58,
            "Perc_contribution_rescale": 2.22531293463143
        },
        {
            "Country": "Mozambique",
            "Abs_contribution": 8.43079443811401e-06,
            "Perc_contribution": 0.32,
            "Fossil_abs": 9.558868642467e-07,
            "Land_abs": 7.47490757386701e-06,
            "Fossil_fraction": 11.3380402198554,
            "Land_fraction": 88.6619597801411,
            "Rank": 59,
            "Perc_contribution_rescale": 2.22531293463143
        },
        {
            "Country": "Malaysia",
            "Abs_contribution": 8.36945898271001e-06,
            "Perc_contribution": 0.31,
            "Fossil_abs": 3.0823988610262e-06,
            "Land_abs": 5.28706012168398e-06,
            "Fossil_fraction": 36.8291291873699,
            "Land_fraction": 63.1708708126322,
            "Rank": 60,
            "Perc_contribution_rescale": 2.1557719054242
        },
        {
            "Country": "Ireland",
            "Abs_contribution": 8.18392767605098e-06,
            "Perc_contribution": 0.31,
            "Fossil_abs": 4.40093461121799e-07,
            "Land_abs": 7.74383421492999e-06,
            "Fossil_fraction": 5.37753360662834,
            "Land_fraction": 94.6224663933815,
            "Rank": 61,
            "Perc_contribution_rescale": 2.1557719054242
        },
        {
            "Country": "Morocco",
            "Abs_contribution": 8.16056353284699e-06,
            "Perc_contribution": 0.31,
            "Fossil_abs": 1.6173980147653e-06,
            "Land_abs": 6.54316551808198e-06,
            "Fossil_fraction": 19.8196853471593,
            "Land_fraction": 80.1803146528443,
            "Rank": 62,
            "Perc_contribution_rescale": 2.1557719054242
        },
        {
            "Country": "Belgium",
            "Abs_contribution": 8.01281998984702e-06,
            "Perc_contribution": 0.3,
            "Fossil_abs": 5.376310814329e-06,
            "Land_abs": 2.636509175518e-06,
            "Fossil_fraction": 67.0963633420104,
            "Land_fraction": 32.9036366579893,
            "Rank": 63,
            "Perc_contribution_rescale": 2.08623087621697
        },
        {
            "Country": "Algeria",
            "Abs_contribution": 7.22383628396501e-06,
            "Perc_contribution": 0.27,
            "Fossil_abs": 2.706946327238e-06,
            "Land_abs": 4.51688995672799e-06,
            "Fossil_fraction": 37.4724207585753,
            "Land_fraction": 62.5275792414383,
            "Rank": 64,
            "Perc_contribution_rescale": 1.87760778859527
        },
        {
            "Country": "Iraq",
            "Abs_contribution": 7.116432357969e-06,
            "Perc_contribution": 0.27,
            "Fossil_abs": 4.0487624988947e-06,
            "Land_abs": 3.06766985907499e-06,
            "Fossil_fraction": 56.8931494776436,
            "Land_fraction": 43.1068505223661,
            "Rank": 65,
            "Perc_contribution_rescale": 1.87760778859527
        },
        {
            "Country": "Uruguay",
            "Abs_contribution": 7.05945412115102e-06,
            "Perc_contribution": 0.27,
            "Fossil_abs": 3.5905487521834e-07,
            "Land_abs": 6.700399245934e-06,
            "Fossil_fraction": 5.08615636643301,
            "Land_fraction": 94.9138436335858,
            "Rank": 66,
            "Perc_contribution_rescale": 1.87760778859527
        },
        {
            "Country": "Central African Republic",
            "Abs_contribution": 6.998644723485e-06,
            "Perc_contribution": 0.26,
            "Fossil_abs": 1.0090928281933e-07,
            "Land_abs": 6.89773544066598e-06,
            "Fossil_fraction": 1.4418403391833,
            "Land_fraction": 98.5581596608212,
            "Rank": 67,
            "Perc_contribution_rescale": 1.80806675938804
        },
        {
            "Country": "Hungary",
            "Abs_contribution": 6.87237574495099e-06,
            "Perc_contribution": 0.26,
            "Fossil_abs": 2.10860267521902e-06,
            "Land_abs": 4.76377306973301e-06,
            "Fossil_fraction": 30.6822961007068,
            "Land_fraction": 69.3177038993082,
            "Rank": 68,
            "Perc_contribution_rescale": 1.80806675938804
        },
        {
            "Country": "Chile",
            "Abs_contribution": 6.49832422868401e-06,
            "Perc_contribution": 0.24,
            "Fossil_abs": 2.3165607120769e-06,
            "Land_abs": 4.181763516607e-06,
            "Fossil_fraction": 35.6485861670529,
            "Land_fraction": 64.3514138329453,
            "Rank": 69,
            "Perc_contribution_rescale": 1.66898470097357
        },
        {
            "Country": "Finland",
            "Abs_contribution": 6.46839094102096e-06,
            "Perc_contribution": 0.24,
            "Fossil_abs": 2.552323709525e-06,
            "Land_abs": 3.916067231496e-06,
            "Fossil_fraction": 39.458402140458,
            "Land_fraction": 60.5415978595427,
            "Rank": 70,
            "Perc_contribution_rescale": 1.66898470097357
        },
        {
            "Country": "Nepal",
            "Abs_contribution": 6.428773961872e-06,
            "Perc_contribution": 0.24,
            "Fossil_abs": 1.3881532648608e-06,
            "Land_abs": 5.04062069701101e-06,
            "Fossil_fraction": 21.5928149456445,
            "Land_fraction": 78.4071850543526,
            "Rank": 71,
            "Perc_contribution_rescale": 1.66898470097357
        },
        {
            "Country": "Madagascar",
            "Abs_contribution": 6.04812686917302e-06,
            "Perc_contribution": 0.23,
            "Fossil_abs": 6.415584530159e-07,
            "Land_abs": 5.40656841615801e-06,
            "Fossil_fraction": 10.6075561391724,
            "Land_fraction": 89.3924438608422,
            "Rank": 72,
            "Perc_contribution_rescale": 1.59944367176634
        },
        {
            "Country": "Guinea",
            "Abs_contribution": 5.973488017222e-06,
            "Perc_contribution": 0.22,
            "Fossil_abs": 5.050066992494e-07,
            "Land_abs": 5.46848131797199e-06,
            "Fossil_fraction": 8.45413429797514,
            "Land_fraction": 91.5458657020147,
            "Rank": 73,
            "Perc_contribution_rescale": 1.52990264255911
        },
        {
            "Country": "Botswana",
            "Abs_contribution": 5.813050119514e-06,
            "Perc_contribution": 0.22,
            "Fossil_abs": 1.6738692494541e-07,
            "Land_abs": 5.64566319456901e-06,
            "Fossil_fraction": 2.87950252456114,
            "Land_fraction": 97.120497475446,
            "Rank": 74,
            "Perc_contribution_rescale": 1.52990264255911
        },
        {
            "Country": "Turkmenistan",
            "Abs_contribution": 5.722241292781e-06,
            "Perc_contribution": 0.21,
            "Fossil_abs": 1.12259663891921e-06,
            "Land_abs": 4.59964465386191e-06,
            "Fossil_fraction": 19.6181283081411,
            "Land_fraction": 80.381871691861,
            "Rank": 75,
            "Perc_contribution_rescale": 1.46036161335188
        },
        {
            "Country": "Taiwan",
            "Abs_contribution": 5.71844480084599e-06,
            "Perc_contribution": 0.21,
            "Fossil_abs": 4.2725923455827e-06,
            "Land_abs": 1.4458524552634e-06,
            "Fossil_fraction": 74.7159847542921,
            "Land_fraction": 25.2840152457098,
            "Rank": 76,
            "Perc_contribution_rescale": 1.46036161335188
        },
        {
            "Country": "Malawi",
            "Abs_contribution": 5.6776807969978e-06,
            "Perc_contribution": 0.21,
            "Fossil_abs": 5.4003754662937e-07,
            "Land_abs": 5.1376432503684e-06,
            "Fossil_fraction": 9.51158696548996,
            "Land_fraction": 90.4884130345094,
            "Rank": 77,
            "Perc_contribution_rescale": 1.46036161335188
        },
        {
            "Country": "Somalia",
            "Abs_contribution": 5.66654027349899e-06,
            "Perc_contribution": 0.21,
            "Fossil_abs": 5.6608017076965e-07,
            "Land_abs": 5.10046010272899e-06,
            "Fossil_fraction": 9.98987289329023,
            "Land_fraction": 90.0101271067036,
            "Rank": 78,
            "Perc_contribution_rescale": 1.46036161335188
        },
        {
            "Country": "Cameroon",
            "Abs_contribution": 5.45824403032201e-06,
            "Perc_contribution": 0.2,
            "Fossil_abs": 7.776285301719e-07,
            "Land_abs": 4.68061550015e-06,
            "Fossil_fraction": 14.2468626512843,
            "Land_fraction": 85.7531373487137,
            "Rank": 79,
            "Perc_contribution_rescale": 1.39082058414465
        },
        {
            "Country": "Lithuania",
            "Abs_contribution": 5.23546171346897e-06,
            "Perc_contribution": 0.2,
            "Fossil_abs": 1.8383903338019e-06,
            "Land_abs": 3.397071379667e-06,
            "Fossil_fraction": 35.1141968830061,
            "Land_fraction": 64.8858031169925,
            "Rank": 80,
            "Perc_contribution_rescale": 1.39082058414465
        },
        {
            "Country": "Czechia",
            "Abs_contribution": 5.134752944829e-06,
            "Perc_contribution": 0.19,
            "Fossil_abs": 2.34026256984099e-06,
            "Land_abs": 2.79449037498601e-06,
            "Fossil_fraction": 45.5769263874277,
            "Land_fraction": 54.4230736125333,
            "Rank": 81,
            "Perc_contribution_rescale": 1.32127955493741
        },
        {
            "Country": "Ghana",
            "Abs_contribution": 5.05695553354201e-06,
            "Perc_contribution": 0.19,
            "Fossil_abs": 8.92264366989601e-07,
            "Land_abs": 4.16469116655199e-06,
            "Fossil_fraction": 17.6442992443052,
            "Land_fraction": 82.3557007556867,
            "Rank": 82,
            "Perc_contribution_rescale": 1.32127955493741
        },
        {
            "Country": "Senegal",
            "Abs_contribution": 4.92374183064901e-06,
            "Perc_contribution": 0.18,
            "Fossil_abs": 4.0169444271288e-07,
            "Land_abs": 4.52204738793599e-06,
            "Fossil_fraction": 8.1583165106756,
            "Land_fraction": 91.8416834893215,
            "Rank": 83,
            "Perc_contribution_rescale": 1.25173852573018
        },
        {
            "Country": "Denmark",
            "Abs_contribution": 4.725621897175e-06,
            "Perc_contribution": 0.18,
            "Fossil_abs": 9.51671271861391e-07,
            "Land_abs": 3.773950625314e-06,
            "Fossil_fraction": 20.1385403354065,
            "Land_fraction": 79.8614596646018,
            "Rank": 84,
            "Perc_contribution_rescale": 1.25173852573018
        },
        {
            "Country": "Ecuador",
            "Abs_contribution": 4.602919636818e-06,
            "Perc_contribution": 0.17,
            "Fossil_abs": 9.64037132464502e-07,
            "Land_abs": 3.6388825043532e-06,
            "Fossil_fraction": 20.9440357105809,
            "Land_fraction": 79.0559642894126,
            "Rank": 85,
            "Perc_contribution_rescale": 1.18219749652295
        },
        {
            "Country": "Zimbabwe",
            "Abs_contribution": 4.47037632253001e-06,
            "Perc_contribution": 0.17,
            "Fossil_abs": 9.76338203998399e-07,
            "Land_abs": 3.494038118531e-06,
            "Fossil_fraction": 21.8401792949243,
            "Land_fraction": 78.159820705062,
            "Rank": 86,
            "Perc_contribution_rescale": 1.18219749652295
        },
        {
            "Country": "Guatemala",
            "Abs_contribution": 4.3596128312636e-06,
            "Perc_contribution": 0.16,
            "Fossil_abs": 9.50056831522899e-07,
            "Land_abs": 3.40955599974069e-06,
            "Fossil_fraction": 21.7922294546402,
            "Land_fraction": 78.2077705453596,
            "Rank": 87,
            "Perc_contribution_rescale": 1.11265646731572
        },
        {
            "Country": "Cambodia",
            "Abs_contribution": 4.22884427030531e-06,
            "Perc_contribution": 0.16,
            "Fossil_abs": 6.74850937131551e-07,
            "Land_abs": 3.5539933331741e-06,
            "Fossil_fraction": 15.9582830200278,
            "Land_fraction": 84.0417169799802,
            "Rank": 88,
            "Perc_contribution_rescale": 1.11265646731572
        },
        {
            "Country": "Yemen",
            "Abs_contribution": 4.2105491648748e-06,
            "Perc_contribution": 0.16,
            "Fossil_abs": 1.5449777274154e-06,
            "Land_abs": 2.66557143745909e-06,
            "Fossil_fraction": 36.6930219056434,
            "Land_fraction": 63.3069780943492,
            "Rank": 89,
            "Perc_contribution_rescale": 1.11265646731572
        },
        {
            "Country": "Afghanistan",
            "Abs_contribution": 3.913673109416e-06,
            "Perc_contribution": 0.15,
            "Fossil_abs": 4.1844383093613e-07,
            "Land_abs": 3.49522927847899e-06,
            "Fossil_fraction": 10.6918441892703,
            "Land_fraction": 89.3081558107073,
            "Rank": 90,
            "Perc_contribution_rescale": 1.04311543810848
        },
        {
            "Country": "Azerbaijan",
            "Abs_contribution": 3.886010881482e-06,
            "Perc_contribution": 0.15,
            "Fossil_abs": 4.881269952511e-07,
            "Land_abs": 3.3978838862309e-06,
            "Fossil_fraction": 12.5611330008665,
            "Land_fraction": 87.4388669991333,
            "Rank": 91,
            "Perc_contribution_rescale": 1.04311543810848
        },
        {
            "Country": "Greece",
            "Abs_contribution": 3.82723563930102e-06,
            "Perc_contribution": 0.14,
            "Fossil_abs": 1.0570175609443e-06,
            "Land_abs": 2.770218078357e-06,
            "Fossil_fraction": 27.6183036677969,
            "Land_fraction": 72.3816963322105,
            "Rank": 92,
            "Perc_contribution_rescale": 0.973574408901252
        },
        {
            "Country": "Norway",
            "Abs_contribution": 3.74789238786799e-06,
            "Perc_contribution": 0.14,
            "Fossil_abs": 1.427801962378e-06,
            "Land_abs": 2.32009042549201e-06,
            "Fossil_fraction": 38.0961301610427,
            "Land_fraction": 61.9038698390112,
            "Rank": 93,
            "Perc_contribution_rescale": 0.973574408901252
        },
        {
            "Country": "Bulgaria",
            "Abs_contribution": 3.684763000587e-06,
            "Perc_contribution": 0.14,
            "Fossil_abs": 5.84474119486896e-07,
            "Land_abs": 3.10028888110002e-06,
            "Fossil_fraction": 15.8619189183615,
            "Land_fraction": 84.1380810816363,
            "Rank": 94,
            "Perc_contribution_rescale": 0.973574408901252
        },
        {
            "Country": "Namibia",
            "Abs_contribution": 3.58919260754701e-06,
            "Perc_contribution": 0.13,
            "Fossil_abs": 2.0070793100437e-07,
            "Land_abs": 3.38848467654199e-06,
            "Fossil_fraction": 5.59200781207284,
            "Land_fraction": 94.4079921879088,
            "Rank": 95,
            "Perc_contribution_rescale": 0.904033379694019
        },
        {
            "Country": "Syria",
            "Abs_contribution": 3.455831377361e-06,
            "Perc_contribution": 0.13,
            "Fossil_abs": 1.3472555644037e-06,
            "Land_abs": 2.1085758129572e-06,
            "Fossil_fraction": 38.9849913751438,
            "Land_fraction": 61.0150086248533,
            "Rank": 96,
            "Perc_contribution_rescale": 0.904033379694019
        },
        {
            "Country": "C\xf4te d'Ivoire",
            "Abs_contribution": 3.3725777920988e-06,
            "Perc_contribution": 0.13,
            "Fossil_abs": 7.94154168668199e-07,
            "Land_abs": 2.57842362343061e-06,
            "Fossil_fraction": 23.5473936443727,
            "Land_fraction": 76.4526063556274,
            "Rank": 97,
            "Perc_contribution_rescale": 0.904033379694019
        },
        {
            "Country": "Austria",
            "Abs_contribution": 3.32086050147402e-06,
            "Perc_contribution": 0.12,
            "Fossil_abs": 1.23418363982661e-06,
            "Land_abs": 2.08667686164701e-06,
            "Fossil_fraction": 37.1645734374809,
            "Land_fraction": 62.8354265625069,
            "Rank": 98,
            "Perc_contribution_rescale": 0.834492350486787
        },
        {
            "Country": "Cuba",
            "Abs_contribution": 3.25881396451901e-06,
            "Perc_contribution": 0.12,
            "Fossil_abs": 8.62206381881799e-07,
            "Land_abs": 2.396607582637e-06,
            "Fossil_fraction": 26.4576742112082,
            "Land_fraction": 73.5423257887853,
            "Rank": 99,
            "Perc_contribution_rescale": 0.834492350486787
        },
        {
            "Country": "Dominican Republic",
            "Abs_contribution": 3.121637678548e-06,
            "Perc_contribution": 0.12,
            "Fossil_abs": 5.14660147639199e-07,
            "Land_abs": 2.6069775309088e-06,
            "Fossil_fraction": 16.4868636477565,
            "Land_fraction": 83.5131363522435,
            "Rank": 100,
            "Perc_contribution_rescale": 0.834492350486787
        },
        {
            "Country": "Nicaragua",
            "Abs_contribution": 3.0971214701283e-06,
            "Perc_contribution": 0.12,
            "Fossil_abs": 2.6582770734171e-07,
            "Land_abs": 2.8312937627866e-06,
            "Fossil_fraction": 8.58305720022981,
            "Land_fraction": 91.4169427997706,
            "Rank": 101,
            "Perc_contribution_rescale": 0.834492350486787
        },
        {
            "Country": "Tunisia",
            "Abs_contribution": 3.0511988056769e-06,
            "Perc_contribution": 0.11,
            "Fossil_abs": 9.048720740011e-07,
            "Land_abs": 2.1463267316757e-06,
            "Fossil_fraction": 29.6562804205856,
            "Land_fraction": 70.3437195794112,
            "Rank": 102,
            "Perc_contribution_rescale": 0.764951321279555
        },
        {
            "Country": "Slovakia",
            "Abs_contribution": 2.92913042091999e-06,
            "Perc_contribution": 0.11,
            "Fossil_abs": 1.7613508685698e-06,
            "Land_abs": 1.1677795523499e-06,
            "Fossil_fraction": 60.1322104331765,
            "Land_fraction": 39.8677895668135,
            "Rank": 103,
            "Perc_contribution_rescale": 0.764951321279555
        },
        {
            "Country": "Serbia",
            "Abs_contribution": 2.890932162569e-06,
            "Perc_contribution": 0.11,
            "Fossil_abs": 8.94368511881799e-07,
            "Land_abs": 1.99656365068599e-06,
            "Fossil_fraction": 30.9370286671489,
            "Land_fraction": 69.0629713328094,
            "Rank": 104,
            "Perc_contribution_rescale": 0.764951321279555
        },
        {
            "Country": "Mauritania",
            "Abs_contribution": 2.84949727835689e-06,
            "Perc_contribution": 0.11,
            "Fossil_abs": 1.9061927710153e-07,
            "Land_abs": 2.6588780012554e-06,
            "Fossil_fraction": 6.6895756858363,
            "Land_fraction": 93.310424314165,
            "Rank": 105,
            "Perc_contribution_rescale": 0.764951321279555
        },
        {
            "Country": "Laos",
            "Abs_contribution": 2.8317592113947e-06,
            "Perc_contribution": 0.11,
            "Fossil_abs": 3.2917445150109e-07,
            "Land_abs": 2.5025847598935e-06,
            "Fossil_fraction": 11.6243800029511,
            "Land_fraction": 88.375619997045,
            "Rank": 106,
            "Perc_contribution_rescale": 0.764951321279555
        },
        {
            "Country": "Portugal",
            "Abs_contribution": 2.81296607841202e-06,
            "Perc_contribution": 0.11,
            "Fossil_abs": 1.0055474891799e-06,
            "Land_abs": 1.8074185892317e-06,
            "Fossil_fraction": 35.7468757585429,
            "Land_fraction": 64.253124241442,
            "Rank": 107,
            "Perc_contribution_rescale": 0.764951321279555
        },
        {
            "Country": "Benin",
            "Abs_contribution": 2.6931476078056e-06,
            "Perc_contribution": 0.1,
            "Fossil_abs": 4.6302022278521e-07,
            "Land_abs": 2.2301273850205e-06,
            "Fossil_fraction": 17.1925304592749,
            "Land_fraction": 82.8074695407294,
            "Rank": 108,
            "Perc_contribution_rescale": 0.695410292072323
        },
        {
            "Country": "Honduras",
            "Abs_contribution": 2.5160999810454e-06,
            "Perc_contribution": 0.09,
            "Fossil_abs": 4.9396206849072e-07,
            "Land_abs": 2.02213791255459e-06,
            "Fossil_fraction": 19.6320524705654,
            "Land_fraction": 80.3679475294311,
            "Rank": 109,
            "Perc_contribution_rescale": 0.62586926286509
        },
        {
            "Country": "United Arab Emirates",
            "Abs_contribution": 2.3872933240816e-06,
            "Perc_contribution": 0.09,
            "Fossil_abs": 1.7284438117999e-06,
            "Land_abs": 6.58849512281661e-07,
            "Fossil_fraction": 72.4018198503042,
            "Land_fraction": 27.5981801496941,
            "Rank": 110,
            "Perc_contribution_rescale": 0.62586926286509
        },
        {
            "Country": "Israel",
            "Abs_contribution": 2.1756248774632e-06,
            "Perc_contribution": 0.08,
            "Fossil_abs": 1.1683984416362e-06,
            "Land_abs": 1.007226435827e-06,
            "Fossil_fraction": 53.7040394113603,
            "Land_fraction": 46.2959605886394,
            "Rank": 111,
            "Perc_contribution_rescale": 0.556328233657858
        },
        {
            "Country": "Tajikistan",
            "Abs_contribution": 2.1533311431182e-06,
            "Perc_contribution": 0.08,
            "Fossil_abs": 1.55488824211251e-07,
            "Land_abs": 1.9978423189069e-06,
            "Fossil_fraction": 7.22085057415229,
            "Land_fraction": 92.7791494258454,
            "Rank": 112,
            "Perc_contribution_rescale": 0.556328233657858
        },
        {
            "Country": "Sri Lanka",
            "Abs_contribution": 2.1319602903398e-06,
            "Perc_contribution": 0.08,
            "Fossil_abs": 8.276704639806e-07,
            "Land_abs": 1.3042898263592e-06,
            "Fossil_fraction": 38.822039403402,
            "Land_fraction": 61.1779605965982,
            "Rank": 113,
            "Perc_contribution_rescale": 0.556328233657858
        },
        {
            "Country": "Croatia",
            "Abs_contribution": 2.114707686522e-06,
            "Perc_contribution": 0.08,
            "Fossil_abs": 1.007220596205e-06,
            "Land_abs": 1.1074870903166e-06,
            "Fossil_fraction": 47.6293060560793,
            "Land_fraction": 52.3706939439015,
            "Rank": 114,
            "Perc_contribution_rescale": 0.556328233657858
        },
        {
            "Country": "Latvia",
            "Abs_contribution": 2.01692534302e-06,
            "Perc_contribution": 0.08,
            "Fossil_abs": 2.22839803321501e-07,
            "Land_abs": 1.7940855396984e-06,
            "Fossil_fraction": 11.0484904209611,
            "Land_fraction": 88.9515095790342,
            "Rank": 115,
            "Perc_contribution_rescale": 0.556328233657858
        },
        {
            "Country": "Switzerland",
            "Abs_contribution": 1.998346222963e-06,
            "Perc_contribution": 0.08,
            "Fossil_abs": 6.077811450409e-07,
            "Land_abs": 1.39056507792159e-06,
            "Fossil_fraction": 30.4142064101249,
            "Land_fraction": 69.5857935898497,
            "Rank": 116,
            "Perc_contribution_rescale": 0.556328233657858
        },
        {
            "Country": "Libya",
            "Abs_contribution": 1.812847913241e-06,
            "Perc_contribution": 0.07,
            "Fossil_abs": 7.54510327258499e-07,
            "Land_abs": 1.0583375859825e-06,
            "Fossil_fraction": 41.6201669068637,
            "Land_fraction": 58.3798330931363,
            "Rank": 117,
            "Perc_contribution_rescale": 0.486787204450626
        },
        {
            "Country": "Kyrgyzstan",
            "Abs_contribution": 1.74041034061001e-06,
            "Perc_contribution": 0.07,
            "Fossil_abs": 1.77164701960971e-07,
            "Land_abs": 1.563245638649e-06,
            "Fossil_fraction": 10.1794788175572,
            "Land_fraction": 89.8205211824406,
            "Rank": 118,
            "Perc_contribution_rescale": 0.486787204450626
        },
        {
            "Country": "North Korea",
            "Abs_contribution": 1.71336121151602e-06,
            "Perc_contribution": 0.06,
            "Fossil_abs": 5.01249867568301e-07,
            "Land_abs": 1.2121113439479e-06,
            "Fossil_fraction": 29.2553528234005,
            "Land_fraction": 70.7446471766098,
            "Rank": 119,
            "Perc_contribution_rescale": 0.417246175243394
        },
        {
            "Country": "Rwanda",
            "Abs_contribution": 1.6837458943436e-06,
            "Perc_contribution": 0.06,
            "Fossil_abs": 2.92982982322601e-07,
            "Land_abs": 1.390762912021e-06,
            "Fossil_fraction": 17.4006649879208,
            "Land_fraction": 82.5993350120792,
            "Rank": 120,
            "Perc_contribution_rescale": 0.417246175243394
        },
        {
            "Country": "Togo",
            "Abs_contribution": 1.5900654734484e-06,
            "Perc_contribution": 0.06,
            "Fossil_abs": 2.7494271799536e-07,
            "Land_abs": 1.3151227554531e-06,
            "Fossil_fraction": 17.2912828173727,
            "Land_fraction": 82.7087171826307,
            "Rank": 121,
            "Perc_contribution_rescale": 0.417246175243394
        },
        {
            "Country": "Estonia",
            "Abs_contribution": 1.57356935270471e-06,
            "Perc_contribution": 0.06,
            "Fossil_abs": 1.6983006296807e-07,
            "Land_abs": 1.40373928973659e-06,
            "Fossil_fraction": 10.7926646306475,
            "Land_fraction": 89.2073353693498,
            "Rank": 122,
            "Perc_contribution_rescale": 0.417246175243394
        },
        {
            "Country": "Haiti",
            "Abs_contribution": 1.5382595680964e-06,
            "Perc_contribution": 0.06,
            "Fossil_abs": 4.1799849521561e-07,
            "Land_abs": 1.1202610728807e-06,
            "Fossil_fraction": 27.1734695421322,
            "Land_fraction": 72.8265304578618,
            "Rank": 123,
            "Perc_contribution_rescale": 0.417246175243394
        },
        {
            "Country": "Georgia",
            "Abs_contribution": 1.51852498969571e-06,
            "Perc_contribution": 0.06,
            "Fossil_abs": 8.58105037090602e-07,
            "Land_abs": 6.60419952605097e-07,
            "Fossil_fraction": 56.5091152871018,
            "Land_fraction": 43.4908847128973,
            "Rank": 124,
            "Perc_contribution_rescale": 0.417246175243394
        },
        {
            "Country": "Papua New Guinea",
            "Abs_contribution": 1.4899508095088e-06,
            "Perc_contribution": 0.06,
            "Fossil_abs": 1.7510567583242e-07,
            "Land_abs": 1.3148451336763e-06,
            "Fossil_fraction": 11.7524467730682,
            "Land_fraction": 88.2475532269267,
            "Rank": 125,
            "Perc_contribution_rescale": 0.417246175243394
        },
        {
            "Country": "Eritrea",
            "Abs_contribution": 1.465298851392e-06,
            "Perc_contribution": 0.06,
            "Fossil_abs": 1.218912905363e-07,
            "Land_abs": 1.3434075608556e-06,
            "Fossil_fraction": 8.31852767921752,
            "Land_fraction": 91.6814723207757,
            "Rank": 126,
            "Perc_contribution_rescale": 0.417246175243394
        },
        {
            "Country": "Burundi",
            "Abs_contribution": 1.4505906876706e-06,
            "Perc_contribution": 0.05,
            "Fossil_abs": 3.1033999858215e-07,
            "Land_abs": 1.1402506890884e-06,
            "Fossil_fraction": 21.3940432142511,
            "Land_fraction": 78.6059567857456,
            "Rank": 127,
            "Perc_contribution_rescale": 0.347705146036161
        },
        {
            "Country": "Jordan",
            "Abs_contribution": 1.4434118497926e-06,
            "Perc_contribution": 0.05,
            "Fossil_abs": 8.91176193385699e-07,
            "Land_abs": 5.52235656406899e-07,
            "Fossil_fraction": 61.7409503402477,
            "Land_fraction": 38.2590496597523,
            "Rank": 128,
            "Perc_contribution_rescale": 0.347705146036161
        },
        {
            "Country": "Costa Rica",
            "Abs_contribution": 1.41910072889741e-06,
            "Perc_contribution": 0.05,
            "Fossil_abs": 2.50847663114089e-07,
            "Land_abs": 1.1682530657833e-06,
            "Fossil_fraction": 17.6765227447237,
            "Land_fraction": 82.3234772552753,
            "Rank": 129,
            "Perc_contribution_rescale": 0.347705146036161
        },
        {
            "Country": "Congo",
            "Abs_contribution": 1.360860346916e-06,
            "Perc_contribution": 0.05,
            "Fossil_abs": 2.2306759775519e-07,
            "Land_abs": 1.1377927491608e-06,
            "Fossil_fraction": 16.3916597511794,
            "Land_fraction": 83.6083402488198,
            "Rank": 130,
            "Perc_contribution_rescale": 0.347705146036161
        },
        {
            "Country": "Sierra Leone",
            "Abs_contribution": 1.2600757246589e-06,
            "Perc_contribution": 0.05,
            "Fossil_abs": 2.5773684344705e-07,
            "Land_abs": 1.0023388812118e-06,
            "Fossil_fraction": 20.4540757672971,
            "Land_fraction": 79.5459242326988,
            "Rank": 131,
            "Perc_contribution_rescale": 0.347705146036161
        },
        {
            "Country": "Oman",
            "Abs_contribution": 1.2364829141512e-06,
            "Perc_contribution": 0.05,
            "Fossil_abs": 6.480913180554e-07,
            "Land_abs": 5.88391596095801e-07,
            "Fossil_fraction": 52.4140940920554,
            "Land_fraction": 47.5859059079445,
            "Rank": 132,
            "Perc_contribution_rescale": 0.347705146036161
        },
        {
            "Country": "Panama",
            "Abs_contribution": 1.23187953398331e-06,
            "Perc_contribution": 0.05,
            "Fossil_abs": 2.3163150791348e-07,
            "Land_abs": 1.0002480260699e-06,
            "Fossil_fraction": 18.8030973421967,
            "Land_fraction": 81.1969026578092,
            "Rank": 133,
            "Perc_contribution_rescale": 0.347705146036161
        },
        {
            "Country": "Trinidad and Tobago",
            "Abs_contribution": 1.2167203793286e-06,
            "Perc_contribution": 0.05,
            "Fossil_abs": 1.03959586380209e-06,
            "Land_abs": 1.7712451552647e-07,
            "Fossil_fraction": 85.4424633189554,
            "Land_fraction": 14.5575366810417,
            "Rank": 134,
            "Perc_contribution_rescale": 0.347705146036161
        },
        {
            "Country": "Lebanon",
            "Abs_contribution": 1.0438864516867e-06,
            "Perc_contribution": 0.04,
            "Fossil_abs": 6.40415559080201e-07,
            "Land_abs": 4.034708926064e-07,
            "Fossil_fraction": 61.3491590053138,
            "Land_fraction": 38.6508409946768,
            "Rank": 135,
            "Perc_contribution_rescale": 0.278164116828929
        },
        {
            "Country": "Armenia",
            "Abs_contribution": 1.0309313301951e-06,
            "Perc_contribution": 0.04,
            "Fossil_abs": 1.4045246143968e-07,
            "Land_abs": 8.90478868755399e-07,
            "Fossil_fraction": 13.623842570882,
            "Land_fraction": 86.3761574291161,
            "Rank": 136,
            "Perc_contribution_rescale": 0.278164116828929
        },
        {
            "Country": "Kuwait",
            "Abs_contribution": 1.0214634711395e-06,
            "Perc_contribution": 0.04,
            "Fossil_abs": 7.16895145943e-07,
            "Land_abs": 3.0456832519651e-07,
            "Fossil_fraction": 70.1831407777375,
            "Land_fraction": 29.8168592222634,
            "Rank": 137,
            "Perc_contribution_rescale": 0.278164116828929
        },
        {
            "Country": "Moldova",
            "Abs_contribution": 1.0010118117453e-06,
            "Perc_contribution": 0.04,
            "Fossil_abs": 1.97262295852899e-07,
            "Land_abs": 8.03749515892499e-07,
            "Fossil_fraction": 19.7062905290763,
            "Land_fraction": 80.2937094709335,
            "Rank": 138,
            "Perc_contribution_rescale": 0.278164116828929
        },
        {
            "Country": "El Salvador",
            "Abs_contribution": 9.66866509233097e-07,
            "Perc_contribution": 0.04,
            "Fossil_abs": 2.11772613180949e-07,
            "Land_abs": 7.55093896052096e-07,
            "Fossil_fraction": 21.9029836237604,
            "Land_fraction": 78.0970163762342,
            "Rank": 139,
            "Perc_contribution_rescale": 0.278164116828929
        },
        {
            "Country": "Bosnia and Herzegovina",
            "Abs_contribution": 9.40852566857303e-07,
            "Perc_contribution": 0.04,
            "Fossil_abs": 2.5449558277156e-07,
            "Land_abs": 6.86356984085701e-07,
            "Fossil_fraction": 27.0494646809162,
            "Land_fraction": 72.9505353190793,
            "Rank": 140,
            "Perc_contribution_rescale": 0.278164116828929
        },
        {
            "Country": "Qatar",
            "Abs_contribution": 7.91659998496181e-07,
            "Perc_contribution": 0.03,
            "Fossil_abs": 6.24719471467791e-07,
            "Land_abs": 1.6694052702839e-07,
            "Fossil_fraction": 78.9125979150764,
            "Land_fraction": 21.0874020849236,
            "Rank": 141,
            "Perc_contribution_rescale": 0.208623087621697
        },
        {
            "Country": "Slovenia",
            "Abs_contribution": 7.15682336364605e-07,
            "Perc_contribution": 0.03,
            "Fossil_abs": 2.36529647611901e-07,
            "Land_abs": 4.791526887527e-07,
            "Fossil_fraction": 33.0495298812853,
            "Land_fraction": 66.9504701187142,
            "Rank": 142,
            "Perc_contribution_rescale": 0.208623087621697
        },
        {
            "Country": "Guinea-Bissau",
            "Abs_contribution": 7.04098259766601e-07,
            "Perc_contribution": 0.03,
            "Fossil_abs": 9.322447550355e-08,
            "Land_abs": 6.108737842631e-07,
            "Fossil_fraction": 13.2402650071103,
            "Land_fraction": 86.7597349928967,
            "Rank": 143,
            "Perc_contribution_rescale": 0.208623087621697
        },
        {
            "Country": "Albania",
            "Abs_contribution": 6.82967532244797e-07,
            "Perc_contribution": 0.03,
            "Fossil_abs": 1.2635065947871e-07,
            "Land_abs": 5.56616872766002e-07,
            "Fossil_fraction": 18.5002439374266,
            "Land_fraction": 81.499756062561,
            "Rank": 144,
            "Perc_contribution_rescale": 0.208623087621697
        },
        {
            "Country": "Hong Kong",
            "Abs_contribution": 5.58604864503299e-07,
            "Perc_contribution": 0.02,
            "Fossil_abs": 5.38234970144e-07,
            "Land_abs": 2.036989435923e-08,
            "Fossil_fraction": 96.3534341260325,
            "Land_fraction": 3.64656587395501,
            "Rank": 145,
            "Perc_contribution_rescale": 0.139082058414465
        },
        {
            "Country": "Gabon",
            "Abs_contribution": 5.34536401416501e-07,
            "Perc_contribution": 0.02,
            "Fossil_abs": 3.2049751699577e-07,
            "Land_abs": 2.1403888442072e-07,
            "Fossil_fraction": 59.9580339423963,
            "Land_fraction": 40.0419660576014,
            "Rank": 146,
            "Perc_contribution_rescale": 0.139082058414465
        },
        {
            "Country": "Guyana",
            "Abs_contribution": 5.08141801744001e-07,
            "Perc_contribution": 0.02,
            "Fossil_abs": 8.90298565816099e-08,
            "Land_abs": 4.19111945162401e-07,
            "Fossil_fraction": 17.5206716463887,
            "Land_fraction": 82.4793283536132,
            "Rank": 147,
            "Perc_contribution_rescale": 0.139082058414465
        },
        {
            "Country": "Liberia",
            "Abs_contribution": 5.04464585625e-07,
            "Perc_contribution": 0.02,
            "Fossil_abs": 2.9801666026228e-07,
            "Land_abs": 2.0644792536272e-07,
            "Fossil_fraction": 59.0758338155801,
            "Land_fraction": 40.9241661844199,
            "Rank": 148,
            "Perc_contribution_rescale": 0.139082058414465
        },
        {
            "Country": "Lesotho",
            "Abs_contribution": 4.88075360698699e-07,
            "Perc_contribution": 0.02,
            "Fossil_abs": 1.2490183082014e-07,
            "Land_abs": 3.63173529878502e-07,
            "Fossil_fraction": 25.5906855534232,
            "Land_fraction": 74.4093144465652,
            "Rank": 149,
            "Perc_contribution_rescale": 0.139082058414465
        },
        {
            "Country": "Singapore",
            "Abs_contribution": 4.63753273608107e-07,
            "Perc_contribution": 0.02,
            "Fossil_abs": 4.47500578183496e-07,
            "Land_abs": 1.625269542457e-08,
            "Fossil_fraction": 96.4954003886245,
            "Land_fraction": 3.50459961136668,
            "Rank": 150,
            "Perc_contribution_rescale": 0.139082058414465
        },
        {
            "Country": "Swaziland",
            "Abs_contribution": 4.27326006640199e-07,
            "Perc_contribution": 0.02,
            "Fossil_abs": 8.27232000573199e-08,
            "Land_abs": 3.44602806583e-07,
            "Fossil_fraction": 19.3583350350524,
            "Land_fraction": 80.6416649649758,
            "Rank": 151,
            "Perc_contribution_rescale": 0.139082058414465
        },
        {
            "Country": "North Macedonia",
            "Abs_contribution": 4.12541276254099e-07,
            "Perc_contribution": 0.02,
            "Fossil_abs": 1.0936145334744e-07,
            "Land_abs": 3.03179822906599e-07,
            "Fossil_fraction": 26.5092148694669,
            "Land_fraction": 73.4907851305187,
            "Rank": 152,
            "Perc_contribution_rescale": 0.139082058414465
        },
        {
            "Country": "Jamaica",
            "Abs_contribution": 3.60062904620701e-07,
            "Perc_contribution": 0.01,
            "Fossil_abs": 1.4150256808461e-07,
            "Land_abs": 2.18560336536021e-07,
            "Fossil_fraction": 39.2994019291356,
            "Land_fraction": 60.7005980708448,
            "Rank": 153,
            "Perc_contribution_rescale": 0.0695410292072323
        },
        {
            "Country": "Gambia",
            "Abs_contribution": 3.3157815056086e-07,
            "Perc_contribution": 0.01,
            "Fossil_abs": 5.6130200764192e-08,
            "Land_abs": 2.75447949796671e-07,
            "Fossil_fraction": 16.9281964656744,
            "Land_fraction": 83.0718035343264,
            "Rank": 154,
            "Perc_contribution_rescale": 0.0695410292072323
        },
        {
            "Country": "Cyprus",
            "Abs_contribution": 3.271554175628e-07,
            "Perc_contribution": 0.01,
            "Fossil_abs": 1.2511562737254e-07,
            "Land_abs": 2.0203979019023e-07,
            "Fossil_fraction": 38.2434832669469,
            "Land_fraction": 61.7565167330437,
            "Rank": 155,
            "Perc_contribution_rescale": 0.0695410292072323
        },
        {
            "Country": "Iceland",
            "Abs_contribution": 3.232263108856e-07,
            "Perc_contribution": 0.01,
            "Fossil_abs": 4.32031217521899e-08,
            "Land_abs": 2.80023189133401e-07,
            "Fossil_fraction": 13.3662144129971,
            "Land_fraction": 86.6337855870001,
            "Rank": 156,
            "Perc_contribution_rescale": 0.0695410292072323
        },
        {
            "Country": "Luxembourg",
            "Abs_contribution": 2.679511906032e-07,
            "Perc_contribution": 0.01,
            "Fossil_abs": 9.36270246210404e-08,
            "Land_abs": 1.7432416598212e-07,
            "Fossil_fraction": 34.9418207137917,
            "Land_fraction": 65.0581792861935,
            "Rank": 157,
            "Perc_contribution_rescale": 0.0695410292072323
        },
        {
            "Country": "Djibouti",
            "Abs_contribution": 2.4640862835017e-07,
            "Perc_contribution": 0.01,
            "Fossil_abs": 3.8309115276746e-08,
            "Land_abs": 2.0809951307342e-07,
            "Fossil_fraction": 15.5469861316322,
            "Land_fraction": 84.4530138683663,
            "Rank": 158,
            "Perc_contribution_rescale": 0.0695410292072323
        },
        {
            "Country": "Suriname",
            "Abs_contribution": 2.3078851852279e-07,
            "Perc_contribution": 0.01,
            "Fossil_abs": 1.0161024276788e-07,
            "Land_abs": 1.2917827575491e-07,
            "Fossil_fraction": 44.0274253755158,
            "Land_fraction": 55.9725746244842,
            "Rank": 159,
            "Perc_contribution_rescale": 0.0695410292072323
        },
        {
            "Country": "Timor-Leste",
            "Abs_contribution": 2.2545785707861e-07,
            "Perc_contribution": 0.01,
            "Fossil_abs": 2.4197974838155e-08,
            "Land_abs": 2.0125988224045e-07,
            "Fossil_fraction": 10.732815059853,
            "Land_fraction": 89.2671849401445,
            "Rank": 160,
            "Perc_contribution_rescale": 0.0695410292072323
        },
        {
            "Country": "Bahrain",
            "Abs_contribution": 2.1880158545879e-07,
            "Perc_contribution": 0.01,
            "Fossil_abs": 2.0193004488316e-07,
            "Land_abs": 1.6871540575628e-08,
            "Fossil_fraction": 92.2891141121061,
            "Land_fraction": 7.710885887893,
            "Rank": 161,
            "Perc_contribution_rescale": 0.0695410292072323
        },
        {
            "Country": "Mauritius",
            "Abs_contribution": 1.8376947917932e-07,
            "Perc_contribution": 0.01,
            "Fossil_abs": 8.68356155424402e-08,
            "Land_abs": 9.69338636368701e-08,
            "Fossil_fraction": 47.2524686527011,
            "Land_fraction": 52.7475313472936,
            "Rank": 162,
            "Perc_contribution_rescale": 0.0695410292072323
        },
        {
            "Country": "Belize",
            "Abs_contribution": 1.81259036747e-07,
            "Perc_contribution": 0.01,
            "Fossil_abs": 1.9333494720934e-08,
            "Land_abs": 1.6192554202607e-07,
            "Fossil_fraction": 10.6662239124218,
            "Land_fraction": 89.3337760875803,
            "Rank": 163,
            "Perc_contribution_rescale": 0.0695410292072323
        },
        {
            "Country": "Montenegro",
            "Abs_contribution": 1.7599795163278e-07,
            "Perc_contribution": 0.01,
            "Fossil_abs": 8.77916833734999e-08,
            "Land_abs": 8.82062682592799e-08,
            "Fossil_fraction": 49.8822188321132,
            "Land_fraction": 50.1177811678869,
            "Rank": 164,
            "Perc_contribution_rescale": 0.0695410292072323
        },
        {
            "Country": "Bhutan",
            "Abs_contribution": 1.7400643399332e-07,
            "Perc_contribution": 0.01,
            "Fossil_abs": 9.422837537105e-08,
            "Land_abs": 7.97780586222697e-08,
            "Fossil_fraction": 54.1522363332078,
            "Land_fraction": 45.8477636667919,
            "Rank": 165,
            "Perc_contribution_rescale": 0.0695410292072323
        },
        {
            "Country": "Fiji",
            "Abs_contribution": 1.656393399961e-07,
            "Perc_contribution": 0.01,
            "Fossil_abs": 4.86959673254601e-08,
            "Land_abs": 1.1694337267058e-07,
            "Fossil_fraction": 29.3987933824215,
            "Land_fraction": 70.6012066175422,
            "Rank": 166,
            "Perc_contribution_rescale": 0.0695410292072323
        },
        {
            "Country": "Brunei Darussalam",
            "Abs_contribution": 1.2177659421329e-07,
            "Perc_contribution": 0,
            "Fossil_abs": 4.1765067503547e-08,
            "Land_abs": 8.00115267097401e-08,
            "Fossil_fraction": 34.2964654031924,
            "Land_fraction": 65.7035345968052,
            "Rank": 167,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Cape Verde",
            "Abs_contribution": 7.63718378457999e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 3.0928801834061e-08,
            "Land_abs": 4.54430360117399e-08,
            "Fossil_fraction": 40.4976529391743,
            "Land_fraction": 59.5023470608271,
            "Rank": 168,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Vanuatu",
            "Abs_contribution": 7.30603259029801e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 8.980351429176e-09,
            "Land_abs": 6.40799744737899e-08,
            "Fossil_fraction": 12.2916936356148,
            "Land_fraction": 87.7083063643659,
            "Rank": 169,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Comoros",
            "Abs_contribution": 6.16638290281098e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 2.2700891231577e-08,
            "Land_abs": 3.896293779653e-08,
            "Fossil_fraction": 36.8139500731112,
            "Land_fraction": 63.1860499268842,
            "Rank": 170,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Bahamas",
            "Abs_contribution": 5.98687685665997e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 4.34268187382502e-08,
            "Land_abs": 1.6441949828344e-08,
            "Fossil_fraction": 72.5366827780013,
            "Land_fraction": 27.4633172219895,
            "Rank": 171,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Barbados",
            "Abs_contribution": 5.415632247134e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 2.7988952940639e-08,
            "Land_abs": 2.61673695307099e-08,
            "Fossil_fraction": 51.6817827788271,
            "Land_fraction": 48.3182172211896,
            "Rank": 172,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Maldives",
            "Abs_contribution": 5.2343098941321e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 5.1035850135467e-08,
            "Land_abs": 1.30724880585431e-09,
            "Fossil_fraction": 97.5025383817656,
            "Land_fraction": 2.49746161823509,
            "Rank": 173,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Samoa",
            "Abs_contribution": 4.53167206850401e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 1.0085718109717e-08,
            "Land_abs": 3.52310025753301e-08,
            "Fossil_fraction": 22.2560634513134,
            "Land_fraction": 77.743936548702,
            "Rank": 174,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Equatorial Guinea",
            "Abs_contribution": 4.35465050489899e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 3.1921504748868e-08,
            "Land_abs": 1.1625000300123e-08,
            "Fossil_fraction": 73.304401152185,
            "Land_fraction": 26.6955988478176,
            "Rank": 175,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Malta",
            "Abs_contribution": 4.06980751306e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 2.1877081372434e-08,
            "Land_abs": 1.882099375816e-08,
            "Fossil_fraction": 53.7545849582087,
            "Land_fraction": 46.2454150417765,
            "Rank": 176,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Tonga",
            "Abs_contribution": 4.064642828425e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 2.37589869711511e-08,
            "Land_abs": 1.68874413131e-08,
            "Fossil_fraction": 58.4528283887551,
            "Land_fraction": 41.5471716112475,
            "Rank": 177,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Andorra",
            "Abs_contribution": 3.41784150131e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 8.13994622489099e-09,
            "Land_abs": 2.603846878821e-08,
            "Fossil_fraction": 23.8160436104807,
            "Land_fraction": 76.1839563895224,
            "Rank": 178,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Solomon Islands",
            "Abs_contribution": 2.96935029493719e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 1.5902821910412e-08,
            "Land_abs": 1.379068103896e-08,
            "Fossil_fraction": 53.5565707337618,
            "Land_fraction": 46.4434292662384,
            "Rank": 179,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Macao",
            "Abs_contribution": 2.9107470449918e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 2.659562540187e-08,
            "Land_abs": 2.5118450480486e-09,
            "Fossil_fraction": 91.3704454244148,
            "Land_fraction": 8.62955457558723,
            "Rank": 180,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Palau",
            "Abs_contribution": 2.300820447417e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 2.292639236333e-08,
            "Land_abs": 8.18121108389698e-11,
            "Fossil_fraction": 99.6444220107139,
            "Land_fraction": 0.355577989281239,
            "Rank": 181,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Lucia",
            "Abs_contribution": 2.22353630817e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 1.1624174761981e-08,
            "Land_abs": 1.0611188319719e-08,
            "Fossil_fraction": 52.2778725009796,
            "Land_fraction": 47.7221274990204,
            "Rank": 182,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Seychelles",
            "Abs_contribution": 2.0875946535221e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 1.8503767394558e-08,
            "Land_abs": 2.37217914066301e-09,
            "Fossil_fraction": 88.6367828320466,
            "Land_fraction": 11.3632171679534,
            "Rank": 183,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Sao Tome and Principe",
            "Abs_contribution": 1.971280779809e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 8.2423132003e-09,
            "Land_abs": 1.147049459779e-08,
            "Fossil_fraction": 41.8119695820227,
            "Land_fraction": 58.1880304179771,
            "Rank": 184,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Antigua and Barbuda",
            "Abs_contribution": 1.90806068783019e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 1.3377988805404e-08,
            "Land_abs": 5.70261807289902e-09,
            "Fossil_fraction": 70.1130152239403,
            "Land_fraction": 29.8869847760656,
            "Rank": 185,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Micronesia (Federated States of)",
            "Abs_contribution": 1.4525224223335e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 2.21290938748201e-15,
            "Land_abs": 1.4525222010425e-08,
            "Fossil_fraction": 1.52349413231566e-05,
            "Land_fraction": 99.9999847650545,
            "Rank": 186,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Dominica",
            "Abs_contribution": 1.444315171699e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 5.393272887732e-09,
            "Land_abs": 9.04987882925804e-09,
            "Fossil_fraction": 37.3413849927762,
            "Land_fraction": 62.6586150072241,
            "Rank": 187,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Grenada",
            "Abs_contribution": 1.3068945190611e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 7.76079936181798e-09,
            "Land_abs": 5.308145828793e-09,
            "Fossil_fraction": 59.3835175572814,
            "Land_fraction": 40.6164824427182,
            "Rank": 188,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Vincent and the Grenadines",
            "Abs_contribution": 1.1123464426311e-08,
            "Perc_contribution": 0,
            "Fossil_abs": 5.65288969605599e-09,
            "Land_abs": 5.47057473025397e-09,
            "Fossil_fraction": 50.8195062204259,
            "Land_fraction": 49.1804937795646,
            "Rank": 189,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Aruba",
            "Abs_contribution": 8.604331898827e-09,
            "Perc_contribution": 0,
            "Fossil_abs": 8.57962693169501e-09,
            "Land_abs": 2.4704967131823e-11,
            "Fossil_fraction": 99.7128775665272,
            "Land_fraction": 0.287122433470877,
            "Rank": 190,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Liechtenstein",
            "Abs_contribution": 8.13135005543098e-09,
            "Perc_contribution": 0,
            "Fossil_abs": 2.759239220182e-09,
            "Land_abs": 5.372110835249e-09,
            "Fossil_fraction": 33.9333468781004,
            "Land_fraction": 66.0666531218999,
            "Rank": 191,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Kitts and Nevis",
            "Abs_contribution": 7.88247397164299e-09,
            "Perc_contribution": 0,
            "Fossil_abs": 5.16114570041001e-09,
            "Land_abs": 2.72132827123402e-09,
            "Fossil_fraction": 65.4762162105083,
            "Land_fraction": 34.5237837895048,
            "Rank": 192,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Kiribati",
            "Abs_contribution": 6.105849381181e-09,
            "Perc_contribution": 0,
            "Fossil_abs": 3.24107356170849e-09,
            "Land_abs": 2.86477581947321e-09,
            "Fossil_fraction": 53.0814528720262,
            "Land_fraction": 46.9185471279853,
            "Rank": 193,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Cook Islands",
            "Abs_contribution": 3.53020984363999e-09,
            "Perc_contribution": 0,
            "Fossil_abs": 1.6323014062705e-09,
            "Land_abs": 1.89790843737031e-09,
            "Fossil_fraction": 46.2380843793533,
            "Land_fraction": 53.7619156206698,
            "Rank": 194,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Turks and Caicos Islands",
            "Abs_contribution": 1.9026717002415e-09,
            "Perc_contribution": 0,
            "Fossil_abs": 1.9026717002415e-09,
            "Land_abs": 0,
            "Fossil_fraction": 100,
            "Land_fraction": 0,
            "Rank": 195,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Tuvalu",
            "Abs_contribution": 1.2869409241007e-09,
            "Perc_contribution": 0,
            "Fossil_abs": 1.53175682321241e-10,
            "Land_abs": 1.1337652417794e-09,
            "Fossil_fraction": 11.9023087581334,
            "Land_fraction": 88.0976912418617,
            "Rank": 196,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Nauru",
            "Abs_contribution": 4.89829951965101e-10,
            "Perc_contribution": 0,
            "Fossil_abs": 2.68205514132251e-10,
            "Land_abs": 2.2162443783283e-10,
            "Fossil_fraction": 54.7548211489034,
            "Land_fraction": 45.2451788510925,
            "Rank": 197,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Niue",
            "Abs_contribution": 3.61592897878e-10,
            "Perc_contribution": 0,
            "Fossil_abs": 1.6434024047489e-11,
            "Land_abs": 3.451588738305e-10,
            "Fossil_fraction": 4.54489680077559,
            "Land_fraction": 95.4551031992215,
            "Rank": 198,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Anguilla",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 199,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Antarctica",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 200,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Bermuda",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 201,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Bonaire, Saint Eustatius and Saba",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 202,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "British Virgin Islands",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 203,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Christmas Island",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 204,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Cura\xe7ao",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 205,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Faeroe Islands",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 206,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "French Polynesia",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 207,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Greenland",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 208,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Kosovo",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 209,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Kuwaiti Oil Fires",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 210,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Leeward Islands",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 211,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Marshall Islands",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 212,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Montserrat",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 213,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "New Caledonia",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 214,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Occupied Palestinian Territory",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 215,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Pacific Islands (Palau)",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 216,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Panama Canal Zone",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 217,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Ryukyu Islands",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 218,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Helena",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 219,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Saint Pierre and Miquelon",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 220,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Sint Maarten (Dutch part)",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 221,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "St. Kitts-Nevis-Anguilla",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 222,
            "Perc_contribution_rescale": 0
        },
        {
            "Country": "Wallis and Futuna Islands",
            "Abs_contribution": 0,
            "Perc_contribution": 0,
            "Fossil_abs": 0,
            "Land_abs": 0,
            "Fossil_fraction": 0,
            "Land_fraction": 0,
            "Rank": 223,
            "Perc_contribution_rescale": 0
        }
    ]
};


// Function to colour polygons
const $24badfeb4d36b999$export$13746b04065d45d9 = function(val, scale, colPalette) {
    // Define the color for "Insufficient Data"
    const noDataColor = "#808080";
    // Check if val is null or undefined
    if (val === null || val === undefined) return noDataColor;
    // Return colour based on value
    return val >= scale[0] ? colPalette[0] : val >= scale[1] ? colPalette[1] : val >= scale[2] ? colPalette[2] : val >= scale[3] ? colPalette[3] : val >= scale[4] ? colPalette[4] : val >= scale[5] ? colPalette[5] : val >= scale[6] ? colPalette[6] : val >= scale[7] ? colPalette[7] : val >= scale[8] ? colPalette[8] : val >= scale[9] ? colPalette[9] : colPalette[10]; // negative values
};
const $24badfeb4d36b999$export$ebcd05299db66cf5 = function(properties, gas, source, chartId) {
    const html = `
    <div>
      <p class="text-start fw-bold" style="margin: 0;">${properties.Country}</p>
      <p class="text-start" style="margin-top: 5px; margin-bottom: 7.5px;">
        <span style="color: grey;">Source:</span>&nbsp;${source}<br>
        <span style="color: grey;">Gas:</span>&nbsp;${gas}<br>
      </p>
    </div>
    <div id="${chartId}" style="width: 100%; height: 150px;"></div>
  `;
    return html;
};
const $24badfeb4d36b999$export$ef5a49dd25f32dd3 = function(value) {
    // console.log(value)
    // 1 decimal place for values >= 10
    if (value >= 10) return value.toFixed(1);
    // 1 decimal place for values between 1 and 10
    if (value >= 1 && value < 10) return value.toFixed(1);
    // 2 decimal places for values between 0.001 and 1
    if (value > 0.001 && value < 1) return value.toFixed(2);
    // 1 significant figure between zero and 0.001
    if (value <= 0.001 && value >= 0) return value.toPrecision(1);
    // 2 significant figure if negative
    if (value < 0) return value.toPrecision(2);
};


// Array of countries
const $e2fadff72b8ceb94$var$countries = (0, $261e7c68d74e4f8b$export$8e2ba63ee7f5f724)["1851_3GHG"].map((i)=>i.Country).sort();
// Declare Tabulator variable
let $e2fadff72b8ceb94$var$table;
// Declare array of indexes which are the rows currently pinned
let $e2fadff72b8ceb94$var$rowsPinned = [];
// Colour function for warming contribution
const $e2fadff72b8ceb94$var$scale = [
    15,
    10,
    5,
    4,
    3,
    2,
    1,
    0.5,
    0.1,
    0,
    0
];
const $e2fadff72b8ceb94$var$colPalette = [
    "#13051D",
    "#3A0E5B",
    "#9D2A62",
    "#D74F3E",
    "#E9672C",
    "#F68614",
    "#FAB124",
    "#FBD54F",
    "#FDED81",
    "#FCFC9E",
    "#DEEEF8"
];
// Create new Tabulator table
$e2fadff72b8ceb94$var$table = new (0, $c2a9788f40f9c90a$export$62676a0a2827a643)("#tabulator-table", {
    data: (0, $261e7c68d74e4f8b$export$8e2ba63ee7f5f724)["1851_3GHG"],
    selectable: false,
    layout: "fitDataFill",
    columnHeaderVertAlign: "bottom",
    movableRows: false,
    index: "Country",
    columns: [
        {
            title: "Rank",
            field: "Rank",
            sorter: "number"
        },
        {
            title: "Country",
            titleFormatter: (cell)=>{
                const value = cell.getValue();
                return `
                <div class="tabulator-col-title">
                    <p id="info-icon-tooltip" class="text-start info-icon-style" style="display: none; width: auto;">
                        Click Rows to Pin / Unpin
                    </p>
                    <span class="pe-1">${value}</span>
                    <span id="info-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#95a5a6" class="bi bi-info-circle-fill" viewBox="0 0 16 18">
                            <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2"/>
                        </svg>
                    </span>
                    <br>
                    <div id="country-wrapper">
                        <select id="country-select" class="mt-2">
                            <option value="" disabled selected>Select Country to Pin to Top ...</option>
                            ${$e2fadff72b8ceb94$var$countries.map((i)=>`<option value="${i}">${i}</option>`).join("")}
                        </select>
                    </div>
                </div>`;
            },
            field: "Country",
            formatter: (cell)=>`<b>${cell.getValue()}</b>`
        },
        // Empty column to create gap
        // { title: "", headerSort: false, width: 0, resizable: false },
        {
            title: "Warming Contribution",
            headerHozAlign: "center",
            columns: [
                // {
                //     title: "Celsius",
                //     titleFormatter: () => {
                //         return `<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<sup>o</sup>C</span>`;
                //     },
                //     headerHozAlign: "center",
                //     hozAlign: "right",
                //     titleDownload: "Warming Contribution (celsius)",
                //     field: "Abs_contribution",
                //     headerSort: false,
                //     formatter: (cell) => {
                //         const value = cell.getValue();
                //         return value > decimalThreshold ? value.toFixed(decimalPlace) // return original value to X decimal places
                //             : value < decimalThreshold && value > 0 ? `<${decimalThreshold}` // return <0.01
                //             : value === 0 ? value.toFixed(decimalThreshold) // return 0.00 if zero
                //             : value.toFixed(8); // return negative value to X decimal places
                //     },
                // },
                {
                    title: "%",
                    titleDownload: "Warming Contribution (%)",
                    width: 95,
                    widthShrink: 0,
                    field: "Perc_contribution",
                    sorter: "number",
                    headerHozAlign: "right",
                    hozAlign: "right",
                    headerSort: false,
                    formatter: (cell)=>{
                        const value = cell.getValue();
                        // display when value is equal to or greater than 0.01
                        if (value > 0.01) // return value.toFixed(decimalPlace);
                        return (0, $24badfeb4d36b999$export$ef5a49dd25f32dd3)(value);
                        // display when value is between 0.01 and 0.00
                        if (value <= 0.01 && value >= 0) return "0.01-0.00";
                        // display when values are negative
                        if (value < 0) return value.toFixed(2);
                    // return value < decimalThreshold ? `<${decimalThreshold}` : value.toFixed(decimalPlace);
                    }
                },
                {
                    title: " ",
                    width: 130,
                    widthShrink: 0,
                    download: false,
                    field: "Perc_contribution_rescale",
                    headerSort: false,
                    formatter: (cell, formatterParams)=>{
                        // value of rescale column
                        const value = cell.getValue();
                        // value of percentage contribution column
                        const percContribution = cell.getData().Perc_contribution;
                        // colour of progress bar
                        const colour = (0, $24badfeb4d36b999$export$13746b04065d45d9)(percContribution, $e2fadff72b8ceb94$var$scale, $e2fadff72b8ceb94$var$colPalette);
                        // return the progress bar with the computed colour
                        return `<div style="background-color: ${colour}; width: ${value}%; height: 100%;"></div>`;
                    }
                }
            ]
        },
        // Empty column to create gap
        {
            title: "",
            headerSort: false,
            width: 0,
            resizable: false
        },
        {
            title: "Source (%)",
            headerHozAlign: "center",
            columns: [
                // {title:"Fossil Fraction", field:"Fossil_fraction", sorter: "number", hozAlign:"left"},
                // {title:"Land Fraction", field:"Land_fraction", sorter: "number", hozAlign:"left"},
                {
                    title: "Fossil Fuels",
                    titleDownload: "Fraction from Fossil Fuels",
                    headerSort: false,
                    field: "Fossil_fraction",
                    width: 185,
                    widthShrink: 0,
                    sorter: "number",
                    hozAlign: "left",
                    formatter: "progress",
                    formatterParams: {
                        min: 0,
                        max: 100,
                        color: "#525252",
                        legend: " ",
                        legendColor: "white"
                    },
                    cellMouseOver: (e, cell)=>{
                        const value = cell.getValue(); // cell value
                        const element = cell.getElement(); // cell DOM element
                        const percentageValue = cell.getData().Perc_contribution; // value for percentage change
                        // console.log(percentageValue)
                        element.querySelector("div:nth-child(2)").style.paddingLeft = "5px";
                        element.querySelector("div:nth-child(2)").style.paddingRight = "5px";
                        element.querySelector("div:nth-child(2)").style.backgroundColor = "black";
                        element.querySelector("div:nth-child(2)").style.width = "fit-content";
                        element.querySelector("div:nth-child(2)").style.fontSize = "90%";
                        element.querySelector("div:nth-child(2)").style.left = "auto";
                        element.querySelector("div:nth-child(2)").style.right = "0";
                        element.querySelector("div:nth-child(2)").style.borderRadius = "5px";
                        element.querySelector("div:nth-child(2)").style.opacity = "0.90";
                        // If percentage change is negative then display "n/a"
                        if (Number(percentageValue) < 0) element.querySelector("div:nth-child(2)").textContent = "N/A";
                        else {
                            const content = Number(value) === 100 ? `100 %` : `${Number(value).toFixed(1)} %`;
                            element.querySelector("div:nth-child(2)").textContent = content; // show percentage on hover
                        }
                    },
                    cellMouseOut: (e, cell)=>{
                        const element = cell.getElement(); // cell DOM element
                        element.querySelector("div:nth-child(2)").style.paddingLeft = 0;
                        element.querySelector("div:nth-child(2)").textContent = " "; // remove when not hovering
                    }
                },
                {
                    title: "Land Use Change",
                    titleDownload: "Fraction from Land Use Change",
                    headerSort: false,
                    field: "Land_fraction",
                    width: 185,
                    widthShrink: 0,
                    sorter: "number",
                    hozAlign: "left",
                    formatter: "progress",
                    formatterParams: {
                        min: 0,
                        max: 100,
                        color: "#8c510a",
                        legend: " ",
                        legendColor: "white"
                    },
                    cellMouseOver: (e, cell)=>{
                        const value = cell.getValue(); // cell value
                        const element = cell.getElement(); // cell DOM element
                        const percentageValue = cell.getData().Perc_contribution; // value for percentage change
                        // console.log(percentageValue)
                        element.querySelector("div:nth-child(2)").style.paddingLeft = "5px";
                        element.querySelector("div:nth-child(2)").style.paddingRight = "5px";
                        element.querySelector("div:nth-child(2)").style.backgroundColor = "black";
                        element.querySelector("div:nth-child(2)").style.width = "fit-content";
                        element.querySelector("div:nth-child(2)").style.fontSize = "90%";
                        element.querySelector("div:nth-child(2)").style.left = "auto";
                        element.querySelector("div:nth-child(2)").style.right = "0";
                        element.querySelector("div:nth-child(2)").style.borderRadius = "5px";
                        element.querySelector("div:nth-child(2)").style.opacity = "0.90";
                        // If percentage change is negative then display "n/a"
                        if (Number(percentageValue) < 0) element.querySelector("div:nth-child(2)").textContent = "N/A";
                        else {
                            const content = Number(value) === 100 ? `100 %` : `${Number(value).toFixed(1)} %`;
                            element.querySelector("div:nth-child(2)").textContent = content; // show percentage on hover
                        }
                    },
                    cellMouseOut: (e, cell)=>{
                        const element = cell.getElement(); // cell DOM element
                        element.querySelector("div:nth-child(2)").style.paddingLeft = 0;
                        element.querySelector("div:nth-child(2)").textContent = " "; // remove when not hovering
                    }
                }
            ]
        }
    ],
    initialSort: [
        {
            column: "Rank",
            dir: "asc"
        }
    ]
});
// ------------------- //
// Choices Event Listeners
// ------------------- //
// Initiate variables
let $e2fadff72b8ceb94$var$choicesGas, $e2fadff72b8ceb94$var$choicesPeriod;
// Choices select input functionality and styling
document.addEventListener("DOMContentLoaded", function() {
    const first = document.getElementById("gas-selector");
    const second = document.getElementById("period-selector");
    const options = {
        searchEnabled: false,
        allowHTML: true,
        shouldSort: false,
        itemSelectText: "click to select"
    };
    $e2fadff72b8ceb94$var$choicesGas = new (0, (/*@__PURE__*/$parcel$interopDefault($125d88de280575d0$exports)))(first, options);
    $e2fadff72b8ceb94$var$choicesPeriod = new (0, (/*@__PURE__*/$parcel$interopDefault($125d88de280575d0$exports)))(second, options);
});
// ------------------- //
// Change Data When Choices Changes
// ------------------- //
// Get element from DOM
const $e2fadff72b8ceb94$var$gasSelector = document.getElementById("gas-selector");
const $e2fadff72b8ceb94$var$periodSelector = document.getElementById("period-selector");
// Update table with new data when user selects a different greenhouse gas
$e2fadff72b8ceb94$var$gasSelector.addEventListener("change", ()=>{
    const gas = $e2fadff72b8ceb94$var$gasSelector.value;
    const timePeriod = $e2fadff72b8ceb94$var$periodSelector.value;
    const variables = `${timePeriod}_${gas}`;
    $e2fadff72b8ceb94$var$table.setData((0, $261e7c68d74e4f8b$export$8e2ba63ee7f5f724)[variables]);
    // Keep countries pinned to top of table if they are in rowPinned array
    const allCountries = $e2fadff72b8ceb94$var$table.getData().map((i)=>i.Country);
    const countryIndex = $e2fadff72b8ceb94$var$rowsPinned.map((country)=>allCountries.indexOf(country));
    const rowsToPin = countryIndex.map((row)=>$e2fadff72b8ceb94$var$table.getRows()[row]);
    rowsToPin.map((i)=>i.freeze());
});
// Update table with new data when user selects a different time period
$e2fadff72b8ceb94$var$periodSelector.addEventListener("change", ()=>{
    const gas = $e2fadff72b8ceb94$var$gasSelector.value;
    const timePeriod = $e2fadff72b8ceb94$var$periodSelector.value;
    const variables = `${timePeriod}_${gas}`;
    $e2fadff72b8ceb94$var$table.setData((0, $261e7c68d74e4f8b$export$8e2ba63ee7f5f724)[variables]);
    // Keep countries pinned to top of table if they are in rowPinned array
    const allCountries = $e2fadff72b8ceb94$var$table.getData().map((i)=>i.Country);
    const countryIndex = $e2fadff72b8ceb94$var$rowsPinned.map((country)=>allCountries.indexOf(country));
    const rowsToPin = countryIndex.map((row)=>$e2fadff72b8ceb94$var$table.getRows()[row]);
    rowsToPin.map((i)=>i.freeze());
});
// // ------------------- //
// // Radio Button Event Listeners (previous version)
// // ------------------- //
// // Function to find the radio input that is selected and return its value
// const getCheckedRadioInput = function () {
//     const checkedRadio = document.querySelector("input[name='value-radio']:checked");
//     return checkedRadio.value;
// };
// // Update table with new data when user selects a different time period
// document.getElementById("radio-selector").addEventListener("change", () => {
//     const timePeriod = getCheckedRadioInput();
//     table.setData(tableData[timePeriod]);
// });
// ------------------- //
// Animate Time Period Event Listener
// ------------------- //
// Function to create new Promise
const $e2fadff72b8ceb94$var$wait = function(time) {
    return new Promise((resolve)=>setTimeout(resolve, time));
};
// Function to process each map layer sequentially to animate map layers
const $e2fadff72b8ceb94$var$mapAnimation = async function() {
    // empty array of pinned countries
    $e2fadff72b8ceb94$var$rowsPinned = [];
    // get greenhouse gas value from DOM
    const gas = $e2fadff72b8ceb94$var$gasSelector.value;
    // 1851
    const variable1851 = `1851_${gas}`;
    $e2fadff72b8ceb94$var$table.setData((0, $261e7c68d74e4f8b$export$8e2ba63ee7f5f724)[variable1851]);
    $e2fadff72b8ceb94$var$choicesPeriod.setChoiceByValue("1851");
    await $e2fadff72b8ceb94$var$wait(1000); // wait 1 second    
    // 1990
    const variable1990 = `1990_${gas}`;
    $e2fadff72b8ceb94$var$table.setData((0, $261e7c68d74e4f8b$export$8e2ba63ee7f5f724)[variable1990]);
    $e2fadff72b8ceb94$var$choicesPeriod.setChoiceByValue("1990");
    await $e2fadff72b8ceb94$var$wait(1000); // wait 1 second  
    // 2005
    const variable2005 = `2005_${gas}`;
    $e2fadff72b8ceb94$var$table.setData((0, $261e7c68d74e4f8b$export$8e2ba63ee7f5f724)[variable2005]);
    $e2fadff72b8ceb94$var$choicesPeriod.setChoiceByValue("2005");
    await $e2fadff72b8ceb94$var$wait(1000); // wait 1 second  
    // 2020
    const variable2020 = `2020_${gas}`;
    $e2fadff72b8ceb94$var$table.setData((0, $261e7c68d74e4f8b$export$8e2ba63ee7f5f724)[variable2020]);
    $e2fadff72b8ceb94$var$choicesPeriod.setChoiceByValue("2020");
    await $e2fadff72b8ceb94$var$wait(1000); // wait 1 second  
};
// Run animation when user clicks button
document.getElementById("btn-animate").addEventListener("click", $e2fadff72b8ceb94$var$mapAnimation);
// ------------------- //
// Download Table Event Listener
// ------------------- //
// Download table on click of button
document.getElementById("btn-download").addEventListener("click", (e)=>{
    e.preventDefault();
    const gas = $e2fadff72b8ceb94$var$gasSelector.value;
    const timePeriod = $e2fadff72b8ceb94$var$periodSelector.value;
    const variables = `${timePeriod}_${gas}`;
    $e2fadff72b8ceb94$var$table.download("csv", `${variables}_table.csv`);
});
// ------------------- //
// On Table Build
// ------------------- //
// Run this code after the table has rendered
$e2fadff72b8ceb94$var$table.on("tableBuilt", ()=>{
    // Get elements from DOM
    const infoIcon = document.getElementById("info-icon");
    const infoIconTooltip = document.getElementById("info-icon-tooltip");
    const countrySelect = document.getElementById("country-select");
    // const countrySelectWrapper = document.getElementById("country-wrapper");
    // Show tooltip on mouse hover
    infoIcon.addEventListener("mouseenter", ()=>{
        infoIconTooltip.style.display = "flex";
    });
    // Remove tooltip when not hovering
    infoIcon.addEventListener("mouseleave", ()=>{
        infoIconTooltip.style.display = "none";
    });
    // Style country selector as Choices class
    // const options = {
    //     searchEnabled: false,
    //     allowHTML: true,
    //     shouldSort: false,
    //     itemSelectText: "click to select",
    //   };
    // const choicesCountrySearch = new Choices(countrySelect, options);
    // Add an event listener to the input to stop propagation and allow user to use country selector
    countrySelect.addEventListener("click", (event)=>{
        event.stopPropagation();
    });
    // Pin row when country is selected
    countrySelect.addEventListener("change", ()=>{
        const country = countrySelect.value;
        // Previous code for scrolling to row
        // table.scrollToRow(country, "top", true); // "top" "center" "nearest" "bottom"
        // Find country row and freeze or unfreeze depending on current pin status
        const countryIndex = $e2fadff72b8ceb94$var$table.getData().map((i)=>i.Country).indexOf(country);
        const row = $e2fadff72b8ceb94$var$table.getRows()[countryIndex];
        const rowFrozen = row.isFrozen();
        const rowCountry = row.getIndex();
        // Pin row if not frozen and add country to rowPinned array
        if (!rowFrozen) {
            row.freeze();
            $e2fadff72b8ceb94$var$rowsPinned.push(rowCountry);
        }
        // Unpin row if frozen and remove country from rowPinned array
        if (rowFrozen) {
            row.unfreeze();
            $e2fadff72b8ceb94$var$rowsPinned = $e2fadff72b8ceb94$var$rowsPinned.filter((country)=>country !== rowCountry);
        }
        // console.log(rowsPinned);
        // Revert back to the placeholder
        countrySelect.selectedIndex = 0;
    });
});
// ------------------- //
// Reset Table
// ------------------- //
// Add event listener to reset button which re-draws table
document.getElementById("btn-reset").addEventListener("click", ()=>{
    $e2fadff72b8ceb94$var$rowsPinned = [];
    $e2fadff72b8ceb94$var$table.setData((0, $261e7c68d74e4f8b$export$8e2ba63ee7f5f724)["1851_3GHG"]);
    $e2fadff72b8ceb94$var$table.clearSort();
    $e2fadff72b8ceb94$var$choicesGas.setChoiceByValue("3GHG");
    $e2fadff72b8ceb94$var$choicesPeriod.setChoiceByValue("1851");
});
// ------------------- //
// Programmatically Move Row
// ------------------- //
// // When a row is clicked, move it to the top of the table (index zero)
// table.on("rowClick", (e, row) => {
//     const rowIndex = row.getIndex();
//     const rowData = row.getData();
//     table.deleteRow(rowIndex); // remove row from its current position
//     table.addRow(rowData, true); // add row to the top of the table
// });
// ------------------- //
// Programmatically Pin Row(s)
// ------------------- //
// When a row is clicked, pin it to the top of table
$e2fadff72b8ceb94$var$table.on("rowClick", (e, row)=>{
    // get country clicked
    const rowCountry = row.getIndex();
    // check if row is pinned (frozen) already
    const rowFrozen = row.isFrozen();
    // Pin row if not frozen and add country to rowPinned array
    if (!rowFrozen) {
        row.freeze();
        $e2fadff72b8ceb94$var$rowsPinned.push(rowCountry);
    }
    // Unpin row if frozen and remove country from rowPinned array
    if (rowFrozen) {
        row.unfreeze();
        $e2fadff72b8ceb94$var$rowsPinned = $e2fadff72b8ceb94$var$rowsPinned.filter((country)=>country !== rowCountry);
    }
// console.log(rowsPinned);
});


//# sourceMappingURL=index.967dc1eb.js.map
